var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value2) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value2 }) : obj[key] = value2;
var __publicField = (obj, key, value2) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value2);
import { readonly, getCurrentInstance, computed, ref as ref$1, shallowReactive, reactive, markRaw, defineComponent, provide, watch, h, onBeforeUnmount, isRef, Transition, withDirectives, onDeactivated, nextTick, onMounted, onUnmounted, Teleport, unref, toRaw, onActivated, inject, onBeforeUpdate, KeepAlive, onUpdated, onBeforeMount, vShow, createApp, toValue, useTemplateRef, toRef, resolveComponent, createBlock, openBlock, mergeProps, withCtx, renderSlot, createSlots, renderList, createVNode, createTextVNode, toDisplayString, normalizeProps, guardReactiveProps, createElementBlock, createCommentVNode, normalizeClass, normalizeStyle, createElementVNode, toHandlers, Fragment, shallowRef, toRefs, useCssVars, resolveDynamicComponent, withModifiers, useSlots, resolveDirective, mergeModels, useModel, toHandlerKey, watchEffect, withKeys, onErrorCaptured, Suspense } from "vue";
import { useI18n } from "vue-i18n";
import { helpers, decimal, email, integer, maxLength, minLength, requiredUnless } from "@vuelidate/validators";
import { useRoute, useRouter, RouterLink, RouterView, onBeforeRouteLeave, onBeforeRouteUpdate } from "vue-router";
import throttle from "lodash.throttle";
import { VueDraggable } from "vue-draggable-plus";
import { Chart as Chart$1, Filler, LinearScale, LineController, LineElement, PointElement, TimeScale, Tooltip as Tooltip$1 } from "chart.js";
import "chartjs-adapter-date-fns";
import useVuelidate, { useVuelidate as useVuelidate$1 } from "@vuelidate/core";
import kebabCase from "lodash.kebabcase";
import createScatterplot from "regl-scatterplot";
import DOMPurify from "dompurify";
import merge$1 from "lodash.merge";
var HttpStatusCode;
(function(HttpStatusCode2) {
  HttpStatusCode2[HttpStatusCode2["CONTINUE"] = 100] = "CONTINUE";
  HttpStatusCode2[HttpStatusCode2["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
  HttpStatusCode2[HttpStatusCode2["PROCESSING"] = 102] = "PROCESSING";
  HttpStatusCode2[HttpStatusCode2["OK"] = 200] = "OK";
  HttpStatusCode2[HttpStatusCode2["CREATED"] = 201] = "CREATED";
  HttpStatusCode2[HttpStatusCode2["ACCEPTED"] = 202] = "ACCEPTED";
  HttpStatusCode2[HttpStatusCode2["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
  HttpStatusCode2[HttpStatusCode2["NO_CONTENT"] = 204] = "NO_CONTENT";
  HttpStatusCode2[HttpStatusCode2["RESET_CONTENT"] = 205] = "RESET_CONTENT";
  HttpStatusCode2[HttpStatusCode2["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
  HttpStatusCode2[HttpStatusCode2["MULTI_STATUS"] = 207] = "MULTI_STATUS";
  HttpStatusCode2[HttpStatusCode2["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
  HttpStatusCode2[HttpStatusCode2["IM_USED"] = 226] = "IM_USED";
  HttpStatusCode2[HttpStatusCode2["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
  HttpStatusCode2[HttpStatusCode2["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
  HttpStatusCode2[HttpStatusCode2["FOUND"] = 302] = "FOUND";
  HttpStatusCode2[HttpStatusCode2["SEE_OTHER"] = 303] = "SEE_OTHER";
  HttpStatusCode2[HttpStatusCode2["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
  HttpStatusCode2[HttpStatusCode2["USE_PROXY"] = 305] = "USE_PROXY";
  HttpStatusCode2[HttpStatusCode2["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
  HttpStatusCode2[HttpStatusCode2["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
  HttpStatusCode2[HttpStatusCode2["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
  HttpStatusCode2[HttpStatusCode2["BAD_REQUEST"] = 400] = "BAD_REQUEST";
  HttpStatusCode2[HttpStatusCode2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  HttpStatusCode2[HttpStatusCode2["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["FORBIDDEN"] = 403] = "FORBIDDEN";
  HttpStatusCode2[HttpStatusCode2["NOT_FOUND"] = 404] = "NOT_FOUND";
  HttpStatusCode2[HttpStatusCode2["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
  HttpStatusCode2[HttpStatusCode2["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
  HttpStatusCode2[HttpStatusCode2["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
  HttpStatusCode2[HttpStatusCode2["CONFLICT"] = 409] = "CONFLICT";
  HttpStatusCode2[HttpStatusCode2["GONE"] = 410] = "GONE";
  HttpStatusCode2[HttpStatusCode2["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
  HttpStatusCode2[HttpStatusCode2["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
  HttpStatusCode2[HttpStatusCode2["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
  HttpStatusCode2[HttpStatusCode2["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
  HttpStatusCode2[HttpStatusCode2["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
  HttpStatusCode2[HttpStatusCode2["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
  HttpStatusCode2[HttpStatusCode2["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
  HttpStatusCode2[HttpStatusCode2["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
  HttpStatusCode2[HttpStatusCode2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  HttpStatusCode2[HttpStatusCode2["LOCKED"] = 423] = "LOCKED";
  HttpStatusCode2[HttpStatusCode2["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
  HttpStatusCode2[HttpStatusCode2["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
  HttpStatusCode2[HttpStatusCode2["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
  HttpStatusCode2[HttpStatusCode2["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
  HttpStatusCode2[HttpStatusCode2["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
  HttpStatusCode2[HttpStatusCode2["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  HttpStatusCode2[HttpStatusCode2["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
  HttpStatusCode2[HttpStatusCode2["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
  HttpStatusCode2[HttpStatusCode2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
  HttpStatusCode2[HttpStatusCode2["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
  HttpStatusCode2[HttpStatusCode2["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
  HttpStatusCode2[HttpStatusCode2["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
  HttpStatusCode2[HttpStatusCode2["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
  HttpStatusCode2[HttpStatusCode2["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
  HttpStatusCode2[HttpStatusCode2["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
  HttpStatusCode2[HttpStatusCode2["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(HttpStatusCode || (HttpStatusCode = {}));
function arrayShallowEqual(arr1, arr2) {
  if (arr1.length !== arr2.length)
    return false;
  return arr1.every((a3, i2) => a3 === arr2[i2]);
}
function flatten(array) {
  return [].concat(...array);
}
function last(arr) {
  return arr[arr.length - 1];
}
function mergeArraysBy(arr1, arr2, predicate) {
  const arr = arr1.map((t2) => arr2.find((u2) => predicate(t2, u2)) ?? t2);
  const rest = arr2.filter((u2) => !arr1.some((t2) => predicate(t2, u2)));
  return [...arr, ...rest];
}
function mergeArraysByKey(arr1, arr2, key) {
  const fn = (t2, u2) => t2[key] === u2[key];
  return mergeArraysBy(arr1, arr2, fn);
}
async function wait(timeout2) {
  return new Promise((resolve) => setTimeout(resolve, timeout2));
}
function getContrastColor(color, darkColor = "black", lightColor = "white") {
  const colorString = color.charAt(0) === "#" ? color.substring(1, 7) : color;
  const r = parseInt(colorString.substring(0, 2), 16);
  const g = parseInt(colorString.substring(2, 4), 16);
  const b2 = parseInt(colorString.substring(4, 6), 16);
  return r * 0.299 + g * 0.587 + b2 * 0.114 > 186 ? darkColor : lightColor;
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof(argument) === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return /* @__PURE__ */ new Date(NaN);
  }
}
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  var dayOfMonth = date.getDate();
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
function add(dirtyDate, duration2) {
  requiredArgs(2, arguments);
  if (!duration2 || _typeof(duration2) !== "object") return /* @__PURE__ */ new Date(NaN);
  var years = duration2.years ? toInteger(duration2.years) : 0;
  var months = duration2.months ? toInteger(duration2.months) : 0;
  var weeks = duration2.weeks ? toInteger(duration2.weeks) : 0;
  var days = duration2.days ? toInteger(duration2.days) : 0;
  var hours = duration2.hours ? toInteger(duration2.hours) : 0;
  var minutes = duration2.minutes ? toInteger(duration2.minutes) : 0;
  var seconds = duration2.seconds ? toInteger(duration2.seconds) : 0;
  var date = toDate(dirtyDate);
  var dateWithMonths = months || years ? addMonths(date, months + years * 12) : date;
  var dateWithDays = days || weeks ? addDays(dateWithMonths, days + weeks * 7) : dateWithMonths;
  var minutesToAdd = minutes + hours * 60;
  var secondsToAdd = seconds + minutesToAdd * 60;
  var msToAdd = secondsToAdd * 1e3;
  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
  return finalDate;
}
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
var MILLISECONDS_IN_DAY$2 = 864e5;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$2);
}
function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
var millisecondsInMinute = 6e4;
var millisecondsInHour = 36e5;
var millisecondsInSecond = 1e3;
function isDate$2(value2) {
  requiredArgs(1, arguments);
  return value2 instanceof Date || _typeof(value2) === "object" && Object.prototype.toString.call(value2) === "[object Date]";
}
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate$2(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign3 = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign3 * difference);
  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign3);
  var result = sign3 * (difference - isLastDayNotFull);
  return result === 0 ? 0 : result;
}
function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value2) {
    return value2 < 0 ? Math.ceil(value2) : Math.floor(value2);
  }
  // Math.trunc is not supported by IE
};
var defaultRoundingMethod = "trunc";
function getRoundingMethod(method) {
  return roundingMap[defaultRoundingMethod];
}
function differenceInHours(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
  return getRoundingMethod()(diff);
}
function differenceInMinutes(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod()(diff);
}
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign3 = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result;
  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      dateLeft.setDate(30);
    }
    dateLeft.setMonth(dateLeft.getMonth() - sign3 * difference);
    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign3;
    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign3 * (difference - Number(isLastMonthNotFull));
  }
  return result === 0 ? 0 : result;
}
function differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1e3;
  return getRoundingMethod()(diff);
}
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign3 = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight));
  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584);
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign3;
  var result = sign3 * (difference - Number(isLastYearNotFull));
  return result === 0 ? 0 : result;
}
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY$1 = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
function addLeadingZeros(number, targetLength) {
  var sign3 = number < 0 ? "-" : "";
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign3 + output;
}
var formatters$1 = {
  // Year
  y: function y(date, token2) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token2 === "yy" ? year % 100 : year, token2.length);
  },
  // Month
  M: function M(date, token2) {
    var month = date.getUTCMonth();
    return token2 === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token2) {
    return addLeadingZeros(date.getUTCDate(), token2.length);
  },
  // AM or PM
  a: function a(date, token2) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function h2(date, token2) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token2.length);
  },
  // Hour [0-23]
  H: function H(date, token2) {
    return addLeadingZeros(date.getUTCHours(), token2.length);
  },
  // Minute
  m: function m(date, token2) {
    return addLeadingZeros(date.getUTCMinutes(), token2.length);
  },
  // Second
  s: function s(date, token2) {
    return addLeadingZeros(date.getUTCSeconds(), token2.length);
  },
  // Fraction of second
  S: function S(date, token2) {
    var numberOfDigits = token2.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token2.length);
  }
};
var dayPeriodEnum = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters = {
  // Era
  G: function G(date, token2, localize2) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token2) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  },
  // Year
  y: function y2(date, token2, localize2) {
    if (token2 === "yo") {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$1.y(date, token2);
  },
  // Local week-numbering year
  Y: function Y(date, token2, localize2, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token2 === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token2 === "Yo") {
      return localize2.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros(weekYear, token2.length);
  },
  // ISO week-numbering year
  R: function R(date, token2) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token2.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token2) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token2.length);
  },
  // Quarter
  Q: function Q(date, token2, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token2) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token2, localize2) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token2) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function M2(date, token2, localize2) {
    var month = date.getUTCMonth();
    switch (token2) {
      case "M":
      case "MM":
        return formatters$1.M(date, token2);
      case "Mo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function L(date, token2, localize2) {
    var month = date.getUTCMonth();
    switch (token2) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function w(date, token2, localize2, options) {
    var week = getUTCWeek(date, options);
    if (token2 === "wo") {
      return localize2.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros(week, token2.length);
  },
  // ISO week of year
  I: function I(date, token2, localize2) {
    var isoWeek = getUTCISOWeek(date);
    if (token2 === "Io") {
      return localize2.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token2.length);
  },
  // Day of the month
  d: function d2(date, token2, localize2) {
    if (token2 === "do") {
      return localize2.ordinalNumber(date.getUTCDate(), {
        unit: "date"
      });
    }
    return formatters$1.d(date, token2);
  },
  // Day of year
  D: function D(date, token2, localize2) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token2 === "Do") {
      return localize2.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token2.length);
  },
  // Day of week
  E: function E(date, token2, localize2) {
    var dayOfWeek = date.getUTCDay();
    switch (token2) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function e(date, token2, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token2, localize2, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token2.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function i(date, token2, localize2) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token2) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token2.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function a2(date, token2, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token2, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token2) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token2, localize2) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token2) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function h3(date, token2, localize2) {
    if (token2 === "ho") {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return formatters$1.h(date, token2);
  },
  // Hour [0-23]
  H: function H2(date, token2, localize2) {
    if (token2 === "Ho") {
      return localize2.ordinalNumber(date.getUTCHours(), {
        unit: "hour"
      });
    }
    return formatters$1.H(date, token2);
  },
  // Hour [0-11]
  K: function K(date, token2, localize2) {
    var hours = date.getUTCHours() % 12;
    if (token2 === "Ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token2.length);
  },
  // Hour [1-24]
  k: function k(date, token2, localize2) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token2 === "ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token2.length);
  },
  // Minute
  m: function m2(date, token2, localize2) {
    if (token2 === "mo") {
      return localize2.ordinalNumber(date.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return formatters$1.m(date, token2);
  },
  // Second
  s: function s2(date, token2, localize2) {
    if (token2 === "so") {
      return localize2.ordinalNumber(date.getUTCSeconds(), {
        unit: "second"
      });
    }
    return formatters$1.s(date, token2);
  },
  // Fraction of second
  S: function S2(date, token2) {
    return formatters$1.S(date, token2);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token2) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone$1(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone$1(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function O(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone$1(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function t(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token2.length);
  },
  // Milliseconds timestamp
  T: function T(date, token2, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token2.length);
  }
};
function formatTimezoneShort(offset2, dirtyDelimiter) {
  var sign3 = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign3 + String(hours);
  }
  var delimiter = dirtyDelimiter;
  return sign3 + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset2, dirtyDelimiter) {
  if (offset2 % 60 === 0) {
    var sign3 = offset2 > 0 ? "-" : "+";
    return sign3 + addLeadingZeros(Math.abs(offset2) / 60, 2);
  }
  return formatTimezone$1(offset2, dirtyDelimiter);
}
function formatTimezone$1(offset2, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign3 = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign3 + hours + delimiter + minutes;
}
var dateLongFormatter = function dateLongFormatter2(pattern, formatLong2) {
  switch (pattern) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
};
var timeLongFormatter = function timeLongFormatter2(pattern, formatLong2) {
  switch (pattern) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter2(pattern, formatLong2) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token2) {
  return protectedDayOfYearTokens.indexOf(token2) !== -1;
}
function isProtectedWeekYearToken(token2) {
  return protectedWeekYearTokens.indexOf(token2) !== -1;
}
function throwProtectedError(token2, format2, input) {
  if (token2 === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance = function formatDistance2(token2, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token2];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative = function formatRelative2(token2, _date, _baseDate, _options) {
  return formatRelativeLocale[token2];
};
function buildLocalizeFn(args) {
  return function(dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber = function ordinalNumber2(dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value2;
    value2 = args.valueCallback ? args.valueCallback(key) : key;
    value2 = options.valueCallback ? options.valueCallback(value2) : value2;
    var rest = string.slice(matchedString.length);
    return {
      value: value2,
      rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value2 = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value2 = options.valueCallback ? options.valueCallback(value2) : value2;
    var rest = string.slice(matchedString.length);
    return {
      value: value2,
      rest
    };
  };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function valueCallback2(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
var locale = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var formattingTokensRegExp$2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$2 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$2 = /''/g;
var unescapedLatinCharacterRegExp$2 = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions2 = getDefaultOptions();
  var locale$1 = (_ref = (_options$locale = void 0) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : locale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = void 0) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : void 0) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = void 0) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : void 0) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale$1.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale$1.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$2).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString$2(substring);
    }
    var formatter2 = formatters[firstCharacter];
    if (formatter2) {
      if (isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter2(utcDate, substring, locale$1.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$2)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString$2(input) {
  var matched = input.match(escapedStringRegExp$2);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp$2, "'");
}
function assign$1(target2, object) {
  if (target2 == null) {
    throw new TypeError("assign requires that input parameter not be null or undefined");
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      target2[property] = object[property];
    }
  }
  return target2;
}
var defaultFormat$1 = ["years", "months", "weeks", "days", "hours", "minutes", "seconds"];
function formatDuration$2(duration2, options) {
  var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;
  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  }
  var defaultOptions2 = getDefaultOptions();
  var locale$1 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : locale;
  var format2 = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : defaultFormat$1;
  var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
  var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : " ";
  if (!locale$1.formatDistance) {
    return "";
  }
  var result = format2.reduce(function(acc, unit) {
    var token2 = "x".concat(unit.replace(/(^.)/, function(m3) {
      return m3.toUpperCase();
    }));
    var value2 = duration2[unit];
    if (typeof value2 === "number" && (zero || duration2[unit])) {
      return acc.concat(locale$1.formatDistance(token2, value2));
    }
    return acc;
  }, []).join(delimiter);
  return result;
}
function intervalToDuration(interval) {
  requiredArgs(1, arguments);
  var start = toDate(interval.start);
  var end = toDate(interval.end);
  if (isNaN(start.getTime())) throw new RangeError("Start Date is invalid");
  if (isNaN(end.getTime())) throw new RangeError("End Date is invalid");
  var duration2 = {};
  duration2.years = Math.abs(differenceInYears(end, start));
  var sign3 = compareAsc(end, start);
  var remainingMonths = add(start, {
    years: sign3 * duration2.years
  });
  duration2.months = Math.abs(differenceInMonths(end, remainingMonths));
  var remainingDays = add(remainingMonths, {
    months: sign3 * duration2.months
  });
  duration2.days = Math.abs(differenceInDays(end, remainingDays));
  var remainingHours = add(remainingDays, {
    days: sign3 * duration2.days
  });
  duration2.hours = Math.abs(differenceInHours(end, remainingHours));
  var remainingMinutes = add(remainingHours, {
    hours: sign3 * duration2.hours
  });
  duration2.minutes = Math.abs(differenceInMinutes(end, remainingMinutes));
  var remainingSeconds = add(remainingMinutes, {
    minutes: sign3 * duration2.minutes
  });
  duration2.seconds = Math.abs(differenceInSeconds(end, remainingSeconds));
  return duration2;
}
function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}
function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}
function _arrayLikeToArray(r, a3) {
  (null == a3 || a3 > r.length) && (a3 = r.length);
  for (var e2 = 0, n = Array(a3); e2 < a3; e2++) n[e2] = r[e2];
  return n;
}
function _unsupportedIterableToArray(r, a3) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a3);
    var t2 = {}.toString.call(r).slice(8, -1);
    return "Object" === t2 && r.constructor && (t2 = r.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray(r, a3) : void 0;
  }
}
function _createForOfIteratorHelper(r, e2) {
  var t2 = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t2) {
    if (Array.isArray(r) || (t2 = _unsupportedIterableToArray(r)) || e2) {
      t2 && (r = t2);
      var _n = 0, F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: true
          } : {
            done: false,
            value: r[_n++]
          };
        },
        e: function e3(r2) {
          throw r2;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o, a3 = true, u2 = false;
  return {
    s: function s3() {
      t2 = t2.call(r);
    },
    n: function n() {
      var r2 = t2.next();
      return a3 = r2.done, r2;
    },
    e: function e3(r2) {
      u2 = true, o = r2;
    },
    f: function f() {
      try {
        a3 || null == t2["return"] || t2["return"]();
      } finally {
        if (u2) throw o;
      }
    }
  };
}
function _assertThisInitialized(e2) {
  if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e2;
}
function _setPrototypeOf(t2, e2) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t3, e3) {
    return t3.__proto__ = e3, t3;
  }, _setPrototypeOf(t2, e2);
}
function _inherits(t2, e2) {
  if ("function" != typeof e2 && null !== e2) throw new TypeError("Super expression must either be null or a function");
  t2.prototype = Object.create(e2 && e2.prototype, {
    constructor: {
      value: t2,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t2, "prototype", {
    writable: false
  }), e2 && _setPrototypeOf(t2, e2);
}
function _getPrototypeOf(t2) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t3) {
    return t3.__proto__ || Object.getPrototypeOf(t3);
  }, _getPrototypeOf(t2);
}
function _isNativeReflectConstruct() {
  try {
    var t2 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t3) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t2;
  })();
}
function _possibleConstructorReturn(t2, e2) {
  if (e2 && ("object" == _typeof(e2) || "function" == typeof e2)) return e2;
  if (void 0 !== e2) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t2);
}
function _createSuper(t2) {
  var r = _isNativeReflectConstruct();
  return function() {
    var e2, o = _getPrototypeOf(t2);
    if (r) {
      var s3 = _getPrototypeOf(this).constructor;
      e2 = Reflect.construct(o, arguments, s3);
    } else e2 = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e2);
  };
}
function _classCallCheck(a3, n) {
  if (!(a3 instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function toPrimitive(t2, r) {
  if ("object" != _typeof(t2) || !t2) return t2;
  var e2 = t2[Symbol.toPrimitive];
  if (void 0 !== e2) {
    var i2 = e2.call(t2, r);
    if ("object" != _typeof(i2)) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t2);
}
function toPropertyKey(t2) {
  var i2 = toPrimitive(t2, "string");
  return "symbol" == _typeof(i2) ? i2 : i2 + "";
}
function _defineProperties(e2, r) {
  for (var t2 = 0; t2 < r.length; t2++) {
    var o = r[t2];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e2, toPropertyKey(o.key), o);
  }
}
function _createClass(e2, r, t2) {
  return r && _defineProperties(e2.prototype, r), Object.defineProperty(e2, "prototype", {
    writable: false
  }), e2;
}
function _defineProperty(e2, r, t2) {
  return (r = toPropertyKey(r)) in e2 ? Object.defineProperty(e2, r, {
    value: t2,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e2[r] = t2, e2;
}
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /* @__PURE__ */ function() {
  function Setter2() {
    _classCallCheck(this, Setter2);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", 0);
  }
  _createClass(Setter2, [{
    key: "validate",
    value: function validate2(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter2;
}();
var ValueSetter = /* @__PURE__ */ function(_Setter) {
  _inherits(ValueSetter2, _Setter);
  var _super = _createSuper(ValueSetter2);
  function ValueSetter2(value2, validateValue, setValue, priority, subPriority) {
    var _this;
    _classCallCheck(this, ValueSetter2);
    _this = _super.call(this);
    _this.value = value2;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  _createClass(ValueSetter2, [{
    key: "validate",
    value: function validate2(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set2(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);
  return ValueSetter2;
}(Setter);
var DateToSystemTimezoneSetter = /* @__PURE__ */ function(_Setter2) {
  _inherits(DateToSystemTimezoneSetter2, _Setter2);
  var _super2 = _createSuper(DateToSystemTimezoneSetter2);
  function DateToSystemTimezoneSetter2() {
    var _this2;
    _classCallCheck(this, DateToSystemTimezoneSetter2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
    _defineProperty(_assertThisInitialized(_this2), "subPriority", -1);
    return _this2;
  }
  _createClass(DateToSystemTimezoneSetter2, [{
    key: "set",
    value: function set2(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }
      var convertedDate = /* @__PURE__ */ new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter2;
}(Setter);
var Parser = /* @__PURE__ */ function() {
  function Parser2() {
    _classCallCheck(this, Parser2);
    _defineProperty(this, "incompatibleTokens", void 0);
    _defineProperty(this, "priority", void 0);
    _defineProperty(this, "subPriority", void 0);
  }
  _createClass(Parser2, [{
    key: "run",
    value: function run2(dateString, token2, match2, options) {
      var result = this.parse(dateString, token2, match2, options);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate2(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser2;
}();
var EraParser = /* @__PURE__ */ function(_Parser) {
  _inherits(EraParser2, _Parser);
  var _super = _createSuper(EraParser2);
  function EraParser2() {
    var _this;
    _classCallCheck(this, EraParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 140);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["R", "u", "t", "T"]);
    return _this;
  }
  _createClass(EraParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "G":
        case "GG":
        case "GGG":
          return match2.era(dateString, {
            width: "abbreviated"
          }) || match2.era(dateString, {
            width: "narrow"
          });
        case "GGGGG":
          return match2.era(dateString, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return match2.era(dateString, {
            width: "wide"
          }) || match2.era(dateString, {
            width: "abbreviated"
          }) || match2.era(dateString, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      flags.era = value2;
      date.setUTCFullYear(value2, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser2;
}(Parser);
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign3 = matchResult[1] === "+" ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign3 * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
var YearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(YearParser2, _Parser);
  var _super = _createSuper(YearParser2);
  function YearParser2() {
    var _this;
    _classCallCheck(this, YearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(YearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(year) {
        return {
          year,
          isTwoDigitYear: token2 === "yy"
        };
      };
      switch (token2) {
        case "y":
          return mapValue(parseNDigits(4, dateString), valueCallback3);
        case "yo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "year"
          }), valueCallback3);
        default:
          return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2.isTwoDigitYear || value2.year > 0;
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      var currentYear = date.getUTCFullYear();
      if (value2.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value2.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !("era" in flags) || flags.era === 1 ? value2.year : 1 - value2.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser2;
}(Parser);
var LocalWeekYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(LocalWeekYearParser2, _Parser);
  var _super = _createSuper(LocalWeekYearParser2);
  function LocalWeekYearParser2() {
    var _this;
    _classCallCheck(this, LocalWeekYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this;
  }
  _createClass(LocalWeekYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(year) {
        return {
          year,
          isTwoDigitYear: token2 === "YY"
        };
      };
      switch (token2) {
        case "Y":
          return mapValue(parseNDigits(4, dateString), valueCallback3);
        case "Yo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "year"
          }), valueCallback3);
        default:
          return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2.isTwoDigitYear || value2.year > 0;
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2, options) {
      var currentYear = getUTCWeekYear(date, options);
      if (value2.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value2.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }
      var year = !("era" in flags) || flags.era === 1 ? value2.year : 1 - value2.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    }
  }]);
  return LocalWeekYearParser2;
}(Parser);
var ISOWeekYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISOWeekYearParser2, _Parser);
  var _super = _createSuper(ISOWeekYearParser2);
  function ISOWeekYearParser2() {
    var _this;
    _classCallCheck(this, ISOWeekYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ISOWeekYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      if (token2 === "R") {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token2.length, dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value2) {
      var firstWeekOfYear = /* @__PURE__ */ new Date(0);
      firstWeekOfYear.setUTCFullYear(value2, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser2;
}(Parser);
var ExtendedYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ExtendedYearParser2, _Parser);
  var _super = _createSuper(ExtendedYearParser2);
  function ExtendedYearParser2() {
    var _this;
    _classCallCheck(this, ExtendedYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 130);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ExtendedYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      if (token2 === "u") {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token2.length, dateString);
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCFullYear(value2, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser2;
}(Parser);
var QuarterParser = /* @__PURE__ */ function(_Parser) {
  _inherits(QuarterParser2, _Parser);
  var _super = _createSuper(QuarterParser2);
  function QuarterParser2() {
    var _this;
    _classCallCheck(this, QuarterParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 120);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(QuarterParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "Q":
        case "QQ":
          return parseNDigits(token2.length, dateString);
        case "Qo":
          return match2.ordinalNumber(dateString, {
            unit: "quarter"
          });
        case "QQQ":
          return match2.quarter(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return match2.quarter(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 4;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth((value2 - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser2;
}(Parser);
var StandAloneQuarterParser = /* @__PURE__ */ function(_Parser) {
  _inherits(StandAloneQuarterParser2, _Parser);
  var _super = _createSuper(StandAloneQuarterParser2);
  function StandAloneQuarterParser2() {
    var _this;
    _classCallCheck(this, StandAloneQuarterParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 120);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(StandAloneQuarterParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "q":
        case "qq":
          return parseNDigits(token2.length, dateString);
        case "qo":
          return match2.ordinalNumber(dateString, {
            unit: "quarter"
          });
        case "qqq":
          return match2.quarter(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return match2.quarter(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 4;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth((value2 - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser2;
}(Parser);
var MonthParser = /* @__PURE__ */ function(_Parser) {
  _inherits(MonthParser2, _Parser);
  var _super = _createSuper(MonthParser2);
  function MonthParser2() {
    var _this;
    _classCallCheck(this, MonthParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]);
    _defineProperty(_assertThisInitialized(_this), "priority", 110);
    return _this;
  }
  _createClass(MonthParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(value2) {
        return value2 - 1;
      };
      switch (token2) {
        case "M":
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback3);
        case "MM":
          return mapValue(parseNDigits(2, dateString), valueCallback3);
        case "Mo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "month"
          }), valueCallback3);
        case "MMM":
          return match2.month(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return match2.month(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth(value2, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser2;
}(Parser);
var StandAloneMonthParser = /* @__PURE__ */ function(_Parser) {
  _inherits(StandAloneMonthParser2, _Parser);
  var _super = _createSuper(StandAloneMonthParser2);
  function StandAloneMonthParser2() {
    var _this;
    _classCallCheck(this, StandAloneMonthParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 110);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(StandAloneMonthParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(value2) {
        return value2 - 1;
      };
      switch (token2) {
        case "L":
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback3);
        case "LL":
          return mapValue(parseNDigits(2, dateString), valueCallback3);
        case "Lo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "month"
          }), valueCallback3);
        case "LLL":
          return match2.month(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return match2.month(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth(value2, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser2;
}(Parser);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
var LocalWeekParser = /* @__PURE__ */ function(_Parser) {
  _inherits(LocalWeekParser2, _Parser);
  var _super = _createSuper(LocalWeekParser2);
  function LocalWeekParser2() {
    var _this;
    _classCallCheck(this, LocalWeekParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 100);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this;
  }
  _createClass(LocalWeekParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "w":
          return parseNumericPattern(numericPatterns.week, dateString);
        case "wo":
          return match2.ordinalNumber(dateString, {
            unit: "week"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 53;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options) {
      return startOfUTCWeek(setUTCWeek(date, value2, options), options);
    }
  }]);
  return LocalWeekParser2;
}(Parser);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
var ISOWeekParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISOWeekParser2, _Parser);
  var _super = _createSuper(ISOWeekParser2);
  function ISOWeekParser2() {
    var _this;
    _classCallCheck(this, ISOWeekParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 100);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ISOWeekParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "I":
          return parseNumericPattern(numericPatterns.week, dateString);
        case "Io":
          return match2.ordinalNumber(dateString, {
            unit: "week"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 53;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value2));
    }
  }]);
  return ISOWeekParser2;
}(Parser);
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DateParser = /* @__PURE__ */ function(_Parser) {
  _inherits(DateParser2, _Parser);
  var _super = _createSuper(DateParser2);
  function DateParser2() {
    var _this;
    _classCallCheck(this, DateParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "subPriority", 1);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(DateParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "d":
          return parseNumericPattern(numericPatterns.date, dateString);
        case "do":
          return match2.ordinalNumber(dateString, {
            unit: "date"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(date, value2) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value2 >= 1 && value2 <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value2 >= 1 && value2 <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCDate(value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser2;
}(Parser);
var DayOfYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(DayOfYearParser2, _Parser);
  var _super = _createSuper(DayOfYearParser2);
  function DayOfYearParser2() {
    var _this;
    _classCallCheck(this, DayOfYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "subpriority", 1);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(DayOfYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "D":
        case "DD":
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);
        case "Do":
          return match2.ordinalNumber(dateString, {
            unit: "date"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(date, value2) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      if (isLeapYear) {
        return value2 >= 1 && value2 <= 366;
      } else {
        return value2 >= 1 && value2 <= 365;
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMonth(0, value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser2;
}(Parser);
function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var DayParser = /* @__PURE__ */ function(_Parser) {
  _inherits(DayParser2, _Parser);
  var _super = _createSuper(DayParser2);
  function DayParser2() {
    var _this;
    _classCallCheck(this, DayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(DayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "E":
        case "EE":
        case "EEE":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options) {
      date = setUTCDay(date, value2, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser2;
}(Parser);
var LocalDayParser = /* @__PURE__ */ function(_Parser) {
  _inherits(LocalDayParser2, _Parser);
  var _super = _createSuper(LocalDayParser2);
  function LocalDayParser2() {
    var _this;
    _classCallCheck(this, LocalDayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]);
    return _this;
  }
  _createClass(LocalDayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2, options) {
      var valueCallback3 = function valueCallback4(value2) {
        var wholeWeekDays = Math.floor((value2 - 1) / 7) * 7;
        return (value2 + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token2) {
        case "e":
        case "ee":
          return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
        case "eo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "day"
          }), valueCallback3);
        case "eee":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options) {
      date = setUTCDay(date, value2, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser2;
}(Parser);
var StandAloneLocalDayParser = /* @__PURE__ */ function(_Parser) {
  _inherits(StandAloneLocalDayParser2, _Parser);
  var _super = _createSuper(StandAloneLocalDayParser2);
  function StandAloneLocalDayParser2() {
    var _this;
    _classCallCheck(this, StandAloneLocalDayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]);
    return _this;
  }
  _createClass(StandAloneLocalDayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2, options) {
      var valueCallback3 = function valueCallback4(value2) {
        var wholeWeekDays = Math.floor((value2 - 1) / 7) * 7;
        return (value2 + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token2) {
        case "c":
        case "cc":
          return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
        case "co":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "day"
          }), valueCallback3);
        case "ccc":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 6;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2, options) {
      date = setUTCDay(date, value2, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser2;
}(Parser);
function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var ISODayParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISODayParser2, _Parser);
  var _super = _createSuper(ISODayParser2);
  function ISODayParser2() {
    var _this;
    _classCallCheck(this, ISODayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 90);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ISODayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(value2) {
        if (value2 === 0) {
          return 7;
        }
        return value2;
      };
      switch (token2) {
        case "i":
        case "ii":
          return parseNDigits(token2.length, dateString);
        case "io":
          return match2.ordinalNumber(dateString, {
            unit: "day"
          });
        case "iii":
          return mapValue(match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback3);
        case "iiiii":
          return mapValue(match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback3);
        case "iiiiii":
          return mapValue(match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback3);
        case "iiii":
        default:
          return mapValue(match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback3);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 7;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date = setUTCISODay(date, value2);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser2;
}(Parser);
var AMPMParser = /* @__PURE__ */ function(_Parser) {
  _inherits(AMPMParser2, _Parser);
  var _super = _createSuper(AMPMParser2);
  function AMPMParser2() {
    var _this;
    _classCallCheck(this, AMPMParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(AMPMParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "a":
        case "aa":
        case "aaa":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser2;
}(Parser);
var AMPMMidnightParser = /* @__PURE__ */ function(_Parser) {
  _inherits(AMPMMidnightParser2, _Parser);
  var _super = _createSuper(AMPMMidnightParser2);
  function AMPMMidnightParser2() {
    var _this;
    _classCallCheck(this, AMPMMidnightParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(AMPMMidnightParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "b":
        case "bb":
        case "bbb":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser2;
}(Parser);
var DayPeriodParser = /* @__PURE__ */ function(_Parser) {
  _inherits(DayPeriodParser2, _Parser);
  var _super = _createSuper(DayPeriodParser2);
  function DayPeriodParser2() {
    var _this;
    _classCallCheck(this, DayPeriodParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["a", "b", "t", "T"]);
    return _this;
  }
  _createClass(DayPeriodParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "B":
        case "BB":
        case "BBB":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser2;
}(Parser);
var Hour1to12Parser = /* @__PURE__ */ function(_Parser) {
  _inherits(Hour1to12Parser2, _Parser);
  var _super = _createSuper(Hour1to12Parser2);
  function Hour1to12Parser2() {
    var _this;
    _classCallCheck(this, Hour1to12Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["H", "K", "k", "t", "T"]);
    return _this;
  }
  _createClass(Hour1to12Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "h":
          return parseNumericPattern(numericPatterns.hour12h, dateString);
        case "ho":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 12;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value2 < 12) {
        date.setUTCHours(value2 + 12, 0, 0, 0);
      } else if (!isPM && value2 === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value2, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser2;
}(Parser);
var Hour0to23Parser = /* @__PURE__ */ function(_Parser) {
  _inherits(Hour0to23Parser2, _Parser);
  var _super = _createSuper(Hour0to23Parser2);
  function Hour0to23Parser2() {
    var _this;
    _classCallCheck(this, Hour0to23Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
    return _this;
  }
  _createClass(Hour0to23Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "H":
          return parseNumericPattern(numericPatterns.hour23h, dateString);
        case "Ho":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 23;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCHours(value2, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser2;
}(Parser);
var Hour0To11Parser = /* @__PURE__ */ function(_Parser) {
  _inherits(Hour0To11Parser2, _Parser);
  var _super = _createSuper(Hour0To11Parser2);
  function Hour0To11Parser2() {
    var _this;
    _classCallCheck(this, Hour0To11Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["h", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(Hour0To11Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "K":
          return parseNumericPattern(numericPatterns.hour11h, dateString);
        case "Ko":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 11;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value2 < 12) {
        date.setUTCHours(value2 + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value2, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser2;
}(Parser);
var Hour1To24Parser = /* @__PURE__ */ function(_Parser) {
  _inherits(Hour1To24Parser2, _Parser);
  var _super = _createSuper(Hour1To24Parser2);
  function Hour1To24Parser2() {
    var _this;
    _classCallCheck(this, Hour1To24Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 70);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
    return _this;
  }
  _createClass(Hour1To24Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "k":
          return parseNumericPattern(numericPatterns.hour24h, dateString);
        case "ko":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 1 && value2 <= 24;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      var hours = value2 <= 24 ? value2 % 24 : value2;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser2;
}(Parser);
var MinuteParser = /* @__PURE__ */ function(_Parser) {
  _inherits(MinuteParser2, _Parser);
  var _super = _createSuper(MinuteParser2);
  function MinuteParser2() {
    var _this;
    _classCallCheck(this, MinuteParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 60);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass(MinuteParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "m":
          return parseNumericPattern(numericPatterns.minute, dateString);
        case "mo":
          return match2.ordinalNumber(dateString, {
            unit: "minute"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 59;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMinutes(value2, 0, 0);
      return date;
    }
  }]);
  return MinuteParser2;
}(Parser);
var SecondParser = /* @__PURE__ */ function(_Parser) {
  _inherits(SecondParser2, _Parser);
  var _super = _createSuper(SecondParser2);
  function SecondParser2() {
    var _this;
    _classCallCheck(this, SecondParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 50);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass(SecondParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "s":
          return parseNumericPattern(numericPatterns.second, dateString);
        case "so":
          return match2.ordinalNumber(dateString, {
            unit: "second"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate2(_date, value2) {
      return value2 >= 0 && value2 <= 59;
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCSeconds(value2, 0);
      return date;
    }
  }]);
  return SecondParser2;
}(Parser);
var FractionOfSecondParser = /* @__PURE__ */ function(_Parser) {
  _inherits(FractionOfSecondParser2, _Parser);
  var _super = _createSuper(FractionOfSecondParser2);
  function FractionOfSecondParser2() {
    var _this;
    _classCallCheck(this, FractionOfSecondParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 30);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass(FractionOfSecondParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      var valueCallback3 = function valueCallback4(value2) {
        return Math.floor(value2 * Math.pow(10, -token2.length + 3));
      };
      return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
    }
  }, {
    key: "set",
    value: function set2(date, _flags, value2) {
      date.setUTCMilliseconds(value2);
      return date;
    }
  }]);
  return FractionOfSecondParser2;
}(Parser);
var ISOTimezoneWithZParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISOTimezoneWithZParser2, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser2);
  function ISOTimezoneWithZParser2() {
    var _this;
    _classCallCheck(this, ISOTimezoneWithZParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 10);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T", "x"]);
    return _this;
  }
  _createClass(ISOTimezoneWithZParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      switch (token2) {
        case "X":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case "XX":
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case "XXXX":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case "XXXXX":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case "XXX":
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value2);
    }
  }]);
  return ISOTimezoneWithZParser2;
}(Parser);
var ISOTimezoneParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISOTimezoneParser2, _Parser);
  var _super = _createSuper(ISOTimezoneParser2);
  function ISOTimezoneParser2() {
    var _this;
    _classCallCheck(this, ISOTimezoneParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 10);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T", "X"]);
    return _this;
  }
  _createClass(ISOTimezoneParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      switch (token2) {
        case "x":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case "xx":
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case "xxxx":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case "xxxxx":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case "xxx":
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set2(date, flags, value2) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value2);
    }
  }]);
  return ISOTimezoneParser2;
}(Parser);
var TimestampSecondsParser = /* @__PURE__ */ function(_Parser) {
  _inherits(TimestampSecondsParser2, _Parser);
  var _super = _createSuper(TimestampSecondsParser2);
  function TimestampSecondsParser2() {
    var _this;
    _classCallCheck(this, TimestampSecondsParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 40);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", "*");
    return _this;
  }
  _createClass(TimestampSecondsParser2, [{
    key: "parse",
    value: function parse2(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value2) {
      return [new Date(value2 * 1e3), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser2;
}(Parser);
var TimestampMillisecondsParser = /* @__PURE__ */ function(_Parser) {
  _inherits(TimestampMillisecondsParser2, _Parser);
  var _super = _createSuper(TimestampMillisecondsParser2);
  function TimestampMillisecondsParser2() {
    var _this;
    _classCallCheck(this, TimestampMillisecondsParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 20);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", "*");
    return _this;
  }
  _createClass(TimestampMillisecondsParser2, [{
    key: "parse",
    value: function parse2(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set2(_date, _flags, value2) {
      return [new Date(value2), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser2;
}(Parser);
var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function parse$3(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions2 = getDefaultOptions();
  var locale$1 = (_ref = (_options$locale = void 0) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : locale;
  if (!locale$1.match) {
    throw new RangeError("locale must contain match property");
  }
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = void 0) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : void 0) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = void 0) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : void 0) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (formatString === "") {
    if (dateString === "") {
      return toDate(dirtyReferenceDate);
    } else {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale$1
  };
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters) {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$1);
  var usedTokens = [];
  var _iterator = _createForOfIteratorHelper(tokens), _step;
  try {
    var _loop = function _loop2() {
      var token2 = _step.value;
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token2)) {
        throwProtectedError(token2, formatString, dirtyDateString);
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token2)) {
        throwProtectedError(token2, formatString, dirtyDateString);
      }
      var firstCharacter = token2[0];
      var parser = parsers[firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function(usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token2, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token2, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token2
        });
        var parseResult = parser.run(dateString, token2, locale$1.match, subFnOptions);
        if (!parseResult) {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        }
        if (token2 === "''") {
          token2 = "'";
        } else if (firstCharacter === "'") {
          token2 = cleanEscapedString$1(token2);
        }
        if (dateString.indexOf(token2) === 0) {
          dateString = dateString.slice(token2.length);
        } else {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var _ret = _loop();
      if (_typeof(_ret) === "object") return _ret.v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function(setter2) {
    return setter2.priority;
  }).sort(function(a3, b2) {
    return b2 - a3;
  }).filter(function(priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function(priority) {
    return setters.filter(function(setter2) {
      return setter2.priority === priority;
    }).sort(function(a3, b2) {
      return b2.subPriority - a3.subPriority;
    });
  }).map(function(setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};
  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters), _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
      var setter = _step2.value;
      if (!setter.validate(utcDate, subFnOptions)) {
        return /* @__PURE__ */ new Date(NaN);
      }
      var result = setter.set(utcDate, flags, subFnOptions);
      if (Array.isArray(result)) {
        utcDate = result[0];
        assign$1(flags, result[1]);
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate;
}
function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}
function isWithinInterval(dirtyDate, interval) {
  requiredArgs(2, arguments);
  var time = toDate(dirtyDate).getTime();
  var startTime = toDate(interval.start).getTime();
  var endTime = toDate(interval.end).getTime();
  if (!(startTime <= endTime)) {
    throw new RangeError("Invalid interval");
  }
  return time >= startTime && time <= endTime;
}
var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function lightFormat(dirtyDate, formatStr) {
  requiredArgs(2, arguments);
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var tokens = formatStr.match(formattingTokensRegExp);
  if (!tokens) return "";
  var result = tokens.map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter2 = formatters$1[firstCharacter];
    if (formatter2) {
      return formatter2(utcDate, substring);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString(input) {
  var matches = input.match(escapedStringRegExp);
  if (!matches) {
    return input;
  }
  return matches[1].replace(doubleQuoteRegExp, "'");
}
function parseISO(argument, options) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = void 0) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  }
  if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset2;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset2 = parseTimezone(dateStrings.timezone);
    if (isNaN(offset2)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    var result = /* @__PURE__ */ new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset2);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token2 = patterns.timezone.exec(timeString);
    if (token2) {
      dateStrings.time = timeString.replace(token2[1], "");
      dateStrings.timezone = token2[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
  var captures = dateString.match(regex);
  if (!captures) return {
    year: NaN,
    restDateString: ""
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  if (year === null) return /* @__PURE__ */ new Date(NaN);
  var captures = dateString.match(dateRegex);
  if (!captures) return /* @__PURE__ */ new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = /* @__PURE__ */ new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value2) {
  return value2 ? parseInt(value2) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN;
  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1e3;
}
function parseTimeUnit(value2) {
  return value2 && parseFloat(value2.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign3 = captures[1] === "+" ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign3 * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = /* @__PURE__ */ new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
function startOfToday() {
  return startOfDay(Date.now());
}
var DateTemplates;
(function(DateTemplates2) {
  DateTemplates2["Days"] = "MMMM d";
  DateTemplates2["Long"] = "yyyy-MM-dd HH:mm:ss";
  DateTemplates2["Short"] = "yyyy-MM-dd";
})(DateTemplates || (DateTemplates = {}));
function formatDate$1(value2, fmt = DateTemplates.Long) {
  const date = value2 instanceof Date ? value2 : parseISO(value2);
  return isValid(date) ? lightFormat(date, fmt) : "";
}
function formatDuration$1(duration2) {
  return formatDuration$2(intervalToDuration({
    end: duration2,
    start: 0
  }), { delimiter: " " });
}
function formatInterval(start, end) {
  const diff = differenceInSeconds(end, start);
  const hours = Math.floor(diff / 3600);
  const minutes = Math.floor(diff / 60 % 60);
  const seconds = diff % 60;
  return hours ? `${hours}h ${minutes}m` : minutes ? `${minutes}m ${seconds}s` : `${seconds}s`;
}
({
  isMac: (() => {
    try {
      return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    } catch {
      return false;
    }
  })()
});
function isInputElement(el) {
  if (!el)
    return false;
  return el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLDivElement && !!el.isContentEditable;
}
async function getFiles(items) {
  const entryFiles = [];
  for (let i2 = 0; i2 < items.length; i2++) {
    const item = items[i2].webkitGetAsEntry();
    if (!item)
      continue;
    entryFiles.push(item);
  }
  const filePromises = entryFiles.map(scanFiles);
  const files = await Promise.all(filePromises);
  return flatten(files);
}
function readEntries(reader) {
  return new Promise((resolve, reject) => {
    reader.readEntries(resolve, reject);
  });
}
function readFile(item) {
  return new Promise((resolve, reject) => {
    item.file(resolve, reject);
  });
}
async function scanDirectories(item) {
  const reader = item.createReader();
  const result = [];
  let entries;
  do {
    entries = await readEntries(reader);
    result.push(...entries);
  } while (entries.length > 0);
  return result;
}
async function scanFiles(item) {
  if (item.isFile) {
    const file = await readFile(item);
    return [file];
  } else if (item.isDirectory) {
    const entries = await scanDirectories(item);
    const filePromises = entries.map(scanFiles);
    const files = await Promise.all(filePromises);
    return flatten(files);
  } else {
    return [];
  }
}
const K2 = 1024;
const SIZES$3 = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
function formatBytes(bytes, decimals = 1) {
  if (!bytes)
    return "0 MB";
  if (bytes === 1)
    return "1 Byte";
  const i2 = Math.floor(Math.log(bytes) / Math.log(K2));
  return `${parseFloat((bytes / Math.pow(K2, i2)).toFixed(decimals))} ${SIZES$3[i2]}`;
}
function dateSort(x2, y3) {
  const valueX = typeof x2 === "string" ? parseISO(x2) : new Date(x2);
  const valueY = typeof y3 === "string" ? parseISO(y3) : new Date(y3);
  const invalidX = !isValid(valueX);
  const invalidY = !isValid(valueY);
  if (invalidX && invalidY)
    return 0;
  if (invalidX)
    return 1;
  if (invalidY)
    return -1;
  return compareAsc(valueX, valueY);
}
function defaultSort(x2, y3) {
  if (x2 == null && y3 == null)
    return 0;
  if (x2 == null)
    return 1;
  if (y3 == null)
    return -1;
  if (x2 < y3)
    return -1;
  if (x2 > y3)
    return 1;
  return 0;
}
const naturalSortFn = new Intl.Collator(void 0, {
  numeric: true,
  sensitivity: "base"
}).compare;
function naturalSort(x2, y3) {
  if (x2 == null && y3 == null)
    return 0;
  if (x2 == null)
    return 1;
  if (y3 == null)
    return -1;
  return naturalSortFn(x2, y3);
}
function distinct(iterable) {
  return [...new Set(iterable)];
}
function distinctByKey(iterable, key) {
  const result = [];
  const uniqueSet = /* @__PURE__ */ new Set();
  for (const t2 of iterable) {
    const value2 = t2[key];
    if (uniqueSet.has(value2))
      continue;
    uniqueSet.add(value2);
    result.push(t2);
  }
  return result;
}
function sortByDate(iterable, key, asc = true) {
  const sortFn = (a3, b2) => {
    const x2 = asc ? a3[key] : b2[key];
    const y3 = asc ? b2[key] : a3[key];
    return dateSort(x2, y3);
  };
  return Array.from(iterable).sort(sortFn);
}
function sortByKey(iterable, key, asc = true, keySortFn = defaultSort) {
  const sortFn = (a3, b2) => {
    const x2 = asc ? a3[key] : b2[key];
    const y3 = asc ? b2[key] : a3[key];
    return keySortFn(x2, y3);
  };
  return Array.from(iterable).sort(sortFn);
}
function isEmptyPlainObject(object) {
  return object != null && Object.keys(object).length === 0;
}
function mapToObject(o, mapfn, filterFn, sortFn) {
  let entries = Object.entries(o);
  if (filterFn) {
    entries = entries.filter(([key, value2]) => filterFn(value2, key));
  }
  const mapped = entries.map(([key, value2], index) => ({
    [key]: mapfn(value2, key, index)
  }));
  return Object.assign({}, ...mapped);
}
function filterObject(o, filterfn) {
  const entries = Object.entries(o);
  const filtered = entries.filter(([key, value2]) => filterfn(value2, key));
  return Object.fromEntries(filtered);
}
function buildObject(iterable, getKey, getValue) {
  const record = {};
  for (const t2 of iterable) {
    const key = getKey.call(this, t2);
    const value2 = getValue.call(this, t2);
    record[key] = value2;
  }
  return record;
}
async function buildObjectAsync(iterable, keyGetter, loadValue, batchSize = Infinity) {
  const record = {};
  const pendingPromises = [];
  const loadPending = async () => {
    const toLoad = [...pendingPromises];
    pendingPromises.length = 0;
    const loaded = await Promise.all(toLoad);
    for (const [key, value2] of loaded) {
      record[key] = value2;
    }
  };
  for (const t2 of iterable) {
    if (pendingPromises.length >= batchSize) {
      await loadPending();
    }
    const key = keyGetter.call(this, t2);
    const promise = loadValue.call(this, t2).then((value2) => [key, value2]);
    pendingPromises.push(promise);
  }
  await loadPending();
  return record;
}
const DefaultOptions = {
  darkMode: false,
  layout: {},
  navigation: {},
  notification: {},
  session: {},
  tables: {
    carousel: true,
    queryParamsFilters: true
  },
  warnAutomation: true
};
const globalOptions = {
  ...DefaultOptions
};
function initializeOptions(options) {
  Object.assign(globalOptions, options ?? {});
}
function useOptionsReadOnly() {
  return readonly(globalOptions);
}
function useOptions() {
  return globalOptions;
}
function useAutomation(id3) {
  const { warnAutomation } = useOptionsReadOnly();
  if (!id3 && warnAutomation) {
    try {
      const instance = getCurrentInstance();
      let node = instance;
      const hierarchy = [];
      while (node) {
        hierarchy.unshift(node.type.name ?? node.type.__file ?? "?");
        node = node.parent;
      }
      if (hierarchy.length) {
        console.warn(`Missing data-automation for ${hierarchy.join(" > ")}`);
      } else {
        console.warn("Missing data-automation somewhere (not enough information to determine where)");
      }
    } catch {
      console.warn("Missing data-automation somewhere (not enough information to determine where)");
    }
  }
  const buildId = (suffix) => {
    if (!id3) return void 0;
    if (typeof id3 === "string") {
      return suffix ? `${id3}__${suffix}` : id3;
    }
    if (!id3.value) return void 0;
    return suffix ? `${id3.value}__${suffix}` : id3.value;
  };
  const dataAttrs = computed(() => {
    const instance = getCurrentInstance();
    const attrs = instance == null ? void 0 : instance.attrs;
    if (!attrs) return void 0;
    return filterObject(attrs, (_, key) => key.startsWith("data-"));
  });
  return {
    buildId,
    dataAttrs
  };
}
/*!
 * Quasar Framework v2.17.2
 * (c) 2015-present Razvan Stoenescu
 * Released under the MIT License.
 */
var attachPoint = null;
function getAttachPoint() {
  if (attachPoint !== null) return attachPoint;
  return attachPoint = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
}
if (typeof __QUASAR_SSR__ !== "boolean") {
  getAttachPoint().__QUASAR_SSR__ = false;
}
if (typeof __QUASAR_SSR_CLIENT__ !== "boolean") {
  getAttachPoint().__QUASAR_SSR_CLIENT__ = false;
}
if (typeof __QUASAR_SSR_PWA__ !== "boolean") {
  getAttachPoint().__QUASAR_SSR_PWA__ = false;
}
function injectProp(target2, propName, get2, set2) {
  Object.defineProperty(target2, propName, {
    get: get2,
    set: set2,
    enumerable: true
  });
  return target2;
}
function injectMultipleProps(target2, props4) {
  for (const key in props4) {
    injectProp(target2, key, props4[key]);
  }
  return target2;
}
var isRuntimeSsrPreHydration = ref$1(
  __QUASAR_SSR_CLIENT__ && (__QUASAR_SSR_PWA__ ? document.body.getAttribute("data-server-rendered") !== null : true)
);
var preHydrationBrowser;
function getMatch(userAgent2, platformMatch) {
  const match2 = /(edg|edge|edga|edgios)\/([\w.]+)/.exec(userAgent2) || /(opr)[\/]([\w.]+)/.exec(userAgent2) || /(vivaldi)[\/]([\w.]+)/.exec(userAgent2) || /(chrome|crios)[\/]([\w.]+)/.exec(userAgent2) || /(version)(applewebkit)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent2) || /(webkit)[\/]([\w.]+).*(version)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(userAgent2) || /(firefox|fxios)[\/]([\w.]+)/.exec(userAgent2) || /(webkit)[\/]([\w.]+)/.exec(userAgent2) || /(opera)(?:.*version|)[\/]([\w.]+)/.exec(userAgent2) || [];
  return {
    browser: match2[5] || match2[3] || match2[1] || "",
    version: match2[4] || match2[2] || "0",
    platform: platformMatch[0] || ""
  };
}
function getPlatformMatch(userAgent2) {
  return /(ipad)/.exec(userAgent2) || /(ipod)/.exec(userAgent2) || /(windows phone)/.exec(userAgent2) || /(iphone)/.exec(userAgent2) || /(kindle)/.exec(userAgent2) || /(silk)/.exec(userAgent2) || /(android)/.exec(userAgent2) || /(win)/.exec(userAgent2) || /(mac)/.exec(userAgent2) || /(linux)/.exec(userAgent2) || /(cros)/.exec(userAgent2) || /(playbook)/.exec(userAgent2) || /(bb)/.exec(userAgent2) || /(blackberry)/.exec(userAgent2) || [];
}
var hasTouch = "ontouchstart" in window || window.navigator.maxTouchPoints > 0;
function getPlatform(UA) {
  const userAgent2 = UA.toLowerCase();
  const platformMatch = getPlatformMatch(userAgent2);
  const matched = getMatch(userAgent2, platformMatch);
  const browser = {
    mobile: false,
    desktop: false,
    cordova: false,
    capacitor: false,
    nativeMobile: false,
    // nativeMobileWrapper: void 0,
    electron: false,
    bex: false,
    linux: false,
    mac: false,
    win: false,
    cros: false,
    chrome: false,
    firefox: false,
    opera: false,
    safari: false,
    vivaldi: false,
    edge: false,
    edgeChromium: false,
    ie: false,
    webkit: false,
    android: false,
    ios: false,
    ipad: false,
    iphone: false,
    ipod: false,
    kindle: false,
    winphone: false,
    blackberry: false,
    playbook: false,
    silk: false
  };
  if (matched.browser) {
    browser[matched.browser] = true;
    browser.version = matched.version;
    browser.versionNumber = parseInt(matched.version, 10);
  }
  if (matched.platform) {
    browser[matched.platform] = true;
  }
  const knownMobiles = browser.android || browser.ios || browser.bb || browser.blackberry || browser.ipad || browser.iphone || browser.ipod || browser.kindle || browser.playbook || browser.silk || browser["windows phone"];
  if (knownMobiles === true || userAgent2.indexOf("mobile") !== -1) {
    browser.mobile = true;
  } else {
    browser.desktop = true;
  }
  if (browser["windows phone"]) {
    browser.winphone = true;
    delete browser["windows phone"];
  }
  if (browser.edga || browser.edgios || browser.edg) {
    browser.edge = true;
    matched.browser = "edge";
  } else if (browser.crios) {
    browser.chrome = true;
    matched.browser = "chrome";
  } else if (browser.fxios) {
    browser.firefox = true;
    matched.browser = "firefox";
  }
  if (browser.ipod || browser.ipad || browser.iphone) {
    browser.ios = true;
  }
  if (browser.vivaldi) {
    matched.browser = "vivaldi";
    browser.vivaldi = true;
  }
  if (
    // Chrome, Opera 15+, Vivaldi and Safari are webkit based browsers
    browser.chrome || browser.opr || browser.safari || browser.vivaldi || browser.mobile === true && browser.ios !== true && knownMobiles !== true
  ) {
    browser.webkit = true;
  }
  if (browser.opr) {
    matched.browser = "opera";
    browser.opera = true;
  }
  if (browser.safari) {
    if (browser.blackberry || browser.bb) {
      matched.browser = "blackberry";
      browser.blackberry = true;
    } else if (browser.playbook) {
      matched.browser = "playbook";
      browser.playbook = true;
    } else if (browser.android) {
      matched.browser = "android";
      browser.android = true;
    } else if (browser.kindle) {
      matched.browser = "kindle";
      browser.kindle = true;
    } else if (browser.silk) {
      matched.browser = "silk";
      browser.silk = true;
    }
  }
  browser.name = matched.browser;
  browser.platform = matched.platform;
  {
    if (userAgent2.indexOf("electron") !== -1) {
      browser.electron = true;
    } else if (document.location.href.indexOf("-extension://") !== -1) {
      browser.bex = true;
    } else {
      if (window.Capacitor !== void 0) {
        browser.capacitor = true;
        browser.nativeMobile = true;
        browser.nativeMobileWrapper = "capacitor";
      } else if (window._cordovaNative !== void 0 || window.cordova !== void 0) {
        browser.cordova = true;
        browser.nativeMobile = true;
        browser.nativeMobileWrapper = "cordova";
      }
      if (isRuntimeSsrPreHydration.value === true) {
        preHydrationBrowser = { is: { ...browser } };
      }
      if (hasTouch === true && browser.mac === true && (browser.desktop === true && browser.safari === true || browser.nativeMobile === true && browser.android !== true && browser.ios !== true && browser.ipad !== true)) {
        delete browser.mac;
        delete browser.desktop;
        const platform = Math.min(window.innerHeight, window.innerWidth) > 414 ? "ipad" : "iphone";
        Object.assign(browser, {
          mobile: true,
          ios: true,
          platform,
          [platform]: true
        });
      }
      if (browser.mobile !== true && window.navigator.userAgentData && window.navigator.userAgentData.mobile) {
        delete browser.desktop;
        browser.mobile = true;
      }
    }
  }
  return browser;
}
var userAgent = navigator.userAgent || navigator.vendor || window.opera;
var ssrClient = {
  has: {
    touch: false,
    webStorage: false
  },
  within: { iframe: false }
};
var client = {
  userAgent,
  is: getPlatform(userAgent),
  has: {
    touch: hasTouch
  },
  within: {
    iframe: window.self !== window.top
  }
};
var Platform = {
  install(opts) {
    const { $q } = opts;
    if (isRuntimeSsrPreHydration.value === true) {
      opts.onSSRHydrated.push(() => {
        Object.assign($q.platform, client);
        isRuntimeSsrPreHydration.value = false;
      });
      $q.platform = reactive(this);
    } else {
      $q.platform = this;
    }
  }
};
{
  let hasWebStorage;
  injectProp(client.has, "webStorage", () => {
    if (hasWebStorage !== void 0) {
      return hasWebStorage;
    }
    try {
      if (window.localStorage) {
        hasWebStorage = true;
        return true;
      }
    } catch (_) {
    }
    hasWebStorage = false;
    return false;
  });
  Object.assign(Platform, client);
  if (isRuntimeSsrPreHydration.value === true) {
    Object.assign(Platform, preHydrationBrowser, ssrClient);
    preHydrationBrowser = null;
  }
}
var Platform_default = Platform;
function createComponent(raw) {
  return markRaw(defineComponent(raw));
}
function createDirective(raw) {
  return markRaw(raw);
}
var createReactivePlugin = (state2, plugin) => {
  const reactiveState = reactive(state2);
  for (const name2 in state2) {
    injectProp(
      plugin,
      name2,
      () => reactiveState[name2],
      (val) => {
        reactiveState[name2] = val;
      }
    );
  }
  return plugin;
};
var listenOpts = {
  hasPassive: false,
  passiveCapture: true,
  notPassiveCapture: true
};
try {
  const opts = Object.defineProperty({}, "passive", {
    get() {
      Object.assign(listenOpts, {
        hasPassive: true,
        passive: { passive: true },
        notPassive: { passive: false },
        passiveCapture: { passive: true, capture: true },
        notPassiveCapture: { passive: false, capture: true }
      });
    }
  });
  window.addEventListener("qtest", null, opts);
  window.removeEventListener("qtest", null, opts);
} catch (_) {
}
function noop() {
}
function leftClick(e2) {
  return e2.button === 0;
}
function position(e2) {
  if (e2.touches && e2.touches[0]) {
    e2 = e2.touches[0];
  } else if (e2.changedTouches && e2.changedTouches[0]) {
    e2 = e2.changedTouches[0];
  } else if (e2.targetTouches && e2.targetTouches[0]) {
    e2 = e2.targetTouches[0];
  }
  return {
    top: e2.clientY,
    left: e2.clientX
  };
}
function getEventPath(e2) {
  if (e2.path) {
    return e2.path;
  }
  if (e2.composedPath) {
    return e2.composedPath();
  }
  const path = [];
  let el = e2.target;
  while (el) {
    path.push(el);
    if (el.tagName === "HTML") {
      path.push(document);
      path.push(window);
      return path;
    }
    el = el.parentElement;
  }
}
function stop(e2) {
  e2.stopPropagation();
}
function prevent(e2) {
  e2.cancelable !== false && e2.preventDefault();
}
function stopAndPrevent(e2) {
  e2.cancelable !== false && e2.preventDefault();
  e2.stopPropagation();
}
function preventDraggable(el, status) {
  if (el === void 0 || status === true && el.__dragPrevented === true) {
    return;
  }
  const fn = status === true ? (el2) => {
    el2.__dragPrevented = true;
    el2.addEventListener("dragstart", prevent, listenOpts.notPassiveCapture);
  } : (el2) => {
    delete el2.__dragPrevented;
    el2.removeEventListener("dragstart", prevent, listenOpts.notPassiveCapture);
  };
  el.querySelectorAll("a, img").forEach(fn);
}
function addEvt(ctx, targetName, events) {
  const name2 = `__q_${targetName}_evt`;
  ctx[name2] = ctx[name2] !== void 0 ? ctx[name2].concat(events) : events;
  events.forEach((evt) => {
    evt[0].addEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
  });
}
function cleanEvt(ctx, targetName) {
  const name2 = `__q_${targetName}_evt`;
  if (ctx[name2] !== void 0) {
    ctx[name2].forEach((evt) => {
      evt[0].removeEventListener(evt[1], ctx[evt[2]], listenOpts[evt[3]]);
    });
    ctx[name2] = void 0;
  }
}
function debounce_default(fn, wait2 = 250, immediate) {
  let timer2 = null;
  function debounced() {
    const args = arguments;
    const later = () => {
      timer2 = null;
      {
        fn.apply(this, args);
      }
    };
    if (timer2 !== null) {
      clearTimeout(timer2);
    }
    timer2 = setTimeout(later, wait2);
  }
  debounced.cancel = () => {
    timer2 !== null && clearTimeout(timer2);
  };
  return debounced;
}
var SIZE_LIST = ["sm", "md", "lg", "xl"];
var { passive } = listenOpts;
createReactivePlugin({
  width: 0,
  height: 0,
  name: "xs",
  sizes: {
    sm: 600,
    md: 1024,
    lg: 1440,
    xl: 1920
  },
  lt: {
    sm: true,
    md: true,
    lg: true,
    xl: true
  },
  gt: {
    xs: false,
    sm: false,
    md: false,
    lg: false
  },
  xs: true,
  sm: false,
  md: false,
  lg: false,
  xl: false
}, {
  setSizes: noop,
  setDebounce: noop,
  install({ $q, onSSRHydrated }) {
    $q.screen = this;
    if (this.__installed === true) {
      if ($q.config.screen !== void 0) {
        if ($q.config.screen.bodyClasses === false) {
          document.body.classList.remove(`screen--${this.name}`);
        } else {
          this.__update(true);
        }
      }
      return;
    }
    const { visualViewport } = window;
    const target2 = visualViewport || window;
    const scrollingElement = document.scrollingElement || document.documentElement;
    const getSize = visualViewport === void 0 || client.is.mobile === true ? () => [
      Math.max(window.innerWidth, scrollingElement.clientWidth),
      Math.max(window.innerHeight, scrollingElement.clientHeight)
    ] : () => [
      visualViewport.width * visualViewport.scale + window.innerWidth - scrollingElement.clientWidth,
      visualViewport.height * visualViewport.scale + window.innerHeight - scrollingElement.clientHeight
    ];
    const classes = $q.config.screen !== void 0 && $q.config.screen.bodyClasses === true;
    this.__update = (force) => {
      const [w2, h138] = getSize();
      if (h138 !== this.height) {
        this.height = h138;
      }
      if (w2 !== this.width) {
        this.width = w2;
      } else if (force !== true) {
        return;
      }
      let s3 = this.sizes;
      this.gt.xs = w2 >= s3.sm;
      this.gt.sm = w2 >= s3.md;
      this.gt.md = w2 >= s3.lg;
      this.gt.lg = w2 >= s3.xl;
      this.lt.sm = w2 < s3.sm;
      this.lt.md = w2 < s3.md;
      this.lt.lg = w2 < s3.lg;
      this.lt.xl = w2 < s3.xl;
      this.xs = this.lt.sm;
      this.sm = this.gt.xs === true && this.lt.md === true;
      this.md = this.gt.sm === true && this.lt.lg === true;
      this.lg = this.gt.md === true && this.lt.xl === true;
      this.xl = this.gt.lg;
      s3 = this.xs === true && "xs" || this.sm === true && "sm" || this.md === true && "md" || this.lg === true && "lg" || "xl";
      if (s3 !== this.name) {
        if (classes === true) {
          document.body.classList.remove(`screen--${this.name}`);
          document.body.classList.add(`screen--${s3}`);
        }
        this.name = s3;
      }
    };
    let updateEvt, updateSizes = {}, updateDebounce = 16;
    this.setSizes = (sizes) => {
      SIZE_LIST.forEach((name2) => {
        if (sizes[name2] !== void 0) {
          updateSizes[name2] = sizes[name2];
        }
      });
    };
    this.setDebounce = (deb) => {
      updateDebounce = deb;
    };
    const start = () => {
      const style2 = getComputedStyle(document.body);
      if (style2.getPropertyValue("--q-size-sm")) {
        SIZE_LIST.forEach((name2) => {
          this.sizes[name2] = parseInt(style2.getPropertyValue(`--q-size-${name2}`), 10);
        });
      }
      this.setSizes = (sizes) => {
        SIZE_LIST.forEach((name2) => {
          if (sizes[name2]) {
            this.sizes[name2] = sizes[name2];
          }
        });
        this.__update(true);
      };
      this.setDebounce = (delay) => {
        updateEvt !== void 0 && target2.removeEventListener("resize", updateEvt, passive);
        updateEvt = delay > 0 ? debounce_default(this.__update, delay) : this.__update;
        target2.addEventListener("resize", updateEvt, passive);
      };
      this.setDebounce(updateDebounce);
      if (Object.keys(updateSizes).length !== 0) {
        this.setSizes(updateSizes);
        updateSizes = void 0;
      } else {
        this.__update();
      }
      classes === true && this.name === "xs" && document.body.classList.add("screen--xs");
    };
    if (isRuntimeSsrPreHydration.value === true) {
      onSSRHydrated.push(start);
    } else {
      start();
    }
  }
});
var Plugin = createReactivePlugin({
  isActive: false,
  mode: false
}, {
  __media: void 0,
  set(val) {
    Plugin.mode = val;
    if (val === "auto") {
      if (Plugin.__media === void 0) {
        Plugin.__media = window.matchMedia("(prefers-color-scheme: dark)");
        Plugin.__updateMedia = () => {
          Plugin.set("auto");
        };
        Plugin.__media.addListener(Plugin.__updateMedia);
      }
      val = Plugin.__media.matches;
    } else if (Plugin.__media !== void 0) {
      Plugin.__media.removeListener(Plugin.__updateMedia);
      Plugin.__media = void 0;
    }
    Plugin.isActive = val === true;
    document.body.classList.remove(`body--${val === true ? "light" : "dark"}`);
    document.body.classList.add(`body--${val === true ? "dark" : "light"}`);
  },
  toggle() {
    {
      Plugin.set(Plugin.isActive === false);
    }
  },
  install({ $q, ssrContext }) {
    const { dark } = $q.config;
    $q.dark = this;
    if (this.__installed !== true) {
      this.set(dark !== void 0 ? dark : false);
    }
  }
});
function setCssVar(propName, value2, element = document.body) {
  if (typeof propName !== "string") {
    throw new TypeError("Expected a string as propName");
  }
  if (typeof value2 !== "string") {
    throw new TypeError("Expected a string as value");
  }
  if (!(element instanceof Element)) {
    throw new TypeError("Expected a DOM element");
  }
  element.style.setProperty(`--q-${propName}`, value2);
}
function shouldIgnoreKey(evt) {
  return evt !== Object(evt) || evt.isComposing === true || evt.qKeyEvent === true;
}
function isKeyCode(evt, keyCodes4) {
  return shouldIgnoreKey(evt) === true ? false : [].concat(keyCodes4).includes(evt.keyCode);
}
var en_US_default = {
  isoName: "en-US",
  nativeName: "English (US)",
  label: {
    clear: "Clear",
    ok: "OK",
    cancel: "Cancel",
    close: "Close",
    set: "Set",
    select: "Select",
    reset: "Reset",
    remove: "Remove",
    update: "Update",
    create: "Create",
    search: "Search",
    filter: "Filter",
    refresh: "Refresh",
    expand: (label) => label ? `Expand "${label}"` : "Expand",
    collapse: (label) => label ? `Collapse "${label}"` : "Collapse"
  },
  date: {
    days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
    daysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    firstDayOfWeek: 0,
    // 0-6, 0 - Sunday, 1 Monday, ...
    format24h: false,
    pluralDay: "days"
  },
  table: {
    noData: "No data available",
    noResults: "No matching records found",
    loading: "Loading...",
    selectedRecords: (rows) => rows === 1 ? "1 record selected." : (rows === 0 ? "No" : rows) + " records selected.",
    recordsPerPage: "Records per page:",
    allRows: "All",
    pagination: (start, end, total) => start + "-" + end + " of " + total,
    columns: "Columns"
  },
  editor: {
    url: "URL",
    bold: "Bold",
    italic: "Italic",
    strikethrough: "Strikethrough",
    underline: "Underline",
    unorderedList: "Unordered List",
    orderedList: "Ordered List",
    subscript: "Subscript",
    superscript: "Superscript",
    hyperlink: "Hyperlink",
    toggleFullscreen: "Toggle Fullscreen",
    quote: "Quote",
    left: "Left align",
    center: "Center align",
    right: "Right align",
    justify: "Justify align",
    print: "Print",
    outdent: "Decrease indentation",
    indent: "Increase indentation",
    removeFormat: "Remove formatting",
    formatting: "Formatting",
    fontSize: "Font Size",
    align: "Align",
    hr: "Insert Horizontal Rule",
    undo: "Undo",
    redo: "Redo",
    heading1: "Heading 1",
    heading2: "Heading 2",
    heading3: "Heading 3",
    heading4: "Heading 4",
    heading5: "Heading 5",
    heading6: "Heading 6",
    paragraph: "Paragraph",
    code: "Code",
    size1: "Very small",
    size2: "A bit small",
    size3: "Normal",
    size4: "Medium-large",
    size5: "Big",
    size6: "Very big",
    size7: "Maximum",
    defaultFont: "Default Font",
    viewSource: "View Source"
  },
  tree: {
    noNodes: "No nodes available",
    noResults: "No matching nodes found"
  }
};
function getLocale() {
  const val = Array.isArray(navigator.languages) === true && navigator.languages.length !== 0 ? navigator.languages[0] : navigator.language;
  if (typeof val === "string") {
    return val.split(/[-_]/).map((v, i2) => i2 === 0 ? v.toLowerCase() : i2 > 1 || v.length < 4 ? v.toUpperCase() : v[0].toUpperCase() + v.slice(1).toLowerCase()).join("-");
  }
}
var Plugin2 = createReactivePlugin({
  __qLang: {}
}, {
  // props: object
  // __langConfig: object
  getLocale,
  set(langObject = en_US_default, ssrContext) {
    const lang = {
      ...langObject,
      rtl: langObject.rtl === true,
      getLocale
    };
    {
      lang.set = Plugin2.set;
      if (Plugin2.__langConfig === void 0 || Plugin2.__langConfig.noHtmlAttrs !== true) {
        const el = document.documentElement;
        el.setAttribute("dir", lang.rtl === true ? "rtl" : "ltr");
        el.setAttribute("lang", lang.isoName);
      }
      Object.assign(Plugin2.__qLang, lang);
    }
  },
  install({ $q, lang, ssrContext }) {
    {
      $q.lang = Plugin2.__qLang;
      Plugin2.__langConfig = $q.config.lang;
      if (this.__installed === true) {
        lang !== void 0 && this.set(lang);
      } else {
        this.props = new Proxy(this.__qLang, {
          get() {
            return Reflect.get(...arguments);
          },
          ownKeys(target2) {
            return Reflect.ownKeys(target2).filter((key) => key !== "set" && key !== "getLocale");
          }
        });
        this.set(lang || en_US_default);
      }
    }
  }
});
var Lang_default = Plugin2;
var material_icons_default = {
  name: "material-icons",
  type: {
    positive: "check_circle",
    negative: "warning",
    info: "info",
    warning: "priority_high"
  },
  arrow: {
    up: "arrow_upward",
    right: "arrow_forward",
    down: "arrow_downward",
    left: "arrow_back",
    dropdown: "arrow_drop_down"
  },
  chevron: {
    left: "chevron_left",
    right: "chevron_right"
  },
  colorPicker: {
    spectrum: "gradient",
    tune: "tune",
    palette: "style"
  },
  pullToRefresh: {
    icon: "refresh"
  },
  carousel: {
    left: "chevron_left",
    right: "chevron_right",
    up: "keyboard_arrow_up",
    down: "keyboard_arrow_down",
    navigationIcon: "lens"
  },
  chip: {
    remove: "cancel",
    selected: "check"
  },
  datetime: {
    arrowLeft: "chevron_left",
    arrowRight: "chevron_right",
    now: "access_time",
    today: "today"
  },
  editor: {
    bold: "format_bold",
    italic: "format_italic",
    strikethrough: "strikethrough_s",
    underline: "format_underlined",
    unorderedList: "format_list_bulleted",
    orderedList: "format_list_numbered",
    subscript: "vertical_align_bottom",
    superscript: "vertical_align_top",
    hyperlink: "link",
    toggleFullscreen: "fullscreen",
    quote: "format_quote",
    left: "format_align_left",
    center: "format_align_center",
    right: "format_align_right",
    justify: "format_align_justify",
    print: "print",
    outdent: "format_indent_decrease",
    indent: "format_indent_increase",
    removeFormat: "format_clear",
    formatting: "text_format",
    fontSize: "format_size",
    align: "format_align_left",
    hr: "remove",
    undo: "undo",
    redo: "redo",
    heading: "format_size",
    code: "code",
    size: "format_size",
    font: "font_download",
    viewSource: "code"
  },
  expansionItem: {
    icon: "keyboard_arrow_down",
    denseIcon: "arrow_drop_down"
  },
  fab: {
    icon: "add",
    activeIcon: "close"
  },
  field: {
    clear: "cancel",
    error: "error"
  },
  pagination: {
    first: "first_page",
    prev: "keyboard_arrow_left",
    next: "keyboard_arrow_right",
    last: "last_page"
  },
  rating: {
    icon: "grade"
  },
  stepper: {
    done: "check",
    active: "edit",
    error: "warning"
  },
  tabs: {
    left: "chevron_left",
    right: "chevron_right",
    up: "keyboard_arrow_up",
    down: "keyboard_arrow_down"
  },
  table: {
    arrowUp: "arrow_upward",
    warning: "warning",
    firstPage: "first_page",
    prevPage: "chevron_left",
    nextPage: "chevron_right",
    lastPage: "last_page"
  },
  tree: {
    icon: "play_arrow"
  },
  uploader: {
    done: "done",
    clear: "clear",
    add: "add_box",
    upload: "cloud_upload",
    removeQueue: "clear_all",
    removeUploaded: "done_all"
  }
};
var Plugin3 = createReactivePlugin({
  iconMapFn: null,
  __qIconSet: {}
}, {
  // props: object
  set(setObject, ssrContext) {
    const def = { ...setObject };
    {
      def.set = Plugin3.set;
      Object.assign(Plugin3.__qIconSet, def);
    }
  },
  install({ $q, iconSet, ssrContext }) {
    {
      if ($q.config.iconMapFn !== void 0) {
        this.iconMapFn = $q.config.iconMapFn;
      }
      $q.iconSet = this.__qIconSet;
      injectProp($q, "iconMapFn", () => this.iconMapFn, (val) => {
        this.iconMapFn = val;
      });
      if (this.__installed === true) {
        iconSet !== void 0 && this.set(iconSet);
      } else {
        this.props = new Proxy(this.__qIconSet, {
          get() {
            return Reflect.get(...arguments);
          },
          ownKeys(target2) {
            return Reflect.ownKeys(target2).filter((key) => key !== "set");
          }
        });
        this.set(iconSet || material_icons_default);
      }
    }
  }
});
var quasarKey = "_q_";
var timelineKey = "_q_t_";
var stepperKey = "_q_s_";
var layoutKey = "_q_l_";
var pageContainerKey = "_q_pc_";
var fabKey = "_q_f_";
var formKey = "_q_fo_";
var tabsKey = "_q_tabs_";
var uploaderKey = "_q_u_";
function emptyRenderFn() {
}
var globalConfig = {};
function isDeepEqual(a3, b2) {
  if (a3 === b2) {
    return true;
  }
  if (a3 !== null && b2 !== null && typeof a3 === "object" && typeof b2 === "object") {
    if (a3.constructor !== b2.constructor) {
      return false;
    }
    let length, i2;
    if (a3.constructor === Array) {
      length = a3.length;
      if (length !== b2.length) {
        return false;
      }
      for (i2 = length; i2-- !== 0; ) {
        if (isDeepEqual(a3[i2], b2[i2]) !== true) {
          return false;
        }
      }
      return true;
    }
    if (a3.constructor === Map) {
      if (a3.size !== b2.size) {
        return false;
      }
      let iter = a3.entries();
      i2 = iter.next();
      while (i2.done !== true) {
        if (b2.has(i2.value[0]) !== true) {
          return false;
        }
        i2 = iter.next();
      }
      iter = a3.entries();
      i2 = iter.next();
      while (i2.done !== true) {
        if (isDeepEqual(i2.value[1], b2.get(i2.value[0])) !== true) {
          return false;
        }
        i2 = iter.next();
      }
      return true;
    }
    if (a3.constructor === Set) {
      if (a3.size !== b2.size) {
        return false;
      }
      const iter = a3.entries();
      i2 = iter.next();
      while (i2.done !== true) {
        if (b2.has(i2.value[0]) !== true) {
          return false;
        }
        i2 = iter.next();
      }
      return true;
    }
    if (a3.buffer != null && a3.buffer.constructor === ArrayBuffer) {
      length = a3.length;
      if (length !== b2.length) {
        return false;
      }
      for (i2 = length; i2-- !== 0; ) {
        if (a3[i2] !== b2[i2]) {
          return false;
        }
      }
      return true;
    }
    if (a3.constructor === RegExp) {
      return a3.source === b2.source && a3.flags === b2.flags;
    }
    if (a3.valueOf !== Object.prototype.valueOf) {
      return a3.valueOf() === b2.valueOf();
    }
    if (a3.toString !== Object.prototype.toString) {
      return a3.toString() === b2.toString();
    }
    const keys = Object.keys(a3).filter((key) => a3[key] !== void 0);
    length = keys.length;
    if (length !== Object.keys(b2).filter((key) => b2[key] !== void 0).length) {
      return false;
    }
    for (i2 = length; i2-- !== 0; ) {
      const key = keys[i2];
      if (isDeepEqual(a3[key], b2[key]) !== true) {
        return false;
      }
    }
    return true;
  }
  return a3 !== a3 && b2 !== b2;
}
function isObject(v) {
  return v !== null && typeof v === "object" && Array.isArray(v) !== true;
}
function isDate$1(v) {
  return Object.prototype.toString.call(v) === "[object Date]";
}
function isRegexp(v) {
  return Object.prototype.toString.call(v) === "[object RegExp]";
}
function isNumber$1(v) {
  return typeof v === "number" && isFinite(v);
}
function createChildApp(appCfg, parentApp) {
  const app2 = createApp(appCfg);
  app2.config.globalProperties = parentApp.config.globalProperties;
  const { reload, ...appContext } = parentApp._context;
  Object.assign(app2._context, appContext);
  return app2;
}
var units = ["B", "KB", "MB", "GB", "TB", "PB"];
function humanStorageSize(bytes, decimals = 1) {
  let u2 = 0;
  while (parseInt(bytes, 10) >= 1024 && u2 < units.length - 1) {
    bytes /= 1024;
    ++u2;
  }
  return `${bytes.toFixed(decimals)}${units[u2]}`;
}
function between(v, min2, max2) {
  return max2 <= min2 ? min2 : Math.min(max2, Math.max(min2, v));
}
function normalizeToInterval(v, min2, max2) {
  if (max2 <= min2) {
    return min2;
  }
  const size2 = max2 - min2 + 1;
  let index = min2 + (v - min2) % size2;
  if (index < min2) {
    index = size2 + index;
  }
  return index === 0 ? 0 : index;
}
function pad(v, length = 2, char = "0") {
  if (v === void 0 || v === null) {
    return v;
  }
  const val = "" + v;
  return val.length >= length ? val : new Array(length - val.length + 1).join(char) + val;
}
var xhr = XMLHttpRequest;
var open = xhr.prototype.open;
var positionValues = ["top", "right", "bottom", "left"];
var stack = [];
var highjackCount = 0;
function translate({ p, pos, active, horiz, reverse, dir }) {
  let x2 = 1, y3 = 1;
  if (horiz === true) {
    if (reverse === true) {
      x2 = -1;
    }
    if (pos === "bottom") {
      y3 = -1;
    }
    return { transform: `translate3d(${x2 * (p - 100)}%,${active ? 0 : y3 * -200}%,0)` };
  }
  if (reverse === true) {
    y3 = -1;
  }
  if (pos === "right") {
    x2 = -1;
  }
  return { transform: `translate3d(${active ? 0 : dir * x2 * -200}%,${y3 * (p - 100)}%,0)` };
}
function inc(p, amount) {
  if (typeof amount !== "number") {
    if (p < 25) {
      amount = Math.random() * 3 + 3;
    } else if (p < 65) {
      amount = Math.random() * 3;
    } else if (p < 85) {
      amount = Math.random() * 2;
    } else if (p < 99) {
      amount = 0.6;
    } else {
      amount = 0;
    }
  }
  return between(p + amount, 0, 100);
}
function highjackAjax(stackEntry) {
  highjackCount++;
  stack.push(stackEntry);
  if (highjackCount > 1) return;
  xhr.prototype.open = function(_, url) {
    const stopStack = [];
    const loadStart = () => {
      stack.forEach((entry) => {
        if (entry.hijackFilter.value === null || entry.hijackFilter.value(url) === true) {
          entry.start();
          stopStack.push(entry.stop);
        }
      });
    };
    const loadEnd = () => {
      stopStack.forEach((stop2) => {
        stop2();
      });
    };
    this.addEventListener("loadstart", loadStart, { once: true });
    this.addEventListener("loadend", loadEnd, { once: true });
    open.apply(this, arguments);
  };
}
function restoreAjax(start) {
  stack = stack.filter((entry) => entry.start !== start);
  highjackCount = Math.max(0, highjackCount - 1);
  if (highjackCount === 0) {
    xhr.prototype.open = open;
  }
}
var QAjaxBar_default = createComponent({
  name: "QAjaxBar",
  props: {
    position: {
      type: String,
      default: "top",
      validator: (val) => positionValues.includes(val)
    },
    size: {
      type: String,
      default: "2px"
    },
    color: String,
    skipHijack: Boolean,
    reverse: Boolean,
    hijackFilter: Function
  },
  emits: ["start", "stop"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const progress = ref$1(0);
    const onScreen = ref$1(false);
    const animate = ref$1(true);
    let sessions = 0, timer2 = null, speed;
    const classes = computed(
      () => `q-loading-bar q-loading-bar--${props4.position}` + (props4.color !== void 0 ? ` bg-${props4.color}` : "") + (animate.value === true ? "" : " no-transition")
    );
    const horizontal = computed(() => props4.position === "top" || props4.position === "bottom");
    const sizeProp = computed(() => horizontal.value === true ? "height" : "width");
    const style2 = computed(() => {
      const active = onScreen.value;
      const obj = translate({
        p: progress.value,
        pos: props4.position,
        active,
        horiz: horizontal.value,
        reverse: proxy.$q.lang.rtl === true && ["top", "bottom"].includes(props4.position) ? props4.reverse === false : props4.reverse,
        dir: proxy.$q.lang.rtl === true ? -1 : 1
      });
      obj[sizeProp.value] = props4.size;
      obj.opacity = active ? 1 : 0;
      return obj;
    });
    const attributes = computed(() => onScreen.value === true ? {
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": progress.value
    } : { "aria-hidden": "true" });
    function start(newSpeed = 300) {
      const oldSpeed = speed;
      speed = Math.max(0, newSpeed) || 0;
      sessions++;
      if (sessions > 1) {
        if (oldSpeed === 0 && newSpeed > 0) {
          planNextStep();
        } else if (timer2 !== null && oldSpeed > 0 && newSpeed <= 0) {
          clearTimeout(timer2);
          timer2 = null;
        }
        return sessions;
      }
      timer2 !== null && clearTimeout(timer2);
      emit("start");
      progress.value = 0;
      timer2 = setTimeout(() => {
        timer2 = null;
        animate.value = true;
        newSpeed > 0 && planNextStep();
      }, onScreen._value === true ? 500 : 1);
      if (onScreen._value !== true) {
        onScreen.value = true;
        animate.value = false;
      }
      return sessions;
    }
    function increment(amount) {
      if (sessions > 0) {
        progress.value = inc(progress.value, amount);
      }
      return sessions;
    }
    function stop2() {
      sessions = Math.max(0, sessions - 1);
      if (sessions > 0) {
        return sessions;
      }
      if (timer2 !== null) {
        clearTimeout(timer2);
        timer2 = null;
      }
      emit("stop");
      const end = () => {
        animate.value = true;
        progress.value = 100;
        timer2 = setTimeout(() => {
          timer2 = null;
          onScreen.value = false;
        }, 1e3);
      };
      if (progress.value === 0) {
        timer2 = setTimeout(end, 1);
      } else {
        end();
      }
      return sessions;
    }
    function planNextStep() {
      if (progress.value < 100) {
        timer2 = setTimeout(() => {
          timer2 = null;
          increment();
          planNextStep();
        }, speed);
      }
    }
    let hijacked;
    onMounted(() => {
      if (props4.skipHijack !== true) {
        hijacked = true;
        highjackAjax({
          start,
          stop: stop2,
          hijackFilter: computed(() => props4.hijackFilter || null)
        });
      }
    });
    onBeforeUnmount(() => {
      timer2 !== null && clearTimeout(timer2);
      hijacked === true && restoreAjax(start);
    });
    Object.assign(proxy, { start, stop: stop2, increment });
    return () => h("div", {
      class: classes.value,
      style: style2.value,
      ...attributes.value
    });
  }
});
var useSizeDefaults = {
  xs: 18,
  sm: 24,
  md: 32,
  lg: 38,
  xl: 46
};
var useSizeProps = {
  size: String
};
function use_size_default(props4, sizes = useSizeDefaults) {
  return computed(() => props4.size !== void 0 ? { fontSize: props4.size in sizes ? `${sizes[props4.size]}px` : props4.size } : null);
}
function hSlot(slot, otherwise) {
  return slot !== void 0 ? slot() || otherwise : otherwise;
}
function hUniqueSlot(slot, otherwise) {
  if (slot !== void 0) {
    const vnode = slot();
    if (vnode !== void 0 && vnode !== null) {
      return vnode.slice();
    }
  }
  return otherwise;
}
function hMergeSlot(slot, source) {
  return slot !== void 0 ? source.concat(slot()) : source;
}
function hMergeSlotSafely(slot, source) {
  if (slot === void 0) {
    return source;
  }
  return source !== void 0 ? source.concat(slot()) : slot();
}
function hDir(tag, data, children, key, condition, getDirsFn) {
  data.key = key + condition;
  const vnode = h(tag, data, children);
  return condition === true ? withDirectives(vnode, getDirsFn()) : vnode;
}
var defaultViewBox = "0 0 24 24";
var sameFn = (i2) => i2;
var ionFn = (i2) => `ionicons ${i2}`;
var libMap = {
  "mdi-": (i2) => `mdi ${i2}`,
  "icon-": sameFn,
  // fontawesome equiv
  "bt-": (i2) => `bt ${i2}`,
  "eva-": (i2) => `eva ${i2}`,
  "ion-md": ionFn,
  "ion-ios": ionFn,
  "ion-logo": ionFn,
  "iconfont ": sameFn,
  "ti-": (i2) => `themify-icon ${i2}`,
  "bi-": (i2) => `bootstrap-icons ${i2}`
};
var matMap = {
  o_: "-outlined",
  r_: "-round",
  s_: "-sharp"
};
var symMap = {
  sym_o_: "-outlined",
  sym_r_: "-rounded",
  sym_s_: "-sharp"
};
var libRE = new RegExp("^(" + Object.keys(libMap).join("|") + ")");
var matRE = new RegExp("^(" + Object.keys(matMap).join("|") + ")");
var symRE = new RegExp("^(" + Object.keys(symMap).join("|") + ")");
var mRE = /^[Mm]\s?[-+]?\.?\d/;
var imgRE = /^img:/;
var svgUseRE = /^svguse:/;
var ionRE = /^ion-/;
var faRE = /^(fa-(classic|sharp|solid|regular|light|brands|duotone|thin)|[lf]a[srlbdk]?) /;
var QIcon_default = createComponent({
  name: "QIcon",
  props: {
    ...useSizeProps,
    tag: {
      type: String,
      default: "i"
    },
    name: String,
    color: String,
    left: Boolean,
    right: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const sizeStyle = use_size_default(props4);
    const classes = computed(
      () => "q-icon" + (props4.left === true ? " on-left" : "") + (props4.right === true ? " on-right" : "") + (props4.color !== void 0 ? ` text-${props4.color}` : "")
    );
    const type2 = computed(() => {
      let cls;
      let icon = props4.name;
      if (icon === "none" || !icon) {
        return { none: true };
      }
      if ($q.iconMapFn !== null) {
        const res = $q.iconMapFn(icon);
        if (res !== void 0) {
          if (res.icon !== void 0) {
            icon = res.icon;
            if (icon === "none" || !icon) {
              return { none: true };
            }
          } else {
            return {
              cls: res.cls,
              content: res.content !== void 0 ? res.content : " "
            };
          }
        }
      }
      if (mRE.test(icon) === true) {
        const [def, viewBox = defaultViewBox] = icon.split("|");
        return {
          svg: true,
          viewBox,
          nodes: def.split("&&").map((path) => {
            const [d3, style2, transform] = path.split("@@");
            return h("path", { style: style2, d: d3, transform });
          })
        };
      }
      if (imgRE.test(icon) === true) {
        return {
          img: true,
          src: icon.substring(4)
        };
      }
      if (svgUseRE.test(icon) === true) {
        const [def, viewBox = defaultViewBox] = icon.split("|");
        return {
          svguse: true,
          src: def.substring(7),
          viewBox
        };
      }
      let content = " ";
      const matches = icon.match(libRE);
      if (matches !== null) {
        cls = libMap[matches[1]](icon);
      } else if (faRE.test(icon) === true) {
        cls = icon;
      } else if (ionRE.test(icon) === true) {
        cls = `ionicons ion-${$q.platform.is.ios === true ? "ios" : "md"}${icon.substring(3)}`;
      } else if (symRE.test(icon) === true) {
        cls = "notranslate material-symbols";
        const matches2 = icon.match(symRE);
        if (matches2 !== null) {
          icon = icon.substring(6);
          cls += symMap[matches2[1]];
        }
        content = icon;
      } else {
        cls = "notranslate material-icons";
        const matches2 = icon.match(matRE);
        if (matches2 !== null) {
          icon = icon.substring(2);
          cls += matMap[matches2[1]];
        }
        content = icon;
      }
      return {
        cls,
        content
      };
    });
    return () => {
      const data = {
        class: classes.value,
        style: sizeStyle.value,
        "aria-hidden": "true",
        role: "presentation"
      };
      if (type2.value.none === true) {
        return h(props4.tag, data, hSlot(slots.default));
      }
      if (type2.value.img === true) {
        return h(props4.tag, data, hMergeSlot(slots.default, [
          h("img", { src: type2.value.src })
        ]));
      }
      if (type2.value.svg === true) {
        return h(props4.tag, data, hMergeSlot(slots.default, [
          h("svg", {
            viewBox: type2.value.viewBox || "0 0 24 24"
          }, type2.value.nodes)
        ]));
      }
      if (type2.value.svguse === true) {
        return h(props4.tag, data, hMergeSlot(slots.default, [
          h("svg", {
            viewBox: type2.value.viewBox
          }, [
            h("use", { "xlink:href": type2.value.src })
          ])
        ]));
      }
      if (type2.value.cls !== void 0) {
        data.class += " " + type2.value.cls;
      }
      return h(props4.tag, data, hMergeSlot(slots.default, [
        type2.value.content
      ]));
    };
  }
});
var QAvatar_default = createComponent({
  name: "QAvatar",
  props: {
    ...useSizeProps,
    fontSize: String,
    color: String,
    textColor: String,
    icon: String,
    square: Boolean,
    rounded: Boolean
  },
  setup(props4, { slots }) {
    const sizeStyle = use_size_default(props4);
    const classes = computed(
      () => "q-avatar" + (props4.color ? ` bg-${props4.color}` : "") + (props4.textColor ? ` text-${props4.textColor} q-chip--colored` : "") + (props4.square === true ? " q-avatar--square" : props4.rounded === true ? " rounded-borders" : "")
    );
    const contentStyle = computed(() => props4.fontSize ? { fontSize: props4.fontSize } : null);
    return () => {
      const icon = props4.icon !== void 0 ? [h(QIcon_default, { name: props4.icon })] : void 0;
      return h("div", {
        class: classes.value,
        style: sizeStyle.value
      }, [
        h("div", {
          class: "q-avatar__content row flex-center overflow-hidden",
          style: contentStyle.value
        }, hMergeSlotSafely(slots.default, icon))
      ]);
    };
  }
});
var alignValues = ["top", "middle", "bottom"];
createComponent({
  name: "QBadge",
  props: {
    color: String,
    textColor: String,
    floating: Boolean,
    transparent: Boolean,
    multiLine: Boolean,
    outline: Boolean,
    rounded: Boolean,
    label: [Number, String],
    align: {
      type: String,
      validator: (v) => alignValues.includes(v)
    }
  },
  setup(props4, { slots }) {
    const style2 = computed(() => {
      return props4.align !== void 0 ? { verticalAlign: props4.align } : null;
    });
    const classes = computed(() => {
      const text = props4.outline === true ? props4.color || props4.textColor : props4.textColor;
      return `q-badge flex inline items-center no-wrap q-badge--${props4.multiLine === true ? "multi" : "single"}-line` + (props4.outline === true ? " q-badge--outline" : props4.color !== void 0 ? ` bg-${props4.color}` : "") + (text !== void 0 ? ` text-${text}` : "") + (props4.floating === true ? " q-badge--floating" : "") + (props4.rounded === true ? " q-badge--rounded" : "") + (props4.transparent === true ? " q-badge--transparent" : "");
    });
    return () => h("div", {
      class: classes.value,
      style: style2.value,
      role: "status",
      "aria-label": props4.label
    }, hMergeSlot(slots.default, props4.label !== void 0 ? [props4.label] : []));
  }
});
var useDarkProps = {
  dark: {
    type: Boolean,
    default: null
  }
};
function use_dark_default(props4, $q) {
  return computed(() => props4.dark === null ? $q.dark.isActive : props4.dark);
}
createComponent({
  name: "QBanner",
  props: {
    ...useDarkProps,
    inlineActions: Boolean,
    dense: Boolean,
    rounded: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const classes = computed(
      () => "q-banner row items-center" + (props4.dense === true ? " q-banner--dense" : "") + (isDark.value === true ? " q-banner--dark q-dark" : "") + (props4.rounded === true ? " rounded-borders" : "")
    );
    const actionClass = computed(
      () => `q-banner__actions row items-center justify-end col-${props4.inlineActions === true ? "auto" : "all"}`
    );
    return () => {
      const child = [
        h("div", {
          class: "q-banner__avatar col-auto row items-center self-start"
        }, hSlot(slots.avatar)),
        h("div", {
          class: "q-banner__content col text-body2"
        }, hSlot(slots.default))
      ];
      const actions = hSlot(slots.action);
      actions !== void 0 && child.push(
        h("div", { class: actionClass.value }, actions)
      );
      return h("div", {
        class: classes.value + (props4.inlineActions === false && actions !== void 0 ? " q-banner--top-padding" : ""),
        role: "alert"
      }, child);
    };
  }
});
createComponent({
  name: "QBar",
  props: {
    ...useDarkProps,
    dense: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const classes = computed(
      () => `q-bar row no-wrap items-center q-bar--${props4.dense === true ? "dense" : "standard"}  q-bar--${isDark.value === true ? "dark" : "light"}`
    );
    return () => h("div", {
      class: classes.value,
      role: "toolbar"
    }, hSlot(slots.default));
  }
});
var alignMap = {
  left: "start",
  center: "center",
  right: "end",
  between: "between",
  around: "around",
  evenly: "evenly",
  stretch: "stretch"
};
var alignValues2 = Object.keys(alignMap);
var useAlignProps = {
  align: {
    type: String,
    validator: (v) => alignValues2.includes(v)
  }
};
function use_align_default(props4) {
  return computed(() => {
    const align = props4.align === void 0 ? props4.vertical === true ? "stretch" : "left" : props4.align;
    return `${props4.vertical === true ? "items" : "justify"}-${alignMap[align]}`;
  });
}
function getParentProxy(proxy) {
  if (Object(proxy.$parent) === proxy.$parent) {
    return proxy.$parent;
  }
  let { parent } = proxy.$;
  while (Object(parent) === parent) {
    if (Object(parent.proxy) === parent.proxy) {
      return parent.proxy;
    }
    parent = parent.parent;
  }
}
function fillNormalizedVNodes(children, vnode) {
  if (typeof vnode.type === "symbol") {
    if (Array.isArray(vnode.children) === true) {
      vnode.children.forEach((child) => {
        fillNormalizedVNodes(children, child);
      });
    }
  } else {
    children.add(vnode);
  }
}
function getNormalizedVNodes(vnodes) {
  const children = /* @__PURE__ */ new Set();
  vnodes.forEach((vnode) => {
    fillNormalizedVNodes(children, vnode);
  });
  return Array.from(children);
}
function vmHasRouter(vm2) {
  return vm2.appContext.config.globalProperties.$router !== void 0;
}
function vmIsDestroyed(vm2) {
  return vm2.isUnmounted === true || vm2.isDeactivated === true;
}
var disabledValues = ["", true];
createComponent({
  name: "QBreadcrumbs",
  props: {
    ...useAlignProps,
    separator: {
      type: String,
      default: "/"
    },
    separatorColor: String,
    activeColor: {
      type: String,
      default: "primary"
    },
    gutter: {
      type: String,
      validator: (v) => ["none", "xs", "sm", "md", "lg", "xl"].includes(v),
      default: "sm"
    }
  },
  setup(props4, { slots }) {
    const alignClass = use_align_default(props4);
    const classes = computed(
      () => `flex items-center ${alignClass.value}${props4.gutter === "none" ? "" : ` q-gutter-${props4.gutter}`}`
    );
    const sepClass = computed(() => props4.separatorColor ? ` text-${props4.separatorColor}` : "");
    const activeClass = computed(() => ` text-${props4.activeColor}`);
    return () => {
      if (slots.default === void 0) return;
      const vnodes = getNormalizedVNodes(
        hSlot(slots.default)
      );
      if (vnodes.length === 0) return;
      let els = 1;
      const child = [], len = vnodes.filter((c2) => c2.type !== void 0 && c2.type.name === "QBreadcrumbsEl").length, separator = slots.separator !== void 0 ? slots.separator : () => props4.separator;
      vnodes.forEach((comp) => {
        if (comp.type !== void 0 && comp.type.name === "QBreadcrumbsEl") {
          const middle = els < len;
          const disabled = comp.props !== null && disabledValues.includes(comp.props.disable);
          const cls = (middle === true ? "" : " q-breadcrumbs--last") + (disabled !== true && middle === true ? activeClass.value : "");
          els++;
          child.push(
            h("div", {
              class: `flex items-center${cls}`
            }, [comp])
          );
          if (middle === true) {
            child.push(
              h("div", {
                class: "q-breadcrumbs__separator" + sepClass.value
              }, separator())
            );
          }
        } else {
          child.push(comp);
        }
      });
      return h("div", {
        class: "q-breadcrumbs"
      }, [
        h("div", { class: classes.value }, child)
      ]);
    };
  }
});
function getOriginalPath(record) {
  return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
function isSameRouteRecord(a3, b2) {
  return (a3.aliasOf || a3) === (b2.aliasOf || b2);
}
function includesParams(outer, inner) {
  for (const key in inner) {
    const innerValue = inner[key], outerValue = outer[key];
    if (typeof innerValue === "string") {
      if (innerValue !== outerValue) {
        return false;
      }
    } else if (Array.isArray(outerValue) === false || outerValue.length !== innerValue.length || innerValue.some((value2, i2) => value2 !== outerValue[i2])) {
      return false;
    }
  }
  return true;
}
function isEquivalentArray(a3, b2) {
  return Array.isArray(b2) === true ? a3.length === b2.length && a3.every((value2, i2) => value2 === b2[i2]) : a3.length === 1 && a3[0] === b2;
}
function isSameRouteLocationParamsValue(a3, b2) {
  return Array.isArray(a3) === true ? isEquivalentArray(a3, b2) : Array.isArray(b2) === true ? isEquivalentArray(b2, a3) : a3 === b2;
}
function isSameRouteLocationParams(a3, b2) {
  if (Object.keys(a3).length !== Object.keys(b2).length) {
    return false;
  }
  for (const key in a3) {
    if (isSameRouteLocationParamsValue(a3[key], b2[key]) === false) {
      return false;
    }
  }
  return true;
}
var useRouterLinkNonMatchingProps = {
  // router-link
  to: [String, Object],
  replace: Boolean,
  // regular <a> link
  href: String,
  target: String,
  // state
  disable: Boolean
};
var useRouterLinkProps = {
  ...useRouterLinkNonMatchingProps,
  // router-link
  exact: Boolean,
  activeClass: {
    type: String,
    default: "q-router-link--active"
  },
  exactActiveClass: {
    type: String,
    default: "q-router-link--exact-active"
  }
};
function use_router_link_default({ fallbackTag, useDisableForRouterLinkProps = true } = {}) {
  const vm2 = getCurrentInstance();
  const { props: props4, proxy, emit } = vm2;
  const hasRouter = vmHasRouter(vm2);
  const hasHrefLink = computed(() => props4.disable !== true && props4.href !== void 0);
  const hasRouterLinkProps = useDisableForRouterLinkProps === true ? computed(
    () => hasRouter === true && props4.disable !== true && hasHrefLink.value !== true && props4.to !== void 0 && props4.to !== null && props4.to !== ""
  ) : computed(
    () => hasRouter === true && hasHrefLink.value !== true && props4.to !== void 0 && props4.to !== null && props4.to !== ""
  );
  const resolvedLink = computed(() => hasRouterLinkProps.value === true ? getLink(props4.to) : null);
  const hasRouterLink = computed(() => resolvedLink.value !== null);
  const hasLink = computed(() => hasHrefLink.value === true || hasRouterLink.value === true);
  const linkTag = computed(() => props4.type === "a" || hasLink.value === true ? "a" : props4.tag || fallbackTag || "div");
  const linkAttrs = computed(() => hasHrefLink.value === true ? {
    href: props4.href,
    target: props4.target
  } : hasRouterLink.value === true ? {
    href: resolvedLink.value.href,
    target: props4.target
  } : {});
  const linkActiveIndex = computed(() => {
    if (hasRouterLink.value === false) {
      return -1;
    }
    const { matched } = resolvedLink.value, { length } = matched, routeMatched = matched[length - 1];
    if (routeMatched === void 0) {
      return -1;
    }
    const currentMatched = proxy.$route.matched;
    if (currentMatched.length === 0) {
      return -1;
    }
    const index = currentMatched.findIndex(
      isSameRouteRecord.bind(null, routeMatched)
    );
    if (index !== -1) {
      return index;
    }
    const parentRecordPath = getOriginalPath(matched[length - 2]);
    return (
      // we are dealing with nested routes
      length > 1 && getOriginalPath(routeMatched) === parentRecordPath && currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex(
        isSameRouteRecord.bind(null, matched[length - 2])
      ) : index
    );
  });
  const linkIsActive = computed(
    () => hasRouterLink.value === true && linkActiveIndex.value !== -1 && includesParams(proxy.$route.params, resolvedLink.value.params)
  );
  const linkIsExactActive = computed(
    () => linkIsActive.value === true && linkActiveIndex.value === proxy.$route.matched.length - 1 && isSameRouteLocationParams(proxy.$route.params, resolvedLink.value.params)
  );
  const linkClass = computed(() => hasRouterLink.value === true ? linkIsExactActive.value === true ? ` ${props4.exactActiveClass} ${props4.activeClass}` : props4.exact === true ? "" : linkIsActive.value === true ? ` ${props4.activeClass}` : "" : "");
  function getLink(to) {
    try {
      return proxy.$router.resolve(to);
    } catch (_) {
    }
    return null;
  }
  function navigateToRouterLink(e2, { returnRouterError, to = props4.to, replace: replace2 = props4.replace } = {}) {
    if (props4.disable === true) {
      e2.preventDefault();
      return Promise.resolve(false);
    }
    if (
      // don't redirect with control keys;
      // should match RouterLink from Vue Router
      e2.metaKey || e2.altKey || e2.ctrlKey || e2.shiftKey || e2.button !== void 0 && e2.button !== 0 || props4.target === "_blank"
    ) {
      return Promise.resolve(false);
    }
    e2.preventDefault();
    const promise = proxy.$router[replace2 === true ? "replace" : "push"](to);
    return returnRouterError === true ? promise : promise.then(() => {
    }).catch(() => {
    });
  }
  function navigateOnClick(e2) {
    if (hasRouterLink.value === true) {
      const go = (opts) => navigateToRouterLink(e2, opts);
      emit("click", e2, go);
      e2.defaultPrevented !== true && go();
    } else {
      emit("click", e2);
    }
  }
  return {
    hasRouterLink,
    hasHrefLink,
    hasLink,
    linkTag,
    resolvedLink,
    linkIsActive,
    linkIsExactActive,
    linkClass,
    linkAttrs,
    getLink,
    navigateToRouterLink,
    navigateOnClick
  };
}
createComponent({
  name: "QBreadcrumbsEl",
  props: {
    ...useRouterLinkProps,
    label: String,
    icon: String,
    tag: {
      type: String,
      default: "span"
    }
  },
  emits: ["click"],
  setup(props4, { slots }) {
    const { linkTag, linkAttrs, linkClass, navigateOnClick } = use_router_link_default();
    const data = computed(() => {
      return {
        class: "q-breadcrumbs__el q-link flex inline items-center relative-position " + (props4.disable !== true ? "q-link--focusable" + linkClass.value : "q-breadcrumbs__el--disable"),
        ...linkAttrs.value,
        onClick: navigateOnClick
      };
    });
    const iconClass = computed(
      () => "q-breadcrumbs__el-icon" + (props4.label !== void 0 ? " q-breadcrumbs__el-icon--with-label" : "")
    );
    return () => {
      const child = [];
      props4.icon !== void 0 && child.push(
        h(QIcon_default, {
          class: iconClass.value,
          name: props4.icon
        })
      );
      props4.label !== void 0 && child.push(props4.label);
      return h(
        linkTag.value,
        { ...data.value },
        hMergeSlot(slots.default, child)
      );
    };
  }
});
var useSpinnerProps = {
  size: {
    type: [String, Number],
    default: "1em"
  },
  color: String
};
function useSpinner(props4) {
  return {
    cSize: computed(() => props4.size in useSizeDefaults ? `${useSizeDefaults[props4.size]}px` : props4.size),
    classes: computed(
      () => "q-spinner" + (props4.color ? ` text-${props4.color}` : "")
    )
  };
}
var QSpinner_default = createComponent({
  name: "QSpinner",
  props: {
    ...useSpinnerProps,
    thickness: {
      type: Number,
      default: 5
    }
  },
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value + " q-spinner-mat",
      width: cSize.value,
      height: cSize.value,
      viewBox: "25 25 50 50"
    }, [
      h("circle", {
        class: "path",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": props4.thickness,
        "stroke-miterlimit": "10"
      })
    ]);
  }
});
function offset(el) {
  if (el === window) {
    return { top: 0, left: 0 };
  }
  const { top, left } = el.getBoundingClientRect();
  return { top, left };
}
function height(el) {
  return el === window ? window.innerHeight : el.getBoundingClientRect().height;
}
function css(element, css2) {
  const style2 = element.style;
  for (const prop in css2) {
    style2[prop] = css2[prop];
  }
}
function getElement(el) {
  if (el === void 0 || el === null) {
    return void 0;
  }
  if (typeof el === "string") {
    try {
      return document.querySelector(el) || void 0;
    } catch (err) {
      return void 0;
    }
  }
  const target2 = unref(el);
  if (target2) {
    return target2.$el || target2;
  }
}
function childHasFocus(el, focusedEl) {
  if (el === void 0 || el === null || el.contains(focusedEl) === true) {
    return true;
  }
  for (let next = el.nextElementSibling; next !== null; next = next.nextElementSibling) {
    if (next.contains(focusedEl)) {
      return true;
    }
  }
  return false;
}
function throttle_default(fn, limit2 = 250) {
  let wait2 = false, result;
  return function() {
    if (wait2 === false) {
      wait2 = true;
      setTimeout(() => {
        wait2 = false;
      }, limit2);
      result = fn.apply(this, arguments);
    }
    return result;
  };
}
function showRipple(evt, el, ctx, forceCenter) {
  ctx.modifiers.stop === true && stop(evt);
  const color = ctx.modifiers.color;
  let center = ctx.modifiers.center;
  center = center === true || forceCenter === true;
  const node = document.createElement("span"), innerNode = document.createElement("span"), pos = position(evt), { left, top, width: width3, height: height2 } = el.getBoundingClientRect(), diameter2 = Math.sqrt(width3 * width3 + height2 * height2), radius2 = diameter2 / 2, centerX = `${(width3 - diameter2) / 2}px`, x2 = center ? centerX : `${pos.left - left - radius2}px`, centerY = `${(height2 - diameter2) / 2}px`, y3 = center ? centerY : `${pos.top - top - radius2}px`;
  innerNode.className = "q-ripple__inner";
  css(innerNode, {
    height: `${diameter2}px`,
    width: `${diameter2}px`,
    transform: `translate3d(${x2},${y3},0) scale3d(.2,.2,1)`,
    opacity: 0
  });
  node.className = `q-ripple${color ? " text-" + color : ""}`;
  node.setAttribute("dir", "ltr");
  node.appendChild(innerNode);
  el.appendChild(node);
  const abort = () => {
    node.remove();
    clearTimeout(timer2);
  };
  ctx.abort.push(abort);
  let timer2 = setTimeout(() => {
    innerNode.classList.add("q-ripple__inner--enter");
    innerNode.style.transform = `translate3d(${centerX},${centerY},0) scale3d(1,1,1)`;
    innerNode.style.opacity = 0.2;
    timer2 = setTimeout(() => {
      innerNode.classList.remove("q-ripple__inner--enter");
      innerNode.classList.add("q-ripple__inner--leave");
      innerNode.style.opacity = 0;
      timer2 = setTimeout(() => {
        node.remove();
        ctx.abort.splice(ctx.abort.indexOf(abort), 1);
      }, 275);
    }, 250);
  }, 50);
}
function updateModifiers(ctx, { modifiers, value: value2, arg }) {
  const cfg = Object.assign({}, ctx.cfg.ripple, modifiers, value2);
  ctx.modifiers = {
    early: cfg.early === true,
    stop: cfg.stop === true,
    center: cfg.center === true,
    color: cfg.color || arg,
    keyCodes: [].concat(cfg.keyCodes || 13)
  };
}
var Ripple_default = createDirective(
  {
    name: "ripple",
    beforeMount(el, binding) {
      const cfg = binding.instance.$.appContext.config.globalProperties.$q.config || {};
      if (cfg.ripple === false) {
        return;
      }
      const ctx = {
        cfg,
        enabled: binding.value !== false,
        modifiers: {},
        abort: [],
        start(evt) {
          if (ctx.enabled === true && evt.qSkipRipple !== true && evt.type === (ctx.modifiers.early === true ? "pointerdown" : "click")) {
            showRipple(evt, el, ctx, evt.qKeyEvent === true);
          }
        },
        keystart: throttle_default((evt) => {
          if (ctx.enabled === true && evt.qSkipRipple !== true && isKeyCode(evt, ctx.modifiers.keyCodes) === true && evt.type === `key${ctx.modifiers.early === true ? "down" : "up"}`) {
            showRipple(evt, el, ctx, true);
          }
        }, 300)
      };
      updateModifiers(ctx, binding);
      el.__qripple = ctx;
      addEvt(ctx, "main", [
        [el, "pointerdown", "start", "passive"],
        [el, "click", "start", "passive"],
        [el, "keydown", "keystart", "passive"],
        [el, "keyup", "keystart", "passive"]
      ]);
    },
    updated(el, binding) {
      if (binding.oldValue !== binding.value) {
        const ctx = el.__qripple;
        if (ctx !== void 0) {
          ctx.enabled = binding.value !== false;
          if (ctx.enabled === true && Object(binding.value) === binding.value) {
            updateModifiers(ctx, binding);
          }
        }
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qripple;
      if (ctx !== void 0) {
        ctx.abort.forEach((fn) => {
          fn();
        });
        cleanEvt(ctx, "main");
        delete el._qripple;
      }
    }
  }
);
var btnPadding = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32
};
var defaultSizes = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 20,
  xl: 24
};
var formTypes = ["button", "submit", "reset"];
var mediaTypeRE = /[^\s]\/[^\s]/;
var btnDesignOptions = ["flat", "outline", "push", "unelevated"];
function getBtnDesign(props4, defaultValue) {
  if (props4.flat === true) return "flat";
  if (props4.outline === true) return "outline";
  if (props4.push === true) return "push";
  if (props4.unelevated === true) return "unelevated";
  return defaultValue;
}
function getBtnDesignAttr(props4) {
  const design = getBtnDesign(props4);
  return design !== void 0 ? { [design]: true } : {};
}
var nonRoundBtnProps = {
  ...useSizeProps,
  ...useRouterLinkNonMatchingProps,
  type: {
    type: String,
    default: "button"
  },
  label: [Number, String],
  icon: String,
  iconRight: String,
  ...btnDesignOptions.reduce(
    (acc, val) => (acc[val] = Boolean) && acc,
    {}
  ),
  square: Boolean,
  rounded: Boolean,
  glossy: Boolean,
  size: String,
  fab: Boolean,
  fabMini: Boolean,
  padding: String,
  color: String,
  textColor: String,
  noCaps: Boolean,
  noWrap: Boolean,
  dense: Boolean,
  tabindex: [Number, String],
  ripple: {
    type: [Boolean, Object],
    default: true
  },
  align: {
    ...useAlignProps.align,
    default: "center"
  },
  stack: Boolean,
  stretch: Boolean,
  loading: {
    type: Boolean,
    default: null
  },
  disable: Boolean
};
var useBtnProps = {
  ...nonRoundBtnProps,
  round: Boolean
};
function use_btn_default(props4) {
  const sizeStyle = use_size_default(props4, defaultSizes);
  const alignClass = use_align_default(props4);
  const { hasRouterLink, hasLink, linkTag, linkAttrs, navigateOnClick } = use_router_link_default({
    fallbackTag: "button"
  });
  const style2 = computed(() => {
    const obj = props4.fab === false && props4.fabMini === false ? sizeStyle.value : {};
    return props4.padding !== void 0 ? Object.assign({}, obj, {
      padding: props4.padding.split(/\s+/).map((v) => v in btnPadding ? btnPadding[v] + "px" : v).join(" "),
      minWidth: "0",
      minHeight: "0"
    }) : obj;
  });
  const isRounded = computed(
    () => props4.rounded === true || props4.fab === true || props4.fabMini === true
  );
  const isActionable = computed(
    () => props4.disable !== true && props4.loading !== true
  );
  const tabIndex = computed(() => isActionable.value === true ? props4.tabindex || 0 : -1);
  const design = computed(() => getBtnDesign(props4, "standard"));
  const attributes = computed(() => {
    const acc = { tabindex: tabIndex.value };
    if (hasLink.value === true) {
      Object.assign(acc, linkAttrs.value);
    } else if (formTypes.includes(props4.type) === true) {
      acc.type = props4.type;
    }
    if (linkTag.value === "a") {
      if (props4.disable === true) {
        acc["aria-disabled"] = "true";
      } else if (acc.href === void 0) {
        acc.role = "button";
      }
      if (hasRouterLink.value !== true && mediaTypeRE.test(props4.type) === true) {
        acc.type = props4.type;
      }
    } else if (props4.disable === true) {
      acc.disabled = "";
      acc["aria-disabled"] = "true";
    }
    if (props4.loading === true && props4.percentage !== void 0) {
      Object.assign(acc, {
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": props4.percentage
      });
    }
    return acc;
  });
  const classes = computed(() => {
    let colors;
    if (props4.color !== void 0) {
      if (props4.flat === true || props4.outline === true) {
        colors = `text-${props4.textColor || props4.color}`;
      } else {
        colors = `bg-${props4.color} text-${props4.textColor || "white"}`;
      }
    } else if (props4.textColor) {
      colors = `text-${props4.textColor}`;
    }
    const shape = props4.round === true ? "round" : `rectangle${isRounded.value === true ? " q-btn--rounded" : props4.square === true ? " q-btn--square" : ""}`;
    return `q-btn--${design.value} q-btn--${shape}` + (colors !== void 0 ? " " + colors : "") + (isActionable.value === true ? " q-btn--actionable q-focusable q-hoverable" : props4.disable === true ? " disabled" : "") + (props4.fab === true ? " q-btn--fab" : props4.fabMini === true ? " q-btn--fab-mini" : "") + (props4.noCaps === true ? " q-btn--no-uppercase" : "") + (props4.dense === true ? " q-btn--dense" : "") + (props4.stretch === true ? " no-border-radius self-stretch" : "") + (props4.glossy === true ? " glossy" : "") + (props4.square ? " q-btn--square" : "");
  });
  const innerClasses = computed(
    () => alignClass.value + (props4.stack === true ? " column" : " row") + (props4.noWrap === true ? " no-wrap text-no-wrap" : "") + (props4.loading === true ? " q-btn__content--hidden" : "")
  );
  return {
    classes,
    style: style2,
    innerClasses,
    attributes,
    hasLink,
    linkTag,
    navigateOnClick,
    isActionable
  };
}
var { passiveCapture } = listenOpts;
var touchTarget = null;
var keyboardTarget = null;
var mouseTarget = null;
var QBtn_default = createComponent({
  name: "QBtn",
  props: {
    ...useBtnProps,
    percentage: Number,
    darkPercentage: Boolean,
    onTouchstart: [Function, Array]
  },
  emits: ["click", "keydown", "mousedown", "keyup"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const {
      classes,
      style: style2,
      innerClasses,
      attributes,
      hasLink,
      linkTag,
      navigateOnClick,
      isActionable
    } = use_btn_default(props4);
    const rootRef = ref$1(null);
    const blurTargetRef = ref$1(null);
    let localTouchTargetEl = null, avoidMouseRipple, mouseTimer = null;
    const hasLabel = computed(
      () => props4.label !== void 0 && props4.label !== null && props4.label !== ""
    );
    const ripple = computed(() => props4.disable === true || props4.ripple === false ? false : {
      keyCodes: hasLink.value === true ? [13, 32] : [13],
      ...props4.ripple === true ? {} : props4.ripple
    });
    const rippleProps = computed(() => ({ center: props4.round }));
    const percentageStyle = computed(() => {
      const val = Math.max(0, Math.min(100, props4.percentage));
      return val > 0 ? { transition: "transform 0.6s", transform: `translateX(${val - 100}%)` } : {};
    });
    const onEvents = computed(() => {
      if (props4.loading === true) {
        return {
          onMousedown: onLoadingEvt,
          onTouchstart: onLoadingEvt,
          onClick: onLoadingEvt,
          onKeydown: onLoadingEvt,
          onKeyup: onLoadingEvt
        };
      }
      if (isActionable.value === true) {
        const acc = {
          onClick,
          onKeydown: onKeydown2,
          onMousedown
        };
        if (proxy.$q.platform.has.touch === true) {
          const suffix = props4.onTouchstart !== void 0 ? "" : "Passive";
          acc[`onTouchstart${suffix}`] = onTouchstart;
        }
        return acc;
      }
      return {
        // needed; especially for disabled <a> tags
        onClick: stopAndPrevent
      };
    });
    const nodeProps = computed(() => ({
      ref: rootRef,
      class: "q-btn q-btn-item non-selectable no-outline " + classes.value,
      style: style2.value,
      ...attributes.value,
      ...onEvents.value
    }));
    function onClick(e2) {
      if (rootRef.value === null) return;
      if (e2 !== void 0) {
        if (e2.defaultPrevented === true) {
          return;
        }
        const el = document.activeElement;
        if (props4.type === "submit" && el !== document.body && rootRef.value.contains(el) === false && el.contains(rootRef.value) === false) {
          rootRef.value.focus();
          const onClickCleanup = () => {
            document.removeEventListener("keydown", stopAndPrevent, true);
            document.removeEventListener("keyup", onClickCleanup, passiveCapture);
            rootRef.value !== null && rootRef.value.removeEventListener("blur", onClickCleanup, passiveCapture);
          };
          document.addEventListener("keydown", stopAndPrevent, true);
          document.addEventListener("keyup", onClickCleanup, passiveCapture);
          rootRef.value.addEventListener("blur", onClickCleanup, passiveCapture);
        }
      }
      navigateOnClick(e2);
    }
    function onKeydown2(e2) {
      if (rootRef.value === null) return;
      emit("keydown", e2);
      if (isKeyCode(e2, [13, 32]) === true && keyboardTarget !== rootRef.value) {
        keyboardTarget !== null && cleanup();
        if (e2.defaultPrevented !== true) {
          rootRef.value.focus();
          keyboardTarget = rootRef.value;
          rootRef.value.classList.add("q-btn--active");
          document.addEventListener("keyup", onPressEnd, true);
          rootRef.value.addEventListener("blur", onPressEnd, passiveCapture);
        }
        stopAndPrevent(e2);
      }
    }
    function onTouchstart(e2) {
      if (rootRef.value === null) return;
      emit("touchstart", e2);
      if (e2.defaultPrevented === true) return;
      if (touchTarget !== rootRef.value) {
        touchTarget !== null && cleanup();
        touchTarget = rootRef.value;
        localTouchTargetEl = e2.target;
        localTouchTargetEl.addEventListener("touchcancel", onPressEnd, passiveCapture);
        localTouchTargetEl.addEventListener("touchend", onPressEnd, passiveCapture);
      }
      avoidMouseRipple = true;
      mouseTimer !== null && clearTimeout(mouseTimer);
      mouseTimer = setTimeout(() => {
        mouseTimer = null;
        avoidMouseRipple = false;
      }, 200);
    }
    function onMousedown(e2) {
      if (rootRef.value === null) return;
      e2.qSkipRipple = avoidMouseRipple === true;
      emit("mousedown", e2);
      if (e2.defaultPrevented !== true && mouseTarget !== rootRef.value) {
        mouseTarget !== null && cleanup();
        mouseTarget = rootRef.value;
        rootRef.value.classList.add("q-btn--active");
        document.addEventListener("mouseup", onPressEnd, passiveCapture);
      }
    }
    function onPressEnd(e2) {
      if (rootRef.value === null) return;
      if (e2 !== void 0 && e2.type === "blur" && document.activeElement === rootRef.value) {
        return;
      }
      if (e2 !== void 0 && e2.type === "keyup") {
        if (keyboardTarget === rootRef.value && isKeyCode(e2, [13, 32]) === true) {
          const evt = new MouseEvent("click", e2);
          evt.qKeyEvent = true;
          e2.defaultPrevented === true && prevent(evt);
          e2.cancelBubble === true && stop(evt);
          rootRef.value.dispatchEvent(evt);
          stopAndPrevent(e2);
          e2.qKeyEvent = true;
        }
        emit("keyup", e2);
      }
      cleanup();
    }
    function cleanup(destroying) {
      const blurTarget = blurTargetRef.value;
      if (destroying !== true && (touchTarget === rootRef.value || mouseTarget === rootRef.value) && blurTarget !== null && blurTarget !== document.activeElement) {
        blurTarget.setAttribute("tabindex", -1);
        blurTarget.focus();
      }
      if (touchTarget === rootRef.value) {
        if (localTouchTargetEl !== null) {
          localTouchTargetEl.removeEventListener("touchcancel", onPressEnd, passiveCapture);
          localTouchTargetEl.removeEventListener("touchend", onPressEnd, passiveCapture);
        }
        touchTarget = localTouchTargetEl = null;
      }
      if (mouseTarget === rootRef.value) {
        document.removeEventListener("mouseup", onPressEnd, passiveCapture);
        mouseTarget = null;
      }
      if (keyboardTarget === rootRef.value) {
        document.removeEventListener("keyup", onPressEnd, true);
        rootRef.value !== null && rootRef.value.removeEventListener("blur", onPressEnd, passiveCapture);
        keyboardTarget = null;
      }
      rootRef.value !== null && rootRef.value.classList.remove("q-btn--active");
    }
    function onLoadingEvt(evt) {
      stopAndPrevent(evt);
      evt.qSkipRipple = true;
    }
    onBeforeUnmount(() => {
      cleanup(true);
    });
    Object.assign(proxy, {
      click: (e2) => {
        if (isActionable.value === true) {
          onClick(e2);
        }
      }
    });
    return () => {
      let inner = [];
      props4.icon !== void 0 && inner.push(
        h(QIcon_default, {
          name: props4.icon,
          left: props4.stack !== true && hasLabel.value === true,
          role: "img"
        })
      );
      hasLabel.value === true && inner.push(
        h("span", { class: "block" }, [props4.label])
      );
      inner = hMergeSlot(slots.default, inner);
      if (props4.iconRight !== void 0 && props4.round === false) {
        inner.push(
          h(QIcon_default, {
            name: props4.iconRight,
            right: props4.stack !== true && hasLabel.value === true,
            role: "img"
          })
        );
      }
      const child = [
        h("span", {
          class: "q-focus-helper",
          ref: blurTargetRef
        })
      ];
      if (props4.loading === true && props4.percentage !== void 0) {
        child.push(
          h("span", {
            class: "q-btn__progress absolute-full overflow-hidden" + (props4.darkPercentage === true ? " q-btn__progress--dark" : "")
          }, [
            h("span", {
              class: "q-btn__progress-indicator fit block",
              style: percentageStyle.value
            })
          ])
        );
      }
      child.push(
        h("span", {
          class: "q-btn__content text-center col items-center q-anchor--skip " + innerClasses.value
        }, inner)
      );
      props4.loading !== null && child.push(
        h(Transition, {
          name: "q-transition--fade"
        }, () => props4.loading === true ? [
          h("span", {
            key: "loading",
            class: "absolute-full flex flex-center"
          }, slots.loading !== void 0 ? slots.loading() : [h(QSpinner_default)])
        ] : null)
      );
      return withDirectives(
        h(
          linkTag.value,
          nodeProps.value,
          child
        ),
        [[
          Ripple_default,
          ripple.value,
          void 0,
          rippleProps.value
        ]]
      );
    };
  }
});
var QBtnGroup_default = createComponent({
  name: "QBtnGroup",
  props: {
    unelevated: Boolean,
    outline: Boolean,
    flat: Boolean,
    rounded: Boolean,
    square: Boolean,
    push: Boolean,
    stretch: Boolean,
    glossy: Boolean,
    spread: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(() => {
      const cls = ["unelevated", "outline", "flat", "rounded", "square", "push", "stretch", "glossy"].filter((t2) => props4[t2] === true).map((t2) => `q-btn-group--${t2}`).join(" ");
      return `q-btn-group row no-wrap${cls.length !== 0 ? " " + cls : ""}` + (props4.spread === true ? " q-btn-group--spread" : " inline");
    });
    return () => h("div", { class: classes.value }, hSlot(slots.default));
  }
});
function clearSelection() {
  if (window.getSelection !== void 0) {
    const selection = window.getSelection();
    if (selection.empty !== void 0) {
      selection.empty();
    } else if (selection.removeAllRanges !== void 0) {
      selection.removeAllRanges();
      Platform_default.is.mobile !== true && selection.addRange(document.createRange());
    }
  } else if (document.selection !== void 0) {
    document.selection.empty();
  }
}
var useAnchorStaticProps = {
  /* SSR does not know about Element */
  target: {
    type: [Boolean, String, Element],
    default: true
  },
  noParentEvent: Boolean
};
var useAnchorProps = {
  ...useAnchorStaticProps,
  contextMenu: Boolean
};
function use_anchor_default({
  showing,
  avoidEmit,
  // required for QPopupProxy (true)
  configureAnchorEl
  // optional
}) {
  const { props: props4, proxy, emit } = getCurrentInstance();
  const anchorEl = ref$1(null);
  let touchTimer = null;
  function canShow(evt) {
    return anchorEl.value === null ? false : evt === void 0 || evt.touches === void 0 || evt.touches.length <= 1;
  }
  const anchorEvents = {};
  if (configureAnchorEl === void 0) {
    Object.assign(anchorEvents, {
      hide(evt) {
        proxy.hide(evt);
      },
      toggle(evt) {
        proxy.toggle(evt);
        evt.qAnchorHandled = true;
      },
      toggleKey(evt) {
        isKeyCode(evt, 13) === true && anchorEvents.toggle(evt);
      },
      contextClick(evt) {
        proxy.hide(evt);
        prevent(evt);
        nextTick(() => {
          proxy.show(evt);
          evt.qAnchorHandled = true;
        });
      },
      prevent,
      mobileTouch(evt) {
        anchorEvents.mobileCleanup(evt);
        if (canShow(evt) !== true) {
          return;
        }
        proxy.hide(evt);
        anchorEl.value.classList.add("non-selectable");
        const target2 = evt.target;
        addEvt(anchorEvents, "anchor", [
          [target2, "touchmove", "mobileCleanup", "passive"],
          [target2, "touchend", "mobileCleanup", "passive"],
          [target2, "touchcancel", "mobileCleanup", "passive"],
          [anchorEl.value, "contextmenu", "prevent", "notPassive"]
        ]);
        touchTimer = setTimeout(() => {
          touchTimer = null;
          proxy.show(evt);
          evt.qAnchorHandled = true;
        }, 300);
      },
      mobileCleanup(evt) {
        anchorEl.value.classList.remove("non-selectable");
        if (touchTimer !== null) {
          clearTimeout(touchTimer);
          touchTimer = null;
        }
        if (showing.value === true && evt !== void 0) {
          clearSelection();
        }
      }
    });
    configureAnchorEl = function(context = props4.contextMenu) {
      if (props4.noParentEvent === true || anchorEl.value === null) return;
      let evts;
      if (context === true) {
        if (proxy.$q.platform.is.mobile === true) {
          evts = [
            [anchorEl.value, "touchstart", "mobileTouch", "passive"]
          ];
        } else {
          evts = [
            [anchorEl.value, "mousedown", "hide", "passive"],
            [anchorEl.value, "contextmenu", "contextClick", "notPassive"]
          ];
        }
      } else {
        evts = [
          [anchorEl.value, "click", "toggle", "passive"],
          [anchorEl.value, "keyup", "toggleKey", "passive"]
        ];
      }
      addEvt(anchorEvents, "anchor", evts);
    };
  }
  function unconfigureAnchorEl() {
    cleanEvt(anchorEvents, "anchor");
  }
  function setAnchorEl(el) {
    anchorEl.value = el;
    while (anchorEl.value.classList.contains("q-anchor--skip")) {
      anchorEl.value = anchorEl.value.parentNode;
    }
    configureAnchorEl();
  }
  function pickAnchorEl() {
    if (props4.target === false || props4.target === "" || proxy.$el.parentNode === null) {
      anchorEl.value = null;
    } else if (props4.target === true) {
      setAnchorEl(proxy.$el.parentNode);
    } else {
      let el = props4.target;
      if (typeof props4.target === "string") {
        try {
          el = document.querySelector(props4.target);
        } catch (err) {
          el = void 0;
        }
      }
      if (el !== void 0 && el !== null) {
        anchorEl.value = el.$el || el;
        configureAnchorEl();
      } else {
        anchorEl.value = null;
        console.error(`Anchor: target "${props4.target}" not found`);
      }
    }
  }
  watch(() => props4.contextMenu, (val) => {
    if (anchorEl.value !== null) {
      unconfigureAnchorEl();
      configureAnchorEl(val);
    }
  });
  watch(() => props4.target, () => {
    if (anchorEl.value !== null) {
      unconfigureAnchorEl();
    }
    pickAnchorEl();
  });
  watch(() => props4.noParentEvent, (val) => {
    if (anchorEl.value !== null) {
      if (val === true) {
        unconfigureAnchorEl();
      } else {
        configureAnchorEl();
      }
    }
  });
  onMounted(() => {
    pickAnchorEl();
    if (avoidEmit !== true && props4.modelValue === true && anchorEl.value === null) {
      emit("update:modelValue", false);
    }
  });
  onBeforeUnmount(() => {
    touchTimer !== null && clearTimeout(touchTimer);
    unconfigureAnchorEl();
  });
  return {
    anchorEl,
    canShow,
    anchorEvents
  };
}
function use_scroll_target_default(props4, configureScrollTarget) {
  const localScrollTarget = ref$1(null);
  let scrollFn;
  function changeScrollEvent(scrollTarget, fn) {
    const fnProp = `${fn !== void 0 ? "add" : "remove"}EventListener`;
    const fnHandler = fn !== void 0 ? fn : scrollFn;
    if (scrollTarget !== window) {
      scrollTarget[fnProp]("scroll", fnHandler, listenOpts.passive);
    }
    window[fnProp]("scroll", fnHandler, listenOpts.passive);
    scrollFn = fn;
  }
  function unconfigureScrollTarget() {
    if (localScrollTarget.value !== null) {
      changeScrollEvent(localScrollTarget.value);
      localScrollTarget.value = null;
    }
  }
  const noParentEventWatcher = watch(() => props4.noParentEvent, () => {
    if (localScrollTarget.value !== null) {
      unconfigureScrollTarget();
      configureScrollTarget();
    }
  });
  onBeforeUnmount(noParentEventWatcher);
  return {
    localScrollTarget,
    unconfigureScrollTarget,
    changeScrollEvent
  };
}
var useModelToggleProps = {
  modelValue: {
    type: Boolean,
    default: null
  },
  "onUpdate:modelValue": [Function, Array]
};
var useModelToggleEmits = [
  "beforeShow",
  "show",
  "beforeHide",
  "hide"
];
function use_model_toggle_default({
  showing,
  canShow,
  // optional
  hideOnRouteChange,
  // optional
  handleShow,
  // optional
  handleHide,
  // optional
  processOnMount
  // optional
}) {
  const vm2 = getCurrentInstance();
  const { props: props4, emit, proxy } = vm2;
  let payload;
  function toggle(evt) {
    if (showing.value === true) {
      hide(evt);
    } else {
      show(evt);
    }
  }
  function show(evt) {
    if (props4.disable === true || evt !== void 0 && evt.qAnchorHandled === true || canShow !== void 0 && canShow(evt) !== true) {
      return;
    }
    const listener = props4["onUpdate:modelValue"] !== void 0;
    if (listener === true && true) {
      emit("update:modelValue", true);
      payload = evt;
      nextTick(() => {
        if (payload === evt) {
          payload = void 0;
        }
      });
    }
    if (props4.modelValue === null || listener === false || false) {
      processShow(evt);
    }
  }
  function processShow(evt) {
    if (showing.value === true) {
      return;
    }
    showing.value = true;
    emit("beforeShow", evt);
    if (handleShow !== void 0) {
      handleShow(evt);
    } else {
      emit("show", evt);
    }
  }
  function hide(evt) {
    if (props4.disable === true) {
      return;
    }
    const listener = props4["onUpdate:modelValue"] !== void 0;
    if (listener === true && true) {
      emit("update:modelValue", false);
      payload = evt;
      nextTick(() => {
        if (payload === evt) {
          payload = void 0;
        }
      });
    }
    if (props4.modelValue === null || listener === false || false) {
      processHide(evt);
    }
  }
  function processHide(evt) {
    if (showing.value === false) {
      return;
    }
    showing.value = false;
    emit("beforeHide", evt);
    if (handleHide !== void 0) {
      handleHide(evt);
    } else {
      emit("hide", evt);
    }
  }
  function processModelChange(val) {
    if (props4.disable === true && val === true) {
      if (props4["onUpdate:modelValue"] !== void 0) {
        emit("update:modelValue", false);
      }
    } else if (val === true !== showing.value) {
      const fn = val === true ? processShow : processHide;
      fn(payload);
    }
  }
  watch(() => props4.modelValue, processModelChange);
  if (hideOnRouteChange !== void 0 && vmHasRouter(vm2) === true) {
    watch(() => proxy.$route.fullPath, () => {
      if (hideOnRouteChange.value === true && showing.value === true) {
        hide();
      }
    });
  }
  processOnMount === true && onMounted(() => {
    processModelChange(props4.modelValue);
  });
  const publicMethods = { show, hide, toggle };
  Object.assign(proxy, publicMethods);
  return publicMethods;
}
var queue = [];
var waitFlags = [];
function clearFlag(flag) {
  waitFlags = waitFlags.filter((entry) => entry !== flag);
}
function addFocusWaitFlag(flag) {
  clearFlag(flag);
  waitFlags.push(flag);
}
function removeFocusWaitFlag(flag) {
  clearFlag(flag);
  if (waitFlags.length === 0 && queue.length !== 0) {
    queue[queue.length - 1]();
    queue = [];
  }
}
function addFocusFn(fn) {
  if (waitFlags.length === 0) {
    fn();
  } else {
    queue.push(fn);
  }
}
function removeFocusFn(fn) {
  queue = queue.filter((entry) => entry !== fn);
}
var nodesList = [];
var portalTypeList = [];
var portalIndex = 1;
var target = document.body;
function createGlobalNode(id3, portalType) {
  const el = document.createElement("div");
  el.id = portalType !== void 0 ? `q-portal--${portalType}--${portalIndex++}` : id3;
  if (globalConfig.globalNodes !== void 0) {
    const cls = globalConfig.globalNodes.class;
    if (cls !== void 0) {
      el.className = cls;
    }
  }
  target.appendChild(el);
  nodesList.push(el);
  portalTypeList.push(portalType);
  return el;
}
function removeGlobalNode(el) {
  const nodeIndex = nodesList.indexOf(el);
  nodesList.splice(nodeIndex, 1);
  portalTypeList.splice(nodeIndex, 1);
  el.remove();
}
function changeGlobalNodesTarget(newTarget) {
  if (newTarget === target) return;
  target = newTarget;
  if (target === document.body || portalTypeList.reduce((acc, type2) => type2 === "dialog" ? acc + 1 : acc, 0) < 2) {
    nodesList.forEach((node) => {
      if (node.contains(target) === false) {
        target.appendChild(node);
      }
    });
    return;
  }
  const lastDialogIndex = portalTypeList.lastIndexOf("dialog");
  for (let i2 = 0; i2 < nodesList.length; i2++) {
    const el = nodesList[i2];
    if ((i2 === lastDialogIndex || portalTypeList[i2] !== "dialog") && el.contains(target) === false) {
      target.appendChild(el);
    }
  }
}
var portalProxyList = [];
function getPortalProxy(el) {
  return portalProxyList.find(
    (proxy) => proxy.contentEl !== null && proxy.contentEl.contains(el)
  );
}
function closePortalMenus(proxy, evt) {
  do {
    if (proxy.$options.name === "QMenu") {
      proxy.hide(evt);
      if (proxy.$props.separateClosePopup === true) {
        return getParentProxy(proxy);
      }
    } else if (proxy.__qPortal === true) {
      const parent = getParentProxy(proxy);
      if (parent !== void 0 && parent.$options.name === "QPopupProxy") {
        proxy.hide(evt);
        return parent;
      } else {
        return proxy;
      }
    }
    proxy = getParentProxy(proxy);
  } while (proxy !== void 0 && proxy !== null);
}
function closePortals(proxy, evt, depth) {
  while (depth !== 0 && proxy !== void 0 && proxy !== null) {
    if (proxy.__qPortal === true) {
      depth--;
      if (proxy.$options.name === "QMenu") {
        proxy = closePortalMenus(proxy, evt);
        continue;
      }
      proxy.hide(evt);
    }
    proxy = getParentProxy(proxy);
  }
}
var QPortal = createComponent({
  name: "QPortal",
  setup(_, { slots }) {
    return () => slots.default();
  }
});
function isOnGlobalDialog(vm2) {
  vm2 = vm2.parent;
  while (vm2 !== void 0 && vm2 !== null) {
    if (vm2.type.name === "QGlobalDialog") {
      return true;
    }
    if (vm2.type.name === "QDialog" || vm2.type.name === "QMenu") {
      return false;
    }
    vm2 = vm2.parent;
  }
  return false;
}
function use_portal_default(vm2, innerRef, renderPortalContent, type2) {
  const portalIsActive = ref$1(false);
  const portalIsAccessible = ref$1(false);
  let portalEl = null;
  const focusObj = {};
  const onGlobalDialog = type2 === "dialog" && isOnGlobalDialog(vm2);
  function showPortal(isReady) {
    if (isReady === true) {
      removeFocusWaitFlag(focusObj);
      portalIsAccessible.value = true;
      return;
    }
    portalIsAccessible.value = false;
    if (portalIsActive.value === false) {
      if (onGlobalDialog === false && portalEl === null) {
        portalEl = createGlobalNode(false, type2);
      }
      portalIsActive.value = true;
      portalProxyList.push(vm2.proxy);
      addFocusWaitFlag(focusObj);
    }
  }
  function hidePortal(isReady) {
    portalIsAccessible.value = false;
    if (isReady !== true) return;
    removeFocusWaitFlag(focusObj);
    portalIsActive.value = false;
    const index = portalProxyList.indexOf(vm2.proxy);
    if (index !== -1) {
      portalProxyList.splice(index, 1);
    }
    if (portalEl !== null) {
      removeGlobalNode(portalEl);
      portalEl = null;
    }
  }
  onUnmounted(() => {
    hidePortal(true);
  });
  vm2.proxy.__qPortal = true;
  injectProp(vm2.proxy, "contentEl", () => innerRef.value);
  return {
    showPortal,
    hidePortal,
    portalIsActive,
    portalIsAccessible,
    renderPortal: () => onGlobalDialog === true ? renderPortalContent() : portalIsActive.value === true ? [h(Teleport, { to: portalEl }, h(QPortal, renderPortalContent))] : void 0
  };
}
var useTransitionProps = {
  transitionShow: {
    type: String,
    default: "fade"
  },
  transitionHide: {
    type: String,
    default: "fade"
  },
  transitionDuration: {
    type: [String, Number],
    default: 300
  }
};
function use_transition_default(props4, defaultShowFn = () => {
}, defaultHideFn = () => {
}) {
  return {
    transitionProps: computed(() => {
      const show = `q-transition--${props4.transitionShow || defaultShowFn()}`;
      const hide = `q-transition--${props4.transitionHide || defaultHideFn()}`;
      return {
        appear: true,
        enterFromClass: `${show}-enter-from`,
        enterActiveClass: `${show}-enter-active`,
        enterToClass: `${show}-enter-to`,
        leaveFromClass: `${hide}-leave-from`,
        leaveActiveClass: `${hide}-leave-active`,
        leaveToClass: `${hide}-leave-to`
      };
    }),
    transitionStyle: computed(() => `--q-transition-duration: ${props4.transitionDuration}ms`)
  };
}
function use_tick_default() {
  let tickFn;
  const vm2 = getCurrentInstance();
  function removeTick() {
    tickFn = void 0;
  }
  onDeactivated(removeTick);
  onBeforeUnmount(removeTick);
  return {
    removeTick,
    registerTick(fn) {
      tickFn = fn;
      nextTick(() => {
        if (tickFn === fn) {
          vmIsDestroyed(vm2) === false && tickFn();
          tickFn = void 0;
        }
      });
    }
  };
}
function use_timeout_default() {
  let timer2 = null;
  const vm2 = getCurrentInstance();
  function removeTimeout() {
    if (timer2 !== null) {
      clearTimeout(timer2);
      timer2 = null;
    }
  }
  onDeactivated(removeTimeout);
  onBeforeUnmount(removeTimeout);
  return {
    removeTimeout,
    registerTimeout(fn, delay) {
      removeTimeout();
      if (vmIsDestroyed(vm2) === false) {
        timer2 = setTimeout(() => {
          timer2 = null;
          fn();
        }, delay);
      }
    }
  };
}
var scrollTargetProp = [Element, String];
var scrollTargets = [null, document, document.body, document.scrollingElement, document.documentElement];
function getScrollTarget(el, targetEl) {
  let target2 = getElement(targetEl);
  if (target2 === void 0) {
    if (el === void 0 || el === null) {
      return window;
    }
    target2 = el.closest(".scroll,.scroll-y,.overflow-auto");
  }
  return scrollTargets.includes(target2) ? window : target2;
}
function getScrollHeight(el) {
  return (el === window ? document.body : el).scrollHeight;
}
function getVerticalScrollPosition(scrollTarget) {
  return scrollTarget === window ? window.pageYOffset || window.scrollY || document.body.scrollTop || 0 : scrollTarget.scrollTop;
}
function getHorizontalScrollPosition(scrollTarget) {
  return scrollTarget === window ? window.pageXOffset || window.scrollX || document.body.scrollLeft || 0 : scrollTarget.scrollLeft;
}
function animVerticalScrollTo(el, to, duration2 = 0) {
  const prevTime = arguments[3] === void 0 ? performance.now() : arguments[3];
  const pos = getVerticalScrollPosition(el);
  if (duration2 <= 0) {
    if (pos !== to) {
      setScroll(el, to);
    }
    return;
  }
  requestAnimationFrame((nowTime) => {
    const frameTime = nowTime - prevTime;
    const newPos = pos + (to - pos) / Math.max(frameTime, duration2) * frameTime;
    setScroll(el, newPos);
    if (newPos !== to) {
      animVerticalScrollTo(el, to, duration2 - frameTime, nowTime);
    }
  });
}
function animHorizontalScrollTo(el, to, duration2 = 0) {
  const prevTime = arguments[3] === void 0 ? performance.now() : arguments[3];
  const pos = getHorizontalScrollPosition(el);
  if (duration2 <= 0) {
    if (pos !== to) {
      setHorizontalScroll(el, to);
    }
    return;
  }
  requestAnimationFrame((nowTime) => {
    const frameTime = nowTime - prevTime;
    const newPos = pos + (to - pos) / Math.max(frameTime, duration2) * frameTime;
    setHorizontalScroll(el, newPos);
    if (newPos !== to) {
      animHorizontalScrollTo(el, to, duration2 - frameTime, nowTime);
    }
  });
}
function setScroll(scrollTarget, offset2) {
  if (scrollTarget === window) {
    window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, offset2);
    return;
  }
  scrollTarget.scrollTop = offset2;
}
function setHorizontalScroll(scrollTarget, offset2) {
  if (scrollTarget === window) {
    window.scrollTo(offset2, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
    return;
  }
  scrollTarget.scrollLeft = offset2;
}
function setVerticalScrollPosition(scrollTarget, offset2, duration2) {
  if (duration2) {
    animVerticalScrollTo(scrollTarget, offset2, duration2);
    return;
  }
  setScroll(scrollTarget, offset2);
}
function setHorizontalScrollPosition(scrollTarget, offset2, duration2) {
  if (duration2) {
    animHorizontalScrollTo(scrollTarget, offset2, duration2);
    return;
  }
  setHorizontalScroll(scrollTarget, offset2);
}
var size;
function getScrollbarWidth() {
  if (size !== void 0) {
    return size;
  }
  const inner = document.createElement("p"), outer = document.createElement("div");
  css(inner, {
    width: "100%",
    height: "200px"
  });
  css(outer, {
    position: "absolute",
    top: "0px",
    left: "0px",
    visibility: "hidden",
    width: "200px",
    height: "150px",
    overflow: "hidden"
  });
  outer.appendChild(inner);
  document.body.appendChild(outer);
  const w1 = inner.offsetWidth;
  outer.style.overflow = "scroll";
  let w2 = inner.offsetWidth;
  if (w1 === w2) {
    w2 = outer.clientWidth;
  }
  outer.remove();
  size = w1 - w2;
  return size;
}
function hasScrollbar(el, onY = true) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) {
    return false;
  }
  return onY ? el.scrollHeight > el.clientHeight && (el.classList.contains("scroll") || el.classList.contains("overflow-auto") || ["auto", "scroll"].includes(window.getComputedStyle(el)["overflow-y"])) : el.scrollWidth > el.clientWidth && (el.classList.contains("scroll") || el.classList.contains("overflow-auto") || ["auto", "scroll"].includes(window.getComputedStyle(el)["overflow-x"]));
}
var handlers = [];
var escDown;
function onKeydown(evt) {
  escDown = evt.keyCode === 27;
}
function onBlur() {
  if (escDown === true) {
    escDown = false;
  }
}
function onKeyup(evt) {
  if (escDown === true) {
    escDown = false;
    if (isKeyCode(evt, 27) === true) {
      handlers[handlers.length - 1](evt);
    }
  }
}
function update(action) {
  window[action]("keydown", onKeydown);
  window[action]("blur", onBlur);
  window[action]("keyup", onKeyup);
  escDown = false;
}
function addEscapeKey(fn) {
  if (client.is.desktop === true) {
    handlers.push(fn);
    if (handlers.length === 1) {
      update("addEventListener");
    }
  }
}
function removeEscapeKey(fn) {
  const index = handlers.indexOf(fn);
  if (index !== -1) {
    handlers.splice(index, 1);
    if (handlers.length === 0) {
      update("removeEventListener");
    }
  }
}
var handlers2 = [];
function trigger(e2) {
  handlers2[handlers2.length - 1](e2);
}
function addFocusout(fn) {
  if (client.is.desktop === true) {
    handlers2.push(fn);
    if (handlers2.length === 1) {
      document.body.addEventListener("focusin", trigger);
    }
  }
}
function removeFocusout(fn) {
  const index = handlers2.indexOf(fn);
  if (index !== -1) {
    handlers2.splice(index, 1);
    if (handlers2.length === 0) {
      document.body.removeEventListener("focusin", trigger);
    }
  }
}
var { notPassiveCapture } = listenOpts;
var registeredList = [];
function globalHandler(evt) {
  const target2 = evt.target;
  if (target2 === void 0 || target2.nodeType === 8 || target2.classList.contains("no-pointer-events") === true) {
    return;
  }
  let portalIndex2 = portalProxyList.length - 1;
  while (portalIndex2 >= 0) {
    const proxy = portalProxyList[portalIndex2].$;
    if (proxy.type.name === "QTooltip") {
      portalIndex2--;
      continue;
    }
    if (proxy.type.name !== "QDialog") {
      break;
    }
    if (proxy.props.seamless !== true) {
      return;
    }
    portalIndex2--;
  }
  for (let i2 = registeredList.length - 1; i2 >= 0; i2--) {
    const state2 = registeredList[i2];
    if ((state2.anchorEl.value === null || state2.anchorEl.value.contains(target2) === false) && (target2 === document.body || state2.innerRef.value !== null && state2.innerRef.value.contains(target2) === false)) {
      evt.qClickOutside = true;
      state2.onClickOutside(evt);
    } else {
      return;
    }
  }
}
function addClickOutside(clickOutsideProps) {
  registeredList.push(clickOutsideProps);
  if (registeredList.length === 1) {
    document.addEventListener("mousedown", globalHandler, notPassiveCapture);
    document.addEventListener("touchstart", globalHandler, notPassiveCapture);
  }
}
function removeClickOutside(clickOutsideProps) {
  const index = registeredList.findIndex((h138) => h138 === clickOutsideProps);
  if (index !== -1) {
    registeredList.splice(index, 1);
    if (registeredList.length === 0) {
      document.removeEventListener("mousedown", globalHandler, notPassiveCapture);
      document.removeEventListener("touchstart", globalHandler, notPassiveCapture);
    }
  }
}
var vpLeft;
var vpTop;
function validatePosition(pos) {
  const parts = pos.split(" ");
  if (parts.length !== 2) {
    return false;
  }
  if (["top", "center", "bottom"].includes(parts[0]) !== true) {
    console.error("Anchor/Self position must start with one of top/center/bottom");
    return false;
  }
  if (["left", "middle", "right", "start", "end"].includes(parts[1]) !== true) {
    console.error("Anchor/Self position must end with one of left/middle/right/start/end");
    return false;
  }
  return true;
}
function validateOffset(val) {
  if (!val) {
    return true;
  }
  if (val.length !== 2) {
    return false;
  }
  if (typeof val[0] !== "number" || typeof val[1] !== "number") {
    return false;
  }
  return true;
}
var horizontalPos = {
  "start#ltr": "left",
  "start#rtl": "right",
  "end#ltr": "right",
  "end#rtl": "left"
};
["left", "middle", "right"].forEach((pos) => {
  horizontalPos[`${pos}#ltr`] = pos;
  horizontalPos[`${pos}#rtl`] = pos;
});
function parsePosition(pos, rtl) {
  const parts = pos.split(" ");
  return {
    vertical: parts[0],
    horizontal: horizontalPos[`${parts[1]}#${rtl === true ? "rtl" : "ltr"}`]
  };
}
function getAnchorProps(el, offset2) {
  let { top, left, right, bottom, width: width3, height: height2 } = el.getBoundingClientRect();
  if (offset2 !== void 0) {
    top -= offset2[1];
    left -= offset2[0];
    bottom += offset2[1];
    right += offset2[0];
    width3 += offset2[0];
    height2 += offset2[1];
  }
  return {
    top,
    bottom,
    height: height2,
    left,
    right,
    width: width3,
    middle: left + (right - left) / 2,
    center: top + (bottom - top) / 2
  };
}
function getAbsoluteAnchorProps(el, absoluteOffset, offset2) {
  let { top, left } = el.getBoundingClientRect();
  top += absoluteOffset.top;
  left += absoluteOffset.left;
  if (offset2 !== void 0) {
    top += offset2[1];
    left += offset2[0];
  }
  return {
    top,
    bottom: top + 1,
    height: 1,
    left,
    right: left + 1,
    width: 1,
    middle: left,
    center: top
  };
}
function getTargetProps(width3, height2) {
  return {
    top: 0,
    center: height2 / 2,
    bottom: height2,
    left: 0,
    middle: width3 / 2,
    right: width3
  };
}
function getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin) {
  return {
    top: anchorProps[anchorOrigin.vertical] - targetProps[selfOrigin.vertical],
    left: anchorProps[anchorOrigin.horizontal] - targetProps[selfOrigin.horizontal]
  };
}
function setPosition(cfg, retryNumber = 0) {
  if (cfg.targetEl === null || cfg.anchorEl === null || retryNumber > 5) {
    return;
  }
  if (cfg.targetEl.offsetHeight === 0 || cfg.targetEl.offsetWidth === 0) {
    setTimeout(() => {
      setPosition(cfg, retryNumber + 1);
    }, 10);
    return;
  }
  const {
    targetEl,
    offset: offset2,
    anchorEl,
    anchorOrigin,
    selfOrigin,
    absoluteOffset,
    fit,
    cover,
    maxHeight,
    maxWidth
  } = cfg;
  if (client.is.ios === true && window.visualViewport !== void 0) {
    const el = document.body.style;
    const { offsetLeft: left, offsetTop: top } = window.visualViewport;
    if (left !== vpLeft) {
      el.setProperty("--q-pe-left", left + "px");
      vpLeft = left;
    }
    if (top !== vpTop) {
      el.setProperty("--q-pe-top", top + "px");
      vpTop = top;
    }
  }
  const { scrollLeft, scrollTop } = targetEl;
  const anchorProps = absoluteOffset === void 0 ? getAnchorProps(anchorEl, cover === true ? [0, 0] : offset2) : getAbsoluteAnchorProps(anchorEl, absoluteOffset, offset2);
  Object.assign(targetEl.style, {
    top: 0,
    left: 0,
    minWidth: null,
    minHeight: null,
    maxWidth,
    maxHeight,
    visibility: "visible"
  });
  const { offsetWidth: origElWidth, offsetHeight: origElHeight } = targetEl;
  const { elWidth, elHeight } = fit === true || cover === true ? { elWidth: Math.max(anchorProps.width, origElWidth), elHeight: cover === true ? Math.max(anchorProps.height, origElHeight) : origElHeight } : { elWidth: origElWidth, elHeight: origElHeight };
  let elStyle = { maxWidth, maxHeight };
  if (fit === true || cover === true) {
    elStyle.minWidth = anchorProps.width + "px";
    if (cover === true) {
      elStyle.minHeight = anchorProps.height + "px";
    }
  }
  Object.assign(targetEl.style, elStyle);
  const targetProps = getTargetProps(elWidth, elHeight);
  let props4 = getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin);
  if (absoluteOffset === void 0 || offset2 === void 0) {
    applyBoundaries(props4, anchorProps, targetProps, anchorOrigin, selfOrigin);
  } else {
    const { top, left } = props4;
    applyBoundaries(props4, anchorProps, targetProps, anchorOrigin, selfOrigin);
    let hasChanged = false;
    if (props4.top !== top) {
      hasChanged = true;
      const offsetY = 2 * offset2[1];
      anchorProps.center = anchorProps.top -= offsetY;
      anchorProps.bottom -= offsetY + 2;
    }
    if (props4.left !== left) {
      hasChanged = true;
      const offsetX = 2 * offset2[0];
      anchorProps.middle = anchorProps.left -= offsetX;
      anchorProps.right -= offsetX + 2;
    }
    if (hasChanged === true) {
      props4 = getTopLeftProps(anchorProps, targetProps, anchorOrigin, selfOrigin);
      applyBoundaries(props4, anchorProps, targetProps, anchorOrigin, selfOrigin);
    }
  }
  elStyle = {
    top: props4.top + "px",
    left: props4.left + "px"
  };
  if (props4.maxHeight !== void 0) {
    elStyle.maxHeight = props4.maxHeight + "px";
    if (anchorProps.height > props4.maxHeight) {
      elStyle.minHeight = elStyle.maxHeight;
    }
  }
  if (props4.maxWidth !== void 0) {
    elStyle.maxWidth = props4.maxWidth + "px";
    if (anchorProps.width > props4.maxWidth) {
      elStyle.minWidth = elStyle.maxWidth;
    }
  }
  Object.assign(targetEl.style, elStyle);
  if (targetEl.scrollTop !== scrollTop) {
    targetEl.scrollTop = scrollTop;
  }
  if (targetEl.scrollLeft !== scrollLeft) {
    targetEl.scrollLeft = scrollLeft;
  }
}
function applyBoundaries(props4, anchorProps, targetProps, anchorOrigin, selfOrigin) {
  const currentHeight = targetProps.bottom, currentWidth = targetProps.right, margin = getScrollbarWidth(), innerHeight = window.innerHeight - margin, innerWidth = document.body.clientWidth;
  if (props4.top < 0 || props4.top + currentHeight > innerHeight) {
    if (selfOrigin.vertical === "center") {
      props4.top = anchorProps[anchorOrigin.vertical] > innerHeight / 2 ? Math.max(0, innerHeight - currentHeight) : 0;
      props4.maxHeight = Math.min(currentHeight, innerHeight);
    } else if (anchorProps[anchorOrigin.vertical] > innerHeight / 2) {
      const anchorY = Math.min(
        innerHeight,
        anchorOrigin.vertical === "center" ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.bottom : anchorProps.top
      );
      props4.maxHeight = Math.min(currentHeight, anchorY);
      props4.top = Math.max(0, anchorY - currentHeight);
    } else {
      props4.top = Math.max(
        0,
        anchorOrigin.vertical === "center" ? anchorProps.center : anchorOrigin.vertical === selfOrigin.vertical ? anchorProps.top : anchorProps.bottom
      );
      props4.maxHeight = Math.min(currentHeight, innerHeight - props4.top);
    }
  }
  if (props4.left < 0 || props4.left + currentWidth > innerWidth) {
    props4.maxWidth = Math.min(currentWidth, innerWidth);
    if (selfOrigin.horizontal === "middle") {
      props4.left = anchorProps[anchorOrigin.horizontal] > innerWidth / 2 ? Math.max(0, innerWidth - currentWidth) : 0;
    } else if (anchorProps[anchorOrigin.horizontal] > innerWidth / 2) {
      const anchorX = Math.min(
        innerWidth,
        anchorOrigin.horizontal === "middle" ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.right : anchorProps.left
      );
      props4.maxWidth = Math.min(currentWidth, anchorX);
      props4.left = Math.max(0, anchorX - props4.maxWidth);
    } else {
      props4.left = Math.max(
        0,
        anchorOrigin.horizontal === "middle" ? anchorProps.middle : anchorOrigin.horizontal === selfOrigin.horizontal ? anchorProps.left : anchorProps.right
      );
      props4.maxWidth = Math.min(currentWidth, innerWidth - props4.left);
    }
  }
}
var QMenu_default = createComponent({
  name: "QMenu",
  inheritAttrs: false,
  props: {
    ...useAnchorProps,
    ...useModelToggleProps,
    ...useDarkProps,
    ...useTransitionProps,
    persistent: Boolean,
    autoClose: Boolean,
    separateClosePopup: Boolean,
    noRouteDismiss: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    fit: Boolean,
    cover: Boolean,
    square: Boolean,
    anchor: {
      type: String,
      validator: validatePosition
    },
    self: {
      type: String,
      validator: validatePosition
    },
    offset: {
      type: Array,
      validator: validateOffset
    },
    scrollTarget: scrollTargetProp,
    touchPosition: Boolean,
    maxHeight: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: null
    }
  },
  emits: [
    ...useModelToggleEmits,
    "click",
    "escapeKey"
  ],
  setup(props4, { slots, emit, attrs }) {
    let refocusTarget = null, absoluteOffset, unwatchPosition, avoidAutoClose;
    const vm2 = getCurrentInstance();
    const { proxy } = vm2;
    const { $q } = proxy;
    const innerRef = ref$1(null);
    const showing = ref$1(false);
    const hideOnRouteChange = computed(
      () => props4.persistent !== true && props4.noRouteDismiss !== true
    );
    const isDark = use_dark_default(props4, $q);
    const { registerTick, removeTick } = use_tick_default();
    const { registerTimeout } = use_timeout_default();
    const { transitionProps, transitionStyle } = use_transition_default(props4);
    const { localScrollTarget, changeScrollEvent, unconfigureScrollTarget } = use_scroll_target_default(props4, configureScrollTarget);
    const { anchorEl, canShow } = use_anchor_default({ showing });
    const { hide } = use_model_toggle_default({
      showing,
      canShow,
      handleShow,
      handleHide,
      hideOnRouteChange,
      processOnMount: true
    });
    const { showPortal, hidePortal, renderPortal } = use_portal_default(vm2, innerRef, renderPortalContent, "menu");
    const clickOutsideProps = {
      anchorEl,
      innerRef,
      onClickOutside(e2) {
        if (props4.persistent !== true && showing.value === true) {
          hide(e2);
          if (
            // always prevent touch event
            e2.type === "touchstart" || e2.target.classList.contains("q-dialog__backdrop")
          ) {
            stopAndPrevent(e2);
          }
          return true;
        }
      }
    };
    const anchorOrigin = computed(
      () => parsePosition(
        props4.anchor || (props4.cover === true ? "center middle" : "bottom start"),
        $q.lang.rtl
      )
    );
    const selfOrigin = computed(() => props4.cover === true ? anchorOrigin.value : parsePosition(props4.self || "top start", $q.lang.rtl));
    const menuClass = computed(
      () => (props4.square === true ? " q-menu--square" : "") + (isDark.value === true ? " q-menu--dark q-dark" : "")
    );
    const onEvents = computed(() => props4.autoClose === true ? { onClick: onAutoClose } : {});
    const handlesFocus = computed(
      () => showing.value === true && props4.persistent !== true
    );
    watch(handlesFocus, (val) => {
      if (val === true) {
        addEscapeKey(onEscapeKey);
        addClickOutside(clickOutsideProps);
      } else {
        removeEscapeKey(onEscapeKey);
        removeClickOutside(clickOutsideProps);
      }
    });
    function focus() {
      addFocusFn(() => {
        let node = innerRef.value;
        if (node && node.contains(document.activeElement) !== true) {
          node = node.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || node.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || node.querySelector("[autofocus], [data-autofocus]") || node;
          node.focus({ preventScroll: true });
        }
      });
    }
    function handleShow(evt) {
      refocusTarget = props4.noRefocus === false ? document.activeElement : null;
      addFocusout(onFocusout);
      showPortal();
      configureScrollTarget();
      absoluteOffset = void 0;
      if (evt !== void 0 && (props4.touchPosition || props4.contextMenu)) {
        const pos = position(evt);
        if (pos.left !== void 0) {
          const { top, left } = anchorEl.value.getBoundingClientRect();
          absoluteOffset = { left: pos.left - left, top: pos.top - top };
        }
      }
      if (unwatchPosition === void 0) {
        unwatchPosition = watch(
          () => $q.screen.width + "|" + $q.screen.height + "|" + props4.self + "|" + props4.anchor + "|" + $q.lang.rtl,
          updatePosition
        );
      }
      if (props4.noFocus !== true) {
        document.activeElement.blur();
      }
      registerTick(() => {
        updatePosition();
        props4.noFocus !== true && focus();
      });
      registerTimeout(() => {
        if ($q.platform.is.ios === true) {
          avoidAutoClose = props4.autoClose;
          innerRef.value.click();
        }
        updatePosition();
        showPortal(true);
        emit("show", evt);
      }, props4.transitionDuration);
    }
    function handleHide(evt) {
      removeTick();
      hidePortal();
      anchorCleanup(true);
      if (refocusTarget !== null && // menu was hidden from code or ESC plugin
      (evt === void 0 || evt.qClickOutside !== true)) {
        ((evt && evt.type.indexOf("key") === 0 ? refocusTarget.closest('[tabindex]:not([tabindex^="-"])') : void 0) || refocusTarget).focus();
        refocusTarget = null;
      }
      registerTimeout(() => {
        hidePortal(true);
        emit("hide", evt);
      }, props4.transitionDuration);
    }
    function anchorCleanup(hiding) {
      absoluteOffset = void 0;
      if (unwatchPosition !== void 0) {
        unwatchPosition();
        unwatchPosition = void 0;
      }
      if (hiding === true || showing.value === true) {
        removeFocusout(onFocusout);
        unconfigureScrollTarget();
        removeClickOutside(clickOutsideProps);
        removeEscapeKey(onEscapeKey);
      }
      if (hiding !== true) {
        refocusTarget = null;
      }
    }
    function configureScrollTarget() {
      if (anchorEl.value !== null || props4.scrollTarget !== void 0) {
        localScrollTarget.value = getScrollTarget(anchorEl.value, props4.scrollTarget);
        changeScrollEvent(localScrollTarget.value, updatePosition);
      }
    }
    function onAutoClose(e2) {
      if (avoidAutoClose !== true) {
        closePortalMenus(proxy, e2);
        emit("click", e2);
      } else {
        avoidAutoClose = false;
      }
    }
    function onFocusout(evt) {
      if (handlesFocus.value === true && props4.noFocus !== true && childHasFocus(innerRef.value, evt.target) !== true) {
        focus();
      }
    }
    function onEscapeKey(evt) {
      emit("escapeKey");
      hide(evt);
    }
    function updatePosition() {
      setPosition({
        targetEl: innerRef.value,
        offset: props4.offset,
        anchorEl: anchorEl.value,
        anchorOrigin: anchorOrigin.value,
        selfOrigin: selfOrigin.value,
        absoluteOffset,
        fit: props4.fit,
        cover: props4.cover,
        maxHeight: props4.maxHeight,
        maxWidth: props4.maxWidth
      });
    }
    function renderPortalContent() {
      return h(
        Transition,
        transitionProps.value,
        () => showing.value === true ? h("div", {
          role: "menu",
          ...attrs,
          ref: innerRef,
          tabindex: -1,
          class: [
            "q-menu q-position-engine scroll" + menuClass.value,
            attrs.class
          ],
          style: [
            attrs.style,
            transitionStyle.value
          ],
          ...onEvents.value
        }, hSlot(slots.default)) : null
      );
    }
    onBeforeUnmount(anchorCleanup);
    Object.assign(proxy, { focus, updatePosition });
    return renderPortal;
  }
});
var buf;
var bufIdx = 0;
var hexBytes = new Array(256);
for (let i2 = 0; i2 < 256; i2++) {
  hexBytes[i2] = (i2 + 256).toString(16).substring(1);
}
var randomBytes = (() => {
  const lib2 = typeof crypto !== "undefined" ? crypto : typeof window !== "undefined" ? window.crypto || window.msCrypto : void 0;
  if (lib2 !== void 0) {
    if (lib2.randomBytes !== void 0) {
      return lib2.randomBytes;
    }
    if (lib2.getRandomValues !== void 0) {
      return (n) => {
        const bytes = new Uint8Array(n);
        lib2.getRandomValues(bytes);
        return bytes;
      };
    }
  }
  return (n) => {
    const r = [];
    for (let i2 = n; i2 > 0; i2--) {
      r.push(Math.floor(Math.random() * 256));
    }
    return r;
  };
})();
var BUFFER_SIZE = 4096;
function uid_default() {
  if (buf === void 0 || bufIdx + 16 > BUFFER_SIZE) {
    bufIdx = 0;
    buf = randomBytes(BUFFER_SIZE);
  }
  const b2 = Array.prototype.slice.call(buf, bufIdx, bufIdx += 16);
  b2[6] = b2[6] & 15 | 64;
  b2[8] = b2[8] & 63 | 128;
  return hexBytes[b2[0]] + hexBytes[b2[1]] + hexBytes[b2[2]] + hexBytes[b2[3]] + "-" + hexBytes[b2[4]] + hexBytes[b2[5]] + "-" + hexBytes[b2[6]] + hexBytes[b2[7]] + "-" + hexBytes[b2[8]] + hexBytes[b2[9]] + "-" + hexBytes[b2[10]] + hexBytes[b2[11]] + hexBytes[b2[12]] + hexBytes[b2[13]] + hexBytes[b2[14]] + hexBytes[b2[15]];
}
function parseValue(val) {
  return val === void 0 || val === null ? null : val;
}
function getId(val, required) {
  return val === void 0 || val === null ? required === true ? `f_${uid_default()}` : null : val;
}
function use_id_default({ getValue, required = true } = {}) {
  if (isRuntimeSsrPreHydration.value === true) {
    const id3 = getValue !== void 0 ? ref$1(parseValue(getValue())) : ref$1(null);
    if (required === true && id3.value === null) {
      onMounted(() => {
        id3.value = `f_${uid_default()}`;
      });
    }
    if (getValue !== void 0) {
      watch(getValue, (newId) => {
        id3.value = getId(newId, required);
      });
    }
    return id3;
  }
  return getValue !== void 0 ? computed(() => getId(getValue(), required)) : ref$1(`f_${uid_default()}`);
}
var btnPropsList = Object.keys(nonRoundBtnProps);
function passBtnProps(props4) {
  return btnPropsList.reduce((acc, key) => {
    const val = props4[key];
    if (val !== void 0) {
      acc[key] = val;
    }
    return acc;
  }, {});
}
var QBtnDropdown_default = createComponent({
  name: "QBtnDropdown",
  props: {
    ...nonRoundBtnProps,
    ...useTransitionProps,
    modelValue: Boolean,
    split: Boolean,
    dropdownIcon: String,
    contentClass: [Array, String, Object],
    contentStyle: [Array, String, Object],
    cover: Boolean,
    persistent: Boolean,
    noRouteDismiss: Boolean,
    autoClose: Boolean,
    menuAnchor: {
      type: String,
      default: "bottom end"
    },
    menuSelf: {
      type: String,
      default: "top end"
    },
    menuOffset: Array,
    disableMainBtn: Boolean,
    disableDropdown: Boolean,
    noIconAnimation: Boolean,
    toggleAriaLabel: String
  },
  emits: ["update:modelValue", "click", "beforeShow", "show", "beforeHide", "hide"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const showing = ref$1(props4.modelValue);
    const menuRef = ref$1(null);
    const targetUid = use_id_default();
    const ariaAttrs = computed(() => {
      const acc = {
        "aria-expanded": showing.value === true ? "true" : "false",
        "aria-haspopup": "true",
        "aria-controls": targetUid.value,
        "aria-label": props4.toggleAriaLabel || proxy.$q.lang.label[showing.value === true ? "collapse" : "expand"](props4.label)
      };
      if (props4.disable === true || (props4.split === false && props4.disableMainBtn === true || props4.disableDropdown === true)) {
        acc["aria-disabled"] = "true";
      }
      return acc;
    });
    const iconClass = computed(
      () => "q-btn-dropdown__arrow" + (showing.value === true && props4.noIconAnimation === false ? " rotate-180" : "") + (props4.split === false ? " q-btn-dropdown__arrow-container" : "")
    );
    const btnDesignAttr = computed(() => getBtnDesignAttr(props4));
    const btnProps = computed(() => passBtnProps(props4));
    watch(() => props4.modelValue, (val) => {
      menuRef.value !== null && menuRef.value[val ? "show" : "hide"]();
    });
    watch(() => props4.split, hide);
    function onBeforeShow(e2) {
      showing.value = true;
      emit("beforeShow", e2);
    }
    function onShow(e2) {
      emit("show", e2);
      emit("update:modelValue", true);
    }
    function onBeforeHide(e2) {
      showing.value = false;
      emit("beforeHide", e2);
    }
    function onHide(e2) {
      emit("hide", e2);
      emit("update:modelValue", false);
    }
    function onClick(e2) {
      emit("click", e2);
    }
    function onClickHide(e2) {
      stop(e2);
      hide();
      emit("click", e2);
    }
    function toggle(evt) {
      menuRef.value !== null && menuRef.value.toggle(evt);
    }
    function show(evt) {
      menuRef.value !== null && menuRef.value.show(evt);
    }
    function hide(evt) {
      menuRef.value !== null && menuRef.value.hide(evt);
    }
    Object.assign(proxy, {
      show,
      hide,
      toggle
    });
    onMounted(() => {
      props4.modelValue === true && show();
    });
    return () => {
      const Arrow = [
        h(QIcon_default, {
          class: iconClass.value,
          name: props4.dropdownIcon || proxy.$q.iconSet.arrow.dropdown
        })
      ];
      props4.disableDropdown !== true && Arrow.push(
        h(QMenu_default, {
          ref: menuRef,
          id: targetUid.value,
          class: props4.contentClass,
          style: props4.contentStyle,
          cover: props4.cover,
          fit: true,
          persistent: props4.persistent,
          noRouteDismiss: props4.noRouteDismiss,
          autoClose: props4.autoClose,
          anchor: props4.menuAnchor,
          self: props4.menuSelf,
          offset: props4.menuOffset,
          separateClosePopup: true,
          transitionShow: props4.transitionShow,
          transitionHide: props4.transitionHide,
          transitionDuration: props4.transitionDuration,
          onBeforeShow,
          onShow,
          onBeforeHide,
          onHide
        }, slots.default)
      );
      if (props4.split === false) {
        return h(QBtn_default, {
          class: "q-btn-dropdown q-btn-dropdown--simple",
          ...btnProps.value,
          ...ariaAttrs.value,
          disable: props4.disable === true || props4.disableMainBtn === true,
          noWrap: true,
          round: false,
          onClick
        }, {
          default: () => hSlot(slots.label, []).concat(Arrow),
          loading: slots.loading
        });
      }
      return h(QBtnGroup_default, {
        class: "q-btn-dropdown q-btn-dropdown--split no-wrap q-btn-item",
        rounded: props4.rounded,
        square: props4.square,
        ...btnDesignAttr.value,
        glossy: props4.glossy,
        stretch: props4.stretch
      }, () => [
        h(QBtn_default, {
          class: "q-btn-dropdown--current",
          ...btnProps.value,
          disable: props4.disable === true || props4.disableMainBtn === true,
          noWrap: true,
          round: false,
          onClick: onClickHide
        }, {
          default: slots.label,
          loading: slots.loading
        }),
        h(QBtn_default, {
          class: "q-btn-dropdown__arrow-container q-anchor--skip",
          ...ariaAttrs.value,
          ...btnDesignAttr.value,
          disable: props4.disable === true || props4.disableDropdown === true,
          rounded: props4.rounded,
          color: props4.color,
          textColor: props4.textColor,
          dense: props4.dense,
          size: props4.size,
          padding: props4.padding,
          ripple: props4.ripple
        }, () => Arrow)
      ]);
    };
  }
});
var useFormProps = {
  name: String
};
function useFormAttrs(props4) {
  return computed(() => ({
    type: "hidden",
    name: props4.name,
    value: props4.modelValue
  }));
}
function useFormInject(formAttrs = {}) {
  return (child, action, className) => {
    child[action](
      h("input", {
        class: "hidden" + (className || ""),
        ...formAttrs.value
      })
    );
  };
}
function useFormInputNameAttr(props4) {
  return computed(() => props4.name || props4.for);
}
createComponent({
  name: "QBtnToggle",
  props: {
    ...useFormProps,
    modelValue: {
      required: true
    },
    options: {
      type: Array,
      required: true,
      validator: (v) => v.every(
        (opt) => ("label" in opt || "icon" in opt || "slot" in opt) && "value" in opt
      )
    },
    // To avoid seeing the active raise shadow through
    // the transparent button, give it a color (even white)
    color: String,
    textColor: String,
    toggleColor: {
      type: String,
      default: "primary"
    },
    toggleTextColor: String,
    outline: Boolean,
    flat: Boolean,
    unelevated: Boolean,
    rounded: Boolean,
    push: Boolean,
    glossy: Boolean,
    size: String,
    padding: String,
    noCaps: Boolean,
    noWrap: Boolean,
    dense: Boolean,
    readonly: Boolean,
    disable: Boolean,
    stack: Boolean,
    stretch: Boolean,
    spread: Boolean,
    clearable: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },
  emits: ["update:modelValue", "clear", "click"],
  setup(props4, { slots, emit }) {
    const hasActiveValue = computed(
      () => props4.options.find((opt) => opt.value === props4.modelValue) !== void 0
    );
    const formAttrs = computed(() => ({
      type: "hidden",
      name: props4.name,
      value: props4.modelValue
    }));
    const injectFormInput = useFormInject(formAttrs);
    const btnDesignAttr = computed(() => getBtnDesignAttr(props4));
    const btnOptionDesign = computed(() => ({
      rounded: props4.rounded,
      dense: props4.dense,
      ...btnDesignAttr.value
    }));
    const btnOptions = computed(() => props4.options.map((item, i2) => {
      const { attrs, value: value2, slot, ...opt } = item;
      return {
        slot,
        props: {
          key: i2,
          "aria-pressed": value2 === props4.modelValue ? "true" : "false",
          ...attrs,
          ...opt,
          ...btnOptionDesign.value,
          disable: props4.disable === true || opt.disable === true,
          // Options that come from the button specific options first, then from general props
          color: value2 === props4.modelValue ? mergeOpt(opt, "toggleColor") : mergeOpt(opt, "color"),
          textColor: value2 === props4.modelValue ? mergeOpt(opt, "toggleTextColor") : mergeOpt(opt, "textColor"),
          noCaps: mergeOpt(opt, "noCaps") === true,
          noWrap: mergeOpt(opt, "noWrap") === true,
          size: mergeOpt(opt, "size"),
          padding: mergeOpt(opt, "padding"),
          ripple: mergeOpt(opt, "ripple"),
          stack: mergeOpt(opt, "stack") === true,
          stretch: mergeOpt(opt, "stretch") === true,
          onClick(e2) {
            set2(value2, item, e2);
          }
        }
      };
    }));
    function set2(value2, opt, e2) {
      if (props4.readonly !== true) {
        if (props4.modelValue === value2) {
          if (props4.clearable === true) {
            emit("update:modelValue", null, null);
            emit("clear");
          }
        } else {
          emit("update:modelValue", value2, opt);
        }
        emit("click", e2);
      }
    }
    function mergeOpt(opt, key) {
      return opt[key] === void 0 ? props4[key] : opt[key];
    }
    function getContent() {
      const child = btnOptions.value.map((opt) => {
        return h(QBtn_default, opt.props, opt.slot !== void 0 ? slots[opt.slot] : void 0);
      });
      if (props4.name !== void 0 && props4.disable !== true && hasActiveValue.value === true) {
        injectFormInput(child, "push");
      }
      return hMergeSlot(slots.default, child);
    }
    return () => h(QBtnGroup_default, {
      class: "q-btn-toggle",
      ...btnDesignAttr.value,
      rounded: props4.rounded,
      stretch: props4.stretch,
      glossy: props4.glossy,
      spread: props4.spread
    }, getContent);
  }
});
var QCard_default = createComponent({
  name: "QCard",
  props: {
    ...useDarkProps,
    tag: {
      type: String,
      default: "div"
    },
    square: Boolean,
    flat: Boolean,
    bordered: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const classes = computed(
      () => "q-card" + (isDark.value === true ? " q-card--dark q-dark" : "") + (props4.bordered === true ? " q-card--bordered" : "") + (props4.square === true ? " q-card--square no-border-radius" : "") + (props4.flat === true ? " q-card--flat no-shadow" : "")
    );
    return () => h(props4.tag, { class: classes.value }, hSlot(slots.default));
  }
});
var QCardSection_default = createComponent({
  name: "QCardSection",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    horizontal: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => `q-card__section q-card__section--${props4.horizontal === true ? "horiz row no-wrap" : "vert"}`
    );
    return () => h(props4.tag, { class: classes.value }, hSlot(slots.default));
  }
});
var QCardActions_default = createComponent({
  name: "QCardActions",
  props: {
    ...useAlignProps,
    vertical: Boolean
  },
  setup(props4, { slots }) {
    const alignClass = use_align_default(props4);
    const classes = computed(
      () => `q-card__actions ${alignClass.value} q-card__actions--${props4.vertical === true ? "vert column" : "horiz row"}`
    );
    return () => h("div", { class: classes.value }, hSlot(slots.default));
  }
});
var modifiersAll = {
  left: true,
  right: true,
  up: true,
  down: true,
  horizontal: true,
  vertical: true
};
var directionList = Object.keys(modifiersAll);
modifiersAll.all = true;
function getModifierDirections(mod2) {
  const dir = {};
  for (const direction of directionList) {
    if (mod2[direction] === true) {
      dir[direction] = true;
    }
  }
  if (Object.keys(dir).length === 0) {
    return modifiersAll;
  }
  if (dir.horizontal === true) {
    dir.left = dir.right = true;
  } else if (dir.left === true && dir.right === true) {
    dir.horizontal = true;
  }
  if (dir.vertical === true) {
    dir.up = dir.down = true;
  } else if (dir.up === true && dir.down === true) {
    dir.vertical = true;
  }
  if (dir.horizontal === true && dir.vertical === true) {
    dir.all = true;
  }
  return dir;
}
var avoidNodeNamesList = ["INPUT", "TEXTAREA"];
function shouldStart(evt, ctx) {
  return ctx.event === void 0 && evt.target !== void 0 && evt.target.draggable !== true && typeof ctx.handler === "function" && avoidNodeNamesList.includes(evt.target.nodeName.toUpperCase()) === false && (evt.qClonedBy === void 0 || evt.qClonedBy.indexOf(ctx.uid) === -1);
}
function parseArg(arg) {
  const data = [0.06, 6, 50];
  if (typeof arg === "string" && arg.length) {
    arg.split(":").forEach((val, index) => {
      const v = parseFloat(val);
      v && (data[index] = v);
    });
  }
  return data;
}
var TouchSwipe_default = createDirective(
  {
    name: "touch-swipe",
    beforeMount(el, { value: value2, arg, modifiers }) {
      if (modifiers.mouse !== true && client.has.touch !== true) {
        return;
      }
      const mouseCapture = modifiers.mouseCapture === true ? "Capture" : "";
      const ctx = {
        handler: value2,
        sensitivity: parseArg(arg),
        direction: getModifierDirections(modifiers),
        noop,
        mouseStart(evt) {
          if (shouldStart(evt, ctx) && leftClick(evt)) {
            addEvt(ctx, "temp", [
              [document, "mousemove", "move", `notPassive${mouseCapture}`],
              [document, "mouseup", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt, true);
          }
        },
        touchStart(evt) {
          if (shouldStart(evt, ctx)) {
            const target2 = evt.target;
            addEvt(ctx, "temp", [
              [target2, "touchmove", "move", "notPassiveCapture"],
              [target2, "touchcancel", "end", "notPassiveCapture"],
              [target2, "touchend", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt);
          }
        },
        start(evt, mouseEvent) {
          client.is.firefox === true && preventDraggable(el, true);
          const pos = position(evt);
          ctx.event = {
            x: pos.left,
            y: pos.top,
            time: Date.now(),
            mouse: mouseEvent === true,
            dir: false
          };
        },
        move(evt) {
          if (ctx.event === void 0) {
            return;
          }
          if (ctx.event.dir !== false) {
            stopAndPrevent(evt);
            return;
          }
          const time = Date.now() - ctx.event.time;
          if (time === 0) {
            return;
          }
          const pos = position(evt), distX = pos.left - ctx.event.x, absX = Math.abs(distX), distY = pos.top - ctx.event.y, absY = Math.abs(distY);
          if (ctx.event.mouse !== true) {
            if (absX < ctx.sensitivity[1] && absY < ctx.sensitivity[1]) {
              ctx.end(evt);
              return;
            }
          } else if (window.getSelection().toString() !== "") {
            ctx.end(evt);
            return;
          } else if (absX < ctx.sensitivity[2] && absY < ctx.sensitivity[2]) {
            return;
          }
          const velX = absX / time, velY = absY / time;
          if (ctx.direction.vertical === true && absX < absY && absX < 100 && velY > ctx.sensitivity[0]) {
            ctx.event.dir = distY < 0 ? "up" : "down";
          }
          if (ctx.direction.horizontal === true && absX > absY && absY < 100 && velX > ctx.sensitivity[0]) {
            ctx.event.dir = distX < 0 ? "left" : "right";
          }
          if (ctx.direction.up === true && absX < absY && distY < 0 && absX < 100 && velY > ctx.sensitivity[0]) {
            ctx.event.dir = "up";
          }
          if (ctx.direction.down === true && absX < absY && distY > 0 && absX < 100 && velY > ctx.sensitivity[0]) {
            ctx.event.dir = "down";
          }
          if (ctx.direction.left === true && absX > absY && distX < 0 && absY < 100 && velX > ctx.sensitivity[0]) {
            ctx.event.dir = "left";
          }
          if (ctx.direction.right === true && absX > absY && distX > 0 && absY < 100 && velX > ctx.sensitivity[0]) {
            ctx.event.dir = "right";
          }
          if (ctx.event.dir !== false) {
            stopAndPrevent(evt);
            if (ctx.event.mouse === true) {
              document.body.classList.add("no-pointer-events--children");
              document.body.classList.add("non-selectable");
              clearSelection();
              ctx.styleCleanup = (withDelay) => {
                ctx.styleCleanup = void 0;
                document.body.classList.remove("non-selectable");
                const remove2 = () => {
                  document.body.classList.remove("no-pointer-events--children");
                };
                if (withDelay === true) {
                  setTimeout(remove2, 50);
                } else {
                  remove2();
                }
              };
            }
            ctx.handler({
              evt,
              touch: ctx.event.mouse !== true,
              mouse: ctx.event.mouse,
              direction: ctx.event.dir,
              duration: time,
              distance: {
                x: absX,
                y: absY
              }
            });
          } else {
            ctx.end(evt);
          }
        },
        end(evt) {
          if (ctx.event === void 0) {
            return;
          }
          cleanEvt(ctx, "temp");
          client.is.firefox === true && preventDraggable(el, false);
          ctx.styleCleanup !== void 0 && ctx.styleCleanup(true);
          evt !== void 0 && ctx.event.dir !== false && stopAndPrevent(evt);
          ctx.event = void 0;
        }
      };
      el.__qtouchswipe = ctx;
      if (modifiers.mouse === true) {
        const capture = modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : "";
        addEvt(ctx, "main", [
          [el, "mousedown", "mouseStart", `passive${capture}`]
        ]);
      }
      client.has.touch === true && addEvt(ctx, "main", [
        [el, "touchstart", "touchStart", `passive${modifiers.capture === true ? "Capture" : ""}`],
        [el, "touchmove", "noop", "notPassiveCapture"]
        // cannot be passive (ex: iOS scroll)
      ]);
    },
    updated(el, bindings) {
      const ctx = el.__qtouchswipe;
      if (ctx !== void 0) {
        if (bindings.oldValue !== bindings.value) {
          typeof bindings.value !== "function" && ctx.end();
          ctx.handler = bindings.value;
        }
        ctx.direction = getModifierDirections(bindings.modifiers);
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qtouchswipe;
      if (ctx !== void 0) {
        cleanEvt(ctx, "main");
        cleanEvt(ctx, "temp");
        client.is.firefox === true && preventDraggable(el, false);
        ctx.styleCleanup !== void 0 && ctx.styleCleanup();
        delete el.__qtouchswipe;
      }
    }
  }
);
function use_render_cache_default() {
  let cache = /* @__PURE__ */ Object.create(null);
  return {
    getCache: (key, defaultValue) => cache[key] === void 0 ? cache[key] = typeof defaultValue === "function" ? defaultValue() : defaultValue : cache[key],
    setCache(key, obj) {
      cache[key] = obj;
    },
    hasCache(key) {
      return Object.hasOwnProperty.call(cache, key);
    },
    clearCache(key) {
      if (key !== void 0) {
        delete cache[key];
      } else {
        cache = /* @__PURE__ */ Object.create(null);
      }
    }
  };
}
var usePanelChildProps = {
  name: { required: true },
  disable: Boolean
};
var PanelWrapper = {
  setup(_, { slots }) {
    return () => h("div", {
      class: "q-panel scroll",
      role: "tabpanel"
    }, hSlot(slots.default));
  }
};
var usePanelProps = {
  modelValue: {
    required: true
  },
  animated: Boolean,
  infinite: Boolean,
  swipeable: Boolean,
  vertical: Boolean,
  transitionPrev: String,
  transitionNext: String,
  transitionDuration: {
    type: [String, Number],
    default: 300
  },
  keepAlive: Boolean,
  keepAliveInclude: [String, Array, RegExp],
  keepAliveExclude: [String, Array, RegExp],
  keepAliveMax: Number
};
var usePanelEmits = ["update:modelValue", "beforeTransition", "transition"];
function use_panel_default() {
  const { props: props4, emit, proxy } = getCurrentInstance();
  const { getCache } = use_render_cache_default();
  const { registerTimeout } = use_timeout_default();
  let panels, forcedPanelTransition;
  const panelIndex = ref$1(null);
  const panelTransition = ref$1(null);
  function onSwipe(evt) {
    const dir = props4.vertical === true ? "up" : "left";
    goToPanelByOffset((proxy.$q.lang.rtl === true ? -1 : 1) * (evt.direction === dir ? 1 : -1));
  }
  const panelDirectives = computed(() => {
    return [[
      TouchSwipe_default,
      onSwipe,
      void 0,
      {
        horizontal: props4.vertical !== true,
        vertical: props4.vertical,
        mouse: true
      }
    ]];
  });
  const transitionPrev = computed(
    () => props4.transitionPrev || `slide-${props4.vertical === true ? "down" : "right"}`
  );
  const transitionNext = computed(
    () => props4.transitionNext || `slide-${props4.vertical === true ? "up" : "left"}`
  );
  const transitionStyle = computed(
    () => `--q-transition-duration: ${props4.transitionDuration}ms`
  );
  const contentKey = computed(() => typeof props4.modelValue === "string" || typeof props4.modelValue === "number" ? props4.modelValue : String(props4.modelValue));
  const keepAliveProps = computed(() => ({
    include: props4.keepAliveInclude,
    exclude: props4.keepAliveExclude,
    max: props4.keepAliveMax
  }));
  const needsUniqueKeepAliveWrapper = computed(
    () => props4.keepAliveInclude !== void 0 || props4.keepAliveExclude !== void 0
  );
  watch(() => props4.modelValue, (newVal, oldVal) => {
    const index = isValidPanelName(newVal) === true ? getPanelIndex(newVal) : -1;
    if (forcedPanelTransition !== true) {
      updatePanelTransition(
        index === -1 ? 0 : index < getPanelIndex(oldVal) ? -1 : 1
      );
    }
    if (panelIndex.value !== index) {
      panelIndex.value = index;
      emit("beforeTransition", newVal, oldVal);
      registerTimeout(() => {
        emit("transition", newVal, oldVal);
      }, props4.transitionDuration);
    }
  });
  function nextPanel() {
    goToPanelByOffset(1);
  }
  function previousPanel() {
    goToPanelByOffset(-1);
  }
  function goToPanel(name2) {
    emit("update:modelValue", name2);
  }
  function isValidPanelName(name2) {
    return name2 !== void 0 && name2 !== null && name2 !== "";
  }
  function getPanelIndex(name2) {
    return panels.findIndex((panel) => {
      return panel.props.name === name2 && panel.props.disable !== "" && panel.props.disable !== true;
    });
  }
  function getEnabledPanels() {
    return panels.filter((panel) => {
      return panel.props.disable !== "" && panel.props.disable !== true;
    });
  }
  function updatePanelTransition(direction) {
    const val = direction !== 0 && props4.animated === true && panelIndex.value !== -1 ? "q-transition--" + (direction === -1 ? transitionPrev.value : transitionNext.value) : null;
    if (panelTransition.value !== val) {
      panelTransition.value = val;
    }
  }
  function goToPanelByOffset(direction, startIndex = panelIndex.value) {
    let index = startIndex + direction;
    while (index !== -1 && index < panels.length) {
      const opt = panels[index];
      if (opt !== void 0 && opt.props.disable !== "" && opt.props.disable !== true) {
        updatePanelTransition(direction);
        forcedPanelTransition = true;
        emit("update:modelValue", opt.props.name);
        setTimeout(() => {
          forcedPanelTransition = false;
        });
        return;
      }
      index += direction;
    }
    if (props4.infinite === true && panels.length !== 0 && startIndex !== -1 && startIndex !== panels.length) {
      goToPanelByOffset(direction, direction === -1 ? panels.length : -1);
    }
  }
  function updatePanelIndex() {
    const index = getPanelIndex(props4.modelValue);
    if (panelIndex.value !== index) {
      panelIndex.value = index;
    }
    return true;
  }
  function getPanelContentChild() {
    const panel = isValidPanelName(props4.modelValue) === true && updatePanelIndex() && panels[panelIndex.value];
    return props4.keepAlive === true ? [
      h(KeepAlive, keepAliveProps.value, [
        h(
          needsUniqueKeepAliveWrapper.value === true ? getCache(contentKey.value, () => ({ ...PanelWrapper, name: contentKey.value })) : PanelWrapper,
          { key: contentKey.value, style: transitionStyle.value },
          () => panel
        )
      ])
    ] : [
      h("div", {
        class: "q-panel scroll",
        style: transitionStyle.value,
        key: contentKey.value,
        role: "tabpanel"
      }, [panel])
    ];
  }
  function getPanelContent() {
    if (panels.length === 0) {
      return;
    }
    return props4.animated === true ? [h(Transition, { name: panelTransition.value }, getPanelContentChild)] : getPanelContentChild();
  }
  function updatePanelsList(slots) {
    panels = getNormalizedVNodes(
      hSlot(slots.default, [])
    ).filter(
      (panel) => panel.props !== null && panel.props.slot === void 0 && isValidPanelName(panel.props.name) === true
    );
    return panels.length;
  }
  function getPanels() {
    return panels;
  }
  Object.assign(proxy, {
    next: nextPanel,
    previous: previousPanel,
    goTo: goToPanel
  });
  return {
    panelIndex,
    panelDirectives,
    updatePanelsList,
    updatePanelIndex,
    getPanelContent,
    getEnabledPanels,
    getPanels,
    isValidPanelName,
    keepAliveProps,
    needsUniqueKeepAliveWrapper,
    goToPanelByOffset,
    goToPanel,
    nextPanel,
    previousPanel
  };
}
var counter = 0;
var useFullscreenProps = {
  fullscreen: Boolean,
  noRouteFullscreenExit: Boolean
};
var useFullscreenEmits = ["update:fullscreen", "fullscreen"];
function use_fullscreen_default() {
  const vm2 = getCurrentInstance();
  const { props: props4, emit, proxy } = vm2;
  let fullscreenFillerNode, container;
  const inFullscreen = ref$1(false);
  vmHasRouter(vm2) === true && watch(() => proxy.$route.fullPath, () => {
    props4.noRouteFullscreenExit !== true && exitFullscreen();
  });
  watch(() => props4.fullscreen, (v) => {
    if (inFullscreen.value !== v) {
      toggleFullscreen();
    }
  });
  watch(inFullscreen, (v) => {
    emit("update:fullscreen", v);
    emit("fullscreen", v);
  });
  function toggleFullscreen() {
    if (inFullscreen.value === true) {
      exitFullscreen();
    } else {
      setFullscreen();
    }
  }
  function setFullscreen() {
    if (inFullscreen.value === true) {
      return;
    }
    inFullscreen.value = true;
    container = proxy.$el.parentNode;
    container.replaceChild(fullscreenFillerNode, proxy.$el);
    document.body.appendChild(proxy.$el);
    counter++;
    if (counter === 1) {
      document.body.classList.add("q-body--fullscreen-mixin");
    }
  }
  function exitFullscreen() {
    if (inFullscreen.value !== true) {
      return;
    }
    container.replaceChild(proxy.$el, fullscreenFillerNode);
    inFullscreen.value = false;
    counter = Math.max(0, counter - 1);
    if (counter === 0) {
      document.body.classList.remove("q-body--fullscreen-mixin");
      if (proxy.$el.scrollIntoView !== void 0) {
        setTimeout(() => {
          proxy.$el.scrollIntoView();
        });
      }
    }
  }
  onBeforeMount(() => {
    fullscreenFillerNode = document.createElement("span");
  });
  onMounted(() => {
    props4.fullscreen === true && setFullscreen();
  });
  onBeforeUnmount(exitFullscreen);
  Object.assign(proxy, {
    toggleFullscreen,
    setFullscreen,
    exitFullscreen
  });
  return {
    inFullscreen,
    toggleFullscreen
  };
}
var navigationPositionOptions = ["top", "right", "bottom", "left"];
var controlTypeOptions = ["regular", "flat", "outline", "push", "unelevated"];
createComponent({
  name: "QCarousel",
  props: {
    ...useDarkProps,
    ...usePanelProps,
    ...useFullscreenProps,
    transitionPrev: {
      // usePanelParentProps override
      type: String,
      default: "fade"
    },
    transitionNext: {
      // usePanelParentProps override
      type: String,
      default: "fade"
    },
    height: String,
    padding: Boolean,
    controlColor: String,
    controlTextColor: String,
    controlType: {
      type: String,
      validator: (v) => controlTypeOptions.includes(v),
      default: "flat"
    },
    autoplay: [Number, Boolean],
    arrows: Boolean,
    prevIcon: String,
    nextIcon: String,
    navigation: Boolean,
    navigationPosition: {
      type: String,
      validator: (v) => navigationPositionOptions.includes(v)
    },
    navigationIcon: String,
    navigationActiveIcon: String,
    thumbnails: Boolean
  },
  emits: [
    ...useFullscreenEmits,
    ...usePanelEmits
  ],
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    let timer2 = null, panelsLen;
    const {
      updatePanelsList,
      getPanelContent,
      panelDirectives,
      goToPanel,
      previousPanel,
      nextPanel,
      getEnabledPanels,
      panelIndex
    } = use_panel_default();
    const { inFullscreen } = use_fullscreen_default();
    const style2 = computed(() => inFullscreen.value !== true && props4.height !== void 0 ? { height: props4.height } : {});
    const direction = computed(() => props4.vertical === true ? "vertical" : "horizontal");
    const navigationPosition = computed(
      () => props4.navigationPosition || (props4.vertical === true ? "right" : "bottom")
    );
    const classes = computed(
      () => `q-carousel q-panel-parent q-carousel--with${props4.padding === true ? "" : "out"}-padding` + (inFullscreen.value === true ? " fullscreen" : "") + (isDark.value === true ? " q-carousel--dark q-dark" : "") + (props4.arrows === true ? ` q-carousel--arrows-${direction.value}` : "") + (props4.navigation === true ? ` q-carousel--navigation-${navigationPosition.value}` : "")
    );
    const arrowIcons = computed(() => {
      const ico = [
        props4.prevIcon || $q.iconSet.carousel[props4.vertical === true ? "up" : "left"],
        props4.nextIcon || $q.iconSet.carousel[props4.vertical === true ? "down" : "right"]
      ];
      return props4.vertical === false && $q.lang.rtl === true ? ico.reverse() : ico;
    });
    const navIcon = computed(() => props4.navigationIcon || $q.iconSet.carousel.navigationIcon);
    const navActiveIcon = computed(() => props4.navigationActiveIcon || navIcon.value);
    const controlProps = computed(() => ({
      color: props4.controlColor,
      textColor: props4.controlTextColor,
      round: true,
      [props4.controlType]: true,
      dense: true
    }));
    watch(() => props4.modelValue, () => {
      if (props4.autoplay) {
        startTimer();
      }
    });
    watch(() => props4.autoplay, (val) => {
      if (val) {
        startTimer();
      } else if (timer2 !== null) {
        clearTimeout(timer2);
        timer2 = null;
      }
    });
    function startTimer() {
      const duration2 = isNumber$1(props4.autoplay) === true ? Math.abs(props4.autoplay) : 5e3;
      timer2 !== null && clearTimeout(timer2);
      timer2 = setTimeout(() => {
        timer2 = null;
        if (duration2 >= 0) {
          nextPanel();
        } else {
          previousPanel();
        }
      }, duration2);
    }
    onMounted(() => {
      props4.autoplay && startTimer();
    });
    onBeforeUnmount(() => {
      timer2 !== null && clearTimeout(timer2);
    });
    function getNavigationContainer(type2, mapping) {
      return h("div", {
        class: `q-carousel__control q-carousel__navigation no-wrap absolute flex q-carousel__navigation--${type2} q-carousel__navigation--${navigationPosition.value}` + (props4.controlColor !== void 0 ? ` text-${props4.controlColor}` : "")
      }, [
        h("div", {
          class: "q-carousel__navigation-inner flex flex-center no-wrap"
        }, getEnabledPanels().map(mapping))
      ]);
    }
    function getContent() {
      const node = [];
      if (props4.navigation === true) {
        const fn = slots["navigation-icon"] !== void 0 ? slots["navigation-icon"] : (opts) => h(QBtn_default, {
          key: "nav" + opts.name,
          class: `q-carousel__navigation-icon q-carousel__navigation-icon--${opts.active === true ? "" : "in"}active`,
          ...opts.btnProps,
          onClick: opts.onClick
        });
        const maxIndex = panelsLen - 1;
        node.push(
          getNavigationContainer("buttons", (panel, index) => {
            const name2 = panel.props.name;
            const active = panelIndex.value === index;
            return fn({
              index,
              maxIndex,
              name: name2,
              active,
              btnProps: {
                icon: active === true ? navActiveIcon.value : navIcon.value,
                size: "sm",
                ...controlProps.value
              },
              onClick: () => {
                goToPanel(name2);
              }
            });
          })
        );
      } else if (props4.thumbnails === true) {
        const color = props4.controlColor !== void 0 ? ` text-${props4.controlColor}` : "";
        node.push(getNavigationContainer("thumbnails", (panel) => {
          const slide = panel.props;
          return h("img", {
            key: "tmb#" + slide.name,
            class: `q-carousel__thumbnail q-carousel__thumbnail--${slide.name === props4.modelValue ? "" : "in"}active` + color,
            src: slide.imgSrc || slide["img-src"],
            onClick: () => {
              goToPanel(slide.name);
            }
          });
        }));
      }
      if (props4.arrows === true && panelIndex.value >= 0) {
        if (props4.infinite === true || panelIndex.value > 0) {
          node.push(
            h("div", {
              key: "prev",
              class: `q-carousel__control q-carousel__arrow q-carousel__prev-arrow q-carousel__prev-arrow--${direction.value} absolute flex flex-center`
            }, [
              h(QBtn_default, {
                icon: arrowIcons.value[0],
                ...controlProps.value,
                onClick: previousPanel
              })
            ])
          );
        }
        if (props4.infinite === true || panelIndex.value < panelsLen - 1) {
          node.push(
            h("div", {
              key: "next",
              class: `q-carousel__control q-carousel__arrow q-carousel__next-arrow q-carousel__next-arrow--${direction.value} absolute flex flex-center`
            }, [
              h(QBtn_default, {
                icon: arrowIcons.value[1],
                ...controlProps.value,
                onClick: nextPanel
              })
            ])
          );
        }
      }
      return hMergeSlot(slots.control, node);
    }
    return () => {
      panelsLen = updatePanelsList(slots);
      return h("div", {
        class: classes.value,
        style: style2.value
      }, [
        hDir(
          "div",
          { class: "q-carousel__slides-container" },
          getPanelContent(),
          "sl-cont",
          props4.swipeable,
          () => panelDirectives.value
        )
      ].concat(getContent()));
    };
  }
});
createComponent({
  name: "QCarouselSlide",
  props: {
    ...usePanelChildProps,
    imgSrc: String
  },
  setup(props4, { slots }) {
    const style2 = computed(() => props4.imgSrc ? { backgroundImage: `url("${props4.imgSrc}")` } : {});
    return () => h("div", {
      class: "q-carousel__slide",
      style: style2.value
    }, hSlot(slots.default));
  }
});
createComponent({
  name: "QCarouselControl",
  props: {
    position: {
      type: String,
      default: "bottom-right",
      validator: (v) => [
        "top-right",
        "top-left",
        "bottom-right",
        "bottom-left",
        "top",
        "right",
        "bottom",
        "left"
      ].includes(v)
    },
    offset: {
      type: Array,
      default: () => [18, 18],
      validator: (v) => v.length === 2
    }
  },
  setup(props4, { slots }) {
    const classes = computed(() => `q-carousel__control absolute absolute-${props4.position}`);
    const style2 = computed(() => ({
      margin: `${props4.offset[1]}px ${props4.offset[0]}px`
    }));
    return () => h("div", {
      class: classes.value,
      style: style2.value
    }, hSlot(slots.default));
  }
});
createComponent({
  name: "QChatMessage",
  props: {
    sent: Boolean,
    label: String,
    bgColor: String,
    textColor: String,
    name: String,
    avatar: String,
    text: Array,
    stamp: String,
    size: String,
    labelHtml: Boolean,
    nameHtml: Boolean,
    textHtml: Boolean,
    stampHtml: Boolean
  },
  setup(props4, { slots }) {
    const op = computed(() => props4.sent === true ? "sent" : "received");
    const textClass = computed(
      () => `q-message-text-content q-message-text-content--${op.value}` + (props4.textColor !== void 0 ? ` text-${props4.textColor}` : "")
    );
    const messageClass = computed(
      () => `q-message-text q-message-text--${op.value}` + (props4.bgColor !== void 0 ? ` text-${props4.bgColor}` : "")
    );
    const containerClass = computed(
      () => "q-message-container row items-end no-wrap" + (props4.sent === true ? " reverse" : "")
    );
    const sizeClass = computed(() => props4.size !== void 0 ? `col-${props4.size}` : "");
    const domProps = computed(() => ({
      msg: props4.textHtml === true ? "innerHTML" : "textContent",
      stamp: props4.stampHtml === true ? "innerHTML" : "textContent",
      name: props4.nameHtml === true ? "innerHTML" : "textContent",
      label: props4.labelHtml === true ? "innerHTML" : "textContent"
    }));
    function wrapStamp(node) {
      if (slots.stamp !== void 0) {
        return [node, h("div", { class: "q-message-stamp" }, slots.stamp())];
      }
      if (props4.stamp) {
        return [
          node,
          h("div", {
            class: "q-message-stamp",
            [domProps.value.stamp]: props4.stamp
          })
        ];
      }
      return [node];
    }
    function getText(contentList, withSlots) {
      const content = withSlots === true ? contentList.length > 1 ? (text) => text : (text) => h("div", [text]) : (text) => h("div", { [domProps.value.msg]: text });
      return contentList.map((msg, index) => h("div", {
        key: index,
        class: messageClass.value
      }, [
        h("div", { class: textClass.value }, wrapStamp(content(msg)))
      ]));
    }
    return () => {
      const container = [];
      if (slots.avatar !== void 0) {
        container.push(slots.avatar());
      } else if (props4.avatar !== void 0) {
        container.push(
          h("img", {
            class: `q-message-avatar q-message-avatar--${op.value}`,
            src: props4.avatar,
            "aria-hidden": "true"
          })
        );
      }
      const msg = [];
      if (slots.name !== void 0) {
        msg.push(
          h("div", { class: `q-message-name q-message-name--${op.value}` }, slots.name())
        );
      } else if (props4.name !== void 0) {
        msg.push(
          h("div", {
            class: `q-message-name q-message-name--${op.value}`,
            [domProps.value.name]: props4.name
          })
        );
      }
      if (slots.default !== void 0) {
        msg.push(
          getText(
            getNormalizedVNodes(slots.default()),
            true
          )
        );
      } else if (props4.text !== void 0) {
        msg.push(getText(props4.text));
      }
      container.push(
        h("div", { class: sizeClass.value }, msg)
      );
      const child = [];
      if (slots.label !== void 0) {
        child.push(
          h("div", { class: "q-message-label" }, slots.label())
        );
      } else if (props4.label !== void 0) {
        child.push(
          h("div", {
            class: "q-message-label",
            [domProps.value.label]: props4.label
          })
        );
      }
      child.push(
        h("div", { class: containerClass.value }, container)
      );
      return h("div", {
        class: `q-message q-message-${op.value}`
      }, child);
    };
  }
});
function use_refocus_target_default(props4, rootRef) {
  const refocusRef = ref$1(null);
  const refocusTargetEl = computed(() => {
    if (props4.disable === true) {
      return null;
    }
    return h("span", {
      ref: refocusRef,
      class: "no-outline",
      tabindex: -1
    });
  });
  function refocusTarget(e2) {
    const root = rootRef.value;
    if (e2 !== void 0 && e2.type.indexOf("key") === 0) {
      if (root !== null && document.activeElement !== root && root.contains(document.activeElement) === true) {
        root.focus();
      }
    } else if (refocusRef.value !== null && (e2 === void 0 || root !== null && root.contains(e2.target) === true)) {
      refocusRef.value.focus();
    }
  }
  return {
    refocusTargetEl,
    refocusTarget
  };
}
var option_sizes_default = {
  xs: 30,
  sm: 35,
  md: 40,
  lg: 50,
  xl: 60
};
var useCheckboxProps = {
  ...useDarkProps,
  ...useSizeProps,
  ...useFormProps,
  modelValue: {
    required: true,
    default: null
  },
  val: {},
  trueValue: { default: true },
  falseValue: { default: false },
  indeterminateValue: { default: null },
  checkedIcon: String,
  uncheckedIcon: String,
  indeterminateIcon: String,
  toggleOrder: {
    type: String,
    validator: (v) => v === "tf" || v === "ft"
  },
  toggleIndeterminate: Boolean,
  label: String,
  leftLabel: Boolean,
  color: String,
  keepColor: Boolean,
  dense: Boolean,
  disable: Boolean,
  tabindex: [String, Number]
};
var useCheckboxEmits = ["update:modelValue"];
function use_checkbox_default(type2, getInner) {
  const { props: props4, slots, emit, proxy } = getCurrentInstance();
  const { $q } = proxy;
  const isDark = use_dark_default(props4, $q);
  const rootRef = ref$1(null);
  const { refocusTargetEl, refocusTarget } = use_refocus_target_default(props4, rootRef);
  const sizeStyle = use_size_default(props4, option_sizes_default);
  const modelIsArray = computed(
    () => props4.val !== void 0 && Array.isArray(props4.modelValue)
  );
  const index = computed(() => {
    const val = toRaw(props4.val);
    return modelIsArray.value === true ? props4.modelValue.findIndex((opt) => toRaw(opt) === val) : -1;
  });
  const isTrue = computed(() => modelIsArray.value === true ? index.value !== -1 : toRaw(props4.modelValue) === toRaw(props4.trueValue));
  const isFalse = computed(() => modelIsArray.value === true ? index.value === -1 : toRaw(props4.modelValue) === toRaw(props4.falseValue));
  const isIndeterminate = computed(
    () => isTrue.value === false && isFalse.value === false
  );
  const tabindex = computed(() => props4.disable === true ? -1 : props4.tabindex || 0);
  const classes = computed(
    () => `q-${type2} cursor-pointer no-outline row inline no-wrap items-center` + (props4.disable === true ? " disabled" : "") + (isDark.value === true ? ` q-${type2}--dark` : "") + (props4.dense === true ? ` q-${type2}--dense` : "") + (props4.leftLabel === true ? " reverse" : "")
  );
  const innerClass = computed(() => {
    const state2 = isTrue.value === true ? "truthy" : isFalse.value === true ? "falsy" : "indet";
    const color = props4.color !== void 0 && (props4.keepColor === true || (type2 === "toggle" ? isTrue.value === true : isFalse.value !== true)) ? ` text-${props4.color}` : "";
    return `q-${type2}__inner relative-position non-selectable q-${type2}__inner--${state2}${color}`;
  });
  const formAttrs = computed(() => {
    const prop = { type: "checkbox" };
    props4.name !== void 0 && Object.assign(prop, {
      // see https://vuejs.org/guide/extras/render-function.html#creating-vnodes (.prop)
      ".checked": isTrue.value,
      "^checked": isTrue.value === true ? "checked" : void 0,
      name: props4.name,
      value: modelIsArray.value === true ? props4.val : props4.trueValue
    });
    return prop;
  });
  const injectFormInput = useFormInject(formAttrs);
  const attributes = computed(() => {
    const attrs = {
      tabindex: tabindex.value,
      role: type2 === "toggle" ? "switch" : "checkbox",
      "aria-label": props4.label,
      "aria-checked": isIndeterminate.value === true ? "mixed" : isTrue.value === true ? "true" : "false"
    };
    if (props4.disable === true) {
      attrs["aria-disabled"] = "true";
    }
    return attrs;
  });
  function onClick(e2) {
    if (e2 !== void 0) {
      stopAndPrevent(e2);
      refocusTarget(e2);
    }
    if (props4.disable !== true) {
      emit("update:modelValue", getNextValue(), e2);
    }
  }
  function getNextValue() {
    if (modelIsArray.value === true) {
      if (isTrue.value === true) {
        const val = props4.modelValue.slice();
        val.splice(index.value, 1);
        return val;
      }
      return props4.modelValue.concat([props4.val]);
    }
    if (isTrue.value === true) {
      if (props4.toggleOrder !== "ft" || props4.toggleIndeterminate === false) {
        return props4.falseValue;
      }
    } else if (isFalse.value === true) {
      if (props4.toggleOrder === "ft" || props4.toggleIndeterminate === false) {
        return props4.trueValue;
      }
    } else {
      return props4.toggleOrder !== "ft" ? props4.trueValue : props4.falseValue;
    }
    return props4.indeterminateValue;
  }
  function onKeydown2(e2) {
    if (e2.keyCode === 13 || e2.keyCode === 32) {
      stopAndPrevent(e2);
    }
  }
  function onKeyup2(e2) {
    if (e2.keyCode === 13 || e2.keyCode === 32) {
      onClick(e2);
    }
  }
  const getInnerContent = getInner(isTrue, isIndeterminate);
  Object.assign(proxy, { toggle: onClick });
  return () => {
    const inner = getInnerContent();
    props4.disable !== true && injectFormInput(
      inner,
      "unshift",
      ` q-${type2}__native absolute q-ma-none q-pa-none`
    );
    const child = [
      h("div", {
        class: innerClass.value,
        style: sizeStyle.value,
        "aria-hidden": "true"
      }, inner)
    ];
    if (refocusTargetEl.value !== null) {
      child.push(refocusTargetEl.value);
    }
    const label = props4.label !== void 0 ? hMergeSlot(slots.default, [props4.label]) : hSlot(slots.default);
    label !== void 0 && child.push(
      h("div", {
        class: `q-${type2}__label q-anchor--skip`
      }, label)
    );
    return h("div", {
      ref: rootRef,
      class: classes.value,
      ...attributes.value,
      onClick,
      onKeydown: onKeydown2,
      onKeyup: onKeyup2
    }, child);
  };
}
var createBgNode = () => h("div", {
  key: "svg",
  class: "q-checkbox__bg absolute"
}, [
  h("svg", {
    class: "q-checkbox__svg fit absolute-full",
    viewBox: "0 0 24 24"
  }, [
    h("path", {
      class: "q-checkbox__truthy",
      fill: "none",
      d: "M1.73,12.91 8.1,19.28 22.79,4.59"
    }),
    h("path", {
      class: "q-checkbox__indet",
      d: "M4,14H20V10H4"
    })
  ])
]);
var QCheckbox_default = createComponent({
  name: "QCheckbox",
  props: useCheckboxProps,
  emits: useCheckboxEmits,
  setup(props4) {
    const bgNode = createBgNode();
    function getInner(isTrue, isIndeterminate) {
      const icon = computed(
        () => (isTrue.value === true ? props4.checkedIcon : isIndeterminate.value === true ? props4.indeterminateIcon : props4.uncheckedIcon) || null
      );
      return () => icon.value !== null ? [
        h("div", {
          key: "icon",
          class: "q-checkbox__icon-container absolute-full flex flex-center no-wrap"
        }, [
          h(QIcon_default, {
            class: "q-checkbox__icon",
            name: icon.value
          })
        ])
      ] : [bgNode];
    }
    return use_checkbox_default("checkbox", getInner);
  }
});
var defaultSizes2 = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 20,
  xl: 24
};
var QChip_default = createComponent({
  name: "QChip",
  props: {
    ...useDarkProps,
    ...useSizeProps,
    dense: Boolean,
    icon: String,
    iconRight: String,
    iconRemove: String,
    iconSelected: String,
    label: [String, Number],
    color: String,
    textColor: String,
    modelValue: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: null
    },
    square: Boolean,
    outline: Boolean,
    clickable: Boolean,
    removable: Boolean,
    removeAriaLabel: String,
    tabindex: [String, Number],
    disable: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },
  emits: ["update:modelValue", "update:selected", "remove", "click"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const sizeStyle = use_size_default(props4, defaultSizes2);
    const hasLeftIcon = computed(() => props4.selected === true || props4.icon !== void 0);
    const leftIcon = computed(() => props4.selected === true ? props4.iconSelected || $q.iconSet.chip.selected : props4.icon);
    const removeIcon = computed(() => props4.iconRemove || $q.iconSet.chip.remove);
    const isClickable = computed(
      () => props4.disable === false && (props4.clickable === true || props4.selected !== null)
    );
    const classes = computed(() => {
      const text = props4.outline === true ? props4.color || props4.textColor : props4.textColor;
      return "q-chip row inline no-wrap items-center" + (props4.outline === false && props4.color !== void 0 ? ` bg-${props4.color}` : "") + (text ? ` text-${text} q-chip--colored` : "") + (props4.disable === true ? " disabled" : "") + (props4.dense === true ? " q-chip--dense" : "") + (props4.outline === true ? " q-chip--outline" : "") + (props4.selected === true ? " q-chip--selected" : "") + (isClickable.value === true ? " q-chip--clickable cursor-pointer non-selectable q-hoverable" : "") + (props4.square === true ? " q-chip--square" : "") + (isDark.value === true ? " q-chip--dark q-dark" : "");
    });
    const attributes = computed(() => {
      const chip = props4.disable === true ? { tabindex: -1, "aria-disabled": "true" } : { tabindex: props4.tabindex || 0 };
      const remove2 = {
        ...chip,
        role: "button",
        "aria-hidden": "false",
        "aria-label": props4.removeAriaLabel || $q.lang.label.remove
      };
      return { chip, remove: remove2 };
    });
    function onKeyup2(e2) {
      e2.keyCode === 13 && onClick(e2);
    }
    function onClick(e2) {
      if (!props4.disable) {
        emit("update:selected", !props4.selected);
        emit("click", e2);
      }
    }
    function onRemove(e2) {
      if (e2.keyCode === void 0 || e2.keyCode === 13) {
        stopAndPrevent(e2);
        if (props4.disable === false) {
          emit("update:modelValue", false);
          emit("remove");
        }
      }
    }
    function getContent() {
      const child = [];
      isClickable.value === true && child.push(
        h("div", { class: "q-focus-helper" })
      );
      hasLeftIcon.value === true && child.push(
        h(QIcon_default, {
          class: "q-chip__icon q-chip__icon--left",
          name: leftIcon.value
        })
      );
      const label = props4.label !== void 0 ? [h("div", { class: "ellipsis" }, [props4.label])] : void 0;
      child.push(
        h("div", {
          class: "q-chip__content col row no-wrap items-center q-anchor--skip"
        }, hMergeSlotSafely(slots.default, label))
      );
      props4.iconRight && child.push(
        h(QIcon_default, {
          class: "q-chip__icon q-chip__icon--right",
          name: props4.iconRight
        })
      );
      props4.removable === true && child.push(
        h(QIcon_default, {
          class: "q-chip__icon q-chip__icon--remove cursor-pointer",
          name: removeIcon.value,
          ...attributes.value.remove,
          onClick: onRemove,
          onKeyup: onRemove
        })
      );
      return child;
    }
    return () => {
      if (props4.modelValue === false) return;
      const data = {
        class: classes.value,
        style: sizeStyle.value
      };
      isClickable.value === true && Object.assign(
        data,
        attributes.value.chip,
        { onClick, onKeyup: onKeyup2 }
      );
      return hDir(
        "div",
        data,
        getContent(),
        "ripple",
        props4.ripple !== false && props4.disable !== true,
        () => [[Ripple_default, props4.ripple]]
      );
    };
  }
});
var useCircularCommonProps = {
  ...useSizeProps,
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 100
  },
  color: String,
  centerColor: String,
  trackColor: String,
  fontSize: String,
  rounded: Boolean,
  // ratio
  thickness: {
    type: Number,
    default: 0.2,
    validator: (v) => v >= 0 && v <= 1
  },
  angle: {
    type: Number,
    default: 0
  },
  showValue: Boolean,
  reverse: Boolean,
  instantFeedback: Boolean
};
var radius = 50;
var diameter = 2 * radius;
var circumference = diameter * Math.PI;
var strokeDashArray = Math.round(circumference * 1e3) / 1e3;
var QCircularProgress_default = createComponent({
  name: "QCircularProgress",
  props: {
    ...useCircularCommonProps,
    value: {
      type: Number,
      default: 0
    },
    animationSpeed: {
      type: [String, Number],
      default: 600
    },
    indeterminate: Boolean
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const sizeStyle = use_size_default(props4);
    const svgStyle = computed(() => {
      const angle = ($q.lang.rtl === true ? -1 : 1) * props4.angle;
      return {
        transform: props4.reverse !== ($q.lang.rtl === true) ? `scale3d(-1, 1, 1) rotate3d(0, 0, 1, ${-90 - angle}deg)` : `rotate3d(0, 0, 1, ${angle - 90}deg)`
      };
    });
    const circleStyle = computed(() => props4.instantFeedback !== true && props4.indeterminate !== true ? { transition: `stroke-dashoffset ${props4.animationSpeed}ms ease 0s, stroke ${props4.animationSpeed}ms ease` } : "");
    const viewBox = computed(() => diameter / (1 - props4.thickness / 2));
    const viewBoxAttr = computed(
      () => `${viewBox.value / 2} ${viewBox.value / 2} ${viewBox.value} ${viewBox.value}`
    );
    const normalized = computed(() => between(props4.value, props4.min, props4.max));
    const range2 = computed(() => props4.max - props4.min);
    const strokeWidth = computed(() => props4.thickness / 2 * viewBox.value);
    const strokeDashOffset = computed(() => {
      const dashRatio = (props4.max - normalized.value) / range2.value;
      const dashGap = props4.rounded === true && normalized.value < props4.max && dashRatio < 0.25 ? strokeWidth.value / 2 * (1 - dashRatio / 0.25) : 0;
      return circumference * dashRatio + dashGap;
    });
    function getCircle({ thickness, offset: offset2, color, cls, rounded }) {
      return h("circle", {
        class: "q-circular-progress__" + cls + (color !== void 0 ? ` text-${color}` : ""),
        style: circleStyle.value,
        fill: "transparent",
        stroke: "currentColor",
        "stroke-width": thickness,
        "stroke-dasharray": strokeDashArray,
        "stroke-dashoffset": offset2,
        "stroke-linecap": rounded,
        cx: viewBox.value,
        cy: viewBox.value,
        r: radius
      });
    }
    return () => {
      const svgChild = [];
      props4.centerColor !== void 0 && props4.centerColor !== "transparent" && svgChild.push(
        h("circle", {
          class: `q-circular-progress__center text-${props4.centerColor}`,
          fill: "currentColor",
          r: radius - strokeWidth.value / 2,
          cx: viewBox.value,
          cy: viewBox.value
        })
      );
      props4.trackColor !== void 0 && props4.trackColor !== "transparent" && svgChild.push(
        getCircle({
          cls: "track",
          thickness: strokeWidth.value,
          offset: 0,
          color: props4.trackColor
        })
      );
      svgChild.push(
        getCircle({
          cls: "circle",
          thickness: strokeWidth.value,
          offset: strokeDashOffset.value,
          color: props4.color,
          rounded: props4.rounded === true ? "round" : void 0
        })
      );
      const child = [
        h("svg", {
          class: "q-circular-progress__svg",
          style: svgStyle.value,
          viewBox: viewBoxAttr.value,
          "aria-hidden": "true"
        }, svgChild)
      ];
      props4.showValue === true && child.push(
        h("div", {
          class: "q-circular-progress__text absolute-full row flex-center content-center",
          style: { fontSize: props4.fontSize }
        }, slots.default !== void 0 ? slots.default() : [h("div", normalized.value)])
      );
      return h("div", {
        class: `q-circular-progress q-circular-progress--${props4.indeterminate === true ? "in" : ""}determinate`,
        style: sizeStyle.value,
        role: "progressbar",
        "aria-valuemin": props4.min,
        "aria-valuemax": props4.max,
        "aria-valuenow": props4.indeterminate === true ? void 0 : normalized.value
      }, hMergeSlotSafely(slots.internal, child));
    };
  }
});
function getChanges(evt, ctx, isFinal) {
  const pos = position(evt);
  let dir, distX = pos.left - ctx.event.x, distY = pos.top - ctx.event.y, absX = Math.abs(distX), absY = Math.abs(distY);
  const direction = ctx.direction;
  if (direction.horizontal === true && direction.vertical !== true) {
    dir = distX < 0 ? "left" : "right";
  } else if (direction.horizontal !== true && direction.vertical === true) {
    dir = distY < 0 ? "up" : "down";
  } else if (direction.up === true && distY < 0) {
    dir = "up";
    if (absX > absY) {
      if (direction.left === true && distX < 0) {
        dir = "left";
      } else if (direction.right === true && distX > 0) {
        dir = "right";
      }
    }
  } else if (direction.down === true && distY > 0) {
    dir = "down";
    if (absX > absY) {
      if (direction.left === true && distX < 0) {
        dir = "left";
      } else if (direction.right === true && distX > 0) {
        dir = "right";
      }
    }
  } else if (direction.left === true && distX < 0) {
    dir = "left";
    if (absX < absY) {
      if (direction.up === true && distY < 0) {
        dir = "up";
      } else if (direction.down === true && distY > 0) {
        dir = "down";
      }
    }
  } else if (direction.right === true && distX > 0) {
    dir = "right";
    if (absX < absY) {
      if (direction.up === true && distY < 0) {
        dir = "up";
      } else if (direction.down === true && distY > 0) {
        dir = "down";
      }
    }
  }
  let synthetic = false;
  if (dir === void 0 && isFinal === false) {
    if (ctx.event.isFirst === true || ctx.event.lastDir === void 0) {
      return {};
    }
    dir = ctx.event.lastDir;
    synthetic = true;
    if (dir === "left" || dir === "right") {
      pos.left -= distX;
      absX = 0;
      distX = 0;
    } else {
      pos.top -= distY;
      absY = 0;
      distY = 0;
    }
  }
  return {
    synthetic,
    payload: {
      evt,
      touch: ctx.event.mouse !== true,
      mouse: ctx.event.mouse === true,
      position: pos,
      direction: dir,
      isFirst: ctx.event.isFirst,
      isFinal: isFinal === true,
      duration: Date.now() - ctx.event.time,
      distance: {
        x: absX,
        y: absY
      },
      offset: {
        x: distX,
        y: distY
      },
      delta: {
        x: pos.left - ctx.event.lastX,
        y: pos.top - ctx.event.lastY
      }
    }
  };
}
var uid = 0;
var TouchPan_default = createDirective(
  {
    name: "touch-pan",
    beforeMount(el, { value: value2, modifiers }) {
      if (modifiers.mouse !== true && client.has.touch !== true) {
        return;
      }
      function handleEvent(evt, mouseEvent) {
        if (modifiers.mouse === true && mouseEvent === true) {
          stopAndPrevent(evt);
        } else {
          modifiers.stop === true && stop(evt);
          modifiers.prevent === true && prevent(evt);
        }
      }
      const ctx = {
        uid: "qvtp_" + uid++,
        handler: value2,
        modifiers,
        direction: getModifierDirections(modifiers),
        noop,
        mouseStart(evt) {
          if (shouldStart(evt, ctx) && leftClick(evt)) {
            addEvt(ctx, "temp", [
              [document, "mousemove", "move", "notPassiveCapture"],
              [document, "mouseup", "end", "passiveCapture"]
            ]);
            ctx.start(evt, true);
          }
        },
        touchStart(evt) {
          if (shouldStart(evt, ctx)) {
            const target2 = evt.target;
            addEvt(ctx, "temp", [
              [target2, "touchmove", "move", "notPassiveCapture"],
              [target2, "touchcancel", "end", "passiveCapture"],
              [target2, "touchend", "end", "passiveCapture"]
            ]);
            ctx.start(evt);
          }
        },
        start(evt, mouseEvent) {
          client.is.firefox === true && preventDraggable(el, true);
          ctx.lastEvt = evt;
          if (mouseEvent === true || modifiers.stop === true) {
            if (ctx.direction.all !== true && (mouseEvent !== true || ctx.modifiers.mouseAllDir !== true && ctx.modifiers.mousealldir !== true)) {
              const clone2 = evt.type.indexOf("mouse") !== -1 ? new MouseEvent(evt.type, evt) : new TouchEvent(evt.type, evt);
              evt.defaultPrevented === true && prevent(clone2);
              evt.cancelBubble === true && stop(clone2);
              Object.assign(clone2, {
                qKeyEvent: evt.qKeyEvent,
                qClickOutside: evt.qClickOutside,
                qAnchorHandled: evt.qAnchorHandled,
                qClonedBy: evt.qClonedBy === void 0 ? [ctx.uid] : evt.qClonedBy.concat(ctx.uid)
              });
              ctx.initialEvent = {
                target: evt.target,
                event: clone2
              };
            }
            stop(evt);
          }
          const { left, top } = position(evt);
          ctx.event = {
            x: left,
            y: top,
            time: Date.now(),
            mouse: mouseEvent === true,
            detected: false,
            isFirst: true,
            isFinal: false,
            lastX: left,
            lastY: top
          };
        },
        move(evt) {
          if (ctx.event === void 0) {
            return;
          }
          const pos = position(evt), distX = pos.left - ctx.event.x, distY = pos.top - ctx.event.y;
          if (distX === 0 && distY === 0) {
            return;
          }
          ctx.lastEvt = evt;
          const isMouseEvt = ctx.event.mouse === true;
          const start = () => {
            handleEvent(evt, isMouseEvt);
            let cursor;
            if (modifiers.preserveCursor !== true && modifiers.preservecursor !== true) {
              cursor = document.documentElement.style.cursor || "";
              document.documentElement.style.cursor = "grabbing";
            }
            isMouseEvt === true && document.body.classList.add("no-pointer-events--children");
            document.body.classList.add("non-selectable");
            clearSelection();
            ctx.styleCleanup = (withDelayedFn) => {
              ctx.styleCleanup = void 0;
              if (cursor !== void 0) {
                document.documentElement.style.cursor = cursor;
              }
              document.body.classList.remove("non-selectable");
              if (isMouseEvt === true) {
                const remove2 = () => {
                  document.body.classList.remove("no-pointer-events--children");
                };
                if (withDelayedFn !== void 0) {
                  setTimeout(() => {
                    remove2();
                    withDelayedFn();
                  }, 50);
                } else {
                  remove2();
                }
              } else if (withDelayedFn !== void 0) {
                withDelayedFn();
              }
            };
          };
          if (ctx.event.detected === true) {
            ctx.event.isFirst !== true && handleEvent(evt, ctx.event.mouse);
            const { payload, synthetic } = getChanges(evt, ctx, false);
            if (payload !== void 0) {
              if (ctx.handler(payload) === false) {
                ctx.end(evt);
              } else {
                if (ctx.styleCleanup === void 0 && ctx.event.isFirst === true) {
                  start();
                }
                ctx.event.lastX = payload.position.left;
                ctx.event.lastY = payload.position.top;
                ctx.event.lastDir = synthetic === true ? void 0 : payload.direction;
                ctx.event.isFirst = false;
              }
            }
            return;
          }
          if (ctx.direction.all === true || isMouseEvt === true && (ctx.modifiers.mouseAllDir === true || ctx.modifiers.mousealldir === true)) {
            start();
            ctx.event.detected = true;
            ctx.move(evt);
            return;
          }
          const absX = Math.abs(distX), absY = Math.abs(distY);
          if (absX !== absY) {
            if (ctx.direction.horizontal === true && absX > absY || ctx.direction.vertical === true && absX < absY || ctx.direction.up === true && absX < absY && distY < 0 || ctx.direction.down === true && absX < absY && distY > 0 || ctx.direction.left === true && absX > absY && distX < 0 || ctx.direction.right === true && absX > absY && distX > 0) {
              ctx.event.detected = true;
              ctx.move(evt);
            } else {
              ctx.end(evt, true);
            }
          }
        },
        end(evt, abort) {
          if (ctx.event === void 0) {
            return;
          }
          cleanEvt(ctx, "temp");
          client.is.firefox === true && preventDraggable(el, false);
          if (abort === true) {
            ctx.styleCleanup !== void 0 && ctx.styleCleanup();
            if (ctx.event.detected !== true && ctx.initialEvent !== void 0) {
              ctx.initialEvent.target.dispatchEvent(ctx.initialEvent.event);
            }
          } else if (ctx.event.detected === true) {
            ctx.event.isFirst === true && ctx.handler(getChanges(evt === void 0 ? ctx.lastEvt : evt, ctx).payload);
            const { payload } = getChanges(evt === void 0 ? ctx.lastEvt : evt, ctx, true);
            const fn = () => {
              ctx.handler(payload);
            };
            if (ctx.styleCleanup !== void 0) {
              ctx.styleCleanup(fn);
            } else {
              fn();
            }
          }
          ctx.event = void 0;
          ctx.initialEvent = void 0;
          ctx.lastEvt = void 0;
        }
      };
      el.__qtouchpan = ctx;
      if (modifiers.mouse === true) {
        const capture = modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : "";
        addEvt(ctx, "main", [
          [el, "mousedown", "mouseStart", `passive${capture}`]
        ]);
      }
      client.has.touch === true && addEvt(ctx, "main", [
        [el, "touchstart", "touchStart", `passive${modifiers.capture === true ? "Capture" : ""}`],
        [el, "touchmove", "noop", "notPassiveCapture"]
        // cannot be passive (ex: iOS scroll)
      ]);
    },
    updated(el, bindings) {
      const ctx = el.__qtouchpan;
      if (ctx !== void 0) {
        if (bindings.oldValue !== bindings.value) {
          typeof value !== "function" && ctx.end();
          ctx.handler = bindings.value;
        }
        ctx.direction = getModifierDirections(bindings.modifiers);
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qtouchpan;
      if (ctx !== void 0) {
        ctx.event !== void 0 && ctx.end();
        cleanEvt(ctx, "main");
        cleanEvt(ctx, "temp");
        client.is.firefox === true && preventDraggable(el, false);
        ctx.styleCleanup !== void 0 && ctx.styleCleanup();
        delete el.__qtouchpan;
      }
    }
  }
);
var markerPrefixClass = "q-slider__marker-labels";
var defaultMarkerConvertFn = (v) => ({ value: v });
var defaultMarkerLabelRenderFn = ({ marker }) => h("div", {
  key: marker.value,
  style: marker.style,
  class: marker.classes
}, marker.label);
var keyCodes = [34, 37, 40, 33, 39, 38];
var useSliderProps = {
  ...useDarkProps,
  ...useFormProps,
  min: {
    type: Number,
    default: 0
  },
  max: {
    type: Number,
    default: 100
  },
  innerMin: Number,
  innerMax: Number,
  step: {
    type: Number,
    default: 1,
    validator: (v) => v >= 0
  },
  snap: Boolean,
  vertical: Boolean,
  reverse: Boolean,
  color: String,
  markerLabelsClass: String,
  label: Boolean,
  labelColor: String,
  labelTextColor: String,
  labelAlways: Boolean,
  switchLabelSide: Boolean,
  markers: [Boolean, Number],
  markerLabels: [Boolean, Array, Object, Function],
  switchMarkerLabelsSide: Boolean,
  trackImg: String,
  trackColor: String,
  innerTrackImg: String,
  innerTrackColor: String,
  selectionColor: String,
  selectionImg: String,
  thumbSize: {
    type: String,
    default: "20px"
  },
  trackSize: {
    type: String,
    default: "4px"
  },
  disable: Boolean,
  readonly: Boolean,
  dense: Boolean,
  tabindex: [String, Number],
  thumbColor: String,
  thumbPath: {
    type: String,
    default: "M 4, 10 a 6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"
  }
};
var useSliderEmits = ["pan", "update:modelValue", "change"];
function use_slider_default({ updateValue: updateValue2, updatePosition, getDragging, formAttrs }) {
  const { props: props4, emit, slots, proxy: { $q } } = getCurrentInstance();
  const isDark = use_dark_default(props4, $q);
  const injectFormInput = useFormInject(formAttrs);
  const active = ref$1(false);
  const preventFocus = ref$1(false);
  const focus = ref$1(false);
  const dragging = ref$1(false);
  const axis = computed(() => props4.vertical === true ? "--v" : "--h");
  const labelSide = computed(() => "-" + (props4.switchLabelSide === true ? "switched" : "standard"));
  const isReversed = computed(() => props4.vertical === true ? props4.reverse === true : props4.reverse !== ($q.lang.rtl === true));
  const innerMin = computed(() => isNaN(props4.innerMin) === true || props4.innerMin < props4.min ? props4.min : props4.innerMin);
  const innerMax = computed(() => isNaN(props4.innerMax) === true || props4.innerMax > props4.max ? props4.max : props4.innerMax);
  const editable = computed(() => props4.disable !== true && props4.readonly !== true && innerMin.value < innerMax.value);
  const roundValueFn = computed(() => {
    if (props4.step === 0) {
      return (v) => v;
    }
    const decimals = (String(props4.step).trim().split(".")[1] || "").length;
    return (v) => parseFloat(v.toFixed(decimals));
  });
  const keyStep = computed(() => props4.step === 0 ? 1 : props4.step);
  const tabindex = computed(() => editable.value === true ? props4.tabindex || 0 : -1);
  const trackLen = computed(() => props4.max - props4.min);
  const innerBarLen = computed(() => innerMax.value - innerMin.value);
  const innerMinRatio = computed(() => convertModelToRatio(innerMin.value));
  const innerMaxRatio = computed(() => convertModelToRatio(innerMax.value));
  const positionProp = computed(() => props4.vertical === true ? isReversed.value === true ? "bottom" : "top" : isReversed.value === true ? "right" : "left");
  const sizeProp = computed(() => props4.vertical === true ? "height" : "width");
  const thicknessProp = computed(() => props4.vertical === true ? "width" : "height");
  const orientation = computed(() => props4.vertical === true ? "vertical" : "horizontal");
  const attributes = computed(() => {
    const acc = {
      role: "slider",
      "aria-valuemin": innerMin.value,
      "aria-valuemax": innerMax.value,
      "aria-orientation": orientation.value,
      "data-step": props4.step
    };
    if (props4.disable === true) {
      acc["aria-disabled"] = "true";
    } else if (props4.readonly === true) {
      acc["aria-readonly"] = "true";
    }
    return acc;
  });
  const classes = computed(
    () => `q-slider q-slider${axis.value} q-slider--${active.value === true ? "" : "in"}active inline no-wrap ` + (props4.vertical === true ? "row" : "column") + (props4.disable === true ? " disabled" : " q-slider--enabled" + (editable.value === true ? " q-slider--editable" : "")) + (focus.value === "both" ? " q-slider--focus" : "") + (props4.label || props4.labelAlways === true ? " q-slider--label" : "") + (props4.labelAlways === true ? " q-slider--label-always" : "") + (isDark.value === true ? " q-slider--dark" : "") + (props4.dense === true ? " q-slider--dense q-slider--dense" + axis.value : "")
  );
  function getPositionClass(name2) {
    const cls = "q-slider__" + name2;
    return `${cls} ${cls}${axis.value} ${cls}${axis.value}${labelSide.value}`;
  }
  function getAxisClass(name2) {
    const cls = "q-slider__" + name2;
    return `${cls} ${cls}${axis.value}`;
  }
  const selectionBarClass = computed(() => {
    const color = props4.selectionColor || props4.color;
    return "q-slider__selection absolute" + (color !== void 0 ? ` text-${color}` : "");
  });
  const markerClass = computed(() => getAxisClass("markers") + " absolute overflow-hidden");
  const trackContainerClass = computed(() => getAxisClass("track-container"));
  const pinClass = computed(() => getPositionClass("pin"));
  const labelClass = computed(() => getPositionClass("label"));
  const textContainerClass = computed(() => getPositionClass("text-container"));
  const markerLabelsContainerClass = computed(
    () => getPositionClass("marker-labels-container") + (props4.markerLabelsClass !== void 0 ? ` ${props4.markerLabelsClass}` : "")
  );
  const trackClass = computed(
    () => "q-slider__track relative-position no-outline" + (props4.trackColor !== void 0 ? ` bg-${props4.trackColor}` : "")
  );
  const trackStyle = computed(() => {
    const acc = { [thicknessProp.value]: props4.trackSize };
    if (props4.trackImg !== void 0) {
      acc.backgroundImage = `url(${props4.trackImg}) !important`;
    }
    return acc;
  });
  const innerBarClass = computed(
    () => "q-slider__inner absolute" + (props4.innerTrackColor !== void 0 ? ` bg-${props4.innerTrackColor}` : "")
  );
  const innerBarStyle = computed(() => {
    const innerDiff = innerMaxRatio.value - innerMinRatio.value;
    const acc = {
      [positionProp.value]: `${100 * innerMinRatio.value}%`,
      [sizeProp.value]: innerDiff === 0 ? "2px" : `${100 * innerDiff}%`
    };
    if (props4.innerTrackImg !== void 0) {
      acc.backgroundImage = `url(${props4.innerTrackImg}) !important`;
    }
    return acc;
  });
  function convertRatioToModel(ratio) {
    const { min: min2, max: max2, step } = props4;
    let model = min2 + ratio * (max2 - min2);
    if (step > 0) {
      const modulo = (model - innerMin.value) % step;
      model += (Math.abs(modulo) >= step / 2 ? (modulo < 0 ? -1 : 1) * step : 0) - modulo;
    }
    model = roundValueFn.value(model);
    return between(model, innerMin.value, innerMax.value);
  }
  function convertModelToRatio(model) {
    return trackLen.value === 0 ? 0 : (model - props4.min) / trackLen.value;
  }
  function getDraggingRatio(evt, dragging2) {
    const pos = position(evt), val = props4.vertical === true ? between((pos.top - dragging2.top) / dragging2.height, 0, 1) : between((pos.left - dragging2.left) / dragging2.width, 0, 1);
    return between(
      isReversed.value === true ? 1 - val : val,
      innerMinRatio.value,
      innerMaxRatio.value
    );
  }
  const markerStep = computed(
    () => isNumber$1(props4.markers) === true ? props4.markers : keyStep.value
  );
  const markerTicks = computed(() => {
    const acc = [];
    const step = markerStep.value;
    const max2 = props4.max;
    let value2 = props4.min;
    do {
      acc.push(value2);
      value2 += step;
    } while (value2 < max2);
    acc.push(max2);
    return acc;
  });
  const markerLabelClass = computed(() => {
    const prefix = ` ${markerPrefixClass}${axis.value}-`;
    return markerPrefixClass + `${prefix}${props4.switchMarkerLabelsSide === true ? "switched" : "standard"}${prefix}${isReversed.value === true ? "rtl" : "ltr"}`;
  });
  const markerLabelsList = computed(() => {
    if (props4.markerLabels === false) {
      return null;
    }
    return getMarkerList(props4.markerLabels).map((entry, index) => ({
      index,
      value: entry.value,
      label: entry.label || entry.value,
      classes: markerLabelClass.value + (entry.classes !== void 0 ? " " + entry.classes : ""),
      style: {
        ...getMarkerLabelStyle(entry.value),
        ...entry.style || {}
      }
    }));
  });
  const markerScope = computed(() => ({
    markerList: markerLabelsList.value,
    markerMap: markerLabelsMap.value,
    classes: markerLabelClass.value,
    // TODO ts definition
    getStyle: getMarkerLabelStyle
  }));
  const markerStyle = computed(() => {
    const size2 = innerBarLen.value === 0 ? "2px" : 100 * markerStep.value / innerBarLen.value;
    return {
      ...innerBarStyle.value,
      backgroundSize: props4.vertical === true ? `2px ${size2}%` : `${size2}% 2px`
    };
  });
  function getMarkerList(def) {
    if (def === false) {
      return null;
    }
    if (def === true) {
      return markerTicks.value.map(defaultMarkerConvertFn);
    }
    if (typeof def === "function") {
      return markerTicks.value.map((value2) => {
        const item = def(value2);
        return isObject(item) === true ? { ...item, value: value2 } : { value: value2, label: item };
      });
    }
    const filterFn = ({ value: value2 }) => value2 >= props4.min && value2 <= props4.max;
    if (Array.isArray(def) === true) {
      return def.map((item) => isObject(item) === true ? item : { value: item }).filter(filterFn);
    }
    return Object.keys(def).map((key) => {
      const item = def[key];
      const value2 = Number(key);
      return isObject(item) === true ? { ...item, value: value2 } : { value: value2, label: item };
    }).filter(filterFn);
  }
  function getMarkerLabelStyle(val) {
    return { [positionProp.value]: `${100 * (val - props4.min) / trackLen.value}%` };
  }
  const markerLabelsMap = computed(() => {
    if (props4.markerLabels === false) {
      return null;
    }
    const acc = {};
    markerLabelsList.value.forEach((entry) => {
      acc[entry.value] = entry;
    });
    return acc;
  });
  function getMarkerLabelsContent() {
    if (slots["marker-label-group"] !== void 0) {
      return slots["marker-label-group"](markerScope.value);
    }
    const fn = slots["marker-label"] || defaultMarkerLabelRenderFn;
    return markerLabelsList.value.map((marker) => fn({
      marker,
      ...markerScope.value
    }));
  }
  const panDirective = computed(() => {
    return [[
      TouchPan_default,
      onPan,
      void 0,
      {
        [orientation.value]: true,
        prevent: true,
        stop: true,
        mouse: true,
        mouseAllDir: true
      }
    ]];
  });
  function onPan(event) {
    if (event.isFinal === true) {
      if (dragging.value !== void 0) {
        updatePosition(event.evt);
        event.touch === true && updateValue2(true);
        dragging.value = void 0;
        emit("pan", "end");
      }
      active.value = false;
      focus.value = false;
    } else if (event.isFirst === true) {
      dragging.value = getDragging(event.evt);
      updatePosition(event.evt);
      updateValue2();
      active.value = true;
      emit("pan", "start");
    } else {
      updatePosition(event.evt);
      updateValue2();
    }
  }
  function onBlur2() {
    focus.value = false;
  }
  function onActivate(evt) {
    updatePosition(evt, getDragging(evt));
    updateValue2();
    preventFocus.value = true;
    active.value = true;
    document.addEventListener("mouseup", onDeactivate, true);
  }
  function onDeactivate() {
    preventFocus.value = false;
    active.value = false;
    updateValue2(true);
    onBlur2();
    document.removeEventListener("mouseup", onDeactivate, true);
  }
  function onMobileClick(evt) {
    updatePosition(evt, getDragging(evt));
    updateValue2(true);
  }
  function onKeyup2(evt) {
    if (keyCodes.includes(evt.keyCode)) {
      updateValue2(true);
    }
  }
  function getTextContainerStyle(ratio) {
    if (props4.vertical === true) {
      return null;
    }
    const p = $q.lang.rtl !== props4.reverse ? 1 - ratio : ratio;
    return {
      transform: `translateX(calc(${2 * p - 1} * ${props4.thumbSize} / 2 + ${50 - 100 * p}%))`
    };
  }
  function getThumbRenderFn(thumb) {
    const focusClass = computed(() => preventFocus.value === false && (focus.value === thumb.focusValue || focus.value === "both") ? " q-slider--focus" : "");
    const classes2 = computed(
      () => `q-slider__thumb q-slider__thumb${axis.value} q-slider__thumb${axis.value}-${isReversed.value === true ? "rtl" : "ltr"} absolute non-selectable` + focusClass.value + (thumb.thumbColor.value !== void 0 ? ` text-${thumb.thumbColor.value}` : "")
    );
    const style2 = computed(() => ({
      width: props4.thumbSize,
      height: props4.thumbSize,
      [positionProp.value]: `${100 * thumb.ratio.value}%`,
      zIndex: focus.value === thumb.focusValue ? 2 : void 0
    }));
    const pinColor = computed(() => thumb.labelColor.value !== void 0 ? ` text-${thumb.labelColor.value}` : "");
    const textContainerStyle = computed(() => getTextContainerStyle(thumb.ratio.value));
    const textClass = computed(() => "q-slider__text" + (thumb.labelTextColor.value !== void 0 ? ` text-${thumb.labelTextColor.value}` : ""));
    return () => {
      const thumbContent = [
        h("svg", {
          class: "q-slider__thumb-shape absolute-full",
          viewBox: "0 0 20 20",
          "aria-hidden": "true"
        }, [
          h("path", { d: props4.thumbPath })
        ]),
        h("div", { class: "q-slider__focus-ring fit" })
      ];
      if (props4.label === true || props4.labelAlways === true) {
        thumbContent.push(
          h("div", {
            class: pinClass.value + " absolute fit no-pointer-events" + pinColor.value
          }, [
            h("div", {
              class: labelClass.value,
              style: { minWidth: props4.thumbSize }
            }, [
              h("div", {
                class: textContainerClass.value,
                style: textContainerStyle.value
              }, [
                h("span", { class: textClass.value }, thumb.label.value)
              ])
            ])
          ])
        );
        if (props4.name !== void 0 && props4.disable !== true) {
          injectFormInput(thumbContent, "push");
        }
      }
      return h("div", {
        class: classes2.value,
        style: style2.value,
        ...thumb.getNodeData()
      }, thumbContent);
    };
  }
  function getContent(selectionBarStyle, trackContainerTabindex, trackContainerEvents, injectThumb) {
    const trackContent = [];
    props4.innerTrackColor !== "transparent" && trackContent.push(
      h("div", {
        key: "inner",
        class: innerBarClass.value,
        style: innerBarStyle.value
      })
    );
    props4.selectionColor !== "transparent" && trackContent.push(
      h("div", {
        key: "selection",
        class: selectionBarClass.value,
        style: selectionBarStyle.value
      })
    );
    props4.markers !== false && trackContent.push(
      h("div", {
        key: "marker",
        class: markerClass.value,
        style: markerStyle.value
      })
    );
    injectThumb(trackContent);
    const content = [
      hDir(
        "div",
        {
          key: "trackC",
          class: trackContainerClass.value,
          tabindex: trackContainerTabindex.value,
          ...trackContainerEvents.value
        },
        [
          h("div", {
            class: trackClass.value,
            style: trackStyle.value
          }, trackContent)
        ],
        "slide",
        editable.value,
        () => panDirective.value
      )
    ];
    if (props4.markerLabels !== false) {
      const action = props4.switchMarkerLabelsSide === true ? "unshift" : "push";
      content[action](
        h("div", {
          key: "markerL",
          class: markerLabelsContainerClass.value
        }, getMarkerLabelsContent())
      );
    }
    return content;
  }
  onBeforeUnmount(() => {
    document.removeEventListener("mouseup", onDeactivate, true);
  });
  return {
    state: {
      active,
      focus,
      preventFocus,
      dragging,
      editable,
      classes,
      tabindex,
      attributes,
      roundValueFn,
      keyStep,
      trackLen,
      innerMin,
      innerMinRatio,
      innerMax,
      innerMaxRatio,
      positionProp,
      sizeProp,
      isReversed
    },
    methods: {
      onActivate,
      onMobileClick,
      onBlur: onBlur2,
      onKeyup: onKeyup2,
      getContent,
      getThumbRenderFn,
      convertRatioToModel,
      convertModelToRatio,
      getDraggingRatio
    }
  };
}
var getNodeData = () => ({});
var QSlider_default = createComponent({
  name: "QSlider",
  props: {
    ...useSliderProps,
    modelValue: {
      required: true,
      default: null,
      validator: (v) => typeof v === "number" || v === null
    },
    labelValue: [String, Number]
  },
  emits: useSliderEmits,
  setup(props4, { emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const { state: state2, methods } = use_slider_default({
      updateValue: updateValue2,
      updatePosition,
      getDragging,
      formAttrs: useFormAttrs(props4)
    });
    const rootRef = ref$1(null);
    const curRatio = ref$1(0);
    const model = ref$1(0);
    function normalizeModel() {
      model.value = props4.modelValue === null ? state2.innerMin.value : between(props4.modelValue, state2.innerMin.value, state2.innerMax.value);
    }
    watch(
      () => `${props4.modelValue}|${state2.innerMin.value}|${state2.innerMax.value}`,
      normalizeModel
    );
    normalizeModel();
    const modelRatio = computed(() => methods.convertModelToRatio(model.value));
    const ratio = computed(() => state2.active.value === true ? curRatio.value : modelRatio.value);
    const selectionBarStyle = computed(() => {
      const acc = {
        [state2.positionProp.value]: `${100 * state2.innerMinRatio.value}%`,
        [state2.sizeProp.value]: `${100 * (ratio.value - state2.innerMinRatio.value)}%`
      };
      if (props4.selectionImg !== void 0) {
        acc.backgroundImage = `url(${props4.selectionImg}) !important`;
      }
      return acc;
    });
    const getThumb = methods.getThumbRenderFn({
      focusValue: true,
      getNodeData,
      ratio,
      label: computed(() => props4.labelValue !== void 0 ? props4.labelValue : model.value),
      thumbColor: computed(() => props4.thumbColor || props4.color),
      labelColor: computed(() => props4.labelColor),
      labelTextColor: computed(() => props4.labelTextColor)
    });
    const trackContainerEvents = computed(() => {
      if (state2.editable.value !== true) {
        return {};
      }
      return $q.platform.is.mobile === true ? { onClick: methods.onMobileClick } : {
        onMousedown: methods.onActivate,
        onFocus,
        onBlur: methods.onBlur,
        onKeydown: onKeydown2,
        onKeyup: methods.onKeyup
      };
    });
    function updateValue2(change) {
      if (model.value !== props4.modelValue) {
        emit("update:modelValue", model.value);
      }
      change === true && emit("change", model.value);
    }
    function getDragging() {
      return rootRef.value.getBoundingClientRect();
    }
    function updatePosition(event, dragging = state2.dragging.value) {
      const ratio2 = methods.getDraggingRatio(event, dragging);
      model.value = methods.convertRatioToModel(ratio2);
      curRatio.value = props4.snap !== true || props4.step === 0 ? ratio2 : methods.convertModelToRatio(model.value);
    }
    function onFocus() {
      state2.focus.value = true;
    }
    function onKeydown2(evt) {
      if (!keyCodes.includes(evt.keyCode)) {
        return;
      }
      stopAndPrevent(evt);
      const stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * state2.keyStep.value, offset2 = ([34, 37, 40].includes(evt.keyCode) ? -1 : 1) * (state2.isReversed.value === true ? -1 : 1) * (props4.vertical === true ? -1 : 1) * stepVal;
      model.value = between(
        state2.roundValueFn.value(model.value + offset2),
        state2.innerMin.value,
        state2.innerMax.value
      );
      updateValue2();
    }
    return () => {
      const content = methods.getContent(
        selectionBarStyle,
        state2.tabindex,
        trackContainerEvents,
        (node) => {
          node.push(getThumb());
        }
      );
      return h("div", {
        ref: rootRef,
        class: state2.classes.value + (props4.modelValue === null ? " q-slider--no-value" : ""),
        ...state2.attributes.value,
        "aria-valuenow": props4.modelValue
      }, content);
    };
  }
});
function use_hydration_default() {
  const isHydrated = ref$1(!isRuntimeSsrPreHydration.value);
  if (isHydrated.value === false) {
    onMounted(() => {
      isHydrated.value = true;
    });
  }
  return { isHydrated };
}
var hasObserver = typeof ResizeObserver !== "undefined";
var resizeProps = hasObserver === true ? {} : {
  style: "display:block;position:absolute;top:0;left:0;right:0;bottom:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1;",
  url: "about:blank"
};
var QResizeObserver_default = createComponent({
  name: "QResizeObserver",
  props: {
    debounce: {
      type: [String, Number],
      default: 100
    }
  },
  emits: ["resize"],
  setup(props4, { emit }) {
    let timer2 = null, targetEl, size2 = { width: -1, height: -1 };
    function trigger3(immediately) {
      if (immediately === true || props4.debounce === 0 || props4.debounce === "0") {
        emitEvent();
      } else if (timer2 === null) {
        timer2 = setTimeout(emitEvent, props4.debounce);
      }
    }
    function emitEvent() {
      if (timer2 !== null) {
        clearTimeout(timer2);
        timer2 = null;
      }
      if (targetEl) {
        const { offsetWidth: width3, offsetHeight: height2 } = targetEl;
        if (width3 !== size2.width || height2 !== size2.height) {
          size2 = { width: width3, height: height2 };
          emit("resize", size2);
        }
      }
    }
    const { proxy } = getCurrentInstance();
    proxy.trigger = trigger3;
    if (hasObserver === true) {
      let observer;
      const init = (stop2) => {
        targetEl = proxy.$el.parentNode;
        if (targetEl) {
          observer = new ResizeObserver(trigger3);
          observer.observe(targetEl);
          emitEvent();
        } else if (stop2 !== true) {
          nextTick(() => {
            init(true);
          });
        }
      };
      onMounted(() => {
        init();
      });
      onBeforeUnmount(() => {
        timer2 !== null && clearTimeout(timer2);
        if (observer !== void 0) {
          if (observer.disconnect !== void 0) {
            observer.disconnect();
          } else if (targetEl) {
            observer.unobserve(targetEl);
          }
        }
      });
      return noop;
    } else {
      let cleanup = function() {
        if (timer2 !== null) {
          clearTimeout(timer2);
          timer2 = null;
        }
        if (curDocView !== void 0) {
          if (curDocView.removeEventListener !== void 0) {
            curDocView.removeEventListener("resize", trigger3, listenOpts.passive);
          }
          curDocView = void 0;
        }
      }, onObjLoad = function() {
        cleanup();
        if (targetEl && targetEl.contentDocument) {
          curDocView = targetEl.contentDocument.defaultView;
          curDocView.addEventListener("resize", trigger3, listenOpts.passive);
          emitEvent();
        }
      };
      const { isHydrated } = use_hydration_default();
      let curDocView;
      onMounted(() => {
        nextTick(() => {
          targetEl = proxy.$el;
          targetEl && onObjLoad();
        });
      });
      onBeforeUnmount(cleanup);
      return () => {
        if (isHydrated.value === true) {
          return h("object", {
            class: "q--avoid-card-border",
            style: resizeProps.style,
            tabindex: -1,
            // fix for Firefox
            type: "text/html",
            data: resizeProps.url,
            "aria-hidden": "true",
            onLoad: onObjLoad
          });
        }
      };
    }
  }
});
var rtlHasScrollBug = false;
if (!__QUASAR_SSR__) {
  const scroller = document.createElement("div");
  scroller.setAttribute("dir", "rtl");
  Object.assign(scroller.style, {
    width: "1px",
    height: "1px",
    overflow: "auto"
  });
  const spacer = document.createElement("div");
  Object.assign(spacer.style, {
    width: "1000px",
    height: "1px"
  });
  document.body.appendChild(scroller);
  scroller.appendChild(spacer);
  scroller.scrollLeft = -1e3;
  rtlHasScrollBug = scroller.scrollLeft >= 0;
  scroller.remove();
}
function getIndicatorClass(color, top, vertical) {
  const pos = vertical === true ? ["left", "right"] : ["top", "bottom"];
  return `absolute-${top === true ? pos[0] : pos[1]}${color ? ` text-${color}` : ""}`;
}
var alignValues3 = ["left", "center", "right", "justify"];
var QTabs_default = createComponent({
  name: "QTabs",
  props: {
    modelValue: [Number, String],
    align: {
      type: String,
      default: "center",
      validator: (v) => alignValues3.includes(v)
    },
    breakpoint: {
      type: [String, Number],
      default: 600
    },
    vertical: Boolean,
    shrink: Boolean,
    stretch: Boolean,
    activeClass: String,
    activeColor: String,
    activeBgColor: String,
    indicatorColor: String,
    leftIcon: String,
    rightIcon: String,
    outsideArrows: Boolean,
    mobileArrows: Boolean,
    switchIndicator: Boolean,
    narrowIndicator: Boolean,
    inlineLabel: Boolean,
    noCaps: Boolean,
    dense: Boolean,
    contentClass: String,
    "onUpdate:modelValue": [Function, Array]
  },
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const { registerTick: registerScrollTick } = use_tick_default();
    const { registerTick: registerUpdateArrowsTick } = use_tick_default();
    const { registerTick: registerAnimateTick } = use_tick_default();
    const { registerTimeout: registerFocusTimeout, removeTimeout: removeFocusTimeout } = use_timeout_default();
    const { registerTimeout: registerScrollToTabTimeout, removeTimeout: removeScrollToTabTimeout } = use_timeout_default();
    const rootRef = ref$1(null);
    const contentRef = ref$1(null);
    const currentModel = ref$1(props4.modelValue);
    const scrollable = ref$1(false);
    const leftArrow = ref$1(true);
    const rightArrow = ref$1(false);
    const justify = ref$1(false);
    const tabDataList = [];
    const tabDataListLen = ref$1(0);
    const hasFocus = ref$1(false);
    let animateTimer = null, scrollTimer = null, unwatchRoute;
    const tabProps = computed(() => ({
      activeClass: props4.activeClass,
      activeColor: props4.activeColor,
      activeBgColor: props4.activeBgColor,
      indicatorClass: getIndicatorClass(
        props4.indicatorColor,
        props4.switchIndicator,
        props4.vertical
      ),
      narrowIndicator: props4.narrowIndicator,
      inlineLabel: props4.inlineLabel,
      noCaps: props4.noCaps
    }));
    const hasActiveTab = computed(() => {
      const len = tabDataListLen.value;
      const val = currentModel.value;
      for (let i2 = 0; i2 < len; i2++) {
        if (tabDataList[i2].name.value === val) {
          return true;
        }
      }
      return false;
    });
    const alignClass = computed(() => {
      const align = scrollable.value === true ? "left" : justify.value === true ? "justify" : props4.align;
      return `q-tabs__content--align-${align}`;
    });
    const classes = computed(
      () => `q-tabs row no-wrap items-center q-tabs--${scrollable.value === true ? "" : "not-"}scrollable q-tabs--${props4.vertical === true ? "vertical" : "horizontal"} q-tabs__arrows--${props4.outsideArrows === true ? "outside" : "inside"} q-tabs--mobile-with${props4.mobileArrows === true ? "" : "out"}-arrows` + (props4.dense === true ? " q-tabs--dense" : "") + (props4.shrink === true ? " col-shrink" : "") + (props4.stretch === true ? " self-stretch" : "")
    );
    const innerClass = computed(
      () => "q-tabs__content scroll--mobile row no-wrap items-center self-stretch hide-scrollbar relative-position " + alignClass.value + (props4.contentClass !== void 0 ? ` ${props4.contentClass}` : "")
    );
    const domProps = computed(() => props4.vertical === true ? { container: "height", content: "offsetHeight", scroll: "scrollHeight" } : { container: "width", content: "offsetWidth", scroll: "scrollWidth" });
    const isRTL = computed(() => props4.vertical !== true && $q.lang.rtl === true);
    const rtlPosCorrection = computed(() => rtlHasScrollBug === false && isRTL.value === true);
    watch(isRTL, updateArrows);
    watch(() => props4.modelValue, (name2) => {
      updateModel2({ name: name2, setCurrent: true, skipEmit: true });
    });
    watch(() => props4.outsideArrows, recalculateScroll);
    function updateModel2({ name: name2, setCurrent, skipEmit }) {
      if (currentModel.value === name2) return;
      if (skipEmit !== true && props4["onUpdate:modelValue"] !== void 0) {
        emit("update:modelValue", name2);
      }
      if (setCurrent === true || props4["onUpdate:modelValue"] === void 0) {
        animate(currentModel.value, name2);
        currentModel.value = name2;
      }
    }
    function recalculateScroll() {
      registerScrollTick(() => {
        updateContainer({
          width: rootRef.value.offsetWidth,
          height: rootRef.value.offsetHeight
        });
      });
    }
    function updateContainer(domSize) {
      if (domProps.value === void 0 || contentRef.value === null) return;
      const size2 = domSize[domProps.value.container], scrollSize = Math.min(
        contentRef.value[domProps.value.scroll],
        Array.prototype.reduce.call(
          contentRef.value.children,
          (acc, el) => acc + (el[domProps.value.content] || 0),
          0
        )
      ), scroll = size2 > 0 && scrollSize > size2;
      scrollable.value = scroll;
      scroll === true && registerUpdateArrowsTick(updateArrows);
      justify.value = size2 < parseInt(props4.breakpoint, 10);
    }
    function animate(oldName, newName) {
      const oldTab = oldName !== void 0 && oldName !== null && oldName !== "" ? tabDataList.find((tab) => tab.name.value === oldName) : null, newTab = newName !== void 0 && newName !== null && newName !== "" ? tabDataList.find((tab) => tab.name.value === newName) : null;
      if (hadActivated === true) {
        hadActivated = false;
      } else if (oldTab && newTab) {
        const oldEl = oldTab.tabIndicatorRef.value, newEl = newTab.tabIndicatorRef.value;
        if (animateTimer !== null) {
          clearTimeout(animateTimer);
          animateTimer = null;
        }
        oldEl.style.transition = "none";
        oldEl.style.transform = "none";
        newEl.style.transition = "none";
        newEl.style.transform = "none";
        const oldPos = oldEl.getBoundingClientRect(), newPos = newEl.getBoundingClientRect();
        newEl.style.transform = props4.vertical === true ? `translate3d(0,${oldPos.top - newPos.top}px,0) scale3d(1,${newPos.height ? oldPos.height / newPos.height : 1},1)` : `translate3d(${oldPos.left - newPos.left}px,0,0) scale3d(${newPos.width ? oldPos.width / newPos.width : 1},1,1)`;
        registerAnimateTick(() => {
          animateTimer = setTimeout(() => {
            animateTimer = null;
            newEl.style.transition = "transform .25s cubic-bezier(.4, 0, .2, 1)";
            newEl.style.transform = "none";
          }, 70);
        });
      }
      if (newTab && scrollable.value === true) {
        scrollToTabEl(newTab.rootRef.value);
      }
    }
    function scrollToTabEl(el) {
      const { left, width: width3, top, height: height2 } = contentRef.value.getBoundingClientRect(), newPos = el.getBoundingClientRect();
      let offset2 = props4.vertical === true ? newPos.top - top : newPos.left - left;
      if (offset2 < 0) {
        contentRef.value[props4.vertical === true ? "scrollTop" : "scrollLeft"] += Math.floor(offset2);
        updateArrows();
        return;
      }
      offset2 += props4.vertical === true ? newPos.height - height2 : newPos.width - width3;
      if (offset2 > 0) {
        contentRef.value[props4.vertical === true ? "scrollTop" : "scrollLeft"] += Math.ceil(offset2);
        updateArrows();
      }
    }
    function updateArrows() {
      const content = contentRef.value;
      if (content === null) return;
      const rect = content.getBoundingClientRect(), pos = props4.vertical === true ? content.scrollTop : Math.abs(content.scrollLeft);
      if (isRTL.value === true) {
        leftArrow.value = Math.ceil(pos + rect.width) < content.scrollWidth - 1;
        rightArrow.value = pos > 0;
      } else {
        leftArrow.value = pos > 0;
        rightArrow.value = props4.vertical === true ? Math.ceil(pos + rect.height) < content.scrollHeight : Math.ceil(pos + rect.width) < content.scrollWidth;
      }
    }
    function animScrollTo(value2) {
      scrollTimer !== null && clearInterval(scrollTimer);
      scrollTimer = setInterval(() => {
        if (scrollTowards(value2) === true) {
          stopAnimScroll();
        }
      }, 5);
    }
    function scrollToStart() {
      animScrollTo(rtlPosCorrection.value === true ? Number.MAX_SAFE_INTEGER : 0);
    }
    function scrollToEnd() {
      animScrollTo(rtlPosCorrection.value === true ? 0 : Number.MAX_SAFE_INTEGER);
    }
    function stopAnimScroll() {
      if (scrollTimer !== null) {
        clearInterval(scrollTimer);
        scrollTimer = null;
      }
    }
    function onKbdNavigate(keyCode, fromEl) {
      const tabs = Array.prototype.filter.call(
        contentRef.value.children,
        (el) => el === fromEl || el.matches && el.matches(".q-tab.q-focusable") === true
      );
      const len = tabs.length;
      if (len === 0) return;
      if (keyCode === 36) {
        scrollToTabEl(tabs[0]);
        tabs[0].focus();
        return true;
      }
      if (keyCode === 35) {
        scrollToTabEl(tabs[len - 1]);
        tabs[len - 1].focus();
        return true;
      }
      const dirPrev = keyCode === (props4.vertical === true ? 38 : 37);
      const dirNext = keyCode === (props4.vertical === true ? 40 : 39);
      const dir = dirPrev === true ? -1 : dirNext === true ? 1 : void 0;
      if (dir !== void 0) {
        const rtlDir = isRTL.value === true ? -1 : 1;
        const index = tabs.indexOf(fromEl) + dir * rtlDir;
        if (index >= 0 && index < len) {
          scrollToTabEl(tabs[index]);
          tabs[index].focus({ preventScroll: true });
        }
        return true;
      }
    }
    const posFn = computed(() => rtlPosCorrection.value === true ? { get: (content) => Math.abs(content.scrollLeft), set: (content, pos) => {
      content.scrollLeft = -pos;
    } } : props4.vertical === true ? { get: (content) => content.scrollTop, set: (content, pos) => {
      content.scrollTop = pos;
    } } : { get: (content) => content.scrollLeft, set: (content, pos) => {
      content.scrollLeft = pos;
    } });
    function scrollTowards(value2) {
      const content = contentRef.value, { get: get2, set: set2 } = posFn.value;
      let done = false, pos = get2(content);
      const direction = value2 < pos ? -1 : 1;
      pos += direction * 5;
      if (pos < 0) {
        done = true;
        pos = 0;
      } else if (direction === -1 && pos <= value2 || direction === 1 && pos >= value2) {
        done = true;
        pos = value2;
      }
      set2(content, pos);
      updateArrows();
      return done;
    }
    function hasQueryIncluded(targetQuery, matchingQuery) {
      for (const key in targetQuery) {
        if (targetQuery[key] !== matchingQuery[key]) {
          return false;
        }
      }
      return true;
    }
    function updateActiveRoute() {
      let name2 = null, bestScore = { matchedLen: 0, queryDiff: 9999, hrefLen: 0 };
      const list = tabDataList.filter((tab) => tab.routeData !== void 0 && tab.routeData.hasRouterLink.value === true);
      const { hash: currentHash, query: currentQuery } = proxy.$route;
      const currentQueryLen = Object.keys(currentQuery).length;
      for (const tab of list) {
        const exact = tab.routeData.exact.value === true;
        if (tab.routeData[exact === true ? "linkIsExactActive" : "linkIsActive"].value !== true) {
          continue;
        }
        const { hash, query, matched, href: href2 } = tab.routeData.resolvedLink.value;
        const queryLen = Object.keys(query).length;
        if (exact === true) {
          if (hash !== currentHash) {
            continue;
          }
          if (queryLen !== currentQueryLen || hasQueryIncluded(currentQuery, query) === false) {
            continue;
          }
          name2 = tab.name.value;
          break;
        }
        if (hash !== "" && hash !== currentHash) {
          continue;
        }
        if (queryLen !== 0 && hasQueryIncluded(query, currentQuery) === false) {
          continue;
        }
        const newScore = {
          matchedLen: matched.length,
          queryDiff: currentQueryLen - queryLen,
          hrefLen: href2.length - hash.length
        };
        if (newScore.matchedLen > bestScore.matchedLen) {
          name2 = tab.name.value;
          bestScore = newScore;
          continue;
        } else if (newScore.matchedLen !== bestScore.matchedLen) {
          continue;
        }
        if (newScore.queryDiff < bestScore.queryDiff) {
          name2 = tab.name.value;
          bestScore = newScore;
        } else if (newScore.queryDiff !== bestScore.queryDiff) {
          continue;
        }
        if (newScore.hrefLen > bestScore.hrefLen) {
          name2 = tab.name.value;
          bestScore = newScore;
        }
      }
      if (name2 === null && tabDataList.some((tab) => tab.routeData === void 0 && tab.name.value === currentModel.value) === true) {
        hadActivated = false;
        return;
      }
      updateModel2({ name: name2, setCurrent: true });
    }
    function onFocusin(e2) {
      removeFocusTimeout();
      if (hasFocus.value !== true && rootRef.value !== null && e2.target && typeof e2.target.closest === "function") {
        const tab = e2.target.closest(".q-tab");
        if (tab && rootRef.value.contains(tab) === true) {
          hasFocus.value = true;
          scrollable.value === true && scrollToTabEl(tab);
        }
      }
    }
    function onFocusout() {
      registerFocusTimeout(() => {
        hasFocus.value = false;
      }, 30);
    }
    function verifyRouteModel() {
      if ($tabs.avoidRouteWatcher === false) {
        registerScrollToTabTimeout(updateActiveRoute);
      } else {
        removeScrollToTabTimeout();
      }
    }
    function watchRoute() {
      if (unwatchRoute === void 0) {
        const unwatch = watch(() => proxy.$route.fullPath, verifyRouteModel);
        unwatchRoute = () => {
          unwatch();
          unwatchRoute = void 0;
        };
      }
    }
    function registerTab(tabData) {
      tabDataList.push(tabData);
      tabDataListLen.value++;
      recalculateScroll();
      if (tabData.routeData === void 0 || proxy.$route === void 0) {
        registerScrollToTabTimeout(() => {
          if (scrollable.value === true) {
            const value2 = currentModel.value;
            const newTab = value2 !== void 0 && value2 !== null && value2 !== "" ? tabDataList.find((tab) => tab.name.value === value2) : null;
            newTab && scrollToTabEl(newTab.rootRef.value);
          }
        });
      } else {
        watchRoute();
        if (tabData.routeData.hasRouterLink.value === true) {
          verifyRouteModel();
        }
      }
    }
    function unregisterTab(tabData) {
      tabDataList.splice(tabDataList.indexOf(tabData), 1);
      tabDataListLen.value--;
      recalculateScroll();
      if (unwatchRoute !== void 0 && tabData.routeData !== void 0) {
        if (tabDataList.every((tab) => tab.routeData === void 0) === true) {
          unwatchRoute();
        }
        verifyRouteModel();
      }
    }
    const $tabs = {
      currentModel,
      tabProps,
      hasFocus,
      hasActiveTab,
      registerTab,
      unregisterTab,
      verifyRouteModel,
      updateModel: updateModel2,
      onKbdNavigate,
      avoidRouteWatcher: false
      // false | string (uid)
    };
    provide(tabsKey, $tabs);
    function cleanup() {
      animateTimer !== null && clearTimeout(animateTimer);
      stopAnimScroll();
      unwatchRoute !== void 0 && unwatchRoute();
    }
    let hadRouteWatcher, hadActivated;
    onBeforeUnmount(cleanup);
    onDeactivated(() => {
      hadRouteWatcher = unwatchRoute !== void 0;
      cleanup();
    });
    onActivated(() => {
      if (hadRouteWatcher === true) {
        watchRoute();
        hadActivated = true;
        verifyRouteModel();
      }
      recalculateScroll();
    });
    return () => {
      return h("div", {
        ref: rootRef,
        class: classes.value,
        role: "tablist",
        onFocusin,
        onFocusout
      }, [
        h(QResizeObserver_default, { onResize: updateContainer }),
        h("div", {
          ref: contentRef,
          class: innerClass.value,
          onScroll: updateArrows
        }, hSlot(slots.default)),
        h(QIcon_default, {
          class: "q-tabs__arrow q-tabs__arrow--left absolute q-tab__icon" + (leftArrow.value === true ? "" : " q-tabs__arrow--faded"),
          name: props4.leftIcon || $q.iconSet.tabs[props4.vertical === true ? "up" : "left"],
          onMousedownPassive: scrollToStart,
          onTouchstartPassive: scrollToStart,
          onMouseupPassive: stopAnimScroll,
          onMouseleavePassive: stopAnimScroll,
          onTouchendPassive: stopAnimScroll
        }),
        h(QIcon_default, {
          class: "q-tabs__arrow q-tabs__arrow--right absolute q-tab__icon" + (rightArrow.value === true ? "" : " q-tabs__arrow--faded"),
          name: props4.rightIcon || $q.iconSet.tabs[props4.vertical === true ? "down" : "right"],
          onMousedownPassive: scrollToEnd,
          onTouchstartPassive: scrollToEnd,
          onMouseupPassive: stopAnimScroll,
          onMouseleavePassive: stopAnimScroll,
          onTouchendPassive: stopAnimScroll
        })
      ]);
    };
  }
});
var id = 0;
var useTabEmits = ["click", "keydown"];
var useTabProps = {
  icon: String,
  label: [Number, String],
  alert: [Boolean, String],
  alertIcon: String,
  name: {
    type: [Number, String],
    default: () => `t_${id++}`
  },
  noCaps: Boolean,
  tabindex: [String, Number],
  disable: Boolean,
  contentClass: String,
  ripple: {
    type: [Boolean, Object],
    default: true
  }
};
function use_tab_default(props4, slots, emit, routeData) {
  const $tabs = inject(tabsKey, emptyRenderFn);
  if ($tabs === emptyRenderFn) {
    console.error("QTab/QRouteTab component needs to be child of QTabs");
    return emptyRenderFn;
  }
  const { proxy } = getCurrentInstance();
  const blurTargetRef = ref$1(null);
  const rootRef = ref$1(null);
  const tabIndicatorRef = ref$1(null);
  const ripple = computed(() => props4.disable === true || props4.ripple === false ? false : Object.assign(
    { keyCodes: [13, 32], early: true },
    props4.ripple === true ? {} : props4.ripple
  ));
  const isActive = computed(() => $tabs.currentModel.value === props4.name);
  const classes = computed(
    () => "q-tab relative-position self-stretch flex flex-center text-center" + (isActive.value === true ? " q-tab--active" + ($tabs.tabProps.value.activeClass ? " " + $tabs.tabProps.value.activeClass : "") + ($tabs.tabProps.value.activeColor ? ` text-${$tabs.tabProps.value.activeColor}` : "") + ($tabs.tabProps.value.activeBgColor ? ` bg-${$tabs.tabProps.value.activeBgColor}` : "") : " q-tab--inactive") + (props4.icon && props4.label && $tabs.tabProps.value.inlineLabel === false ? " q-tab--full" : "") + (props4.noCaps === true || $tabs.tabProps.value.noCaps === true ? " q-tab--no-caps" : "") + (props4.disable === true ? " disabled" : " q-focusable q-hoverable cursor-pointer") + (routeData !== void 0 ? routeData.linkClass.value : "")
  );
  const innerClass = computed(
    () => "q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable " + ($tabs.tabProps.value.inlineLabel === true ? "row no-wrap q-tab__content--inline" : "column") + (props4.contentClass !== void 0 ? ` ${props4.contentClass}` : "")
  );
  const tabIndex = computed(() => props4.disable === true || $tabs.hasFocus.value === true || isActive.value === false && $tabs.hasActiveTab.value === true ? -1 : props4.tabindex || 0);
  function onClick(e2, keyboard) {
    if (keyboard !== true && blurTargetRef.value !== null) {
      blurTargetRef.value.focus();
    }
    if (props4.disable === true) {
      if (routeData !== void 0 && routeData.hasRouterLink.value === true) {
        stopAndPrevent(e2);
      }
      return;
    }
    if (routeData === void 0) {
      $tabs.updateModel({ name: props4.name });
      emit("click", e2);
      return;
    }
    if (routeData.hasRouterLink.value === true) {
      const go = (opts = {}) => {
        let hardError;
        const reqId = opts.to === void 0 || isDeepEqual(opts.to, props4.to) === true ? $tabs.avoidRouteWatcher = uid_default() : null;
        return routeData.navigateToRouterLink(e2, { ...opts, returnRouterError: true }).catch((err) => {
          hardError = err;
        }).then((softError) => {
          if (reqId === $tabs.avoidRouteWatcher) {
            $tabs.avoidRouteWatcher = false;
            if (hardError === void 0 && (softError === void 0 || softError.message !== void 0 && softError.message.startsWith("Avoided redundant navigation") === true)) {
              $tabs.updateModel({ name: props4.name });
            }
          }
          if (opts.returnRouterError === true) {
            return hardError !== void 0 ? Promise.reject(hardError) : softError;
          }
        });
      };
      emit("click", e2, go);
      e2.defaultPrevented !== true && go();
      return;
    }
    emit("click", e2);
  }
  function onKeydown2(e2) {
    if (isKeyCode(e2, [13, 32])) {
      onClick(e2, true);
    } else if (shouldIgnoreKey(e2) !== true && e2.keyCode >= 35 && e2.keyCode <= 40 && e2.altKey !== true && e2.metaKey !== true) {
      $tabs.onKbdNavigate(e2.keyCode, proxy.$el) === true && stopAndPrevent(e2);
    }
    emit("keydown", e2);
  }
  function getContent() {
    const narrow = $tabs.tabProps.value.narrowIndicator, content = [], indicator = h("div", {
      ref: tabIndicatorRef,
      class: [
        "q-tab__indicator",
        $tabs.tabProps.value.indicatorClass
      ]
    });
    props4.icon !== void 0 && content.push(
      h(QIcon_default, {
        class: "q-tab__icon",
        name: props4.icon
      })
    );
    props4.label !== void 0 && content.push(
      h("div", { class: "q-tab__label" }, props4.label)
    );
    props4.alert !== false && content.push(
      props4.alertIcon !== void 0 ? h(QIcon_default, {
        class: "q-tab__alert-icon",
        color: props4.alert !== true ? props4.alert : void 0,
        name: props4.alertIcon
      }) : h("div", {
        class: "q-tab__alert" + (props4.alert !== true ? ` text-${props4.alert}` : "")
      })
    );
    narrow === true && content.push(indicator);
    const node = [
      h("div", { class: "q-focus-helper", tabindex: -1, ref: blurTargetRef }),
      h("div", { class: innerClass.value }, hMergeSlot(slots.default, content))
    ];
    narrow === false && node.push(indicator);
    return node;
  }
  const tabData = {
    name: computed(() => props4.name),
    rootRef,
    tabIndicatorRef,
    routeData
  };
  onBeforeUnmount(() => {
    $tabs.unregisterTab(tabData);
  });
  onMounted(() => {
    $tabs.registerTab(tabData);
  });
  function renderTab(tag, customData) {
    const data = {
      ref: rootRef,
      class: classes.value,
      tabindex: tabIndex.value,
      role: "tab",
      "aria-selected": isActive.value === true ? "true" : "false",
      "aria-disabled": props4.disable === true ? "true" : void 0,
      onClick,
      onKeydown: onKeydown2,
      ...customData
    };
    return withDirectives(
      h(tag, data, getContent()),
      [[Ripple_default, ripple.value]]
    );
  }
  return { renderTab, $tabs };
}
var QTab_default = createComponent({
  name: "QTab",
  props: useTabProps,
  emits: useTabEmits,
  setup(props4, { slots, emit }) {
    const { renderTab } = use_tab_default(props4, slots, emit);
    return () => renderTab("div");
  }
});
var QTabPanels_default = createComponent({
  name: "QTabPanels",
  props: {
    ...usePanelProps,
    ...useDarkProps
  },
  emits: usePanelEmits,
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const { updatePanelsList, getPanelContent, panelDirectives } = use_panel_default();
    const classes = computed(
      () => "q-tab-panels q-panel-parent" + (isDark.value === true ? " q-tab-panels--dark q-dark" : "")
    );
    return () => {
      updatePanelsList(slots);
      return hDir(
        "div",
        { class: classes.value },
        getPanelContent(),
        "pan",
        props4.swipeable,
        () => panelDirectives.value
      );
    };
  }
});
var QTabPanel_default = createComponent({
  name: "QTabPanel",
  props: usePanelChildProps,
  setup(_, { slots }) {
    return () => h("div", { class: "q-tab-panel", role: "tabpanel" }, hSlot(slots.default));
  }
});
var hex = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/;
var hexa = /^#[0-9a-fA-F]{4}([0-9a-fA-F]{4})?$/;
var hexOrHexa = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;
var rgb = /^rgb\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5])\)$/;
var rgba = /^rgba\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/;
var testPattern = {
  date: (v) => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v),
  time: (v) => /^([0-1]?\d|2[0-3]):[0-5]\d$/.test(v),
  fulltime: (v) => /^([0-1]?\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(v),
  timeOrFulltime: (v) => /^([0-1]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(v),
  // -- RFC 5322 --
  // -- Added in v2.6.6 --
  // This is a basic helper validation.
  // For something more complex (like RFC 822) you should write and use your own rule.
  // We won't be accepting PRs to enhance the one below because of the reason above.
  // eslint-disable-next-line
  email: (v) => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v),
  hexColor: (v) => hex.test(v),
  hexaColor: (v) => hexa.test(v),
  hexOrHexaColor: (v) => hexOrHexa.test(v),
  rgbColor: (v) => rgb.test(v),
  rgbaColor: (v) => rgba.test(v),
  rgbOrRgbaColor: (v) => rgb.test(v) || rgba.test(v),
  hexOrRgbColor: (v) => hex.test(v) || rgb.test(v),
  hexaOrRgbaColor: (v) => hexa.test(v) || rgba.test(v),
  anyColor: (v) => hexOrHexa.test(v) || rgb.test(v) || rgba.test(v)
};
var reRGBA = /^rgb(a)?\((\d{1,3}),(\d{1,3}),(\d{1,3}),?([01]?\.?\d*?)?\)$/;
function rgbToHex({ r, g, b: b2, a: a3 }) {
  const alpha = a3 !== void 0;
  r = Math.round(r);
  g = Math.round(g);
  b2 = Math.round(b2);
  if (r > 255 || g > 255 || b2 > 255 || alpha && a3 > 100) {
    throw new TypeError("Expected 3 numbers below 256 (and optionally one below 100)");
  }
  a3 = alpha ? (Math.round(255 * a3 / 100) | 1 << 8).toString(16).slice(1) : "";
  return "#" + (b2 | g << 8 | r << 16 | 1 << 24).toString(16).slice(1) + a3;
}
function rgbToString({ r, g, b: b2, a: a3 }) {
  return `rgb${a3 !== void 0 ? "a" : ""}(${r},${g},${b2}${a3 !== void 0 ? "," + a3 / 100 : ""})`;
}
function hexToRgb(hex2) {
  if (typeof hex2 !== "string") {
    throw new TypeError("Expected a string");
  }
  hex2 = hex2.replace(/^#/, "");
  if (hex2.length === 3) {
    hex2 = hex2[0] + hex2[0] + hex2[1] + hex2[1] + hex2[2] + hex2[2];
  } else if (hex2.length === 4) {
    hex2 = hex2[0] + hex2[0] + hex2[1] + hex2[1] + hex2[2] + hex2[2] + hex2[3] + hex2[3];
  }
  const num = parseInt(hex2, 16);
  return hex2.length > 6 ? { r: num >> 24 & 255, g: num >> 16 & 255, b: num >> 8 & 255, a: Math.round((num & 255) / 2.55) } : { r: num >> 16, g: num >> 8 & 255, b: num & 255 };
}
function hsvToRgb({ h: h138, s: s3, v, a: a3 }) {
  let r, g, b2;
  s3 = s3 / 100;
  v = v / 100;
  h138 = h138 / 360;
  const i2 = Math.floor(h138 * 6), f = h138 * 6 - i2, p = v * (1 - s3), q2 = v * (1 - f * s3), t2 = v * (1 - (1 - f) * s3);
  switch (i2 % 6) {
    case 0:
      r = v;
      g = t2;
      b2 = p;
      break;
    case 1:
      r = q2;
      g = v;
      b2 = p;
      break;
    case 2:
      r = p;
      g = v;
      b2 = t2;
      break;
    case 3:
      r = p;
      g = q2;
      b2 = v;
      break;
    case 4:
      r = t2;
      g = p;
      b2 = v;
      break;
    case 5:
      r = v;
      g = p;
      b2 = q2;
      break;
  }
  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b2 * 255),
    a: a3
  };
}
function rgbToHsv({ r, g, b: b2, a: a3 }) {
  const max2 = Math.max(r, g, b2), min2 = Math.min(r, g, b2), d3 = max2 - min2, s3 = max2 === 0 ? 0 : d3 / max2, v = max2 / 255;
  let h138;
  switch (max2) {
    case min2:
      h138 = 0;
      break;
    case r:
      h138 = g - b2 + d3 * (g < b2 ? 6 : 0);
      h138 /= 6 * d3;
      break;
    case g:
      h138 = b2 - r + d3 * 2;
      h138 /= 6 * d3;
      break;
    case b2:
      h138 = r - g + d3 * 4;
      h138 /= 6 * d3;
      break;
  }
  return {
    h: Math.round(h138 * 360),
    s: Math.round(s3 * 100),
    v: Math.round(v * 100),
    a: a3
  };
}
function textToRgb(str) {
  if (typeof str !== "string") {
    throw new TypeError("Expected a string");
  }
  const color = str.replace(/ /g, "");
  const m3 = reRGBA.exec(color);
  if (m3 === null) {
    return hexToRgb(color);
  }
  const rgb2 = {
    r: Math.min(255, parseInt(m3[2], 10)),
    g: Math.min(255, parseInt(m3[3], 10)),
    b: Math.min(255, parseInt(m3[4], 10))
  };
  if (m3[1]) {
    const alpha = parseFloat(m3[5]);
    rgb2.a = Math.min(1, isNaN(alpha) === true ? 1 : alpha) * 100;
  }
  return rgb2;
}
function lighten$2(color, percent) {
  if (typeof color !== "string") {
    throw new TypeError("Expected a string as color");
  }
  if (typeof percent !== "number") {
    throw new TypeError("Expected a numeric percent");
  }
  const rgb2 = textToRgb(color), t2 = percent < 0 ? 0 : 255, p = Math.abs(percent) / 100, R2 = rgb2.r, G2 = rgb2.g, B2 = rgb2.b;
  return "#" + (16777216 + (Math.round((t2 - R2) * p) + R2) * 65536 + (Math.round((t2 - G2) * p) + G2) * 256 + (Math.round((t2 - B2) * p) + B2)).toString(16).slice(1);
}
function luminosity$1(color) {
  if (typeof color !== "string" && (!color || color.r === void 0)) {
    throw new TypeError("Expected a string or a {r, g, b} object as color");
  }
  const rgb2 = typeof color === "string" ? textToRgb(color) : color, r = rgb2.r / 255, g = rgb2.g / 255, b2 = rgb2.b / 255, R2 = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4), G2 = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4), B2 = b2 <= 0.03928 ? b2 / 12.92 : Math.pow((b2 + 0.055) / 1.055, 2.4);
  return 0.2126 * R2 + 0.7152 * G2 + 0.0722 * B2;
}
function brightness(color) {
  if (typeof color !== "string" && (!color || color.r === void 0)) {
    throw new TypeError("Expected a string or a {r, g, b} object as color");
  }
  const rgb2 = typeof color === "string" ? textToRgb(color) : color;
  return (rgb2.r * 299 + rgb2.g * 587 + rgb2.b * 114) / 1e3;
}
function blend(fgColor, bgColor) {
  if (typeof fgColor !== "string" && (!fgColor || fgColor.r === void 0)) {
    throw new TypeError("Expected a string or a {r, g, b[, a]} object as fgColor");
  }
  if (typeof bgColor !== "string" && (!bgColor || bgColor.r === void 0)) {
    throw new TypeError("Expected a string or a {r, g, b[, a]} object as bgColor");
  }
  const rgb1 = typeof fgColor === "string" ? textToRgb(fgColor) : fgColor, r1 = rgb1.r / 255, g1 = rgb1.g / 255, b1 = rgb1.b / 255, a1 = rgb1.a !== void 0 ? rgb1.a / 100 : 1, rgb2 = typeof bgColor === "string" ? textToRgb(bgColor) : bgColor, r2 = rgb2.r / 255, g2 = rgb2.g / 255, b2 = rgb2.b / 255, a22 = rgb2.a !== void 0 ? rgb2.a / 100 : 1, a3 = a1 + a22 * (1 - a1), r = Math.round((r1 * a1 + r2 * a22 * (1 - a1)) / a3 * 255), g = Math.round((g1 * a1 + g2 * a22 * (1 - a1)) / a3 * 255), b3 = Math.round((b1 * a1 + b2 * a22 * (1 - a1)) / a3 * 255);
  const ret = { r, g, b: b3, a: Math.round(a3 * 100) };
  return typeof fgColor === "string" ? rgbToHex(ret) : ret;
}
function changeAlpha(color, offset2) {
  if (typeof color !== "string") {
    throw new TypeError("Expected a string as color");
  }
  if (offset2 === void 0 || offset2 < -1 || offset2 > 1) {
    throw new TypeError("Expected offset to be between -1 and 1");
  }
  const { r, g, b: b2, a: a3 } = textToRgb(color);
  const alpha = a3 !== void 0 ? a3 / 100 : 0;
  return rgbToHex({
    r,
    g,
    b: b2,
    a: Math.round(Math.min(1, Math.max(0, alpha + offset2)) * 100)
  });
}
function getPaletteColor$1(colorName) {
  if (typeof colorName !== "string") {
    throw new TypeError("Expected a string as color");
  }
  const el = document.createElement("div");
  el.className = `text-${colorName} invisible fixed no-pointer-events`;
  document.body.appendChild(el);
  const result = getComputedStyle(el).getPropertyValue("color");
  el.remove();
  return rgbToHex(textToRgb(result));
}
var colors_default = {
  rgbToHex,
  hexToRgb,
  hsvToRgb,
  rgbToHsv,
  textToRgb,
  lighten: lighten$2,
  luminosity: luminosity$1,
  brightness,
  blend,
  changeAlpha,
  getPaletteColor: getPaletteColor$1
};
var palette = [
  "rgb(255,204,204)",
  "rgb(255,230,204)",
  "rgb(255,255,204)",
  "rgb(204,255,204)",
  "rgb(204,255,230)",
  "rgb(204,255,255)",
  "rgb(204,230,255)",
  "rgb(204,204,255)",
  "rgb(230,204,255)",
  "rgb(255,204,255)",
  "rgb(255,153,153)",
  "rgb(255,204,153)",
  "rgb(255,255,153)",
  "rgb(153,255,153)",
  "rgb(153,255,204)",
  "rgb(153,255,255)",
  "rgb(153,204,255)",
  "rgb(153,153,255)",
  "rgb(204,153,255)",
  "rgb(255,153,255)",
  "rgb(255,102,102)",
  "rgb(255,179,102)",
  "rgb(255,255,102)",
  "rgb(102,255,102)",
  "rgb(102,255,179)",
  "rgb(102,255,255)",
  "rgb(102,179,255)",
  "rgb(102,102,255)",
  "rgb(179,102,255)",
  "rgb(255,102,255)",
  "rgb(255,51,51)",
  "rgb(255,153,51)",
  "rgb(255,255,51)",
  "rgb(51,255,51)",
  "rgb(51,255,153)",
  "rgb(51,255,255)",
  "rgb(51,153,255)",
  "rgb(51,51,255)",
  "rgb(153,51,255)",
  "rgb(255,51,255)",
  "rgb(255,0,0)",
  "rgb(255,128,0)",
  "rgb(255,255,0)",
  "rgb(0,255,0)",
  "rgb(0,255,128)",
  "rgb(0,255,255)",
  "rgb(0,128,255)",
  "rgb(0,0,255)",
  "rgb(128,0,255)",
  "rgb(255,0,255)",
  "rgb(245,0,0)",
  "rgb(245,123,0)",
  "rgb(245,245,0)",
  "rgb(0,245,0)",
  "rgb(0,245,123)",
  "rgb(0,245,245)",
  "rgb(0,123,245)",
  "rgb(0,0,245)",
  "rgb(123,0,245)",
  "rgb(245,0,245)",
  "rgb(214,0,0)",
  "rgb(214,108,0)",
  "rgb(214,214,0)",
  "rgb(0,214,0)",
  "rgb(0,214,108)",
  "rgb(0,214,214)",
  "rgb(0,108,214)",
  "rgb(0,0,214)",
  "rgb(108,0,214)",
  "rgb(214,0,214)",
  "rgb(163,0,0)",
  "rgb(163,82,0)",
  "rgb(163,163,0)",
  "rgb(0,163,0)",
  "rgb(0,163,82)",
  "rgb(0,163,163)",
  "rgb(0,82,163)",
  "rgb(0,0,163)",
  "rgb(82,0,163)",
  "rgb(163,0,163)",
  "rgb(92,0,0)",
  "rgb(92,46,0)",
  "rgb(92,92,0)",
  "rgb(0,92,0)",
  "rgb(0,92,46)",
  "rgb(0,92,92)",
  "rgb(0,46,92)",
  "rgb(0,0,92)",
  "rgb(46,0,92)",
  "rgb(92,0,92)",
  "rgb(255,255,255)",
  "rgb(205,205,205)",
  "rgb(178,178,178)",
  "rgb(153,153,153)",
  "rgb(127,127,127)",
  "rgb(102,102,102)",
  "rgb(76,76,76)",
  "rgb(51,51,51)",
  "rgb(25,25,25)",
  "rgb(0,0,0)"
];
var thumbPath = "M5 5 h10 v10 h-10 v-10 z";
var alphaTrackImg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAH0lEQVQoU2NkYGAwZkAFZ5G5jPRRgOYEVDeB3EBjBQBOZwTVugIGyAAAAABJRU5ErkJggg==";
var QColor_default = createComponent({
  name: "QColor",
  props: {
    ...useDarkProps,
    ...useFormProps,
    modelValue: String,
    defaultValue: String,
    defaultView: {
      type: String,
      default: "spectrum",
      validator: (v) => ["spectrum", "tune", "palette"].includes(v)
    },
    formatModel: {
      type: String,
      default: "auto",
      validator: (v) => ["auto", "hex", "rgb", "hexa", "rgba"].includes(v)
    },
    palette: Array,
    noHeader: Boolean,
    noHeaderTabs: Boolean,
    noFooter: Boolean,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    disable: Boolean,
    readonly: Boolean
  },
  emits: ["update:modelValue", "change"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const { getCache } = use_render_cache_default();
    const spectrumRef = ref$1(null);
    const errorIconRef = ref$1(null);
    const forceHex = computed(() => props4.formatModel === "auto" ? null : props4.formatModel.indexOf("hex") !== -1);
    const forceAlpha = computed(() => props4.formatModel === "auto" ? null : props4.formatModel.indexOf("a") !== -1);
    const topView = ref$1(
      props4.formatModel === "auto" ? props4.modelValue === void 0 || props4.modelValue === null || props4.modelValue === "" || props4.modelValue.startsWith("#") ? "hex" : "rgb" : props4.formatModel.startsWith("hex") ? "hex" : "rgb"
    );
    const view = ref$1(props4.defaultView);
    const model = ref$1(parseModel(props4.modelValue || props4.defaultValue));
    const editable = computed(() => props4.disable !== true && props4.readonly !== true);
    const isHex = computed(
      () => props4.modelValue === void 0 || props4.modelValue === null || props4.modelValue === "" || props4.modelValue.startsWith("#")
    );
    const isOutputHex = computed(() => forceHex.value !== null ? forceHex.value : isHex.value);
    const formAttrs = computed(() => ({
      type: "hidden",
      name: props4.name,
      value: model.value[isOutputHex.value === true ? "hex" : "rgb"]
    }));
    const injectFormInput = useFormInject(formAttrs);
    const hasAlpha = computed(() => forceAlpha.value !== null ? forceAlpha.value : model.value.a !== void 0);
    const currentBgColor = computed(() => ({
      backgroundColor: model.value.rgb || "#000"
    }));
    const headerClass = computed(() => {
      const light = model.value.a !== void 0 && model.value.a < 65 ? true : luminosity$1(model.value) > 0.4;
      return `q-color-picker__header-content q-color-picker__header-content--${light ? "light" : "dark"}`;
    });
    const spectrumStyle = computed(() => ({
      background: `hsl(${model.value.h},100%,50%)`
    }));
    const spectrumPointerStyle = computed(() => ({
      top: `${100 - model.value.v}%`,
      [$q.lang.rtl === true ? "right" : "left"]: `${model.value.s}%`
    }));
    const computedPalette = computed(() => props4.palette !== void 0 && props4.palette.length !== 0 ? props4.palette : palette);
    const classes = computed(
      () => "q-color-picker" + (props4.bordered === true ? " q-color-picker--bordered" : "") + (props4.square === true ? " q-color-picker--square no-border-radius" : "") + (props4.flat === true ? " q-color-picker--flat no-shadow" : "") + (props4.disable === true ? " disabled" : "") + (isDark.value === true ? " q-color-picker--dark q-dark" : "")
    );
    const attributes = computed(() => props4.disable === true ? { "aria-disabled": "true" } : {});
    const spectrumDirective = computed(() => {
      return [[
        TouchPan_default,
        onSpectrumPan,
        void 0,
        { prevent: true, stop: true, mouse: true }
      ]];
    });
    watch(() => props4.modelValue, (v) => {
      const localModel = parseModel(v || props4.defaultValue);
      if (localModel.hex !== model.value.hex) {
        model.value = localModel;
      }
    });
    watch(() => props4.defaultValue, (v) => {
      if (!props4.modelValue && v) {
        const localModel = parseModel(v);
        if (localModel.hex !== model.value.hex) {
          model.value = localModel;
        }
      }
    });
    function updateModel2(rgb2, change) {
      model.value.hex = rgbToHex(rgb2);
      model.value.rgb = rgbToString(rgb2);
      model.value.r = rgb2.r;
      model.value.g = rgb2.g;
      model.value.b = rgb2.b;
      model.value.a = rgb2.a;
      const value2 = model.value[isOutputHex.value === true ? "hex" : "rgb"];
      emit("update:modelValue", value2);
      change === true && emit("change", value2);
    }
    function parseModel(v) {
      const alpha = forceAlpha.value !== void 0 ? forceAlpha.value : props4.formatModel === "auto" ? null : props4.formatModel.indexOf("a") !== -1;
      if (typeof v !== "string" || v.length === 0 || testPattern.anyColor(v.replace(/ /g, "")) !== true) {
        return {
          h: 0,
          s: 0,
          v: 0,
          r: 0,
          g: 0,
          b: 0,
          a: alpha === true ? 100 : void 0,
          hex: void 0,
          rgb: void 0
        };
      }
      const model2 = textToRgb(v);
      if (alpha === true && model2.a === void 0) {
        model2.a = 100;
      }
      model2.hex = rgbToHex(model2);
      model2.rgb = rgbToString(model2);
      return Object.assign(model2, rgbToHsv(model2));
    }
    function changeSpectrum(left, top, change) {
      const panel = spectrumRef.value;
      if (panel === null) return;
      const width3 = panel.clientWidth, height2 = panel.clientHeight, rect = panel.getBoundingClientRect();
      let x2 = Math.min(width3, Math.max(0, left - rect.left));
      if ($q.lang.rtl === true) {
        x2 = width3 - x2;
      }
      const y3 = Math.min(height2, Math.max(0, top - rect.top)), s3 = Math.round(100 * x2 / width3), v = Math.round(100 * Math.max(0, Math.min(1, -(y3 / height2) + 1))), rgb2 = hsvToRgb({
        h: model.value.h,
        s: s3,
        v,
        a: hasAlpha.value === true ? model.value.a : void 0
      });
      model.value.s = s3;
      model.value.v = v;
      updateModel2(rgb2, change);
    }
    function onHue(val, change) {
      const h138 = Math.round(val);
      const rgb2 = hsvToRgb({
        h: h138,
        s: model.value.s,
        v: model.value.v,
        a: hasAlpha.value === true ? model.value.a : void 0
      });
      model.value.h = h138;
      updateModel2(rgb2, change);
    }
    function onHueChange(val) {
      onHue(val, true);
    }
    function onNumericChange(value2, formatModel, max2, evt, change) {
      evt !== void 0 && stop(evt);
      if (!/^[0-9]+$/.test(value2)) {
        change === true && proxy.$forceUpdate();
        return;
      }
      const val = Math.floor(Number(value2));
      if (val < 0 || val > max2) {
        change === true && proxy.$forceUpdate();
        return;
      }
      const rgb2 = {
        r: formatModel === "r" ? val : model.value.r,
        g: formatModel === "g" ? val : model.value.g,
        b: formatModel === "b" ? val : model.value.b,
        a: hasAlpha.value === true ? formatModel === "a" ? val : model.value.a : void 0
      };
      if (formatModel !== "a") {
        const hsv = rgbToHsv(rgb2);
        model.value.h = hsv.h;
        model.value.s = hsv.s;
        model.value.v = hsv.v;
      }
      updateModel2(rgb2, change);
      if (evt !== void 0 && change !== true && evt.target.selectionEnd !== void 0) {
        const index = evt.target.selectionEnd;
        nextTick(() => {
          evt.target.setSelectionRange(index, index);
        });
      }
    }
    function onEditorChange(evt, change) {
      let rgb2;
      const inp = evt.target.value;
      stop(evt);
      if (topView.value === "hex") {
        if (inp.length !== (hasAlpha.value === true ? 9 : 7) || !/^#[0-9A-Fa-f]+$/.test(inp)) {
          return true;
        }
        rgb2 = hexToRgb(inp);
      } else {
        let model2;
        if (!inp.endsWith(")")) {
          return true;
        } else if (hasAlpha.value !== true && inp.startsWith("rgb(")) {
          model2 = inp.substring(4, inp.length - 1).split(",").map((n) => parseInt(n, 10));
          if (model2.length !== 3 || !/^rgb\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3}\)$/.test(inp)) {
            return true;
          }
        } else if (hasAlpha.value === true && inp.startsWith("rgba(")) {
          model2 = inp.substring(5, inp.length - 1).split(",");
          if (model2.length !== 4 || !/^rgba\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3},(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/.test(inp)) {
            return true;
          }
          for (let i2 = 0; i2 < 3; i2++) {
            const v2 = parseInt(model2[i2], 10);
            if (v2 < 0 || v2 > 255) {
              return true;
            }
            model2[i2] = v2;
          }
          const v = parseFloat(model2[3]);
          if (v < 0 || v > 1) {
            return true;
          }
          model2[3] = v;
        } else {
          return true;
        }
        if (model2[0] < 0 || model2[0] > 255 || model2[1] < 0 || model2[1] > 255 || model2[2] < 0 || model2[2] > 255 || hasAlpha.value === true && (model2[3] < 0 || model2[3] > 1)) {
          return true;
        }
        rgb2 = {
          r: model2[0],
          g: model2[1],
          b: model2[2],
          a: hasAlpha.value === true ? model2[3] * 100 : void 0
        };
      }
      const hsv = rgbToHsv(rgb2);
      model.value.h = hsv.h;
      model.value.s = hsv.s;
      model.value.v = hsv.v;
      updateModel2(rgb2, change);
      if (change !== true) {
        const index = evt.target.selectionEnd;
        nextTick(() => {
          evt.target.setSelectionRange(index, index);
        });
      }
    }
    function onPalettePick(color) {
      const def = parseModel(color);
      const rgb2 = { r: def.r, g: def.g, b: def.b, a: def.a };
      if (rgb2.a === void 0) {
        rgb2.a = model.value.a;
      }
      model.value.h = def.h;
      model.value.s = def.s;
      model.value.v = def.v;
      updateModel2(rgb2, true);
    }
    function onSpectrumPan(evt) {
      if (evt.isFinal) {
        changeSpectrum(
          evt.position.left,
          evt.position.top,
          true
        );
      } else {
        onSpectrumChange(evt);
      }
    }
    const onSpectrumChange = throttle_default(
      (evt) => {
        changeSpectrum(evt.position.left, evt.position.top);
      },
      20
    );
    function onSpectrumClick(evt) {
      changeSpectrum(
        evt.pageX - window.pageXOffset,
        evt.pageY - window.pageYOffset,
        true
      );
    }
    function onActivate(evt) {
      changeSpectrum(
        evt.pageX - window.pageXOffset,
        evt.pageY - window.pageYOffset
      );
    }
    function updateErrorIcon(val) {
      if (errorIconRef.value !== null) {
        errorIconRef.value.$el.style.opacity = val ? 1 : 0;
      }
    }
    function setTopView(val) {
      topView.value = val;
    }
    function getHeader() {
      const child = [];
      props4.noHeaderTabs !== true && child.push(
        h(QTabs_default, {
          class: "q-color-picker__header-tabs",
          modelValue: topView.value,
          dense: true,
          align: "justify",
          "onUpdate:modelValue": setTopView
        }, () => [
          h(QTab_default, {
            label: "HEX" + (hasAlpha.value === true ? "A" : ""),
            name: "hex",
            ripple: false
          }),
          h(QTab_default, {
            label: "RGB" + (hasAlpha.value === true ? "A" : ""),
            name: "rgb",
            ripple: false
          })
        ])
      );
      child.push(
        h("div", {
          class: "q-color-picker__header-banner row flex-center no-wrap"
        }, [
          h("input", {
            class: "fit",
            value: model.value[topView.value],
            ...editable.value !== true ? { readonly: true } : {},
            ...getCache("topIn", {
              onInput: (evt) => {
                updateErrorIcon(onEditorChange(evt) === true);
              },
              onChange: stop,
              onBlur: (evt) => {
                onEditorChange(evt, true) === true && proxy.$forceUpdate();
                updateErrorIcon(false);
              }
            })
          }),
          h(QIcon_default, {
            ref: errorIconRef,
            class: "q-color-picker__error-icon absolute no-pointer-events",
            name: $q.iconSet.type.negative
          })
        ])
      );
      return h("div", {
        class: "q-color-picker__header relative-position overflow-hidden"
      }, [
        h("div", { class: "q-color-picker__header-bg absolute-full" }),
        h("div", {
          class: headerClass.value,
          style: currentBgColor.value
        }, child)
      ]);
    }
    function getContent() {
      return h(QTabPanels_default, {
        modelValue: view.value,
        animated: true
      }, () => [
        h(QTabPanel_default, {
          class: "q-color-picker__spectrum-tab overflow-hidden",
          name: "spectrum"
        }, getSpectrumTab),
        h(QTabPanel_default, {
          class: "q-pa-md q-color-picker__tune-tab",
          name: "tune"
        }, getTuneTab),
        h(QTabPanel_default, {
          class: "q-color-picker__palette-tab",
          name: "palette"
        }, getPaletteTab)
      ]);
    }
    function setView(val) {
      view.value = val;
    }
    function getFooter() {
      return h("div", {
        class: "q-color-picker__footer relative-position overflow-hidden"
      }, [
        h(QTabs_default, {
          class: "absolute-full",
          modelValue: view.value,
          dense: true,
          align: "justify",
          "onUpdate:modelValue": setView
        }, () => [
          h(QTab_default, {
            icon: $q.iconSet.colorPicker.spectrum,
            name: "spectrum",
            ripple: false
          }),
          h(QTab_default, {
            icon: $q.iconSet.colorPicker.tune,
            name: "tune",
            ripple: false
          }),
          h(QTab_default, {
            icon: $q.iconSet.colorPicker.palette,
            name: "palette",
            ripple: false
          })
        ])
      ]);
    }
    function getSpectrumTab() {
      const data = {
        ref: spectrumRef,
        class: "q-color-picker__spectrum non-selectable relative-position cursor-pointer" + (editable.value !== true ? " readonly" : ""),
        style: spectrumStyle.value,
        ...editable.value === true ? {
          onClick: onSpectrumClick,
          onMousedown: onActivate
        } : {}
      };
      const child = [
        h("div", { style: { paddingBottom: "100%" } }),
        h("div", { class: "q-color-picker__spectrum-white absolute-full" }),
        h("div", { class: "q-color-picker__spectrum-black absolute-full" }),
        h("div", {
          class: "absolute",
          style: spectrumPointerStyle.value
        }, [
          model.value.hex !== void 0 ? h("div", { class: "q-color-picker__spectrum-circle" }) : null
        ])
      ];
      const sliders = [
        h(QSlider_default, {
          class: "q-color-picker__hue non-selectable",
          modelValue: model.value.h,
          min: 0,
          max: 360,
          trackSize: "8px",
          innerTrackColor: "transparent",
          selectionColor: "transparent",
          readonly: editable.value !== true,
          thumbPath,
          "onUpdate:modelValue": onHue,
          onChange: onHueChange
        })
      ];
      hasAlpha.value === true && sliders.push(
        h(QSlider_default, {
          class: "q-color-picker__alpha non-selectable",
          modelValue: model.value.a,
          min: 0,
          max: 100,
          trackSize: "8px",
          trackColor: "white",
          innerTrackColor: "transparent",
          selectionColor: "transparent",
          trackImg: alphaTrackImg,
          readonly: editable.value !== true,
          hideSelection: true,
          thumbPath,
          ...getCache("alphaSlide", {
            "onUpdate:modelValue": (value2) => onNumericChange(value2, "a", 100),
            onChange: (value2) => onNumericChange(value2, "a", 100, void 0, true)
          })
        })
      );
      return [
        hDir("div", data, child, "spec", editable.value, () => spectrumDirective.value),
        h("div", { class: "q-color-picker__sliders" }, sliders)
      ];
    }
    function getTuneTab() {
      return [
        h("div", { class: "row items-center no-wrap" }, [
          h("div", "R"),
          h(QSlider_default, {
            modelValue: model.value.r,
            min: 0,
            max: 255,
            color: "red",
            dark: isDark.value,
            readonly: editable.value !== true,
            ...getCache("rSlide", {
              "onUpdate:modelValue": (value2) => onNumericChange(value2, "r", 255),
              onChange: (value2) => onNumericChange(value2, "r", 255, void 0, true)
            })
          }),
          h("input", {
            value: model.value.r,
            maxlength: 3,
            readonly: editable.value !== true,
            onChange: stop,
            ...getCache("rIn", {
              onInput: (evt) => onNumericChange(evt.target.value, "r", 255, evt),
              onBlur: (evt) => onNumericChange(evt.target.value, "r", 255, evt, true)
            })
          })
        ]),
        h("div", { class: "row items-center no-wrap" }, [
          h("div", "G"),
          h(QSlider_default, {
            modelValue: model.value.g,
            min: 0,
            max: 255,
            color: "green",
            dark: isDark.value,
            readonly: editable.value !== true,
            ...getCache("gSlide", {
              "onUpdate:modelValue": (value2) => onNumericChange(value2, "g", 255),
              onChange: (value2) => onNumericChange(value2, "g", 255, void 0, true)
            })
          }),
          h("input", {
            value: model.value.g,
            maxlength: 3,
            readonly: editable.value !== true,
            onChange: stop,
            ...getCache("gIn", {
              onInput: (evt) => onNumericChange(evt.target.value, "g", 255, evt),
              onBlur: (evt) => onNumericChange(evt.target.value, "g", 255, evt, true)
            })
          })
        ]),
        h("div", { class: "row items-center no-wrap" }, [
          h("div", "B"),
          h(QSlider_default, {
            modelValue: model.value.b,
            min: 0,
            max: 255,
            color: "blue",
            readonly: editable.value !== true,
            dark: isDark.value,
            ...getCache("bSlide", {
              "onUpdate:modelValue": (value2) => onNumericChange(value2, "b", 255),
              onChange: (value2) => onNumericChange(value2, "b", 255, void 0, true)
            })
          }),
          h("input", {
            value: model.value.b,
            maxlength: 3,
            readonly: editable.value !== true,
            onChange: stop,
            ...getCache("bIn", {
              onInput: (evt) => onNumericChange(evt.target.value, "b", 255, evt),
              onBlur: (evt) => onNumericChange(evt.target.value, "b", 255, evt, true)
            })
          })
        ]),
        hasAlpha.value === true ? h("div", { class: "row items-center no-wrap" }, [
          h("div", "A"),
          h(QSlider_default, {
            modelValue: model.value.a,
            color: "grey",
            readonly: editable.value !== true,
            dark: isDark.value,
            ...getCache("aSlide", {
              "onUpdate:modelValue": (value2) => onNumericChange(value2, "a", 100),
              onChange: (value2) => onNumericChange(value2, "a", 100, void 0, true)
            })
          }),
          h("input", {
            value: model.value.a,
            maxlength: 3,
            readonly: editable.value !== true,
            onChange: stop,
            ...getCache("aIn", {
              onInput: (evt) => onNumericChange(evt.target.value, "a", 100, evt),
              onBlur: (evt) => onNumericChange(evt.target.value, "a", 100, evt, true)
            })
          })
        ]) : null
      ];
    }
    function getPaletteTab() {
      const fn = (color) => h("div", {
        class: "q-color-picker__cube col-auto",
        style: { backgroundColor: color },
        ...editable.value === true ? getCache("palette#" + color, {
          onClick: () => {
            onPalettePick(color);
          }
        }) : {}
      });
      return [
        h("div", {
          class: "row items-center q-color-picker__palette-rows" + (editable.value === true ? " q-color-picker__palette-rows--editable" : "")
        }, computedPalette.value.map(fn))
      ];
    }
    return () => {
      const child = [getContent()];
      if (props4.name !== void 0 && props4.disable !== true) {
        injectFormInput(child, "push");
      }
      props4.noHeader !== true && child.unshift(
        getHeader()
      );
      props4.noFooter !== true && child.push(
        getFooter()
      );
      return h("div", {
        class: classes.value,
        ...attributes.value
      }, child);
    };
  }
});
var breaks = [
  -61,
  9,
  38,
  199,
  426,
  686,
  756,
  818,
  1111,
  1181,
  1210,
  1635,
  2060,
  2097,
  2192,
  2262,
  2324,
  2394,
  2456,
  3178
];
function toJalaali(gy, gm, gd) {
  if (Object.prototype.toString.call(gy) === "[object Date]") {
    gd = gy.getDate();
    gm = gy.getMonth() + 1;
    gy = gy.getFullYear();
  }
  return d2j(g2d(gy, gm, gd));
}
function toGregorian(jy, jm, jd) {
  return d2g(j2d(jy, jm, jd));
}
function isLeapJalaaliYear(jy) {
  return jalCalLeap(jy) === 0;
}
function jalaaliMonthLength(jy, jm) {
  if (jm <= 6) return 31;
  if (jm <= 11) return 30;
  if (isLeapJalaaliYear(jy)) return 30;
  return 29;
}
function jalCalLeap(jy) {
  const bl = breaks.length;
  let jp = breaks[0], jm, jump, leap, n, i2;
  if (jy < jp || jy >= breaks[bl - 1]) {
    throw new Error("Invalid Jalaali year " + jy);
  }
  for (i2 = 1; i2 < bl; i2 += 1) {
    jm = breaks[i2];
    jump = jm - jp;
    if (jy < jm) {
      break;
    }
    jp = jm;
  }
  n = jy - jp;
  if (jump - n < 6) {
    n = n - jump + div(jump + 4, 33) * 33;
  }
  leap = mod(mod(n + 1, 33) - 1, 4);
  if (leap === -1) {
    leap = 4;
  }
  return leap;
}
function jalCal(jy, withoutLeap) {
  const bl = breaks.length, gy = jy + 621;
  let leapJ = -14, jp = breaks[0], jm, jump, leap, n, i2;
  if (jy < jp || jy >= breaks[bl - 1]) {
    throw new Error("Invalid Jalaali year " + jy);
  }
  for (i2 = 1; i2 < bl; i2 += 1) {
    jm = breaks[i2];
    jump = jm - jp;
    if (jy < jm) {
      break;
    }
    leapJ = leapJ + div(jump, 33) * 8 + div(mod(jump, 33), 4);
    jp = jm;
  }
  n = jy - jp;
  leapJ = leapJ + div(n, 33) * 8 + div(mod(n, 33) + 3, 4);
  if (mod(jump, 33) === 4 && jump - n === 4) {
    leapJ += 1;
  }
  const leapG = div(gy, 4) - div((div(gy, 100) + 1) * 3, 4) - 150;
  const march = 20 + leapJ - leapG;
  if (!withoutLeap) {
    if (jump - n < 6) {
      n = n - jump + div(jump + 4, 33) * 33;
    }
    leap = mod(mod(n + 1, 33) - 1, 4);
    if (leap === -1) {
      leap = 4;
    }
  }
  return {
    leap,
    gy,
    march
  };
}
function j2d(jy, jm, jd) {
  const r = jalCal(jy, true);
  return g2d(r.gy, 3, r.march) + (jm - 1) * 31 - div(jm, 7) * (jm - 7) + jd - 1;
}
function d2j(jdn) {
  const gy = d2g(jdn).gy;
  let jy = gy - 621, jd, jm, k2;
  const r = jalCal(jy, false), jdn1f = g2d(gy, 3, r.march);
  k2 = jdn - jdn1f;
  if (k2 >= 0) {
    if (k2 <= 185) {
      jm = 1 + div(k2, 31);
      jd = mod(k2, 31) + 1;
      return {
        jy,
        jm,
        jd
      };
    } else {
      k2 -= 186;
    }
  } else {
    jy -= 1;
    k2 += 179;
    if (r.leap === 1) {
      k2 += 1;
    }
  }
  jm = 7 + div(k2, 30);
  jd = mod(k2, 30) + 1;
  return {
    jy,
    jm,
    jd
  };
}
function g2d(gy, gm, gd) {
  let d3 = div((gy + div(gm - 8, 6) + 100100) * 1461, 4) + div(153 * mod(gm + 9, 12) + 2, 5) + gd - 34840408;
  d3 = d3 - div(div(gy + 100100 + div(gm - 8, 6), 100) * 3, 4) + 752;
  return d3;
}
function d2g(jdn) {
  let j = 4 * jdn + 139361631;
  j = j + div(div(4 * jdn + 183187720, 146097) * 3, 4) * 4 - 3908;
  const i2 = div(mod(j, 1461), 4) * 5 + 308, gd = div(mod(i2, 153), 5) + 1, gm = mod(div(i2, 153), 12) + 1, gy = div(j, 1461) - 100100 + div(8 - gm, 6);
  return {
    gy,
    gm,
    gd
  };
}
function div(a3, b2) {
  return ~~(a3 / b2);
}
function mod(a3, b2) {
  return a3 - ~~(a3 / b2) * b2;
}
var calendars = ["gregorian", "persian"];
var useDatetimeProps = {
  // should define modelValue in the target component
  mask: {
    type: String
  },
  locale: Object,
  calendar: {
    type: String,
    validator: (v) => calendars.includes(v),
    default: "gregorian"
  },
  landscape: Boolean,
  color: String,
  textColor: String,
  square: Boolean,
  flat: Boolean,
  bordered: Boolean,
  readonly: Boolean,
  disable: Boolean
};
var useDatetimeEmits = ["update:modelValue"];
function getDayHash(date) {
  return date.year + "/" + pad(date.month) + "/" + pad(date.day);
}
function use_datetime_default(props4, $q) {
  const editable = computed(() => {
    return props4.disable !== true && props4.readonly !== true;
  });
  const tabindex = computed(() => {
    return editable.value === true ? 0 : -1;
  });
  const headerClass = computed(() => {
    const cls = [];
    props4.color !== void 0 && cls.push(`bg-${props4.color}`);
    props4.textColor !== void 0 && cls.push(`text-${props4.textColor}`);
    return cls.join(" ");
  });
  function getLocale2() {
    return props4.locale !== void 0 ? { ...$q.lang.date, ...props4.locale } : $q.lang.date;
  }
  function getCurrentDate(dateOnly) {
    const d3 = /* @__PURE__ */ new Date();
    const timeFill = dateOnly === true ? null : 0;
    if (props4.calendar === "persian") {
      const jDate = toJalaali(d3);
      return {
        year: jDate.jy,
        month: jDate.jm,
        day: jDate.jd
      };
    }
    return {
      year: d3.getFullYear(),
      month: d3.getMonth() + 1,
      day: d3.getDate(),
      hour: timeFill,
      minute: timeFill,
      second: timeFill,
      millisecond: timeFill
    };
  }
  return {
    editable,
    tabindex,
    headerClass,
    getLocale: getLocale2,
    getCurrentDate
  };
}
var MILLISECONDS_IN_DAY = 864e5;
var MILLISECONDS_IN_HOUR = 36e5;
var MILLISECONDS_IN_MINUTE = 6e4;
var defaultMask = "YYYY-MM-DDTHH:mm:ss.SSSZ";
var token = /\[((?:[^\]\\]|\\]|\\)*)\]|do|d{1,4}|Mo|M{1,4}|m{1,2}|wo|w{1,2}|Qo|Do|DDDo|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]/g;
var reverseToken = /(\[[^\]]*\])|do|d{1,4}|Mo|M{1,4}|m{1,2}|wo|w{1,2}|Qo|Do|DDDo|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]|([.*+:?^,\s${}()|\\]+)/g;
var regexStore = {};
function getRegexData(mask, dateLocale) {
  const days = "(" + dateLocale.days.join("|") + ")", key = mask + days;
  if (regexStore[key] !== void 0) {
    return regexStore[key];
  }
  const daysShort = "(" + dateLocale.daysShort.join("|") + ")", months = "(" + dateLocale.months.join("|") + ")", monthsShort = "(" + dateLocale.monthsShort.join("|") + ")";
  const map = {};
  let index = 0;
  const regexText = mask.replace(reverseToken, (match2) => {
    index++;
    switch (match2) {
      case "YY":
        map.YY = index;
        return "(-?\\d{1,2})";
      case "YYYY":
        map.YYYY = index;
        return "(-?\\d{1,4})";
      case "M":
        map.M = index;
        return "(\\d{1,2})";
      case "Mo":
        map.M = index++;
        return "(\\d{1,2}(st|nd|rd|th))";
      case "MM":
        map.M = index;
        return "(\\d{2})";
      case "MMM":
        map.MMM = index;
        return monthsShort;
      case "MMMM":
        map.MMMM = index;
        return months;
      case "D":
        map.D = index;
        return "(\\d{1,2})";
      case "Do":
        map.D = index++;
        return "(\\d{1,2}(st|nd|rd|th))";
      case "DD":
        map.D = index;
        return "(\\d{2})";
      case "H":
        map.H = index;
        return "(\\d{1,2})";
      case "HH":
        map.H = index;
        return "(\\d{2})";
      case "h":
        map.h = index;
        return "(\\d{1,2})";
      case "hh":
        map.h = index;
        return "(\\d{2})";
      case "m":
        map.m = index;
        return "(\\d{1,2})";
      case "mm":
        map.m = index;
        return "(\\d{2})";
      case "s":
        map.s = index;
        return "(\\d{1,2})";
      case "ss":
        map.s = index;
        return "(\\d{2})";
      case "S":
        map.S = index;
        return "(\\d{1})";
      case "SS":
        map.S = index;
        return "(\\d{2})";
      case "SSS":
        map.S = index;
        return "(\\d{3})";
      case "A":
        map.A = index;
        return "(AM|PM)";
      case "a":
        map.a = index;
        return "(am|pm)";
      case "aa":
        map.aa = index;
        return "(a\\.m\\.|p\\.m\\.)";
      case "ddd":
        return daysShort;
      case "dddd":
        return days;
      case "Q":
      case "d":
      case "E":
        return "(\\d{1})";
      case "do":
        index++;
        return "(\\d{1}(st|nd|rd|th))";
      case "Qo":
        return "(1st|2nd|3rd|4th)";
      case "DDD":
      case "DDDD":
        return "(\\d{1,3})";
      case "DDDo":
        index++;
        return "(\\d{1,3}(st|nd|rd|th))";
      case "w":
        return "(\\d{1,2})";
      case "wo":
        index++;
        return "(\\d{1,2}(st|nd|rd|th))";
      case "ww":
        return "(\\d{2})";
      case "Z":
        map.Z = index;
        return "(Z|[+-]\\d{2}:\\d{2})";
      case "ZZ":
        map.ZZ = index;
        return "(Z|[+-]\\d{2}\\d{2})";
      case "X":
        map.X = index;
        return "(-?\\d+)";
      case "x":
        map.x = index;
        return "(-?\\d{4,})";
      default:
        index--;
        if (match2[0] === "[") {
          match2 = match2.substring(1, match2.length - 1);
        }
        return match2.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
  });
  const res = { map, regex: new RegExp("^" + regexText) };
  regexStore[key] = res;
  return res;
}
function getDateLocale(paramDateLocale, langProps) {
  return paramDateLocale !== void 0 ? paramDateLocale : langProps !== void 0 ? langProps.date : en_US_default.date;
}
function formatTimezone(offset2, delimeter = "") {
  const sign3 = offset2 > 0 ? "-" : "+", absOffset = Math.abs(offset2), hours = Math.floor(absOffset / 60), minutes = absOffset % 60;
  return sign3 + pad(hours) + delimeter + pad(minutes);
}
function __splitDate(str, mask, dateLocale, calendar, defaultModel) {
  const date = {
    year: null,
    month: null,
    day: null,
    hour: null,
    minute: null,
    second: null,
    millisecond: null,
    timezoneOffset: null,
    dateHash: null,
    timeHash: null
  };
  defaultModel !== void 0 && Object.assign(date, defaultModel);
  if (str === void 0 || str === null || str === "" || typeof str !== "string") {
    return date;
  }
  if (mask === void 0) {
    mask = defaultMask;
  }
  const langOpts = getDateLocale(dateLocale, Lang_default.props), months = langOpts.months, monthsShort = langOpts.monthsShort;
  const { regex, map } = getRegexData(mask, langOpts);
  const match2 = str.match(regex);
  if (match2 === null) {
    return date;
  }
  let tzString = "";
  if (map.X !== void 0 || map.x !== void 0) {
    const stamp = parseInt(match2[map.X !== void 0 ? map.X : map.x], 10);
    if (isNaN(stamp) === true || stamp < 0) {
      return date;
    }
    const d3 = new Date(stamp * (map.X !== void 0 ? 1e3 : 1));
    date.year = d3.getFullYear();
    date.month = d3.getMonth() + 1;
    date.day = d3.getDate();
    date.hour = d3.getHours();
    date.minute = d3.getMinutes();
    date.second = d3.getSeconds();
    date.millisecond = d3.getMilliseconds();
  } else {
    if (map.YYYY !== void 0) {
      date.year = parseInt(match2[map.YYYY], 10);
    } else if (map.YY !== void 0) {
      const y3 = parseInt(match2[map.YY], 10);
      date.year = y3 < 0 ? y3 : 2e3 + y3;
    }
    if (map.M !== void 0) {
      date.month = parseInt(match2[map.M], 10);
      if (date.month < 1 || date.month > 12) {
        return date;
      }
    } else if (map.MMM !== void 0) {
      date.month = monthsShort.indexOf(match2[map.MMM]) + 1;
    } else if (map.MMMM !== void 0) {
      date.month = months.indexOf(match2[map.MMMM]) + 1;
    }
    if (map.D !== void 0) {
      date.day = parseInt(match2[map.D], 10);
      if (date.year === null || date.month === null || date.day < 1) {
        return date;
      }
      const maxDay = calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
      if (date.day > maxDay) {
        return date;
      }
    }
    if (map.H !== void 0) {
      date.hour = parseInt(match2[map.H], 10) % 24;
    } else if (map.h !== void 0) {
      date.hour = parseInt(match2[map.h], 10) % 12;
      if (map.A && match2[map.A] === "PM" || map.a && match2[map.a] === "pm" || map.aa && match2[map.aa] === "p.m.") {
        date.hour += 12;
      }
      date.hour = date.hour % 24;
    }
    if (map.m !== void 0) {
      date.minute = parseInt(match2[map.m], 10) % 60;
    }
    if (map.s !== void 0) {
      date.second = parseInt(match2[map.s], 10) % 60;
    }
    if (map.S !== void 0) {
      date.millisecond = parseInt(match2[map.S], 10) * 10 ** (3 - match2[map.S].length);
    }
    if (map.Z !== void 0 || map.ZZ !== void 0) {
      tzString = map.Z !== void 0 ? match2[map.Z].replace(":", "") : match2[map.ZZ];
      date.timezoneOffset = (tzString[0] === "+" ? -1 : 1) * (60 * tzString.slice(1, 3) + 1 * tzString.slice(3, 5));
    }
  }
  date.dateHash = pad(date.year, 6) + "/" + pad(date.month) + "/" + pad(date.day);
  date.timeHash = pad(date.hour) + ":" + pad(date.minute) + ":" + pad(date.second) + tzString;
  return date;
}
function getWeekOfYear(date) {
  const thursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  thursday.setDate(thursday.getDate() - (thursday.getDay() + 6) % 7 + 3);
  const firstThursday = new Date(thursday.getFullYear(), 0, 4);
  firstThursday.setDate(firstThursday.getDate() - (firstThursday.getDay() + 6) % 7 + 3);
  const ds = thursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
  thursday.setHours(thursday.getHours() - ds);
  const weekDiff = (thursday - firstThursday) / (MILLISECONDS_IN_DAY * 7);
  return 1 + Math.floor(weekDiff);
}
function startOfDate(date, unit, utc) {
  const t2 = new Date(date), prefix = `set${utc === true ? "UTC" : ""}`;
  switch (unit) {
    case "year":
    case "years":
      t2[`${prefix}Month`](0);
    case "month":
    case "months":
      t2[`${prefix}Date`](1);
    case "day":
    case "days":
    case "date":
      t2[`${prefix}Hours`](0);
    case "hour":
    case "hours":
      t2[`${prefix}Minutes`](0);
    case "minute":
    case "minutes":
      t2[`${prefix}Seconds`](0);
    case "second":
    case "seconds":
      t2[`${prefix}Milliseconds`](0);
  }
  return t2;
}
function getDiff(t2, sub, interval) {
  return (t2.getTime() - t2.getTimezoneOffset() * MILLISECONDS_IN_MINUTE - (sub.getTime() - sub.getTimezoneOffset() * MILLISECONDS_IN_MINUTE)) / interval;
}
function getDateDiff(date, subtract, unit = "days") {
  const t2 = new Date(date), sub = new Date(subtract);
  switch (unit) {
    case "years":
    case "year":
      return t2.getFullYear() - sub.getFullYear();
    case "months":
    case "month":
      return (t2.getFullYear() - sub.getFullYear()) * 12 + t2.getMonth() - sub.getMonth();
    case "days":
    case "day":
    case "date":
      return getDiff(startOfDate(t2, "day"), startOfDate(sub, "day"), MILLISECONDS_IN_DAY);
    case "hours":
    case "hour":
      return getDiff(startOfDate(t2, "hour"), startOfDate(sub, "hour"), MILLISECONDS_IN_HOUR);
    case "minutes":
    case "minute":
      return getDiff(startOfDate(t2, "minute"), startOfDate(sub, "minute"), MILLISECONDS_IN_MINUTE);
    case "seconds":
    case "second":
      return getDiff(startOfDate(t2, "second"), startOfDate(sub, "second"), 1e3);
  }
}
function getDayOfYear(date) {
  return getDateDiff(date, startOfDate(date, "year"), "days") + 1;
}
function getOrdinal(n) {
  if (n >= 11 && n <= 13) {
    return `${n}th`;
  }
  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
  }
  return `${n}th`;
}
var formatter = {
  // Year: 00, 01, ..., 99
  YY(date, dateLocale, forcedYear) {
    const y3 = this.YYYY(date, dateLocale, forcedYear) % 100;
    return y3 >= 0 ? pad(y3) : "-" + pad(Math.abs(y3));
  },
  // Year: 1900, 1901, ..., 2099
  YYYY(date, _dateLocale, forcedYear) {
    return forcedYear !== void 0 && forcedYear !== null ? forcedYear : date.getFullYear();
  },
  // Month: 1, 2, ..., 12
  M(date) {
    return date.getMonth() + 1;
  },
  // Month: 1st, 2nd, ..., 12th
  Mo(date) {
    return getOrdinal(date.getMonth() + 1);
  },
  // Month: 01, 02, ..., 12
  MM(date) {
    return pad(date.getMonth() + 1);
  },
  // Month Short Name: Jan, Feb, ...
  MMM(date, dateLocale) {
    return dateLocale.monthsShort[date.getMonth()];
  },
  // Month Name: January, February, ...
  MMMM(date, dateLocale) {
    return dateLocale.months[date.getMonth()];
  },
  // Quarter: 1, 2, 3, 4
  Q(date) {
    return Math.ceil((date.getMonth() + 1) / 3);
  },
  // Quarter: 1st, 2nd, 3rd, 4th
  Qo(date) {
    return getOrdinal(this.Q(date));
  },
  // Day of month: 1, 2, ..., 31
  D(date) {
    return date.getDate();
  },
  // Day of month: 1st, 2nd, ..., 31st
  Do(date) {
    return getOrdinal(date.getDate());
  },
  // Day of month: 01, 02, ..., 31
  DD(date) {
    return pad(date.getDate());
  },
  // Day of year: 1, 2, ..., 366
  DDD(date) {
    return getDayOfYear(date);
  },
  // Day of year: 1st, 2nd, ..., 366th
  DDDo(date) {
    return getOrdinal(getDayOfYear(date));
  },
  // Day of year: 001, 002, ..., 366
  DDDD(date) {
    return pad(getDayOfYear(date), 3);
  },
  // Day of week: 0, 1, ..., 6
  d(date) {
    return date.getDay();
  },
  // Day of week: 0th, 1st, ..., 6th
  do(date) {
    return getOrdinal(date.getDay());
  },
  // Day of week: Su, Mo, ...
  dd(date, dateLocale) {
    return dateLocale.days[date.getDay()].slice(0, 2);
  },
  // Day of week: Sun, Mon, ...
  ddd(date, dateLocale) {
    return dateLocale.daysShort[date.getDay()];
  },
  // Day of week: Sunday, Monday, ...
  dddd(date, dateLocale) {
    return dateLocale.days[date.getDay()];
  },
  // Day of ISO week: 1, 2, ..., 7
  E(date) {
    return date.getDay() || 7;
  },
  // Week of Year: 1 2 ... 52 53
  w(date) {
    return getWeekOfYear(date);
  },
  // Week of Year: 1st 2nd ... 52nd 53rd
  wo(date) {
    return getOrdinal(getWeekOfYear(date));
  },
  // Week of Year: 01 02 ... 52 53
  ww(date) {
    return pad(getWeekOfYear(date));
  },
  // Hour: 0, 1, ... 23
  H(date) {
    return date.getHours();
  },
  // Hour: 00, 01, ..., 23
  HH(date) {
    return pad(date.getHours());
  },
  // Hour: 1, 2, ..., 12
  h(date) {
    const hours = date.getHours();
    return hours === 0 ? 12 : hours > 12 ? hours % 12 : hours;
  },
  // Hour: 01, 02, ..., 12
  hh(date) {
    return pad(this.h(date));
  },
  // Minute: 0, 1, ..., 59
  m(date) {
    return date.getMinutes();
  },
  // Minute: 00, 01, ..., 59
  mm(date) {
    return pad(date.getMinutes());
  },
  // Second: 0, 1, ..., 59
  s(date) {
    return date.getSeconds();
  },
  // Second: 00, 01, ..., 59
  ss(date) {
    return pad(date.getSeconds());
  },
  // 1/10 of second: 0, 1, ..., 9
  S(date) {
    return Math.floor(date.getMilliseconds() / 100);
  },
  // 1/100 of second: 00, 01, ..., 99
  SS(date) {
    return pad(Math.floor(date.getMilliseconds() / 10));
  },
  // Millisecond: 000, 001, ..., 999
  SSS(date) {
    return pad(date.getMilliseconds(), 3);
  },
  // Meridiem: AM, PM
  A(date) {
    return date.getHours() < 12 ? "AM" : "PM";
  },
  // Meridiem: am, pm
  a(date) {
    return date.getHours() < 12 ? "am" : "pm";
  },
  // Meridiem: a.m., p.m.
  aa(date) {
    return date.getHours() < 12 ? "a.m." : "p.m.";
  },
  // Timezone: -01:00, +00:00, ... +12:00
  Z(date, _dateLocale, _forcedYear, forcedTimezoneOffset) {
    const tzOffset = forcedTimezoneOffset === void 0 || forcedTimezoneOffset === null ? date.getTimezoneOffset() : forcedTimezoneOffset;
    return formatTimezone(tzOffset, ":");
  },
  // Timezone: -0100, +0000, ... +1200
  ZZ(date, _dateLocale, _forcedYear, forcedTimezoneOffset) {
    const tzOffset = forcedTimezoneOffset === void 0 || forcedTimezoneOffset === null ? date.getTimezoneOffset() : forcedTimezoneOffset;
    return formatTimezone(tzOffset);
  },
  // Seconds timestamp: 512969520
  X(date) {
    return Math.floor(date.getTime() / 1e3);
  },
  // Milliseconds timestamp: 512969520900
  x(date) {
    return date.getTime();
  }
};
function formatDate(val, mask, dateLocale, __forcedYear, __forcedTimezoneOffset) {
  if (val !== 0 && !val || val === Infinity || val === -Infinity) {
    return;
  }
  const date = new Date(val);
  if (isNaN(date)) {
    return;
  }
  if (mask === void 0) {
    mask = defaultMask;
  }
  const locale2 = getDateLocale(dateLocale, Lang_default.props);
  return mask.replace(
    token,
    (match2, text) => match2 in formatter ? formatter[match2](date, locale2, __forcedYear, __forcedTimezoneOffset) : text === void 0 ? match2 : text.split("\\]").join("]")
  );
}
var yearsInterval = 20;
var views = ["Calendar", "Years", "Months"];
var viewIsValid = (v) => views.includes(v);
var yearMonthValidator = (v) => /^-?[\d]+\/[0-1]\d$/.test(v);
var lineStr = " — ";
function getMonthHash(date) {
  return date.year + "/" + pad(date.month);
}
var QDate_default = createComponent({
  name: "QDate",
  props: {
    ...useDatetimeProps,
    ...useFormProps,
    ...useDarkProps,
    modelValue: {
      required: true,
      validator: (val) => typeof val === "string" || Array.isArray(val) === true || Object(val) === val || val === null
    },
    multiple: Boolean,
    range: Boolean,
    title: String,
    subtitle: String,
    mask: {
      ...useDatetimeProps.mask,
      // this mask is forced
      // when using persian calendar
      default: "YYYY/MM/DD"
    },
    defaultYearMonth: {
      type: String,
      validator: yearMonthValidator
    },
    yearsInMonthView: Boolean,
    events: [Array, Function],
    eventColor: [String, Function],
    emitImmediately: Boolean,
    options: [Array, Function],
    navigationMinYearMonth: {
      type: String,
      validator: yearMonthValidator
    },
    navigationMaxYearMonth: {
      type: String,
      validator: yearMonthValidator
    },
    noUnset: Boolean,
    firstDayOfWeek: [String, Number],
    todayBtn: Boolean,
    minimal: Boolean,
    defaultView: {
      type: String,
      default: "Calendar",
      validator: viewIsValid
    }
  },
  emits: [
    ...useDatetimeEmits,
    "rangeStart",
    "rangeEnd",
    "navigation"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const { getCache } = use_render_cache_default();
    const { tabindex, headerClass, getLocale: getLocale2, getCurrentDate } = use_datetime_default(props4, $q);
    let lastEmitValue;
    const formAttrs = useFormAttrs(props4);
    const injectFormInput = useFormInject(formAttrs);
    const blurTargetRef = ref$1(null);
    const innerMask = ref$1(getMask());
    const innerLocale = ref$1(getLocale2());
    const mask = computed(() => getMask());
    const locale2 = computed(() => getLocale2());
    const today = computed(() => getCurrentDate());
    const viewModel = ref$1(getViewModel(innerMask.value, innerLocale.value));
    const view = ref$1(props4.defaultView);
    const direction = computed(() => $q.lang.rtl === true ? "right" : "left");
    const monthDirection = ref$1(direction.value);
    const yearDirection = ref$1(direction.value);
    const year = viewModel.value.year;
    const startYear = ref$1(year - year % yearsInterval - (year < 0 ? yearsInterval : 0));
    const editRange = ref$1(null);
    const classes = computed(() => {
      const type2 = props4.landscape === true ? "landscape" : "portrait";
      return `q-date q-date--${type2} q-date--${type2}-${props4.minimal === true ? "minimal" : "standard"}` + (isDark.value === true ? " q-date--dark q-dark" : "") + (props4.bordered === true ? " q-date--bordered" : "") + (props4.square === true ? " q-date--square no-border-radius" : "") + (props4.flat === true ? " q-date--flat no-shadow" : "") + (props4.disable === true ? " disabled" : props4.readonly === true ? " q-date--readonly" : "");
    });
    const computedColor = computed(() => {
      return props4.color || "primary";
    });
    const computedTextColor = computed(() => {
      return props4.textColor || "white";
    });
    const isImmediate = computed(
      () => props4.emitImmediately === true && props4.multiple !== true && props4.range !== true
    );
    const normalizedModel = computed(() => Array.isArray(props4.modelValue) === true ? props4.modelValue : props4.modelValue !== null && props4.modelValue !== void 0 ? [props4.modelValue] : []);
    const daysModel = computed(
      () => normalizedModel.value.filter((date) => typeof date === "string").map((date) => decodeString(date, innerMask.value, innerLocale.value)).filter(
        (date) => date.dateHash !== null && date.day !== null && date.month !== null && date.year !== null
      )
    );
    const rangeModel = computed(() => {
      const fn = (date) => decodeString(date, innerMask.value, innerLocale.value);
      return normalizedModel.value.filter((date) => isObject(date) === true && date.from !== void 0 && date.to !== void 0).map((range2) => ({ from: fn(range2.from), to: fn(range2.to) })).filter((range2) => range2.from.dateHash !== null && range2.to.dateHash !== null && range2.from.dateHash < range2.to.dateHash);
    });
    const getNativeDateFn = computed(() => props4.calendar !== "persian" ? (model) => new Date(model.year, model.month - 1, model.day) : (model) => {
      const gDate = toGregorian(model.year, model.month, model.day);
      return new Date(gDate.gy, gDate.gm - 1, gDate.gd);
    });
    const encodeObjectFn = computed(() => props4.calendar === "persian" ? getDayHash : (date, mask2, locale22) => formatDate(
      new Date(
        date.year,
        date.month - 1,
        date.day,
        date.hour,
        date.minute,
        date.second,
        date.millisecond
      ),
      mask2 === void 0 ? innerMask.value : mask2,
      locale22 === void 0 ? innerLocale.value : locale22,
      date.year,
      date.timezoneOffset
    ));
    const daysInModel = computed(
      () => daysModel.value.length + rangeModel.value.reduce(
        (acc, range2) => acc + 1 + getDateDiff(
          getNativeDateFn.value(range2.to),
          getNativeDateFn.value(range2.from)
        ),
        0
      )
    );
    const headerTitle = computed(() => {
      if (props4.title !== void 0 && props4.title !== null && props4.title.length !== 0) {
        return props4.title;
      }
      if (editRange.value !== null) {
        const model2 = editRange.value.init;
        const date2 = getNativeDateFn.value(model2);
        return innerLocale.value.daysShort[date2.getDay()] + ", " + innerLocale.value.monthsShort[model2.month - 1] + " " + model2.day + lineStr + "?";
      }
      if (daysInModel.value === 0) {
        return lineStr;
      }
      if (daysInModel.value > 1) {
        return `${daysInModel.value} ${innerLocale.value.pluralDay}`;
      }
      const model = daysModel.value[0];
      const date = getNativeDateFn.value(model);
      if (isNaN(date.valueOf()) === true) {
        return lineStr;
      }
      if (innerLocale.value.headerTitle !== void 0) {
        return innerLocale.value.headerTitle(date, model);
      }
      return innerLocale.value.daysShort[date.getDay()] + ", " + innerLocale.value.monthsShort[model.month - 1] + " " + model.day;
    });
    const minSelectedModel = computed(() => {
      const model = daysModel.value.concat(rangeModel.value.map((range2) => range2.from)).sort((a3, b2) => a3.year - b2.year || a3.month - b2.month);
      return model[0];
    });
    const maxSelectedModel = computed(() => {
      const model = daysModel.value.concat(rangeModel.value.map((range2) => range2.to)).sort((a3, b2) => b2.year - a3.year || b2.month - a3.month);
      return model[0];
    });
    const headerSubtitle = computed(() => {
      if (props4.subtitle !== void 0 && props4.subtitle !== null && props4.subtitle.length !== 0) {
        return props4.subtitle;
      }
      if (daysInModel.value === 0) {
        return lineStr;
      }
      if (daysInModel.value > 1) {
        const from = minSelectedModel.value;
        const to = maxSelectedModel.value;
        const month = innerLocale.value.monthsShort;
        return month[from.month - 1] + (from.year !== to.year ? " " + from.year + lineStr + month[to.month - 1] + " " : from.month !== to.month ? lineStr + month[to.month - 1] : "") + " " + to.year;
      }
      return daysModel.value[0].year;
    });
    const dateArrow = computed(() => {
      const val = [$q.iconSet.datetime.arrowLeft, $q.iconSet.datetime.arrowRight];
      return $q.lang.rtl === true ? val.reverse() : val;
    });
    const computedFirstDayOfWeek = computed(() => props4.firstDayOfWeek !== void 0 ? Number(props4.firstDayOfWeek) : innerLocale.value.firstDayOfWeek);
    const daysOfWeek = computed(() => {
      const days2 = innerLocale.value.daysShort, first = computedFirstDayOfWeek.value;
      return first > 0 ? days2.slice(first, 7).concat(days2.slice(0, first)) : days2;
    });
    const daysInMonth2 = computed(() => {
      const date = viewModel.value;
      return props4.calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
    });
    const evtColor = computed(() => typeof props4.eventColor === "function" ? props4.eventColor : () => props4.eventColor);
    const minNav = computed(() => {
      if (props4.navigationMinYearMonth === void 0) {
        return null;
      }
      const data = props4.navigationMinYearMonth.split("/");
      return { year: parseInt(data[0], 10), month: parseInt(data[1], 10) };
    });
    const maxNav = computed(() => {
      if (props4.navigationMaxYearMonth === void 0) {
        return null;
      }
      const data = props4.navigationMaxYearMonth.split("/");
      return { year: parseInt(data[0], 10), month: parseInt(data[1], 10) };
    });
    const navBoundaries = computed(() => {
      const data = {
        month: { prev: true, next: true },
        year: { prev: true, next: true }
      };
      if (minNav.value !== null && minNav.value.year >= viewModel.value.year) {
        data.year.prev = false;
        if (minNav.value.year === viewModel.value.year && minNav.value.month >= viewModel.value.month) {
          data.month.prev = false;
        }
      }
      if (maxNav.value !== null && maxNav.value.year <= viewModel.value.year) {
        data.year.next = false;
        if (maxNav.value.year === viewModel.value.year && maxNav.value.month <= viewModel.value.month) {
          data.month.next = false;
        }
      }
      return data;
    });
    const daysMap = computed(() => {
      const map = {};
      daysModel.value.forEach((entry) => {
        const hash = getMonthHash(entry);
        if (map[hash] === void 0) {
          map[hash] = [];
        }
        map[hash].push(entry.day);
      });
      return map;
    });
    const rangeMap = computed(() => {
      const map = {};
      rangeModel.value.forEach((entry) => {
        const hashFrom = getMonthHash(entry.from);
        const hashTo = getMonthHash(entry.to);
        if (map[hashFrom] === void 0) {
          map[hashFrom] = [];
        }
        map[hashFrom].push({
          from: entry.from.day,
          to: hashFrom === hashTo ? entry.to.day : void 0,
          range: entry
        });
        if (hashFrom < hashTo) {
          let hash;
          const { year: year2, month } = entry.from;
          const cur = month < 12 ? { year: year2, month: month + 1 } : { year: year2 + 1, month: 1 };
          while ((hash = getMonthHash(cur)) <= hashTo) {
            if (map[hash] === void 0) {
              map[hash] = [];
            }
            map[hash].push({
              from: void 0,
              to: hash === hashTo ? entry.to.day : void 0,
              range: entry
            });
            cur.month++;
            if (cur.month > 12) {
              cur.year++;
              cur.month = 1;
            }
          }
        }
      });
      return map;
    });
    const rangeView = computed(() => {
      if (editRange.value === null) {
        return;
      }
      const { init, initHash, final, finalHash } = editRange.value;
      const [from, to] = initHash <= finalHash ? [init, final] : [final, init];
      const fromHash = getMonthHash(from);
      const toHash = getMonthHash(to);
      if (fromHash !== viewMonthHash.value && toHash !== viewMonthHash.value) {
        return;
      }
      const view2 = {};
      if (fromHash === viewMonthHash.value) {
        view2.from = from.day;
        view2.includeFrom = true;
      } else {
        view2.from = 1;
      }
      if (toHash === viewMonthHash.value) {
        view2.to = to.day;
        view2.includeTo = true;
      } else {
        view2.to = daysInMonth2.value;
      }
      return view2;
    });
    const viewMonthHash = computed(() => getMonthHash(viewModel.value));
    const selectionDaysMap = computed(() => {
      const map = {};
      if (props4.options === void 0) {
        for (let i2 = 1; i2 <= daysInMonth2.value; i2++) {
          map[i2] = true;
        }
        return map;
      }
      const fn = typeof props4.options === "function" ? props4.options : (date) => props4.options.includes(date);
      for (let i2 = 1; i2 <= daysInMonth2.value; i2++) {
        const dayHash = viewMonthHash.value + "/" + pad(i2);
        map[i2] = fn(dayHash);
      }
      return map;
    });
    const eventDaysMap = computed(() => {
      const map = {};
      if (props4.events === void 0) {
        for (let i2 = 1; i2 <= daysInMonth2.value; i2++) {
          map[i2] = false;
        }
      } else {
        const fn = typeof props4.events === "function" ? props4.events : (date) => props4.events.includes(date);
        for (let i2 = 1; i2 <= daysInMonth2.value; i2++) {
          const dayHash = viewMonthHash.value + "/" + pad(i2);
          map[i2] = fn(dayHash) === true && evtColor.value(dayHash);
        }
      }
      return map;
    });
    const viewDays = computed(() => {
      let date, endDay;
      const { year: year2, month } = viewModel.value;
      if (props4.calendar !== "persian") {
        date = new Date(year2, month - 1, 1);
        endDay = new Date(year2, month - 1, 0).getDate();
      } else {
        const gDate = toGregorian(year2, month, 1);
        date = new Date(gDate.gy, gDate.gm - 1, gDate.gd);
        let prevJM = month - 1;
        let prevJY = year2;
        if (prevJM === 0) {
          prevJM = 12;
          prevJY--;
        }
        endDay = jalaaliMonthLength(prevJY, prevJM);
      }
      return {
        days: date.getDay() - computedFirstDayOfWeek.value - 1,
        endDay
      };
    });
    const days = computed(() => {
      const res = [];
      const { days: days2, endDay } = viewDays.value;
      const len = days2 < 0 ? days2 + 7 : days2;
      if (len < 6) {
        for (let i2 = endDay - len; i2 <= endDay; i2++) {
          res.push({ i: i2, fill: true });
        }
      }
      const index = res.length;
      for (let i2 = 1; i2 <= daysInMonth2.value; i2++) {
        const day = { i: i2, event: eventDaysMap.value[i2], classes: [] };
        if (selectionDaysMap.value[i2] === true) {
          day.in = true;
          day.flat = true;
        }
        res.push(day);
      }
      if (daysMap.value[viewMonthHash.value] !== void 0) {
        daysMap.value[viewMonthHash.value].forEach((day) => {
          const i2 = index + day - 1;
          Object.assign(res[i2], {
            selected: true,
            unelevated: true,
            flat: false,
            color: computedColor.value,
            textColor: computedTextColor.value
          });
        });
      }
      if (rangeMap.value[viewMonthHash.value] !== void 0) {
        rangeMap.value[viewMonthHash.value].forEach((entry) => {
          if (entry.from !== void 0) {
            const from = index + entry.from - 1;
            const to = index + (entry.to || daysInMonth2.value) - 1;
            for (let day = from; day <= to; day++) {
              Object.assign(res[day], {
                range: entry.range,
                unelevated: true,
                color: computedColor.value,
                textColor: computedTextColor.value
              });
            }
            Object.assign(res[from], {
              rangeFrom: true,
              flat: false
            });
            entry.to !== void 0 && Object.assign(res[to], {
              rangeTo: true,
              flat: false
            });
          } else if (entry.to !== void 0) {
            const to = index + entry.to - 1;
            for (let day = index; day <= to; day++) {
              Object.assign(res[day], {
                range: entry.range,
                unelevated: true,
                color: computedColor.value,
                textColor: computedTextColor.value
              });
            }
            Object.assign(res[to], {
              flat: false,
              rangeTo: true
            });
          } else {
            const to = index + daysInMonth2.value - 1;
            for (let day = index; day <= to; day++) {
              Object.assign(res[day], {
                range: entry.range,
                unelevated: true,
                color: computedColor.value,
                textColor: computedTextColor.value
              });
            }
          }
        });
      }
      if (rangeView.value !== void 0) {
        const from = index + rangeView.value.from - 1;
        const to = index + rangeView.value.to - 1;
        for (let day = from; day <= to; day++) {
          res[day].color = computedColor.value;
          res[day].editRange = true;
        }
        if (rangeView.value.includeFrom === true) {
          res[from].editRangeFrom = true;
        }
        if (rangeView.value.includeTo === true) {
          res[to].editRangeTo = true;
        }
      }
      if (viewModel.value.year === today.value.year && viewModel.value.month === today.value.month) {
        res[index + today.value.day - 1].today = true;
      }
      const left = res.length % 7;
      if (left > 0) {
        const afterDays = 7 - left;
        for (let i2 = 1; i2 <= afterDays; i2++) {
          res.push({ i: i2, fill: true });
        }
      }
      res.forEach((day) => {
        let cls = "q-date__calendar-item ";
        if (day.fill === true) {
          cls += "q-date__calendar-item--fill";
        } else {
          cls += `q-date__calendar-item--${day.in === true ? "in" : "out"}`;
          if (day.range !== void 0) {
            cls += ` q-date__range${day.rangeTo === true ? "-to" : day.rangeFrom === true ? "-from" : ""}`;
          }
          if (day.editRange === true) {
            cls += ` q-date__edit-range${day.editRangeFrom === true ? "-from" : ""}${day.editRangeTo === true ? "-to" : ""}`;
          }
          if (day.range !== void 0 || day.editRange === true) {
            cls += ` text-${day.color}`;
          }
        }
        day.classes = cls;
      });
      return res;
    });
    const attributes = computed(() => props4.disable === true ? { "aria-disabled": "true" } : {});
    watch(() => props4.modelValue, (v) => {
      if (lastEmitValue === v) {
        lastEmitValue = 0;
      } else {
        const model = getViewModel(innerMask.value, innerLocale.value);
        updateViewModel(model.year, model.month, model);
      }
    });
    watch(view, () => {
      if (blurTargetRef.value !== null && proxy.$el.contains(document.activeElement) === true) {
        blurTargetRef.value.focus();
      }
    });
    watch(() => viewModel.value.year + "|" + viewModel.value.month, () => {
      emit("navigation", { year: viewModel.value.year, month: viewModel.value.month });
    });
    watch(mask, (val) => {
      updateValue2(val, innerLocale.value, "mask");
      innerMask.value = val;
    });
    watch(locale2, (val) => {
      updateValue2(innerMask.value, val, "locale");
      innerLocale.value = val;
    });
    function setToday() {
      const { year: year2, month, day } = today.value;
      const date = {
        // contains more props than needed (hour, minute, second, millisecond)
        // but those aren't used in the processing of this "date" variable
        ...viewModel.value,
        // overwriting with today's date
        year: year2,
        month,
        day
      };
      const monthMap = daysMap.value[getMonthHash(date)];
      if (monthMap === void 0 || monthMap.includes(date.day) === false) {
        addToModel(date);
      }
      setCalendarTo(date.year, date.month);
    }
    function setView(viewMode) {
      if (viewIsValid(viewMode) === true) {
        view.value = viewMode;
      }
    }
    function offsetCalendar(type2, descending) {
      if (["month", "year"].includes(type2)) {
        const fn = type2 === "month" ? goToMonth : goToYear;
        fn(descending === true ? -1 : 1);
      }
    }
    function setCalendarTo(year2, month) {
      view.value = "Calendar";
      updateViewModel(year2, month);
    }
    function setEditingRange(from, to) {
      if (props4.range === false || !from) {
        editRange.value = null;
        return;
      }
      const init = Object.assign({ ...viewModel.value }, from);
      const final = to !== void 0 ? Object.assign({ ...viewModel.value }, to) : init;
      editRange.value = {
        init,
        initHash: getDayHash(init),
        final,
        finalHash: getDayHash(final)
      };
      setCalendarTo(init.year, init.month);
    }
    function getMask() {
      return props4.calendar === "persian" ? "YYYY/MM/DD" : props4.mask;
    }
    function decodeString(date, mask2, locale22) {
      return __splitDate(
        date,
        mask2,
        locale22,
        props4.calendar,
        {
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        }
      );
    }
    function getViewModel(mask2, locale22) {
      const model = Array.isArray(props4.modelValue) === true ? props4.modelValue : props4.modelValue ? [props4.modelValue] : [];
      if (model.length === 0) {
        return getDefaultViewModel();
      }
      const target2 = model[model.length - 1];
      const decoded = decodeString(
        target2.from !== void 0 ? target2.from : target2,
        mask2,
        locale22
      );
      return decoded.dateHash === null ? getDefaultViewModel() : decoded;
    }
    function getDefaultViewModel() {
      let year2, month;
      if (props4.defaultYearMonth !== void 0) {
        const d3 = props4.defaultYearMonth.split("/");
        year2 = parseInt(d3[0], 10);
        month = parseInt(d3[1], 10);
      } else {
        const d3 = today.value !== void 0 ? today.value : getCurrentDate();
        year2 = d3.year;
        month = d3.month;
      }
      return {
        year: year2,
        month,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        dateHash: year2 + "/" + pad(month) + "/01"
      };
    }
    function goToMonth(offset2) {
      let year2 = viewModel.value.year;
      let month = Number(viewModel.value.month) + offset2;
      if (month === 13) {
        month = 1;
        year2++;
      } else if (month === 0) {
        month = 12;
        year2--;
      }
      updateViewModel(year2, month);
      isImmediate.value === true && emitImmediately("month");
    }
    function goToYear(offset2) {
      const year2 = Number(viewModel.value.year) + offset2;
      updateViewModel(year2, viewModel.value.month);
      isImmediate.value === true && emitImmediately("year");
    }
    function setYear(year2) {
      updateViewModel(year2, viewModel.value.month);
      view.value = props4.defaultView === "Years" ? "Months" : "Calendar";
      isImmediate.value === true && emitImmediately("year");
    }
    function setMonth(month) {
      updateViewModel(viewModel.value.year, month);
      view.value = "Calendar";
      isImmediate.value === true && emitImmediately("month");
    }
    function toggleDate(date, monthHash) {
      const month = daysMap.value[monthHash];
      const fn = month !== void 0 && month.includes(date.day) === true ? removeFromModel : addToModel;
      fn(date);
    }
    function getShortDate(date) {
      return { year: date.year, month: date.month, day: date.day };
    }
    function updateViewModel(year2, month, time) {
      if (minNav.value !== null && year2 <= minNav.value.year) {
        if (month < minNav.value.month || year2 < minNav.value.year) {
          month = minNav.value.month;
        }
        year2 = minNav.value.year;
      }
      if (maxNav.value !== null && year2 >= maxNav.value.year) {
        if (month > maxNav.value.month || year2 > maxNav.value.year) {
          month = maxNav.value.month;
        }
        year2 = maxNav.value.year;
      }
      if (time !== void 0) {
        const { hour, minute, second, millisecond, timezoneOffset, timeHash } = time;
        Object.assign(viewModel.value, { hour, minute, second, millisecond, timezoneOffset, timeHash });
      }
      const newHash = year2 + "/" + pad(month) + "/01";
      if (newHash !== viewModel.value.dateHash) {
        monthDirection.value = viewModel.value.dateHash < newHash === ($q.lang.rtl !== true) ? "left" : "right";
        if (year2 !== viewModel.value.year) {
          yearDirection.value = monthDirection.value;
        }
        nextTick(() => {
          startYear.value = year2 - year2 % yearsInterval - (year2 < 0 ? yearsInterval : 0);
          Object.assign(viewModel.value, {
            year: year2,
            month,
            day: 1,
            dateHash: newHash
          });
        });
      }
    }
    function emitValue(val, action, date) {
      const value2 = val !== null && val.length === 1 && props4.multiple === false ? val[0] : val;
      lastEmitValue = value2;
      const { reason, details } = getEmitParams(action, date);
      emit("update:modelValue", value2, reason, details);
    }
    function emitImmediately(reason) {
      const date = daysModel.value[0] !== void 0 && daysModel.value[0].dateHash !== null ? { ...daysModel.value[0] } : { ...viewModel.value };
      nextTick(() => {
        date.year = viewModel.value.year;
        date.month = viewModel.value.month;
        const maxDay = props4.calendar !== "persian" ? new Date(date.year, date.month, 0).getDate() : jalaaliMonthLength(date.year, date.month);
        date.day = Math.min(Math.max(1, date.day), maxDay);
        const value2 = encodeEntry(date);
        lastEmitValue = value2;
        const { details } = getEmitParams("", date);
        emit("update:modelValue", value2, reason, details);
      });
    }
    function getEmitParams(action, date) {
      return date.from !== void 0 ? {
        reason: `${action}-range`,
        details: {
          ...getShortDate(date.target),
          from: getShortDate(date.from),
          to: getShortDate(date.to)
        }
      } : {
        reason: `${action}-day`,
        details: getShortDate(date)
      };
    }
    function encodeEntry(date, mask2, locale22) {
      return date.from !== void 0 ? { from: encodeObjectFn.value(date.from, mask2, locale22), to: encodeObjectFn.value(date.to, mask2, locale22) } : encodeObjectFn.value(date, mask2, locale22);
    }
    function addToModel(date) {
      let value2;
      if (props4.multiple === true) {
        if (date.from !== void 0) {
          const fromHash = getDayHash(date.from);
          const toHash = getDayHash(date.to);
          const days2 = daysModel.value.filter((day) => day.dateHash < fromHash || day.dateHash > toHash);
          const ranges = rangeModel.value.filter(({ from, to }) => to.dateHash < fromHash || from.dateHash > toHash);
          value2 = days2.concat(ranges).concat(date).map((entry) => encodeEntry(entry));
        } else {
          const model = normalizedModel.value.slice();
          model.push(encodeEntry(date));
          value2 = model;
        }
      } else {
        value2 = encodeEntry(date);
      }
      emitValue(value2, "add", date);
    }
    function removeFromModel(date) {
      if (props4.noUnset === true) {
        return;
      }
      let model = null;
      if (props4.multiple === true && Array.isArray(props4.modelValue) === true) {
        const val = encodeEntry(date);
        if (date.from !== void 0) {
          model = props4.modelValue.filter(
            (date2) => date2.from !== void 0 ? date2.from !== val.from && date2.to !== val.to : true
          );
        } else {
          model = props4.modelValue.filter((date2) => date2 !== val);
        }
        if (model.length === 0) {
          model = null;
        }
      }
      emitValue(model, "remove", date);
    }
    function updateValue2(mask2, locale22, reason) {
      const model = daysModel.value.concat(rangeModel.value).map((entry) => encodeEntry(entry, mask2, locale22)).filter((entry) => {
        return entry.from !== void 0 ? entry.from.dateHash !== null && entry.to.dateHash !== null : entry.dateHash !== null;
      });
      emit("update:modelValue", (props4.multiple === true ? model : model[0]) || null, reason);
    }
    function getHeader() {
      if (props4.minimal === true) return;
      return h("div", {
        class: "q-date__header " + headerClass.value
      }, [
        h("div", {
          class: "relative-position"
        }, [
          h(Transition, {
            name: "q-transition--fade"
          }, () => h("div", {
            key: "h-yr-" + headerSubtitle.value,
            class: "q-date__header-subtitle q-date__header-link " + (view.value === "Years" ? "q-date__header-link--active" : "cursor-pointer"),
            tabindex: tabindex.value,
            ...getCache("vY", {
              onClick() {
                view.value = "Years";
              },
              onKeyup(e2) {
                e2.keyCode === 13 && (view.value = "Years");
              }
            })
          }, [headerSubtitle.value]))
        ]),
        h("div", {
          class: "q-date__header-title relative-position flex no-wrap"
        }, [
          h("div", {
            class: "relative-position col"
          }, [
            h(Transition, {
              name: "q-transition--fade"
            }, () => h("div", {
              key: "h-sub" + headerTitle.value,
              class: "q-date__header-title-label q-date__header-link " + (view.value === "Calendar" ? "q-date__header-link--active" : "cursor-pointer"),
              tabindex: tabindex.value,
              ...getCache("vC", {
                onClick() {
                  view.value = "Calendar";
                },
                onKeyup(e2) {
                  e2.keyCode === 13 && (view.value = "Calendar");
                }
              })
            }, [headerTitle.value]))
          ]),
          props4.todayBtn === true ? h(QBtn_default, {
            class: "q-date__header-today self-start",
            icon: $q.iconSet.datetime.today,
            flat: true,
            size: "sm",
            round: true,
            tabindex: tabindex.value,
            onClick: setToday
          }) : null
        ])
      ]);
    }
    function getNavigation({ label, type: type2, key, dir, goTo, boundaries, cls }) {
      return [
        h("div", {
          class: "row items-center q-date__arrow"
        }, [
          h(QBtn_default, {
            round: true,
            dense: true,
            size: "sm",
            flat: true,
            icon: dateArrow.value[0],
            tabindex: tabindex.value,
            disable: boundaries.prev === false,
            ...getCache("go-#" + type2, { onClick() {
              goTo(-1);
            } })
          })
        ]),
        h("div", {
          class: "relative-position overflow-hidden flex flex-center" + cls
        }, [
          h(Transition, {
            name: "q-transition--jump-" + dir
          }, () => h("div", { key }, [
            h(QBtn_default, {
              flat: true,
              dense: true,
              noCaps: true,
              label,
              tabindex: tabindex.value,
              ...getCache("view#" + type2, { onClick: () => {
                view.value = type2;
              } })
            })
          ]))
        ]),
        h("div", {
          class: "row items-center q-date__arrow"
        }, [
          h(QBtn_default, {
            round: true,
            dense: true,
            size: "sm",
            flat: true,
            icon: dateArrow.value[1],
            tabindex: tabindex.value,
            disable: boundaries.next === false,
            ...getCache("go+#" + type2, { onClick() {
              goTo(1);
            } })
          })
        ])
      ];
    }
    const renderViews = {
      Calendar: () => [
        h("div", {
          key: "calendar-view",
          class: "q-date__view q-date__calendar"
        }, [
          h("div", {
            class: "q-date__navigation row items-center no-wrap"
          }, getNavigation({
            label: innerLocale.value.months[viewModel.value.month - 1],
            type: "Months",
            key: viewModel.value.month,
            dir: monthDirection.value,
            goTo: goToMonth,
            boundaries: navBoundaries.value.month,
            cls: " col"
          }).concat(getNavigation({
            label: viewModel.value.year,
            type: "Years",
            key: viewModel.value.year,
            dir: yearDirection.value,
            goTo: goToYear,
            boundaries: navBoundaries.value.year,
            cls: ""
          }))),
          h("div", {
            class: "q-date__calendar-weekdays row items-center no-wrap"
          }, daysOfWeek.value.map((day) => h("div", { class: "q-date__calendar-item" }, [h("div", day)]))),
          h("div", {
            class: "q-date__calendar-days-container relative-position overflow-hidden"
          }, [
            h(Transition, {
              name: "q-transition--slide-" + monthDirection.value
            }, () => h("div", {
              key: viewMonthHash.value,
              class: "q-date__calendar-days fit"
            }, days.value.map((day) => h("div", { class: day.classes }, [
              day.in === true ? h(
                QBtn_default,
                {
                  class: day.today === true ? "q-date__today" : "",
                  dense: true,
                  flat: day.flat,
                  unelevated: day.unelevated,
                  color: day.color,
                  textColor: day.textColor,
                  label: day.i,
                  tabindex: tabindex.value,
                  ...getCache("day#" + day.i, {
                    onClick: () => {
                      onDayClick(day.i);
                    },
                    onMouseover: () => {
                      onDayMouseover(day.i);
                    }
                  })
                },
                day.event !== false ? () => h("div", { class: "q-date__event bg-" + day.event }) : null
              ) : h("div", "" + day.i)
            ]))))
          ])
        ])
      ],
      Months() {
        const currentYear = viewModel.value.year === today.value.year;
        const isDisabled = (month) => {
          return minNav.value !== null && viewModel.value.year === minNav.value.year && minNav.value.month > month || maxNav.value !== null && viewModel.value.year === maxNav.value.year && maxNav.value.month < month;
        };
        const content = innerLocale.value.monthsShort.map((month, i2) => {
          const active = viewModel.value.month === i2 + 1;
          return h("div", {
            class: "q-date__months-item flex flex-center"
          }, [
            h(QBtn_default, {
              class: currentYear === true && today.value.month === i2 + 1 ? "q-date__today" : null,
              flat: active !== true,
              label: month,
              unelevated: active,
              color: active === true ? computedColor.value : null,
              textColor: active === true ? computedTextColor.value : null,
              tabindex: tabindex.value,
              disable: isDisabled(i2 + 1),
              ...getCache("month#" + i2, { onClick: () => {
                setMonth(i2 + 1);
              } })
            })
          ]);
        });
        props4.yearsInMonthView === true && content.unshift(
          h("div", { class: "row no-wrap full-width" }, [
            getNavigation({
              label: viewModel.value.year,
              type: "Years",
              key: viewModel.value.year,
              dir: yearDirection.value,
              goTo: goToYear,
              boundaries: navBoundaries.value.year,
              cls: " col"
            })
          ])
        );
        return h("div", {
          key: "months-view",
          class: "q-date__view q-date__months flex flex-center"
        }, content);
      },
      Years() {
        const start = startYear.value, stop2 = start + yearsInterval, years = [];
        const isDisabled = (year2) => {
          return minNav.value !== null && minNav.value.year > year2 || maxNav.value !== null && maxNav.value.year < year2;
        };
        for (let i2 = start; i2 <= stop2; i2++) {
          const active = viewModel.value.year === i2;
          years.push(
            h("div", {
              class: "q-date__years-item flex flex-center"
            }, [
              h(QBtn_default, {
                key: "yr" + i2,
                class: today.value.year === i2 ? "q-date__today" : null,
                flat: !active,
                label: i2,
                dense: true,
                unelevated: active,
                color: active === true ? computedColor.value : null,
                textColor: active === true ? computedTextColor.value : null,
                tabindex: tabindex.value,
                disable: isDisabled(i2),
                ...getCache("yr#" + i2, { onClick: () => {
                  setYear(i2);
                } })
              })
            ])
          );
        }
        return h("div", {
          class: "q-date__view q-date__years flex flex-center"
        }, [
          h("div", {
            class: "col-auto"
          }, [
            h(QBtn_default, {
              round: true,
              dense: true,
              flat: true,
              icon: dateArrow.value[0],
              tabindex: tabindex.value,
              disable: isDisabled(start),
              ...getCache("y-", { onClick: () => {
                startYear.value -= yearsInterval;
              } })
            })
          ]),
          h("div", {
            class: "q-date__years-content col self-stretch row items-center"
          }, years),
          h("div", {
            class: "col-auto"
          }, [
            h(QBtn_default, {
              round: true,
              dense: true,
              flat: true,
              icon: dateArrow.value[1],
              tabindex: tabindex.value,
              disable: isDisabled(stop2),
              ...getCache("y+", { onClick: () => {
                startYear.value += yearsInterval;
              } })
            })
          ])
        ]);
      }
    };
    function onDayClick(dayIndex) {
      const day = { ...viewModel.value, day: dayIndex };
      if (props4.range === false) {
        toggleDate(day, viewMonthHash.value);
        return;
      }
      if (editRange.value === null) {
        const dayProps = days.value.find((day2) => day2.fill !== true && day2.i === dayIndex);
        if (props4.noUnset !== true && dayProps.range !== void 0) {
          removeFromModel({ target: day, from: dayProps.range.from, to: dayProps.range.to });
          return;
        }
        if (dayProps.selected === true) {
          removeFromModel(day);
          return;
        }
        const initHash = getDayHash(day);
        editRange.value = {
          init: day,
          initHash,
          final: day,
          finalHash: initHash
        };
        emit("rangeStart", getShortDate(day));
      } else {
        const initHash = editRange.value.initHash, finalHash = getDayHash(day), payload = initHash <= finalHash ? { from: editRange.value.init, to: day } : { from: day, to: editRange.value.init };
        editRange.value = null;
        addToModel(initHash === finalHash ? day : { target: day, ...payload });
        emit("rangeEnd", {
          from: getShortDate(payload.from),
          to: getShortDate(payload.to)
        });
      }
    }
    function onDayMouseover(dayIndex) {
      if (editRange.value !== null) {
        const final = { ...viewModel.value, day: dayIndex };
        Object.assign(editRange.value, {
          final,
          finalHash: getDayHash(final)
        });
      }
    }
    Object.assign(proxy, {
      setToday,
      setView,
      offsetCalendar,
      setCalendarTo,
      setEditingRange
    });
    return () => {
      const content = [
        h("div", {
          class: "q-date__content col relative-position"
        }, [
          h(Transition, {
            name: "q-transition--fade"
          }, renderViews[view.value])
        ])
      ];
      const def = hSlot(slots.default);
      def !== void 0 && content.push(
        h("div", { class: "q-date__actions" }, def)
      );
      if (props4.name !== void 0 && props4.disable !== true) {
        injectFormInput(content, "push");
      }
      return h("div", {
        class: classes.value,
        ...attributes.value
      }, [
        getHeader(),
        h("div", {
          ref: blurTargetRef,
          class: "q-date__main col column",
          tabindex: -1
        }, content)
      ]);
    };
  }
});
function use_history_default(showing, hide, hideOnRouteChange) {
  function removeFromHistory() {
  }
  onBeforeUnmount(() => {
    showing.value === true && removeFromHistory();
  });
  return {
    removeFromHistory,
    addToHistory() {
    }
  };
}
var registered = 0;
var scrollPositionX;
var scrollPositionY;
var maxScrollTop;
var vpPendingUpdate = false;
var bodyLeft;
var bodyTop;
var href;
var closeTimer = null;
function onWheel(e2) {
  if (shouldPreventScroll(e2)) {
    stopAndPrevent(e2);
  }
}
function shouldPreventScroll(e2) {
  if (e2.target === document.body || e2.target.classList.contains("q-layout__backdrop")) {
    return true;
  }
  const path = getEventPath(e2), shift = e2.shiftKey && !e2.deltaX, scrollY = !shift && Math.abs(e2.deltaX) <= Math.abs(e2.deltaY), delta = shift || scrollY ? e2.deltaY : e2.deltaX;
  for (let index = 0; index < path.length; index++) {
    const el = path[index];
    if (hasScrollbar(el, scrollY)) {
      return scrollY ? delta < 0 && el.scrollTop === 0 ? true : delta > 0 && el.scrollTop + el.clientHeight === el.scrollHeight : delta < 0 && el.scrollLeft === 0 ? true : delta > 0 && el.scrollLeft + el.clientWidth === el.scrollWidth;
    }
  }
  return true;
}
function onAppleScroll(e2) {
  if (e2.target === document) {
    document.scrollingElement.scrollTop = document.scrollingElement.scrollTop;
  }
}
function onAppleResize(evt) {
  if (vpPendingUpdate === true) {
    return;
  }
  vpPendingUpdate = true;
  requestAnimationFrame(() => {
    vpPendingUpdate = false;
    const { height: height2 } = evt.target, { clientHeight, scrollTop } = document.scrollingElement;
    if (maxScrollTop === void 0 || height2 !== window.innerHeight) {
      maxScrollTop = clientHeight - height2;
      document.scrollingElement.scrollTop = scrollTop;
    }
    if (scrollTop > maxScrollTop) {
      document.scrollingElement.scrollTop -= Math.ceil((scrollTop - maxScrollTop) / 8);
    }
  });
}
function apply(action) {
  const body = document.body, hasViewport = window.visualViewport !== void 0;
  if (action === "add") {
    const { overflowY, overflowX } = window.getComputedStyle(body);
    scrollPositionX = getHorizontalScrollPosition(window);
    scrollPositionY = getVerticalScrollPosition(window);
    bodyLeft = body.style.left;
    bodyTop = body.style.top;
    href = window.location.href;
    body.style.left = `-${scrollPositionX}px`;
    body.style.top = `-${scrollPositionY}px`;
    if (overflowX !== "hidden" && (overflowX === "scroll" || body.scrollWidth > window.innerWidth)) {
      body.classList.add("q-body--force-scrollbar-x");
    }
    if (overflowY !== "hidden" && (overflowY === "scroll" || body.scrollHeight > window.innerHeight)) {
      body.classList.add("q-body--force-scrollbar-y");
    }
    body.classList.add("q-body--prevent-scroll");
    document.qScrollPrevented = true;
    if (client.is.ios === true) {
      if (hasViewport === true) {
        window.scrollTo(0, 0);
        window.visualViewport.addEventListener("resize", onAppleResize, listenOpts.passiveCapture);
        window.visualViewport.addEventListener("scroll", onAppleResize, listenOpts.passiveCapture);
        window.scrollTo(0, 0);
      } else {
        window.addEventListener("scroll", onAppleScroll, listenOpts.passiveCapture);
      }
    }
  }
  if (client.is.desktop === true && client.is.mac === true) {
    window[`${action}EventListener`]("wheel", onWheel, listenOpts.notPassive);
  }
  if (action === "remove") {
    if (client.is.ios === true) {
      if (hasViewport === true) {
        window.visualViewport.removeEventListener("resize", onAppleResize, listenOpts.passiveCapture);
        window.visualViewport.removeEventListener("scroll", onAppleResize, listenOpts.passiveCapture);
      } else {
        window.removeEventListener("scroll", onAppleScroll, listenOpts.passiveCapture);
      }
    }
    body.classList.remove("q-body--prevent-scroll");
    body.classList.remove("q-body--force-scrollbar-x");
    body.classList.remove("q-body--force-scrollbar-y");
    document.qScrollPrevented = false;
    body.style.left = bodyLeft;
    body.style.top = bodyTop;
    if (window.location.href === href) {
      window.scrollTo(scrollPositionX, scrollPositionY);
    }
    maxScrollTop = void 0;
  }
}
function prevent_scroll_default(state2) {
  let action = "add";
  if (state2 === true) {
    registered++;
    if (closeTimer !== null) {
      clearTimeout(closeTimer);
      closeTimer = null;
      return;
    }
    if (registered > 1) {
      return;
    }
  } else {
    if (registered === 0) {
      return;
    }
    registered--;
    if (registered > 0) {
      return;
    }
    action = "remove";
    if (client.is.ios === true && client.is.nativeMobile === true) {
      closeTimer !== null && clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        apply(action);
        closeTimer = null;
      }, 100);
      return;
    }
  }
  apply(action);
}
function use_prevent_scroll_default() {
  let currentState;
  return {
    preventBodyScroll(state2) {
      if (state2 !== currentState && (currentState !== void 0 || state2 === true)) {
        currentState = state2;
        prevent_scroll_default(state2);
      }
    }
  };
}
var maximizedModals = 0;
var positionClass = {
  standard: "fixed-full flex-center",
  top: "fixed-top justify-center",
  bottom: "fixed-bottom justify-center",
  right: "fixed-right items-center",
  left: "fixed-left items-center"
};
var defaultTransitions = {
  standard: ["scale", "scale"],
  top: ["slide-down", "slide-up"],
  bottom: ["slide-up", "slide-down"],
  right: ["slide-left", "slide-right"],
  left: ["slide-right", "slide-left"]
};
var QDialog_default = createComponent({
  name: "QDialog",
  inheritAttrs: false,
  props: {
    ...useModelToggleProps,
    ...useTransitionProps,
    transitionShow: String,
    // override useTransitionProps
    transitionHide: String,
    // override useTransitionProps
    persistent: Boolean,
    autoClose: Boolean,
    allowFocusOutside: Boolean,
    noEscDismiss: Boolean,
    noBackdropDismiss: Boolean,
    noRouteDismiss: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    noShake: Boolean,
    seamless: Boolean,
    maximized: Boolean,
    fullWidth: Boolean,
    fullHeight: Boolean,
    square: Boolean,
    backdropFilter: String,
    position: {
      type: String,
      default: "standard",
      validator: (val) => ["standard", "top", "bottom", "left", "right"].includes(val)
    }
  },
  emits: [
    ...useModelToggleEmits,
    "shake",
    "click",
    "escapeKey"
  ],
  setup(props4, { slots, emit, attrs }) {
    const vm2 = getCurrentInstance();
    const innerRef = ref$1(null);
    const showing = ref$1(false);
    const animating = ref$1(false);
    let shakeTimeout = null, refocusTarget = null, isMaximized, avoidAutoClose;
    const hideOnRouteChange = computed(
      () => props4.persistent !== true && props4.noRouteDismiss !== true && props4.seamless !== true
    );
    const { preventBodyScroll } = use_prevent_scroll_default();
    const { registerTimeout } = use_timeout_default();
    const { registerTick, removeTick } = use_tick_default();
    const { transitionProps, transitionStyle } = use_transition_default(
      props4,
      () => defaultTransitions[props4.position][0],
      () => defaultTransitions[props4.position][1]
    );
    const backdropStyle = computed(() => transitionStyle.value + (props4.backdropFilter !== void 0 ? `;backdrop-filter:${props4.backdropFilter};-webkit-backdrop-filter:${props4.backdropFilter}` : ""));
    const { showPortal, hidePortal, portalIsAccessible, renderPortal } = use_portal_default(
      vm2,
      innerRef,
      renderPortalContent,
      "dialog"
    );
    const { hide } = use_model_toggle_default({
      showing,
      hideOnRouteChange,
      handleShow,
      handleHide,
      processOnMount: true
    });
    use_history_default(showing);
    const classes = computed(
      () => `q-dialog__inner flex no-pointer-events q-dialog__inner--${props4.maximized === true ? "maximized" : "minimized"} q-dialog__inner--${props4.position} ${positionClass[props4.position]}` + (animating.value === true ? " q-dialog__inner--animating" : "") + (props4.fullWidth === true ? " q-dialog__inner--fullwidth" : "") + (props4.fullHeight === true ? " q-dialog__inner--fullheight" : "") + (props4.square === true ? " q-dialog__inner--square" : "")
    );
    const useBackdrop = computed(() => showing.value === true && props4.seamless !== true);
    const onEvents = computed(() => props4.autoClose === true ? { onClick: onAutoClose } : {});
    const rootClasses = computed(() => [
      `q-dialog fullscreen no-pointer-events q-dialog--${useBackdrop.value === true ? "modal" : "seamless"}`,
      attrs.class
    ]);
    watch(() => props4.maximized, (state2) => {
      showing.value === true && updateMaximized(state2);
    });
    watch(useBackdrop, (val) => {
      preventBodyScroll(val);
      if (val === true) {
        addFocusout(onFocusChange);
        addEscapeKey(onEscapeKey);
      } else {
        removeFocusout(onFocusChange);
        removeEscapeKey(onEscapeKey);
      }
    });
    function handleShow(evt) {
      refocusTarget = props4.noRefocus === false && document.activeElement !== null ? document.activeElement : null;
      updateMaximized(props4.maximized);
      showPortal();
      animating.value = true;
      if (props4.noFocus !== true) {
        document.activeElement !== null && document.activeElement.blur();
        registerTick(focus);
      } else {
        removeTick();
      }
      registerTimeout(() => {
        if (vm2.proxy.$q.platform.is.ios === true) {
          if (props4.seamless !== true && document.activeElement) {
            const { top, bottom } = document.activeElement.getBoundingClientRect(), { innerHeight } = window, height2 = window.visualViewport !== void 0 ? window.visualViewport.height : innerHeight;
            if (top > 0 && bottom > height2 / 2) {
              document.scrollingElement.scrollTop = Math.min(
                document.scrollingElement.scrollHeight - height2,
                bottom >= innerHeight ? Infinity : Math.ceil(document.scrollingElement.scrollTop + bottom - height2 / 2)
              );
            }
            document.activeElement.scrollIntoView();
          }
          avoidAutoClose = true;
          innerRef.value.click();
          avoidAutoClose = false;
        }
        showPortal(true);
        animating.value = false;
        emit("show", evt);
      }, props4.transitionDuration);
    }
    function handleHide(evt) {
      removeTick();
      cleanup(true);
      animating.value = true;
      hidePortal();
      if (refocusTarget !== null) {
        ((evt && evt.type.indexOf("key") === 0 ? refocusTarget.closest('[tabindex]:not([tabindex^="-"])') : void 0) || refocusTarget).focus();
        refocusTarget = null;
      }
      registerTimeout(() => {
        hidePortal(true);
        animating.value = false;
        emit("hide", evt);
      }, props4.transitionDuration);
    }
    function focus(selector) {
      addFocusFn(() => {
        let node = innerRef.value;
        if (node === null) return;
        if (selector !== void 0) {
          const target2 = node.querySelector(selector);
          if (target2 !== null) {
            target2.focus({ preventScroll: true });
            return;
          }
        }
        if (node.contains(document.activeElement) !== true) {
          node = node.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || node.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || node.querySelector("[autofocus], [data-autofocus]") || node;
          node.focus({ preventScroll: true });
        }
      });
    }
    function shake(focusTarget) {
      if (focusTarget && typeof focusTarget.focus === "function") {
        focusTarget.focus({ preventScroll: true });
      } else {
        focus();
      }
      emit("shake");
      const node = innerRef.value;
      if (node !== null) {
        node.classList.remove("q-animate--scale");
        node.classList.add("q-animate--scale");
        shakeTimeout !== null && clearTimeout(shakeTimeout);
        shakeTimeout = setTimeout(() => {
          shakeTimeout = null;
          if (innerRef.value !== null) {
            node.classList.remove("q-animate--scale");
            focus();
          }
        }, 170);
      }
    }
    function onEscapeKey() {
      if (props4.seamless !== true) {
        if (props4.persistent === true || props4.noEscDismiss === true) {
          props4.maximized !== true && props4.noShake !== true && shake();
        } else {
          emit("escapeKey");
          hide();
        }
      }
    }
    function cleanup(hiding) {
      if (shakeTimeout !== null) {
        clearTimeout(shakeTimeout);
        shakeTimeout = null;
      }
      if (hiding === true || showing.value === true) {
        updateMaximized(false);
        if (props4.seamless !== true) {
          preventBodyScroll(false);
          removeFocusout(onFocusChange);
          removeEscapeKey(onEscapeKey);
        }
      }
      if (hiding !== true) {
        refocusTarget = null;
      }
    }
    function updateMaximized(active) {
      if (active === true) {
        if (isMaximized !== true) {
          maximizedModals < 1 && document.body.classList.add("q-body--dialog");
          maximizedModals++;
          isMaximized = true;
        }
      } else if (isMaximized === true) {
        if (maximizedModals < 2) {
          document.body.classList.remove("q-body--dialog");
        }
        maximizedModals--;
        isMaximized = false;
      }
    }
    function onAutoClose(e2) {
      if (avoidAutoClose !== true) {
        hide(e2);
        emit("click", e2);
      }
    }
    function onBackdropClick(e2) {
      if (props4.persistent !== true && props4.noBackdropDismiss !== true) {
        hide(e2);
      } else if (props4.noShake !== true) {
        shake();
      }
    }
    function onFocusChange(evt) {
      if (props4.allowFocusOutside !== true && portalIsAccessible.value === true && childHasFocus(innerRef.value, evt.target) !== true) {
        focus('[tabindex]:not([tabindex="-1"])');
      }
    }
    Object.assign(vm2.proxy, {
      // expose public methods
      focus,
      shake,
      // private but needed by QSelect
      __updateRefocusTarget(target2) {
        refocusTarget = target2 || null;
      }
    });
    onBeforeUnmount(cleanup);
    function renderPortalContent() {
      return h("div", {
        role: "dialog",
        "aria-modal": useBackdrop.value === true ? "true" : "false",
        ...attrs,
        class: rootClasses.value
      }, [
        h(Transition, {
          name: "q-transition--fade",
          appear: true
        }, () => useBackdrop.value === true ? h("div", {
          class: "q-dialog__backdrop fixed-full",
          style: backdropStyle.value,
          "aria-hidden": "true",
          tabindex: -1,
          onClick: onBackdropClick
        }) : null),
        h(
          Transition,
          transitionProps.value,
          () => showing.value === true ? h("div", {
            ref: innerRef,
            class: classes.value,
            style: transitionStyle.value,
            tabindex: -1,
            ...onEvents.value
          }, hSlot(slots.default)) : null
        )
      ]);
    }
    return renderPortal;
  }
});
var duration = 150;
var QDrawer_default = createComponent({
  name: "QDrawer",
  inheritAttrs: false,
  props: {
    ...useModelToggleProps,
    ...useDarkProps,
    side: {
      type: String,
      default: "left",
      validator: (v) => ["left", "right"].includes(v)
    },
    width: {
      type: Number,
      default: 300
    },
    mini: Boolean,
    miniToOverlay: Boolean,
    miniWidth: {
      type: Number,
      default: 57
    },
    noMiniAnimation: Boolean,
    breakpoint: {
      type: Number,
      default: 1023
    },
    showIfAbove: Boolean,
    behavior: {
      type: String,
      validator: (v) => ["default", "desktop", "mobile"].includes(v),
      default: "default"
    },
    bordered: Boolean,
    elevated: Boolean,
    overlay: Boolean,
    persistent: Boolean,
    noSwipeOpen: Boolean,
    noSwipeClose: Boolean,
    noSwipeBackdrop: Boolean
  },
  emits: [
    ...useModelToggleEmits,
    "onLayout",
    "miniState"
  ],
  setup(props4, { slots, emit, attrs }) {
    const vm2 = getCurrentInstance();
    const { proxy: { $q } } = vm2;
    const isDark = use_dark_default(props4, $q);
    const { preventBodyScroll } = use_prevent_scroll_default();
    const { registerTimeout, removeTimeout } = use_timeout_default();
    const $layout = inject(layoutKey, emptyRenderFn);
    if ($layout === emptyRenderFn) {
      console.error("QDrawer needs to be child of QLayout");
      return emptyRenderFn;
    }
    let lastDesktopState, timerMini = null, layoutTotalWidthWatcher;
    const belowBreakpoint = ref$1(
      props4.behavior === "mobile" || props4.behavior !== "desktop" && $layout.totalWidth.value <= props4.breakpoint
    );
    const isMini = computed(
      () => props4.mini === true && belowBreakpoint.value !== true
    );
    const size2 = computed(() => isMini.value === true ? props4.miniWidth : props4.width);
    const showing = ref$1(
      props4.showIfAbove === true && belowBreakpoint.value === false ? true : props4.modelValue === true
    );
    const hideOnRouteChange = computed(
      () => props4.persistent !== true && (belowBreakpoint.value === true || onScreenOverlay.value === true)
    );
    function handleShow(evt, noEvent) {
      evt !== false && $layout.animate();
      applyPosition(0);
      if (belowBreakpoint.value === true) {
        const otherInstance = $layout.instances[otherSide.value];
        if (otherInstance !== void 0 && otherInstance.belowBreakpoint === true) {
          otherInstance.hide(false);
        }
        applyBackdrop(1);
        $layout.isContainer.value !== true && preventBodyScroll(true);
      } else {
        applyBackdrop(0);
        evt !== false && setScrollable(false);
      }
      registerTimeout(() => {
        evt !== false && setScrollable(true);
        noEvent !== true && emit("show", evt);
      }, duration);
    }
    function handleHide(evt, noEvent) {
      evt !== false && $layout.animate();
      applyBackdrop(0);
      applyPosition(stateDirection.value * size2.value);
      cleanup();
      if (noEvent !== true) {
        registerTimeout(() => {
          emit("hide", evt);
        }, duration);
      } else {
        removeTimeout();
      }
    }
    const { show, hide } = use_model_toggle_default({
      showing,
      hideOnRouteChange,
      handleShow,
      handleHide
    });
    use_history_default(showing);
    const instance = {
      belowBreakpoint,
      hide
    };
    const rightSide = computed(() => props4.side === "right");
    const stateDirection = computed(
      () => ($q.lang.rtl === true ? -1 : 1) * (rightSide.value === true ? 1 : -1)
    );
    const flagBackdropBg = ref$1(0);
    const flagPanning = ref$1(false);
    const flagMiniAnimate = ref$1(false);
    const flagContentPosition = ref$1(
      // starting with "hidden" for SSR
      size2.value * stateDirection.value
    );
    const otherSide = computed(() => rightSide.value === true ? "left" : "right");
    const offset2 = computed(() => showing.value === true && belowBreakpoint.value === false && props4.overlay === false ? props4.miniToOverlay === true ? props4.miniWidth : size2.value : 0);
    const fixed = computed(
      () => props4.overlay === true || props4.miniToOverlay === true || $layout.view.value.indexOf(rightSide.value ? "R" : "L") !== -1 || $q.platform.is.ios === true && $layout.isContainer.value === true
    );
    const onLayout = computed(
      () => props4.overlay === false && showing.value === true && belowBreakpoint.value === false
    );
    const onScreenOverlay = computed(
      () => props4.overlay === true && showing.value === true && belowBreakpoint.value === false
    );
    const backdropClass = computed(
      () => "fullscreen q-drawer__backdrop" + (showing.value === false && flagPanning.value === false ? " hidden" : "")
    );
    const backdropStyle = computed(() => ({
      backgroundColor: `rgba(0,0,0,${flagBackdropBg.value * 0.4})`
    }));
    const headerSlot = computed(() => rightSide.value === true ? $layout.rows.value.top[2] === "r" : $layout.rows.value.top[0] === "l");
    const footerSlot = computed(() => rightSide.value === true ? $layout.rows.value.bottom[2] === "r" : $layout.rows.value.bottom[0] === "l");
    const aboveStyle = computed(() => {
      const css2 = {};
      if ($layout.header.space === true && headerSlot.value === false) {
        if (fixed.value === true) {
          css2.top = `${$layout.header.offset}px`;
        } else if ($layout.header.space === true) {
          css2.top = `${$layout.header.size}px`;
        }
      }
      if ($layout.footer.space === true && footerSlot.value === false) {
        if (fixed.value === true) {
          css2.bottom = `${$layout.footer.offset}px`;
        } else if ($layout.footer.space === true) {
          css2.bottom = `${$layout.footer.size}px`;
        }
      }
      return css2;
    });
    const style2 = computed(() => {
      const style3 = {
        width: `${size2.value}px`,
        transform: `translateX(${flagContentPosition.value}px)`
      };
      return belowBreakpoint.value === true ? style3 : Object.assign(style3, aboveStyle.value);
    });
    const contentClass = computed(
      () => "q-drawer__content fit " + ($layout.isContainer.value !== true ? "scroll" : "overflow-auto")
    );
    const classes = computed(
      () => `q-drawer q-drawer--${props4.side}` + (flagMiniAnimate.value === true ? " q-drawer--mini-animate" : "") + (props4.bordered === true ? " q-drawer--bordered" : "") + (isDark.value === true ? " q-drawer--dark q-dark" : "") + (flagPanning.value === true ? " no-transition" : showing.value === true ? "" : " q-layout--prevent-focus") + (belowBreakpoint.value === true ? " fixed q-drawer--on-top q-drawer--mobile q-drawer--top-padding" : ` q-drawer--${isMini.value === true ? "mini" : "standard"}` + (fixed.value === true || onLayout.value !== true ? " fixed" : "") + (props4.overlay === true || props4.miniToOverlay === true ? " q-drawer--on-top" : "") + (headerSlot.value === true ? " q-drawer--top-padding" : ""))
    );
    const openDirective = computed(() => {
      const dir = $q.lang.rtl === true ? props4.side : otherSide.value;
      return [[
        TouchPan_default,
        onOpenPan,
        void 0,
        {
          [dir]: true,
          mouse: true
        }
      ]];
    });
    const contentCloseDirective = computed(() => {
      const dir = $q.lang.rtl === true ? otherSide.value : props4.side;
      return [[
        TouchPan_default,
        onClosePan,
        void 0,
        {
          [dir]: true,
          mouse: true
        }
      ]];
    });
    const backdropCloseDirective = computed(() => {
      const dir = $q.lang.rtl === true ? otherSide.value : props4.side;
      return [[
        TouchPan_default,
        onClosePan,
        void 0,
        {
          [dir]: true,
          mouse: true,
          mouseAllDir: true
        }
      ]];
    });
    function updateBelowBreakpoint() {
      updateLocal(belowBreakpoint, props4.behavior === "mobile" || props4.behavior !== "desktop" && $layout.totalWidth.value <= props4.breakpoint);
    }
    watch(belowBreakpoint, (val) => {
      if (val === true) {
        lastDesktopState = showing.value;
        showing.value === true && hide(false);
      } else if (props4.overlay === false && props4.behavior !== "mobile" && lastDesktopState !== false) {
        if (showing.value === true) {
          applyPosition(0);
          applyBackdrop(0);
          cleanup();
        } else {
          show(false);
        }
      }
    });
    watch(() => props4.side, (newSide, oldSide) => {
      if ($layout.instances[oldSide] === instance) {
        $layout.instances[oldSide] = void 0;
        $layout[oldSide].space = false;
        $layout[oldSide].offset = 0;
      }
      $layout.instances[newSide] = instance;
      $layout[newSide].size = size2.value;
      $layout[newSide].space = onLayout.value;
      $layout[newSide].offset = offset2.value;
    });
    watch($layout.totalWidth, () => {
      if ($layout.isContainer.value === true || document.qScrollPrevented !== true) {
        updateBelowBreakpoint();
      }
    });
    watch(
      () => props4.behavior + props4.breakpoint,
      updateBelowBreakpoint
    );
    watch($layout.isContainer, (val) => {
      showing.value === true && preventBodyScroll(val !== true);
      val === true && updateBelowBreakpoint();
    });
    watch($layout.scrollbarWidth, () => {
      applyPosition(showing.value === true ? 0 : void 0);
    });
    watch(offset2, (val) => {
      updateLayout("offset", val);
    });
    watch(onLayout, (val) => {
      emit("onLayout", val);
      updateLayout("space", val);
    });
    watch(rightSide, () => {
      applyPosition();
    });
    watch(size2, (val) => {
      applyPosition();
      updateSizeOnLayout(props4.miniToOverlay, val);
    });
    watch(() => props4.miniToOverlay, (val) => {
      updateSizeOnLayout(val, size2.value);
    });
    watch(() => $q.lang.rtl, () => {
      applyPosition();
    });
    watch(() => props4.mini, () => {
      if (props4.noMiniAnimation) return;
      if (props4.modelValue === true) {
        animateMini();
        $layout.animate();
      }
    });
    watch(isMini, (val) => {
      emit("miniState", val);
    });
    function applyPosition(position2) {
      if (position2 === void 0) {
        nextTick(() => {
          position2 = showing.value === true ? 0 : size2.value;
          applyPosition(stateDirection.value * position2);
        });
      } else {
        if ($layout.isContainer.value === true && rightSide.value === true && (belowBreakpoint.value === true || Math.abs(position2) === size2.value)) {
          position2 += stateDirection.value * $layout.scrollbarWidth.value;
        }
        flagContentPosition.value = position2;
      }
    }
    function applyBackdrop(x2) {
      flagBackdropBg.value = x2;
    }
    function setScrollable(v) {
      const action = v === true ? "remove" : $layout.isContainer.value !== true ? "add" : "";
      action !== "" && document.body.classList[action]("q-body--drawer-toggle");
    }
    function animateMini() {
      timerMini !== null && clearTimeout(timerMini);
      if (vm2.proxy && vm2.proxy.$el) {
        vm2.proxy.$el.classList.add("q-drawer--mini-animate");
      }
      flagMiniAnimate.value = true;
      timerMini = setTimeout(() => {
        timerMini = null;
        flagMiniAnimate.value = false;
        if (vm2 && vm2.proxy && vm2.proxy.$el) {
          vm2.proxy.$el.classList.remove("q-drawer--mini-animate");
        }
      }, 150);
    }
    function onOpenPan(evt) {
      if (showing.value !== false) {
        return;
      }
      const width3 = size2.value, position2 = between(evt.distance.x, 0, width3);
      if (evt.isFinal === true) {
        const opened = position2 >= Math.min(75, width3);
        if (opened === true) {
          show();
        } else {
          $layout.animate();
          applyBackdrop(0);
          applyPosition(stateDirection.value * width3);
        }
        flagPanning.value = false;
        return;
      }
      applyPosition(
        ($q.lang.rtl === true ? rightSide.value !== true : rightSide.value) ? Math.max(width3 - position2, 0) : Math.min(0, position2 - width3)
      );
      applyBackdrop(
        between(position2 / width3, 0, 1)
      );
      if (evt.isFirst === true) {
        flagPanning.value = true;
      }
    }
    function onClosePan(evt) {
      if (showing.value !== true) {
        return;
      }
      const width3 = size2.value, dir = evt.direction === props4.side, position2 = ($q.lang.rtl === true ? dir !== true : dir) ? between(evt.distance.x, 0, width3) : 0;
      if (evt.isFinal === true) {
        const opened = Math.abs(position2) < Math.min(75, width3);
        if (opened === true) {
          $layout.animate();
          applyBackdrop(1);
          applyPosition(0);
        } else {
          hide();
        }
        flagPanning.value = false;
        return;
      }
      applyPosition(stateDirection.value * position2);
      applyBackdrop(between(1 - position2 / width3, 0, 1));
      if (evt.isFirst === true) {
        flagPanning.value = true;
      }
    }
    function cleanup() {
      preventBodyScroll(false);
      setScrollable(true);
    }
    function updateLayout(prop, val) {
      $layout.update(props4.side, prop, val);
    }
    function updateLocal(prop, val) {
      if (prop.value !== val) {
        prop.value = val;
      }
    }
    function updateSizeOnLayout(miniToOverlay, size3) {
      updateLayout("size", miniToOverlay === true ? props4.miniWidth : size3);
    }
    $layout.instances[props4.side] = instance;
    updateSizeOnLayout(props4.miniToOverlay, size2.value);
    updateLayout("space", onLayout.value);
    updateLayout("offset", offset2.value);
    if (props4.showIfAbove === true && props4.modelValue !== true && showing.value === true && props4["onUpdate:modelValue"] !== void 0) {
      emit("update:modelValue", true);
    }
    onMounted(() => {
      emit("onLayout", onLayout.value);
      emit("miniState", isMini.value);
      lastDesktopState = props4.showIfAbove === true;
      const fn = () => {
        const action = showing.value === true ? handleShow : handleHide;
        action(false, true);
      };
      if ($layout.totalWidth.value !== 0) {
        nextTick(fn);
        return;
      }
      layoutTotalWidthWatcher = watch($layout.totalWidth, () => {
        layoutTotalWidthWatcher();
        layoutTotalWidthWatcher = void 0;
        if (showing.value === false && props4.showIfAbove === true && belowBreakpoint.value === false) {
          show(false);
        } else {
          fn();
        }
      });
    });
    onBeforeUnmount(() => {
      layoutTotalWidthWatcher !== void 0 && layoutTotalWidthWatcher();
      if (timerMini !== null) {
        clearTimeout(timerMini);
        timerMini = null;
      }
      showing.value === true && cleanup();
      if ($layout.instances[props4.side] === instance) {
        $layout.instances[props4.side] = void 0;
        updateLayout("size", 0);
        updateLayout("offset", 0);
        updateLayout("space", false);
      }
    });
    return () => {
      const child = [];
      if (belowBreakpoint.value === true) {
        props4.noSwipeOpen === false && child.push(
          withDirectives(
            h("div", {
              key: "open",
              class: `q-drawer__opener fixed-${props4.side}`,
              "aria-hidden": "true"
            }),
            openDirective.value
          )
        );
        child.push(
          hDir(
            "div",
            {
              ref: "backdrop",
              class: backdropClass.value,
              style: backdropStyle.value,
              "aria-hidden": "true",
              onClick: hide
            },
            void 0,
            "backdrop",
            props4.noSwipeBackdrop !== true && showing.value === true,
            () => backdropCloseDirective.value
          )
        );
      }
      const mini = isMini.value === true && slots.mini !== void 0;
      const content = [
        h(
          "div",
          {
            ...attrs,
            key: "" + mini,
            // required otherwise Vue will not diff correctly
            class: [
              contentClass.value,
              attrs.class
            ]
          },
          mini === true ? slots.mini() : hSlot(slots.default)
        )
      ];
      if (props4.elevated === true && showing.value === true) {
        content.push(
          h("div", {
            class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
          })
        );
      }
      child.push(
        hDir(
          "aside",
          { ref: "content", class: classes.value, style: style2.value },
          content,
          "contentclose",
          props4.noSwipeClose !== true && belowBreakpoint.value === true,
          () => contentCloseDirective.value
        )
      );
      return h("div", { class: "q-drawer-container" }, child);
    };
  }
});
function getBlockElement(el, parent) {
  if (parent && el === parent) {
    return null;
  }
  const nodeName = el.nodeName.toLowerCase();
  if (["div", "li", "ul", "ol", "blockquote"].includes(nodeName) === true) {
    return el;
  }
  const style2 = window.getComputedStyle ? window.getComputedStyle(el) : el.currentStyle, display = style2.display;
  if (display === "block" || display === "table") {
    return el;
  }
  return getBlockElement(el.parentNode);
}
function isChildOf(el, parent, orSame) {
  return !el || el === document.body ? false : orSame === true && el === parent || (parent === document ? document.body : parent).contains(el.parentNode);
}
function createRange(node, chars, range2) {
  if (!range2) {
    range2 = document.createRange();
    range2.selectNode(node);
    range2.setStart(node, 0);
  }
  if (chars.count === 0) {
    range2.setEnd(node, chars.count);
  } else if (chars.count > 0) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent.length < chars.count) {
        chars.count -= node.textContent.length;
      } else {
        range2.setEnd(node, chars.count);
        chars.count = 0;
      }
    } else {
      for (let lp = 0; chars.count !== 0 && lp < node.childNodes.length; lp++) {
        range2 = createRange(node.childNodes[lp], chars, range2);
      }
    }
  }
  return range2;
}
var urlRegex = /^https?:\/\//;
var Caret = class {
  constructor(el, eVm) {
    this.el = el;
    this.eVm = eVm;
    this._range = null;
  }
  get selection() {
    if (this.el) {
      const sel = document.getSelection();
      if (isChildOf(sel.anchorNode, this.el, true) && isChildOf(sel.focusNode, this.el, true)) {
        return sel;
      }
    }
    return null;
  }
  get hasSelection() {
    return this.selection !== null ? this.selection.toString().length !== 0 : false;
  }
  get range() {
    const sel = this.selection;
    if (sel !== null && sel.rangeCount) {
      return sel.getRangeAt(0);
    }
    return this._range;
  }
  get parent() {
    const range2 = this.range;
    if (range2 !== null) {
      const node = range2.startContainer;
      return node.nodeType === document.ELEMENT_NODE ? node : node.parentNode;
    }
    return null;
  }
  get blockParent() {
    const parent = this.parent;
    if (parent !== null) {
      return getBlockElement(parent, this.el);
    }
    return null;
  }
  save(range2 = this.range) {
    if (range2 !== null) {
      this._range = range2;
    }
  }
  restore(range2 = this._range) {
    const r = document.createRange(), sel = document.getSelection();
    if (range2 !== null) {
      r.setStart(range2.startContainer, range2.startOffset);
      r.setEnd(range2.endContainer, range2.endOffset);
      sel.removeAllRanges();
      sel.addRange(r);
    } else {
      sel.selectAllChildren(this.el);
      sel.collapseToEnd();
    }
  }
  savePosition() {
    let charCount = -1, node;
    const selection = document.getSelection(), parentEl = this.el.parentNode;
    if (selection.focusNode && isChildOf(selection.focusNode, parentEl)) {
      node = selection.focusNode;
      charCount = selection.focusOffset;
      while (node && node !== parentEl) {
        if (node !== this.el && node.previousSibling) {
          node = node.previousSibling;
          charCount += node.textContent.length;
        } else {
          node = node.parentNode;
        }
      }
    }
    this.savedPos = charCount;
  }
  restorePosition(length = 0) {
    if (this.savedPos > 0 && this.savedPos < length) {
      const selection = window.getSelection(), range2 = createRange(this.el, { count: this.savedPos });
      if (range2) {
        range2.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range2);
      }
    }
  }
  hasParent(name2, spanLevel) {
    const el = spanLevel ? this.parent : this.blockParent;
    return el !== null ? el.nodeName.toLowerCase() === name2.toLowerCase() : false;
  }
  hasParents(list, recursive, el = this.parent) {
    if (el === null) {
      return false;
    }
    if (list.includes(el.nodeName.toLowerCase()) === true) {
      return true;
    }
    return recursive === true ? this.hasParents(list, recursive, el.parentNode) : false;
  }
  is(cmd, param) {
    if (this.selection === null) {
      return false;
    }
    switch (cmd) {
      case "formatBlock":
        return param === "DIV" && this.parent === this.el || this.hasParent(param, param === "PRE");
      case "link":
        return this.hasParent("A", true);
      case "fontSize":
        return document.queryCommandValue(cmd) === param;
      case "fontName":
        const res = document.queryCommandValue(cmd);
        return res === `"${param}"` || res === param;
      case "fullscreen":
        return this.eVm.inFullscreen.value;
      case "viewsource":
        return this.eVm.isViewingSource.value;
      case void 0:
        return false;
      default:
        const state2 = document.queryCommandState(cmd);
        return param !== void 0 ? state2 === param : state2;
    }
  }
  getParentAttribute(attrib) {
    if (this.parent !== null) {
      return this.parent.getAttribute(attrib);
    }
    return null;
  }
  can(name2) {
    if (name2 === "outdent") {
      return this.hasParents(["blockquote", "li"], true);
    }
    if (name2 === "indent") {
      return this.hasParents(["li"], true);
    }
    if (name2 === "link") {
      return this.selection !== null || this.is("link");
    }
  }
  apply(cmd, param, done = noop) {
    if (cmd === "formatBlock") {
      if (["BLOCKQUOTE", "H1", "H2", "H3", "H4", "H5", "H6"].includes(param) && this.is(cmd, param)) {
        cmd = "outdent";
        param = null;
      }
      if (param === "PRE" && this.is(cmd, "PRE")) {
        param = "P";
      }
    } else if (cmd === "print") {
      done();
      const win = window.open();
      win.document.write(`
        <!doctype html>
        <html>
          <head>
            <title>Print - ${document.title}</title>
          </head>
          <body>
            <div>${this.el.innerHTML}</div>
          </body>
        </html>
      `);
      win.print();
      win.close();
      return;
    } else if (cmd === "link") {
      const link = this.getParentAttribute("href");
      if (link === null) {
        const selection = this.selectWord(this.selection);
        const url = selection ? selection.toString() : "";
        if (!url.length) {
          if (!this.range || !this.range.cloneContents().querySelector("img")) {
            return;
          }
        }
        this.eVm.editLinkUrl.value = urlRegex.test(url) ? url : "https://";
        document.execCommand("createLink", false, this.eVm.editLinkUrl.value);
        this.save(selection.getRangeAt(0));
      } else {
        this.eVm.editLinkUrl.value = link;
        this.range.selectNodeContents(this.parent);
        this.save();
      }
      return;
    } else if (cmd === "fullscreen") {
      this.eVm.toggleFullscreen();
      done();
      return;
    } else if (cmd === "viewsource") {
      this.eVm.isViewingSource.value = this.eVm.isViewingSource.value === false;
      this.eVm.setContent(this.eVm.props.modelValue);
      done();
      return;
    }
    document.execCommand(cmd, false, param);
    done();
  }
  selectWord(sel) {
    if (sel === null || sel.isCollapsed !== true || /* IE 11 */
    sel.modify === void 0) {
      return sel;
    }
    const range2 = document.createRange();
    range2.setStart(sel.anchorNode, sel.anchorOffset);
    range2.setEnd(sel.focusNode, sel.focusOffset);
    const direction = range2.collapsed ? ["backward", "forward"] : ["forward", "backward"];
    range2.detach();
    const endNode = sel.focusNode, endOffset = sel.focusOffset;
    sel.collapse(sel.anchorNode, sel.anchorOffset);
    sel.modify("move", direction[0], "character");
    sel.modify("move", direction[1], "word");
    sel.extend(endNode, endOffset);
    sel.modify("extend", direction[1], "character");
    sel.modify("extend", direction[0], "word");
    return sel;
  }
};
var QTooltip_default = createComponent({
  name: "QTooltip",
  inheritAttrs: false,
  props: {
    ...useAnchorStaticProps,
    ...useModelToggleProps,
    ...useTransitionProps,
    maxHeight: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: null
    },
    transitionShow: {
      ...useTransitionProps.transitionShow,
      default: "jump-down"
    },
    transitionHide: {
      ...useTransitionProps.transitionHide,
      default: "jump-up"
    },
    anchor: {
      type: String,
      default: "bottom middle",
      validator: validatePosition
    },
    self: {
      type: String,
      default: "top middle",
      validator: validatePosition
    },
    offset: {
      type: Array,
      default: () => [14, 14],
      validator: validateOffset
    },
    scrollTarget: scrollTargetProp,
    delay: {
      type: Number,
      default: 0
    },
    hideDelay: {
      type: Number,
      default: 0
    },
    persistent: Boolean
  },
  emits: [
    ...useModelToggleEmits
  ],
  setup(props4, { slots, emit, attrs }) {
    let unwatchPosition, observer;
    const vm2 = getCurrentInstance();
    const { proxy: { $q } } = vm2;
    const innerRef = ref$1(null);
    const showing = ref$1(false);
    const anchorOrigin = computed(() => parsePosition(props4.anchor, $q.lang.rtl));
    const selfOrigin = computed(() => parsePosition(props4.self, $q.lang.rtl));
    const hideOnRouteChange = computed(() => props4.persistent !== true);
    const { registerTick, removeTick } = use_tick_default();
    const { registerTimeout } = use_timeout_default();
    const { transitionProps, transitionStyle } = use_transition_default(props4);
    const { localScrollTarget, changeScrollEvent, unconfigureScrollTarget } = use_scroll_target_default(props4, configureScrollTarget);
    const { anchorEl, canShow, anchorEvents } = use_anchor_default({ showing, configureAnchorEl });
    const { show, hide } = use_model_toggle_default({
      showing,
      canShow,
      handleShow,
      handleHide,
      hideOnRouteChange,
      processOnMount: true
    });
    Object.assign(anchorEvents, { delayShow, delayHide });
    const { showPortal, hidePortal, renderPortal } = use_portal_default(vm2, innerRef, renderPortalContent, "tooltip");
    if ($q.platform.is.mobile === true) {
      const clickOutsideProps = {
        anchorEl,
        innerRef,
        onClickOutside(e2) {
          hide(e2);
          if (e2.target.classList.contains("q-dialog__backdrop")) {
            stopAndPrevent(e2);
          }
          return true;
        }
      };
      const hasClickOutside = computed(
        () => (
          // it doesn't has external model
          // (null is the default value)
          props4.modelValue === null && props4.persistent !== true && showing.value === true
        )
      );
      watch(hasClickOutside, (val) => {
        const fn = val === true ? addClickOutside : removeClickOutside;
        fn(clickOutsideProps);
      });
      onBeforeUnmount(() => {
        removeClickOutside(clickOutsideProps);
      });
    }
    function handleShow(evt) {
      showPortal();
      registerTick(() => {
        observer = new MutationObserver(() => updatePosition());
        observer.observe(innerRef.value, { attributes: false, childList: true, characterData: true, subtree: true });
        updatePosition();
        configureScrollTarget();
      });
      if (unwatchPosition === void 0) {
        unwatchPosition = watch(
          () => $q.screen.width + "|" + $q.screen.height + "|" + props4.self + "|" + props4.anchor + "|" + $q.lang.rtl,
          updatePosition
        );
      }
      registerTimeout(() => {
        showPortal(true);
        emit("show", evt);
      }, props4.transitionDuration);
    }
    function handleHide(evt) {
      removeTick();
      hidePortal();
      anchorCleanup();
      registerTimeout(() => {
        hidePortal(true);
        emit("hide", evt);
      }, props4.transitionDuration);
    }
    function anchorCleanup() {
      if (observer !== void 0) {
        observer.disconnect();
        observer = void 0;
      }
      if (unwatchPosition !== void 0) {
        unwatchPosition();
        unwatchPosition = void 0;
      }
      unconfigureScrollTarget();
      cleanEvt(anchorEvents, "tooltipTemp");
    }
    function updatePosition() {
      setPosition({
        targetEl: innerRef.value,
        offset: props4.offset,
        anchorEl: anchorEl.value,
        anchorOrigin: anchorOrigin.value,
        selfOrigin: selfOrigin.value,
        maxHeight: props4.maxHeight,
        maxWidth: props4.maxWidth
      });
    }
    function delayShow(evt) {
      if ($q.platform.is.mobile === true) {
        clearSelection();
        document.body.classList.add("non-selectable");
        const target2 = anchorEl.value;
        const evts = ["touchmove", "touchcancel", "touchend", "click"].map((e2) => [target2, e2, "delayHide", "passiveCapture"]);
        addEvt(anchorEvents, "tooltipTemp", evts);
      }
      registerTimeout(() => {
        show(evt);
      }, props4.delay);
    }
    function delayHide(evt) {
      if ($q.platform.is.mobile === true) {
        cleanEvt(anchorEvents, "tooltipTemp");
        clearSelection();
        setTimeout(() => {
          document.body.classList.remove("non-selectable");
        }, 10);
      }
      registerTimeout(() => {
        hide(evt);
      }, props4.hideDelay);
    }
    function configureAnchorEl() {
      if (props4.noParentEvent === true || anchorEl.value === null) return;
      const evts = $q.platform.is.mobile === true ? [
        [anchorEl.value, "touchstart", "delayShow", "passive"]
      ] : [
        [anchorEl.value, "mouseenter", "delayShow", "passive"],
        [anchorEl.value, "mouseleave", "delayHide", "passive"]
      ];
      addEvt(anchorEvents, "anchor", evts);
    }
    function configureScrollTarget() {
      if (anchorEl.value !== null || props4.scrollTarget !== void 0) {
        localScrollTarget.value = getScrollTarget(anchorEl.value, props4.scrollTarget);
        const fn = props4.noParentEvent === true ? updatePosition : hide;
        changeScrollEvent(localScrollTarget.value, fn);
      }
    }
    function getTooltipContent() {
      return showing.value === true ? h("div", {
        ...attrs,
        ref: innerRef,
        class: [
          "q-tooltip q-tooltip--style q-position-engine no-pointer-events",
          attrs.class
        ],
        style: [
          attrs.style,
          transitionStyle.value
        ],
        role: "tooltip"
      }, hSlot(slots.default)) : null;
    }
    function renderPortalContent() {
      return h(Transition, transitionProps.value, getTooltipContent);
    }
    onBeforeUnmount(anchorCleanup);
    Object.assign(vm2.proxy, { updatePosition });
    return renderPortal;
  }
});
var QItem_default = createComponent({
  name: "QItem",
  props: {
    ...useDarkProps,
    ...useRouterLinkProps,
    tag: {
      type: String,
      default: "div"
    },
    active: {
      type: Boolean,
      default: null
    },
    clickable: Boolean,
    dense: Boolean,
    insetLevel: Number,
    tabindex: [String, Number],
    focused: Boolean,
    manualFocus: Boolean
  },
  emits: ["click", "keyup"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const { hasLink, linkAttrs, linkClass, linkTag, navigateOnClick } = use_router_link_default();
    const rootRef = ref$1(null);
    const blurTargetRef = ref$1(null);
    const isActionable = computed(
      () => props4.clickable === true || hasLink.value === true || props4.tag === "label"
    );
    const isClickable = computed(
      () => props4.disable !== true && isActionable.value === true
    );
    const classes = computed(
      () => "q-item q-item-type row no-wrap" + (props4.dense === true ? " q-item--dense" : "") + (isDark.value === true ? " q-item--dark" : "") + (hasLink.value === true && props4.active === null ? linkClass.value : props4.active === true ? ` q-item--active${props4.activeClass !== void 0 ? ` ${props4.activeClass}` : ""}` : "") + (props4.disable === true ? " disabled" : "") + (isClickable.value === true ? " q-item--clickable q-link cursor-pointer " + (props4.manualFocus === true ? "q-manual-focusable" : "q-focusable q-hoverable") + (props4.focused === true ? " q-manual-focusable--focused" : "") : "")
    );
    const style2 = computed(() => {
      if (props4.insetLevel === void 0) {
        return null;
      }
      const dir = $q.lang.rtl === true ? "Right" : "Left";
      return {
        ["padding" + dir]: 16 + props4.insetLevel * 56 + "px"
      };
    });
    function onClick(e2) {
      if (isClickable.value === true) {
        if (blurTargetRef.value !== null) {
          if (e2.qKeyEvent !== true && document.activeElement === rootRef.value) {
            blurTargetRef.value.focus();
          } else if (document.activeElement === blurTargetRef.value) {
            rootRef.value.focus();
          }
        }
        navigateOnClick(e2);
      }
    }
    function onKeyup2(e2) {
      if (isClickable.value === true && isKeyCode(e2, [13, 32]) === true) {
        stopAndPrevent(e2);
        e2.qKeyEvent = true;
        const evt = new MouseEvent("click", e2);
        evt.qKeyEvent = true;
        rootRef.value.dispatchEvent(evt);
      }
      emit("keyup", e2);
    }
    function getContent() {
      const child = hUniqueSlot(slots.default, []);
      isClickable.value === true && child.unshift(
        h("div", { class: "q-focus-helper", tabindex: -1, ref: blurTargetRef })
      );
      return child;
    }
    return () => {
      const data = {
        ref: rootRef,
        class: classes.value,
        style: style2.value,
        role: "listitem",
        onClick,
        onKeyup: onKeyup2
      };
      if (isClickable.value === true) {
        data.tabindex = props4.tabindex || "0";
        Object.assign(data, linkAttrs.value);
      } else if (isActionable.value === true) {
        data["aria-disabled"] = "true";
      }
      return h(
        linkTag.value,
        data,
        getContent()
      );
    };
  }
});
var QItemSection_default = createComponent({
  name: "QItemSection",
  props: {
    avatar: Boolean,
    thumbnail: Boolean,
    side: Boolean,
    top: Boolean,
    noWrap: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => `q-item__section column q-item__section--${props4.avatar === true || props4.side === true || props4.thumbnail === true ? "side" : "main"}` + (props4.top === true ? " q-item__section--top justify-start" : " justify-center") + (props4.avatar === true ? " q-item__section--avatar" : "") + (props4.thumbnail === true ? " q-item__section--thumbnail" : "") + (props4.noWrap === true ? " q-item__section--nowrap" : "")
    );
    return () => h("div", { class: classes.value }, hSlot(slots.default));
  }
});
function run(e2, btn, eVm) {
  if (btn.handler) {
    btn.handler(e2, eVm, eVm.caret);
  } else {
    eVm.runCmd(btn.cmd, btn.param);
  }
}
function getGroup(children) {
  return h("div", { class: "q-editor__toolbar-group" }, children);
}
function getBtn(eVm, btn, clickHandler, active = false) {
  const toggled = active || (btn.type === "toggle" ? btn.toggled ? btn.toggled(eVm) : btn.cmd && eVm.caret.is(btn.cmd, btn.param) : false), child = [];
  if (btn.tip && eVm.$q.platform.is.desktop) {
    const Key = btn.key ? h("div", [
      h("small", `(CTRL + ${String.fromCharCode(btn.key)})`)
    ]) : null;
    child.push(
      h(QTooltip_default, { delay: 1e3 }, () => [
        h("div", { innerHTML: btn.tip }),
        Key
      ])
    );
  }
  return h(QBtn_default, {
    ...eVm.buttonProps.value,
    icon: btn.icon !== null ? btn.icon : void 0,
    color: toggled ? btn.toggleColor || eVm.props.toolbarToggleColor : btn.color || eVm.props.toolbarColor,
    textColor: toggled && !eVm.props.toolbarPush ? null : btn.textColor || eVm.props.toolbarTextColor,
    label: btn.label,
    disable: btn.disable ? typeof btn.disable === "function" ? btn.disable(eVm) : true : false,
    size: "sm",
    onClick(e2) {
      clickHandler && clickHandler();
      run(e2, btn, eVm);
    }
  }, () => child);
}
function getDropdown(eVm, btn) {
  const onlyIcons = btn.list === "only-icons";
  let label = btn.label, icon = btn.icon !== null ? btn.icon : void 0, contentClass, Items;
  function closeDropdown() {
    Dropdown.component.proxy.hide();
  }
  if (onlyIcons) {
    Items = btn.options.map((btn2) => {
      const active = btn2.type === void 0 ? eVm.caret.is(btn2.cmd, btn2.param) : false;
      if (active) {
        label = btn2.tip;
        icon = btn2.icon !== null ? btn2.icon : void 0;
      }
      return getBtn(eVm, btn2, closeDropdown, active);
    });
    contentClass = eVm.toolbarBackgroundClass.value;
    Items = [
      getGroup(Items)
    ];
  } else {
    const activeClass = eVm.props.toolbarToggleColor !== void 0 ? `text-${eVm.props.toolbarToggleColor}` : null;
    const inactiveClass = eVm.props.toolbarTextColor !== void 0 ? `text-${eVm.props.toolbarTextColor}` : null;
    const noIcons = btn.list === "no-icons";
    Items = btn.options.map((btn2) => {
      const disable = btn2.disable ? btn2.disable(eVm) : false;
      const active = btn2.type === void 0 ? eVm.caret.is(btn2.cmd, btn2.param) : false;
      if (active) {
        label = btn2.tip;
        icon = btn2.icon !== null ? btn2.icon : void 0;
      }
      const htmlTip = btn2.htmlTip;
      return h(QItem_default, {
        active,
        activeClass,
        clickable: true,
        disable,
        dense: true,
        onClick(e2) {
          closeDropdown();
          eVm.contentRef.value !== null && eVm.contentRef.value.focus();
          eVm.caret.restore();
          run(e2, btn2, eVm);
        }
      }, () => [
        noIcons === true ? null : h(
          QItemSection_default,
          {
            class: active ? activeClass : inactiveClass,
            side: true
          },
          () => h(QIcon_default, { name: btn2.icon !== null ? btn2.icon : void 0 })
        ),
        h(
          QItemSection_default,
          htmlTip ? () => h("div", { class: "text-no-wrap", innerHTML: btn2.htmlTip }) : btn2.tip ? () => h("div", { class: "text-no-wrap" }, btn2.tip) : void 0
        )
      ]);
    });
    contentClass = [eVm.toolbarBackgroundClass.value, inactiveClass];
  }
  const highlight = btn.highlight && label !== btn.label;
  const Dropdown = h(QBtnDropdown_default, {
    ...eVm.buttonProps.value,
    noCaps: true,
    noWrap: true,
    color: highlight ? eVm.props.toolbarToggleColor : eVm.props.toolbarColor,
    textColor: highlight && !eVm.props.toolbarPush ? null : eVm.props.toolbarTextColor,
    label: btn.fixedLabel ? btn.label : label,
    icon: btn.fixedIcon ? btn.icon !== null ? btn.icon : void 0 : icon,
    contentClass,
    onShow: (evt) => eVm.emit("dropdownShow", evt),
    onHide: (evt) => eVm.emit("dropdownHide", evt),
    onBeforeShow: (evt) => eVm.emit("dropdownBeforeShow", evt),
    onBeforeHide: (evt) => eVm.emit("dropdownBeforeHide", evt)
  }, () => Items);
  return Dropdown;
}
function getToolbar(eVm) {
  if (eVm.caret) {
    return eVm.buttons.value.filter((f) => {
      return !eVm.isViewingSource.value || f.find((fb) => fb.cmd === "viewsource");
    }).map((group) => getGroup(
      group.map((btn) => {
        if (eVm.isViewingSource.value && btn.cmd !== "viewsource") {
          return false;
        }
        if (btn.type === "slot") {
          return hSlot(eVm.slots[btn.slot]);
        }
        if (btn.type === "dropdown") {
          return getDropdown(eVm, btn);
        }
        return getBtn(eVm, btn);
      })
    ));
  }
}
function getFonts(defaultFont, defaultFontLabel, defaultFontIcon, fonts = {}) {
  const aliases = Object.keys(fonts);
  if (aliases.length === 0) {
    return {};
  }
  const def = {
    default_font: {
      cmd: "fontName",
      param: defaultFont,
      icon: defaultFontIcon,
      tip: defaultFontLabel
    }
  };
  aliases.forEach((alias) => {
    const name2 = fonts[alias];
    def[alias] = {
      cmd: "fontName",
      param: name2,
      icon: defaultFontIcon,
      tip: name2,
      htmlTip: `<font face="${name2}">${name2}</font>`
    };
  });
  return def;
}
function getLinkEditor(eVm) {
  if (eVm.caret) {
    const color = eVm.props.toolbarColor || eVm.props.toolbarTextColor;
    let link = eVm.editLinkUrl.value;
    const updateLink = () => {
      eVm.caret.restore();
      if (link !== eVm.editLinkUrl.value) {
        document.execCommand("createLink", false, link === "" ? " " : link);
      }
      eVm.editLinkUrl.value = null;
    };
    return [
      h("div", { class: `q-mx-xs text-${color}` }, `${eVm.$q.lang.editor.url}: `),
      h("input", {
        key: "qedt_btm_input",
        class: "col q-editor__link-input",
        value: link,
        onInput: (evt) => {
          stop(evt);
          link = evt.target.value;
        },
        onKeydown: (evt) => {
          if (shouldIgnoreKey(evt) === true) {
            return;
          }
          switch (evt.keyCode) {
            case 13:
              prevent(evt);
              return updateLink();
            case 27:
              prevent(evt);
              eVm.caret.restore();
              if (!eVm.editLinkUrl.value || eVm.editLinkUrl.value === "https://") {
                document.execCommand("unlink");
              }
              eVm.editLinkUrl.value = null;
              break;
          }
        }
      }),
      getGroup([
        h(QBtn_default, {
          key: "qedt_btm_rem",
          tabindex: -1,
          ...eVm.buttonProps.value,
          label: eVm.$q.lang.label.remove,
          noCaps: true,
          onClick: () => {
            eVm.caret.restore();
            document.execCommand("unlink");
            eVm.editLinkUrl.value = null;
          }
        }),
        h(QBtn_default, {
          key: "qedt_btm_upd",
          ...eVm.buttonProps.value,
          label: eVm.$q.lang.label.update,
          noCaps: true,
          onClick: updateLink
        })
      ])
    ];
  }
}
var listenerRE = /^on[A-Z]/;
function use_split_attrs_default() {
  const { attrs, vnode } = getCurrentInstance();
  const acc = {
    listeners: ref$1({}),
    attributes: ref$1({})
  };
  function update6() {
    const attributes = {};
    const listeners = {};
    for (const key in attrs) {
      if (key !== "class" && key !== "style" && listenerRE.test(key) === false) {
        attributes[key] = attrs[key];
      }
    }
    for (const key in vnode.props) {
      if (listenerRE.test(key) === true) {
        listeners[key] = vnode.props[key];
      }
    }
    acc.attributes.value = attributes;
    acc.listeners.value = listeners;
  }
  onBeforeUpdate(update6);
  update6();
  return acc;
}
var toString = Object.prototype.toString;
var hasOwn$2 = Object.prototype.hasOwnProperty;
var notPlainObject = new Set(
  ["Boolean", "Number", "String", "Function", "Array", "Date", "RegExp"].map((name2) => "[object " + name2 + "]")
);
function isPlainObject(obj) {
  if (obj !== Object(obj) || notPlainObject.has(toString.call(obj)) === true) {
    return false;
  }
  if (obj.constructor && hasOwn$2.call(obj, "constructor") === false && hasOwn$2.call(obj.constructor.prototype, "isPrototypeOf") === false) {
    return false;
  }
  let key;
  for (key in obj) {
  }
  return key === void 0 || hasOwn$2.call(obj, key);
}
function extend() {
  let options, name2, src, copy, copyIsArray, clone2, target2 = arguments[0] || {}, i2 = 1, deep = false;
  const length = arguments.length;
  if (typeof target2 === "boolean") {
    deep = target2;
    target2 = arguments[1] || {};
    i2 = 2;
  }
  if (Object(target2) !== target2 && typeof target2 !== "function") {
    target2 = {};
  }
  if (length === i2) {
    target2 = this;
    i2--;
  }
  for (; i2 < length; i2++) {
    if ((options = arguments[i2]) !== null) {
      for (name2 in options) {
        src = target2[name2];
        copy = options[name2];
        if (target2 === copy) {
          continue;
        }
        if (deep === true && copy && ((copyIsArray = Array.isArray(copy)) || isPlainObject(copy) === true)) {
          if (copyIsArray === true) {
            clone2 = Array.isArray(src) === true ? src : [];
          } else {
            clone2 = isPlainObject(src) === true ? src : {};
          }
          target2[name2] = extend(deep, clone2, copy);
        } else if (copy !== void 0) {
          target2[name2] = copy;
        }
      }
    }
  }
  return target2;
}
createComponent({
  name: "QEditor",
  props: {
    ...useDarkProps,
    ...useFullscreenProps,
    modelValue: {
      type: String,
      required: true
    },
    readonly: Boolean,
    disable: Boolean,
    minHeight: {
      type: String,
      default: "10rem"
    },
    maxHeight: String,
    height: String,
    definitions: Object,
    fonts: Object,
    placeholder: String,
    toolbar: {
      type: Array,
      validator: (v) => v.length === 0 || v.every((group) => group.length),
      // long line on purpose for API validation purposes:
      default: () => [["left", "center", "right", "justify"], ["bold", "italic", "underline", "strike"], ["undo", "redo"]]
    },
    toolbarColor: String,
    toolbarBg: String,
    toolbarTextColor: String,
    toolbarToggleColor: {
      type: String,
      default: "primary"
    },
    toolbarOutline: Boolean,
    toolbarPush: Boolean,
    toolbarRounded: Boolean,
    paragraphTag: {
      type: String,
      validator: (v) => ["div", "p"].includes(v),
      default: "div"
    },
    contentStyle: Object,
    contentClass: [Object, Array, String],
    square: Boolean,
    flat: Boolean,
    dense: Boolean
  },
  emits: [
    ...useFullscreenEmits,
    "update:modelValue",
    "keydown",
    "click",
    "focus",
    "blur",
    "dropdownShow",
    "dropdownHide",
    "dropdownBeforeShow",
    "dropdownBeforeHide",
    "linkShow",
    "linkHide"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const { inFullscreen, toggleFullscreen } = use_fullscreen_default();
    const splitAttrs = use_split_attrs_default();
    const rootRef = ref$1(null);
    const contentRef = ref$1(null);
    const editLinkUrl = ref$1(null);
    const isViewingSource = ref$1(false);
    const editable = computed(() => !props4.readonly && !props4.disable);
    let defaultFont, offsetBottom;
    let lastEmit = props4.modelValue;
    {
      document.execCommand("defaultParagraphSeparator", false, props4.paragraphTag);
      defaultFont = window.getComputedStyle(document.body).fontFamily;
    }
    const toolbarBackgroundClass = computed(() => props4.toolbarBg ? ` bg-${props4.toolbarBg}` : "");
    const buttonProps = computed(() => {
      const flat = props4.toolbarOutline !== true && props4.toolbarPush !== true;
      return {
        type: "a",
        flat,
        noWrap: true,
        outline: props4.toolbarOutline,
        push: props4.toolbarPush,
        rounded: props4.toolbarRounded,
        dense: true,
        color: props4.toolbarColor,
        disable: !editable.value,
        size: "sm"
      };
    });
    const buttonDef = computed(() => {
      const e2 = $q.lang.editor, i2 = $q.iconSet.editor;
      return {
        bold: { cmd: "bold", icon: i2.bold, tip: e2.bold, key: 66 },
        italic: { cmd: "italic", icon: i2.italic, tip: e2.italic, key: 73 },
        strike: { cmd: "strikeThrough", icon: i2.strikethrough, tip: e2.strikethrough, key: 83 },
        underline: { cmd: "underline", icon: i2.underline, tip: e2.underline, key: 85 },
        unordered: { cmd: "insertUnorderedList", icon: i2.unorderedList, tip: e2.unorderedList },
        ordered: { cmd: "insertOrderedList", icon: i2.orderedList, tip: e2.orderedList },
        subscript: { cmd: "subscript", icon: i2.subscript, tip: e2.subscript, htmlTip: "x<subscript>2</subscript>" },
        superscript: { cmd: "superscript", icon: i2.superscript, tip: e2.superscript, htmlTip: "x<superscript>2</superscript>" },
        link: { cmd: "link", disable: (eVm2) => eVm2.caret && !eVm2.caret.can("link"), icon: i2.hyperlink, tip: e2.hyperlink, key: 76 },
        fullscreen: { cmd: "fullscreen", icon: i2.toggleFullscreen, tip: e2.toggleFullscreen, key: 70 },
        viewsource: { cmd: "viewsource", icon: i2.viewSource, tip: e2.viewSource },
        quote: { cmd: "formatBlock", param: "BLOCKQUOTE", icon: i2.quote, tip: e2.quote, key: 81 },
        left: { cmd: "justifyLeft", icon: i2.left, tip: e2.left },
        center: { cmd: "justifyCenter", icon: i2.center, tip: e2.center },
        right: { cmd: "justifyRight", icon: i2.right, tip: e2.right },
        justify: { cmd: "justifyFull", icon: i2.justify, tip: e2.justify },
        print: { type: "no-state", cmd: "print", icon: i2.print, tip: e2.print, key: 80 },
        outdent: { type: "no-state", disable: (eVm2) => eVm2.caret && !eVm2.caret.can("outdent"), cmd: "outdent", icon: i2.outdent, tip: e2.outdent },
        indent: { type: "no-state", disable: (eVm2) => eVm2.caret && !eVm2.caret.can("indent"), cmd: "indent", icon: i2.indent, tip: e2.indent },
        removeFormat: { type: "no-state", cmd: "removeFormat", icon: i2.removeFormat, tip: e2.removeFormat },
        hr: { type: "no-state", cmd: "insertHorizontalRule", icon: i2.hr, tip: e2.hr },
        undo: { type: "no-state", cmd: "undo", icon: i2.undo, tip: e2.undo, key: 90 },
        redo: { type: "no-state", cmd: "redo", icon: i2.redo, tip: e2.redo, key: 89 },
        h1: { cmd: "formatBlock", param: "H1", icon: i2.heading1 || i2.heading, tip: e2.heading1, htmlTip: `<h1 class="q-ma-none">${e2.heading1}</h1>` },
        h2: { cmd: "formatBlock", param: "H2", icon: i2.heading2 || i2.heading, tip: e2.heading2, htmlTip: `<h2 class="q-ma-none">${e2.heading2}</h2>` },
        h3: { cmd: "formatBlock", param: "H3", icon: i2.heading3 || i2.heading, tip: e2.heading3, htmlTip: `<h3 class="q-ma-none">${e2.heading3}</h3>` },
        h4: { cmd: "formatBlock", param: "H4", icon: i2.heading4 || i2.heading, tip: e2.heading4, htmlTip: `<h4 class="q-ma-none">${e2.heading4}</h4>` },
        h5: { cmd: "formatBlock", param: "H5", icon: i2.heading5 || i2.heading, tip: e2.heading5, htmlTip: `<h5 class="q-ma-none">${e2.heading5}</h5>` },
        h6: { cmd: "formatBlock", param: "H6", icon: i2.heading6 || i2.heading, tip: e2.heading6, htmlTip: `<h6 class="q-ma-none">${e2.heading6}</h6>` },
        p: { cmd: "formatBlock", param: props4.paragraphTag, icon: i2.heading, tip: e2.paragraph },
        code: { cmd: "formatBlock", param: "PRE", icon: i2.code, htmlTip: `<code>${e2.code}</code>` },
        "size-1": { cmd: "fontSize", param: "1", icon: i2.size1 || i2.size, tip: e2.size1, htmlTip: `<font size="1">${e2.size1}</font>` },
        "size-2": { cmd: "fontSize", param: "2", icon: i2.size2 || i2.size, tip: e2.size2, htmlTip: `<font size="2">${e2.size2}</font>` },
        "size-3": { cmd: "fontSize", param: "3", icon: i2.size3 || i2.size, tip: e2.size3, htmlTip: `<font size="3">${e2.size3}</font>` },
        "size-4": { cmd: "fontSize", param: "4", icon: i2.size4 || i2.size, tip: e2.size4, htmlTip: `<font size="4">${e2.size4}</font>` },
        "size-5": { cmd: "fontSize", param: "5", icon: i2.size5 || i2.size, tip: e2.size5, htmlTip: `<font size="5">${e2.size5}</font>` },
        "size-6": { cmd: "fontSize", param: "6", icon: i2.size6 || i2.size, tip: e2.size6, htmlTip: `<font size="6">${e2.size6}</font>` },
        "size-7": { cmd: "fontSize", param: "7", icon: i2.size7 || i2.size, tip: e2.size7, htmlTip: `<font size="7">${e2.size7}</font>` }
      };
    });
    const buttons = computed(() => {
      const userDef = props4.definitions || {};
      const def = props4.definitions || props4.fonts ? extend(
        true,
        {},
        buttonDef.value,
        userDef,
        getFonts(
          defaultFont,
          $q.lang.editor.defaultFont,
          $q.iconSet.editor.font,
          props4.fonts
        )
      ) : buttonDef.value;
      return props4.toolbar.map(
        (group) => group.map((token2) => {
          if (token2.options) {
            return {
              type: "dropdown",
              icon: token2.icon,
              label: token2.label,
              size: "sm",
              dense: true,
              fixedLabel: token2.fixedLabel,
              fixedIcon: token2.fixedIcon,
              highlight: token2.highlight,
              list: token2.list,
              options: token2.options.map((item) => def[item])
            };
          }
          const obj = def[token2];
          if (obj) {
            return obj.type === "no-state" || userDef[token2] && (obj.cmd === void 0 || buttonDef.value[obj.cmd] && buttonDef.value[obj.cmd].type === "no-state") ? obj : Object.assign({ type: "toggle" }, obj);
          } else {
            return {
              type: "slot",
              slot: token2
            };
          }
        })
      );
    });
    const eVm = {
      $q,
      props: props4,
      slots,
      emit,
      // caret (will get injected after mount)
      inFullscreen,
      toggleFullscreen,
      runCmd,
      isViewingSource,
      editLinkUrl,
      toolbarBackgroundClass,
      buttonProps,
      contentRef,
      buttons,
      setContent
    };
    watch(() => props4.modelValue, (v) => {
      if (lastEmit !== v) {
        lastEmit = v;
        setContent(v, true);
      }
    });
    watch(editLinkUrl, (v) => {
      emit(`link${v ? "Show" : "Hide"}`);
    });
    const hasToolbar = computed(() => props4.toolbar && props4.toolbar.length !== 0);
    const keys = computed(() => {
      const k2 = {}, add2 = (btn) => {
        if (btn.key) {
          k2[btn.key] = {
            cmd: btn.cmd,
            param: btn.param
          };
        }
      };
      buttons.value.forEach((group) => {
        group.forEach((token2) => {
          if (token2.options) {
            token2.options.forEach(add2);
          } else {
            add2(token2);
          }
        });
      });
      return k2;
    });
    const innerStyle = computed(() => inFullscreen.value ? props4.contentStyle : [
      {
        minHeight: props4.minHeight,
        height: props4.height,
        maxHeight: props4.maxHeight
      },
      props4.contentStyle
    ]);
    const classes = computed(
      () => `q-editor q-editor--${isViewingSource.value === true ? "source" : "default"}` + (props4.disable === true ? " disabled" : "") + (inFullscreen.value === true ? " fullscreen column" : "") + (props4.square === true ? " q-editor--square no-border-radius" : "") + (props4.flat === true ? " q-editor--flat" : "") + (props4.dense === true ? " q-editor--dense" : "") + (isDark.value === true ? " q-editor--dark q-dark" : "")
    );
    const innerClass = computed(() => [
      props4.contentClass,
      "q-editor__content",
      { col: inFullscreen.value, "overflow-auto": inFullscreen.value || props4.maxHeight }
    ]);
    const attributes = computed(() => props4.disable === true ? { "aria-disabled": "true" } : {});
    function onInput() {
      if (contentRef.value !== null) {
        const prop = `inner${isViewingSource.value === true ? "Text" : "HTML"}`;
        const val = contentRef.value[prop];
        if (val !== props4.modelValue) {
          lastEmit = val;
          emit("update:modelValue", val);
        }
      }
    }
    function onKeydown2(e2) {
      emit("keydown", e2);
      if (e2.ctrlKey !== true || shouldIgnoreKey(e2) === true) {
        refreshToolbar();
        return;
      }
      const key = e2.keyCode;
      const target2 = keys.value[key];
      if (target2 !== void 0) {
        const { cmd, param } = target2;
        stopAndPrevent(e2);
        runCmd(cmd, param, false);
      }
    }
    function onClick(e2) {
      refreshToolbar();
      emit("click", e2);
    }
    function onBlur2(e2) {
      if (contentRef.value !== null) {
        const { scrollTop, scrollHeight } = contentRef.value;
        offsetBottom = scrollHeight - scrollTop;
      }
      eVm.caret.save();
      emit("blur", e2);
    }
    function onFocus(e2) {
      nextTick(() => {
        if (contentRef.value !== null && offsetBottom !== void 0) {
          contentRef.value.scrollTop = contentRef.value.scrollHeight - offsetBottom;
        }
      });
      emit("focus", e2);
    }
    function onFocusin(e2) {
      const root = rootRef.value;
      if (root !== null && root.contains(e2.target) === true && (e2.relatedTarget === null || root.contains(e2.relatedTarget) !== true)) {
        const prop = `inner${isViewingSource.value === true ? "Text" : "HTML"}`;
        eVm.caret.restorePosition(contentRef.value[prop].length);
        refreshToolbar();
      }
    }
    function onFocusout(e2) {
      const root = rootRef.value;
      if (root !== null && root.contains(e2.target) === true && (e2.relatedTarget === null || root.contains(e2.relatedTarget) !== true)) {
        eVm.caret.savePosition();
        refreshToolbar();
      }
    }
    function onPointerStart() {
      offsetBottom = void 0;
    }
    function onSelectionchange(e2) {
      eVm.caret.save();
    }
    function setContent(v, restorePosition) {
      if (contentRef.value !== null) {
        if (restorePosition === true) {
          eVm.caret.savePosition();
        }
        const prop = `inner${isViewingSource.value === true ? "Text" : "HTML"}`;
        contentRef.value[prop] = v;
        if (restorePosition === true) {
          eVm.caret.restorePosition(contentRef.value[prop].length);
          refreshToolbar();
        }
      }
    }
    function runCmd(cmd, param, update6 = true) {
      focus();
      eVm.caret.restore();
      eVm.caret.apply(cmd, param, () => {
        focus();
        eVm.caret.save();
        if (update6) {
          refreshToolbar();
        }
      });
    }
    function refreshToolbar() {
      setTimeout(() => {
        editLinkUrl.value = null;
        proxy.$forceUpdate();
      }, 1);
    }
    function focus() {
      addFocusFn(() => {
        contentRef.value !== null && contentRef.value.focus({ preventScroll: true });
      });
    }
    function getContentEl() {
      return contentRef.value;
    }
    onMounted(() => {
      eVm.caret = proxy.caret = new Caret(contentRef.value, eVm);
      setContent(props4.modelValue);
      refreshToolbar();
      document.addEventListener("selectionchange", onSelectionchange);
    });
    onBeforeUnmount(() => {
      document.removeEventListener("selectionchange", onSelectionchange);
    });
    Object.assign(proxy, {
      runCmd,
      refreshToolbar,
      focus,
      getContentEl
    });
    return () => {
      let toolbars;
      if (hasToolbar.value) {
        const bars = [
          h("div", {
            key: "qedt_top",
            class: "q-editor__toolbar row no-wrap scroll-x" + toolbarBackgroundClass.value
          }, getToolbar(eVm))
        ];
        editLinkUrl.value !== null && bars.push(
          h("div", {
            key: "qedt_btm",
            class: "q-editor__toolbar row no-wrap items-center scroll-x" + toolbarBackgroundClass.value
          }, getLinkEditor(eVm))
        );
        toolbars = h("div", {
          key: "toolbar_ctainer",
          class: "q-editor__toolbars-container"
        }, bars);
      }
      return h("div", {
        ref: rootRef,
        class: classes.value,
        style: { height: inFullscreen.value === true ? "100%" : null },
        ...attributes.value,
        onFocusin,
        onFocusout
      }, [
        toolbars,
        h("div", {
          ref: contentRef,
          style: innerStyle.value,
          class: innerClass.value,
          contenteditable: editable.value,
          placeholder: props4.placeholder,
          ...{},
          ...splitAttrs.listeners.value,
          onInput,
          onKeydown: onKeydown2,
          onClick,
          onBlur: onBlur2,
          onFocus,
          // clean saved scroll position
          onMousedown: onPointerStart,
          onTouchstartPassive: onPointerStart
        })
      ]);
    };
  }
});
var QItemLabel_default = createComponent({
  name: "QItemLabel",
  props: {
    overline: Boolean,
    caption: Boolean,
    header: Boolean,
    lines: [Number, String]
  },
  setup(props4, { slots }) {
    const parsedLines = computed(() => parseInt(props4.lines, 10));
    const classes = computed(
      () => "q-item__label" + (props4.overline === true ? " q-item__label--overline text-overline" : "") + (props4.caption === true ? " q-item__label--caption text-caption" : "") + (props4.header === true ? " q-item__label--header" : "") + (parsedLines.value === 1 ? " ellipsis" : "")
    );
    const style2 = computed(() => {
      return props4.lines !== void 0 && parsedLines.value > 1 ? {
        overflow: "hidden",
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": parsedLines.value
      } : null;
    });
    return () => h("div", {
      style: style2.value,
      class: classes.value
    }, hSlot(slots.default));
  }
});
var QSlideTransition_default = createComponent({
  name: "QSlideTransition",
  props: {
    appear: Boolean,
    duration: {
      type: Number,
      default: 300
    }
  },
  emits: ["show", "hide"],
  setup(props4, { slots, emit }) {
    let animating = false, doneFn, element;
    let timer2 = null, timerFallback = null, animListener, lastEvent;
    function cleanup() {
      doneFn && doneFn();
      doneFn = null;
      animating = false;
      if (timer2 !== null) {
        clearTimeout(timer2);
        timer2 = null;
      }
      if (timerFallback !== null) {
        clearTimeout(timerFallback);
        timerFallback = null;
      }
      element !== void 0 && element.removeEventListener("transitionend", animListener);
      animListener = null;
    }
    function begin(el, height2, done) {
      if (height2 !== void 0) {
        el.style.height = `${height2}px`;
      }
      el.style.transition = `height ${props4.duration}ms cubic-bezier(.25, .8, .50, 1)`;
      animating = true;
      doneFn = done;
    }
    function end(el, event) {
      el.style.overflowY = null;
      el.style.height = null;
      el.style.transition = null;
      cleanup();
      event !== lastEvent && emit(event);
    }
    function onEnter(el, done) {
      let pos = 0;
      element = el;
      if (animating === true) {
        cleanup();
        pos = el.offsetHeight === el.scrollHeight ? 0 : void 0;
      } else {
        lastEvent = "hide";
        el.style.overflowY = "hidden";
      }
      begin(el, pos, done);
      timer2 = setTimeout(() => {
        timer2 = null;
        el.style.height = `${el.scrollHeight}px`;
        animListener = (evt) => {
          timerFallback = null;
          if (Object(evt) !== evt || evt.target === el) {
            end(el, "show");
          }
        };
        el.addEventListener("transitionend", animListener);
        timerFallback = setTimeout(animListener, props4.duration * 1.1);
      }, 100);
    }
    function onLeave(el, done) {
      let pos;
      element = el;
      if (animating === true) {
        cleanup();
      } else {
        lastEvent = "show";
        el.style.overflowY = "hidden";
        pos = el.scrollHeight;
      }
      begin(el, pos, done);
      timer2 = setTimeout(() => {
        timer2 = null;
        el.style.height = 0;
        animListener = (evt) => {
          timerFallback = null;
          if (Object(evt) !== evt || evt.target === el) {
            end(el, "hide");
          }
        };
        el.addEventListener("transitionend", animListener);
        timerFallback = setTimeout(animListener, props4.duration * 1.1);
      }, 100);
    }
    onBeforeUnmount(() => {
      animating === true && cleanup();
    });
    return () => h(Transition, {
      css: false,
      appear: props4.appear,
      onEnter,
      onLeave
    }, slots.default);
  }
});
var insetMap = {
  true: "inset",
  item: "item-inset",
  "item-thumbnail": "item-thumbnail-inset"
};
var margins = {
  xs: 2,
  sm: 4,
  md: 8,
  lg: 16,
  xl: 24
};
var QSeparator_default = createComponent({
  name: "QSeparator",
  props: {
    ...useDarkProps,
    spaced: [Boolean, String],
    inset: [Boolean, String],
    vertical: Boolean,
    color: String,
    size: String
  },
  setup(props4) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const orientation = computed(() => props4.vertical === true ? "vertical" : "horizontal");
    const orientClass = computed(() => ` q-separator--${orientation.value}`);
    const insetClass = computed(() => props4.inset !== false ? `${orientClass.value}-${insetMap[props4.inset]}` : "");
    const classes = computed(
      () => `q-separator${orientClass.value}${insetClass.value}` + (props4.color !== void 0 ? ` bg-${props4.color}` : "") + (isDark.value === true ? " q-separator--dark" : "")
    );
    const style2 = computed(() => {
      const acc = {};
      if (props4.size !== void 0) {
        acc[props4.vertical === true ? "width" : "height"] = props4.size;
      }
      if (props4.spaced !== false) {
        const size2 = props4.spaced === true ? `${margins.md}px` : props4.spaced in margins ? `${margins[props4.spaced]}px` : props4.spaced;
        const dir = props4.vertical === true ? ["Left", "Right"] : ["Top", "Bottom"];
        acc[`margin${dir[0]}`] = acc[`margin${dir[1]}`] = size2;
      }
      return acc;
    });
    return () => h("hr", {
      class: classes.value,
      style: style2.value,
      "aria-orientation": orientation.value
    });
  }
});
var itemGroups = shallowReactive({});
var LINK_PROPS = Object.keys(useRouterLinkProps);
var QExpansionItem_default = createComponent({
  name: "QExpansionItem",
  props: {
    ...useRouterLinkProps,
    ...useModelToggleProps,
    ...useDarkProps,
    icon: String,
    label: String,
    labelLines: [Number, String],
    caption: String,
    captionLines: [Number, String],
    dense: Boolean,
    toggleAriaLabel: String,
    expandIcon: String,
    expandedIcon: String,
    expandIconClass: [Array, String, Object],
    duration: {},
    headerInsetLevel: Number,
    contentInsetLevel: Number,
    expandSeparator: Boolean,
    defaultOpened: Boolean,
    hideExpandIcon: Boolean,
    expandIconToggle: Boolean,
    switchToggleSide: Boolean,
    denseToggle: Boolean,
    group: String,
    popup: Boolean,
    headerStyle: [Array, String, Object],
    headerClass: [Array, String, Object]
  },
  emits: [
    ...useModelToggleEmits,
    "click",
    "afterShow",
    "afterHide"
  ],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const showing = ref$1(
      props4.modelValue !== null ? props4.modelValue : props4.defaultOpened
    );
    const blurTargetRef = ref$1(null);
    const targetUid = use_id_default();
    const { show, hide, toggle } = use_model_toggle_default({ showing });
    let uniqueId, exitGroup;
    const classes = computed(
      () => `q-expansion-item q-item-type q-expansion-item--${showing.value === true ? "expanded" : "collapsed"} q-expansion-item--${props4.popup === true ? "popup" : "standard"}`
    );
    const contentStyle = computed(() => {
      if (props4.contentInsetLevel === void 0) {
        return null;
      }
      const dir = $q.lang.rtl === true ? "Right" : "Left";
      return {
        ["padding" + dir]: props4.contentInsetLevel * 56 + "px"
      };
    });
    const hasLink = computed(
      () => props4.disable !== true && (props4.href !== void 0 || props4.to !== void 0 && props4.to !== null && props4.to !== "")
    );
    const linkProps = computed(() => {
      const acc = {};
      LINK_PROPS.forEach((key) => {
        acc[key] = props4[key];
      });
      return acc;
    });
    const isClickable = computed(
      () => hasLink.value === true || props4.expandIconToggle !== true
    );
    const expansionIcon = computed(() => props4.expandedIcon !== void 0 && showing.value === true ? props4.expandedIcon : props4.expandIcon || $q.iconSet.expansionItem[props4.denseToggle === true ? "denseIcon" : "icon"]);
    const activeToggleIcon = computed(
      () => props4.disable !== true && (hasLink.value === true || props4.expandIconToggle === true)
    );
    const headerSlotScope = computed(() => ({
      expanded: showing.value === true,
      detailsId: targetUid.value,
      toggle,
      show,
      hide
    }));
    const toggleAriaAttrs = computed(() => {
      const toggleAriaLabel = props4.toggleAriaLabel !== void 0 ? props4.toggleAriaLabel : $q.lang.label[showing.value === true ? "collapse" : "expand"](props4.label);
      return {
        role: "button",
        "aria-expanded": showing.value === true ? "true" : "false",
        "aria-controls": targetUid.value,
        "aria-label": toggleAriaLabel
      };
    });
    watch(() => props4.group, (name2) => {
      exitGroup !== void 0 && exitGroup();
      name2 !== void 0 && enterGroup();
    });
    function onHeaderClick(e2) {
      hasLink.value !== true && toggle(e2);
      emit("click", e2);
    }
    function toggleIconKeyboard(e2) {
      e2.keyCode === 13 && toggleIcon(e2, true);
    }
    function toggleIcon(e2, keyboard) {
      keyboard !== true && blurTargetRef.value !== null && blurTargetRef.value.focus();
      toggle(e2);
      stopAndPrevent(e2);
    }
    function onShow() {
      emit("afterShow");
    }
    function onHide() {
      emit("afterHide");
    }
    function enterGroup() {
      if (uniqueId === void 0) {
        uniqueId = uid_default();
      }
      if (showing.value === true) {
        itemGroups[props4.group] = uniqueId;
      }
      const show2 = watch(showing, (val) => {
        if (val === true) {
          itemGroups[props4.group] = uniqueId;
        } else if (itemGroups[props4.group] === uniqueId) {
          delete itemGroups[props4.group];
        }
      });
      const group = watch(
        () => itemGroups[props4.group],
        (val, oldVal) => {
          if (oldVal === uniqueId && val !== void 0 && val !== uniqueId) {
            hide();
          }
        }
      );
      exitGroup = () => {
        show2();
        group();
        if (itemGroups[props4.group] === uniqueId) {
          delete itemGroups[props4.group];
        }
        exitGroup = void 0;
      };
    }
    function getToggleIcon() {
      const data = {
        class: [
          `q-focusable relative-position cursor-pointer${props4.denseToggle === true && props4.switchToggleSide === true ? " items-end" : ""}`,
          props4.expandIconClass
        ],
        side: props4.switchToggleSide !== true,
        avatar: props4.switchToggleSide
      };
      const child = [
        h(QIcon_default, {
          class: "q-expansion-item__toggle-icon" + (props4.expandedIcon === void 0 && showing.value === true ? " q-expansion-item__toggle-icon--rotated" : ""),
          name: expansionIcon.value
        })
      ];
      if (activeToggleIcon.value === true) {
        Object.assign(data, {
          tabindex: 0,
          ...toggleAriaAttrs.value,
          onClick: toggleIcon,
          onKeyup: toggleIconKeyboard
        });
        child.unshift(
          h("div", {
            ref: blurTargetRef,
            class: "q-expansion-item__toggle-focus q-icon q-focus-helper q-focus-helper--rounded",
            tabindex: -1
          })
        );
      }
      return h(QItemSection_default, data, () => child);
    }
    function getHeaderChild() {
      let child;
      if (slots.header !== void 0) {
        child = [].concat(slots.header(headerSlotScope.value));
      } else {
        child = [
          h(QItemSection_default, () => [
            h(QItemLabel_default, { lines: props4.labelLines }, () => props4.label || ""),
            props4.caption ? h(QItemLabel_default, { lines: props4.captionLines, caption: true }, () => props4.caption) : null
          ])
        ];
        props4.icon && child[props4.switchToggleSide === true ? "push" : "unshift"](
          h(QItemSection_default, {
            side: props4.switchToggleSide === true,
            avatar: props4.switchToggleSide !== true
          }, () => h(QIcon_default, { name: props4.icon }))
        );
      }
      if (props4.disable !== true && props4.hideExpandIcon !== true) {
        child[props4.switchToggleSide === true ? "unshift" : "push"](
          getToggleIcon()
        );
      }
      return child;
    }
    function getHeader() {
      const data = {
        ref: "item",
        style: props4.headerStyle,
        class: props4.headerClass,
        dark: isDark.value,
        disable: props4.disable,
        dense: props4.dense,
        insetLevel: props4.headerInsetLevel
      };
      if (isClickable.value === true) {
        data.clickable = true;
        data.onClick = onHeaderClick;
        Object.assign(
          data,
          hasLink.value === true ? linkProps.value : toggleAriaAttrs.value
        );
      }
      return h(QItem_default, data, getHeaderChild);
    }
    function getTransitionChild() {
      return withDirectives(
        h("div", {
          key: "e-content",
          class: "q-expansion-item__content relative-position",
          style: contentStyle.value,
          id: targetUid.value
        }, hSlot(slots.default)),
        [[
          vShow,
          showing.value
        ]]
      );
    }
    function getContent() {
      const node = [
        getHeader(),
        h(QSlideTransition_default, {
          duration: props4.duration,
          onShow,
          onHide
        }, getTransitionChild)
      ];
      if (props4.expandSeparator === true) {
        node.push(
          h(QSeparator_default, {
            class: "q-expansion-item__border q-expansion-item__border--top absolute-top",
            dark: isDark.value
          }),
          h(QSeparator_default, {
            class: "q-expansion-item__border q-expansion-item__border--bottom absolute-bottom",
            dark: isDark.value
          })
        );
      }
      return node;
    }
    props4.group !== void 0 && enterGroup();
    onBeforeUnmount(() => {
      exitGroup !== void 0 && exitGroup();
    });
    return () => h("div", { class: classes.value }, [
      h("div", { class: "q-expansion-item__container relative-position" }, getContent())
    ]);
  }
});
var labelPositions = ["top", "right", "bottom", "left"];
var useFabProps = {
  type: {
    type: String,
    default: "a"
  },
  outline: Boolean,
  push: Boolean,
  flat: Boolean,
  unelevated: Boolean,
  color: String,
  textColor: String,
  glossy: Boolean,
  square: Boolean,
  padding: String,
  label: {
    type: [String, Number],
    default: ""
  },
  labelPosition: {
    type: String,
    default: "right",
    validator: (v) => labelPositions.includes(v)
  },
  externalLabel: Boolean,
  hideLabel: {
    type: Boolean
  },
  labelClass: [Array, String, Object],
  labelStyle: [Array, String, Object],
  disable: Boolean,
  tabindex: [Number, String]
};
function use_fab_default(props4, showing) {
  return {
    formClass: computed(
      () => `q-fab--form-${props4.square === true ? "square" : "rounded"}`
    ),
    stacked: computed(
      () => props4.externalLabel === false && ["top", "bottom"].includes(props4.labelPosition)
    ),
    labelProps: computed(() => {
      if (props4.externalLabel === true) {
        const hideLabel = props4.hideLabel === null ? showing.value === false : props4.hideLabel;
        return {
          action: "push",
          data: {
            class: [
              props4.labelClass,
              `q-fab__label q-tooltip--style q-fab__label--external q-fab__label--external-${props4.labelPosition}` + (hideLabel === true ? " q-fab__label--external-hidden" : "")
            ],
            style: props4.labelStyle
          }
        };
      }
      return {
        action: ["left", "top"].includes(props4.labelPosition) ? "unshift" : "push",
        data: {
          class: [
            props4.labelClass,
            `q-fab__label q-fab__label--internal q-fab__label--internal-${props4.labelPosition}` + (props4.hideLabel === true ? " q-fab__label--internal-hidden" : "")
          ],
          style: props4.labelStyle
        }
      };
    })
  };
}
var directions = ["up", "right", "down", "left"];
var alignValues4 = ["left", "center", "right"];
createComponent({
  name: "QFab",
  props: {
    ...useFabProps,
    ...useModelToggleProps,
    icon: String,
    activeIcon: String,
    hideIcon: Boolean,
    hideLabel: {
      ...useFabProps.hideLabel,
      default: null
    },
    direction: {
      type: String,
      default: "right",
      validator: (v) => directions.includes(v)
    },
    persistent: Boolean,
    verticalActionsAlign: {
      type: String,
      default: "center",
      validator: (v) => alignValues4.includes(v)
    }
  },
  emits: useModelToggleEmits,
  setup(props4, { slots }) {
    const triggerRef = ref$1(null);
    const showing = ref$1(props4.modelValue === true);
    const targetUid = use_id_default();
    const { proxy: { $q } } = getCurrentInstance();
    const { formClass, labelProps } = use_fab_default(props4, showing);
    const hideOnRouteChange = computed(() => props4.persistent !== true);
    const { hide, toggle } = use_model_toggle_default({
      showing,
      hideOnRouteChange
    });
    const slotScope = computed(() => ({ opened: showing.value }));
    const classes = computed(
      () => `q-fab z-fab row inline justify-center q-fab--align-${props4.verticalActionsAlign} ${formClass.value}` + (showing.value === true ? " q-fab--opened" : " q-fab--closed")
    );
    const actionClass = computed(
      () => `q-fab__actions flex no-wrap inline q-fab__actions--${props4.direction} q-fab__actions--${showing.value === true ? "opened" : "closed"}`
    );
    const actionAttrs = computed(() => {
      const attrs = {
        id: targetUid.value,
        role: "menu"
      };
      if (showing.value !== true) {
        attrs["aria-hidden"] = "true";
      }
      return attrs;
    });
    const iconHolderClass = computed(
      () => `q-fab__icon-holder  q-fab__icon-holder--${showing.value === true ? "opened" : "closed"}`
    );
    function getIcon(kebab, camel) {
      const slotFn = slots[kebab];
      const classes2 = `q-fab__${kebab} absolute-full`;
      return slotFn === void 0 ? h(QIcon_default, { class: classes2, name: props4[camel] || $q.iconSet.fab[camel] }) : h("div", { class: classes2 }, slotFn(slotScope.value));
    }
    function getTriggerContent() {
      const child = [];
      props4.hideIcon !== true && child.push(
        h("div", { class: iconHolderClass.value }, [
          getIcon("icon", "icon"),
          getIcon("active-icon", "activeIcon")
        ])
      );
      if (props4.label !== "" || slots.label !== void 0) {
        child[labelProps.value.action](
          h("div", labelProps.value.data, slots.label !== void 0 ? slots.label(slotScope.value) : [props4.label])
        );
      }
      return hMergeSlot(slots.tooltip, child);
    }
    provide(fabKey, {
      showing,
      onChildClick(evt) {
        hide(evt);
        if (triggerRef.value !== null) {
          triggerRef.value.$el.focus();
        }
      }
    });
    return () => h("div", {
      class: classes.value
    }, [
      h(QBtn_default, {
        ref: triggerRef,
        class: formClass.value,
        ...props4,
        noWrap: true,
        stack: props4.stacked,
        align: void 0,
        icon: void 0,
        label: void 0,
        noCaps: true,
        fab: true,
        "aria-expanded": showing.value === true ? "true" : "false",
        "aria-haspopup": "true",
        "aria-controls": targetUid.value,
        onClick: toggle
      }, getTriggerContent),
      h("div", { class: actionClass.value, ...actionAttrs.value }, hSlot(slots.default))
    ]);
  }
});
var anchorMap = {
  start: "self-end",
  center: "self-center",
  end: "self-start"
};
var anchorValues = Object.keys(anchorMap);
createComponent({
  name: "QFabAction",
  props: {
    ...useFabProps,
    icon: {
      type: String,
      default: ""
    },
    anchor: {
      type: String,
      validator: (v) => anchorValues.includes(v)
    },
    to: [String, Object],
    replace: Boolean
  },
  emits: ["click"],
  setup(props4, { slots, emit }) {
    const $fab = inject(fabKey, () => ({
      showing: { value: true },
      onChildClick: noop
    }));
    const { formClass, labelProps } = use_fab_default(props4, $fab.showing);
    const classes = computed(() => {
      const align = anchorMap[props4.anchor];
      return formClass.value + (align !== void 0 ? ` ${align}` : "");
    });
    const isDisabled = computed(
      () => props4.disable === true || $fab.showing.value !== true
    );
    function click(e2) {
      $fab.onChildClick(e2);
      emit("click", e2);
    }
    function getContent() {
      const child = [];
      if (slots.icon !== void 0) {
        child.push(slots.icon());
      } else if (props4.icon !== "") {
        child.push(
          h(QIcon_default, { name: props4.icon })
        );
      }
      if (props4.label !== "" || slots.label !== void 0) {
        child[labelProps.value.action](
          h("div", labelProps.value.data, slots.label !== void 0 ? slots.label() : [props4.label])
        );
      }
      return hMergeSlot(slots.default, child);
    }
    const vm2 = getCurrentInstance();
    Object.assign(vm2.proxy, { click });
    return () => h(QBtn_default, {
      class: classes.value,
      ...props4,
      noWrap: true,
      stack: props4.stacked,
      icon: void 0,
      label: void 0,
      noCaps: true,
      fabMini: true,
      disable: isDisabled.value,
      onClick: click
    }, getContent);
  }
});
function use_form_child_default({ validate: validate2, resetValidation, requiresQForm }) {
  const $form = inject(formKey, false);
  if ($form !== false) {
    const { props: props4, proxy } = getCurrentInstance();
    Object.assign(proxy, { validate: validate2, resetValidation });
    watch(() => props4.disable, (val) => {
      if (val === true) {
        typeof resetValidation === "function" && resetValidation();
        $form.unbindComponent(proxy);
      } else {
        $form.bindComponent(proxy);
      }
    });
    onMounted(() => {
      props4.disable !== true && $form.bindComponent(proxy);
    });
    onBeforeUnmount(() => {
      props4.disable !== true && $form.unbindComponent(proxy);
    });
  } else if (requiresQForm === true) {
    console.error("Parent QForm not found on useFormChild()!");
  }
}
var lazyRulesValues = [true, false, "ondemand"];
var useValidateProps = {
  modelValue: {},
  error: {
    type: Boolean,
    default: null
  },
  errorMessage: String,
  noErrorIcon: Boolean,
  rules: Array,
  reactiveRules: Boolean,
  lazyRules: {
    type: [Boolean, String],
    default: false,
    // statement unneeded but avoids future vue implementation changes
    validator: (v) => lazyRulesValues.includes(v)
  }
};
function use_validate_default(focused, innerLoading) {
  const { props: props4, proxy } = getCurrentInstance();
  const innerError = ref$1(false);
  const innerErrorMessage = ref$1(null);
  const isDirtyModel = ref$1(false);
  use_form_child_default({ validate: validate2, resetValidation });
  let validateIndex = 0, unwatchRules;
  const hasRules = computed(
    () => props4.rules !== void 0 && props4.rules !== null && props4.rules.length !== 0
  );
  const canDebounceValidate = computed(() => props4.disable !== true && hasRules.value === true && innerLoading.value === false);
  const hasError = computed(
    () => props4.error === true || innerError.value === true
  );
  const errorMessage = computed(() => typeof props4.errorMessage === "string" && props4.errorMessage.length !== 0 ? props4.errorMessage : innerErrorMessage.value);
  watch(() => props4.modelValue, () => {
    isDirtyModel.value = true;
    if (canDebounceValidate.value === true && props4.lazyRules === false) {
      debouncedValidate();
    }
  });
  function onRulesChange() {
    if (props4.lazyRules !== "ondemand" && canDebounceValidate.value === true && isDirtyModel.value === true) {
      debouncedValidate();
    }
  }
  watch(() => props4.reactiveRules, (val) => {
    if (val === true) {
      if (unwatchRules === void 0) {
        unwatchRules = watch(() => props4.rules, onRulesChange, { immediate: true, deep: true });
      }
    } else if (unwatchRules !== void 0) {
      unwatchRules();
      unwatchRules = void 0;
    }
  }, { immediate: true });
  watch(() => props4.lazyRules, onRulesChange);
  watch(focused, (val) => {
    if (val === true) {
      isDirtyModel.value = true;
    } else if (canDebounceValidate.value === true && props4.lazyRules !== "ondemand") {
      debouncedValidate();
    }
  });
  function resetValidation() {
    validateIndex++;
    innerLoading.value = false;
    isDirtyModel.value = false;
    innerError.value = false;
    innerErrorMessage.value = null;
    debouncedValidate.cancel();
  }
  function validate2(val = props4.modelValue) {
    if (props4.disable === true || hasRules.value === false) {
      return true;
    }
    const index = ++validateIndex;
    const setDirty = innerLoading.value !== true ? () => {
      isDirtyModel.value = true;
    } : () => {
    };
    const update6 = (err, msg) => {
      err === true && setDirty();
      innerError.value = err;
      innerErrorMessage.value = msg || null;
      innerLoading.value = false;
    };
    const promises = [];
    for (let i2 = 0; i2 < props4.rules.length; i2++) {
      const rule = props4.rules[i2];
      let res;
      if (typeof rule === "function") {
        res = rule(val, testPattern);
      } else if (typeof rule === "string" && testPattern[rule] !== void 0) {
        res = testPattern[rule](val);
      }
      if (res === false || typeof res === "string") {
        update6(true, res);
        return false;
      } else if (res !== true && res !== void 0) {
        promises.push(res);
      }
    }
    if (promises.length === 0) {
      update6(false);
      return true;
    }
    innerLoading.value = true;
    return Promise.all(promises).then(
      (res) => {
        if (res === void 0 || Array.isArray(res) === false || res.length === 0) {
          index === validateIndex && update6(false);
          return true;
        }
        const msg = res.find((r) => r === false || typeof r === "string");
        index === validateIndex && update6(msg !== void 0, msg);
        return msg === void 0;
      },
      (e2) => {
        if (index === validateIndex) {
          console.error(e2);
          update6(true);
        }
        return false;
      }
    );
  }
  const debouncedValidate = debounce_default(validate2, 0);
  onBeforeUnmount(() => {
    unwatchRules !== void 0 && unwatchRules();
    debouncedValidate.cancel();
  });
  Object.assign(proxy, { resetValidation, validate: validate2 });
  injectProp(proxy, "hasError", () => hasError.value);
  return {
    isDirtyModel,
    hasRules,
    hasError,
    errorMessage,
    validate: validate2,
    resetValidation
  };
}
function fieldValueIsFilled(val) {
  return val !== void 0 && val !== null && ("" + val).length !== 0;
}
var useNonInputFieldProps = {
  ...useDarkProps,
  ...useValidateProps,
  label: String,
  stackLabel: Boolean,
  hint: String,
  hideHint: Boolean,
  prefix: String,
  suffix: String,
  labelColor: String,
  color: String,
  bgColor: String,
  filled: Boolean,
  outlined: Boolean,
  borderless: Boolean,
  standout: [Boolean, String],
  square: Boolean,
  loading: Boolean,
  labelSlot: Boolean,
  bottomSlots: Boolean,
  hideBottomSpace: Boolean,
  rounded: Boolean,
  dense: Boolean,
  itemAligned: Boolean,
  counter: Boolean,
  clearable: Boolean,
  clearIcon: String,
  disable: Boolean,
  readonly: Boolean,
  autofocus: Boolean,
  for: String
};
var useFieldProps = {
  ...useNonInputFieldProps,
  maxlength: [Number, String]
};
var useFieldEmits = ["update:modelValue", "clear", "focus", "blur"];
function useFieldState({ requiredForAttr = true, tagProp, changeEvent = false } = {}) {
  const { props: props4, proxy } = getCurrentInstance();
  const isDark = use_dark_default(props4, proxy.$q);
  const targetUid = use_id_default({
    required: requiredForAttr,
    getValue: () => props4.for
  });
  return {
    requiredForAttr,
    changeEvent,
    tag: tagProp === true ? computed(() => props4.tag) : { value: "label" },
    isDark,
    editable: computed(
      () => props4.disable !== true && props4.readonly !== true
    ),
    innerLoading: ref$1(false),
    focused: ref$1(false),
    hasPopupOpen: false,
    splitAttrs: use_split_attrs_default(),
    targetUid,
    rootRef: ref$1(null),
    targetRef: ref$1(null),
    controlRef: ref$1(null)
    /**
         * user supplied additionals:
    
         * innerValue - computed
         * floatingLabel - computed
         * inputRef - computed
    
         * fieldClass - computed
         * hasShadow - computed
    
         * controlEvents - Object with fn(e)
    
         * getControl - fn
         * getInnerAppend - fn
         * getControlChild - fn
         * getShadowControl - fn
         * showPopup - fn
         */
  };
}
function use_field_default(state2) {
  const { props: props4, emit, slots, attrs, proxy } = getCurrentInstance();
  const { $q } = proxy;
  let focusoutTimer = null;
  if (state2.hasValue === void 0) {
    state2.hasValue = computed(() => fieldValueIsFilled(props4.modelValue));
  }
  if (state2.emitValue === void 0) {
    state2.emitValue = (value2) => {
      emit("update:modelValue", value2);
    };
  }
  if (state2.controlEvents === void 0) {
    state2.controlEvents = {
      onFocusin: onControlFocusin,
      onFocusout: onControlFocusout
    };
  }
  Object.assign(state2, {
    clearValue,
    onControlFocusin,
    onControlFocusout,
    focus
  });
  if (state2.computedCounter === void 0) {
    state2.computedCounter = computed(() => {
      if (props4.counter !== false) {
        const len = typeof props4.modelValue === "string" || typeof props4.modelValue === "number" ? ("" + props4.modelValue).length : Array.isArray(props4.modelValue) === true ? props4.modelValue.length : 0;
        const max2 = props4.maxlength !== void 0 ? props4.maxlength : props4.maxValues;
        return len + (max2 !== void 0 ? " / " + max2 : "");
      }
    });
  }
  const {
    isDirtyModel,
    hasRules,
    hasError,
    errorMessage,
    resetValidation
  } = use_validate_default(state2.focused, state2.innerLoading);
  const floatingLabel = state2.floatingLabel !== void 0 ? computed(() => props4.stackLabel === true || state2.focused.value === true || state2.floatingLabel.value === true) : computed(() => props4.stackLabel === true || state2.focused.value === true || state2.hasValue.value === true);
  const shouldRenderBottom = computed(
    () => props4.bottomSlots === true || props4.hint !== void 0 || hasRules.value === true || props4.counter === true || props4.error !== null
  );
  const styleType = computed(() => {
    if (props4.filled === true) {
      return "filled";
    }
    if (props4.outlined === true) {
      return "outlined";
    }
    if (props4.borderless === true) {
      return "borderless";
    }
    if (props4.standout) {
      return "standout";
    }
    return "standard";
  });
  const classes = computed(
    () => `q-field row no-wrap items-start q-field--${styleType.value}` + (state2.fieldClass !== void 0 ? ` ${state2.fieldClass.value}` : "") + (props4.rounded === true ? " q-field--rounded" : "") + (props4.square === true ? " q-field--square" : "") + (floatingLabel.value === true ? " q-field--float" : "") + (hasLabel.value === true ? " q-field--labeled" : "") + (props4.dense === true ? " q-field--dense" : "") + (props4.itemAligned === true ? " q-field--item-aligned q-item-type" : "") + (state2.isDark.value === true ? " q-field--dark" : "") + (state2.getControl === void 0 ? " q-field--auto-height" : "") + (state2.focused.value === true ? " q-field--focused" : "") + (hasError.value === true ? " q-field--error" : "") + (hasError.value === true || state2.focused.value === true ? " q-field--highlighted" : "") + (props4.hideBottomSpace !== true && shouldRenderBottom.value === true ? " q-field--with-bottom" : "") + (props4.disable === true ? " q-field--disabled" : props4.readonly === true ? " q-field--readonly" : "")
  );
  const contentClass = computed(
    () => "q-field__control relative-position row no-wrap" + (props4.bgColor !== void 0 ? ` bg-${props4.bgColor}` : "") + (hasError.value === true ? " text-negative" : typeof props4.standout === "string" && props4.standout.length !== 0 && state2.focused.value === true ? ` ${props4.standout}` : props4.color !== void 0 ? ` text-${props4.color}` : "")
  );
  const hasLabel = computed(
    () => props4.labelSlot === true || props4.label !== void 0
  );
  const labelClass = computed(
    () => "q-field__label no-pointer-events absolute ellipsis" + (props4.labelColor !== void 0 && hasError.value !== true ? ` text-${props4.labelColor}` : "")
  );
  const controlSlotScope = computed(() => ({
    id: state2.targetUid.value,
    editable: state2.editable.value,
    focused: state2.focused.value,
    floatingLabel: floatingLabel.value,
    modelValue: props4.modelValue,
    emitValue: state2.emitValue
  }));
  const attributes = computed(() => {
    const acc = {};
    if (state2.targetUid.value) {
      acc.for = state2.targetUid.value;
    }
    if (props4.disable === true) {
      acc["aria-disabled"] = "true";
    }
    return acc;
  });
  function focusHandler() {
    const el = document.activeElement;
    let target2 = state2.targetRef !== void 0 && state2.targetRef.value;
    if (target2 && (el === null || el.id !== state2.targetUid.value)) {
      target2.hasAttribute("tabindex") === true || (target2 = target2.querySelector("[tabindex]"));
      if (target2 && target2 !== el) {
        target2.focus({ preventScroll: true });
      }
    }
  }
  function focus() {
    addFocusFn(focusHandler);
  }
  function blur() {
    removeFocusFn(focusHandler);
    const el = document.activeElement;
    if (el !== null && state2.rootRef.value.contains(el)) {
      el.blur();
    }
  }
  function onControlFocusin(e2) {
    if (focusoutTimer !== null) {
      clearTimeout(focusoutTimer);
      focusoutTimer = null;
    }
    if (state2.editable.value === true && state2.focused.value === false) {
      state2.focused.value = true;
      emit("focus", e2);
    }
  }
  function onControlFocusout(e2, then) {
    focusoutTimer !== null && clearTimeout(focusoutTimer);
    focusoutTimer = setTimeout(() => {
      focusoutTimer = null;
      if (document.hasFocus() === true && (state2.hasPopupOpen === true || state2.controlRef === void 0 || state2.controlRef.value === null || state2.controlRef.value.contains(document.activeElement) !== false)) {
        return;
      }
      if (state2.focused.value === true) {
        state2.focused.value = false;
        emit("blur", e2);
      }
      then !== void 0 && then();
    });
  }
  function clearValue(e2) {
    stopAndPrevent(e2);
    if ($q.platform.is.mobile !== true) {
      const el = state2.targetRef !== void 0 && state2.targetRef.value || state2.rootRef.value;
      el.focus();
    } else if (state2.rootRef.value.contains(document.activeElement) === true) {
      document.activeElement.blur();
    }
    if (props4.type === "file") {
      state2.inputRef.value.value = null;
    }
    emit("update:modelValue", null);
    state2.changeEvent === true && emit("change", null);
    emit("clear", props4.modelValue);
    nextTick(() => {
      const isDirty = isDirtyModel.value;
      resetValidation();
      isDirtyModel.value = isDirty;
    });
  }
  function onClearableKeyup(evt) {
    [13, 32].includes(evt.keyCode) && clearValue(evt);
  }
  function getContent() {
    const node = [];
    slots.prepend !== void 0 && node.push(
      h("div", {
        class: "q-field__prepend q-field__marginal row no-wrap items-center",
        key: "prepend",
        onClick: prevent
      }, slots.prepend())
    );
    node.push(
      h("div", {
        class: "q-field__control-container col relative-position row no-wrap q-anchor--skip"
      }, getControlContainer())
    );
    hasError.value === true && props4.noErrorIcon === false && node.push(
      getInnerAppendNode("error", [
        h(QIcon_default, { name: $q.iconSet.field.error, color: "negative" })
      ])
    );
    if (props4.loading === true || state2.innerLoading.value === true) {
      node.push(
        getInnerAppendNode(
          "inner-loading-append",
          slots.loading !== void 0 ? slots.loading() : [h(QSpinner_default, { color: props4.color })]
        )
      );
    } else if (props4.clearable === true && state2.hasValue.value === true && state2.editable.value === true) {
      node.push(
        getInnerAppendNode("inner-clearable-append", [
          h(QIcon_default, {
            class: "q-field__focusable-action",
            name: props4.clearIcon || $q.iconSet.field.clear,
            tabindex: 0,
            role: "button",
            "aria-hidden": "false",
            "aria-label": $q.lang.label.clear,
            onKeyup: onClearableKeyup,
            onClick: clearValue
          })
        ])
      );
    }
    slots.append !== void 0 && node.push(
      h("div", {
        class: "q-field__append q-field__marginal row no-wrap items-center",
        key: "append",
        onClick: prevent
      }, slots.append())
    );
    state2.getInnerAppend !== void 0 && node.push(
      getInnerAppendNode("inner-append", state2.getInnerAppend())
    );
    state2.getControlChild !== void 0 && node.push(
      state2.getControlChild()
    );
    return node;
  }
  function getControlContainer() {
    const node = [];
    props4.prefix !== void 0 && props4.prefix !== null && node.push(
      h("div", {
        class: "q-field__prefix no-pointer-events row items-center"
      }, props4.prefix)
    );
    if (state2.getShadowControl !== void 0 && state2.hasShadow.value === true) {
      node.push(
        state2.getShadowControl()
      );
    }
    if (state2.getControl !== void 0) {
      node.push(state2.getControl());
    } else if (slots.rawControl !== void 0) {
      node.push(slots.rawControl());
    } else if (slots.control !== void 0) {
      node.push(
        h("div", {
          ref: state2.targetRef,
          class: "q-field__native row",
          tabindex: -1,
          ...state2.splitAttrs.attributes.value,
          "data-autofocus": props4.autofocus === true || void 0
        }, slots.control(controlSlotScope.value))
      );
    }
    hasLabel.value === true && node.push(
      h("div", {
        class: labelClass.value
      }, hSlot(slots.label, props4.label))
    );
    props4.suffix !== void 0 && props4.suffix !== null && node.push(
      h("div", {
        class: "q-field__suffix no-pointer-events row items-center"
      }, props4.suffix)
    );
    return node.concat(hSlot(slots.default));
  }
  function getBottom() {
    let msg, key;
    if (hasError.value === true) {
      if (errorMessage.value !== null) {
        msg = [h("div", { role: "alert" }, errorMessage.value)];
        key = `q--slot-error-${errorMessage.value}`;
      } else {
        msg = hSlot(slots.error);
        key = "q--slot-error";
      }
    } else if (props4.hideHint !== true || state2.focused.value === true) {
      if (props4.hint !== void 0) {
        msg = [h("div", props4.hint)];
        key = `q--slot-hint-${props4.hint}`;
      } else {
        msg = hSlot(slots.hint);
        key = "q--slot-hint";
      }
    }
    const hasCounter = props4.counter === true || slots.counter !== void 0;
    if (props4.hideBottomSpace === true && hasCounter === false && msg === void 0) {
      return;
    }
    const main = h("div", {
      key,
      class: "q-field__messages col"
    }, msg);
    return h("div", {
      class: "q-field__bottom row items-start q-field__bottom--" + (props4.hideBottomSpace !== true ? "animated" : "stale"),
      onClick: prevent
    }, [
      props4.hideBottomSpace === true ? main : h(Transition, { name: "q-transition--field-message" }, () => main),
      hasCounter === true ? h("div", {
        class: "q-field__counter"
      }, slots.counter !== void 0 ? slots.counter() : state2.computedCounter.value) : null
    ]);
  }
  function getInnerAppendNode(key, content) {
    return content === null ? null : h("div", {
      key,
      class: "q-field__append q-field__marginal row no-wrap items-center q-anchor--skip"
    }, content);
  }
  let shouldActivate = false;
  onDeactivated(() => {
    shouldActivate = true;
  });
  onActivated(() => {
    shouldActivate === true && props4.autofocus === true && proxy.focus();
  });
  props4.autofocus === true && onMounted(() => {
    proxy.focus();
  });
  onBeforeUnmount(() => {
    focusoutTimer !== null && clearTimeout(focusoutTimer);
  });
  Object.assign(proxy, { focus, blur });
  return function renderField() {
    const labelAttrs = state2.getControl === void 0 && slots.control === void 0 ? {
      ...state2.splitAttrs.attributes.value,
      "data-autofocus": props4.autofocus === true || void 0,
      ...attributes.value
    } : attributes.value;
    return h(state2.tag.value, {
      ref: state2.rootRef,
      class: [
        classes.value,
        attrs.class
      ],
      style: attrs.style,
      ...labelAttrs
    }, [
      slots.before !== void 0 ? h("div", {
        class: "q-field__before q-field__marginal row no-wrap items-center",
        onClick: prevent
      }, slots.before()) : null,
      h("div", {
        class: "q-field__inner relative-position col self-stretch"
      }, [
        h("div", {
          ref: state2.controlRef,
          class: contentClass.value,
          tabindex: -1,
          ...state2.controlEvents
        }, getContent()),
        shouldRenderBottom.value === true ? getBottom() : null
      ]),
      slots.after !== void 0 ? h("div", {
        class: "q-field__after q-field__marginal row no-wrap items-center",
        onClick: prevent
      }, slots.after()) : null
    ]);
  };
}
var QField_default = createComponent({
  name: "QField",
  inheritAttrs: false,
  props: {
    ...useFieldProps,
    tag: {
      type: String,
      default: "label"
    }
  },
  emits: useFieldEmits,
  setup() {
    return use_field_default(
      useFieldState({ tagProp: true })
    );
  }
});
function filterFiles(files, rejectedFiles, failedPropValidation, filterFn) {
  const acceptedFiles = [];
  files.forEach((file) => {
    if (filterFn(file) === true) {
      acceptedFiles.push(file);
    } else {
      rejectedFiles.push({ failedPropValidation, file });
    }
  });
  return acceptedFiles;
}
function stopAndPreventDrag(e2) {
  e2 && e2.dataTransfer && (e2.dataTransfer.dropEffect = "copy");
  stopAndPrevent(e2);
}
var useFileProps = {
  multiple: Boolean,
  accept: String,
  capture: String,
  maxFileSize: [Number, String],
  maxTotalSize: [Number, String],
  maxFiles: [Number, String],
  filter: Function
};
var useFileEmits = ["rejected"];
function use_file_default({
  editable,
  dnd,
  getFileInput,
  addFilesToQueue
}) {
  const { props: props4, emit, proxy } = getCurrentInstance();
  const dndRef = ref$1(null);
  const extensions = computed(() => props4.accept !== void 0 ? props4.accept.split(",").map((ext) => {
    ext = ext.trim();
    if (ext === "*") {
      return "*/";
    } else if (ext.endsWith("/*")) {
      ext = ext.slice(0, ext.length - 1);
    }
    return ext.toUpperCase();
  }) : null);
  const maxFilesNumber = computed(() => parseInt(props4.maxFiles, 10));
  const maxTotalSizeNumber = computed(() => parseInt(props4.maxTotalSize, 10));
  function pickFiles(e2) {
    if (editable.value) {
      if (e2 !== Object(e2)) {
        e2 = { target: null };
      }
      if (e2.target !== null && e2.target.matches('input[type="file"]') === true) {
        e2.clientX === 0 && e2.clientY === 0 && stop(e2);
      } else {
        const input = getFileInput();
        input && input !== e2.target && input.click(e2);
      }
    }
  }
  function addFiles(files) {
    if (editable.value && files) {
      addFilesToQueue(null, files);
    }
  }
  function processFiles(e2, filesToProcess, currentFileList, append) {
    let files = Array.from(filesToProcess || e2.target.files);
    const rejectedFiles = [];
    const done = () => {
      if (rejectedFiles.length !== 0) {
        emit("rejected", rejectedFiles);
      }
    };
    if (props4.accept !== void 0 && extensions.value.indexOf("*/") === -1) {
      files = filterFiles(files, rejectedFiles, "accept", (file) => {
        return extensions.value.some((ext) => file.type.toUpperCase().startsWith(ext) || file.name.toUpperCase().endsWith(ext));
      });
      if (files.length === 0) {
        return done();
      }
    }
    if (props4.maxFileSize !== void 0) {
      const maxFileSize = parseInt(props4.maxFileSize, 10);
      files = filterFiles(files, rejectedFiles, "max-file-size", (file) => {
        return file.size <= maxFileSize;
      });
      if (files.length === 0) {
        return done();
      }
    }
    if (props4.multiple !== true && files.length !== 0) {
      files = [files[0]];
    }
    files.forEach((file) => {
      file.__key = file.webkitRelativePath + file.lastModified + file.name + file.size;
    });
    if (append === true) {
      const filenameMap = currentFileList.map((entry) => entry.__key);
      files = filterFiles(files, rejectedFiles, "duplicate", (file) => {
        return filenameMap.includes(file.__key) === false;
      });
    }
    if (files.length === 0) {
      return done();
    }
    if (props4.maxTotalSize !== void 0) {
      let size2 = append === true ? currentFileList.reduce((total, file) => total + file.size, 0) : 0;
      files = filterFiles(files, rejectedFiles, "max-total-size", (file) => {
        size2 += file.size;
        return size2 <= maxTotalSizeNumber.value;
      });
      if (files.length === 0) {
        return done();
      }
    }
    if (typeof props4.filter === "function") {
      const filteredFiles = props4.filter(files);
      files = filterFiles(files, rejectedFiles, "filter", (file) => {
        return filteredFiles.includes(file);
      });
    }
    if (props4.maxFiles !== void 0) {
      let filesNumber = append === true ? currentFileList.length : 0;
      files = filterFiles(files, rejectedFiles, "max-files", () => {
        filesNumber++;
        return filesNumber <= maxFilesNumber.value;
      });
      if (files.length === 0) {
        return done();
      }
    }
    done();
    if (files.length !== 0) {
      return files;
    }
  }
  function onDragover(e2) {
    stopAndPreventDrag(e2);
    dnd.value !== true && (dnd.value = true);
  }
  function onDragleave(e2) {
    stopAndPrevent(e2);
    const gone = e2.relatedTarget !== null || client.is.safari !== true ? e2.relatedTarget !== dndRef.value : document.elementsFromPoint(e2.clientX, e2.clientY).includes(dndRef.value) === false;
    gone === true && (dnd.value = false);
  }
  function onDrop(e2) {
    stopAndPreventDrag(e2);
    const files = e2.dataTransfer.files;
    if (files.length !== 0) {
      addFilesToQueue(null, files);
    }
    dnd.value = false;
  }
  function getDndNode(type2) {
    if (dnd.value === true) {
      return h("div", {
        ref: dndRef,
        class: `q-${type2}__dnd absolute-full`,
        onDragenter: stopAndPreventDrag,
        onDragover: stopAndPreventDrag,
        onDragleave,
        onDrop
      });
    }
  }
  Object.assign(proxy, { pickFiles, addFiles });
  return {
    pickFiles,
    addFiles,
    onDragover,
    onDragleave,
    processFiles,
    getDndNode,
    maxFilesNumber,
    maxTotalSizeNumber
  };
}
function use_file_dom_props_default(props4, typeGuard) {
  function getFormDomProps() {
    const model = props4.modelValue;
    try {
      const dt = "DataTransfer" in window ? new DataTransfer() : "ClipboardEvent" in window ? new ClipboardEvent("").clipboardData : void 0;
      if (Object(model) === model) {
        ("length" in model ? Array.from(model) : [model]).forEach((file) => {
          dt.items.add(file);
        });
      }
      return {
        files: dt.files
      };
    } catch (e2) {
      return {
        files: void 0
      };
    }
  }
  return typeGuard === true ? computed(() => {
    if (props4.type !== "file") {
      return;
    }
    return getFormDomProps();
  }) : computed(getFormDomProps);
}
var QFile_default = createComponent({
  name: "QFile",
  inheritAttrs: false,
  props: {
    ...useNonInputFieldProps,
    ...useFormProps,
    ...useFileProps,
    /* SSR does not know about File & FileList */
    modelValue: [File, FileList, Array],
    append: Boolean,
    useChips: Boolean,
    displayValue: [String, Number],
    tabindex: {
      type: [String, Number],
      default: 0
    },
    counterLabel: Function,
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  emits: [
    ...useFieldEmits,
    ...useFileEmits
  ],
  setup(props4, { slots, emit, attrs }) {
    const { proxy } = getCurrentInstance();
    const state2 = useFieldState();
    const inputRef = ref$1(null);
    const dnd = ref$1(false);
    const nameProp = useFormInputNameAttr(props4);
    const {
      pickFiles,
      onDragover,
      onDragleave,
      processFiles,
      getDndNode
    } = use_file_default({ editable: state2.editable, dnd, getFileInput, addFilesToQueue });
    const formDomProps = use_file_dom_props_default(props4);
    const innerValue = computed(() => Object(props4.modelValue) === props4.modelValue ? "length" in props4.modelValue ? Array.from(props4.modelValue) : [props4.modelValue] : []);
    const hasValue = computed(() => fieldValueIsFilled(innerValue.value));
    const selectedString = computed(
      () => innerValue.value.map((file) => file.name).join(", ")
    );
    const totalSize = computed(
      () => humanStorageSize(
        innerValue.value.reduce((acc, file) => acc + file.size, 0)
      )
    );
    const counterProps = computed(() => ({
      totalSize: totalSize.value,
      filesNumber: innerValue.value.length,
      maxFiles: props4.maxFiles
    }));
    const inputAttrs = computed(() => ({
      tabindex: -1,
      type: "file",
      title: "",
      // try to remove default tooltip,
      accept: props4.accept,
      capture: props4.capture,
      name: nameProp.value,
      ...attrs,
      id: state2.targetUid.value,
      disabled: state2.editable.value !== true
    }));
    const fieldClass = computed(
      () => "q-file q-field--auto-height" + (dnd.value === true ? " q-file--dnd" : "")
    );
    const isAppending = computed(
      () => props4.multiple === true && props4.append === true
    );
    function removeAtIndex(index) {
      const files = innerValue.value.slice();
      files.splice(index, 1);
      emitValue(files);
    }
    function removeFile(file) {
      const index = innerValue.value.indexOf(file);
      if (index !== -1) {
        removeAtIndex(index);
      }
    }
    function emitValue(files) {
      emit("update:modelValue", props4.multiple === true ? files : files[0]);
    }
    function onKeydown2(e2) {
      e2.keyCode === 13 && prevent(e2);
    }
    function onKeyup2(e2) {
      if (e2.keyCode === 13 || e2.keyCode === 32) {
        pickFiles(e2);
      }
    }
    function getFileInput() {
      return inputRef.value;
    }
    function addFilesToQueue(e2, fileList) {
      const files = processFiles(e2, fileList, innerValue.value, isAppending.value);
      const fileInput = getFileInput();
      if (fileInput !== void 0 && fileInput !== null) {
        fileInput.value = "";
      }
      if (files === void 0) return;
      if (props4.multiple === true ? props4.modelValue && files.every((f) => innerValue.value.includes(f)) : props4.modelValue === files[0]) {
        return;
      }
      emitValue(
        isAppending.value === true ? innerValue.value.concat(files) : files
      );
    }
    function getFiller() {
      return [
        h("input", {
          class: [props4.inputClass, "q-file__filler"],
          style: props4.inputStyle
        })
      ];
    }
    function getSelection2() {
      if (slots.file !== void 0) {
        return innerValue.value.length === 0 ? getFiller() : innerValue.value.map(
          (file, index) => slots.file({ index, file, ref: this })
        );
      }
      if (slots.selected !== void 0) {
        return innerValue.value.length === 0 ? getFiller() : slots.selected({ files: innerValue.value, ref: this });
      }
      if (props4.useChips === true) {
        return innerValue.value.length === 0 ? getFiller() : innerValue.value.map((file, i2) => h(QChip_default, {
          key: "file-" + i2,
          removable: state2.editable.value,
          dense: true,
          textColor: props4.color,
          tabindex: props4.tabindex,
          onRemove: () => {
            removeAtIndex(i2);
          }
        }, () => h("span", {
          class: "ellipsis",
          textContent: file.name
        })));
      }
      const textContent = props4.displayValue !== void 0 ? props4.displayValue : selectedString.value;
      return textContent.length !== 0 ? [
        h("div", {
          class: props4.inputClass,
          style: props4.inputStyle,
          textContent
        })
      ] : getFiller();
    }
    function getInput() {
      const data = {
        ref: inputRef,
        ...inputAttrs.value,
        ...formDomProps.value,
        class: "q-field__input fit absolute-full cursor-pointer",
        onChange: addFilesToQueue
      };
      if (props4.multiple === true) {
        data.multiple = true;
      }
      return h("input", data);
    }
    Object.assign(state2, {
      fieldClass,
      emitValue,
      hasValue,
      inputRef,
      innerValue,
      floatingLabel: computed(
        () => hasValue.value === true || fieldValueIsFilled(props4.displayValue)
      ),
      computedCounter: computed(() => {
        if (props4.counterLabel !== void 0) {
          return props4.counterLabel(counterProps.value);
        }
        const max2 = props4.maxFiles;
        return `${innerValue.value.length}${max2 !== void 0 ? " / " + max2 : ""} (${totalSize.value})`;
      }),
      getControlChild: () => getDndNode("file"),
      getControl: () => {
        const data = {
          ref: state2.targetRef,
          class: "q-field__native row items-center cursor-pointer",
          tabindex: props4.tabindex
        };
        if (state2.editable.value === true) {
          Object.assign(data, { onDragover, onDragleave, onKeydown: onKeydown2, onKeyup: onKeyup2 });
        }
        return h("div", data, [getInput()].concat(getSelection2()));
      }
    });
    Object.assign(proxy, {
      removeAtIndex,
      removeFile,
      getNativeElement: () => inputRef.value
      // deprecated
    });
    injectProp(proxy, "nativeEl", () => inputRef.value);
    return use_field_default(state2);
  }
});
createComponent({
  name: "QFooter",
  props: {
    modelValue: {
      type: Boolean,
      default: true
    },
    reveal: Boolean,
    bordered: Boolean,
    elevated: Boolean,
    heightHint: {
      type: [String, Number],
      default: 50
    }
  },
  emits: ["reveal", "focusin"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $layout = inject(layoutKey, emptyRenderFn);
    if ($layout === emptyRenderFn) {
      console.error("QFooter needs to be child of QLayout");
      return emptyRenderFn;
    }
    const size2 = ref$1(parseInt(props4.heightHint, 10));
    const revealed = ref$1(true);
    const windowHeight = ref$1(
      isRuntimeSsrPreHydration.value === true || $layout.isContainer.value === true ? 0 : window.innerHeight
    );
    const fixed = computed(
      () => props4.reveal === true || $layout.view.value.indexOf("F") !== -1 || $q.platform.is.ios && $layout.isContainer.value === true
    );
    const containerHeight = computed(() => $layout.isContainer.value === true ? $layout.containerHeight.value : windowHeight.value);
    const offset2 = computed(() => {
      if (props4.modelValue !== true) {
        return 0;
      }
      if (fixed.value === true) {
        return revealed.value === true ? size2.value : 0;
      }
      const offset3 = $layout.scroll.value.position + containerHeight.value + size2.value - $layout.height.value;
      return offset3 > 0 ? offset3 : 0;
    });
    const hidden = computed(
      () => props4.modelValue !== true || fixed.value === true && revealed.value !== true
    );
    const revealOnFocus = computed(
      () => props4.modelValue === true && hidden.value === true && props4.reveal === true
    );
    const classes = computed(
      () => "q-footer q-layout__section--marginal " + (fixed.value === true ? "fixed" : "absolute") + "-bottom" + (props4.bordered === true ? " q-footer--bordered" : "") + (hidden.value === true ? " q-footer--hidden" : "") + (props4.modelValue !== true ? " q-layout--prevent-focus" + (fixed.value !== true ? " hidden" : "") : "")
    );
    const style2 = computed(() => {
      const view = $layout.rows.value.bottom, css2 = {};
      if (view[0] === "l" && $layout.left.space === true) {
        css2[$q.lang.rtl === true ? "right" : "left"] = `${$layout.left.size}px`;
      }
      if (view[2] === "r" && $layout.right.space === true) {
        css2[$q.lang.rtl === true ? "left" : "right"] = `${$layout.right.size}px`;
      }
      return css2;
    });
    function updateLayout(prop, val) {
      $layout.update("footer", prop, val);
    }
    function updateLocal(prop, val) {
      if (prop.value !== val) {
        prop.value = val;
      }
    }
    function onResize({ height: height2 }) {
      updateLocal(size2, height2);
      updateLayout("size", height2);
    }
    function updateRevealed() {
      if (props4.reveal !== true) return;
      const { direction, position: position2, inflectionPoint } = $layout.scroll.value;
      updateLocal(revealed, direction === "up" || position2 - inflectionPoint < 100 || $layout.height.value - containerHeight.value - position2 - size2.value < 300);
    }
    function onFocusin(evt) {
      if (revealOnFocus.value === true) {
        updateLocal(revealed, true);
      }
      emit("focusin", evt);
    }
    watch(() => props4.modelValue, (val) => {
      updateLayout("space", val);
      updateLocal(revealed, true);
      $layout.animate();
    });
    watch(offset2, (val) => {
      updateLayout("offset", val);
    });
    watch(() => props4.reveal, (val) => {
      val === false && updateLocal(revealed, props4.modelValue);
    });
    watch(revealed, (val) => {
      $layout.animate();
      emit("reveal", val);
    });
    watch([size2, $layout.scroll, $layout.height], updateRevealed);
    watch(() => $q.screen.height, (val) => {
      $layout.isContainer.value !== true && updateLocal(windowHeight, val);
    });
    const instance = {};
    $layout.instances.footer = instance;
    props4.modelValue === true && updateLayout("size", size2.value);
    updateLayout("space", props4.modelValue);
    updateLayout("offset", offset2.value);
    onBeforeUnmount(() => {
      if ($layout.instances.footer === instance) {
        $layout.instances.footer = void 0;
        updateLayout("size", 0);
        updateLayout("offset", 0);
        updateLayout("space", false);
      }
    });
    return () => {
      const child = hMergeSlot(slots.default, [
        h(QResizeObserver_default, {
          debounce: 0,
          onResize
        })
      ]);
      props4.elevated === true && child.push(
        h("div", {
          class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
        })
      );
      return h("footer", {
        class: classes.value,
        style: style2.value,
        onFocusin
      }, child);
    };
  }
});
createComponent({
  name: "QForm",
  props: {
    autofocus: Boolean,
    noErrorFocus: Boolean,
    noResetFocus: Boolean,
    greedy: Boolean,
    onSubmit: Function
  },
  emits: ["reset", "validationSuccess", "validationError"],
  setup(props4, { slots, emit }) {
    const vm2 = getCurrentInstance();
    const rootRef = ref$1(null);
    let validateIndex = 0;
    const registeredComponents = [];
    function validate2(shouldFocus) {
      const focus2 = typeof shouldFocus === "boolean" ? shouldFocus : props4.noErrorFocus !== true;
      const index = ++validateIndex;
      const emitEvent = (res, ref73) => {
        emit(`validation${res === true ? "Success" : "Error"}`, ref73);
      };
      const validateComponent = (comp) => {
        const valid = comp.validate();
        return typeof valid.then === "function" ? valid.then(
          (valid2) => ({ valid: valid2, comp }),
          (err) => ({ valid: false, comp, err })
        ) : Promise.resolve({ valid, comp });
      };
      const errorsPromise = props4.greedy === true ? Promise.all(registeredComponents.map(validateComponent)).then((res) => res.filter((r) => r.valid !== true)) : registeredComponents.reduce(
        (acc, comp) => acc.then(() => {
          return validateComponent(comp).then((r) => {
            if (r.valid === false) {
              return Promise.reject(r);
            }
          });
        }),
        Promise.resolve()
      ).catch((error) => [error]);
      return errorsPromise.then((errors) => {
        if (errors === void 0 || errors.length === 0) {
          index === validateIndex && emitEvent(true);
          return true;
        }
        if (index === validateIndex) {
          const { comp, err } = errors[0];
          err !== void 0 && console.error(err);
          emitEvent(false, comp);
          if (focus2 === true) {
            const activeError = errors.find(({ comp: comp2 }) => typeof comp2.focus === "function" && vmIsDestroyed(comp2.$) === false);
            if (activeError !== void 0) {
              activeError.comp.focus();
            }
          }
        }
        return false;
      });
    }
    function resetValidation() {
      validateIndex++;
      registeredComponents.forEach((comp) => {
        typeof comp.resetValidation === "function" && comp.resetValidation();
      });
    }
    function submit(evt) {
      evt !== void 0 && stopAndPrevent(evt);
      const index = validateIndex + 1;
      validate2().then((val) => {
        if (index === validateIndex && val === true) {
          if (props4.onSubmit !== void 0) {
            emit("submit", evt);
          } else if (evt !== void 0 && evt.target !== void 0 && typeof evt.target.submit === "function") {
            evt.target.submit();
          }
        }
      });
    }
    function reset(evt) {
      evt !== void 0 && stopAndPrevent(evt);
      emit("reset");
      nextTick(() => {
        resetValidation();
        if (props4.autofocus === true && props4.noResetFocus !== true) {
          focus();
        }
      });
    }
    function focus() {
      addFocusFn(() => {
        if (rootRef.value === null) return;
        const target2 = rootRef.value.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || rootRef.value.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || rootRef.value.querySelector("[autofocus], [data-autofocus]") || Array.prototype.find.call(rootRef.value.querySelectorAll("[tabindex]"), (el) => el.tabIndex !== -1);
        target2 !== null && target2 !== void 0 && target2.focus({ preventScroll: true });
      });
    }
    provide(formKey, {
      bindComponent(vmProxy) {
        registeredComponents.push(vmProxy);
      },
      unbindComponent(vmProxy) {
        const index = registeredComponents.indexOf(vmProxy);
        if (index !== -1) {
          registeredComponents.splice(index, 1);
        }
      }
    });
    let shouldActivate = false;
    onDeactivated(() => {
      shouldActivate = true;
    });
    onActivated(() => {
      shouldActivate === true && props4.autofocus === true && focus();
    });
    onMounted(() => {
      props4.autofocus === true && focus();
    });
    Object.assign(vm2.proxy, {
      validate: validate2,
      resetValidation,
      submit,
      reset,
      focus,
      getValidationComponents: () => registeredComponents
    });
    return () => h("form", {
      class: "q-form",
      ref: rootRef,
      onSubmit: submit,
      onReset: reset
    }, hSlot(slots.default));
  }
});
var QHeader_default = createComponent({
  name: "QHeader",
  props: {
    modelValue: {
      type: Boolean,
      default: true
    },
    reveal: Boolean,
    revealOffset: {
      type: Number,
      default: 250
    },
    bordered: Boolean,
    elevated: Boolean,
    heightHint: {
      type: [String, Number],
      default: 50
    }
  },
  emits: ["reveal", "focusin"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $layout = inject(layoutKey, emptyRenderFn);
    if ($layout === emptyRenderFn) {
      console.error("QHeader needs to be child of QLayout");
      return emptyRenderFn;
    }
    const size2 = ref$1(parseInt(props4.heightHint, 10));
    const revealed = ref$1(true);
    const fixed = computed(
      () => props4.reveal === true || $layout.view.value.indexOf("H") !== -1 || $q.platform.is.ios && $layout.isContainer.value === true
    );
    const offset2 = computed(() => {
      if (props4.modelValue !== true) {
        return 0;
      }
      if (fixed.value === true) {
        return revealed.value === true ? size2.value : 0;
      }
      const offset3 = size2.value - $layout.scroll.value.position;
      return offset3 > 0 ? offset3 : 0;
    });
    const hidden = computed(
      () => props4.modelValue !== true || fixed.value === true && revealed.value !== true
    );
    const revealOnFocus = computed(
      () => props4.modelValue === true && hidden.value === true && props4.reveal === true
    );
    const classes = computed(
      () => "q-header q-layout__section--marginal " + (fixed.value === true ? "fixed" : "absolute") + "-top" + (props4.bordered === true ? " q-header--bordered" : "") + (hidden.value === true ? " q-header--hidden" : "") + (props4.modelValue !== true ? " q-layout--prevent-focus" : "")
    );
    const style2 = computed(() => {
      const view = $layout.rows.value.top, css2 = {};
      if (view[0] === "l" && $layout.left.space === true) {
        css2[$q.lang.rtl === true ? "right" : "left"] = `${$layout.left.size}px`;
      }
      if (view[2] === "r" && $layout.right.space === true) {
        css2[$q.lang.rtl === true ? "left" : "right"] = `${$layout.right.size}px`;
      }
      return css2;
    });
    function updateLayout(prop, val) {
      $layout.update("header", prop, val);
    }
    function updateLocal(prop, val) {
      if (prop.value !== val) {
        prop.value = val;
      }
    }
    function onResize({ height: height2 }) {
      updateLocal(size2, height2);
      updateLayout("size", height2);
    }
    function onFocusin(evt) {
      if (revealOnFocus.value === true) {
        updateLocal(revealed, true);
      }
      emit("focusin", evt);
    }
    watch(() => props4.modelValue, (val) => {
      updateLayout("space", val);
      updateLocal(revealed, true);
      $layout.animate();
    });
    watch(offset2, (val) => {
      updateLayout("offset", val);
    });
    watch(() => props4.reveal, (val) => {
      val === false && updateLocal(revealed, props4.modelValue);
    });
    watch(revealed, (val) => {
      $layout.animate();
      emit("reveal", val);
    });
    watch($layout.scroll, (scroll) => {
      props4.reveal === true && updateLocal(
        revealed,
        scroll.direction === "up" || scroll.position <= props4.revealOffset || scroll.position - scroll.inflectionPoint < 100
      );
    });
    const instance = {};
    $layout.instances.header = instance;
    props4.modelValue === true && updateLayout("size", size2.value);
    updateLayout("space", props4.modelValue);
    updateLayout("offset", offset2.value);
    onBeforeUnmount(() => {
      if ($layout.instances.header === instance) {
        $layout.instances.header = void 0;
        updateLayout("size", 0);
        updateLayout("offset", 0);
        updateLayout("space", false);
      }
    });
    return () => {
      const child = hUniqueSlot(slots.default, []);
      props4.elevated === true && child.push(
        h("div", {
          class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
        })
      );
      child.push(
        h(QResizeObserver_default, {
          debounce: 0,
          onResize
        })
      );
      return h("header", {
        class: classes.value,
        style: style2.value,
        onFocusin
      }, child);
    };
  }
});
var useRatioProps = {
  ratio: [String, Number]
};
function use_ratio_default(props4, naturalRatio) {
  return computed(() => {
    const ratio = Number(
      props4.ratio || (naturalRatio !== void 0 ? naturalRatio.value : void 0)
    );
    return isNaN(ratio) !== true && ratio > 0 ? { paddingBottom: `${100 / ratio}%` } : null;
  });
}
var defaultRatio = 1.7778;
var QImg_default = createComponent({
  name: "QImg",
  props: {
    ...useRatioProps,
    src: String,
    srcset: String,
    sizes: String,
    alt: String,
    crossorigin: String,
    decoding: String,
    referrerpolicy: String,
    draggable: Boolean,
    loading: {
      type: String,
      default: "lazy"
    },
    loadingShowDelay: {
      type: [Number, String],
      default: 0
    },
    fetchpriority: {
      type: String,
      default: "auto"
    },
    width: String,
    height: String,
    initialRatio: {
      type: [Number, String],
      default: defaultRatio
    },
    placeholderSrc: String,
    errorSrc: String,
    fit: {
      type: String,
      default: "cover"
    },
    position: {
      type: String,
      default: "50% 50%"
    },
    imgClass: String,
    imgStyle: Object,
    noSpinner: Boolean,
    noNativeMenu: Boolean,
    noTransition: Boolean,
    spinnerColor: String,
    spinnerSize: String
  },
  emits: ["load", "error"],
  setup(props4, { slots, emit }) {
    const naturalRatio = ref$1(props4.initialRatio);
    const ratioStyle = use_ratio_default(props4, naturalRatio);
    const vm2 = getCurrentInstance();
    const { registerTimeout: registerLoadTimeout, removeTimeout: removeLoadTimeout } = use_timeout_default();
    const { registerTimeout: registerLoadShowTimeout, removeTimeout: removeLoadShowTimeout } = use_timeout_default();
    const placeholderImg = computed(() => props4.placeholderSrc !== void 0 ? { src: props4.placeholderSrc } : null);
    const errorImg = computed(() => props4.errorSrc !== void 0 ? { src: props4.errorSrc, __qerror: true } : null);
    const images = [
      ref$1(null),
      ref$1(placeholderImg.value)
    ];
    const position2 = ref$1(0);
    const isLoading = ref$1(false);
    const hasError = ref$1(false);
    const classes = computed(
      () => `q-img q-img--${props4.noNativeMenu === true ? "no-" : ""}menu`
    );
    const style2 = computed(() => ({
      width: props4.width,
      height: props4.height
    }));
    const imgClass = computed(
      () => `q-img__image ${props4.imgClass !== void 0 ? props4.imgClass + " " : ""}q-img__image--with${props4.noTransition === true ? "out" : ""}-transition q-img__image--`
    );
    const imgStyle = computed(() => ({
      ...props4.imgStyle,
      objectFit: props4.fit,
      objectPosition: props4.position
    }));
    function setLoading() {
      removeLoadShowTimeout();
      if (props4.loadingShowDelay === 0) {
        isLoading.value = true;
        return;
      }
      registerLoadShowTimeout(() => {
        isLoading.value = true;
      }, props4.loadingShowDelay);
    }
    function clearLoading() {
      removeLoadShowTimeout();
      isLoading.value = false;
    }
    function onLoad({ target: target2 }) {
      if (vmIsDestroyed(vm2) === false) {
        removeLoadTimeout();
        naturalRatio.value = target2.naturalHeight === 0 ? 0.5 : target2.naturalWidth / target2.naturalHeight;
        waitForCompleteness(target2, 1);
      }
    }
    function waitForCompleteness(target2, count) {
      if (count === 1e3 || vmIsDestroyed(vm2) === true) return;
      if (target2.complete === true) {
        onReady(target2);
      } else {
        registerLoadTimeout(() => {
          waitForCompleteness(target2, count + 1);
        }, 50);
      }
    }
    function onReady(target2) {
      if (vmIsDestroyed(vm2) === true) return;
      position2.value = position2.value ^ 1;
      images[position2.value].value = null;
      clearLoading();
      if (target2.getAttribute("__qerror") !== "true") {
        hasError.value = false;
      }
      emit("load", target2.currentSrc || target2.src);
    }
    function onError(err) {
      removeLoadTimeout();
      clearLoading();
      hasError.value = true;
      images[position2.value].value = errorImg.value;
      images[position2.value ^ 1].value = placeholderImg.value;
      emit("error", err);
    }
    function getImage(index) {
      const img = images[index].value;
      const data = {
        key: "img_" + index,
        class: imgClass.value,
        style: imgStyle.value,
        alt: props4.alt,
        crossorigin: props4.crossorigin,
        decoding: props4.decoding,
        referrerpolicy: props4.referrerpolicy,
        height: props4.height,
        width: props4.width,
        loading: props4.loading,
        fetchpriority: props4.fetchpriority,
        "aria-hidden": "true",
        draggable: props4.draggable,
        ...img
      };
      if (position2.value === index) {
        Object.assign(data, {
          class: data.class + "current",
          onLoad,
          onError
        });
      } else {
        data.class += "loaded";
      }
      return h(
        "div",
        { class: "q-img__container absolute-full", key: "img" + index },
        h("img", data)
      );
    }
    function getContent() {
      if (isLoading.value === false) {
        return h("div", {
          key: "content",
          class: "q-img__content absolute-full q-anchor--skip"
        }, hSlot(slots[hasError.value === true ? "error" : "default"]));
      }
      return h("div", {
        key: "loading",
        class: "q-img__loading absolute-full flex flex-center"
      }, slots.loading !== void 0 ? slots.loading() : props4.noSpinner === true ? void 0 : [
        h(QSpinner_default, {
          color: props4.spinnerColor,
          size: props4.spinnerSize
        })
      ]);
    }
    {
      let watchSrc = function() {
        watch(
          () => props4.src || props4.srcset || props4.sizes ? {
            src: props4.src,
            srcset: props4.srcset,
            sizes: props4.sizes
          } : null,
          (imgProps) => {
            removeLoadTimeout();
            hasError.value = false;
            if (imgProps === null) {
              clearLoading();
              images[position2.value ^ 1].value = placeholderImg.value;
            } else {
              setLoading();
            }
            images[position2.value].value = imgProps;
          },
          { immediate: true }
        );
      };
      if (isRuntimeSsrPreHydration.value === true) {
        onMounted(watchSrc);
      } else {
        watchSrc();
      }
    }
    return () => {
      const content = [];
      if (ratioStyle.value !== null) {
        content.push(
          h("div", { key: "filler", style: ratioStyle.value })
        );
      }
      if (images[0].value !== null) {
        content.push(
          getImage(0)
        );
      }
      if (images[1].value !== null) {
        content.push(
          getImage(1)
        );
      }
      content.push(
        h(Transition, { name: "q-transition--fade" }, getContent)
      );
      return h("div", {
        key: "main",
        class: classes.value,
        style: style2.value,
        role: "img",
        "aria-label": props4.alt
      }, content);
    };
  }
});
var { passive: passive2 } = listenOpts;
var QInfiniteScroll_default = createComponent({
  name: "QInfiniteScroll",
  props: {
    offset: {
      type: Number,
      default: 500
    },
    debounce: {
      type: [String, Number],
      default: 100
    },
    scrollTarget: scrollTargetProp,
    initialIndex: {
      type: Number,
      default: 0
    },
    disable: Boolean,
    reverse: Boolean
  },
  emits: ["load"],
  setup(props4, { slots, emit }) {
    const isFetching = ref$1(false);
    const isWorking = ref$1(true);
    const rootRef = ref$1(null);
    const loadingRef = ref$1(null);
    let index = props4.initialIndex;
    let localScrollTarget, poll;
    const classes = computed(
      () => "q-infinite-scroll__loading" + (isFetching.value === true ? "" : " invisible")
    );
    function immediatePoll() {
      if (props4.disable === true || isFetching.value === true || isWorking.value === false) {
        return;
      }
      const scrollHeight = getScrollHeight(localScrollTarget), scrollPosition = getVerticalScrollPosition(localScrollTarget), containerHeight = height(localScrollTarget);
      if (props4.reverse === false) {
        if (Math.round(scrollPosition + containerHeight + props4.offset) >= Math.round(scrollHeight)) {
          trigger3();
        }
      } else if (Math.round(scrollPosition) <= props4.offset) {
        trigger3();
      }
    }
    function trigger3() {
      if (props4.disable === true || isFetching.value === true || isWorking.value === false) {
        return;
      }
      index++;
      isFetching.value = true;
      const heightBefore = getScrollHeight(localScrollTarget);
      emit("load", index, (isDone) => {
        if (isWorking.value === true) {
          isFetching.value = false;
          nextTick(() => {
            if (props4.reverse === true) {
              const heightAfter = getScrollHeight(localScrollTarget), scrollPosition = getVerticalScrollPosition(localScrollTarget), heightDifference = heightAfter - heightBefore;
              setVerticalScrollPosition(localScrollTarget, scrollPosition + heightDifference);
            }
            if (isDone === true) {
              stop2();
            } else if (rootRef.value) {
              rootRef.value.closest("body") && poll();
            }
          });
        }
      });
    }
    function reset() {
      index = 0;
    }
    function resume() {
      if (isWorking.value === false) {
        isWorking.value = true;
        localScrollTarget.addEventListener("scroll", poll, passive2);
      }
      immediatePoll();
    }
    function stop2() {
      if (isWorking.value === true) {
        isWorking.value = false;
        isFetching.value = false;
        localScrollTarget.removeEventListener("scroll", poll, passive2);
        if (poll !== void 0 && poll.cancel !== void 0) {
          poll.cancel();
        }
      }
    }
    function updateScrollTarget() {
      if (localScrollTarget && isWorking.value === true) {
        localScrollTarget.removeEventListener("scroll", poll, passive2);
      }
      localScrollTarget = getScrollTarget(rootRef.value, props4.scrollTarget);
      if (isWorking.value === true) {
        localScrollTarget.addEventListener("scroll", poll, passive2);
        if (props4.reverse === true) {
          const scrollHeight = getScrollHeight(localScrollTarget), containerHeight = height(localScrollTarget);
          setVerticalScrollPosition(localScrollTarget, scrollHeight - containerHeight);
        }
        immediatePoll();
      }
    }
    function setIndex(newIndex) {
      index = newIndex;
    }
    function setDebounce(val) {
      val = parseInt(val, 10);
      const oldPoll = poll;
      poll = val <= 0 ? immediatePoll : debounce_default(immediatePoll, isNaN(val) === true ? 100 : val);
      if (localScrollTarget && isWorking.value === true) {
        if (oldPoll !== void 0) {
          localScrollTarget.removeEventListener("scroll", oldPoll, passive2);
        }
        localScrollTarget.addEventListener("scroll", poll, passive2);
      }
    }
    function updateSvgAnimations(isRetry) {
      if (renderLoadingSlot.value === true) {
        if (loadingRef.value === null) {
          isRetry !== true && nextTick(() => {
            updateSvgAnimations(true);
          });
          return;
        }
        const action = `${isFetching.value === true ? "un" : ""}pauseAnimations`;
        Array.from(loadingRef.value.getElementsByTagName("svg")).forEach((el) => {
          el[action]();
        });
      }
    }
    const renderLoadingSlot = computed(() => props4.disable !== true && isWorking.value === true);
    watch([isFetching, renderLoadingSlot], () => {
      updateSvgAnimations();
    });
    watch(() => props4.disable, (val) => {
      if (val === true) {
        stop2();
      } else {
        resume();
      }
    });
    watch(() => props4.reverse, () => {
      if (isFetching.value === false && isWorking.value === true) {
        immediatePoll();
      }
    });
    watch(() => props4.scrollTarget, updateScrollTarget);
    watch(() => props4.debounce, setDebounce);
    let scrollPos = false;
    onActivated(() => {
      if (scrollPos !== false && localScrollTarget) {
        setVerticalScrollPosition(localScrollTarget, scrollPos);
      }
    });
    onDeactivated(() => {
      scrollPos = localScrollTarget ? getVerticalScrollPosition(localScrollTarget) : false;
    });
    onBeforeUnmount(() => {
      if (isWorking.value === true) {
        localScrollTarget.removeEventListener("scroll", poll, passive2);
      }
    });
    onMounted(() => {
      setDebounce(props4.debounce);
      updateScrollTarget();
      isFetching.value === false && updateSvgAnimations();
    });
    const vm2 = getCurrentInstance();
    Object.assign(vm2.proxy, {
      poll: () => {
        poll !== void 0 && poll();
      },
      trigger: trigger3,
      stop: stop2,
      reset,
      resume,
      setIndex,
      updateScrollTarget
    });
    return () => {
      const child = hUniqueSlot(slots.default, []);
      if (renderLoadingSlot.value === true) {
        child[props4.reverse === false ? "push" : "unshift"](
          h("div", { ref: loadingRef, class: classes.value }, hSlot(slots.loading))
        );
      }
      return h("div", {
        class: "q-infinite-scroll",
        ref: rootRef
      }, child);
    };
  }
});
var QInnerLoading_default = createComponent({
  name: "QInnerLoading",
  props: {
    ...useDarkProps,
    ...useTransitionProps,
    showing: Boolean,
    color: String,
    size: {
      type: [String, Number],
      default: "42px"
    },
    label: String,
    labelClass: String,
    labelStyle: [String, Array, Object]
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const { transitionProps, transitionStyle } = use_transition_default(props4);
    const classes = computed(
      () => "q-inner-loading q--avoid-card-border absolute-full column flex-center" + (isDark.value === true ? " q-inner-loading--dark" : "")
    );
    const labelClass = computed(
      () => "q-inner-loading__label" + (props4.labelClass !== void 0 ? ` ${props4.labelClass}` : "")
    );
    function getInner() {
      const child = [
        h(QSpinner_default, {
          size: props4.size,
          color: props4.color
        })
      ];
      if (props4.label !== void 0) {
        child.push(
          h("div", {
            class: labelClass.value,
            style: props4.labelStyle
          }, [props4.label])
        );
      }
      return child;
    }
    function getContent() {
      return props4.showing === true ? h(
        "div",
        { class: classes.value, style: transitionStyle.value },
        slots.default !== void 0 ? slots.default() : getInner()
      ) : null;
    }
    return () => h(Transition, transitionProps.value, getContent);
  }
});
var NAMED_MASKS = {
  date: "####/##/##",
  datetime: "####/##/## ##:##",
  time: "##:##",
  fulltime: "##:##:##",
  phone: "(###) ### - ####",
  card: "#### #### #### ####"
};
var TOKENS = {
  "#": { pattern: "[\\d]", negate: "[^\\d]" },
  S: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]" },
  N: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]" },
  A: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]", transform: (v) => v.toLocaleUpperCase() },
  a: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]", transform: (v) => v.toLocaleLowerCase() },
  X: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]", transform: (v) => v.toLocaleUpperCase() },
  x: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]", transform: (v) => v.toLocaleLowerCase() }
};
var KEYS = Object.keys(TOKENS);
KEYS.forEach((key) => {
  TOKENS[key].regex = new RegExp(TOKENS[key].pattern);
});
var tokenRegexMask = new RegExp("\\\\([^.*+?^${}()|([\\]])|([.*+?^${}()|[\\]])|([" + KEYS.join("") + "])|(.)", "g");
var escRegex = /[.*+?^${}()|[\]\\]/g;
var MARKER = String.fromCharCode(1);
var useMaskProps = {
  mask: String,
  reverseFillMask: Boolean,
  fillMask: [Boolean, String],
  unmaskedValue: Boolean
};
function use_mask_default(props4, emit, emitValue, inputRef) {
  let maskMarked, maskReplaced, computedMask, computedUnmask, pastedTextStart, selectionAnchor;
  const hasMask = ref$1(null);
  const innerValue = ref$1(getInitialMaskedValue());
  function getIsTypeText() {
    return props4.autogrow === true || ["textarea", "text", "search", "url", "tel", "password"].includes(props4.type);
  }
  watch(() => props4.type + props4.autogrow, updateMaskInternals);
  watch(() => props4.mask, (v) => {
    if (v !== void 0) {
      updateMaskValue(innerValue.value, true);
    } else {
      const val = unmaskValue(innerValue.value);
      updateMaskInternals();
      props4.modelValue !== val && emit("update:modelValue", val);
    }
  });
  watch(() => props4.fillMask + props4.reverseFillMask, () => {
    hasMask.value === true && updateMaskValue(innerValue.value, true);
  });
  watch(() => props4.unmaskedValue, () => {
    hasMask.value === true && updateMaskValue(innerValue.value);
  });
  function getInitialMaskedValue() {
    updateMaskInternals();
    if (hasMask.value === true) {
      const masked = maskValue(unmaskValue(props4.modelValue));
      return props4.fillMask !== false ? fillWithMask(masked) : masked;
    }
    return props4.modelValue;
  }
  function getPaddedMaskMarked(size2) {
    if (size2 < maskMarked.length) {
      return maskMarked.slice(-size2);
    }
    let pad2 = "", localMaskMarked = maskMarked;
    const padPos = localMaskMarked.indexOf(MARKER);
    if (padPos !== -1) {
      for (let i2 = size2 - localMaskMarked.length; i2 > 0; i2--) {
        pad2 += MARKER;
      }
      localMaskMarked = localMaskMarked.slice(0, padPos) + pad2 + localMaskMarked.slice(padPos);
    }
    return localMaskMarked;
  }
  function updateMaskInternals() {
    hasMask.value = props4.mask !== void 0 && props4.mask.length !== 0 && getIsTypeText();
    if (hasMask.value === false) {
      computedUnmask = void 0;
      maskMarked = "";
      maskReplaced = "";
      return;
    }
    const localComputedMask = NAMED_MASKS[props4.mask] === void 0 ? props4.mask : NAMED_MASKS[props4.mask], fillChar = typeof props4.fillMask === "string" && props4.fillMask.length !== 0 ? props4.fillMask.slice(0, 1) : "_", fillCharEscaped = fillChar.replace(escRegex, "\\$&"), unmask = [], extract = [], mask = [];
    let firstMatch = props4.reverseFillMask === true, unmaskChar = "", negateChar = "";
    localComputedMask.replace(tokenRegexMask, (_, char1, esc, token2, char2) => {
      if (token2 !== void 0) {
        const c2 = TOKENS[token2];
        mask.push(c2);
        negateChar = c2.negate;
        if (firstMatch === true) {
          extract.push("(?:" + negateChar + "+)?(" + c2.pattern + "+)?(?:" + negateChar + "+)?(" + c2.pattern + "+)?");
          firstMatch = false;
        }
        extract.push("(?:" + negateChar + "+)?(" + c2.pattern + ")?");
      } else if (esc !== void 0) {
        unmaskChar = "\\" + (esc === "\\" ? "" : esc);
        mask.push(esc);
        unmask.push("([^" + unmaskChar + "]+)?" + unmaskChar + "?");
      } else {
        const c2 = char1 !== void 0 ? char1 : char2;
        unmaskChar = c2 === "\\" ? "\\\\\\\\" : c2.replace(escRegex, "\\\\$&");
        mask.push(c2);
        unmask.push("([^" + unmaskChar + "]+)?" + unmaskChar + "?");
      }
    });
    const unmaskMatcher = new RegExp(
      "^" + unmask.join("") + "(" + (unmaskChar === "" ? "." : "[^" + unmaskChar + "]") + "+)?" + (unmaskChar === "" ? "" : "[" + unmaskChar + "]*") + "$"
    ), extractLast = extract.length - 1, extractMatcher = extract.map((re, index) => {
      if (index === 0 && props4.reverseFillMask === true) {
        return new RegExp("^" + fillCharEscaped + "*" + re);
      } else if (index === extractLast) {
        return new RegExp(
          "^" + re + "(" + (negateChar === "" ? "." : negateChar) + "+)?" + (props4.reverseFillMask === true ? "$" : fillCharEscaped + "*")
        );
      }
      return new RegExp("^" + re);
    });
    computedMask = mask;
    computedUnmask = (val) => {
      const unmaskMatch = unmaskMatcher.exec(props4.reverseFillMask === true ? val : val.slice(0, mask.length + 1));
      if (unmaskMatch !== null) {
        val = unmaskMatch.slice(1).join("");
      }
      const extractMatch = [], extractMatcherLength = extractMatcher.length;
      for (let i2 = 0, str = val; i2 < extractMatcherLength; i2++) {
        const m3 = extractMatcher[i2].exec(str);
        if (m3 === null) {
          break;
        }
        str = str.slice(m3.shift().length);
        extractMatch.push(...m3);
      }
      if (extractMatch.length !== 0) {
        return extractMatch.join("");
      }
      return val;
    };
    maskMarked = mask.map((v) => typeof v === "string" ? v : MARKER).join("");
    maskReplaced = maskMarked.split(MARKER).join(fillChar);
  }
  function updateMaskValue(rawVal, updateMaskInternalsFlag, inputType) {
    const inp = inputRef.value, end = inp.selectionEnd, endReverse = inp.value.length - end, unmasked = unmaskValue(rawVal);
    updateMaskInternalsFlag === true && updateMaskInternals();
    const preMasked = maskValue(unmasked), masked = props4.fillMask !== false ? fillWithMask(preMasked) : preMasked, changed2 = innerValue.value !== masked;
    inp.value !== masked && (inp.value = masked);
    changed2 === true && (innerValue.value = masked);
    document.activeElement === inp && nextTick(() => {
      if (masked === maskReplaced) {
        const cursor = props4.reverseFillMask === true ? maskReplaced.length : 0;
        inp.setSelectionRange(cursor, cursor, "forward");
        return;
      }
      if (inputType === "insertFromPaste" && props4.reverseFillMask !== true) {
        const maxEnd = inp.selectionEnd;
        let cursor = end - 1;
        for (let i2 = pastedTextStart; i2 <= cursor && i2 < maxEnd; i2++) {
          if (maskMarked[i2] !== MARKER) {
            cursor++;
          }
        }
        moveCursor.right(inp, cursor);
        return;
      }
      if (["deleteContentBackward", "deleteContentForward"].indexOf(inputType) !== -1) {
        const cursor = props4.reverseFillMask === true ? end === 0 ? masked.length > preMasked.length ? 1 : 0 : Math.max(0, masked.length - (masked === maskReplaced ? 0 : Math.min(preMasked.length, endReverse) + 1)) + 1 : end;
        inp.setSelectionRange(cursor, cursor, "forward");
        return;
      }
      if (props4.reverseFillMask === true) {
        if (changed2 === true) {
          const cursor = Math.max(0, masked.length - (masked === maskReplaced ? 0 : Math.min(preMasked.length, endReverse + 1)));
          if (cursor === 1 && end === 1) {
            inp.setSelectionRange(cursor, cursor, "forward");
          } else {
            moveCursor.rightReverse(inp, cursor);
          }
        } else {
          const cursor = masked.length - endReverse;
          inp.setSelectionRange(cursor, cursor, "backward");
        }
      } else {
        if (changed2 === true) {
          const cursor = Math.max(0, maskMarked.indexOf(MARKER), Math.min(preMasked.length, end) - 1);
          moveCursor.right(inp, cursor);
        } else {
          const cursor = end - 1;
          moveCursor.right(inp, cursor);
        }
      }
    });
    const val = props4.unmaskedValue === true ? unmaskValue(masked) : masked;
    if (String(props4.modelValue) !== val && (props4.modelValue !== null || val !== "")) {
      emitValue(val, true);
    }
  }
  function moveCursorForPaste(inp, start, end) {
    const preMasked = maskValue(unmaskValue(inp.value));
    start = Math.max(0, maskMarked.indexOf(MARKER), Math.min(preMasked.length, start));
    pastedTextStart = start;
    inp.setSelectionRange(start, end, "forward");
  }
  const moveCursor = {
    left(inp, cursor) {
      const noMarkBefore = maskMarked.slice(cursor - 1).indexOf(MARKER) === -1;
      let i2 = Math.max(0, cursor - 1);
      for (; i2 >= 0; i2--) {
        if (maskMarked[i2] === MARKER) {
          cursor = i2;
          noMarkBefore === true && cursor++;
          break;
        }
      }
      if (i2 < 0 && maskMarked[cursor] !== void 0 && maskMarked[cursor] !== MARKER) {
        return moveCursor.right(inp, 0);
      }
      cursor >= 0 && inp.setSelectionRange(cursor, cursor, "backward");
    },
    right(inp, cursor) {
      const limit2 = inp.value.length;
      let i2 = Math.min(limit2, cursor + 1);
      for (; i2 <= limit2; i2++) {
        if (maskMarked[i2] === MARKER) {
          cursor = i2;
          break;
        } else if (maskMarked[i2 - 1] === MARKER) {
          cursor = i2;
        }
      }
      if (i2 > limit2 && maskMarked[cursor - 1] !== void 0 && maskMarked[cursor - 1] !== MARKER) {
        return moveCursor.left(inp, limit2);
      }
      inp.setSelectionRange(cursor, cursor, "forward");
    },
    leftReverse(inp, cursor) {
      const localMaskMarked = getPaddedMaskMarked(inp.value.length);
      let i2 = Math.max(0, cursor - 1);
      for (; i2 >= 0; i2--) {
        if (localMaskMarked[i2 - 1] === MARKER) {
          cursor = i2;
          break;
        } else if (localMaskMarked[i2] === MARKER) {
          cursor = i2;
          if (i2 === 0) {
            break;
          }
        }
      }
      if (i2 < 0 && localMaskMarked[cursor] !== void 0 && localMaskMarked[cursor] !== MARKER) {
        return moveCursor.rightReverse(inp, 0);
      }
      cursor >= 0 && inp.setSelectionRange(cursor, cursor, "backward");
    },
    rightReverse(inp, cursor) {
      const limit2 = inp.value.length, localMaskMarked = getPaddedMaskMarked(limit2), noMarkBefore = localMaskMarked.slice(0, cursor + 1).indexOf(MARKER) === -1;
      let i2 = Math.min(limit2, cursor + 1);
      for (; i2 <= limit2; i2++) {
        if (localMaskMarked[i2 - 1] === MARKER) {
          cursor = i2;
          cursor > 0 && noMarkBefore === true && cursor--;
          break;
        }
      }
      if (i2 > limit2 && localMaskMarked[cursor - 1] !== void 0 && localMaskMarked[cursor - 1] !== MARKER) {
        return moveCursor.leftReverse(inp, limit2);
      }
      inp.setSelectionRange(cursor, cursor, "forward");
    }
  };
  function onMaskedClick(e2) {
    emit("click", e2);
    selectionAnchor = void 0;
  }
  function onMaskedKeydown(e2) {
    emit("keydown", e2);
    if (shouldIgnoreKey(e2) === true || e2.altKey === true) {
      return;
    }
    const inp = inputRef.value, start = inp.selectionStart, end = inp.selectionEnd;
    if (!e2.shiftKey) {
      selectionAnchor = void 0;
    }
    if (e2.keyCode === 37 || e2.keyCode === 39) {
      if (e2.shiftKey && selectionAnchor === void 0) {
        selectionAnchor = inp.selectionDirection === "forward" ? start : end;
      }
      const fn = moveCursor[(e2.keyCode === 39 ? "right" : "left") + (props4.reverseFillMask === true ? "Reverse" : "")];
      e2.preventDefault();
      fn(inp, selectionAnchor === start ? end : start);
      if (e2.shiftKey) {
        const cursor = inp.selectionStart;
        inp.setSelectionRange(Math.min(selectionAnchor, cursor), Math.max(selectionAnchor, cursor), "forward");
      }
    } else if (e2.keyCode === 8 && props4.reverseFillMask !== true && start === end) {
      moveCursor.left(inp, start);
      inp.setSelectionRange(inp.selectionStart, end, "backward");
    } else if (e2.keyCode === 46 && props4.reverseFillMask === true && start === end) {
      moveCursor.rightReverse(inp, end);
      inp.setSelectionRange(start, inp.selectionEnd, "forward");
    }
  }
  function maskValue(val) {
    if (val === void 0 || val === null || val === "") {
      return "";
    }
    if (props4.reverseFillMask === true) {
      return maskValueReverse(val);
    }
    const mask = computedMask;
    let valIndex = 0, output = "";
    for (let maskIndex = 0; maskIndex < mask.length; maskIndex++) {
      const valChar = val[valIndex], maskDef = mask[maskIndex];
      if (typeof maskDef === "string") {
        output += maskDef;
        valChar === maskDef && valIndex++;
      } else if (valChar !== void 0 && maskDef.regex.test(valChar)) {
        output += maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar;
        valIndex++;
      } else {
        return output;
      }
    }
    return output;
  }
  function maskValueReverse(val) {
    const mask = computedMask, firstTokenIndex = maskMarked.indexOf(MARKER);
    let valIndex = val.length - 1, output = "";
    for (let maskIndex = mask.length - 1; maskIndex >= 0 && valIndex !== -1; maskIndex--) {
      const maskDef = mask[maskIndex];
      let valChar = val[valIndex];
      if (typeof maskDef === "string") {
        output = maskDef + output;
        valChar === maskDef && valIndex--;
      } else if (valChar !== void 0 && maskDef.regex.test(valChar)) {
        do {
          output = (maskDef.transform !== void 0 ? maskDef.transform(valChar) : valChar) + output;
          valIndex--;
          valChar = val[valIndex];
        } while (firstTokenIndex === maskIndex && valChar !== void 0 && maskDef.regex.test(valChar));
      } else {
        return output;
      }
    }
    return output;
  }
  function unmaskValue(val) {
    return typeof val !== "string" || computedUnmask === void 0 ? typeof val === "number" ? computedUnmask("" + val) : val : computedUnmask(val);
  }
  function fillWithMask(val) {
    if (maskReplaced.length - val.length <= 0) {
      return val;
    }
    return props4.reverseFillMask === true && val.length !== 0 ? maskReplaced.slice(0, -val.length) + val : val + maskReplaced.slice(val.length);
  }
  return {
    innerValue,
    hasMask,
    moveCursorForPaste,
    updateMaskValue,
    onMaskedKeydown,
    onMaskedClick
  };
}
var isJapanese = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/;
var isChinese = /[\u4e00-\u9fff\u3400-\u4dbf\u{20000}-\u{2a6df}\u{2a700}-\u{2b73f}\u{2b740}-\u{2b81f}\u{2b820}-\u{2ceaf}\uf900-\ufaff\u3300-\u33ff\ufe30-\ufe4f\uf900-\ufaff\u{2f800}-\u{2fa1f}]/u;
var isKorean = /[\u3131-\u314e\u314f-\u3163\uac00-\ud7a3]/;
var isPlainText = /[a-z0-9_ -]$/i;
function use_key_composition_default(onInput) {
  return function onComposition(e2) {
    if (e2.type === "compositionend" || e2.type === "change") {
      if (e2.target.qComposing !== true) return;
      e2.target.qComposing = false;
      onInput(e2);
    } else if (e2.type === "compositionupdate" && e2.target.qComposing !== true && typeof e2.data === "string") {
      const isComposing = client.is.firefox === true ? isPlainText.test(e2.data) === false : isJapanese.test(e2.data) === true || isChinese.test(e2.data) === true || isKorean.test(e2.data) === true;
      if (isComposing === true) {
        e2.target.qComposing = true;
      }
    }
  };
}
var QInput_default = createComponent({
  name: "QInput",
  inheritAttrs: false,
  props: {
    ...useFieldProps,
    ...useMaskProps,
    ...useFormProps,
    // override of useFieldProps > modelValue
    modelValue: [String, Number, FileList],
    shadowText: String,
    type: {
      type: String,
      default: "text"
    },
    debounce: [String, Number],
    autogrow: Boolean,
    // makes a textarea
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  emits: [
    ...useFieldEmits,
    "paste",
    "change",
    "keydown",
    "click",
    "animationend"
  ],
  setup(props4, { emit, attrs }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const temp = {};
    let emitCachedValue = NaN, typedNumber, stopValueWatcher, emitTimer = null, emitValueFn;
    const inputRef = ref$1(null);
    const nameProp = useFormInputNameAttr(props4);
    const {
      innerValue,
      hasMask,
      moveCursorForPaste,
      updateMaskValue,
      onMaskedKeydown,
      onMaskedClick
    } = use_mask_default(props4, emit, emitValue, inputRef);
    const formDomProps = use_file_dom_props_default(
      props4,
      /* type guard */
      true
    );
    const hasValue = computed(() => fieldValueIsFilled(innerValue.value));
    const onComposition = use_key_composition_default(onInput);
    const state2 = useFieldState({ changeEvent: true });
    const isTextarea = computed(
      () => props4.type === "textarea" || props4.autogrow === true
    );
    const isTypeText = computed(
      () => isTextarea.value === true || ["text", "search", "url", "tel", "password"].includes(props4.type)
    );
    const onEvents = computed(() => {
      const evt = {
        ...state2.splitAttrs.listeners.value,
        onInput,
        onPaste,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        onChange,
        onBlur: onFinishEditing,
        onFocus: stop
      };
      evt.onCompositionstart = evt.onCompositionupdate = evt.onCompositionend = onComposition;
      if (hasMask.value === true) {
        evt.onKeydown = onMaskedKeydown;
        evt.onClick = onMaskedClick;
      }
      if (props4.autogrow === true) {
        evt.onAnimationend = onAnimationend;
      }
      return evt;
    });
    const inputAttrs = computed(() => {
      const attrs2 = {
        tabindex: 0,
        "data-autofocus": props4.autofocus === true || void 0,
        rows: props4.type === "textarea" ? 6 : void 0,
        "aria-label": props4.label,
        name: nameProp.value,
        ...state2.splitAttrs.attributes.value,
        id: state2.targetUid.value,
        maxlength: props4.maxlength,
        disabled: props4.disable === true,
        readonly: props4.readonly === true
      };
      if (isTextarea.value === false) {
        attrs2.type = props4.type;
      }
      if (props4.autogrow === true) {
        attrs2.rows = 1;
      }
      return attrs2;
    });
    watch(() => props4.type, () => {
      if (inputRef.value) {
        inputRef.value.value = props4.modelValue;
      }
    });
    watch(() => props4.modelValue, (v) => {
      if (hasMask.value === true) {
        if (stopValueWatcher === true) {
          stopValueWatcher = false;
          if (String(v) === emitCachedValue) {
            return;
          }
        }
        updateMaskValue(v);
      } else if (innerValue.value !== v) {
        innerValue.value = v;
        if (props4.type === "number" && temp.hasOwnProperty("value") === true) {
          if (typedNumber === true) {
            typedNumber = false;
          } else {
            delete temp.value;
          }
        }
      }
      props4.autogrow === true && nextTick(adjustHeight);
    });
    watch(() => props4.autogrow, (val) => {
      if (val === true) {
        nextTick(adjustHeight);
      } else if (inputRef.value !== null && attrs.rows > 0) {
        inputRef.value.style.height = "auto";
      }
    });
    watch(() => props4.dense, () => {
      props4.autogrow === true && nextTick(adjustHeight);
    });
    function focus() {
      addFocusFn(() => {
        const el = document.activeElement;
        if (inputRef.value !== null && inputRef.value !== el && (el === null || el.id !== state2.targetUid.value)) {
          inputRef.value.focus({ preventScroll: true });
        }
      });
    }
    function select() {
      inputRef.value !== null && inputRef.value.select();
    }
    function onPaste(e2) {
      if (hasMask.value === true && props4.reverseFillMask !== true) {
        const inp = e2.target;
        moveCursorForPaste(inp, inp.selectionStart, inp.selectionEnd);
      }
      emit("paste", e2);
    }
    function onInput(e2) {
      if (!e2 || !e2.target) {
        return;
      }
      if (props4.type === "file") {
        emit("update:modelValue", e2.target.files);
        return;
      }
      const val = e2.target.value;
      if (e2.target.qComposing === true) {
        temp.value = val;
        return;
      }
      if (hasMask.value === true) {
        updateMaskValue(val, false, e2.inputType);
      } else {
        emitValue(val);
        if (isTypeText.value === true && e2.target === document.activeElement) {
          const { selectionStart, selectionEnd } = e2.target;
          if (selectionStart !== void 0 && selectionEnd !== void 0) {
            nextTick(() => {
              if (e2.target === document.activeElement && val.indexOf(e2.target.value) === 0) {
                e2.target.setSelectionRange(selectionStart, selectionEnd);
              }
            });
          }
        }
      }
      props4.autogrow === true && adjustHeight();
    }
    function onAnimationend(e2) {
      emit("animationend", e2);
      adjustHeight();
    }
    function emitValue(val, stopWatcher) {
      emitValueFn = () => {
        emitTimer = null;
        if (props4.type !== "number" && temp.hasOwnProperty("value") === true) {
          delete temp.value;
        }
        if (props4.modelValue !== val && emitCachedValue !== val) {
          emitCachedValue = val;
          stopWatcher === true && (stopValueWatcher = true);
          emit("update:modelValue", val);
          nextTick(() => {
            emitCachedValue === val && (emitCachedValue = NaN);
          });
        }
        emitValueFn = void 0;
      };
      if (props4.type === "number") {
        typedNumber = true;
        temp.value = val;
      }
      if (props4.debounce !== void 0) {
        emitTimer !== null && clearTimeout(emitTimer);
        temp.value = val;
        emitTimer = setTimeout(emitValueFn, props4.debounce);
      } else {
        emitValueFn();
      }
    }
    function adjustHeight() {
      requestAnimationFrame(() => {
        const inp = inputRef.value;
        if (inp !== null) {
          const parentStyle = inp.parentNode.style;
          const { scrollTop } = inp;
          const { overflowY, maxHeight } = $q.platform.is.firefox === true ? {} : window.getComputedStyle(inp);
          const changeOverflow = overflowY !== void 0 && overflowY !== "scroll";
          changeOverflow === true && (inp.style.overflowY = "hidden");
          parentStyle.marginBottom = inp.scrollHeight - 1 + "px";
          inp.style.height = "1px";
          inp.style.height = inp.scrollHeight + "px";
          changeOverflow === true && (inp.style.overflowY = parseInt(maxHeight, 10) < inp.scrollHeight ? "auto" : "hidden");
          parentStyle.marginBottom = "";
          inp.scrollTop = scrollTop;
        }
      });
    }
    function onChange(e2) {
      onComposition(e2);
      if (emitTimer !== null) {
        clearTimeout(emitTimer);
        emitTimer = null;
      }
      emitValueFn !== void 0 && emitValueFn();
      emit("change", e2.target.value);
    }
    function onFinishEditing(e2) {
      e2 !== void 0 && stop(e2);
      if (emitTimer !== null) {
        clearTimeout(emitTimer);
        emitTimer = null;
      }
      emitValueFn !== void 0 && emitValueFn();
      typedNumber = false;
      stopValueWatcher = false;
      delete temp.value;
      props4.type !== "file" && setTimeout(() => {
        if (inputRef.value !== null) {
          inputRef.value.value = innerValue.value !== void 0 ? innerValue.value : "";
        }
      });
    }
    function getCurValue() {
      return temp.hasOwnProperty("value") === true ? temp.value : innerValue.value !== void 0 ? innerValue.value : "";
    }
    onBeforeUnmount(() => {
      onFinishEditing();
    });
    onMounted(() => {
      props4.autogrow === true && adjustHeight();
    });
    Object.assign(state2, {
      innerValue,
      fieldClass: computed(
        () => `q-${isTextarea.value === true ? "textarea" : "input"}` + (props4.autogrow === true ? " q-textarea--autogrow" : "")
      ),
      hasShadow: computed(
        () => props4.type !== "file" && typeof props4.shadowText === "string" && props4.shadowText.length !== 0
      ),
      inputRef,
      emitValue,
      hasValue,
      floatingLabel: computed(
        () => hasValue.value === true && (props4.type !== "number" || isNaN(innerValue.value) === false) || fieldValueIsFilled(props4.displayValue)
      ),
      getControl: () => {
        return h(isTextarea.value === true ? "textarea" : "input", {
          ref: inputRef,
          class: [
            "q-field__native q-placeholder",
            props4.inputClass
          ],
          style: props4.inputStyle,
          ...inputAttrs.value,
          ...onEvents.value,
          ...props4.type !== "file" ? { value: getCurValue() } : formDomProps.value
        });
      },
      getShadowControl: () => {
        return h("div", {
          class: "q-field__native q-field__shadow absolute-bottom no-pointer-events" + (isTextarea.value === true ? "" : " text-no-wrap")
        }, [
          h("span", { class: "invisible" }, getCurValue()),
          h("span", props4.shadowText)
        ]);
      }
    });
    const renderFn = use_field_default(state2);
    Object.assign(proxy, {
      focus,
      select,
      getNativeElement: () => inputRef.value
      // deprecated
    });
    injectProp(proxy, "nativeEl", () => inputRef.value);
    return renderFn;
  }
});
var defaultCfg = {
  threshold: 0,
  root: null,
  rootMargin: "0px"
};
function update2(el, ctx, value2) {
  let handler, cfg, changed2;
  if (typeof value2 === "function") {
    handler = value2;
    cfg = defaultCfg;
    changed2 = ctx.cfg === void 0;
  } else {
    handler = value2.handler;
    cfg = Object.assign({}, defaultCfg, value2.cfg);
    changed2 = ctx.cfg === void 0 || isDeepEqual(ctx.cfg, cfg) === false;
  }
  if (ctx.handler !== handler) {
    ctx.handler = handler;
  }
  if (changed2 === true) {
    ctx.cfg = cfg;
    ctx.observer !== void 0 && ctx.observer.unobserve(el);
    ctx.observer = new IntersectionObserver(([entry]) => {
      if (typeof ctx.handler === "function") {
        if (entry.rootBounds === null && document.body.contains(el) === true) {
          ctx.observer.unobserve(el);
          ctx.observer.observe(el);
          return;
        }
        const res = ctx.handler(entry, ctx.observer);
        if (res === false || ctx.once === true && entry.isIntersecting === true) {
          destroy(el);
        }
      }
    }, cfg);
    ctx.observer.observe(el);
  }
}
function destroy(el) {
  const ctx = el.__qvisible;
  if (ctx !== void 0) {
    ctx.observer !== void 0 && ctx.observer.unobserve(el);
    delete el.__qvisible;
  }
}
var Intersection_default = createDirective(
  {
    name: "intersection",
    mounted(el, { modifiers, value: value2 }) {
      const ctx = {
        once: modifiers.once === true
      };
      update2(el, ctx, value2);
      el.__qvisible = ctx;
    },
    updated(el, binding) {
      const ctx = el.__qvisible;
      ctx !== void 0 && update2(el, ctx, binding.value);
    },
    beforeUnmount: destroy
  }
);
var QIntersection_default = createComponent({
  name: "QIntersection",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    once: Boolean,
    transition: String,
    transitionDuration: {
      type: [String, Number],
      default: 300
    },
    ssrPrerender: Boolean,
    margin: String,
    threshold: [Number, Array],
    root: {
      default: null
    },
    disable: Boolean,
    onVisibility: Function
  },
  setup(props4, { slots, emit }) {
    const showing = ref$1(isRuntimeSsrPreHydration.value === true ? props4.ssrPrerender : false);
    const intersectionProps = computed(() => props4.root !== void 0 || props4.margin !== void 0 || props4.threshold !== void 0 ? {
      handler: trigger3,
      cfg: {
        root: props4.root,
        rootMargin: props4.margin,
        threshold: props4.threshold
      }
    } : trigger3);
    const hasDirective = computed(
      () => props4.disable !== true && (isRuntimeSsrPreHydration.value !== true || props4.once !== true || props4.ssrPrerender !== true)
    );
    const directives2 = computed(() => {
      return [[
        Intersection_default,
        intersectionProps.value,
        void 0,
        { once: props4.once }
      ]];
    });
    const transitionStyle = computed(
      () => `--q-transition-duration: ${props4.transitionDuration}ms`
    );
    function trigger3(entry) {
      if (showing.value !== entry.isIntersecting) {
        showing.value = entry.isIntersecting;
        props4.onVisibility !== void 0 && emit("visibility", showing.value);
      }
    }
    function getContent() {
      if (showing.value === true) {
        return [h("div", { key: "content", style: transitionStyle.value }, hSlot(slots.default))];
      }
      if (slots.hidden !== void 0) {
        return [h("div", { key: "hidden", style: transitionStyle.value }, slots.hidden())];
      }
    }
    return () => {
      const child = props4.transition ? [
        h(Transition, {
          name: "q-transition--" + props4.transition
        }, getContent)
      ] : getContent();
      return hDir(
        props4.tag,
        { class: "q-intersection" },
        child,
        "main",
        hasDirective.value,
        () => directives2.value
      );
    };
  }
});
var roleAttrExceptions = ["ul", "ol"];
var QList_default = createComponent({
  name: "QList",
  props: {
    ...useDarkProps,
    bordered: Boolean,
    dense: Boolean,
    separator: Boolean,
    padding: Boolean,
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const role = computed(
      () => roleAttrExceptions.includes(props4.tag) ? null : "list"
    );
    const classes = computed(
      () => "q-list" + (props4.bordered === true ? " q-list--bordered" : "") + (props4.dense === true ? " q-list--dense" : "") + (props4.separator === true ? " q-list--separator" : "") + (isDark.value === true ? " q-list--dark" : "") + (props4.padding === true ? " q-list--padding" : "")
    );
    return () => h(props4.tag, { class: classes.value, role: role.value }, hSlot(slots.default));
  }
});
var keyCodes2 = [34, 37, 40, 33, 39, 38];
var commonPropsName = Object.keys(useCircularCommonProps);
createComponent({
  name: "QKnob",
  props: {
    ...useFormProps,
    ...useCircularCommonProps,
    modelValue: {
      type: Number,
      required: true
    },
    innerMin: Number,
    innerMax: Number,
    step: {
      type: Number,
      default: 1,
      validator: (v) => v >= 0
    },
    tabindex: {
      type: [Number, String],
      default: 0
    },
    disable: Boolean,
    readonly: Boolean
  },
  emits: ["update:modelValue", "change", "dragValue"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const model = ref$1(props4.modelValue);
    const dragging = ref$1(false);
    const innerMin = computed(() => isNaN(props4.innerMin) === true || props4.innerMin < props4.min ? props4.min : props4.innerMin);
    const innerMax = computed(() => isNaN(props4.innerMax) === true || props4.innerMax > props4.max ? props4.max : props4.innerMax);
    let centerPosition;
    function normalizeModel() {
      model.value = props4.modelValue === null ? innerMin.value : between(props4.modelValue, innerMin.value, innerMax.value);
      updateValue2(true);
    }
    watch(
      () => `${props4.modelValue}|${innerMin.value}|${innerMax.value}`,
      normalizeModel
    );
    normalizeModel();
    const editable = computed(() => props4.disable === false && props4.readonly === false);
    const classes = computed(
      () => "q-knob non-selectable" + (editable.value === true ? " q-knob--editable" : props4.disable === true ? " disabled" : "")
    );
    const decimals = computed(() => (String(props4.step).trim().split(".")[1] || "").length);
    const step = computed(() => props4.step === 0 ? 1 : props4.step);
    const instantFeedback = computed(() => props4.instantFeedback === true || dragging.value === true);
    const onEvents = $q.platform.is.mobile === true ? computed(() => editable.value === true ? { onClick } : {}) : computed(() => editable.value === true ? {
      onMousedown,
      onClick,
      onKeydown: onKeydown2,
      onKeyup: onKeyup2
    } : {});
    const attrs = computed(() => editable.value === true ? { tabindex: props4.tabindex } : { [`aria-${props4.disable === true ? "disabled" : "readonly"}`]: "true" });
    const circularProps = computed(() => {
      const agg = {};
      commonPropsName.forEach((name2) => {
        agg[name2] = props4[name2];
      });
      return agg;
    });
    function pan(event) {
      if (event.isFinal) {
        updatePosition(event.evt, true);
        dragging.value = false;
      } else if (event.isFirst) {
        updateCenterPosition();
        dragging.value = true;
        updatePosition(event.evt);
      } else {
        updatePosition(event.evt);
      }
    }
    const directives2 = computed(() => {
      return [[
        TouchPan_default,
        pan,
        void 0,
        { prevent: true, stop: true, mouse: true }
      ]];
    });
    function updateCenterPosition() {
      const { top, left, width: width3, height: height2 } = proxy.$el.getBoundingClientRect();
      centerPosition = {
        top: top + height2 / 2,
        left: left + width3 / 2
      };
    }
    function onMousedown(evt) {
      updateCenterPosition();
      updatePosition(evt);
    }
    function onClick(evt) {
      updateCenterPosition();
      updatePosition(evt, true);
    }
    function onKeydown2(evt) {
      if (!keyCodes2.includes(evt.keyCode)) {
        return;
      }
      stopAndPrevent(evt);
      const stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * step.value, offset2 = [34, 37, 40].includes(evt.keyCode) ? -stepVal : stepVal;
      model.value = between(
        parseFloat((model.value + offset2).toFixed(decimals.value)),
        innerMin.value,
        innerMax.value
      );
      updateValue2();
    }
    function updatePosition(evt, change) {
      const pos = position(evt), height2 = Math.abs(pos.top - centerPosition.top), distance = Math.sqrt(
        height2 ** 2 + Math.abs(pos.left - centerPosition.left) ** 2
      );
      let angle = Math.asin(height2 / distance) * (180 / Math.PI);
      if (pos.top < centerPosition.top) {
        angle = centerPosition.left < pos.left ? 90 - angle : 270 + angle;
      } else {
        angle = centerPosition.left < pos.left ? angle + 90 : 270 - angle;
      }
      if ($q.lang.rtl === true) {
        angle = normalizeToInterval(-angle - props4.angle, 0, 360);
      } else if (props4.angle) {
        angle = normalizeToInterval(angle - props4.angle, 0, 360);
      }
      if (props4.reverse === true) {
        angle = 360 - angle;
      }
      let newModel = props4.min + angle / 360 * (props4.max - props4.min);
      if (step.value !== 0) {
        const modulo = newModel % step.value;
        newModel = newModel - modulo + (Math.abs(modulo) >= step.value / 2 ? (modulo < 0 ? -1 : 1) * step.value : 0);
        newModel = parseFloat(newModel.toFixed(decimals.value));
      }
      newModel = between(newModel, innerMin.value, innerMax.value);
      emit("dragValue", newModel);
      if (model.value !== newModel) {
        model.value = newModel;
      }
      updateValue2(change);
    }
    function onKeyup2(evt) {
      if (keyCodes2.includes(evt.keyCode)) {
        updateValue2(true);
      }
    }
    function updateValue2(change) {
      props4.modelValue !== model.value && emit("update:modelValue", model.value);
      change === true && emit("change", model.value);
    }
    const formAttrs = useFormAttrs(props4);
    function getNameInput() {
      return h("input", formAttrs.value);
    }
    return () => {
      const data = {
        class: classes.value,
        role: "slider",
        "aria-valuemin": innerMin.value,
        "aria-valuemax": innerMax.value,
        "aria-valuenow": props4.modelValue,
        ...attrs.value,
        ...circularProps.value,
        value: model.value,
        instantFeedback: instantFeedback.value,
        ...onEvents.value
      };
      const child = {
        default: slots.default
      };
      if (editable.value === true && props4.name !== void 0) {
        child.internal = getNameInput;
      }
      return hDir(
        QCircularProgress_default,
        data,
        child,
        "knob",
        editable.value,
        () => directives2.value
      );
    };
  }
});
var { passive: passive3 } = listenOpts;
var axisValues = ["both", "horizontal", "vertical"];
var QScrollObserver_default = createComponent({
  name: "QScrollObserver",
  props: {
    axis: {
      type: String,
      validator: (v) => axisValues.includes(v),
      default: "vertical"
    },
    debounce: [String, Number],
    scrollTarget: scrollTargetProp
  },
  emits: ["scroll"],
  setup(props4, { emit }) {
    const scroll = {
      position: {
        top: 0,
        left: 0
      },
      direction: "down",
      directionChanged: false,
      delta: {
        top: 0,
        left: 0
      },
      inflectionPoint: {
        top: 0,
        left: 0
      }
    };
    let clearTimer = null, localScrollTarget, parentEl;
    watch(() => props4.scrollTarget, () => {
      unconfigureScrollTarget();
      configureScrollTarget();
    });
    function emitEvent() {
      clearTimer !== null && clearTimer();
      const top = Math.max(0, getVerticalScrollPosition(localScrollTarget));
      const left = getHorizontalScrollPosition(localScrollTarget);
      const delta = {
        top: top - scroll.position.top,
        left: left - scroll.position.left
      };
      if (props4.axis === "vertical" && delta.top === 0 || props4.axis === "horizontal" && delta.left === 0) {
        return;
      }
      const curDir = Math.abs(delta.top) >= Math.abs(delta.left) ? delta.top < 0 ? "up" : "down" : delta.left < 0 ? "left" : "right";
      scroll.position = { top, left };
      scroll.directionChanged = scroll.direction !== curDir;
      scroll.delta = delta;
      if (scroll.directionChanged === true) {
        scroll.direction = curDir;
        scroll.inflectionPoint = scroll.position;
      }
      emit("scroll", { ...scroll });
    }
    function configureScrollTarget() {
      localScrollTarget = getScrollTarget(parentEl, props4.scrollTarget);
      localScrollTarget.addEventListener("scroll", trigger3, passive3);
      trigger3(true);
    }
    function unconfigureScrollTarget() {
      if (localScrollTarget !== void 0) {
        localScrollTarget.removeEventListener("scroll", trigger3, passive3);
        localScrollTarget = void 0;
      }
    }
    function trigger3(immediately) {
      if (immediately === true || props4.debounce === 0 || props4.debounce === "0") {
        emitEvent();
      } else if (clearTimer === null) {
        const [timer2, fn] = props4.debounce ? [setTimeout(emitEvent, props4.debounce), clearTimeout] : [requestAnimationFrame(emitEvent), cancelAnimationFrame];
        clearTimer = () => {
          fn(timer2);
          clearTimer = null;
        };
      }
    }
    const { proxy } = getCurrentInstance();
    watch(() => proxy.$q.lang.rtl, emitEvent);
    onMounted(() => {
      parentEl = proxy.$el.parentNode;
      configureScrollTarget();
    });
    onBeforeUnmount(() => {
      clearTimer !== null && clearTimer();
      unconfigureScrollTarget();
    });
    Object.assign(proxy, {
      trigger: trigger3,
      getPosition: () => scroll
    });
    return noop;
  }
});
var QLayout_default = createComponent({
  name: "QLayout",
  props: {
    container: Boolean,
    view: {
      type: String,
      default: "hhh lpr fff",
      validator: (v) => /^(h|l)h(h|r) lpr (f|l)f(f|r)$/.test(v.toLowerCase())
    },
    onScroll: Function,
    onScrollHeight: Function,
    onResize: Function
  },
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const rootRef = ref$1(null);
    const height2 = ref$1($q.screen.height);
    const width3 = ref$1(props4.container === true ? 0 : $q.screen.width);
    const scroll = ref$1({ position: 0, direction: "down", inflectionPoint: 0 });
    const containerHeight = ref$1(0);
    const scrollbarWidth = ref$1(isRuntimeSsrPreHydration.value === true ? 0 : getScrollbarWidth());
    const classes = computed(
      () => "q-layout q-layout--" + (props4.container === true ? "containerized" : "standard")
    );
    const style2 = computed(() => props4.container === false ? { minHeight: $q.screen.height + "px" } : null);
    const targetStyle = computed(() => scrollbarWidth.value !== 0 ? { [$q.lang.rtl === true ? "left" : "right"]: `${scrollbarWidth.value}px` } : null);
    const targetChildStyle = computed(() => scrollbarWidth.value !== 0 ? {
      [$q.lang.rtl === true ? "right" : "left"]: 0,
      [$q.lang.rtl === true ? "left" : "right"]: `-${scrollbarWidth.value}px`,
      width: `calc(100% + ${scrollbarWidth.value}px)`
    } : null);
    function onPageScroll(data) {
      if (props4.container === true || document.qScrollPrevented !== true) {
        const info = {
          position: data.position.top,
          direction: data.direction,
          directionChanged: data.directionChanged,
          inflectionPoint: data.inflectionPoint.top,
          delta: data.delta.top
        };
        scroll.value = info;
        props4.onScroll !== void 0 && emit("scroll", info);
      }
    }
    function onPageResize(data) {
      const { height: newHeight, width: newWidth } = data;
      let resized = false;
      if (height2.value !== newHeight) {
        resized = true;
        height2.value = newHeight;
        props4.onScrollHeight !== void 0 && emit("scrollHeight", newHeight);
        updateScrollbarWidth();
      }
      if (width3.value !== newWidth) {
        resized = true;
        width3.value = newWidth;
      }
      if (resized === true && props4.onResize !== void 0) {
        emit("resize", data);
      }
    }
    function onContainerResize({ height: height3 }) {
      if (containerHeight.value !== height3) {
        containerHeight.value = height3;
        updateScrollbarWidth();
      }
    }
    function updateScrollbarWidth() {
      if (props4.container === true) {
        const width4 = height2.value > containerHeight.value ? getScrollbarWidth() : 0;
        if (scrollbarWidth.value !== width4) {
          scrollbarWidth.value = width4;
        }
      }
    }
    let animateTimer = null;
    const $layout = {
      instances: {},
      view: computed(() => props4.view),
      isContainer: computed(() => props4.container),
      rootRef,
      height: height2,
      containerHeight,
      scrollbarWidth,
      totalWidth: computed(() => width3.value + scrollbarWidth.value),
      rows: computed(() => {
        const rows = props4.view.toLowerCase().split(" ");
        return {
          top: rows[0].split(""),
          middle: rows[1].split(""),
          bottom: rows[2].split("")
        };
      }),
      header: reactive({ size: 0, offset: 0, space: false }),
      right: reactive({ size: 300, offset: 0, space: false }),
      footer: reactive({ size: 0, offset: 0, space: false }),
      left: reactive({ size: 300, offset: 0, space: false }),
      scroll,
      animate() {
        if (animateTimer !== null) {
          clearTimeout(animateTimer);
        } else {
          document.body.classList.add("q-body--layout-animate");
        }
        animateTimer = setTimeout(() => {
          animateTimer = null;
          document.body.classList.remove("q-body--layout-animate");
        }, 155);
      },
      update(part, prop, val) {
        $layout[part][prop] = val;
      }
    };
    provide(layoutKey, $layout);
    if (getScrollbarWidth() > 0) {
      let restoreScrollbar = function() {
        timer2 = null;
        el.classList.remove("hide-scrollbar");
      }, hideScrollbar = function() {
        if (timer2 === null) {
          if (el.scrollHeight > $q.screen.height) {
            return;
          }
          el.classList.add("hide-scrollbar");
        } else {
          clearTimeout(timer2);
        }
        timer2 = setTimeout(restoreScrollbar, 300);
      }, updateScrollEvent = function(action) {
        if (timer2 !== null && action === "remove") {
          clearTimeout(timer2);
          restoreScrollbar();
        }
        window[`${action}EventListener`]("resize", hideScrollbar);
      };
      let timer2 = null;
      const el = document.body;
      watch(
        () => props4.container !== true ? "add" : "remove",
        updateScrollEvent
      );
      props4.container !== true && updateScrollEvent("add");
      onUnmounted(() => {
        updateScrollEvent("remove");
      });
    }
    return () => {
      const content = hMergeSlot(slots.default, [
        h(QScrollObserver_default, { onScroll: onPageScroll }),
        h(QResizeObserver_default, { onResize: onPageResize })
      ]);
      const layout = h("div", {
        class: classes.value,
        style: style2.value,
        ref: props4.container === true ? void 0 : rootRef,
        tabindex: -1
      }, content);
      if (props4.container === true) {
        return h("div", {
          class: "q-layout-container overflow-hidden",
          ref: rootRef
        }, [
          h(QResizeObserver_default, { onResize: onContainerResize }),
          h("div", {
            class: "absolute-full",
            style: targetStyle.value
          }, [
            h("div", {
              class: "scroll",
              style: targetChildStyle.value
            }, [layout])
          ])
        ]);
      }
      return layout;
    };
  }
});
var separatorValues = ["horizontal", "vertical", "cell", "none"];
var QMarkupTable_default = createComponent({
  name: "QMarkupTable",
  props: {
    ...useDarkProps,
    dense: Boolean,
    flat: Boolean,
    bordered: Boolean,
    square: Boolean,
    wrapCells: Boolean,
    separator: {
      type: String,
      default: "horizontal",
      validator: (v) => separatorValues.includes(v)
    }
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const classes = computed(
      () => `q-markup-table q-table__container q-table__card q-table--${props4.separator}-separator` + (isDark.value === true ? " q-table--dark q-table__card--dark q-dark" : "") + (props4.dense === true ? " q-table--dense" : "") + (props4.flat === true ? " q-table--flat" : "") + (props4.bordered === true ? " q-table--bordered" : "") + (props4.square === true ? " q-table--square" : "") + (props4.wrapCells === false ? " q-table--no-wrap" : "")
    );
    return () => h("div", {
      class: classes.value
    }, [
      h("table", { class: "q-table" }, hSlot(slots.default))
    ]);
  }
});
createComponent({
  name: "QNoSsr",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    placeholder: String
  },
  setup(props4, { slots }) {
    const { isHydrated } = use_hydration_default();
    return () => {
      if (isHydrated.value === true) {
        const node2 = hSlot(slots.default);
        return node2 === void 0 ? node2 : node2.length > 1 ? h(props4.tag, {}, node2) : node2[0];
      }
      const data = {
        class: "q-no-ssr-placeholder"
      };
      const node = hSlot(slots.placeholder);
      if (node !== void 0) {
        return node.length > 1 ? h(props4.tag, data, node) : node[0];
      }
      if (props4.placeholder !== void 0) {
        return h(props4.tag, data, props4.placeholder);
      }
    };
  }
});
var createSvg = () => h("svg", {
  key: "svg",
  class: "q-radio__bg absolute non-selectable",
  viewBox: "0 0 24 24"
}, [
  h("path", {
    d: "M12,22a10,10 0 0 1 -10,-10a10,10 0 0 1 10,-10a10,10 0 0 1 10,10a10,10 0 0 1 -10,10m0,-22a12,12 0 0 0 -12,12a12,12 0 0 0 12,12a12,12 0 0 0 12,-12a12,12 0 0 0 -12,-12"
  }),
  h("path", {
    class: "q-radio__check",
    d: "M12,6a6,6 0 0 0 -6,6a6,6 0 0 0 6,6a6,6 0 0 0 6,-6a6,6 0 0 0 -6,-6"
  })
]);
var QRadio_default = createComponent({
  name: "QRadio",
  props: {
    ...useDarkProps,
    ...useSizeProps,
    ...useFormProps,
    modelValue: { required: true },
    val: { required: true },
    label: String,
    leftLabel: Boolean,
    checkedIcon: String,
    uncheckedIcon: String,
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    disable: Boolean,
    tabindex: [String, Number]
  },
  emits: ["update:modelValue"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const isDark = use_dark_default(props4, proxy.$q);
    const sizeStyle = use_size_default(props4, option_sizes_default);
    const rootRef = ref$1(null);
    const { refocusTargetEl, refocusTarget } = use_refocus_target_default(props4, rootRef);
    const isTrue = computed(() => toRaw(props4.modelValue) === toRaw(props4.val));
    const classes = computed(
      () => "q-radio cursor-pointer no-outline row inline no-wrap items-center" + (props4.disable === true ? " disabled" : "") + (isDark.value === true ? " q-radio--dark" : "") + (props4.dense === true ? " q-radio--dense" : "") + (props4.leftLabel === true ? " reverse" : "")
    );
    const innerClass = computed(() => {
      const color = props4.color !== void 0 && (props4.keepColor === true || isTrue.value === true) ? ` text-${props4.color}` : "";
      return `q-radio__inner relative-position q-radio__inner--${isTrue.value === true ? "truthy" : "falsy"}${color}`;
    });
    const icon = computed(
      () => (isTrue.value === true ? props4.checkedIcon : props4.uncheckedIcon) || null
    );
    const tabindex = computed(() => props4.disable === true ? -1 : props4.tabindex || 0);
    const formAttrs = computed(() => {
      const prop = { type: "radio" };
      props4.name !== void 0 && Object.assign(prop, {
        // see https://vuejs.org/guide/extras/render-function.html#creating-vnodes (.prop)
        ".checked": isTrue.value === true,
        "^checked": isTrue.value === true ? "checked" : void 0,
        name: props4.name,
        value: props4.val
      });
      return prop;
    });
    const injectFormInput = useFormInject(formAttrs);
    function onClick(e2) {
      if (e2 !== void 0) {
        stopAndPrevent(e2);
        refocusTarget(e2);
      }
      if (props4.disable !== true && isTrue.value !== true) {
        emit("update:modelValue", props4.val, e2);
      }
    }
    function onKeydown2(e2) {
      if (e2.keyCode === 13 || e2.keyCode === 32) {
        stopAndPrevent(e2);
      }
    }
    function onKeyup2(e2) {
      if (e2.keyCode === 13 || e2.keyCode === 32) {
        onClick(e2);
      }
    }
    Object.assign(proxy, { set: onClick });
    const svg = createSvg();
    return () => {
      const content = icon.value !== null ? [
        h("div", {
          key: "icon",
          class: "q-radio__icon-container absolute-full flex flex-center no-wrap"
        }, [
          h(QIcon_default, {
            class: "q-radio__icon",
            name: icon.value
          })
        ])
      ] : [svg];
      props4.disable !== true && injectFormInput(
        content,
        "unshift",
        " q-radio__native q-ma-none q-pa-none"
      );
      const child = [
        h("div", {
          class: innerClass.value,
          style: sizeStyle.value,
          "aria-hidden": "true"
        }, content)
      ];
      if (refocusTargetEl.value !== null) {
        child.push(refocusTargetEl.value);
      }
      const label = props4.label !== void 0 ? hMergeSlot(slots.default, [props4.label]) : hSlot(slots.default);
      label !== void 0 && child.push(
        h("div", {
          class: "q-radio__label q-anchor--skip"
        }, label)
      );
      return h("div", {
        ref: rootRef,
        class: classes.value,
        tabindex: tabindex.value,
        role: "radio",
        "aria-label": props4.label,
        "aria-checked": isTrue.value === true ? "true" : "false",
        "aria-disabled": props4.disable === true ? "true" : void 0,
        onClick,
        onKeydown: onKeydown2,
        onKeyup: onKeyup2
      }, child);
    };
  }
});
var QToggle_default = createComponent({
  name: "QToggle",
  props: {
    ...useCheckboxProps,
    icon: String,
    iconColor: String
  },
  emits: useCheckboxEmits,
  setup(props4) {
    function getInner(isTrue, isIndeterminate) {
      const icon = computed(
        () => (isTrue.value === true ? props4.checkedIcon : isIndeterminate.value === true ? props4.indeterminateIcon : props4.uncheckedIcon) || props4.icon
      );
      const color = computed(() => isTrue.value === true ? props4.iconColor : null);
      return () => [
        h("div", { class: "q-toggle__track" }),
        h(
          "div",
          {
            class: "q-toggle__thumb absolute flex flex-center no-wrap"
          },
          icon.value !== void 0 ? [
            h(QIcon_default, {
              name: icon.value,
              color: color.value
            })
          ] : void 0
        )
      ];
    }
    return use_checkbox_default("toggle", getInner);
  }
});
var components$1 = {
  radio: QRadio_default,
  checkbox: QCheckbox_default,
  toggle: QToggle_default
};
var typeValues = Object.keys(components$1);
function getPropValueFn(userPropName, defaultPropName) {
  if (typeof userPropName === "function") return userPropName;
  const propName = userPropName !== void 0 ? userPropName : defaultPropName;
  return (opt) => opt[propName];
}
var QOptionGroup_default = createComponent({
  name: "QOptionGroup",
  props: {
    ...useDarkProps,
    modelValue: {
      required: true
    },
    options: {
      type: Array,
      validator: (opts) => opts.every(isObject),
      default: () => []
    },
    optionValue: [Function, String],
    optionLabel: [Function, String],
    optionDisable: [Function, String],
    name: String,
    type: {
      type: String,
      default: "radio",
      validator: (v) => typeValues.includes(v)
    },
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    size: String,
    leftLabel: Boolean,
    inline: Boolean,
    disable: Boolean
  },
  emits: ["update:modelValue"],
  setup(props4, { emit, slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const arrayModel = Array.isArray(props4.modelValue);
    if (props4.type === "radio") {
      if (arrayModel === true) {
        console.error("q-option-group: model should not be array");
      }
    } else if (arrayModel === false) {
      console.error("q-option-group: model should be array in your case");
    }
    const isDark = use_dark_default(props4, $q);
    const component = computed(() => components$1[props4.type]);
    const getOptionValue = computed(() => getPropValueFn(props4.optionValue, "value"));
    const getOptionLabel = computed(() => getPropValueFn(props4.optionLabel, "label"));
    const getOptionDisable = computed(() => getPropValueFn(props4.optionDisable, "disable"));
    const innerOptions = computed(() => props4.options.map((opt) => ({
      val: getOptionValue.value(opt),
      name: opt.name === void 0 ? props4.name : opt.name,
      disable: props4.disable || getOptionDisable.value(opt),
      leftLabel: opt.leftLabel === void 0 ? props4.leftLabel : opt.leftLabel,
      color: opt.color === void 0 ? props4.color : opt.color,
      checkedIcon: opt.checkedIcon,
      uncheckedIcon: opt.uncheckedIcon,
      dark: opt.dark === void 0 ? isDark.value : opt.dark,
      size: opt.size === void 0 ? props4.size : opt.size,
      dense: props4.dense,
      keepColor: opt.keepColor === void 0 ? props4.keepColor : opt.keepColor
    })));
    const classes = computed(
      () => "q-option-group q-gutter-x-sm" + (props4.inline === true ? " q-option-group--inline" : "")
    );
    const attrs = computed(() => {
      const attrs2 = { role: "group" };
      if (props4.type === "radio") {
        attrs2.role = "radiogroup";
        if (props4.disable === true) {
          attrs2["aria-disabled"] = "true";
        }
      }
      return attrs2;
    });
    function onUpdateModelValue(value2) {
      emit("update:modelValue", value2);
    }
    return () => h("div", {
      class: classes.value,
      ...attrs.value
    }, props4.options.map((opt, i2) => {
      const child = slots["label-" + i2] !== void 0 ? () => slots["label-" + i2](opt) : slots.label !== void 0 ? () => slots.label(opt) : void 0;
      return h("div", [
        h(component.value, {
          label: child === void 0 ? getOptionLabel.value(opt) : null,
          modelValue: props4.modelValue,
          "onUpdate:modelValue": onUpdateModelValue,
          ...innerOptions.value[i2]
        }, child)
      ]);
    }));
  }
});
var QPage_default = createComponent({
  name: "QPage",
  props: {
    padding: Boolean,
    styleFn: Function
  },
  setup(props4, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $layout = inject(layoutKey, emptyRenderFn);
    if ($layout === emptyRenderFn) {
      console.error("QPage needs to be a deep child of QLayout");
      return emptyRenderFn;
    }
    const $pageContainer = inject(pageContainerKey, emptyRenderFn);
    if ($pageContainer === emptyRenderFn) {
      console.error("QPage needs to be child of QPageContainer");
      return emptyRenderFn;
    }
    const style2 = computed(() => {
      const offset2 = ($layout.header.space === true ? $layout.header.size : 0) + ($layout.footer.space === true ? $layout.footer.size : 0);
      if (typeof props4.styleFn === "function") {
        const height2 = $layout.isContainer.value === true ? $layout.containerHeight.value : $q.screen.height;
        return props4.styleFn(offset2, height2);
      }
      return {
        minHeight: $layout.isContainer.value === true ? $layout.containerHeight.value - offset2 + "px" : $q.screen.height === 0 ? offset2 !== 0 ? `calc(100vh - ${offset2}px)` : "100vh" : $q.screen.height - offset2 + "px"
      };
    });
    const classes = computed(
      () => `q-page${props4.padding === true ? " q-layout-padding" : ""}`
    );
    return () => h("main", {
      class: classes.value,
      style: style2.value
    }, hSlot(slots.default));
  }
});
var QPageContainer_default = createComponent({
  name: "QPageContainer",
  setup(_, { slots }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $layout = inject(layoutKey, emptyRenderFn);
    if ($layout === emptyRenderFn) {
      console.error("QPageContainer needs to be child of QLayout");
      return emptyRenderFn;
    }
    provide(pageContainerKey, true);
    const style2 = computed(() => {
      const css2 = {};
      if ($layout.header.space === true) {
        css2.paddingTop = `${$layout.header.size}px`;
      }
      if ($layout.right.space === true) {
        css2[`padding${$q.lang.rtl === true ? "Left" : "Right"}`] = `${$layout.right.size}px`;
      }
      if ($layout.footer.space === true) {
        css2.paddingBottom = `${$layout.footer.size}px`;
      }
      if ($layout.left.space === true) {
        css2[`padding${$q.lang.rtl === true ? "Right" : "Left"}`] = `${$layout.left.size}px`;
      }
      return css2;
    });
    return () => h("div", {
      class: "q-page-container",
      style: style2.value
    }, hSlot(slots.default));
  }
});
var usePageStickyProps = {
  position: {
    type: String,
    default: "bottom-right",
    validator: (v) => [
      "top-right",
      "top-left",
      "bottom-right",
      "bottom-left",
      "top",
      "right",
      "bottom",
      "left"
    ].includes(v)
  },
  offset: {
    type: Array,
    validator: (v) => v.length === 2
  },
  expand: Boolean
};
function use_page_sticky_default() {
  const { props: props4, proxy: { $q } } = getCurrentInstance();
  const $layout = inject(layoutKey, emptyRenderFn);
  if ($layout === emptyRenderFn) {
    console.error("QPageSticky needs to be child of QLayout");
    return emptyRenderFn;
  }
  const attach = computed(() => {
    const pos = props4.position;
    return {
      top: pos.indexOf("top") !== -1,
      right: pos.indexOf("right") !== -1,
      bottom: pos.indexOf("bottom") !== -1,
      left: pos.indexOf("left") !== -1,
      vertical: pos === "top" || pos === "bottom",
      horizontal: pos === "left" || pos === "right"
    };
  });
  const top = computed(() => $layout.header.offset);
  const right = computed(() => $layout.right.offset);
  const bottom = computed(() => $layout.footer.offset);
  const left = computed(() => $layout.left.offset);
  const style2 = computed(() => {
    let posX = 0, posY = 0;
    const side = attach.value;
    const dir = $q.lang.rtl === true ? -1 : 1;
    if (side.top === true && top.value !== 0) {
      posY = `${top.value}px`;
    } else if (side.bottom === true && bottom.value !== 0) {
      posY = `${-bottom.value}px`;
    }
    if (side.left === true && left.value !== 0) {
      posX = `${dir * left.value}px`;
    } else if (side.right === true && right.value !== 0) {
      posX = `${-dir * right.value}px`;
    }
    const css2 = { transform: `translate(${posX}, ${posY})` };
    if (props4.offset) {
      css2.margin = `${props4.offset[1]}px ${props4.offset[0]}px`;
    }
    if (side.vertical === true) {
      if (left.value !== 0) {
        css2[$q.lang.rtl === true ? "right" : "left"] = `${left.value}px`;
      }
      if (right.value !== 0) {
        css2[$q.lang.rtl === true ? "left" : "right"] = `${right.value}px`;
      }
    } else if (side.horizontal === true) {
      if (top.value !== 0) {
        css2.top = `${top.value}px`;
      }
      if (bottom.value !== 0) {
        css2.bottom = `${bottom.value}px`;
      }
    }
    return css2;
  });
  const classes = computed(
    () => `q-page-sticky row flex-center fixed-${props4.position} q-page-sticky--${props4.expand === true ? "expand" : "shrink"}`
  );
  function getStickyContent(slots) {
    const content = hSlot(slots.default);
    return h(
      "div",
      {
        class: classes.value,
        style: style2.value
      },
      props4.expand === true ? content : [h("div", content)]
    );
  }
  return {
    $layout,
    getStickyContent
  };
}
createComponent({
  name: "QPageScroller",
  props: {
    ...usePageStickyProps,
    scrollOffset: {
      type: Number,
      default: 1e3
    },
    reverse: Boolean,
    duration: {
      type: Number,
      default: 300
    },
    offset: {
      ...usePageStickyProps.offset,
      default: () => [18, 18]
    }
  },
  emits: ["click"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const { $layout, getStickyContent } = use_page_sticky_default();
    const rootRef = ref$1(null);
    let heightWatcher;
    const scrollHeight = computed(() => $layout.height.value - ($layout.isContainer.value === true ? $layout.containerHeight.value : $q.screen.height));
    function isVisible() {
      return props4.reverse === true ? scrollHeight.value - $layout.scroll.value.position > props4.scrollOffset : $layout.scroll.value.position > props4.scrollOffset;
    }
    const showing = ref$1(isVisible());
    function updateVisibility() {
      const newVal = isVisible();
      if (showing.value !== newVal) {
        showing.value = newVal;
      }
    }
    function updateReverse() {
      if (props4.reverse === true) {
        if (heightWatcher === void 0) {
          heightWatcher = watch(scrollHeight, updateVisibility);
        }
      } else {
        cleanup();
      }
    }
    watch($layout.scroll, updateVisibility);
    watch(() => props4.reverse, updateReverse);
    function cleanup() {
      if (heightWatcher !== void 0) {
        heightWatcher();
        heightWatcher = void 0;
      }
    }
    function onClick(e2) {
      const target2 = getScrollTarget(
        $layout.isContainer.value === true ? rootRef.value : $layout.rootRef.value
      );
      setVerticalScrollPosition(
        target2,
        props4.reverse === true ? $layout.height.value : 0,
        props4.duration
      );
      emit("click", e2);
    }
    function getContent() {
      return showing.value === true ? h("div", {
        ref: rootRef,
        class: "q-page-scroller",
        onClick
      }, getStickyContent(slots)) : null;
    }
    updateReverse();
    onBeforeUnmount(cleanup);
    return () => h(
      Transition,
      { name: "q-transition--fade" },
      getContent
    );
  }
});
createComponent({
  name: "QPageSticky",
  props: usePageStickyProps,
  setup(_, { slots }) {
    const { getStickyContent } = use_page_sticky_default();
    return () => getStickyContent(slots);
  }
});
function getBool(val, otherwise) {
  return [true, false].includes(val) ? val : otherwise;
}
createComponent({
  name: "QPagination",
  props: {
    ...useDarkProps,
    modelValue: {
      type: Number,
      required: true
    },
    min: {
      type: [Number, String],
      default: 1
    },
    max: {
      type: [Number, String],
      required: true
    },
    maxPages: {
      type: [Number, String],
      default: 0,
      validator: (v) => (typeof v === "string" ? parseInt(v, 10) : v) >= 0
    },
    inputStyle: [Array, String, Object],
    inputClass: [Array, String, Object],
    size: String,
    disable: Boolean,
    input: Boolean,
    iconPrev: String,
    iconNext: String,
    iconFirst: String,
    iconLast: String,
    toFn: Function,
    boundaryLinks: {
      type: Boolean,
      default: null
    },
    boundaryNumbers: {
      type: Boolean,
      default: null
    },
    directionLinks: {
      type: Boolean,
      default: null
    },
    ellipses: {
      type: Boolean,
      default: null
    },
    ripple: {
      type: [Boolean, Object],
      default: null
    },
    round: Boolean,
    rounded: Boolean,
    flat: Boolean,
    outline: Boolean,
    unelevated: Boolean,
    push: Boolean,
    glossy: Boolean,
    color: {
      type: String,
      default: "primary"
    },
    textColor: String,
    activeDesign: {
      type: String,
      default: "",
      values: (v) => v === "" || btnDesignOptions.includes(v)
    },
    activeColor: String,
    activeTextColor: String,
    gutter: String,
    padding: {
      type: String,
      default: "3px 2px"
    }
  },
  emits: ["update:modelValue"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const minProp = computed(() => parseInt(props4.min, 10));
    const maxProp = computed(() => parseInt(props4.max, 10));
    const maxPagesProp = computed(() => parseInt(props4.maxPages, 10));
    const inputPlaceholder = computed(() => model.value + " / " + maxProp.value);
    const boundaryLinksProp = computed(() => getBool(props4.boundaryLinks, props4.input));
    const boundaryNumbersProp = computed(() => getBool(props4.boundaryNumbers, !props4.input));
    const directionLinksProp = computed(() => getBool(props4.directionLinks, props4.input));
    const ellipsesProp = computed(() => getBool(props4.ellipses, !props4.input));
    const newPage = ref$1(null);
    const model = computed({
      get: () => props4.modelValue,
      set: (val) => {
        val = parseInt(val, 10);
        if (props4.disable || isNaN(val)) {
          return;
        }
        const value2 = between(val, minProp.value, maxProp.value);
        if (props4.modelValue !== value2) {
          emit("update:modelValue", value2);
        }
      }
    });
    watch(() => `${minProp.value}|${maxProp.value}`, () => {
      model.value = props4.modelValue;
    });
    const classes = computed(
      () => "q-pagination row no-wrap items-center" + (props4.disable === true ? " disabled" : "")
    );
    const gutterProp = computed(() => props4.gutter in btnPadding ? `${btnPadding[props4.gutter]}px` : props4.gutter || null);
    const gutterStyle = computed(() => gutterProp.value !== null ? `--q-pagination-gutter-parent:-${gutterProp.value};--q-pagination-gutter-child:${gutterProp.value}` : null);
    const icons = computed(() => {
      const ico = [
        props4.iconFirst || $q.iconSet.pagination.first,
        props4.iconPrev || $q.iconSet.pagination.prev,
        props4.iconNext || $q.iconSet.pagination.next,
        props4.iconLast || $q.iconSet.pagination.last
      ];
      return $q.lang.rtl === true ? ico.reverse() : ico;
    });
    const attrs = computed(() => ({
      "aria-disabled": props4.disable === true ? "true" : "false",
      role: "navigation"
    }));
    const btnDesignProp = computed(() => getBtnDesign(props4, "flat"));
    const btnProps = computed(() => ({
      [btnDesignProp.value]: true,
      round: props4.round,
      rounded: props4.rounded,
      padding: props4.padding,
      color: props4.color,
      textColor: props4.textColor,
      size: props4.size,
      ripple: props4.ripple !== null ? props4.ripple : true
    }));
    const btnActiveDesignProp = computed(() => {
      const acc = { [btnDesignProp.value]: false };
      if (props4.activeDesign !== "") {
        acc[props4.activeDesign] = true;
      }
      return acc;
    });
    const activeBtnProps = computed(() => ({
      ...btnActiveDesignProp.value,
      color: props4.activeColor || props4.color,
      textColor: props4.activeTextColor || props4.textColor
    }));
    const btnConfig = computed(() => {
      let maxPages = Math.max(
        maxPagesProp.value,
        1 + (ellipsesProp.value ? 2 : 0) + (boundaryNumbersProp.value ? 2 : 0)
      );
      const acc = {
        pgFrom: minProp.value,
        pgTo: maxProp.value,
        ellipsesStart: false,
        ellipsesEnd: false,
        boundaryStart: false,
        boundaryEnd: false,
        marginalStyle: {
          minWidth: `${Math.max(2, String(maxProp.value).length)}em`
        }
      };
      if (maxPagesProp.value && maxPages < maxProp.value - minProp.value + 1) {
        maxPages = 1 + Math.floor(maxPages / 2) * 2;
        acc.pgFrom = Math.max(minProp.value, Math.min(maxProp.value - maxPages + 1, props4.modelValue - Math.floor(maxPages / 2)));
        acc.pgTo = Math.min(maxProp.value, acc.pgFrom + maxPages - 1);
        if (boundaryNumbersProp.value) {
          acc.boundaryStart = true;
          acc.pgFrom++;
        }
        if (ellipsesProp.value && acc.pgFrom > minProp.value + (boundaryNumbersProp.value ? 1 : 0)) {
          acc.ellipsesStart = true;
          acc.pgFrom++;
        }
        if (boundaryNumbersProp.value) {
          acc.boundaryEnd = true;
          acc.pgTo--;
        }
        if (ellipsesProp.value && acc.pgTo < maxProp.value - (boundaryNumbersProp.value ? 1 : 0)) {
          acc.ellipsesEnd = true;
          acc.pgTo--;
        }
      }
      return acc;
    });
    function set2(value2) {
      model.value = value2;
    }
    function setByOffset(offset2) {
      model.value = model.value + offset2;
    }
    const inputEvents = computed(() => {
      function updateModel2() {
        model.value = newPage.value;
        newPage.value = null;
      }
      return {
        "onUpdate:modelValue": (val) => {
          newPage.value = val;
        },
        onKeyup: (e2) => {
          isKeyCode(e2, 13) === true && updateModel2();
        },
        onBlur: updateModel2
      };
    });
    function getBtn2(cfg, page, active) {
      const data = {
        "aria-label": page,
        "aria-current": "false",
        ...btnProps.value,
        ...cfg
      };
      if (active === true) {
        Object.assign(data, {
          "aria-current": "true",
          ...activeBtnProps.value
        });
      }
      if (page !== void 0) {
        if (props4.toFn !== void 0) {
          data.to = props4.toFn(page);
        } else {
          data.onClick = () => {
            set2(page);
          };
        }
      }
      return h(QBtn_default, data);
    }
    Object.assign(proxy, { set: set2, setByOffset });
    return () => {
      const contentStart = [];
      const contentEnd = [];
      let contentMiddle;
      if (boundaryLinksProp.value === true) {
        contentStart.push(
          getBtn2({
            key: "bls",
            disable: props4.disable || props4.modelValue <= minProp.value,
            icon: icons.value[0]
          }, minProp.value)
        );
        contentEnd.unshift(
          getBtn2({
            key: "ble",
            disable: props4.disable || props4.modelValue >= maxProp.value,
            icon: icons.value[3]
          }, maxProp.value)
        );
      }
      if (directionLinksProp.value === true) {
        contentStart.push(
          getBtn2({
            key: "bdp",
            disable: props4.disable || props4.modelValue <= minProp.value,
            icon: icons.value[1]
          }, props4.modelValue - 1)
        );
        contentEnd.unshift(
          getBtn2({
            key: "bdn",
            disable: props4.disable || props4.modelValue >= maxProp.value,
            icon: icons.value[2]
          }, props4.modelValue + 1)
        );
      }
      if (props4.input !== true) {
        contentMiddle = [];
        const { pgFrom, pgTo, marginalStyle: style2 } = btnConfig.value;
        if (btnConfig.value.boundaryStart === true) {
          const active = minProp.value === props4.modelValue;
          contentStart.push(
            getBtn2({
              key: "bns",
              style: style2,
              disable: props4.disable,
              label: minProp.value
            }, minProp.value, active)
          );
        }
        if (btnConfig.value.boundaryEnd === true) {
          const active = maxProp.value === props4.modelValue;
          contentEnd.unshift(
            getBtn2({
              key: "bne",
              style: style2,
              disable: props4.disable,
              label: maxProp.value
            }, maxProp.value, active)
          );
        }
        if (btnConfig.value.ellipsesStart === true) {
          contentStart.push(
            getBtn2({
              key: "bes",
              style: style2,
              disable: props4.disable,
              label: "…",
              ripple: false
            }, pgFrom - 1)
          );
        }
        if (btnConfig.value.ellipsesEnd === true) {
          contentEnd.unshift(
            getBtn2({
              key: "bee",
              style: style2,
              disable: props4.disable,
              label: "…",
              ripple: false
            }, pgTo + 1)
          );
        }
        for (let i2 = pgFrom; i2 <= pgTo; i2++) {
          contentMiddle.push(
            getBtn2({
              key: `bpg${i2}`,
              style: style2,
              disable: props4.disable,
              label: i2
            }, i2, i2 === props4.modelValue)
          );
        }
      }
      return h("div", {
        class: classes.value,
        ...attrs.value
      }, [
        h("div", {
          class: "q-pagination__content row no-wrap items-center",
          style: gutterStyle.value
        }, [
          ...contentStart,
          props4.input === true ? h(QInput_default, {
            class: "inline",
            style: { width: `${inputPlaceholder.value.length / 1.5}em` },
            type: "number",
            dense: true,
            value: newPage.value,
            disable: props4.disable,
            dark: isDark.value,
            borderless: true,
            inputClass: props4.inputClass,
            inputStyle: props4.inputStyle,
            placeholder: inputPlaceholder.value,
            min: minProp.value,
            max: maxProp.value,
            ...inputEvents.value
          }) : h("div", {
            class: "q-pagination__middle row justify-center"
          }, contentMiddle),
          ...contentEnd
        ])
      ]);
    };
  }
});
function frame_debounce_default(fn) {
  let wait2 = false, frame, callArgs;
  function debounced() {
    callArgs = arguments;
    if (wait2 === true) return;
    wait2 = true;
    frame = window.requestAnimationFrame(() => {
      fn.apply(this, callArgs);
      callArgs = void 0;
      wait2 = false;
    });
  }
  debounced.cancel = () => {
    window.cancelAnimationFrame(frame);
    wait2 = false;
  };
  return debounced;
}
var { passive: passive4 } = listenOpts;
createComponent({
  name: "QParallax",
  props: {
    src: String,
    height: {
      type: Number,
      default: 500
    },
    speed: {
      type: Number,
      default: 1,
      validator: (v) => v >= 0 && v <= 1
    },
    scrollTarget: scrollTargetProp,
    onScroll: Function
  },
  setup(props4, { slots, emit }) {
    const percentScrolled = ref$1(0);
    const rootRef = ref$1(null);
    const mediaParentRef = ref$1(null);
    const mediaRef = ref$1(null);
    let isWorking, mediaEl, mediaHeight, resizeHandler, observer, localScrollTarget;
    watch(() => props4.height, () => {
      isWorking === true && updatePos();
    });
    watch(() => props4.scrollTarget, () => {
      if (isWorking === true) {
        stop2();
        start();
      }
    });
    let update6 = (percentage) => {
      percentScrolled.value = percentage;
      props4.onScroll !== void 0 && emit("scroll", percentage);
    };
    function updatePos() {
      let containerTop, containerHeight, containerBottom;
      if (localScrollTarget === window) {
        containerTop = 0;
        containerBottom = containerHeight = window.innerHeight;
      } else {
        containerTop = offset(localScrollTarget).top;
        containerHeight = height(localScrollTarget);
        containerBottom = containerTop + containerHeight;
      }
      const top = offset(rootRef.value).top;
      const bottom = top + props4.height;
      if (observer !== void 0 || bottom > containerTop && top < containerBottom) {
        const percent = (containerBottom - top) / (props4.height + containerHeight);
        setPos((mediaHeight - props4.height) * percent * props4.speed);
        update6(percent);
      }
    }
    let setPos = (offset2) => {
      mediaEl.style.transform = `translate3d(-50%,${Math.round(offset2)}px,0)`;
    };
    function onResize() {
      mediaHeight = mediaEl.naturalHeight || mediaEl.videoHeight || height(mediaEl);
      isWorking === true && updatePos();
    }
    function start() {
      isWorking = true;
      localScrollTarget = getScrollTarget(rootRef.value, props4.scrollTarget);
      localScrollTarget.addEventListener("scroll", updatePos, passive4);
      window.addEventListener("resize", resizeHandler, passive4);
      updatePos();
    }
    function stop2() {
      if (isWorking === true) {
        isWorking = false;
        localScrollTarget.removeEventListener("scroll", updatePos, passive4);
        window.removeEventListener("resize", resizeHandler, passive4);
        localScrollTarget = void 0;
        setPos.cancel();
        update6.cancel();
        resizeHandler.cancel();
      }
    }
    onMounted(() => {
      setPos = frame_debounce_default(setPos);
      update6 = frame_debounce_default(update6);
      resizeHandler = frame_debounce_default(onResize);
      mediaEl = slots.media !== void 0 ? mediaParentRef.value.children[0] : mediaRef.value;
      mediaEl.onload = mediaEl.onloadstart = mediaEl.loadedmetadata = onResize;
      onResize();
      mediaEl.style.display = "initial";
      if (window.IntersectionObserver !== void 0) {
        observer = new IntersectionObserver((entries) => {
          const fn = entries[0].isIntersecting === true ? start : stop2;
          fn();
        });
        observer.observe(rootRef.value);
      } else {
        start();
      }
    });
    onBeforeUnmount(() => {
      stop2();
      observer !== void 0 && observer.disconnect();
      mediaEl.onload = mediaEl.onloadstart = mediaEl.loadedmetadata = null;
    });
    return () => {
      return h("div", {
        ref: rootRef,
        class: "q-parallax",
        style: { height: `${props4.height}px` }
      }, [
        h("div", {
          ref: mediaParentRef,
          class: "q-parallax__media absolute-full"
        }, slots.media !== void 0 ? slots.media() : [
          h("img", {
            ref: mediaRef,
            src: props4.src
          })
        ]),
        h(
          "div",
          { class: "q-parallax__content absolute-full column flex-center" },
          slots.content !== void 0 ? slots.content({ percentScrolled: percentScrolled.value }) : hSlot(slots.default)
        )
      ]);
    };
  }
});
function cloneDeep(data, hash = /* @__PURE__ */ new WeakMap()) {
  if (Object(data) !== data) return data;
  if (hash.has(data)) return hash.get(data);
  const result = data instanceof Date ? new Date(data) : data instanceof RegExp ? new RegExp(data.source, data.flags) : data instanceof Set ? /* @__PURE__ */ new Set() : data instanceof Map ? /* @__PURE__ */ new Map() : typeof data.constructor !== "function" ? /* @__PURE__ */ Object.create(null) : data.prototype !== void 0 && typeof data.prototype.constructor === "function" ? data : new data.constructor();
  if (typeof data.constructor === "function" && typeof data.valueOf === "function") {
    const val = data.valueOf();
    if (Object(val) !== val) {
      const result2 = new data.constructor(val);
      hash.set(data, result2);
      return result2;
    }
  }
  hash.set(data, result);
  if (data instanceof Set) {
    data.forEach((val) => {
      result.add(cloneDeep(val, hash));
    });
  } else if (data instanceof Map) {
    data.forEach((val, key) => {
      result.set(key, cloneDeep(val, hash));
    });
  }
  return Object.assign(
    result,
    ...Object.keys(data).map((key) => ({ [key]: cloneDeep(data[key], hash) }))
  );
}
createComponent({
  name: "QPopupEdit",
  props: {
    modelValue: {
      required: true
    },
    title: String,
    buttons: Boolean,
    labelSet: String,
    labelCancel: String,
    color: {
      type: String,
      default: "primary"
    },
    validate: {
      type: Function,
      default: () => true
    },
    autoSave: Boolean,
    /* menu props overrides */
    cover: {
      type: Boolean,
      default: true
    },
    /* end of menu props */
    disable: Boolean
  },
  emits: [
    "update:modelValue",
    "save",
    "cancel",
    "beforeShow",
    "show",
    "beforeHide",
    "hide"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const menuRef = ref$1(null);
    const initialValue = ref$1("");
    const currentModel = ref$1("");
    let validated = false;
    const scope = computed(() => {
      return injectProp({
        initialValue: initialValue.value,
        validate: props4.validate,
        set: set2,
        cancel,
        updatePosition
      }, "value", () => currentModel.value, (val) => {
        currentModel.value = val;
      });
    });
    function set2() {
      if (props4.validate(currentModel.value) === false) {
        return;
      }
      if (hasModelChanged() === true) {
        emit("save", currentModel.value, initialValue.value);
        emit("update:modelValue", currentModel.value);
      }
      closeMenu();
    }
    function cancel() {
      if (hasModelChanged() === true) {
        emit("cancel", currentModel.value, initialValue.value);
      }
      closeMenu();
    }
    function updatePosition() {
      nextTick(() => {
        menuRef.value.updatePosition();
      });
    }
    function hasModelChanged() {
      return isDeepEqual(currentModel.value, initialValue.value) === false;
    }
    function closeMenu() {
      validated = true;
      menuRef.value.hide();
    }
    function onBeforeShow() {
      validated = false;
      initialValue.value = cloneDeep(props4.modelValue);
      currentModel.value = cloneDeep(props4.modelValue);
      emit("beforeShow");
    }
    function onShow() {
      emit("show");
    }
    function onBeforeHide() {
      if (validated === false && hasModelChanged() === true) {
        if (props4.autoSave === true && props4.validate(currentModel.value) === true) {
          emit("save", currentModel.value, initialValue.value);
          emit("update:modelValue", currentModel.value);
        } else {
          emit("cancel", currentModel.value, initialValue.value);
        }
      }
      emit("beforeHide");
    }
    function onHide() {
      emit("hide");
    }
    function getContent() {
      const child = slots.default !== void 0 ? [].concat(slots.default(scope.value)) : [];
      props4.title && child.unshift(
        h("div", { class: "q-dialog__title q-mt-sm q-mb-sm" }, props4.title)
      );
      props4.buttons === true && child.push(
        h("div", { class: "q-popup-edit__buttons row justify-center no-wrap" }, [
          h(QBtn_default, {
            flat: true,
            color: props4.color,
            label: props4.labelCancel || $q.lang.label.cancel,
            onClick: cancel
          }),
          h(QBtn_default, {
            flat: true,
            color: props4.color,
            label: props4.labelSet || $q.lang.label.set,
            onClick: set2
          })
        ])
      );
      return child;
    }
    Object.assign(proxy, {
      set: set2,
      cancel,
      show(e2) {
        menuRef.value !== null && menuRef.value.show(e2);
      },
      hide(e2) {
        menuRef.value !== null && menuRef.value.hide(e2);
      },
      updatePosition
    });
    return () => {
      if (props4.disable === true) return;
      return h(QMenu_default, {
        ref: menuRef,
        class: "q-popup-edit",
        cover: props4.cover,
        onBeforeShow,
        onShow,
        onBeforeHide,
        onHide,
        onEscapeKey: cancel
      }, getContent);
    };
  }
});
var QPopupProxy_default = createComponent({
  name: "QPopupProxy",
  props: {
    ...useAnchorProps,
    breakpoint: {
      type: [String, Number],
      default: 450
    }
  },
  emits: ["show", "hide"],
  setup(props4, { slots, emit, attrs }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const showing = ref$1(false);
    const popupRef = ref$1(null);
    const breakpoint = computed(() => parseInt(props4.breakpoint, 10));
    const { canShow } = use_anchor_default({ showing });
    function getType() {
      return $q.screen.width < breakpoint.value || $q.screen.height < breakpoint.value ? "dialog" : "menu";
    }
    const type2 = ref$1(getType());
    const popupProps = computed(
      () => type2.value === "menu" ? { maxHeight: "99vh" } : {}
    );
    watch(() => getType(), (val) => {
      if (showing.value !== true) {
        type2.value = val;
      }
    });
    function onShow(evt) {
      showing.value = true;
      emit("show", evt);
    }
    function onHide(evt) {
      showing.value = false;
      type2.value = getType();
      emit("hide", evt);
    }
    Object.assign(proxy, {
      show(evt) {
        canShow(evt) === true && popupRef.value.show(evt);
      },
      hide(evt) {
        popupRef.value.hide(evt);
      },
      toggle(evt) {
        popupRef.value.toggle(evt);
      }
    });
    injectProp(proxy, "currentComponent", () => ({
      type: type2.value,
      ref: popupRef.value
    }));
    return () => {
      const data = {
        ref: popupRef,
        ...popupProps.value,
        ...attrs,
        onShow,
        onHide
      };
      let component;
      if (type2.value === "dialog") {
        component = QDialog_default;
      } else {
        component = QMenu_default;
        Object.assign(data, {
          target: props4.target,
          contextMenu: props4.contextMenu,
          noParentEvent: true,
          separateClosePopup: true
        });
      }
      return h(component, data, slots.default);
    };
  }
});
var defaultSizes3 = {
  xs: 2,
  sm: 4,
  md: 6,
  lg: 10,
  xl: 14
};
function width2(val, reverse, $q) {
  return {
    transform: reverse === true ? `translateX(${$q.lang.rtl === true ? "-" : ""}100%) scale3d(${-val},1,1)` : `scale3d(${val},1,1)`
  };
}
var QLinearProgress_default = createComponent({
  name: "QLinearProgress",
  props: {
    ...useDarkProps,
    ...useSizeProps,
    value: {
      type: Number,
      default: 0
    },
    buffer: Number,
    color: String,
    trackColor: String,
    reverse: Boolean,
    stripe: Boolean,
    indeterminate: Boolean,
    query: Boolean,
    rounded: Boolean,
    animationSpeed: {
      type: [String, Number],
      default: 2100
    },
    instantFeedback: Boolean
  },
  setup(props4, { slots }) {
    const { proxy } = getCurrentInstance();
    const isDark = use_dark_default(props4, proxy.$q);
    const sizeStyle = use_size_default(props4, defaultSizes3);
    const motion = computed(() => props4.indeterminate === true || props4.query === true);
    const widthReverse = computed(() => props4.reverse !== props4.query);
    const style2 = computed(() => ({
      ...sizeStyle.value !== null ? sizeStyle.value : {},
      "--q-linear-progress-speed": `${props4.animationSpeed}ms`
    }));
    const classes = computed(
      () => "q-linear-progress" + (props4.color !== void 0 ? ` text-${props4.color}` : "") + (props4.reverse === true || props4.query === true ? " q-linear-progress--reverse" : "") + (props4.rounded === true ? " rounded-borders" : "")
    );
    const trackStyle = computed(() => width2(props4.buffer !== void 0 ? props4.buffer : 1, widthReverse.value, proxy.$q));
    const transitionSuffix = computed(() => `with${props4.instantFeedback === true ? "out" : ""}-transition`);
    const trackClass = computed(
      () => `q-linear-progress__track absolute-full q-linear-progress__track--${transitionSuffix.value} q-linear-progress__track--${isDark.value === true ? "dark" : "light"}` + (props4.trackColor !== void 0 ? ` bg-${props4.trackColor}` : "")
    );
    const modelStyle = computed(() => width2(motion.value === true ? 1 : props4.value, widthReverse.value, proxy.$q));
    const modelClass = computed(
      () => `q-linear-progress__model absolute-full q-linear-progress__model--${transitionSuffix.value} q-linear-progress__model--${motion.value === true ? "in" : ""}determinate`
    );
    const stripeStyle = computed(() => ({ width: `${props4.value * 100}%` }));
    const stripeClass = computed(
      () => `q-linear-progress__stripe absolute-${props4.reverse === true ? "right" : "left"} q-linear-progress__stripe--${transitionSuffix.value}`
    );
    return () => {
      const child = [
        h("div", {
          class: trackClass.value,
          style: trackStyle.value
        }),
        h("div", {
          class: modelClass.value,
          style: modelStyle.value
        })
      ];
      props4.stripe === true && motion.value === false && child.push(
        h("div", {
          class: stripeClass.value,
          style: stripeStyle.value
        })
      );
      return h("div", {
        class: classes.value,
        style: style2.value,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 1,
        "aria-valuenow": props4.indeterminate === true ? void 0 : props4.value
      }, hMergeSlot(slots.default, child));
    };
  }
});
var PULLER_HEIGHT = 40;
var OFFSET_TOP = 20;
createComponent({
  name: "QPullToRefresh",
  props: {
    color: String,
    bgColor: String,
    icon: String,
    noMouse: Boolean,
    disable: Boolean,
    scrollTarget: scrollTargetProp
  },
  emits: ["refresh"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const state2 = ref$1("pull");
    const pullRatio = ref$1(0);
    const pulling = ref$1(false);
    const pullPosition = ref$1(-PULLER_HEIGHT);
    const animating = ref$1(false);
    const positionCSS = ref$1({});
    const style2 = computed(() => ({
      opacity: pullRatio.value,
      transform: `translateY(${pullPosition.value}px) rotate(${pullRatio.value * 360}deg)`
    }));
    const classes = computed(
      () => "q-pull-to-refresh__puller row flex-center" + (animating.value === true ? " q-pull-to-refresh__puller--animating" : "") + (props4.bgColor !== void 0 ? ` bg-${props4.bgColor}` : "")
    );
    function pull(event) {
      if (event.isFinal === true) {
        if (pulling.value === true) {
          pulling.value = false;
          if (state2.value === "pulled") {
            state2.value = "refreshing";
            animateTo({ pos: OFFSET_TOP });
            trigger3();
          } else if (state2.value === "pull") {
            animateTo({ pos: -PULLER_HEIGHT, ratio: 0 });
          }
        }
        return;
      }
      if (animating.value === true || state2.value === "refreshing") {
        return false;
      }
      if (event.isFirst === true) {
        if (getVerticalScrollPosition(localScrollTarget) !== 0 || event.direction !== "down") {
          if (pulling.value === true) {
            pulling.value = false;
            state2.value = "pull";
            animateTo({ pos: -PULLER_HEIGHT, ratio: 0 });
          }
          return false;
        }
        pulling.value = true;
        const { top, left } = $el.getBoundingClientRect();
        positionCSS.value = {
          top: top + "px",
          left: left + "px",
          width: window.getComputedStyle($el).getPropertyValue("width")
        };
      }
      prevent(event.evt);
      const distance = Math.min(140, Math.max(0, event.distance.y));
      pullPosition.value = distance - PULLER_HEIGHT;
      pullRatio.value = between(distance / (OFFSET_TOP + PULLER_HEIGHT), 0, 1);
      const newState = pullPosition.value > OFFSET_TOP ? "pulled" : "pull";
      if (state2.value !== newState) {
        state2.value = newState;
      }
    }
    const directives2 = computed(() => {
      const modifiers = { down: true };
      if (props4.noMouse !== true) {
        modifiers.mouse = true;
      }
      return [[
        TouchPan_default,
        pull,
        void 0,
        modifiers
      ]];
    });
    const contentClass = computed(
      () => `q-pull-to-refresh__content${pulling.value === true ? " no-pointer-events" : ""}`
    );
    function trigger3() {
      emit("refresh", () => {
        animateTo({ pos: -PULLER_HEIGHT, ratio: 0 }, () => {
          state2.value = "pull";
        });
      });
    }
    let $el, localScrollTarget, timer2 = null;
    function animateTo({ pos, ratio }, done) {
      animating.value = true;
      pullPosition.value = pos;
      if (ratio !== void 0) {
        pullRatio.value = ratio;
      }
      timer2 !== null && clearTimeout(timer2);
      timer2 = setTimeout(() => {
        timer2 = null;
        animating.value = false;
        done && done();
      }, 300);
    }
    function updateScrollTarget() {
      localScrollTarget = getScrollTarget($el, props4.scrollTarget);
    }
    watch(() => props4.scrollTarget, updateScrollTarget);
    onMounted(() => {
      $el = proxy.$el;
      updateScrollTarget();
    });
    onBeforeUnmount(() => {
      timer2 !== null && clearTimeout(timer2);
    });
    Object.assign(proxy, { trigger: trigger3, updateScrollTarget });
    return () => {
      const child = [
        h("div", { class: contentClass.value }, hSlot(slots.default)),
        h("div", {
          class: "q-pull-to-refresh__puller-container fixed row flex-center no-pointer-events z-top",
          style: positionCSS.value
        }, [
          h("div", {
            class: classes.value,
            style: style2.value
          }, [
            state2.value !== "refreshing" ? h(QIcon_default, {
              name: props4.icon || $q.iconSet.pullToRefresh.icon,
              color: props4.color,
              size: "32px"
            }) : h(QSpinner_default, {
              size: "24px",
              color: props4.color
            })
          ])
        ])
      ];
      return hDir(
        "div",
        { class: "q-pull-to-refresh" },
        child,
        "main",
        props4.disable === false,
        () => directives2.value
      );
    };
  }
});
var dragType = {
  MIN: 0,
  RANGE: 1,
  MAX: 2
};
var QRange_default = createComponent({
  name: "QRange",
  props: {
    ...useSliderProps,
    modelValue: {
      type: Object,
      default: () => ({ min: null, max: null }),
      validator: (v) => "min" in v && "max" in v
    },
    dragRange: Boolean,
    dragOnlyRange: Boolean,
    leftLabelColor: String,
    leftLabelTextColor: String,
    rightLabelColor: String,
    rightLabelTextColor: String,
    leftLabelValue: [String, Number],
    rightLabelValue: [String, Number],
    leftThumbColor: String,
    rightThumbColor: String
  },
  emits: useSliderEmits,
  setup(props4, { emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const { state: state2, methods } = use_slider_default({
      updateValue: updateValue2,
      updatePosition,
      getDragging,
      formAttrs: computed(() => ({
        type: "hidden",
        name: props4.name,
        value: `${props4.modelValue.min}|${props4.modelValue.max}`
      }))
    });
    const rootRef = ref$1(null);
    const curMinRatio = ref$1(0);
    const curMaxRatio = ref$1(0);
    const model = ref$1({ min: 0, max: 0 });
    function normalizeModel() {
      model.value.min = props4.modelValue.min === null ? state2.innerMin.value : between(props4.modelValue.min, state2.innerMin.value, state2.innerMax.value);
      model.value.max = props4.modelValue.max === null ? state2.innerMax.value : between(props4.modelValue.max, state2.innerMin.value, state2.innerMax.value);
    }
    watch(
      () => `${props4.modelValue.min}|${props4.modelValue.max}|${state2.innerMin.value}|${state2.innerMax.value}`,
      normalizeModel
    );
    normalizeModel();
    const modelMinRatio = computed(() => methods.convertModelToRatio(model.value.min));
    const modelMaxRatio = computed(() => methods.convertModelToRatio(model.value.max));
    const ratioMin = computed(() => state2.active.value === true ? curMinRatio.value : modelMinRatio.value);
    const ratioMax = computed(() => state2.active.value === true ? curMaxRatio.value : modelMaxRatio.value);
    const selectionBarStyle = computed(() => {
      const acc = {
        [state2.positionProp.value]: `${100 * ratioMin.value}%`,
        [state2.sizeProp.value]: `${100 * (ratioMax.value - ratioMin.value)}%`
      };
      if (props4.selectionImg !== void 0) {
        acc.backgroundImage = `url(${props4.selectionImg}) !important`;
      }
      return acc;
    });
    const trackContainerEvents = computed(() => {
      if (state2.editable.value !== true) {
        return {};
      }
      if ($q.platform.is.mobile === true) {
        return { onClick: methods.onMobileClick };
      }
      const evt = { onMousedown: methods.onActivate };
      if (props4.dragRange === true || props4.dragOnlyRange === true) {
        Object.assign(evt, {
          onFocus: () => {
            state2.focus.value = "both";
          },
          onBlur: methods.onBlur,
          onKeydown: onKeydown2,
          onKeyup: methods.onKeyup
        });
      }
      return evt;
    });
    function getEvents(side) {
      return $q.platform.is.mobile !== true && state2.editable.value === true && props4.dragOnlyRange !== true ? {
        onFocus: () => {
          state2.focus.value = side;
        },
        onBlur: methods.onBlur,
        onKeydown: onKeydown2,
        onKeyup: methods.onKeyup
      } : {};
    }
    const thumbTabindex = computed(() => props4.dragOnlyRange !== true ? state2.tabindex.value : null);
    const trackContainerTabindex = computed(() => $q.platform.is.mobile !== true && (props4.dragRange || props4.dragOnlyRange === true) ? state2.tabindex.value : null);
    const minThumbRef = ref$1(null);
    const minEvents = computed(() => getEvents("min"));
    const getMinThumb = methods.getThumbRenderFn({
      focusValue: "min",
      getNodeData: () => ({
        ref: minThumbRef,
        key: "tmin",
        ...minEvents.value,
        tabindex: thumbTabindex.value
      }),
      ratio: ratioMin,
      label: computed(() => props4.leftLabelValue !== void 0 ? props4.leftLabelValue : model.value.min),
      thumbColor: computed(() => props4.leftThumbColor || props4.thumbColor || props4.color),
      labelColor: computed(() => props4.leftLabelColor || props4.labelColor),
      labelTextColor: computed(() => props4.leftLabelTextColor || props4.labelTextColor)
    });
    const maxEvents = computed(() => getEvents("max"));
    const getMaxThumb = methods.getThumbRenderFn({
      focusValue: "max",
      getNodeData: () => ({
        ...maxEvents.value,
        key: "tmax",
        tabindex: thumbTabindex.value
      }),
      ratio: ratioMax,
      label: computed(() => props4.rightLabelValue !== void 0 ? props4.rightLabelValue : model.value.max),
      thumbColor: computed(() => props4.rightThumbColor || props4.thumbColor || props4.color),
      labelColor: computed(() => props4.rightLabelColor || props4.labelColor),
      labelTextColor: computed(() => props4.rightLabelTextColor || props4.labelTextColor)
    });
    function updateValue2(change) {
      if (model.value.min !== props4.modelValue.min || model.value.max !== props4.modelValue.max) {
        emit("update:modelValue", { ...model.value });
      }
      change === true && emit("change", { ...model.value });
    }
    function getDragging(event) {
      const { left, top, width: width3, height: height2 } = rootRef.value.getBoundingClientRect(), sensitivity = props4.dragOnlyRange === true ? 0 : props4.vertical === true ? minThumbRef.value.offsetHeight / (2 * height2) : minThumbRef.value.offsetWidth / (2 * width3);
      const dragging = {
        left,
        top,
        width: width3,
        height: height2,
        valueMin: model.value.min,
        valueMax: model.value.max,
        ratioMin: modelMinRatio.value,
        ratioMax: modelMaxRatio.value
      };
      const ratio = methods.getDraggingRatio(event, dragging);
      if (props4.dragOnlyRange !== true && ratio < dragging.ratioMin + sensitivity) {
        dragging.type = dragType.MIN;
      } else if (props4.dragOnlyRange === true || ratio < dragging.ratioMax - sensitivity) {
        if (props4.dragRange === true || props4.dragOnlyRange === true) {
          dragging.type = dragType.RANGE;
          Object.assign(dragging, {
            offsetRatio: ratio,
            offsetModel: methods.convertRatioToModel(ratio),
            rangeValue: dragging.valueMax - dragging.valueMin,
            rangeRatio: dragging.ratioMax - dragging.ratioMin
          });
        } else {
          dragging.type = dragging.ratioMax - ratio < ratio - dragging.ratioMin ? dragType.MAX : dragType.MIN;
        }
      } else {
        dragging.type = dragType.MAX;
      }
      return dragging;
    }
    function updatePosition(event, dragging = state2.dragging.value) {
      let pos;
      const ratio = methods.getDraggingRatio(event, dragging);
      const localModel = methods.convertRatioToModel(ratio);
      switch (dragging.type) {
        case dragType.MIN:
          if (ratio <= dragging.ratioMax) {
            pos = {
              minR: ratio,
              maxR: dragging.ratioMax,
              min: localModel,
              max: dragging.valueMax
            };
            state2.focus.value = "min";
          } else {
            pos = {
              minR: dragging.ratioMax,
              maxR: ratio,
              min: dragging.valueMax,
              max: localModel
            };
            state2.focus.value = "max";
          }
          break;
        case dragType.MAX:
          if (ratio >= dragging.ratioMin) {
            pos = {
              minR: dragging.ratioMin,
              maxR: ratio,
              min: dragging.valueMin,
              max: localModel
            };
            state2.focus.value = "max";
          } else {
            pos = {
              minR: ratio,
              maxR: dragging.ratioMin,
              min: localModel,
              max: dragging.valueMin
            };
            state2.focus.value = "min";
          }
          break;
        case dragType.RANGE:
          const ratioDelta = ratio - dragging.offsetRatio, minR = between(dragging.ratioMin + ratioDelta, state2.innerMinRatio.value, state2.innerMaxRatio.value - dragging.rangeRatio), modelDelta = localModel - dragging.offsetModel, min2 = between(dragging.valueMin + modelDelta, state2.innerMin.value, state2.innerMax.value - dragging.rangeValue);
          pos = {
            minR,
            maxR: minR + dragging.rangeRatio,
            min: state2.roundValueFn.value(min2),
            max: state2.roundValueFn.value(min2 + dragging.rangeValue)
          };
          state2.focus.value = "both";
          break;
      }
      model.value = model.value.min === null || model.value.max === null ? { min: pos.min || props4.min, max: pos.max || props4.max } : { min: pos.min, max: pos.max };
      if (props4.snap !== true || props4.step === 0) {
        curMinRatio.value = pos.minR;
        curMaxRatio.value = pos.maxR;
      } else {
        curMinRatio.value = methods.convertModelToRatio(model.value.min);
        curMaxRatio.value = methods.convertModelToRatio(model.value.max);
      }
    }
    function onKeydown2(evt) {
      if (!keyCodes.includes(evt.keyCode)) {
        return;
      }
      stopAndPrevent(evt);
      const stepVal = ([34, 33].includes(evt.keyCode) ? 10 : 1) * state2.keyStep.value, offset2 = ([34, 37, 40].includes(evt.keyCode) ? -1 : 1) * (state2.isReversed.value === true ? -1 : 1) * (props4.vertical === true ? -1 : 1) * stepVal;
      if (state2.focus.value === "both") {
        const interval = model.value.max - model.value.min;
        const min2 = between(
          state2.roundValueFn.value(model.value.min + offset2),
          state2.innerMin.value,
          state2.innerMax.value - interval
        );
        model.value = {
          min: min2,
          max: state2.roundValueFn.value(min2 + interval)
        };
      } else if (state2.focus.value === false) {
        return;
      } else {
        const which = state2.focus.value;
        model.value = {
          ...model.value,
          [which]: between(
            state2.roundValueFn.value(model.value[which] + offset2),
            which === "min" ? state2.innerMin.value : model.value.min,
            which === "max" ? state2.innerMax.value : model.value.max
          )
        };
      }
      updateValue2();
    }
    return () => {
      const content = methods.getContent(
        selectionBarStyle,
        trackContainerTabindex,
        trackContainerEvents,
        (node) => {
          node.push(
            getMinThumb(),
            getMaxThumb()
          );
        }
      );
      return h("div", {
        ref: rootRef,
        class: "q-range " + state2.classes.value + (props4.modelValue.min === null || props4.modelValue.max === null ? " q-slider--no-value" : ""),
        ...state2.attributes.value,
        "aria-valuenow": props4.modelValue.min + "|" + props4.modelValue.max
      }, content);
    };
  }
});
createComponent({
  name: "QRating",
  props: {
    ...useSizeProps,
    ...useFormProps,
    modelValue: {
      type: Number,
      required: true
    },
    max: {
      type: [String, Number],
      default: 5
    },
    icon: [String, Array],
    iconHalf: [String, Array],
    iconSelected: [String, Array],
    iconAriaLabel: [String, Array],
    color: [String, Array],
    colorHalf: [String, Array],
    colorSelected: [String, Array],
    noReset: Boolean,
    noDimming: Boolean,
    readonly: Boolean,
    disable: Boolean
  },
  emits: ["update:modelValue"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const sizeStyle = use_size_default(props4);
    const formAttrs = useFormAttrs(props4);
    const injectFormInput = useFormInject(formAttrs);
    const mouseModel = ref$1(0);
    let iconRefs = {};
    const editable = computed(
      () => props4.readonly !== true && props4.disable !== true
    );
    const classes = computed(
      () => `q-rating row inline items-center q-rating--${editable.value === true ? "" : "non-"}editable` + (props4.noDimming === true ? " q-rating--no-dimming" : "") + (props4.disable === true ? " disabled" : "") + (props4.color !== void 0 && Array.isArray(props4.color) === false ? ` text-${props4.color}` : "")
    );
    const iconData = computed(() => {
      const iconLen = Array.isArray(props4.icon) === true ? props4.icon.length : 0, selIconLen = Array.isArray(props4.iconSelected) === true ? props4.iconSelected.length : 0, halfIconLen = Array.isArray(props4.iconHalf) === true ? props4.iconHalf.length : 0, colorLen = Array.isArray(props4.color) === true ? props4.color.length : 0, selColorLen = Array.isArray(props4.colorSelected) === true ? props4.colorSelected.length : 0, halfColorLen = Array.isArray(props4.colorHalf) === true ? props4.colorHalf.length : 0;
      return {
        iconLen,
        icon: iconLen > 0 ? props4.icon[iconLen - 1] : props4.icon,
        selIconLen,
        selIcon: selIconLen > 0 ? props4.iconSelected[selIconLen - 1] : props4.iconSelected,
        halfIconLen,
        halfIcon: halfIconLen > 0 ? props4.iconHalf[selIconLen - 1] : props4.iconHalf,
        colorLen,
        color: colorLen > 0 ? props4.color[colorLen - 1] : props4.color,
        selColorLen,
        selColor: selColorLen > 0 ? props4.colorSelected[selColorLen - 1] : props4.colorSelected,
        halfColorLen,
        halfColor: halfColorLen > 0 ? props4.colorHalf[halfColorLen - 1] : props4.colorHalf
      };
    });
    const iconLabel = computed(() => {
      if (typeof props4.iconAriaLabel === "string") {
        const label = props4.iconAriaLabel.length !== 0 ? `${props4.iconAriaLabel} ` : "";
        return (i2) => `${label}${i2}`;
      }
      if (Array.isArray(props4.iconAriaLabel) === true) {
        const iMax = props4.iconAriaLabel.length;
        if (iMax > 0) {
          return (i2) => props4.iconAriaLabel[Math.min(i2, iMax) - 1];
        }
      }
      return (i2, label) => `${label} ${i2}`;
    });
    const stars = computed(() => {
      const acc = [], icons = iconData.value, ceil = Math.ceil(props4.modelValue), tabindex = editable.value === true ? 0 : null;
      const halfIndex = props4.iconHalf === void 0 || ceil === props4.modelValue ? -1 : ceil;
      for (let i2 = 1; i2 <= props4.max; i2++) {
        const active = mouseModel.value === 0 && props4.modelValue >= i2 || mouseModel.value > 0 && mouseModel.value >= i2, half = halfIndex === i2 && mouseModel.value < i2, exSelected = mouseModel.value > 0 && (half === true ? ceil : props4.modelValue) >= i2 && mouseModel.value < i2, color = half === true ? i2 <= icons.halfColorLen ? props4.colorHalf[i2 - 1] : icons.halfColor : icons.selColor !== void 0 && active === true ? i2 <= icons.selColorLen ? props4.colorSelected[i2 - 1] : icons.selColor : i2 <= icons.colorLen ? props4.color[i2 - 1] : icons.color, name2 = (half === true ? i2 <= icons.halfIconLen ? props4.iconHalf[i2 - 1] : icons.halfIcon : icons.selIcon !== void 0 && (active === true || exSelected === true) ? i2 <= icons.selIconLen ? props4.iconSelected[i2 - 1] : icons.selIcon : i2 <= icons.iconLen ? props4.icon[i2 - 1] : icons.icon) || $q.iconSet.rating.icon;
        acc.push({
          name: (half === true ? i2 <= icons.halfIconLen ? props4.iconHalf[i2 - 1] : icons.halfIcon : icons.selIcon !== void 0 && (active === true || exSelected === true) ? i2 <= icons.selIconLen ? props4.iconSelected[i2 - 1] : icons.selIcon : i2 <= icons.iconLen ? props4.icon[i2 - 1] : icons.icon) || $q.iconSet.rating.icon,
          attrs: {
            tabindex,
            role: "radio",
            "aria-checked": props4.modelValue === i2 ? "true" : "false",
            "aria-label": iconLabel.value(i2, name2)
          },
          iconClass: "q-rating__icon" + (active === true || half === true ? " q-rating__icon--active" : "") + (exSelected === true ? " q-rating__icon--exselected" : "") + (mouseModel.value === i2 ? " q-rating__icon--hovered" : "") + (color !== void 0 ? ` text-${color}` : "")
        });
      }
      return acc;
    });
    const attributes = computed(() => {
      const attrs = { role: "radiogroup" };
      if (props4.disable === true) {
        attrs["aria-disabled"] = "true";
      }
      if (props4.readonly === true) {
        attrs["aria-readonly"] = "true";
      }
      return attrs;
    });
    function set2(value2) {
      if (editable.value === true) {
        const model = between(parseInt(value2, 10), 1, parseInt(props4.max, 10)), newVal = props4.noReset !== true && props4.modelValue === model ? 0 : model;
        newVal !== props4.modelValue && emit("update:modelValue", newVal);
        mouseModel.value = 0;
      }
    }
    function setHoverValue(value2) {
      if (editable.value === true) {
        mouseModel.value = value2;
      }
    }
    function onKeyup2(e2, i2) {
      switch (e2.keyCode) {
        case 13:
        case 32:
          set2(i2);
          return stopAndPrevent(e2);
        case 37:
        case 40:
          if (iconRefs[`rt${i2 - 1}`]) {
            iconRefs[`rt${i2 - 1}`].focus();
          }
          return stopAndPrevent(e2);
        case 39:
        case 38:
          if (iconRefs[`rt${i2 + 1}`]) {
            iconRefs[`rt${i2 + 1}`].focus();
          }
          return stopAndPrevent(e2);
      }
    }
    function resetMouseModel() {
      mouseModel.value = 0;
    }
    onBeforeUpdate(() => {
      iconRefs = {};
    });
    return () => {
      const child = [];
      stars.value.forEach(({ iconClass, name: name2, attrs }, index) => {
        const i2 = index + 1;
        child.push(
          h("div", {
            key: i2,
            ref: (el) => {
              iconRefs[`rt${i2}`] = el;
            },
            class: "q-rating__icon-container flex flex-center",
            ...attrs,
            onClick() {
              set2(i2);
            },
            onMouseover() {
              setHoverValue(i2);
            },
            onMouseout: resetMouseModel,
            onFocus() {
              setHoverValue(i2);
            },
            onBlur: resetMouseModel,
            onKeyup(e2) {
              onKeyup2(e2, i2);
            }
          }, hMergeSlot(
            slots[`tip-${i2}`],
            [h(QIcon_default, { class: iconClass, name: name2 })]
          ))
        );
      });
      if (props4.name !== void 0 && props4.disable !== true) {
        injectFormInput(child, "push");
      }
      return h("div", {
        class: classes.value,
        style: sizeStyle.value,
        ...attributes.value
      }, child);
    };
  }
});
createComponent({
  name: "QResponsive",
  props: useRatioProps,
  setup(props4, { slots }) {
    const ratioStyle = use_ratio_default(props4);
    return () => h("div", {
      class: "q-responsive"
    }, [
      h("div", {
        class: "q-responsive__filler overflow-hidden"
      }, [
        h("div", { style: ratioStyle.value })
      ]),
      h("div", {
        class: "q-responsive__content absolute-full fit"
      }, hSlot(slots.default))
    ]);
  }
});
var ScrollAreaControls_default = createComponent({
  props: [
    "store",
    "barStyle",
    "verticalBarStyle",
    "horizontalBarStyle"
  ],
  setup(props4) {
    return () => [
      h("div", {
        class: props4.store.scroll.vertical.barClass.value,
        style: [props4.barStyle, props4.verticalBarStyle],
        "aria-hidden": "true",
        onMousedown: props4.store.onVerticalMousedown
      }),
      h("div", {
        class: props4.store.scroll.horizontal.barClass.value,
        style: [props4.barStyle, props4.horizontalBarStyle],
        "aria-hidden": "true",
        onMousedown: props4.store.onHorizontalMousedown
      }),
      withDirectives(
        h("div", {
          ref: props4.store.scroll.vertical.ref,
          class: props4.store.scroll.vertical.thumbClass.value,
          style: props4.store.scroll.vertical.style.value,
          "aria-hidden": "true"
        }),
        props4.store.thumbVertDir
      ),
      withDirectives(
        h("div", {
          ref: props4.store.scroll.horizontal.ref,
          class: props4.store.scroll.horizontal.thumbClass.value,
          style: props4.store.scroll.horizontal.style.value,
          "aria-hidden": "true"
        }),
        props4.store.thumbHorizDir
      )
    ];
  }
});
var axisList = ["vertical", "horizontal"];
var dirProps = {
  vertical: { offset: "offsetY", scroll: "scrollTop", dir: "down", dist: "y" },
  horizontal: { offset: "offsetX", scroll: "scrollLeft", dir: "right", dist: "x" }
};
var panOpts = {
  prevent: true,
  mouse: true,
  mouseAllDir: true
};
var getMinThumbSize = (size2) => size2 >= 250 ? 50 : Math.ceil(size2 / 5);
var QScrollArea_default = createComponent({
  name: "QScrollArea",
  props: {
    ...useDarkProps,
    thumbStyle: Object,
    verticalThumbStyle: Object,
    horizontalThumbStyle: Object,
    barStyle: [Array, String, Object],
    verticalBarStyle: [Array, String, Object],
    horizontalBarStyle: [Array, String, Object],
    verticalOffset: {
      type: Array,
      default: [0, 0]
    },
    horizontalOffset: {
      type: Array,
      default: [0, 0]
    },
    contentStyle: [Array, String, Object],
    contentActiveStyle: [Array, String, Object],
    delay: {
      type: [String, Number],
      default: 1e3
    },
    visible: {
      type: Boolean,
      default: null
    },
    tabindex: [String, Number],
    onScroll: Function
  },
  setup(props4, { slots, emit }) {
    const tempShowing = ref$1(false);
    const panning = ref$1(false);
    const hover = ref$1(false);
    const container = {
      vertical: ref$1(0),
      horizontal: ref$1(0)
    };
    const scroll = {
      vertical: {
        ref: ref$1(null),
        position: ref$1(0),
        size: ref$1(0)
      },
      horizontal: {
        ref: ref$1(null),
        position: ref$1(0),
        size: ref$1(0)
      }
    };
    const { proxy } = getCurrentInstance();
    const isDark = use_dark_default(props4, proxy.$q);
    let timer2 = null, panRefPos;
    const targetRef = ref$1(null);
    const classes = computed(
      () => "q-scrollarea" + (isDark.value === true ? " q-scrollarea--dark" : "")
    );
    Object.assign(container, {
      verticalInner: computed(() => container.vertical.value - props4.verticalOffset[0] - props4.verticalOffset[1]),
      horizontalInner: computed(() => container.horizontal.value - props4.horizontalOffset[0] - props4.horizontalOffset[1])
    });
    scroll.vertical.percentage = computed(() => {
      const diff2 = scroll.vertical.size.value - container.vertical.value;
      if (diff2 <= 0) {
        return 0;
      }
      const p = between(scroll.vertical.position.value / diff2, 0, 1);
      return Math.round(p * 1e4) / 1e4;
    });
    scroll.vertical.thumbHidden = computed(() => (props4.visible === null ? hover.value : props4.visible) !== true && tempShowing.value === false && panning.value === false || scroll.vertical.size.value <= container.vertical.value + 1);
    scroll.vertical.thumbStart = computed(() => props4.verticalOffset[0] + scroll.vertical.percentage.value * (container.verticalInner.value - scroll.vertical.thumbSize.value));
    scroll.vertical.thumbSize = computed(
      () => Math.round(
        between(
          container.verticalInner.value * container.verticalInner.value / scroll.vertical.size.value,
          getMinThumbSize(container.verticalInner.value),
          container.verticalInner.value
        )
      )
    );
    scroll.vertical.style = computed(() => ({
      ...props4.thumbStyle,
      ...props4.verticalThumbStyle,
      top: `${scroll.vertical.thumbStart.value}px`,
      height: `${scroll.vertical.thumbSize.value}px`,
      right: `${props4.horizontalOffset[1]}px`
    }));
    scroll.vertical.thumbClass = computed(() => "q-scrollarea__thumb q-scrollarea__thumb--v absolute-right" + (scroll.vertical.thumbHidden.value === true ? " q-scrollarea__thumb--invisible" : ""));
    scroll.vertical.barClass = computed(() => "q-scrollarea__bar q-scrollarea__bar--v absolute-right" + (scroll.vertical.thumbHidden.value === true ? " q-scrollarea__bar--invisible" : ""));
    scroll.horizontal.percentage = computed(() => {
      const diff2 = scroll.horizontal.size.value - container.horizontal.value;
      if (diff2 <= 0) {
        return 0;
      }
      const p = between(Math.abs(scroll.horizontal.position.value) / diff2, 0, 1);
      return Math.round(p * 1e4) / 1e4;
    });
    scroll.horizontal.thumbHidden = computed(() => (props4.visible === null ? hover.value : props4.visible) !== true && tempShowing.value === false && panning.value === false || scroll.horizontal.size.value <= container.horizontal.value + 1);
    scroll.horizontal.thumbStart = computed(() => props4.horizontalOffset[0] + scroll.horizontal.percentage.value * (container.horizontalInner.value - scroll.horizontal.thumbSize.value));
    scroll.horizontal.thumbSize = computed(
      () => Math.round(
        between(
          container.horizontalInner.value * container.horizontalInner.value / scroll.horizontal.size.value,
          getMinThumbSize(container.horizontalInner.value),
          container.horizontalInner.value
        )
      )
    );
    scroll.horizontal.style = computed(() => ({
      ...props4.thumbStyle,
      ...props4.horizontalThumbStyle,
      [proxy.$q.lang.rtl === true ? "right" : "left"]: `${scroll.horizontal.thumbStart.value}px`,
      width: `${scroll.horizontal.thumbSize.value}px`,
      bottom: `${props4.verticalOffset[1]}px`
    }));
    scroll.horizontal.thumbClass = computed(() => "q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom" + (scroll.horizontal.thumbHidden.value === true ? " q-scrollarea__thumb--invisible" : ""));
    scroll.horizontal.barClass = computed(() => "q-scrollarea__bar q-scrollarea__bar--h absolute-bottom" + (scroll.horizontal.thumbHidden.value === true ? " q-scrollarea__bar--invisible" : ""));
    const mainStyle = computed(() => scroll.vertical.thumbHidden.value === true && scroll.horizontal.thumbHidden.value === true ? props4.contentStyle : props4.contentActiveStyle);
    function getScroll() {
      const info = {};
      axisList.forEach((axis) => {
        const data = scroll[axis];
        Object.assign(info, {
          [axis + "Position"]: data.position.value,
          [axis + "Percentage"]: data.percentage.value,
          [axis + "Size"]: data.size.value,
          [axis + "ContainerSize"]: container[axis].value,
          [axis + "ContainerInnerSize"]: container[axis + "Inner"].value
        });
      });
      return info;
    }
    const emitScroll = debounce_default(() => {
      const info = getScroll();
      info.ref = proxy;
      emit("scroll", info);
    }, 0);
    function localSetScrollPosition(axis, offset2, duration2) {
      if (axisList.includes(axis) === false) {
        console.error("[QScrollArea]: wrong first param of setScrollPosition (vertical/horizontal)");
        return;
      }
      const fn = axis === "vertical" ? setVerticalScrollPosition : setHorizontalScrollPosition;
      fn(targetRef.value, offset2, duration2);
    }
    function updateContainer({ height: height2, width: width3 }) {
      let change = false;
      if (container.vertical.value !== height2) {
        container.vertical.value = height2;
        change = true;
      }
      if (container.horizontal.value !== width3) {
        container.horizontal.value = width3;
        change = true;
      }
      change === true && startTimer();
    }
    function updateScroll({ position: position2 }) {
      let change = false;
      if (scroll.vertical.position.value !== position2.top) {
        scroll.vertical.position.value = position2.top;
        change = true;
      }
      if (scroll.horizontal.position.value !== position2.left) {
        scroll.horizontal.position.value = position2.left;
        change = true;
      }
      change === true && startTimer();
    }
    function updateScrollSize({ height: height2, width: width3 }) {
      if (scroll.horizontal.size.value !== width3) {
        scroll.horizontal.size.value = width3;
        startTimer();
      }
      if (scroll.vertical.size.value !== height2) {
        scroll.vertical.size.value = height2;
        startTimer();
      }
    }
    function onPanThumb(e2, axis) {
      const data = scroll[axis];
      if (e2.isFirst === true) {
        if (data.thumbHidden.value === true) {
          return;
        }
        panRefPos = data.position.value;
        panning.value = true;
      } else if (panning.value !== true) {
        return;
      }
      if (e2.isFinal === true) {
        panning.value = false;
      }
      const dProp = dirProps[axis];
      const multiplier = (data.size.value - container[axis].value) / (container[axis + "Inner"].value - data.thumbSize.value);
      const distance = e2.distance[dProp.dist];
      const pos = panRefPos + (e2.direction === dProp.dir ? 1 : -1) * distance * multiplier;
      setScroll3(pos, axis);
    }
    function onMousedown(evt, axis) {
      const data = scroll[axis];
      if (data.thumbHidden.value !== true) {
        const startOffset = axis === "vertical" ? props4.verticalOffset[0] : props4.horizontalOffset[0];
        const offset2 = evt[dirProps[axis].offset] - startOffset;
        const thumbStart = data.thumbStart.value - startOffset;
        if (offset2 < thumbStart || offset2 > thumbStart + data.thumbSize.value) {
          const targetThumbStart = offset2 - data.thumbSize.value / 2;
          const percentage = between(targetThumbStart / (container[axis + "Inner"].value - data.thumbSize.value), 0, 1);
          setScroll3(percentage * Math.max(0, data.size.value - container[axis].value), axis);
        }
        if (data.ref.value !== null) {
          data.ref.value.dispatchEvent(new MouseEvent(evt.type, evt));
        }
      }
    }
    function startTimer() {
      tempShowing.value = true;
      timer2 !== null && clearTimeout(timer2);
      timer2 = setTimeout(() => {
        timer2 = null;
        tempShowing.value = false;
      }, props4.delay);
      props4.onScroll !== void 0 && emitScroll();
    }
    function setScroll3(offset2, axis) {
      targetRef.value[dirProps[axis].scroll] = offset2;
    }
    let mouseEventTimer = null;
    function onMouseenter() {
      if (mouseEventTimer !== null) {
        clearTimeout(mouseEventTimer);
      }
      mouseEventTimer = setTimeout(() => {
        mouseEventTimer = null;
        hover.value = true;
      }, proxy.$q.platform.is.ios ? 50 : 0);
    }
    function onMouseleave() {
      if (mouseEventTimer !== null) {
        clearTimeout(mouseEventTimer);
        mouseEventTimer = null;
      }
      hover.value = false;
    }
    let scrollPosition = null;
    watch(() => proxy.$q.lang.rtl, (rtl) => {
      if (targetRef.value !== null) {
        setHorizontalScrollPosition(
          targetRef.value,
          Math.abs(scroll.horizontal.position.value) * (rtl === true ? -1 : 1)
        );
      }
    });
    onDeactivated(() => {
      scrollPosition = {
        top: scroll.vertical.position.value,
        left: scroll.horizontal.position.value
      };
    });
    onActivated(() => {
      if (scrollPosition === null) return;
      const scrollTarget = targetRef.value;
      if (scrollTarget !== null) {
        setHorizontalScrollPosition(scrollTarget, scrollPosition.left);
        setVerticalScrollPosition(scrollTarget, scrollPosition.top);
      }
    });
    onBeforeUnmount(emitScroll.cancel);
    Object.assign(proxy, {
      getScrollTarget: () => targetRef.value,
      getScroll,
      getScrollPosition: () => ({
        top: scroll.vertical.position.value,
        left: scroll.horizontal.position.value
      }),
      getScrollPercentage: () => ({
        top: scroll.vertical.percentage.value,
        left: scroll.horizontal.percentage.value
      }),
      setScrollPosition: localSetScrollPosition,
      setScrollPercentage(axis, percentage, duration2) {
        localSetScrollPosition(
          axis,
          percentage * (scroll[axis].size.value - container[axis].value) * (axis === "horizontal" && proxy.$q.lang.rtl === true ? -1 : 1),
          duration2
        );
      }
    });
    const store = {
      scroll,
      thumbVertDir: [[
        TouchPan_default,
        (e2) => {
          onPanThumb(e2, "vertical");
        },
        void 0,
        { vertical: true, ...panOpts }
      ]],
      thumbHorizDir: [[
        TouchPan_default,
        (e2) => {
          onPanThumb(e2, "horizontal");
        },
        void 0,
        { horizontal: true, ...panOpts }
      ]],
      onVerticalMousedown(evt) {
        onMousedown(evt, "vertical");
      },
      onHorizontalMousedown(evt) {
        onMousedown(evt, "horizontal");
      }
    };
    return () => {
      return h("div", {
        class: classes.value,
        onMouseenter,
        onMouseleave
      }, [
        h("div", {
          ref: targetRef,
          class: "q-scrollarea__container scroll relative-position fit hide-scrollbar",
          tabindex: props4.tabindex !== void 0 ? props4.tabindex : void 0
        }, [
          h("div", {
            class: "q-scrollarea__content absolute",
            style: mainStyle.value
          }, hMergeSlot(slots.default, [
            h(QResizeObserver_default, {
              debounce: 0,
              onResize: updateScrollSize
            })
          ])),
          h(QScrollObserver_default, {
            axis: "both",
            onScroll: updateScroll
          })
        ]),
        h(QResizeObserver_default, {
          debounce: 0,
          onResize: updateContainer
        }),
        h(ScrollAreaControls_default, {
          store,
          barStyle: props4.barStyle,
          verticalBarStyle: props4.verticalBarStyle,
          horizontalBarStyle: props4.horizontalBarStyle
        })
      ]);
    };
  }
});
var aggBucketSize = 1e3;
var scrollToEdges = [
  "start",
  "center",
  "end",
  "start-force",
  "center-force",
  "end-force"
];
var filterProto = Array.prototype.filter;
var setOverflowAnchor = __QUASAR_SSR__ || window.getComputedStyle(document.body).overflowAnchor === void 0 ? noop : function(contentEl, index) {
  if (contentEl === null) {
    return;
  }
  if (contentEl._qOverflowAnimationFrame !== void 0) {
    cancelAnimationFrame(contentEl._qOverflowAnimationFrame);
  }
  contentEl._qOverflowAnimationFrame = requestAnimationFrame(() => {
    if (contentEl === null) {
      return;
    }
    contentEl._qOverflowAnimationFrame = void 0;
    const children = contentEl.children || [];
    filterProto.call(children, (el2) => el2.dataset && el2.dataset.qVsAnchor !== void 0).forEach((el2) => {
      delete el2.dataset.qVsAnchor;
    });
    const el = children[index];
    if (el && el.dataset) {
      el.dataset.qVsAnchor = "";
    }
  });
};
function sumFn(acc, h138) {
  return acc + h138;
}
function getScrollDetails(parent, child, beforeRef, afterRef, horizontal, rtl, stickyStart, stickyEnd) {
  const parentCalc = parent === window ? document.scrollingElement || document.documentElement : parent, propElSize = horizontal === true ? "offsetWidth" : "offsetHeight", details = {
    scrollStart: 0,
    scrollViewSize: -stickyStart - stickyEnd,
    scrollMaxSize: 0,
    offsetStart: -stickyStart,
    offsetEnd: -stickyEnd
  };
  if (horizontal === true) {
    if (parent === window) {
      details.scrollStart = window.pageXOffset || window.scrollX || document.body.scrollLeft || 0;
      details.scrollViewSize += document.documentElement.clientWidth;
    } else {
      details.scrollStart = parentCalc.scrollLeft;
      details.scrollViewSize += parentCalc.clientWidth;
    }
    details.scrollMaxSize = parentCalc.scrollWidth;
    if (rtl === true) {
      details.scrollStart = (rtlHasScrollBug === true ? details.scrollMaxSize - details.scrollViewSize : 0) - details.scrollStart;
    }
  } else {
    if (parent === window) {
      details.scrollStart = window.pageYOffset || window.scrollY || document.body.scrollTop || 0;
      details.scrollViewSize += document.documentElement.clientHeight;
    } else {
      details.scrollStart = parentCalc.scrollTop;
      details.scrollViewSize += parentCalc.clientHeight;
    }
    details.scrollMaxSize = parentCalc.scrollHeight;
  }
  if (beforeRef !== null) {
    for (let el = beforeRef.previousElementSibling; el !== null; el = el.previousElementSibling) {
      if (el.classList.contains("q-virtual-scroll--skip") === false) {
        details.offsetStart += el[propElSize];
      }
    }
  }
  if (afterRef !== null) {
    for (let el = afterRef.nextElementSibling; el !== null; el = el.nextElementSibling) {
      if (el.classList.contains("q-virtual-scroll--skip") === false) {
        details.offsetEnd += el[propElSize];
      }
    }
  }
  if (child !== parent) {
    const parentRect = parentCalc.getBoundingClientRect(), childRect = child.getBoundingClientRect();
    if (horizontal === true) {
      details.offsetStart += childRect.left - parentRect.left;
      details.offsetEnd -= childRect.width;
    } else {
      details.offsetStart += childRect.top - parentRect.top;
      details.offsetEnd -= childRect.height;
    }
    if (parent !== window) {
      details.offsetStart += details.scrollStart;
    }
    details.offsetEnd += details.scrollMaxSize - details.offsetStart;
  }
  return details;
}
function setScroll2(parent, scroll, horizontal, rtl) {
  if (scroll === "end") {
    scroll = (parent === window ? document.body : parent)[horizontal === true ? "scrollWidth" : "scrollHeight"];
  }
  if (parent === window) {
    if (horizontal === true) {
      if (rtl === true) {
        scroll = (rtlHasScrollBug === true ? document.body.scrollWidth - document.documentElement.clientWidth : 0) - scroll;
      }
      window.scrollTo(scroll, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
    } else {
      window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, scroll);
    }
  } else if (horizontal === true) {
    if (rtl === true) {
      scroll = (rtlHasScrollBug === true ? parent.scrollWidth - parent.offsetWidth : 0) - scroll;
    }
    parent.scrollLeft = scroll;
  } else {
    parent.scrollTop = scroll;
  }
}
function sumSize(sizeAgg, size2, from, to) {
  if (from >= to) {
    return 0;
  }
  const lastTo = size2.length, fromAgg = Math.floor(from / aggBucketSize), toAgg = Math.floor((to - 1) / aggBucketSize) + 1;
  let total = sizeAgg.slice(fromAgg, toAgg).reduce(sumFn, 0);
  if (from % aggBucketSize !== 0) {
    total -= size2.slice(fromAgg * aggBucketSize, from).reduce(sumFn, 0);
  }
  if (to % aggBucketSize !== 0 && to !== lastTo) {
    total -= size2.slice(to, toAgg * aggBucketSize).reduce(sumFn, 0);
  }
  return total;
}
var commonVirtScrollProps = {
  virtualScrollSliceSize: {
    type: [Number, String],
    default: 10
  },
  virtualScrollSliceRatioBefore: {
    type: [Number, String],
    default: 1
  },
  virtualScrollSliceRatioAfter: {
    type: [Number, String],
    default: 1
  },
  virtualScrollItemSize: {
    type: [Number, String],
    default: 24
  },
  virtualScrollStickySizeStart: {
    type: [Number, String],
    default: 0
  },
  virtualScrollStickySizeEnd: {
    type: [Number, String],
    default: 0
  },
  tableColspan: [Number, String]
};
var commonVirtScrollPropsList = Object.keys(commonVirtScrollProps);
var useVirtualScrollProps = {
  virtualScrollHorizontal: Boolean,
  onVirtualScroll: Function,
  ...commonVirtScrollProps
};
function useVirtualScroll({
  virtualScrollLength,
  getVirtualScrollTarget,
  getVirtualScrollEl,
  virtualScrollItemSizeComputed
  // optional
}) {
  const vm2 = getCurrentInstance();
  const { props: props4, emit, proxy } = vm2;
  const { $q } = proxy;
  let prevScrollStart, prevToIndex, localScrollViewSize, virtualScrollSizesAgg = [], virtualScrollSizes;
  const virtualScrollPaddingBefore = ref$1(0);
  const virtualScrollPaddingAfter = ref$1(0);
  const virtualScrollSliceSizeComputed = ref$1({});
  const beforeRef = ref$1(null);
  const afterRef = ref$1(null);
  const contentRef = ref$1(null);
  const virtualScrollSliceRange = ref$1({ from: 0, to: 0 });
  const colspanAttr = computed(() => props4.tableColspan !== void 0 ? props4.tableColspan : 100);
  if (virtualScrollItemSizeComputed === void 0) {
    virtualScrollItemSizeComputed = computed(() => props4.virtualScrollItemSize);
  }
  const needsReset = computed(() => virtualScrollItemSizeComputed.value + ";" + props4.virtualScrollHorizontal);
  const needsSliceRecalc = computed(
    () => needsReset.value + ";" + props4.virtualScrollSliceRatioBefore + ";" + props4.virtualScrollSliceRatioAfter
  );
  watch(needsSliceRecalc, () => {
    setVirtualScrollSize();
  });
  watch(needsReset, reset);
  function reset() {
    localResetVirtualScroll(prevToIndex, true);
  }
  function refresh(toIndex) {
    localResetVirtualScroll(toIndex === void 0 ? prevToIndex : toIndex);
  }
  function scrollTo(toIndex, edge) {
    const scrollEl = getVirtualScrollTarget();
    if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) {
      return;
    }
    const scrollDetails = getScrollDetails(
      scrollEl,
      getVirtualScrollEl(),
      beforeRef.value,
      afterRef.value,
      props4.virtualScrollHorizontal,
      $q.lang.rtl,
      props4.virtualScrollStickySizeStart,
      props4.virtualScrollStickySizeEnd
    );
    localScrollViewSize !== scrollDetails.scrollViewSize && setVirtualScrollSize(scrollDetails.scrollViewSize);
    setVirtualScrollSliceRange(
      scrollEl,
      scrollDetails,
      Math.min(virtualScrollLength.value - 1, Math.max(0, parseInt(toIndex, 10) || 0)),
      0,
      scrollToEdges.indexOf(edge) !== -1 ? edge : prevToIndex !== -1 && toIndex > prevToIndex ? "end" : "start"
    );
  }
  function localOnVirtualScrollEvt() {
    const scrollEl = getVirtualScrollTarget();
    if (scrollEl === void 0 || scrollEl === null || scrollEl.nodeType === 8) {
      return;
    }
    const scrollDetails = getScrollDetails(
      scrollEl,
      getVirtualScrollEl(),
      beforeRef.value,
      afterRef.value,
      props4.virtualScrollHorizontal,
      $q.lang.rtl,
      props4.virtualScrollStickySizeStart,
      props4.virtualScrollStickySizeEnd
    ), listLastIndex = virtualScrollLength.value - 1, listEndOffset = scrollDetails.scrollMaxSize - scrollDetails.offsetStart - scrollDetails.offsetEnd - virtualScrollPaddingAfter.value;
    if (prevScrollStart === scrollDetails.scrollStart) {
      return;
    }
    if (scrollDetails.scrollMaxSize <= 0) {
      setVirtualScrollSliceRange(scrollEl, scrollDetails, 0, 0);
      return;
    }
    localScrollViewSize !== scrollDetails.scrollViewSize && setVirtualScrollSize(scrollDetails.scrollViewSize);
    updateVirtualScrollSizes(virtualScrollSliceRange.value.from);
    const scrollMaxStart = Math.floor(scrollDetails.scrollMaxSize - Math.max(scrollDetails.scrollViewSize, scrollDetails.offsetEnd) - Math.min(virtualScrollSizes[listLastIndex], scrollDetails.scrollViewSize / 2));
    if (scrollMaxStart > 0 && Math.ceil(scrollDetails.scrollStart) >= scrollMaxStart) {
      setVirtualScrollSliceRange(
        scrollEl,
        scrollDetails,
        listLastIndex,
        scrollDetails.scrollMaxSize - scrollDetails.offsetEnd - virtualScrollSizesAgg.reduce(sumFn, 0)
      );
      return;
    }
    let toIndex = 0, listOffset = scrollDetails.scrollStart - scrollDetails.offsetStart, offset2 = listOffset;
    if (listOffset <= listEndOffset && listOffset + scrollDetails.scrollViewSize >= virtualScrollPaddingBefore.value) {
      listOffset -= virtualScrollPaddingBefore.value;
      toIndex = virtualScrollSliceRange.value.from;
      offset2 = listOffset;
    } else {
      for (let j = 0; listOffset >= virtualScrollSizesAgg[j] && toIndex < listLastIndex; j++) {
        listOffset -= virtualScrollSizesAgg[j];
        toIndex += aggBucketSize;
      }
    }
    while (listOffset > 0 && toIndex < listLastIndex) {
      listOffset -= virtualScrollSizes[toIndex];
      if (listOffset > -scrollDetails.scrollViewSize) {
        toIndex++;
        offset2 = listOffset;
      } else {
        offset2 = virtualScrollSizes[toIndex] + listOffset;
      }
    }
    setVirtualScrollSliceRange(
      scrollEl,
      scrollDetails,
      toIndex,
      offset2
    );
  }
  function setVirtualScrollSliceRange(scrollEl, scrollDetails, toIndex, offset2, align) {
    const alignForce = typeof align === "string" && align.indexOf("-force") !== -1;
    const alignEnd = alignForce === true ? align.replace("-force", "") : align;
    const alignRange = alignEnd !== void 0 ? alignEnd : "start";
    let from = Math.max(0, toIndex - virtualScrollSliceSizeComputed.value[alignRange]), to = from + virtualScrollSliceSizeComputed.value.total;
    if (to > virtualScrollLength.value) {
      to = virtualScrollLength.value;
      from = Math.max(0, to - virtualScrollSliceSizeComputed.value.total);
    }
    prevScrollStart = scrollDetails.scrollStart;
    const rangeChanged = from !== virtualScrollSliceRange.value.from || to !== virtualScrollSliceRange.value.to;
    if (rangeChanged === false && alignEnd === void 0) {
      emitScroll(toIndex);
      return;
    }
    const { activeElement } = document;
    const contentEl = contentRef.value;
    if (rangeChanged === true && contentEl !== null && contentEl !== activeElement && contentEl.contains(activeElement) === true) {
      contentEl.addEventListener("focusout", onBlurRefocusFn);
      setTimeout(() => {
        contentEl !== null && contentEl.removeEventListener("focusout", onBlurRefocusFn);
      });
    }
    setOverflowAnchor(contentEl, toIndex - from);
    const sizeBefore = alignEnd !== void 0 ? virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0) : 0;
    if (rangeChanged === true) {
      const tempTo = to >= virtualScrollSliceRange.value.from && from <= virtualScrollSliceRange.value.to ? virtualScrollSliceRange.value.to : to;
      virtualScrollSliceRange.value = { from, to: tempTo };
      virtualScrollPaddingBefore.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, 0, from);
      virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, to, virtualScrollLength.value);
      requestAnimationFrame(() => {
        if (virtualScrollSliceRange.value.to !== to && prevScrollStart === scrollDetails.scrollStart) {
          virtualScrollSliceRange.value = { from: virtualScrollSliceRange.value.from, to };
          virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, to, virtualScrollLength.value);
        }
      });
    }
    requestAnimationFrame(() => {
      if (prevScrollStart !== scrollDetails.scrollStart) {
        return;
      }
      if (rangeChanged === true) {
        updateVirtualScrollSizes(from);
      }
      const sizeAfter = virtualScrollSizes.slice(from, toIndex).reduce(sumFn, 0), posStart = sizeAfter + scrollDetails.offsetStart + virtualScrollPaddingBefore.value, posEnd = posStart + virtualScrollSizes[toIndex];
      let scrollPosition = posStart + offset2;
      if (alignEnd !== void 0) {
        const sizeDiff = sizeAfter - sizeBefore;
        const scrollStart = scrollDetails.scrollStart + sizeDiff;
        scrollPosition = alignForce !== true && scrollStart < posStart && posEnd < scrollStart + scrollDetails.scrollViewSize ? scrollStart : alignEnd === "end" ? posEnd - scrollDetails.scrollViewSize : posStart - (alignEnd === "start" ? 0 : Math.round((scrollDetails.scrollViewSize - virtualScrollSizes[toIndex]) / 2));
      }
      prevScrollStart = scrollPosition;
      setScroll2(
        scrollEl,
        scrollPosition,
        props4.virtualScrollHorizontal,
        $q.lang.rtl
      );
      emitScroll(toIndex);
    });
  }
  function updateVirtualScrollSizes(from) {
    const contentEl = contentRef.value;
    if (contentEl) {
      const children = filterProto.call(
        contentEl.children,
        (el) => el.classList && el.classList.contains("q-virtual-scroll--skip") === false
      ), childrenLength = children.length, sizeFn = props4.virtualScrollHorizontal === true ? (el) => el.getBoundingClientRect().width : (el) => el.offsetHeight;
      let index = from, size2, diff2;
      for (let i2 = 0; i2 < childrenLength; ) {
        size2 = sizeFn(children[i2]);
        i2++;
        while (i2 < childrenLength && children[i2].classList.contains("q-virtual-scroll--with-prev") === true) {
          size2 += sizeFn(children[i2]);
          i2++;
        }
        diff2 = size2 - virtualScrollSizes[index];
        if (diff2 !== 0) {
          virtualScrollSizes[index] += diff2;
          virtualScrollSizesAgg[Math.floor(index / aggBucketSize)] += diff2;
        }
        index++;
      }
    }
  }
  function onBlurRefocusFn() {
    contentRef.value !== null && contentRef.value !== void 0 && contentRef.value.focus();
  }
  function localResetVirtualScroll(toIndex, fullReset) {
    const defaultSize = 1 * virtualScrollItemSizeComputed.value;
    if (fullReset === true || Array.isArray(virtualScrollSizes) === false) {
      virtualScrollSizes = [];
    }
    const oldVirtualScrollSizesLength = virtualScrollSizes.length;
    virtualScrollSizes.length = virtualScrollLength.value;
    for (let i2 = virtualScrollLength.value - 1; i2 >= oldVirtualScrollSizesLength; i2--) {
      virtualScrollSizes[i2] = defaultSize;
    }
    const jMax = Math.floor((virtualScrollLength.value - 1) / aggBucketSize);
    virtualScrollSizesAgg = [];
    for (let j = 0; j <= jMax; j++) {
      let size2 = 0;
      const iMax = Math.min((j + 1) * aggBucketSize, virtualScrollLength.value);
      for (let i2 = j * aggBucketSize; i2 < iMax; i2++) {
        size2 += virtualScrollSizes[i2];
      }
      virtualScrollSizesAgg.push(size2);
    }
    prevToIndex = -1;
    prevScrollStart = void 0;
    virtualScrollPaddingBefore.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, 0, virtualScrollSliceRange.value.from);
    virtualScrollPaddingAfter.value = sumSize(virtualScrollSizesAgg, virtualScrollSizes, virtualScrollSliceRange.value.to, virtualScrollLength.value);
    if (toIndex >= 0) {
      updateVirtualScrollSizes(virtualScrollSliceRange.value.from);
      nextTick(() => {
        scrollTo(toIndex);
      });
    } else {
      onVirtualScrollEvt();
    }
  }
  function setVirtualScrollSize(scrollViewSize) {
    if (scrollViewSize === void 0 && typeof window !== "undefined") {
      const scrollEl = getVirtualScrollTarget();
      if (scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) {
        scrollViewSize = getScrollDetails(
          scrollEl,
          getVirtualScrollEl(),
          beforeRef.value,
          afterRef.value,
          props4.virtualScrollHorizontal,
          $q.lang.rtl,
          props4.virtualScrollStickySizeStart,
          props4.virtualScrollStickySizeEnd
        ).scrollViewSize;
      }
    }
    localScrollViewSize = scrollViewSize;
    const virtualScrollSliceRatioBefore = parseFloat(props4.virtualScrollSliceRatioBefore) || 0;
    const virtualScrollSliceRatioAfter = parseFloat(props4.virtualScrollSliceRatioAfter) || 0;
    const multiplier = 1 + virtualScrollSliceRatioBefore + virtualScrollSliceRatioAfter;
    const view = scrollViewSize === void 0 || scrollViewSize <= 0 ? 1 : Math.ceil(scrollViewSize / virtualScrollItemSizeComputed.value);
    const baseSize = Math.max(
      1,
      view,
      Math.ceil((props4.virtualScrollSliceSize > 0 ? props4.virtualScrollSliceSize : 10) / multiplier)
    );
    virtualScrollSliceSizeComputed.value = {
      total: Math.ceil(baseSize * multiplier),
      start: Math.ceil(baseSize * virtualScrollSliceRatioBefore),
      center: Math.ceil(baseSize * (0.5 + virtualScrollSliceRatioBefore)),
      end: Math.ceil(baseSize * (1 + virtualScrollSliceRatioBefore)),
      view
    };
  }
  function padVirtualScroll(tag, content) {
    const paddingSize = props4.virtualScrollHorizontal === true ? "width" : "height";
    const style2 = {
      ["--q-virtual-scroll-item-" + paddingSize]: virtualScrollItemSizeComputed.value + "px"
    };
    return [
      tag === "tbody" ? h(tag, {
        class: "q-virtual-scroll__padding",
        key: "before",
        ref: beforeRef
      }, [
        h("tr", [
          h("td", {
            style: { [paddingSize]: `${virtualScrollPaddingBefore.value}px`, ...style2 },
            colspan: colspanAttr.value
          })
        ])
      ]) : h(tag, {
        class: "q-virtual-scroll__padding",
        key: "before",
        ref: beforeRef,
        style: { [paddingSize]: `${virtualScrollPaddingBefore.value}px`, ...style2 }
      }),
      h(tag, {
        class: "q-virtual-scroll__content",
        key: "content",
        ref: contentRef,
        tabindex: -1
      }, content.flat()),
      tag === "tbody" ? h(tag, {
        class: "q-virtual-scroll__padding",
        key: "after",
        ref: afterRef
      }, [
        h("tr", [
          h("td", {
            style: { [paddingSize]: `${virtualScrollPaddingAfter.value}px`, ...style2 },
            colspan: colspanAttr.value
          })
        ])
      ]) : h(tag, {
        class: "q-virtual-scroll__padding",
        key: "after",
        ref: afterRef,
        style: { [paddingSize]: `${virtualScrollPaddingAfter.value}px`, ...style2 }
      })
    ];
  }
  function emitScroll(index) {
    if (prevToIndex !== index) {
      props4.onVirtualScroll !== void 0 && emit("virtualScroll", {
        index,
        from: virtualScrollSliceRange.value.from,
        to: virtualScrollSliceRange.value.to - 1,
        direction: index < prevToIndex ? "decrease" : "increase",
        ref: proxy
      });
      prevToIndex = index;
    }
  }
  setVirtualScrollSize();
  const onVirtualScrollEvt = debounce_default(
    localOnVirtualScrollEvt,
    $q.platform.is.ios === true ? 120 : 35
  );
  onBeforeMount(() => {
    setVirtualScrollSize();
  });
  let shouldActivate = false;
  onDeactivated(() => {
    shouldActivate = true;
  });
  onActivated(() => {
    if (shouldActivate !== true) return;
    const scrollEl = getVirtualScrollTarget();
    if (prevScrollStart !== void 0 && scrollEl !== void 0 && scrollEl !== null && scrollEl.nodeType !== 8) {
      setScroll2(
        scrollEl,
        prevScrollStart,
        props4.virtualScrollHorizontal,
        $q.lang.rtl
      );
    } else {
      scrollTo(prevToIndex);
    }
  });
  __QUASAR_SSR__ || onBeforeUnmount(() => {
    onVirtualScrollEvt.cancel();
  });
  Object.assign(proxy, { scrollTo, reset, refresh });
  return {
    virtualScrollSliceRange,
    virtualScrollSliceSizeComputed,
    setVirtualScrollSize,
    onVirtualScrollEvt,
    localResetVirtualScroll,
    padVirtualScroll,
    scrollTo,
    reset,
    refresh
  };
}
var validateNewValueMode = (v) => ["add", "add-unique", "toggle"].includes(v);
var reEscapeList = ".*+?^${}()|[]\\";
var fieldPropsList = Object.keys(useFieldProps);
function getPropValueFn2(userPropName, defaultPropName) {
  if (typeof userPropName === "function") return userPropName;
  const propName = userPropName !== void 0 ? userPropName : defaultPropName;
  return (opt) => opt !== null && typeof opt === "object" && propName in opt ? opt[propName] : opt;
}
var QSelect_default = createComponent({
  name: "QSelect",
  inheritAttrs: false,
  props: {
    ...useVirtualScrollProps,
    ...useFormProps,
    ...useFieldProps,
    // override of useFieldProps > modelValue
    modelValue: {
      required: true
    },
    multiple: Boolean,
    displayValue: [String, Number],
    displayValueHtml: Boolean,
    dropdownIcon: String,
    options: {
      type: Array,
      default: () => []
    },
    optionValue: [Function, String],
    optionLabel: [Function, String],
    optionDisable: [Function, String],
    hideSelected: Boolean,
    hideDropdownIcon: Boolean,
    fillInput: Boolean,
    maxValues: [Number, String],
    optionsDense: Boolean,
    optionsDark: {
      type: Boolean,
      default: null
    },
    optionsSelectedClass: String,
    optionsHtml: Boolean,
    optionsCover: Boolean,
    menuShrink: Boolean,
    menuAnchor: String,
    menuSelf: String,
    menuOffset: Array,
    popupContentClass: String,
    popupContentStyle: [String, Array, Object],
    popupNoRouteDismiss: Boolean,
    useInput: Boolean,
    useChips: Boolean,
    newValueMode: {
      type: String,
      validator: validateNewValueMode
    },
    mapOptions: Boolean,
    emitValue: Boolean,
    disableTabSelection: Boolean,
    inputDebounce: {
      type: [Number, String],
      default: 500
    },
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object],
    tabindex: {
      type: [String, Number],
      default: 0
    },
    autocomplete: String,
    transitionShow: {},
    transitionHide: {},
    transitionDuration: {},
    behavior: {
      type: String,
      validator: (v) => ["default", "menu", "dialog"].includes(v),
      default: "default"
    },
    // override of useVirtualScrollProps > virtualScrollItemSize (no default)
    virtualScrollItemSize: useVirtualScrollProps.virtualScrollItemSize.type,
    onNewValue: Function,
    onFilter: Function
  },
  emits: [
    ...useFieldEmits,
    "add",
    "remove",
    "inputValue",
    "keyup",
    "keypress",
    "keydown",
    "popupShow",
    "popupHide",
    "filterAbort"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const menu = ref$1(false);
    const dialog = ref$1(false);
    const optionIndex = ref$1(-1);
    const inputValue = ref$1("");
    const dialogFieldFocused = ref$1(false);
    const innerLoadingIndicator = ref$1(false);
    let filterTimer = null, inputValueTimer = null, innerValueCache, hasDialog, userInputValue, filterId = null, defaultInputValue, transitionShowComputed, searchBuffer, searchBufferExp;
    const inputRef = ref$1(null);
    const targetRef = ref$1(null);
    const menuRef = ref$1(null);
    const dialogRef = ref$1(null);
    const menuContentRef = ref$1(null);
    const nameProp = useFormInputNameAttr(props4);
    const onComposition = use_key_composition_default(onInput);
    const virtualScrollLength = computed(() => Array.isArray(props4.options) ? props4.options.length : 0);
    const virtualScrollItemSizeComputed = computed(() => props4.virtualScrollItemSize === void 0 ? props4.optionsDense === true ? 24 : 48 : props4.virtualScrollItemSize);
    const {
      virtualScrollSliceRange,
      virtualScrollSliceSizeComputed,
      localResetVirtualScroll,
      padVirtualScroll,
      onVirtualScrollEvt,
      scrollTo,
      setVirtualScrollSize
    } = useVirtualScroll({
      virtualScrollLength,
      getVirtualScrollTarget,
      getVirtualScrollEl,
      virtualScrollItemSizeComputed
    });
    const state2 = useFieldState();
    const innerValue = computed(() => {
      const mapNull = props4.mapOptions === true && props4.multiple !== true, val = props4.modelValue !== void 0 && (props4.modelValue !== null || mapNull === true) ? props4.multiple === true && Array.isArray(props4.modelValue) ? props4.modelValue : [props4.modelValue] : [];
      if (props4.mapOptions === true && Array.isArray(props4.options) === true) {
        const cache = props4.mapOptions === true && innerValueCache !== void 0 ? innerValueCache : [];
        const values = val.map((v) => getOption(v, cache));
        return props4.modelValue === null && mapNull === true ? values.filter((v) => v !== null) : values;
      }
      return val;
    });
    const innerFieldProps = computed(() => {
      const acc = {};
      fieldPropsList.forEach((key) => {
        const val = props4[key];
        if (val !== void 0) {
          acc[key] = val;
        }
      });
      return acc;
    });
    const isOptionsDark = computed(() => props4.optionsDark === null ? state2.isDark.value : props4.optionsDark);
    const hasValue = computed(() => fieldValueIsFilled(innerValue.value));
    const computedInputClass = computed(() => {
      let cls = "q-field__input q-placeholder col";
      if (props4.hideSelected === true || innerValue.value.length === 0) {
        return [cls, props4.inputClass];
      }
      cls += " q-field__input--padding";
      return props4.inputClass === void 0 ? cls : [cls, props4.inputClass];
    });
    const menuContentClass = computed(
      () => (props4.virtualScrollHorizontal === true ? "q-virtual-scroll--horizontal" : "") + (props4.popupContentClass ? " " + props4.popupContentClass : "")
    );
    const noOptions = computed(() => virtualScrollLength.value === 0);
    const selectedString = computed(
      () => innerValue.value.map((opt) => getOptionLabel.value(opt)).join(", ")
    );
    const ariaCurrentValue = computed(() => props4.displayValue !== void 0 ? props4.displayValue : selectedString.value);
    const needsHtmlFn = computed(() => props4.optionsHtml === true ? () => true : (opt) => opt !== void 0 && opt !== null && opt.html === true);
    const valueAsHtml = computed(() => props4.displayValueHtml === true || props4.displayValue === void 0 && (props4.optionsHtml === true || innerValue.value.some(needsHtmlFn.value)));
    const tabindex = computed(() => state2.focused.value === true ? props4.tabindex : -1);
    const comboboxAttrs = computed(() => {
      const attrs = {
        tabindex: props4.tabindex,
        role: "combobox",
        "aria-label": props4.label,
        "aria-readonly": props4.readonly === true ? "true" : "false",
        "aria-autocomplete": props4.useInput === true ? "list" : "none",
        "aria-expanded": menu.value === true ? "true" : "false",
        "aria-controls": `${state2.targetUid.value}_lb`
      };
      if (optionIndex.value >= 0) {
        attrs["aria-activedescendant"] = `${state2.targetUid.value}_${optionIndex.value}`;
      }
      return attrs;
    });
    const listboxAttrs = computed(() => ({
      id: `${state2.targetUid.value}_lb`,
      role: "listbox",
      "aria-multiselectable": props4.multiple === true ? "true" : "false"
    }));
    const selectedScope = computed(() => {
      return innerValue.value.map((opt, i2) => ({
        index: i2,
        opt,
        html: needsHtmlFn.value(opt),
        selected: true,
        removeAtIndex: removeAtIndexAndFocus,
        toggleOption,
        tabindex: tabindex.value
      }));
    });
    const optionScope = computed(() => {
      if (virtualScrollLength.value === 0) {
        return [];
      }
      const { from, to } = virtualScrollSliceRange.value;
      return props4.options.slice(from, to).map((opt, i2) => {
        const disable = isOptionDisabled.value(opt) === true;
        const active = isOptionSelected(opt) === true;
        const index = from + i2;
        const itemProps = {
          clickable: true,
          active,
          activeClass: computedOptionsSelectedClass.value,
          manualFocus: true,
          focused: false,
          disable,
          tabindex: -1,
          dense: props4.optionsDense,
          dark: isOptionsDark.value,
          role: "option",
          "aria-selected": active === true ? "true" : "false",
          id: `${state2.targetUid.value}_${index}`,
          onClick: () => {
            toggleOption(opt);
          }
        };
        if (disable !== true) {
          optionIndex.value === index && (itemProps.focused = true);
          if ($q.platform.is.desktop === true) {
            itemProps.onMousemove = () => {
              menu.value === true && setOptionIndex(index);
            };
          }
        }
        return {
          index,
          opt,
          html: needsHtmlFn.value(opt),
          label: getOptionLabel.value(opt),
          selected: itemProps.active,
          focused: itemProps.focused,
          toggleOption,
          setOptionIndex,
          itemProps
        };
      });
    });
    const dropdownArrowIcon = computed(() => props4.dropdownIcon !== void 0 ? props4.dropdownIcon : $q.iconSet.arrow.dropdown);
    const squaredMenu = computed(
      () => props4.optionsCover === false && props4.outlined !== true && props4.standout !== true && props4.borderless !== true && props4.rounded !== true
    );
    const computedOptionsSelectedClass = computed(() => props4.optionsSelectedClass !== void 0 ? props4.optionsSelectedClass : props4.color !== void 0 ? `text-${props4.color}` : "");
    const getOptionValue = computed(() => getPropValueFn2(props4.optionValue, "value"));
    const getOptionLabel = computed(() => getPropValueFn2(props4.optionLabel, "label"));
    const isOptionDisabled = computed(() => getPropValueFn2(props4.optionDisable, "disable"));
    const innerOptionsValue = computed(() => innerValue.value.map(getOptionValue.value));
    const inputControlEvents = computed(() => {
      const evt = {
        onInput,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        onChange: onComposition,
        onKeydown: onTargetKeydown,
        onKeyup: onTargetAutocomplete,
        onKeypress: onTargetKeypress,
        onFocus: selectInputText,
        onClick(e2) {
          hasDialog === true && stop(e2);
        }
      };
      evt.onCompositionstart = evt.onCompositionupdate = evt.onCompositionend = onComposition;
      return evt;
    });
    watch(innerValue, (val) => {
      innerValueCache = val;
      if (props4.useInput === true && props4.fillInput === true && props4.multiple !== true && state2.innerLoading.value !== true && (dialog.value !== true && menu.value !== true || hasValue.value !== true)) {
        userInputValue !== true && resetInputValue();
        if (dialog.value === true || menu.value === true) {
          filter("");
        }
      }
    }, { immediate: true });
    watch(() => props4.fillInput, resetInputValue);
    watch(menu, updateMenu);
    watch(virtualScrollLength, rerenderMenu);
    function getEmittingOptionValue(opt) {
      return props4.emitValue === true ? getOptionValue.value(opt) : opt;
    }
    function removeAtIndex(index) {
      if (index !== -1 && index < innerValue.value.length) {
        if (props4.multiple === true) {
          const model = props4.modelValue.slice();
          emit("remove", { index, value: model.splice(index, 1)[0] });
          emit("update:modelValue", model);
        } else {
          emit("update:modelValue", null);
        }
      }
    }
    function removeAtIndexAndFocus(index) {
      removeAtIndex(index);
      state2.focus();
    }
    function add2(opt, unique) {
      const val = getEmittingOptionValue(opt);
      if (props4.multiple !== true) {
        props4.fillInput === true && updateInputValue(
          getOptionLabel.value(opt),
          true,
          true
        );
        emit("update:modelValue", val);
        return;
      }
      if (innerValue.value.length === 0) {
        emit("add", { index: 0, value: val });
        emit("update:modelValue", props4.multiple === true ? [val] : val);
        return;
      }
      if (unique === true && isOptionSelected(opt) === true) {
        return;
      }
      if (props4.maxValues !== void 0 && props4.modelValue.length >= props4.maxValues) {
        return;
      }
      const model = props4.modelValue.slice();
      emit("add", { index: model.length, value: val });
      model.push(val);
      emit("update:modelValue", model);
    }
    function toggleOption(opt, keepOpen) {
      if (state2.editable.value !== true || opt === void 0 || isOptionDisabled.value(opt) === true) {
        return;
      }
      const optValue = getOptionValue.value(opt);
      if (props4.multiple !== true) {
        if (keepOpen !== true) {
          updateInputValue(
            props4.fillInput === true ? getOptionLabel.value(opt) : "",
            true,
            true
          );
          hidePopup();
        }
        targetRef.value !== null && targetRef.value.focus();
        if (innerValue.value.length === 0 || isDeepEqual(getOptionValue.value(innerValue.value[0]), optValue) !== true) {
          emit("update:modelValue", props4.emitValue === true ? optValue : opt);
        }
        return;
      }
      (hasDialog !== true || dialogFieldFocused.value === true) && state2.focus();
      selectInputText();
      if (innerValue.value.length === 0) {
        const val = props4.emitValue === true ? optValue : opt;
        emit("add", { index: 0, value: val });
        emit("update:modelValue", props4.multiple === true ? [val] : val);
        return;
      }
      const model = props4.modelValue.slice(), index = innerOptionsValue.value.findIndex((v) => isDeepEqual(v, optValue));
      if (index !== -1) {
        emit("remove", { index, value: model.splice(index, 1)[0] });
      } else {
        if (props4.maxValues !== void 0 && model.length >= props4.maxValues) {
          return;
        }
        const val = props4.emitValue === true ? optValue : opt;
        emit("add", { index: model.length, value: val });
        model.push(val);
      }
      emit("update:modelValue", model);
    }
    function setOptionIndex(index) {
      if ($q.platform.is.desktop !== true) return;
      const val = index !== -1 && index < virtualScrollLength.value ? index : -1;
      if (optionIndex.value !== val) {
        optionIndex.value = val;
      }
    }
    function moveOptionSelection(offset2 = 1, skipInputValue) {
      if (menu.value === true) {
        let index = optionIndex.value;
        do {
          index = normalizeToInterval(
            index + offset2,
            -1,
            virtualScrollLength.value - 1
          );
        } while (index !== -1 && index !== optionIndex.value && isOptionDisabled.value(props4.options[index]) === true);
        if (optionIndex.value !== index) {
          setOptionIndex(index);
          scrollTo(index);
          if (skipInputValue !== true && props4.useInput === true && props4.fillInput === true) {
            setInputValue(
              index >= 0 ? getOptionLabel.value(props4.options[index]) : defaultInputValue,
              true
            );
          }
        }
      }
    }
    function getOption(value2, valueCache) {
      const fn = (opt) => isDeepEqual(getOptionValue.value(opt), value2);
      return props4.options.find(fn) || valueCache.find(fn) || value2;
    }
    function isOptionSelected(opt) {
      const val = getOptionValue.value(opt);
      return innerOptionsValue.value.find((v) => isDeepEqual(v, val)) !== void 0;
    }
    function selectInputText(e2) {
      if (props4.useInput === true && targetRef.value !== null && (e2 === void 0 || targetRef.value === e2.target && e2.target.value === selectedString.value)) {
        targetRef.value.select();
      }
    }
    function onTargetKeyup(e2) {
      if (isKeyCode(e2, 27) === true && menu.value === true) {
        stop(e2);
        hidePopup();
        resetInputValue();
      }
      emit("keyup", e2);
    }
    function onTargetAutocomplete(e2) {
      const { value: value2 } = e2.target;
      if (e2.keyCode !== void 0) {
        onTargetKeyup(e2);
        return;
      }
      e2.target.value = "";
      if (filterTimer !== null) {
        clearTimeout(filterTimer);
        filterTimer = null;
      }
      if (inputValueTimer !== null) {
        clearTimeout(inputValueTimer);
        inputValueTimer = null;
      }
      resetInputValue();
      if (typeof value2 === "string" && value2.length !== 0) {
        const needle = value2.toLocaleLowerCase();
        const findFn = (extractFn) => {
          const option = props4.options.find((opt) => String(extractFn.value(opt)).toLocaleLowerCase() === needle);
          if (option === void 0) return false;
          if (innerValue.value.indexOf(option) === -1) {
            toggleOption(option);
          } else {
            hidePopup();
          }
          return true;
        };
        const fillFn = (afterFilter) => {
          if (findFn(getOptionValue) !== true && afterFilter !== true && findFn(getOptionLabel) !== true) {
            filter(value2, true, () => fillFn(true));
          }
        };
        fillFn();
      } else {
        state2.clearValue(e2);
      }
    }
    function onTargetKeypress(e2) {
      emit("keypress", e2);
    }
    function onTargetKeydown(e2) {
      emit("keydown", e2);
      if (shouldIgnoreKey(e2) === true) {
        return;
      }
      const newValueModeValid = inputValue.value.length !== 0 && (props4.newValueMode !== void 0 || props4.onNewValue !== void 0);
      const tabShouldSelect = e2.shiftKey !== true && props4.disableTabSelection !== true && props4.multiple !== true && (optionIndex.value !== -1 || newValueModeValid === true);
      if (e2.keyCode === 27) {
        prevent(e2);
        return;
      }
      if (e2.keyCode === 9 && tabShouldSelect === false) {
        closeMenu();
        return;
      }
      if (e2.target === void 0 || e2.target.id !== state2.targetUid.value || state2.editable.value !== true) return;
      if (e2.keyCode === 40 && state2.innerLoading.value !== true && menu.value === false) {
        stopAndPrevent(e2);
        showPopup();
        return;
      }
      if (e2.keyCode === 8 && (props4.useChips === true || props4.clearable === true) && props4.hideSelected !== true && inputValue.value.length === 0) {
        if (props4.multiple === true && Array.isArray(props4.modelValue) === true) {
          removeAtIndex(props4.modelValue.length - 1);
        } else if (props4.multiple !== true && props4.modelValue !== null) {
          emit("update:modelValue", null);
        }
        return;
      }
      if ((e2.keyCode === 35 || e2.keyCode === 36) && (typeof inputValue.value !== "string" || inputValue.value.length === 0)) {
        stopAndPrevent(e2);
        optionIndex.value = -1;
        moveOptionSelection(e2.keyCode === 36 ? 1 : -1, props4.multiple);
      }
      if ((e2.keyCode === 33 || e2.keyCode === 34) && virtualScrollSliceSizeComputed.value !== void 0) {
        stopAndPrevent(e2);
        optionIndex.value = Math.max(
          -1,
          Math.min(
            virtualScrollLength.value,
            optionIndex.value + (e2.keyCode === 33 ? -1 : 1) * virtualScrollSliceSizeComputed.value.view
          )
        );
        moveOptionSelection(e2.keyCode === 33 ? 1 : -1, props4.multiple);
      }
      if (e2.keyCode === 38 || e2.keyCode === 40) {
        stopAndPrevent(e2);
        moveOptionSelection(e2.keyCode === 38 ? -1 : 1, props4.multiple);
      }
      const optionsLength = virtualScrollLength.value;
      if (searchBuffer === void 0 || searchBufferExp < Date.now()) {
        searchBuffer = "";
      }
      if (optionsLength > 0 && props4.useInput !== true && e2.key !== void 0 && e2.key.length === 1 && e2.altKey === false && e2.ctrlKey === false && e2.metaKey === false && (e2.keyCode !== 32 || searchBuffer.length !== 0)) {
        menu.value !== true && showPopup(e2);
        const char = e2.key.toLocaleLowerCase(), keyRepeat = searchBuffer.length === 1 && searchBuffer[0] === char;
        searchBufferExp = Date.now() + 1500;
        if (keyRepeat === false) {
          stopAndPrevent(e2);
          searchBuffer += char;
        }
        const searchRe = new RegExp("^" + searchBuffer.split("").map((l) => reEscapeList.indexOf(l) !== -1 ? "\\" + l : l).join(".*"), "i");
        let index = optionIndex.value;
        if (keyRepeat === true || index < 0 || searchRe.test(getOptionLabel.value(props4.options[index])) !== true) {
          do {
            index = normalizeToInterval(index + 1, -1, optionsLength - 1);
          } while (index !== optionIndex.value && (isOptionDisabled.value(props4.options[index]) === true || searchRe.test(getOptionLabel.value(props4.options[index])) !== true));
        }
        if (optionIndex.value !== index) {
          nextTick(() => {
            setOptionIndex(index);
            scrollTo(index);
            if (index >= 0 && props4.useInput === true && props4.fillInput === true) {
              setInputValue(getOptionLabel.value(props4.options[index]), true);
            }
          });
        }
        return;
      }
      if (e2.keyCode !== 13 && (e2.keyCode !== 32 || props4.useInput === true || searchBuffer !== "") && (e2.keyCode !== 9 || tabShouldSelect === false)) return;
      e2.keyCode !== 9 && stopAndPrevent(e2);
      if (optionIndex.value !== -1 && optionIndex.value < optionsLength) {
        toggleOption(props4.options[optionIndex.value]);
        return;
      }
      if (newValueModeValid === true) {
        const done = (val, mode) => {
          if (mode) {
            if (validateNewValueMode(mode) !== true) {
              return;
            }
          } else {
            mode = props4.newValueMode;
          }
          updateInputValue("", props4.multiple !== true, true);
          if (val === void 0 || val === null) {
            return;
          }
          const fn = mode === "toggle" ? toggleOption : add2;
          fn(val, mode === "add-unique");
          if (props4.multiple !== true) {
            targetRef.value !== null && targetRef.value.focus();
            hidePopup();
          }
        };
        if (props4.onNewValue !== void 0) {
          emit("newValue", inputValue.value, done);
        } else {
          done(inputValue.value);
        }
        if (props4.multiple !== true) {
          return;
        }
      }
      if (menu.value === true) {
        closeMenu();
      } else if (state2.innerLoading.value !== true) {
        showPopup();
      }
    }
    function getVirtualScrollEl() {
      return hasDialog === true ? menuContentRef.value : menuRef.value !== null && menuRef.value.contentEl !== null ? menuRef.value.contentEl : void 0;
    }
    function getVirtualScrollTarget() {
      return getVirtualScrollEl();
    }
    function getSelection2() {
      if (props4.hideSelected === true) {
        return [];
      }
      if (slots["selected-item"] !== void 0) {
        return selectedScope.value.map((scope) => slots["selected-item"](scope)).slice();
      }
      if (slots.selected !== void 0) {
        return [].concat(slots.selected());
      }
      if (props4.useChips === true) {
        return selectedScope.value.map((scope, i2) => h(QChip_default, {
          key: "option-" + i2,
          removable: state2.editable.value === true && isOptionDisabled.value(scope.opt) !== true,
          dense: true,
          textColor: props4.color,
          tabindex: tabindex.value,
          onRemove() {
            scope.removeAtIndex(i2);
          }
        }, () => h("span", {
          class: "ellipsis",
          [scope.html === true ? "innerHTML" : "textContent"]: getOptionLabel.value(scope.opt)
        })));
      }
      return [
        h("span", {
          [valueAsHtml.value === true ? "innerHTML" : "textContent"]: ariaCurrentValue.value
        })
      ];
    }
    function getAllOptions() {
      if (noOptions.value === true) {
        return slots["no-option"] !== void 0 ? slots["no-option"]({ inputValue: inputValue.value }) : void 0;
      }
      const fn = slots.option !== void 0 ? slots.option : (scope) => {
        return h(QItem_default, {
          key: scope.index,
          ...scope.itemProps
        }, () => {
          return h(
            QItemSection_default,
            () => h(
              QItemLabel_default,
              () => h("span", {
                [scope.html === true ? "innerHTML" : "textContent"]: scope.label
              })
            )
          );
        });
      };
      let options = padVirtualScroll("div", optionScope.value.map(fn));
      if (slots["before-options"] !== void 0) {
        options = slots["before-options"]().concat(options);
      }
      return hMergeSlot(slots["after-options"], options);
    }
    function getInput(fromDialog, isTarget) {
      const attrs = isTarget === true ? { ...comboboxAttrs.value, ...state2.splitAttrs.attributes.value } : void 0;
      const data = {
        ref: isTarget === true ? targetRef : void 0,
        key: "i_t",
        class: computedInputClass.value,
        style: props4.inputStyle,
        value: inputValue.value !== void 0 ? inputValue.value : "",
        // required for Android in order to show ENTER key when in form
        type: "search",
        ...attrs,
        id: isTarget === true ? state2.targetUid.value : void 0,
        maxlength: props4.maxlength,
        autocomplete: props4.autocomplete,
        "data-autofocus": fromDialog === true || props4.autofocus === true || void 0,
        disabled: props4.disable === true,
        readonly: props4.readonly === true,
        ...inputControlEvents.value
      };
      if (fromDialog !== true && hasDialog === true) {
        if (Array.isArray(data.class) === true) {
          data.class = [...data.class, "no-pointer-events"];
        } else {
          data.class += " no-pointer-events";
        }
      }
      return h("input", data);
    }
    function onInput(e2) {
      if (filterTimer !== null) {
        clearTimeout(filterTimer);
        filterTimer = null;
      }
      if (inputValueTimer !== null) {
        clearTimeout(inputValueTimer);
        inputValueTimer = null;
      }
      if (e2 && e2.target && e2.target.qComposing === true) {
        return;
      }
      setInputValue(e2.target.value || "");
      userInputValue = true;
      defaultInputValue = inputValue.value;
      if (state2.focused.value !== true && (hasDialog !== true || dialogFieldFocused.value === true)) {
        state2.focus();
      }
      if (props4.onFilter !== void 0) {
        filterTimer = setTimeout(() => {
          filterTimer = null;
          filter(inputValue.value);
        }, props4.inputDebounce);
      }
    }
    function setInputValue(val, emitImmediately) {
      if (inputValue.value !== val) {
        inputValue.value = val;
        if (emitImmediately === true || props4.inputDebounce === 0 || props4.inputDebounce === "0") {
          emit("inputValue", val);
        } else {
          inputValueTimer = setTimeout(() => {
            inputValueTimer = null;
            emit("inputValue", val);
          }, props4.inputDebounce);
        }
      }
    }
    function updateInputValue(val, noFiltering, internal) {
      userInputValue = internal !== true;
      if (props4.useInput === true) {
        setInputValue(val, true);
        if (noFiltering === true || internal !== true) {
          defaultInputValue = val;
        }
        noFiltering !== true && filter(val);
      }
    }
    function filter(val, keepClosed, afterUpdateFn) {
      if (props4.onFilter === void 0 || keepClosed !== true && state2.focused.value !== true) {
        return;
      }
      if (state2.innerLoading.value === true) {
        emit("filterAbort");
      } else {
        state2.innerLoading.value = true;
        innerLoadingIndicator.value = true;
      }
      if (val !== "" && props4.multiple !== true && innerValue.value.length !== 0 && userInputValue !== true && val === getOptionLabel.value(innerValue.value[0])) {
        val = "";
      }
      const localFilterId = setTimeout(() => {
        menu.value === true && (menu.value = false);
      }, 10);
      filterId !== null && clearTimeout(filterId);
      filterId = localFilterId;
      emit(
        "filter",
        val,
        (fn, afterFn) => {
          if ((keepClosed === true || state2.focused.value === true) && filterId === localFilterId) {
            clearTimeout(filterId);
            typeof fn === "function" && fn();
            innerLoadingIndicator.value = false;
            nextTick(() => {
              state2.innerLoading.value = false;
              if (state2.editable.value === true) {
                if (keepClosed === true) {
                  menu.value === true && hidePopup();
                } else if (menu.value === true) {
                  updateMenu(true);
                } else {
                  menu.value = true;
                }
              }
              typeof afterFn === "function" && nextTick(() => {
                afterFn(proxy);
              });
              typeof afterUpdateFn === "function" && nextTick(() => {
                afterUpdateFn(proxy);
              });
            });
          }
        },
        () => {
          if (state2.focused.value === true && filterId === localFilterId) {
            clearTimeout(filterId);
            state2.innerLoading.value = false;
            innerLoadingIndicator.value = false;
          }
          menu.value === true && (menu.value = false);
        }
      );
    }
    function getMenu() {
      return h(QMenu_default, {
        ref: menuRef,
        class: menuContentClass.value,
        style: props4.popupContentStyle,
        modelValue: menu.value,
        fit: props4.menuShrink !== true,
        cover: props4.optionsCover === true && noOptions.value !== true && props4.useInput !== true,
        anchor: props4.menuAnchor,
        self: props4.menuSelf,
        offset: props4.menuOffset,
        dark: isOptionsDark.value,
        noParentEvent: true,
        noRefocus: true,
        noFocus: true,
        noRouteDismiss: props4.popupNoRouteDismiss,
        square: squaredMenu.value,
        transitionShow: props4.transitionShow,
        transitionHide: props4.transitionHide,
        transitionDuration: props4.transitionDuration,
        separateClosePopup: true,
        ...listboxAttrs.value,
        onScrollPassive: onVirtualScrollEvt,
        onBeforeShow: onControlPopupShow,
        onBeforeHide: onMenuBeforeHide,
        onShow: onMenuShow
      }, getAllOptions);
    }
    function onMenuBeforeHide(e2) {
      onControlPopupHide(e2);
      closeMenu();
    }
    function onMenuShow() {
      setVirtualScrollSize();
    }
    function onDialogFieldFocus(e2) {
      stop(e2);
      targetRef.value !== null && targetRef.value.focus();
      dialogFieldFocused.value = true;
      window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, 0);
    }
    function onDialogFieldBlur(e2) {
      stop(e2);
      nextTick(() => {
        dialogFieldFocused.value = false;
      });
    }
    function getDialog() {
      const content = [
        h(QField_default, {
          class: `col-auto ${state2.fieldClass.value}`,
          ...innerFieldProps.value,
          for: state2.targetUid.value,
          dark: isOptionsDark.value,
          square: true,
          loading: innerLoadingIndicator.value,
          itemAligned: false,
          filled: true,
          stackLabel: inputValue.value.length !== 0,
          ...state2.splitAttrs.listeners.value,
          onFocus: onDialogFieldFocus,
          onBlur: onDialogFieldBlur
        }, {
          ...slots,
          rawControl: () => state2.getControl(true),
          before: void 0,
          after: void 0
        })
      ];
      menu.value === true && content.push(
        h("div", {
          ref: menuContentRef,
          class: menuContentClass.value + " scroll",
          style: props4.popupContentStyle,
          ...listboxAttrs.value,
          onClick: prevent,
          onScrollPassive: onVirtualScrollEvt
        }, getAllOptions())
      );
      return h(QDialog_default, {
        ref: dialogRef,
        modelValue: dialog.value,
        position: props4.useInput === true ? "top" : void 0,
        transitionShow: transitionShowComputed,
        transitionHide: props4.transitionHide,
        transitionDuration: props4.transitionDuration,
        noRouteDismiss: props4.popupNoRouteDismiss,
        onBeforeShow: onControlPopupShow,
        onBeforeHide: onDialogBeforeHide,
        onHide: onDialogHide,
        onShow: onDialogShow
      }, () => h("div", {
        class: "q-select__dialog" + (isOptionsDark.value === true ? " q-select__dialog--dark q-dark" : "") + (dialogFieldFocused.value === true ? " q-select__dialog--focused" : "")
      }, content));
    }
    function onDialogBeforeHide(e2) {
      onControlPopupHide(e2);
      if (dialogRef.value !== null) {
        dialogRef.value.__updateRefocusTarget(
          state2.rootRef.value.querySelector(".q-field__native > [tabindex]:last-child")
        );
      }
      state2.focused.value = false;
    }
    function onDialogHide(e2) {
      hidePopup();
      state2.focused.value === false && emit("blur", e2);
      resetInputValue();
    }
    function onDialogShow() {
      const el = document.activeElement;
      if ((el === null || el.id !== state2.targetUid.value) && targetRef.value !== null && targetRef.value !== el) {
        targetRef.value.focus();
      }
      setVirtualScrollSize();
    }
    function closeMenu() {
      if (dialog.value === true) {
        return;
      }
      optionIndex.value = -1;
      if (menu.value === true) {
        menu.value = false;
      }
      if (state2.focused.value === false) {
        if (filterId !== null) {
          clearTimeout(filterId);
          filterId = null;
        }
        if (state2.innerLoading.value === true) {
          emit("filterAbort");
          state2.innerLoading.value = false;
          innerLoadingIndicator.value = false;
        }
      }
    }
    function showPopup(e2) {
      if (state2.editable.value !== true) {
        return;
      }
      if (hasDialog === true) {
        state2.onControlFocusin(e2);
        dialog.value = true;
        nextTick(() => {
          state2.focus();
        });
      } else {
        state2.focus();
      }
      if (props4.onFilter !== void 0) {
        filter(inputValue.value);
      } else if (noOptions.value !== true || slots["no-option"] !== void 0) {
        menu.value = true;
      }
    }
    function hidePopup() {
      dialog.value = false;
      closeMenu();
    }
    function resetInputValue() {
      props4.useInput === true && updateInputValue(
        props4.multiple !== true && props4.fillInput === true && innerValue.value.length !== 0 ? getOptionLabel.value(innerValue.value[0]) || "" : "",
        true,
        true
      );
    }
    function updateMenu(show) {
      let optionIndex2 = -1;
      if (show === true) {
        if (innerValue.value.length !== 0) {
          const val = getOptionValue.value(innerValue.value[0]);
          optionIndex2 = props4.options.findIndex((v) => isDeepEqual(getOptionValue.value(v), val));
        }
        localResetVirtualScroll(optionIndex2);
      }
      setOptionIndex(optionIndex2);
    }
    function rerenderMenu(newLength, oldLength) {
      if (menu.value === true && state2.innerLoading.value === false) {
        localResetVirtualScroll(-1, true);
        nextTick(() => {
          if (menu.value === true && state2.innerLoading.value === false) {
            if (newLength > oldLength) {
              localResetVirtualScroll();
            } else {
              updateMenu(true);
            }
          }
        });
      }
    }
    function updateMenuPosition() {
      if (dialog.value === false && menuRef.value !== null) {
        menuRef.value.updatePosition();
      }
    }
    function onControlPopupShow(e2) {
      e2 !== void 0 && stop(e2);
      emit("popupShow", e2);
      state2.hasPopupOpen = true;
      state2.onControlFocusin(e2);
    }
    function onControlPopupHide(e2) {
      e2 !== void 0 && stop(e2);
      emit("popupHide", e2);
      state2.hasPopupOpen = false;
      state2.onControlFocusout(e2);
    }
    function updatePreState() {
      hasDialog = $q.platform.is.mobile !== true && props4.behavior !== "dialog" ? false : props4.behavior !== "menu" && (props4.useInput === true ? slots["no-option"] !== void 0 || props4.onFilter !== void 0 || noOptions.value === false : true);
      transitionShowComputed = $q.platform.is.ios === true && hasDialog === true && props4.useInput === true ? "fade" : props4.transitionShow;
    }
    onBeforeUpdate(updatePreState);
    onUpdated(updateMenuPosition);
    updatePreState();
    onBeforeUnmount(() => {
      filterTimer !== null && clearTimeout(filterTimer);
      inputValueTimer !== null && clearTimeout(inputValueTimer);
    });
    Object.assign(proxy, {
      showPopup,
      hidePopup,
      removeAtIndex,
      add: add2,
      toggleOption,
      getOptionIndex: () => optionIndex.value,
      setOptionIndex,
      moveOptionSelection,
      filter,
      updateMenuPosition,
      updateInputValue,
      isOptionSelected,
      getEmittingOptionValue,
      isOptionDisabled: (...args) => isOptionDisabled.value.apply(null, args) === true,
      getOptionValue: (...args) => getOptionValue.value.apply(null, args),
      getOptionLabel: (...args) => getOptionLabel.value.apply(null, args)
    });
    Object.assign(state2, {
      innerValue,
      fieldClass: computed(
        () => `q-select q-field--auto-height q-select--with${props4.useInput !== true ? "out" : ""}-input q-select--with${props4.useChips !== true ? "out" : ""}-chips q-select--${props4.multiple === true ? "multiple" : "single"}`
      ),
      inputRef,
      targetRef,
      hasValue,
      showPopup,
      floatingLabel: computed(
        () => props4.hideSelected !== true && hasValue.value === true || typeof inputValue.value === "number" || inputValue.value.length !== 0 || fieldValueIsFilled(props4.displayValue)
      ),
      getControlChild: () => {
        if (state2.editable.value !== false && (dialog.value === true || noOptions.value !== true || slots["no-option"] !== void 0)) {
          return hasDialog === true ? getDialog() : getMenu();
        } else if (state2.hasPopupOpen === true) {
          state2.hasPopupOpen = false;
        }
      },
      controlEvents: {
        onFocusin(e2) {
          state2.onControlFocusin(e2);
        },
        onFocusout(e2) {
          state2.onControlFocusout(e2, () => {
            resetInputValue();
            closeMenu();
          });
        },
        onClick(e2) {
          prevent(e2);
          if (hasDialog !== true && menu.value === true) {
            closeMenu();
            targetRef.value !== null && targetRef.value.focus();
            return;
          }
          showPopup(e2);
        }
      },
      getControl: (fromDialog) => {
        const child = getSelection2();
        const isTarget = fromDialog === true || dialog.value !== true || hasDialog !== true;
        if (props4.useInput === true) {
          child.push(getInput(fromDialog, isTarget));
        } else if (state2.editable.value === true) {
          const attrs2 = isTarget === true ? comboboxAttrs.value : void 0;
          child.push(
            h("input", {
              ref: isTarget === true ? targetRef : void 0,
              key: "d_t",
              class: "q-select__focus-target",
              id: isTarget === true ? state2.targetUid.value : void 0,
              value: ariaCurrentValue.value,
              readonly: true,
              "data-autofocus": fromDialog === true || props4.autofocus === true || void 0,
              ...attrs2,
              onKeydown: onTargetKeydown,
              onKeyup: onTargetKeyup,
              onKeypress: onTargetKeypress
            })
          );
          if (isTarget === true && typeof props4.autocomplete === "string" && props4.autocomplete.length !== 0) {
            child.push(
              h("input", {
                class: "q-select__autocomplete-input",
                autocomplete: props4.autocomplete,
                tabindex: -1,
                onKeyup: onTargetAutocomplete
              })
            );
          }
        }
        if (nameProp.value !== void 0 && props4.disable !== true && innerOptionsValue.value.length !== 0) {
          const opts = innerOptionsValue.value.map((value2) => h("option", { value: value2, selected: true }));
          child.push(
            h("select", {
              class: "hidden",
              name: nameProp.value,
              multiple: props4.multiple
            }, opts)
          );
        }
        const attrs = props4.useInput === true || isTarget !== true ? void 0 : state2.splitAttrs.attributes.value;
        return h("div", {
          class: "q-field__native row items-center",
          ...attrs,
          ...state2.splitAttrs.listeners.value
        }, child);
      },
      getInnerAppend: () => props4.loading !== true && innerLoadingIndicator.value !== true && props4.hideDropdownIcon !== true ? [
        h(QIcon_default, {
          class: "q-select__dropdown-icon" + (menu.value === true ? " rotate-180" : ""),
          name: dropdownArrowIcon.value
        })
      ] : null
    });
    return use_field_default(state2);
  }
});
var skeletonTypes = [
  "text",
  "rect",
  "circle",
  "QBtn",
  "QBadge",
  "QChip",
  "QToolbar",
  "QCheckbox",
  "QRadio",
  "QToggle",
  "QSlider",
  "QRange",
  "QInput",
  "QAvatar"
];
var skeletonAnimations = [
  "wave",
  "pulse",
  "pulse-x",
  "pulse-y",
  "fade",
  "blink",
  "none"
];
var QSkeleton_default = createComponent({
  name: "QSkeleton",
  props: {
    ...useDarkProps,
    tag: {
      type: String,
      default: "div"
    },
    type: {
      type: String,
      validator: (v) => skeletonTypes.includes(v),
      default: "rect"
    },
    animation: {
      type: String,
      validator: (v) => skeletonAnimations.includes(v),
      default: "wave"
    },
    animationSpeed: {
      type: [String, Number],
      default: 1500
    },
    square: Boolean,
    bordered: Boolean,
    size: String,
    width: String,
    height: String
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const style2 = computed(() => {
      const size2 = props4.size !== void 0 ? [props4.size, props4.size] : [props4.width, props4.height];
      return {
        "--q-skeleton-speed": `${props4.animationSpeed}ms`,
        width: size2[0],
        height: size2[1]
      };
    });
    const classes = computed(
      () => `q-skeleton q-skeleton--${isDark.value === true ? "dark" : "light"} q-skeleton--type-${props4.type}` + (props4.animation !== "none" ? ` q-skeleton--anim q-skeleton--anim-${props4.animation}` : "") + (props4.square === true ? " q-skeleton--square" : "") + (props4.bordered === true ? " q-skeleton--bordered" : "")
    );
    return () => h(props4.tag, {
      class: classes.value,
      style: style2.value
    }, hSlot(slots.default));
  }
});
var slotsDef = [
  ["left", "center", "start", "width"],
  ["right", "center", "end", "width"],
  ["top", "start", "center", "height"],
  ["bottom", "end", "center", "height"]
];
createComponent({
  name: "QSlideItem",
  props: {
    ...useDarkProps,
    leftColor: String,
    rightColor: String,
    topColor: String,
    bottomColor: String,
    onSlide: Function
  },
  emits: ["action", "top", "right", "bottom", "left"],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const { getCache } = use_render_cache_default();
    const contentRef = ref$1(null);
    let timer2 = null, pan = {}, dirRefs = {}, dirContentRefs = {};
    const langDir = computed(() => $q.lang.rtl === true ? { left: "right", right: "left" } : { left: "left", right: "right" });
    const classes = computed(
      () => "q-slide-item q-item-type overflow-hidden" + (isDark.value === true ? " q-slide-item--dark q-dark" : "")
    );
    function reset() {
      contentRef.value.style.transform = "translate(0,0)";
    }
    function emitSlide(side, ratio, isReset) {
      props4.onSlide !== void 0 && emit("slide", { side, ratio, isReset });
    }
    function onPan(evt) {
      const node = contentRef.value;
      if (evt.isFirst) {
        pan = {
          dir: null,
          size: { left: 0, right: 0, top: 0, bottom: 0 },
          scale: 0
        };
        node.classList.add("no-transition");
        slotsDef.forEach((slotName) => {
          if (slots[slotName[0]] !== void 0) {
            const node2 = dirContentRefs[slotName[0]];
            node2.style.transform = "scale(1)";
            pan.size[slotName[0]] = node2.getBoundingClientRect()[slotName[3]];
          }
        });
        pan.axis = evt.direction === "up" || evt.direction === "down" ? "Y" : "X";
      } else if (evt.isFinal) {
        node.classList.remove("no-transition");
        if (pan.scale === 1) {
          node.style.transform = `translate${pan.axis}(${pan.dir * 100}%)`;
          timer2 !== null && clearTimeout(timer2);
          timer2 = setTimeout(() => {
            timer2 = null;
            emit(pan.showing, { reset });
            emit("action", { side: pan.showing, reset });
          }, 230);
        } else {
          node.style.transform = "translate(0,0)";
          emitSlide(pan.showing, 0, true);
        }
        return;
      } else {
        evt.direction = pan.axis === "X" ? evt.offset.x < 0 ? "left" : "right" : evt.offset.y < 0 ? "up" : "down";
      }
      if (slots.left === void 0 && evt.direction === langDir.value.right || slots.right === void 0 && evt.direction === langDir.value.left || slots.top === void 0 && evt.direction === "down" || slots.bottom === void 0 && evt.direction === "up") {
        node.style.transform = "translate(0,0)";
        return;
      }
      let showing, dir, dist;
      if (pan.axis === "X") {
        dir = evt.direction === "left" ? -1 : 1;
        showing = dir === 1 ? langDir.value.left : langDir.value.right;
        dist = evt.distance.x;
      } else {
        dir = evt.direction === "up" ? -2 : 2;
        showing = dir === 2 ? "top" : "bottom";
        dist = evt.distance.y;
      }
      if (pan.dir !== null && Math.abs(dir) !== Math.abs(pan.dir)) {
        return;
      }
      if (pan.dir !== dir) {
        ["left", "right", "top", "bottom"].forEach((d3) => {
          if (dirRefs[d3]) {
            dirRefs[d3].style.visibility = showing === d3 ? "visible" : "hidden";
          }
        });
        pan.showing = showing;
        pan.dir = dir;
      }
      pan.scale = Math.max(0, Math.min(1, (dist - 40) / pan.size[showing]));
      node.style.transform = `translate${pan.axis}(${dist * dir / Math.abs(dir)}px)`;
      dirContentRefs[showing].style.transform = `scale(${pan.scale})`;
      emitSlide(showing, pan.scale, false);
    }
    onBeforeUpdate(() => {
      dirRefs = {};
      dirContentRefs = {};
    });
    onBeforeUnmount(() => {
      timer2 !== null && clearTimeout(timer2);
    });
    Object.assign(proxy, { reset });
    return () => {
      const content = [], slotsList = {
        left: slots[langDir.value.right] !== void 0,
        right: slots[langDir.value.left] !== void 0,
        up: slots.bottom !== void 0,
        down: slots.top !== void 0
      }, dirs = Object.keys(slotsList).filter((key) => slotsList[key] === true);
      slotsDef.forEach((slotName) => {
        const dir = slotName[0];
        if (slots[dir] !== void 0) {
          content.push(
            h("div", {
              key: dir,
              ref: (el) => {
                dirRefs[dir] = el;
              },
              class: `q-slide-item__${dir} absolute-full row no-wrap items-${slotName[1]} justify-${slotName[2]}` + (props4[dir + "Color"] !== void 0 ? ` bg-${props4[dir + "Color"]}` : "")
            }, [
              h("div", { ref: (el) => {
                dirContentRefs[dir] = el;
              } }, slots[dir]())
            ])
          );
        }
      });
      const node = h("div", {
        key: `${dirs.length === 0 ? "only-" : ""} content`,
        ref: contentRef,
        class: "q-slide-item__content"
      }, hSlot(slots.default));
      if (dirs.length === 0) {
        content.push(node);
      } else {
        content.push(
          withDirectives(node, getCache("dir#" + dirs.join(""), () => {
            const modifiers = {
              prevent: true,
              stop: true,
              mouse: true
            };
            dirs.forEach((dir) => {
              modifiers[dir] = true;
            });
            return [[
              TouchPan_default,
              onPan,
              void 0,
              modifiers
            ]];
          }))
        );
      }
      return h("div", { class: classes.value }, content);
    };
  }
});
var QSpace_default = createComponent({
  name: "QSpace",
  setup() {
    const space = h("div", { class: "q-space" });
    return () => space;
  }
});
var innerHTML = '<g transform="matrix(1 0 0 -1 0 80)"><rect width="10" height="20" rx="3"><animate attributeName="height" begin="0s" dur="4.3s" values="20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="15" width="10" height="80" rx="3"><animate attributeName="height" begin="0s" dur="2s" values="80;55;33;5;75;23;73;33;12;14;60;80" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="30" width="10" height="50" rx="3"><animate attributeName="height" begin="0s" dur="1.4s" values="50;34;78;23;56;23;34;76;80;54;21;50" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="45" width="10" height="30" rx="3"><animate attributeName="height" begin="0s" dur="2s" values="30;45;13;80;56;72;45;76;34;23;67;30" calcMode="linear" repeatCount="indefinite"></animate></rect></g>';
createComponent({
  name: "QSpinnerAudio",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 55 80",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML
    });
  }
});
var innerHTML2 = '<g transform="translate(1 1)" stroke-width="2" fill="none" fill-rule="evenodd"><circle cx="5" cy="50" r="5"><animate attributeName="cy" begin="0s" dur="2.2s" values="50;5;50;50" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="cx" begin="0s" dur="2.2s" values="5;27;49;5" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="27" cy="5" r="5"><animate attributeName="cy" begin="0s" dur="2.2s" from="5" to="5" values="5;50;50;5" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="cx" begin="0s" dur="2.2s" from="27" to="27" values="27;49;5;27" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="49" cy="50" r="5"><animate attributeName="cy" begin="0s" dur="2.2s" values="50;50;5;50" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="cx" from="49" to="49" begin="0s" dur="2.2s" values="49;5;27;49" calcMode="linear" repeatCount="indefinite"></animate></circle></g>';
createComponent({
  name: "QSpinnerBall",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      stroke: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 57 57",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML2
    });
  }
});
var innerHTML3 = '<rect y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="30" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="60" width="15" height="140" rx="6"><animate attributeName="height" begin="0s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="90" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.25s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.25s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect><rect x="120" y="10" width="15" height="120" rx="6"><animate attributeName="height" begin="0.5s" dur="1s" values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="y" begin="0.5s" dur="1s" values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear" repeatCount="indefinite"></animate></rect>';
createComponent({
  name: "QSpinnerBars",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 135 140",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML3
    });
  }
});
var innerHTML4 = '<rect x="25" y="25" width="50" height="50" fill="none" stroke-width="4" stroke="currentColor"><animateTransform id="spinnerBox" attributeName="transform" type="rotate" from="0 50 50" to="180 50 50" dur="0.5s" begin="rectBox.end"></animateTransform></rect><rect x="27" y="27" width="46" height="50" fill="currentColor"><animate id="rectBox" attributeName="height" begin="0s;spinnerBox.end" dur="1.3s" from="50" to="0" fill="freeze"></animate></rect>';
createComponent({
  name: "QSpinnerBox",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML4
    });
  }
});
var innerHTML5 = '<circle cx="50" cy="50" r="48" fill="none" stroke-width="4" stroke-miterlimit="10" stroke="currentColor"></circle><line stroke-linecap="round" stroke-width="4" stroke-miterlimit="10" stroke="currentColor" x1="50" y1="50" x2="85" y2="50.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="2s" repeatCount="indefinite"></animateTransform></line><line stroke-linecap="round" stroke-width="4" stroke-miterlimit="10" stroke="currentColor" x1="50" y1="50" x2="49.5" y2="74"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="15s" repeatCount="indefinite"></animateTransform></line>';
createComponent({
  name: "QSpinnerClock",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML5
    });
  }
});
var innerHTML6 = '<rect x="0" y="0" width="100" height="100" fill="none"></rect><path d="M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z" fill="currentColor"></path><circle cx="30" cy="47" r="5" fill="#fff"><animate attributeName="opacity" from="0" to="1" values="0;1;1" keyTimes="0;0.2;1" dur="1s" repeatCount="indefinite"></animate></circle><circle cx="50" cy="47" r="5" fill="#fff"><animate attributeName="opacity" from="0" to="1" values="0;0;1;1" keyTimes="0;0.2;0.4;1" dur="1s" repeatCount="indefinite"></animate></circle><circle cx="70" cy="47" r="5" fill="#fff"><animate attributeName="opacity" from="0" to="1" values="0;0;1;1" keyTimes="0;0.4;0.6;1" dur="1s" repeatCount="indefinite"></animate></circle>';
createComponent({
  name: "QSpinnerComment",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      innerHTML: innerHTML6
    });
  }
});
var innerHTML7 = '<rect x="0" y="0" width="100" height="100" fill="none"></rect><g transform="translate(25 25)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.9"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g><g transform="translate(75 25)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.8"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0.1s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g><g transform="translate(25 75)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.7"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0.3s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g><g transform="translate(75 75)"><rect x="-20" y="-20" width="40" height="40" fill="currentColor" opacity="0.6"><animateTransform attributeName="transform" type="scale" from="1.5" to="1" repeatCount="indefinite" begin="0.2s" dur="1s" calcMode="spline" keySplines="0.2 0.8 0.2 0.8" keyTimes="0;1"></animateTransform></rect></g>';
createComponent({
  name: "QSpinnerCube",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      innerHTML: innerHTML7
    });
  }
});
var innerHTML8 = '<circle cx="15" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="60" cy="15" r="9" fill-opacity=".3"><animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from=".5" to=".5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="105" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate></circle>';
createComponent({
  name: "QSpinnerDots",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 120 30",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML8
    });
  }
});
var innerHTML9 = '<g transform="translate(20 50)"><rect x="-10" y="-30" width="20" height="60" fill="currentColor" opacity="0.6"><animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform></rect></g><g transform="translate(50 50)"><rect x="-10" y="-30" width="20" height="60" fill="currentColor" opacity="0.8"><animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0.1s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform></rect></g><g transform="translate(80 50)"><rect x="-10" y="-30" width="20" height="60" fill="currentColor" opacity="0.9"><animateTransform attributeName="transform" type="scale" from="2" to="1" begin="0.2s" repeatCount="indefinite" dur="1s" calcMode="spline" keySplines="0.1 0.9 0.4 1" keyTimes="0;1" values="2;1"></animateTransform></rect></g>';
createComponent({
  name: "QSpinnerFacebook",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "xMidYMid",
      innerHTML: innerHTML9
    });
  }
});
var innerHTML10 = '<g transform="translate(-20,-20)"><path d="M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z" fill="currentColor"><animateTransform attributeName="transform" type="rotate" from="90 50 50" to="0 50 50" dur="1s" repeatCount="indefinite"></animateTransform></path></g><g transform="translate(20,20) rotate(15 50 50)"><path d="M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z" fill="currentColor"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="90 50 50" dur="1s" repeatCount="indefinite"></animateTransform></path></g>';
createComponent({
  name: "QSpinnerGears",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML10
    });
  }
});
var innerHTML11 = '<circle cx="12.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="0s" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="12.5" cy="52.5" r="12.5" fill-opacity=".5"><animate attributeName="fill-opacity" begin="100ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="52.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="300ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="52.5" cy="52.5" r="12.5"><animate attributeName="fill-opacity" begin="600ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="92.5" cy="12.5" r="12.5"><animate attributeName="fill-opacity" begin="800ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="92.5" cy="52.5" r="12.5"><animate attributeName="fill-opacity" begin="400ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="12.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="700ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="52.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="500ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="92.5" cy="92.5" r="12.5"><animate attributeName="fill-opacity" begin="200ms" dur="1s" values="1;.2;1" calcMode="linear" repeatCount="indefinite"></animate></circle>';
createComponent({
  name: "QSpinnerGrid",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 105 105",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML11
    });
  }
});
var innerHTML12 = '<path d="M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.716-6.002 11.47-7.65 17.304-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z" fill-opacity=".5"><animate attributeName="fill-opacity" begin="0s" dur="1.4s" values="0.5;1;0.5" calcMode="linear" repeatCount="indefinite"></animate></path><path d="M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.593-2.32 17.308 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z" fill-opacity=".5"><animate attributeName="fill-opacity" begin="0.7s" dur="1.4s" values="0.5;1;0.5" calcMode="linear" repeatCount="indefinite"></animate></path><path d="M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"></path>';
createComponent({
  name: "QSpinnerHearts",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      fill: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 140 64",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML12
    });
  }
});
var innerHTML13 = '<g><path fill="none" stroke="currentColor" stroke-width="5" stroke-miterlimit="10" d="M58.4,51.7c-0.9-0.9-1.4-2-1.4-2.3s0.5-0.4,1.4-1.4 C70.8,43.8,79.8,30.5,80,15.5H70H30H20c0.2,15,9.2,28.1,21.6,32.3c0.9,0.9,1.4,1.2,1.4,1.5s-0.5,1.6-1.4,2.5 C29.2,56.1,20.2,69.5,20,85.5h10h40h10C79.8,69.5,70.8,55.9,58.4,51.7z"></path><clipPath id="uil-hourglass-clip1"><rect x="15" y="20" width="70" height="25"><animate attributeName="height" from="25" to="0" dur="1s" repeatCount="indefinite" values="25;0;0" keyTimes="0;0.5;1"></animate><animate attributeName="y" from="20" to="45" dur="1s" repeatCount="indefinite" values="20;45;45" keyTimes="0;0.5;1"></animate></rect></clipPath><clipPath id="uil-hourglass-clip2"><rect x="15" y="55" width="70" height="25"><animate attributeName="height" from="0" to="25" dur="1s" repeatCount="indefinite" values="0;25;25" keyTimes="0;0.5;1"></animate><animate attributeName="y" from="80" to="55" dur="1s" repeatCount="indefinite" values="80;55;55" keyTimes="0;0.5;1"></animate></rect></clipPath><path d="M29,23c3.1,11.4,11.3,19.5,21,19.5S67.9,34.4,71,23H29z" clip-path="url(#uil-hourglass-clip1)" fill="currentColor"></path><path d="M71.6,78c-3-11.6-11.5-20-21.5-20s-18.5,8.4-21.5,20H71.6z" clip-path="url(#uil-hourglass-clip2)" fill="currentColor"></path><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="180 50 50" repeatCount="indefinite" dur="1s" values="0 50 50;0 50 50;180 50 50" keyTimes="0;0.7;1"></animateTransform></g>';
createComponent({
  name: "QSpinnerHourglass",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML13
    });
  }
});
var innerHTML14 = '<path d="M24.3,30C11.4,30,5,43.3,5,50s6.4,20,19.3,20c19.3,0,32.1-40,51.4-40C88.6,30,95,43.3,95,50s-6.4,20-19.3,20C56.4,70,43.6,30,24.3,30z" fill="none" stroke="currentColor" stroke-width="8" stroke-dasharray="10.691205342610678 10.691205342610678" stroke-dashoffset="0"><animate attributeName="stroke-dashoffset" from="0" to="21.382410685221355" begin="0" dur="2s" repeatCount="indefinite" fill="freeze"></animate></path>';
createComponent({
  name: "QSpinnerInfinity",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      innerHTML: innerHTML14
    });
  }
});
var innerHTML15 = '<g stroke-width="4" stroke-linecap="round"><line y1="17" y2="29" transform="translate(32,32) rotate(180)"><animate attributeName="stroke-opacity" dur="750ms" values="1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(210)"><animate attributeName="stroke-opacity" dur="750ms" values="0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(240)"><animate attributeName="stroke-opacity" dur="750ms" values=".1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(270)"><animate attributeName="stroke-opacity" dur="750ms" values=".15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(300)"><animate attributeName="stroke-opacity" dur="750ms" values=".25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(330)"><animate attributeName="stroke-opacity" dur="750ms" values=".35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(0)"><animate attributeName="stroke-opacity" dur="750ms" values=".45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(30)"><animate attributeName="stroke-opacity" dur="750ms" values=".55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(60)"><animate attributeName="stroke-opacity" dur="750ms" values=".65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(90)"><animate attributeName="stroke-opacity" dur="750ms" values=".7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(120)"><animate attributeName="stroke-opacity" dur="750ms" values=".85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85" repeatCount="indefinite"></animate></line><line y1="17" y2="29" transform="translate(32,32) rotate(150)"><animate attributeName="stroke-opacity" dur="750ms" values="1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1" repeatCount="indefinite"></animate></line></g>';
createComponent({
  name: "QSpinnerIos",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      stroke: "currentColor",
      fill: "currentColor",
      viewBox: "0 0 64 64",
      innerHTML: innerHTML15
    });
  }
});
var innerHTML16 = '<circle cx="50" cy="50" r="44" fill="none" stroke-width="4" stroke-opacity=".5" stroke="currentColor"></circle><circle cx="8" cy="54" r="6" fill="currentColor" stroke-width="3" stroke="currentColor"><animateTransform attributeName="transform" type="rotate" from="0 50 48" to="360 50 52" dur="2s" repeatCount="indefinite"></animateTransform></circle>';
createComponent({
  name: "QSpinnerOrbit",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML16
    });
  }
});
var innerHTML17 = '<g transform="translate(1 1)" stroke-width="2" fill="none" fill-rule="evenodd"><circle stroke-opacity=".5" cx="18" cy="18" r="18"></circle><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"></animateTransform></path></g>';
createComponent({
  name: "QSpinnerOval",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      stroke: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML17
    });
  }
});
var innerHTML18 = '<path d="M0 50A50 50 0 0 1 50 0L50 50L0 50" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="0.8s" repeatCount="indefinite"></animateTransform></path><path d="M50 0A50 50 0 0 1 100 50L50 50L50 0" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="1.6s" repeatCount="indefinite"></animateTransform></path><path d="M100 50A50 50 0 0 1 50 100L50 50L100 50" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="2.4s" repeatCount="indefinite"></animateTransform></path><path d="M50 100A50 50 0 0 1 0 50L50 50L50 100" fill="currentColor" opacity="0.5"><animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="3.2s" repeatCount="indefinite"></animateTransform></path>';
createComponent({
  name: "QSpinnerPie",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML18
    });
  }
});
var innerHTML19 = '<g fill="none" fill-rule="evenodd" stroke-width="2"><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="0s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="0s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate></circle><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="-0.9s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="-0.9s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite"></animate></circle></g>';
createComponent({
  name: "QSpinnerPuff",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      stroke: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 44 44",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML19
    });
  }
});
var innerHTML20 = '<g transform="scale(0.55)"><circle cx="30" cy="150" r="30" fill="currentColor"><animate attributeName="opacity" from="0" to="1" dur="1s" begin="0" repeatCount="indefinite" keyTimes="0;0.5;1" values="0;1;1"></animate></circle><path d="M90,150h30c0-49.7-40.3-90-90-90v30C63.1,90,90,116.9,90,150z" fill="currentColor"><animate attributeName="opacity" from="0" to="1" dur="1s" begin="0.1" repeatCount="indefinite" keyTimes="0;0.5;1" values="0;1;1"></animate></path><path d="M150,150h30C180,67.2,112.8,0,30,0v30C96.3,30,150,83.7,150,150z" fill="currentColor"><animate attributeName="opacity" from="0" to="1" dur="1s" begin="0.2" repeatCount="indefinite" keyTimes="0;0.5;1" values="0;1;1"></animate></path></g>';
createComponent({
  name: "QSpinnerRadio",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML20
    });
  }
});
var innerHTML21 = '<g fill="none" fill-rule="evenodd" transform="translate(1 1)" stroke-width="2"><circle cx="22" cy="22" r="6"><animate attributeName="r" begin="1.5s" dur="3s" values="6;22" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="1.5s" dur="3s" values="1;0" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-width" begin="1.5s" dur="3s" values="2;0" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="22" cy="22" r="6"><animate attributeName="r" begin="3s" dur="3s" values="6;22" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-opacity" begin="3s" dur="3s" values="1;0" calcMode="linear" repeatCount="indefinite"></animate><animate attributeName="stroke-width" begin="3s" dur="3s" values="2;0" calcMode="linear" repeatCount="indefinite"></animate></circle><circle cx="22" cy="22" r="8"><animate attributeName="r" begin="0s" dur="1.5s" values="6;1;2;3;4;5;6" calcMode="linear" repeatCount="indefinite"></animate></circle></g>';
createComponent({
  name: "QSpinnerRings",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      stroke: "currentColor",
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 45 45",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML21
    });
  }
});
var innerHTML22 = '<defs><linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a"><stop stop-color="currentColor" stop-opacity="0" offset="0%"></stop><stop stop-color="currentColor" stop-opacity=".631" offset="63.146%"></stop><stop stop-color="currentColor" offset="100%"></stop></linearGradient></defs><g transform="translate(1 1)" fill="none" fill-rule="evenodd"><path d="M36 18c0-9.94-8.06-18-18-18" stroke="url(#a)" stroke-width="2"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"></animateTransform></path><circle fill="currentColor" cx="36" cy="18" r="1"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"></animateTransform></circle></g>';
createComponent({
  name: "QSpinnerTail",
  props: useSpinnerProps,
  setup(props4) {
    const { cSize, classes } = useSpinner(props4);
    return () => h("svg", {
      class: classes.value,
      width: cSize.value,
      height: cSize.value,
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg",
      innerHTML: innerHTML22
    });
  }
});
createComponent({
  name: "QSplitter",
  props: {
    ...useDarkProps,
    modelValue: {
      type: Number,
      required: true
    },
    reverse: Boolean,
    unit: {
      type: String,
      default: "%",
      validator: (v) => ["%", "px"].includes(v)
    },
    limits: {
      type: Array,
      validator: (v) => {
        if (v.length !== 2) return false;
        if (typeof v[0] !== "number" || typeof v[1] !== "number") return false;
        return v[0] >= 0 && v[0] <= v[1];
      }
    },
    emitImmediately: Boolean,
    horizontal: Boolean,
    disable: Boolean,
    beforeClass: [Array, String, Object],
    afterClass: [Array, String, Object],
    separatorClass: [Array, String, Object],
    separatorStyle: [Array, String, Object]
  },
  emits: ["update:modelValue"],
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const isDark = use_dark_default(props4, $q);
    const rootRef = ref$1(null);
    const sideRefs = {
      before: ref$1(null),
      after: ref$1(null)
    };
    const classes = computed(
      () => `q-splitter no-wrap ${props4.horizontal === true ? "q-splitter--horizontal column" : "q-splitter--vertical row"} q-splitter--${props4.disable === true ? "disabled" : "workable"}` + (isDark.value === true ? " q-splitter--dark" : "")
    );
    const propName = computed(() => props4.horizontal === true ? "height" : "width");
    const side = computed(() => props4.reverse !== true ? "before" : "after");
    const computedLimits = computed(() => props4.limits !== void 0 ? props4.limits : props4.unit === "%" ? [10, 90] : [50, Infinity]);
    function getCSSValue(value2) {
      return (props4.unit === "%" ? value2 : Math.round(value2)) + props4.unit;
    }
    const styles = computed(() => ({
      [side.value]: {
        [propName.value]: getCSSValue(props4.modelValue)
      }
    }));
    let __dir, __maxValue, __value, __multiplier, __normalized;
    function pan(evt) {
      if (evt.isFirst === true) {
        const size2 = rootRef.value.getBoundingClientRect()[propName.value];
        __dir = props4.horizontal === true ? "up" : "left";
        __maxValue = props4.unit === "%" ? 100 : size2;
        __value = Math.min(__maxValue, computedLimits.value[1], Math.max(computedLimits.value[0], props4.modelValue));
        __multiplier = (props4.reverse !== true ? 1 : -1) * (props4.horizontal === true ? 1 : $q.lang.rtl === true ? -1 : 1) * (props4.unit === "%" ? size2 === 0 ? 0 : 100 / size2 : 1);
        rootRef.value.classList.add("q-splitter--active");
        return;
      }
      if (evt.isFinal === true) {
        if (__normalized !== props4.modelValue) {
          emit("update:modelValue", __normalized);
        }
        rootRef.value.classList.remove("q-splitter--active");
        return;
      }
      const val = __value + __multiplier * (evt.direction === __dir ? -1 : 1) * evt.distance[props4.horizontal === true ? "y" : "x"];
      __normalized = Math.min(__maxValue, computedLimits.value[1], Math.max(computedLimits.value[0], val));
      sideRefs[side.value].value.style[propName.value] = getCSSValue(__normalized);
      if (props4.emitImmediately === true && props4.modelValue !== __normalized) {
        emit("update:modelValue", __normalized);
      }
    }
    const sepDirective = computed(() => {
      return [[
        TouchPan_default,
        pan,
        void 0,
        {
          [props4.horizontal === true ? "vertical" : "horizontal"]: true,
          prevent: true,
          stop: true,
          mouse: true,
          mouseAllDir: true
        }
      ]];
    });
    function normalize2(val, limits) {
      if (val < limits[0]) {
        emit("update:modelValue", limits[0]);
      } else if (val > limits[1]) {
        emit("update:modelValue", limits[1]);
      }
    }
    watch(() => props4.modelValue, (v) => {
      normalize2(v, computedLimits.value);
    });
    watch(() => props4.limits, () => {
      nextTick(() => {
        normalize2(props4.modelValue, computedLimits.value);
      });
    });
    return () => {
      const child = [
        h("div", {
          ref: sideRefs.before,
          class: [
            "q-splitter__panel q-splitter__before" + (props4.reverse === true ? " col" : ""),
            props4.beforeClass
          ],
          style: styles.value.before
        }, hSlot(slots.before)),
        h("div", {
          class: [
            "q-splitter__separator",
            props4.separatorClass
          ],
          style: props4.separatorStyle,
          "aria-disabled": props4.disable === true ? "true" : void 0
        }, [
          hDir(
            "div",
            { class: "q-splitter__separator-area absolute-full" },
            hSlot(slots.separator),
            "sep",
            props4.disable !== true,
            () => sepDirective.value
          )
        ]),
        h("div", {
          ref: sideRefs.after,
          class: [
            "q-splitter__panel q-splitter__after" + (props4.reverse === true ? "" : " col"),
            props4.afterClass
          ],
          style: styles.value.after
        }, hSlot(slots.after))
      ];
      return h("div", {
        class: classes.value,
        ref: rootRef
      }, hMergeSlot(slots.default, child));
    };
  }
});
var StepHeader_default = createComponent({
  name: "StepHeader",
  props: {
    stepper: {},
    step: {},
    goToPanel: Function
  },
  setup(props4, { attrs }) {
    const { proxy: { $q } } = getCurrentInstance();
    const blurRef = ref$1(null);
    const isActive = computed(() => props4.stepper.modelValue === props4.step.name);
    const isDisable = computed(() => {
      const opt = props4.step.disable;
      return opt === true || opt === "";
    });
    const isError2 = computed(() => {
      const opt = props4.step.error;
      return opt === true || opt === "";
    });
    const isDone = computed(() => {
      const opt = props4.step.done;
      return isDisable.value === false && (opt === true || opt === "");
    });
    const headerNav = computed(() => {
      const opt = props4.step.headerNav, nav = opt === true || opt === "" || opt === void 0;
      return isDisable.value === false && props4.stepper.headerNav && nav;
    });
    const hasPrefix = computed(() => {
      return props4.step.prefix && (isActive.value === false || props4.stepper.activeIcon === "none") && (isError2.value === false || props4.stepper.errorIcon === "none") && (isDone.value === false || props4.stepper.doneIcon === "none");
    });
    const icon = computed(() => {
      const defaultIcon = props4.step.icon || props4.stepper.inactiveIcon;
      if (isActive.value === true) {
        const icon2 = props4.step.activeIcon || props4.stepper.activeIcon;
        return icon2 === "none" ? defaultIcon : icon2 || $q.iconSet.stepper.active;
      }
      if (isError2.value === true) {
        const icon2 = props4.step.errorIcon || props4.stepper.errorIcon;
        return icon2 === "none" ? defaultIcon : icon2 || $q.iconSet.stepper.error;
      }
      if (isDisable.value === false && isDone.value === true) {
        const icon2 = props4.step.doneIcon || props4.stepper.doneIcon;
        return icon2 === "none" ? defaultIcon : icon2 || $q.iconSet.stepper.done;
      }
      return defaultIcon;
    });
    const color = computed(() => {
      const errorColor = isError2.value === true ? props4.step.errorColor || props4.stepper.errorColor : void 0;
      if (isActive.value === true) {
        const color2 = props4.step.activeColor || props4.stepper.activeColor || props4.step.color;
        return color2 !== void 0 ? color2 : errorColor;
      }
      if (errorColor !== void 0) {
        return errorColor;
      }
      if (isDisable.value === false && isDone.value === true) {
        return props4.step.doneColor || props4.stepper.doneColor || props4.step.color || props4.stepper.inactiveColor;
      }
      return props4.step.color || props4.stepper.inactiveColor;
    });
    const classes = computed(() => {
      return "q-stepper__tab col-grow flex items-center no-wrap relative-position" + (color.value !== void 0 ? ` text-${color.value}` : "") + (isError2.value === true ? " q-stepper__tab--error q-stepper__tab--error-with-" + (hasPrefix.value === true ? "prefix" : "icon") : "") + (isActive.value === true ? " q-stepper__tab--active" : "") + (isDone.value === true ? " q-stepper__tab--done" : "") + (headerNav.value === true ? " q-stepper__tab--navigation q-focusable q-hoverable" : "") + (isDisable.value === true ? " q-stepper__tab--disabled" : "");
    });
    const ripple = computed(() => props4.stepper.headerNav !== true ? false : headerNav.value);
    function onActivate() {
      blurRef.value !== null && blurRef.value.focus();
      isActive.value === false && props4.goToPanel(props4.step.name);
    }
    function onKeyup2(e2) {
      if (e2.keyCode === 13 && isActive.value === false) {
        props4.goToPanel(props4.step.name);
      }
    }
    return () => {
      const data = { class: classes.value };
      if (headerNav.value === true) {
        data.onClick = onActivate;
        data.onKeyup = onKeyup2;
        Object.assign(
          data,
          isDisable.value === true ? { tabindex: -1, "aria-disabled": "true" } : { tabindex: attrs.tabindex || 0 }
        );
      }
      const child = [
        h("div", { class: "q-focus-helper", tabindex: -1, ref: blurRef }),
        h("div", { class: "q-stepper__dot row flex-center q-stepper__line relative-position" }, [
          h("span", { class: "row flex-center" }, [
            hasPrefix.value === true ? props4.step.prefix : h(QIcon_default, { name: icon.value })
          ])
        ])
      ];
      if (props4.step.title !== void 0 && props4.step.title !== null) {
        const content = [
          h("div", { class: "q-stepper__title" }, props4.step.title)
        ];
        if (props4.step.caption !== void 0 && props4.step.caption !== null) {
          content.push(
            h("div", { class: "q-stepper__caption" }, props4.step.caption)
          );
        }
        child.push(
          h("div", {
            class: "q-stepper__label q-stepper__line relative-position"
          }, content)
        );
      }
      return withDirectives(
        h("div", data, child),
        [[Ripple_default, ripple.value]]
      );
    };
  }
});
function getStepWrapper(slots) {
  return h("div", {
    class: "q-stepper__step-content"
  }, [
    h("div", {
      class: "q-stepper__step-inner"
    }, hSlot(slots.default))
  ]);
}
var PanelWrapper2 = {
  setup(_, { slots }) {
    return () => getStepWrapper(slots);
  }
};
createComponent({
  name: "QStep",
  props: {
    ...usePanelChildProps,
    icon: String,
    color: String,
    title: {
      type: String,
      required: true
    },
    caption: String,
    prefix: [String, Number],
    doneIcon: String,
    doneColor: String,
    activeIcon: String,
    activeColor: String,
    errorIcon: String,
    errorColor: String,
    headerNav: {
      type: Boolean,
      default: true
    },
    done: Boolean,
    error: Boolean,
    onScroll: [Function, Array]
  },
  setup(props4, { slots, emit }) {
    const { proxy: { $q } } = getCurrentInstance();
    const $stepper = inject(stepperKey, emptyRenderFn);
    if ($stepper === emptyRenderFn) {
      console.error("QStep needs to be a child of QStepper");
      return emptyRenderFn;
    }
    const { getCache } = use_render_cache_default();
    const rootRef = ref$1(null);
    const isActive = computed(() => $stepper.value.modelValue === props4.name);
    const scrollEvent = computed(() => $q.platform.is.ios !== true && $q.platform.is.chrome === true || isActive.value !== true || $stepper.value.vertical !== true ? {} : {
      onScroll(e2) {
        const { target: target2 } = e2;
        if (target2.scrollTop > 0) {
          target2.scrollTop = 0;
        }
        props4.onScroll !== void 0 && emit("scroll", e2);
      }
    });
    const contentKey = computed(() => typeof props4.name === "string" || typeof props4.name === "number" ? props4.name : String(props4.name));
    function getStepContent() {
      const vertical = $stepper.value.vertical;
      if (vertical === true && $stepper.value.keepAlive === true) {
        return h(
          KeepAlive,
          $stepper.value.keepAliveProps.value,
          isActive.value === true ? [
            h(
              $stepper.value.needsUniqueKeepAliveWrapper.value === true ? getCache(contentKey.value, () => ({ ...PanelWrapper2, name: contentKey.value })) : PanelWrapper2,
              { key: contentKey.value },
              slots.default
            )
          ] : void 0
        );
      }
      return vertical !== true || isActive.value === true ? getStepWrapper(slots) : void 0;
    }
    return () => h(
      "div",
      { ref: rootRef, class: "q-stepper__step", role: "tabpanel", ...scrollEvent.value },
      $stepper.value.vertical === true ? [
        h(StepHeader_default, {
          stepper: $stepper.value,
          step: props4,
          goToPanel: $stepper.value.goToPanel
        }),
        $stepper.value.animated === true ? h(QSlideTransition_default, getStepContent) : getStepContent()
      ] : [getStepContent()]
    );
  }
});
var camelRE = /(-\w)/g;
function camelizeProps(props4) {
  const acc = {};
  for (const key in props4) {
    const newKey = key.replace(camelRE, (m3) => m3[1].toUpperCase());
    acc[newKey] = props4[key];
  }
  return acc;
}
createComponent({
  name: "QStepper",
  props: {
    ...useDarkProps,
    ...usePanelProps,
    flat: Boolean,
    bordered: Boolean,
    alternativeLabels: Boolean,
    headerNav: Boolean,
    contracted: Boolean,
    headerClass: String,
    inactiveColor: String,
    inactiveIcon: String,
    doneIcon: String,
    doneColor: String,
    activeIcon: String,
    activeColor: String,
    errorIcon: String,
    errorColor: String
  },
  emits: usePanelEmits,
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    const {
      updatePanelsList,
      isValidPanelName,
      updatePanelIndex,
      getPanelContent,
      getPanels,
      panelDirectives,
      goToPanel,
      keepAliveProps,
      needsUniqueKeepAliveWrapper
    } = use_panel_default();
    provide(stepperKey, computed(() => ({
      goToPanel,
      keepAliveProps,
      needsUniqueKeepAliveWrapper,
      ...props4
    })));
    const classes = computed(
      () => `q-stepper q-stepper--${props4.vertical === true ? "vertical" : "horizontal"}` + (props4.flat === true ? " q-stepper--flat" : "") + (props4.bordered === true ? " q-stepper--bordered" : "") + (isDark.value === true ? " q-stepper--dark q-dark" : "")
    );
    const headerClasses = computed(
      () => `q-stepper__header row items-stretch justify-between q-stepper__header--${props4.alternativeLabels === true ? "alternative" : "standard"}-labels` + (props4.flat === false || props4.bordered === true ? " q-stepper__header--border" : "") + (props4.contracted === true ? " q-stepper__header--contracted" : "") + (props4.headerClass !== void 0 ? ` ${props4.headerClass}` : "")
    );
    function getContent() {
      const top = hSlot(slots.message, []);
      if (props4.vertical === true) {
        isValidPanelName(props4.modelValue) && updatePanelIndex();
        const content = h("div", {
          class: "q-stepper__content"
        }, hSlot(slots.default));
        return top === void 0 ? [content] : top.concat(content);
      }
      return [
        h(
          "div",
          { class: headerClasses.value },
          getPanels().map((panel) => {
            const step = camelizeProps(panel.props);
            return h(StepHeader_default, {
              key: step.name,
              stepper: props4,
              step,
              goToPanel
            });
          })
        ),
        top,
        hDir(
          "div",
          { class: "q-stepper__content q-panel-parent" },
          getPanelContent(),
          "cont",
          props4.swipeable,
          () => panelDirectives.value
        )
      ];
    }
    return () => {
      updatePanelsList(slots);
      return h("div", {
        class: classes.value
      }, hMergeSlot(slots.navigation, getContent()));
    };
  }
});
createComponent({
  name: "QStepperNavigation",
  setup(_, { slots }) {
    return () => h("div", { class: "q-stepper__nav" }, hSlot(slots.default));
  }
});
var QTh_default = createComponent({
  name: "QTh",
  props: {
    props: Object,
    autoWidth: Boolean
  },
  emits: ["click"],
  setup(props4, { slots, emit }) {
    const vm2 = getCurrentInstance();
    const { proxy: { $q } } = vm2;
    const onClick = (evt) => {
      emit("click", evt);
    };
    return () => {
      if (props4.props === void 0) {
        return h("th", {
          class: props4.autoWidth === true ? "q-table--col-auto-width" : "",
          onClick
        }, hSlot(slots.default));
      }
      let col, child;
      const name2 = vm2.vnode.key;
      if (name2) {
        col = props4.props.colsMap[name2];
        if (col === void 0) return;
      } else {
        col = props4.props.col;
      }
      if (col.sortable === true) {
        const action = col.align === "right" ? "unshift" : "push";
        child = hUniqueSlot(slots.default, []);
        child[action](
          h(QIcon_default, {
            class: col.__iconClass,
            name: $q.iconSet.table.arrowUp
          })
        );
      } else {
        child = hSlot(slots.default);
      }
      const data = {
        class: col.__thClass + (props4.autoWidth === true ? " q-table--col-auto-width" : ""),
        style: col.headerStyle,
        onClick: (evt) => {
          col.sortable === true && props4.props.sort(col);
          onClick(evt);
        }
      };
      return h("th", data, child);
    };
  }
});
function get_table_middle_default(props4, content) {
  return h("div", props4, [
    h("table", { class: "q-table" }, content)
  ]);
}
var comps = {
  list: QList_default,
  table: QMarkupTable_default
};
var typeOptions = ["list", "table", "__qtable"];
var QVirtualScroll_default = createComponent({
  name: "QVirtualScroll",
  props: {
    ...useVirtualScrollProps,
    type: {
      type: String,
      default: "list",
      validator: (v) => typeOptions.includes(v)
    },
    items: {
      type: Array,
      default: () => []
    },
    itemsFn: Function,
    itemsSize: Number,
    scrollTarget: scrollTargetProp
  },
  setup(props4, { slots, attrs }) {
    let localScrollTarget;
    const rootRef = ref$1(null);
    const virtualScrollLength = computed(() => props4.itemsSize >= 0 && props4.itemsFn !== void 0 ? parseInt(props4.itemsSize, 10) : Array.isArray(props4.items) ? props4.items.length : 0);
    const {
      virtualScrollSliceRange,
      localResetVirtualScroll,
      padVirtualScroll,
      onVirtualScrollEvt
    } = useVirtualScroll({
      virtualScrollLength,
      getVirtualScrollTarget,
      getVirtualScrollEl
    });
    const virtualScrollScope = computed(() => {
      if (virtualScrollLength.value === 0) {
        return [];
      }
      const mapFn = (item, i2) => ({
        index: virtualScrollSliceRange.value.from + i2,
        item
      });
      return props4.itemsFn === void 0 ? props4.items.slice(virtualScrollSliceRange.value.from, virtualScrollSliceRange.value.to).map(mapFn) : props4.itemsFn(virtualScrollSliceRange.value.from, virtualScrollSliceRange.value.to - virtualScrollSliceRange.value.from).map(mapFn);
    });
    const classes = computed(
      () => "q-virtual-scroll q-virtual-scroll" + (props4.virtualScrollHorizontal === true ? "--horizontal" : "--vertical") + (props4.scrollTarget !== void 0 ? "" : " scroll")
    );
    const attributes = computed(() => props4.scrollTarget !== void 0 ? {} : { tabindex: 0 });
    watch(virtualScrollLength, () => {
      localResetVirtualScroll();
    });
    watch(() => props4.scrollTarget, () => {
      unconfigureScrollTarget();
      configureScrollTarget();
    });
    function getVirtualScrollEl() {
      return rootRef.value.$el || rootRef.value;
    }
    function getVirtualScrollTarget() {
      return localScrollTarget;
    }
    function configureScrollTarget() {
      localScrollTarget = getScrollTarget(getVirtualScrollEl(), props4.scrollTarget);
      localScrollTarget.addEventListener("scroll", onVirtualScrollEvt, listenOpts.passive);
    }
    function unconfigureScrollTarget() {
      if (localScrollTarget !== void 0) {
        localScrollTarget.removeEventListener("scroll", onVirtualScrollEvt, listenOpts.passive);
        localScrollTarget = void 0;
      }
    }
    function __getVirtualChildren() {
      let child = padVirtualScroll(
        props4.type === "list" ? "div" : "tbody",
        virtualScrollScope.value.map(slots.default)
      );
      if (slots.before !== void 0) {
        child = slots.before().concat(child);
      }
      return hMergeSlot(slots.after, child);
    }
    onBeforeMount(() => {
      localResetVirtualScroll();
    });
    onMounted(() => {
      configureScrollTarget();
    });
    onActivated(() => {
      configureScrollTarget();
    });
    onDeactivated(() => {
      unconfigureScrollTarget();
    });
    onBeforeUnmount(() => {
      unconfigureScrollTarget();
    });
    return () => {
      if (slots.default === void 0) {
        console.error("QVirtualScroll: default scoped slot is required for rendering");
        return;
      }
      return props4.type === "__qtable" ? get_table_middle_default(
        { ref: rootRef, class: "q-table__middle " + classes.value },
        __getVirtualChildren()
      ) : h(comps[props4.type], {
        ...attrs,
        ref: rootRef,
        class: [attrs.class, classes.value],
        ...attributes.value
      }, __getVirtualChildren);
    };
  }
});
function sortDate(a3, b2) {
  return new Date(a3) - new Date(b2);
}
var useTableSortProps = {
  sortMethod: Function,
  binaryStateSort: Boolean,
  columnSortOrder: {
    type: String,
    validator: (v) => v === "ad" || v === "da",
    default: "ad"
  }
};
function useTableSort(props4, computedPagination, colList, setPagination) {
  const columnToSort = computed(() => {
    const { sortBy } = computedPagination.value;
    return sortBy ? colList.value.find((def) => def.name === sortBy) || null : null;
  });
  const computedSortMethod = computed(() => props4.sortMethod !== void 0 ? props4.sortMethod : (data, sortBy, descending) => {
    const col = colList.value.find((def) => def.name === sortBy);
    if (col === void 0 || col.field === void 0) {
      return data;
    }
    const dir = descending === true ? -1 : 1, val = typeof col.field === "function" ? (v) => col.field(v) : (v) => v[col.field];
    return data.sort((a3, b2) => {
      let A = val(a3), B2 = val(b2);
      if (col.rawSort !== void 0) {
        return col.rawSort(A, B2, a3, b2) * dir;
      }
      if (A === null || A === void 0) {
        return -1 * dir;
      }
      if (B2 === null || B2 === void 0) {
        return 1 * dir;
      }
      if (col.sort !== void 0) {
        return col.sort(A, B2, a3, b2) * dir;
      }
      if (isNumber$1(A) === true && isNumber$1(B2) === true) {
        return (A - B2) * dir;
      }
      if (isDate$1(A) === true && isDate$1(B2) === true) {
        return sortDate(A, B2) * dir;
      }
      if (typeof A === "boolean" && typeof B2 === "boolean") {
        return (A - B2) * dir;
      }
      [A, B2] = [A, B2].map((s3) => (s3 + "").toLocaleString().toLowerCase());
      return A < B2 ? -1 * dir : A === B2 ? 0 : dir;
    });
  });
  function sort(col) {
    let sortOrder = props4.columnSortOrder;
    if (isObject(col) === true) {
      if (col.sortOrder) {
        sortOrder = col.sortOrder;
      }
      col = col.name;
    } else {
      const def = colList.value.find((def2) => def2.name === col);
      if (def !== void 0 && def.sortOrder) {
        sortOrder = def.sortOrder;
      }
    }
    let { sortBy, descending } = computedPagination.value;
    if (sortBy !== col) {
      sortBy = col;
      descending = sortOrder === "da";
    } else if (props4.binaryStateSort === true) {
      descending = !descending;
    } else if (descending === true) {
      if (sortOrder === "ad") {
        sortBy = null;
      } else {
        descending = false;
      }
    } else {
      if (sortOrder === "ad") {
        descending = true;
      } else {
        sortBy = null;
      }
    }
    setPagination({ sortBy, descending, page: 1 });
  }
  return {
    columnToSort,
    computedSortMethod,
    sort
  };
}
var useTableFilterProps = {
  filter: [String, Object],
  filterMethod: Function
};
function useTableFilter(props4, setPagination) {
  const computedFilterMethod = computed(() => props4.filterMethod !== void 0 ? props4.filterMethod : (rows, terms, cols, cellValue) => {
    const lowerTerms = terms ? terms.toLowerCase() : "";
    return rows.filter(
      (row) => cols.some((col) => {
        const val = cellValue(col, row) + "";
        const haystack = val === "undefined" || val === "null" ? "" : val.toLowerCase();
        return haystack.indexOf(lowerTerms) !== -1;
      })
    );
  });
  watch(
    () => props4.filter,
    () => {
      nextTick(() => {
        setPagination({ page: 1 }, true);
      });
    },
    { deep: true }
  );
  return { computedFilterMethod };
}
function samePagination(oldPag, newPag) {
  for (const prop in newPag) {
    if (newPag[prop] !== oldPag[prop]) {
      return false;
    }
  }
  return true;
}
function fixPagination(p) {
  if (p.page < 1) {
    p.page = 1;
  }
  if (p.rowsPerPage !== void 0 && p.rowsPerPage < 1) {
    p.rowsPerPage = 0;
  }
  return p;
}
var useTablePaginationProps = {
  pagination: Object,
  rowsPerPageOptions: {
    type: Array,
    default: () => [5, 7, 10, 15, 20, 25, 50, 0]
  },
  "onUpdate:pagination": [Function, Array]
};
function useTablePaginationState(vm2, getCellValue) {
  const { props: props4, emit } = vm2;
  const innerPagination = ref$1(
    Object.assign({
      sortBy: null,
      descending: false,
      page: 1,
      rowsPerPage: props4.rowsPerPageOptions.length !== 0 ? props4.rowsPerPageOptions[0] : 5
    }, props4.pagination)
  );
  const computedPagination = computed(() => {
    const pag = props4["onUpdate:pagination"] !== void 0 ? { ...innerPagination.value, ...props4.pagination } : innerPagination.value;
    return fixPagination(pag);
  });
  const isServerSide = computed(() => computedPagination.value.rowsNumber !== void 0);
  function sendServerRequest(pagination) {
    requestServerInteraction({
      pagination,
      filter: props4.filter
    });
  }
  function requestServerInteraction(prop = {}) {
    nextTick(() => {
      emit("request", {
        pagination: prop.pagination || computedPagination.value,
        filter: prop.filter || props4.filter,
        getCellValue
      });
    });
  }
  function setPagination(val, forceServerRequest) {
    const newPagination = fixPagination({
      ...computedPagination.value,
      ...val
    });
    if (samePagination(computedPagination.value, newPagination) === true) {
      if (isServerSide.value === true && forceServerRequest === true) {
        sendServerRequest(newPagination);
      }
      return;
    }
    if (isServerSide.value === true) {
      sendServerRequest(newPagination);
      return;
    }
    if (props4.pagination !== void 0 && props4["onUpdate:pagination"] !== void 0) {
      emit("update:pagination", newPagination);
    } else {
      innerPagination.value = newPagination;
    }
  }
  return {
    innerPagination,
    computedPagination,
    isServerSide,
    requestServerInteraction,
    setPagination
  };
}
function useTablePagination$1(vm2, innerPagination, computedPagination, isServerSide, setPagination, filteredSortedRowsNumber) {
  const { props: props4, emit, proxy: { $q } } = vm2;
  const computedRowsNumber = computed(() => isServerSide.value === true ? computedPagination.value.rowsNumber || 0 : filteredSortedRowsNumber.value);
  const firstRowIndex = computed(() => {
    const { page, rowsPerPage } = computedPagination.value;
    return (page - 1) * rowsPerPage;
  });
  const lastRowIndex = computed(() => {
    const { page, rowsPerPage } = computedPagination.value;
    return page * rowsPerPage;
  });
  const isFirstPage = computed(() => computedPagination.value.page === 1);
  const pagesNumber = computed(() => computedPagination.value.rowsPerPage === 0 ? 1 : Math.max(
    1,
    Math.ceil(computedRowsNumber.value / computedPagination.value.rowsPerPage)
  ));
  const isLastPage = computed(() => lastRowIndex.value === 0 ? true : computedPagination.value.page >= pagesNumber.value);
  const computedRowsPerPageOptions = computed(() => {
    const opts = props4.rowsPerPageOptions.includes(innerPagination.value.rowsPerPage) ? props4.rowsPerPageOptions : [innerPagination.value.rowsPerPage].concat(props4.rowsPerPageOptions);
    return opts.map((count) => ({
      label: count === 0 ? $q.lang.table.allRows : "" + count,
      value: count
    }));
  });
  watch(pagesNumber, (lastPage2, oldLastPage) => {
    if (lastPage2 === oldLastPage) {
      return;
    }
    const currentPage = computedPagination.value.page;
    if (lastPage2 && !currentPage) {
      setPagination({ page: 1 });
    } else if (lastPage2 < currentPage) {
      setPagination({ page: lastPage2 });
    }
  });
  function firstPage() {
    setPagination({ page: 1 });
  }
  function prevPage() {
    const { page } = computedPagination.value;
    if (page > 1) {
      setPagination({ page: page - 1 });
    }
  }
  function nextPage() {
    const { page, rowsPerPage } = computedPagination.value;
    if (lastRowIndex.value > 0 && page * rowsPerPage < computedRowsNumber.value) {
      setPagination({ page: page + 1 });
    }
  }
  function lastPage() {
    setPagination({ page: pagesNumber.value });
  }
  if (props4["onUpdate:pagination"] !== void 0) {
    emit("update:pagination", { ...computedPagination.value });
  }
  return {
    firstRowIndex,
    lastRowIndex,
    isFirstPage,
    isLastPage,
    pagesNumber,
    computedRowsPerPageOptions,
    computedRowsNumber,
    firstPage,
    prevPage,
    nextPage,
    lastPage
  };
}
var useTableRowSelectionProps = {
  selection: {
    type: String,
    default: "none",
    validator: (v) => ["single", "multiple", "none"].includes(v)
  },
  selected: {
    type: Array,
    default: () => []
  }
};
var useTableRowSelectionEmits = ["update:selected", "selection"];
function useTableRowSelection(props4, emit, computedRows, getRowKey) {
  const selectedKeys = computed(() => {
    const keys = {};
    props4.selected.map(getRowKey.value).forEach((key) => {
      keys[key] = true;
    });
    return keys;
  });
  const hasSelectionMode = computed(() => {
    return props4.selection !== "none";
  });
  const singleSelection = computed(() => {
    return props4.selection === "single";
  });
  const multipleSelection = computed(() => {
    return props4.selection === "multiple";
  });
  const allRowsSelected = computed(
    () => computedRows.value.length !== 0 && computedRows.value.every(
      (row) => selectedKeys.value[getRowKey.value(row)] === true
    )
  );
  const someRowsSelected = computed(
    () => allRowsSelected.value !== true && computedRows.value.some((row) => selectedKeys.value[getRowKey.value(row)] === true)
  );
  const rowsSelectedNumber = computed(() => props4.selected.length);
  function isRowSelected(key) {
    return selectedKeys.value[key] === true;
  }
  function clearSelection2() {
    emit("update:selected", []);
  }
  function updateSelection(keys, rows, added, evt) {
    emit("selection", { rows, added, keys, evt });
    const payload = singleSelection.value === true ? added === true ? rows : [] : added === true ? props4.selected.concat(rows) : props4.selected.filter(
      (row) => keys.includes(getRowKey.value(row)) === false
    );
    emit("update:selected", payload);
  }
  return {
    hasSelectionMode,
    singleSelection,
    multipleSelection,
    allRowsSelected,
    someRowsSelected,
    rowsSelectedNumber,
    isRowSelected,
    clearSelection: clearSelection2,
    updateSelection
  };
}
function getVal(val) {
  return Array.isArray(val) ? val.slice() : [];
}
var useTableRowExpandProps = {
  expanded: Array
  // v-model:expanded
};
var useTableRowExpandEmits = ["update:expanded"];
function useTableRowExpand(props4, emit) {
  const innerExpanded = ref$1(getVal(props4.expanded));
  watch(() => props4.expanded, (val) => {
    innerExpanded.value = getVal(val);
  });
  function isRowExpanded(key) {
    return innerExpanded.value.includes(key);
  }
  function setExpanded(val) {
    if (props4.expanded !== void 0) {
      emit("update:expanded", val);
    } else {
      innerExpanded.value = val;
    }
  }
  function updateExpanded(key, add2) {
    const target2 = innerExpanded.value.slice();
    const index = target2.indexOf(key);
    if (add2 === true) {
      if (index === -1) {
        target2.push(key);
        setExpanded(target2);
      }
    } else if (index !== -1) {
      target2.splice(index, 1);
      setExpanded(target2);
    }
  }
  return {
    isRowExpanded,
    setExpanded,
    updateExpanded
  };
}
var useTableColumnSelectionProps = {
  visibleColumns: Array
};
function useTableColumnSelection(props4, computedPagination, hasSelectionMode) {
  const colList = computed(() => {
    if (props4.columns !== void 0) {
      return props4.columns;
    }
    const row = props4.rows[0];
    return row !== void 0 ? Object.keys(row).map((name2) => ({
      name: name2,
      label: name2.toUpperCase(),
      field: name2,
      align: isNumber$1(row[name2]) ? "right" : "left",
      sortable: true
    })) : [];
  });
  const computedCols = computed(() => {
    const { sortBy, descending } = computedPagination.value;
    const cols = props4.visibleColumns !== void 0 ? colList.value.filter((col) => col.required === true || props4.visibleColumns.includes(col.name) === true) : colList.value;
    return cols.map((col) => {
      const align = col.align || "right";
      const alignClass = `text-${align}`;
      return {
        ...col,
        align,
        __iconClass: `q-table__sort-icon q-table__sort-icon--${align}`,
        __thClass: alignClass + (col.headerClasses !== void 0 ? " " + col.headerClasses : "") + (col.sortable === true ? " sortable" : "") + (col.name === sortBy ? ` sorted ${descending === true ? "sort-desc" : ""}` : ""),
        __tdStyle: col.style !== void 0 ? typeof col.style !== "function" ? () => col.style : col.style : () => null,
        __tdClass: col.classes !== void 0 ? typeof col.classes !== "function" ? () => alignClass + " " + col.classes : (row) => alignClass + " " + col.classes(row) : () => alignClass
      };
    });
  });
  const computedColsMap = computed(() => {
    const names = {};
    computedCols.value.forEach((col) => {
      names[col.name] = col;
    });
    return names;
  });
  const computedColspan = computed(() => {
    return props4.tableColspan !== void 0 ? props4.tableColspan : computedCols.value.length + (hasSelectionMode.value === true ? 1 : 0);
  });
  return {
    colList,
    computedCols,
    computedColsMap,
    computedColspan
  };
}
var bottomClass = "q-table__bottom row items-center";
var virtScrollPassthroughProps = {};
commonVirtScrollPropsList.forEach((p) => {
  virtScrollPassthroughProps[p] = {};
});
var QTable_default = createComponent({
  name: "QTable",
  props: {
    rows: {
      type: Array,
      required: true
    },
    rowKey: {
      type: [String, Function],
      default: "id"
    },
    columns: Array,
    loading: Boolean,
    iconFirstPage: String,
    iconPrevPage: String,
    iconNextPage: String,
    iconLastPage: String,
    title: String,
    hideHeader: Boolean,
    grid: Boolean,
    gridHeader: Boolean,
    dense: Boolean,
    flat: Boolean,
    bordered: Boolean,
    square: Boolean,
    separator: {
      type: String,
      default: "horizontal",
      validator: (v) => ["horizontal", "vertical", "cell", "none"].includes(v)
    },
    wrapCells: Boolean,
    virtualScroll: Boolean,
    virtualScrollTarget: {},
    ...virtScrollPassthroughProps,
    noDataLabel: String,
    noResultsLabel: String,
    loadingLabel: String,
    selectedRowsLabel: Function,
    rowsPerPageLabel: String,
    paginationLabel: Function,
    color: {
      type: String,
      default: "grey-8"
    },
    titleClass: [String, Array, Object],
    tableStyle: [String, Array, Object],
    tableClass: [String, Array, Object],
    tableHeaderStyle: [String, Array, Object],
    tableHeaderClass: [String, Array, Object],
    cardContainerClass: [String, Array, Object],
    cardContainerStyle: [String, Array, Object],
    cardStyle: [String, Array, Object],
    cardClass: [String, Array, Object],
    hideBottom: Boolean,
    hideSelectedBanner: Boolean,
    hideNoData: Boolean,
    hidePagination: Boolean,
    onRowClick: Function,
    onRowDblclick: Function,
    onRowContextmenu: Function,
    ...useDarkProps,
    ...useFullscreenProps,
    ...useTableColumnSelectionProps,
    ...useTableFilterProps,
    ...useTablePaginationProps,
    ...useTableRowExpandProps,
    ...useTableRowSelectionProps,
    ...useTableSortProps
  },
  emits: [
    "request",
    "virtualScroll",
    ...useFullscreenEmits,
    ...useTableRowExpandEmits,
    ...useTableRowSelectionEmits
  ],
  setup(props4, { slots, emit }) {
    const vm2 = getCurrentInstance();
    const { proxy: { $q } } = vm2;
    const isDark = use_dark_default(props4, $q);
    const { inFullscreen, toggleFullscreen } = use_fullscreen_default();
    const getRowKey = computed(() => typeof props4.rowKey === "function" ? props4.rowKey : (row) => row[props4.rowKey]);
    const rootRef = ref$1(null);
    const virtScrollRef = ref$1(null);
    const hasVirtScroll = computed(() => props4.grid !== true && props4.virtualScroll === true);
    const cardDefaultClass = computed(
      () => " q-table__card" + (isDark.value === true ? " q-table__card--dark q-dark" : "") + (props4.square === true ? " q-table--square" : "") + (props4.flat === true ? " q-table--flat" : "") + (props4.bordered === true ? " q-table--bordered" : "")
    );
    const __containerClass = computed(
      () => `q-table__container q-table--${props4.separator}-separator column no-wrap` + (props4.grid === true ? " q-table--grid" : cardDefaultClass.value) + (isDark.value === true ? " q-table--dark" : "") + (props4.dense === true ? " q-table--dense" : "") + (props4.wrapCells === false ? " q-table--no-wrap" : "") + (inFullscreen.value === true ? " fullscreen scroll" : "")
    );
    const containerClass = computed(
      () => __containerClass.value + (props4.loading === true ? " q-table--loading" : "")
    );
    watch(
      () => props4.tableStyle + props4.tableClass + props4.tableHeaderStyle + props4.tableHeaderClass + __containerClass.value,
      () => {
        hasVirtScroll.value === true && virtScrollRef.value !== null && virtScrollRef.value.reset();
      }
    );
    const {
      innerPagination,
      computedPagination,
      isServerSide,
      requestServerInteraction,
      setPagination
    } = useTablePaginationState(vm2, getCellValue);
    const { computedFilterMethod } = useTableFilter(props4, setPagination);
    const { isRowExpanded, setExpanded, updateExpanded } = useTableRowExpand(props4, emit);
    const filteredSortedRows = computed(() => {
      let rows = props4.rows;
      if (isServerSide.value === true || rows.length === 0) {
        return rows;
      }
      const { sortBy, descending } = computedPagination.value;
      if (props4.filter) {
        rows = computedFilterMethod.value(rows, props4.filter, computedCols.value, getCellValue);
      }
      if (columnToSort.value !== null) {
        rows = computedSortMethod.value(
          props4.rows === rows ? rows.slice() : rows,
          sortBy,
          descending
        );
      }
      return rows;
    });
    const filteredSortedRowsNumber = computed(() => filteredSortedRows.value.length);
    const computedRows = computed(() => {
      let rows = filteredSortedRows.value;
      if (isServerSide.value === true) {
        return rows;
      }
      const { rowsPerPage } = computedPagination.value;
      if (rowsPerPage !== 0) {
        if (firstRowIndex.value === 0 && props4.rows !== rows) {
          if (rows.length > lastRowIndex.value) {
            rows = rows.slice(0, lastRowIndex.value);
          }
        } else {
          rows = rows.slice(firstRowIndex.value, lastRowIndex.value);
        }
      }
      return rows;
    });
    const {
      hasSelectionMode,
      singleSelection,
      multipleSelection,
      allRowsSelected,
      someRowsSelected,
      rowsSelectedNumber,
      isRowSelected,
      clearSelection: clearSelection2,
      updateSelection
    } = useTableRowSelection(props4, emit, computedRows, getRowKey);
    const { colList, computedCols, computedColsMap, computedColspan } = useTableColumnSelection(props4, computedPagination, hasSelectionMode);
    const { columnToSort, computedSortMethod, sort } = useTableSort(props4, computedPagination, colList, setPagination);
    const {
      firstRowIndex,
      lastRowIndex,
      isFirstPage,
      isLastPage,
      pagesNumber,
      computedRowsPerPageOptions,
      computedRowsNumber,
      firstPage,
      prevPage,
      nextPage,
      lastPage
    } = useTablePagination$1(vm2, innerPagination, computedPagination, isServerSide, setPagination, filteredSortedRowsNumber);
    const nothingToDisplay = computed(() => computedRows.value.length === 0);
    const virtProps = computed(() => {
      const acc = {};
      commonVirtScrollPropsList.forEach((p) => {
        acc[p] = props4[p];
      });
      if (acc.virtualScrollItemSize === void 0) {
        acc.virtualScrollItemSize = props4.dense === true ? 28 : 48;
      }
      return acc;
    });
    function resetVirtualScroll() {
      hasVirtScroll.value === true && virtScrollRef.value.reset();
    }
    function getBody() {
      if (props4.grid === true) {
        return getGridBody();
      }
      const header = props4.hideHeader !== true ? getTHead : null;
      if (hasVirtScroll.value === true) {
        const topRow = slots["top-row"];
        const bottomRow = slots["bottom-row"];
        const virtSlots = {
          default: (props5) => getTBodyTR(props5.item, slots.body, props5.index)
        };
        if (topRow !== void 0) {
          const topContent = h("tbody", topRow({ cols: computedCols.value }));
          virtSlots.before = header === null ? () => topContent : () => [header()].concat(topContent);
        } else if (header !== null) {
          virtSlots.before = header;
        }
        if (bottomRow !== void 0) {
          virtSlots.after = () => h("tbody", bottomRow({ cols: computedCols.value }));
        }
        return h(QVirtualScroll_default, {
          ref: virtScrollRef,
          class: props4.tableClass,
          style: props4.tableStyle,
          ...virtProps.value,
          scrollTarget: props4.virtualScrollTarget,
          items: computedRows.value,
          type: "__qtable",
          tableColspan: computedColspan.value,
          onVirtualScroll: onVScroll
        }, virtSlots);
      }
      const child = [
        getTBody()
      ];
      if (header !== null) {
        child.unshift(header());
      }
      return get_table_middle_default({
        class: ["q-table__middle scroll", props4.tableClass],
        style: props4.tableStyle
      }, child);
    }
    function scrollTo(toIndex, edge) {
      if (virtScrollRef.value !== null) {
        virtScrollRef.value.scrollTo(toIndex, edge);
        return;
      }
      toIndex = parseInt(toIndex, 10);
      const rowEl = rootRef.value.querySelector(`tbody tr:nth-of-type(${toIndex + 1})`);
      if (rowEl !== null) {
        const scrollTarget = rootRef.value.querySelector(".q-table__middle.scroll");
        const offsetTop = rowEl.offsetTop - props4.virtualScrollStickySizeStart;
        const direction = offsetTop < scrollTarget.scrollTop ? "decrease" : "increase";
        scrollTarget.scrollTop = offsetTop;
        emit("virtualScroll", {
          index: toIndex,
          from: 0,
          to: innerPagination.value.rowsPerPage - 1,
          direction
        });
      }
    }
    function onVScroll(info) {
      emit("virtualScroll", info);
    }
    function getProgress() {
      return [
        h(QLinearProgress_default, {
          class: "q-table__linear-progress",
          color: props4.color,
          dark: isDark.value,
          indeterminate: true,
          trackColor: "transparent"
        })
      ];
    }
    function getTBodyTR(row, bodySlot, pageIndex) {
      const key = getRowKey.value(row), selected = isRowSelected(key);
      if (bodySlot !== void 0) {
        return bodySlot(
          getBodyScope({
            key,
            row,
            pageIndex,
            __trClass: selected ? "selected" : ""
          })
        );
      }
      const bodyCell = slots["body-cell"], child = computedCols.value.map((col) => {
        const bodyCellCol = slots[`body-cell-${col.name}`], slot = bodyCellCol !== void 0 ? bodyCellCol : bodyCell;
        return slot !== void 0 ? slot(getBodyCellScope({ key, row, pageIndex, col })) : h("td", {
          class: col.__tdClass(row),
          style: col.__tdStyle(row)
        }, getCellValue(col, row));
      });
      if (hasSelectionMode.value === true) {
        const slot = slots["body-selection"];
        const content = slot !== void 0 ? slot(getBodySelectionScope({ key, row, pageIndex })) : [
          h(QCheckbox_default, {
            modelValue: selected,
            color: props4.color,
            dark: isDark.value,
            dense: props4.dense,
            "onUpdate:modelValue": (adding, evt) => {
              updateSelection([key], [row], adding, evt);
            }
          })
        ];
        child.unshift(
          h("td", { class: "q-table--col-auto-width" }, content)
        );
      }
      const data = { key, class: { selected } };
      if (props4.onRowClick !== void 0) {
        data.class["cursor-pointer"] = true;
        data.onClick = (evt) => {
          emit("rowClick", evt, row, pageIndex);
        };
      }
      if (props4.onRowDblclick !== void 0) {
        data.class["cursor-pointer"] = true;
        data.onDblclick = (evt) => {
          emit("rowDblclick", evt, row, pageIndex);
        };
      }
      if (props4.onRowContextmenu !== void 0) {
        data.class["cursor-pointer"] = true;
        data.onContextmenu = (evt) => {
          emit("rowContextmenu", evt, row, pageIndex);
        };
      }
      return h("tr", data, child);
    }
    function getTBody() {
      const body = slots.body, topRow = slots["top-row"], bottomRow = slots["bottom-row"];
      let child = computedRows.value.map(
        (row, pageIndex) => getTBodyTR(row, body, pageIndex)
      );
      if (topRow !== void 0) {
        child = topRow({ cols: computedCols.value }).concat(child);
      }
      if (bottomRow !== void 0) {
        child = child.concat(bottomRow({ cols: computedCols.value }));
      }
      return h("tbody", child);
    }
    function getBodyScope(data) {
      injectBodyCommonScope(data);
      data.cols = data.cols.map(
        (col) => injectProp({ ...col }, "value", () => getCellValue(col, data.row))
      );
      return data;
    }
    function getBodyCellScope(data) {
      injectBodyCommonScope(data);
      injectProp(data, "value", () => getCellValue(data.col, data.row));
      return data;
    }
    function getBodySelectionScope(data) {
      injectBodyCommonScope(data);
      return data;
    }
    function injectBodyCommonScope(data) {
      Object.assign(data, {
        cols: computedCols.value,
        colsMap: computedColsMap.value,
        sort,
        rowIndex: firstRowIndex.value + data.pageIndex,
        color: props4.color,
        dark: isDark.value,
        dense: props4.dense
      });
      hasSelectionMode.value === true && injectProp(
        data,
        "selected",
        () => isRowSelected(data.key),
        (adding, evt) => {
          updateSelection([data.key], [data.row], adding, evt);
        }
      );
      injectProp(
        data,
        "expand",
        () => isRowExpanded(data.key),
        (adding) => {
          updateExpanded(data.key, adding);
        }
      );
    }
    function getCellValue(col, row) {
      const val = typeof col.field === "function" ? col.field(row) : row[col.field];
      return col.format !== void 0 ? col.format(val, row) : val;
    }
    const marginalsScope = computed(() => ({
      pagination: computedPagination.value,
      pagesNumber: pagesNumber.value,
      isFirstPage: isFirstPage.value,
      isLastPage: isLastPage.value,
      firstPage,
      prevPage,
      nextPage,
      lastPage,
      inFullscreen: inFullscreen.value,
      toggleFullscreen
    }));
    function getTopDiv() {
      const top = slots.top, topLeft = slots["top-left"], topRight = slots["top-right"], topSelection = slots["top-selection"], hasSelection = hasSelectionMode.value === true && topSelection !== void 0 && rowsSelectedNumber.value > 0, topClass = "q-table__top relative-position row items-center";
      if (top !== void 0) {
        return h("div", { class: topClass }, [top(marginalsScope.value)]);
      }
      let child;
      if (hasSelection === true) {
        child = topSelection(marginalsScope.value).slice();
      } else {
        child = [];
        if (topLeft !== void 0) {
          child.push(
            h("div", { class: "q-table__control" }, [
              topLeft(marginalsScope.value)
            ])
          );
        } else if (props4.title) {
          child.push(
            h("div", { class: "q-table__control" }, [
              h("div", {
                class: ["q-table__title", props4.titleClass]
              }, props4.title)
            ])
          );
        }
      }
      if (topRight !== void 0) {
        child.push(
          h("div", { class: "q-table__separator col" })
        );
        child.push(
          h("div", { class: "q-table__control" }, [
            topRight(marginalsScope.value)
          ])
        );
      }
      if (child.length === 0) {
        return;
      }
      return h("div", { class: topClass }, child);
    }
    const headerSelectedValue = computed(() => someRowsSelected.value === true ? null : allRowsSelected.value);
    function getTHead() {
      const child = getTHeadTR();
      if (props4.loading === true && slots.loading === void 0) {
        child.push(
          h("tr", { class: "q-table__progress" }, [
            h("th", {
              class: "relative-position",
              colspan: computedColspan.value
            }, getProgress())
          ])
        );
      }
      return h("thead", child);
    }
    function getTHeadTR() {
      const header = slots.header, headerCell = slots["header-cell"];
      if (header !== void 0) {
        return header(
          getHeaderScope({ header: true })
        ).slice();
      }
      const child = computedCols.value.map((col) => {
        const headerCellCol = slots[`header-cell-${col.name}`], slot = headerCellCol !== void 0 ? headerCellCol : headerCell, props5 = getHeaderScope({ col });
        return slot !== void 0 ? slot(props5) : h(QTh_default, {
          key: col.name,
          props: props5
        }, () => col.label);
      });
      if (singleSelection.value === true && props4.grid !== true) {
        child.unshift(
          h("th", { class: "q-table--col-auto-width" }, " ")
        );
      } else if (multipleSelection.value === true) {
        const slot = slots["header-selection"];
        const content = slot !== void 0 ? slot(getHeaderScope({})) : [
          h(QCheckbox_default, {
            color: props4.color,
            modelValue: headerSelectedValue.value,
            dark: isDark.value,
            dense: props4.dense,
            "onUpdate:modelValue": onMultipleSelectionSet
          })
        ];
        child.unshift(
          h("th", { class: "q-table--col-auto-width" }, content)
        );
      }
      return [
        h("tr", {
          class: props4.tableHeaderClass,
          style: props4.tableHeaderStyle
        }, child)
      ];
    }
    function getHeaderScope(data) {
      Object.assign(data, {
        cols: computedCols.value,
        sort,
        colsMap: computedColsMap.value,
        color: props4.color,
        dark: isDark.value,
        dense: props4.dense
      });
      if (multipleSelection.value === true) {
        injectProp(
          data,
          "selected",
          () => headerSelectedValue.value,
          onMultipleSelectionSet
        );
      }
      return data;
    }
    function onMultipleSelectionSet(val) {
      if (someRowsSelected.value === true) {
        val = false;
      }
      updateSelection(
        computedRows.value.map(getRowKey.value),
        computedRows.value,
        val
      );
    }
    const navIcon = computed(() => {
      const ico = [
        props4.iconFirstPage || $q.iconSet.table.firstPage,
        props4.iconPrevPage || $q.iconSet.table.prevPage,
        props4.iconNextPage || $q.iconSet.table.nextPage,
        props4.iconLastPage || $q.iconSet.table.lastPage
      ];
      return $q.lang.rtl === true ? ico.reverse() : ico;
    });
    function getBottomDiv() {
      if (props4.hideBottom === true) {
        return;
      }
      if (nothingToDisplay.value === true) {
        if (props4.hideNoData === true) {
          return;
        }
        const message = props4.loading === true ? props4.loadingLabel || $q.lang.table.loading : props4.filter ? props4.noResultsLabel || $q.lang.table.noResults : props4.noDataLabel || $q.lang.table.noData;
        const noData = slots["no-data"];
        const children = noData !== void 0 ? [noData({ message, icon: $q.iconSet.table.warning, filter: props4.filter })] : [
          h(QIcon_default, {
            class: "q-table__bottom-nodata-icon",
            name: $q.iconSet.table.warning
          }),
          message
        ];
        return h("div", { class: bottomClass + " q-table__bottom--nodata" }, children);
      }
      const bottom = slots.bottom;
      if (bottom !== void 0) {
        return h("div", { class: bottomClass }, [bottom(marginalsScope.value)]);
      }
      const child = props4.hideSelectedBanner !== true && hasSelectionMode.value === true && rowsSelectedNumber.value > 0 ? [
        h("div", { class: "q-table__control" }, [
          h("div", [
            (props4.selectedRowsLabel || $q.lang.table.selectedRecords)(rowsSelectedNumber.value)
          ])
        ])
      ] : [];
      if (props4.hidePagination !== true) {
        return h("div", {
          class: bottomClass + " justify-end"
        }, getPaginationDiv(child));
      }
      if (child.length !== 0) {
        return h("div", { class: bottomClass }, child);
      }
    }
    function onPagSelection(pag) {
      setPagination({
        page: 1,
        rowsPerPage: pag.value
      });
    }
    function getPaginationDiv(child) {
      let control;
      const { rowsPerPage } = computedPagination.value, paginationLabel = props4.paginationLabel || $q.lang.table.pagination, paginationSlot = slots.pagination, hasOpts = props4.rowsPerPageOptions.length > 1;
      child.push(
        h("div", { class: "q-table__separator col" })
      );
      if (hasOpts === true) {
        child.push(
          h("div", { class: "q-table__control" }, [
            h("span", { class: "q-table__bottom-item" }, [
              props4.rowsPerPageLabel || $q.lang.table.recordsPerPage
            ]),
            h(QSelect_default, {
              class: "q-table__select inline q-table__bottom-item",
              color: props4.color,
              modelValue: rowsPerPage,
              options: computedRowsPerPageOptions.value,
              displayValue: rowsPerPage === 0 ? $q.lang.table.allRows : rowsPerPage,
              dark: isDark.value,
              borderless: true,
              dense: true,
              optionsDense: true,
              optionsCover: true,
              "onUpdate:modelValue": onPagSelection
            })
          ])
        );
      }
      if (paginationSlot !== void 0) {
        control = paginationSlot(marginalsScope.value);
      } else {
        control = [
          h("span", rowsPerPage !== 0 ? { class: "q-table__bottom-item" } : {}, [
            rowsPerPage ? paginationLabel(firstRowIndex.value + 1, Math.min(lastRowIndex.value, computedRowsNumber.value), computedRowsNumber.value) : paginationLabel(1, filteredSortedRowsNumber.value, computedRowsNumber.value)
          ])
        ];
        if (rowsPerPage !== 0 && pagesNumber.value > 1) {
          const btnProps = {
            color: props4.color,
            round: true,
            dense: true,
            flat: true
          };
          if (props4.dense === true) {
            btnProps.size = "sm";
          }
          pagesNumber.value > 2 && control.push(
            h(QBtn_default, {
              key: "pgFirst",
              ...btnProps,
              icon: navIcon.value[0],
              disable: isFirstPage.value,
              onClick: firstPage
            })
          );
          control.push(
            h(QBtn_default, {
              key: "pgPrev",
              ...btnProps,
              icon: navIcon.value[1],
              disable: isFirstPage.value,
              onClick: prevPage
            }),
            h(QBtn_default, {
              key: "pgNext",
              ...btnProps,
              icon: navIcon.value[2],
              disable: isLastPage.value,
              onClick: nextPage
            })
          );
          pagesNumber.value > 2 && control.push(
            h(QBtn_default, {
              key: "pgLast",
              ...btnProps,
              icon: navIcon.value[3],
              disable: isLastPage.value,
              onClick: lastPage
            })
          );
        }
      }
      child.push(
        h("div", { class: "q-table__control" }, control)
      );
      return child;
    }
    function getGridHeader() {
      const child = props4.gridHeader === true ? [
        h("table", { class: "q-table" }, [
          getTHead()
        ])
      ] : props4.loading === true && slots.loading === void 0 ? getProgress() : void 0;
      return h("div", { class: "q-table__middle" }, child);
    }
    function getGridBody() {
      const item = slots.item !== void 0 ? slots.item : (scope) => {
        const child = scope.cols.map(
          (col) => h("div", { class: "q-table__grid-item-row" }, [
            h("div", { class: "q-table__grid-item-title" }, [col.label]),
            h("div", { class: "q-table__grid-item-value" }, [col.value])
          ])
        );
        if (hasSelectionMode.value === true) {
          const slot = slots["body-selection"];
          const content = slot !== void 0 ? slot(scope) : [
            h(QCheckbox_default, {
              modelValue: scope.selected,
              color: props4.color,
              dark: isDark.value,
              dense: props4.dense,
              "onUpdate:modelValue": (adding, evt) => {
                updateSelection([scope.key], [scope.row], adding, evt);
              }
            })
          ];
          child.unshift(
            h("div", { class: "q-table__grid-item-row" }, content),
            h(QSeparator_default, { dark: isDark.value })
          );
        }
        const data = {
          class: [
            "q-table__grid-item-card" + cardDefaultClass.value,
            props4.cardClass
          ],
          style: props4.cardStyle
        };
        if (props4.onRowClick !== void 0 || props4.onRowDblclick !== void 0) {
          data.class[0] += " cursor-pointer";
          if (props4.onRowClick !== void 0) {
            data.onClick = (evt) => {
              emit("RowClick", evt, scope.row, scope.pageIndex);
            };
          }
          if (props4.onRowDblclick !== void 0) {
            data.onDblclick = (evt) => {
              emit("RowDblclick", evt, scope.row, scope.pageIndex);
            };
          }
        }
        return h("div", {
          class: "q-table__grid-item col-xs-12 col-sm-6 col-md-4 col-lg-3" + (scope.selected === true ? " q-table__grid-item--selected" : "")
        }, [
          h("div", data, child)
        ]);
      };
      return h("div", {
        class: [
          "q-table__grid-content row",
          props4.cardContainerClass
        ],
        style: props4.cardContainerStyle
      }, computedRows.value.map((row, pageIndex) => {
        return item(getBodyScope({
          key: getRowKey.value(row),
          row,
          pageIndex
        }));
      }));
    }
    Object.assign(vm2.proxy, {
      requestServerInteraction,
      setPagination,
      firstPage,
      prevPage,
      nextPage,
      lastPage,
      isRowSelected,
      clearSelection: clearSelection2,
      isRowExpanded,
      setExpanded,
      sort,
      resetVirtualScroll,
      scrollTo,
      getCellValue
    });
    injectMultipleProps(vm2.proxy, {
      filteredSortedRows: () => filteredSortedRows.value,
      computedRows: () => computedRows.value,
      computedRowsNumber: () => computedRowsNumber.value
    });
    return () => {
      const child = [getTopDiv()];
      const data = { ref: rootRef, class: containerClass.value };
      if (props4.grid === true) {
        child.push(getGridHeader());
      } else {
        Object.assign(data, {
          class: [data.class, props4.cardClass],
          style: props4.cardStyle
        });
      }
      child.push(
        getBody(),
        getBottomDiv()
      );
      if (props4.loading === true && slots.loading !== void 0) {
        child.push(
          slots.loading()
        );
      }
      return h("div", data, child);
    };
  }
});
var QTr_default = createComponent({
  name: "QTr",
  props: {
    props: Object,
    noHover: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => "q-tr" + (props4.props === void 0 || props4.props.header === true ? "" : " " + props4.props.__trClass) + (props4.noHover === true ? " q-tr--no-hover" : "")
    );
    return () => h("tr", { class: classes.value }, hSlot(slots.default));
  }
});
var QTd_default = createComponent({
  name: "QTd",
  props: {
    props: Object,
    autoWidth: Boolean,
    noHover: Boolean
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const classes = computed(
      () => "q-td" + (props4.autoWidth === true ? " q-table--col-auto-width" : "") + (props4.noHover === true ? " q-td--no-hover" : "") + " "
    );
    return () => {
      if (props4.props === void 0) {
        return h("td", { class: classes.value }, hSlot(slots.default));
      }
      const name2 = vm2.vnode.key;
      const col = (props4.props.colsMap !== void 0 ? props4.props.colsMap[name2] : null) || props4.props.col;
      if (col === void 0) return;
      const { row } = props4.props;
      return h("td", {
        class: classes.value + col.__tdClass(row),
        style: col.__tdStyle(row)
      }, hSlot(slots.default));
    };
  }
});
var QRouteTab_default = createComponent({
  name: "QRouteTab",
  props: {
    ...useRouterLinkProps,
    ...useTabProps
  },
  emits: useTabEmits,
  setup(props4, { slots, emit }) {
    const routeData = use_router_link_default({
      useDisableForRouterLinkProps: false
    });
    const { renderTab, $tabs } = use_tab_default(
      props4,
      slots,
      emit,
      {
        exact: computed(() => props4.exact),
        ...routeData
      }
    );
    watch(
      () => `${props4.name} | ${props4.exact} | ${(routeData.resolvedLink.value || {}).href}`,
      $tabs.verifyRouteModel
    );
    return () => renderTab(routeData.linkTag.value, routeData.linkAttrs.value);
  }
});
function getViewByModel(model, withSeconds) {
  if (model.hour !== null) {
    if (model.minute === null) {
      return "minute";
    }
  }
  return "hour";
}
function getCurrentTime() {
  const d3 = /* @__PURE__ */ new Date();
  return {
    hour: d3.getHours(),
    minute: d3.getMinutes(),
    second: d3.getSeconds(),
    millisecond: d3.getMilliseconds()
  };
}
createComponent({
  name: "QTime",
  props: {
    ...useDarkProps,
    ...useFormProps,
    ...useDatetimeProps,
    modelValue: {
      required: true,
      validator: (val) => typeof val === "string" || val === null
    },
    mask: {
      ...useDatetimeProps.mask,
      default: null
    },
    format24h: {
      type: Boolean,
      default: null
    },
    defaultDate: {
      type: String,
      validator: (v) => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(v)
    },
    options: Function,
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    withSeconds: Boolean,
    nowBtn: Boolean
  },
  emits: useDatetimeEmits,
  setup(props4, { slots, emit }) {
    const vm2 = getCurrentInstance();
    const { $q } = vm2.proxy;
    const isDark = use_dark_default(props4, $q);
    const { tabindex, headerClass, getLocale: getLocale2, getCurrentDate } = use_datetime_default(props4, $q);
    const formAttrs = useFormAttrs(props4);
    const injectFormInput = useFormInject(formAttrs);
    let draggingClockRect, dragCache;
    const clockRef = ref$1(null);
    const mask = computed(() => getMask());
    const locale2 = computed(() => getLocale2());
    const defaultDateModel = computed(() => getDefaultDateModel());
    const model = __splitDate(
      props4.modelValue,
      mask.value,
      // initial mask
      locale2.value,
      // initial locale
      props4.calendar,
      defaultDateModel.value
    );
    const view = ref$1(getViewByModel(model));
    const innerModel = ref$1(model);
    const isAM = ref$1(model.hour === null || model.hour < 12);
    const classes = computed(
      () => `q-time q-time--${props4.landscape === true ? "landscape" : "portrait"}` + (isDark.value === true ? " q-time--dark q-dark" : "") + (props4.disable === true ? " disabled" : props4.readonly === true ? " q-time--readonly" : "") + (props4.bordered === true ? " q-time--bordered" : "") + (props4.square === true ? " q-time--square no-border-radius" : "") + (props4.flat === true ? " q-time--flat no-shadow" : "")
    );
    const stringModel = computed(() => {
      const time = innerModel.value;
      return {
        hour: time.hour === null ? "--" : computedFormat24h.value === true ? pad(time.hour) : String(
          isAM.value === true ? time.hour === 0 ? 12 : time.hour : time.hour > 12 ? time.hour - 12 : time.hour
        ),
        minute: time.minute === null ? "--" : pad(time.minute),
        second: time.second === null ? "--" : pad(time.second)
      };
    });
    const computedFormat24h = computed(() => props4.format24h !== null ? props4.format24h : $q.lang.date.format24h);
    const pointerStyle = computed(() => {
      const forHour = view.value === "hour", divider = forHour === true ? 12 : 60, amount = innerModel.value[view.value], degrees = Math.round(amount * (360 / divider)) - 180;
      let transform = `rotate(${degrees}deg) translateX(-50%)`;
      if (forHour === true && computedFormat24h.value === true && innerModel.value.hour >= 12) {
        transform += " scale(.7)";
      }
      return { transform };
    });
    const minLink = computed(() => innerModel.value.hour !== null);
    const secLink = computed(() => minLink.value === true && innerModel.value.minute !== null);
    const hourInSelection = computed(() => props4.hourOptions !== void 0 ? (val) => props4.hourOptions.includes(val) : props4.options !== void 0 ? (val) => props4.options(val, null, null) : null);
    const minuteInSelection = computed(() => props4.minuteOptions !== void 0 ? (val) => props4.minuteOptions.includes(val) : props4.options !== void 0 ? (val) => props4.options(innerModel.value.hour, val, null) : null);
    const secondInSelection = computed(() => props4.secondOptions !== void 0 ? (val) => props4.secondOptions.includes(val) : props4.options !== void 0 ? (val) => props4.options(innerModel.value.hour, innerModel.value.minute, val) : null);
    const validHours = computed(() => {
      if (hourInSelection.value === null) {
        return null;
      }
      const am = getValidValues(0, 11, hourInSelection.value);
      const pm = getValidValues(12, 11, hourInSelection.value);
      return { am, pm, values: am.values.concat(pm.values) };
    });
    const validMinutes = computed(() => minuteInSelection.value !== null ? getValidValues(0, 59, minuteInSelection.value) : null);
    const validSeconds = computed(() => secondInSelection.value !== null ? getValidValues(0, 59, secondInSelection.value) : null);
    const viewValidOptions = computed(() => {
      switch (view.value) {
        case "hour":
          return validHours.value;
        case "minute":
          return validMinutes.value;
        case "second":
          return validSeconds.value;
      }
    });
    const positions = computed(() => {
      let start, end, offset2 = 0, step = 1;
      const values = viewValidOptions.value !== null ? viewValidOptions.value.values : void 0;
      if (view.value === "hour") {
        if (computedFormat24h.value === true) {
          start = 0;
          end = 23;
        } else {
          start = 0;
          end = 11;
          if (isAM.value === false) {
            offset2 = 12;
          }
        }
      } else {
        start = 0;
        end = 55;
        step = 5;
      }
      const pos = [];
      for (let val = start, index = start; val <= end; val += step, index++) {
        const actualVal = val + offset2, disable = values !== void 0 && values.includes(actualVal) === false, label = view.value === "hour" && val === 0 ? computedFormat24h.value === true ? "00" : "12" : val;
        pos.push({ val: actualVal, index, disable, label });
      }
      return pos;
    });
    const clockDirectives = computed(() => {
      return [[
        TouchPan_default,
        onPan,
        void 0,
        {
          stop: true,
          prevent: true,
          mouse: true
        }
      ]];
    });
    watch(() => props4.modelValue, (v) => {
      const model2 = __splitDate(
        v,
        mask.value,
        locale2.value,
        props4.calendar,
        defaultDateModel.value
      );
      if (model2.dateHash !== innerModel.value.dateHash || model2.timeHash !== innerModel.value.timeHash) {
        innerModel.value = model2;
        if (model2.hour === null) {
          view.value = "hour";
        } else {
          isAM.value = model2.hour < 12;
        }
      }
    });
    watch([mask, locale2], () => {
      nextTick(() => {
        updateValue2();
      });
    });
    function setNow() {
      const date = {
        ...getCurrentDate(),
        ...getCurrentTime()
      };
      updateValue2(date);
      Object.assign(innerModel.value, date);
      view.value = "hour";
    }
    function getValidValues(start, count, testFn) {
      const values = Array.apply(null, { length: count + 1 }).map((_, index) => {
        const i2 = index + start;
        return {
          index: i2,
          val: testFn(i2) === true
          // force boolean
        };
      }).filter((v) => v.val === true).map((v) => v.index);
      return {
        min: values[0],
        max: values[values.length - 1],
        values,
        threshold: count + 1
      };
    }
    function getWheelDist(a3, b2, threshold) {
      const diff2 = Math.abs(a3 - b2);
      return Math.min(diff2, threshold - diff2);
    }
    function getNormalizedClockValue(val, { min: min2, max: max2, values, threshold }) {
      if (val === min2) {
        return min2;
      }
      if (val < min2 || val > max2) {
        return getWheelDist(val, min2, threshold) <= getWheelDist(val, max2, threshold) ? min2 : max2;
      }
      const index = values.findIndex((v) => val <= v), before = values[index - 1], after = values[index];
      return val - before <= after - val ? before : after;
    }
    function getMask() {
      return props4.calendar !== "persian" && props4.mask !== null ? props4.mask : `HH:mm${props4.withSeconds === true ? ":ss" : ""}`;
    }
    function getDefaultDateModel() {
      if (typeof props4.defaultDate !== "string") {
        const date = getCurrentDate(true);
        date.dateHash = getDayHash(date);
        return date;
      }
      return __splitDate(props4.defaultDate, "YYYY/MM/DD", void 0, props4.calendar);
    }
    function shouldAbortInteraction() {
      return vmIsDestroyed(vm2) === true || viewValidOptions.value !== null && (viewValidOptions.value.values.length === 0 || view.value === "hour" && computedFormat24h.value !== true && validHours.value[isAM.value === true ? "am" : "pm"].values.length === 0);
    }
    function getClockRect() {
      const clock = clockRef.value, { top, left, width: width3 } = clock.getBoundingClientRect(), dist = width3 / 2;
      return {
        top: top + dist,
        left: left + dist,
        dist: dist * 0.7
      };
    }
    function onPan(event) {
      if (shouldAbortInteraction() === true) {
        return;
      }
      if (event.isFirst === true) {
        draggingClockRect = getClockRect();
        dragCache = updateClock(event.evt, draggingClockRect);
        return;
      }
      dragCache = updateClock(event.evt, draggingClockRect, dragCache);
      if (event.isFinal === true) {
        draggingClockRect = false;
        dragCache = null;
        goToNextView();
      }
    }
    function goToNextView() {
      if (view.value === "hour") {
        view.value = "minute";
      } else if (props4.withSeconds && view.value === "minute") {
        view.value = "second";
      }
    }
    function updateClock(evt, clockRect, cacheVal) {
      const pos = position(evt), height2 = Math.abs(pos.top - clockRect.top), distance = Math.sqrt(
        Math.pow(Math.abs(pos.top - clockRect.top), 2) + Math.pow(Math.abs(pos.left - clockRect.left), 2)
      );
      let val, angle = Math.asin(height2 / distance) * (180 / Math.PI);
      if (pos.top < clockRect.top) {
        angle = clockRect.left < pos.left ? 90 - angle : 270 + angle;
      } else {
        angle = clockRect.left < pos.left ? angle + 90 : 270 - angle;
      }
      if (view.value === "hour") {
        val = angle / 30;
        if (validHours.value !== null) {
          const am = computedFormat24h.value !== true ? isAM.value === true : validHours.value.am.values.length !== 0 && validHours.value.pm.values.length !== 0 ? distance >= clockRect.dist : validHours.value.am.values.length !== 0;
          val = getNormalizedClockValue(
            val + (am === true ? 0 : 12),
            validHours.value[am === true ? "am" : "pm"]
          );
        } else {
          val = Math.round(val);
          if (computedFormat24h.value === true) {
            if (distance < clockRect.dist) {
              if (val < 12) {
                val += 12;
              }
            } else if (val === 12) {
              val = 0;
            }
          } else if (isAM.value === true && val === 12) {
            val = 0;
          } else if (isAM.value === false && val !== 12) {
            val += 12;
          }
        }
        if (computedFormat24h.value === true) {
          isAM.value = val < 12;
        }
      } else {
        val = Math.round(angle / 6) % 60;
        if (view.value === "minute" && validMinutes.value !== null) {
          val = getNormalizedClockValue(val, validMinutes.value);
        } else if (view.value === "second" && validSeconds.value !== null) {
          val = getNormalizedClockValue(val, validSeconds.value);
        }
      }
      if (cacheVal !== val) {
        setModel[view.value](val);
      }
      return val;
    }
    const setView = {
      hour() {
        view.value = "hour";
      },
      minute() {
        view.value = "minute";
      },
      second() {
        view.value = "second";
      }
    };
    function setAmOnKey(e2) {
      e2.keyCode === 13 && setAm();
    }
    function setPmOnKey(e2) {
      e2.keyCode === 13 && setPm();
    }
    function onClick(evt) {
      if (shouldAbortInteraction() !== true) {
        if ($q.platform.is.desktop !== true) {
          updateClock(evt, getClockRect());
        }
        goToNextView();
      }
    }
    function onMousedown(evt) {
      if (shouldAbortInteraction() !== true) {
        updateClock(evt, getClockRect());
      }
    }
    function onKeyupHour(e2) {
      if (e2.keyCode === 13) {
        view.value = "hour";
      } else if ([37, 39].includes(e2.keyCode)) {
        const payload = e2.keyCode === 37 ? -1 : 1;
        if (validHours.value !== null) {
          const values = computedFormat24h.value === true ? validHours.value.values : validHours.value[isAM.value === true ? "am" : "pm"].values;
          if (values.length === 0) return;
          if (innerModel.value.hour === null) {
            setHour(values[0]);
          } else {
            const index = (values.length + values.indexOf(innerModel.value.hour) + payload) % values.length;
            setHour(values[index]);
          }
        } else {
          const wrap = computedFormat24h.value === true ? 24 : 12, offset2 = computedFormat24h.value !== true && isAM.value === false ? 12 : 0, val = innerModel.value.hour === null ? -payload : innerModel.value.hour;
          setHour(offset2 + (24 + val + payload) % wrap);
        }
      }
    }
    function onKeyupMinute(e2) {
      if (e2.keyCode === 13) {
        view.value = "minute";
      } else if ([37, 39].includes(e2.keyCode)) {
        const payload = e2.keyCode === 37 ? -1 : 1;
        if (validMinutes.value !== null) {
          const values = validMinutes.value.values;
          if (values.length === 0) return;
          if (innerModel.value.minute === null) {
            setMinute(values[0]);
          } else {
            const index = (values.length + values.indexOf(innerModel.value.minute) + payload) % values.length;
            setMinute(values[index]);
          }
        } else {
          const val = innerModel.value.minute === null ? -payload : innerModel.value.minute;
          setMinute((60 + val + payload) % 60);
        }
      }
    }
    function onKeyupSecond(e2) {
      if (e2.keyCode === 13) {
        view.value = "second";
      } else if ([37, 39].includes(e2.keyCode)) {
        const payload = e2.keyCode === 37 ? -1 : 1;
        if (validSeconds.value !== null) {
          const values = validSeconds.value.values;
          if (values.length === 0) return;
          if (innerModel.value.seconds === null) {
            setSecond(values[0]);
          } else {
            const index = (values.length + values.indexOf(innerModel.value.second) + payload) % values.length;
            setSecond(values[index]);
          }
        } else {
          const val = innerModel.value.second === null ? -payload : innerModel.value.second;
          setSecond((60 + val + payload) % 60);
        }
      }
    }
    function setHour(hour) {
      if (innerModel.value.hour !== hour) {
        innerModel.value.hour = hour;
        verifyAndUpdate();
      }
    }
    function setMinute(minute) {
      if (innerModel.value.minute !== minute) {
        innerModel.value.minute = minute;
        verifyAndUpdate();
      }
    }
    function setSecond(second) {
      if (innerModel.value.second !== second) {
        innerModel.value.second = second;
        verifyAndUpdate();
      }
    }
    const setModel = {
      hour: setHour,
      minute: setMinute,
      second: setSecond
    };
    function setAm() {
      if (isAM.value === false) {
        isAM.value = true;
        if (innerModel.value.hour !== null) {
          innerModel.value.hour -= 12;
          verifyAndUpdate();
        }
      }
    }
    function setPm() {
      if (isAM.value === true) {
        isAM.value = false;
        if (innerModel.value.hour !== null) {
          innerModel.value.hour += 12;
          verifyAndUpdate();
        }
      }
    }
    function goToViewWhenHasModel(newView) {
      const model2 = props4.modelValue;
      if (view.value !== newView && model2 !== void 0 && model2 !== null && model2 !== "" && typeof model2 !== "string") {
        view.value = newView;
      }
    }
    function verifyAndUpdate() {
      if (hourInSelection.value !== null && hourInSelection.value(innerModel.value.hour) !== true) {
        innerModel.value = __splitDate();
        goToViewWhenHasModel("hour");
        return;
      }
      if (minuteInSelection.value !== null && minuteInSelection.value(innerModel.value.minute) !== true) {
        innerModel.value.minute = null;
        innerModel.value.second = null;
        goToViewWhenHasModel("minute");
        return;
      }
      if (props4.withSeconds === true && secondInSelection.value !== null && secondInSelection.value(innerModel.value.second) !== true) {
        innerModel.value.second = null;
        goToViewWhenHasModel("second");
        return;
      }
      if (innerModel.value.hour === null || innerModel.value.minute === null || props4.withSeconds === true && innerModel.value.second === null) {
        return;
      }
      updateValue2();
    }
    function updateValue2(obj) {
      const date = Object.assign({ ...innerModel.value }, obj);
      const val = props4.calendar === "persian" ? pad(date.hour) + ":" + pad(date.minute) + (props4.withSeconds === true ? ":" + pad(date.second) : "") : formatDate(
        new Date(
          date.year,
          date.month === null ? null : date.month - 1,
          date.day,
          date.hour,
          date.minute,
          date.second,
          date.millisecond
        ),
        mask.value,
        locale2.value,
        date.year,
        date.timezoneOffset
      );
      date.changed = val !== props4.modelValue;
      emit("update:modelValue", val, date);
    }
    function getHeader() {
      const label = [
        h("div", {
          class: "q-time__link " + (view.value === "hour" ? "q-time__link--active" : "cursor-pointer"),
          tabindex: tabindex.value,
          onClick: setView.hour,
          onKeyup: onKeyupHour
        }, stringModel.value.hour),
        h("div", ":"),
        h(
          "div",
          minLink.value === true ? {
            class: "q-time__link " + (view.value === "minute" ? "q-time__link--active" : "cursor-pointer"),
            tabindex: tabindex.value,
            onKeyup: onKeyupMinute,
            onClick: setView.minute
          } : { class: "q-time__link" },
          stringModel.value.minute
        )
      ];
      if (props4.withSeconds === true) {
        label.push(
          h("div", ":"),
          h(
            "div",
            secLink.value === true ? {
              class: "q-time__link " + (view.value === "second" ? "q-time__link--active" : "cursor-pointer"),
              tabindex: tabindex.value,
              onKeyup: onKeyupSecond,
              onClick: setView.second
            } : { class: "q-time__link" },
            stringModel.value.second
          )
        );
      }
      const child = [
        h("div", {
          class: "q-time__header-label row items-center no-wrap",
          dir: "ltr"
        }, label)
      ];
      computedFormat24h.value === false && child.push(
        h("div", {
          class: "q-time__header-ampm column items-between no-wrap"
        }, [
          h("div", {
            class: "q-time__link " + (isAM.value === true ? "q-time__link--active" : "cursor-pointer"),
            tabindex: tabindex.value,
            onClick: setAm,
            onKeyup: setAmOnKey
          }, "AM"),
          h("div", {
            class: "q-time__link " + (isAM.value !== true ? "q-time__link--active" : "cursor-pointer"),
            tabindex: tabindex.value,
            onClick: setPm,
            onKeyup: setPmOnKey
          }, "PM")
        ])
      );
      return h("div", {
        class: "q-time__header flex flex-center no-wrap " + headerClass.value
      }, child);
    }
    function getClock() {
      const current = innerModel.value[view.value];
      return h("div", {
        class: "q-time__content col relative-position"
      }, [
        h(Transition, {
          name: "q-transition--scale"
        }, () => h("div", {
          key: "clock" + view.value,
          class: "q-time__container-parent absolute-full"
        }, [
          h("div", {
            ref: clockRef,
            class: "q-time__container-child fit overflow-hidden"
          }, [
            withDirectives(
              h("div", {
                class: "q-time__clock cursor-pointer non-selectable",
                onClick,
                onMousedown
              }, [
                h("div", { class: "q-time__clock-circle fit" }, [
                  h("div", {
                    class: "q-time__clock-pointer" + (innerModel.value[view.value] === null ? " hidden" : props4.color !== void 0 ? ` text-${props4.color}` : ""),
                    style: pointerStyle.value
                  }),
                  positions.value.map((pos) => h("div", {
                    class: `q-time__clock-position row flex-center q-time__clock-pos-${pos.index}` + (pos.val === current ? " q-time__clock-position--active " + headerClass.value : pos.disable === true ? " q-time__clock-position--disable" : "")
                  }, [h("span", pos.label)]))
                ])
              ]),
              clockDirectives.value
            )
          ])
        ])),
        props4.nowBtn === true ? h(QBtn_default, {
          class: "q-time__now-button absolute",
          icon: $q.iconSet.datetime.now,
          unelevated: true,
          size: "sm",
          round: true,
          color: props4.color,
          textColor: props4.textColor,
          tabindex: tabindex.value,
          onClick: setNow
        }) : null
      ]);
    }
    vm2.proxy.setNow = setNow;
    return () => {
      const child = [getClock()];
      const def = hSlot(slots.default);
      def !== void 0 && child.push(
        h("div", { class: "q-time__actions" }, def)
      );
      if (props4.name !== void 0 && props4.disable !== true) {
        injectFormInput(child, "push");
      }
      return h("div", {
        class: classes.value,
        tabindex: -1
      }, [
        getHeader(),
        h("div", { class: "q-time__main col overflow-auto" }, child)
      ]);
    };
  }
});
createComponent({
  name: "QTimeline",
  props: {
    ...useDarkProps,
    color: {
      type: String,
      default: "primary"
    },
    side: {
      type: String,
      default: "right",
      validator: (v) => ["left", "right"].includes(v)
    },
    layout: {
      type: String,
      default: "dense",
      validator: (v) => ["dense", "comfortable", "loose"].includes(v)
    }
  },
  setup(props4, { slots }) {
    const vm2 = getCurrentInstance();
    const isDark = use_dark_default(props4, vm2.proxy.$q);
    provide(timelineKey, props4);
    const classes = computed(
      () => `q-timeline q-timeline--${props4.layout} q-timeline--${props4.layout}--${props4.side}` + (isDark.value === true ? " q-timeline--dark" : "")
    );
    return () => h("ul", { class: classes.value }, hSlot(slots.default));
  }
});
createComponent({
  name: "QTimelineEntry",
  props: {
    heading: Boolean,
    tag: {
      type: String,
      default: "h3"
    },
    side: {
      type: String,
      default: "right",
      validator: (v) => ["left", "right"].includes(v)
    },
    icon: String,
    avatar: String,
    color: String,
    title: String,
    subtitle: String,
    body: String
  },
  setup(props4, { slots }) {
    const $timeline = inject(timelineKey, emptyRenderFn);
    if ($timeline === emptyRenderFn) {
      console.error("QTimelineEntry needs to be child of QTimeline");
      return emptyRenderFn;
    }
    const classes = computed(
      () => `q-timeline__entry q-timeline__entry--${props4.side}` + (props4.icon !== void 0 || props4.avatar !== void 0 ? " q-timeline__entry--icon" : "")
    );
    const dotClass = computed(
      () => `q-timeline__dot text-${props4.color || $timeline.color}`
    );
    const reverse = computed(
      () => $timeline.layout === "comfortable" && $timeline.side === "left"
    );
    return () => {
      const child = hUniqueSlot(slots.default, []);
      if (props4.body !== void 0) {
        child.unshift(props4.body);
      }
      if (props4.heading === true) {
        const content2 = [
          h("div"),
          h("div"),
          h(
            props4.tag,
            { class: "q-timeline__heading-title" },
            child
          )
        ];
        return h("div", {
          class: "q-timeline__heading"
        }, reverse.value === true ? content2.reverse() : content2);
      }
      let dot;
      if (props4.icon !== void 0) {
        dot = [
          h(QIcon_default, {
            class: "row items-center justify-center",
            name: props4.icon
          })
        ];
      } else if (props4.avatar !== void 0) {
        dot = [
          h("img", {
            class: "q-timeline__dot-img",
            src: props4.avatar
          })
        ];
      }
      const content = [
        h("div", { class: "q-timeline__subtitle" }, [
          h("span", {}, hSlot(slots.subtitle, [props4.subtitle]))
        ]),
        h("div", { class: dotClass.value }, dot),
        h("div", { class: "q-timeline__content" }, [
          h("h6", { class: "q-timeline__title" }, hSlot(slots.title, [props4.title]))
        ].concat(child))
      ];
      return h("li", {
        class: classes.value
      }, reverse.value === true ? content.reverse() : content);
    };
  }
});
createComponent({
  name: "QToolbar",
  props: {
    inset: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => "q-toolbar row no-wrap items-center" + (props4.inset === true ? " q-toolbar--inset" : "")
    );
    return () => h("div", { class: classes.value, role: "toolbar" }, hSlot(slots.default));
  }
});
createComponent({
  name: "QToolbarTitle",
  props: {
    shrink: Boolean
  },
  setup(props4, { slots }) {
    const classes = computed(
      () => "q-toolbar__title ellipsis" + (props4.shrink === true ? " col-shrink" : "")
    );
    return () => h("div", { class: classes.value }, hSlot(slots.default));
  }
});
var tickStrategyOptions = ["none", "strict", "leaf", "leaf-filtered"];
createComponent({
  name: "QTree",
  props: {
    ...useDarkProps,
    nodes: {
      type: Array,
      required: true
    },
    nodeKey: {
      type: String,
      required: true
    },
    labelKey: {
      type: String,
      default: "label"
    },
    childrenKey: {
      type: String,
      default: "children"
    },
    dense: Boolean,
    color: String,
    controlColor: String,
    textColor: String,
    selectedColor: String,
    icon: String,
    tickStrategy: {
      type: String,
      default: "none",
      validator: (v) => tickStrategyOptions.includes(v)
    },
    ticked: Array,
    // v-model:ticked
    expanded: Array,
    // v-model:expanded
    selected: {},
    // v-model:selected
    noSelectionUnset: Boolean,
    defaultExpandAll: Boolean,
    accordion: Boolean,
    filter: String,
    filterMethod: Function,
    duration: {},
    noConnectors: Boolean,
    noTransition: Boolean,
    noNodesLabel: String,
    noResultsLabel: String
  },
  emits: [
    "update:expanded",
    "update:ticked",
    "update:selected",
    "lazyLoad",
    "afterShow",
    "afterHide"
  ],
  setup(props4, { slots, emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const lazy = ref$1({});
    const innerTicked = ref$1(props4.ticked || []);
    const innerExpanded = ref$1(props4.expanded || []);
    let blurTargets = {};
    onBeforeUpdate(() => {
      blurTargets = {};
    });
    const classes = computed(
      () => `q-tree q-tree--${props4.dense === true ? "dense" : "standard"}` + (props4.noConnectors === true ? " q-tree--no-connectors" : "") + (isDark.value === true ? " q-tree--dark" : "") + (props4.color !== void 0 ? ` text-${props4.color}` : "")
    );
    const hasSelection = computed(() => props4.selected !== void 0);
    const computedIcon = computed(() => props4.icon || $q.iconSet.tree.icon);
    const computedControlColor = computed(() => props4.controlColor || props4.color);
    const textColorClass = computed(() => props4.textColor !== void 0 ? ` text-${props4.textColor}` : "");
    const selectedColorClass = computed(() => {
      const color = props4.selectedColor || props4.color;
      return color ? ` text-${color}` : "";
    });
    const computedFilterMethod = computed(() => props4.filterMethod !== void 0 ? props4.filterMethod : (node, filter) => {
      const filt = filter.toLowerCase();
      return node[props4.labelKey] && node[props4.labelKey].toLowerCase().indexOf(filt) !== -1;
    });
    const meta = computed(() => {
      const meta2 = {};
      const travel = (node, parent) => {
        const tickStrategy = node.tickStrategy || (parent ? parent.tickStrategy : props4.tickStrategy);
        const key = node[props4.nodeKey], isParent = node[props4.childrenKey] && Array.isArray(node[props4.childrenKey]) && node[props4.childrenKey].length !== 0, selectable = node.disabled !== true && hasSelection.value === true && node.selectable !== false, expandable = node.disabled !== true && node.expandable !== false, hasTicking = tickStrategy !== "none", strictTicking = tickStrategy === "strict", leafFilteredTicking = tickStrategy === "leaf-filtered", leafTicking = tickStrategy === "leaf" || tickStrategy === "leaf-filtered";
        let tickable = node.disabled !== true && node.tickable !== false;
        if (leafTicking === true && tickable === true && parent && parent.tickable !== true) {
          tickable = false;
        }
        let localLazy = node.lazy;
        if (localLazy === true && lazy.value[key] !== void 0 && Array.isArray(node[props4.childrenKey]) === true) {
          localLazy = lazy.value[key];
        }
        const m3 = {
          key,
          parent,
          isParent,
          lazy: localLazy,
          disabled: node.disabled,
          link: node.disabled !== true && (selectable === true || expandable === true && (isParent === true || localLazy === true)),
          children: [],
          matchesFilter: props4.filter ? computedFilterMethod.value(node, props4.filter) : true,
          selected: key === props4.selected && selectable === true,
          selectable,
          expanded: isParent === true ? innerExpanded.value.includes(key) : false,
          expandable,
          noTick: node.noTick === true || strictTicking !== true && localLazy && localLazy !== "loaded",
          tickable,
          tickStrategy,
          hasTicking,
          strictTicking,
          leafFilteredTicking,
          leafTicking,
          ticked: strictTicking === true ? innerTicked.value.includes(key) : isParent === true ? false : innerTicked.value.includes(key)
        };
        meta2[key] = m3;
        if (isParent === true) {
          m3.children = node[props4.childrenKey].map((n) => travel(n, m3));
          if (props4.filter) {
            if (m3.matchesFilter !== true) {
              m3.matchesFilter = m3.children.some((n) => n.matchesFilter);
            } else if (m3.noTick !== true && m3.disabled !== true && m3.tickable === true && leafFilteredTicking === true && m3.children.every((n) => n.matchesFilter !== true || n.noTick === true || n.tickable !== true) === true) {
              m3.tickable = false;
            }
          }
          if (m3.matchesFilter === true) {
            if (m3.noTick !== true && strictTicking !== true && m3.children.every((n) => n.noTick) === true) {
              m3.noTick = true;
            }
            if (leafTicking) {
              m3.ticked = false;
              m3.indeterminate = m3.children.some((node2) => node2.indeterminate === true);
              m3.tickable = m3.tickable === true && m3.children.some((node2) => node2.tickable);
              if (m3.indeterminate !== true) {
                const sel = m3.children.reduce((acc, meta3) => meta3.ticked === true ? acc + 1 : acc, 0);
                if (sel === m3.children.length) {
                  m3.ticked = true;
                } else if (sel > 0) {
                  m3.indeterminate = true;
                }
              }
              if (m3.indeterminate === true) {
                m3.indeterminateNextState = m3.children.every((meta3) => meta3.tickable !== true || meta3.ticked !== true);
              }
            }
          }
        }
        return m3;
      };
      props4.nodes.forEach((node) => travel(node, null));
      return meta2;
    });
    watch(() => props4.ticked, (val) => {
      innerTicked.value = val;
    });
    watch(() => props4.expanded, (val) => {
      innerExpanded.value = val;
    });
    function getNodeByKey(key) {
      const reduce = [].reduce;
      const find = (result, node) => {
        if (result || !node) {
          return result;
        }
        if (Array.isArray(node) === true) {
          return reduce.call(Object(node), find, result);
        }
        if (node[props4.nodeKey] === key) {
          return node;
        }
        if (node[props4.childrenKey]) {
          return find(null, node[props4.childrenKey]);
        }
      };
      return find(null, props4.nodes);
    }
    function getTickedNodes() {
      return innerTicked.value.map((key) => getNodeByKey(key));
    }
    function getExpandedNodes() {
      return innerExpanded.value.map((key) => getNodeByKey(key));
    }
    function isExpanded(key) {
      return key && meta.value[key] ? meta.value[key].expanded : false;
    }
    function collapseAll() {
      if (props4.expanded !== void 0) {
        emit("update:expanded", []);
      } else {
        innerExpanded.value = [];
      }
    }
    function expandAll() {
      const expanded = [];
      const travel = (node) => {
        if (node[props4.childrenKey] && node[props4.childrenKey].length !== 0) {
          if (node.expandable !== false && node.disabled !== true) {
            expanded.push(node[props4.nodeKey]);
            node[props4.childrenKey].forEach(travel);
          }
        }
      };
      props4.nodes.forEach(travel);
      if (props4.expanded !== void 0) {
        emit("update:expanded", expanded);
      } else {
        innerExpanded.value = expanded;
      }
    }
    function setExpanded(key, state2, node = getNodeByKey(key), m3 = meta.value[key]) {
      if (m3.lazy && m3.lazy !== "loaded") {
        if (m3.lazy === "loading") {
          return;
        }
        lazy.value[key] = "loading";
        if (Array.isArray(node[props4.childrenKey]) !== true) {
          node[props4.childrenKey] = [];
        }
        emit("lazyLoad", {
          node,
          key,
          done: (children) => {
            lazy.value[key] = "loaded";
            node[props4.childrenKey] = Array.isArray(children) === true ? children : [];
            nextTick(() => {
              const localMeta = meta.value[key];
              if (localMeta && localMeta.isParent === true) {
                localSetExpanded(key, true);
              }
            });
          },
          fail: () => {
            delete lazy.value[key];
            if (node[props4.childrenKey].length === 0) {
              delete node[props4.childrenKey];
            }
          }
        });
      } else if (m3.isParent === true && m3.expandable === true) {
        localSetExpanded(key, state2);
      }
    }
    function localSetExpanded(key, state2) {
      let target2 = innerExpanded.value;
      const shouldEmit = props4.expanded !== void 0;
      if (shouldEmit === true) {
        target2 = target2.slice();
      }
      if (state2) {
        if (props4.accordion) {
          if (meta.value[key]) {
            const collapse = [];
            if (meta.value[key].parent) {
              meta.value[key].parent.children.forEach((m3) => {
                if (m3.key !== key && m3.expandable === true) {
                  collapse.push(m3.key);
                }
              });
            } else {
              props4.nodes.forEach((node) => {
                const k2 = node[props4.nodeKey];
                if (k2 !== key) {
                  collapse.push(k2);
                }
              });
            }
            if (collapse.length !== 0) {
              target2 = target2.filter((k2) => collapse.includes(k2) === false);
            }
          }
        }
        target2 = target2.concat([key]).filter((key2, index, self2) => self2.indexOf(key2) === index);
      } else {
        target2 = target2.filter((k2) => k2 !== key);
      }
      if (shouldEmit === true) {
        emit("update:expanded", target2);
      } else {
        innerExpanded.value = target2;
      }
    }
    function isTicked(key) {
      return key && meta.value[key] ? meta.value[key].ticked : false;
    }
    function setTicked(keys, state2) {
      let target2 = innerTicked.value;
      const shouldEmit = props4.ticked !== void 0;
      if (shouldEmit === true) {
        target2 = target2.slice();
      }
      if (state2) {
        target2 = target2.concat(keys).filter((key, index, self2) => self2.indexOf(key) === index);
      } else {
        target2 = target2.filter((k2) => keys.includes(k2) === false);
      }
      if (shouldEmit === true) {
        emit("update:ticked", target2);
      }
    }
    function getSlotScope(node, meta2, key) {
      const scope = { tree: proxy, node, key, color: props4.color, dark: isDark.value };
      injectProp(
        scope,
        "expanded",
        () => {
          return meta2.expanded;
        },
        (val) => {
          val !== meta2.expanded && setExpanded(key, val);
        }
      );
      injectProp(
        scope,
        "ticked",
        () => {
          return meta2.ticked;
        },
        (val) => {
          val !== meta2.ticked && setTicked([key], val);
        }
      );
      return scope;
    }
    function getChildren(nodes) {
      return (props4.filter ? nodes.filter((n) => meta.value[n[props4.nodeKey]].matchesFilter) : nodes).map((child) => getNode(child));
    }
    function getNodeMedia(node) {
      if (node.icon !== void 0) {
        return h(QIcon_default, {
          class: "q-tree__icon q-mr-sm",
          name: node.icon,
          color: node.iconColor
        });
      }
      const src = node.img || node.avatar;
      if (src) {
        return h("img", {
          class: `q-tree__${node.img ? "img" : "avatar"} q-mr-sm`,
          src
        });
      }
    }
    function onShow() {
      emit("afterShow");
    }
    function onHide() {
      emit("afterHide");
    }
    function getNode(node) {
      const key = node[props4.nodeKey], m3 = meta.value[key], header = node.header ? slots[`header-${node.header}`] || slots["default-header"] : slots["default-header"];
      const children = m3.isParent === true ? getChildren(node[props4.childrenKey]) : [];
      const isParent = children.length !== 0 || m3.lazy && m3.lazy !== "loaded";
      let body = node.body ? slots[`body-${node.body}`] || slots["default-body"] : slots["default-body"];
      const slotScope = header !== void 0 || body !== void 0 ? getSlotScope(node, m3, key) : null;
      if (body !== void 0) {
        body = h("div", { class: "q-tree__node-body relative-position" }, [
          h("div", { class: textColorClass.value }, [
            body(slotScope)
          ])
        ]);
      }
      return h("div", {
        key,
        class: `q-tree__node relative-position q-tree__node--${isParent === true ? "parent" : "child"}`
      }, [
        h("div", {
          class: "q-tree__node-header relative-position row no-wrap items-center" + (m3.link === true ? " q-tree__node--link q-hoverable q-focusable" : "") + (m3.selected === true ? " q-tree__node--selected" : "") + (m3.disabled === true ? " q-tree__node--disabled" : ""),
          tabindex: m3.link === true ? 0 : -1,
          ariaExpanded: children.length > 0 ? m3.expanded : null,
          role: "treeitem",
          onClick: (e2) => {
            onClick(node, m3, e2);
          },
          onKeypress(e2) {
            if (shouldIgnoreKey(e2) !== true) {
              if (e2.keyCode === 13) {
                onClick(node, m3, e2, true);
              } else if (e2.keyCode === 32) {
                onExpandClick(node, m3, e2, true);
              }
            }
          }
        }, [
          h("div", {
            class: "q-focus-helper",
            tabindex: -1,
            ref: (el) => {
              blurTargets[m3.key] = el;
            }
          }),
          m3.lazy === "loading" ? h(QSpinner_default, {
            class: "q-tree__spinner",
            color: computedControlColor.value
          }) : isParent === true ? h(QIcon_default, {
            class: "q-tree__arrow" + (m3.expanded === true ? " q-tree__arrow--rotate" : ""),
            name: computedIcon.value,
            onClick(e2) {
              onExpandClick(node, m3, e2);
            }
          }) : null,
          m3.hasTicking === true && m3.noTick !== true ? h(QCheckbox_default, {
            class: "q-tree__tickbox",
            modelValue: m3.indeterminate === true ? null : m3.ticked,
            color: computedControlColor.value,
            dark: isDark.value,
            dense: true,
            keepColor: true,
            disable: m3.tickable !== true,
            onKeydown: stopAndPrevent,
            "onUpdate:modelValue": (v) => {
              onTickedClick(m3, v);
            }
          }) : null,
          h("div", {
            class: "q-tree__node-header-content col row no-wrap items-center" + (m3.selected === true ? selectedColorClass.value : textColorClass.value)
          }, [
            header ? header(slotScope) : [
              getNodeMedia(node),
              h("div", node[props4.labelKey])
            ]
          ])
        ]),
        isParent === true ? props4.noTransition === true ? m3.expanded === true ? h("div", {
          class: "q-tree__node-collapsible" + textColorClass.value,
          key: `${key}__q`
        }, [
          body,
          h("div", {
            class: "q-tree__children" + (m3.disabled === true ? " q-tree__node--disabled" : ""),
            role: "group"
          }, children)
        ]) : null : h(QSlideTransition_default, {
          duration: props4.duration,
          onShow,
          onHide
        }, () => withDirectives(
          h("div", {
            class: "q-tree__node-collapsible" + textColorClass.value,
            key: `${key}__q`
          }, [
            body,
            h("div", {
              class: "q-tree__children" + (m3.disabled === true ? " q-tree__node--disabled" : ""),
              role: "group"
            }, children)
          ]),
          [[vShow, m3.expanded]]
        )) : body
      ]);
    }
    function blur(key) {
      const blurTarget = blurTargets[key];
      blurTarget && blurTarget.focus();
    }
    function onClick(node, meta2, e2, keyboard) {
      keyboard !== true && meta2.selectable !== false && blur(meta2.key);
      if (hasSelection.value && meta2.selectable) {
        if (props4.noSelectionUnset === false) {
          emit("update:selected", meta2.key !== props4.selected ? meta2.key : null);
        } else if (meta2.key !== props4.selected) {
          emit("update:selected", meta2.key === void 0 ? null : meta2.key);
        }
      } else {
        onExpandClick(node, meta2, e2, keyboard);
      }
      if (typeof node.handler === "function") {
        node.handler(node);
      }
    }
    function onExpandClick(node, meta2, e2, keyboard) {
      if (e2 !== void 0) {
        stopAndPrevent(e2);
      }
      keyboard !== true && meta2.selectable !== false && blur(meta2.key);
      setExpanded(meta2.key, !meta2.expanded, node, meta2);
    }
    function onTickedClick(meta2, state2) {
      if (meta2.indeterminate === true) {
        state2 = meta2.indeterminateNextState;
      }
      if (meta2.strictTicking) {
        setTicked([meta2.key], state2);
      } else if (meta2.leafTicking) {
        const keys = [];
        const travel = (meta3) => {
          if (meta3.isParent) {
            if (state2 !== true && meta3.noTick !== true && meta3.tickable === true) {
              keys.push(meta3.key);
            }
            if (meta3.leafTicking === true) {
              meta3.children.forEach(travel);
            }
          } else if (meta3.noTick !== true && meta3.tickable === true && (meta3.leafFilteredTicking !== true || meta3.matchesFilter === true)) {
            keys.push(meta3.key);
          }
        };
        travel(meta2);
        setTicked(keys, state2);
      }
    }
    props4.defaultExpandAll === true && expandAll();
    Object.assign(proxy, {
      getNodeByKey,
      getTickedNodes,
      getExpandedNodes,
      isExpanded,
      collapseAll,
      expandAll,
      setExpanded,
      isTicked,
      setTicked
    });
    return () => {
      const children = getChildren(props4.nodes);
      return h(
        "div",
        {
          class: classes.value,
          role: "tree"
        },
        children.length === 0 ? props4.filter ? props4.noResultsLabel || $q.lang.tree.noResults : props4.noNodesLabel || $q.lang.tree.noNodes : children
      );
    };
  }
});
function getProgressLabel(p) {
  return (p * 100).toFixed(2) + "%";
}
var coreProps = {
  ...useDarkProps,
  ...useFileProps,
  label: String,
  color: String,
  textColor: String,
  square: Boolean,
  flat: Boolean,
  bordered: Boolean,
  noThumbnails: Boolean,
  thumbnailFit: {
    type: String,
    default: "cover"
  },
  autoUpload: Boolean,
  hideUploadBtn: Boolean,
  disable: Boolean,
  readonly: Boolean
};
var coreEmits = [
  ...useFileEmits,
  "start",
  "finish",
  "added",
  "removed"
];
function getRenderer(getPlugin, expose) {
  const vm2 = getCurrentInstance();
  const { props: props4, slots, emit, proxy } = vm2;
  const { $q } = proxy;
  const isDark = use_dark_default(props4, $q);
  function updateFileStatus(file, status, uploadedSize) {
    file.__status = status;
    if (status === "idle") {
      file.__uploaded = 0;
      file.__progress = 0;
      file.__sizeLabel = humanStorageSize(file.size);
      file.__progressLabel = "0.00%";
      return;
    }
    if (status === "failed") {
      proxy.$forceUpdate();
      return;
    }
    file.__uploaded = status === "uploaded" ? file.size : uploadedSize;
    file.__progress = status === "uploaded" ? 1 : Math.min(0.9999, file.__uploaded / file.size);
    file.__progressLabel = getProgressLabel(file.__progress);
    proxy.$forceUpdate();
  }
  const editable = computed(() => props4.disable !== true && props4.readonly !== true);
  const dnd = ref$1(false);
  const rootRef = ref$1(null);
  const inputRef = ref$1(null);
  const state2 = {
    files: ref$1([]),
    queuedFiles: ref$1([]),
    uploadedFiles: ref$1([]),
    uploadedSize: ref$1(0),
    updateFileStatus,
    isAlive: () => vmIsDestroyed(vm2) === false
  };
  const {
    pickFiles,
    addFiles,
    onDragover,
    onDragleave,
    processFiles,
    getDndNode,
    maxFilesNumber,
    maxTotalSizeNumber
  } = use_file_default({ editable, dnd, getFileInput, addFilesToQueue });
  Object.assign(state2, getPlugin({
    props: props4,
    slots,
    emit,
    helpers: state2,
    exposeApi: (obj) => {
      Object.assign(state2, obj);
    }
  }));
  if (state2.isBusy === void 0) {
    state2.isBusy = ref$1(false);
  }
  const uploadSize = ref$1(0);
  const uploadProgress = computed(() => uploadSize.value === 0 ? 0 : state2.uploadedSize.value / uploadSize.value);
  const uploadProgressLabel = computed(() => getProgressLabel(uploadProgress.value));
  const uploadSizeLabel = computed(() => humanStorageSize(uploadSize.value));
  const canAddFiles = computed(
    () => editable.value === true && state2.isUploading.value !== true && (props4.multiple === true || state2.queuedFiles.value.length === 0) && (props4.maxFiles === void 0 || state2.files.value.length < maxFilesNumber.value) && (props4.maxTotalSize === void 0 || uploadSize.value < maxTotalSizeNumber.value)
  );
  const canUpload = computed(
    () => editable.value === true && state2.isBusy.value !== true && state2.isUploading.value !== true && state2.queuedFiles.value.length !== 0
  );
  provide(uploaderKey, renderInput);
  const classes = computed(
    () => "q-uploader column no-wrap" + (isDark.value === true ? " q-uploader--dark q-dark" : "") + (props4.bordered === true ? " q-uploader--bordered" : "") + (props4.square === true ? " q-uploader--square no-border-radius" : "") + (props4.flat === true ? " q-uploader--flat no-shadow" : "") + (props4.disable === true ? " disabled q-uploader--disable" : "") + (dnd.value === true ? " q-uploader--dnd" : "")
  );
  const colorClass = computed(
    () => "q-uploader__header" + (props4.color !== void 0 ? ` bg-${props4.color}` : "") + (props4.textColor !== void 0 ? ` text-${props4.textColor}` : "")
  );
  watch(state2.isUploading, (newVal, oldVal) => {
    if (oldVal === false && newVal === true) {
      emit("start");
    } else if (oldVal === true && newVal === false) {
      emit("finish");
    }
  });
  function reset() {
    if (props4.disable === false) {
      state2.abort();
      state2.uploadedSize.value = 0;
      uploadSize.value = 0;
      revokeImgURLs();
      state2.files.value = [];
      state2.queuedFiles.value = [];
      state2.uploadedFiles.value = [];
    }
  }
  function removeUploadedFiles() {
    if (props4.disable === false) {
      batchRemoveFiles(["uploaded"], () => {
        state2.uploadedFiles.value = [];
      });
    }
  }
  function removeQueuedFiles() {
    batchRemoveFiles(["idle", "failed"], ({ size: size2 }) => {
      uploadSize.value -= size2;
      state2.queuedFiles.value = [];
    });
  }
  function batchRemoveFiles(statusList, cb) {
    if (props4.disable === true) {
      return;
    }
    const removed = {
      files: [],
      size: 0
    };
    const localFiles = state2.files.value.filter((f) => {
      if (statusList.indexOf(f.__status) === -1) {
        return true;
      }
      removed.size += f.size;
      removed.files.push(f);
      f.__img !== void 0 && window.URL.revokeObjectURL(f.__img.src);
      return false;
    });
    if (removed.files.length !== 0) {
      state2.files.value = localFiles;
      cb(removed);
      emit("removed", removed.files);
    }
  }
  function removeFile(file) {
    if (props4.disable) return;
    if (file.__status === "uploaded") {
      state2.uploadedFiles.value = state2.uploadedFiles.value.filter((f) => f.__key !== file.__key);
    } else if (file.__status === "uploading") {
      file.__abort();
    } else {
      uploadSize.value -= file.size;
    }
    state2.files.value = state2.files.value.filter((f) => {
      if (f.__key !== file.__key) {
        return true;
      }
      f.__img !== void 0 && window.URL.revokeObjectURL(f.__img.src);
      return false;
    });
    state2.queuedFiles.value = state2.queuedFiles.value.filter((f) => f.__key !== file.__key);
    emit("removed", [file]);
  }
  function revokeImgURLs() {
    state2.files.value.forEach((f) => {
      f.__img !== void 0 && window.URL.revokeObjectURL(f.__img.src);
    });
  }
  function getFileInput() {
    return inputRef.value || rootRef.value.getElementsByClassName("q-uploader__input")[0];
  }
  function addFilesToQueue(e2, fileList) {
    const localFiles = processFiles(e2, fileList, state2.files.value, true);
    const fileInput = getFileInput();
    if (fileInput !== void 0 && fileInput !== null) {
      fileInput.value = "";
    }
    if (localFiles === void 0) return;
    localFiles.forEach((file) => {
      state2.updateFileStatus(file, "idle");
      uploadSize.value += file.size;
      if (props4.noThumbnails !== true && file.type.toUpperCase().startsWith("IMAGE")) {
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        file.__img = img;
      }
    });
    state2.files.value = state2.files.value.concat(localFiles);
    state2.queuedFiles.value = state2.queuedFiles.value.concat(localFiles);
    emit("added", localFiles);
    props4.autoUpload === true && state2.upload();
  }
  function upload() {
    canUpload.value === true && state2.upload();
  }
  function getBtn2(show, icon, fn) {
    if (show === true) {
      const data = {
        type: "a",
        key: icon,
        icon: $q.iconSet.uploader[icon],
        flat: true,
        dense: true
      };
      let child = void 0;
      if (icon === "add") {
        data.onClick = pickFiles;
        child = renderInput;
      } else {
        data.onClick = fn;
      }
      return h(QBtn_default, data, child);
    }
  }
  function renderInput() {
    return h("input", {
      ref: inputRef,
      class: "q-uploader__input overflow-hidden absolute-full",
      tabindex: -1,
      type: "file",
      title: "",
      // try to remove default tooltip
      accept: props4.accept,
      multiple: props4.multiple === true ? "multiple" : void 0,
      capture: props4.capture,
      onMousedown: stop,
      // need to stop refocus from QBtn
      onClick: pickFiles,
      onChange: addFilesToQueue
    });
  }
  function getHeader() {
    if (slots.header !== void 0) {
      return slots.header(publicApi);
    }
    return [
      h("div", {
        class: "q-uploader__header-content column"
      }, [
        h("div", {
          class: "flex flex-center no-wrap q-gutter-xs"
        }, [
          getBtn2(state2.queuedFiles.value.length !== 0, "removeQueue", removeQueuedFiles),
          getBtn2(state2.uploadedFiles.value.length !== 0, "removeUploaded", removeUploadedFiles),
          state2.isUploading.value === true ? h(QSpinner_default, { class: "q-uploader__spinner" }) : null,
          h("div", { class: "col column justify-center" }, [
            props4.label !== void 0 ? h("div", { class: "q-uploader__title" }, [props4.label]) : null,
            h("div", { class: "q-uploader__subtitle" }, [
              uploadSizeLabel.value + " / " + uploadProgressLabel.value
            ])
          ]),
          getBtn2(canAddFiles.value, "add"),
          getBtn2(props4.hideUploadBtn === false && canUpload.value === true, "upload", state2.upload),
          getBtn2(state2.isUploading.value, "clear", state2.abort)
        ])
      ])
    ];
  }
  function getList() {
    if (slots.list !== void 0) {
      return slots.list(publicApi);
    }
    return state2.files.value.map((file) => h("div", {
      key: file.__key,
      class: "q-uploader__file relative-position" + (props4.noThumbnails !== true && file.__img !== void 0 ? " q-uploader__file--img" : "") + (file.__status === "failed" ? " q-uploader__file--failed" : file.__status === "uploaded" ? " q-uploader__file--uploaded" : ""),
      style: props4.noThumbnails !== true && file.__img !== void 0 ? { backgroundImage: 'url("' + file.__img.src + '")', backgroundSize: props4.thumbnailFit } : null
    }, [
      h("div", {
        class: "q-uploader__file-header row flex-center no-wrap"
      }, [
        file.__status === "failed" ? h(QIcon_default, {
          class: "q-uploader__file-status",
          name: $q.iconSet.type.negative,
          color: "negative"
        }) : null,
        h("div", { class: "q-uploader__file-header-content col" }, [
          h("div", { class: "q-uploader__title" }, [file.name]),
          h("div", {
            class: "q-uploader__subtitle row items-center no-wrap"
          }, [
            file.__sizeLabel + " / " + file.__progressLabel
          ])
        ]),
        file.__status === "uploading" ? h(QCircularProgress_default, {
          value: file.__progress,
          min: 0,
          max: 1,
          indeterminate: file.__progress === 0
        }) : h(QBtn_default, {
          round: true,
          dense: true,
          flat: true,
          icon: $q.iconSet.uploader[file.__status === "uploaded" ? "done" : "clear"],
          onClick: () => {
            removeFile(file);
          }
        })
      ])
    ]));
  }
  onBeforeUnmount(() => {
    state2.isUploading.value === true && state2.abort();
    state2.files.value.length !== 0 && revokeImgURLs();
  });
  const publicApi = {};
  for (const key in state2) {
    if (isRef(state2[key]) === true) {
      injectProp(publicApi, key, () => state2[key].value);
    } else {
      publicApi[key] = state2[key];
    }
  }
  Object.assign(publicApi, {
    upload,
    reset,
    removeUploadedFiles,
    removeQueuedFiles,
    removeFile,
    pickFiles,
    addFiles
  });
  injectMultipleProps(publicApi, {
    canAddFiles: () => canAddFiles.value,
    canUpload: () => canUpload.value,
    uploadSizeLabel: () => uploadSizeLabel.value,
    uploadProgressLabel: () => uploadProgressLabel.value
  });
  expose({
    ...state2,
    upload,
    reset,
    removeUploadedFiles,
    removeQueuedFiles,
    removeFile,
    pickFiles,
    addFiles,
    canAddFiles,
    canUpload,
    uploadSizeLabel,
    uploadProgressLabel
  });
  return () => {
    const children = [
      h("div", { class: colorClass.value }, getHeader()),
      h("div", { class: "q-uploader__list scroll" }, getList()),
      getDndNode("uploader")
    ];
    state2.isBusy.value === true && children.push(
      h("div", {
        class: "q-uploader__overlay absolute-full flex flex-center"
      }, [h(QSpinner_default)])
    );
    const data = { ref: rootRef, class: classes.value };
    if (canAddFiles.value === true) {
      Object.assign(data, { onDragover, onDragleave });
    }
    return h("div", data, children);
  };
}
var trueFn = () => true;
function get_emits_object_default(emitsArray) {
  const emitsObject = {};
  emitsArray.forEach((val) => {
    emitsObject[val] = trueFn;
  });
  return emitsObject;
}
var coreEmitsObject = get_emits_object_default(coreEmits);
var create_uploader_component_default = ({ name: name2, props: props4, emits: emits3, injectPlugin: injectPlugin2 }) => createComponent({
  name: name2,
  props: {
    ...coreProps,
    ...props4
  },
  emits: isObject(emits3) === true ? { ...coreEmitsObject, ...emits3 } : [...coreEmits, ...emits3],
  setup(_, { expose }) {
    return getRenderer(injectPlugin2, expose);
  }
});
function getFn(prop) {
  return typeof prop === "function" ? prop : () => prop;
}
var name = "QUploader";
var props = {
  url: [Function, String],
  method: {
    type: [Function, String],
    default: "POST"
  },
  fieldName: {
    type: [Function, String],
    default: () => (file) => file.name
  },
  headers: [Function, Array],
  formFields: [Function, Array],
  withCredentials: [Function, Boolean],
  sendRaw: [Function, Boolean],
  batch: [Function, Boolean],
  factory: Function
};
var emits = ["factoryFailed", "uploaded", "failed", "uploading"];
function injectPlugin({ props: props4, emit, helpers: helpers2 }) {
  const xhrs = ref$1([]);
  const promises = ref$1([]);
  const workingThreads = ref$1(0);
  const xhrProps = computed(() => ({
    url: getFn(props4.url),
    method: getFn(props4.method),
    headers: getFn(props4.headers),
    formFields: getFn(props4.formFields),
    fieldName: getFn(props4.fieldName),
    withCredentials: getFn(props4.withCredentials),
    sendRaw: getFn(props4.sendRaw),
    batch: getFn(props4.batch)
  }));
  const isUploading = computed(() => workingThreads.value > 0);
  const isBusy = computed(() => promises.value.length !== 0);
  let abortPromises;
  function abort() {
    xhrs.value.forEach((x2) => {
      x2.abort();
    });
    if (promises.value.length !== 0) {
      abortPromises = true;
    }
  }
  function upload() {
    const queue2 = helpers2.queuedFiles.value.slice(0);
    helpers2.queuedFiles.value = [];
    if (xhrProps.value.batch(queue2)) {
      runFactory(queue2);
    } else {
      queue2.forEach((file) => {
        runFactory([file]);
      });
    }
  }
  function runFactory(files) {
    workingThreads.value++;
    if (typeof props4.factory !== "function") {
      performUpload(files, {});
      return;
    }
    const res = props4.factory(files);
    if (!res) {
      emit(
        "factoryFailed",
        new Error("QUploader: factory() does not return properly"),
        files
      );
      workingThreads.value--;
    } else if (typeof res.catch === "function" && typeof res.then === "function") {
      promises.value.push(res);
      const failed = (err) => {
        if (helpers2.isAlive() === true) {
          promises.value = promises.value.filter((p) => p !== res);
          if (promises.value.length === 0) {
            abortPromises = false;
          }
          helpers2.queuedFiles.value = helpers2.queuedFiles.value.concat(files);
          files.forEach((f) => {
            helpers2.updateFileStatus(f, "failed");
          });
          emit("factoryFailed", err, files);
          workingThreads.value--;
        }
      };
      res.then((factory) => {
        if (abortPromises === true) {
          failed(new Error("Aborted"));
        } else if (helpers2.isAlive() === true) {
          promises.value = promises.value.filter((p) => p !== res);
          performUpload(files, factory);
        }
      }).catch(failed);
    } else {
      performUpload(files, res || {});
    }
  }
  function performUpload(files, factory) {
    const form = new FormData(), xhr2 = new XMLHttpRequest();
    const getProp2 = (name2, arg) => {
      return factory[name2] !== void 0 ? getFn(factory[name2])(arg) : xhrProps.value[name2](arg);
    };
    const url = getProp2("url", files);
    if (!url) {
      console.error("q-uploader: invalid or no URL specified");
      workingThreads.value--;
      return;
    }
    const fields = getProp2("formFields", files);
    fields !== void 0 && fields.forEach((field) => {
      form.append(field.name, field.value);
    });
    let uploadIndex = 0, uploadIndexSize = 0, localUploadedSize = 0, maxUploadSize = 0, aborted;
    xhr2.upload.addEventListener("progress", (e2) => {
      if (aborted === true) return;
      const loaded = Math.min(maxUploadSize, e2.loaded);
      helpers2.uploadedSize.value += loaded - localUploadedSize;
      localUploadedSize = loaded;
      let size2 = localUploadedSize - uploadIndexSize;
      for (let i2 = uploadIndex; size2 > 0 && i2 < files.length; i2++) {
        const file = files[i2], uploaded = size2 > file.size;
        if (uploaded) {
          size2 -= file.size;
          uploadIndex++;
          uploadIndexSize += file.size;
          helpers2.updateFileStatus(file, "uploading", file.size);
        } else {
          helpers2.updateFileStatus(file, "uploading", size2);
          return;
        }
      }
    }, false);
    xhr2.onreadystatechange = () => {
      if (xhr2.readyState < 4) {
        return;
      }
      if (xhr2.status && xhr2.status < 400) {
        helpers2.uploadedFiles.value = helpers2.uploadedFiles.value.concat(files);
        files.forEach((f) => {
          helpers2.updateFileStatus(f, "uploaded");
        });
        emit("uploaded", { files, xhr: xhr2 });
      } else {
        aborted = true;
        helpers2.uploadedSize.value -= localUploadedSize;
        helpers2.queuedFiles.value = helpers2.queuedFiles.value.concat(files);
        files.forEach((f) => {
          helpers2.updateFileStatus(f, "failed");
        });
        emit("failed", { files, xhr: xhr2 });
      }
      workingThreads.value--;
      xhrs.value = xhrs.value.filter((x2) => x2 !== xhr2);
    };
    xhr2.open(
      getProp2("method", files),
      url
    );
    if (getProp2("withCredentials", files) === true) {
      xhr2.withCredentials = true;
    }
    const headers = getProp2("headers", files);
    headers !== void 0 && headers.forEach((head) => {
      xhr2.setRequestHeader(head.name, head.value);
    });
    const sendRaw = getProp2("sendRaw", files);
    files.forEach((file) => {
      helpers2.updateFileStatus(file, "uploading", 0);
      if (sendRaw !== true) {
        form.append(getProp2("fieldName", file), file, file.name);
      }
      file.xhr = xhr2;
      file.__abort = () => {
        xhr2.abort();
      };
      maxUploadSize += file.size;
    });
    emit("uploading", { files, xhr: xhr2 });
    xhrs.value.push(xhr2);
    if (sendRaw === true) {
      xhr2.send(new Blob(files));
    } else {
      xhr2.send(form);
    }
  }
  return {
    isUploading,
    isBusy,
    abort,
    upload
  };
}
var xhr_uploader_plugin_default = {
  name,
  props,
  emits,
  injectPlugin
};
create_uploader_component_default(xhr_uploader_plugin_default);
createComponent({
  name: "QUploaderAddTrigger",
  setup() {
    const $trigger = inject(uploaderKey, emptyRenderFn);
    if ($trigger === emptyRenderFn) {
      console.error("QUploaderAddTrigger needs to be child of QUploader");
    }
    return $trigger;
  }
});
createComponent({
  name: "QVideo",
  props: {
    ...useRatioProps,
    src: {
      type: String,
      required: true
    },
    title: String,
    fetchpriority: {
      type: String,
      default: "auto"
    },
    loading: {
      type: String,
      default: "eager"
    },
    referrerpolicy: {
      type: String,
      default: "strict-origin-when-cross-origin"
    }
  },
  setup(props4) {
    const ratioStyle = use_ratio_default(props4);
    const classes = computed(
      () => "q-video" + (props4.ratio !== void 0 ? " q-video--responsive" : "")
    );
    return () => h("div", {
      class: classes.value,
      style: ratioStyle.value
    }, [
      h("iframe", {
        src: props4.src,
        title: props4.title,
        fetchpriority: props4.fetchpriority,
        loading: props4.loading,
        referrerpolicy: props4.referrerpolicy,
        frameborder: "0",
        allowfullscreen: true
      })
    ]);
  }
});
function getDepth(value2) {
  if (value2 === false) {
    return 0;
  }
  if (value2 === true || value2 === void 0) {
    return 1;
  }
  const depth = parseInt(value2, 10);
  return isNaN(depth) ? 0 : depth;
}
createDirective(
  {
    name: "close-popup",
    beforeMount(el, { value: value2 }) {
      const ctx = {
        depth: getDepth(value2),
        handler(evt) {
          ctx.depth !== 0 && setTimeout(() => {
            const proxy = getPortalProxy(el);
            if (proxy !== void 0) {
              closePortals(proxy, evt, ctx.depth);
            }
          });
        },
        handlerKey(evt) {
          isKeyCode(evt, 13) === true && ctx.handler(evt);
        }
      };
      el.__qclosepopup = ctx;
      el.addEventListener("click", ctx.handler);
      el.addEventListener("keyup", ctx.handlerKey);
    },
    updated(el, { value: value2, oldValue }) {
      if (value2 !== oldValue) {
        el.__qclosepopup.depth = getDepth(value2);
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qclosepopup;
      el.removeEventListener("click", ctx.handler);
      el.removeEventListener("keyup", ctx.handlerKey);
      delete el.__qclosepopup;
    }
  }
);
var id2 = 0;
var offsetBase = void 0;
function getAbsolutePosition(el, resize) {
  if (offsetBase === void 0) {
    offsetBase = document.createElement("div");
    offsetBase.style.cssText = "position: absolute; left: 0; top: 0";
    document.body.appendChild(offsetBase);
  }
  const boundingRect = el.getBoundingClientRect();
  const baseRect = offsetBase.getBoundingClientRect();
  const { marginLeft, marginRight, marginTop, marginBottom } = window.getComputedStyle(el);
  const marginH = parseInt(marginLeft, 10) + parseInt(marginRight, 10);
  const marginV = parseInt(marginTop, 10) + parseInt(marginBottom, 10);
  return {
    left: boundingRect.left - baseRect.left,
    top: boundingRect.top - baseRect.top,
    width: boundingRect.right - boundingRect.left,
    height: boundingRect.bottom - boundingRect.top,
    widthM: boundingRect.right - boundingRect.left + (resize === true ? 0 : marginH),
    heightM: boundingRect.bottom - boundingRect.top + (resize === true ? 0 : marginV),
    marginH: resize === true ? marginH : 0,
    marginV: resize === true ? marginV : 0
  };
}
function getAbsoluteSize(el) {
  return {
    width: el.scrollWidth,
    height: el.scrollHeight
  };
}
var styleEdges = ["Top", "Right", "Bottom", "Left"];
var styleBorderRadiuses = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"];
var reStyleSkipKey = /-block|-inline|block-|inline-/;
var reStyleSkipRule = /(-block|-inline|block-|inline-).*:/;
function getComputedStyle2(el, props4) {
  const style2 = window.getComputedStyle(el);
  const fixed = {};
  for (let i2 = 0; i2 < props4.length; i2++) {
    const prop = props4[i2];
    if (style2[prop] === "") {
      if (prop === "cssText") {
        const styleLen = style2.length;
        let val = "";
        for (let i22 = 0; i22 < styleLen; i22++) {
          if (reStyleSkipKey.test(style2[i22]) !== true) {
            val += style2[i22] + ": " + style2[style2[i22]] + "; ";
          }
        }
        fixed[prop] = val;
      } else if (["borderWidth", "borderStyle", "borderColor"].indexOf(prop) !== -1) {
        const suffix = prop.replace("border", "");
        let val = "";
        for (let j = 0; j < styleEdges.length; j++) {
          const subProp = "border" + styleEdges[j] + suffix;
          val += style2[subProp] + " ";
        }
        fixed[prop] = val;
      } else if (prop === "borderRadius") {
        let val1 = "";
        let val2 = "";
        for (let j = 0; j < styleBorderRadiuses.length; j++) {
          const val = style2[styleBorderRadiuses[j]].split(" ");
          val1 += val[0] + " ";
          val2 += (val[1] === void 0 ? val[0] : val[1]) + " ";
        }
        fixed[prop] = val1 + "/ " + val2;
      } else {
        fixed[prop] = style2[prop];
      }
    } else {
      if (prop === "cssText") {
        fixed[prop] = style2[prop].split(";").filter((val) => reStyleSkipRule.test(val) !== true).join(";");
      } else {
        fixed[prop] = style2[prop];
      }
    }
  }
  return fixed;
}
var zIndexPositions = ["absolute", "fixed", "relative", "sticky"];
function getMaxZIndex(elStart) {
  let el = elStart;
  let maxIndex = 0;
  while (el !== null && el !== document) {
    const { position: position2, zIndex } = window.getComputedStyle(el);
    const zIndexNum = Number(zIndex);
    if (zIndexNum > maxIndex && (el === elStart || zIndexPositions.includes(position2) === true)) {
      maxIndex = zIndexNum;
    }
    el = el.parentNode;
  }
  return maxIndex;
}
function normalizeElements(opts) {
  return {
    from: opts.from,
    to: opts.to !== void 0 ? opts.to : opts.from
  };
}
function normalizeOptions(options) {
  if (typeof options === "number") {
    options = {
      duration: options
    };
  } else if (typeof options === "function") {
    options = {
      onEnd: options
    };
  }
  return {
    ...options,
    waitFor: options.waitFor === void 0 ? 0 : options.waitFor,
    duration: isNaN(options.duration) === true ? 300 : parseInt(options.duration, 10),
    easing: typeof options.easing === "string" && options.easing.length !== 0 ? options.easing : "ease-in-out",
    delay: isNaN(options.delay) === true ? 0 : parseInt(options.delay, 10),
    fill: typeof options.fill === "string" && options.fill.length !== 0 ? options.fill : "none",
    resize: options.resize === true,
    // account for UMD too where modifiers will be lowercased to work
    useCSS: options.useCSS === true || options.usecss === true,
    // account for UMD too where modifiers will be lowercased to work
    hideFromClone: options.hideFromClone === true || options.hidefromclone === true,
    // account for UMD too where modifiers will be lowercased to work
    keepToClone: options.keepToClone === true || options.keeptoclone === true,
    tween: options.tween === true,
    tweenFromOpacity: isNaN(options.tweenFromOpacity) === true ? 0.6 : parseFloat(options.tweenFromOpacity),
    tweenToOpacity: isNaN(options.tweenToOpacity) === true ? 0.5 : parseFloat(options.tweenToOpacity)
  };
}
function getElement2(element) {
  const type2 = typeof element;
  return type2 === "function" ? element() : type2 === "string" ? document.querySelector(element) : element;
}
function isValidElement(element) {
  return element && element.ownerDocument === document && element.parentNode !== null;
}
function morph(_options) {
  let cancel = () => false;
  let cancelStatus = false;
  let endElementTo = true;
  const elements = normalizeElements(_options);
  const options = normalizeOptions(_options);
  const elFrom = getElement2(elements.from);
  if (isValidElement(elFrom) !== true) {
    return cancel;
  }
  typeof elFrom.qMorphCancel === "function" && elFrom.qMorphCancel();
  let animationFromClone = void 0;
  let animationFromTween = void 0;
  let animationToClone = void 0;
  let animationTo = void 0;
  const elFromParent = elFrom.parentNode;
  const elFromNext = elFrom.nextElementSibling;
  const elFromPosition = getAbsolutePosition(elFrom, options.resize);
  const {
    width: elFromParentWidthBefore,
    height: elFromParentHeightBefore
  } = getAbsoluteSize(elFromParent);
  const {
    borderWidth: elFromBorderWidth,
    borderStyle: elFromBorderStyle,
    borderColor: elFromBorderColor,
    borderRadius: elFromBorderRadius,
    backgroundColor: elFromBackground,
    transform: elFromTransform,
    position: elFromPositioningType,
    cssText: elFromCssText
  } = getComputedStyle2(elFrom, ["borderWidth", "borderStyle", "borderColor", "borderRadius", "backgroundColor", "transform", "position", "cssText"]);
  const elFromClassSaved = elFrom.classList.toString();
  const elFromStyleSaved = elFrom.style.cssText;
  const elFromClone = elFrom.cloneNode(true);
  const elFromTween = options.tween === true ? elFrom.cloneNode(true) : void 0;
  if (elFromTween !== void 0) {
    elFromTween.className = elFromTween.classList.toString().split(" ").filter((c2) => /^bg-/.test(c2) === false).join(" ");
  }
  options.hideFromClone === true && elFromClone.classList.add("q-morph--internal");
  elFromClone.setAttribute("aria-hidden", "true");
  elFromClone.style.transition = "none";
  elFromClone.style.animation = "none";
  elFromClone.style.pointerEvents = "none";
  elFromParent.insertBefore(elFromClone, elFromNext);
  elFrom.qMorphCancel = () => {
    cancelStatus = true;
    elFromClone.remove();
    elFromTween !== void 0 && elFromTween.remove();
    options.hideFromClone === true && elFromClone.classList.remove("q-morph--internal");
    elFrom.qMorphCancel = void 0;
  };
  const calculateFinalState = () => {
    const elTo = getElement2(elements.to);
    if (cancelStatus === true || isValidElement(elTo) !== true) {
      typeof elFrom.qMorphCancel === "function" && elFrom.qMorphCancel();
      return;
    }
    elFrom !== elTo && typeof elTo.qMorphCancel === "function" && elTo.qMorphCancel();
    options.keepToClone !== true && elTo.classList.add("q-morph--internal");
    elFromClone.classList.add("q-morph--internal");
    const {
      width: elFromParentWidthAfter,
      height: elFromParentHeightAfter
    } = getAbsoluteSize(elFromParent);
    const {
      width: elToParentWidthBefore,
      height: elToParentHeightBefore
    } = getAbsoluteSize(elTo.parentNode);
    options.hideFromClone !== true && elFromClone.classList.remove("q-morph--internal");
    elTo.qMorphCancel = () => {
      cancelStatus = true;
      elFromClone.remove();
      elFromTween !== void 0 && elFromTween.remove();
      options.hideFromClone === true && elFromClone.classList.remove("q-morph--internal");
      options.keepToClone !== true && elTo.classList.remove("q-morph--internal");
      elFrom.qMorphCancel = void 0;
      elTo.qMorphCancel = void 0;
    };
    const animate = () => {
      if (cancelStatus === true) {
        typeof elTo.qMorphCancel === "function" && elTo.qMorphCancel();
        return;
      }
      if (options.hideFromClone !== true) {
        elFromClone.classList.add("q-morph--internal");
        elFromClone.innerHTML = "";
        elFromClone.style.left = 0;
        elFromClone.style.right = "unset";
        elFromClone.style.top = 0;
        elFromClone.style.bottom = "unset";
        elFromClone.style.transform = "none";
      }
      if (options.keepToClone !== true) {
        elTo.classList.remove("q-morph--internal");
      }
      const elToParent = elTo.parentNode;
      const {
        width: elToParentWidthAfter,
        height: elToParentHeightAfter
      } = getAbsoluteSize(elToParent);
      const elToClone = elTo.cloneNode(options.keepToClone);
      elToClone.setAttribute("aria-hidden", "true");
      if (options.keepToClone !== true) {
        elToClone.style.left = 0;
        elToClone.style.right = "unset";
        elToClone.style.top = 0;
        elToClone.style.bottom = "unset";
        elToClone.style.transform = "none";
        elToClone.style.pointerEvents = "none";
      }
      elToClone.classList.add("q-morph--internal");
      const elToNext = elTo === elFrom && elFromParent === elToParent ? elFromClone : elTo.nextElementSibling;
      elToParent.insertBefore(elToClone, elToNext);
      const {
        borderWidth: elToBorderWidth,
        borderStyle: elToBorderStyle,
        borderColor: elToBorderColor,
        borderRadius: elToBorderRadius,
        backgroundColor: elToBackground,
        transform: elToTransform,
        position: elToPositioningType,
        cssText: elToCssText
      } = getComputedStyle2(elTo, ["borderWidth", "borderStyle", "borderColor", "borderRadius", "backgroundColor", "transform", "position", "cssText"]);
      const elToClassSaved = elTo.classList.toString();
      const elToStyleSaved = elTo.style.cssText;
      elTo.style.cssText = elToCssText;
      elTo.style.transform = "none";
      elTo.style.animation = "none";
      elTo.style.transition = "none";
      elTo.className = elToClassSaved.split(" ").filter((c2) => /^bg-/.test(c2) === false).join(" ");
      const elToPosition = getAbsolutePosition(elTo, options.resize);
      const deltaX = elFromPosition.left - elToPosition.left;
      const deltaY = elFromPosition.top - elToPosition.top;
      const scaleX = elFromPosition.width / (elToPosition.width > 0 ? elToPosition.width : 10);
      const scaleY = elFromPosition.height / (elToPosition.height > 0 ? elToPosition.height : 100);
      const elFromParentWidthDiff = elFromParentWidthBefore - elFromParentWidthAfter;
      const elFromParentHeightDiff = elFromParentHeightBefore - elFromParentHeightAfter;
      const elToParentWidthDiff = elToParentWidthAfter - elToParentWidthBefore;
      const elToParentHeightDiff = elToParentHeightAfter - elToParentHeightBefore;
      const elFromCloneWidth = Math.max(elFromPosition.widthM, elFromParentWidthDiff);
      const elFromCloneHeight = Math.max(elFromPosition.heightM, elFromParentHeightDiff);
      const elToCloneWidth = Math.max(elToPosition.widthM, elToParentWidthDiff);
      const elToCloneHeight = Math.max(elToPosition.heightM, elToParentHeightDiff);
      const elSharedSize = elFrom === elTo && ["absolute", "fixed"].includes(elToPositioningType) === false && ["absolute", "fixed"].includes(elFromPositioningType) === false;
      let elToNeedsFixedPosition = elToPositioningType === "fixed";
      let parent = elToParent;
      while (elToNeedsFixedPosition !== true && parent !== document) {
        elToNeedsFixedPosition = window.getComputedStyle(parent).position === "fixed";
        parent = parent.parentNode;
      }
      if (options.hideFromClone !== true) {
        elFromClone.style.display = "block";
        elFromClone.style.flex = "0 0 auto";
        elFromClone.style.opacity = 0;
        elFromClone.style.minWidth = "unset";
        elFromClone.style.maxWidth = "unset";
        elFromClone.style.minHeight = "unset";
        elFromClone.style.maxHeight = "unset";
        elFromClone.classList.remove("q-morph--internal");
      }
      if (options.keepToClone !== true) {
        elToClone.style.display = "block";
        elToClone.style.flex = "0 0 auto";
        elToClone.style.opacity = 0;
        elToClone.style.minWidth = "unset";
        elToClone.style.maxWidth = "unset";
        elToClone.style.minHeight = "unset";
        elToClone.style.maxHeight = "unset";
      }
      elToClone.classList.remove("q-morph--internal");
      if (typeof options.classes === "string") {
        elTo.className += " " + options.classes;
      }
      if (typeof options.style === "string") {
        elTo.style.cssText += " " + options.style;
      } else if (isObject(options.style) === true) {
        for (const prop in options.style) {
          elTo.style[prop] = options.style[prop];
        }
      }
      const elFromZIndex = getMaxZIndex(elFromClone);
      const elToZIndex = getMaxZIndex(elTo);
      const documentScroll = elToNeedsFixedPosition === true ? document.documentElement : { scrollLeft: 0, scrollTop: 0 };
      elTo.style.position = elToNeedsFixedPosition === true ? "fixed" : "absolute";
      elTo.style.left = `${elToPosition.left - documentScroll.scrollLeft}px`;
      elTo.style.right = "unset";
      elTo.style.top = `${elToPosition.top - documentScroll.scrollTop}px`;
      elTo.style.margin = 0;
      if (options.resize === true) {
        elTo.style.minWidth = "unset";
        elTo.style.maxWidth = "unset";
        elTo.style.minHeight = "unset";
        elTo.style.maxHeight = "unset";
        elTo.style.overflow = "hidden";
        elTo.style.overflowX = "hidden";
        elTo.style.overflowY = "hidden";
      }
      document.body.appendChild(elTo);
      if (elFromTween !== void 0) {
        elFromTween.style.cssText = elFromCssText;
        elFromTween.style.transform = "none";
        elFromTween.style.animation = "none";
        elFromTween.style.transition = "none";
        elFromTween.style.position = elTo.style.position;
        elFromTween.style.left = `${elFromPosition.left - documentScroll.scrollLeft}px`;
        elFromTween.style.right = "unset";
        elFromTween.style.top = `${elFromPosition.top - documentScroll.scrollTop}px`;
        elFromTween.style.margin = 0;
        elFromTween.style.pointerEvents = "none";
        if (options.resize === true) {
          elFromTween.style.minWidth = "unset";
          elFromTween.style.maxWidth = "unset";
          elFromTween.style.minHeight = "unset";
          elFromTween.style.maxHeight = "unset";
          elFromTween.style.overflow = "hidden";
          elFromTween.style.overflowX = "hidden";
          elFromTween.style.overflowY = "hidden";
        }
        document.body.appendChild(elFromTween);
      }
      const commonCleanup = (aborted) => {
        if (elFrom === elTo && endElementTo !== true) {
          elTo.style.cssText = elFromStyleSaved;
          elTo.className = elFromClassSaved;
        } else {
          elTo.style.cssText = elToStyleSaved;
          elTo.className = elToClassSaved;
        }
        elToClone.parentNode === elToParent && elToParent.insertBefore(elTo, elToClone);
        elFromClone.remove();
        elToClone.remove();
        elFromTween !== void 0 && elFromTween.remove();
        cancel = () => false;
        elFrom.qMorphCancel = void 0;
        elTo.qMorphCancel = void 0;
        if (typeof options.onEnd === "function") {
          options.onEnd(endElementTo === true ? "to" : "from", aborted === true);
        }
      };
      if (options.useCSS !== true && typeof elTo.animate === "function") {
        const resizeFrom = options.resize === true ? {
          transform: `translate(${deltaX}px, ${deltaY}px)`,
          width: `${elFromCloneWidth}px`,
          height: `${elFromCloneHeight}px`
        } : {
          transform: `translate(${deltaX}px, ${deltaY}px) scale(${scaleX}, ${scaleY})`
        };
        const resizeTo = options.resize === true ? {
          width: `${elToCloneWidth}px`,
          height: `${elToCloneHeight}px`
        } : {};
        const resizeFromTween = options.resize === true ? {
          width: `${elFromCloneWidth}px`,
          height: `${elFromCloneHeight}px`
        } : {};
        const resizeToTween = options.resize === true ? {
          transform: `translate(${-1 * deltaX}px, ${-1 * deltaY}px)`,
          width: `${elToCloneWidth}px`,
          height: `${elToCloneHeight}px`
        } : {
          transform: `translate(${-1 * deltaX}px, ${-1 * deltaY}px) scale(${1 / scaleX}, ${1 / scaleY})`
        };
        const tweenFrom = elFromTween !== void 0 ? { opacity: options.tweenToOpacity } : { backgroundColor: elFromBackground };
        const tweenTo = elFromTween !== void 0 ? { opacity: 1 } : { backgroundColor: elToBackground };
        animationTo = elTo.animate([
          {
            margin: 0,
            borderWidth: elFromBorderWidth,
            borderStyle: elFromBorderStyle,
            borderColor: elFromBorderColor,
            borderRadius: elFromBorderRadius,
            zIndex: elFromZIndex,
            transformOrigin: "0 0",
            ...resizeFrom,
            ...tweenFrom
          },
          {
            margin: 0,
            borderWidth: elToBorderWidth,
            borderStyle: elToBorderStyle,
            borderColor: elToBorderColor,
            borderRadius: elToBorderRadius,
            zIndex: elToZIndex,
            transformOrigin: "0 0",
            transform: elToTransform,
            ...resizeTo,
            ...tweenTo
          }
        ], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        animationFromTween = elFromTween === void 0 ? void 0 : elFromTween.animate([
          {
            opacity: options.tweenFromOpacity,
            margin: 0,
            borderWidth: elFromBorderWidth,
            borderStyle: elFromBorderStyle,
            borderColor: elFromBorderColor,
            borderRadius: elFromBorderRadius,
            zIndex: elFromZIndex,
            transformOrigin: "0 0",
            transform: elFromTransform,
            ...resizeFromTween
          },
          {
            opacity: 0,
            margin: 0,
            borderWidth: elToBorderWidth,
            borderStyle: elToBorderStyle,
            borderColor: elToBorderColor,
            borderRadius: elToBorderRadius,
            zIndex: elToZIndex,
            transformOrigin: "0 0",
            ...resizeToTween
          }
        ], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        animationFromClone = options.hideFromClone === true || elSharedSize === true ? void 0 : elFromClone.animate([
          {
            margin: `${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px`,
            width: `${elFromCloneWidth + elFromPosition.marginH}px`,
            height: `${elFromCloneHeight + elFromPosition.marginV}px`
          },
          {
            margin: 0,
            width: 0,
            height: 0
          }
        ], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        animationToClone = options.keepToClone === true ? void 0 : elToClone.animate([
          elSharedSize === true ? {
            margin: `${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px`,
            width: `${elFromCloneWidth + elFromPosition.marginH}px`,
            height: `${elFromCloneHeight + elFromPosition.marginV}px`
          } : {
            margin: 0,
            width: 0,
            height: 0
          },
          {
            margin: `${elToParentHeightDiff < 0 ? elToParentHeightDiff / 2 : 0}px ${elToParentWidthDiff < 0 ? elToParentWidthDiff / 2 : 0}px`,
            width: `${elToCloneWidth + elToPosition.marginH}px`,
            height: `${elToCloneHeight + elToPosition.marginV}px`
          }
        ], {
          duration: options.duration,
          easing: options.easing,
          fill: options.fill,
          delay: options.delay
        });
        const cleanup = (abort) => {
          animationFromClone !== void 0 && animationFromClone.cancel();
          animationFromTween !== void 0 && animationFromTween.cancel();
          animationToClone !== void 0 && animationToClone.cancel();
          animationTo.cancel();
          animationTo.removeEventListener("finish", cleanup);
          animationTo.removeEventListener("cancel", cleanup);
          commonCleanup(abort);
          animationFromClone = void 0;
          animationFromTween = void 0;
          animationToClone = void 0;
          animationTo = void 0;
        };
        elFrom.qMorphCancel = () => {
          elFrom.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        elTo.qMorphCancel = () => {
          elTo.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        animationTo.addEventListener("finish", cleanup);
        animationTo.addEventListener("cancel", cleanup);
        cancel = (abort) => {
          if (cancelStatus === true || animationTo === void 0) {
            return false;
          }
          if (abort === true) {
            cleanup(true);
            return true;
          }
          endElementTo = endElementTo !== true;
          animationFromClone !== void 0 && animationFromClone.reverse();
          animationFromTween !== void 0 && animationFromTween.reverse();
          animationToClone !== void 0 && animationToClone.reverse();
          animationTo.reverse();
          return true;
        };
      } else {
        const qAnimId = `q-morph-anim-${++id2}`;
        const style2 = document.createElement("style");
        const resizeFrom = options.resize === true ? `
            transform: translate(${deltaX}px, ${deltaY}px);
            width: ${elFromCloneWidth}px;
            height: ${elFromCloneHeight}px;
          ` : `transform: translate(${deltaX}px, ${deltaY}px) scale(${scaleX}, ${scaleY});`;
        const resizeTo = options.resize === true ? `
            width: ${elToCloneWidth}px;
            height: ${elToCloneHeight}px;
          ` : "";
        const resizeFromTween = options.resize === true ? `
            width: ${elFromCloneWidth}px;
            height: ${elFromCloneHeight}px;
          ` : "";
        const resizeToTween = options.resize === true ? `
            transform: translate(${-1 * deltaX}px, ${-1 * deltaY}px);
            width: ${elToCloneWidth}px;
            height: ${elToCloneHeight}px;
          ` : `transform: translate(${-1 * deltaX}px, ${-1 * deltaY}px) scale(${1 / scaleX}, ${1 / scaleY});`;
        const tweenFrom = elFromTween !== void 0 ? `opacity: ${options.tweenToOpacity};` : `background-color: ${elFromBackground};`;
        const tweenTo = elFromTween !== void 0 ? "opacity: 1;" : `background-color: ${elToBackground};`;
        const keyframesFromTween = elFromTween === void 0 ? "" : `
            @keyframes ${qAnimId}-from-tween {
              0% {
                opacity: ${options.tweenFromOpacity};
                margin: 0;
                border-width: ${elFromBorderWidth};
                border-style: ${elFromBorderStyle};
                border-color: ${elFromBorderColor};
                border-radius: ${elFromBorderRadius};
                z-index: ${elFromZIndex};
                transform-origin: 0 0;
                transform: ${elFromTransform};
                ${resizeFromTween}
              }

              100% {
                opacity: 0;
                margin: 0;
                border-width: ${elToBorderWidth};
                border-style: ${elToBorderStyle};
                border-color: ${elToBorderColor};
                border-radius: ${elToBorderRadius};
                z-index: ${elToZIndex};
                transform-origin: 0 0;
                ${resizeToTween}
              }
            }
          `;
        const keyframesFrom = options.hideFromClone === true || elSharedSize === true ? "" : `
            @keyframes ${qAnimId}-from {
              0% {
                margin: ${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px;
                width: ${elFromCloneWidth + elFromPosition.marginH}px;
                height: ${elFromCloneHeight + elFromPosition.marginV}px;
              }

              100% {
                margin: 0;
                width: 0;
                height: 0;
              }
            }
          `;
        const keyframeToStart = elSharedSize === true ? `
            margin: ${elFromParentHeightDiff < 0 ? elFromParentHeightDiff / 2 : 0}px ${elFromParentWidthDiff < 0 ? elFromParentWidthDiff / 2 : 0}px;
            width: ${elFromCloneWidth + elFromPosition.marginH}px;
            height: ${elFromCloneHeight + elFromPosition.marginV}px;
          ` : `
            margin: 0;
            width: 0;
            height: 0;
          `;
        const keyframesTo = options.keepToClone === true ? "" : `
            @keyframes ${qAnimId}-to {
              0% {
                ${keyframeToStart}
              }

              100% {
                margin: ${elToParentHeightDiff < 0 ? elToParentHeightDiff / 2 : 0}px ${elToParentWidthDiff < 0 ? elToParentWidthDiff / 2 : 0}px;
                width: ${elToCloneWidth + elToPosition.marginH}px;
                height: ${elToCloneHeight + elToPosition.marginV}px;
              }
            }
          `;
        style2.innerHTML = `
          @keyframes ${qAnimId} {
            0% {
              margin: 0;
              border-width: ${elFromBorderWidth};
              border-style: ${elFromBorderStyle};
              border-color: ${elFromBorderColor};
              border-radius: ${elFromBorderRadius};
              background-color: ${elFromBackground};
              z-index: ${elFromZIndex};
              transform-origin: 0 0;
              ${resizeFrom}
              ${tweenFrom}
            }

            100% {
              margin: 0;
              border-width: ${elToBorderWidth};
              border-style: ${elToBorderStyle};
              border-color: ${elToBorderColor};
              border-radius: ${elToBorderRadius};
              background-color: ${elToBackground};
              z-index: ${elToZIndex};
              transform-origin: 0 0;
              transform: ${elToTransform};
              ${resizeTo}
              ${tweenTo}
            }
          }

          ${keyframesFrom}

          ${keyframesFromTween}

          ${keyframesTo}
        `;
        document.head.appendChild(style2);
        let animationDirection = "normal";
        elFromClone.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-from`;
        if (elFromTween !== void 0) {
          elFromTween.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-from-tween`;
        }
        elToClone.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}-to`;
        elTo.style.animation = `${options.duration}ms ${options.easing} ${options.delay}ms ${animationDirection} ${options.fill} ${qAnimId}`;
        const cleanup = (evt) => {
          if (evt === Object(evt) && evt.animationName !== qAnimId) {
            return;
          }
          elTo.removeEventListener("animationend", cleanup);
          elTo.removeEventListener("animationcancel", cleanup);
          commonCleanup();
          style2.remove();
        };
        elFrom.qMorphCancel = () => {
          elFrom.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        elTo.qMorphCancel = () => {
          elTo.qMorphCancel = void 0;
          cancelStatus = true;
          cleanup();
        };
        elTo.addEventListener("animationend", cleanup);
        elTo.addEventListener("animationcancel", cleanup);
        cancel = (abort) => {
          if (cancelStatus === true || !elTo || !elFromClone || !elToClone) {
            return false;
          }
          if (abort === true) {
            cleanup();
            return true;
          }
          endElementTo = endElementTo !== true;
          animationDirection = animationDirection === "normal" ? "reverse" : "normal";
          elFromClone.style.animationDirection = animationDirection;
          elFromTween.style.animationDirection = animationDirection;
          elToClone.style.animationDirection = animationDirection;
          elTo.style.animationDirection = animationDirection;
          return true;
        };
      }
    };
    if (options.waitFor > 0 || options.waitFor === "transitionend" || options.waitFor === Object(options.waitFor) && typeof options.waitFor.then === "function") {
      const delayPromise = options.waitFor > 0 ? new Promise((resolve) => setTimeout(resolve, options.waitFor)) : options.waitFor === "transitionend" ? new Promise((resolve) => {
        const endFn = () => {
          if (timer2 !== null) {
            clearTimeout(timer2);
            timer2 = null;
          }
          if (elTo) {
            elTo.removeEventListener("transitionend", endFn);
            elTo.removeEventListener("transitioncancel", endFn);
          }
          resolve();
        };
        let timer2 = setTimeout(endFn, 400);
        elTo.addEventListener("transitionend", endFn);
        elTo.addEventListener("transitioncancel", endFn);
      }) : options.waitFor;
      delayPromise.then(animate).catch(() => {
        typeof elTo.qMorphCancel === "function" && elTo.qMorphCancel();
      });
    } else {
      animate();
    }
  };
  typeof _options.onToggle === "function" && _options.onToggle();
  requestAnimationFrame(calculateFinalState);
  return (abort) => cancel(abort);
}
var morphGroups = {};
var props2 = [
  "duration",
  "delay",
  "easing",
  "fill",
  "classes",
  "style",
  "duration",
  "resize",
  "useCSS",
  "hideFromClone",
  "keepToClone",
  "tween",
  "tweenFromOpacity",
  "tweenToOpacity",
  "waitFor",
  "onEnd"
];
var mods = [
  "resize",
  "useCSS",
  "hideFromClone",
  "keepToClone",
  "tween"
];
function changeClass(ctx, action) {
  if (ctx.clsAction !== action) {
    ctx.clsAction = action;
    ctx.el.classList[action]("q-morph--invisible");
  }
}
function trigger2(group) {
  if (group.animating === true || group.queue.length < 2) {
    return;
  }
  const [from, to] = group.queue;
  group.animating = true;
  from.animating = true;
  to.animating = true;
  changeClass(from, "remove");
  changeClass(to, "remove");
  const cancelFn = morph({
    from: from.el,
    to: to.el,
    onToggle() {
      changeClass(from, "add");
      changeClass(to, "remove");
    },
    ...to.opts,
    onEnd(dir, aborted) {
      to.opts.onEnd !== void 0 && to.opts.onEnd(dir, aborted);
      if (aborted === true) {
        return;
      }
      from.animating = false;
      to.animating = false;
      group.animating = false;
      group.cancel = void 0;
      group.queue.shift();
      trigger2(group);
    }
  });
  group.cancel = () => {
    cancelFn(true);
    group.cancel = void 0;
  };
}
function updateModifiers2(mod2, ctx) {
  const opts = ctx.opts;
  mods.forEach((name2) => {
    opts[name2] = mod2[name2] === true;
  });
}
function insertArgs(arg, ctx) {
  const opts = typeof arg === "string" && arg.length !== 0 ? arg.split(":") : [];
  ctx.name = opts[0];
  ctx.group = opts[1];
  Object.assign(ctx.opts, {
    duration: isNaN(opts[2]) === true ? 300 : parseFloat(opts[2]),
    waitFor: opts[3]
  });
}
function updateArgs(arg, ctx) {
  if (arg.group !== void 0) {
    ctx.group = arg.group;
  }
  if (arg.name !== void 0) {
    ctx.name = arg.name;
  }
  const opts = ctx.opts;
  props2.forEach((name2) => {
    if (arg[name2] !== void 0) {
      opts[name2] = arg[name2];
    }
  });
}
function updateModel(name2, ctx) {
  if (ctx.name === name2) {
    const group = morphGroups[ctx.group];
    if (group === void 0) {
      morphGroups[ctx.group] = {
        name: ctx.group,
        model: name2,
        queue: [ctx],
        animating: false
      };
      changeClass(ctx, "remove");
    } else if (group.model !== name2) {
      group.model = name2;
      group.queue.push(ctx);
      if (group.animating === false && group.queue.length === 2) {
        trigger2(group);
      }
    }
    return;
  }
  if (ctx.animating === false) {
    changeClass(ctx, "add");
  }
}
function updateValue(ctx, value2) {
  let model;
  if (Object(value2) === value2) {
    model = "" + value2.model;
    updateArgs(value2, ctx);
    updateModifiers2(value2, ctx);
  } else {
    model = "" + value2;
  }
  if (model !== ctx.model) {
    ctx.model = model;
    updateModel(model, ctx);
  } else if (ctx.animating === false && ctx.clsAction !== void 0) {
    ctx.el.classList[ctx.clsAction]("q-morph--invisible");
  }
}
createDirective(
  {
    name: "morph",
    mounted(el, binding) {
      const ctx = {
        el,
        animating: false,
        opts: {}
      };
      updateModifiers2(binding.modifiers, ctx);
      insertArgs(binding.arg, ctx);
      updateValue(ctx, binding.value);
      el.__qmorph = ctx;
    },
    updated(el, binding) {
      updateValue(el.__qmorph, binding.value);
    },
    beforeUnmount(el) {
      const ctx = el.__qmorph;
      const group = morphGroups[ctx.group];
      if (group !== void 0) {
        const index = group.queue.indexOf(ctx);
        if (index !== -1) {
          group.queue = group.queue.filter((item) => item !== ctx);
          if (group.queue.length === 0) {
            group.cancel !== void 0 && group.cancel();
            delete morphGroups[ctx.group];
          }
        }
      }
      if (ctx.clsAction === "add") {
        el.classList.remove("q-morph--invisible");
      }
      delete el.__qmorph;
    }
  }
);
var defaultCfg2 = {
  childList: true,
  subtree: true,
  attributes: true,
  characterData: true,
  attributeOldValue: true,
  characterDataOldValue: true
};
function update3(el, ctx, value2) {
  ctx.handler = value2;
  ctx.observer !== void 0 && ctx.observer.disconnect();
  ctx.observer = new MutationObserver((list) => {
    if (typeof ctx.handler === "function") {
      const res = ctx.handler(list);
      if (res === false || ctx.once === true) {
        destroy2(el);
      }
    }
  });
  ctx.observer.observe(el, ctx.opts);
}
function destroy2(el) {
  const ctx = el.__qmutation;
  if (ctx !== void 0) {
    ctx.observer !== void 0 && ctx.observer.disconnect();
    delete el.__qmutation;
  }
}
createDirective(
  {
    name: "mutation",
    mounted(el, { modifiers: { once, ...mod2 }, value: value2 }) {
      const ctx = {
        once,
        opts: Object.keys(mod2).length === 0 ? defaultCfg2 : mod2
      };
      update3(el, ctx, value2);
      el.__qmutation = ctx;
    },
    updated(el, { oldValue, value: value2 }) {
      const ctx = el.__qmutation;
      if (ctx !== void 0 && oldValue !== value2) {
        update3(el, ctx, value2);
      }
    },
    beforeUnmount: destroy2
  }
);
var { passive: passive5 } = listenOpts;
function update4(ctx, { value: value2, oldValue }) {
  if (typeof value2 !== "function") {
    ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, passive5);
    return;
  }
  ctx.handler = value2;
  if (typeof oldValue !== "function") {
    ctx.scrollTarget.addEventListener("scroll", ctx.scroll, passive5);
    ctx.scroll();
  }
}
createDirective(
  {
    name: "scroll-fire",
    mounted(el, binding) {
      const ctx = {
        scrollTarget: getScrollTarget(el),
        scroll: debounce_default(() => {
          let containerBottom, elBottom;
          if (ctx.scrollTarget === window) {
            elBottom = el.getBoundingClientRect().bottom;
            containerBottom = window.innerHeight;
          } else {
            elBottom = offset(el).top + height(el);
            containerBottom = offset(ctx.scrollTarget).top + height(ctx.scrollTarget);
          }
          if (elBottom > 0 && elBottom < containerBottom) {
            ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, passive5);
            ctx.handler(el);
          }
        }, 25)
      };
      update4(ctx, binding);
      el.__qscrollfire = ctx;
    },
    updated(el, binding) {
      if (binding.value !== binding.oldValue) {
        update4(el.__qscrollfire, binding);
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qscrollfire;
      ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, passive5);
      ctx.scroll.cancel();
      delete el.__qscrollfire;
    }
  }
);
function update5(ctx, { value: value2, oldValue }) {
  if (typeof value2 !== "function") {
    ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, listenOpts.passive);
    return;
  }
  ctx.handler = value2;
  if (typeof oldValue !== "function") {
    ctx.scrollTarget.addEventListener("scroll", ctx.scroll, listenOpts.passive);
  }
}
createDirective(
  {
    name: "scroll",
    mounted(el, binding) {
      const ctx = {
        scrollTarget: getScrollTarget(el),
        scroll() {
          ctx.handler(
            getVerticalScrollPosition(ctx.scrollTarget),
            getHorizontalScrollPosition(ctx.scrollTarget)
          );
        }
      };
      update5(ctx, binding);
      el.__qscroll = ctx;
    },
    updated(el, binding) {
      if (el.__qscroll !== void 0 && binding.oldValue !== binding.value) {
        update5(el.__qscroll, binding);
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qscroll;
      ctx.scrollTarget.removeEventListener("scroll", ctx.scroll, listenOpts.passive);
      delete el.__qscroll;
    }
  }
);
createDirective(
  {
    name: "touch-hold",
    beforeMount(el, binding) {
      const { modifiers } = binding;
      if (modifiers.mouse !== true && client.has.touch !== true) {
        return;
      }
      const ctx = {
        handler: binding.value,
        noop,
        mouseStart(evt) {
          if (typeof ctx.handler === "function" && leftClick(evt) === true) {
            addEvt(ctx, "temp", [
              [document, "mousemove", "move", "passiveCapture"],
              [document, "click", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt, true);
          }
        },
        touchStart(evt) {
          if (evt.target !== void 0 && typeof ctx.handler === "function") {
            const target2 = evt.target;
            addEvt(ctx, "temp", [
              [target2, "touchmove", "move", "passiveCapture"],
              [target2, "touchcancel", "end", "notPassiveCapture"],
              [target2, "touchend", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt);
          }
        },
        start(evt, mouseEvent) {
          ctx.origin = position(evt);
          const startTime = Date.now();
          if (client.is.mobile === true) {
            document.body.classList.add("non-selectable");
            clearSelection();
            ctx.styleCleanup = (withDelay) => {
              ctx.styleCleanup = void 0;
              const remove2 = () => {
                document.body.classList.remove("non-selectable");
              };
              if (withDelay === true) {
                clearSelection();
                setTimeout(remove2, 10);
              } else {
                remove2();
              }
            };
          }
          ctx.triggered = false;
          ctx.sensitivity = mouseEvent === true ? ctx.mouseSensitivity : ctx.touchSensitivity;
          ctx.timer = setTimeout(() => {
            ctx.timer = void 0;
            clearSelection();
            ctx.triggered = true;
            ctx.handler({
              evt,
              touch: mouseEvent !== true,
              mouse: mouseEvent === true,
              position: ctx.origin,
              duration: Date.now() - startTime
            });
          }, ctx.duration);
        },
        move(evt) {
          const { top, left } = position(evt);
          if (ctx.timer !== void 0 && (Math.abs(left - ctx.origin.left) >= ctx.sensitivity || Math.abs(top - ctx.origin.top) >= ctx.sensitivity)) {
            clearTimeout(ctx.timer);
            ctx.timer = void 0;
          }
        },
        end(evt) {
          cleanEvt(ctx, "temp");
          ctx.styleCleanup !== void 0 && ctx.styleCleanup(ctx.triggered);
          if (ctx.triggered === true) {
            evt !== void 0 && stopAndPrevent(evt);
          } else if (ctx.timer !== void 0) {
            clearTimeout(ctx.timer);
            ctx.timer = void 0;
          }
        }
      };
      const data = [600, 5, 7];
      if (typeof binding.arg === "string" && binding.arg.length !== 0) {
        binding.arg.split(":").forEach((val, index) => {
          const v = parseInt(val, 10);
          v && (data[index] = v);
        });
      }
      [ctx.duration, ctx.touchSensitivity, ctx.mouseSensitivity] = data;
      el.__qtouchhold = ctx;
      if (modifiers.mouse === true) {
        const capture = modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : "";
        addEvt(ctx, "main", [
          [el, "mousedown", "mouseStart", `passive${capture}`]
        ]);
      }
      client.has.touch === true && addEvt(ctx, "main", [
        [el, "touchstart", "touchStart", `passive${modifiers.capture === true ? "Capture" : ""}`],
        [el, "touchend", "noop", "notPassiveCapture"]
      ]);
    },
    updated(el, binding) {
      const ctx = el.__qtouchhold;
      if (ctx !== void 0 && binding.oldValue !== binding.value) {
        typeof binding.value !== "function" && ctx.end();
        ctx.handler = binding.value;
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qtouchhold;
      if (ctx !== void 0) {
        cleanEvt(ctx, "main");
        cleanEvt(ctx, "temp");
        ctx.timer !== void 0 && clearTimeout(ctx.timer);
        ctx.styleCleanup !== void 0 && ctx.styleCleanup();
        delete el.__qtouchhold;
      }
    }
  }
);
var keyCodes3 = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  delete: [8, 46]
};
var keyRegex = new RegExp(`^([\\d+]+|${Object.keys(keyCodes3).join("|")})$`, "i");
function shouldEnd(evt, origin) {
  const { top, left } = position(evt);
  return Math.abs(left - origin.left) >= 7 || Math.abs(top - origin.top) >= 7;
}
createDirective(
  {
    name: "touch-repeat",
    beforeMount(el, { modifiers, value: value2, arg }) {
      const keyboard = Object.keys(modifiers).reduce((acc, key) => {
        if (keyRegex.test(key) === true) {
          const keyCode = isNaN(parseInt(key, 10)) ? keyCodes3[key.toLowerCase()] : parseInt(key, 10);
          keyCode >= 0 && acc.push(keyCode);
        }
        return acc;
      }, []);
      if (modifiers.mouse !== true && client.has.touch !== true && keyboard.length === 0) {
        return;
      }
      const durations = typeof arg === "string" && arg.length !== 0 ? arg.split(":").map((val) => parseInt(val, 10)) : [0, 600, 300];
      const durationsLast = durations.length - 1;
      const ctx = {
        keyboard,
        handler: value2,
        noop,
        mouseStart(evt) {
          if (ctx.event === void 0 && typeof ctx.handler === "function" && leftClick(evt) === true) {
            addEvt(ctx, "temp", [
              [document, "mousemove", "move", "passiveCapture"],
              [document, "click", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt, true);
          }
        },
        keyboardStart(evt) {
          if (typeof ctx.handler === "function" && isKeyCode(evt, keyboard) === true) {
            if (durations[0] === 0 || ctx.event !== void 0) {
              stopAndPrevent(evt);
              el.focus();
              if (ctx.event !== void 0) {
                return;
              }
            }
            addEvt(ctx, "temp", [
              [document, "keyup", "end", "notPassiveCapture"],
              [document, "click", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt, false, true);
          }
        },
        touchStart(evt) {
          if (evt.target !== void 0 && typeof ctx.handler === "function") {
            const target2 = evt.target;
            addEvt(ctx, "temp", [
              [target2, "touchmove", "move", "passiveCapture"],
              [target2, "touchcancel", "end", "notPassiveCapture"],
              [target2, "touchend", "end", "notPassiveCapture"]
            ]);
            ctx.start(evt);
          }
        },
        start(evt, mouseEvent, keyboardEvent) {
          if (keyboardEvent !== true) {
            ctx.origin = position(evt);
          }
          function styleCleanup(withDelay) {
            ctx.styleCleanup = void 0;
            document.documentElement.style.cursor = "";
            const remove2 = () => {
              document.body.classList.remove("non-selectable");
            };
            if (withDelay === true) {
              clearSelection();
              setTimeout(remove2, 10);
            } else {
              remove2();
            }
          }
          if (client.is.mobile === true) {
            document.body.classList.add("non-selectable");
            clearSelection();
            ctx.styleCleanup = styleCleanup;
          }
          ctx.event = {
            touch: mouseEvent !== true && keyboardEvent !== true,
            mouse: mouseEvent === true,
            keyboard: keyboardEvent === true,
            startTime: Date.now(),
            repeatCount: 0
          };
          const fn = () => {
            ctx.timer = void 0;
            if (ctx.event === void 0) {
              return;
            }
            if (ctx.event.repeatCount === 0) {
              ctx.event.evt = evt;
              if (keyboardEvent === true) {
                ctx.event.keyCode = evt.keyCode;
              } else {
                ctx.event.position = position(evt);
              }
              if (client.is.mobile !== true) {
                document.documentElement.style.cursor = "pointer";
                document.body.classList.add("non-selectable");
                clearSelection();
                ctx.styleCleanup = styleCleanup;
              }
            }
            ctx.event.duration = Date.now() - ctx.event.startTime;
            ctx.event.repeatCount += 1;
            ctx.handler(ctx.event);
            const index = durationsLast < ctx.event.repeatCount ? durationsLast : ctx.event.repeatCount;
            ctx.timer = setTimeout(fn, durations[index]);
          };
          if (durations[0] === 0) {
            fn();
          } else {
            ctx.timer = setTimeout(fn, durations[0]);
          }
        },
        move(evt) {
          if (ctx.event !== void 0 && ctx.timer !== void 0 && shouldEnd(evt, ctx.origin) === true) {
            clearTimeout(ctx.timer);
            ctx.timer = void 0;
          }
        },
        end(evt) {
          if (ctx.event === void 0) {
            return;
          }
          ctx.styleCleanup !== void 0 && ctx.styleCleanup(true);
          evt !== void 0 && ctx.event.repeatCount > 0 && stopAndPrevent(evt);
          cleanEvt(ctx, "temp");
          if (ctx.timer !== void 0) {
            clearTimeout(ctx.timer);
            ctx.timer = void 0;
          }
          ctx.event = void 0;
        }
      };
      el.__qtouchrepeat = ctx;
      if (modifiers.mouse === true) {
        const capture = modifiers.mouseCapture === true || modifiers.mousecapture === true ? "Capture" : "";
        addEvt(ctx, "main", [
          [el, "mousedown", "mouseStart", `passive${capture}`]
        ]);
      }
      client.has.touch === true && addEvt(ctx, "main", [
        [el, "touchstart", "touchStart", `passive${modifiers.capture === true ? "Capture" : ""}`],
        [el, "touchend", "noop", "passiveCapture"]
      ]);
      if (keyboard.length !== 0) {
        const capture = modifiers.keyCapture === true || modifiers.keycapture === true ? "Capture" : "";
        addEvt(ctx, "main", [
          [el, "keydown", "keyboardStart", `notPassive${capture}`]
        ]);
      }
    },
    updated(el, { oldValue, value: value2 }) {
      const ctx = el.__qtouchrepeat;
      if (ctx !== void 0 && oldValue !== value2) {
        typeof value2 !== "function" && ctx.end();
        ctx.handler = value2;
      }
    },
    beforeUnmount(el) {
      const ctx = el.__qtouchrepeat;
      if (ctx !== void 0) {
        ctx.timer !== void 0 && clearTimeout(ctx.timer);
        cleanEvt(ctx, "main");
        cleanEvt(ctx, "temp");
        ctx.styleCleanup !== void 0 && ctx.styleCleanup();
        delete el.__qtouchrepeat;
      }
    }
  }
);
function getCssVar(propName, element = document.body) {
  if (typeof propName !== "string") {
    throw new TypeError("Expected a string as propName");
  }
  if (!(element instanceof Element)) {
    throw new TypeError("Expected a DOM element");
  }
  return getComputedStyle(element).getPropertyValue(`--q-${propName}`).trim() || null;
}
var metaValue;
function getProp() {
  return client.is.winphone ? "msapplication-navbutton-color" : client.is.safari ? "apple-mobile-web-app-status-bar-style" : "theme-color";
}
function getMetaTag(v) {
  const els = document.getElementsByTagName("META");
  for (const i2 in els) {
    if (els[i2].name === v) {
      return els[i2];
    }
  }
}
function setColor(hexColor) {
  if (metaValue === void 0) {
    metaValue = getProp();
  }
  let metaTag = getMetaTag(metaValue);
  const newTag = metaTag === void 0;
  if (newTag) {
    metaTag = document.createElement("meta");
    metaTag.setAttribute("name", metaValue);
  }
  metaTag.setAttribute("content", hexColor);
  if (newTag) {
    document.head.appendChild(metaTag);
  }
}
({
  set: client.is.mobile === true && (client.is.nativeMobile === true || client.is.winphone === true || client.is.safari === true || client.is.webkit === true || client.is.vivaldi === true) ? (hexColor) => {
    const val = hexColor || getCssVar("primary");
    if (client.is.nativeMobile === true && window.StatusBar) {
      window.StatusBar.backgroundColorByHexString(val);
    } else {
      setColor(val);
    }
  } : noop
});
var prefixes = {};
function assignFn(fn) {
  Object.assign(Plugin4, {
    request: fn,
    exit: fn,
    toggle: fn
  });
}
function getFullscreenElement() {
  return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || null;
}
function updateEl() {
  const newEl = Plugin4.activeEl = Plugin4.isActive === false ? null : getFullscreenElement();
  changeGlobalNodesTarget(
    newEl === null || newEl === document.documentElement ? document.body : newEl
  );
}
function togglePluginState() {
  Plugin4.isActive = Plugin4.isActive === false;
  updateEl();
}
function promisify(target2, fn) {
  try {
    const res = target2[fn]();
    return res === void 0 ? Promise.resolve() : res;
  } catch (err) {
    return Promise.reject(err);
  }
}
var Plugin4 = createReactivePlugin({
  isActive: false,
  activeEl: null
}, {
  isCapable: false,
  install({ $q }) {
    $q.fullscreen = this;
  }
});
{
  prefixes.request = [
    "requestFullscreen",
    "msRequestFullscreen",
    "mozRequestFullScreen",
    "webkitRequestFullscreen"
  ].find((request) => document.documentElement[request] !== void 0);
  Plugin4.isCapable = prefixes.request !== void 0;
  if (Plugin4.isCapable === false) {
    assignFn(() => Promise.reject("Not capable"));
  } else {
    Object.assign(Plugin4, {
      request(target2) {
        const el = target2 || document.documentElement;
        const { activeEl } = Plugin4;
        if (el === activeEl) {
          return Promise.resolve();
        }
        const queue2 = activeEl !== null && el.contains(activeEl) === true ? Plugin4.exit() : Promise.resolve();
        return queue2.finally(() => promisify(el, prefixes.request));
      },
      exit() {
        return Plugin4.isActive === true ? promisify(document, prefixes.exit) : Promise.resolve();
      },
      toggle(target2) {
        return Plugin4.isActive === true ? Plugin4.exit() : Plugin4.request(target2);
      }
    });
    prefixes.exit = [
      "exitFullscreen",
      "msExitFullscreen",
      "mozCancelFullScreen",
      "webkitExitFullscreen"
    ].find((exit) => document[exit]);
    Plugin4.isActive = Boolean(getFullscreenElement());
    Plugin4.isActive === true && updateEl();
    [
      "onfullscreenchange",
      "onmsfullscreenchange",
      "onwebkitfullscreenchange"
    ].forEach((evt) => {
      document[evt] = togglePluginState;
    });
  }
}
var Plugin5 = createReactivePlugin({
  appVisible: true
}, {
  install({ $q }) {
    injectProp($q, "appVisible", () => this.appVisible);
  }
});
{
  let prop, evt;
  if (typeof document.hidden !== "undefined") {
    prop = "hidden";
    evt = "visibilitychange";
  } else if (typeof document.msHidden !== "undefined") {
    prop = "msHidden";
    evt = "msvisibilitychange";
  } else if (typeof document.webkitHidden !== "undefined") {
    prop = "webkitHidden";
    evt = "webkitvisibilitychange";
  }
  if (evt && typeof document[prop] !== "undefined") {
    const update6 = () => {
      Plugin5.appVisible = !document[prop];
    };
    document.addEventListener(evt, update6, false);
  }
}
createComponent({
  name: "BottomSheetComponent",
  props: {
    ...useDarkProps,
    title: String,
    message: String,
    actions: Array,
    grid: Boolean,
    cardClass: [String, Array, Object],
    cardStyle: [String, Array, Object]
  },
  emits: ["ok", "hide"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const isDark = use_dark_default(props4, proxy.$q);
    const dialogRef = ref$1(null);
    function show() {
      dialogRef.value.show();
    }
    function hide() {
      dialogRef.value.hide();
    }
    function onOk(action) {
      emit("ok", action);
      hide();
    }
    function onHide() {
      emit("hide");
    }
    function getGrid() {
      return props4.actions.map((action) => {
        const img = action.avatar || action.img;
        return action.label === void 0 ? h(QSeparator_default, {
          class: "col-all",
          dark: isDark.value
        }) : h("div", {
          class: [
            "q-bottom-sheet__item q-hoverable q-focusable cursor-pointer relative-position",
            action.class
          ],
          style: action.style,
          tabindex: 0,
          role: "listitem",
          onClick() {
            onOk(action);
          },
          onKeyup(e2) {
            e2.keyCode === 13 && onOk(action);
          }
        }, [
          h("div", { class: "q-focus-helper" }),
          action.icon ? h(QIcon_default, { name: action.icon, color: action.color }) : img ? h("img", {
            class: action.avatar ? "q-bottom-sheet__avatar" : "",
            src: img
          }) : h("div", { class: "q-bottom-sheet__empty-icon" }),
          h("div", action.label)
        ]);
      });
    }
    function getList() {
      return props4.actions.map((action) => {
        const img = action.avatar || action.img;
        return action.label === void 0 ? h(QSeparator_default, { spaced: true, dark: isDark.value }) : h(QItem_default, {
          class: ["q-bottom-sheet__item", action.classes],
          style: action.style,
          tabindex: 0,
          clickable: true,
          dark: isDark.value,
          onClick() {
            onOk(action);
          }
        }, () => [
          h(
            QItemSection_default,
            { avatar: true },
            () => action.icon ? h(QIcon_default, { name: action.icon, color: action.color }) : img ? h("img", {
              class: action.avatar ? "q-bottom-sheet__avatar" : "",
              src: img
            }) : null
          ),
          h(QItemSection_default, () => action.label)
        ]);
      });
    }
    function getCardContent() {
      const child = [];
      props4.title && child.push(
        h(QCardSection_default, {
          class: "q-dialog__title"
        }, () => props4.title)
      );
      props4.message && child.push(
        h(QCardSection_default, {
          class: "q-dialog__message"
        }, () => props4.message)
      );
      child.push(
        props4.grid === true ? h("div", {
          class: "row items-stretch justify-start",
          role: "list"
        }, getGrid()) : h("div", {
          role: "list"
        }, getList())
      );
      return child;
    }
    function getContent() {
      return [
        h(QCard_default, {
          class: [
            `q-bottom-sheet q-bottom-sheet--${props4.grid === true ? "grid" : "list"}` + (isDark.value === true ? " q-bottom-sheet--dark q-dark" : ""),
            props4.cardClass
          ],
          style: props4.cardStyle
        }, getCardContent)
      ];
    }
    Object.assign(proxy, { show, hide });
    return () => h(QDialog_default, {
      ref: dialogRef,
      position: "bottom",
      onHide
    }, getContent);
  }
});
function encode$1(string) {
  return encodeURIComponent(string);
}
function decode$1(string) {
  return decodeURIComponent(string);
}
function stringifyCookieValue(value2) {
  return encode$1(value2 === Object(value2) ? JSON.stringify(value2) : "" + value2);
}
function read(string) {
  if (string === "") {
    return string;
  }
  if (string.indexOf('"') === 0) {
    string = string.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\");
  }
  string = decode$1(string.replace(/\+/g, " "));
  try {
    const parsed = JSON.parse(string);
    if (parsed === Object(parsed) || Array.isArray(parsed) === true) {
      string = parsed;
    }
  } catch (_) {
  }
  return string;
}
function getString(msOffset) {
  const time = /* @__PURE__ */ new Date();
  time.setMilliseconds(time.getMilliseconds() + msOffset);
  return time.toUTCString();
}
function parseExpireString(str) {
  let timestamp = 0;
  const days = str.match(/(\d+)d/);
  const hours = str.match(/(\d+)h/);
  const minutes = str.match(/(\d+)m/);
  const seconds = str.match(/(\d+)s/);
  if (days) {
    timestamp += days[1] * 864e5;
  }
  if (hours) {
    timestamp += hours[1] * 36e5;
  }
  if (minutes) {
    timestamp += minutes[1] * 6e4;
  }
  if (seconds) {
    timestamp += seconds[1] * 1e3;
  }
  return timestamp === 0 ? str : getString(timestamp);
}
function set(key, val, opts = {}, ssr) {
  let expire, expireValue;
  if (opts.expires !== void 0) {
    if (Object.prototype.toString.call(opts.expires) === "[object Date]") {
      expire = opts.expires.toUTCString();
    } else if (typeof opts.expires === "string") {
      expire = parseExpireString(opts.expires);
    } else {
      expireValue = parseFloat(opts.expires);
      expire = isNaN(expireValue) === false ? getString(expireValue * 864e5) : opts.expires;
    }
  }
  const keyValue = `${encode$1(key)}=${stringifyCookieValue(val)}`;
  const cookie = [
    keyValue,
    expire !== void 0 ? "; Expires=" + expire : "",
    // use expires attribute, max-age is not supported by IE
    opts.path ? "; Path=" + opts.path : "",
    opts.domain ? "; Domain=" + opts.domain : "",
    opts.sameSite ? "; SameSite=" + opts.sameSite : "",
    opts.httpOnly ? "; HttpOnly" : "",
    opts.secure ? "; Secure" : "",
    opts.other ? "; " + opts.other : ""
  ].join("");
  if (ssr) {
    if (ssr.req.qCookies) {
      ssr.req.qCookies.push(cookie);
    } else {
      ssr.req.qCookies = [cookie];
    }
    ssr.res.setHeader("Set-Cookie", ssr.req.qCookies);
    let all = ssr.req.headers.cookie || "";
    if (expire !== void 0 && expireValue < 0) {
      const val2 = get$1(key, ssr);
      if (val2 !== void 0) {
        all = all.replace(`${key}=${val2}; `, "").replace(`; ${key}=${val2}`, "").replace(`${key}=${val2}`, "");
      }
    } else {
      all = all ? `${keyValue}; ${all}` : cookie;
    }
    ssr.req.headers.cookie = all;
  } else {
    document.cookie = cookie;
  }
}
function get$1(key, ssr) {
  const cookieSource = ssr ? ssr.req.headers : document, cookies = cookieSource.cookie ? cookieSource.cookie.split("; ") : [], l = cookies.length;
  let result = key ? null : {}, i2 = 0, parts, name2, cookie;
  for (; i2 < l; i2++) {
    parts = cookies[i2].split("=");
    name2 = decode$1(parts.shift());
    cookie = parts.join("=");
    if (!key) {
      result[name2] = cookie;
    } else if (key === name2) {
      result = read(cookie);
      break;
    }
  }
  return result;
}
function remove(key, options, ssr) {
  set(
    key,
    "",
    { expires: -1, ...options },
    ssr
  );
}
function has$4(key, ssr) {
  return get$1(key, ssr) !== null;
}
function getObject(ssr) {
  return {
    get: (key) => get$1(key, ssr),
    set: (key, val, opts) => set(key, val, opts, ssr),
    has: (key) => has$4(key, ssr),
    remove: (key, options) => remove(key, options, ssr),
    getAll: () => get$1(null, ssr)
  };
}
var Plugin6 = {
  install({ $q, ssrContext }) {
    $q.cookies = this;
  }
};
if (__QUASAR_SSR__) {
  Plugin6.parseSSR = (ssrContext) => {
    if (ssrContext !== void 0) {
      return getObject(ssrContext);
    }
  };
}
{
  Object.assign(Plugin6, getObject());
}
createComponent({
  name: "DialogPluginComponent",
  props: {
    ...useDarkProps,
    title: String,
    message: String,
    prompt: Object,
    options: Object,
    progress: [Boolean, Object],
    html: Boolean,
    ok: {
      type: [String, Object, Boolean],
      default: true
    },
    cancel: [String, Object, Boolean],
    focus: {
      type: String,
      default: "ok",
      validator: (v) => ["ok", "cancel", "none"].includes(v)
    },
    stackButtons: Boolean,
    color: String,
    cardClass: [String, Array, Object],
    cardStyle: [String, Array, Object]
  },
  emits: ["ok", "hide"],
  setup(props4, { emit }) {
    const { proxy } = getCurrentInstance();
    const { $q } = proxy;
    const isDark = use_dark_default(props4, $q);
    const dialogRef = ref$1(null);
    const model = ref$1(
      props4.prompt !== void 0 ? props4.prompt.model : props4.options !== void 0 ? props4.options.model : void 0
    );
    const classes = computed(
      () => "q-dialog-plugin" + (isDark.value === true ? " q-dialog-plugin--dark q-dark" : "") + (props4.progress !== false ? " q-dialog-plugin--progress" : "")
    );
    const vmColor = computed(
      () => props4.color || (isDark.value === true ? "amber" : "primary")
    );
    const spinner = computed(() => props4.progress === false ? null : isObject(props4.progress) === true ? {
      component: props4.progress.spinner || QSpinner_default,
      props: { color: props4.progress.color || vmColor.value }
    } : {
      component: QSpinner_default,
      props: { color: vmColor.value }
    });
    const hasForm = computed(
      () => props4.prompt !== void 0 || props4.options !== void 0
    );
    const formProps = computed(() => {
      if (hasForm.value !== true) {
        return {};
      }
      const { model: model2, isValid: isValid2, items, ...formProps2 } = props4.prompt !== void 0 ? props4.prompt : props4.options;
      return formProps2;
    });
    const okLabel = computed(() => isObject(props4.ok) === true ? $q.lang.label.ok : props4.ok === true ? $q.lang.label.ok : props4.ok);
    const cancelLabel = computed(() => isObject(props4.cancel) === true ? $q.lang.label.cancel : props4.cancel === true ? $q.lang.label.cancel : props4.cancel);
    const okDisabled = computed(() => {
      if (props4.prompt !== void 0) {
        return props4.prompt.isValid !== void 0 && props4.prompt.isValid(model.value) !== true;
      }
      if (props4.options !== void 0) {
        return props4.options.isValid !== void 0 && props4.options.isValid(model.value) !== true;
      }
      return false;
    });
    const okProps = computed(() => ({
      color: vmColor.value,
      label: okLabel.value,
      ripple: false,
      disable: okDisabled.value,
      ...isObject(props4.ok) === true ? props4.ok : { flat: true },
      "data-autofocus": props4.focus === "ok" && hasForm.value !== true || void 0,
      onClick: onOk
    }));
    const cancelProps = computed(() => ({
      color: vmColor.value,
      label: cancelLabel.value,
      ripple: false,
      ...isObject(props4.cancel) === true ? props4.cancel : { flat: true },
      "data-autofocus": props4.focus === "cancel" && hasForm.value !== true || void 0,
      onClick: onCancel
    }));
    watch(() => props4.prompt && props4.prompt.model, onUpdateModel);
    watch(() => props4.options && props4.options.model, onUpdateModel);
    function show() {
      dialogRef.value.show();
    }
    function hide() {
      dialogRef.value.hide();
    }
    function onOk() {
      emit("ok", toRaw(model.value));
      hide();
    }
    function onCancel() {
      hide();
    }
    function onDialogHide() {
      emit("hide");
    }
    function onUpdateModel(val) {
      model.value = val;
    }
    function onInputKeyup(evt) {
      if (okDisabled.value !== true && props4.prompt.type !== "textarea" && isKeyCode(evt, 13) === true) {
        onOk();
      }
    }
    function getSection(classes2, text) {
      return props4.html === true ? h(QCardSection_default, {
        class: classes2,
        innerHTML: text
      }) : h(QCardSection_default, { class: classes2 }, () => text);
    }
    function getPrompt() {
      return [
        h(QInput_default, {
          color: vmColor.value,
          dense: true,
          autofocus: true,
          dark: isDark.value,
          ...formProps.value,
          modelValue: model.value,
          "onUpdate:modelValue": onUpdateModel,
          onKeyup: onInputKeyup
        })
      ];
    }
    function getOptions() {
      return [
        h(QOptionGroup_default, {
          color: vmColor.value,
          options: props4.options.items,
          dark: isDark.value,
          ...formProps.value,
          modelValue: model.value,
          "onUpdate:modelValue": onUpdateModel
        })
      ];
    }
    function getButtons() {
      const child = [];
      props4.cancel && child.push(
        h(QBtn_default, cancelProps.value)
      );
      props4.ok && child.push(
        h(QBtn_default, okProps.value)
      );
      return h(QCardActions_default, {
        class: props4.stackButtons === true ? "items-end" : "",
        vertical: props4.stackButtons,
        align: "right"
      }, () => child);
    }
    function getCardContent() {
      const child = [];
      props4.title && child.push(
        getSection("q-dialog__title", props4.title)
      );
      props4.progress !== false && child.push(
        h(
          QCardSection_default,
          { class: "q-dialog__progress" },
          () => h(spinner.value.component, spinner.value.props)
        )
      );
      props4.message && child.push(
        getSection("q-dialog__message", props4.message)
      );
      if (props4.prompt !== void 0) {
        child.push(
          h(
            QCardSection_default,
            { class: "scroll q-dialog-plugin__form" },
            getPrompt
          )
        );
      } else if (props4.options !== void 0) {
        child.push(
          h(QSeparator_default, { dark: isDark.value }),
          h(
            QCardSection_default,
            { class: "scroll q-dialog-plugin__form" },
            getOptions
          ),
          h(QSeparator_default, { dark: isDark.value })
        );
      }
      if (props4.ok || props4.cancel) {
        child.push(getButtons());
      }
      return child;
    }
    function getContent() {
      return [
        h(QCard_default, {
          class: [
            classes.value,
            props4.cardClass
          ],
          style: props4.cardStyle,
          dark: isDark.value
        }, getCardContent)
      ];
    }
    Object.assign(proxy, { show, hide });
    return () => h(QDialog_default, {
      ref: dialogRef,
      onHide: onDialogHide
    }, getContent);
  }
});
var app;
var vm;
var uid2 = 0;
var timeout = null;
var props3 = {};
var activeGroups = {};
var originalDefaults = {
  group: "__default_quasar_group__",
  delay: 0,
  message: false,
  html: false,
  spinnerSize: 80,
  spinnerColor: "",
  messageColor: "",
  backgroundColor: "",
  boxClass: "",
  spinner: QSpinner_default,
  customClass: ""
};
var defaults$2 = { ...originalDefaults };
function registerProps(opts) {
  if (opts && opts.group !== void 0 && activeGroups[opts.group] !== void 0) {
    return Object.assign(activeGroups[opts.group], opts);
  }
  const newProps = isObject(opts) === true && opts.ignoreDefaults === true ? { ...originalDefaults, ...opts } : { ...defaults$2, ...opts };
  activeGroups[newProps.group] = newProps;
  return newProps;
}
var Plugin7 = createReactivePlugin({
  isActive: false
}, {
  show(opts) {
    props3 = registerProps(opts);
    const { group } = props3;
    Plugin7.isActive = true;
    if (app !== void 0) {
      props3.uid = uid2;
      vm.$forceUpdate();
    } else {
      props3.uid = ++uid2;
      timeout !== null && clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        const el = createGlobalNode("q-loading");
        app = createChildApp({
          name: "QLoading",
          setup() {
            onMounted(() => {
              prevent_scroll_default(true);
            });
            function onAfterLeave() {
              if (Plugin7.isActive !== true && app !== void 0) {
                prevent_scroll_default(false);
                app.unmount(el);
                removeGlobalNode(el);
                app = void 0;
                vm = void 0;
              }
            }
            function getContent() {
              if (Plugin7.isActive !== true) {
                return null;
              }
              const content = [
                h(props3.spinner, {
                  class: "q-loading__spinner",
                  color: props3.spinnerColor,
                  size: props3.spinnerSize
                })
              ];
              props3.message && content.push(
                h("div", {
                  class: "q-loading__message" + (props3.messageColor ? ` text-${props3.messageColor}` : ""),
                  [props3.html === true ? "innerHTML" : "textContent"]: props3.message
                })
              );
              return h("div", {
                class: "q-loading fullscreen flex flex-center z-max " + props3.customClass.trim(),
                key: props3.uid
              }, [
                h("div", {
                  class: "q-loading__backdrop" + (props3.backgroundColor ? ` bg-${props3.backgroundColor}` : "")
                }),
                h("div", {
                  class: "q-loading__box column items-center " + props3.boxClass
                }, content)
              ]);
            }
            return () => h(Transition, {
              name: "q-transition--fade",
              appear: true,
              onAfterLeave
            }, getContent);
          }
        }, Plugin7.__parentApp);
        vm = app.mount(el);
      }, props3.delay);
    }
    return (paramProps) => {
      if (paramProps === void 0 || Object(paramProps) !== paramProps) {
        Plugin7.hide(group);
        return;
      }
      Plugin7.show({ ...paramProps, group });
    };
  },
  hide(group) {
    if (Plugin7.isActive === true) {
      if (group === void 0) {
        activeGroups = {};
      } else if (activeGroups[group] === void 0) {
        return;
      } else {
        delete activeGroups[group];
        const keys = Object.keys(activeGroups);
        if (keys.length !== 0) {
          const lastGroup = keys[keys.length - 1];
          Plugin7.show({ group: lastGroup });
          return;
        }
      }
      if (timeout !== null) {
        clearTimeout(timeout);
        timeout = null;
      }
      Plugin7.isActive = false;
    }
  },
  setDefaults(opts) {
    {
      isObject(opts) === true && Object.assign(defaults$2, opts);
    }
  },
  install({ $q, parentApp }) {
    $q.loading = this;
    {
      Plugin7.__parentApp = parentApp;
      if ($q.config.loading !== void 0) {
        this.setDefaults($q.config.loading);
      }
    }
  }
});
var barRef = ref$1(null);
var Plugin8 = createReactivePlugin({
  isActive: false
}, {
  start: noop,
  stop: noop,
  increment: noop,
  setDefaults: noop,
  install({ $q, parentApp }) {
    $q.loadingBar = this;
    if (this.__installed === true) {
      if ($q.config.loadingBar !== void 0) {
        this.setDefaults($q.config.loadingBar);
      }
      return;
    }
    const props4 = ref$1(
      $q.config.loadingBar !== void 0 ? { ...$q.config.loadingBar } : {}
    );
    function onStart() {
      Plugin8.isActive = true;
    }
    function onStop() {
      Plugin8.isActive = false;
    }
    const el = createGlobalNode("q-loading-bar");
    createChildApp({
      name: "LoadingBar",
      // hide App from Vue devtools
      devtools: { hide: true },
      setup: () => () => h(QAjaxBar_default, { ...props4.value, onStart, onStop, ref: barRef })
    }, parentApp).mount(el);
    Object.assign(this, {
      start(speed) {
        barRef.value.start(speed);
      },
      stop() {
        barRef.value.stop();
      },
      increment() {
        barRef.value.increment.apply(null, arguments);
      },
      setDefaults(opts) {
        if (isObject(opts) === true) {
          Object.assign(props4.value, opts);
        }
      }
    });
  }
});
function encode2(value2) {
  if (isDate$1(value2) === true) {
    return "__q_date|" + value2.getTime();
  }
  if (isRegexp(value2) === true) {
    return "__q_expr|" + value2.source;
  }
  if (typeof value2 === "number") {
    return "__q_numb|" + value2;
  }
  if (typeof value2 === "boolean") {
    return "__q_bool|" + (value2 ? "1" : "0");
  }
  if (typeof value2 === "string") {
    return "__q_strn|" + value2;
  }
  if (typeof value2 === "function") {
    return "__q_strn|" + value2.toString();
  }
  if (value2 === Object(value2)) {
    return "__q_objt|" + JSON.stringify(value2);
  }
  return value2;
}
function decode2(value2) {
  const length = value2.length;
  if (length < 9) {
    return value2;
  }
  const type2 = value2.substring(0, 8);
  const source = value2.substring(9);
  switch (type2) {
    case "__q_date":
      const number = Number(source);
      return new Date(Number.isNaN(number) === true ? source : number);
    case "__q_expr":
      return new RegExp(source);
    case "__q_numb":
      return Number(source);
    case "__q_bool":
      return Boolean(source === "1");
    case "__q_strn":
      return "" + source;
    case "__q_objt":
      return JSON.parse(source);
    default:
      return value2;
  }
}
function getEmptyStorage() {
  const getVal2 = () => null;
  return {
    has: () => false,
    // alias for hasItem; TODO: remove in Qv3
    hasItem: () => false,
    getLength: () => 0,
    getItem: getVal2,
    getIndex: getVal2,
    getKey: getVal2,
    getAll: () => {
    },
    getAllKeys: () => [],
    set: noop,
    // alias for setItem; TODO: remove in Qv3
    setItem: noop,
    remove: noop,
    // alias for removeItem; TODO: remove in Qv3
    removeItem: noop,
    clear: noop,
    isEmpty: () => true
  };
}
function getStorage(type2) {
  const webStorage = window[type2 + "Storage"], get2 = (key) => {
    const item = webStorage.getItem(key);
    return item ? decode2(item) : null;
  };
  const hasItem = (key) => webStorage.getItem(key) !== null;
  const setItem = (key, value2) => {
    webStorage.setItem(key, encode2(value2));
  };
  const removeItem = (key) => {
    webStorage.removeItem(key);
  };
  return {
    has: hasItem,
    // TODO: remove in Qv3
    hasItem,
    getLength: () => webStorage.length,
    getItem: get2,
    getIndex: (index) => {
      return index < webStorage.length ? get2(webStorage.key(index)) : null;
    },
    getKey: (index) => {
      return index < webStorage.length ? webStorage.key(index) : null;
    },
    getAll: () => {
      let key;
      const result = {}, len = webStorage.length;
      for (let i2 = 0; i2 < len; i2++) {
        key = webStorage.key(i2);
        result[key] = get2(key);
      }
      return result;
    },
    getAllKeys: () => {
      const result = [], len = webStorage.length;
      for (let i2 = 0; i2 < len; i2++) {
        result.push(webStorage.key(i2));
      }
      return result;
    },
    set: setItem,
    // TODO: remove in Qv3
    setItem,
    remove: removeItem,
    // TODO: remove in Qv3
    removeItem,
    clear: () => {
      webStorage.clear();
    },
    isEmpty: () => webStorage.length === 0
  };
}
var storage = client.has.webStorage === false ? getEmptyStorage() : getStorage("local");
var Plugin9 = {
  install({ $q }) {
    $q.localStorage = storage;
  }
};
Object.assign(Plugin9, storage);
var LocalStorage_default = Plugin9;
var storage2 = client.has.webStorage === false ? getEmptyStorage() : getStorage("session");
var Plugin10 = {
  install({ $q }) {
    $q.sessionStorage = storage2;
  }
};
Object.assign(Plugin10, storage2);
function useDialogPluginComponent() {
  const { emit, proxy } = getCurrentInstance();
  const dialogRef = ref$1(null);
  function show() {
    dialogRef.value.show();
  }
  function hide() {
    dialogRef.value.hide();
  }
  function onDialogOK(payload) {
    emit("ok", payload);
    hide();
  }
  function onDialogHide() {
    emit("hide");
  }
  Object.assign(proxy, { show, hide });
  return {
    dialogRef,
    onDialogHide,
    onDialogOK,
    onDialogCancel: hide
  };
}
var emits2 = ["ok", "hide"];
useDialogPluginComponent.emits = emits2;
useDialogPluginComponent.emitsObject = get_emits_object_default(emits2);
function useQuasar() {
  return inject(quasarKey);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;
function validate(uuid) {
  return typeof uuid === "string" && REGEX.test(uuid);
}
function parse$2(uuid) {
  if (!validate(uuid)) {
    throw TypeError("Invalid UUID");
  }
  let v;
  return Uint8Array.of((v = parseInt(uuid.slice(0, 8), 16)) >>> 24, v >>> 16 & 255, v >>> 8 & 255, v & 255, (v = parseInt(uuid.slice(9, 13), 16)) >>> 8, v & 255, (v = parseInt(uuid.slice(14, 18), 16)) >>> 8, v & 255, (v = parseInt(uuid.slice(19, 23), 16)) >>> 8, v & 255, (v = parseInt(uuid.slice(24, 36), 16)) / 1099511627776 & 255, v / 4294967296 & 255, v >>> 24 & 255, v >>> 16 & 255, v >>> 8 & 255, v & 255);
}
const { lighten: lighten$1 } = colors_default;
const baseColor = typeof document === "undefined" ? "#F2209E" : getCssVar("primary") ?? "#F2209E";
const USER_COLORS = [
  "#242DDD",
  "#2457CD",
  "#2490DD",
  "#252CDC",
  "#253ECB",
  "#25AAC8",
  "#25C3AC",
  "#26A0BF",
  "#27B675",
  "#2BA19D",
  "#394FD0",
  "#3987D0",
  "#39A0D0",
  "#3A0CA3",
  "#3F37C9",
  "#4361EE",
  "#4895EF",
  "#4CC9F0",
  "#4F25CB",
  "#553ACF",
  "#5EB098",
  "#5F8FE4",
  "#5F9FE4",
  "#61BD7C",
  "#61BDBA",
  "#655FE4",
  "#6981C9",
  "#6997C9",
  "#6F6AC8",
  "#7209B7",
  "#7339D0",
  "#73C0E3",
  "#7499E3",
  "#75CDB6",
  "#7787E4",
  "#78A3DF",
  "#79D0D9",
  "#7AA3E5",
  "#7AD0A1",
  "#7CA6D2",
  "#7D24DD",
  "#7DBEE6",
  "#7ED1C1",
  "#80B6A0",
  "#82CC89",
  "#865EE5",
  "#86D192",
  "#98BAA5",
  "#A1D08F",
  "#AC5FE4",
  "#ADBCA7",
  "#B5179E",
  "#BD34C9",
  "#BED092",
  "#CE57BD",
  "#F2209E"
];
function getUserColor(userId) {
  const value2 = typeof userId === "number" ? userId : validate(userId) ? parse$2(userId)[0] : String(userId).charCodeAt(0);
  return USER_COLORS[value2 % (USER_COLORS.length - 1)];
}
function getColor(index) {
  return lighten$1(baseColor, Math.max(-100, -15 * index));
}
function rgbaColor(color, opacity) {
  const colorString = color.charAt(0) === "#" ? color.substring(1, 7) : color;
  if (colorString.length === 6) {
    const r = parseInt(colorString.substring(0, 2), 16);
    const g = parseInt(colorString.substring(2, 4), 16);
    const b2 = parseInt(colorString.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b2}, ${opacity})`;
  }
  return colorString;
}
function setPrimaryColor(value2) {
  const customColors = {
    accent: lighten$1(value2, -15),
    primary: value2,
    primary05op: colors_default.changeAlpha(value2, 0.5),
    primaryLighter: colors_default.changeAlpha(value2, 0.2)
  };
  setCssVar("accent", customColors.accent);
  setCssVar("primary", customColors.primary);
  setCssVar("primary-fixed", customColors.primary);
  setCssVar("primary-05op", customColors.primary05op);
  setCssVar("primary-05op-fixed", customColors.primary05op);
  setCssVar("primary-lighter", customColors.primaryLighter);
}
function roundNumberToPrecision(number, precision = 3) {
  return Number(parseFloat(String(number)).toPrecision(precision));
}
function roundToStep(number, step) {
  if (step === 0) {
    return number;
  }
  return roundNumberToPrecision(Math.floor(roundNumberToPrecision(number / step)) * step);
}
function truncateNumber(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.trunc(number * factor) / factor;
}
function maxValueRaw(min2, inclusive) {
  return inclusive ? (value2) => !helpers.req(value2) || +value2 <= +toValue(min2) : (value2) => !helpers.req(value2) || +value2 < +toValue(min2);
}
function minValueRaw(min2, inclusive) {
  return inclusive ? (value2) => !helpers.req(value2) || +value2 >= +toValue(min2) : (value2) => !helpers.req(value2) || +value2 > +toValue(min2);
}
function conditional(condition, rule) {
  if (rule instanceof Function) {
    return rule;
  } else {
    return {
      ...rule,
      $validator: (value2, siblingState, vm2) => !toValue(condition) || rule.$validator(value2, siblingState, vm2)
    };
  }
}
function maxValue(max2, inclusive) {
  return {
    $message: ({ $params }) => `The maximum value allowed is ${toValue($params.max)}`,
    $params: { max: max2 },
    $validator: maxValueRaw(max2, inclusive)
  };
}
function minValue(min2, inclusive) {
  return {
    $message: ({ $params }) => `The minimum value allowed is ${toValue($params.min)}`,
    $params: { min: min2 },
    $validator: minValueRaw(min2, inclusive)
  };
}
function minCharCountRaw(min2, regex) {
  return (value2) => !helpers.req(value2) || (value2.match(regex) ?? []).length >= toValue(min2);
}
function minCharsCountRaw(min2, regexes) {
  return (value2) => !helpers.req(value2) || regexes.every((regex) => (value2.match(regex) ?? []).length >= toValue(min2));
}
const _ValidationBuilder = class _ValidationBuilder {
  constructor(i18nPath, label, i18n) {
    __publicField(this, "_i18nPath");
    __publicField(this, "_label");
    __publicField(this, "_rules");
    __publicField(this, "_i18n");
    if (i18nPath) {
      this._i18nPath = i18nPath;
    }
    if (label) {
      this._label = label;
    }
    if (i18n) {
      this._i18n = i18n;
    }
    this._rules = {};
  }
  get label() {
    if (this._i18nPath) return this.t(this._i18nPath);
    if (this._label) return this._label;
    return this.t("rvai-base.general.inputs.field");
  }
  static withLabel(label, i18n) {
    return new _ValidationBuilder(void 0, label, i18n);
  }
  static $t(i18nPath, i18n) {
    return new _ValidationBuilder(i18nPath, void 0, i18n);
  }
  addRule(key, rule) {
    this._rules[key] = rule;
  }
  get arrayRequired() {
    this._rules.required = {
      $message: this.t("rvai-base.validation.isRequired", [this.label]),
      $validator: (value2) => Array.isArray(value2) && !!value2.length
    };
    return this;
  }
  arrayRequiredIf(condition) {
    this._rules.required = {
      $message: this.t("rvai-base.validation.isRequired", [this.label]),
      $params: { condition },
      $validator: (value2) => !toValue(condition) || Array.isArray(value2) && !!value2.length
    };
    return this;
  }
  custom(fn, i18nMessagePath, i18nParams = [], key = "custom") {
    this.rules[key] = helpers.withMessage(
      () => this.t(i18nMessagePath, "value" in i18nParams ? i18nParams.value : i18nParams),
      fn
    );
    return this;
  }
  customAsync(fn, messageI18nOrRef, i18nParams = [], key = "customAsync") {
    this._rules[key] = helpers.withAsync({
      $message: typeof messageI18nOrRef === "string" ? this.t(messageI18nOrRef, toValue(i18nParams)) : messageI18nOrRef,
      $validator: fn
    });
    return this;
  }
  customError(i18nMessagePath) {
    this._rules.customError = {
      $message: i18nMessagePath ? this.t(i18nMessagePath, [this.label]) : "",
      $params: { i18nMessagePath },
      $validator: (value2) => !helpers.req(value2) || !i18nMessagePath
    };
    return this;
  }
  customErrorWithMismatches(regEx, findSymbolsRegex, textPath) {
    this._rules.customErrorWithMismatches = helpers.withMessage(
      (v) => {
        const notAllowedSymbols = distinct(v.$model.split(findSymbolsRegex)).join("");
        return this.t(textPath, [this.label, notAllowedSymbols]);
      },
      {
        $validator: helpers.regex(regEx)
      }
    );
    return this;
  }
  get decimal() {
    this._rules.decimal = helpers.withMessage(
      this.t("rvai-base.validation.decimal", [this.label]),
      decimal
    );
    return this;
  }
  decimalIf(condition) {
    this._rules.decimal = {
      $message: this.t("rvai-base.validation.decimal", [this.label]),
      $params: { condition },
      $validator: (value2) => !helpers.req(value2) || !toValue(condition) || Number.isFinite(Number(value2))
    };
    return this;
  }
  get dnsLabel() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.dnsLabel", [this.label]),
      $validator: helpers.regex(/^[a-z]([a-z0-9-]{0,61}[a-z0-9])?$/)
    };
    return this;
  }
  get email() {
    this._rules.email = helpers.withMessage(
      this.t("rvai-base.validation.email"),
      email
    );
    return this;
  }
  equalTo(equalTo) {
    this._rules.equalTo = {
      $message: () => this.t("rvai-base.validation.equalTo", [this.label, equalTo]),
      $params: { equalTo },
      $validator: (value2) => !helpers.req(value2) || !equalTo || value2 === equalTo
    };
    return this;
  }
  if(condition) {
    return new IfValidationBuilder(
      this,
      condition,
      this._i18nPath,
      this._label,
      this._i18n
    );
  }
  get integer() {
    this._rules.integer = helpers.withMessage(
      this.t("rvai-base.validation.integer", [this.label]),
      integer
    );
    return this;
  }
  integerIf(condition) {
    this._rules.integer = {
      $message: this.t("rvai-base.validation.integer", [this.label]),
      $params: { condition },
      $validator: (value2) => !helpers.req(value2) || !toValue(condition) || Number.isInteger(Number(value2))
    };
    return this;
  }
  maxLength(max2) {
    if (max2 == null) return this;
    this._rules.maxLength = helpers.withMessage(
      this.t("rvai-base.validation.maxLength", [this.label, max2]),
      maxLength(max2)
    );
    return this;
  }
  maxValue(max2, inclusive = true) {
    if (max2 == null) return this;
    this._rules.max = this._maxValue(max2, inclusive);
    return this;
  }
  maxValueIf(condition, max2, inclusive = true) {
    if (max2 == null) return this;
    this._rules.max = conditional(
      condition,
      this._maxValue(max2, inclusive)
    );
    return this;
  }
  minLowerCaseCount(min2, i18nPath = "rvai-base.validation.minLowerCaseCount") {
    this._rules.minLowerCaseCount = {
      $message: this.t(i18nPath, [this.label, min2], { plural: min2 }),
      $params: { min: min2 },
      $validator: minCharCountRaw(min2, /[a-z]/g)
    };
    return this;
  }
  minNumberCount(min2, i18nPath = "rvai-base.validation.minNumberCount") {
    this._rules.minNumberCount = {
      $message: this.t(i18nPath, [this.label, min2], { plural: min2 }),
      $params: { min: min2 },
      $validator: minCharCountRaw(min2, /[0-9]/g)
    };
    return this;
  }
  minSpecialCount(min2, i18nPath = "rvai-base.validation.minSpecialCount") {
    this._rules.minSpecialCount = {
      $message: this.t(i18nPath, [this.label, min2], { plural: min2 }),
      $params: { min: min2 },
      $validator: minCharCountRaw(min2, /[!"#$%'()*+,\-./:;<=>?@\\[\]^_`{|}~\s]/g)
    };
    return this;
  }
  minUpperAndLowerCaseCount(min2, i18nPath = "rvai-base.validation.minUpperAndLowerCaseCount") {
    this._rules.minUpperAndLowerCaseCount = {
      $message: this.t(i18nPath, [this.label, min2], { plural: min2 }),
      $params: { min: min2 },
      $validator: minCharsCountRaw(min2, [/[a-z]/g, /[A-Z]/g])
    };
    return this;
  }
  minUpperCaseCount(min2, i18nPath = "rvai-base.validation.minUpperCaseCount") {
    this._rules.minUpperCaseCount = {
      $message: this.t(i18nPath, [this.label, min2], { plural: min2 }),
      $params: { min: min2 },
      $validator: minCharCountRaw(min2, /[A-Z]/g)
    };
    return this;
  }
  minLength(min2, i18nPath = "rvai-base.validation.minLength") {
    if (min2 == null) return this;
    this._rules.minLength = helpers.withMessage(
      this.t(i18nPath, [this.label, min2]),
      minLength(min2)
    );
    return this;
  }
  minValue(min2, inclusive = true) {
    if (min2 == null) return this;
    this._rules.min = this._minValue(min2, inclusive);
    return this;
  }
  minValueIf(condition, min2, inclusive = true) {
    if (min2 == null) return this;
    this._rules.min = conditional(
      condition,
      this._minValue(min2, inclusive)
    );
    return this;
  }
  get numbersOnly() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.numbers", [this.label]),
      $validator: helpers.regex(/^[0-9]*$/)
    };
    return this;
  }
  get numeric() {
    this._rules.numeric = {
      $message: this.t("rvai-base.validation.numeric", [this.label]),
      $validator: helpers.regex(/^-?\d*(\.\d+)?$/)
    };
    return this;
  }
  oneOfRegexes(regExes) {
    this._rules.oneOfRegexes = {
      $message: this.t("rvai-base.validation.mustBeValid", [this.label]),
      $params: { regExes },
      $validator: (value2) => !helpers.req(value2) || !regExes.length || regExes.some((regex) => regex.test(value2))
    };
    return this;
  }
  regex(regEx, textPath = "rvai-base.validation.mustBeValid") {
    this._rules.regex = {
      $message: this.t(textPath, [this.label]),
      $validator: helpers.regex(regEx)
    };
    return this;
  }
  get required() {
    this._rules.required = {
      $message: this.t("rvai-base.validation.isRequired", [this.label]),
      $validator: (value2) => !!helpers.req(value2)
    };
    return this;
  }
  requiredIf(condition) {
    this._rules.required = {
      $message: this.t("rvai-base.validation.isRequired", [this.label]),
      $params: { condition },
      $validator: (value2) => !toValue(condition) || !!helpers.req(value2)
    };
    return this;
  }
  requiredUnless(condition) {
    this._rules.required = helpers.withMessage(
      this.t("rvai-base.validation.isRequired", [this.label]),
      requiredUnless(() => !!toValue(condition))
    );
    return this;
  }
  get rules() {
    return this._rules;
  }
  sameAs(i18nPath, val) {
    this._rules.sameAs = {
      $message: this.t("rvai-base.validation.sameAs", [this.label, this.t(i18nPath)]),
      $params: { val },
      $validator: (value2) => !helpers.req(value2) || value2 === val
    };
    return this;
  }
  get slug() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.slug", [this.label]),
      $validator: helpers.regex(/^[a-z0-9]+(?:[-_.][a-z0-9]+)*$/)
    };
    return this;
  }
  uniqueValue(values) {
    const isUnique = (value2) => {
      return !toValue(values).filter(Boolean).map((s3) => typeof s3 === "string" ? s3.toLowerCase() : s3).includes(typeof value2 === "string" ? value2.toLowerCase() : value2);
    };
    this._rules.unique = {
      $message: this.t("rvai-base.validation.isUnique", [this.label]),
      $params: { values },
      $validator: (value2) => !helpers.req(value2) || isUnique(value2)
    };
    return this;
  }
  get url() {
    this._rules.url = {
      $message: this.t("rvai-base.validation.url", [this.label]),
      $validator: helpers.regex(/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/)
    };
    return this;
  }
  get withoutSpaces() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.withoutSpaces", [this.label]),
      $validator: helpers.regex(/^[^\s]*$/)
    };
    return this;
  }
  get wordsAndNumbers() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.wordsAndNumbers", [this.label]),
      $validator: helpers.regex(/^[a-zA-Z0-9]*$/)
    };
    return this;
  }
  get wordsWithoutSpaces() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.wordsWithoutSpaces", [this.label]),
      $validator: helpers.regex(/^[a-zA-Z0-9_-]*$/)
    };
    return this;
  }
  get wordsWithSpaces() {
    this._rules.regex = {
      $message: this.t("rvai-base.validation.wordsWithSpaces", [this.label]),
      $validator: helpers.regex(/^[a-zA-Z0-9_\- ]*$/)
    };
    return this;
  }
  _maxValue(max2, inclusive) {
    const message = inclusive ? "rvai-base.validation.maxValue" : "rvai-base.validation.maxValueExclusive";
    return helpers.withMessage(
      this.t(message, [this.label, max2]),
      maxValue(max2, inclusive)
    );
  }
  _minValue(min2, inclusive) {
    const message = inclusive ? "rvai-base.validation.minValue" : "rvai-base.validation.minValueExclusive";
    return helpers.withMessage(
      this.t(message, [this.label, min2]),
      minValue(min2, inclusive)
    );
  }
  t(key, params, options) {
    return this.i18n.t(key, params, {
      ...options,
      missingWarn: false
    });
  }
  get i18n() {
    return this._i18n ?? _ValidationBuilder.i18n;
  }
};
__publicField(_ValidationBuilder, "i18n");
let ValidationBuilder = _ValidationBuilder;
class IfValidationBuilder extends ValidationBuilder {
  constructor(builder, condition, i18nPath, label, i18n) {
    super(i18nPath, label, i18n);
    __publicField(this, "builder");
    __publicField(this, "condition");
    this.builder = builder;
    this.condition = condition;
  }
  end() {
    Object.entries(this._rules).forEach(([key, rule]) => {
      this.builder.addRule(
        `if_${key}`,
        conditional(this.condition, rule)
      );
    });
    return this.builder;
  }
}
const lineStyles = {
  dashed: {
    borderDash: [5, 4]
  },
  "dashed-long-with-offset": {
    borderDash: [10, 3],
    borderDashOffset: 5
  },
  dotted: {
    borderCapStyle: "round",
    borderDash: [0, 4]
  },
  "dotted-loosely": {
    borderCapStyle: "round",
    borderDash: [0, 10]
  },
  solid: {}
};
function buildGradient(ctx, chartArea, color) {
  const rgbColor = colors_default.textToRgb(color);
  const rgbColorString = `${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}`;
  const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
  gradient.addColorStop(0, `rgba(${rgbColorString}, 0)`);
  gradient.addColorStop(0.3, `rgba(${rgbColorString}, 0.3)`);
  gradient.addColorStop(0.5, `rgba(${rgbColorString}, 0.5)`);
  gradient.addColorStop(0.8, `rgba(${rgbColorString}, 0.8)`);
  gradient.addColorStop(1, `rgba(${rgbColorString}, 1)`);
  return gradient;
}
function useChartDatasets({
  chartRef,
  params
}) {
  return computed(() => {
    const {
      chart,
      entries,
      fill,
      interpolate,
      relativeTime
    } = params.value;
    return entries.map((entry) => {
      var _a;
      const color = toValue(params.value.colors)[entry.key];
      const lineStyle = lineStyles[entry.lineStyle ?? "solid"];
      let chartData;
      if (chart.timeAxis && relativeTime && entry.data.length) {
        const x0 = new Date((_a = entry.data[0]) == null ? void 0 : _a[chart.xAxis]).getTime();
        chartData = entry.data.map((x2) => ({
          ...x2,
          [chart.xAxis]: new Date(x2[chart.xAxis]).getTime() - x0 || 0
        }));
      } else {
        chartData = entry.data;
      }
      let height2;
      let width;
      let gradient;
      return {
        borderCapStyle: lineStyle == null ? void 0 : lineStyle.borderCapStyle,
        borderColor: entry.opacity ? rgbaColor(color, entry.opacity) : color,
        borderDash: lineStyle == null ? void 0 : lineStyle.borderDash,
        borderDashOffset: lineStyle == null ? void 0 : lineStyle.borderDashOffset,
        borderWidth: 2,
        data: chartData,
        fill,
        label: entry.name,
        pointBackgroundColor: color,
        pointBorderColor: color,
        pointRadius: (context) => {
          return context.dataIndex === context.dataset.data.length - 1 ? 4 : 0;
        },
        ...interpolate && {
          cubicInterpolationMode: "monotone"
        },
        ...fill && {
          backgroundColor: (ctx) => {
            const { chartArea } = ctx.chart;
            const chartWidth = chartArea.right - chartArea.left;
            const chartHeight = chartArea.bottom - chartArea.top;
            if (!chartWidth || !chartHeight) return color;
            if (!gradient || width !== chartWidth || height2 !== chartHeight) {
              const canvasContext = chartRef.value.getContext("2d");
              gradient = buildGradient(canvasContext, chartArea, color);
            }
            return gradient;
          }
        }
      };
    });
  });
}
class ChartDefinition {
  constructor(params) {
    Object.assign(this, params);
  }
}
class ChartEntry {
  constructor(params) {
    Object.assign(this, params);
  }
}
const NULL_CLASS_ID = "null";
const UNKNOWN_CLASS_ID = "999";
const {
  lighten,
  luminosity
} = colors_default;
class ConfusionMatrixData {
  constructor(matrix, options) {
    __publicField(this, "classes1");
    __publicField(this, "classes2");
    __publicField(this, "includeIgnoreClassInMetricCalculation");
    __publicField(this, "matrix");
    __publicField(this, "maxValue");
    __publicField(this, "metrics1");
    __publicField(this, "metrics2");
    __publicField(this, "metricTotal");
    __publicField(this, "percentages");
    __publicField(this, "styles");
    __publicField(this, "stylesDarkMode");
    __publicField(this, "transposed");
    this.includeIgnoreClassInMetricCalculation = !!(options == null ? void 0 : options.includeIgnoreClassInMetricCalculation);
    this.matrix = matrix ?? {};
    this.transposed = this.buildTransposed(matrix);
    this.classes1 = Object.keys(this.matrix);
    this.classes2 = Object.keys(this.transposed);
    this.maxValue = this.buildMaxValue(this.matrix);
    this.metrics1 = this.buildMetrics(this.matrix);
    this.metrics2 = this.buildMetrics(this.transposed);
    this.metricTotal = this.buildMetricTotal(this.matrix);
    this.percentages = this.buildPercentages(this.matrix);
    this.styles = this.buildStyles(this.matrix, this.maxValue);
    this.stylesDarkMode = this.buildStyles(this.matrix, this.maxValue, true);
    markRaw(this);
  }
  getClasses1() {
    return distinct([
      ...this.classes1,
      ...this.classes2.filter((x2) => !this.ignoreClass(x2))
    ]);
  }
  getClasses2() {
    return distinct([
      ...this.classes2,
      ...this.classes1.filter((x2) => !this.ignoreClass(x2))
    ]);
  }
  getValue(id1, id22) {
    var _a;
    return ((_a = this.matrix[id1]) == null ? void 0 : _a[id22]) || 0;
  }
  getMetric1(id3) {
    if (this.ignoreClass(id3)) return "-";
    return this.round(this.metrics1[id3]);
  }
  getMetric2(id3) {
    if (this.ignoreClass(id3)) return "-";
    return this.round(this.metrics2[id3]);
  }
  getMetricTotal() {
    return this.round(this.metricTotal);
  }
  getOutliers() {
    return Object.entries(this.matrix).flatMap(([source1, others]) => {
      return Object.entries(others).map(([source2, count]) => {
        return count && source1 !== source2 ? {
          source1,
          source2
        } : null;
      }).filter(Boolean);
    });
  }
  getPercentage(id1, id22) {
    var _a;
    return `${this.round((_a = this.percentages[id1]) == null ? void 0 : _a[id22], 2)}%`;
  }
  getStyle(id1, id22, isDark = false) {
    var _a, _b;
    if (isDark) {
      return ((_a = this.stylesDarkMode[id1]) == null ? void 0 : _a[id22]) ?? {};
    }
    return ((_b = this.styles[id1]) == null ? void 0 : _b[id22]) ?? {};
  }
  getTransposed() {
    return new ConfusionMatrixData(this.transposed);
  }
  getValues1(id3) {
    return this.matrix[id3] ?? {};
  }
  getValues2(id3) {
    return this.transposed[id3] ?? {};
  }
  toRaw() {
    return this.matrix;
  }
  buildMaxValue(matrix) {
    if (!matrix) return 0;
    return Object.values(matrix).reduce((max2, items) => {
      return Object.values(items).reduce((max22, value2) => {
        return value2 > max22 ? value2 : max22;
      }, max2);
    }, 0);
  }
  getObjectValuesSum(object, classId) {
    let entries = Object.entries(object);
    if (!this.includeIgnoreClassInMetricCalculation) {
      entries = entries.filter(([k2]) => this.unknownClass(classId) || !this.ignoreClass(k2));
    }
    return entries.reduce((acc, [, value2]) => acc + value2, 0);
  }
  buildMetrics(matrix) {
    if (!matrix) return {};
    return mapToObject(
      matrix,
      (values, id3) => {
        const actual = values[id3] ?? 0;
        const sum = this.getObjectValuesSum(values, id3);
        return sum ? actual / sum : 0;
      },
      (_, id3) => !this.nullClass(id3)
    );
  }
  buildMetricTotal(matrix) {
    if (!matrix) return 0;
    let sum = 0;
    let actual = 0;
    Object.entries(matrix).filter(([id3]) => this.includeIgnoreClassInMetricCalculation || !this.ignoreClass(id3)).forEach(([id3, values]) => {
      actual += values[id3] ?? 0;
      sum += this.getObjectValuesSum(values, id3);
    });
    return sum ? actual / sum : 0;
  }
  buildPercentages(matrix) {
    if (!matrix) return {};
    let sum = 0;
    Object.entries(matrix).forEach(([, values]) => {
      sum += Object.entries(values).reduce((acc, [, value2]) => acc + value2, 0);
    });
    return mapToObject(
      matrix,
      (entries) => mapToObject(
        entries,
        (value2) => sum ? value2 / sum : 0
      )
    );
  }
  buildStyles(matrix, max2, isDark = false) {
    if (!matrix || !max2) return {};
    return mapToObject(
      matrix,
      (entries) => mapToObject(
        entries,
        (value2) => {
          let k2 = 100 * (1 - value2 / this.maxValue);
          if (value2 > 0) {
            const maxK = 98;
            k2 = Math.min(maxK, k2);
          }
          const color = lighten(this.maxColor(isDark), isDark ? Math.abs(k2 - 100) : k2);
          const textColor = luminosity(color) < 0.5 ? "white" : "inherit";
          return {
            "background-color": color,
            color: textColor
          };
        }
      )
    );
  }
  buildTransposed(matrix) {
    if (!matrix) return {};
    const transposed = {};
    for (const [k2, obj] of Object.entries(matrix)) {
      for (const [l, value2] of Object.entries(obj)) {
        if (l in transposed) {
          transposed[l][k2] = value2;
        } else {
          transposed[l] = { [k2]: value2 };
        }
      }
    }
    return transposed;
  }
  maxColor(isDark = false) {
    try {
      if (isDark) {
        return getCssVar("dark-fixed") ?? "#353C54";
      }
      return getCssVar("black-1-fixed") ?? "#1F2641";
    } catch {
      return "#1F2641";
    }
  }
  ignoreClass(id3) {
    return this.nullClass(id3) || this.unknownClass(id3);
  }
  nullClass(id3) {
    return id3 === NULL_CLASS_ID;
  }
  unknownClass(id3) {
    return id3 === UNKNOWN_CLASS_ID;
  }
  round(value2, decimal2 = 0, defaultValue = "0") {
    return value2 ? (100 * value2).toLocaleString(void 0, { maximumFractionDigits: decimal2 }) : defaultValue;
  }
}
var CookiesPolicy = /* @__PURE__ */ ((CookiesPolicy2) => {
  CookiesPolicy2["All"] = "all";
  CookiesPolicy2["Required"] = "required";
  return CookiesPolicy2;
})(CookiesPolicy || {});
const DARK_MODE_LOCAL_STORAGE_KEY = "darkMode";
var DetailsDataType = /* @__PURE__ */ ((DetailsDataType2) => {
  DetailsDataType2["Classes"] = "Classes";
  DetailsDataType2["Color"] = "Color";
  DetailsDataType2["Custom"] = "Custom";
  DetailsDataType2["Link"] = "Link";
  DetailsDataType2["List"] = "List";
  DetailsDataType2["Text"] = "Text";
  DetailsDataType2["TextWrap"] = "TextWrap";
  return DetailsDataType2;
})(DetailsDataType || {});
class FieldVisibility {
  constructor(params) {
    __publicField(this, "fields");
    __publicField(this, "_hideable");
    __publicField(this, "label");
    __publicField(this, "key");
    __publicField(this, "_visible");
    this.fields = params.fields;
    this._hideable = params.hideable == null ? true : !!params.hideable;
    this.key = params.key;
    this.label = params.label;
    this._visible = params.visible == null ? true : !!params.visible;
  }
  clone() {
    return new FieldVisibility({
      fields: this.fields.map((v) => v.clone()),
      hideable: this.hideable,
      key: this.key,
      label: this.label,
      visible: this.visible
    });
  }
  get hideable() {
    return this.fields.length ? this.fields.some((v) => v.hideable) : !!this._hideable;
  }
  get visible() {
    return this.fields.length ? this.fields.some((v) => v.visible) : !!this._visible;
  }
  set visible(visible) {
    if (this._hideable) {
      if (this.fields.length) {
        this.fields = this.fields.map((v) => {
          v.visible = visible;
          return v;
        });
      } else {
        this._visible = visible;
      }
    }
  }
  isFieldVisible(key) {
    var _a;
    return !!((_a = this.fields.find((v) => v.key === key || v.isFieldVisible(key))) == null ? void 0 : _a.visible);
  }
  static getVisibleKeys(field) {
    if (!field.visible) {
      return [field.key];
    }
    return flatten(
      field.fields.map(FieldVisibility.getVisibleKeys)
    );
  }
  serialize() {
    if (!this.visible) {
      return [this.key];
    }
    return flatten(
      this.fields.map((f) => f.serialize())
    );
  }
  static fromQueryParams(params, hiddenNames) {
    const visible = hiddenNames.includes(params.key) ? false : params.visible;
    return new FieldVisibility({
      ...params,
      fields: params.fields.map((v) => FieldVisibility.fromQueryParams(
        {
          ...v,
          visible
        },
        hiddenNames
      )),
      visible
    });
  }
}
function isHistoryRouteMeta(meta) {
  if (!meta) return false;
  return "track" in meta;
}
const KEY_0 = "0";
const KEY_1 = "1";
const KEY_2 = "2";
const KEY_3 = "3";
const KEY_4 = "4";
const KEY_5 = "5";
const KEY_6 = "6";
const KEY_7 = "7";
const KEY_8 = "8";
const KEY_9 = "9";
const KEY_A_LOWER = "a";
const KEY_A_UPPER = "A";
const KEY_ALT = "Alt";
const KEY_ARROW_DOWN = "ArrowDown";
const KEY_ARROW_LEFT = "ArrowLeft";
const KEY_ARROW_RIGHT = "ArrowRight";
const KEY_ARROW_UP = "ArrowUp";
const KEY_B_LOWER = "b";
const KEY_B_UPPER = "B";
const KEY_BACKSPACE = "Backspace";
const KEY_C_UPPER = "C";
const KEY_CONTROL = "Control";
const KEY_D_LOWER = "d";
const KEY_D_UPPER = "D";
const KEY_DEL = "Del";
const KEY_DELETE = "Delete";
const KEY_E_UPPER = "E";
const KEY_ENTER = "Enter";
const KEY_EQUAL = "=";
const KEY_ESC = "Esc";
const KEY_ESCAPE = "Escape";
const KEY_F_LOWER = "f";
const KEY_F_UPPER = "F";
const KEY_F1 = "F1";
const KEY_G_LOWER = "g";
const KEY_G_UPPER = "G";
const KEY_I_UPPER = "I";
const KEY_L_LOWER = "l";
const KEY_L_UPPER = "L";
const KEY_M_UPPER = "M";
const KEY_META = "Meta";
const KEY_MINUS = "-";
const KEY_O_UPPER = "O";
const KEY_P_LOWER = "p";
const KEY_P_UPPER = "P";
const KEY_PLUS = "+";
const KEY_R_LOWER = "r";
const KEY_R_UPPER = "R";
const KEY_SHIFT = "Shift";
const KEY_SPACE = " ";
const KEY_S_LOWER = "s";
const KEY_S_UPPER = "S";
const KEY_TAB = "Tab";
const KEY_T_LOWER = "t";
const KEY_T_UPPER = "T";
const KEY_V_UPPER = "V";
const KEY_W_UPPER = "W";
const KEY_Y_UPPER = "Y";
const KEY_X_LOWER = "x";
const KEY_X_UPPER = "X";
const KEY_Z_CODE = "KeyZ";
const KEY_Z_LOWER = "z";
const KEY_Z_UPPER = "Z";
const PAPER_KEY_SHIFT = "shift";
const PAPER_KEY_SPACE = "space";
var Layout = /* @__PURE__ */ ((Layout2) => {
  Layout2["Default"] = "default";
  Layout2["Full"] = "full";
  Layout2["LeftOnly"] = "leftOnly";
  Layout2["RightOnly"] = "rightOnly";
  Layout2["Split"] = "split";
  return Layout2;
})(Layout || {});
function isLayoutRouteMeta(meta) {
  if (!meta) return false;
  return "allowedLayouts" in meta || "full" in meta;
}
var PipelineHealthStatus = /* @__PURE__ */ ((PipelineHealthStatus2) => {
  PipelineHealthStatus2["Critical"] = "CRITICAL";
  PipelineHealthStatus2["Failing"] = "FAILING";
  PipelineHealthStatus2["Healthy"] = "HEALTHY";
  PipelineHealthStatus2["Overpowered"] = "OVERPOWERED";
  PipelineHealthStatus2["Unbalanced"] = "UNBALANCED";
  PipelineHealthStatus2["Underpowered"] = "UNDERPOWERED";
  PipelineHealthStatus2["Unknown"] = "UNKNOWN";
  return PipelineHealthStatus2;
})(PipelineHealthStatus || {});
var ReplicaStatus = /* @__PURE__ */ ((ReplicaStatus2) => {
  ReplicaStatus2["Error"] = "ERROR";
  ReplicaStatus2["Queued"] = "QUEUED";
  ReplicaStatus2["Running"] = "RUNNING";
  ReplicaStatus2["Starting"] = "STARTING";
  ReplicaStatus2["Unknown"] = "UNKNOWN";
  return ReplicaStatus2;
})(ReplicaStatus || {});
var RowActionsVisibility = /* @__PURE__ */ ((RowActionsVisibility2) => {
  RowActionsVisibility2["HiddenUntilHover"] = "HiddenUntilHover";
  RowActionsVisibility2["NoActions"] = "NoActions";
  RowActionsVisibility2["Visible"] = "Visible";
  return RowActionsVisibility2;
})(RowActionsVisibility || {});
class CancelAsync extends Error {
}
class HttpsProtocolMismatch extends Error {
}
class NotFound extends Error {
}
class Unauthorized extends Error {
}
const RvaiExceptions = {
  CancelAsync,
  HttpsProtocolMismatch,
  NotFound,
  Unauthorized
};
var SortOrders = /* @__PURE__ */ ((SortOrders2) => {
  SortOrders2["Asc"] = "asc";
  SortOrders2["Desc"] = "desc";
  return SortOrders2;
})(SortOrders || {});
var SortType = /* @__PURE__ */ ((SortType2) => {
  SortType2["Date"] = "date";
  return SortType2;
})(SortType || {});
var TableFilterType = /* @__PURE__ */ ((TableFilterType2) => {
  TableFilterType2["Date"] = "date";
  TableFilterType2["FreeText"] = "freeText";
  TableFilterType2["List"] = "list";
  TableFilterType2["Number"] = "number";
  TableFilterType2["Single"] = "single";
  return TableFilterType2;
})(TableFilterType || {});
var ShapesNoData = /* @__PURE__ */ ((ShapesNoData2) => {
  ShapesNoData2["Horizontal"] = "horizontal";
  ShapesNoData2["Square"] = "square";
  return ShapesNoData2;
})(ShapesNoData || {});
function useDarkMode() {
  const $q = useQuasar();
  function initialize2(value2) {
    if (value2 != null) {
      $q.dark.set(value2);
    } else {
      $q.dark.set(LocalStorage_default.getItem(DARK_MODE_LOCAL_STORAGE_KEY) || false);
    }
  }
  function set2(value2) {
    $q.dark.set(value2);
    LocalStorage_default.set(DARK_MODE_LOCAL_STORAGE_KEY, $q.dark.isActive);
  }
  function toggle() {
    $q.dark.toggle();
    LocalStorage_default.set(DARK_MODE_LOCAL_STORAGE_KEY, $q.dark.isActive);
  }
  return {
    initialize: initialize2,
    isDark: computed(() => $q.dark.isActive),
    set: set2,
    toggle
  };
}
const TWO_DAYS_IN_MS = 1728e5;
function isTimeRangeLargerThan2Days(params) {
  const {
    min: min2,
    max: max2
  } = params;
  return min2 && max2 && max2 - min2 > TWO_DAYS_IN_MS;
}
function formatDuration(value2) {
  const total = value2 / 1e3;
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor(total / 60 % 60);
  const seconds = total % 60;
  return hours ? `${hours}h ${minutes}m` : minutes ? `${minutes}m ${seconds}s` : `${seconds}s`;
}
function useChartOptions({
  customTooltip,
  params,
  tooltipLines
}) {
  const { isDark } = useDarkMode();
  return computed(() => {
    var _a, _b, _c;
    const { chart } = params.value;
    let xAxisLabel = ((_a = chart.labels) == null ? void 0 : _a[chart.xAxis]) || chart.xAxis;
    if (chart.xAxisUnit) xAxisLabel += ` (${chart.xAxisUnit})`;
    let yAxisLabel = ((_b = chart.labels) == null ? void 0 : _b[chart.yAxis]) || chart.yAxis;
    if (chart.yAxisUnit) yAxisLabel += ` (${chart.yAxisUnit})`;
    const labelColor = isDark.value ? getCssVar("white-fixed") ?? "#FFFFFF" : getCssVar("grey-1-fixed") ?? "#485374";
    const xAxisTicksConfig = {
      autoSkipPadding: 30,
      maxRotation: params.value.labelMaxRotation,
      maxTicksLimit: params.value.xAxisMaxTicksLimit
    };
    const options = {
      animation: false,
      interaction: {
        axis: "xy",
        intersect: false,
        mode: "nearest"
      },
      maintainAspectRatio: params.value.maintainAspectRatio,
      parsing: {
        xAxisKey: chart.xAxis,
        yAxisKey: chart.yAxis
      },
      plugins: {
        tooltip: {
          callbacks: {
            label: (item) => {
              var _a2;
              return [
                item.dataset.label ?? "",
                ...((_a2 = tooltipLines.value[item.datasetIndex]) == null ? void 0 : _a2[item.dataIndex]) ?? []
              ];
            },
            title: () => ""
          },
          enabled: false,
          external: customTooltip
        }
      },
      responsive: true,
      scales: {
        xAxis: {
          ticks: xAxisTicksConfig,
          title: {
            color: labelColor,
            display: params.value.showAxisLabels,
            font: {
              lineHeight: "18px",
              size: 12,
              weight: "600"
            },
            text: xAxisLabel
          },
          type: "linear"
        },
        yAxis: {
          beginAtZero: true,
          title: {
            color: labelColor,
            display: params.value.showAxisLabels,
            font: {
              lineHeight: "18px",
              size: 12,
              weight: "600"
            },
            text: yAxisLabel
          }
        }
      }
    };
    if (chart.timeAxis) {
      options.scales = {
        ...options.scales,
        xAxis: {
          ...(_c = options.scales) == null ? void 0 : _c.xAxis,
          ...params.value.relativeTime ? {
            ticks: {
              ...xAxisTicksConfig,
              callback: (value2) => formatDuration(value2)
            }
          } : {
            ...params.value.max ? { max: params.value.max } : {},
            ...params.value.min ? { min: params.value.min } : {},
            ticks: xAxisTicksConfig,
            time: {
              displayFormats: Object.assign({
                hour: "MMM d HH:mm",
                minute: "HH:mm",
                second: "HH:mm:ss",
                week: "MMM d"
                /* Weeks */
              }, params.value.xAxisTimeDisplayFormats),
              ...isTimeRangeLargerThan2Days(params.value) ? { minUnit: "hour" } : {}
            },
            type: "time"
          }
        }
      };
    }
    return options;
  });
}
const OFFSET = 10;
const SCROLLBAR_OFFSET = 15;
function useChartTooltip(chart, caret) {
  const tooltipGhostRef = useTemplateRef("tooltipGhost");
  const style = ref$1({
    height: "0px",
    left: "0px",
    overflow: "auto",
    top: "0px",
    width: "0px"
  });
  const timeout2 = ref$1(null);
  function getXDeviation() {
    const offsetWidth = getTooltipWidth();
    if (caret.value.x <= offsetWidth / 2) {
      return offsetWidth / 2 + OFFSET;
    }
    if (chart.value.width - caret.value.x <= offsetWidth / 2) {
      return -offsetWidth / 2 + -OFFSET;
    }
    return 0;
  }
  function getLeft() {
    if (!tooltipGhostRef.value || !chart) return 0;
    return chart.value.position.x + caret.value.x + getXDeviation();
  }
  function getTop() {
    if (!tooltipGhostRef.value || !chart) return 0;
    return chart.value.position.y + caret.value.y + OFFSET;
  }
  function updateTooltipSizeAndPosition() {
    if (!tooltipGhostRef.value || !chart.value) return;
    style.value = {
      height: `${getTooltipHeight()}px`,
      left: `${getLeft()}px`,
      overflow: getTooltipHeight() < tooltipGhostRef.value.offsetHeight ? "auto" : "hidden",
      top: `${getTop()}px`,
      width: `${getTooltipWidth()}px`
    };
  }
  function getTooltipWidth() {
    return tooltipGhostRef.value.offsetWidth + SCROLLBAR_OFFSET;
  }
  function getTooltipHeight() {
    return Math.min(tooltipGhostRef.value.offsetHeight, getMaxHeight());
  }
  function getMaxHeight() {
    return window.innerHeight - chart.value.top - caret.value.y - OFFSET;
  }
  watch([chart, caret], () => {
    timeout2.value = window.setTimeout(() => {
      updateTooltipSizeAndPosition();
    }, 1);
  }, {
    deep: true,
    immediate: true
  });
  onUnmounted(() => {
    if (timeout2.value) {
      window.clearTimeout(timeout2.value);
    }
  });
  return { style };
}
const state$1 = reactive({});
function useCollapsed(name2, value2) {
  if (state$1[name2] === void 0) {
    state$1[name2] = value2 === void 0 ? true : value2;
  }
  const collapsed = toRef(state$1, name2);
  function toggleCollapsed() {
    state$1[name2] = !state$1[name2];
  }
  return {
    collapsed,
    toggleCollapsed
  };
}
const _sfc_main$1L = defineComponent({
  name: "Tooltip",
  components: {
    QTooltip: QTooltip_default
  },
  inheritAttrs: false,
  props: {
    /**
     * Automatically hide after a time when manually triggered
     */
    autoHide: {
      default: void 0,
      type: Number
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Two values setting the starting position or anchor point of the Tooltip relative to its target
     */
    anchor: {
      type: String,
      default: "bottom middle"
    },
    /**
     * Render arrow (bottom|left|right|top)
     */
    arrow: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * The maximum width of the Tooltip; Size in CSS units, including unit name
     */
    maxWidth: {
      type: String,
      default: "400px"
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: Boolean,
      default: void 0
    },
    /**
     * An array of two numbers to offset the Tooltip horizontally and vertically in pixels
     */
    offset: {
      type: Array,
      default: () => [14, 14]
    },
    /**
     * Two values setting the Tooltip's own position relative to its target
     */
    self: {
      type: String,
      default: "top middle"
    },
    /**
     * Configure a target element to trigger Tooltip toggle; 'true' means it enables the parent DOM element, 'false' means it disables attaching events to any DOM elements; By using a String (CSS selector) it attaches the events to the specified DOM element (if it exists)
     */
    target: {
      type: [Boolean, String],
      default: true
    }
  },
  emits: [
    /**
     * Emitted when the component needs to change the model; Is also used by v-model
     *
     * @type {boolean}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const tooltipRef = ref$1(null);
    const timeout2 = ref$1(null);
    const arrowClass = computed(() => {
      switch (props4.arrow) {
        case "bottom":
          return "rv-tooltip__arrow rv-tooltip__arrow--bottom";
        case "left":
          return "rv-tooltip__arrow rv-tooltip__arrow--left";
        case "right":
          return "rv-tooltip__arrow rv-tooltip__arrow--right";
        case "top":
          return "rv-tooltip__arrow rv-tooltip__arrow--top";
        default:
          return void 0;
      }
    });
    function show(evt) {
      var _a;
      (_a = tooltipRef.value) == null ? void 0 : _a.show(evt);
      if (timeout2.value) window.clearTimeout(timeout2.value);
      if (props4.autoHide) {
        timeout2.value = window.setTimeout(() => {
          var _a2;
          (_a2 = tooltipRef.value) == null ? void 0 : _a2.hide();
        }, props4.autoHide);
      }
    }
    function onUpdate(value2) {
      emit("update:modelValue", value2);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      arrowClass,
      onUpdate,
      show,
      tooltipRef
    };
  }
});
const _export_sfc = (sfc, props4) => {
  const target2 = sfc.__vccOpts || sfc;
  for (const [key, val] of props4) {
    target2[key] = val;
  }
  return target2;
};
function _sfc_render$1z(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QTooltip = resolveComponent("QTooltip");
  return openBlock(), createBlock(_component_QTooltip, mergeProps(_ctx.dataAttrs, {
    ref: "tooltipRef",
    anchor: _ctx.anchor,
    class: ["rv-tooltip q-pa-sm text-overline shadow-6", [_ctx.arrowClass, _ctx.$props.class]],
    "data-automation": _ctx.buildId(),
    delay: 500,
    fit: true,
    "max-width": _ctx.maxWidth,
    "model-value": _ctx.modelValue,
    offset: _ctx.offset,
    self: _ctx.self,
    target: _ctx.target,
    "transition-hide": "fade",
    "transition-show": "fade",
    "onUpdate:modelValue": _ctx.onUpdate
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["anchor", "class", "data-automation", "max-width", "model-value", "offset", "self", "target", "onUpdate:modelValue"]);
}
const Tooltip = /* @__PURE__ */ _export_sfc(_sfc_main$1L, [["render", _sfc_render$1z]]);
const COLORS = [
  "accent",
  "black-1",
  "grey-1",
  "grey-2",
  "info",
  "negative",
  "positive",
  "primary",
  "primary-fixed",
  "warning",
  "white-fixed"
];
const SIZES$2 = ["xs", "sm", "md", "lg"];
const _sfc_main$1K = defineComponent({
  name: "RvButton",
  components: {
    QBtn: QBtn_default,
    Tooltip
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Label or content alignment
     */
    align: {
      type: String,
      default: "center",
      validator: (v) => ["left", "right", "center", "around", "between", "evenly"].includes(v)
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Color name for component from the Quasar Color Palette
     */
    color: {
      type: String,
      default: void 0,
      validator: (v) => COLORS.includes(v)
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Native <a> link href attribute; Has priority over the 'to' and 'replace' props
     */
    href: {
      type: String,
      default: void 0
    },
    /**
     * Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
     */
    icon: {
      type: String,
      default: void 0
    },
    /**
     * Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
     */
    iconRight: {
      type: String,
      default: void 0
    },
    /**
     * The text that will be shown on the button
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Put button into loading state (displays a QSpinner -- can be overridden by using a 'loading' slot)
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Render button in secondary mode
     */
    secondary: {
      type: Boolean,
      default: false
    },
    /**
     * Size in standard size name (xs|sm|md|lg)
     */
    size: {
      type: String,
      default: "md",
      validator: (v) => SIZES$2.includes(v)
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Native <a> link target attribute; Use it only with 'to' or 'href' props
     */
    target: {
      type: String,
      default: void 0
    },
    /**
     * Render button in tertiary mode
     */
    tertiary: {
      type: Boolean,
      default: false
    },
    /**
     * Overrides text color (if needed); Color name from the Quasar Color Palette
     */
    textColor: {
      type: String,
      default: void 0
    },
    /**
     * Equivalent to Vue Router <router-link> 'to' property; Superseded by 'href' prop if used
     */
    to: {
      type: [Object, String],
      default: void 0
    },
    /**
     * The text that will be shown on the button tooltip
     */
    tooltip: {
      type: String,
      default: void 0
    },
    /**
     * 1) Define the button native type attribute (submit, reset, button) or 2) render component with <a> tag so you can access events even if disable or 3) Use 'href' prop and specify 'type' as a media tag
     */
    type: {
      type: String,
      default: "button"
    }
  },
  emits: [
    /**
     * Emitted when component is clicked (activated)
     *
     * @type {object}
     */
    "click"
  ],
  setup(props4, {
    emit,
    slots
  }) {
    const buttonColor = computed(() => {
      if (props4.secondary && !hasLabel.value && !props4.color) return "black-1";
      return props4.color ?? "primary";
    });
    const hasLabel = computed(() => props4.label != null && props4.label !== "");
    const onClick = throttle(
      (event) => emit("click", event),
      200,
      { trailing: false }
    );
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      buttonColor,
      hasLabel,
      onClick,
      slots
    };
  }
});
function _sfc_render$1y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QBtn = resolveComponent("QBtn");
  return openBlock(), createBlock(_component_QBtn, mergeProps(_ctx.dataAttrs, {
    align: _ctx.align,
    class: ["rv-button", [
      _ctx.$props.class,
      `rv-button--${_ctx.size}`,
      { "rv-button--icon-only": !_ctx.hasLabel }
    ]],
    color: _ctx.buttonColor,
    "data-automation": _ctx.buildId(),
    disable: _ctx.disable,
    flat: _ctx.tertiary,
    href: _ctx.href,
    icon: _ctx.icon,
    "icon-right": _ctx.iconRight,
    label: _ctx.label,
    loading: _ctx.loading,
    "no-caps": "",
    outline: _ctx.secondary,
    ripple: false,
    style: _ctx.style,
    target: _ctx.target,
    "text-color": _ctx.textColor,
    to: _ctx.to,
    type: _ctx.type,
    onClick: _ctx.onClick
  }), createSlots({ _: 2 }, [
    _ctx.tooltip ? {
      name: "default",
      fn: withCtx(() => [
        createVNode(_component_Tooltip, {
          "data-automation": _ctx.buildId("tooltip")
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.tooltip), 1)
          ]),
          _: 1
        }, 8, ["data-automation"])
      ]),
      key: "0"
    } : void 0,
    renderList(_ctx.slots, (_, name2) => {
      return {
        name: name2,
        fn: withCtx((slotData) => [
          renderSlot(_ctx.$slots, name2, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)
        ])
      };
    })
  ]), 1040, ["align", "class", "color", "data-automation", "disable", "flat", "href", "icon", "icon-right", "label", "loading", "outline", "style", "target", "text-color", "to", "type", "onClick"]);
}
const Button = /* @__PURE__ */ _export_sfc(_sfc_main$1K, [["render", _sfc_render$1y], ["__scopeId", "data-v-397cc32d"]]);
const _sfc_main$1J = defineComponent({
  name: "ClickableArea",
  components: {
    QBtn: QBtn_default
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Changes background color on hover
     */
    hoverable: {
      type: Boolean,
      default: true
    },
    /**
     * Native <a> link href attribute; Has priority over the 'to' and 'replace' props
     */
    href: {
      type: String,
      default: void 0
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Native <a> link target attribute; Use it only with 'to' or 'href' props
     */
    target: {
      type: String,
      default: void 0
    },
    /**
     * Equivalent to Vue Router <router-link> 'to' property; Superseded by 'href' prop if used
     */
    to: {
      type: [Object, String],
      default: void 0
    },
    /**
     * 1) Define the button native type attribute (submit, reset, button) or 2) render component with <a> tag so you can access events even if disable or 3) Use 'href' prop and specify 'type' as a media tag
     */
    type: {
      type: String,
      default: "button"
    }
  },
  emits: [
    /**
     * Emitted when component is clicked (activated)
     *
     * @type {object}
     */
    "click",
    "dragend",
    "dragleave",
    "dragover",
    "dragstart",
    "drop"
  ],
  setup(props4, { emit }) {
    const onClick = throttle(
      (event) => emit("click", event),
      200,
      { trailing: false }
    );
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      onClick
    };
  }
});
function _sfc_render$1x(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QBtn = resolveComponent("QBtn");
  return openBlock(), createBlock(_component_QBtn, mergeProps(_ctx.dataAttrs, {
    class: ["rv-clickable-area", [
      _ctx.$props.class,
      { "rv-clickable-area--hoverable": _ctx.hoverable && !_ctx.disable }
    ]],
    "data-automation": _ctx.buildId(),
    disable: _ctx.disable,
    href: _ctx.href,
    "no-caps": "",
    ripple: false,
    style: _ctx.style,
    target: _ctx.target,
    to: _ctx.to,
    type: _ctx.type,
    onClick: _ctx.onClick,
    onDragend: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("dragend", $event)),
    onDragleave: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("dragleave", $event)),
    onDragover: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("dragover", $event)),
    onDragstart: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("dragstart", $event)),
    onDrop: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("drop", $event))
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ]),
    _: 3
  }, 16, ["class", "data-automation", "disable", "href", "style", "target", "to", "type", "onClick"]);
}
const ClickableArea = /* @__PURE__ */ _export_sfc(_sfc_main$1J, [["render", _sfc_render$1x], ["__scopeId", "data-v-35f5def3"]]);
const SIZES$1 = ["xs", "sm", "md"];
const _sfc_main$1I = defineComponent({
  name: "Checkbox",
  components: {
    ClickableArea,
    QCheckbox: QCheckbox_default,
    QIcon: QIcon_default,
    QMenu: QMenu_default
  },
  inheritAttrs: false,
  props: {
    /**
     * Used to align the checkbox with other components (including option group)
     */
    aligned: {
      type: Boolean,
      default: false
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Label to display along the component
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:model-value' event) OR use v-model directive
     */
    modelValue: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: [Boolean, Array],
      default: void 0
    },
    /**
     * Size in standard size name (xs|sm|md)
     */
    size: {
      type: String,
      default: void 0,
      validator: (v) => SIZES$1.includes(v)
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Works when model ('value') is Array. It tells the component which value should add/remove when ticked/unticked
     */
    val: {
      type: null,
      default: void 0
    }
  },
  emits: ["update:modelValue"],
  setup(props4, { emit }) {
    const showMenu = ref$1(false);
    const value2 = computed({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      get() {
        return props4.modelValue;
      },
      set(value22) {
        emit("update:modelValue", value22);
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      showMenu,
      value: value2
    };
  }
});
const _hoisted_1$1t = { class: "rv-checkbox-wrapper row items-center" };
function _sfc_render$1w(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QCheckbox = resolveComponent("QCheckbox");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_ClickableArea = resolveComponent("ClickableArea");
  return openBlock(), createElementBlock("div", _hoisted_1$1t, [
    createVNode(_component_QCheckbox, mergeProps({
      ..._ctx.dataAttrs,
      ...!!_ctx.$attrs.onClick && { onClick: _ctx.$attrs.onClick }
    }, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.value = $event),
      class: ["rv-checkbox", [
        _ctx.$props.class,
        `rv-checkbox--${_ctx.size}`,
        {
          "rv-checkbox--aligned": _ctx.aligned,
          "rv-checkbox--with-menu": _ctx.$slots["menu"]
        }
      ]],
      "data-automation": _ctx.buildId(),
      dense: _ctx.dense,
      disable: _ctx.disable,
      label: _ctx.label,
      size: _ctx.size,
      style: _ctx.style,
      val: _ctx.val
    }), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]),
      _: 3
    }, 16, ["modelValue", "class", "data-automation", "dense", "disable", "label", "size", "style", "val"]),
    _ctx.$slots["menu"] ? (openBlock(), createBlock(_component_ClickableArea, {
      key: 0,
      class: normalizeClass(["rv-checkbox__menu-icon-wrapper cursor-pointer flex items-center", [`rv-checkbox__menu-icon-wrapper--${_ctx.size}`]]),
      "data-automation": "checkbox__menu-icon-wrapper",
      disable: _ctx.disable
    }, {
      default: withCtx(() => [
        createVNode(_component_QIcon, {
          "data-automation": "checkbox__menu-icon",
          name: "mdi-menu-down",
          size: "15px"
        }),
        createVNode(_component_QMenu, {
          modelValue: _ctx.showMenu,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.showMenu = $event),
          "auto-close": "",
          "data-automation": "checkbox__menu",
          self: "top left"
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "menu", {}, void 0, true)
          ]),
          _: 3
        }, 8, ["modelValue"])
      ]),
      _: 3
    }, 8, ["class", "disable"])) : createCommentVNode("", true)
  ]);
}
const Checkbox = /* @__PURE__ */ _export_sfc(_sfc_main$1I, [["render", _sfc_render$1w], ["__scopeId", "data-v-d0b6c497"]]);
const _sfc_main$1H = defineComponent({
  name: "ScrollArea",
  components: {
    QScrollArea: QScrollArea_default
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "scrollArea"
    },
    /**
     * Classes applied to the Histogram
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Removes horizontal scroll
     */
    noHorizontal: {
      type: Boolean,
      default: false
    },
    /**
     * Force render the content as a normal div
     */
    noScroll: {
      type: Boolean,
      default: false
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Manually control the visibility of the scrollbar; Overrides default mouse over/leave behavior
     */
    visible: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["scroll"],
  setup(props4, { emit }) {
    const scrollAreaRef = ref$1();
    const bottomVisible = ref$1(true);
    const topVisible = ref$1(true);
    function onScroll(event) {
      emit("scroll", event);
      const {
        verticalContainerSize,
        verticalPosition,
        verticalSize
      } = event;
      topVisible.value = !verticalPosition;
      bottomVisible.value = verticalSize - verticalContainerSize === verticalPosition;
    }
    function setScrollPosition(axis, offset2, duration2 = 0) {
      if (scrollAreaRef.value) scrollAreaRef.value.setScrollPosition(axis, offset2, duration2);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      bottomVisible,
      onScroll,
      scrollAreaRef,
      setScrollPosition,
      topVisible
    };
  }
});
const _hoisted_1$1s = ["data-automation"];
function _sfc_render$1v(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QScrollArea = resolveComponent("QScrollArea");
  return !_ctx.noScroll ? (openBlock(), createBlock(_component_QScrollArea, mergeProps({ key: 0 }, {
    ..._ctx.dataAttrs,
    ..._ctx.$props.visible != null && { visible: _ctx.$props.visible }
  }, {
    ref: "scrollAreaRef",
    class: ["scroll-area", [_ctx.$props.class, { "scroll-area--no-horizontal": _ctx.noHorizontal }]],
    "data-automation": _ctx.buildId(),
    style: _ctx.style,
    onScroll: _ctx.onScroll
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ]),
    _: 3
  }, 16, ["class", "data-automation", "style", "onScroll"])) : (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(["scroll-area", _ctx.$props.class]),
    "data-automation": _ctx.buildId(),
    style: normalizeStyle(_ctx.style)
  }, [
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ], 14, _hoisted_1$1s));
}
const ScrollArea = /* @__PURE__ */ _export_sfc(_sfc_main$1H, [["render", _sfc_render$1v], ["__scopeId", "data-v-b4e771c5"]]);
const _sfc_main$1G = defineComponent({
  name: "RvDialog",
  components: {
    QCard: QCard_default,
    QCardActions: QCardActions_default,
    QCardSection: QCardSection_default,
    QDialog: QDialog_default,
    QResizeObserver: QResizeObserver_default,
    RvButton: Button,
    ScrollArea
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "dialog"
    },
    /**
     * Render an empty q-dialog component
     */
    empty: {
      type: Boolean,
      default: false
    },
    /**
     * Show close dialog button on the top
     */
    hideCloseButton: {
      type: Boolean,
      default: false
    },
    /**
     * Dialog width
     */
    width: {
      type: String,
      default: "400px"
    }
  },
  emits: [
    ...useDialogPluginComponent.emits,
    "on-cancel"
  ],
  setup(props4) {
    const {
      dialogRef,
      onDialogHide
    } = useDialogPluginComponent();
    const contentRef = ref$1();
    const contentHeight = ref$1(0);
    const contentHeightStyle = computed(() => `${contentHeight.value}px`);
    function hide() {
      var _a;
      (_a = dialogRef.value) == null ? void 0 : _a.hide();
    }
    function onResize(dimensions) {
      contentHeight.value = dimensions.height;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      contentHeightStyle,
      contentRef,
      dialogRef,
      hide,
      onDialogHide,
      onResize
    };
  }
});
const _hoisted_1$1r = { ref: "contentRef" };
function _sfc_render$1u(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvButton = resolveComponent("RvButton");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  const _component_QCardActions = resolveComponent("QCardActions");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  return openBlock(), createBlock(_component_QDialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId()
  }, _ctx.$attrs, {
    style: {
      "--dialog-width": _ctx.width,
      "--dialog-content-height": _ctx.contentHeightStyle
    },
    onHide: _ctx.onDialogHide
  }), {
    default: withCtx(() => [
      _ctx.empty ? renderSlot(_ctx.$slots, "default", { key: 0 }, void 0, true) : (openBlock(), createBlock(_component_QCard, {
        key: 1,
        class: "rv-dialog column no-wrap"
      }, {
        default: withCtx(() => [
          !_ctx.hideCloseButton ? (openBlock(), createBlock(_component_QCardSection, {
            key: 0,
            class: "q-pb-none flex justify-end"
          }, {
            default: withCtx(() => [
              createVNode(_component_RvButton, {
                class: "no-padding",
                color: "black-1",
                "data-automation": _ctx.buildId("close"),
                icon: "mdi-close",
                tertiary: "",
                onClick: _ctx.hide
              }, null, 8, ["data-automation", "onClick"])
            ]),
            _: 1
          })) : createCommentVNode("", true),
          createVNode(_component_QCardSection, {
            class: "q-pt-none row justify-center items-center",
            "data-automation": _ctx.buildId("title")
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "title", {}, void 0, true)
            ]),
            _: 3
          }, 8, ["data-automation"]),
          createVNode(_component_QCardSection, {
            class: "rv-dialog__content q-px-md q-py-none",
            "data-automation": _ctx.buildId("content")
          }, {
            default: withCtx(() => [
              createVNode(_component_ScrollArea, {
                class: "full-height",
                "data-automation": _ctx.buildId("scroll")
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_1$1r, [
                    createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"]),
                    renderSlot(_ctx.$slots, "default", {}, void 0, true)
                  ], 512)
                ]),
                _: 3
              }, 8, ["data-automation"])
            ]),
            _: 3
          }, 8, ["data-automation"]),
          createVNode(_component_QCardActions, {
            class: "row q-pa-md flex justify-end",
            "data-automation": _ctx.buildId("actions")
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "actions", {}, void 0, true)
            ]),
            _: 3
          }, 8, ["data-automation"])
        ]),
        _: 3
      }))
    ]),
    _: 3
  }, 16, ["data-automation", "style", "onHide"]);
}
const RvDialog = /* @__PURE__ */ _export_sfc(_sfc_main$1G, [["render", _sfc_render$1u], ["__scopeId", "data-v-2ee0d6fc"]]);
function useSidebar() {
  const instance = getCurrentInstance();
  if (!instance) throw new Error("No component");
  const { emit } = instance;
  const {
    dialogRef,
    onDialogCancel,
    onDialogHide,
    onDialogOK
  } = useDialogPluginComponent();
  const saving = ref$1(false);
  function onError() {
    saving.value = false;
  }
  function onSave(data) {
    saving.value = true;
    emit("ok", {
      data,
      onDone: () => {
        if (dialogRef == null ? void 0 : dialogRef.value) onDialogCancel();
      },
      onError
    });
  }
  return {
    dialogRef,
    onCancel: onDialogCancel,
    onError,
    onHide: onDialogHide,
    onOK: onDialogOK,
    onSave,
    saving
  };
}
useSidebar.emits = useDialogPluginComponent.emits;
const _sfc_main$1F = defineComponent({
  name: "ConfirmDialog",
  components: {
    Checkbox,
    QIcon: QIcon_default,
    QSpace: QSpace_default,
    RvButton: Button,
    RvDialog
  },
  props: {
    /**
     * Text displayed on the confirmation button
     */
    actionLabel: {
      type: String,
      default: () => useI18n().t("rvai-base.general.actions.confirm")
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "confirmDialog"
    },
    /**
     * Display "Don't show again" checkbox
     */
    withDontShowAgain: {
      type: Boolean,
      default: false
    },
    /**
     * Text displayed on the cancel button
     */
    cancelLabel: {
      type: String,
      default: () => useI18n().t("rvai-base.general.actions.cancel")
    },
    /**
     * Main text
     */
    message: {
      type: String,
      required: true
    },
    /**
     * Text displayed in title
     */
    title: {
      type: String,
      default: () => useI18n().t("rvai-base.general.titles.sure")
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    const {
      dialogRef,
      onOK
    } = useSidebar();
    const dontShowAgain = ref$1(false);
    function ok(confirmed) {
      const payload = { confirmed };
      if (props4.withDontShowAgain) {
        payload.dontShowAgain = dontShowAgain.value;
      }
      onOK(payload);
    }
    function cancel() {
      ok(false);
    }
    function confirm() {
      ok(true);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      cancel,
      confirm,
      dialogRef,
      dontShowAgain,
      t: t2
    };
  }
});
const _hoisted_1$1q = ["data-automation"];
const _hoisted_2$19 = ["innerHTML"];
function _sfc_render$1t(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_RvButton = resolveComponent("RvButton");
  const _component_RvDialog = resolveComponent("RvDialog");
  return openBlock(), createBlock(_component_RvDialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId()
  }, toHandlers(_ctx.$attrs)), {
    title: withCtx(() => [
      createVNode(_component_QIcon, {
        color: "grey-2",
        "data-automation": _ctx.buildId("icon-error"),
        name: "error",
        size: "33px"
      }, null, 8, ["data-automation"]),
      createElementVNode("span", {
        class: "rv-confirm-dialog__title text-subtitle1 text-center q-ml-sm",
        "data-automation": _ctx.buildId("label")
      }, toDisplayString(_ctx.title), 9, _hoisted_1$1q)
    ]),
    default: withCtx(() => [
      createElementVNode("div", {
        innerHTML: _ctx.$sanitize(_ctx.message)
      }, null, 8, _hoisted_2$19),
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ]),
    actions: withCtx(() => [
      _ctx.withDontShowAgain ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createVNode(_component_Checkbox, {
          modelValue: _ctx.dontShowAgain,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.dontShowAgain = $event),
          "data-automation": _ctx.buildId("dontShowAgain"),
          label: _ctx.t("rvai-base.dialogs.confirmation.dontShowAgain")
        }, null, 8, ["modelValue", "data-automation", "label"]),
        createVNode(_component_QSpace)
      ], 64)) : createCommentVNode("", true),
      createVNode(_component_RvButton, {
        class: "rv-confirm-dialog__cancel-btn",
        "data-automation": _ctx.buildId("cancel"),
        label: _ctx.cancelLabel,
        secondary: "",
        size: "sm",
        onClick: _cache[1] || (_cache[1] = ($event) => _ctx.cancel())
      }, null, 8, ["data-automation", "label"]),
      createVNode(_component_RvButton, {
        class: "rv-confirm-dialog__confirm-btn",
        color: "primary",
        "data-automation": _ctx.buildId("confirm"),
        label: _ctx.actionLabel,
        size: "sm",
        onClick: _cache[2] || (_cache[2] = ($event) => _ctx.confirm())
      }, null, 8, ["data-automation", "label"])
    ]),
    _: 3
  }, 16, ["data-automation"]);
}
const ConfirmDialog = /* @__PURE__ */ _export_sfc(_sfc_main$1F, [["render", _sfc_render$1t], ["__scopeId", "data-v-7188dfda"]]);
function useConfirmDialog() {
  const $q = useQuasar();
  const dialog = ref$1(void 0);
  function onConfirm(params) {
    return new Promise((resolve) => {
      dialog.value = $q.dialog({
        component: ConfirmDialog,
        componentProps: params,
        persistent: params.persistent
      }).onOk(({
        confirmed,
        dontShowAgain
      }) => {
        if ("withDontShowAgain" in params && params.withDontShowAgain) {
          resolve({
            confirmed,
            dontShowAgain
          });
        } else {
          resolve(confirmed);
        }
      }).onCancel(() => {
        resolve(void 0);
      });
    });
  }
  return {
    dialog,
    onConfirm
  };
}
const COOKIES_POLICY = "cookiesPolicy";
const cookiesPolicy = ref$1(
  LocalStorage_default.getItem(COOKIES_POLICY) ?? null
);
function useCookiesPolicy() {
  const allowOptionalCookies = computed(() => cookiesPolicy.value === CookiesPolicy.All);
  const hasCookiesPolicy = computed(() => !!cookiesPolicy.value);
  function setCookiesPolicy(value2) {
    cookiesPolicy.value = value2;
    LocalStorage_default.set(COOKIES_POLICY, value2);
  }
  return {
    allowOptionalCookies,
    cookiesPolicy: readonly(cookiesPolicy),
    hasCookiesPolicy,
    setCookiesPolicy
  };
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a3 = function a4() {
      if (this instanceof a4) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a3.prototype = f.prototype;
  } else a3 = {};
  Object.defineProperty(a3, "__esModule", { value: true });
  Object.keys(n).forEach(function(k2) {
    var d3 = Object.getOwnPropertyDescriptor(n, k2);
    Object.defineProperty(a3, k2, d3.get ? d3 : {
      enumerable: true,
      get: function() {
        return n[k2];
      }
    });
  });
  return a3;
}
var type = TypeError;
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasMap = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace$1 = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat$1 = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O2) {
  return O2.__proto__;
} : null);
function addNumericSeparator(num, str) {
  if (num === Infinity || num === -Infinity || num !== num || num && num > -1e3 && num < 1e3 || $test.call(/e/, str)) {
    return str;
  }
  var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof num === "number") {
    var int = num < 0 ? -$floor(-num) : $floor(num);
    if (int !== num) {
      var intStr = String(int);
      var dec = $slice.call(str, intStr.length + 1);
      return $replace$1.call(intStr, sepRegex, "$&_") + "." + $replace$1.call($replace$1.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return $replace$1.call(str, sepRegex, "$&_");
}
var utilInspect = require$$0;
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
var quotes = {
  __proto__: null,
  "double": '"',
  single: "'"
};
var quoteREs = {
  __proto__: null,
  "double": /(["\\])/g,
  single: /(['\\])/g
};
var objectInspect = function inspect_(obj, options, depth, seen) {
  var opts = options || {};
  if (has$3(opts, "quoteStyle") && !has$3(quotes, opts.quoteStyle)) {
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  }
  if (has$3(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  }
  var customInspect = has$3(opts, "customInspect") ? opts.customInspect : true;
  if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  }
  if (has$3(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  }
  if (has$3(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") {
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  }
  var numericSeparator = opts.numericSeparator;
  if (typeof obj === "undefined") {
    return "undefined";
  }
  if (obj === null) {
    return "null";
  }
  if (typeof obj === "boolean") {
    return obj ? "true" : "false";
  }
  if (typeof obj === "string") {
    return inspectString(obj, opts);
  }
  if (typeof obj === "number") {
    if (obj === 0) {
      return Infinity / obj > 0 ? "0" : "-0";
    }
    var str = String(obj);
    return numericSeparator ? addNumericSeparator(obj, str) : str;
  }
  if (typeof obj === "bigint") {
    var bigIntStr = String(obj) + "n";
    return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
  }
  var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
  if (typeof depth === "undefined") {
    depth = 0;
  }
  if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") {
    return isArray$3(obj) ? "[Array]" : "[Object]";
  }
  var indent = getIndent(opts, depth);
  if (typeof seen === "undefined") {
    seen = [];
  } else if (indexOf(seen, obj) >= 0) {
    return "[Circular]";
  }
  function inspect2(value2, from, noIndent) {
    if (from) {
      seen = $arrSlice.call(seen);
      seen.push(from);
    }
    if (noIndent) {
      var newOpts = {
        depth: opts.depth
      };
      if (has$3(opts, "quoteStyle")) {
        newOpts.quoteStyle = opts.quoteStyle;
      }
      return inspect_(value2, newOpts, depth + 1, seen);
    }
    return inspect_(value2, opts, depth + 1, seen);
  }
  if (typeof obj === "function" && !isRegExp$1(obj)) {
    var name2 = nameOf(obj);
    var keys = arrObjKeys(obj, inspect2);
    return "[Function" + (name2 ? ": " + name2 : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $join.call(keys, ", ") + " }" : "");
  }
  if (isSymbol(obj)) {
    var symString = hasShammedSymbols ? $replace$1.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
    return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
  }
  if (isElement(obj)) {
    var s3 = "<" + $toLowerCase.call(String(obj.nodeName));
    var attrs = obj.attributes || [];
    for (var i2 = 0; i2 < attrs.length; i2++) {
      s3 += " " + attrs[i2].name + "=" + wrapQuotes(quote(attrs[i2].value), "double", opts);
    }
    s3 += ">";
    if (obj.childNodes && obj.childNodes.length) {
      s3 += "...";
    }
    s3 += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
    return s3;
  }
  if (isArray$3(obj)) {
    if (obj.length === 0) {
      return "[]";
    }
    var xs = arrObjKeys(obj, inspect2);
    if (indent && !singleLineValues(xs)) {
      return "[" + indentedJoin(xs, indent) + "]";
    }
    return "[ " + $join.call(xs, ", ") + " ]";
  }
  if (isError(obj)) {
    var parts = arrObjKeys(obj, inspect2);
    if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) {
      return "{ [" + String(obj) + "] " + $join.call($concat$1.call("[cause]: " + inspect2(obj.cause), parts), ", ") + " }";
    }
    if (parts.length === 0) {
      return "[" + String(obj) + "]";
    }
    return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
  }
  if (typeof obj === "object" && customInspect) {
    if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) {
      return utilInspect(obj, { depth: maxDepth - depth });
    } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
      return obj.inspect();
    }
  }
  if (isMap(obj)) {
    var mapParts = [];
    if (mapForEach) {
      mapForEach.call(obj, function(value2, key) {
        mapParts.push(inspect2(key, obj, true) + " => " + inspect2(value2, obj));
      });
    }
    return collectionOf("Map", mapSize.call(obj), mapParts, indent);
  }
  if (isSet(obj)) {
    var setParts = [];
    if (setForEach) {
      setForEach.call(obj, function(value2) {
        setParts.push(inspect2(value2, obj));
      });
    }
    return collectionOf("Set", setSize.call(obj), setParts, indent);
  }
  if (isWeakMap(obj)) {
    return weakCollectionOf("WeakMap");
  }
  if (isWeakSet(obj)) {
    return weakCollectionOf("WeakSet");
  }
  if (isWeakRef(obj)) {
    return weakCollectionOf("WeakRef");
  }
  if (isNumber(obj)) {
    return markBoxed(inspect2(Number(obj)));
  }
  if (isBigInt(obj)) {
    return markBoxed(inspect2(bigIntValueOf.call(obj)));
  }
  if (isBoolean(obj)) {
    return markBoxed(booleanValueOf.call(obj));
  }
  if (isString(obj)) {
    return markBoxed(inspect2(String(obj)));
  }
  if (typeof window !== "undefined" && obj === window) {
    return "{ [object Window] }";
  }
  if (typeof globalThis !== "undefined" && obj === globalThis || typeof commonjsGlobal !== "undefined" && obj === commonjsGlobal) {
    return "{ [object globalThis] }";
  }
  if (!isDate(obj) && !isRegExp$1(obj)) {
    var ys = arrObjKeys(obj, inspect2);
    var isPlainObject2 = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
    var protoTag = obj instanceof Object ? "" : "null prototype";
    var stringTag = !isPlainObject2 && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr$1(obj), 8, -1) : protoTag ? "Object" : "";
    var constructorTag = isPlainObject2 || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
    var tag = constructorTag + (stringTag || protoTag ? "[" + $join.call($concat$1.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
    if (ys.length === 0) {
      return tag + "{}";
    }
    if (indent) {
      return tag + "{" + indentedJoin(ys, indent) + "}";
    }
    return tag + "{ " + $join.call(ys, ", ") + " }";
  }
  return String(obj);
};
function wrapQuotes(s3, defaultStyle, opts) {
  var style = opts.quoteStyle || defaultStyle;
  var quoteChar = quotes[style];
  return quoteChar + s3 + quoteChar;
}
function quote(s3) {
  return $replace$1.call(String(s3), /"/g, "&quot;");
}
function canTrustToString(obj) {
  return !toStringTag || !(typeof obj === "object" && (toStringTag in obj || typeof obj[toStringTag] !== "undefined"));
}
function isArray$3(obj) {
  return toStr$1(obj) === "[object Array]" && canTrustToString(obj);
}
function isDate(obj) {
  return toStr$1(obj) === "[object Date]" && canTrustToString(obj);
}
function isRegExp$1(obj) {
  return toStr$1(obj) === "[object RegExp]" && canTrustToString(obj);
}
function isError(obj) {
  return toStr$1(obj) === "[object Error]" && canTrustToString(obj);
}
function isString(obj) {
  return toStr$1(obj) === "[object String]" && canTrustToString(obj);
}
function isNumber(obj) {
  return toStr$1(obj) === "[object Number]" && canTrustToString(obj);
}
function isBoolean(obj) {
  return toStr$1(obj) === "[object Boolean]" && canTrustToString(obj);
}
function isSymbol(obj) {
  if (hasShammedSymbols) {
    return obj && typeof obj === "object" && obj instanceof Symbol;
  }
  if (typeof obj === "symbol") {
    return true;
  }
  if (!obj || typeof obj !== "object" || !symToString) {
    return false;
  }
  try {
    symToString.call(obj);
    return true;
  } catch (e2) {
  }
  return false;
}
function isBigInt(obj) {
  if (!obj || typeof obj !== "object" || !bigIntValueOf) {
    return false;
  }
  try {
    bigIntValueOf.call(obj);
    return true;
  } catch (e2) {
  }
  return false;
}
var hasOwn$1 = Object.prototype.hasOwnProperty || function(key) {
  return key in this;
};
function has$3(obj, key) {
  return hasOwn$1.call(obj, key);
}
function toStr$1(obj) {
  return objectToString.call(obj);
}
function nameOf(f) {
  if (f.name) {
    return f.name;
  }
  var m3 = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
  if (m3) {
    return m3[1];
  }
  return null;
}
function indexOf(xs, x2) {
  if (xs.indexOf) {
    return xs.indexOf(x2);
  }
  for (var i2 = 0, l = xs.length; i2 < l; i2++) {
    if (xs[i2] === x2) {
      return i2;
    }
  }
  return -1;
}
function isMap(x2) {
  if (!mapSize || !x2 || typeof x2 !== "object") {
    return false;
  }
  try {
    mapSize.call(x2);
    try {
      setSize.call(x2);
    } catch (s3) {
      return true;
    }
    return x2 instanceof Map;
  } catch (e2) {
  }
  return false;
}
function isWeakMap(x2) {
  if (!weakMapHas || !x2 || typeof x2 !== "object") {
    return false;
  }
  try {
    weakMapHas.call(x2, weakMapHas);
    try {
      weakSetHas.call(x2, weakSetHas);
    } catch (s3) {
      return true;
    }
    return x2 instanceof WeakMap;
  } catch (e2) {
  }
  return false;
}
function isWeakRef(x2) {
  if (!weakRefDeref || !x2 || typeof x2 !== "object") {
    return false;
  }
  try {
    weakRefDeref.call(x2);
    return true;
  } catch (e2) {
  }
  return false;
}
function isSet(x2) {
  if (!setSize || !x2 || typeof x2 !== "object") {
    return false;
  }
  try {
    setSize.call(x2);
    try {
      mapSize.call(x2);
    } catch (m3) {
      return true;
    }
    return x2 instanceof Set;
  } catch (e2) {
  }
  return false;
}
function isWeakSet(x2) {
  if (!weakSetHas || !x2 || typeof x2 !== "object") {
    return false;
  }
  try {
    weakSetHas.call(x2, weakSetHas);
    try {
      weakMapHas.call(x2, weakMapHas);
    } catch (s3) {
      return true;
    }
    return x2 instanceof WeakSet;
  } catch (e2) {
  }
  return false;
}
function isElement(x2) {
  if (!x2 || typeof x2 !== "object") {
    return false;
  }
  if (typeof HTMLElement !== "undefined" && x2 instanceof HTMLElement) {
    return true;
  }
  return typeof x2.nodeName === "string" && typeof x2.getAttribute === "function";
}
function inspectString(str, opts) {
  if (str.length > opts.maxStringLength) {
    var remaining = str.length - opts.maxStringLength;
    var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
    return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
  }
  var quoteRE = quoteREs[opts.quoteStyle || "single"];
  quoteRE.lastIndex = 0;
  var s3 = $replace$1.call($replace$1.call(str, quoteRE, "\\$1"), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(s3, "single", opts);
}
function lowbyte(c2) {
  var n = c2.charCodeAt(0);
  var x2 = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[n];
  if (x2) {
    return "\\" + x2;
  }
  return "\\x" + (n < 16 ? "0" : "") + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
  return "Object(" + str + ")";
}
function weakCollectionOf(type2) {
  return type2 + " { ? }";
}
function collectionOf(type2, size2, entries, indent) {
  var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
  return type2 + " (" + size2 + ") {" + joinedEntries + "}";
}
function singleLineValues(xs) {
  for (var i2 = 0; i2 < xs.length; i2++) {
    if (indexOf(xs[i2], "\n") >= 0) {
      return false;
    }
  }
  return true;
}
function getIndent(opts, depth) {
  var baseIndent;
  if (opts.indent === "	") {
    baseIndent = "	";
  } else if (typeof opts.indent === "number" && opts.indent > 0) {
    baseIndent = $join.call(Array(opts.indent + 1), " ");
  } else {
    return null;
  }
  return {
    base: baseIndent,
    prev: $join.call(Array(depth + 1), baseIndent)
  };
}
function indentedJoin(xs, indent) {
  if (xs.length === 0) {
    return "";
  }
  var lineJoiner = "\n" + indent.prev + indent.base;
  return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys(obj, inspect2) {
  var isArr = isArray$3(obj);
  var xs = [];
  if (isArr) {
    xs.length = obj.length;
    for (var i2 = 0; i2 < obj.length; i2++) {
      xs[i2] = has$3(obj, i2) ? inspect2(obj[i2], obj) : "";
    }
  }
  var syms = typeof gOPS === "function" ? gOPS(obj) : [];
  var symMap2;
  if (hasShammedSymbols) {
    symMap2 = {};
    for (var k2 = 0; k2 < syms.length; k2++) {
      symMap2["$" + syms[k2]] = syms[k2];
    }
  }
  for (var key in obj) {
    if (!has$3(obj, key)) {
      continue;
    }
    if (isArr && String(Number(key)) === key && key < obj.length) {
      continue;
    }
    if (hasShammedSymbols && symMap2["$" + key] instanceof Symbol) {
      continue;
    } else if ($test.call(/[^\w$]/, key)) {
      xs.push(inspect2(key, obj) + ": " + inspect2(obj[key], obj));
    } else {
      xs.push(key + ": " + inspect2(obj[key], obj));
    }
  }
  if (typeof gOPS === "function") {
    for (var j = 0; j < syms.length; j++) {
      if (isEnumerable.call(obj, syms[j])) {
        xs.push("[" + inspect2(syms[j]) + "]: " + inspect2(obj[syms[j]], obj));
      }
    }
  }
  return xs;
}
var inspect$3 = objectInspect;
var $TypeError$5 = type;
var listGetNode = function(list, key, isDelete) {
  var prev = list;
  var curr;
  for (; (curr = prev.next) != null; prev = curr) {
    if (curr.key === key) {
      prev.next = curr.next;
      if (!isDelete) {
        curr.next = /** @type {NonNullable<typeof list.next>} */
        list.next;
        list.next = curr;
      }
      return curr;
    }
  }
};
var listGet = function(objects, key) {
  if (!objects) {
    return void 0;
  }
  var node = listGetNode(objects, key);
  return node && node.value;
};
var listSet = function(objects, key, value2) {
  var node = listGetNode(objects, key);
  if (node) {
    node.value = value2;
  } else {
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key,
      next: objects.next,
      value: value2
    };
  }
};
var listHas = function(objects, key) {
  if (!objects) {
    return false;
  }
  return !!listGetNode(objects, key);
};
var listDelete = function(objects, key) {
  if (objects) {
    return listGetNode(objects, key, true);
  }
};
var sideChannelList = function getSideChannelList() {
  var $o;
  var channel = {
    assert: function(key) {
      if (!channel.has(key)) {
        throw new $TypeError$5("Side channel does not contain " + inspect$3(key));
      }
    },
    "delete": function(key) {
      var root = $o && $o.next;
      var deletedNode = listDelete($o, key);
      if (deletedNode && root && root === deletedNode) {
        $o = void 0;
      }
      return !!deletedNode;
    },
    get: function(key) {
      return listGet($o, key);
    },
    has: function(key) {
      return listHas($o, key);
    },
    set: function(key, value2) {
      if (!$o) {
        $o = {
          next: void 0
        };
      }
      listSet(
        /** @type {NonNullable<typeof $o>} */
        $o,
        key,
        value2
      );
    }
  };
  return channel;
};
var esObjectAtoms = Object;
var esErrors = Error;
var _eval = EvalError;
var range = RangeError;
var ref = ReferenceError;
var syntax = SyntaxError;
var uri = URIError;
var abs$1 = Math.abs;
var floor$1 = Math.floor;
var max$2 = Math.max;
var min$1 = Math.min;
var pow$1 = Math.pow;
var round$1 = Math.round;
var _isNaN = Number.isNaN || function isNaN2(a3) {
  return a3 !== a3;
};
var $isNaN = _isNaN;
var sign$1 = function sign(number) {
  if ($isNaN(number) || number === 0) {
    return number;
  }
  return number < 0 ? -1 : 1;
};
var gOPD = Object.getOwnPropertyDescriptor;
var $gOPD$1 = gOPD;
if ($gOPD$1) {
  try {
    $gOPD$1([], "length");
  } catch (e2) {
    $gOPD$1 = null;
  }
}
var gopd = $gOPD$1;
var $defineProperty$1 = Object.defineProperty || false;
if ($defineProperty$1) {
  try {
    $defineProperty$1({}, "a", { value: 1 });
  } catch (e2) {
    $defineProperty$1 = false;
  }
}
var esDefineProperty = $defineProperty$1;
var shams;
var hasRequiredShams;
function requireShams() {
  if (hasRequiredShams) return shams;
  hasRequiredShams = 1;
  shams = function hasSymbols2() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
      return false;
    }
    if (typeof Symbol.iterator === "symbol") {
      return true;
    }
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") {
      return false;
    }
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
      return false;
    }
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
      return false;
    }
    var symVal = 42;
    obj[sym] = symVal;
    for (var _ in obj) {
      return false;
    }
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
      return false;
    }
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
      return false;
    }
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) {
      return false;
    }
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
      return false;
    }
    if (typeof Object.getOwnPropertyDescriptor === "function") {
      var descriptor = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(obj, sym)
      );
      if (descriptor.value !== symVal || descriptor.enumerable !== true) {
        return false;
      }
    }
    return true;
  };
  return shams;
}
var hasSymbols$1;
var hasRequiredHasSymbols;
function requireHasSymbols() {
  if (hasRequiredHasSymbols) return hasSymbols$1;
  hasRequiredHasSymbols = 1;
  var origSymbol = typeof Symbol !== "undefined" && Symbol;
  var hasSymbolSham = requireShams();
  hasSymbols$1 = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") {
      return false;
    }
    if (typeof Symbol !== "function") {
      return false;
    }
    if (typeof origSymbol("foo") !== "symbol") {
      return false;
    }
    if (typeof Symbol("bar") !== "symbol") {
      return false;
    }
    return hasSymbolSham();
  };
  return hasSymbols$1;
}
var Reflect_getPrototypeOf;
var hasRequiredReflect_getPrototypeOf;
function requireReflect_getPrototypeOf() {
  if (hasRequiredReflect_getPrototypeOf) return Reflect_getPrototypeOf;
  hasRequiredReflect_getPrototypeOf = 1;
  Reflect_getPrototypeOf = typeof Reflect !== "undefined" && Reflect.getPrototypeOf || null;
  return Reflect_getPrototypeOf;
}
var Object_getPrototypeOf;
var hasRequiredObject_getPrototypeOf;
function requireObject_getPrototypeOf() {
  if (hasRequiredObject_getPrototypeOf) return Object_getPrototypeOf;
  hasRequiredObject_getPrototypeOf = 1;
  var $Object2 = esObjectAtoms;
  Object_getPrototypeOf = $Object2.getPrototypeOf || null;
  return Object_getPrototypeOf;
}
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var toStr = Object.prototype.toString;
var max$1 = Math.max;
var funcType = "[object Function]";
var concatty = function concatty2(a3, b2) {
  var arr = [];
  for (var i2 = 0; i2 < a3.length; i2 += 1) {
    arr[i2] = a3[i2];
  }
  for (var j = 0; j < b2.length; j += 1) {
    arr[j + a3.length] = b2[j];
  }
  return arr;
};
var slicy = function slicy2(arrLike, offset2) {
  var arr = [];
  for (var i2 = offset2, j = 0; i2 < arrLike.length; i2 += 1, j += 1) {
    arr[j] = arrLike[i2];
  }
  return arr;
};
var joiny = function(arr, joiner) {
  var str = "";
  for (var i2 = 0; i2 < arr.length; i2 += 1) {
    str += arr[i2];
    if (i2 + 1 < arr.length) {
      str += joiner;
    }
  }
  return str;
};
var implementation$1 = function bind(that) {
  var target2 = this;
  if (typeof target2 !== "function" || toStr.apply(target2) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target2);
  }
  var args = slicy(arguments, 1);
  var bound;
  var binder = function() {
    if (this instanceof bound) {
      var result = target2.apply(
        this,
        concatty(args, arguments)
      );
      if (Object(result) === result) {
        return result;
      }
      return this;
    }
    return target2.apply(
      that,
      concatty(args, arguments)
    );
  };
  var boundLength = max$1(0, target2.length - args.length);
  var boundArgs = [];
  for (var i2 = 0; i2 < boundLength; i2++) {
    boundArgs[i2] = "$" + i2;
  }
  bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
  if (target2.prototype) {
    var Empty = function Empty2() {
    };
    Empty.prototype = target2.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound;
};
var implementation = implementation$1;
var functionBind = Function.prototype.bind || implementation;
var functionCall = Function.prototype.call;
var functionApply;
var hasRequiredFunctionApply;
function requireFunctionApply() {
  if (hasRequiredFunctionApply) return functionApply;
  hasRequiredFunctionApply = 1;
  functionApply = Function.prototype.apply;
  return functionApply;
}
var reflectApply = typeof Reflect !== "undefined" && Reflect && Reflect.apply;
var bind$2 = functionBind;
var $apply$1 = requireFunctionApply();
var $call$2 = functionCall;
var $reflectApply = reflectApply;
var actualApply = $reflectApply || bind$2.call($call$2, $apply$1);
var bind$1 = functionBind;
var $TypeError$4 = type;
var $call$1 = functionCall;
var $actualApply = actualApply;
var callBindApplyHelpers = function callBindBasic(args) {
  if (args.length < 1 || typeof args[0] !== "function") {
    throw new $TypeError$4("a function is required");
  }
  return $actualApply(bind$1, $call$1, args);
};
var get;
var hasRequiredGet;
function requireGet() {
  if (hasRequiredGet) return get;
  hasRequiredGet = 1;
  var callBind = callBindApplyHelpers;
  var gOPD2 = gopd;
  var hasProtoAccessor;
  try {
    hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (e2) {
    if (!e2 || typeof e2 !== "object" || !("code" in e2) || e2.code !== "ERR_PROTO_ACCESS") {
      throw e2;
    }
  }
  var desc = !!hasProtoAccessor && gOPD2 && gOPD2(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  );
  var $Object2 = Object;
  var $getPrototypeOf = $Object2.getPrototypeOf;
  get = desc && typeof desc.get === "function" ? callBind([desc.get]) : typeof $getPrototypeOf === "function" ? (
    /** @type {import('./get')} */
    function getDunder(value2) {
      return $getPrototypeOf(value2 == null ? value2 : $Object2(value2));
    }
  ) : false;
  return get;
}
var getProto$1;
var hasRequiredGetProto;
function requireGetProto() {
  if (hasRequiredGetProto) return getProto$1;
  hasRequiredGetProto = 1;
  var reflectGetProto = requireReflect_getPrototypeOf();
  var originalGetProto = requireObject_getPrototypeOf();
  var getDunderProto = requireGet();
  getProto$1 = reflectGetProto ? function getProto2(O2) {
    return reflectGetProto(O2);
  } : originalGetProto ? function getProto2(O2) {
    if (!O2 || typeof O2 !== "object" && typeof O2 !== "function") {
      throw new TypeError("getProto: not an object");
    }
    return originalGetProto(O2);
  } : getDunderProto ? function getProto2(O2) {
    return getDunderProto(O2);
  } : null;
  return getProto$1;
}
var hasown;
var hasRequiredHasown;
function requireHasown() {
  if (hasRequiredHasown) return hasown;
  hasRequiredHasown = 1;
  var call = Function.prototype.call;
  var $hasOwn = Object.prototype.hasOwnProperty;
  var bind3 = functionBind;
  hasown = bind3.call(call, $hasOwn);
  return hasown;
}
var undefined$1;
var $Object = esObjectAtoms;
var $Error = esErrors;
var $EvalError = _eval;
var $RangeError = range;
var $ReferenceError = ref;
var $SyntaxError = syntax;
var $TypeError$3 = type;
var $URIError = uri;
var abs = abs$1;
var floor = floor$1;
var max = max$2;
var min = min$1;
var pow = pow$1;
var round = round$1;
var sign2 = sign$1;
var $Function = Function;
var getEvalledConstructor = function(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
  } catch (e2) {
  }
};
var $gOPD = gopd;
var $defineProperty = esDefineProperty;
var throwTypeError = function() {
  throw new $TypeError$3();
};
var ThrowTypeError = $gOPD ? function() {
  try {
    arguments.callee;
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      return $gOPD(arguments, "callee").get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols = requireHasSymbols()();
var getProto = requireGetProto();
var $ObjectGPO = requireObject_getPrototypeOf();
var $ReflectGPO = requireReflect_getPrototypeOf();
var $apply = requireFunctionApply();
var $call = functionCall;
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined$1 : getProto(Uint8Array);
var INTRINSICS = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": $Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": $EvalError,
  "%Float16Array%": typeof Float16Array === "undefined" ? undefined$1 : Float16Array,
  "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
  "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": $Object,
  "%Object.getOwnPropertyDescriptor%": $gOPD,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
  "%RangeError%": $RangeError,
  "%ReferenceError%": $ReferenceError,
  "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$3,
  "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
  "%URIError%": $URIError,
  "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet,
  "%Function.prototype.call%": $call,
  "%Function.prototype.apply%": $apply,
  "%Object.defineProperty%": $defineProperty,
  "%Object.getPrototypeOf%": $ObjectGPO,
  "%Math.abs%": abs,
  "%Math.floor%": floor,
  "%Math.max%": max,
  "%Math.min%": min,
  "%Math.pow%": pow,
  "%Math.round%": round,
  "%Math.sign%": sign2,
  "%Reflect.getPrototypeOf%": $ReflectGPO
};
if (getProto) {
  try {
    null.error;
  } catch (e2) {
    var errorProto = getProto(getProto(e2));
    INTRINSICS["%Error.prototype%"] = errorProto;
  }
}
var doEval = function doEval2(name2) {
  var value2;
  if (name2 === "%AsyncFunction%") {
    value2 = getEvalledConstructor("async function () {}");
  } else if (name2 === "%GeneratorFunction%") {
    value2 = getEvalledConstructor("function* () {}");
  } else if (name2 === "%AsyncGeneratorFunction%") {
    value2 = getEvalledConstructor("async function* () {}");
  } else if (name2 === "%AsyncGenerator%") {
    var fn = doEval2("%AsyncGeneratorFunction%");
    if (fn) {
      value2 = fn.prototype;
    }
  } else if (name2 === "%AsyncIteratorPrototype%") {
    var gen = doEval2("%AsyncGenerator%");
    if (gen && getProto) {
      value2 = getProto(gen.prototype);
    }
  }
  INTRINSICS[name2] = value2;
  return value2;
};
var LEGACY_ALIASES = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
};
var bind2 = functionBind;
var hasOwn = requireHasown();
var $concat = bind2.call($call, Array.prototype.concat);
var $spliceApply = bind2.call($apply, Array.prototype.splice);
var $replace = bind2.call($call, String.prototype.replace);
var $strSlice = bind2.call($call, String.prototype.slice);
var $exec = bind2.call($call, RegExp.prototype.exec);
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = function stringToPath2(string) {
  var first = $strSlice(string, 0, 1);
  var last2 = $strSlice(string, -1);
  if (first === "%" && last2 !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
  } else if (last2 === "%" && first !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
  }
  var result = [];
  $replace(string, rePropName, function(match2, number, quote2, subString) {
    result[result.length] = quote2 ? $replace(subString, reEscapeChar, "$1") : number || match2;
  });
  return result;
};
var getBaseIntrinsic = function getBaseIntrinsic2(name2, allowMissing) {
  var intrinsicName = name2;
  var alias;
  if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = "%" + alias[0] + "%";
  }
  if (hasOwn(INTRINSICS, intrinsicName)) {
    var value2 = INTRINSICS[intrinsicName];
    if (value2 === needsEval) {
      value2 = doEval(intrinsicName);
    }
    if (typeof value2 === "undefined" && !allowMissing) {
      throw new $TypeError$3("intrinsic " + name2 + " exists, but is not available. Please file an issue!");
    }
    return {
      alias,
      name: intrinsicName,
      value: value2
    };
  }
  throw new $SyntaxError("intrinsic " + name2 + " does not exist!");
};
var getIntrinsic = function GetIntrinsic(name2, allowMissing) {
  if (typeof name2 !== "string" || name2.length === 0) {
    throw new $TypeError$3("intrinsic name must be a non-empty string");
  }
  if (arguments.length > 1 && typeof allowMissing !== "boolean") {
    throw new $TypeError$3('"allowMissing" argument must be a boolean');
  }
  if ($exec(/^%?[^%]*%?$/, name2) === null) {
    throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  }
  var parts = stringToPath(name2);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
  var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value2 = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat([0, 1], alias));
  }
  for (var i2 = 1, isOwn = true; i2 < parts.length; i2 += 1) {
    var part = parts[i2];
    var first = $strSlice(part, 0, 1);
    var last2 = $strSlice(part, -1);
    if ((first === '"' || first === "'" || first === "`" || (last2 === '"' || last2 === "'" || last2 === "`")) && first !== last2) {
      throw new $SyntaxError("property names with quotes must have matching quotes");
    }
    if (part === "constructor" || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += "." + part;
    intrinsicRealName = "%" + intrinsicBaseName + "%";
    if (hasOwn(INTRINSICS, intrinsicRealName)) {
      value2 = INTRINSICS[intrinsicRealName];
    } else if (value2 != null) {
      if (!(part in value2)) {
        if (!allowMissing) {
          throw new $TypeError$3("base intrinsic for " + name2 + " exists, but the property is not available.");
        }
        return void 0;
      }
      if ($gOPD && i2 + 1 >= parts.length) {
        var desc = $gOPD(value2, part);
        isOwn = !!desc;
        if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
          value2 = desc.get;
        } else {
          value2 = value2[part];
        }
      } else {
        isOwn = hasOwn(value2, part);
        value2 = value2[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value2;
      }
    }
  }
  return value2;
};
var GetIntrinsic$2 = getIntrinsic;
var callBindBasic2 = callBindApplyHelpers;
var $indexOf = callBindBasic2([GetIntrinsic$2("%String.prototype.indexOf%")]);
var callBound$2 = function callBoundIntrinsic(name2, allowMissing) {
  var intrinsic = (
    /** @type {(this: unknown, ...args: unknown[]) => unknown} */
    GetIntrinsic$2(name2, !!allowMissing)
  );
  if (typeof intrinsic === "function" && $indexOf(name2, ".prototype.") > -1) {
    return callBindBasic2(
      /** @type {const} */
      [intrinsic]
    );
  }
  return intrinsic;
};
var GetIntrinsic$1 = getIntrinsic;
var callBound$1 = callBound$2;
var inspect$2 = objectInspect;
var $TypeError$2 = type;
var $Map = GetIntrinsic$1("%Map%", true);
var $mapGet = callBound$1("Map.prototype.get", true);
var $mapSet = callBound$1("Map.prototype.set", true);
var $mapHas = callBound$1("Map.prototype.has", true);
var $mapDelete = callBound$1("Map.prototype.delete", true);
var $mapSize = callBound$1("Map.prototype.size", true);
var sideChannelMap = !!$Map && /** @type {Exclude<import('.'), false>} */
function getSideChannelMap() {
  var $m;
  var channel = {
    assert: function(key) {
      if (!channel.has(key)) {
        throw new $TypeError$2("Side channel does not contain " + inspect$2(key));
      }
    },
    "delete": function(key) {
      if ($m) {
        var result = $mapDelete($m, key);
        if ($mapSize($m) === 0) {
          $m = void 0;
        }
        return result;
      }
      return false;
    },
    get: function(key) {
      if ($m) {
        return $mapGet($m, key);
      }
    },
    has: function(key) {
      if ($m) {
        return $mapHas($m, key);
      }
      return false;
    },
    set: function(key, value2) {
      if (!$m) {
        $m = new $Map();
      }
      $mapSet($m, key, value2);
    }
  };
  return channel;
};
var GetIntrinsic2 = getIntrinsic;
var callBound = callBound$2;
var inspect$1 = objectInspect;
var getSideChannelMap$1 = sideChannelMap;
var $TypeError$1 = type;
var $WeakMap = GetIntrinsic2("%WeakMap%", true);
var $weakMapGet = callBound("WeakMap.prototype.get", true);
var $weakMapSet = callBound("WeakMap.prototype.set", true);
var $weakMapHas = callBound("WeakMap.prototype.has", true);
var $weakMapDelete = callBound("WeakMap.prototype.delete", true);
var sideChannelWeakmap = $WeakMap ? (
  /** @type {Exclude<import('.'), false>} */
  function getSideChannelWeakMap() {
    var $wm;
    var $m;
    var channel = {
      assert: function(key) {
        if (!channel.has(key)) {
          throw new $TypeError$1("Side channel does not contain " + inspect$1(key));
        }
      },
      "delete": function(key) {
        if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
          if ($wm) {
            return $weakMapDelete($wm, key);
          }
        } else if (getSideChannelMap$1) {
          if ($m) {
            return $m["delete"](key);
          }
        }
        return false;
      },
      get: function(key) {
        if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
          if ($wm) {
            return $weakMapGet($wm, key);
          }
        }
        return $m && $m.get(key);
      },
      has: function(key) {
        if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
          if ($wm) {
            return $weakMapHas($wm, key);
          }
        }
        return !!$m && $m.has(key);
      },
      set: function(key, value2) {
        if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
          if (!$wm) {
            $wm = new $WeakMap();
          }
          $weakMapSet($wm, key, value2);
        } else if (getSideChannelMap$1) {
          if (!$m) {
            $m = getSideChannelMap$1();
          }
          $m.set(key, value2);
        }
      }
    };
    return channel;
  }
) : getSideChannelMap$1;
var $TypeError = type;
var inspect = objectInspect;
var getSideChannelList2 = sideChannelList;
var getSideChannelMap2 = sideChannelMap;
var getSideChannelWeakMap2 = sideChannelWeakmap;
var makeChannel = getSideChannelWeakMap2 || getSideChannelMap2 || getSideChannelList2;
var sideChannel = function getSideChannel() {
  var $channelData;
  var channel = {
    assert: function(key) {
      if (!channel.has(key)) {
        throw new $TypeError("Side channel does not contain " + inspect(key));
      }
    },
    "delete": function(key) {
      return !!$channelData && $channelData["delete"](key);
    },
    get: function(key) {
      return $channelData && $channelData.get(key);
    },
    has: function(key) {
      return !!$channelData && $channelData.has(key);
    },
    set: function(key, value2) {
      if (!$channelData) {
        $channelData = makeChannel();
      }
      $channelData.set(key, value2);
    }
  };
  return channel;
};
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
};
var formats$3 = {
  "default": Format.RFC3986,
  formatters: {
    RFC1738: function(value2) {
      return replace.call(value2, percentTwenties, "+");
    },
    RFC3986: function(value2) {
      return String(value2);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
};
var formats$2 = formats$3;
var getSideChannel$1 = sideChannel;
var has$2 = Object.prototype.hasOwnProperty;
var isArray$2 = Array.isArray;
var overflowChannel = getSideChannel$1();
var markOverflow = function markOverflow2(obj, maxIndex) {
  overflowChannel.set(obj, maxIndex);
  return obj;
};
var isOverflow = function isOverflow2(obj) {
  return overflowChannel.has(obj);
};
var getMaxIndex = function getMaxIndex2(obj) {
  return overflowChannel.get(obj);
};
var setMaxIndex = function setMaxIndex2(obj, maxIndex) {
  overflowChannel.set(obj, maxIndex);
};
var hexTable = function() {
  var array = [];
  for (var i2 = 0; i2 < 256; ++i2) {
    array.push("%" + ((i2 < 16 ? "0" : "") + i2.toString(16)).toUpperCase());
  }
  return array;
}();
var compactQueue = function compactQueue2(queue2) {
  while (queue2.length > 1) {
    var item = queue2.pop();
    var obj = item.obj[item.prop];
    if (isArray$2(obj)) {
      var compacted = [];
      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== "undefined") {
          compacted.push(obj[j]);
        }
      }
      item.obj[item.prop] = compacted;
    }
  }
};
var arrayToObject = function arrayToObject2(source, options) {
  var obj = options && options.plainObjects ? { __proto__: null } : {};
  for (var i2 = 0; i2 < source.length; ++i2) {
    if (typeof source[i2] !== "undefined") {
      obj[i2] = source[i2];
    }
  }
  return obj;
};
var merge = function merge2(target2, source, options) {
  if (!source) {
    return target2;
  }
  if (typeof source !== "object" && typeof source !== "function") {
    if (isArray$2(target2)) {
      target2.push(source);
    } else if (target2 && typeof target2 === "object") {
      if (isOverflow(target2)) {
        var newIndex = getMaxIndex(target2) + 1;
        target2[newIndex] = source;
        setMaxIndex(target2, newIndex);
      } else if (options && (options.plainObjects || options.allowPrototypes) || !has$2.call(Object.prototype, source)) {
        target2[source] = true;
      }
    } else {
      return [target2, source];
    }
    return target2;
  }
  if (!target2 || typeof target2 !== "object") {
    if (isOverflow(source)) {
      var sourceKeys = Object.keys(source);
      var result = options && options.plainObjects ? { __proto__: null, 0: target2 } : { 0: target2 };
      for (var m3 = 0; m3 < sourceKeys.length; m3++) {
        var oldKey = parseInt(sourceKeys[m3], 10);
        result[oldKey + 1] = source[sourceKeys[m3]];
      }
      return markOverflow(result, getMaxIndex(source) + 1);
    }
    return [target2].concat(source);
  }
  var mergeTarget = target2;
  if (isArray$2(target2) && !isArray$2(source)) {
    mergeTarget = arrayToObject(target2, options);
  }
  if (isArray$2(target2) && isArray$2(source)) {
    source.forEach(function(item, i2) {
      if (has$2.call(target2, i2)) {
        var targetItem = target2[i2];
        if (targetItem && typeof targetItem === "object" && item && typeof item === "object") {
          target2[i2] = merge2(targetItem, item, options);
        } else {
          target2.push(item);
        }
      } else {
        target2[i2] = item;
      }
    });
    return target2;
  }
  return Object.keys(source).reduce(function(acc, key) {
    var value2 = source[key];
    if (has$2.call(acc, key)) {
      acc[key] = merge2(acc[key], value2, options);
    } else {
      acc[key] = value2;
    }
    return acc;
  }, mergeTarget);
};
var assign = function assignSingleSource(target2, source) {
  return Object.keys(source).reduce(function(acc, key) {
    acc[key] = source[key];
    return acc;
  }, target2);
};
var decode = function(str, defaultDecoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, " ");
  if (charset === "iso-8859-1") {
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  }
  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e2) {
    return strWithoutPlus;
  }
};
var limit = 1024;
var encode = function encode3(str, defaultEncoder, charset, kind, format2) {
  if (str.length === 0) {
    return str;
  }
  var string = str;
  if (typeof str === "symbol") {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== "string") {
    string = String(str);
  }
  if (charset === "iso-8859-1") {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
      return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
  }
  var out = "";
  for (var j = 0; j < string.length; j += limit) {
    var segment = string.length >= limit ? string.slice(j, j + limit) : string;
    var arr = [];
    for (var i2 = 0; i2 < segment.length; ++i2) {
      var c2 = segment.charCodeAt(i2);
      if (c2 === 45 || c2 === 46 || c2 === 95 || c2 === 126 || c2 >= 48 && c2 <= 57 || c2 >= 65 && c2 <= 90 || c2 >= 97 && c2 <= 122 || format2 === formats$2.RFC1738 && (c2 === 40 || c2 === 41)) {
        arr[arr.length] = segment.charAt(i2);
        continue;
      }
      if (c2 < 128) {
        arr[arr.length] = hexTable[c2];
        continue;
      }
      if (c2 < 2048) {
        arr[arr.length] = hexTable[192 | c2 >> 6] + hexTable[128 | c2 & 63];
        continue;
      }
      if (c2 < 55296 || c2 >= 57344) {
        arr[arr.length] = hexTable[224 | c2 >> 12] + hexTable[128 | c2 >> 6 & 63] + hexTable[128 | c2 & 63];
        continue;
      }
      i2 += 1;
      c2 = 65536 + ((c2 & 1023) << 10 | segment.charCodeAt(i2) & 1023);
      arr[arr.length] = hexTable[240 | c2 >> 18] + hexTable[128 | c2 >> 12 & 63] + hexTable[128 | c2 >> 6 & 63] + hexTable[128 | c2 & 63];
    }
    out += arr.join("");
  }
  return out;
};
var compact = function compact2(value2) {
  var queue2 = [{ obj: { o: value2 }, prop: "o" }];
  var refs = [];
  for (var i2 = 0; i2 < queue2.length; ++i2) {
    var item = queue2[i2];
    var obj = item.obj[item.prop];
    var keys = Object.keys(obj);
    for (var j = 0; j < keys.length; ++j) {
      var key = keys[j];
      var val = obj[key];
      if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
        queue2.push({ obj, prop: key });
        refs.push(val);
      }
    }
  }
  compactQueue(queue2);
  return value2;
};
var isRegExp = function isRegExp2(obj) {
  return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var isBuffer = function isBuffer2(obj) {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine = function combine2(a3, b2, arrayLimit, plainObjects) {
  if (isOverflow(a3)) {
    var newIndex = getMaxIndex(a3) + 1;
    a3[newIndex] = b2;
    setMaxIndex(a3, newIndex);
    return a3;
  }
  var result = [].concat(a3, b2);
  if (result.length > arrayLimit) {
    return markOverflow(arrayToObject(result, { plainObjects }), result.length - 1);
  }
  return result;
};
var maybeMap = function maybeMap2(val, fn) {
  if (isArray$2(val)) {
    var mapped = [];
    for (var i2 = 0; i2 < val.length; i2 += 1) {
      mapped.push(fn(val[i2]));
    }
    return mapped;
  }
  return fn(val);
};
var utils$2 = {
  arrayToObject,
  assign,
  combine,
  compact,
  decode,
  encode,
  isBuffer,
  isOverflow,
  isRegExp,
  maybeMap,
  merge
};
var getSideChannel2 = sideChannel;
var utils$1 = utils$2;
var formats$1 = formats$3;
var has$1 = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    return prefix + "[]";
  },
  comma: "comma",
  indices: function indices(prefix, key) {
    return prefix + "[" + key + "]";
  },
  repeat: function repeat(prefix) {
    return prefix;
  }
};
var isArray$1 = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function(arr, valueOrArray) {
  push.apply(arr, isArray$1(valueOrArray) ? valueOrArray : [valueOrArray]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats$1["default"];
var defaults$1 = {
  addQueryPrefix: false,
  allowDots: false,
  allowEmptyArrays: false,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: false,
  commaRoundTrip: false,
  delimiter: "&",
  encode: true,
  encodeDotInKeys: false,
  encoder: utils$1.encode,
  encodeValuesOnly: false,
  filter: void 0,
  format: defaultFormat,
  formatter: formats$1.formatters[defaultFormat],
  // deprecated
  indices: false,
  serializeDate: function serializeDate(date) {
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};
var isNonNullishPrimitive = function isNonNullishPrimitive2(v) {
  return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var sentinel = {};
var stringify$1 = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate2, format2, formatter2, encodeValuesOnly, charset, sideChannel2) {
  var obj = object;
  var tmpSc = sideChannel2;
  var step = 0;
  var findFlag = false;
  while ((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag) {
    var pos = tmpSc.get(object);
    step += 1;
    if (typeof pos !== "undefined") {
      if (pos === step) {
        throw new RangeError("Cyclic object value");
      } else {
        findFlag = true;
      }
    }
    if (typeof tmpSc.get(sentinel) === "undefined") {
      step = 0;
    }
  }
  if (typeof filter === "function") {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate2(obj);
  } else if (generateArrayPrefix === "comma" && isArray$1(obj)) {
    obj = utils$1.maybeMap(obj, function(value3) {
      if (value3 instanceof Date) {
        return serializeDate2(value3);
      }
      return value3;
    });
  }
  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset, "key", format2) : prefix;
    }
    obj = "";
  }
  if (isNonNullishPrimitive(obj) || utils$1.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset, "key", format2);
      return [formatter2(keyValue) + "=" + formatter2(encoder(obj, defaults$1.encoder, charset, "value", format2))];
    }
    return [formatter2(prefix) + "=" + formatter2(String(obj))];
  }
  var values = [];
  if (typeof obj === "undefined") {
    return values;
  }
  var objKeys;
  if (generateArrayPrefix === "comma" && isArray$1(obj)) {
    if (encodeValuesOnly && encoder) {
      obj = utils$1.maybeMap(obj, encoder);
    }
    objKeys = [{ value: obj.length > 0 ? obj.join(",") || null : void 0 }];
  } else if (isArray$1(filter)) {
    objKeys = filter;
  } else {
    var keys = Object.keys(obj);
    objKeys = sort ? keys.sort(sort) : keys;
  }
  var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, "%2E") : String(prefix);
  var adjustedPrefix = commaRoundTrip && isArray$1(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
  if (allowEmptyArrays && isArray$1(obj) && obj.length === 0) {
    return adjustedPrefix + "[]";
  }
  for (var j = 0; j < objKeys.length; ++j) {
    var key = objKeys[j];
    var value2 = typeof key === "object" && key && typeof key.value !== "undefined" ? key.value : obj[key];
    if (skipNulls && value2 === null) {
      continue;
    }
    var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, "%2E") : String(key);
    var keyPrefix = isArray$1(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
    sideChannel2.set(object, step);
    var valueSideChannel = getSideChannel2();
    valueSideChannel.set(sentinel, sideChannel2);
    pushToArray(values, stringify(
      value2,
      keyPrefix,
      generateArrayPrefix,
      commaRoundTrip,
      allowEmptyArrays,
      strictNullHandling,
      skipNulls,
      encodeDotInKeys,
      generateArrayPrefix === "comma" && encodeValuesOnly && isArray$1(obj) ? null : encoder,
      filter,
      sort,
      allowDots,
      serializeDate2,
      format2,
      formatter2,
      encodeValuesOnly,
      charset,
      valueSideChannel
    ));
  }
  return values;
};
var normalizeStringifyOptions = function normalizeStringifyOptions2(opts) {
  if (!opts) {
    return defaults$1;
  }
  if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") {
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  }
  if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") {
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  }
  if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") {
    throw new TypeError("Encoder has to be a function.");
  }
  var charset = opts.charset || defaults$1.charset;
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  var format2 = formats$1["default"];
  if (typeof opts.format !== "undefined") {
    if (!has$1.call(formats$1.formatters, opts.format)) {
      throw new TypeError("Unknown format option provided.");
    }
    format2 = opts.format;
  }
  var formatter2 = formats$1.formatters[format2];
  var filter = defaults$1.filter;
  if (typeof opts.filter === "function" || isArray$1(opts.filter)) {
    filter = opts.filter;
  }
  var arrayFormat;
  if (opts.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = opts.arrayFormat;
  } else if ("indices" in opts) {
    arrayFormat = opts.indices ? "indices" : "repeat";
  } else {
    arrayFormat = defaults$1.arrayFormat;
  }
  if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") {
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  }
  var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : defaults$1.allowDots : !!opts.allowDots;
  return {
    addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults$1.addQueryPrefix,
    allowDots,
    allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : defaults$1.allowEmptyArrays,
    arrayFormat,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults$1.charsetSentinel,
    commaRoundTrip: !!opts.commaRoundTrip,
    delimiter: typeof opts.delimiter === "undefined" ? defaults$1.delimiter : opts.delimiter,
    encode: typeof opts.encode === "boolean" ? opts.encode : defaults$1.encode,
    encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : defaults$1.encodeDotInKeys,
    encoder: typeof opts.encoder === "function" ? opts.encoder : defaults$1.encoder,
    encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults$1.encodeValuesOnly,
    filter,
    format: format2,
    formatter: formatter2,
    serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults$1.serializeDate,
    skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults$1.skipNulls,
    sort: typeof opts.sort === "function" ? opts.sort : null,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults$1.strictNullHandling
  };
};
var stringify_1 = function(object, opts) {
  var obj = object;
  var options = normalizeStringifyOptions(opts);
  var objKeys;
  var filter;
  if (typeof options.filter === "function") {
    filter = options.filter;
    obj = filter("", obj);
  } else if (isArray$1(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }
  var keys = [];
  if (typeof obj !== "object" || obj === null) {
    return "";
  }
  var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
  var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
  if (!objKeys) {
    objKeys = Object.keys(obj);
  }
  if (options.sort) {
    objKeys.sort(options.sort);
  }
  var sideChannel2 = getSideChannel2();
  for (var i2 = 0; i2 < objKeys.length; ++i2) {
    var key = objKeys[i2];
    var value2 = obj[key];
    if (options.skipNulls && value2 === null) {
      continue;
    }
    pushToArray(keys, stringify$1(
      value2,
      key,
      generateArrayPrefix,
      commaRoundTrip,
      options.allowEmptyArrays,
      options.strictNullHandling,
      options.skipNulls,
      options.encodeDotInKeys,
      options.encode ? options.encoder : null,
      options.filter,
      options.sort,
      options.allowDots,
      options.serializeDate,
      options.format,
      options.formatter,
      options.encodeValuesOnly,
      options.charset,
      sideChannel2
    ));
  }
  var joined = keys.join(options.delimiter);
  var prefix = options.addQueryPrefix === true ? "?" : "";
  if (options.charsetSentinel) {
    if (options.charset === "iso-8859-1") {
      prefix += "utf8=%26%2310003%3B&";
    } else {
      prefix += "utf8=%E2%9C%93&";
    }
  }
  return joined.length > 0 ? prefix + joined : "";
};
var utils = utils$2;
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var defaults = {
  allowDots: false,
  allowEmptyArrays: false,
  allowPrototypes: false,
  allowSparse: false,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: false,
  comma: false,
  decodeDotInKeys: false,
  decoder: utils.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1e3,
  parseArrays: true,
  plainObjects: false,
  strictDepth: false,
  strictNullHandling: false,
  throwOnLimitExceeded: false
};
var interpretNumericEntities = function(str) {
  return str.replace(/&#(\d+);/g, function($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
};
var parseArrayValue = function(val, options, currentArrayLength) {
  if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) {
    return val.split(",");
  }
  if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
    throw new RangeError("Array limit exceeded. Only " + options.arrayLimit + " element" + (options.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
  }
  return val;
};
var isoSentinel = "utf8=%26%2310003%3B";
var charsetSentinel = "utf8=%E2%9C%93";
var parseValues = function parseQueryStringValues(str, options) {
  var obj = { __proto__: null };
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
  cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  var limit2 = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
  var parts = cleanStr.split(
    options.delimiter,
    options.throwOnLimitExceeded ? limit2 + 1 : limit2
  );
  if (options.throwOnLimitExceeded && parts.length > limit2) {
    throw new RangeError("Parameter limit exceeded. Only " + limit2 + " parameter" + (limit2 === 1 ? "" : "s") + " allowed.");
  }
  var skipIndex = -1;
  var i2;
  var charset = options.charset;
  if (options.charsetSentinel) {
    for (i2 = 0; i2 < parts.length; ++i2) {
      if (parts[i2].indexOf("utf8=") === 0) {
        if (parts[i2] === charsetSentinel) {
          charset = "utf-8";
        } else if (parts[i2] === isoSentinel) {
          charset = "iso-8859-1";
        }
        skipIndex = i2;
        i2 = parts.length;
      }
    }
  }
  for (i2 = 0; i2 < parts.length; ++i2) {
    if (i2 === skipIndex) {
      continue;
    }
    var part = parts[i2];
    var bracketEqualsPos = part.indexOf("]=");
    var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
    var key;
    var val;
    if (pos === -1) {
      key = options.decoder(part, defaults.decoder, charset, "key");
      val = options.strictNullHandling ? null : "";
    } else {
      key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
      if (key !== null) {
        val = utils.maybeMap(
          parseArrayValue(
            part.slice(pos + 1),
            options,
            isArray(obj[key]) ? obj[key].length : 0
          ),
          function(encodedVal) {
            return options.decoder(encodedVal, defaults.decoder, charset, "value");
          }
        );
      }
    }
    if (val && options.interpretNumericEntities && charset === "iso-8859-1") {
      val = interpretNumericEntities(String(val));
    }
    if (part.indexOf("[]=") > -1) {
      val = isArray(val) ? [val] : val;
    }
    if (key !== null) {
      var existing = has.call(obj, key);
      if (existing && options.duplicates === "combine") {
        obj[key] = utils.combine(
          obj[key],
          val,
          options.arrayLimit,
          options.plainObjects
        );
      } else if (!existing || options.duplicates === "last") {
        obj[key] = val;
      }
    }
  }
  return obj;
};
var parseObject = function(chain, val, options, valuesParsed) {
  var currentArrayLength = 0;
  if (chain.length > 0 && chain[chain.length - 1] === "[]") {
    var parentKey = chain.slice(0, -1).join("");
    currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
  }
  var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);
  for (var i2 = chain.length - 1; i2 >= 0; --i2) {
    var obj;
    var root = chain[i2];
    if (root === "[]" && options.parseArrays) {
      if (utils.isOverflow(leaf)) {
        obj = leaf;
      } else {
        obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : utils.combine(
          [],
          leaf,
          options.arrayLimit,
          options.plainObjects
        );
      }
    } else {
      obj = options.plainObjects ? { __proto__: null } : {};
      var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
      var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
      var index = parseInt(decodedRoot, 10);
      if (!options.parseArrays && decodedRoot === "") {
        obj = { 0: leaf };
      } else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && (options.parseArrays && index <= options.arrayLimit)) {
        obj = [];
        obj[index] = leaf;
      } else if (decodedRoot !== "__proto__") {
        obj[decodedRoot] = leaf;
      }
    }
    leaf = obj;
  }
  return leaf;
};
var splitKeyIntoSegments = function splitKeyIntoSegments2(givenKey, options) {
  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
  if (options.depth <= 0) {
    if (!options.plainObjects && has.call(Object.prototype, key)) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    return [key];
  }
  var brackets2 = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g;
  var segment = brackets2.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key;
  var keys = [];
  if (parent) {
    if (!options.plainObjects && has.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys.push(parent);
  }
  var i2 = 0;
  while ((segment = child.exec(key)) !== null && i2 < options.depth) {
    i2 += 1;
    var segmentContent = segment[1].slice(1, -1);
    if (!options.plainObjects && has.call(Object.prototype, segmentContent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys.push(segment[1]);
  }
  if (segment) {
    if (options.strictDepth === true) {
      throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
    }
    keys.push("[" + key.slice(segment.index) + "]");
  }
  return keys;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
  if (!givenKey) {
    return;
  }
  var keys = splitKeyIntoSegments(givenKey, options);
  if (!keys) {
    return;
  }
  return parseObject(keys, val, options, valuesParsed);
};
var normalizeParseOptions = function normalizeParseOptions2(opts) {
  if (!opts) {
    return defaults;
  }
  if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") {
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  }
  if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") {
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  }
  if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") {
    throw new TypeError("Decoder has to be a function.");
  }
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  if (typeof opts.throwOnLimitExceeded !== "undefined" && typeof opts.throwOnLimitExceeded !== "boolean") {
    throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
  }
  var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
  var duplicates = typeof opts.duplicates === "undefined" ? defaults.duplicates : opts.duplicates;
  if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") {
    throw new TypeError("The duplicates option must be either combine, first, or last");
  }
  var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
  return {
    allowDots,
    allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
    allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
    allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
    arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
    comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
    decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
    decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
    delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
    duplicates,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
    strictDepth: typeof opts.strictDepth === "boolean" ? !!opts.strictDepth : defaults.strictDepth,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling,
    throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === "boolean" ? opts.throwOnLimitExceeded : false
  };
};
var parse$1 = function(str, opts) {
  var options = normalizeParseOptions(opts);
  if (str === "" || str === null || typeof str === "undefined") {
    return options.plainObjects ? { __proto__: null } : {};
  }
  var tempObj = typeof str === "string" ? parseValues(str, options) : str;
  var obj = options.plainObjects ? { __proto__: null } : {};
  var keys = Object.keys(tempObj);
  for (var i2 = 0; i2 < keys.length; ++i2) {
    var key = keys[i2];
    var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
    obj = utils.merge(obj, newObj, options);
  }
  if (options.allowSparse === true) {
    return obj;
  }
  return utils.compact(obj);
};
var stringify2 = stringify_1;
var parse = parse$1;
var formats = formats$3;
var lib = {
  formats,
  parse,
  stringify: stringify2
};
const qs = /* @__PURE__ */ getDefaultExportFromCjs(lib);
function useQueryParams() {
  const route = useRoute();
  const router = useRouter();
  const queryParams = computed(() => route.query);
  function parseQuery(v, options) {
    return qs.parse(v, {
      arrayLimit: 100,
      ...options
    });
  }
  function setQuery(v) {
    const newQueries = { ...queryParams.value };
    Object.entries(v).forEach(([key, value2]) => {
      if (value2 == null || value2 === "") {
        delete newQueries[key];
      } else {
        newQueries[key] = stringifyQuery(value2);
      }
    });
    void router.replace({
      query: newQueries
    });
  }
  function stringifyQuery(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" ? v.toString() : qs.stringify(v, { encode: false });
  }
  return {
    parseQuery,
    queryParams,
    setQuery,
    stringifyQuery
  };
}
const FieldsVisibility = Symbol("Fields visibility dependency");
const HIDDEN_FIELDS_QUERY = "hiddenFields";
function buildFieldsVisibility(config) {
  const $q = useQuasar();
  const {
    parseQuery,
    queryParams,
    setQuery
  } = useQueryParams();
  const hiddenFields = computed(() => {
    return Object.values(
      parseQuery(queryParams.value[HIDDEN_FIELDS_QUERY] ?? "")
    );
  });
  const fields = ref$1(buildObject(
    config,
    (v) => v.key,
    (v) => FieldVisibility.fromQueryParams(v, hiddenFields.value)
  ));
  function isVisible(section, key) {
    const sectionField = fields.value[section];
    if (!sectionField) return false;
    return key ? sectionField.isFieldVisible(key) : sectionField.visible;
  }
  function onOpenFieldsDialog() {
    $q.dialog({
      component: FieldsVisibilityDialog,
      componentProps: {
        fields: fields.value
      }
    }).onOk((data) => {
      fields.value = data;
      setQuery({
        [HIDDEN_FIELDS_QUERY]: flatten(Object.values(data).map((v) => v.serialize()))
      });
    });
  }
  function setFields(data) {
    fields.value = buildObject(
      data,
      (v) => v.key,
      (v) => FieldVisibility.fromQueryParams(v, hiddenFields.value)
    );
  }
  return {
    fields,
    isVisible,
    onOpenFieldsDialog,
    setFields
  };
}
function provideFieldsVisibility(config) {
  const composable = buildFieldsVisibility(config);
  provide(FieldsVisibility, composable);
  return composable;
}
function useFieldsVisibility() {
  const composable = inject(FieldsVisibility, void 0);
  if (!composable) {
    throw new Error(
      "Fields visibility was not registered. Make sure you used 'provideFieldsVisibility'"
    );
  }
  return composable;
}
const _sfc_main$1E = defineComponent({
  name: "InfoDialog",
  components: {
    QIcon: QIcon_default,
    RvButton: Button,
    RvDialog
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "infoDialog"
    },
    /**
     * Text displayed on the confirmation button
     */
    actionLabel: {
      type: String,
      default: () => useI18n().t("rvai-base.general.actions.ok")
    },
    /**
     * Flag to hide close button
     */
    hasCloseButton: {
      type: Boolean,
      default: true
    },
    /**
     * Main text
     */
    message: {
      type: String,
      required: true
    },
    /**
    * Text displayed in title
    */
    title: {
      type: String,
      default: void 0
    }
  },
  setup(props4) {
    const {
      dialogRef,
      onOK
    } = useSidebar();
    function confirm() {
      onOK(true);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      confirm,
      dialogRef
    };
  }
});
const _hoisted_1$1p = ["data-automation"];
const _hoisted_2$18 = ["innerHTML"];
function _sfc_render$1s(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_RvButton = resolveComponent("RvButton");
  const _component_RvDialog = resolveComponent("RvDialog");
  return openBlock(), createBlock(_component_RvDialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId(),
    "hide-close-button": !_ctx.hasCloseButton
  }, toHandlers(_ctx.$attrs)), createSlots({
    default: withCtx(() => [
      createElementVNode("div", {
        class: normalizeClass(["row no-wrap items-start q-pb-none", _ctx.title ? "justify-start" : "justify-center"])
      }, [
        !_ctx.title ? (openBlock(), createBlock(_component_QIcon, {
          key: 0,
          color: "grey-2",
          "data-automation": _ctx.buildId("icon-error"),
          name: "error",
          size: "32px"
        }, null, 8, ["data-automation"])) : createCommentVNode("", true),
        createElementVNode("div", {
          class: "rv-info-dialog__context flex items-center q-ml-sm",
          innerHTML: _ctx.$sanitize(_ctx.message)
        }, null, 8, _hoisted_2$18)
      ], 2)
    ]),
    actions: withCtx(() => [
      createVNode(_component_RvButton, {
        color: "primary",
        "data-automation": _ctx.buildId("confirm"),
        label: _ctx.actionLabel,
        size: "sm",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.confirm())
      }, null, 8, ["data-automation", "label"])
    ]),
    _: 2
  }, [
    _ctx.title ? {
      name: "title",
      fn: withCtx(() => [
        createVNode(_component_QIcon, {
          color: "grey-2",
          "data-automation": _ctx.buildId("icon-error"),
          name: "error",
          size: "33px"
        }, null, 8, ["data-automation"]),
        createElementVNode("span", {
          class: "rv-info-dialog__title text-subtitle1 text-center q-ml-sm",
          "data-automation": _ctx.buildId("title")
        }, toDisplayString(_ctx.title), 9, _hoisted_1$1p)
      ]),
      key: "0"
    } : void 0
  ]), 1040, ["data-automation", "hide-close-button"]);
}
const InfoDialog = /* @__PURE__ */ _export_sfc(_sfc_main$1E, [["render", _sfc_render$1s], ["__scopeId", "data-v-39e37d2f"]]);
function useInfoDialog() {
  const $q = useQuasar();
  function onConfirm(params) {
    return new Promise((resolve) => {
      $q.dialog({
        component: InfoDialog,
        componentProps: params,
        persistent: params.persistent
      }).onOk((confirmed) => {
        resolve(confirmed);
      });
    });
  }
  return {
    onConfirm
  };
}
const LS_LAYOUT = "LS_LAYOUT";
function buildLayoutStore(allowOptionalCookies, defaultLayout = Layout.Default) {
  const { navigation } = useOptionsReadOnly();
  const route = useRoute();
  const loaded = LocalStorage_default.getItem(LS_LAYOUT) || {};
  const availableLayouts = ref$1([]);
  const collapsedNavigationbar = ref$1(loaded.collapsedNavigationbar ?? false);
  const collapsedNavigationbarAfterAnimation = ref$1(loaded.collapsedNavigationbar ?? false);
  const hasRightContent = ref$1(true);
  const layout = ref$1(loaded.layout ?? defaultLayout);
  const savedLayouts = ref$1(/* @__PURE__ */ new Map());
  const showOverlay = ref$1(false);
  const smallScreen = ref$1(false);
  const isSidebarAnimationInprogress = ref$1(false);
  const isDefaultLayout = computed(() => layout.value === Layout.Default);
  const isFullLayout = computed(() => layout.value === Layout.Full);
  const isLeftOnlyLayout = computed(() => layout.value === Layout.LeftOnly);
  const isRightOnlyLayout = computed(() => layout.value === Layout.RightOnly);
  const isSplitLayout = computed(() => layout.value === Layout.Split);
  const showLeftSidebar = computed(() => {
    return isDefaultLayout.value || isLeftOnlyLayout.value || isSplitLayout.value;
  });
  const showRightSidebar = computed(() => {
    return isDefaultLayout.value || isRightOnlyLayout.value || isSplitLayout.value;
  });
  function ensureRightVisible() {
    switch (layout.value) {
      case Layout.Full:
        return setLayout(Layout.RightOnly);
      case Layout.Split:
        return setLayout(Layout.Split);
      case Layout.LeftOnly:
        return setLayout(Layout.Default);
    }
  }
  function saveLayout() {
    if (!allowOptionalCookies.value) return;
    const saved = {
      collapsedNavigationbar: collapsedNavigationbar.value ?? false,
      layout: layout.value ?? defaultLayout
    };
    LocalStorage_default.set(LS_LAYOUT, saved);
  }
  function setHasRightContent(value2) {
    hasRightContent.value = value2;
    if (!value2 && layout.value !== Layout.LeftOnly) {
      setLayout(Layout.LeftOnly);
    }
  }
  function setAvailableLayouts(layouts2) {
    availableLayouts.value = layouts2;
    if (!layouts2.includes(layout.value)) {
      setLayout(layouts2[0]);
    }
  }
  function setLayout(value2) {
    if (!hasRightContent.value && value2 !== Layout.LeftOnly) return;
    layout.value = value2;
    saveLayout();
  }
  function setSmallScreen(value2) {
    smallScreen.value = value2;
  }
  function toggleNavigationBar(value2) {
    collapsedNavigationbar.value = value2 == null ? !collapsedNavigationbar.value : value2;
    saveLayout();
  }
  function toggleShowOverlay(value2) {
    showOverlay.value = value2 == null ? !showOverlay.value : value2;
  }
  function watchRoute(defaultLayouts) {
    watch(
      () => route.name,
      () => {
        const metaLayouts = isLayoutRouteMeta(route.meta) && route.meta.allowedLayouts;
        const layouts2 = metaLayouts || defaultLayouts;
        hasRightContent.value = true;
        setAvailableLayouts(layouts2);
        if (!navigation.saveLayoutOnRouteChange) return;
        const routeName = typeof route.name === "string" ? route.name : window.location.pathname;
        const savedLayout = savedLayouts.value.get(routeName);
        if (savedLayout) setLayout(savedLayout);
      },
      { immediate: true }
    );
  }
  function toggleRightSidebar() {
    switch (layout.value) {
      case Layout.Default:
        return setLayout(Layout.LeftOnly);
      case Layout.LeftOnly:
        return setLayout(Layout.Default);
      case Layout.RightOnly:
        return setLayout(Layout.Full);
      case Layout.Full:
        return setLayout(Layout.RightOnly);
    }
  }
  watch(collapsedNavigationbar, async (collapsed) => {
    isSidebarAnimationInprogress.value = true;
    if (navigation.delayOnSidebarToggle) {
      await wait(navigation.delayOnSidebarToggle);
      collapsedNavigationbarAfterAnimation.value = collapsed;
    } else {
      collapsedNavigationbarAfterAnimation.value = collapsed;
    }
    isSidebarAnimationInprogress.value = false;
  });
  watch(layout, (value2) => {
    if (!navigation.saveLayoutOnRouteChange) return;
    const routeName = typeof route.name === "string" ? route.name : window.location.pathname;
    savedLayouts.value.set(routeName, value2);
  });
  return {
    availableLayouts,
    collapsedNavigationbar,
    collapsedNavigationbarAfterAnimation,
    ensureRightVisible,
    hasRightContent,
    isDefaultLayout,
    isFullLayout,
    isLeftOnlyLayout,
    isRightOnlyLayout,
    isSidebarAnimationInprogress,
    isSplitLayout,
    layout,
    setAvailableLayouts,
    setHasRightContent,
    setLayout,
    setSmallScreen,
    showLeftSidebar,
    showOverlay,
    showRightSidebar,
    smallScreen,
    toggleNavigationBar,
    toggleRightSidebar,
    toggleShowOverlay,
    watchRoute
  };
}
const LayoutStore = "LayoutStore dependency";
function provideLayoutStore({
  defaultLayout = Layout.Default,
  persistent = ref$1(true)
} = {}) {
  const composable = buildLayoutStore(persistent, defaultLayout);
  provide(LayoutStore, composable);
  return composable;
}
function useLayout() {
  return inject(LayoutStore);
}
function useLogo() {
  const { navigation } = useOptionsReadOnly();
  const logoMain = computed(() => {
    var _a;
    return ((_a = navigation.logoOptions) == null ? void 0 : _a.main) ?? "/rvai-base/logos.svg#main";
  });
  const logoRegular = computed(() => {
    var _a;
    return ((_a = navigation.logoOptions) == null ? void 0 : _a.regular) ?? "/rvai-base/logos.svg#regular";
  });
  const customLogoSrc = computed(() => {
    var _a;
    return (_a = navigation.logoOptions) == null ? void 0 : _a.customLogoSrc;
  });
  const logoAlignClasses = computed(() => {
    var _a;
    const align = ((_a = navigation.logoOptions) == null ? void 0 : _a.align) ?? "center";
    return `flex justify-${align}`;
  });
  return {
    customLogoSrc,
    logoAlignClasses,
    logoMain,
    logoRegular
  };
}
const initialState = () => ({
  backClicked: false,
  previousRoutes: []
});
const state = reactive(initialState());
function useNavigationHistory(defaultRoute, directRoute) {
  const { t: t2 } = useI18n();
  const {
    navigation: {
      backButtonLabels = {},
      homeRoute
    }
  } = useOptionsReadOnly();
  const router = useRouter();
  const labels = {
    ...backButtonLabels,
    ..."default" in backButtonLabels ? {} : {
      get default() {
        return t2("rvai-base.general.backBtn.default");
      }
    }
  };
  const fallbackRoute = defaultRoute ?? homeRoute ?? "/";
  const previousRoute = computed(() => {
    const lastFrom = state.previousRoutes[state.previousRoutes.length - 1];
    return lastFrom ?? fallbackRoute;
  });
  function getLabel(route) {
    const defaultKey = "default";
    const key = typeof route === "string" ? route : "name" in route ? route.name : void 0;
    return labels[key ?? defaultKey] ?? labels[defaultKey];
  }
  function getPreviousPageLabel() {
    if (directRoute) return getLabel(directRoute);
    const lastFrom = state.previousRoutes[state.previousRoutes.length - 1];
    if (!(lastFrom == null ? void 0 : lastFrom.name)) {
      return getLabel(fallbackRoute);
    } else {
      return getLabel(lastFrom);
    }
  }
  function goToRoute(route) {
    void router.push(typeof route === "string" ? { name: route } : route);
  }
  function goToPreviousPage() {
    state.backClicked = true;
    if (directRoute) {
      goToRoute(directRoute);
      return;
    }
    const lastFrom = state.previousRoutes.pop();
    if (!lastFrom) {
      goToRoute(fallbackRoute);
    } else {
      goToRoute(lastFrom);
    }
  }
  return {
    getPreviousPageLabel,
    goToPreviousPage,
    previousRoute
  };
}
const navigationHistoryGuard = (to, from) => {
  if (to.name !== from.name) {
    const initialRoute = !from.name && from.path === "/";
    if (!state.backClicked && !(isHistoryRouteMeta(from.meta) && from.meta.track === false) && !initialRoute) {
      state.previousRoutes = [...state.previousRoutes, from];
    }
    state.backClicked = false;
  }
};
const PAGE_SIZE = 50;
function buildPaginationComposable(params) {
  const { t: t2 } = useI18n();
  const { onConfirm } = useInfoDialog();
  const currentPage = ref$1((params == null ? void 0 : params.initialCurrentPage) ?? 1);
  const newPage = ref$1("");
  const pageSize = ref$1((params == null ? void 0 : params.initialPageSize) ?? PAGE_SIZE);
  const totalCount = ref$1(0);
  const canNavigate = computed(() => {
    return pageCount.value > 1;
  });
  const pageValue = computed(() => {
    const page = currentPage.value;
    return String(page);
  });
  const hasNextPage = computed(() => {
    return currentPage.value < pageCount.value;
  });
  const hasPreviousPage = computed(() => {
    return currentPage.value > 1;
  });
  const pageCount = computed(() => {
    return Math.ceil((totalCount.value || 1) / pageSize.value);
  });
  function goToFirstPage() {
    currentPage.value = 1;
  }
  function goToLastPage() {
    currentPage.value = pageCount.value;
  }
  function goToNextPage() {
    goToPage(currentPage.value + 1);
  }
  function goToPage(pageRaw) {
    if (pageRaw === "") return false;
    const newPage2 = Number(pageRaw);
    if (isNaN(newPage2) || newPage2 < 1 || newPage2 > pageCount.value) {
      return false;
    }
    currentPage.value = newPage2;
    return true;
  }
  function goToPreviousPage() {
    goToPage(currentPage.value - 1);
  }
  async function onBlur2() {
    if (newPage.value === "") return;
    const page = newPage.value;
    newPage.value = "";
    const navigated = goToPage(page);
    if (!navigated) {
      await onConfirm({
        actionLabel: t2("rvai-base.general.actions.ok"),
        dataAutomation: "noPageDialog",
        hasCloseButton: false,
        message: t2("rvai-base.components.pagination.noPage", {
          max: pageCount.value,
          min: 1,
          page
        }),
        persistent: true
      });
    }
  }
  function setPageSize(value2) {
    pageSize.value = value2;
  }
  function setTotalCount(value2) {
    totalCount.value = value2;
    if (currentPage.value > pageCount.value) {
      goToFirstPage();
    }
  }
  return {
    canNavigate,
    currentPage: readonly(currentPage),
    goToFirstPage,
    goToLastPage,
    goToNextPage,
    goToPage,
    goToPreviousPage,
    hasNextPage,
    hasPreviousPage,
    newPage,
    onBlur: onBlur2,
    pageCount,
    pageSize: readonly(pageSize),
    pageValue,
    setPageSize,
    setTotalCount,
    totalCount: readonly(totalCount)
  };
}
const Pagination$1 = "Pagination dependency";
function providePagination(params) {
  const composable = buildPaginationComposable(params);
  provide(Pagination$1, composable);
  return composable;
}
function usePagination() {
  const paginationComposable = inject(Pagination$1);
  if (!paginationComposable) {
    throw new Error('The pagination was not registered. Make sure you used "providePagination".');
  }
  return paginationComposable;
}
const { getPaletteColor } = colors_default;
const colorCache = /* @__PURE__ */ new Map();
function usePaletteColorsCache() {
  const { isDark } = useDarkMode();
  function getPaletteColorCache(color) {
    let cachedColor = colorCache.get(color);
    if (!cachedColor) {
      cachedColor = getPaletteColor(color);
      colorCache.set(color, cachedColor);
    }
    return cachedColor;
  }
  watch(isDark, () => {
    colorCache.clear();
  });
  return {
    getPaletteColorCache
  };
}
const PANEL_DEFAULT_SIZE = 324;
const PANEL_MAX_SIZE = 768;
const SPLIT_VIEW_MIN_SCREEN_WIDTH = 1439;
function useRightPanelSize(params) {
  const {
    minScreenWidth = SPLIT_VIEW_MIN_SCREEN_WIDTH,
    panelDefaulSize = PANEL_DEFAULT_SIZE,
    panelGap = 0,
    panelMaxSize = PANEL_MAX_SIZE
  } = params ?? {};
  const {
    isSplitLayout,
    layout
  } = useLayout();
  const rightPanelWidth = ref$1(panelDefaulSize);
  function setRightPanelWidth(screenWidth) {
    const panelWidth = isSplitLayout.value && screenWidth > minScreenWidth ? Math.round(Math.min(screenWidth * 0.4 + panelGap, panelMaxSize + panelGap)) : panelDefaulSize;
    rightPanelWidth.value = panelWidth;
  }
  watch(layout, () => {
    setRightPanelWidth(window.innerWidth);
  });
  return {
    rightPanelWidth,
    setRightPanelWidth
  };
}
function useScrollNavigation(config) {
  let ticking = false;
  const currentPosition = ref$1();
  const navigation = computed(() => {
    const pos = currentPosition.value;
    if (pos) {
      return config.value.map((n) => ({
        ...n,
        active: n.to === pos.to
      }));
    } else {
      return config.value;
    }
  });
  const navigationTops = computed(() => navigation.value.map((n) => {
    const el = document.getElementById(n.to);
    const top = (el == null ? void 0 : el.offsetTop) ?? 0;
    return {
      to: n.to,
      top
    };
  }));
  function handleScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        currentPosition.value = navigationTops.value.filter((n) => n.top >= Math.floor(window.scrollY))[0];
        ticking = false;
      });
      ticking = true;
    }
  }
  function scrollTo(value2) {
    const el = document.getElementById(value2);
    const top = (el == null ? void 0 : el.offsetTop) ?? 0;
    currentPosition.value = navigationTops.value.find((v) => v.top === top);
    window.scrollTo({
      behavior: "smooth",
      top
    });
  }
  onMounted(async () => {
    window.addEventListener("scroll", handleScroll);
  });
  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
  });
  return {
    navigation,
    scrollTo
  };
}
function useSidebarHelpers() {
  const $q = useQuasar();
  function openSidebar(options) {
    return $q.dialog(options);
  }
  return {
    openSidebar
  };
}
function buildStepSidebarComposable() {
  const stack2 = shallowRef([]);
  const currentStep = computed(() => {
    return stack2.value.length ? stack2.value[stack2.value.length - 1] : null;
  });
  const isDefaultStep = computed(() => {
    return !stack2.value.length;
  });
  const showBackButton = computed(() => {
    return !isDefaultStep.value;
  });
  function isCurrentStep(step) {
    return currentStep.value === step;
  }
  function onBack() {
    void nextTick(() => {
      stack2.value = stack2.value.slice(0, -1);
    });
  }
  function onReset() {
    void nextTick(() => {
      stack2.value = [];
    });
  }
  function pushStep(step) {
    stack2.value = [...stack2.value, step];
  }
  return {
    currentStep,
    isCurrentStep,
    isDefaultStep,
    onBack,
    onReset,
    pushStep,
    showBackButton,
    stack: stack2
  };
}
const UseStepSidebarSymbol = "UseStepSidebar";
function provideStepSidebar() {
  const composable = buildStepSidebarComposable();
  provide(UseStepSidebarSymbol, composable);
  return composable;
}
function useStepSidebar() {
  const composable = inject(UseStepSidebarSymbol);
  if (!composable) {
    throw new Error("Could not inject `UseStepSidebarComposable`. Did you forget `provideStepSidebar`?");
  }
  return composable;
}
function getFilterValue(row, col) {
  const {
    field,
    filterableField
  } = col;
  if (!filterableField) return void 0;
  const computedField = filterableField === true ? field : filterableField;
  if (!computedField) return void 0;
  const value2 = typeof computedField === "function" ? computedField(row) : row[computedField];
  return value2;
}
function isFilterable$1(col) {
  return !!col.filterableField && !!col.filterType && col.filterType !== TableFilterType.FreeText;
}
function isSearchable$1(col) {
  return !!col.filterableField;
}
function matchesFilterValue(filter, value2) {
  switch (filter.type) {
    case TableFilterType.Date: {
      const dt = value2 instanceof Date ? value2 : parseISO(value2);
      if (!isValid(dt)) return false;
      const [, endHours] = filter.value.end.split(" ");
      const [, startHours] = filter.value.start.split(" ");
      const endDate = endHours ? filter.value.end : `${filter.value.end} 23:59:59`;
      const startDate = startHours ? filter.value.start : `${filter.value.start} 00:00:00`;
      if (filter.value.start && !filter.value.end) {
        return isAfter(dt, new Date(startDate));
      } else if (filter.value.end && !filter.value.start) {
        return isBefore(dt, new Date(endDate));
      } else {
        return isWithinInterval(dt, {
          end: new Date(endDate),
          start: new Date(startDate)
        });
      }
    }
    case TableFilterType.Number:
      if (typeof value2 !== "number") return false;
      if (filter.min != null && filter.min > value2) return false;
      if (filter.max != null && filter.max < value2) return false;
      return true;
    case TableFilterType.List:
      return filter.value.includes(value2);
    case TableFilterType.Single:
      return filter.value === value2;
  }
}
function matchesSearchValue(needle, value2) {
  if (typeof value2 !== "string" && typeof value2 !== "number") return false;
  return value2.toString().toLocaleLowerCase().includes(needle);
}
function useClientTableFiltering(columns, rows) {
  const options = useOptionsReadOnly();
  const queryParamsFilters = computed(() => options.tables.queryParamsFilters);
  const filterableColumns = computed(() => columns.value.filter(isFilterable$1));
  const searchableColumns = computed(() => columns.value.filter(isSearchable$1));
  const {
    parseQuery,
    queryParams,
    setQuery
  } = useQueryParams();
  const {
    filters: queryFilters,
    search: querySearch
  } = queryParams.value;
  const filters = reactive({
    search: queryParamsFilters.value ? querySearch : void 0,
    values: queryParamsFilters.value && queryFilters ? parseQuery(queryFilters.replaceAll("+", "%2B")) : {}
  });
  const filterOptions = computed(() => {
    return buildObject(
      filterableColumns.value,
      (col) => col.name,
      (col) => buildFilterOption(col, toValue(rows))
    );
  });
  const filterOptionsOpenedByDefault = ref$1([]);
  const hasFilters = computed(() => !isEmptyPlainObject(filters.values));
  const hasSearchQueryFilter = computed(() => !!filters.search);
  const hasFilterableValues = computed(() => !isEmptyPlainObject(visibleFilterOptions.value));
  const search = computed({
    get() {
      return filters.search;
    },
    set(value2) {
      filters.search = value2;
    }
  });
  const searchable = computed(() => !!searchableColumns.value.length);
  const visibleColumns = computed(() => {
    return columns.value.map((c2) => c2.name);
  });
  const visibleFilterOptions = computed(() => filterObject(
    filterOptions.value,
    (option, key) => visibleColumns.value.includes(key) && (key in filters.values || option.hasOptions)
  ));
  function buildFilterOption(col, rows2) {
    if (!col.filterType) throw new Error("Cannot build filter config for unknown type");
    switch (col.filterType) {
      case TableFilterType.Date: {
        const values = rows2.map((row) => {
          return getFilterValue(row, col);
        }).filter(Boolean);
        return {
          beforeOptions: col.filterBeforeOptions,
          hasOptions: values.length > 1,
          key: col.name,
          label: col.filterName,
          options: [],
          type: TableFilterType.Date
        };
      }
      case TableFilterType.Number: {
        const values = rows2.map((row) => {
          const value2 = getFilterValue(row, col);
          return Array.isArray(value2) ? value2 : [value2];
        });
        const numberValues = flatten(values).filter((x2) => x2 != null);
        const min2 = Math.min(...numberValues);
        const max2 = Math.max(...numberValues);
        return {
          hasOptions: min2 !== max2 && min2 !== Infinity,
          key: col.name,
          label: col.filterName,
          max: max2,
          min: min2,
          step: col.filterStep,
          type: TableFilterType.Number
        };
      }
      case TableFilterType.List:
      case TableFilterType.Single: {
        const values = rows2.map((row) => {
          const value2 = getFilterValue(row, col);
          return Array.isArray(value2) ? value2 : [value2];
        });
        const grouped = flatten(values).filter(Boolean).reduce(
          (acc, curr) => {
            if (curr) acc[curr] = (acc[curr] || 0) + 1;
            return acc;
          },
          {}
        );
        const options2 = Object.entries(grouped).map(([value2, count]) => ({
          count,
          label: value2 || "",
          value: value2
        })).sort((a3, b2) => col.filterOptionsSorting === SortOrders.Desc ? naturalSort(b2.label, a3.label) : naturalSort(a3.label, b2.label));
        return {
          hasOptions: options2.length > 1,
          key: col.name,
          label: col.filterName,
          options: options2,
          type: col.filterType
        };
      }
      default:
        throw new Error(`Cannot build filter config for type ${col.filterType}`);
    }
  }
  function getFilteredRows(skipColumn) {
    let result = [...toValue(rows)];
    Object.values(filters.values).forEach((filter) => {
      if (!filter) return;
      if (skipColumn && filter.key === skipColumn) return;
      const col = columns.value.find((c2) => c2.name === filter.key);
      if (!col) return;
      result = result.filter((row) => {
        const rowValue = getFilterValue(row, col);
        return Array.isArray(rowValue) ? rowValue.some((x2) => matchesFilterValue(filter, x2)) : matchesFilterValue(filter, rowValue);
      });
    });
    const needle = (filters.search || "").toLocaleLowerCase();
    if (needle) {
      result = result.filter((row) => {
        return searchableColumns.value.some((col) => {
          const rowValue = getFilterValue(row, col);
          if (!rowValue) return false;
          return Array.isArray(rowValue) ? rowValue.some((x2) => matchesSearchValue(needle, x2)) : matchesSearchValue(needle, rowValue);
        });
      });
    }
    return result;
  }
  function resetFilters() {
    filters.values = {};
  }
  function resetSearchQuery() {
    filters.search = void 0;
  }
  function updateFilters(filter, value2) {
    if (!value2) {
      delete filters.values[filter.key];
      return;
    }
    if (filter.type !== value2.type) {
      throw new Error(filter.type);
    }
    filters.values[filter.key] = value2;
  }
  if (queryParamsFilters.value) {
    watch(filters, () => {
      setQuery({
        filters: isEmptyPlainObject(filters.values) ? void 0 : filters.values,
        search: filters.search
      });
    });
    watch(queryParams, (query) => {
      if (isEmptyPlainObject(query)) {
        filters.search = void 0;
        filters.values = {};
      }
    });
  }
  return {
    filterOptions,
    filterOptionsOpenedByDefault,
    filters,
    getFilteredRows,
    hasFilterableValues,
    hasFilters,
    hasSearchQueryFilter,
    initializeFilters: async () => {
    },
    resetFilters,
    resetSearchQuery,
    search,
    searchable,
    updateFilters,
    visibleFilterOptions
  };
}
const MAX_CONCURRENT_REQUESTS = 10;
function isFilterable(col) {
  return !!col.filterableField && !!col.filterType && col.filterType !== TableFilterType.FreeText;
}
function isSearchable(col) {
  return !!col.filterableField;
}
function buildDefaultFilter(col) {
  return {
    hasOptions: false,
    key: col.name,
    label: col.filterName,
    options: [],
    type: col.filterType
  };
}
function useServerTableFiltering(columns, onRequestFilters) {
  const options = useOptionsReadOnly();
  const queryParamsFilters = computed(() => options.tables.queryParamsFilters);
  const filterableColumns = computed(() => columns.value.filter(isFilterable));
  const searchableColumns = computed(() => columns.value.filter(isSearchable));
  const {
    parseQuery,
    queryParams,
    setQuery
  } = useQueryParams();
  const {
    filters: queryFilters,
    search: querySearch
  } = queryParams.value;
  const filters = reactive({
    search: queryParamsFilters.value ? querySearch : void 0,
    values: queryParamsFilters.value && queryFilters ? parseQuery(queryFilters) : {}
  });
  const filterOptions = ref$1({});
  const filterOptionsOpenedByDefault = ref$1([]);
  const hasFilters = computed(() => !isEmptyPlainObject(filters.values));
  const hasSearchQueryFilter = computed(() => !!filters.search);
  const hasFilterableValues = computed(() => !isEmptyPlainObject(visibleFilterOptions.value));
  const search = computed({
    get() {
      return filters.search;
    },
    set(value2) {
      filters.search = value2;
    }
  });
  const searchable = computed(() => !!searchableColumns.value.length);
  const visibleColumns = computed(() => {
    return columns.value.map((c2) => c2.name);
  });
  const visibleFilterOptions = computed(() => {
    return Object.keys(filterOptions.value).filter((key) => visibleColumns.value.includes(key) && (key in filters.values || filterOptions.value[key].hasOptions)).reduce((obj, key) => {
      return {
        ...obj,
        [key]: filterOptions.value[key]
      };
    }, {});
  });
  async function initializeFilters() {
    filterOptions.value = await buildObjectAsync(
      filterableColumns.value,
      (col) => col.name,
      async (col) => await onRequestFilters(col) ?? buildDefaultFilter(col),
      MAX_CONCURRENT_REQUESTS
    );
  }
  function getFilteredRows() {
    throw new Error("Unsupported operation");
  }
  function resetFilters() {
    filters.values = {};
  }
  function resetSearchQuery() {
    filters.search = void 0;
  }
  function updateFilters(filter, value2) {
    if (!value2) {
      delete filters.values[filter.key];
      return;
    }
    if (filter.type !== value2.type) {
      throw new Error(filter.type);
    }
    filters.values[filter.key] = value2;
  }
  if (queryParamsFilters.value) {
    watch(filters, () => {
      setQuery({
        filters: isEmptyPlainObject(filters.values) ? void 0 : filters.values,
        search: filters.search
      });
    });
    watch(queryParams, (query) => {
      if (isEmptyPlainObject(query)) {
        filters.search = void 0;
        filters.values = {};
      }
    });
  }
  return {
    filterOptions: computed(() => filterOptions.value),
    filterOptionsOpenedByDefault,
    filters,
    getFilteredRows,
    hasFilterableValues,
    hasFilters,
    hasSearchQueryFilter,
    initializeFilters,
    resetFilters,
    resetSearchQuery,
    search,
    searchable,
    updateFilters,
    visibleFilterOptions
  };
}
function useCommonSelecting({
  immutableKey,
  initialSelectedRows,
  rowKey,
  visibleRows
}) {
  const allSelectedRef = ref$1(initialSelectedRows ? [...initialSelectedRows] : []);
  const lastSelected = ref$1();
  const selecting = ref$1(false);
  const selectableRows = computed(() => {
    return visibleRows.value.filter((r) => !immutableKey || !r[immutableKey]);
  });
  function difference(arr1, arr2) {
    return arr1.filter((a3) => !includes(arr2, a3));
  }
  function equals(arr1, arr2) {
    if (arr1.some((a3) => !includes(arr2, a3))) return false;
    if (arr2.some((a3) => !includes(arr1, a3))) return false;
    return true;
  }
  function includes(arr, value2) {
    return arr.some((x2) => rowsEqual(x2, value2));
  }
  function rowsEqual(a3, b2) {
    return a3[rowKey] === b2[rowKey];
  }
  function setSelecting(v) {
    selecting.value = v;
  }
  function toggleSelected(row, range2 = false) {
    const currentSelection = allSelectedRef.value;
    const lastItem = lastSelected.value;
    const visibleItems = visibleRows.value;
    const isSelected = includes(currentSelection, row);
    const lastIndex = lastItem ? visibleItems.findIndex((x2) => rowsEqual(x2, lastItem)) : -1;
    let selected;
    if (!range2 || lastIndex < 0) {
      selected = isSelected ? difference(currentSelection, [row]) : [...currentSelection, row];
    } else {
      const rowIndex = visibleItems.findIndex((x2) => rowsEqual(x2, row));
      const affected = visibleItems.slice(Math.min(rowIndex, lastIndex), Math.max(rowIndex, lastIndex) + 1).filter((r) => !immutableKey || !r[immutableKey]);
      const nonAffected = difference(currentSelection, affected);
      selected = isSelected ? nonAffected : [...nonAffected, ...affected];
    }
    allSelectedRef.value = selected;
    lastSelected.value = row;
    setSelecting(!!selected.length);
  }
  function toggleSelecting() {
    setSelecting(!selecting.value);
    allSelectedRef.value = [];
  }
  return {
    allSelectedRef,
    difference,
    equals,
    includes,
    lastSelected,
    rowsEqual,
    selectableRows,
    selecting,
    setSelecting,
    toggleSelected,
    toggleSelecting
  };
}
function useFilteredSelecting({
  immutableKey,
  initialSelectedRows,
  rowKey,
  rows,
  visibleRows
}) {
  const {
    allSelectedRef,
    difference,
    equals,
    includes,
    rowsEqual,
    selectableRows,
    selecting,
    setSelecting,
    toggleSelected,
    toggleSelecting
  } = useCommonSelecting({
    immutableKey,
    initialSelectedRows,
    rowKey,
    visibleRows
  });
  const filteredSelected = ref$1([]);
  const allSelected = computed({
    get() {
      return allSelectedRef.value;
    },
    set(value2) {
      const added = difference(value2, allSelectedRef.value);
      const removed = difference(allSelectedRef.value, value2);
      filteredSelected.value = difference(filteredSelected.value, removed).concat(added);
      allSelectedRef.value = value2;
      if (value2.length) selecting.value = true;
    }
  });
  const allSelectedValue = computed(() => {
    if (!allSelected.value.length) {
      return false;
    } else if (selectableRows.value.length === allSelected.value.length) {
      return true;
    } else {
      return null;
    }
  });
  function clearSelection2() {
    allSelected.value = [];
  }
  function toggleAll(value2) {
    setSelecting(!!value2);
    allSelected.value = value2 ? selectableRows.value : [];
  }
  function updateSelected() {
    const allRows = [...toValue(rows)];
    allSelectedRef.value = allSelectedRef.value.filter((x2) => includes(allRows, x2)).map((x2) => allRows.find((r) => rowsEqual(r, x2)) || x2);
    filteredSelected.value = allSelectedRef.value.filter((x2) => includes(visibleRows.value, x2)).filter((x2) => !immutableKey || !x2[immutableKey]);
  }
  function updateSelection(selected) {
    const same = equals(selected, filteredSelected.value);
    if (same) return;
    allSelectedRef.value = allSelectedRef.value.filter((x2) => includes(selected, x2));
    filteredSelected.value = allSelectedRef.value.filter((x2) => includes(selected, x2)).filter((x2) => !immutableKey || !x2[immutableKey]);
  }
  watch(allSelectedRef, () => {
    filteredSelected.value = allSelectedRef.value.filter((x2) => includes(visibleRows.value, x2)).filter((x2) => !immutableKey || !x2[immutableKey]);
  });
  return {
    allSelected,
    allSelectedValue,
    clearSelection: clearSelection2,
    filteredSelected,
    selectableRows,
    selecting,
    setSelecting,
    toggleAll,
    toggleSelected,
    toggleSelecting,
    updateSelected,
    updateSelection
  };
}
function useUnfilteredSelecting(visibleRows, rowKey, immutableKey) {
  const {
    allSelectedRef,
    difference,
    equals,
    includes,
    rowsEqual,
    selectableRows,
    selecting,
    setSelecting,
    toggleSelected,
    toggleSelecting
  } = useCommonSelecting({
    immutableKey,
    rowKey,
    visibleRows
  });
  const allSelected = computed({
    get() {
      return allSelectedRef.value;
    },
    set(value2) {
      allSelectedRef.value = value2;
      if (value2.length) selecting.value = true;
    }
  });
  const filteredSelected = computed(() => allSelected.value);
  const allSelectedValue = computed(() => {
    const visibleSelected = selectableRows.value.filter((r) => includes(allSelected.value, r));
    if (visibleSelected.length === 0) {
      return false;
    } else if (visibleSelected.length === selectableRows.value.length) {
      return true;
    } else {
      return null;
    }
  });
  function clearSelection2() {
    allSelected.value = [];
  }
  function toggleAll(value2) {
    if (value2) {
      allSelected.value = mergeArraysByKey(
        allSelected.value,
        selectableRows.value,
        rowKey
      );
    } else {
      allSelected.value = difference(
        allSelected.value,
        selectableRows.value
      );
    }
  }
  function updateSelected() {
    allSelectedRef.value = allSelectedRef.value.map((x2) => visibleRows.value.find((r) => rowsEqual(r, x2)) || x2);
  }
  function updateSelection(selected) {
    const same = equals(selected, filteredSelected.value);
    if (same) return;
    allSelectedRef.value = allSelectedRef.value.filter((x2) => includes(selected, x2));
  }
  return {
    allSelected,
    allSelectedValue,
    clearSelection: clearSelection2,
    filteredSelected,
    selectableRows,
    selecting,
    setSelecting,
    toggleAll,
    toggleSelected,
    toggleSelecting,
    updateSelected,
    updateSelection
  };
}
function useTableCardsSorting(columns) {
  const { t: t2 } = useI18n();
  const selectedItem = ref$1(null);
  const sortableItems = computed(() => {
    const sortableColumns = columns.value.filter((c2) => c2.sortable);
    return sortableColumns.reduce((acc, val) => val.filterType === TableFilterType.Date ? [
      ...acc,
      {
        descending: false,
        get label() {
          return val.i18nSortNameAsc ? t2(val.i18nSortNameAsc) : `${t2("rvai-base.general.text.first")} ${val.label.toLowerCase()}`;
        },
        name: val.name,
        value: val.name + SortOrders.Asc
      },
      {
        descending: true,
        get label() {
          return val.i18nSortNameDesc ? t2(val.i18nSortNameDesc) : `${t2("rvai-base.general.text.last")} ${val.label.toLowerCase()}`;
        },
        name: val.name,
        value: val.name + SortOrders.Desc
      }
    ] : [
      ...acc,
      {
        descending: false,
        get label() {
          return val.i18nSortNameAsc ? t2(val.i18nSortNameAsc) : `${val.label} ${t2("rvai-base.general.text.sortAsc")}`;
        },
        name: val.name,
        value: val.name + SortOrders.Asc
      },
      {
        descending: true,
        get label() {
          return val.i18nSortNameDesc ? t2(val.i18nSortNameDesc) : `${val.label} ${t2("rvai-base.general.text.sortDesc")}`;
        },
        name: val.name,
        value: val.name + SortOrders.Desc
      }
    ], []);
  });
  return {
    selectedItem,
    sortableItems
  };
}
function useTableCarousel({
  data,
  hasActionColumn,
  isEnabled,
  isSelectionEnabled,
  minColumnWidth = 200
}) {
  const CHECKBOX_WIDTH = isSelectionEnabled ? 40 : 0;
  const TABLE_MARGIN = 32;
  const NEXT_COLUMN_WIDTH = 32;
  const ACTION_COLUMN_WIDTH = hasActionColumn ? 56 : 0;
  const FIXED_COLUMNS_WIDTH = TABLE_MARGIN + NEXT_COLUMN_WIDTH + ACTION_COLUMN_WIDTH + CHECKBOX_WIDTH;
  const FIRST_COLUMN_WIDTH = minColumnWidth;
  const MIN_WIDTH = minColumnWidth;
  const isCarouselCalculationsEnabled = ref$1(true);
  const isCarouselEnabled = ref$1(isEnabled);
  const currentColumnIndex = ref$1(0);
  const tableWidth = ref$1(0);
  const totalWidth = ref$1(0);
  const cols = computed(() => {
    let cols2 = Math.min(Math.floor(totalWidth.value / MIN_WIDTH), data.value.length);
    do {
      const width = totalWidth.value / cols2;
      if (width >= MIN_WIDTH) break;
    } while (--cols2 > 1);
    return Math.max(1, cols2);
  });
  const colWidth = computed(() => {
    return `${totalWidth.value / cols.value}px`;
  });
  const disableNextButton = computed(() => currentColumnIndex.value + cols.value >= data.value.length);
  const disablePreviousButton = computed(() => !currentColumnIndex.value);
  const transformOffsetLeft = computed(() => currentColumnIndex.value * parseFloat(colWidth.value));
  const visibleColumnsCount = computed(() => Math.floor((tableWidth.value - CHECKBOX_WIDTH - FIRST_COLUMN_WIDTH) / parseFloat(colWidth.value)));
  function setCarouselCalculationsEnabled(val) {
    isCarouselCalculationsEnabled.value = val;
  }
  function setTableCarousel(val) {
    isCarouselEnabled.value = val;
  }
  function nextColumn() {
    currentColumnIndex.value++;
  }
  function prevColumn() {
    currentColumnIndex.value--;
  }
  function onResize({ width }) {
    if (!isCarouselCalculationsEnabled.value) return;
    totalWidth.value = Math.max(0, width - FIXED_COLUMNS_WIDTH);
    tableWidth.value = width;
  }
  watch(visibleColumnsCount, (curr, prev) => {
    const scrollableColumns = data.value.length - 1;
    const hasColumnsCountIncreased = curr > prev;
    const hasEmptySpace = curr > scrollableColumns - currentColumnIndex.value;
    if (prev !== -Infinity && hasColumnsCountIncreased && hasEmptySpace) {
      currentColumnIndex.value -= curr - prev;
    }
  });
  watch(() => data.value.length, (currentLength, prevLength) => {
    const wasDataDecreased = currentLength < prevLength;
    const scrollableColumns = currentLength - 1;
    const hasEmptySpace = visibleColumnsCount.value > scrollableColumns - currentColumnIndex.value;
    if (wasDataDecreased && hasEmptySpace) {
      currentColumnIndex.value -= currentColumnIndex.value + visibleColumnsCount.value - scrollableColumns;
    }
  });
  return {
    cols,
    colWidth,
    currentColumnIndex,
    disableNextButton,
    disablePreviousButton,
    isCarouselEnabled,
    nextColumn,
    onResize,
    prevColumn,
    setCarouselCalculationsEnabled,
    setTableCarousel,
    totalWidth,
    transformOffsetLeft
  };
}
const LS_KEY = "LS_TABLE_CONFIG";
function useTableConfig(tableId) {
  function getConfig() {
    var _a;
    const config = (_a = LocalStorage_default.getItem(LS_KEY)) == null ? void 0 : _a[tableId];
    return {
      grid: (config == null ? void 0 : config.grid) ?? void 0
    };
  }
  function setConfig(update6) {
    const config = LocalStorage_default.getItem(LS_KEY);
    LocalStorage_default.set(LS_KEY, {
      ...config,
      [tableId]: {
        ...config == null ? void 0 : config[tableId],
        ...update6
      }
    });
  }
  return {
    getConfig,
    setConfig
  };
}
function useTablePagination() {
  function paginateRows(rows, pagination) {
    const {
      page = 1,
      rowsPerPage = 0
    } = pagination;
    const startRow = (page - 1) * rowsPerPage;
    const fetchCount = rowsPerPage === 0 ? rows.length : rowsPerPage;
    return rows.slice(startRow, startRow + fetchCount);
  }
  return {
    paginateRows
  };
}
function compareBoolean(a3, b2) {
  return +a3 - +b2;
}
function compareNumber(a3, b2) {
  return a3 - b2;
}
function defaultCompare(a3, b2) {
  return a3 > b2 ? 1 : a3 < b2 ? -1 : 0;
}
function getSortValue(row, col) {
  const {
    field,
    sortableField
  } = col;
  const computedField = sortableField || field;
  if (!computedField) return "";
  return typeof computedField === "function" ? computedField(row) : row[computedField];
}
function useTableSorting(columns) {
  function sortRows(rows, {
    descending,
    sortBy
  }) {
    const result = [...rows];
    if (!sortBy) return result;
    const col = columns.value.find((c2) => c2.name === sortBy);
    if (!col) return result;
    result.sort((a3, b2) => {
      const x2 = descending ? getSortValue(b2, col) : getSortValue(a3, col);
      const y3 = descending ? getSortValue(a3, col) : getSortValue(b2, col);
      if (x2 == null && y3 == null) return 0;
      if (x2 == null) return 1;
      if (y3 == null) return -1;
      if (typeof x2 !== typeof y3) return 0;
      switch (typeof x2) {
        case "boolean":
          return compareBoolean(x2, y3);
        case "number":
          return compareNumber(x2, y3);
        case "string":
          return naturalSort(x2, y3);
        default:
          return defaultCompare(x2, y3);
      }
    });
    return result;
  }
  return {
    sortRows
  };
}
function buildTableComposable({
  carousel,
  columns,
  defaultRowsPerPage = 0,
  enableSelection = true,
  hasRowActions = true,
  immutableKey,
  initialSelectedRows,
  onServerRequest,
  onServerRequestFilter,
  rowKey,
  rows: data,
  tableId,
  totalRows: totalRowsValue,
  visibleColumnNames
}) {
  if (onServerRequest && totalRowsValue == null) {
    console.warn("Make sure to provide `totalRows` when using server side pagination");
  }
  const { t: t2 } = useI18n();
  const options = useOptionsReadOnly();
  const {
    queryParams,
    setQuery
  } = useQueryParams();
  const tableRef = ref$1(null);
  const rows = ref$1([]);
  const serverLoading = ref$1(false);
  const queryParamsFilters = computed(() => options.tables.queryParamsFilters);
  const visibleColumns = computed(() => {
    const columnsValue = "value" in columns ? columns.value : columns;
    return (visibleColumnNames == null ? void 0 : visibleColumnNames.value.length) ? columnsValue.filter((c2) => visibleColumnNames.value.includes(c2.name)) : columnsValue;
  });
  const translatedColumns = computed(() => visibleColumns.value.map((c2) => {
    c2.label = "i18nLabel" in c2 ? c2.i18nLabel ? t2(c2.i18nLabel) : "" : c2.label;
    c2.filterName = c2.i18nFilterName ? t2(c2.i18nFilterName) : c2.label;
    return c2;
  }));
  const {
    filterOptions,
    filterOptionsOpenedByDefault,
    filters,
    getFilteredRows,
    hasFilterableValues,
    hasFilters,
    hasSearchQueryFilter,
    initializeFilters,
    resetFilters,
    resetSearchQuery,
    search,
    searchable,
    updateFilters,
    visibleFilterOptions
  } = onServerRequestFilter ? useServerTableFiltering(translatedColumns, onServerRequestFilter) : useClientTableFiltering(translatedColumns, data);
  const { paginateRows } = useTablePagination();
  const {
    allSelected,
    allSelectedValue,
    clearSelection: clearSelection2,
    filteredSelected,
    selectableRows,
    selecting,
    toggleAll,
    toggleSelected,
    toggleSelecting,
    updateSelected,
    updateSelection
  } = onServerRequestFilter ? useUnfilteredSelecting(rows, rowKey, immutableKey) : useFilteredSelecting({
    immutableKey,
    initialSelectedRows,
    rowKey,
    rows: data,
    visibleRows: rows
  });
  const { sortRows } = useTableSorting(translatedColumns);
  const {
    selectedItem,
    sortableItems
  } = useTableCardsSorting(translatedColumns);
  const {
    cols: carouselColumns,
    colWidth,
    disableNextButton,
    disablePreviousButton,
    isCarouselEnabled,
    nextColumn,
    onResize,
    prevColumn,
    setCarouselCalculationsEnabled,
    setTableCarousel,
    totalWidth,
    transformOffsetLeft
  } = useTableCarousel({
    data: translatedColumns,
    hasActionColumn: hasRowActions,
    isEnabled: (carousel == null ? void 0 : carousel.enableCarousel) ?? options.tables.carousel ?? true,
    isSelectionEnabled: enableSelection,
    minColumnWidth: carousel == null ? void 0 : carousel.minColumnWidth
  });
  const {
    getConfig,
    setConfig
  } = useTableConfig(tableId);
  const {
    desc,
    sortBy
  } = queryParams.value;
  const pagination = ref$1({
    descending: !!(queryParamsFilters.value && sortBy && desc),
    page: 1,
    rowsNumber: 0,
    rowsPerPage: defaultRowsPerPage,
    sortBy: queryParamsFilters.value ? sortBy : void 0
  });
  const totalRows = computed(() => {
    return totalRowsValue == null ? rows.value.length : toValue(totalRowsValue);
  });
  const hasNoData = computed(() => {
    return onServerRequest ? !totalRows.value : !data.value.length;
  });
  async function onRequest(props4) {
    if (onServerRequest) {
      try {
        serverLoading.value = true;
        const result = await onServerRequest(props4.pagination, { ...props4.filter });
        pagination.value.rowsNumber = result.rowsNumber;
        rows.value = [...result.rows];
      } finally {
        serverLoading.value = false;
      }
    } else {
      const filtered = getFilteredRows();
      pagination.value.rowsNumber = filtered.length;
      const sorted = sortRows(filtered, props4.pagination);
      const result = paginateRows(sorted, props4.pagination);
      rows.value = result;
    }
    pagination.value.descending = props4.pagination.descending;
    pagination.value.page = props4.pagination.page;
    pagination.value.rowsPerPage = props4.pagination.rowsPerPage;
    pagination.value.sortBy = props4.pagination.sortBy;
    updateSelected();
  }
  if (!onServerRequest) {
    onMounted(() => {
      watch(data, () => {
        var _a;
        (_a = tableRef.value) == null ? void 0 : _a.requestServerInteraction({
          pagination: {
            ...pagination.value,
            sortBy: pagination.value.sortBy ?? void 0
          }
        });
      }, {
        immediate: true
      });
    });
  }
  if (queryParamsFilters.value) {
    watch(() => [pagination.value.sortBy, pagination.value.descending], ([sortBy2, desc2]) => {
      setQuery({
        desc: sortBy2 && desc2 ? true : void 0,
        sortBy: sortBy2
      });
    });
    watch(queryParams, (query) => {
      if (isEmptyPlainObject(query)) {
        pagination.value.descending = false;
        pagination.value.sortBy = void 0;
      }
    });
  }
  return {
    allSelected,
    allSelectedValue,
    carouselColumns,
    clearSelection: clearSelection2,
    columns: translatedColumns,
    colWidth,
    disableNextButton,
    disablePreviousButton,
    enableSelection,
    filteredSelected,
    filterOptions,
    filterOptionsOpenedByDefault,
    filters,
    getConfig,
    hasFilterableValues,
    hasFilters,
    hasNoData,
    hasRowActions,
    hasSearchQueryFilter,
    immutableKey,
    initializeFilters,
    isCarouselEnabled,
    nextColumn,
    onRequest,
    onResize,
    pagination,
    prevColumn,
    resetFilters,
    resetSearchQuery,
    rowKey,
    rows,
    search,
    searchable,
    selectableRows,
    selectedItem,
    selecting,
    serverLoading,
    setCarouselCalculationsEnabled,
    setConfig,
    setTableCarousel,
    sortableItems,
    tableRef,
    toggleAll,
    toggleSelected,
    toggleSelecting,
    totalRows,
    totalWidth,
    transformOffsetLeft,
    updateFilters,
    updateSelection,
    visibleFilterOptions
  };
}
const Table$1 = "Table dependency";
function provideTable(params) {
  const composable = buildTableComposable(params);
  provide(Table$1, composable);
  return composable;
}
function useTable() {
  const tableComposable = inject(Table$1);
  if (!tableComposable) {
    throw new Error('The table was not registered. Make sure you used "provideTable".');
  }
  return tableComposable;
}
function useValidation(props4) {
  const {
    class: classRef,
    validation
  } = toRefs(props4);
  const error = computed(() => {
    var _a, _b;
    return !((_a = validation.value) == null ? void 0 : _a.$pending) && ((_b = validation.value) == null ? void 0 : _b.$error);
  });
  const errorMessage = computed(() => {
    var _a;
    if (!validation.value) return void 0;
    if (!validation.value.$error) return void 0;
    return (_a = validation.value.$errors[0]) == null ? void 0 : _a.$message;
  });
  const isValidated = computed(() => {
    if (!validation.value) return false;
    return validation.value.$dirty && !validation.value.$invalid;
  });
  function onBlur2() {
    var _a;
    (_a = validation.value) == null ? void 0 : _a.$touch();
  }
  return {
    classRef,
    error,
    errorMessage,
    isValidated,
    onBlur: onBlur2
  };
}
const _sfc_main$1D = defineComponent({
  name: "FieldsVisibilityDialogSection",
  components: { Checkbox },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Section item element that can be set hidden/visible
     */
    sectionItem: {
      required: true,
      type: Object
    }
  },
  setup(props4) {
    function isSectionVisible(item) {
      if (!item.fields.length) {
        return !!item.visible;
      }
      if (item.fields.every((v) => v.visible)) {
        return true;
      } else if (item.fields.every((v) => !v.visible)) {
        return false;
      } else {
        return null;
      }
    }
    function onToggleSection(field) {
      field.visible = !field.visible;
    }
    return {
      ...useAutomation(props4.dataAutomation),
      isSectionVisible,
      onToggleSection
    };
  }
});
const _hoisted_1$1o = ["data-automation"];
const _hoisted_2$17 = { class: "text-body3" };
const _hoisted_3$V = { class: "text-body3" };
function _sfc_render$1r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_FieldsVisibilityDialogSection = resolveComponent("FieldsVisibilityDialogSection", true);
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", {
      class: "visibility-section text-black-1 q-pb-sm",
      "data-automation": _ctx.buildId()
    }, [
      createVNode(_component_Checkbox, {
        dense: "",
        disable: !_ctx.sectionItem.hideable,
        "model-value": _ctx.isSectionVisible(_ctx.sectionItem),
        size: "md",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.onToggleSection(_ctx.sectionItem))
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_2$17, toDisplayString(_ctx.sectionItem.label), 1)
        ]),
        _: 1
      }, 8, ["disable", "model-value"])
    ], 8, _hoisted_1$1o),
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.sectionItem.fields, (field) => {
      return openBlock(), createElementBlock("div", {
        key: field.label,
        class: "visibility-section__fields q-mb-sm"
      }, [
        field.fields.length ? (openBlock(), createBlock(_component_FieldsVisibilityDialogSection, {
          key: 0,
          "section-item": field
        }, null, 8, ["section-item"])) : (openBlock(), createBlock(_component_Checkbox, {
          key: 1,
          modelValue: field.visible,
          "onUpdate:modelValue": ($event) => field.visible = $event,
          dense: "",
          disable: !field.hideable,
          size: "md"
        }, {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_3$V, toDisplayString(field.label), 1)
          ]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "disable"]))
      ]);
    }), 128))
  ], 64);
}
const FieldsVisibilityDialogSection = /* @__PURE__ */ _export_sfc(_sfc_main$1D, [["render", _sfc_render$1r], ["__scopeId", "data-v-0476d004"]]);
const _sfc_main$1C = defineComponent({
  name: "FieldsVisibilityDialog",
  components: {
    Checkbox,
    FieldsVisibilityDialogSection,
    RvButton: Button,
    RvDialog
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Section item element that can be set hidden/visible
     */
    fields: {
      required: true,
      type: Object
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    const {
      dialogRef,
      onCancel,
      onOK
    } = useSidebar();
    const data = ref$1(
      Object.entries(props4.fields).reduce((acc, [key, v]) => ({
        ...acc,
        [key]: v.clone()
      }), {})
    );
    const allSelected = computed(() => {
      const values = Object.values(data.value);
      if (values.every((v) => v.fields.length ? v.fields.every((v2) => v2.visible) : v.visible)) {
        return true;
      } else if (values.every((v) => v.fields.length ? v.fields.every((v2) => !v2.visible) : !v.visible)) {
        return false;
      } else {
        return null;
      }
    });
    function onToggleAll(visible) {
      data.value = Object.entries(data.value).reduce((acc, [key, v]) => {
        v.visible = visible;
        return {
          ...acc,
          [key]: v
        };
      }, {});
    }
    return {
      ...useAutomation(props4.dataAutomation),
      allSelected,
      data,
      dialogRef,
      onCancel,
      onOK,
      onToggleAll,
      t: t2
    };
  }
});
const _hoisted_1$1n = { class: "text-subtitle1 q-ml-sm text-black-1" };
const _hoisted_2$16 = { class: "row q-pb-sm" };
const _hoisted_3$U = { class: "text-body3" };
function _sfc_render$1q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_FieldsVisibilityDialogSection = resolveComponent("FieldsVisibilityDialogSection");
  const _component_RvButton = resolveComponent("RvButton");
  const _component_RvDialog = resolveComponent("RvDialog");
  return openBlock(), createBlock(_component_RvDialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId()
  }, toHandlers(_ctx.$attrs)), {
    title: withCtx(() => [
      createElementVNode("span", _hoisted_1$1n, toDisplayString(_ctx.t("rvai-base.general.text.showRows")), 1)
    ]),
    default: withCtx(() => [
      createElementVNode("div", _hoisted_2$16, [
        createVNode(_component_Checkbox, {
          dense: "",
          "model-value": _ctx.allSelected,
          size: "md",
          "onUpdate:modelValue": _ctx.onToggleAll
        }, {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_3$U, toDisplayString(_ctx.t("rvai-base.general.text.allRows")), 1)
          ]),
          _: 1
        }, 8, ["model-value", "onUpdate:modelValue"])
      ]),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.data, (item) => {
        return openBlock(), createElementBlock("div", {
          key: item.label,
          class: "col q-pb-sm"
        }, [
          createVNode(_component_FieldsVisibilityDialogSection, { "section-item": item }, null, 8, ["section-item"])
        ]);
      }), 128))
    ]),
    actions: withCtx(() => [
      createVNode(_component_RvButton, {
        label: _ctx.t("rvai-base.general.actions.cancel"),
        secondary: "",
        size: "sm",
        onClick: _ctx.onCancel
      }, null, 8, ["label", "onClick"]),
      createVNode(_component_RvButton, {
        color: "primary",
        label: _ctx.t("rvai-base.general.actions.save"),
        size: "sm",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.onOK(_ctx.data))
      }, null, 8, ["label"])
    ]),
    _: 1
  }, 16, ["data-automation"]);
}
const FieldsVisibilityDialog = /* @__PURE__ */ _export_sfc(_sfc_main$1C, [["render", _sfc_render$1q], ["__scopeId", "data-v-6d83a752"]]);
const iconStyles = {
  md: {
    iconSize: "1.5rem",
    size: "32px"
  },
  sm: {
    iconSize: "1rem",
    size: "24px"
  }
};
const _sfc_main$1B = defineComponent({
  name: "ActionButton",
  components: {
    QBtn: QBtn_default,
    QIcon: QIcon_default,
    Tooltip
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Applies to the shortcut 'position: absolute'
     */
    absoluteShortcut: {
      type: Boolean,
      default: false
    },
    /**
     * Classes applied to the Histogram
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
     */
    icon: {
      type: String,
      default: void 0
    },
    /**
     * Icon size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
     */
    iconSize: {
      type: String,
      default: void 0
    },
    /**
     * Shows indicator circle in top right corner of the icon
     */
    indicator: {
      type: Boolean,
      default: false
    },
    /**
     * Adds an optional text to the indicator in the top right
     */
    indicatorLabel: {
      type: String,
      default: void 0
    },
    /**
     * Put component in selected mode
     */
    selected: {
      type: Boolean,
      default: false
    },
    /**
     * The text below the button
     */
    shortcut: {
      type: String,
      default: void 0
    },
    /**
     * Condition that meets whether the shortcut will be shown
     */
    showShortcuts: {
      type: Boolean,
      default: false
    },
    /**
     * Size in standard size name (sm|md)
     */
    size: {
      type: String,
      default: "md"
    },
    /**
     * The text that will be shown on the button tooltip; Can be used as a "tooltip" property or as a slot
     */
    tooltip: {
      type: String,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when component is clicked (activated)
     *
     * @type {object}
     */
    "click"
  ],
  setup(props4, { emit }) {
    const { isDark } = useDarkMode();
    const onClick = throttle(
      (event) => emit("click", event),
      200,
      { trailing: false }
    );
    const iconStyle = computed(() => {
      const style = iconStyles[props4.size];
      if (props4.iconSize) {
        style.iconSize = props4.iconSize;
      }
      return style;
    });
    const textColor = computed(() => {
      if (props4.disable) return "grey-2";
      if (props4.selected) return isDark.value ? "white--dark" : "primary";
      return "black-1";
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      iconStyle,
      isDark,
      onClick,
      textColor
    };
  }
});
const _hoisted_1$1m = ["data-automation"];
const _hoisted_2$15 = ["data-automation"];
const _hoisted_3$T = ["data-automation"];
function _sfc_render$1p(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QBtn = resolveComponent("QBtn");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: "action relative-position flex column items-center",
    "data-automation": _ctx.buildId(),
    style: { "--size": _ctx.iconStyle.size }
  }), [
    createVNode(_component_QBtn, {
      class: normalizeClass(_ctx.$props.class),
      color: _ctx.isDark ? "primary-05op" : "grey-6",
      "data-automation": _ctx.buildId("button"),
      disable: _ctx.disable,
      flat: !_ctx.selected,
      style: normalizeStyle(_ctx.style),
      "text-color": _ctx.textColor,
      unelevated: "",
      onClick: _ctx.onClick
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default", {}, void 0, true),
        _ctx.icon ? (openBlock(), createBlock(_component_QIcon, {
          key: 0,
          name: _ctx.icon,
          size: _ctx.iconStyle.iconSize
        }, null, 8, ["name", "size"])) : createCommentVNode("", true),
        _ctx.indicator ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["indicator", { "label row justify-center items-center": !!_ctx.indicatorLabel }])
        }, [
          _ctx.indicatorLabel ? (openBlock(), createElementBlock("span", {
            key: 0,
            "data-automation": _ctx.buildId("indicator-label")
          }, toDisplayString(_ctx.indicatorLabel), 9, _hoisted_2$15)) : createCommentVNode("", true)
        ], 2)) : createCommentVNode("", true),
        _ctx.tooltip || _ctx.$slots.tooltip ? (openBlock(), createBlock(_component_Tooltip, {
          key: 2,
          "data-automation": _ctx.buildId("tooltip"),
          offset: [14, 4]
        }, {
          default: withCtx(() => [
            _ctx.tooltip ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createTextVNode(toDisplayString(_ctx.tooltip), 1)
            ], 64)) : renderSlot(_ctx.$slots, "tooltip", { key: 1 }, void 0, true)
          ]),
          _: 3
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["class", "color", "data-automation", "disable", "flat", "style", "text-color", "onClick"]),
    _ctx.showShortcuts && (_ctx.shortcut || _ctx.$slots.shortcut) ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["action__shortcut text-caption text-grey-2", { "absolute-center": _ctx.absoluteShortcut }]),
      "data-automation": _ctx.buildId("shortcut")
    }, [
      _ctx.shortcut ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString(_ctx.shortcut), 1)
      ], 64)) : renderSlot(_ctx.$slots, "shortcut", { key: 1 }, void 0, true)
    ], 10, _hoisted_3$T)) : createCommentVNode("", true)
  ], 16, _hoisted_1$1m);
}
const ActionButton = /* @__PURE__ */ _export_sfc(_sfc_main$1B, [["render", _sfc_render$1p], ["__scopeId", "data-v-d992ada4"]]);
const _sfc_main$1A = defineComponent({
  name: "AutoHeight",
  components: {
    QResizeObserver: QResizeObserver_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    offset: {
      type: Number,
      default: 0
    }
  },
  setup(props4) {
    const height2 = ref$1(0);
    const heightStyle = computed(() => ({
      height: `${height2.value - props4.offset}px`
    }));
    function onResize(dimensions) {
      height2.value = dimensions.height;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      heightStyle,
      onResize
    };
  }
});
const _hoisted_1$1l = ["data-automation"];
function _sfc_render$1o(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  return openBlock(), createElementBlock("div", {
    "data-automation": _ctx.buildId()
  }, [
    createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"]),
    renderSlot(_ctx.$slots, "default", { heightStyle: _ctx.heightStyle })
  ], 8, _hoisted_1$1l);
}
const AutoHeight = /* @__PURE__ */ _export_sfc(_sfc_main$1A, [["render", _sfc_render$1o]]);
const FONT_SIZE_MAP = {
  lg: "18px",
  md: "12px",
  sm: "10px",
  xl: "60px",
  xs: "7px"
};
const SIZE_MAP = {
  lg: "44px",
  md: "30px",
  sm: "24px",
  xl: "120px",
  xs: "18px"
};
const ICON_SIZE_MAP = {
  lg: "25px",
  md: "18px",
  sm: "14px",
  xl: "84px",
  xs: "10px"
};
const DEFAULT_PRIMARY = "#F2209E";
const SIZES = ["xs", "sm", "md", "lg", "xl"];
const DEFAULT_SIZE = "sm";
const COLOR_BLACK = getCssVar("black-1-fixed") ?? "#1F2641";
const COLOR_GREY = getCssVar("grey-2") ?? "#97A1BF";
const COLOR_WHITE = getCssVar("white-fixed") ?? "#FFFFFF";
const __default__$4 = defineComponent({
  name: "Avatar",
  components: {
    QAvatar: QAvatar_default,
    QIcon: QIcon_default,
    Tooltip
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Color name for component from the Quasar Color Palette or HEX color
     */
    backgroundColor: {
      type: String,
      default: ""
    },
    /**
     * Color name for component from the Quasar Color Palette or HEX color
     */
    borderColor: {
      type: String,
      default: "white"
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Render component in hidable state based on boolean value if passed
     */
    hidden: {
      type: Boolean,
      default: void 0
    },
    /**
     * Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
     */
    icon: {
      type: String,
      default: void 0
    },
    /**
     * The avatar iamge to be displayed. If missing, it display the initials.
     */
    image: {
      type: String,
      default: void 0
    },
    /**
     * The text displayed in the component
     */
    initials: {
      type: String,
      default: void 0
    },
    /**
     * The first 2 letters are displayed in the component
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Prevent display of "initials", show full "label"
     */
    noInitial: {
      type: Boolean,
      default: false
    },
    /**
     * Render a diagonal line
     */
    crossed: {
      type: Boolean,
      default: false
    },
    /**
     * Render logo
     */
    showLogo: {
      type: Boolean,
      default: false
    },
    /**
     * Render tooltip
     */
    showTooltip: {
      type: Boolean,
      default: true
    },
    /**
     * Size in standard size name (xs|sm|md|lg|xl)
     */
    size: {
      type: String,
      default: DEFAULT_SIZE,
      validator: (v) => SIZES.includes(v)
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Text color name for component from the Quasar Color Palette
     */
    textColor: {
      type: String,
      default: ""
    },
    /**
     * UUID must be passed in tables for the correct display of tooltips
     */
    uuid: {
      type: [Number, String],
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when component is clicked
     *
     * @type {object}
     */
    "click"
  ],
  setup(props4, { emit }) {
    var _a;
    const { isDark } = useDarkMode();
    const { getPaletteColorCache } = usePaletteColorsCache();
    const isPrimaryOverridden = ((_a = getCssVar("primary")) == null ? void 0 : _a.toUpperCase()) !== DEFAULT_PRIMARY;
    const avatarSize = computed(() => {
      return SIZE_MAP[props4.size] ?? SIZE_MAP[DEFAULT_SIZE];
    });
    const fontSize = computed(() => {
      return FONT_SIZE_MAP[props4.size] ?? FONT_SIZE_MAP[DEFAULT_SIZE];
    });
    const iconSize = computed(() => {
      return ICON_SIZE_MAP[props4.size] ?? ICON_SIZE_MAP[DEFAULT_SIZE];
    });
    const hidable = computed(() => typeof props4.hidden === "boolean");
    const initialsValue = computed(() => {
      if (props4.initials) return props4.initials;
      const [label] = (props4.label ?? "").split("@");
      try {
        const initials = label.replace(/\([^)]*\)/g, "").replace(/[-_]/g, " ").replace(/\B([A-Z])/g, " $1").match(/\b\w/g) || [];
        const initialsPreview = initials.length > 1 ? (initials.shift() ?? "") + (initials.pop() ?? "") : label.substring(0, 2);
        return initialsPreview.toUpperCase();
      } catch {
        const initialsPreview = label.substring(0, 2);
        return initialsPreview.toUpperCase();
      }
    });
    const computedBorderColor = computed(() => isHexColor(props4.borderColor) ? props4.borderColor : getPaletteColorCache(props4.borderColor));
    const styles = computed(() => {
      let background;
      if (props4.disable) {
        background = COLOR_GREY;
      } else if (!isPrimaryOverridden && props4.uuid && !props4.showLogo && !props4.image) {
        background = getUserColor(props4.uuid);
      }
      const backgroundProps = props4.backgroundColor ? isHexColor(props4.backgroundColor) ? props4.backgroundColor : getPaletteColorCache(props4.backgroundColor) : void 0;
      const defaultBackgroundColor = isDark.value ? COLOR_WHITE : COLOR_BLACK;
      const defaultColor = isDark.value ? COLOR_BLACK : COLOR_WHITE;
      return {
        background: backgroundProps ?? background ?? defaultBackgroundColor,
        color: backgroundProps || background ? COLOR_WHITE : defaultColor
      };
    });
    function isHexColor(color) {
      return /^#([0-9a-f]{3}){1,2}$/i.test(color);
    }
    function onClick(event) {
      if (props4.disable) return;
      emit("click", event);
    }
    return {
      ...useAutomation(props4.dataAutomation),
      avatarSize,
      computedBorderColor,
      fontSize,
      hidable,
      iconSize,
      initialsValue,
      onClick,
      styles
    };
  }
});
const __injectCSSVars__$4 = () => {
  useCssVars((_ctx) => ({
    "v45118491": _ctx.computedBorderColor
  }));
};
const __setup__$4 = __default__$4.setup;
__default__$4.setup = __setup__$4 ? (props4, ctx) => {
  __injectCSSVars__$4();
  return __setup__$4(props4, ctx);
} : __injectCSSVars__$4;
const _hoisted_1$1k = ["data-automation"];
const _hoisted_2$14 = ["data-automation"];
const _hoisted_3$S = ["data-automation"];
function _sfc_render$1n(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QAvatar = resolveComponent("QAvatar");
  return openBlock(), createElementBlock("div", {
    class: "rv-avatar-wrapper",
    "data-automation": _ctx.buildId("wrapper")
  }, [
    createVNode(_component_QAvatar, mergeProps({
      class: ["rv-avatar text-weight-medium", [_ctx.$props.class, { "rv-avatar--hidable": _ctx.hidable }]]
    }, _ctx.dataAttrs, {
      "data-automation": _ctx.buildId(),
      "font-size": _ctx.fontSize,
      icon: _ctx.icon,
      size: _ctx.avatarSize,
      style: [_ctx.styles, _ctx.style],
      "text-color": _ctx.textColor,
      onClick: _ctx.onClick
    }), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default", {}, () => [
          _ctx.hidden ? (openBlock(), createBlock(_component_QIcon, {
            key: 0,
            class: "rv-avatar__hidden",
            name: "rvai-base:eye-off",
            size: _ctx.iconSize
          }, null, 8, ["size"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            _ctx.hidable ? (openBlock(), createBlock(_component_QIcon, {
              key: 0,
              class: "rv-avatar__visible hidden",
              name: "rvai-base:eye",
              size: _ctx.iconSize
            }, null, 8, ["size"])) : createCommentVNode("", true),
            _ctx.image ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: "rv-avatar__image",
              "data-automation": _ctx.buildId("image"),
              style: normalizeStyle({ "background-image": `url(${_ctx.image})` })
            }, null, 12, _hoisted_2$14)) : _ctx.showLogo ? (openBlock(), createBlock(_component_QIcon, {
              key: 2,
              class: "rv-avatar__content",
              "data-automation": _ctx.buildId("logo"),
              name: "rvai-base:robovision",
              size: _ctx.iconSize
            }, null, 8, ["data-automation", "size"])) : (openBlock(), createElementBlock("div", {
              key: 3,
              class: "rv-avatar__content",
              "data-automation": _ctx.buildId("label")
            }, toDisplayString(_ctx.noInitial ? _ctx.label : _ctx.initialsValue), 9, _hoisted_3$S))
          ], 64))
        ], true),
        renderSlot(_ctx.$slots, "extra", {}, void 0, true),
        createElementVNode("span", {
          class: normalizeClass({
            "rv-avatar--crossed": _ctx.crossed
          })
        }, null, 2),
        _ctx.showTooltip ? (openBlock(), createBlock(_component_Tooltip, {
          key: 0,
          anchor: "bottom middle",
          "data-automation": _ctx.buildId("tooltip"),
          self: "center middle"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.label), 1)
          ]),
          _: 1
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      _: 3
    }, 16, ["class", "data-automation", "font-size", "icon", "size", "style", "text-color", "onClick"])
  ], 8, _hoisted_1$1k);
}
const Avatar = /* @__PURE__ */ _export_sfc(__default__$4, [["render", _sfc_render$1n], ["__scopeId", "data-v-e5b54de5"]]);
const _sfc_main$1z = defineComponent({
  name: "BackButton",
  components: {
    QIcon: QIcon_default,
    RvButton: Button,
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    collapseWithLeftSidebar: {
      type: Boolean,
      default: false
    },
    defaultRoute: {
      type: [Object, String],
      default: void 0
    },
    directRoute: {
      type: [Object, String],
      default: void 0
    }
  },
  setup(props4) {
    const { showLeftSidebar } = useLayout();
    const {
      getPreviousPageLabel,
      goToPreviousPage
    } = useNavigationHistory(props4.defaultRoute, props4.directRoute);
    const collapse = computed(() => {
      return props4.collapseWithLeftSidebar && !showLeftSidebar.value;
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      collapse,
      goToPreviousPage,
      label: getPreviousPageLabel()
    };
  }
});
const _hoisted_1$1j = ["data-automation"];
const _hoisted_2$13 = {
  key: 0,
  class: "text-no-wrap"
};
function _sfc_render$1m(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_RvButton = resolveComponent("RvButton");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["bg-white rounded-borders q-py-md", {
      "q-px-lg": !_ctx.collapse,
      "flex items-center justify-center": _ctx.collapse
    }]),
    "data-automation": _ctx.buildId("wrapper")
  }, [
    createVNode(_component_RvButton, {
      align: "left",
      class: "no-padding",
      "data-automation": _ctx.buildId(),
      size: "sm",
      tertiary: "",
      onClick: _ctx.goToPreviousPage
    }, {
      default: withCtx(() => [
        createVNode(_component_QIcon, {
          class: normalizeClass({ "q-mr-sm": !_ctx.collapse }),
          name: "mdi-chevron-left",
          size: "1.5rem"
        }, {
          default: withCtx(() => [
            _ctx.collapse ? (openBlock(), createBlock(_component_Tooltip, { key: 0 }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.label), 1)
              ]),
              _: 1
            })) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]),
        !_ctx.collapse ? (openBlock(), createElementBlock("div", _hoisted_2$13, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-automation", "onClick"])
  ], 10, _hoisted_1$1j);
}
const BackButton = /* @__PURE__ */ _export_sfc(_sfc_main$1z, [["render", _sfc_render$1m]]);
const _sfc_main$1y = defineComponent({
  name: "Bullet",
  components: {
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Css color of the bullet border.
     */
    borderColor: {
      type: String,
      default: void 0
    },
    /**
     * Color name for component
     */
    color: {
      type: String,
      default: ""
    },
    /**
     * Render a diagonal line
     */
    crossed: {
      type: Boolean,
      default: false
    },
    /**
     * Render tooltip
     */
    isTooltipShown: {
      type: Boolean,
      default: true
    },
    /**
     * Render label before bullet
     */
    label: {
      type: [Number, String],
      default: void 0
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    labelClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Render a plus sign inside component and hides the label
     */
    more: {
      type: Boolean,
      default: false
    },
    /**
     * Render a plus sign inside component, shows label if any
     */
    moreWithLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Disable rendering a border with a constrasting color
     */
    noContrastBorder: {
      type: Boolean,
      default: false
    },
    /**
     * Show bullet as a circle block
     */
    rounded: {
      type: Boolean,
      default: false
    },
    /**
     * Wrapper size (in px)
     */
    size: {
      type: [Number, String],
      default: 8
    },
    /**
     * Can be used as a "tooltip" property or as a slot
     */
    tooltip: {
      type: String,
      default: void 0
    },
    /**
     * Two values setting the starting position or anchor point of the Tooltip relative to its target
     */
    tooltipAnchor: {
      type: String,
      default: "bottom middle"
    },
    /**
     * The maximum width of the Tooltip; Size in CSS units, including unit name
     */
    tooltipMaxWidth: {
      type: String,
      default: "400px"
    },
    /**
     * Two values setting the Tooltip's own position relative to its target
     */
    tooltipSelf: {
      type: String,
      default: "center middle"
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    const { isDark } = useDarkMode();
    const containerSize = computed(() => {
      if (props4.rounded) return parseInt(props4.size.toString());
      return Math.round(parseInt(props4.size.toString()) * Math.SQRT2);
    });
    const moreBullet = computed(() => props4.more || props4.moreWithLabel);
    const contrastBorderColor = computed(() => {
      if (props4.borderColor) {
        if (props4.borderColor.startsWith("#")) return props4.borderColor;
        return getCssVar(props4.borderColor) ?? void 0;
      }
      if (props4.noContrastBorder) {
        return resolvedColor.value;
      }
      return getContrastColor(
        resolvedColor.value,
        isDark.value ? "transparent" : getCssVar("grey-1") ?? void 0,
        isDark.value ? getCssVar("grey-1") ?? void 0 : "transparent"
      );
    });
    const resolvedColor = computed(() => {
      if (props4.color.startsWith("#")) return props4.color;
      return getCssVar(props4.color) ?? getCssVar("grey-1");
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      containerSize,
      contrastBorderColor,
      moreBullet,
      resolvedColor,
      t: t2
    };
  }
});
const _hoisted_1$1i = ["data-automation"];
const _hoisted_2$12 = ["data-automation"];
const _hoisted_3$R = ["data-automation"];
const _hoisted_4$z = ["data-automation"];
const _hoisted_5$s = {
  key: 0,
  class: "plus"
};
const _hoisted_6$h = {
  key: 1,
  class: "crossed"
};
const _hoisted_7$e = {
  key: 2,
  class: "content-block"
};
function _sfc_render$1l(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createElementBlock("div", {
    class: "flex inline items-center justify-center no-wrap text-center",
    "data-automation": _ctx.buildId(),
    style: normalizeStyle({
      "--container-size": `${_ctx.containerSize}px`,
      "--size": `${_ctx.size}px`
    })
  }, [
    _ctx.label != null && !_ctx.more ? (openBlock(), createElementBlock("span", {
      key: 0,
      class: normalizeClass(["text-body3 text-grey-1 q-mr-xs", _ctx.labelClass]),
      "data-automation": _ctx.buildId("label")
    }, toDisplayString(_ctx.label), 11, _hoisted_2$12)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: "bullet__container relative-position flex items-center justify-center",
      "data-automation": _ctx.buildId("bullet__container")
    }, [
      createElementVNode("div", {
        class: normalizeClass(["bullet inline-block", {
          "bullet--crossed": _ctx.crossed,
          "bullet--more": _ctx.moreBullet,
          "rounded": _ctx.rounded
        }]),
        "data-automation": _ctx.buildId("bullet__container--bullet"),
        style: normalizeStyle({
          ..._ctx.color && { backgroundColor: _ctx.resolvedColor },
          "border": `1px solid ${_ctx.contrastBorderColor} !important`
        })
      }, null, 14, _hoisted_4$z),
      _ctx.moreBullet ? (openBlock(), createElementBlock("div", _hoisted_5$s, toDisplayString(_ctx.t("rvai-base.general.symbols.plus")), 1)) : _ctx.crossed ? (openBlock(), createElementBlock("div", _hoisted_6$h)) : createCommentVNode("", true),
      _ctx.$slots["content"] ? (openBlock(), createElementBlock("div", _hoisted_7$e, [
        renderSlot(_ctx.$slots, "content", {}, void 0, true)
      ])) : createCommentVNode("", true),
      _ctx.isTooltipShown && (_ctx.tooltip || _ctx.moreBullet || _ctx.$slots["tooltip"]) ? (openBlock(), createBlock(_component_Tooltip, {
        key: 3,
        anchor: _ctx.tooltipAnchor,
        "data-automation": _ctx.buildId("tooltip"),
        "max-width": _ctx.tooltipMaxWidth,
        self: _ctx.tooltipSelf
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "tooltip", {}, void 0, true),
          !_ctx.$slots["tooltip"] ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(_ctx.moreBullet ? _ctx.label : _ctx.tooltip), 1)
          ], 64)) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["anchor", "data-automation", "max-width", "self"])) : createCommentVNode("", true)
    ], 8, _hoisted_3$R)
  ], 12, _hoisted_1$1i);
}
const Bullet = /* @__PURE__ */ _export_sfc(_sfc_main$1y, [["render", _sfc_render$1l], ["__scopeId", "data-v-b6cfb40b"]]);
const HISTOGRAM_DEFAULT_SIZE = 276;
const LABEL_MAX_WIDTH = 140;
const MIN_SPACING = 100;
const ROW_DEFAULT_MIN_HEIGHT = 8;
const ROW_DETAILED_MIN_HEIGHT = 20;
const _sfc_main$1x = defineComponent({
  name: "Histogram",
  components: {
    Bullet,
    QInnerLoading: QInnerLoading_default,
    QResizeObserver: QResizeObserver_default,
    QSpace: QSpace_default,
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Displays all info in a row (classNames, percentages, etc)
     */
    detailed: {
      type: Boolean,
      default: false
    },
    /**
     * Bar height
     */
    barHeight: {
      type: Number,
      default: void 0
    },
    /**
     * Classes applied to the Histogram
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Class distribution data
     */
    entries: {
      type: Array,
      required: true
    },
    /**
     * Displays class names and percentages
     */
    full: {
      type: Boolean,
      default: false
    },
    /**
     * Displays spinner
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Component max height
     */
    maxHeight: {
      type: Number,
      default: void 0
    },
    /**
     * Emits 'update:selected' with row.id, when true
     */
    selectable: {
      type: Boolean,
      default: false
    },
    /**
     * v-model:selected; allows handling selected class
     */
    selected: {
      type: String,
      default: void 0
    },
    /**
     * Shows class name or class id
     */
    showName: {
      type: Boolean,
      default: false
    },
    /**
     * Histogram size ('sm' | 'md')
     */
    size: {
      type: String,
      default: "sm"
    }
  },
  emits: [
    /**
     * Emitted when 'selectable' property is true and bar is clicked
     */
    "update:selected"
  ],
  setup(props4, { emit }) {
    const histogramRef = ref$1(null);
    const availableWidth = ref$1(0);
    const { t: t2 } = useI18n();
    const barMargin = computed(() => props4.detailed ? 2 : 1);
    const rowMinHeight = computed(() => props4.detailed ? ROW_DETAILED_MIN_HEIGHT : ROW_DEFAULT_MIN_HEIGHT);
    const rowHeight = computed(() => {
      return Math.max(
        histogramSize.value / props4.entries.length - barMargin.value - (props4.detailed ? barMargin.value : 0),
        rowMinHeight.value
      );
    });
    const computedBarHeight = computed(() => props4.barHeight ?? Math.max(rowHeight.value, ROW_DEFAULT_MIN_HEIGHT));
    const isContentScrollable = computed(() => {
      return rowHeight.value <= rowMinHeight.value;
    });
    const histogramSize = computed(() => {
      var _a;
      return props4.maxHeight || ((_a = histogramRef.value) == null ? void 0 : _a.offsetHeight) || HISTOGRAM_DEFAULT_SIZE;
    });
    const maxCount = computed(() => Math.max(...props4.entries.map((c2) => c2.count)));
    const countLimit = computed(() => last(stepsValues.value) ?? 0);
    const entriesWithSize = computed(() => {
      const max2 = props4.full ? countLimit.value : maxCount.value;
      return props4.entries.map((c2) => {
        const size2 = max2 ? 100 * (c2.count / max2) : 0;
        return {
          ...c2,
          size: `${size2}%`
        };
      });
    });
    const labelWidth = computed(() => {
      if (props4.full) return 24;
      return (computedBarHeight.value >= 16 ? 8 : 4) * 2;
    });
    const hasSquareBackground = computed(() => !props4.full && props4.size === "sm");
    const stepsValues = computed(() => {
      if (!availableWidth.value) return [];
      const stepPow = 10 ** Math.max(0, Math.floor(Math.log10(maxCount.value)));
      const maxSteps = Math.max(1, Math.floor(availableWidth.value / MIN_SPACING));
      const minStepSize = maxCount.value / maxSteps;
      const stepSize = Math.ceil(minStepSize / stepPow) * stepPow;
      const stepsCount = Math.max(1, Math.ceil(maxCount.value / stepSize));
      return Array.from({ length: stepsCount + 1 }).map((_, index) => index * stepSize);
    });
    const steps = computed(() => {
      if (!countLimit.value) return [];
      return stepsValues.value.map((s3) => [
        String(s3),
        // TODO decimal
        `${100 * s3 / countLimit.value}%`
      ]);
    });
    const stepsBars = computed(() => {
      return steps.value.map((p) => p[1]);
    });
    function getBulletSize() {
      return computedBarHeight.value >= 16 || props4.full || props4.detailed ? 8 : 4;
    }
    function isSelected(row) {
      return props4.selected === row.id;
    }
    function isAnnotated(row) {
      return !["null", null].includes(row.id);
    }
    function isEmpty(row) {
      return [""].includes(row.id);
    }
    function onClick(row) {
      if (!props4.selectable) return;
      if (isSelected(row)) {
        emit("update:selected", void 0);
      } else {
        emit("update:selected", row.id);
      }
    }
    function onResize({ width }) {
      availableWidth.value = width - LABEL_MAX_WIDTH;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      barMargin,
      computedBarHeight,
      entriesWithSize,
      getBulletSize,
      hasSquareBackground,
      histogramRef,
      histogramSize,
      isAnnotated,
      isContentScrollable,
      isEmpty,
      isSelected,
      labelWidth,
      onClick,
      onResize,
      steps,
      stepsBars,
      t: t2
    };
  }
});
const _hoisted_1$1h = ["data-automation"];
const _hoisted_2$11 = ["data-automation", "onClick"];
const _hoisted_3$Q = {
  key: 2,
  class: "ellipsis"
};
const _hoisted_4$y = { class: "full-width" };
const _hoisted_5$r = ["data-automation"];
const _hoisted_6$g = {
  key: 0,
  class: "histogram__values row no-wrap items-center q-mx-sm"
};
const _hoisted_7$d = ["data-automation"];
const _hoisted_8$9 = ["data-automation"];
const _hoisted_9$8 = {
  key: 1,
  class: "histogram__pct-bar-wrapper"
};
const _hoisted_10$5 = ["data-automation"];
const _hoisted_11$5 = ["data-automation"];
const _hoisted_12$4 = { class: "histogram__pct-wrapper relative-position col-grow text-right q-pa-xs q-mt-md" };
const _hoisted_13$4 = ["data-automation"];
function _sfc_render$1k(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QInnerLoading = resolveComponent("QInnerLoading");
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  const _component_Bullet = resolveComponent("Bullet");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createElementBlock("div", {
    ref: "histogramRef",
    class: normalizeClass(["histogram relative-position row no-wrap", [
      _ctx.$props.class,
      {
        "bg-grey-5--light bg-grey-1--dark": !_ctx.full && !_ctx.detailed,
        "histogram--custom-height": _ctx.maxHeight,
        "histogram--full": _ctx.full,
        "histogram--min-height": _ctx.loading,
        "histogram--square": _ctx.hasSquareBackground
      }
    ]]),
    "data-automation": _ctx.buildId(),
    style: normalizeStyle({
      "--histogram-size": `${_ctx.histogramSize}px`
    })
  }, [
    createVNode(_component_QInnerLoading, {
      class: "z-top",
      color: "primary",
      "data-automation": _ctx.buildId("loading"),
      showing: _ctx.loading
    }, null, 8, ["data-automation", "showing"]),
    createElementVNode("div", {
      class: normalizeClass(["histogram__wrapper relative-position col", { "histogram__wrapper--scrollable": _ctx.isContentScrollable }]),
      style: normalizeStyle({
        "--bar-height": `${_ctx.computedBarHeight}px`
      })
    }, [
      _ctx.full || _ctx.detailed ? (openBlock(), createBlock(_component_QResizeObserver, {
        key: 0,
        onResize: _ctx.onResize
      }, null, 8, ["onResize"])) : createCommentVNode("", true),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.entriesWithSize, (entry) => {
        return openBlock(), createElementBlock("div", {
          key: entry.id,
          class: normalizeClass(["histogram__entry row no-wrap", {
            "cursor-pointer": _ctx.selectable,
            "histogram__entry--full": _ctx.full,
            "histogram__entry--detailed": _ctx.detailed,
            "histogram__entry--selected": _ctx.isSelected(entry)
          }]),
          "data-automation": _ctx.buildId(`entry-${entry.id}`),
          style: normalizeStyle({
            "--bar-margin": `${_ctx.barMargin}px`,
            "--color": entry.color,
            "--entries-count": _ctx.entries.length,
            "--entry-min-height": _ctx.full || _ctx.detailed ? "20px" : `${_ctx.barHeight}px`,
            "--entry-size": entry.size
          }),
          onClick: ($event) => _ctx.onClick(entry)
        }, [
          createElementVNode("div", {
            class: normalizeClass(["histogram__label row items-center text-small text-bold col-fixed", [
              { "histogram__label--full q-pr-sm": _ctx.full || _ctx.detailed },
              { "q-ml-sm": _ctx.detailed },
              _ctx.full || _ctx.detailed || _ctx.isAnnotated(entry) ? "q-pr-sm" : "q-pr-xs"
            ]]),
            style: normalizeStyle({ ...!_ctx.full && !_ctx.detailed && { width: `${_ctx.labelWidth}px` } })
          }, [
            createElementVNode("div", {
              class: "row items-center no-wrap zero-min-width",
              style: normalizeStyle({ fontSize: _ctx.full || _ctx.detailed ? "inherit" : "6px" })
            }, [
              _ctx.isAnnotated(entry) ? (openBlock(), createBlock(_component_Bullet, {
                key: 0,
                class: "col-fixed q-mr-xs",
                color: entry.color,
                crossed: _ctx.isEmpty(entry),
                "data-automation": _ctx.buildId("bullet"),
                size: _ctx.getBulletSize()
              }, null, 8, ["color", "crossed", "data-automation", "size"])) : createCommentVNode("", true),
              entry.id === "null" ? (openBlock(), createElementBlock("div", {
                key: 1,
                style: normalizeStyle({ width: `${_ctx.labelWidth}px` })
              }, null, 4)) : createCommentVNode("", true),
              _ctx.full || _ctx.detailed ? (openBlock(), createElementBlock("div", _hoisted_3$Q, toDisplayString(_ctx.showName ? entry.name : entry.id === "null" ? _ctx.t("rvai-base.components.histogram.noLabel") : entry.id), 1)) : createCommentVNode("", true)
            ], 4)
          ], 6),
          createElementVNode("div", _hoisted_4$y, [
            createElementVNode("div", {
              class: normalizeClass(["histogram__bar relative-position z-fab", {
                "histogram__bar--none": !_ctx.isAnnotated(entry),
                "histogram__bar--empty": _ctx.isEmpty(entry)
              }]),
              "data-automation": _ctx.buildId(`entry__bar--${entry.id}`)
            }, null, 10, _hoisted_5$r)
          ]),
          _ctx.detailed ? (openBlock(), createElementBlock("div", _hoisted_6$g, [
            createElementVNode("div", {
              class: "histogram__count text-bold",
              "data-automation": _ctx.buildId(`entry__count--${entry.id}`)
            }, toDisplayString(entry.count), 9, _hoisted_7$d),
            createVNode(_component_QSpace),
            createElementVNode("div", {
              class: "histogram__percentage q-ml-xs row items-center justify-end",
              "data-automation": _ctx.buildId(`entry__percentage--${entry.id}`)
            }, toDisplayString(entry.pct), 9, _hoisted_8$9)
          ])) : createCommentVNode("", true),
          _ctx.$slots["tooltip"] ? (openBlock(), createBlock(_component_Tooltip, {
            key: 1,
            anchor: "center left",
            "data-automation": _ctx.buildId("tooltip"),
            offset: [_ctx.full ? -150 : -20, 0],
            self: "center left"
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "tooltip", { entry }, void 0, true)
            ]),
            _: 2
          }, 1032, ["data-automation", "offset"])) : createCommentVNode("", true)
        ], 14, _hoisted_2$11);
      }), 128)),
      _ctx.full ? (openBlock(), createElementBlock("div", _hoisted_9$8, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.stepsBars, (left, index) => {
          return openBlock(), createElementBlock("div", {
            key: index,
            class: "histogram__pct-bar",
            "data-automation": _ctx.buildId(`bar-${index}`),
            style: normalizeStyle({ "left": left })
          }, null, 12, _hoisted_10$5);
        }), 128))
      ])) : createCommentVNode("", true),
      _ctx.full ? (openBlock(), createElementBlock("div", {
        key: 2,
        class: "histogram__footer",
        "data-automation": _ctx.buildId("footer")
      }, [
        createElementVNode("div", _hoisted_12$4, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.steps, ([count, left], index) => {
            return openBlock(), createElementBlock("div", {
              key: index,
              class: "histogram__pct text-bold text-grey-1",
              "data-automation": _ctx.buildId(`step-${index}`),
              style: normalizeStyle({ "left": left })
            }, toDisplayString(count), 13, _hoisted_13$4);
          }), 128))
        ])
      ], 8, _hoisted_11$5)) : createCommentVNode("", true)
    ], 6)
  ], 14, _hoisted_1$1h);
}
const BarChart = /* @__PURE__ */ _export_sfc(_sfc_main$1x, [["render", _sfc_render$1k], ["__scopeId", "data-v-d010ab71"]]);
const _sfc_main$1w = defineComponent({
  name: "Separator",
  inheritAtttrs: false,
  components: {
    QSeparator: QSeparator_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "separator"
    },
    /**
     * Dark theme color name for component from the Quasar Color Palette
     */
    colorDark: {
      type: String,
      default: "grey-2--dark"
    },
    /**
     * Light theme color name for component from the Quasar Color Palette
     */
    colorLight: {
      type: String,
      default: "grey-3--light"
    },
    /**
     * If set to true, the separator will be vertical
     */
    vertical: {
      type: Boolean,
      default: false
    }
  },
  setup(props4) {
    const { isDark } = useDarkMode();
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      isDark
    };
  }
});
function _sfc_render$1j(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QSeparator = resolveComponent("QSeparator");
  return openBlock(), createBlock(_component_QSeparator, {
    color: _ctx.isDark ? _ctx.colorDark : _ctx.colorLight,
    "data-automation": _ctx.buildId(),
    vertical: _ctx.vertical
  }, null, 8, ["color", "data-automation", "vertical"]);
}
const Separator = /* @__PURE__ */ _export_sfc(_sfc_main$1w, [["render", _sfc_render$1j]]);
const _sfc_main$1v = defineComponent({
  name: "Card",
  components: {
    QMenu: QMenu_default,
    RvButton: Button,
    Separator
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Separator animated on hover,
     * if false - only when component is clickable
     */
    alwaysAnimated: {
      type: Boolean,
      default: true
    },
    /**
     * Text displayed in description
     */
    description: {
      type: String,
      default: ""
    },
    /**
     * Text displayed in title
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Equivalent to Vue Router <router-link> 'to' property
     */
    to: {
      type: [Object, String],
      default: void 0
    }
  },
  setup(props4) {
    const headerHover = ref$1(false);
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      headerHover,
      RouterLink
    };
  }
});
const _hoisted_1$1g = ["data-automation"];
const _hoisted_2$10 = { class: "column" };
const _hoisted_3$P = ["data-automation"];
const _hoisted_4$x = ["data-automation"];
function _sfc_render$1i(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QMenu = resolveComponent("QMenu");
  const _component_RvButton = resolveComponent("RvButton");
  const _component_Separator = resolveComponent("Separator");
  return openBlock(), createElementBlock("div", {
    class: "rounded-borders bg-grey-5 q-pa-md",
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", {
      class: normalizeClass(["card column relative-position", {
        "card--animated": _ctx.alwaysAnimated
      }])
    }, [
      _ctx.$slots["actions"] || _ctx.$slots["header"] || _ctx.title || _ctx.description ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.to && !_ctx.$slots["content"] ? _ctx.RouterLink : "div"), {
        key: 0,
        class: normalizeClass(["card__header row justify-between items-start q-pa-md", {
          "card__header--animated": _ctx.to && !_ctx.$slots["content"] && !_ctx.$slots["actions"] && !_ctx.$slots["header"],
          "card__header--clickable": _ctx.to && !_ctx.$slots["content"]
        }]),
        to: _ctx.to,
        onMouseout: _cache[1] || (_cache[1] = ($event) => _ctx.headerHover = false),
        onMouseover: _cache[2] || (_cache[2] = ($event) => _ctx.headerHover = true)
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "header", {}, () => [
            createElementVNode("div", _hoisted_2$10, [
              createElementVNode("div", {
                class: "text-subtitle3 text-black-1",
                "data-automation": _ctx.buildId("title")
              }, toDisplayString(_ctx.title), 9, _hoisted_3$P),
              createElementVNode("div", {
                "data-automation": _ctx.buildId("description")
              }, toDisplayString(_ctx.description), 9, _hoisted_4$x)
            ])
          ], true),
          _ctx.$slots["actions"] ? (openBlock(), createBlock(_component_RvButton, {
            key: 0,
            class: "card__dots no-padding absolute",
            color: "grey-1",
            "data-automation": _ctx.buildId("actions"),
            icon: "mdi-dots-horizontal",
            tertiary: "",
            onClick: _cache[0] || (_cache[0] = withModifiers(() => {
            }, ["stop", "prevent"]))
          }, {
            default: withCtx(() => [
              createVNode(_component_QMenu, { "auto-close": "" }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "actions", {}, void 0, true)
                ]),
                _: 3
              })
            ]),
            _: 3
          }, 8, ["data-automation"])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 40, ["class", "to"])) : createCommentVNode("", true),
      _ctx.$slots["content"] ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.to ? _ctx.RouterLink : "div"), {
        key: 1,
        class: "card__content",
        to: _ctx.to
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "content", {}, void 0, true)
        ]),
        _: 3
      }, 8, ["to"])) : createCommentVNode("", true),
      _ctx.$slots["bottom"] ? (openBlock(), createBlock(_component_Separator, {
        key: 2,
        class: "card__separator q-mx-md",
        color: "grey-3"
      })) : createCommentVNode("", true),
      _ctx.$slots["bottom"] ? (openBlock(), createElementBlock("div", {
        key: 3,
        class: "card__content-bottom",
        onClick: _cache[3] || (_cache[3] = withModifiers(() => {
        }, ["stop", "prevent"]))
      }, [
        renderSlot(_ctx.$slots, "bottom", {}, void 0, true)
      ])) : createCommentVNode("", true)
    ], 2)
  ], 8, _hoisted_1$1g);
}
const Card = /* @__PURE__ */ _export_sfc(_sfc_main$1v, [["render", _sfc_render$1i], ["__scopeId", "data-v-54432239"]]);
const _sfc_main$1u = defineComponent({
  name: "CardImage",
  components: {
    QImg: QImg_default,
    QSkeleton: QSkeleton_default
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Component height
     */
    height: {
      type: String,
      default: "101px"
    },
    /**
     * An image for a specific project type
     */
    imageUrl: {
      type: String,
      default: void 0
    },
    /**
     * Render skeleton
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Default image. Shown when "imageUrl" and "thumbnailUrl" do not exist.
     * Or when both of them are loaded with error.
     */
    noImageUrl: {
      type: String,
      required: true
    },
    /**
     * Default image.Thumbnail for dataset
     */
    thumbnailUrl: {
      type: String,
      default: null
    }
  },
  setup(props4) {
    const thumbnailError = ref$1(false);
    const backgroundColor = computed(() => props4.imageUrl ? "var(--q-grey-5-fixed)" : "var(--q-grey-5)");
    const backgroundImage = computed(() => {
      if (props4.thumbnailUrl || props4.imageUrl) return void 0;
      return `url("${props4.noImageUrl}")`;
    });
    function onThumbnailError() {
      thumbnailError.value = true;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      backgroundColor,
      backgroundImage,
      onThumbnailError,
      thumbnailError
    };
  }
});
const _hoisted_1$1f = ["data-automation"];
function _sfc_render$1h(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QImg = resolveComponent("QImg");
  const _component_QSkeleton = resolveComponent("QSkeleton");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: "card-image relative-position",
    "data-automation": _ctx.buildId(),
    style: {
      "background-color": _ctx.backgroundColor,
      "background-image": _ctx.backgroundImage,
      "height": _ctx.height
    }
  }), [
    _ctx.thumbnailUrl && !_ctx.thumbnailError ? (openBlock(), createBlock(_component_QImg, {
      key: 0,
      "data-automation": _ctx.buildId("thumbnailImage"),
      fit: "cover",
      height: _ctx.height,
      src: _ctx.thumbnailUrl,
      onError: _ctx.onThumbnailError
    }, null, 8, ["data-automation", "height", "src", "onError"])) : _ctx.imageUrl ? (openBlock(), createBlock(_component_QImg, {
      key: 1,
      "data-automation": _ctx.buildId("image"),
      "error-src": _ctx.noImageUrl,
      fit: "contain",
      height: _ctx.height,
      src: _ctx.imageUrl
    }, null, 8, ["data-automation", "error-src", "height", "src"])) : createCommentVNode("", true),
    _ctx.loading ? (openBlock(), createBlock(_component_QSkeleton, {
      key: 2,
      class: "absolute-full",
      "data-automation": _ctx.buildId("skeleton"),
      square: ""
    }, null, 8, ["data-automation"])) : createCommentVNode("", true)
  ], 16, _hoisted_1$1f);
}
const CardImage = /* @__PURE__ */ _export_sfc(_sfc_main$1u, [["render", _sfc_render$1h], ["__scopeId", "data-v-8858407a"]]);
const __default__$3 = defineComponent({
  name: "CardItem",
  components: {
    QIcon: QIcon_default,
    QMenu: QMenu_default,
    RvButton: Button
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Background color name for component from the Quasar Color Palette
     */
    backgroundColor: {
      type: String,
      default: "grey-5"
    },
    /**
     * Text displayed in description
     */
    description: {
      type: String,
      default: ""
    },
    /**
     * Allow to hover component via prop
     */
    forceHover: {
      type: Boolean,
      default: false
    },
    /**
     * Showing without padding and disabled padding
     */
    inline: {
      type: Boolean,
      default: false
    },
    /**
     * Hide arrow right icon
     */
    hideIcon: {
      type: Boolean,
      default: false
    },
    /**
     * Text displayed in title
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Equivalent to Vue Router <router-link> 'to' property
     */
    to: {
      type: [Object, String],
      default: void 0
    }
  },
  setup(props4) {
    const borderColor = computed(() => props4.backgroundColor ? getCssVar(props4.backgroundColor) ?? "transparent" : "transparent");
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      borderColor,
      RouterLink
    };
  }
});
const __injectCSSVars__$3 = () => {
  useCssVars((_ctx) => ({
    "v8aae5146": _ctx.borderColor
  }));
};
const __setup__$3 = __default__$3.setup;
__default__$3.setup = __setup__$3 ? (props4, ctx) => {
  __injectCSSVars__$3();
  return __setup__$3(props4, ctx);
} : __injectCSSVars__$3;
const _hoisted_1$1e = ["data-automation"];
const _hoisted_2$$ = ["data-automation"];
const _hoisted_3$O = { class: "column" };
const _hoisted_4$w = ["data-automation"];
const _hoisted_5$q = ["data-automation"];
function _sfc_render$1g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QMenu = resolveComponent("QMenu");
  const _component_RvButton = resolveComponent("RvButton");
  const _component_QIcon = resolveComponent("QIcon");
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.to ? _ctx.RouterLink : "div"), {
    class: normalizeClass(["card-item row justify-between items-center no-wrap rounded-borders", {
      "card-item--force-hover": _ctx.forceHover,
      "card-item--animated-border q-pa-md": !_ctx.inline,
      [`bg-${_ctx.backgroundColor}`]: !!_ctx.backgroundColor
    }]),
    "data-automation": _ctx.buildId(),
    to: _ctx.to
  }, {
    default: withCtx(() => [
      createElementVNode("div", {
        class: "row items-center col",
        "data-automation": _ctx.buildId("content-wrapper")
      }, [
        renderSlot(_ctx.$slots, "prepend", {}, void 0, true),
        createElementVNode("div", {
          class: "card-item__content col",
          "data-automation": _ctx.buildId("content")
        }, [
          renderSlot(_ctx.$slots, "content", {}, () => [
            createElementVNode("div", _hoisted_3$O, [
              createElementVNode("div", {
                class: "text-subtitle3 text-black-1",
                "data-automation": _ctx.buildId("title")
              }, toDisplayString(_ctx.title), 9, _hoisted_4$w),
              createElementVNode("div", {
                "data-automation": _ctx.buildId("description")
              }, toDisplayString(_ctx.description), 9, _hoisted_5$q)
            ])
          ], true)
        ], 8, _hoisted_2$$)
      ], 8, _hoisted_1$1e),
      _ctx.$slots["actions"] ? (openBlock(), createBlock(_component_RvButton, {
        key: 0,
        class: "card-item__dots self-start",
        color: "black-1",
        "data-automation": _ctx.buildId("actions"),
        icon: "mdi-dots-horizontal",
        tertiary: "",
        onClick: _cache[0] || (_cache[0] = withModifiers(() => {
        }, ["stop", "prevent"]))
      }, {
        default: withCtx(() => [
          createVNode(_component_QMenu, { "auto-close": "" }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "actions", {}, void 0, true)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["data-automation"])) : createCommentVNode("", true),
      !_ctx.hideIcon && !_ctx.$slots["actions"] ? (openBlock(), createBlock(_component_QIcon, {
        key: 1,
        class: "card-item__chevron",
        color: "black-1",
        "data-automation": _ctx.buildId("chevron-icon"),
        name: "mdi-chevron-right",
        size: "24px"
      }, null, 8, ["data-automation"])) : createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class", "data-automation", "to"]);
}
const CardItem = /* @__PURE__ */ _export_sfc(__default__$3, [["render", _sfc_render$1g], ["__scopeId", "data-v-88f954b4"]]);
const _hoisted_1$1d = ["data-automation"];
const _hoisted_2$_ = ["data-automation"];
const _hoisted_3$N = ["data-automation"];
const _hoisted_4$v = ["data-automation"];
const _hoisted_5$p = ["data-automation"];
const _sfc_main$1t = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "Carousel",
  props: {
    alignLeft: { type: Boolean, default: false },
    backgroundColor: { default: "white" },
    class: {},
    dataAutomation: {},
    draggable: { type: Boolean, default: false },
    draggableItemKey: { default: "id" },
    fixedSlideWidth: {},
    gap: { default: 16 },
    items: {},
    maxWidthPerSlide: { default: 608 },
    minWidthPerSlide: { default: 260 },
    showControls: { type: Boolean, default: true },
    singleSampleUsesAllSpace: { type: Boolean, default: false },
    transitionTime: { default: "0.5s" }
  },
  emits: ["reorder", "resize"],
  setup(__props, { expose: __expose, emit: __emit }) {
    useCssVars((_ctx) => ({
      "v213382d7": justifyContent.value
    }));
    const emit = __emit;
    const {
      buildId,
      dataAttrs
    } = useAutomation(computed(() => __props.dataAutomation));
    const { isDark } = useDarkMode();
    const carouselObserverWidth = ref$1(0);
    const carouselRef = useTemplateRef("carouselRef");
    const carouselWidth = ref$1(void 0);
    const currentIndex = ref$1(0);
    const justifyContent = ref$1("normal");
    const slideMaxWidth = ref$1(__props.maxWidthPerSlide);
    const slidesLeftSpace = ref$1(void 0);
    const slidesPerPage = ref$1(1);
    const slidesRef = ref$1(null);
    const slideWidth = ref$1(0);
    const draggedItem = ref$1();
    const sortedItems = computed({
      get() {
        return __props.items;
      },
      set(value2) {
        emit("reorder", value2, draggedItem.value);
      }
    });
    const hidedButtons = computed(() => slidesPerPage.value === __props.items.length);
    const disablePreviousButton = computed(() => !currentIndex.value);
    const disableNextButton = computed(
      () => currentIndex.value === __props.items.length - slidesPerPage.value
    );
    const translatePosition = computed(
      () => currentIndex.value * (slideWidth.value + __props.gap)
    );
    const slideMinWidth = computed(() => __props.fixedSlideWidth ?? __props.minWidthPerSlide);
    function calcCarouselWithFixedSlides() {
      if (!carouselRef.value || !__props.fixedSlideWidth) return;
      const availableSlidesPerPage = Math.floor(
        (carouselRef.value.offsetWidth + __props.gap) / (__props.fixedSlideWidth + __props.gap)
      );
      const hasHiddenSlides = availableSlidesPerPage < __props.items.length;
      slidesPerPage.value = hasHiddenSlides ? availableSlidesPerPage : __props.items.length;
      slideWidth.value = __props.fixedSlideWidth;
      justifyContent.value = hasHiddenSlides || __props.alignLeft ? "normal" : "center";
      const freeSpace = carouselRef.value.offsetWidth - availableSlidesPerPage * slideWidth.value - __props.gap * (availableSlidesPerPage - 1);
      carouselWidth.value = hasHiddenSlides ? carouselRef.value.offsetWidth - freeSpace : void 0;
      slidesLeftSpace.value = hasHiddenSlides ? freeSpace / 2 : void 0;
    }
    function calcSlideMaxWidth() {
      if (carouselRef.value) {
        if (__props.items.length === 1 && __props.singleSampleUsesAllSpace) {
          slideMaxWidth.value = carouselRef.value.offsetWidth;
        } else {
          const maxWidth = carouselRef.value.offsetWidth / 2 - __props.gap / 2;
          slideMaxWidth.value = maxWidth >= __props.minWidthPerSlide ? maxWidth : __props.maxWidthPerSlide;
        }
      }
    }
    function calcSlideWidth() {
      if (carouselRef.value) {
        const slidesPerPageWithoutSpaces = Math.floor(
          carouselRef.value.offsetWidth / __props.minWidthPerSlide
        );
        const spacesWidth = __props.gap * (slidesPerPageWithoutSpaces - 1);
        const slidesPerPageWithSpaces = Math.floor(
          carouselRef.value.offsetWidth / (__props.minWidthPerSlide + spacesWidth)
        );
        slidesPerPage.value = slidesPerPageWithSpaces > __props.items.length ? __props.items.length : slidesPerPageWithSpaces;
        slideWidth.value = Math.floor(
          (carouselRef.value.offsetWidth - (slidesPerPage.value - 1) * __props.gap) / slidesPerPage.value
        );
      } else {
        slideWidth.value = 0;
      }
    }
    function onNext() {
      if (currentIndex.value !== __props.items.length - slidesPerPage.value) {
        currentIndex.value += 1;
      }
    }
    function onPrev() {
      if (currentIndex.value !== 0) {
        currentIndex.value -= 1;
      }
    }
    function resizeSlide(width) {
      emit("resize");
      calcSlideMaxWidth();
      if (__props.fixedSlideWidth) {
        calcCarouselWithFixedSlides();
      } else {
        calcSlideWidth();
      }
      if (!width || width !== carouselObserverWidth.value) {
        currentIndex.value = 0;
        if (width) {
          carouselObserverWidth.value = width;
        }
      }
    }
    function onStart(e2) {
      draggedItem.value = e2.data;
    }
    const resizeObserver = new ResizeObserver((entry) => {
      var _a;
      return resizeSlide((_a = entry[0]) == null ? void 0 : _a.contentRect.width);
    });
    watch(
      () => __props.fixedSlideWidth,
      () => {
        resizeSlide();
      }
    );
    watch(
      () => __props.items.length,
      () => {
        resizeSlide();
      }
    );
    onMounted(() => {
      resizeSlide();
      if (carouselRef.value) resizeObserver.observe(carouselRef.value);
    });
    onUnmounted(() => {
      resizeObserver.disconnect();
    });
    __expose({
      carouselRef,
      disableNextButton,
      disablePreviousButton,
      onNext,
      onPrev,
      slideWidth,
      translatePosition
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(unref(dataAttrs), {
        ref_key: "carouselRef",
        ref: carouselRef,
        class: ["rv-carousel relative-position", [_ctx.$props.class, `bg-${__props.backgroundColor}`]],
        "data-automation": unref(buildId)()
      }), [
        createElementVNode("div", {
          class: "rv-carousel__slides relative-position",
          "data-automation": unref(buildId)("slides"),
          style: normalizeStyle({
            ...!__props.alignLeft && carouselWidth.value && { width: `${carouselWidth.value}px` },
            ...!__props.alignLeft && slidesLeftSpace.value && { marginLeft: `${slidesLeftSpace.value}px` }
          })
        }, [
          createVNode(unref(QTabs_default), {
            class: "rv-carousel__tabs",
            shrink: "",
            stretch: ""
          }, {
            default: withCtx(() => [
              __props.draggable ? (openBlock(), createBlock(unref(VueDraggable), {
                key: 0,
                ref_key: "slidesRef",
                ref: slidesRef,
                modelValue: sortedItems.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => sortedItems.value = $event),
                class: "row no-wrap items-center self-stretch hide-scrollbar",
                "data-automation": unref(buildId)("slides--draggable"),
                style: normalizeStyle({
                  transform: `translate(-${translatePosition.value}px, 0)`,
                  transition: __props.transitionTime
                }),
                onStart
              }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(sortedItems.value, (item, index) => {
                    return openBlock(), createElementBlock("div", {
                      key: (item == null ? void 0 : item[__props.draggableItemKey]) ?? index,
                      class: normalizeClass(["rv-carousel__slide rv-carousel__slide--draggable", { "rv-carousel__slide--draggable__dark": unref(isDark) }]),
                      "data-automation": unref(buildId)(`slide${index}`),
                      style: normalizeStyle({
                        "margin-right": index === sortedItems.value.length - 1 ? 0 : `${__props.gap}px`,
                        "max-width": `${slideWidth.value ?? slideMaxWidth.value}px`,
                        "min-width": `${slideWidth.value ?? slideMinWidth.value}px`,
                        width: `${slideWidth.value ?? slideWidth.value}px`
                      })
                    }, [
                      renderSlot(_ctx.$slots, "slide", {
                        index,
                        item
                      }, void 0, true)
                    ], 14, _hoisted_3$N);
                  }), 128))
                ]),
                _: 3
              }, 8, ["modelValue", "data-automation", "style"])) : (openBlock(), createElementBlock("div", {
                key: 1,
                ref_key: "slidesRef",
                ref: slidesRef,
                class: "row no-wrap items-center self-stretch hide-scrollbar",
                style: normalizeStyle({
                  transform: `translate(-${translatePosition.value}px, 0)`,
                  transition: __props.transitionTime
                })
              }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(__props.items, (item, index) => {
                  return openBlock(), createElementBlock("div", {
                    key: index,
                    class: "rv-carousel__slide",
                    "data-automation": unref(buildId)(`slide${index}`),
                    style: normalizeStyle({
                      "margin-right": index === __props.items.length - 1 ? 0 : `${__props.gap}px`,
                      "max-width": `${slideWidth.value ?? slideMaxWidth.value}px`,
                      "min-width": `${slideWidth.value ?? slideMinWidth.value}px`,
                      width: `${slideWidth.value ?? slideWidth.value}px`
                    })
                  }, [
                    renderSlot(_ctx.$slots, "slide", {
                      index,
                      item
                    }, void 0, true)
                  ], 12, _hoisted_4$v);
                }), 128))
              ], 4))
            ]),
            _: 3
          })
        ], 12, _hoisted_2$_),
        __props.showControls ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "rv-carousel__control flex row space-between full-width",
          "data-automation": unref(buildId)("control")
        }, [
          createVNode(unref(QBtn_default), {
            class: normalizeClass(["rv-carousel__button rv-carousel__button--left", {
              hidden: hidedButtons.value
            }]),
            color: "white",
            "data-automation": unref(buildId)("prev"),
            dense: "",
            disabled: disablePreviousButton.value,
            icon: "chevron_left",
            "text-color": "black-1",
            onClick: onPrev,
            onDragover: onPrev
          }, null, 8, ["class", "data-automation", "disabled"]),
          createVNode(unref(QBtn_default), {
            class: normalizeClass(["rv-carousel__button rv-carousel__button--right", {
              hidden: hidedButtons.value
            }]),
            color: "white",
            "data-automation": unref(buildId)("next"),
            dense: "",
            disabled: disableNextButton.value,
            icon: "chevron_right",
            "text-color": "black-1",
            onClick: onNext,
            onDragover: onNext
          }, null, 8, ["class", "data-automation", "disabled"])
        ], 8, _hoisted_5$p)) : createCommentVNode("", true)
      ], 16, _hoisted_1$1d);
    };
  }
});
const Carousel = /* @__PURE__ */ _export_sfc(_sfc_main$1t, [["__scopeId", "data-v-ffc14817"]]);
const _hoisted_1$1c = ["data-automation", "stroke"];
const _sfc_main$1s = /* @__PURE__ */ defineComponent({
  __name: "ChartLineIndicator",
  props: {
    color: {
      required: true,
      type: String
    },
    dataAutomation: {
      default: "chart-line-indicator",
      type: String
    },
    lineStyle: {
      default: "solid",
      type: String
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", {
        class: normalizeClass(["chart-line-indicator", `chart-line-indicator--${__props.lineStyle}`]),
        "data-automation": unref(buildId)(),
        stroke: __props.color,
        viewBox: "0 0 16 2",
        xmlns: "http://www.w3.org/2000/svg"
      }, [..._cache[0] || (_cache[0] = [
        createElementVNode("path", { d: "M0,1 H 100" }, null, -1)
      ])], 10, _hoisted_1$1c);
    };
  }
});
const _hoisted_1$1b = ["data-automation"];
const _hoisted_2$Z = { key: 0 };
const _sfc_main$1r = /* @__PURE__ */ defineComponent({
  __name: "ChartTooltipContent",
  props: {
    dataAutomation: {
      default: "chart-tooltip-content",
      type: String
    },
    items: {
      default: void 0,
      type: Array
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("table", {
        class: "chart-tooltip-content q-ma-none",
        "data-automation": unref(buildId)()
      }, [
        createElementVNode("tbody", null, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.items, (item, itemIndex) => {
            return openBlock(), createElementBlock(Fragment, { key: itemIndex }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(item.lines, (line, lineIndex) => {
                var _a;
                return openBlock(), createElementBlock("tr", {
                  key: `${line}-${lineIndex}`
                }, [
                  createElementVNode("td", null, [
                    lineIndex == 0 ? (openBlock(), createBlock(_sfc_main$1s, {
                      key: 0,
                      color: item.color,
                      "data-automation": unref(buildId)("indicator"),
                      "line-style": item.lineStyle
                    }, null, 8, ["color", "data-automation", "line-style"])) : createCommentVNode("", true)
                  ]),
                  createElementVNode("td", null, [
                    ((_a = item.highlightedLineIndices) == null ? void 0 : _a.includes(lineIndex)) ? (openBlock(), createElementBlock("b", _hoisted_2$Z, toDisplayString(line), 1)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                      createTextVNode(toDisplayString(line), 1)
                    ], 64))
                  ])
                ]);
              }), 128))
            ], 64);
          }), 128))
        ])
      ], 8, _hoisted_1$1b);
    };
  }
});
const _hoisted_1$1a = ["data-automation"];
const _hoisted_2$Y = ["data-automation"];
const _sfc_main$1q = /* @__PURE__ */ defineComponent({
  __name: "ChartTooltip",
  props: {
    caret: {
      default: () => ({
        x: 0,
        y: 0
      }),
      type: Object
    },
    chart: {
      default: void 0,
      type: Object
    },
    dataAutomation: {
      default: "chart-tooltip",
      type: String
    },
    items: {
      default: void 0,
      type: Array
    }
  },
  setup(__props) {
    const props4 = __props;
    const {
      caret,
      chart
    } = toRefs(props4);
    const { buildId } = useAutomation(props4.dataAutomation);
    const { style } = useChartTooltip(chart, caret);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        createElementVNode("div", {
          ref: "tooltipGhost",
          class: "chart-tooltip chart-tooltip--ghost",
          "data-automation": unref(buildId)("ghost")
        }, [
          createVNode(_sfc_main$1r, {
            "data-automation": unref(buildId)("ghost-content"),
            items: __props.items
          }, null, 8, ["data-automation", "items"])
        ], 8, _hoisted_1$1a),
        createElementVNode("div", {
          class: "chart-tooltip",
          "data-automation": unref(buildId)(),
          style: normalizeStyle(unref(style))
        }, [
          createVNode(_sfc_main$1r, { items: __props.items }, null, 8, ["items"])
        ], 12, _hoisted_2$Y)
      ]);
    };
  }
});
Chart$1.register(
  Filler,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Tooltip$1
);
const _sfc_main$1p = defineComponent({
  name: "Chart",
  components: {
    Bullet,
    ChartTooltip: _sfc_main$1q
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    chart: {
      type: Object,
      required: true
    },
    entries: {
      type: Array,
      default: () => []
    },
    interpolate: {
      default: false,
      type: Boolean
    },
    fill: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    maintainAspectRatio: {
      type: Boolean,
      default: false
    },
    max: {
      type: Object,
      default: void 0
    },
    min: {
      type: Object,
      default: void 0
    },
    noLegend: {
      type: Boolean,
      default: false
    },
    relativeTime: {
      type: Boolean,
      default: false
    },
    /**
    * Maximum rotation for tick labels when rotating to condense labels. Note: Rotation doesn't occur until necessary. Note: Only applicable to horizontal scales.
    * https://www.chartjs.org/docs/3.5.1/axes/cartesian/#common-tick-options-to-all-cartesian-axes
    * @default 50
    */
    labelMaxRotation: {
      type: Number,
      default: 50
    },
    showAxisLabels: {
      type: Boolean,
      default: false
    },
    xAxisTimeDisplayFormats: {
      default: void 0,
      type: Object
    },
    xAxisMaxTicksLimit: {
      default: void 0,
      type: Number
    },
    /**
     * Allows adding custom formatting for each tooltip field value. Useful in situations where we don't want to modify the entry's data.
     *
     * Example use cases:
     *  - A field that is used as an axis value but contains large numbers that we want to format inside the tooltip (eg. 2,000,000).
     *  - Formatting data of all the entries causes performance issues.
     */
    tooltipFieldFormat: {
      default: void 0,
      type: Object
    },
    /**
     * Allows specifying fields to be rendered in bold.
     */
    tooltipHighlightedFields: {
      default: () => [],
      type: Array
    },
    /**
     * Allows specifying fields order for the tooltip (listed fields will be on top, rest will be sorted alphabetically).
     */
    tooltipPinnedFields: {
      default: () => [],
      type: Array
    },
    width: {
      type: String,
      default: "200"
    }
  },
  setup(props4) {
    const { isDark } = useDarkMode();
    const chartRef = ref$1(null);
    const show = computed(() => props4.entries.length);
    let chartInstance;
    const isShowTooltip = ref$1(false);
    const tooltipData = ref$1(null);
    const colors = computed(() => {
      return props4.entries.reduce((acc, entry, index) => ({
        ...acc,
        [entry.key]: entry.color || getColor(index)
      }), {});
    });
    const chartDatasetsParams = computed(() => ({
      chart: props4.chart,
      colors,
      entries: props4.entries,
      fill: props4.fill,
      interpolate: props4.interpolate,
      relativeTime: props4.relativeTime
    }));
    const datasets = useChartDatasets({
      chartRef,
      params: chartDatasetsParams
    });
    const tooltipIgnoredFields = computed(() => {
      return props4.entries.flatMap((entry) => entry.ignoreTooltipFields ?? []);
    });
    const tooltipEntries = computed(() => {
      const { chart } = props4;
      return props4.entries.map((entry) => entry.data.map((data) => {
        const dataFields = Object.entries(data).map(([key, value2]) => {
          var _a;
          return {
            key,
            label: ((_a = chart.labels) == null ? void 0 : _a[key]) ?? key,
            value: value2
          };
        }).filter((field) => !tooltipIgnoredFields.value.includes(field.key));
        const sortedFields = [...dataFields, ...entry.extraFields ?? []].sort((itemA, itemB) => {
          const indexA = props4.tooltipPinnedFields.indexOf(itemA.key);
          const indexB = props4.tooltipPinnedFields.indexOf(itemB.key);
          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
          }
          if (indexA !== -1) return -1;
          if (indexB !== -1) return 1;
          return itemA.label.localeCompare(itemB.label);
        });
        return sortedFields;
      }));
    });
    const tooltipHighlightedLineIndices = computed(
      () => tooltipEntries.value.map(
        (dataset) => dataset.map(
          (dataPoint) => dataPoint.map((field, index) => [field, index]).filter(([field]) => props4.tooltipHighlightedFields.includes(field.key)).map(([, index]) => index + 1)
          // +1 to account for entry name
        )
      )
    );
    const tooltipLines = computed(
      () => tooltipEntries.value.map((dataset, datasetIndex) => dataset.map((dataPoint) => dataPoint.map((field) => {
        var _a;
        if ((_a = props4.tooltipFieldFormat) == null ? void 0 : _a[field.key]) {
          return `${field.label}: ${props4.tooltipFieldFormat[field.key](field.value)}`;
        }
        if (field.value instanceof Date) {
          if (props4.relativeTime) {
            const firstTime = tooltipEntries.value[datasetIndex][0].find((f) => f.key === field.key).value;
            return firstTime && `${field.label}: ${formatInterval(firstTime, field.value)}`;
          }
          return `${field.label}: ${formatDate$1(field.value, DateTemplates.Long)}`;
        }
        return `${field.label}: ${String(field.value)}`;
      })))
    );
    const legend = computed(() => {
      return props4.entries.map((entry) => ({
        color: colors.value[entry.key],
        key: entry.key,
        name: entry.name
      }));
    });
    const chartOptionsParams = computed(() => ({
      chart: props4.chart,
      labelMaxRotation: props4.labelMaxRotation,
      maintainAspectRatio: props4.maintainAspectRatio,
      max: props4.max,
      min: props4.min,
      relativeTime: props4.relativeTime,
      showAxisLabels: props4.showAxisLabels,
      xAxisMaxTicksLimit: props4.xAxisMaxTicksLimit,
      xAxisTimeDisplayFormats: props4.xAxisTimeDisplayFormats
    }));
    const options = useChartOptions({
      customTooltip,
      params: chartOptionsParams,
      tooltipLines
    });
    function customTooltip({
      chart,
      tooltip
    }) {
      var _a;
      if (!isShowTooltip.value) return;
      if (!((_a = tooltip.body) == null ? void 0 : _a.length)) {
        tooltipData.value = null;
        return;
      }
      tooltipData.value = {
        caret: {
          x: tooltip.caretX,
          y: tooltip.caretY
        },
        chart: {
          height: chart.height,
          position: {
            x: chart.canvas.offsetLeft,
            y: chart.canvas.offsetTop
          },
          top: chart.canvas.getBoundingClientRect().top,
          width: chart.width
        },
        items: tooltip.body.map((body, index) => ({
          color: tooltip.labelColors[index].backgroundColor.toString(),
          highlightedLineIndices: tooltipHighlightedLineIndices.value[tooltip.dataPoints[index].datasetIndex][index],
          lines: body.lines,
          lineStyle: props4.entries[tooltip.dataPoints[index].datasetIndex].lineStyle
        }))
      };
    }
    function onMouseEnter() {
      isShowTooltip.value = true;
    }
    function onMouseLeave() {
      isShowTooltip.value = false;
      tooltipData.value = null;
    }
    onMounted(async () => {
      if (!chartRef.value) return;
      Chart$1.defaults.color = isDark.value ? getCssVar("white-fixed") ?? "#FFFFFF" : getCssVar("grey-1-fixed") ?? "#485374";
      Chart$1.defaults.borderColor = isDark.value ? getCssVar("grey-1-fixed") ?? "#485374" : getCssVar("grey-3-fixed") ?? "#DADDE3";
      const config = {
        data: {
          datasets: datasets.value
        },
        options: options.value,
        type: "line"
      };
      chartInstance = new Chart$1(chartRef.value, config);
    });
    watch([datasets, options], ([newDatasets, newOptions]) => {
      if (!chartInstance) return;
      chartInstance.options = newOptions;
      chartInstance.data.datasets = newDatasets;
      chartInstance.update();
    });
    onUnmounted(() => {
      if (chartInstance) chartInstance.destroy();
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      chartRef,
      isShowTooltip,
      legend,
      onMouseEnter,
      onMouseLeave,
      show,
      tooltipData
    };
  }
});
const _hoisted_1$19 = ["data-automation"];
const _hoisted_2$X = ["data-automation"];
const _hoisted_3$M = ["data-automation", "width"];
const _hoisted_4$u = ["data-automation"];
const _hoisted_5$o = ["data-automation"];
const _hoisted_6$f = ["data-automation"];
function _sfc_render$1f(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b, _c;
  const _component_ChartTooltip = resolveComponent("ChartTooltip");
  const _component_Bullet = resolveComponent("Bullet");
  return openBlock(), createElementBlock("div", {
    class: "tensorboard-chart",
    "data-automation": _ctx.buildId()
  }, [
    withDirectives(createElementVNode("div", {
      class: normalizeClass(["relative-position", { "full-height": _ctx.fullHeight }]),
      "data-automation": _ctx.buildId("container"),
      onMouseenter: _cache[0] || (_cache[0] = (...args) => _ctx.onMouseEnter && _ctx.onMouseEnter(...args)),
      onMouseleave: _cache[1] || (_cache[1] = (...args) => _ctx.onMouseLeave && _ctx.onMouseLeave(...args))
    }, [
      createElementVNode("canvas", {
        ref: "chartRef",
        "data-automation": _ctx.buildId("canvas"),
        height: "200",
        width: _ctx.width
      }, null, 8, _hoisted_3$M),
      withDirectives(createVNode(_component_ChartTooltip, {
        caret: (_a = _ctx.tooltipData) == null ? void 0 : _a.caret,
        chart: (_b = _ctx.tooltipData) == null ? void 0 : _b.chart,
        items: (_c = _ctx.tooltipData) == null ? void 0 : _c.items
      }, null, 8, ["caret", "chart", "items"]), [
        [vShow, _ctx.isShowTooltip && _ctx.tooltipData]
      ])
    ], 42, _hoisted_2$X), [
      [vShow, _ctx.show]
    ]),
    !_ctx.noLegend ? (openBlock(), createElementBlock("div", {
      key: 0,
      "data-automation": _ctx.buildId("legend")
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.legend, (item) => {
        return openBlock(), createElementBlock("div", {
          key: item.key,
          class: "inline flex no-wrap items-center text-small q-mr-sm",
          "data-automation": _ctx.buildId(`item__${item.key}`)
        }, [
          createVNode(_component_Bullet, {
            color: item.color,
            "data-automation": _ctx.buildId(`item__${item.key}__bullet`)
          }, null, 8, ["color", "data-automation"]),
          createElementVNode("div", {
            class: "q-ml-xs",
            "data-automation": _ctx.buildId(`item__${item.key}__label`)
          }, toDisplayString(item.name), 9, _hoisted_6$f)
        ], 8, _hoisted_5$o);
      }), 128))
    ], 8, _hoisted_4$u)) : createCommentVNode("", true)
  ], 8, _hoisted_1$19);
}
const Chart = /* @__PURE__ */ _export_sfc(_sfc_main$1p, [["render", _sfc_render$1f]]);
const _sfc_main$1o = defineComponent({
  name: "Chip",
  components: {
    QIcon: QIcon_default
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Color name for component from the Quasar Color Palette
     */
    backgroundColor: {
      type: String,
      default: ""
    },
    /**
     * Border applied to component
     */
    bordered: {
      type: Boolean,
      default: false
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Icon color as a Quasar variable (primary|dark|grey-1)
     */
    iconColor: {
      type: String,
      default: ""
    },
    /**
     * Icon name
     */
    iconName: {
      type: String,
      default: ""
    },
    /**
     * Shows icons, if defined, on the right
     */
    iconRight: {
      type: Boolean,
      default: false
    },
    /**
     * The text that will be shown on the button
     */
    label: {
      type: String,
      required: true
    },
    /**
     * Render chip in primary mode
     */
    primary: {
      type: Boolean,
      default: true
    },
    /**
     * Render chip in secondary mode
     */
    secondary: {
      type: Boolean,
      default: false
    },
    /**
     * Size in standard size name (sm|md)
     */
    size: {
      type: String,
      default: "sm"
    },
    /**
     * Text color name for component from the Quasar Color Palette
     */
    textColor: {
      type: String,
      default: ""
    }
  },
  setup(props4) {
    const isCustom = computed(() => props4.backgroundColor || props4.textColor);
    const isPrimary = computed(() => props4.primary && !props4.secondary && !isCustom.value);
    const isSecondary = computed(() => props4.secondary && !isCustom.value);
    const textClass = computed(() => props4.textColor ? `text-${props4.textColor}` : "");
    const backgroundClass = computed(() => props4.backgroundColor ? `bg-${props4.backgroundColor}` : "");
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      backgroundClass,
      isPrimary,
      isSecondary,
      textClass
    };
  }
});
const _hoisted_1$18 = ["data-automation"];
function _sfc_render$1e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: ["rv-chip", [
      {
        "rv-chip--bordered": _ctx.bordered,
        "rv-chip--primary": _ctx.isPrimary,
        "rv-chip--secondary": _ctx.isSecondary,
        "rv-chip--sm": _ctx.size === "sm",
        "rv-chip--md": _ctx.size === "md"
      },
      _ctx.backgroundClass,
      _ctx.textClass,
      _ctx.$props.class
    ]],
    "data-automation": _ctx.buildId()
  }), [
    _ctx.iconName && !_ctx.iconRight ? (openBlock(), createBlock(_component_QIcon, {
      key: 0,
      class: "rv-chip__icon rv-chip__icon--left",
      color: _ctx.iconColor,
      "data-automation": _ctx.buildId("icon"),
      name: _ctx.iconName
    }, null, 8, ["color", "data-automation", "name"])) : createCommentVNode("", true),
    createElementVNode("span", null, toDisplayString(_ctx.label), 1),
    _ctx.iconName && _ctx.iconRight ? (openBlock(), createBlock(_component_QIcon, {
      key: 1,
      class: "rv-chip__icon rv-chip__icon--right",
      color: _ctx.iconColor,
      "data-automation": _ctx.buildId("icon"),
      name: _ctx.iconName
    }, null, 8, ["color", "data-automation", "name"])) : createCommentVNode("", true)
  ], 16, _hoisted_1$18);
}
const Chip = /* @__PURE__ */ _export_sfc(_sfc_main$1o, [["render", _sfc_render$1e], ["__scopeId", "data-v-b4177217"]]);
const _sfc_main$1n = defineComponent({
  name: "CircularProgress",
  components: {
    QCircularProgress: QCircularProgress_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Color name for the arc progress from the Quasar Color Palette
     */
    color: {
      type: String,
      default: "primary"
    },
    /**
     * Size of text in CSS units, including unit name. Suggestion: use 'em' units to sync with component size
     */
    fontSize: {
      type: String,
      default: "1em"
    },
    /**
     * Put component into 'indeterminate' state; Ignores 'value' prop
     */
    indeterminate: {
      type: Boolean,
      default: false
    },
    /**
     * Maximum value defining 100% progress made (must be higher than 'min')
     */
    max: {
      type: Number,
      default: 100
    },
    /**
     * Minimum value defining 'no progress' (must be lower than 'max')
     */
    min: {
      type: Number,
      default: 0
    },
    /**
     * Enables the default slot and uses it (if available), otherwise it displays the 'value' prop as text;
     * Make sure the text has enough space to be displayed inside the component
     */
    showValue: {
      type: Boolean,
      default: false
    },
    /**
     * Size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
     */
    size: {
      type: String,
      default: "1em"
    },
    /**
     * Thickness of progress arc as a ratio (0.0 < x < 1.0) of component size
     */
    thickness: {
      type: Number,
      default: 0.2
    },
    /**
     * Color name for the track of the component from the Quasar Color Palette
     */
    trackColor: {
      type: String,
      default: void 0
    },
    /**
     * Current progress (must be between min/max)
     */
    value: {
      type: Number,
      default: 0
    }
  },
  setup(props4) {
    const { isDark } = useDarkMode();
    const trackColorComputed = computed(() => {
      if (props4.trackColor) return props4.trackColor;
      return isDark.value ? "grey-1--dark" : "grey-3--light";
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      trackColorComputed
    };
  }
});
function _sfc_render$1d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QCircularProgress = resolveComponent("QCircularProgress");
  return openBlock(), createBlock(_component_QCircularProgress, {
    class: normalizeClass(["rv-circular-progress text-primary--light text-white--dark text-center", _ctx.$props.class]),
    color: _ctx.color,
    "data-automation": _ctx.buildId(),
    "font-size": _ctx.fontSize,
    indeterminate: _ctx.indeterminate,
    max: _ctx.max,
    min: _ctx.min,
    "show-value": _ctx.showValue,
    size: _ctx.size,
    thickness: _ctx.thickness,
    "track-color": _ctx.trackColorComputed,
    value: _ctx.value
  }, {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "color", "data-automation", "font-size", "indeterminate", "max", "min", "show-value", "size", "thickness", "track-color", "value"]);
}
const CircularProgress = /* @__PURE__ */ _export_sfc(_sfc_main$1n, [["render", _sfc_render$1d]]);
const _sfc_main$1m = defineComponent({
  name: "EllipsisText",
  components: {
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Show 3dots at the beginning
     * @type {Boolean}
     */
    reverse: {
      type: Boolean,
      default: false
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    tooltipClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Text displayed inside the component
     */
    text: {
      type: [String, Number],
      default: void 0
    },
    /**
     * To keep spaces between working in text
     */
    textWithSpaces: {
      type: Boolean,
      default: false
    },
    /**
     * Tooltip is shown by default when overflowing text, or always shown when passing this property
     */
    tooltip: {
      type: [String],
      default: void 0
    }
  },
  setup(props4) {
    const containerRef = ref$1(null);
    const contentRef = ref$1(null);
    const overflowed = ref$1(false);
    const textContent = computed(() => {
      var _a;
      return props4.text ?? ((_a = contentRef.value) == null ? void 0 : _a.innerText) ?? "";
    });
    function checkWidth() {
      overflowed.value = !!containerRef.value && !!contentRef.value && contentRef.value.offsetWidth > containerRef.value.offsetWidth;
    }
    onMounted(checkWidth);
    watch(
      () => props4.text,
      () => {
        void nextTick(checkWidth);
      },
      { immediate: true }
    );
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      containerRef,
      contentRef,
      overflowed,
      textContent
    };
  }
});
const _hoisted_1$17 = ["data-automation"];
const _hoisted_2$W = { ref: "contentRef" };
const _hoisted_3$L = { key: 0 };
const _hoisted_4$t = { key: 1 };
function _sfc_render$1c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createElementBlock("div", {
    ref: "containerRef",
    class: normalizeClass(["rv-ellipsis-text ellipsis", [{
      "rv-ellipsis-text--overflowed": _ctx.overflowed,
      "rv-ellipsis-text--reverse": _ctx.reverse,
      "rv-ellipsis-text--with-spaces": _ctx.textWithSpaces
    }, _ctx.$props.class]]),
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("span", _hoisted_2$W, [
      renderSlot(_ctx.$slots, "default", {}, () => [
        createTextVNode(toDisplayString(_ctx.text), 1)
      ], true)
    ], 512),
    _ctx.overflowed || _ctx.tooltip ? (openBlock(), createBlock(_component_Tooltip, {
      key: 0,
      anchor: "bottom middle",
      class: normalizeClass(["rv-ellipsis-text__tooltip", _ctx.tooltipClass]),
      "data-automation": _ctx.buildId("tooltip"),
      self: "center middle"
    }, {
      default: withCtx(() => [
        _ctx.overflowed ? (openBlock(), createElementBlock("div", _hoisted_3$L, toDisplayString(_ctx.textContent), 1)) : createCommentVNode("", true),
        _ctx.tooltip ? (openBlock(), createElementBlock("div", _hoisted_4$t, toDisplayString(_ctx.tooltip), 1)) : createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class", "data-automation"])) : createCommentVNode("", true)
  ], 10, _hoisted_1$17);
}
const EllipsisText = /* @__PURE__ */ _export_sfc(_sfc_main$1m, [["render", _sfc_render$1c], ["__scopeId", "data-v-c09b2f3c"]]);
const _sfc_main$1l = defineComponent({
  name: "RvInput",
  components: {
    EllipsisText,
    QIcon: QIcon_default,
    QInput: QInput_default,
    Tooltip
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Hint for input autofill feature
     */
    autocomplete: {
      type: String,
      default: void 0
    },
    /**
     * Focus field on initial component render
     */
    autofocus: {
      type: Boolean,
      default: false
    },
    /**
     * Focus field on initial component render
     */
    autogrow: {
      type: Boolean,
      default: false
    },
    /**
     * Enables bottom slots ('error', 'hint', 'counter')
     */
    bottomSlots: {
      type: Boolean,
      default: false
    },
    /**
     * Classes applied to the component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Debounce amount (in milliseconds) when updating model
     */
    debounce: {
      type: [String, Number],
      default: 200
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Forcefully hides the error icon, always.
     */
    hideErrorIcon: {
      type: Boolean,
      default: false
    },
    /**
     * Helper (hint) text which gets placed below your wrapped form component
     */
    hint: {
      type: String,
      default: void 0
    },
    /**
     * Render info icon with tooltip. Can be used as an "info-text" property or as a slot
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: "rv-input__info-text"
    },
    /**
     * Classes applied to the input
     * @type {[Array, Object, String]}
     */
    inputClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * The text that will be shown above the input
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    labelClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: [Number, String],
      default: void 0
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    /**
     * Text that appears in the form control when it has no value set
     */
    placeholder: {
      type: String,
      default: void 0
    },
    /**
     * Put component in readonly mode
     */
    readonly: {
      type: Boolean,
      default: false
    },
    /**
     * Specifies the visible height of a text area
     */
    rows: {
      type: Number,
      default: 6
    },
    /**
     * Option to show or hide the error
     */
    showError: {
      type: Boolean,
      default: true
    },
    /**
     * Option to show or hide the error icon. Only applies if showError is false.
     */
    showErrorIcon: {
      type: Boolean,
      default: false
    },
    /**
     * Option to show or hide the error
     */
    showErrorMessage: {
      type: Boolean,
      default: true
    },
    /**
     * Show error as a tooltip of the valid icon (if enabled)
     */
    showErrorAsTooltip: {
      default: false,
      type: Boolean
    },
    /**
     * Show optional label next to label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Option to show or hide the validation
     */
    showValid: {
      type: Boolean,
      default: true
    },
    /**
     * The text to be displayed at the end inside the input
     */
    suffix: {
      type: String,
      default: void 0
    },
    /**
     * Global attribute indicates that its element can be focused, and where it participates in sequential keyboard navigation
     */
    tabindex: {
      type: String,
      default: void 0
    },
    /**
     * A string specifying the type of control to render
     */
    type: {
      type: String,
      default: "text"
    },
    /**
     * Validation for the component
     */
    validation: {
      type: Object,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when component loses focus
     *
     * @type {object}
     */
    "blur",
    /**
     * Emitted when component gets focused
     *
     * @type {object}
     */
    "change",
    /**
     * Emitted when component changes
     *
     * @type {object}
     */
    "focus",
    /**
     * Emitted on keydown event
     *
     * @type {object}
     */
    "keydown",
    /**
     * Emitted on keypress event
     *
     * @type {object}
     */
    "keypress",
    /**
     * Emitted on keyup event
     *
     * @type {object}
     */
    "keyup",
    /**
     * Emitted when the user has initiated a "paste" action in input element.
     *
     * @type {object}
     */
    "paste",
    /**
     * Emitted when the component needs to change the model; Is also used by v-model
     *
     * @type {[string, number]}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const slots = useSlots();
    const { t: t2 } = useI18n();
    const input = ref$1(null);
    const errorTooltipRef = ref$1(null);
    const focused = ref$1(false);
    const {
      classRef,
      error,
      errorMessage,
      isValidated,
      onBlur: onValidationBlur
    } = useValidation(props4);
    const hasValidation = computed(() => props4.showValid && isValidated.value && props4.modelValue || props4.showError && error.value);
    const bottomSlotNames = computed(() => ["error", "hint", "counter"].filter((name2) => props4.bottomSlots && slots[name2]));
    const isTextarea = computed(() => props4.type === "textarea");
    const maxLength2 = computed(() => {
      var _a;
      if (!props4.validation) return;
      return (_a = props4.validation.maxLength) == null ? void 0 : _a.$params.max;
    });
    function blur() {
      var _a;
      (_a = input.value) == null ? void 0 : _a.blur();
    }
    function onBlur2(...args) {
      onValidationBlur();
      focused.value = false;
      emit("blur", ...args);
    }
    function onChange(...args) {
      emit("change", ...args);
    }
    function onFocus(...args) {
      emit("focus", ...args);
      focused.value = true;
    }
    function onKeydown2(...args) {
      emit("keydown", ...args);
    }
    function onKeypress(...args) {
      emit("keypress", ...args);
    }
    function onKeyup2(...args) {
      emit("keyup", ...args);
    }
    function onPaste(...args) {
      emit("paste", ...args);
    }
    function onUpdate(value2) {
      emit("update:modelValue", value2);
    }
    if (props4.showErrorAsTooltip) {
      watch(errorMessage, (value2, prevValue) => {
        if (value2 && value2 !== prevValue) {
          void nextTick(() => {
            var _a;
            (_a = errorTooltipRef.value) == null ? void 0 : _a.show();
          });
        }
      });
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      blur,
      bottomSlotNames,
      classRef,
      error,
      errorMessage,
      errorTooltipRef,
      focused,
      hasValidation,
      input,
      isTextarea,
      isValidated,
      maxLength: maxLength2,
      onBlur: onBlur2,
      onChange,
      onFocus,
      onKeydown: onKeydown2,
      onKeypress,
      onKeyup: onKeyup2,
      onPaste,
      onUpdate,
      t: t2
    };
  }
});
const _hoisted_1$16 = ["data-automation"];
const _hoisted_2$V = { class: "row no-wrap items-center full-width" };
const _hoisted_3$K = ["data-automation"];
function _sfc_render$1b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QInput = resolveComponent("QInput");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: ["rv-input", [
      _ctx.classRef,
      {
        "rv-input--dense": _ctx.dense,
        "rv-input--disabled": _ctx.disable || _ctx.readonly,
        "rv-input--error": !!((_ctx.showError || _ctx.showErrorIcon) && _ctx.error),
        "rv-input--textarea": _ctx.isTextarea
      }
    ]],
    "data-automation": _ctx.buildId()
  }), [
    _ctx.label ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["rv-input__label flex justify-between items-center", _ctx.labelClass])
    }, [
      createElementVNode("span", _hoisted_2$V, [
        createVNode(_component_EllipsisText, {
          class: "text-subtitle3",
          "data-automation": _ctx.buildId("label"),
          text: _ctx.label
        }, null, 8, ["data-automation", "text"]),
        _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "q-ml-xs",
          "data-automation": _ctx.buildId("optional")
        }, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 9, _hoisted_3$K)) : createCommentVNode("", true),
        _ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
          key: 1,
          class: "q-ml-xs info-icon",
          color: "black-1",
          "data-automation": _ctx.buildId("icon-info"),
          name: "info",
          size: "16px"
        }, {
          default: withCtx(() => [
            createVNode(_component_Tooltip, {
              anchor: "top middle",
              class: normalizeClass(_ctx.infoTextClass),
              "data-automation": _ctx.buildId("tooltip"),
              self: "bottom middle"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "infoText", {}, () => [
                  createTextVNode(toDisplayString(_ctx.infoText), 1)
                ], true)
              ]),
              _: 3
            }, 8, ["class", "data-automation"])
          ]),
          _: 3
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      renderSlot(_ctx.$slots, "label-append", {}, void 0, true)
    ], 2)) : createCommentVNode("", true),
    createVNode(_component_QInput, {
      ref: "input",
      autocomplete: _ctx.autocomplete,
      autofocus: _ctx.autofocus,
      autogrow: _ctx.autogrow,
      "bottom-slots": _ctx.bottomSlots,
      debounce: _ctx.debounce,
      dense: "",
      disable: _ctx.disable || _ctx.readonly,
      error: _ctx.showError && _ctx.error,
      "error-message": _ctx.showErrorMessage ? _ctx.errorMessage : "",
      "hide-bottom-space": "",
      hint: _ctx.hint,
      "input-class": _ctx.inputClass,
      "model-value": _ctx.modelValue,
      "no-error-icon": "",
      placeholder: _ctx.placeholder,
      rows: _ctx.autogrow ? void 0 : _ctx.rows,
      standout: "",
      suffix: _ctx.suffix,
      tabindex: _ctx.tabindex,
      type: _ctx.type,
      onBlur: _ctx.onBlur,
      onChange: _ctx.onChange,
      onFocus: _ctx.onFocus,
      onKeydown: _ctx.onKeydown,
      onKeypress: _ctx.onKeypress,
      onKeyup: _ctx.onKeyup,
      onPaste: _ctx.onPaste,
      "onUpdate:modelValue": _ctx.onUpdate
    }, createSlots({
      append: withCtx((slotData) => [
        renderSlot(_ctx.$slots, "append", normalizeProps(guardReactiveProps(slotData || {})), void 0, true)
      ]),
      prepend: withCtx((slotData) => [
        renderSlot(_ctx.$slots, "prepend", normalizeProps(guardReactiveProps(slotData || {})), void 0, true)
      ]),
      _: 2
    }, [
      _ctx.showValid && _ctx.isValidated && _ctx.modelValue ? {
        name: "after",
        fn: withCtx(() => [
          createVNode(_component_QIcon, {
            key: "valid",
            color: "positive",
            "data-automation": _ctx.buildId("icon-valid"),
            name: "mdi-check-circle"
          }, null, 8, ["data-automation"])
        ]),
        key: "0"
      } : !_ctx.hideErrorIcon && (_ctx.showError || _ctx.showErrorIcon) && _ctx.error ? {
        name: "after",
        fn: withCtx(() => [
          createVNode(_component_QIcon, {
            key: "error",
            color: "negative",
            "data-automation": _ctx.buildId("icon-error"),
            name: "mdi-close-circle"
          }, {
            default: withCtx(() => [
              _ctx.showErrorAsTooltip ? (openBlock(), createBlock(_component_Tooltip, {
                key: 0,
                ref: "errorTooltipRef",
                anchor: "bottom middle",
                "auto-hide": 3e3,
                class: normalizeClass(_ctx.infoTextClass),
                offset: [0, 4],
                self: "top middle"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.errorMessage), 1)
                ]),
                _: 1
              }, 8, ["class"])) : createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data-automation"])
        ]),
        key: "1"
      } : void 0,
      renderList(_ctx.bottomSlotNames, (name2) => {
        return {
          name: name2,
          fn: withCtx((slotData) => [
            renderSlot(_ctx.$slots, name2, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)
          ])
        };
      })
    ]), 1032, ["autocomplete", "autofocus", "autogrow", "bottom-slots", "debounce", "disable", "error", "error-message", "hint", "input-class", "model-value", "placeholder", "rows", "suffix", "tabindex", "type", "onBlur", "onChange", "onFocus", "onKeydown", "onKeypress", "onKeyup", "onPaste", "onUpdate:modelValue"]),
    renderSlot(_ctx.$slots, "after", {
      focused: _ctx.focused,
      validation: _ctx.validation
    }, void 0, true),
    _ctx.isTextarea && _ctx.maxLength ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: normalizeClass(["rv-input__description text-grey-1", {
        "rv-input__description--validated": _ctx.hasValidation
      }])
    }, toDisplayString(_ctx.t("rvai-base.general.inputs.maxCharacters", _ctx.maxLength)), 3)) : createCommentVNode("", true)
  ], 16, _hoisted_1$16);
}
const RvInput = /* @__PURE__ */ _export_sfc(_sfc_main$1l, [["render", _sfc_render$1b], ["__scopeId", "data-v-7c0dd776"]]);
const _sfc_main$1k = defineComponent({
  name: "ColorPicker",
  components: {
    QColor: QColor_default,
    RvInput
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * v-model
     */
    modelValue: {
      type: String,
      required: true
    }
  },
  emits: [
    /**
     * Emitted when component is updated
     *
     * @type {object}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t2 } = useI18n();
    const hexColorInput = computed({
      get() {
        return props4.modelValue.startsWith("#") ? props4.modelValue.substring(1).toUpperCase() : props4.modelValue.toUpperCase();
      },
      set(value2) {
        const hasHashtag = value2.startsWith("#");
        const valueWithoutHashtag = hasHashtag ? value2 == null ? void 0 : value2.slice(1) : value2;
        if (valueWithoutHashtag.match(/(\b[0-9A-F]{3}\b)|(\b[0-9A-F]{6}\b)/gi)) {
          emit("update:modelValue", `#${valueWithoutHashtag}`);
        }
      }
    });
    const red = computed({
      get() {
        return colors_default.hexToRgb(props4.modelValue).r;
      },
      set(value2) {
        setRGB(value2, "r");
      }
    });
    const green = computed({
      get() {
        return colors_default.hexToRgb(props4.modelValue).g;
      },
      set(value2) {
        setRGB(value2, "g");
      }
    });
    const blue = computed({
      get() {
        return colors_default.hexToRgb(props4.modelValue).b;
      },
      set(value2) {
        setRGB(value2, "b");
      }
    });
    function setRGB(value2, key) {
      const rgb2 = colors_default.hexToRgb(props4.modelValue);
      if (value2 > 255 || value2.toString().match(/\D/g)) {
        rgb2[key] = 255;
      } else {
        rgb2[key] = value2;
      }
      emit("update:modelValue", colors_default.rgbToHex(rgb2));
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      blue,
      green,
      hexColorInput,
      red,
      t: t2
    };
  }
});
const _hoisted_1$15 = ["data-automation"];
const _hoisted_2$U = { class: "q-pb-md flex no-wrap inputs" };
function _sfc_render$1a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QColor = resolveComponent("QColor");
  const _component_RvInput = resolveComponent("RvInput");
  return openBlock(), createElementBlock("div", {
    class: "bg-white",
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", {
      style: normalizeStyle({ "--color": _ctx.modelValue })
    }, [
      createVNode(_component_QColor, {
        "data-automation": _ctx.buildId("color-picker"),
        "format-model": "hex",
        "model-value": _ctx.modelValue,
        "no-footer": "",
        "no-header": "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
      }, null, 8, ["data-automation", "model-value"])
    ], 4),
    createElementVNode("div", _hoisted_2$U, [
      createVNode(_component_RvInput, {
        modelValue: _ctx.hexColorInput,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.hexColorInput = $event),
        class: "color__input color__input--hex",
        "data-automation": _ctx.buildId("hex"),
        label: _ctx.t("rvai-base.components.colorPicker.hex"),
        "no-error-icon": ""
      }, null, 8, ["modelValue", "data-automation", "label"]),
      createVNode(_component_RvInput, {
        modelValue: _ctx.red,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.red = $event),
        class: "color__input",
        "data-automation": _ctx.buildId("red"),
        label: _ctx.t("rvai-base.components.colorPicker.rgb.r")
      }, null, 8, ["modelValue", "data-automation", "label"]),
      createVNode(_component_RvInput, {
        modelValue: _ctx.green,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.green = $event),
        class: "color__input",
        "data-automation": _ctx.buildId("green"),
        label: _ctx.t("rvai-base.components.colorPicker.rgb.g")
      }, null, 8, ["modelValue", "data-automation", "label"]),
      createVNode(_component_RvInput, {
        modelValue: _ctx.blue,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.blue = $event),
        class: "color__input",
        "data-automation": _ctx.buildId("blue"),
        label: _ctx.t("rvai-base.components.colorPicker.rgb.b")
      }, null, 8, ["modelValue", "data-automation", "label"])
    ])
  ], 8, _hoisted_1$15);
}
const ColorPicker = /* @__PURE__ */ _export_sfc(_sfc_main$1k, [["render", _sfc_render$1a], ["__scopeId", "data-v-161838b3"]]);
const _sfc_main$1j = defineComponent({
  name: "ColorPickerInput",
  components: {
    ColorPicker,
    QIcon: QIcon_default,
    QPopupProxy: QPopupProxy_default,
    RvInput
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Render info icon with tooltip
     */
    infoText: {
      default: void 0,
      type: String
    },
    /**
     * The text that will be shown above the input
     */
    label: {
      default: void 0,
      type: String
    },
    /**
     * v-model
     */
    modelValue: {
      default: null,
      type: String
    },
    /**
     * Show optional label next to label
     */
    showOptionalLabel: {
      default: false,
      type: Boolean
    }
  },
  emits: [
    /**
     * Emitted when component is updated
     *
     * @type {object}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const color = computed({
      get() {
        var _a;
        if (!props4.modelValue) return "";
        const hasHashtag = props4.modelValue.startsWith("#");
        const valueWithoutHashtag = hasHashtag ? (_a = props4.modelValue) == null ? void 0 : _a.substring(1) : props4.modelValue;
        return `#${valueWithoutHashtag.toUpperCase()}`;
      },
      set(value2) {
        if (value2 === "") {
          emit("update:modelValue", "");
          return;
        }
        const hasHashtag = value2 == null ? void 0 : value2.startsWith("#");
        const valueWithoutHashtag = hasHashtag ? value2 == null ? void 0 : value2.substring(1) : value2;
        if (valueWithoutHashtag == null ? void 0 : valueWithoutHashtag.match(/(\b[0-9A-F]{3}\b)|(\b[0-9A-F]{6}\b)/gi)) {
          emit("update:modelValue", `#${valueWithoutHashtag}`);
        }
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      color
    };
  }
});
const _hoisted_1$14 = ["data-automation"];
const _hoisted_2$T = ["data-automation"];
function _sfc_render$19(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvInput = resolveComponent("RvInput");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_ColorPicker = resolveComponent("ColorPicker");
  const _component_QPopupProxy = resolveComponent("QPopupProxy");
  return openBlock(), createElementBlock("div", {
    class: "row no-wrap",
    "data-automation": _ctx.buildId()
  }, [
    createVNode(_component_RvInput, {
      modelValue: _ctx.color,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.color = $event),
      class: "full-width",
      "data-automation": _ctx.buildId("input"),
      "info-text": _ctx.infoText,
      label: _ctx.label,
      "show-optional-label": _ctx.showOptionalLabel
    }, createSlots({ _: 2 }, [
      !!_ctx.color ? {
        name: "prepend",
        fn: withCtx(() => [
          createElementVNode("div", {
            class: "color-picker__color-indicator",
            "data-automation": _ctx.buildId("color-indicator"),
            style: normalizeStyle(`background-color: ${_ctx.color}`)
          }, null, 12, _hoisted_2$T)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "data-automation", "info-text", "label", "show-optional-label"]),
    !!_ctx.color ? (openBlock(), createBlock(_component_QIcon, {
      key: 0,
      class: "color-picker__success",
      color: "positive",
      "data-automation": _ctx.buildId("success"),
      name: "mdi-check-circle",
      size: "24px"
    }, null, 8, ["data-automation"])) : createCommentVNode("", true),
    createVNode(_component_QPopupProxy, {
      class: "color-picker__popup q-pa-md",
      "data-automation": _ctx.buildId("popup"),
      "no-focus": "",
      offset: [0, 5]
    }, {
      default: withCtx(() => [
        createVNode(_component_ColorPicker, {
          key: "colorPicker",
          modelValue: _ctx.color,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.color = $event),
          class: "color-picker__component",
          "data-automation": _ctx.buildId("component")
        }, null, 8, ["modelValue", "data-automation"])
      ]),
      _: 1
    }, 8, ["data-automation"])
  ], 8, _hoisted_1$14);
}
const ColorPickerInput = /* @__PURE__ */ _export_sfc(_sfc_main$1j, [["render", _sfc_render$19], ["__scopeId", "data-v-56107070"]]);
const __default__$2 = defineComponent({
  name: "ColorPicker",
  components: {
    ActionButton,
    QColor: QColor_default,
    QMenu: QMenu_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: void 0,
      type: String
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      default: false,
      type: Boolean
    },
    /**
     * v-model
     */
    modelValue: {
      required: true,
      type: String
    }
  },
  emits: [
    /**
     * Emitted when component is updated
     *
     * @type {object}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const value2 = computed({
      get() {
        return props4.modelValue;
      },
      set(value22) {
        emit("update:modelValue", value22);
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      value: value2
    };
  }
});
const __injectCSSVars__$2 = () => {
  useCssVars((_ctx) => ({
    "v4bd23360": _ctx.value
  }));
};
const __setup__$2 = __default__$2.setup;
__default__$2.setup = __setup__$2 ? (props4, ctx) => {
  __injectCSSVars__$2();
  return __setup__$2(props4, ctx);
} : __injectCSSVars__$2;
const _hoisted_1$13 = ["data-automation"];
const _hoisted_2$S = ["data-automation"];
function _sfc_render$18(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QColor = resolveComponent("QColor");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_ActionButton = resolveComponent("ActionButton");
  return openBlock(), createElementBlock("div", {
    class: "color-picker",
    "data-automation": _ctx.buildId()
  }, [
    createVNode(_component_ActionButton, {
      "data-automation": _ctx.buildId("button"),
      disable: _ctx.disable,
      selected: "",
      tertiary: ""
    }, {
      default: withCtx(() => [
        createElementVNode("div", {
          class: "color-picker__indicator",
          "data-automation": _ctx.buildId("indicator")
        }, null, 8, _hoisted_2$S),
        createVNode(_component_QMenu, {
          anchor: "top left",
          "auto-close": "",
          offset: [0, 0],
          self: "top left"
        }, {
          default: withCtx(() => [
            createVNode(_component_QColor, {
              modelValue: _ctx.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.value = $event),
              class: "color-picker__palette q-pa-sm",
              "data-automation": _ctx.buildId("palette"),
              "default-view": "palette",
              "no-footer": "",
              "no-header": ""
            }, null, 8, ["modelValue", "data-automation"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-automation", "disable"])
  ], 8, _hoisted_1$13);
}
const ColorPickerV2 = /* @__PURE__ */ _export_sfc(__default__$2, [["render", _sfc_render$18], ["__scopeId", "data-v-4f737bce"]]);
const _sfc_main$1i = defineComponent({
  name: "CombinedInputs",
  components: {
    EllipsisText,
    QIcon: QIcon_default,
    RvInput,
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Render text below first input
     */
    hint: {
      type: String,
      default: "Length x width"
    },
    /**
     * Render info icon with tooltip. Can be used as an "info-text" property or as a slot
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: "rv-combined-inputs__info-text"
    },
    /**
     * Render text above first input
     */
    label: {
      type: String,
      required: true
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    labelClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Text that appears in the form control when it has no value set
     */
    placeholders: {
      type: Array,
      default: () => []
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    /**
     * Text displayed between inputs
     */
    separator: {
      type: String,
      default: "X"
    },
    /**
     * Show optional label next to label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * v-model for inputs
     */
    modelValue: {
      type: Array,
      required: true
    },
    /**
     * Validation rules
     */
    validation: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: Array,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when value is updated
     *
     * @type {object}
     */
    "update:model-value"
  ],
  setup(props4, { emit }) {
    const { t: t2 } = useI18n();
    const { isDark } = useDarkMode();
    const valuesRef = ref$1(props4.modelValue);
    const error = computed(() => {
      var _a;
      return (_a = props4.validation) == null ? void 0 : _a.some((v) => v == null ? void 0 : v.$error);
    });
    const errorMessage = computed(() => {
      if (!props4.validation) return void 0;
      if (props4.validation.every((v) => !v.$error)) return void 0;
      const errorMessages = props4.validation.map((v) => {
        var _a;
        return (_a = v.$errors[0]) == null ? void 0 : _a.$message;
      }).filter(Boolean);
      return errorMessages[0];
    });
    const isValidated = computed(() => {
      if (!props4.validation) return false;
      return props4.validation.every((v) => v.$dirty && !v.$invalid);
    });
    function onUpdate(value2, index) {
      const updated = [...props4.modelValue];
      updated[index] = value2;
      valuesRef.value = updated;
      emit("update:model-value", updated);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      error,
      errorMessage,
      isDark,
      isValidated,
      onUpdate,
      t: t2,
      values: valuesRef
    };
  }
});
const _hoisted_1$12 = ["data-automation"];
const _hoisted_2$R = { class: "row no-wrap items-center full-width" };
const _hoisted_3$J = {
  key: 0,
  class: "q-ml-xs"
};
const _hoisted_4$s = { class: "rv-combined-inputs row justify-between no-wrap align-center" };
const _hoisted_5$n = {
  key: 0,
  class: "rv-combined-inputs__separator flex items-center q-px-sm"
};
const _hoisted_6$e = ["data-automation"];
const _hoisted_7$c = { class: "q-field__bottom" };
const _hoisted_8$8 = ["data-automation"];
const _hoisted_9$7 = { class: "q-field__bottom" };
function _sfc_render$17(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_RvInput = resolveComponent("RvInput");
  return openBlock(), createElementBlock("div", {
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", {
      class: normalizeClass(["rv-combined-inputs__field", { "rv-combined-inputs--disabled": _ctx.disable }])
    }, [
      _ctx.label ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["rv-combined-inputs__label flex justify-between items-center", _ctx.labelClass])
      }, [
        createElementVNode("span", _hoisted_2$R, [
          createVNode(_component_EllipsisText, {
            class: "text-subtitle3",
            "data-automation": _ctx.buildId("label"),
            text: _ctx.label
          }, null, 8, ["data-automation", "text"]),
          _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_3$J, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
          _ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
            key: 1,
            class: "q-ml-xs info-icon",
            color: "black-1",
            "data-automation": _ctx.buildId("icon-info"),
            name: "info",
            size: "16px"
          }, {
            default: withCtx(() => [
              createVNode(_component_Tooltip, {
                anchor: "top middle",
                class: normalizeClass(_ctx.infoTextClass),
                self: "bottom middle"
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "infoText", {}, () => [
                    createTextVNode(toDisplayString(_ctx.infoText), 1)
                  ], true)
                ]),
                _: 3
              }, 8, ["class"])
            ]),
            _: 3
          }, 8, ["data-automation"])) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "label-append", {}, void 0, true)
      ], 2)) : createCommentVNode("", true),
      createElementVNode("div", _hoisted_4$s, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.values, (value2, index) => {
          return openBlock(), createElementBlock(Fragment, { key: index }, [
            index ? (openBlock(), createElementBlock("span", _hoisted_5$n, toDisplayString(_ctx.separator), 1)) : createCommentVNode("", true),
            createVNode(_component_RvInput, {
              "data-automation": _ctx.buildId(index.toString()),
              disable: _ctx.disable,
              "model-value": value2,
              placeholder: _ctx.placeholders[index],
              "onUpdate:modelValue": ($event) => _ctx.onUpdate($event, index)
            }, null, 8, ["data-automation", "disable", "model-value", "placeholder", "onUpdate:modelValue"])
          ], 64);
        }), 128)),
        _ctx.isValidated ? (openBlock(), createBlock(_component_QIcon, {
          key: "valid",
          class: "rv-combined-inputs__icon q-pl-sm",
          color: "positive",
          "data-automation": _ctx.buildId("icon-valid"),
          name: "mdi-check-circle",
          size: "24px"
        }, null, 8, ["data-automation"])) : _ctx.error ? (openBlock(), createBlock(_component_QIcon, {
          key: "error",
          class: "rv-combined-inputs__icon q-pl-sm",
          color: "negative",
          "data-automation": _ctx.buildId("icon-error"),
          name: "mdi-close-circle",
          size: "24px"
        }, null, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      _ctx.error ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: "q-field--dense q-field--error",
        "data-automation": _ctx.buildId("error")
      }, [
        createElementVNode("div", _hoisted_7$c, toDisplayString(_ctx.errorMessage), 1)
      ], 8, _hoisted_6$e)) : _ctx.hint ? (openBlock(), createElementBlock("div", {
        key: 2,
        class: normalizeClass(["q-field--dense q-field--hint", { "q-field--dark": _ctx.isDark }]),
        "data-automation": _ctx.buildId("hint")
      }, [
        createElementVNode("div", _hoisted_9$7, toDisplayString(_ctx.hint), 1)
      ], 10, _hoisted_8$8)) : createCommentVNode("", true)
    ], 2)
  ], 8, _hoisted_1$12);
}
const CombinedInputs = /* @__PURE__ */ _export_sfc(_sfc_main$1i, [["render", _sfc_render$17], ["__scopeId", "data-v-43ada02d"]]);
const DETAILED_ROW_MIN_HEIGHT = 24;
const _sfc_main$1h = defineComponent({
  name: "ConfusionMatrix",
  components: {
    Avatar,
    Bullet,
    EllipsisText,
    QResizeObserver: QResizeObserver_default,
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the Histogram
     * @type {[Array, Object, String]}
     */
    classes: {
      type: Array,
      required: true
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Detailed mode; Show like in full mode
     */
    detailed: {
      type: Boolean,
      default: false
    },
    /**
     * Matrix model
     */
    matrix: {
      type: Object,
      required: true
    },
    /**
     * Set max visible rows; if not set - visible all rows
     */
    maxVisibleRows: {
      type: Number,
      default: void 0
    },
    /**
     * Allows to select multiple cells when 'command' or 'ctrl' is pressed
     */
    multipleSelection: {
      type: Boolean,
      default: false
    },
    /**
     * Overrides colors for current user avatar
     */
    overrideCurrentUserAvatar: {
      type: Boolean,
      default: false
    },
    /**
     * v-model:selected; allows handling selected entry
     */
    /**
     * Overrides the default header label for the "no annotations" column/row
     */
    noAnnotationLabel: {
      type: String,
      default: () => useI18n().t("rvai-base.components.confusionMatrix.noAnnotation")
    },
    selected: {
      type: Object,
      default: void 0
    },
    /**
     * Emits 'update:selected' with source ids, when true
     */
    selectable: {
      type: Boolean,
      default: false
    },
    /**
     * Shows class name or class id
     */
    showClassName: {
      type: Boolean,
      default: false
    },
    /**
     * Shows 'Match' text
     */
    showMatchWord: {
      type: Boolean,
      default: false
    },
    /**
     * Data source 1
     */
    source1: {
      type: Object,
      required: true
    },
    /**
     * Data source 2
     */
    source2: {
      type: Object,
      required: true
    },
    /**
     * Always render borders between cells
     */
    withBorders: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:selected"],
  setup(props4, { emit }) {
    var _a, _b, _c;
    const { t: t2 } = useI18n();
    const { isDark } = useDarkMode();
    const confusionMatrixRef = ref$1(null);
    const confusionMatrixTableRef = ref$1(null);
    const contentWidth = ref$1(0);
    const matrixWidth = ref$1(((_a = confusionMatrixRef.value) == null ? void 0 : _a.offsetWidth) ?? 0);
    const matrixHeight = ref$1(((_b = confusionMatrixRef.value) == null ? void 0 : _b.offsetHeight) ?? 0);
    const tableHeight = ref$1(((_c = confusionMatrixTableRef.value) == null ? void 0 : _c.offsetHeight) ?? 0);
    const reduced = ref$1(false);
    const classes1 = computed(() => {
      const ids = props4.matrix.getClasses1();
      return ids.map(getClass).filter(Boolean).sort(sortClasses);
    });
    const classes2 = computed(() => {
      const ids = props4.matrix.getClasses2();
      return ids.map(getClass).filter(Boolean).sort(sortClasses);
    });
    const cssVars = computed(() => {
      return {
        ...props4.maxVisibleRows && { "--max-rows": 2 + props4.maxVisibleRows },
        "--matrix-cell-width": `${matrixCellWidth.value}px`,
        "--matrix-row-height": `${matrixRowHeight.value}px`,
        "--matrix-size": `${matrixWidth.value}px`
      };
    });
    const hasSquareBackground = computed(() => props4.dense || props4.detailed);
    const matrixCellWidth = computed(() => matrixWidth.value / (classes1.value.length + 2));
    const matrixRowHeight = computed(() => {
      return Math.max(
        (props4.detailed ? tableHeight.value : matrixHeight.value) / (classes2.value.length + (props4.detailed ? 3 : 2)),
        props4.detailed ? DETAILED_ROW_MIN_HEIGHT : 0
      );
    });
    const renderBorders = computed(() => matrixWidth.value / classes2.value.length > 30);
    function getClass(id3) {
      const clazz = props4.classes.find((c2) => c2.id === id3);
      if (clazz) {
        return clazz;
      }
      return {
        color: "#ff0000",
        id: id3,
        name: id3 === NULL_CLASS_ID ? props4.noAnnotationLabel : id3
      };
    }
    function getClassName(clazz) {
      if (clazz.id === NULL_CLASS_ID) return props4.noAnnotationLabel;
      return props4.showClassName ? clazz.name ?? clazz.id : clazz.id;
    }
    function isSelected(id1, id22) {
      if (!props4.selected || !props4.selected.length) return false;
      return props4.selected.some((x2) => x2.source1 === id1 && x2.source2 === id22);
    }
    let maxTableWidth = 0;
    function calculateMatrixSize() {
      var _a2, _b2, _c2, _d;
      const count = classes2.value.length;
      if (!count) return;
      const fixed = props4.dense ? 64 : 200;
      const limit2 = props4.dense ? 16 : 100;
      const available = contentWidth.value - fixed;
      const cellWidth = available / count;
      const tableWidth = ((_a2 = confusionMatrixTableRef.value) == null ? void 0 : _a2.offsetWidth) ?? 0;
      tableHeight.value = ((_b2 = confusionMatrixTableRef.value) == null ? void 0 : _b2.offsetHeight) ?? 0;
      if (tableWidth > contentWidth.value) {
        maxTableWidth = tableWidth > maxTableWidth ? tableWidth : maxTableWidth;
      }
      reduced.value = cellWidth < limit2 || contentWidth.value < maxTableWidth;
      matrixWidth.value = ((_c2 = confusionMatrixRef.value) == null ? void 0 : _c2.offsetWidth) ?? 0;
      matrixHeight.value = ((_d = confusionMatrixRef.value) == null ? void 0 : _d.offsetHeight) ?? 0;
    }
    function onResize({ width }) {
      contentWidth.value = width;
      calculateMatrixSize();
    }
    function select(event, id1, id22) {
      var _a2;
      if (!props4.selectable) return;
      if (isSelected(id1, id22)) {
        emit(
          "update:selected",
          props4.multipleSelection && (event.metaKey || event.ctrlKey) ? (_a2 = props4.selected) == null ? void 0 : _a2.filter((x2) => !(x2.source1 === id1 && x2.source2 === id22)) : void 0
        );
      } else {
        emit(
          "update:selected",
          props4.multipleSelection && (event.metaKey || event.ctrlKey) ? [
            ...props4.selected ?? [],
            {
              source1: id1 || void 0,
              source2: id22 || void 0
            }
          ] : [{
            source1: id1 || void 0,
            source2: id22 || void 0
          }]
        );
      }
    }
    function selectAllOutliers() {
      if (!props4.selectable) return;
      emit("update:selected", props4.matrix.getOutliers());
    }
    function deselectAllOutliers() {
      var _a2;
      emit("update:selected", (_a2 = props4.selected) == null ? void 0 : _a2.filter((cell) => cell.source1 === cell.source2));
    }
    function sortClasses(a3, b2) {
      if (a3.id === NULL_CLASS_ID && b2.id !== NULL_CLASS_ID) return -1;
      if (b2.id === NULL_CLASS_ID && a3.id !== NULL_CLASS_ID) return 1;
      if (a3.id === UNKNOWN_CLASS_ID && b2.id !== UNKNOWN_CLASS_ID) return -1;
      if (b2.id === UNKNOWN_CLASS_ID && a3.id !== UNKNOWN_CLASS_ID) return 1;
      return naturalSort(a3.name, b2.name);
    }
    function generateCSV() {
      const headerRow = [
        "",
        props4.source2.name,
        ...(classes1.value ?? []).map((item) => getClassName(item)),
        t2("rvai-base.components.confusionMatrix.matchPercentage")
      ].map((value2) => value2.toString().replace(/,/g, ".")).join(",");
      const subheaderRow = [
        props4.source1.name,
        "",
        ...(classes1.value ?? []).map((item) => item.id === NULL_CLASS_ID || item.id === null ? "" : item.id),
        ""
      ].map((value2) => value2.toString().replace(/,/g, ".")).join(",");
      const dataRows = classes2.value.map((class2) => {
        const row = [
          getClassName(class2),
          class2.id === NULL_CLASS_ID || class2.id === null ? "" : class2.id,
          ...classes1.value.map((class1) => props4.matrix.getValue(class2.id, class1.id)),
          props4.matrix.getMetric1(class2.id)
        ].map((value2) => value2.toString().replace(/,/g, ".")).join(",");
        return row;
      }).join("\n");
      const matchRow = [
        t2("rvai-base.components.confusionMatrix.matchPercentage"),
        "",
        ...(classes1.value ?? []).map((item) => props4.matrix.getMetric2(item.id)),
        props4.matrix.getMetricTotal()
      ].map((value2) => value2.toString().replace(/,/g, ".")).join(",");
      const csv = `${headerRow}
${subheaderRow}
${dataRows}
${matchRow}`;
      return csv;
    }
    watch(() => props4.detailed, (value2, prevValue) => {
      if (prevValue && !value2) {
        maxTableWidth = 0;
        calculateMatrixSize();
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      classes1,
      classes2,
      confusionMatrixRef,
      confusionMatrixTableRef,
      cssVars,
      deselectAllOutliers,
      generateCSV,
      getClassName,
      hasSquareBackground,
      isDark,
      isSelected,
      NULL_CLASS_ID,
      onResize,
      reduced,
      renderBorders,
      select,
      selectAllOutliers,
      t: t2
    };
  }
});
const _hoisted_1$11 = ["data-automation"];
const _hoisted_2$Q = { class: "col-auto q-py-xs" };
const _hoisted_3$I = { class: "row no-wrap items-center text-bold" };
const _hoisted_4$r = ["data-automation"];
const _hoisted_5$m = {
  key: 0,
  class: "confusion-matrix__cell confusion-matrix__cell--header confusion-matrix__cell--left"
};
const _hoisted_6$d = { class: "row items-center text-bold no-wrap" };
const _hoisted_7$b = { class: "q-ml-sm zero-min-width" };
const _hoisted_8$7 = ["data-automation", "onClick"];
const _hoisted_9$6 = { class: "flex inline items-center no-wrap" };
const _hoisted_10$4 = ["data-automation"];
const _hoisted_11$4 = { class: "confusion-matrix__cell-wrapper" };
const _hoisted_12$3 = ["data-automation"];
const _hoisted_13$3 = ["onClick"];
const _hoisted_14$2 = ["data-automation"];
const _hoisted_15$2 = ["data-automation", "onClick"];
const _hoisted_16$1 = {
  key: 0,
  class: "confusion-matrix__cell--null"
};
const _hoisted_17$1 = {
  key: 1,
  class: "confusion-matrix__cell-value q-px-xs"
};
const _hoisted_18$1 = { class: "row no-wrap items-center q-mt-sm" };
const _hoisted_19$1 = { class: "row no-wrap items-center q-mt-sm" };
const _hoisted_20 = {
  key: 0,
  class: "confusion-matrix__cell--null"
};
const _hoisted_21 = { class: "confusion-matrix__cell-wrapper confusion-matrix__cell-value text-bold" };
const _hoisted_22 = {
  key: 0,
  class: "confusion-matrix__cell confusion-matrix__cell--left text-bold"
};
const _hoisted_23 = ["data-automation"];
const _hoisted_24 = {
  key: 0,
  class: "confusion-matrix__cell--null"
};
const _hoisted_25 = { class: "confusion-matrix__cell-value" };
const _hoisted_26 = { class: "confusion-matrix__cell-wrapper text-bold" };
function _sfc_render$16(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = resolveComponent("Avatar");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  const _component_Bullet = resolveComponent("Bullet");
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createElementBlock("div", {
    ref: "confusionMatrixRef",
    class: normalizeClass(["confusion-matrix bg-white text-small text-grey-1", {
      "confusion-matrix--borders-x": _ctx.withBorders,
      "confusion-matrix--borders-y": _ctx.renderBorders || _ctx.withBorders,
      "confusion-matrix--dense": _ctx.dense,
      "confusion-matrix--superdense": _ctx.dense && _ctx.reduced,
      "confusion-matrix--selectable": _ctx.selectable,
      "confusion-matrix--square": _ctx.hasSquareBackground
    }]),
    "data-automation": _ctx.buildId(),
    style: normalizeStyle(_ctx.cssVars)
  }, [
    !_ctx.dense ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["confusion-matrix__before row justify-center full-width bg-white", { "q-pb-xs": _ctx.detailed }])
    }, [
      createElementVNode("div", _hoisted_2$Q, [
        renderSlot(_ctx.$slots, "source2", {}, () => [
          createElementVNode("div", _hoisted_3$I, [
            createVNode(_component_Avatar, {
              "background-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "white" : _ctx.source2.color,
              "border-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "grey-1" : "white",
              "data-automation": _ctx.buildId("source2"),
              initials: _ctx.source2.initials,
              label: _ctx.source2.name,
              "show-logo": !_ctx.source2.initials && !_ctx.source2.isUser,
              "text-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "grey-1" : "",
              uuid: _ctx.source2.id
            }, null, 8, ["background-color", "border-color", "data-automation", "initials", "label", "show-logo", "text-color", "uuid"]),
            createVNode(_component_EllipsisText, {
              class: "q-ml-sm",
              "data-automation": _ctx.buildId("source2__label"),
              text: _ctx.source2.name
            }, null, 8, ["data-automation", "text"])
          ])
        ], true)
      ])
    ], 2)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: normalizeClass(["confusion-matrix__wrapper", { "confusion-matrix__wrapper--detailed": _ctx.detailed }])
    }, [
      createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"]),
      createElementVNode("div", {
        ref: "confusionMatrixTableRef",
        class: "confusion-matrix__table",
        "data-automation": _ctx.buildId("table")
      }, [
        !_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["confusion-matrix__header bg-grey-5 text-bold", { "confusion-matrix__header--detailed": _ctx.detailed }])
        }, [
          !_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", _hoisted_5$m, [
            !_ctx.dense ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["confusion-matrix__cell-wrapper", { "q-ml-sm": _ctx.detailed }])
            }, [
              renderSlot(_ctx.$slots, "source1", {}, () => [
                createElementVNode("div", _hoisted_6$d, [
                  createVNode(_component_Avatar, {
                    "background-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "white" : _ctx.source1.color,
                    "border-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "grey-1" : "white",
                    "data-automation": _ctx.buildId("source1"),
                    initials: _ctx.source1.initials,
                    label: _ctx.source1.name,
                    "show-logo": !_ctx.source1.initials && !_ctx.source1.isUser,
                    "text-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "grey-1" : "",
                    uuid: _ctx.source1.id
                  }, null, 8, ["background-color", "border-color", "data-automation", "initials", "label", "show-logo", "text-color", "uuid"]),
                  createElementVNode("div", _hoisted_7$b, [
                    createVNode(_component_EllipsisText, {
                      "data-automation": _ctx.buildId("source1__label"),
                      text: _ctx.source1.name
                    }, null, 8, ["data-automation", "text"])
                  ])
                ])
              ], true)
            ], 2)) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.classes2, (class2, index2) => {
            return openBlock(), createElementBlock("div", {
              key: class2.id,
              class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--header", {
                "confusion-matrix__cell--last": index2 + 1 === _ctx.classes2.length,
                "confusion-matrix__cell--selected": _ctx.isSelected(void 0, class2.id)
              }]),
              "data-automation": _ctx.buildId(`cell--header-${class2.id}`),
              onClick: ($event) => _ctx.select($event, void 0, class2.id)
            }, [
              createElementVNode("div", _hoisted_9$6, [
                class2.id !== _ctx.NULL_CLASS_ID ? (openBlock(), createBlock(_component_Bullet, {
                  key: 0,
                  class: normalizeClass(["col-fixed", {
                    "q-mr-xs": !_ctx.reduced && !_ctx.dense && class2.id !== _ctx.NULL_CLASS_ID
                  }]),
                  color: class2.color,
                  "data-automation": _ctx.buildId(`cell--header-${class2.id}__bullet`),
                  size: "8"
                }, null, 8, ["class", "color", "data-automation"])) : createCommentVNode("", true),
                !_ctx.reduced && !_ctx.dense ? (openBlock(), createBlock(_component_EllipsisText, {
                  key: 1,
                  "data-automation": _ctx.buildId(`cell--header-${class2.id}__label`),
                  text: _ctx.getClassName(class2)
                }, null, 8, ["data-automation", "text"])) : class2.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("span", {
                  key: 2,
                  "data-automation": _ctx.buildId(`cell--header-${class2.id}__label`)
                }, toDisplayString(_ctx.t("rvai-base.general.text.no")), 9, _hoisted_10$4)) : createCommentVNode("", true),
                _ctx.reduced || _ctx.dense ? (openBlock(), createBlock(_component_Tooltip, {
                  key: 3,
                  "data-automation": _ctx.buildId(`cell--header-${class2.id}__tooltip`)
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.getClassName(class2)), 1)
                  ]),
                  _: 2
                }, 1032, ["data-automation"])) : createCommentVNode("", true)
              ])
            ], 10, _hoisted_8$7);
          }), 128)),
          createElementVNode("div", {
            class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--header confusion-matrix__cell--right", { "confusion-matrix__cell--right--detailed": _ctx.detailed }])
          }, [
            createElementVNode("div", _hoisted_11$4, toDisplayString(!_ctx.dense && !_ctx.detailed ? _ctx.t("rvai-base.components.confusionMatrix.matchPercentage") : _ctx.t("rvai-base.general.symbols.percentage")), 1)
          ], 2)
        ], 2)) : createCommentVNode("", true),
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.classes1, (class1, index1) => {
          return openBlock(), createElementBlock("div", {
            key: class1.id,
            class: normalizeClass(["confusion-matrix__row", {
              "confusion-matrix__row--last": index1 + 1 === _ctx.classes1.length
            }]),
            "data-automation": _ctx.buildId(`row-${class1.id}`)
          }, [
            !_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--left text-bold", { "confusion-matrix__cell--selected": _ctx.isSelected(class1.id, void 0) }]),
              onClick: ($event) => _ctx.select($event, class1.id, void 0)
            }, [
              createElementVNode("div", {
                class: normalizeClass(["confusion-matrix__cell-wrapper flex inline items-center no-wrap", { "q-ml-sm": _ctx.detailed }])
              }, [
                class1.id !== _ctx.NULL_CLASS_ID ? (openBlock(), createBlock(_component_Bullet, {
                  key: 0,
                  class: normalizeClass(["col-fixed", {
                    "q-mr-xs": !_ctx.dense && class1.id !== _ctx.NULL_CLASS_ID
                  }]),
                  color: class1.color,
                  "data-automation": _ctx.buildId(`row-${class1.id}__bullet`),
                  size: "8"
                }, null, 8, ["class", "color", "data-automation"])) : createCommentVNode("", true),
                !_ctx.dense ? (openBlock(), createBlock(_component_EllipsisText, {
                  key: 1,
                  "data-automation": _ctx.buildId(`row-${class1.id}__label`),
                  text: _ctx.getClassName(class1)
                }, null, 8, ["data-automation", "text"])) : class1.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("span", {
                  key: 2,
                  "data-automation": _ctx.buildId(`row-${class1.id}__label`)
                }, toDisplayString(_ctx.t("rvai-base.general.text.no")), 9, _hoisted_14$2)) : createCommentVNode("", true)
              ], 2)
            ], 10, _hoisted_13$3)) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.classes2, (class2, index2) => {
              return openBlock(), createElementBlock("div", {
                key: class2.id,
                class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--content", {
                  "confusion-matrix__cell--last": index2 + 1 === _ctx.classes2.length,
                  "confusion-matrix__cell--selected": _ctx.isSelected(class1.id, class2.id)
                }]),
                "data-automation": _ctx.buildId(`cell--content-${class2.id}`),
                style: normalizeStyle(_ctx.matrix.getStyle(class1.id, class2.id, _ctx.isDark)),
                onClick: ($event) => _ctx.select($event, class1.id, class2.id)
              }, [
                class1.id === _ctx.NULL_CLASS_ID || class2.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("div", _hoisted_16$1)) : createCommentVNode("", true),
                !_ctx.dense ? (openBlock(), createElementBlock("div", _hoisted_17$1, toDisplayString(_ctx.matrix.getValue(class1.id, class2.id) || "-"), 1)) : createCommentVNode("", true),
                createVNode(_component_Tooltip, {
                  anchor: "center middle",
                  "data-automation": _ctx.buildId(`cell--content-${class2.id}__tooltip`),
                  self: "center left"
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", null, [
                      createElementVNode("strong", null, toDisplayString(_ctx.matrix.getValue(class1.id, class2.id)), 1),
                      createTextVNode(" " + toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [_ctx.matrix.getPercentage(class1.id, class2.id)])), 1)
                    ]),
                    createElementVNode("div", _hoisted_18$1, [
                      createVNode(_component_Avatar, {
                        "background-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "white" : _ctx.source2.color,
                        "border-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "grey-1" : "white",
                        "data-automation": _ctx.buildId(`cell--content-${class2.id}__tooltip-avatar`),
                        initials: _ctx.source2.initials,
                        label: _ctx.source2.name,
                        "show-logo": !_ctx.source2.initials && !_ctx.source2.isUser,
                        "text-color": _ctx.overrideCurrentUserAvatar && _ctx.source2.isCurrent ? "grey-1" : "",
                        uuid: _ctx.source2.id
                      }, null, 8, ["background-color", "border-color", "data-automation", "initials", "label", "show-logo", "text-color", "uuid"]),
                      createVNode(_component_EllipsisText, {
                        class: "q-ml-sm",
                        "data-automation": _ctx.buildId(`cell--content-${class2.id}__tooltip-label`),
                        text: _ctx.getClassName(class2)
                      }, null, 8, ["data-automation", "text"])
                    ]),
                    createElementVNode("div", _hoisted_19$1, [
                      createVNode(_component_Avatar, {
                        "background-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "white" : _ctx.source1.color,
                        "border-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "grey-1" : "white",
                        "data-automation": _ctx.buildId(`cell--content-${class1.id}__tooltip-avatar`),
                        initials: _ctx.source1.initials,
                        label: _ctx.source1.name,
                        "show-logo": !_ctx.source1.initials && !_ctx.source1.isUser,
                        "text-color": _ctx.overrideCurrentUserAvatar && _ctx.source1.isCurrent ? "grey-1" : "",
                        uuid: _ctx.source1.id
                      }, null, 8, ["background-color", "border-color", "data-automation", "initials", "label", "show-logo", "text-color", "uuid"]),
                      createVNode(_component_EllipsisText, {
                        class: "q-ml-sm",
                        "data-automation": _ctx.buildId(`cell--content-${class1.id}__tooltip-label`),
                        text: _ctx.getClassName(class1)
                      }, null, 8, ["data-automation", "text"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["data-automation"])
              ], 14, _hoisted_15$2);
            }), 128)),
            !_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--match confusion-matrix__cell--right", { "confusion-matrix__cell--right--detailed": _ctx.detailed }])
            }, [
              class1.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("div", _hoisted_20)) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_21, toDisplayString(_ctx.matrix.getMetric1(class1.id)), 1)
            ], 2)) : createCommentVNode("", true)
          ], 10, _hoisted_12$3);
        }), 128)),
        !_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["confusion-matrix__footer bg-white", { "confusion-matrix__footer--detailed": _ctx.detailed }])
        }, [
          !_ctx.dense || !_ctx.reduced ? (openBlock(), createElementBlock("div", _hoisted_22, [
            createElementVNode("div", {
              class: normalizeClass(["confusion-matrix__cell-wrapper", { "q-ml-sm": _ctx.detailed }])
            }, toDisplayString(!_ctx.dense && !_ctx.detailed || _ctx.showMatchWord ? _ctx.t("rvai-base.components.confusionMatrix.matchPercentage") : _ctx.t("rvai-base.general.symbols.percentage")), 3)
          ])) : createCommentVNode("", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.classes2, (class2, index2) => {
            return openBlock(), createElementBlock("div", {
              key: class2.id,
              class: normalizeClass(["confusion-matrix__cell text-bold", {
                "confusion-matrix__cell--last": index2 + 1 === _ctx.classes2.length
              }]),
              "data-automation": _ctx.buildId(`cell-${class2.id}`)
            }, [
              class2.id === _ctx.NULL_CLASS_ID ? (openBlock(), createElementBlock("div", _hoisted_24)) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_25, toDisplayString(_ctx.matrix.getMetric2(class2.id)), 1)
            ], 10, _hoisted_23);
          }), 128)),
          createElementVNode("div", {
            class: normalizeClass(["confusion-matrix__cell confusion-matrix__cell--match confusion-matrix__cell--right", { "confusion-matrix__cell--right--detailed": _ctx.detailed }])
          }, [
            createElementVNode("div", _hoisted_26, toDisplayString(_ctx.matrix.getMetricTotal()), 1)
          ], 2)
        ], 2)) : createCommentVNode("", true)
      ], 8, _hoisted_4$r)
    ], 2)
  ], 14, _hoisted_1$11);
}
const ConfusionMatrix = /* @__PURE__ */ _export_sfc(_sfc_main$1h, [["render", _sfc_render$16], ["__scopeId", "data-v-af54c4a9"]]);
var Steps = /* @__PURE__ */ ((Steps2) => {
  Steps2["Action"] = "action";
  Steps2["Info"] = "info";
  return Steps2;
})(Steps || {});
const _sfc_main$1g = defineComponent({
  name: "CookiesDialog",
  components: {
    QCard: QCard_default,
    QCardActions: QCardActions_default,
    QCardSection: QCardSection_default,
    QDialog: QDialog_default,
    QIcon: QIcon_default,
    RvButton: Button
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "cookiesDialog"
    },
    /**
     * Provide cookies label for accept button
     */
    cookiesAcceptBtn: {
      type: String,
      default: void 0
    },
    /**
     * Provide cookies label for reject button
     */
    cookiesRejectBtn: {
      type: String,
      default: void 0
    },
    /**
     * Provide cookies title
     */
    cookiesTitle: {
      type: String,
      default: void 0
    },
    /**
     * Provide cookies URL to open in the iframe
     */
    cookiesUrl: {
      type: String,
      required: true
    },
    /**
     * Provide cookies dialog width
     */
    cookiesWidth: {
      type: String,
      default: "420px"
    }
  },
  emits: [
    ...useDialogPluginComponent.emits,
    /**
     * Emitted when a cookie policy has been accepted or rejected
     *
     * @type {object}
     */
    "set-cookies-policy"
  ],
  setup(props4) {
    const { t: t2 } = useI18n();
    const {
      dialogRef,
      onDialogCancel,
      onDialogHide,
      onDialogOK
    } = useDialogPluginComponent();
    const {
      hasCookiesPolicy,
      setCookiesPolicy
    } = useCookiesPolicy();
    const currentStep = ref$1(
      "action"
      /* Action */
    );
    function onAccept() {
      setCookiesPolicy(CookiesPolicy.All);
      onDialogOK();
    }
    function onReject() {
      setCookiesPolicy(CookiesPolicy.Required);
      onDialogOK();
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      CookiesPolicy,
      currentStep,
      dialogRef,
      hasCookiesPolicy,
      onAccept,
      onCancel: onDialogCancel,
      onHide: onDialogHide,
      onReject,
      setCookiesPolicy,
      Steps,
      t: t2
    };
  }
});
const _hoisted_1$10 = { class: "text-subtitle1 q-ml-sm" };
const _hoisted_2$P = ["data-automation"];
const _hoisted_3$H = ["data-automation", "src"];
function _sfc_render$15(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvButton = resolveComponent("RvButton");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_i18n_t = resolveComponent("i18n-t");
  const _component_QCardActions = resolveComponent("QCardActions");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  const _directive_quasar_variables = resolveDirective("quasar-variables");
  return openBlock(), createBlock(_component_QDialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId(),
    maximized: _ctx.currentStep === _ctx.Steps.Info,
    persistent: !_ctx.hasCookiesPolicy
  }, toHandlers(_ctx.$attrs), { onHide: _ctx.onHide }), {
    default: withCtx(() => [
      _ctx.currentStep === _ctx.Steps.Action ? (openBlock(), createBlock(_component_QCard, {
        key: 0,
        class: "rv-cookies-actions-dialog column no-wrap",
        "data-automation": _ctx.buildId("card1"),
        style: normalizeStyle({ width: _ctx.cookiesWidth })
      }, {
        default: withCtx(() => [
          _ctx.hasCookiesPolicy ? (openBlock(), createBlock(_component_QCardSection, {
            key: 0,
            class: "q-pb-none flex justify-end"
          }, {
            default: withCtx(() => [
              createVNode(_component_RvButton, {
                "data-automation": _ctx.buildId("close1"),
                icon: "mdi-close",
                tertiary: "",
                onClick: _ctx.onCancel
              }, null, 8, ["data-automation", "onClick"])
            ]),
            _: 1
          })) : createCommentVNode("", true),
          createVNode(_component_QCardSection, {
            class: normalizeClass(["row justify-center items-center", { "q-pt-none": _ctx.hasCookiesPolicy }])
          }, {
            default: withCtx(() => [
              createVNode(_component_QIcon, {
                color: "black-1",
                "data-automation": _ctx.buildId("icon-cookie"),
                name: "rvai-base:cookie",
                size: "36px"
              }, null, 8, ["data-automation"]),
              createElementVNode("span", _hoisted_1$10, toDisplayString(_ctx.cookiesTitle || _ctx.t("rvai-base.policiesAndLicenses.titles.cookies")), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          createVNode(_component_QCardSection, { class: "rv-cookies-actions-dialog__content q-px-md q-py-none" }, {
            default: withCtx(() => [
              createVNode(_component_i18n_t, { keypath: "rvai-base.policiesAndLicenses.text.cookies" }, {
                here: withCtx(() => [
                  createElementVNode("a", {
                    class: "rv-cookies-actions-dialog__content--btn cursor-pointer",
                    "data-automation": _ctx.buildId("btn-info"),
                    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.currentStep = _ctx.Steps.Info)
                  }, toDisplayString(_ctx.t("rvai-base.policiesAndLicenses.actions.cookies.here")), 9, _hoisted_2$P)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          createVNode(_component_QCardActions, { class: "row q-pa-md flex justify-end" }, {
            default: withCtx(() => [
              createVNode(_component_RvButton, {
                "data-automation": _ctx.buildId("reject"),
                label: _ctx.cookiesRejectBtn || _ctx.t("rvai-base.policiesAndLicenses.actions.cookies.reject"),
                secondary: "",
                onClick: _ctx.onReject
              }, null, 8, ["data-automation", "label", "onClick"]),
              createVNode(_component_RvButton, {
                color: "primary",
                "data-automation": _ctx.buildId("accept"),
                label: _ctx.cookiesAcceptBtn || _ctx.t("rvai-base.policiesAndLicenses.actions.cookies.accept"),
                onClick: _ctx.onAccept
              }, null, 8, ["data-automation", "label", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data-automation", "style"])) : createCommentVNode("", true),
      _ctx.currentStep === _ctx.Steps.Info ? (openBlock(), createBlock(_component_QCard, {
        key: 1,
        class: "rv-cookies-info-dialog column no-wrap",
        "data-automation": _ctx.buildId("card2")
      }, {
        default: withCtx(() => [
          createVNode(_component_QCardSection, { class: "q-pb-none flex justify-end" }, {
            default: withCtx(() => [
              createVNode(_component_RvButton, {
                "data-automation": _ctx.buildId("close2"),
                icon: "mdi-close",
                tertiary: "",
                onClick: _cache[1] || (_cache[1] = ($event) => _ctx.currentStep = _ctx.Steps.Action)
              }, null, 8, ["data-automation"])
            ]),
            _: 1
          }),
          createVNode(_component_QCardSection, { class: "full-width full-height" }, {
            default: withCtx(() => [
              withDirectives(createElementVNode("iframe", {
                "data-automation": _ctx.buildId("iframe"),
                frameborder: "0",
                height: "100%",
                src: _ctx.cookiesUrl,
                width: "100%"
              }, null, 8, _hoisted_3$H), [
                [_directive_quasar_variables]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data-automation"])) : createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["data-automation", "maximized", "persistent", "onHide"]);
}
const CookiesDialog = /* @__PURE__ */ _export_sfc(_sfc_main$1g, [["render", _sfc_render$15], ["__scopeId", "data-v-92fcbcd8"]]);
const _sfc_main$1f = defineComponent({
  name: "CopyContentBtn",
  components: {
    RvButton: Button,
    Tooltip
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    color: {
      type: String,
      default: "primary"
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in 'flat' design
     */
    flat: {
      type: Boolean,
      default: true
    },
    /**
     * Icon name following Quasar convention; Make sure you have the icon library installed unless you are using 'img:' prefix
     */
    icon: {
      type: String,
      default: "mdi-content-copy"
    },
    /**
     * Text displayed next to icon
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Hides icon
     */
    noIcon: {
      type: Boolean,
      default: true
    },
    /**
     * Render button in secondary mode
     */
    secondary: {
      type: Boolean,
      default: false
    },
    /**
     * Shows default label after copying (by default 5000ms, can be changed with time-after-copying property)
     */
    showDefaultLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Size in standard size name (xs|sm|md|lg)
     */
    size: {
      type: String,
      default: "md"
    },
    /**
     * The time in ms after which 'Copied' changes to default label. By default 5000ms.
     */
    timeAfterCopying: {
      type: Number,
      default: 5e3
    },
    /**
     * Text copied to clipboard
     */
    value: {
      type: String,
      required: true
    }
  },
  emits: ["click"],
  setup(props4, { emit }) {
    const { t: t2 } = useI18n();
    const copied = ref$1(false);
    const currentIcon = computed(() => {
      return props4.noIcon || copied.value ? void 0 : props4.icon;
    });
    const currentLabel = computed(() => {
      return copied.value ? t2("rvai-base.components.copyContentButton.copied") : props4.label;
    });
    async function copyToClipboard() {
      try {
        if ("clipboard" in navigator) {
          navigator.clipboard.writeText(props4.value);
        }
        const node = createNode(props4.value);
        document.body.appendChild(node);
        const selection = getSelection();
        if (!selection) throw new Error();
        selection.removeAllRanges();
        const range2 = document.createRange();
        range2.selectNodeContents(node);
        selection.addRange(range2);
        document.execCommand("copy");
        selection.removeAllRanges();
        document.body.removeChild(node);
        copied.value = true;
        if (props4.showDefaultLabel) {
          await wait(props4.timeAfterCopying);
          copied.value = false;
        }
      } catch (e2) {
        console.error("Failed to copy to clipboard", e2);
      } finally {
        emit("click");
      }
    }
    function createNode(text) {
      const node = document.createElement("pre");
      node.style.height = "1px";
      node.style.position = "fixed";
      node.style.top = "5px";
      node.style.width = "1px";
      node.textContent = text;
      return node;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      copied,
      copyToClipboard,
      currentIcon,
      currentLabel,
      t: t2
    };
  }
});
function _sfc_render$14(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_RvButton = resolveComponent("RvButton");
  return openBlock(), createBlock(_component_RvButton, mergeProps(_ctx.dataAttrs, {
    class: ["copy-content-btn cursor-pointer", _ctx.$props.class],
    color: _ctx.disable ? "grey-2" : _ctx.color,
    "data-automation": _ctx.buildId(),
    disable: _ctx.disable,
    icon: _ctx.currentIcon,
    label: _ctx.currentLabel,
    secondary: _ctx.secondary,
    size: _ctx.size,
    tertiary: _ctx.flat,
    onClick: _cache[0] || (_cache[0] = () => _ctx.copyToClipboard())
  }), {
    default: withCtx(() => [
      !_ctx.disable && !_ctx.copied ? (openBlock(), createBlock(_component_Tooltip, { key: 0 }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.t("rvai-base.components.copyContentButton.copy")), 1)
        ]),
        _: 1
      })) : createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["class", "color", "data-automation", "disable", "icon", "label", "secondary", "size", "tertiary"]);
}
const CopyContentBtn = /* @__PURE__ */ _export_sfc(_sfc_main$1f, [["render", _sfc_render$14]]);
const _hoisted_1$$ = ["data-automation"];
const _hoisted_2$O = { class: "rv-date" };
const _hoisted_3$G = ["data-automation"];
const _hoisted_4$q = {
  class: "q-mt-md q-mb-sm",
  style: { "margin-left": "13px", "margin-right": "13px" }
};
const _hoisted_5$l = {
  class: "flex flex-row no-wrap",
  style: { "margin-left": "11px", "margin-right": "11px" }
};
const _hoisted_6$c = { class: "q-px-sm flex items-center" };
const _hoisted_7$a = { class: "q-px-sm flex items-center" };
const DATE_FORMAT = "yyyy-MM-dd";
const DATE_WITH_FULL_TIME_FORMAT = "yyyy-MM-dd HH:mm:ss";
const DATE_WITH_TIME_FORMAT = "yyyy-MM-dd HH:mm";
const _sfc_main$1e = /* @__PURE__ */ defineComponent({
  __name: "DatePicker",
  props: /* @__PURE__ */ mergeModels({
    clearable: { type: Boolean, default: true },
    dataAutomation: { default: void 0 },
    dense: { type: Boolean, default: false },
    label: { default: "" },
    locale: { default: void 0 },
    optionalLabel: { default: "" },
    options: { type: Function, default: () => true },
    placeholder: { default: "" },
    showHint: { type: Boolean, default: true },
    showOptionalLabel: { type: Boolean, default: false },
    validationError: { default: "" },
    validationErrorShownWhen: { default: "focused" },
    withSeconds: { type: Boolean, default: true },
    withTime: { type: Boolean, default: false },
    withValidation: { type: Boolean, default: false },
    wrapperClass: { default: void 0 }
  }, {
    "modelValue": {
      default: ""
    },
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels([
    /**
     * Emitted when input is updated
     *
     * @type {object}
     */
    "update:original-value"
  ], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {
    useCssVars((_ctx) => ({
      "v060538c4": messagesColor.value
    }));
    const DATE_REGEX = /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/g;
    const DATE_WITH_FULL_TIME_FORMAT_REGEX = /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])$/g;
    const DATE_WITH_TIME_REGEX = /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):([0-5][0-9])$/g;
    const props4 = __props;
    const model = useModel(__props, "modelValue");
    const emit = __emit;
    const { t: t2 } = useI18n();
    const isFocused = ref$1(false);
    const originalData = ref$1(model.value);
    const popupRef = ref$1(null);
    const inputRef = ref$1(null);
    const defaultLocale = {
      days: t2("rvai-base.components.datePicker.days").split("_"),
      daysShort: t2("rvai-base.components.datePicker.daysShort").split("_"),
      firstDayOfWeek: 0,
      months: t2("rvai-base.components.datePicker.months").toUpperCase().split("_"),
      monthsShort: t2("rvai-base.components.datePicker.monthsShort").toUpperCase().split("_")
    };
    const dateFormat = computed(() => {
      if (!props4.withTime) return DATE_FORMAT;
      return props4.withSeconds ? DATE_WITH_FULL_TIME_FORMAT : DATE_WITH_TIME_FORMAT;
    });
    const regex = computed(() => {
      if (!props4.withTime) return DATE_REGEX;
      return props4.withSeconds ? DATE_WITH_FULL_TIME_FORMAT_REGEX : DATE_WITH_TIME_REGEX;
    });
    const hours = ref$1("");
    function parseTimeComponents(value2) {
      const res = {
        hours: "",
        minutes: "",
        seconds: ""
      };
      if (!value2) return res;
      const DATE_TIME_SEPARATOR = " ";
      const [_date, time] = value2.split(DATE_TIME_SEPARATOR);
      if (!time) return res;
      const TIME_SEPARATOR = ":";
      const [hours2, minutes2, seconds2] = time.split(TIME_SEPARATOR);
      res.hours = hours2 ?? "";
      res.minutes = minutes2 ?? "";
      res.seconds = props4.withSeconds ? seconds2 ?? "" : "";
      return res;
    }
    function hoursBlur() {
      const v = hours.value ?? "00";
      const [
        dates,
        time
      ] = getCurrent().split(" ");
      const timeArray = time.split(":");
      const minutesString = timeArray[1] ?? "00";
      const secondsString = props4.withSeconds ? timeArray[2] ?? "00" : "";
      const regex1 = /^[0-9]$/gi;
      const regex2 = /^[0][1-9]$/gi;
      const regex3 = /^[0][1][0-9]$/gi;
      const regex4 = /^[0][2][0-3]$/gi;
      const regex5 = /^[2][0-3]$/gi;
      const regex6 = /^[1][0-9]$/gi;
      const regex7 = /^[0]+$/gi;
      const regex8 = /^[0][0][1-9]$/gi;
      const timeFormat = props4.withSeconds ? `:${secondsString}` : "";
      const setModelHours = (hours2) => {
        model.value = `${dates} ${hours2}:${minutesString}${timeFormat}`;
      };
      if (Number(v) > 23) {
        setModelHours("23");
      } else if (regex1.test(v)) {
        setModelHours(`0${v}`);
      } else if (regex2.test(v) || regex5.test(v) || regex6.test(v)) {
        setModelHours(v);
      } else if (regex3.test(v) || regex4.test(v) || regex8.test(v)) {
        setModelHours(v.substring(1, 3));
      } else if (regex7.test(v)) {
        setModelHours("00");
      }
    }
    const minutes = ref$1("");
    function minutesBlur() {
      const minutesValue = minutes.value ?? "00";
      const [
        dates,
        time
      ] = getCurrent().split(" ");
      const timeArray = time.split(":");
      const hoursString = timeArray[0] ?? "00";
      const secondsString = props4.withSeconds ? timeArray[2] ?? "00" : "";
      const singleDigitRegex = /^[0-9]$/gi;
      const zeroAndSingleDigitRegex = /^[0][1-9]$/gi;
      const zeroAndDoubleDigitRegex = /^[0][0-5][0-9]$/gi;
      const fullDoubleDigitRegex = /^[1-5][0-9]$/gi;
      const allZeroesRegex = /^[0]+$/gi;
      const doubleZeroAndDigitRegex = /^[0][0][1-9]$/gi;
      const timeFormat = props4.withSeconds ? `:${secondsString}` : "";
      const dateHH = `${dates} ${hoursString}`;
      const setModelMinutes = (hours2) => {
        model.value = `${dateHH}:${hours2}${timeFormat}`;
      };
      if (Number(minutesValue) > 60) {
        setModelMinutes("59");
      } else if (singleDigitRegex.test(minutesValue)) {
        setModelMinutes(`0${minutesValue}`);
      } else if (zeroAndSingleDigitRegex.test(minutesValue) || fullDoubleDigitRegex.test(minutesValue)) {
        setModelMinutes(`${minutesValue}`);
      } else if (zeroAndDoubleDigitRegex.test(minutesValue) || doubleZeroAndDigitRegex.test(minutesValue)) {
        setModelMinutes(`${minutesValue.substring(1, 3)}`);
      } else if (allZeroesRegex.test(minutesValue)) {
        setModelMinutes("00");
      }
    }
    const seconds = ref$1("");
    function secondsBlur() {
      const secondsValue = seconds.value ?? "00";
      const [
        dates,
        time
      ] = getCurrent().split(" ");
      const timeArray = time.split(":");
      const hoursString = timeArray[0] ?? "00";
      const minutesString = timeArray[1] ?? "00";
      const regex1 = /^[0-9]$/gi;
      const regex2 = /^[0][1-9]$/gi;
      const regex3 = /^[0][0-5][0-9]$/gi;
      const regex4 = /^[1-5][0-9]$/gi;
      const regex5 = /^[0]+$/gi;
      const regex6 = /^[0][0][1-9]$/gi;
      const setModelSeconds = (seconds2) => {
        model.value = `${dates} ${hoursString}:${minutesString}:${seconds2}`;
      };
      if (Number(secondsValue) > 60) {
        setModelSeconds("59");
      } else if (regex1.test(secondsValue)) {
        setModelSeconds(`0${secondsValue}`);
      } else if (regex2.test(secondsValue) || regex4.test(secondsValue)) {
        setModelSeconds(secondsValue);
      } else if (regex3.test(secondsValue) || regex6.test(secondsValue)) {
        setModelSeconds(secondsValue.substring(1, 3));
      } else if (regex5.test(secondsValue)) {
        setModelSeconds("00");
      }
    }
    const date = computed({
      get() {
        return model.value;
      },
      set(value2) {
        var _a;
        if (!props4.clearable && !value2) {
          return;
        }
        if (!value2) {
          model.value = "";
          return;
        }
        const v = getDateValue(value2);
        if (!props4.options(v)) return;
        if (v.length !== mask.value.length) return;
        if (new RegExp(regex.value).test(v)) {
          model.value = v;
        }
        if (popupRef.value && !props4.withTime) {
          popupRef.value.hide();
          (_a = inputRef.value) == null ? void 0 : _a.blur();
        }
      }
    });
    const mask = computed(() => {
      if (!props4.withTime) return "YYYY-MM-DD";
      return props4.withSeconds ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";
    });
    const messagesColor = computed(() => props4.withValidation && v$.value.$invalid ? "var(--q-negative)" : "var(--q-grey-1)");
    const shouldShowPassedValidationError = computed(() => {
      if (props4.validationErrorShownWhen === "focused") return isFocused.value;
      return props4.validationError !== "";
    });
    const validationRules = computed(() => {
      return {
        originalData: ValidationBuilder.withLabel("Datepicker").custom(
          (value2) => !value2 || new RegExp(regex.value).test(value2),
          t2("rvai-base.components.datePicker.wrongFormat")
        ).customError(shouldShowPassedValidationError.value ? props4.validationError : "").rules
      };
    });
    const v$ = useVuelidate(
      validationRules,
      {
        originalData
      },
      { $autoDirty: true }
    );
    function getTimeValue() {
      if (!hours.value || !minutes.value || props4.withSeconds && !seconds.value) {
        return "";
      }
      return props4.withSeconds ? `${hours.value}:${minutes.value}:${seconds.value}` : `${hours.value}:${minutes.value}`;
    }
    function getDateValue(value2) {
      const time = getTimeValue();
      return time && value2.split(" ")[1] !== time ? `${value2.split(" ")[0]} ${time}` : value2;
    }
    function getCurrent() {
      const today = startOfToday();
      const fullTimeFormat = props4.withSeconds ? DATE_WITH_FULL_TIME_FORMAT : DATE_WITH_TIME_FORMAT;
      if (model.value) {
        const parsed = parse$3(model.value, dateFormat.value, today);
        if (isValid(parsed)) {
          return format(parsed, fullTimeFormat);
        }
      }
      return format(today, fullTimeFormat);
    }
    function onBeforeHide() {
      if (!props4.withTime) return;
      const curr = parseTimeComponents(model.value);
      if (hours.value !== curr.hours) hoursBlur();
      if (minutes.value !== curr.minutes) minutesBlur();
      if (props4.withSeconds && seconds.value !== curr.seconds) secondsBlur();
    }
    function isValidValue(v) {
      return v.length === mask.value.length && new RegExp(regex.value).test(v) && props4.options(v);
    }
    function updateValueOnBlur() {
      const v = originalData.value;
      if (!isValidValue(v)) {
        originalData.value = model.value;
        return;
      }
      model.value = v;
    }
    function onBlur2() {
      isFocused.value = false;
      updateValueOnBlur();
    }
    function onFocus() {
      isFocused.value = true;
    }
    function resetDate() {
      originalData.value = "";
      model.value = "";
    }
    watch(model, (value2) => {
      originalData.value = value2;
      const time = parseTimeComponents(value2);
      hours.value = time.hours;
      minutes.value = time.minutes;
      seconds.value = time.seconds;
    }, { immediate: true });
    watch(originalData, () => {
      emit("update:original-value", originalData.value);
    }, { immediate: true });
    const {
      buildId
    } = useAutomation(computed(() => props4.dataAutomation));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["rv-date-picker", [__props.wrapperClass, { "rv-date-picker--dense": __props.dense }]]),
        "data-automation": unref(buildId)()
      }, [
        createVNode(RvInput, {
          ref_key: "inputRef",
          ref: inputRef,
          modelValue: originalData.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => originalData.value = $event),
          "data-automation": unref(buildId)("date"),
          hint: __props.showHint ? mask.value : void 0,
          label: __props.label,
          maxlength: "0",
          "optional-label": __props.optionalLabel,
          placeholder: __props.placeholder,
          "show-optional-label": __props.showOptionalLabel,
          "show-valid": false,
          validation: __props.withValidation ? unref(v$).originalData : void 0,
          onBlur: onBlur2,
          onFocus
        }, {
          append: withCtx(() => [
            createVNode(unref(QIcon_default), {
              class: "cursor-pointer",
              color: "grey-1",
              "data-automation": unref(buildId)("icon-calendar"),
              name: "rvai-base:calendar"
            }, {
              default: withCtx(() => [
                createVNode(unref(QPopupProxy_default), {
                  ref_key: "popupRef",
                  ref: popupRef,
                  offset: [0, 5],
                  onBeforeHide
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_2$O, [
                      createVNode(unref(QDate_default), {
                        modelValue: date.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => date.value = $event),
                        class: "rv-date",
                        "data-automation": unref(buildId)("date-picker"),
                        locale: __props.locale ?? defaultLocale,
                        mask: mask.value,
                        minimal: "",
                        options: __props.options,
                        "years-in-month-view": false
                      }, {
                        default: withCtx(() => [
                          __props.withTime ? (openBlock(), createElementBlock("div", {
                            key: 0,
                            class: "border-top",
                            "data-automation": unref(buildId)("with-time")
                          }, [
                            renderSlot(_ctx.$slots, "time-input-label", {}, () => [
                              createElementVNode("div", _hoisted_4$q, toDisplayString(unref(t2)("rvai-base.components.datePicker.selectTime")), 1)
                            ], true),
                            createElementVNode("div", _hoisted_5$l, [
                              createVNode(RvInput, {
                                modelValue: hours.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => hours.value = $event),
                                "data-automation": unref(buildId)("hours"),
                                maxlength: "3",
                                placeholder: unref(t2)("rvai-base.components.datePicker.hh"),
                                onBlur: hoursBlur
                              }, null, 8, ["modelValue", "data-automation", "placeholder"]),
                              createElementVNode("div", _hoisted_6$c, toDisplayString(unref(t2)("rvai-base.general.symbols.semicolon")), 1),
                              createVNode(RvInput, {
                                modelValue: minutes.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => minutes.value = $event),
                                "data-automation": unref(buildId)("minutes"),
                                maxlength: "3",
                                placeholder: unref(t2)("rvai-base.components.datePicker.mm"),
                                onBlur: minutesBlur
                              }, null, 8, ["modelValue", "data-automation", "placeholder"]),
                              __props.withSeconds ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                                createElementVNode("div", _hoisted_7$a, toDisplayString(unref(t2)("rvai-base.general.symbols.semicolon")), 1),
                                createVNode(RvInput, {
                                  modelValue: seconds.value,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => seconds.value = $event),
                                  "data-automation": unref(buildId)("seconds"),
                                  maxlength: "3",
                                  placeholder: unref(t2)("rvai-base.components.datePicker.ss"),
                                  onBlur: secondsBlur
                                }, null, 8, ["modelValue", "data-automation", "placeholder"])
                              ], 64)) : createCommentVNode("", true)
                            ])
                          ], 8, _hoisted_3$G)) : createCommentVNode("", true)
                        ]),
                        _: 3
                      }, 8, ["modelValue", "data-automation", "locale", "mask", "options"])
                    ])
                  ]),
                  _: 3
                }, 512)
              ]),
              _: 3
            }, 8, ["data-automation"]),
            __props.clearable && __props.modelValue ? (openBlock(), createBlock(unref(QIcon_default), {
              key: 0,
              class: "cursor-pointer",
              color: "grey-1",
              "data-automation": unref(buildId)("icon-close"),
              name: "rvai-base:close",
              onClick: resetDate
            }, null, 8, ["data-automation"])) : createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["modelValue", "data-automation", "hint", "label", "optional-label", "placeholder", "show-optional-label", "validation"])
      ], 10, _hoisted_1$$);
    };
  }
});
const DatePicker = /* @__PURE__ */ _export_sfc(_sfc_main$1e, [["__scopeId", "data-v-2a51510f"]]);
const OUTER_THICKNESS_DEFAULT_VALUE = 0.2;
const _sfc_main$1d = defineComponent({
  name: "DoubleCircularProgress",
  components: {
    CircularProgress
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "double-circular-progress"
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Size of text in CSS units, including unit name. Suggestion: use 'em' units to sync with component size
     */
    fontSize: {
      type: String,
      default: "8px"
    },
    /**
     * Color name for the inner arc progress from the Quasar Color Palette
     */
    innerColor: {
      type: String,
      default: "grey-2"
    },
    /**
     * Put inner component into 'indeterminate' state; Ignores 'value' prop
     */
    innerIndeterminate: {
      type: Boolean,
      default: false
    },
    /**
     * Maximum value for inner circle defining 100% progress made (must be higher than 'min')
     */
    innerMax: {
      type: Number,
      default: 100
    },
    /**
     * Minimum value for inner circle defining 'no progress' (must be lower than 'max')
     */
    innerMin: {
      type: Number,
      default: 0
    },
    /**
     * Inner component size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
     */
    innerSize: {
      type: String,
      default: void 0
    },
    /**
     * Thickness of inner progress arc as a ratio (0.0 < x < 1.0) of component size
     */
    innerThickness: {
      type: Number,
      default: void 0
    },
    /**
     * Color name for the inner track of the component from the Quasar Color Palette
     */
    innerTrackColor: {
      type: String,
      default: void 0
    },
    /**
     * Current progress for inner component (must be between min/max)
     */
    innerValue: {
      type: Number,
      default: 0
    },
    /**
     * Color name for the outer arc progress from the Quasar Color Palette
     */
    outerColor: {
      type: String,
      default: "primary"
    },
    /**
     * Put outer component into 'indeterminate' state; Ignores 'value' prop
     */
    outerIndeterminate: {
      type: Boolean,
      default: false
    },
    /**
     * Maximum value for outer circle defining 100% progress made (must be higher than 'min')
     */
    outerMax: {
      type: Number,
      default: 100
    },
    /**
     * Minimum value for outer circle defining 'no progress' (must be lower than 'max')
     */
    outerMin: {
      type: Number,
      default: 0
    },
    /**
     * Outer component size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
     */
    outerSize: {
      type: String,
      default: "50px"
    },
    /**
     * Thickness of outer progress arc as a ratio (0.0 < x < 1.0) of component size
     */
    outerThickness: {
      type: Number,
      default: void 0
    },
    /**
     * Color name for the outer track of the component from the Quasar Color Palette
     */
    outerTrackColor: {
      type: String,
      default: void 0
    },
    /**
     * Current progress for outer component  (must be between min/max)
     */
    outerValue: {
      type: Number,
      default: 0
    },
    /**
     * Enables the default slot and uses it (if available), otherwise it displays the 'value' prop as text;
     * Make sure the text has enough space to be displayed inside the component
     */
    showValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props4) {
    const { isDark } = useDarkMode();
    const innerSizeComputed = computed(() => {
      return props4.innerSize ?? `${Math.ceil(parseInt(props4.outerSize) - parseInt(props4.outerSize) * outerThicknessComputed.value)}px`;
    });
    const innerThicknessComputed = computed(() => {
      const outerThicknessPx = parseInt(props4.outerSize) * outerThicknessComputed.value;
      const innerThickness = outerThicknessPx / parseInt(innerSizeComputed.value);
      return props4.innerThickness ?? innerThickness;
    });
    const innerTrackColorComputed = computed(() => {
      if (props4.innerTrackColor) return props4.innerTrackColor;
      return isDark.value ? "grey-1--dark" : "grey-3--light";
    });
    const outerThicknessComputed = computed(() => {
      return props4.outerThickness ?? OUTER_THICKNESS_DEFAULT_VALUE;
    });
    const outerTrackColorComputed = computed(() => {
      if (props4.outerTrackColor) return props4.outerTrackColor;
      return isDark.value ? "grey-1--dark" : "grey-3--light";
    });
    const percentage = computed(() => {
      const innerPercentage = Math.round(props4.innerValue / props4.innerMax * 100);
      const outerPercentage = Math.round(props4.outerValue / props4.outerMax * 100);
      return Math.max(innerPercentage, outerPercentage);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      innerSizeComputed,
      innerThicknessComputed,
      innerTrackColorComputed,
      outerThicknessComputed,
      outerTrackColorComputed,
      percentage
    };
  }
});
function _sfc_render$13(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CircularProgress = resolveComponent("CircularProgress");
  return openBlock(), createBlock(_component_CircularProgress, {
    class: normalizeClass(_ctx.$props.class),
    color: _ctx.outerColor,
    "data-automation": _ctx.buildId(),
    indeterminate: _ctx.outerIndeterminate,
    max: _ctx.outerMax,
    min: _ctx.outerMin,
    "show-value": "",
    size: _ctx.outerSize,
    thickness: _ctx.outerThicknessComputed,
    "track-color": _ctx.outerTrackColorComputed,
    value: _ctx.outerValue
  }, {
    default: withCtx(() => [
      createVNode(_component_CircularProgress, {
        color: _ctx.innerColor,
        "data-automation": _ctx.buildId("inner"),
        "font-size": _ctx.fontSize,
        indeterminate: _ctx.innerIndeterminate,
        max: _ctx.innerMax,
        min: _ctx.innerMin,
        "show-value": _ctx.showValue,
        size: _ctx.innerSizeComputed,
        thickness: _ctx.innerThicknessComputed,
        "track-color": _ctx.innerTrackColorComputed,
        value: _ctx.innerValue
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", { percentage: _ctx.percentage })
        ]),
        _: 3
      }, 8, ["color", "data-automation", "font-size", "indeterminate", "max", "min", "show-value", "size", "thickness", "track-color", "value"])
    ]),
    _: 3
  }, 8, ["class", "color", "data-automation", "indeterminate", "max", "min", "size", "thickness", "track-color", "value"]);
}
const DoubleCircularProgress = /* @__PURE__ */ _export_sfc(_sfc_main$1d, [["render", _sfc_render$13]]);
const _sfc_main$1c = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "ButtonDropdown",
  props: {
    align: { default: "center" },
    autoClose: { type: Boolean, default: false },
    class: { default: void 0 },
    color: { default: "primary" },
    dataAutomation: { default: void 0 },
    disable: { type: Boolean, default: false },
    icon: { default: void 0 },
    iconRight: { default: void 0 },
    label: { default: void 0 },
    loading: { type: [Boolean, null], default: false },
    secondary: { type: Boolean, default: false },
    size: { default: "md" },
    style: { default: void 0 },
    tertiary: { type: Boolean, default: false },
    textColor: { default: void 0 },
    tooltip: { default: void 0 }
  },
  setup(__props, { expose: __expose }) {
    const slots = useSlots();
    const props4 = __props;
    const dropdown = useTemplateRef("dropdown");
    __expose({
      dropdown
    });
    const {
      buildId,
      dataAttrs
    } = useAutomation(computed(() => props4.dataAutomation));
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(QBtnDropdown_default), mergeProps({
        ref_key: "dropdown",
        ref: dropdown
      }, unref(dataAttrs), {
        align: __props.align,
        "auto-close": __props.autoClose,
        class: ["rv-button-dropdown", [
          props4.class,
          `rv-button-dropdown--${__props.size}`,
          { "rv-button-dropdown--icon-only": !__props.label }
        ]],
        color: __props.color,
        "data-automation": unref(buildId)(),
        disable: __props.disable,
        flat: __props.tertiary,
        icon: __props.icon,
        "icon-right": __props.iconRight,
        label: __props.label,
        loading: __props.loading,
        "no-caps": "",
        outline: __props.secondary,
        ripple: false,
        style: __props.style,
        "text-color": __props.textColor
      }), createSlots({ _: 2 }, [
        __props.tooltip ? {
          name: "label",
          fn: withCtx(() => [
            createVNode(Tooltip, {
              "data-automation": unref(buildId)("tooltip")
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.tooltip), 1)
              ]),
              _: 1
            }, 8, ["data-automation"])
          ]),
          key: "0"
        } : void 0,
        renderList(unref(slots), (_, name2) => {
          return {
            name: name2,
            fn: withCtx((slotData) => [
              renderSlot(_ctx.$slots, name2, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)
            ])
          };
        })
      ]), 1040, ["align", "auto-close", "class", "color", "data-automation", "disable", "flat", "icon", "icon-right", "label", "loading", "outline", "style", "text-color"]);
    };
  }
});
const ButtonDropdown = /* @__PURE__ */ _export_sfc(_sfc_main$1c, [["__scopeId", "data-v-010e4085"]]);
const _sfc_main$1b = defineComponent({
  name: "Validation",
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    validation: {
      type: Object,
      default: void 0
    }
  },
  setup(props4) {
    const {
      classRef,
      error,
      errorMessage
    } = useValidation(props4);
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      classRef,
      error,
      errorMessage
    };
  }
});
const _hoisted_1$_ = ["data-automation"];
const _hoisted_2$N = { class: "q-field--dense q-field--error" };
const _hoisted_3$F = ["data-automation"];
function _sfc_render$12(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "rv-validation",
    "data-automation": _ctx.buildId()
  }, [
    renderSlot(_ctx.$slots, "default", {}, void 0, true),
    createElementVNode("div", _hoisted_2$N, [
      _ctx.error ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["q-field__bottom", _ctx.classRef]),
        "data-automation": _ctx.buildId("error"),
        role: "alert"
      }, toDisplayString(_ctx.errorMessage), 11, _hoisted_3$F)) : createCommentVNode("", true)
    ])
  ], 8, _hoisted_1$_);
}
const Validation = /* @__PURE__ */ _export_sfc(_sfc_main$1b, [["render", _sfc_render$12], ["__scopeId", "data-v-c4b1d2e6"]]);
const _sfc_main$1a = defineComponent({
  name: "Dropzone",
  components: {
    QIcon: QIcon_default,
    Validation
  },
  props: {
    /**
       * Allowed extensions (.tgz|.jpg|.png etc.)
       */
    allowedExtensions: {
      type: Array,
      default: void 0
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Indicates that only directories should be available to be selected by the user in the file picker interface.
     */
    directory: {
      type: Boolean,
      default: false
    },
    /**
     * Indicates that dropzone is disabled.
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Empty state title
     */
    emptyTitle: {
      type: String,
      default: void 0
    },
    /**
     * Allowed number of files, if multiple is true
     */
    maxFiles: {
      type: Number,
      default: 1e3
    },
    /**
     * The maximum allowed size of the combined files (in bytes)
     */
    maxSize: {
      type: Number,
      default: void 0
    },
    /**
     * Model value - always an array, even if multiple is false
     */
    modelValue: {
      type: Array,
      required: true
    },
    /**
     * Allows to select more than one file
     */
    multiple: {
      type: Boolean,
      default: true
    },
    /**
     * Makes the selection of files optional. If false, will return a validation error if empty.
     */
    optional: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when files in the file input are clearer
     *
     * @type {object}
     */
    "clear",
    /**
     * Emitted when files in the file input are changed
     *
     * @type {object}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t2 } = useI18n();
    const inputRef = ref$1();
    const dragging = ref$1(false);
    const isDisabled = computed(() => {
      if (error.value) return true;
      if (!props4.multiple && !!props4.modelValue.length) return true;
      return props4.disable;
    });
    const error = computed(() => {
      var _a;
      if (!v$.value.$error) return void 0;
      return (_a = v$.value.$errors[0]) == null ? void 0 : _a.$message;
    });
    const extensions = computed(() => {
      var _a;
      return (_a = props4.allowedExtensions) == null ? void 0 : _a.join(", ");
    });
    const hasData = computed(() => {
      return !!props4.modelValue.length;
    });
    const icon = computed(() => {
      if (error.value) {
        return "mdi-alert-circle-outline";
      } else if (hasData.value) {
        return "mdi-check-circle";
      } else {
        return "rvai-base:arrow-circle-up";
      }
    });
    const title = computed(() => {
      if (error.value) {
        return t2("rvai-base.components.dropzone.errorTitle");
      } else if (hasData.value) {
        return t2("rvai-base.components.dropzone.dataTitle", props4.modelValue.length);
      } else if (props4.emptyTitle) {
        return props4.emptyTitle;
      } else if (props4.dense) {
        return t2("rvai-base.components.dropzone.denseTitle");
      } else {
        return t2("rvai-base.components.dropzone.emptyTitle", props4.multiple ? props4.maxFiles : 1);
      }
    });
    const totalFileSize = computed(() => {
      return props4.modelValue.reduce((acc, f) => acc + f.size, 0);
    });
    const validationRules = computed(() => ({
      value: ValidationBuilder.$t("rvai-base.general.text.theValue").custom(
        (files) => {
          const maxFiles = props4.multiple ? props4.maxFiles : 1;
          return files.length <= maxFiles;
        },
        "rvai-base.components.dropzone.validation.maxFiles",
        [props4.multiple ? props4.maxFiles : 1],
        "maxFiles"
      ).custom(
        (files) => {
          const { allowedExtensions } = props4;
          if (!(allowedExtensions == null ? void 0 : allowedExtensions.length)) return true;
          return files.every((f) => allowedExtensions.some((ext) => f.name.toLowerCase().endsWith(ext)));
        },
        "rvai-base.components.dropzone.validation.fileExtensions",
        [],
        "fileExtensions"
      ).custom(
        () => {
          const { maxSize } = props4;
          if (!maxSize) return true;
          return totalFileSize.value <= maxSize;
        },
        "rvai-base.components.dropzone.validation.maxSize",
        computed(() => [
          formatBytes(totalFileSize.value, 3),
          formatBytes(props4.maxSize ?? 0, 3)
        ]),
        "maxSize"
      ).rules
    }));
    const v$ = useVuelidate(
      validationRules,
      computed(() => ({
        value: props4.modelValue
      })),
      { $autoDirty: true }
    );
    const requiredRules = computed(() => ({
      value: ValidationBuilder.$t("rvai-base.general.text.theValue").arrayRequiredIf(!props4.optional).rules
    }));
    const vRequired$ = useVuelidate(
      requiredRules,
      computed(() => ({
        value: props4.modelValue
      })),
      { $autoDirty: true }
    );
    function onChange(files) {
      if (!files.length) return;
      emit("update:modelValue", [...props4.modelValue, ...files]);
    }
    function onClear() {
      emit("update:modelValue", []);
      emit("clear");
    }
    function onClick() {
      var _a;
      if (isDisabled.value) return;
      (_a = inputRef.value) == null ? void 0 : _a.click();
    }
    function onDragLeave(e2) {
      e2.preventDefault();
      e2.stopPropagation();
      dragging.value = false;
    }
    function onDragOver(e2) {
      e2.preventDefault();
      e2.stopPropagation();
      if (isDisabled.value) return;
      dragging.value = true;
    }
    async function onDrop(e2) {
      e2.preventDefault();
      e2.stopPropagation();
      dragging.value = false;
      if (!e2.dataTransfer || isDisabled.value) return;
      try {
        const files = await getFiles(e2.dataTransfer.items);
        const toChange = props4.multiple ? files : [files[0]];
        onChange(toChange);
      } catch (error2) {
        console.error(error2);
      }
    }
    function onFilesChanged(e2) {
      const input = e2.target;
      const files = Array.from((input == null ? void 0 : input.files) ?? []);
      onChange(files);
      input.value = "";
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      dragging,
      error,
      extensions,
      hasData,
      icon,
      inputRef,
      isDisabled,
      onClear,
      onClick,
      onDragLeave,
      onDragOver,
      onDrop,
      onFilesChanged,
      t: t2,
      title,
      v$,
      vRequired$
    };
  }
});
const _hoisted_1$Z = ["data-automation"];
const _hoisted_2$M = ["data-automation"];
const _hoisted_3$E = ["data-automation"];
const _hoisted_4$p = ["data-automation"];
const _hoisted_5$k = ["data-automation"];
const _hoisted_6$b = { class: "dropzone__link" };
const _hoisted_7$9 = ["data-automation"];
const _hoisted_8$6 = ["data-automation"];
const _hoisted_9$5 = { class: "dropzone__link" };
const _hoisted_10$3 = ["data-automation"];
const _hoisted_11$3 = ["data-automation"];
const _hoisted_12$2 = { class: "text-small" };
const _hoisted_13$2 = ["accept", "data-automation", "multiple", "webkitdirectory"];
function _sfc_render$11(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_i18n_t = resolveComponent("i18n-t");
  const _component_Validation = resolveComponent("Validation");
  return openBlock(), createBlock(_component_Validation, {
    "data-automation": _ctx.buildId("validation"),
    validation: _ctx.vRequired$.value
  }, {
    default: withCtx(() => [
      createElementVNode("div", {
        class: normalizeClass(["dropzone column no-wrap items-center bg-white rounded-borders text-center q-pa-lg", {
          "cursor-pointer": !_ctx.isDisabled,
          "dropzone--dragging": _ctx.dragging,
          "dropzone--disabled text-grey-2": _ctx.disable
        }]),
        "data-automation": _ctx.buildId(),
        onClick: _cache[4] || (_cache[4] = (...args) => _ctx.onClick && _ctx.onClick(...args)),
        onDragenter: _cache[5] || (_cache[5] = (...args) => _ctx.onDragOver && _ctx.onDragOver(...args)),
        onDragleave: _cache[6] || (_cache[6] = (...args) => _ctx.onDragLeave && _ctx.onDragLeave(...args)),
        onDragover: _cache[7] || (_cache[7] = (...args) => _ctx.onDragOver && _ctx.onDragOver(...args)),
        onDrop: _cache[8] || (_cache[8] = (...args) => _ctx.onDrop && _ctx.onDrop(...args))
      }, [
        createVNode(_component_QIcon, {
          class: "dropzone__icon q-mb-md",
          "data-automation": _ctx.buildId("icon"),
          name: _ctx.icon,
          size: "40px"
        }, null, 8, ["data-automation", "name"]),
        createElementVNode("div", {
          class: "text-subtitle2 text-black-1",
          "data-automation": _ctx.buildId("title")
        }, toDisplayString(_ctx.title), 9, _hoisted_2$M),
        _ctx.error ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createElementVNode("div", {
            class: "text-small",
            "data-automation": _ctx.buildId("error")
          }, toDisplayString(_ctx.error), 9, _hoisted_3$E),
          createElementVNode("div", {
            class: "text-small q-mt-sm",
            "data-automation": _ctx.buildId("description")
          }, [
            createElementVNode("span", {
              class: "cursor-pointer dropzone__link",
              onClick: _cache[0] || (_cache[0] = withModifiers((...args) => _ctx.onClear && _ctx.onClear(...args), ["stop"]))
            }, toDisplayString(_ctx.t("rvai-base.components.dropzone.retry")), 1)
          ], 8, _hoisted_4$p)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          _ctx.hasData ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            _ctx.multiple ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              !_ctx.dense ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: "text-small q-mt-sm",
                "data-automation": _ctx.buildId("maxFiles")
              }, toDisplayString(_ctx.t("rvai-base.components.dropzone.maxFiles", _ctx.maxFiles)), 9, _hoisted_5$k)) : createCommentVNode("", true),
              createVNode(_component_i18n_t, {
                class: "text-small q-mt-sm",
                "data-automation": _ctx.buildId("description"),
                keypath: "rvai-base.components.dropzone.dataDescription",
                scope: "global",
                tag: "div"
              }, {
                default: withCtx(() => [
                  createElementVNode("span", _hoisted_6$b, toDisplayString(_ctx.t("rvai-base.components.dropzone.addMore")), 1),
                  createElementVNode("span", {
                    class: "dropzone__link",
                    onClick: _cache[1] || (_cache[1] = withModifiers((...args) => _ctx.onClear && _ctx.onClear(...args), ["stop"]))
                  }, toDisplayString(_ctx.t("rvai-base.components.dropzone.clearAll")), 1)
                ]),
                _: 1
              }, 8, ["data-automation"])
            ], 64)) : (openBlock(), createElementBlock("div", {
              key: 1,
              class: "text-small q-mt-sm",
              "data-automation": _ctx.buildId("description")
            }, [
              createElementVNode("span", {
                class: "cursor-pointer dropzone__link",
                onClick: _cache[2] || (_cache[2] = withModifiers((...args) => _ctx.onClear && _ctx.onClear(...args), ["stop"]))
              }, toDisplayString(_ctx.t("rvai-base.components.dropzone.clearFile")), 1)
            ], 8, _hoisted_7$9))
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            !_ctx.dense ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "text-small q-mt-sm",
              "data-automation": _ctx.buildId("maxFiles")
            }, toDisplayString(_ctx.t("rvai-base.components.dropzone.maxFiles", _ctx.multiple ? _ctx.maxFiles : 1)), 9, _hoisted_8$6)) : createCommentVNode("", true),
            !_ctx.dense ? (openBlock(), createBlock(_component_i18n_t, {
              key: 1,
              class: "text-small q-mt-sm",
              "data-automation": _ctx.buildId("description"),
              keypath: "rvai-base.components.dropzone.emptyDescription",
              scope: "global",
              tag: "div"
            }, {
              default: withCtx(() => [
                createElementVNode("span", _hoisted_9$5, toDisplayString(_ctx.t("rvai-base.components.dropzone.uploadFromComputer")), 1)
              ]),
              _: 1
            }, 8, ["data-automation"])) : createCommentVNode("", true)
          ], 64)),
          _ctx.allowedExtensions && !_ctx.dense ? (openBlock(), createElementBlock("div", {
            key: 2,
            class: "text-small q-mt-sm",
            "data-automation": _ctx.buildId("extensions")
          }, toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [_ctx.allowedExtensions.join(", ")])), 9, _hoisted_10$3)) : createCommentVNode("", true),
          _ctx.dragging ? (openBlock(), createElementBlock("div", {
            key: 3,
            class: "dropzone__drag column no-wrap justify-center items-center q-mt-sm",
            "data-automation": _ctx.buildId("dragging")
          }, [
            createElementVNode("div", {
              class: normalizeClass(["dropzone__drag__icon col-fixed", [
                _ctx.dense ? "q-mb-md" : "q-mb-lg",
                { "dropzone__drag__icon--dense": _ctx.dense }
              ]])
            }, [
              createVNode(_component_QIcon, {
                color: "white",
                name: "rvai-base:file-copy",
                size: _ctx.dense ? "22px" : "32px"
              }, null, 8, ["size"])
            ], 2),
            createElementVNode("div", {
              class: normalizeClass(["text-subtitle2 text-black-1", { "q-mb-sm": !_ctx.dense }])
            }, toDisplayString(_ctx.t("rvai-base.components.dropzone.dragTitle")), 3),
            createElementVNode("div", _hoisted_12$2, toDisplayString(_ctx.t("rvai-base.components.dropzone.dragDescription")), 1)
          ], 8, _hoisted_11$3)) : createCommentVNode("", true)
        ], 64)),
        createElementVNode("input", {
          ref: "inputRef",
          accept: _ctx.extensions,
          class: "hidden",
          "data-automation": _ctx.buildId("input"),
          multiple: _ctx.multiple,
          type: "file",
          webkitdirectory: _ctx.directory,
          onChange: _cache[3] || (_cache[3] = (...args) => _ctx.onFilesChanged && _ctx.onFilesChanged(...args))
        }, null, 40, _hoisted_13$2)
      ], 42, _hoisted_1$Z)
    ]),
    _: 1
  }, 8, ["data-automation", "validation"]);
}
const Dropzone = /* @__PURE__ */ _export_sfc(_sfc_main$1a, [["render", _sfc_render$11], ["__scopeId", "data-v-32ad4474"]]);
const _sfc_main$19 = defineComponent({
  name: "RvSelect",
  components: {
    EllipsisText,
    QIcon: QIcon_default,
    QItem: QItem_default,
    QItemLabel: QItemLabel_default,
    QItemSection: QItemSection_default,
    QSelect: QSelect_default,
    Tooltip
  },
  inheritAttrs: true,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Show label inside element
     */
    caption: {
      type: String,
      default: void 0
    },
    /**
     * Show clear button
     */
    clearable: {
      type: Boolean,
      default: false
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Override default selection string, if not using 'selected' slot/scoped slot and if not using 'use-chips' prop
     */
    displayValue: {
      type: [Number, String],
      default: void 0
    },
    /**
     * Update model with the value of the selected option instead of the whole option
     */
    emitValue: {
      type: Boolean,
      default: false
    },
    /**
     * Fills the input with current value; Useful along with 'hide-selected'; Does NOT works along with 'multiple' selection
     */
    fillInput: {
      type: Boolean,
      default: false
    },
    /**
     * Hides selection; Use the underlying input tag to hold the label (instead of showing it to the right of the input) of the selected option; Only works for non 'multiple' Selects
     */
    hideSelected: {
      type: Boolean,
      default: false
    },
    /**
     * Helper (hint) text which gets placed below your wrapped form component
     */
    hint: {
      type: String,
      default: void 0
    },
    /**
     * Adds info icon and shows the text on hover
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: "rv-select__info-text"
    },
    /**
     * Debounce the input model update with an amount of milliseconds
     */
    inputDebounce: {
      type: [Number, String],
      default: 500
    },
    /**
     * A text label that will “float” up above the input field, once the field gets focus
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Try to map labels of model from 'options' Array; has a small performance penalty; If you are using emit-value you will probably need to use map-options to display the label text in the select field rather than the value;  Refer to the 'Affecting model' section above
     */
    mapOptions: {
      type: Boolean,
      default: false
    },
    /**
     * Model of the component; Must be Array if using 'multiple' prop; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: [Array, Number, Object, String, Boolean],
      default: void 0
    },
    /**
     * Allow multiple selection; Model must be Array
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    /**
     * Property of option which holds the 'label'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionLabel: {
      type: String,
      default: "label"
    },
    /**
     * Property of option which holds the 'value'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionValue: {
      type: String,
      default: "value"
    },
    /**
     * Available options that the user can select from. For best performance freeze the list of options.
     */
    options: {
      type: [Number, Object, String, Boolean],
      default: () => []
    },
    /**
     * Dense mode for options list; occupies less space
     */
    optionsDense: {
      type: Boolean,
      default: false
    },
    /**
     * Class definitions to be attributed to the popup content
     */
    popupContentClass: {
      type: String,
      default: "rv-select__menu"
    },
    /**
     * Put component in readonly mode
     */
    readonly: {
      type: Boolean,
      default: false
    },
    /**
     * Shows label before select
     */
    showLabelBefore: {
      type: Boolean,
      default: false
    },
    /**
     * Shows optional label after base label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Use an input tag where users can type
     */
    useInput: {
      type: Boolean,
      default: false
    },
    /**
     * Validation for the component
     */
    validation: {
      type: Object,
      default: void 0
    }
  },
  emits: [
    "filter",
    "input-value",
    "on-popup-hide",
    "on-popup-show",
    "update:modelValue"
  ],
  setup(props4, {
    emit,
    slots
  }) {
    const { t: t2 } = useI18n();
    const {
      classRef,
      error,
      errorMessage,
      isValidated,
      onBlur: onBlur2
    } = useValidation(props4);
    const selectRef = ref$1(null);
    const showCaption = ref$1(!!props4.caption);
    const optionWidth = computed(() => {
      var _a;
      const componentWidth = ((_a = selectRef.value) == null ? void 0 : _a.$el.offsetWidth) ?? 0;
      return componentWidth - 64;
    });
    const value2 = computed({
      get() {
        return props4.modelValue;
      },
      set(value22) {
        emit("update:modelValue", value22);
      }
    });
    function onFilter(...args) {
      emit("filter", ...args);
    }
    function onInput(value22) {
      emit("input-value", value22);
    }
    function onPopupHide() {
      showCaption.value = true;
      emit("on-popup-hide");
    }
    function onPopupShow() {
      showCaption.value = false;
      emit("on-popup-show");
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      classRef,
      error,
      errorMessage,
      isValidated,
      onBlur: onBlur2,
      onFilter,
      onInput,
      onPopupHide,
      onPopupShow,
      optionWidth,
      showCaption,
      slots,
      t: t2,
      value: value2
    };
  }
});
const _hoisted_1$Y = ["data-automation"];
const _hoisted_2$L = {
  key: 0,
  class: "rv-select__label row no-wrap items-center"
};
const _hoisted_3$D = {
  key: 0,
  class: "q-ml-xs"
};
const _hoisted_4$o = { class: "rv-select__label text-black-1 row no-wrap items-center" };
const _hoisted_5$j = {
  key: 0,
  class: "q-ml-xs"
};
function _sfc_render$10(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItemSection = resolveComponent("QItemSection");
  const _component_QItem = resolveComponent("QItem");
  const _component_QSelect = resolveComponent("QSelect");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["rv-select", [
      _ctx.classRef,
      {
        "rv-select--dense": _ctx.dense,
        "rv-select--disabled": _ctx.disable || _ctx.readonly
      }
    ]]),
    "data-automation": _ctx.buildId()
  }, [
    !_ctx.showLabelBefore ? (openBlock(), createElementBlock("div", _hoisted_2$L, [
      createVNode(_component_EllipsisText, {
        class: "text-subtitle3",
        "data-automation": _ctx.buildId("label")
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.label), 1)
        ]),
        _: 1
      }, 8, ["data-automation"]),
      _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_3$D, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
      _ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
        key: 1,
        class: "q-ml-xs info-icon",
        color: "black-1",
        "data-automation": _ctx.buildId("icon-info"),
        name: "info",
        size: "16px"
      }, {
        default: withCtx(() => [
          createVNode(_component_Tooltip, {
            anchor: "top middle",
            class: normalizeClass(_ctx.infoTextClass),
            self: "bottom middle"
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "infoText", {}, () => [
                createTextVNode(toDisplayString(_ctx.infoText), 1)
              ], true)
            ]),
            _: 3
          }, 8, ["class"])
        ]),
        _: 3
      }, 8, ["data-automation"])) : createCommentVNode("", true)
    ])) : createCommentVNode("", true),
    createVNode(_component_QSelect, mergeProps({
      ref: "selectRef",
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.value = $event),
      clearable: _ctx.clearable,
      "data-automation": _ctx.buildId("select"),
      dense: "",
      disable: _ctx.disable || _ctx.readonly,
      "display-value": _ctx.displayValue,
      "emit-value": _ctx.emitValue,
      error: _ctx.error,
      "error-message": _ctx.errorMessage,
      "fill-input": _ctx.fillInput,
      "hide-bottom-space": "",
      "hide-selected": _ctx.hideSelected,
      hint: _ctx.hint,
      "input-debounce": _ctx.inputDebounce,
      "map-options": _ctx.mapOptions,
      multiple: _ctx.multiple,
      "no-error-icon": "",
      "option-label": _ctx.optionLabel,
      "option-value": _ctx.optionValue,
      options: _ctx.options,
      "options-dense": _ctx.optionsDense,
      "popup-content-class": _ctx.popupContentClass,
      standout: "",
      "use-input": _ctx.useInput,
      "v-model": _ctx.modelValue,
      "virtual-scroll-slice-size": 100
    }, { [toHandlerKey(_ctx.useInput && `filter`)]: _ctx.onFilter }, { [toHandlerKey(_ctx.useInput && `inputValue`)]: _ctx.onInput }, {
      onBlur: _ctx.onBlur,
      onPopupHide: _ctx.onPopupHide,
      onPopupShow: _ctx.onPopupShow
    }), createSlots({
      option: withCtx(({ itemProps, opt, selected }) => [
        createVNode(_component_QItem, mergeProps(itemProps, {
          "data-automation": _ctx.buildId(`option-${opt[_ctx.optionLabel] || opt}`)
        }), {
          default: withCtx(() => [
            createVNode(_component_QItemSection, { class: "q-item__section column q-item__section--main justify-center" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, { class: "q-item__label" }, {
                  default: withCtx(() => [
                    createVNode(_component_EllipsisText, {
                      style: normalizeStyle({ "width": `${_ctx.optionWidth}px` }),
                      text: opt[_ctx.optionLabel] || opt
                    }, null, 8, ["style", "text"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024),
            createVNode(_component_QItemSection, { side: "" }, {
              default: withCtx(() => [
                selected ? (openBlock(), createBlock(_component_QIcon, {
                  key: 0,
                  class: "rv-select__option--icon",
                  color: "grey-1",
                  name: "mdi-check",
                  size: "18px"
                })) : createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040, ["data-automation"])
      ]),
      _: 2
    }, [
      _ctx.modelValue == null && _ctx.caption && _ctx.showCaption ? {
        name: "selected",
        fn: withCtx(() => [
          createVNode(_component_EllipsisText, {
            class: "rv-select__caption flex items-center",
            "data-automation": _ctx.buildId("caption"),
            text: _ctx.caption
          }, null, 8, ["data-automation", "text"])
        ]),
        key: "0"
      } : void 0,
      _ctx.isValidated && (Array.isArray(_ctx.modelValue) ? _ctx.modelValue.length : _ctx.modelValue != null) ? {
        name: "after",
        fn: withCtx(() => [
          createVNode(_component_QIcon, {
            key: "valid",
            class: "rv-select__after--icon",
            color: "positive",
            "data-automation": _ctx.buildId("icon-valid"),
            name: "mdi-check-circle"
          }, null, 8, ["data-automation"])
        ]),
        key: "1"
      } : _ctx.error ? {
        name: "after",
        fn: withCtx(() => [
          createVNode(_component_QIcon, {
            key: "error",
            class: "rv-select__after--icon",
            color: "negative",
            "data-automation": _ctx.buildId("icon-error"),
            name: "mdi-close-circle"
          }, null, 8, ["data-automation"])
        ]),
        key: "2"
      } : void 0,
      _ctx.showLabelBefore ? {
        name: "before",
        fn: withCtx(() => [
          createElementVNode("div", _hoisted_4$o, [
            createVNode(_component_EllipsisText, { class: "text-subtitle3" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.label), 1)
              ]),
              _: 1
            }),
            _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_5$j, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true)
          ])
        ]),
        key: "3"
      } : void 0,
      renderList(_ctx.slots, (_, name2) => {
        return {
          name: name2,
          fn: withCtx((slotData) => [
            renderSlot(_ctx.$slots, name2, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)
          ])
        };
      })
    ]), 1040, ["modelValue", "clearable", "data-automation", "disable", "display-value", "emit-value", "error", "error-message", "fill-input", "hide-selected", "hint", "input-debounce", "map-options", "multiple", "option-label", "option-value", "options", "options-dense", "popup-content-class", "use-input", "v-model", "onBlur", "onPopupHide", "onPopupShow"])
  ], 10, _hoisted_1$Y);
}
const RvSelect = /* @__PURE__ */ _export_sfc(_sfc_main$19, [["render", _sfc_render$10], ["__scopeId", "data-v-5afa2d07"]]);
const _sfc_main$18 = defineComponent({
  name: "Duration",
  components: {
    RvSelect
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * A text label that will “float” up above the select
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Duration time in seconds
     */
    modelValue: {
      type: Number,
      required: true
    }
  },
  emits: [
    /**
     * Emitted when component value is updated
     */
    "update:modelValue"
  ],
  setup(props4) {
    const { t: t2 } = useI18n();
    const options = [
      600,
      3600,
      21600,
      86400,
      259200,
      604800,
      2678400,
      -1
    ].map((v) => ({
      label: v > 0 ? formatDuration$1(v * 1e3) : t2("rvai-base.components.duration.infinite"),
      value: v
    }));
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      options
    };
  }
});
function _sfc_render$$(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvSelect = resolveComponent("RvSelect");
  return openBlock(), createBlock(_component_RvSelect, mergeProps(_ctx.dataAttrs, {
    class: _ctx.$props.class,
    "data-automation": _ctx.buildId(),
    "emit-value": "",
    label: _ctx.label,
    "map-options": "",
    "model-value": _ctx.modelValue,
    options: _ctx.options,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
  }), null, 16, ["class", "data-automation", "label", "model-value", "options"]);
}
const Duration = /* @__PURE__ */ _export_sfc(_sfc_main$18, [["render", _sfc_render$$]]);
const _sfc_main$17 = defineComponent({
  name: "EditableText",
  components: {
    EllipsisText,
    RvButton: Button,
    RvInput
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Initialize the component in edit mode. Focus on the input.
     */
    defaultEdit: {
      type: Boolean,
      default: false
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in disabled mode(show only plain text)
     */
    disableEdit: {
      type: Boolean,
      default: false
    },
    /**
     * The value to be displaye.
     */
    displayValue: {
      type: String,
      default: void 0
    },
    /**
     * Trigger update:model-value always. Without comparing with model-value.
    */
    emitEveryTime: {
      type: Boolean,
      default: false
    },
    /**
     * Hides the edit button. Edit can still be triggered via ref.
     */
    hideEdit: {
      type: Boolean,
      default: false
    },
    /**
     * Classes to be applied to the input component
     */
    inputClass: {
      type: [Array, String, Object],
      default: void 0
    },
    /**
     * Show 3dots at the beginning
     * @type {Boolean}
     */
    reverseEllipsisText: {
      type: Boolean,
      default: false
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:model-value' event) OR use v-model directive
     */
    modelValue: {
      required: true,
      type: String
    },
    /**
     * Disable update on blur
     */
    noUpdateOnBlur: {
      type: Boolean,
      default: false
    },
    /**
     * Always shows disabled button
     */
    showButtonWhenDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Equivalent to Vue Router <router-link> 'to' property
     */
    to: {
      type: [Object, String],
      default: void 0
    },
    /**
     * Validation rules for the component
     */
    validationRules: {
      type: Object,
      default: void 0
    }
  },
  emits: [
    "cancel",
    "edit",
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const editing = ref$1(props4.defaultEdit);
    const inputRef = ref$1(null);
    const newValue = ref$1(props4.modelValue);
    const newValueTrimmed = ref$1(newValue.value.trim());
    const v$ = useVuelidate$1(
      { ...props4.validationRules && { newValue: props4.validationRules } },
      { newValue: newValueTrimmed },
      { $autoDirty: true }
    );
    function edit() {
      onEditClick();
    }
    function onCancel() {
      editing.value = false;
      newValue.value = props4.modelValue;
      emit("cancel");
    }
    function onBlur2() {
      if (props4.noUpdateOnBlur) {
        onCancel();
      } else {
        void onSave();
      }
    }
    function onKeyUp(evt) {
      switch (evt.key) {
        case "Enter":
          evt.stopPropagation();
          evt.preventDefault();
          return void onSave();
        case "Escape":
          evt.stopPropagation();
          evt.preventDefault();
          return onCancel();
      }
    }
    function onEditClick() {
      v$.value.$reset();
      editing.value = !props4.disableEdit;
      emit("edit");
    }
    async function onSave() {
      const isValid2 = await v$.value.$validate();
      if (!isValid2) {
        onCancel();
        return;
      }
      editing.value = false;
      if (newValueTrimmed.value !== props4.modelValue || props4.emitEveryTime) {
        emit("update:modelValue", newValueTrimmed.value);
      }
    }
    watch(() => props4.modelValue, (value2) => {
      newValue.value = value2;
    });
    watch(newValue, (v) => {
      newValueTrimmed.value = v.trim();
    });
    watch(
      editing,
      (value2) => {
        if (value2) {
          document.addEventListener("keyup", onKeyUp);
        } else {
          document.removeEventListener("keyup", onKeyUp);
        }
      },
      {
        immediate: true
      }
    );
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      edit,
      editing,
      inputRef,
      newValue,
      onBlur: onBlur2,
      onEditClick,
      onKeyUp,
      RouterLink,
      v$
    };
  }
});
const _hoisted_1$X = ["data-automation"];
const _hoisted_2$K = ["data-automation"];
const _hoisted_3$C = {
  key: 1,
  class: "editable-text__text-block flex items-center no-wrap"
};
function _sfc_render$_(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvInput = resolveComponent("RvInput");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_RvButton = resolveComponent("RvButton");
  return openBlock(), createElementBlock("div", {
    class: "editable-text",
    "data-automation": _ctx.buildId()
  }, [
    _ctx.editing && !_ctx.disableEdit ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "row no-wrap items-center",
      "data-automation": _ctx.buildId("container"),
      tabindex: "0"
    }, [
      createVNode(_component_RvInput, {
        ref: "inputRef",
        modelValue: _ctx.newValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.newValue = $event),
        autofocus: "",
        class: "editable-text__input",
        "data-automation": _ctx.buildId("input"),
        dense: _ctx.dense,
        "show-error-as-tooltip": "",
        "show-error-message": false,
        "tab-index": 0,
        validation: _ctx.v$.newValue,
        onBlur: _ctx.onBlur
      }, null, 8, ["modelValue", "data-automation", "dense", "validation", "onBlur"])
    ], 8, _hoisted_2$K)) : (openBlock(), createElementBlock("div", _hoisted_3$C, [
      (openBlock(), createBlock(resolveDynamicComponent(_ctx.to ? _ctx.RouterLink : "div"), {
        class: normalizeClass(["editable-text__text q-mr-sm zero-min-width", { "editable-text__text--clickable": !!_ctx.to && !_ctx.disableEdit }]),
        to: _ctx.to
      }, {
        default: withCtx(() => [
          createVNode(_component_EllipsisText, {
            "data-automation": _ctx.buildId("label"),
            reverse: _ctx.reverseEllipsisText,
            text: _ctx.displayValue == null ? _ctx.modelValue : _ctx.displayValue
          }, null, 8, ["data-automation", "reverse", "text"])
        ]),
        _: 1
      }, 8, ["class", "to"])),
      _ctx.showButtonWhenDisabled ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        !_ctx.hideEdit ? (openBlock(), createBlock(_component_RvButton, {
          key: 0,
          class: "editable-text__edit",
          "data-automation": _ctx.buildId("edit"),
          disable: _ctx.disableEdit,
          icon: "edit",
          size: "sm",
          tertiary: "",
          "text-color": "black-1",
          onClick: withModifiers(_ctx.onEditClick, ["stop", "prevent"])
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "disabled", {}, void 0, true)
          ]),
          _: 3
        }, 8, ["data-automation", "disable", "onClick"])) : createCommentVNode("", true)
      ], 64)) : !_ctx.disableEdit && !_ctx.hideEdit ? (openBlock(), createBlock(_component_RvButton, {
        key: 1,
        class: "editable-text__edit",
        "data-automation": _ctx.buildId("edit"),
        icon: "edit",
        size: "sm",
        tertiary: "",
        "text-color": "black-1",
        onClick: withModifiers(_ctx.onEditClick, ["stop", "prevent"])
      }, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)
    ]))
  ], 8, _hoisted_1$X);
}
const EditableText = /* @__PURE__ */ _export_sfc(_sfc_main$17, [["render", _sfc_render$_], ["__scopeId", "data-v-a230ee49"]]);
const _sfc_main$16 = defineComponent({
  name: "Toggle",
  inheritAtttrs: false,
  components: {
    QIcon: QIcon_default,
    QToggle: QToggle_default,
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * What model value should be considered as unchecked/unticked/off?
     */
    falseValue: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: [Array, Object, String, Boolean, Number],
      default: false
    },
    /**
     * Render info icon with tooltip. Can be used as an "info-text" property or as a slot
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: "rv-toggle__info-text"
    },
    /**
     * Label to display along the component
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:model-value' event) OR use v-model directive
     */
    modelValue: {
      type: [Array, Boolean],
      default: void 0
    },
    /**
     * What model value should be considered as checked/ticked/on?
     */
    trueValue: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: [Array, Object, String, Boolean, Number],
      default: true
    },
    /**
     * Works when model ('value') is Array. It tells the component which value should add/remove when ticked/unticked
     */
    val: {
      type: String,
      default: void 0
    }
  },
  emits: ["update:modelValue"],
  setup(props4, { emit }) {
    const value2 = computed({
      get() {
        return props4.modelValue;
      },
      set(value22) {
        emit("update:modelValue", value22);
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      value: value2
    };
  }
});
const _hoisted_1$W = ["data-automation"];
const _hoisted_2$J = ["data-automation"];
function _sfc_render$Z(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QToggle = resolveComponent("QToggle");
  return openBlock(), createElementBlock("div", {
    class: "rv-toggle row items-center",
    "data-automation": _ctx.buildId("wrapper")
  }, [
    createVNode(_component_QToggle, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.value = $event),
      class: normalizeClass(_ctx.$props.class),
      "data-automation": _ctx.buildId(),
      dense: _ctx.dense,
      disable: _ctx.disable,
      "false-value": _ctx.falseValue,
      "true-value": _ctx.trueValue,
      val: _ctx.val
    }, {
      default: withCtx(() => [
        _ctx.label || _ctx.$slots.default ? renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
          createElementVNode("div", {
            class: "rv-toggle__label text-body3 q-ml-sm row items-center",
            "data-automation": _ctx.buildId("label")
          }, [
            createTextVNode(toDisplayString(_ctx.label) + " ", 1),
            _ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
              key: 0,
              class: "q-ml-xs info-icon",
              color: "black-1",
              "data-automation": _ctx.buildId("icon-info"),
              name: "info",
              size: "16px",
              onClick: _cache[0] || (_cache[0] = withModifiers(() => {
              }, ["stop"]))
            }, {
              default: withCtx(() => [
                createVNode(_component_Tooltip, {
                  anchor: "top middle",
                  class: normalizeClass(_ctx.infoTextClass),
                  self: "bottom middle"
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "infoText", {}, () => [
                      createTextVNode(toDisplayString(_ctx.infoText), 1)
                    ], true)
                  ]),
                  _: 3
                }, 8, ["class"])
              ]),
              _: 3
            }, 8, ["data-automation"])) : createCommentVNode("", true)
          ], 8, _hoisted_2$J)
        ], true) : createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["modelValue", "class", "data-automation", "dense", "disable", "false-value", "true-value", "val"])
  ], 8, _hoisted_1$W);
}
const Toggle = /* @__PURE__ */ _export_sfc(_sfc_main$16, [["render", _sfc_render$Z], ["__scopeId", "data-v-37614148"]]);
const _sfc_main$15 = defineComponent({
  name: "ExpansionItem",
  components: {
    EllipsisText,
    QIcon: QIcon_default,
    QSlideTransition: QSlideTransition_default,
    QSpace: QSpace_default,
    Toggle
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: void 0,
      type: String
    },
    /**
     * Applies a generic border radius
     */
    border: {
      default: false,
      type: Boolean
    },
    /**
     * Show header below content when expanded
     */
    bottomHeader: {
      default: false,
      type: Boolean
    },
    /**
     * Apply custom class(es) to the content
     * @type {[Array, Object, String]}
     */
    contentClass: {
      default: void 0,
      type: [Array, Object, String]
    },
    /**
     * Puts expansion item into open state on initial render; Overridden by v-model if used
     */
    defaultOpened: {
      default: false,
      type: Boolean
    },
    /**
     * Apply custom class(es) to the expand icon
     * @type {[Array, Object, String]}
     */
    expandIconClass: {
      default: void 0,
      type: [Array, Object, String]
    },
    /**
     * Apply custom class(es) to the header actions
     * @type {[Array, Object, String]}
     */
    headerActionsClass: {
      default: void 0,
      type: [Array, Object, String]
    },
    /**
     * Apply custom class(es) to the header
     * @type {[Array, Object, String]}
     */
    headerClass: {
      default: void 0,
      type: [Array, Object, String]
    },
    /**
     * Applies background to all component when title is hovered
     * color name from the Quasar Color Palette
     */
    hoverBackgroundColor: {
      type: String,
      default: ""
    },
    /**
     * Apply custom class(es) to the icon item section
     * @type {[Array, Object, String]}
     */
    iconClass: {
      default: void 0,
      type: [Array, Object, String]
    },
    /**
     * Header label (unless using 'header' slot)
     */
    label: {
      default: void 0,
      type: String
    },
    /**
     * Model of the component defining the 'expanded' state; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      default: void 0,
      type: Boolean
    },
    /**
     * Disable animation on hover
     */
    noHoverAnimation: {
      default: false,
      type: Boolean
    },
    /**
     * Show control on the right
     */
    rightIcon: {
      default: false,
      type: Boolean
    },
    /**
     * Indicates whether or not the item is toggleable.
     */
    toggleable: {
      default: true,
      type: Boolean
    },
    /**
     * Time duration to animate hide/show content
     */
    transitionDuration: {
      default: 400,
      type: Number
    },
    /**
     * Show toggle to control visibility
     */
    useToggle: {
      default: false,
      type: Boolean
    }
  },
  emits: [
    /**
     * Emitted when showing/hidden state changes; Is also used by v-model
     * @arg {Boolean} value - New state (showing/hidden)
     */
    "update:model-value"
  ],
  setup(props4, { emit }) {
    const expanded = ref$1(false);
    const hovered = ref$1(false);
    const invertIcon = computed(() => props4.rightIcon || props4.bottomHeader);
    watchEffect(() => {
      expanded.value = props4.modelValue ?? props4.defaultOpened;
    });
    function hide() {
      expanded.value = false;
      emit("update:model-value", expanded.value);
    }
    function show() {
      expanded.value = true;
      emit("update:model-value", expanded.value);
    }
    function toggle() {
      expanded.value = !expanded.value;
      emit("update:model-value", expanded.value);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      expanded,
      hide,
      hovered,
      invertIcon,
      show,
      toggle
    };
  }
});
const _hoisted_1$V = ["data-automation"];
const _hoisted_2$I = ["data-automation"];
const _hoisted_3$B = { class: "row no-wrap items-center" };
const _hoisted_4$n = {
  key: 0,
  class: "expansion-item__content-wrapper"
};
const _hoisted_5$i = ["data-automation"];
function _sfc_render$Y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Toggle = resolveComponent("Toggle");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_QSlideTransition = resolveComponent("QSlideTransition");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([
      "expansion-item column no-wrap",
      {
        "border-card rounded-borders q-pa-md": _ctx.border,
        "expansion-item--expanded": _ctx.expanded,
        [_ctx.hoverBackgroundColor]: _ctx.hoverBackgroundColor && _ctx.hovered,
        "expansion-item--invert-icon": _ctx.invertIcon,
        "reverse": _ctx.bottomHeader
      }
    ]),
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", mergeProps({
      class: ["expansion-item__header-wrapper row items-center no-wrap text-subtitle3", [
        {
          "expansion-item__header-wrapper--animated": !_ctx.noHoverAnimation && _ctx.toggleable,
          "cursor-pointer": _ctx.toggleable,
          "reverse justify-between": _ctx.rightIcon
        },
        _ctx.headerClass
      ]]
    }, {
      [toHandlerKey(_ctx.toggleable && `click`)]: _cache[1] || (_cache[1] = (...args) => _ctx.toggle && _ctx.toggle(...args))
    }, {
      onMouseout: _cache[2] || (_cache[2] = ($event) => _ctx.hovered = false),
      onMouseover: _cache[3] || (_cache[3] = ($event) => _ctx.hovered = true)
    }), [
      _ctx.toggleable ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass([
          _ctx.rightIcon ? "q-ml-sm" : "q-mr-sm",
          _ctx.iconClass
        ])
      }, [
        _ctx.useToggle ? (openBlock(), createBlock(_component_Toggle, {
          key: 0,
          modelValue: _ctx.expanded,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.expanded = $event),
          "data-automation": _ctx.buildId("toggle")
        }, null, 8, ["modelValue", "data-automation"])) : (openBlock(), createBlock(_component_QIcon, {
          key: 1,
          "aria-expanded": _ctx.expanded,
          class: normalizeClass([
            "expansion-item__icon",
            { "expansion-item__icon--rotated": _ctx.expanded },
            _ctx.expandIconClass
          ]),
          "data-automation": _ctx.buildId("icon"),
          name: _ctx.invertIcon ? "mdi-chevron-down" : "mdi-chevron-right",
          size: "sm"
        }, null, 8, ["aria-expanded", "class", "data-automation", "name"]))
      ], 2)) : createCommentVNode("", true),
      createElementVNode("div", {
        class: "expansion-item__header col zero-min-width",
        "data-automation": _ctx.buildId("header")
      }, [
        renderSlot(_ctx.$slots, "header", {}, () => [
          createElementVNode("div", _hoisted_3$B, [
            renderSlot(_ctx.$slots, "label", { expanded: _ctx.expanded }, () => [
              createVNode(_component_EllipsisText, {
                class: "zero-min-width",
                "data-automation": _ctx.buildId("header__label"),
                text: _ctx.label
              }, null, 8, ["data-automation", "text"])
            ], true),
            createVNode(_component_QSpace),
            _ctx.$slots["header-actions"] ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["q-pl-sm", _ctx.headerActionsClass])
            }, [
              renderSlot(_ctx.$slots, "header-actions", {}, void 0, true)
            ], 2)) : createCommentVNode("", true)
          ])
        ], true)
      ], 8, _hoisted_2$I)
    ], 16),
    createVNode(_component_QSlideTransition, { duration: _ctx.transitionDuration }, {
      default: withCtx(() => [
        _ctx.expanded ? (openBlock(), createElementBlock("div", _hoisted_4$n, [
          createElementVNode("div", {
            class: normalizeClass(_ctx.contentClass ?? "q-mt-sm"),
            "data-automation": _ctx.buildId("content")
          }, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 10, _hoisted_5$i)
        ])) : createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["duration"])
  ], 10, _hoisted_1$V);
}
const ExpansionItem = /* @__PURE__ */ _export_sfc(_sfc_main$15, [["render", _sfc_render$Y], ["__scopeId", "data-v-c8edb7b9"]]);
const _sfc_main$14 = defineComponent({
  name: "ExpansionList",
  components: {
    RvButton: Button
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Emits 'show-all' event when "Show all" is clicked
     */
    emitEvents: {
      type: Boolean,
      default: false
    },
    /**
     * Arrow icon will be shown on the left side of the text
     */
    iconLeft: {
      type: Boolean,
      default: false
    },
    /**
     * Items to be displayed
     */
    items: {
      type: [Object, Array],
      required: true
    },
    /**
     * Initial number of items shown
     */
    limit: {
      type: Number,
      default: 3
    },
    /**
     * Render "Show all" button
     */
    showAll: {
      type: Boolean,
      default: false
    },
    /**
     * The number of items added when "Show more" is clicked
     */
    step: {
      type: Number,
      default: 5
    },
    /**
     * Property that defines the unique key of each item (the result must be a primitive, not Object, Array, etc)
     */
    uniqueField: {
      type: String,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when "Show all" is clicked
     */
    "show-all"
  ],
  setup(props4, { emit }) {
    const { t: t2 } = useI18n();
    const currentLimit = ref$1(props4.limit);
    const itemsLength = computed(() => {
      return Array.isArray(props4.items) ? props4.items.length : Object.keys(props4.items).length;
    });
    const itemsToShow = computed(() => {
      if (Array.isArray(props4.items)) {
        return props4.items.slice(0, currentLimit.value);
      } else {
        const entries = Object.entries(props4.items).slice(0, currentLimit.value);
        return Object.fromEntries(entries);
      }
    });
    function onShowAll() {
      if (props4.emitEvents) {
        emit("show-all");
      } else {
        currentLimit.value = itemsLength.value;
      }
    }
    function onShowLess() {
      currentLimit.value = props4.limit;
    }
    function onShowMore() {
      currentLimit.value += props4.step;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      currentLimit,
      itemsLength,
      itemsToShow,
      onShowAll,
      onShowLess,
      onShowMore,
      t: t2
    };
  }
});
const _hoisted_1$U = ["data-automation"];
const _hoisted_2$H = ["data-automation"];
const _hoisted_3$A = {
  key: 0,
  class: "expansion-list__action q-my-sm"
};
function _sfc_render$X(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvButton = resolveComponent("RvButton");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["expansion-list full-width", {
      "expansion-list--expandable": _ctx.itemsLength > _ctx.limit
    }]),
    "data-automation": _ctx.buildId()
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.itemsToShow, (item, key) => {
      return openBlock(), createElementBlock("div", {
        key: (_ctx.uniqueField && item[_ctx.uniqueField]) ?? key,
        class: "expansion-list__content",
        "data-automation": _ctx.buildId(`content-${String(key)}`)
      }, [
        renderSlot(_ctx.$slots, "default", {
          item,
          itemKey: key
        })
      ], 8, _hoisted_2$H);
    }), 128)),
    _ctx.itemsLength > _ctx.limit ? (openBlock(), createElementBlock("div", _hoisted_3$A, [
      _ctx.showAll && _ctx.itemsLength > _ctx.currentLimit ? (openBlock(), createBlock(_component_RvButton, {
        key: 0,
        class: "no-padding full-width items-start",
        color: "black-1",
        "data-automation": _ctx.buildId("show-all"),
        icon: _ctx.iconLeft ? "mdi-chevron-right" : void 0,
        "icon-right": _ctx.iconLeft ? void 0 : "mdi-chevron-right",
        label: _ctx.t("rvai-base.general.actions.showAll"),
        size: "sm",
        tertiary: "",
        onClick: _ctx.onShowAll
      }, null, 8, ["data-automation", "icon", "icon-right", "label", "onClick"])) : _ctx.itemsLength > _ctx.currentLimit ? (openBlock(), createBlock(_component_RvButton, {
        key: 1,
        class: "no-padding full-width items-start",
        color: "black-1",
        "data-automation": _ctx.buildId("show-more"),
        icon: _ctx.iconLeft ? "mdi-chevron-down" : void 0,
        "icon-right": _ctx.iconLeft ? void 0 : "mdi-chevron-down",
        label: _ctx.t("rvai-base.general.actions.showMore"),
        size: "sm",
        tertiary: "",
        onClick: _ctx.onShowMore
      }, null, 8, ["data-automation", "icon", "icon-right", "label", "onClick"])) : (openBlock(), createBlock(_component_RvButton, {
        key: 2,
        class: "no-padding full-width items-start",
        color: "black-1",
        "data-automation": _ctx.buildId("show-less"),
        icon: _ctx.iconLeft ? "mdi-chevron-up" : void 0,
        "icon-right": _ctx.iconLeft ? void 0 : "mdi-chevron-up",
        label: _ctx.t("rvai-base.general.actions.showLess"),
        size: "sm",
        tertiary: "",
        onClick: _ctx.onShowLess
      }, null, 8, ["data-automation", "icon", "icon-right", "label", "onClick"]))
    ])) : createCommentVNode("", true)
  ], 10, _hoisted_1$U);
}
const ExpansionList = /* @__PURE__ */ _export_sfc(_sfc_main$14, [["render", _sfc_render$X]]);
const _sfc_main$13 = defineComponent({
  name: "FieldEdit",
  components: {
    EllipsisText,
    QField: QField_default,
    QIcon: QIcon_default,
    QSpace: QSpace_default,
    RvButton: Button,
    Tooltip
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Render info icon with tooltip. Can be used as an "info-text" property or as a slot
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: "rv-field-edit__info-text"
    },
    /**
     * The text that will be shown on the component
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    labelClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Model of the component
     * @type {[Array, Object, String]}
     */
    modelValue: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: [Array, Boolean, Object, String, Number],
      default: void 0
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    readonly: {
      default: false,
      type: Boolean
    },
    /**
     * Shows error message
     */
    showErrorMessage: {
      type: Boolean,
      default: true
    },
    /**
     * Render optional label next to label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Validation for the component
     */
    validation: {
      type: Object,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when "Add/Edit" is clicked
     */
    "on-edit"
  ],
  setup(props4, { emit }) {
    const { t: t2 } = useI18n();
    const {
      classRef,
      error,
      errorMessage,
      isValidated
    } = useValidation(props4);
    const editIcon = computed(() => {
      return isEmpty.value ? "mdi-plus" : "mdi-pencil";
    });
    const editLabel = computed(() => {
      return isEmpty.value ? t2("rvai-base.general.actions.add") : t2("rvai-base.general.actions.edit");
    });
    const isEmpty = computed(() => {
      const value2 = props4.modelValue;
      return Array.isArray(value2) ? !value2.length : !value2;
    });
    function onEdit() {
      emit("on-edit");
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      classRef,
      editIcon,
      editLabel,
      error,
      errorMessage,
      isEmpty,
      isValidated,
      onEdit,
      t: t2
    };
  }
});
const _hoisted_1$T = ["data-automation"];
const _hoisted_2$G = { class: "row no-wrap items-center full-width" };
const _hoisted_3$z = {
  key: 0,
  class: "q-ml-xs",
  "data-test": "optional"
};
const _hoisted_4$m = ["data-automation"];
function _sfc_render$W(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_RvButton = resolveComponent("RvButton");
  const _component_QField = resolveComponent("QField");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: ["rv-field-edit", [
      _ctx.classRef,
      { "rv-field-edit--disabled": _ctx.disable }
    ]],
    "data-automation": _ctx.buildId()
  }), [
    createElementVNode("div", {
      class: normalizeClass(["rv-field-edit__label row no-wrap justify-between items-center", _ctx.labelClass])
    }, [
      createElementVNode("div", _hoisted_2$G, [
        renderSlot(_ctx.$slots, "label", {}, () => [
          createVNode(_component_EllipsisText, {
            class: "text-subtitle3",
            "data-automation": _ctx.buildId("label"),
            text: _ctx.label
          }, null, 8, ["data-automation", "text"])
        ], true),
        _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_3$z, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
        _ctx.infoText || _ctx.$slots["info-text"] ? (openBlock(), createBlock(_component_QIcon, {
          key: 1,
          class: "q-ml-xs info-icon",
          color: "black-1",
          "data-automation": _ctx.buildId("icon-info"),
          name: "info",
          size: "16px"
        }, {
          default: withCtx(() => [
            createVNode(_component_Tooltip, {
              anchor: "top middle",
              class: normalizeClass(_ctx.infoTextClass),
              self: "bottom middle"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "info-text", {}, () => [
                  createTextVNode(toDisplayString(_ctx.infoText), 1)
                ], true)
              ]),
              _: 3
            }, 8, ["class"])
          ]),
          _: 3
        }, 8, ["data-automation"])) : createCommentVNode("", true),
        createVNode(_component_QSpace),
        _ctx.isValidated && !_ctx.isEmpty && !_ctx.readonly ? (openBlock(), createBlock(_component_QIcon, {
          key: "valid",
          class: "rv-field-edit__status",
          color: "positive",
          "data-automation": _ctx.buildId("icon-valid"),
          name: "mdi-check-circle"
        }, null, 8, ["data-automation"])) : _ctx.error && _ctx.showErrorMessage && !_ctx.readonly ? (openBlock(), createBlock(_component_QIcon, {
          key: "error",
          class: "rv-field-edit__status",
          color: "negative",
          "data-automation": _ctx.buildId("icon-error"),
          name: "mdi-close-circle"
        }, null, 8, ["data-automation"])) : createCommentVNode("", true),
        !_ctx.readonly ? (openBlock(), createBlock(_component_RvButton, {
          key: 4,
          class: "q-ml-sm",
          "data-automation": _ctx.buildId("edit"),
          disable: _ctx.disable,
          icon: _ctx.editIcon,
          label: _ctx.editLabel,
          size: "sm",
          tertiary: "",
          onClick: _ctx.onEdit
        }, null, 8, ["data-automation", "disable", "icon", "label", "onClick"])) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "label-append", {}, void 0, true)
      ])
    ], 2),
    createVNode(_component_QField, {
      class: normalizeClass(["q-pa-none", { "q-pt-sm": !_ctx.isEmpty }]),
      "data-automation": _ctx.buildId("q-field"),
      dense: "",
      error: _ctx.error,
      "error-message": _ctx.showErrorMessage ? _ctx.errorMessage : "",
      "hide-bottom-space": "",
      "model-value": _ctx.modelValue,
      "no-error-icon": "",
      standout: ""
    }, {
      default: withCtx(() => [
        createElementVNode("div", {
          class: "full-width",
          "data-automation": _ctx.buildId("default-slot")
        }, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ], 8, _hoisted_4$m)
      ]),
      _: 3
    }, 8, ["class", "data-automation", "error", "error-message", "model-value"])
  ], 16, _hoisted_1$T);
}
const FieldEdit = /* @__PURE__ */ _export_sfc(_sfc_main$13, [["render", _sfc_render$W], ["__scopeId", "data-v-e3f426b0"]]);
const _sfc_main$12 = defineComponent({
  name: "FilePicker",
  components: {
    EllipsisText,
    QFile: QFile_default,
    QIcon: QIcon_default,
    RvButton: Button
  },
  props: {
    /**
     * List of all accepted file extentions
     */
    acceptedFiles: {
      default: void 0,
      type: Array
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: void 0,
      type: String
    },
    /**
     * Value to show in input while file is not selected yet
     */
    defaultValue: {
      default: "",
      type: String
    },
    /**
     * Set component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Prevent displaying hint below the input
     */
    hideHint: {
      default: false,
      type: Boolean
    },
    /**
     * Hint text below the input
     */
    hintText: {
      default: void 0,
      type: String
    },
    /**
     * Label of the input
     */
    label: {
      default: void 0,
      type: String
    },
    /**
     * Maximum allowed file size
     */
    maxFileSize: {
      default: void 0,
      type: Number
    },
    /**
     * v-model
     */
    modelValue: {
      default: void 0,
      type: File
    },
    /**
     * Show optional label next to label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t2 } = useI18n();
    const inputRef = ref$1();
    const filename = ref$1("");
    const validationError = ref$1("");
    const hasValidationError = computed(() => !!validationError.value);
    const hintTextValue = computed(() => {
      var _a;
      return props4.hintText ?? ((_a = props4.acceptedFiles) == null ? void 0 : _a.map((type2) => type2.toUpperCase().replace(".", "")).join(", ")) ?? "";
    });
    function clear() {
      filename.value = "";
      validationError.value = "";
    }
    function getFormattedFileSize() {
      if (!props4.maxFileSize) return;
      const bytes = props4.maxFileSize;
      const k2 = bytes > 0 ? Math.floor(Math.log2(bytes) / 10) : 0;
      const rank = (k2 > 0 ? "KMGT"[k2 - 1] : "") + "B";
      const count = Math.floor(bytes / Math.pow(1024, k2));
      return `${count}${rank}`;
    }
    function onUpdate(value2) {
      emit("update:modelValue", value2);
      filename.value = value2.name;
      validationError.value = "";
    }
    function onRejected(rejectedEntries) {
      if (rejectedEntries.some((e2) => e2.failedPropValidation === "accept")) {
        validationError.value = t2("rvai-base.validation.wrongFormat");
      } else if (rejectedEntries.some((e2) => e2.failedPropValidation === "max-file-size")) {
        validationError.value = t2("rvai-base.validation.fileTooLarge", [getFormattedFileSize()]);
      }
      emit("update:modelValue", null);
      filename.value = rejectedEntries[0].file.name;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      clear,
      filename,
      hasValidationError,
      hintTextValue,
      inputRef,
      onRejected,
      onUpdate,
      t: t2,
      validationError
    };
  }
});
const _hoisted_1$S = ["data-automation"];
const _hoisted_2$F = { class: "row no-wrap items-center full-width" };
const _hoisted_3$y = ["data-automation"];
const _hoisted_4$l = ["data-automation"];
const _hoisted_5$h = { class: "file-picker__filename-container full-width overflow-hidden" };
function _sfc_render$V(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_RvButton = resolveComponent("RvButton");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QFile = resolveComponent("QFile");
  return openBlock(), createElementBlock("div", {
    class: "file-picker__container",
    "data-automation": _ctx.buildId()
  }, [
    renderSlot(_ctx.$slots, "label", {}, () => [
      createElementVNode("div", _hoisted_2$F, [
        createElementVNode("div", {
          class: normalizeClass(["text-black-1 text-subtitle3", { "text-grey-2": _ctx.disable }]),
          "data-automation": _ctx.buildId("label")
        }, toDisplayString(_ctx.label), 11, _hoisted_3$y),
        _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "q-ml-xs",
          "data-automation": _ctx.buildId("optional")
        }, toDisplayString(_ctx.t("rvai-base.general.inputs.optional")), 9, _hoisted_4$l)) : createCommentVNode("", true)
      ])
    ], true),
    createVNode(_component_QFile, {
      ref: "inputRef",
      accept: (_a = _ctx.acceptedFiles) == null ? void 0 : _a.join(","),
      "bg-color": "grey-6",
      borderless: "",
      class: normalizeClass(["file-picker__input ellipsis", { "file-picker__input--disabled": _ctx.disable }]),
      "data-automation": _ctx.buildId("input"),
      disable: _ctx.disable,
      "display-value": "",
      error: !!_ctx.validationError,
      "error-message": _ctx.validationError,
      hint: _ctx.hideHint ? "" : _ctx.hintTextValue,
      "max-file-size": _ctx.maxFileSize,
      "model-value": _ctx.modelValue,
      "no-error-icon": "",
      onRejected: _ctx.onRejected,
      "onUpdate:modelValue": _ctx.onUpdate
    }, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_5$h, [
          createVNode(_component_EllipsisText, {
            class: "text-body3",
            "data-automation": _ctx.buildId("filename"),
            text: _ctx.filename || _ctx.defaultValue
          }, null, 8, ["data-automation", "text"])
        ])
      ]),
      after: withCtx(() => [
        createVNode(_component_RvButton, {
          "data-automation": _ctx.buildId("browse-files"),
          disable: _ctx.disable,
          label: _ctx.$t("rvai-base.general.actions.browse"),
          secondary: "",
          size: "md",
          type: "a",
          onClick: _cache[0] || (_cache[0] = withModifiers(($event) => {
            var _a2;
            return (_a2 = _ctx.inputRef) == null ? void 0 : _a2.pickFiles();
          }, ["prevent"]))
        }, null, 8, ["data-automation", "disable", "label"]),
        _ctx.validationError ? (openBlock(), createBlock(_component_QIcon, {
          key: 0,
          class: "q-ml-xs",
          color: "negative",
          "data-automation": _ctx.buildId("alert"),
          name: "rvai-base:cancel",
          size: "20px"
        }, null, 8, ["data-automation"])) : !!_ctx.filename ? (openBlock(), createBlock(_component_QIcon, {
          key: 1,
          class: "q-ml-xs",
          color: "positive",
          "data-automation": _ctx.buildId("success"),
          name: "rvai-base:success",
          size: "20px"
        }, null, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["accept", "class", "data-automation", "disable", "error", "error-message", "hint", "max-file-size", "model-value", "onRejected", "onUpdate:modelValue"])
  ], 8, _hoisted_1$S);
}
const FilePicker = /* @__PURE__ */ _export_sfc(_sfc_main$12, [["render", _sfc_render$V], ["__scopeId", "data-v-0627916d"]]);
const _sfc_main$11 = defineComponent({
  name: "NoData",
  components: {
    QIcon: QIcon_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the Histogram
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    iconName: {
      type: String,
      default: ""
    },
    iconSize: {
      type: String,
      default: ""
    },
    iconShape: {
      type: String,
      default: ShapesNoData.Horizontal,
      validator: (v) => Object.values(ShapesNoData).includes(v)
    },
    subtitle: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$R = ["data-automation"];
const _hoisted_2$E = { class: "wrapper column flex-center full-width" };
const _hoisted_3$x = ["data-automation"];
const _hoisted_4$k = ["data-automation"];
const _hoisted_5$g = ["data-automation"];
function _sfc_render$U(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  return openBlock(), createElementBlock("div", mergeProps({
    class: ["rv-no-data text-center flex flex-center", _ctx.$props.class],
    "data-automation": _ctx.buildId()
  }, _ctx.$attrs), [
    createElementVNode("div", _hoisted_2$E, [
      _ctx.iconName ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["icon-wrapper flex-center", { [_ctx.iconShape]: !_ctx.iconSize }]),
        "data-automation": _ctx.buildId("icon-wrapper")
      }, [
        createVNode(_component_QIcon, {
          class: normalizeClass(["icon", { "icon--full-size": !_ctx.iconSize }]),
          name: _ctx.iconName,
          size: _ctx.iconSize
        }, null, 8, ["class", "name", "size"])
      ], 10, _hoisted_3$x)) : createCommentVNode("", true),
      _ctx.title ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: "text-h1 q-mt-lg",
        "data-automation": _ctx.buildId("title")
      }, toDisplayString(_ctx.title), 9, _hoisted_4$k)) : createCommentVNode("", true),
      _ctx.subtitle ? (openBlock(), createElementBlock("div", {
        key: 2,
        class: "q-mt-md text-body3",
        "data-automation": _ctx.buildId("subtitle")
      }, toDisplayString(_ctx.subtitle), 9, _hoisted_5$g)) : createCommentVNode("", true),
      createElementVNode("div", {
        class: normalizeClass(["full-width", {
          "q-mt-md": _ctx.title,
          "q-mt-lg": _ctx.subtitle
        }])
      }, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 2)
    ])
  ], 16, _hoisted_1$R);
}
const NoData = /* @__PURE__ */ _export_sfc(_sfc_main$11, [["render", _sfc_render$U], ["__scopeId", "data-v-378b9301"]]);
const _sfc_main$10 = defineComponent({
  name: "Radio",
  components: {
    QRadio: QRadio_default
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Label to display along the component
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:model-value' event) OR use v-model directive
     */
    modelValue: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: [Boolean, Number, String, Array],
      default: void 0
    },
    /**
     * The actual value of the option with which model value is changed
     */
    val: {
      type: null,
      default: void 0
    }
  },
  emits: ["update:modelValue"],
  setup(props4, { emit }) {
    const value2 = computed({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      get() {
        return props4.modelValue;
      },
      set(value22) {
        emit("update:modelValue", value22);
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      value: value2
    };
  }
});
function _sfc_render$T(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QRadio = resolveComponent("QRadio");
  return openBlock(), createBlock(_component_QRadio, mergeProps(_ctx.dataAttrs, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.value = $event),
    class: ["rv-radio", _ctx.$props.class],
    "data-automation": _ctx.buildId(),
    dense: _ctx.dense,
    disable: _ctx.disable,
    label: _ctx.label,
    val: _ctx.val
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ]),
    _: 3
  }, 16, ["modelValue", "class", "data-automation", "dense", "disable", "label", "val"]);
}
const Radio = /* @__PURE__ */ _export_sfc(_sfc_main$10, [["render", _sfc_render$T], ["__scopeId", "data-v-b5f9518f"]]);
const _sfc_main$$ = defineComponent({
  name: "SortButton",
  components: {
    QIcon: QIcon_default,
    QItem: QItem_default,
    QItemLabel: QItemLabel_default,
    QList: QList_default,
    QMenu: QMenu_default,
    RvButton: Button,
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    modelValue: {
      type: Object,
      default: void 0
    },
    sortFields: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: Array,
      required: true
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t2 } = useI18n();
    function onSort(value2) {
      emit("update:modelValue", value2);
    }
    onMounted(() => {
      const defaultSortField = props4.sortFields.find((f) => f.sortByDefault);
      onSort(defaultSortField || props4.sortFields[0]);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      onSort,
      t: t2
    };
  }
});
function _sfc_render$S(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItem = resolveComponent("QItem");
  const _component_QList = resolveComponent("QList");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_RvButton = resolveComponent("RvButton");
  return openBlock(), createBlock(_component_RvButton, {
    class: "no-padding",
    color: "black-1",
    "data-automation": _ctx.buildId(),
    icon: "rvai-base:sort-asc",
    tertiary: ""
  }, {
    default: withCtx(() => [
      createVNode(_component_Tooltip, {
        "data-automation": _ctx.buildId("tooltip")
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.t("rvai-base.general.actions.sort")), 1)
        ]),
        _: 1
      }, 8, ["data-automation"]),
      createVNode(_component_QMenu, {
        "auto-close": "",
        class: "sort-menu",
        self: "top right",
        style: { "min-width": "220px" }
      }, {
        default: withCtx(() => [
          createVNode(_component_QList, { separator: "" }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.sortFields, (item) => {
                return openBlock(), createBlock(_component_QItem, {
                  key: item.name,
                  clickable: "",
                  "data-automation": _ctx.buildId(`item-${String(item.name)}`),
                  onClick: ($event) => _ctx.onSort(item)
                }, {
                  default: withCtx(() => [
                    createVNode(_component_QItemLabel, { class: "row justify-between items-center full-width" }, {
                      default: withCtx(() => [
                        createElementVNode("span", null, toDisplayString(item.label), 1),
                        _ctx.modelValue && item.label === _ctx.modelValue.label ? (openBlock(), createBlock(_component_QIcon, {
                          key: 0,
                          name: "mdi-check",
                          size: "18px"
                        })) : createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["data-automation", "onClick"]);
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data-automation"]);
}
const SortButton = /* @__PURE__ */ _export_sfc(_sfc_main$$, [["render", _sfc_render$S]]);
const INITIAL_DATA_SIZE = 200;
const _sfc_main$_ = defineComponent({
  name: "FilterableList",
  components: {
    Checkbox,
    EllipsisText,
    NoData,
    QIcon: QIcon_default,
    QInfiniteScroll: QInfiniteScroll_default,
    QIntersection: QIntersection_default,
    QItem: QItem_default,
    QItemLabel: QItemLabel_default,
    QItemSection: QItemSection_default,
    QList: QList_default,
    Radio,
    RvButton: Button,
    RvInput,
    SortButton,
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Makes items in the list clickable
     */
    clickable: {
      type: Boolean,
      default: false
    },
    /**
     * Render custom item in slot #item
     */
    customItem: {
      type: Boolean,
      default: false
    },
    /**
     * Items to be displayed
     * @type {[Record<string, unknown>]}
     */
    data: {
      type: Array,
      required: true
    },
    /**
     * On hover the delete icon will be visible
     */
    deletable: {
      type: Boolean,
      default: false
    },
    /**
     * Hides 'Select all' when 'multiple' property is true
     */
    hideSelectAll: {
      type: Boolean,
      default: false
    },
    /**
     * Hides checkboxes when 'multiple' property is true
     */
    hideSelectors: {
      type: Boolean,
      default: false
    },
    /**
     *  Put item in disabled mode when immutableField is presented
     */
    immutableField: {
      type: String,
      default: void 0
    },
    /**
     *  Show data partially when scrolling
     */
    infiniteScrolling: {
      type: Boolean,
      default: false
    },
    /**
     *  Show data partially when scrolling
     */
    infiniteScrollingSize: {
      type: Number,
      default: INITIAL_DATA_SIZE
    },
    /**
     *  Render the label at the top and search button next to it
     */
    /**
     *  Classes for infinite scroll wrapper
     */
    infiniteScrollWrapperClass: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: [Array, Object],
      default: void 0
    },
    /**
     * Render checkboxes instead of radio buttons
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * Allow to provide slot 'item'
     */
    nestedKey: {
      type: String,
      default: ""
    },
    /**
     * Property of option which holds the 'label'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionLabel: {
      type: String,
      default: "label"
    },
    /**
     * Property of option which holds the 'value'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionValue: {
      type: String,
      default: "value"
    },
    /**
     * Render label as radio button
     */
    notSelectedOptionLabel: {
      type: String,
      default: ""
    },
    /**
     * Disable select all checkbox
     */
    selectAllDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Show tooltip when checkbox disabled
     */
    selectAllDisabledTooltip: {
      type: String,
      default: ""
    },
    /**
     * Provides the ability to sort data
     */
    sortFields: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: Array,
      default: null
    },
    /**
     * Custom options to setup in Intl.Collator to sort data
     */
    sortOptions: {
      type: Object,
      default: void 0
    },
    /**
     * Disable the ability to select items
     */
    toggable: {
      type: Boolean,
      default: false
    },
    /**
     * Wraps each item with QIntersection
     */
    withIntersection: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when delete icon is clicked
     */
    "delete-item",
    /**
     * Emitted when item in the list is clicked
     */
    "on-click-item",
    /**
     * Emitted when data was sorted
     */
    "on-sort",
    /**
     * Emitted when items in the list are selected
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t2 } = useI18n();
    const dataSize = ref$1(props4.infiniteScrollingSize);
    const filter = ref$1("");
    const infiniteScrollRef = ref$1();
    const showFilter = ref$1(false);
    const showSelectorValue = ref$1(false);
    const sortField = ref$1();
    const allSelected = computed(() => {
      if (Array.isArray(filteredData.value)) {
        const isEveryItemNotSelected = filteredData.value.filter((d3) => !props4.immutableField || !d3[props4.immutableField]).every((d3) => !selected.value.includes(d3[props4.optionValue]));
        if (isEveryItemNotSelected) return false;
        const isEveryItemSelected = filteredData.value.filter((d3) => !props4.immutableField || !d3[props4.immutableField]).every((d3) => selected.value.includes(d3[props4.optionValue]));
        if (isEveryItemSelected) return true;
        return void 0;
      }
      return false;
    });
    const sortedData = computed(() => {
      if (!sortField.value) return props4.data;
      return sortField.value.type === SortType.Date ? sortByDate(props4.data, sortField.value.name, sortField.value.order === SortOrders.Asc) : sortByKey(props4.data, sortField.value.name, sortField.value.order === SortOrders.Asc, naturalSortWrapper);
    });
    const filteredData = computed(() => {
      const needle = filter.value.toLowerCase();
      return sortedData.value.filter((i2) => String(i2[props4.optionLabel]).toLowerCase().includes(needle));
    });
    const dataToShow = computed(() => {
      return props4.infiniteScrolling ? filteredData.value.slice(0, dataSize.value) : filteredData.value;
    });
    const selected = computed(() => {
      if (!props4.modelValue) return void 0;
      return Array.isArray(props4.modelValue) ? props4.modelValue.map((x2) => x2[props4.optionValue]) : props4.modelValue[props4.optionValue];
    });
    const showSelector = computed(() => !props4.hideSelectors && (!props4.toggable || showSelectorValue.value));
    function naturalSortWrapper(a3, b2) {
      return props4.sortOptions ? new Intl.Collator(void 0, props4.sortOptions).compare(a3, b2) : naturalSort(a3, b2);
    }
    function onDeleteItem(itemValue) {
      emit("delete-item", itemValue);
    }
    function onLoad(v, done) {
      if (!props4.infiniteScrolling) return;
      if (dataSize.value !== filteredData.value.length) {
        const nextPageSize = v * props4.infiniteScrollingSize;
        dataSize.value = nextPageSize > filteredData.value.length ? filteredData.value.length : nextPageSize;
      }
      done();
    }
    function onSelectNone() {
      emit("update:modelValue", null);
    }
    function onSort(v) {
      sortField.value = v;
      resetInfinityScroll();
      emit("on-sort", v);
    }
    function onToggle(value2) {
      const payload = Array.isArray(value2) ? value2.map((v) => props4.data.find((x2) => x2[props4.optionValue] === v)) : props4.data.find((x2) => x2[props4.optionValue] === value2);
      emit("update:modelValue", payload);
    }
    function onToggleAll() {
      const filteredDataValues = filteredData.value.filter((d3) => !props4.immutableField || !d3[props4.immutableField]).map((v) => v[props4.optionValue]);
      const uniqueValues = distinct([...selected.value, ...filteredDataValues]);
      const hiddenSelectedValues = selected.value.filter((v) => !filteredData.value.some((x2) => x2[props4.optionValue] === v));
      const updateValue2 = allSelected.value ? hiddenSelectedValues : uniqueValues;
      emit(
        "update:modelValue",
        updateValue2.map((v) => props4.data.find((d3) => v === d3[props4.optionValue]))
      );
    }
    function onToggleFilter() {
      showFilter.value = !showFilter.value;
      if (!showFilter.value) {
        resetSearch();
      }
    }
    function onToggleShowSelector() {
      showSelectorValue.value = !showSelectorValue.value;
      if (!showSelectorValue.value) {
        emit("update:modelValue", props4.multiple ? [] : void 0);
      }
    }
    function resetInfinityScroll() {
      var _a;
      dataSize.value = props4.infiniteScrollingSize;
      (_a = infiniteScrollRef.value) == null ? void 0 : _a.reset();
    }
    function resetSearch() {
      filter.value = "";
      resetInfinityScroll();
    }
    function setFilter(v) {
      filter.value = v;
      resetInfinityScroll();
    }
    watch(() => props4.data, () => {
      const selection = props4.modelValue;
      if (!selection) return void 0;
      let payload;
      if (Array.isArray(selection)) {
        payload = props4.data.filter((v) => selection.some((x2) => x2[props4.optionValue] === v[props4.optionValue]));
      } else {
        payload = props4.data.find((v) => selection[props4.optionValue] === v[props4.optionValue]);
      }
      emit("update:modelValue", payload);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      allSelected,
      dataToShow,
      filter,
      filteredData,
      infiniteScrollRef,
      // initialItemsHeight,
      // itemRefs,
      onDeleteItem,
      onLoad,
      onSelectNone,
      onSort,
      onToggle,
      onToggleAll,
      onToggleFilter,
      onToggleShowSelector,
      // onVisibilityChange,
      resetSearch,
      selected,
      setFilter,
      showFilter,
      showSelector,
      sortedData,
      sortField,
      t: t2
    };
  }
});
const _hoisted_1$Q = ["data-automation"];
const _hoisted_2$D = ["data-automation"];
const _hoisted_3$w = { class: "row no-wrap q-pl-sm" };
const _hoisted_4$j = { class: "q-mb-lg" };
const _hoisted_5$f = { class: "text-bold" };
function _sfc_render$R(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_RvButton = resolveComponent("RvButton");
  const _component_SortButton = resolveComponent("SortButton");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_RvInput = resolveComponent("RvInput");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_QItemSection = resolveComponent("QItemSection");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItem = resolveComponent("QItem");
  const _component_Radio = resolveComponent("Radio");
  const _component_QInfiniteScroll = resolveComponent("QInfiniteScroll");
  const _component_NoData = resolveComponent("NoData");
  const _component_QList = resolveComponent("QList");
  return openBlock(), createElementBlock("div", {
    class: "filterable-list",
    "data-automation": _ctx.buildId()
  }, [
    _ctx.label ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "row no-wrap full-width justify-between q-mb-sm",
      "data-automation": _ctx.buildId("label-wrapper")
    }, [
      createVNode(_component_EllipsisText, {
        class: "text-subtitle3 text-center text-black-1",
        "data-automation": _ctx.buildId("label"),
        text: _ctx.label
      }, null, 8, ["data-automation", "text"]),
      createElementVNode("div", _hoisted_3$w, [
        createVNode(_component_RvButton, {
          class: "no-padding",
          color: "black-1",
          "data-automation": _ctx.buildId("search"),
          disable: _ctx.data.length === 0,
          icon: "search",
          tertiary: "",
          tooltip: _ctx.t("rvai-base.general.actions.search"),
          onClick: _ctx.onToggleFilter
        }, null, 8, ["data-automation", "disable", "tooltip", "onClick"]),
        _ctx.sortFields && _ctx.sortFields.length > 0 ? (openBlock(), createBlock(_component_SortButton, {
          key: 0,
          modelValue: _ctx.sortField,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event) => _ctx.sortField = $event),
            _ctx.onSort
          ],
          class: "q-mr-sm",
          "data-automation": _ctx.buildId("sort"),
          disable: _ctx.data.length === 0,
          "sort-fields": _ctx.sortFields
        }, null, 8, ["modelValue", "data-automation", "disable", "sort-fields", "onUpdate:modelValue"])) : createCommentVNode("", true),
        _ctx.toggable ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          !_ctx.showSelector ? (openBlock(), createBlock(_component_RvButton, {
            key: 0,
            color: "black-1",
            "data-automation": _ctx.buildId("multi-select"),
            icon: "rvai-base:multi-select",
            size: "sm",
            tertiary: "",
            tooltip: _ctx.t("rvai-base.general.text.multiselect"),
            onClick: _ctx.onToggleShowSelector
          }, null, 8, ["data-automation", "tooltip", "onClick"])) : (openBlock(), createBlock(_component_RvButton, {
            key: 1,
            color: "primary",
            "data-automation": _ctx.buildId("cancel"),
            size: "sm",
            tertiary: "",
            onClick: _ctx.onToggleShowSelector
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.t("rvai-base.general.actions.cancel")), 1)
            ]),
            _: 1
          }, 8, ["data-automation", "onClick"]))
        ], 64)) : createCommentVNode("", true)
      ])
    ], 8, _hoisted_2$D)) : createCommentVNode("", true),
    _ctx.showFilter ? (openBlock(), createBlock(_component_RvInput, {
      key: 1,
      autofocus: "",
      "data-automation": _ctx.buildId("searchInput"),
      icon: "search",
      "label-class": "q-pb-sm",
      "model-value": _ctx.filter,
      placeholder: _ctx.t("rvai-base.general.actions.search"),
      "onUpdate:modelValue": _ctx.setFilter
    }, {
      prepend: withCtx(() => [
        createVNode(_component_QIcon, {
          color: "black-1",
          name: "search"
        })
      ]),
      _: 1
    }, 8, ["data-automation", "model-value", "placeholder", "onUpdate:modelValue"])) : createCommentVNode("", true),
    _ctx.$slots["append-content"] ? renderSlot(_ctx.$slots, "append-content", { key: 2 }, void 0, true) : createCommentVNode("", true),
    createVNode(_component_QList, {
      "data-automation": _ctx.buildId("list")
    }, {
      default: withCtx(() => [
        _ctx.multiple && _ctx.showSelector && _ctx.filteredData.length && !_ctx.hideSelectAll ? (openBlock(), createBlock(_component_QItem, {
          key: 0,
          class: "q-pa-none",
          "data-automation": _ctx.buildId("item-multiple"),
          tag: "label"
        }, {
          default: withCtx(() => [
            _ctx.selectAllDisabledTooltip && _ctx.selectAllDisabled ? (openBlock(), createBlock(_component_Tooltip, {
              key: 0,
              anchor: "center left",
              "data-automation": _ctx.buildId("checkbox-tooltip")
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.selectAllDisabledTooltip), 1)
              ]),
              _: 1
            }, 8, ["data-automation"])) : createCommentVNode("", true),
            createVNode(_component_QItemSection, {
              avatar: "",
              class: "filterable-list__checkbox",
              "data-automation": _ctx.buildId("avatar")
            }, {
              default: withCtx(() => [
                createVNode(_component_Checkbox, {
                  "data-automation": _ctx.buildId("checkbox"),
                  dense: "",
                  disable: _ctx.selectAllDisabled,
                  "model-value": _ctx.allSelected,
                  "onUpdate:modelValue": _ctx.onToggleAll
                }, null, 8, ["data-automation", "disable", "model-value", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["data-automation"]),
            createVNode(_component_QItemSection, { class: "border-bottom q-py-sm" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, {
                  class: "text-subtitle3",
                  "data-automation": _ctx.buildId("selectAll")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_EllipsisText, {
                      class: normalizeClass({ "text-grey-2": _ctx.selectAllDisabled }),
                      "data-automation": _ctx.buildId("selectAll__label"),
                      text: _ctx.t("rvai-base.general.actions.selectAll")
                    }, null, 8, ["class", "data-automation", "text"])
                  ]),
                  _: 1
                }, 8, ["data-automation"])
              ]),
              _: 1
            }),
            renderSlot(_ctx.$slots, "select-all", {}, void 0, true)
          ]),
          _: 3
        }, 8, ["data-automation"])) : createCommentVNode("", true),
        _ctx.notSelectedOptionLabel ? (openBlock(), createBlock(_component_QItem, {
          key: 1,
          class: "q-pa-none",
          "data-automation": _ctx.buildId("item-not-selected"),
          tag: "label"
        }, {
          default: withCtx(() => [
            createVNode(_component_QItemSection, {
              avatar: "",
              class: "filterable-list__checkbox"
            }, {
              default: withCtx(() => [
                createVNode(_component_Radio, {
                  dense: "",
                  "model-value": _ctx.selected,
                  val: void 0,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.onSelectNone())
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            createVNode(_component_QItemSection, { class: "border-bottom q-py-sm" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, { class: "text-subtitle3" }, {
                  default: withCtx(() => [
                    createVNode(_component_EllipsisText, {
                      "data-automation": _ctx.buildId("item-not-selected__label"),
                      text: _ctx.notSelectedOptionLabel
                    }, null, 8, ["data-automation", "text"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-automation"])) : createCommentVNode("", true),
        _ctx.$slots["no-data"] && !_ctx.data.length ? renderSlot(_ctx.$slots, "no-data", { key: 2 }, void 0, true) : createCommentVNode("", true),
        createElementVNode("div", {
          id: "infinite-scroll-wrapper",
          class: normalizeClass(_ctx.infiniteScrollWrapperClass)
        }, [
          createVNode(_component_QInfiniteScroll, {
            ref: "infiniteScrollRef",
            class: "full-height",
            "data-automation": _ctx.buildId(`infinite-scroll`),
            offset: 250,
            "scroll-target": "#infinite-scroll-wrapper",
            onLoad: _ctx.onLoad
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "items", {
                isFiltering: !!_ctx.filter,
                items: _ctx.dataToShow
              }, () => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.dataToShow, (item, index) => {
                  return openBlock(), createBlock(resolveDynamicComponent(_ctx.withIntersection ? "QIntersection" : "div"), {
                    key: item[_ctx.optionValue],
                    style: normalizeStyle([item.height ? `height: ${item.height}px` : ""])
                  }, {
                    default: withCtx(() => {
                      var _a;
                      return [
                        renderSlot(_ctx.$slots, "prepend-item", { item }, void 0, true),
                        createVNode(_component_QItem, {
                          class: "filterable-list__item-filtered q-pa-none",
                          clickable: _ctx.clickable,
                          "data-automation": _ctx.buildId(`item-filtered-${index}`),
                          tag: _ctx.showSelector && ((_a = item[_ctx.nestedKey]) == null ? void 0 : _a.length) === 1 ? "label" : void 0,
                          onClick: ($event) => _ctx.$emit("on-click-item", item)
                        }, {
                          default: withCtx(() => [
                            _ctx.nestedKey && item[_ctx.nestedKey].length > 1 || _ctx.customItem ? renderSlot(_ctx.$slots, "item", {
                              key: 0,
                              item
                            }, void 0, true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                              _ctx.showSelector ? (openBlock(), createBlock(_component_QItemSection, {
                                key: 0,
                                avatar: "",
                                class: normalizeClass(["filterable-list__item-checkbox", {
                                  "invisible": item && item[_ctx.immutableField]
                                }])
                              }, {
                                default: withCtx(() => [
                                  _ctx.multiple ? (openBlock(), createBlock(_component_Checkbox, {
                                    key: 0,
                                    "data-automation": _ctx.buildId(`item__${item[_ctx.optionValue]}__checkbox`),
                                    dense: "",
                                    disable: !!(item && item[_ctx.immutableField]),
                                    "model-value": _ctx.selected,
                                    val: item[_ctx.optionValue],
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.onToggle($event))
                                  }, null, 8, ["data-automation", "disable", "model-value", "val"])) : (openBlock(), createBlock(_component_Radio, {
                                    key: 1,
                                    "data-automation": _ctx.buildId(`item__${item[_ctx.optionValue]}__radio`),
                                    dense: "",
                                    disable: !!(item && item[_ctx.immutableField]),
                                    "model-value": _ctx.selected,
                                    val: item[_ctx.optionValue],
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.onToggle($event))
                                  }, null, 8, ["data-automation", "disable", "model-value", "val"]))
                                ]),
                                _: 2
                              }, 1032, ["class"])) : createCommentVNode("", true),
                              createVNode(_component_QItemSection, { class: "border-bottom q-py-sm" }, {
                                default: withCtx(() => [
                                  renderSlot(_ctx.$slots, "label", { item }, () => [
                                    createVNode(_component_QItemLabel, { class: "filterable-list__item-label flex no-wrap justify-between" }, {
                                      default: withCtx(() => [
                                        createVNode(_component_EllipsisText, {
                                          class: "filterable-list__item-text",
                                          "data-automation": _ctx.buildId(`item__${item[_ctx.optionValue]}__label`),
                                          text: item[_ctx.optionLabel]
                                        }, null, 8, ["data-automation", "text"]),
                                        _ctx.deletable ? (openBlock(), createBlock(_component_QIcon, {
                                          key: 0,
                                          class: "filterable-list__icon-delete-item cursor-pointer",
                                          color: "grey-1",
                                          "data-automation": _ctx.buildId("delete"),
                                          name: "delete",
                                          size: "1.5rem",
                                          onClick: ($event) => _ctx.onDeleteItem(item[_ctx.optionValue])
                                        }, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ], true)
                                ]),
                                _: 2
                              }, 1024)
                            ], 64))
                          ]),
                          _: 2
                        }, 1032, ["clickable", "data-automation", "tag", "onClick"]),
                        renderSlot(_ctx.$slots, "append-item", { item }, void 0, true)
                      ];
                    }),
                    _: 2
                  }, 1032, ["style"]);
                }), 128))
              ], true)
            ]),
            _: 3
          }, 8, ["data-automation", "onLoad"])
        ], 2),
        !_ctx.filteredData.length && _ctx.sortedData.length !== 0 ? (openBlock(), createBlock(_component_QItemLabel, {
          key: 3,
          class: "q-py-sm q-mt-lg",
          "data-automation": _ctx.buildId("label-no-data")
        }, {
          default: withCtx(() => [
            createVNode(_component_NoData, {
              "data-automation": _ctx.buildId("noData"),
              "icon-name": "img:/rvai-base/robot-loupe.svg",
              "icon-size": "170px"
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_4$j, [
                  createElementVNode("span", _hoisted_5$f, toDisplayString(_ctx.t("rvai-base.general.table.sorry")) + toDisplayString(_ctx.t("rvai-base.general.symbols.comma")), 1),
                  _cache[4] || (_cache[4] = createElementVNode("br", null, null, -1)),
                  createElementVNode("span", null, toDisplayString(_ctx.t("rvai-base.general.table.noSearchResult")), 1)
                ]),
                createVNode(_component_RvButton, {
                  color: "primary",
                  "data-automation": _ctx.buildId("search"),
                  label: _ctx.t("rvai-base.general.table.searchAgain"),
                  size: "sm",
                  onClick: _ctx.resetSearch
                }, null, 8, ["data-automation", "label", "onClick"])
              ]),
              _: 1
            }, 8, ["data-automation"])
          ]),
          _: 1
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["data-automation"])
  ], 8, _hoisted_1$Q);
}
const FilterableList = /* @__PURE__ */ _export_sfc(_sfc_main$_, [["render", _sfc_render$R], ["__scopeId", "data-v-673b6d31"]]);
function useNavigation() {
  const route = useRoute();
  function matchesRouteNames(item) {
    var _a, _b;
    const currentRouteName = "name" in route && typeof route.name === "string" ? route.name : "";
    return ((_a = item.routeNames) == null ? void 0 : _a.includes(currentRouteName)) || ((_b = item.to) == null ? void 0 : _b.name) === currentRouteName;
  }
  function matchesRouteQuery(item) {
    var _a;
    const currentQuery = "query" in route ? route.query : void 0;
    if (!currentQuery || !((_a = item.matchQuery) == null ? void 0 : _a.length)) return true;
    return item.matchQuery.every((q2) => {
      var _a2;
      return !!((_a2 = item.to) == null ? void 0 : _a2.query) && item.to.query[q2] === currentQuery[q2];
    });
  }
  function matchesRoute(item) {
    return matchesRouteNames(item) && matchesRouteQuery(item);
  }
  return {
    matchesRoute,
    matchesRouteNames,
    matchesRouteQuery
  };
}
const _sfc_main$Z = {
  name: "HeaderNavigationItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup() {
    const route = useRoute();
    const {
      matchesRoute
    } = useNavigation();
    return {
      matchesRoute,
      route
    };
  }
};
const _hoisted_1$P = {
  class: "row items-center no-wrap",
  "data-automation": "header-navigation-item"
};
function _sfc_render$Q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = resolveComponent("RouterLink");
  return openBlock(), createElementBlock("div", _hoisted_1$P, [
    createVNode(_component_RouterLink, {
      "active-class": $props.item.routeNames || $props.item.matchQuery ? "" : "navigation-item--active",
      class: normalizeClass(["navigation-item text-black-1 text-body3", { "navigation-item--active": $setup.matchesRoute($props.item) }]),
      "data-automation": "header-navigation-item__link",
      to: $setup.matchesRoute($props.item) ? $setup.route : $props.item.to
    }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString($props.item.label), 1)
      ]),
      _: 1
    }, 8, ["active-class", "class", "to"]),
    (openBlock(), createBlock(resolveDynamicComponent($props.item.component), {
      class: "q-ml-sm",
      "data-automation": "header-navigation-item__component"
    }))
  ]);
}
const HeaderNavigationItem = /* @__PURE__ */ _export_sfc(_sfc_main$Z, [["render", _sfc_render$Q], ["__scopeId", "data-v-c599f3e1"]]);
const _sfc_main$Y = defineComponent({
  name: "HeaderNavigationGroupedItems",
  components: {
    HeaderNavigationItem,
    QIcon: QIcon_default,
    QItem: QItem_default,
    QItemLabel: QItemLabel_default,
    QItemSection: QItemSection_default,
    QList: QList_default,
    QMenu: QMenu_default
  },
  props: {
    navigationItems: {
      type: Array,
      default: () => []
    },
    groupLabel: {
      type: String,
      default: ""
    }
  },
  setup(props4) {
    const {
      matchesRoute
    } = useNavigation();
    const menuOpen = ref$1(false);
    const activeGroupedItem = computed(() => props4.navigationItems.find((item) => matchesRoute(item)));
    const hasSingleItem = computed(() => props4.navigationItems.length && props4.navigationItems.length === 1);
    const hasMultipleItems = computed(() => props4.navigationItems.length && props4.navigationItems.length > 1);
    return {
      activeGroupedItem,
      hasMultipleItems,
      hasSingleItem,
      matchesRoute,
      menuOpen
    };
  }
});
const _hoisted_1$O = {
  class: "navigation-item cursor-pointer row items-center no-wrap text-black-1 text-body3",
  "data-automation": "header-navigation-grouped-items"
};
const _hoisted_2$C = {
  class: "header-navigation-item",
  "data-automation": "header-navigation-grouped-items__label"
};
const _hoisted_3$v = {
  key: 0,
  class: "q-mx-sm",
  "data-automation": "header-navigation-grouped-items__separator"
};
function _sfc_render$P(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HeaderNavigationItem = resolveComponent("HeaderNavigationItem");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItemSection = resolveComponent("QItemSection");
  const _component_QItem = resolveComponent("QItem");
  const _component_RouterLink = resolveComponent("RouterLink");
  const _component_QList = resolveComponent("QList");
  const _component_QMenu = resolveComponent("QMenu");
  return openBlock(), createElementBlock("div", _hoisted_1$O, [
    _ctx.hasMultipleItems ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      createElementVNode("div", _hoisted_2$C, toDisplayString(_ctx.groupLabel || _ctx.$t("rvai-base.general.text.otherCenters")), 1),
      _ctx.activeGroupedItem ? (openBlock(), createElementBlock("div", _hoisted_3$v, toDisplayString(_ctx.$t("rvai-base.general.symbols.separator")), 1)) : createCommentVNode("", true)
    ], 64)) : createCommentVNode("", true),
    _ctx.hasMultipleItems && _ctx.activeGroupedItem ? (openBlock(), createBlock(_component_HeaderNavigationItem, {
      key: 1,
      "data-automation": "header-navigation-grouped-items__active-item",
      item: _ctx.activeGroupedItem
    }, null, 8, ["item"])) : _ctx.hasSingleItem ? (openBlock(), createBlock(_component_HeaderNavigationItem, {
      key: 2,
      "data-automation": "header-navigation-grouped-items__active-item",
      item: _ctx.navigationItems[0]
    }, null, 8, ["item"])) : createCommentVNode("", true),
    _ctx.hasMultipleItems ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
      createVNode(_component_QIcon, {
        "data-automation": "header-navigation-grouped-items__icon",
        name: "arrow_drop_down",
        size: "16px"
      }),
      createVNode(_component_QMenu, {
        modelValue: _ctx.menuOpen,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.menuOpen = $event),
        anchor: "bottom right",
        "auto-close": "",
        "content-style": { width: "220px" },
        "data-automation": "header-navigation-grouped-items__menu",
        self: "top right"
      }, {
        default: withCtx(() => [
          createVNode(_component_QList, { separator: "" }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.navigationItems, (item) => {
                return openBlock(), createBlock(_component_RouterLink, {
                  key: item.label,
                  custom: "",
                  to: item.to
                }, {
                  default: withCtx(({ navigate }) => [
                    createVNode(_component_QItem, {
                      clickable: "",
                      "data-automation": "header-navigation-grouped-items__menu-item",
                      onClick: navigate
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_QItemSection, { class: "row items-center no-wrap justify-between" }, {
                          default: withCtx(() => [
                            createVNode(_component_QItemLabel, { "data-automation": "header-navigation-grouped-items__menu-item-label" }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _ctx.matchesRoute(item) ? (openBlock(), createBlock(_component_QIcon, {
                              key: 0,
                              class: "q-ml-sm",
                              color: "grey-1",
                              "data-automation": "header-navigation-grouped-items__menu-selected-icon",
                              name: "mdi-check",
                              size: "16px"
                            })) : createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["to"]);
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 64)) : createCommentVNode("", true)
  ]);
}
const HeaderNavigationGroupedItems = /* @__PURE__ */ _export_sfc(_sfc_main$Y, [["render", _sfc_render$P], ["__scopeId", "data-v-cce312d8"]]);
const _sfc_main$X = defineComponent({
  name: "HeaderNavigationItems",
  components: {
    HeaderNavigationGroupedItems,
    HeaderNavigationItem,
    Separator
  },
  props: {
    navigationItems: {
      type: Array,
      default: () => []
    },
    groupedItems: {
      type: Array,
      default: () => []
    },
    groupedItemsLabel: {
      type: String,
      default: ""
    }
  }
});
const _hoisted_1$N = {
  key: 0,
  class: "header-navigation-items row items-center no-wrap",
  "data-automation": "header-navigation-items"
};
function _sfc_render$O(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HeaderNavigationItem = resolveComponent("HeaderNavigationItem");
  const _component_Separator = resolveComponent("Separator");
  const _component_HeaderNavigationGroupedItems = resolveComponent("HeaderNavigationGroupedItems");
  return _ctx.navigationItems.length || _ctx.groupedItems.length ? (openBlock(), createElementBlock("div", _hoisted_1$N, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.navigationItems, (item, i2) => {
      return openBlock(), createElementBlock(Fragment, {
        key: item.label
      }, [
        createVNode(_component_HeaderNavigationItem, {
          "data-automation": "header-navigation-items__item",
          item
        }, null, 8, ["item"]),
        i2 < _ctx.navigationItems.length - 1 ? (openBlock(), createBlock(_component_Separator, {
          key: 0,
          class: "q-mx-md",
          vertical: ""
        })) : createCommentVNode("", true)
      ], 64);
    }), 128)),
    _ctx.groupedItems.length ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      _ctx.navigationItems.length ? (openBlock(), createBlock(_component_Separator, {
        key: 0,
        class: "q-mx-md",
        vertical: ""
      })) : createCommentVNode("", true),
      createVNode(_component_HeaderNavigationGroupedItems, {
        "data-automation": "header-navigation-items__grouped-items",
        "group-label": _ctx.groupedItemsLabel,
        "navigation-items": _ctx.groupedItems
      }, null, 8, ["group-label", "navigation-items"])
    ], 64)) : createCommentVNode("", true)
  ])) : createCommentVNode("", true);
}
const HeaderNavigationItems = /* @__PURE__ */ _export_sfc(_sfc_main$X, [["render", _sfc_render$O]]);
const _sfc_main$W = defineComponent({
  name: "HealthIcon",
  components: {
    QIcon: QIcon_default,
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Shows different text for autoscaling deployments
     */
    autoScalingEnabled: {
      type: Boolean,
      default: false
    },
    /**
     * Pipeline health status
     */
    healthStatus: {
      type: String,
      default: void 0
    },
    /**
     * Replica status
     */
    replicaStatus: {
      type: String,
      default: void 0
    },
    /**
     * Apply running styles
     */
    running: {
      type: Boolean,
      default: false
    },
    /**
     * Icon size
     */
    size: {
      type: String,
      default: "1.5em"
    },
    /**
     * Shows tooltip
     */
    showTooltip: {
      type: Boolean,
      default: true
    },
    /**
     * Apply stopped styles
     */
    stopped: {
      type: Boolean,
      default: false
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    const status = computed(() => props4.healthStatus || props4.replicaStatus);
    const color = computed(() => {
      switch (status.value) {
        case PipelineHealthStatus.Critical:
        case PipelineHealthStatus.Failing:
        case ReplicaStatus.Error:
          return "negative";
        case PipelineHealthStatus.Healthy:
        case ReplicaStatus.Starting:
        case ReplicaStatus.Running:
          return "positive";
        case PipelineHealthStatus.Overpowered:
        case PipelineHealthStatus.Unbalanced:
        case PipelineHealthStatus.Underpowered:
          return "warning";
        case ReplicaStatus.Queued:
          return "grey-1";
        case PipelineHealthStatus.Unknown:
          return "black-1";
        default:
          return props4.stopped ? "grey-2" : props4.replicaStatus && props4.running ? "positive" : "grey-1";
      }
    });
    const icon = computed(() => {
      switch (status.value) {
        case PipelineHealthStatus.Critical:
          return "rvai-base:storage-unresponsive";
        case PipelineHealthStatus.Failing:
        case ReplicaStatus.Error:
          return "rvai-base:storage-failed";
        case ReplicaStatus.Queued:
          return "rvai-base:storage-queued";
        case PipelineHealthStatus.Healthy:
        case ReplicaStatus.Starting:
        case ReplicaStatus.Running:
          return "rvai-base:storage-healthy";
        case PipelineHealthStatus.Overpowered:
          return "rvai-base:storage-overpowered";
        case PipelineHealthStatus.Unbalanced:
          return "rvai-base:storage-unbalanced";
        case PipelineHealthStatus.Underpowered:
          return "rvai-base:storage-underpowered";
        case PipelineHealthStatus.Unknown:
          return "rvai-base:storage-unknown";
        default:
          return props4.running ? props4.replicaStatus ? "rvai-base:storage-healthy" : "rvai-base:storage-start" : "rvai-base:storage-stopped";
      }
    });
    const tooltip = computed(() => {
      switch (status.value) {
        case PipelineHealthStatus.Critical:
          return props4.autoScalingEnabled ? t2("rvai-base.components.health.autoscalingStatus.critical") : t2("rvai-base.components.health.status.critical");
        case PipelineHealthStatus.Failing:
          return t2("rvai-base.components.health.status.failing");
        case PipelineHealthStatus.Healthy:
          return t2("rvai-base.components.health.status.healthy");
        case PipelineHealthStatus.Overpowered:
          return t2("rvai-base.components.health.status.overpowered");
        case PipelineHealthStatus.Underpowered:
          return t2("rvai-base.components.health.status.underpowered");
        case PipelineHealthStatus.Unknown:
          return t2("rvai-base.components.health.status.unknown");
        case ReplicaStatus.Queued:
          return t2("rvai-base.components.health.replicaStatus.queued");
        case ReplicaStatus.Starting:
          return t2("rvai-base.components.health.replicaStatus.starting");
        case ReplicaStatus.Running:
          return t2("rvai-base.components.health.replicaStatus.running");
        case ReplicaStatus.Error:
          return t2("rvai-base.components.health.replicaStatus.error");
        default:
          return props4.stopped ? t2("rvai-base.components.health.status.stopped") : props4.replicaStatus || t2("rvai-base.components.health.status.unknown");
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      color,
      icon,
      tooltip
    };
  }
});
const _hoisted_1$M = ["data-automation"];
function _sfc_render$N(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createElementBlock("div", {
    class: "health-icon",
    "data-automation": _ctx.buildId()
  }, [
    createVNode(_component_QIcon, {
      color: _ctx.color,
      name: _ctx.icon,
      size: _ctx.size
    }, null, 8, ["color", "name", "size"]),
    _ctx.showTooltip ? (openBlock(), createBlock(_component_Tooltip, {
      key: 0,
      offset: [0, 2]
    }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString(_ctx.tooltip), 1)
      ]),
      _: 1
    })) : createCommentVNode("", true)
  ], 8, _hoisted_1$M);
}
const HealthIcon = /* @__PURE__ */ _export_sfc(_sfc_main$W, [["render", _sfc_render$N], ["__scopeId", "data-v-c2f71db7"]]);
const UNKNOWN_CLASS = "unknown";
const _sfc_main$V = defineComponent({
  name: "Histogram",
  components: {
    Avatar,
    BarChart,
    EllipsisText
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Displays all info in a row (classNames, percentages, etc)
     */
    detailed: {
      type: Boolean,
      default: false
    },
    /**
     * Bar height
     */
    barHeight: {
      type: Number,
      default: void 0
    },
    /**
     * Classes applied to the Histogram
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Class distribution data
     */
    classDistribution: {
      type: Object,
      required: true
    },
    /**
     * List of classes
     */
    classes: {
      type: Array,
      required: true
    },
    /**
     * Displays class names and percentages
     */
    full: {
      type: Boolean,
      default: false
    },
    /**
     * Displays spinner
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Component max height
     */
    maxHeight: {
      type: Number,
      default: void 0
    },
    /**
     * Overrides colors for current user avatar
     */
    overrideCurrentUserAvatar: {
      type: Boolean,
      default: false
    },
    /**
     * Emits 'update:selected' with row.id, when true
     */
    selectable: {
      type: Boolean,
      default: false
    },
    /**
     * v-model:selected; allows handling selected class
     */
    selected: {
      type: String,
      default: void 0
    },
    /**
     * Shows class name or class id
     */
    showClassName: {
      type: Boolean,
      default: false
    },
    /**
     * Histogram size ('sm' | 'md')
     */
    size: {
      type: String,
      default: "sm"
    },
    /**
     * Sort data inside Histogram
     */
    sort: {
      type: String,
      default: void 0
    },
    /**
     * Sorting order
     */
    sortAsc: {
      type: Boolean,
      default: true
    },
    /**
     * Shows tooltip with additional information on bar hover
     */
    source: {
      type: Object,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when 'selectable' property is true and bar is clicked
     */
    "update:selected"
  ],
  setup(props4) {
    const { t: t2 } = useI18n();
    const histogramRef = ref$1(null);
    const entries = computed(() => {
      const entries2 = [...props4.classDistribution.entries ?? []].filter((e2) => e2.count !== 0 || !(isNull(e2.id) || e2.id === ""));
      if (!entries2.length) {
        entries2.push({
          count: 0,
          id: null
        });
      }
      return entries2.map(({
        count,
        id: id3
      }) => {
        const clazz = id3 ? props4.classes.find((def) => def.id === id3) : void 0;
        const classColor = id3 ? (clazz == null ? void 0 : clazz.defaultColor) ?? "var(--q-primary)" : "#000";
        const className = isNull(id3) ? t2("rvai-base.components.histogram.notAnnotated") : id3 === "" ? t2("rvai-base.components.histogram.emptyAnnotation") : (clazz == null ? void 0 : clazz.name) ?? t2("rvai-base.components.histogram.unknownClass");
        const pct = totalSamples.value ? Math.min(100 * (count / totalSamples.value), 100) : 0;
        return {
          color: classColor,
          count,
          id: id3,
          name: className,
          pct: `${pct.toLocaleString(void 0, { maximumFractionDigits: 2 })}%`
        };
      });
    });
    const entriesSorted = computed(() => {
      return [...entries.value].sort((a3, b2) => {
        const x2 = props4.sortAsc ? a3 : b2;
        const y3 = props4.sortAsc ? b2 : a3;
        switch (props4.sort) {
          case "count":
            return x2.count - y3.count;
          default:
            if (isNull(x2.id) && !isNull(y3.id)) return -1;
            if (isNull(y3.id) && !isNull(x2.id)) return 1;
            if (x2.id === "" && y3.id !== "") return -1;
            if (y3.id === "" && x2.id !== "") return 1;
            if (x2.id === UNKNOWN_CLASS && y3.id !== UNKNOWN_CLASS) return -1;
            if (y3.id === UNKNOWN_CLASS && x2.id !== UNKNOWN_CLASS) return 1;
            return naturalSort(x2.name, y3.name);
        }
      });
    });
    const totalSamples = computed(() => {
      return props4.classDistribution.total ?? 0;
    });
    function generateCSV(countAnnotations = false) {
      const headerRow = [
        t2("rvai-base.components.histogram.classId"),
        t2("rvai-base.components.histogram.className"),
        countAnnotations ? t2("rvai-base.components.histogram.annotations") : t2("rvai-base.components.histogram.samples"),
        t2("rvai-base.components.histogram.percentage")
      ].map((value2) => value2.replace(/,/g, ".")).join(",");
      const contentRows = entriesSorted.value.map((entry) => {
        const row = [
          entry.id ?? "",
          entry.name ?? "",
          entry.count ?? "",
          entry.pct ?? ""
        ].map((value2) => value2.toString().replace(/,/g, ".")).join(",");
        return row;
      }).join("\n");
      return `${headerRow}
${contentRows}`;
    }
    function isNull(id3) {
      return id3 == null || id3 === "null";
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      entriesSorted,
      generateCSV,
      histogramRef,
      t: t2
    };
  }
});
const _hoisted_1$L = { class: "column no-wrap q-mt-sm" };
const _hoisted_2$B = {
  key: 0,
  class: "row items-center q-mb-sm"
};
const _hoisted_3$u = { class: "row no-wrap" };
function _sfc_render$M(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = resolveComponent("Avatar");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_rv_bullet = resolveComponent("rv-bullet");
  const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
  const _component_BarChart = resolveComponent("BarChart");
  return openBlock(), createBlock(_component_BarChart, {
    ref: "histogramRef",
    "bar-height": _ctx.barHeight,
    class: normalizeClass(_ctx.$props.class),
    "data-automation": _ctx.buildId(),
    detailed: _ctx.detailed,
    entries: _ctx.entriesSorted,
    full: _ctx.full,
    loading: _ctx.loading,
    "max-height": _ctx.maxHeight,
    selectable: _ctx.selectable,
    selected: _ctx.selected,
    "show-name": _ctx.showClassName,
    size: _ctx.size,
    "sort-asc": _ctx.sortAsc,
    "onUpdate:selected": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:selected", $event))
  }, createSlots({ _: 2 }, [
    !_ctx.detailed ? {
      name: "tooltip",
      fn: withCtx(({ entry }) => [
        createElementVNode("div", null, [
          createElementVNode("strong", null, toDisplayString(entry.count), 1),
          createTextVNode(" " + toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [entry.pct])), 1)
        ]),
        createElementVNode("div", _hoisted_1$L, [
          _ctx.source ? (openBlock(), createElementBlock("div", _hoisted_2$B, [
            createVNode(_component_Avatar, {
              "background-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "white" : _ctx.source.color,
              "border-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "grey-1" : "white",
              "data-automation": _ctx.buildId("avatar"),
              initials: _ctx.source.initials,
              label: _ctx.source.name,
              "show-logo": !_ctx.source.initials && !_ctx.source.isUser,
              "text-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "grey-1" : "",
              uuid: _ctx.source.id
            }, null, 8, ["background-color", "border-color", "data-automation", "initials", "label", "show-logo", "text-color", "uuid"]),
            createVNode(_component_EllipsisText, {
              class: "q-ml-sm black-1",
              "data-automation": _ctx.buildId("source"),
              text: _ctx.source.name
            }, null, 8, ["data-automation", "text"])
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_3$u, [
            createVNode(_component_rv_bullet, {
              color: entry.color,
              "data-automation": _ctx.buildId("classColor")
            }, null, 8, ["color", "data-automation"]),
            createVNode(_component_rv_ellipsis_text, {
              class: "q-ml-xs",
              "data-automation": _ctx.buildId("className"),
              text: entry.name
            }, null, 8, ["data-automation", "text"])
          ])
        ])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["bar-height", "class", "data-automation", "detailed", "entries", "full", "loading", "max-height", "selectable", "selected", "show-name", "size", "sort-asc"]);
}
const Histogram = /* @__PURE__ */ _export_sfc(_sfc_main$V, [["render", _sfc_render$M]]);
const _sfc_main$U = defineComponent({
  name: "HistogramWrapper",
  components: {
    Avatar,
    Histogram,
    QCard: QCard_default,
    QCardSection: QCardSection_default,
    QDialog: QDialog_default,
    QSpace: QSpace_default,
    RvButton: Button,
    RvSelect
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Bar height; Not applied to maximized Histogram
     */
    barHeight: {
      type: Number,
      default: void 0
    },
    /**
     * Classes applied to the component; Not applied to maximized Histogram
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * List of classes
     */
    classes: {
      type: Array,
      required: true
    },
    /**
     * Annotations and samples data passed to the component
     */
    dataStats: {
      type: Object,
      required: true
    },
    /**
     * Default displaying mode
     */
    defaultMode: {
      type: String,
      default: "samples"
    },
    /**
     * Default displaying split
     */
    defaultSplit: {
      type: String,
      default: "all"
    },
    /**
     * Hides component title
     */
    hideTitle: {
      type: Boolean,
      default: false
    },
    /**
     * Overrides colors for current user avatar
     */
    overrideCurrentUserAvatar: {
      type: Boolean,
      default: false
    },
    /**
     * Histogram size ('sm' | 'md')
     */
    size: {
      type: String,
      default: "sm"
    },
    /**
     * Shows tooltip with additional information on bar hover
     */
    source: {
      type: Object,
      default: void 0
    },
    /**
     * Shows class name or class id
     */
    showClassName: {
      type: Boolean,
      default: false
    },
    /**
     * Shows component footer
     */
    showFooter: {
      type: Boolean,
      default: false
    },
    /**
     * Adds the ability to switch between annotations and samples
     */
    showMode: {
      type: Boolean,
      default: false
    },
    /**
     * Apply custom class(es) to the wrapper
     * @type {[Array, Object, String]}
     */
    wrapperClass: {
      type: [Array, Object, String],
      default: void 0
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    const mode = ref$1(props4.defaultMode);
    const open2 = ref$1(false);
    const sort = ref$1("name");
    const sortAsc = ref$1(true);
    const split = ref$1(props4.defaultSplit);
    const classDistribution = computed(() => {
      var _a, _b;
      return (_b = (_a = props4.dataStats) == null ? void 0 : _a[mode.value]) == null ? void 0 : _b[split.value];
    });
    const modeOptions = computed(() => {
      return [
        {
          label: t2("rvai-base.components.histogram.modes.annotations"),
          value: "annotations"
        },
        {
          label: t2("rvai-base.components.histogram.modes.samples"),
          value: "samples"
        }
      ];
    });
    const modeLabel = computed(() => {
      var _a;
      return ((_a = modeOptions.value.find((x2) => x2.value === mode.value)) == null ? void 0 : _a.label) ?? "";
    });
    const sortOptions = computed(() => {
      return [
        {
          label: t2("rvai-base.components.histogram.count"),
          value: "count"
        },
        {
          label: t2("rvai-base.components.histogram.name"),
          value: "name"
        }
      ];
    });
    const splitOptions = computed(() => {
      return [
        {
          label: t2("rvai-base.components.histogram.trainingSetup.all"),
          value: "all"
        },
        {
          label: t2("rvai-base.components.histogram.trainingSetup.test"),
          value: "test"
        },
        {
          label: t2("rvai-base.components.histogram.trainingSetup.validate"),
          value: "validation"
        },
        {
          label: t2("rvai-base.components.histogram.trainingSetup.train"),
          value: "train"
        }
      ];
    });
    const splitLabel = computed(() => {
      var _a;
      return ((_a = splitOptions.value.find((x2) => x2.value === split.value)) == null ? void 0 : _a.label) ?? "";
    });
    function resetSortAsc() {
      sortAsc.value = true;
    }
    function toggleOpen() {
      open2.value = !open2.value;
    }
    function toggleSortAsc() {
      sortAsc.value = !sortAsc.value;
    }
    function maximize() {
      open2.value = true;
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      classDistribution,
      maximize,
      mode,
      modeLabel,
      modeOptions,
      open: open2,
      resetSortAsc,
      sort,
      sortAsc,
      sortOptions,
      split,
      splitLabel,
      splitOptions,
      t: t2,
      toggleOpen,
      toggleSortAsc
    };
  }
});
const _hoisted_1$K = ["data-automation"];
const _hoisted_2$A = ["data-automation"];
const _hoisted_3$t = { class: "text-body3" };
const _hoisted_4$i = ["data-automation"];
const _hoisted_5$e = { key: 0 };
const _hoisted_6$a = { class: "text-body3" };
const _hoisted_7$8 = { class: "row no-wrap justify-end full-width q-mb-lg" };
const _hoisted_8$5 = {
  key: 0,
  class: "row q-mr-lg"
};
const _hoisted_9$4 = { class: "text-subtitle3 flex flex-center q-mr-sm" };
const _hoisted_10$2 = { class: "row q-mr-lg" };
const _hoisted_11$2 = { class: "text-subtitle3 flex flex-center q-mr-sm" };
const _hoisted_12$1 = { class: "row" };
const _hoisted_13$1 = { class: "text-subtitle3 flex flex-center q-mr-sm" };
const _hoisted_14$1 = { class: "border-card rounded-borders full-width q-px-lg q-py-md" };
const _hoisted_15$1 = {
  key: 0,
  class: "row no-wrap justify-center items-center q-mb-sm"
};
function _sfc_render$L(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QSpace = resolveComponent("QSpace");
  const _component_RvButton = resolveComponent("RvButton");
  const _component_Histogram = resolveComponent("Histogram");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_RvSelect = resolveComponent("RvSelect");
  const _component_Avatar = resolveComponent("Avatar");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", mergeProps(_ctx.dataAttrs, {
      class: ["histogram-wrapper", _ctx.wrapperClass],
      "data-automation": _ctx.buildId()
    }), [
      !_ctx.hideTitle ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "row no-wrap q-mb-sm",
        "data-automation": _ctx.buildId("title")
      }, [
        createElementVNode("div", _hoisted_3$t, [
          renderSlot(_ctx.$slots, "title", {}, () => [
            createElementVNode("strong", null, toDisplayString(_ctx.t("rvai-base.components.histogram.chartTitle")), 1),
            createTextVNode(" " + toDisplayString(_ctx.t("rvai-base.components.histogram.classDistribution")), 1)
          ], true)
        ]),
        createVNode(_component_QSpace),
        createVNode(_component_RvButton, {
          class: "no-padding",
          color: "black-1",
          "data-automation": _ctx.buildId("full"),
          icon: "mdi-fullscreen",
          tertiary: "",
          onClick: _ctx.toggleOpen
        }, null, 8, ["data-automation", "onClick"])
      ], 8, _hoisted_2$A)) : createCommentVNode("", true),
      createVNode(_component_Histogram, {
        "bar-height": _ctx.barHeight,
        class: normalizeClass(_ctx.$props.class),
        "class-distribution": _ctx.classDistribution,
        classes: _ctx.classes,
        "data-automation": _ctx.buildId("1"),
        "show-class-name": _ctx.showClassName,
        size: _ctx.size,
        sort: _ctx.sort,
        "sort-asc": _ctx.sortAsc,
        source: _ctx.source
      }, null, 8, ["bar-height", "class", "class-distribution", "classes", "data-automation", "show-class-name", "size", "sort", "sort-asc", "source"]),
      _ctx.showFooter ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: "text-body3 text-grey-1--light text-grey-2--dark q-mt-sm",
        "data-automation": _ctx.buildId("footer")
      }, [
        _ctx.showMode ? (openBlock(), createElementBlock("div", _hoisted_5$e, toDisplayString(_ctx.t("rvai-base.components.histogram.mode")) + " " + toDisplayString(_ctx.modeLabel), 1)) : createCommentVNode("", true),
        createElementVNode("div", null, toDisplayString(_ctx.t("rvai-base.components.histogram.split")) + " " + toDisplayString(_ctx.splitLabel), 1)
      ], 8, _hoisted_4$i)) : createCommentVNode("", true)
    ], 16, _hoisted_1$K),
    createVNode(_component_QDialog, {
      modelValue: _ctx.open,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.open = $event),
      "data-automation": _ctx.buildId("dialog"),
      "full-height": "",
      "full-width": ""
    }, {
      default: withCtx(() => [
        createVNode(_component_QCard, { class: "column no-wrap" }, {
          default: withCtx(() => [
            createVNode(_component_QCardSection, { class: "histogram-wrapper__title q-pb-none row items-center bg-white" }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_6$a, [
                  renderSlot(_ctx.$slots, "title", {}, () => [
                    createElementVNode("strong", null, toDisplayString(_ctx.t("rvai-base.components.histogram.chartTitle")), 1),
                    createTextVNode(" " + toDisplayString(_ctx.t("rvai-base.components.histogram.classDistribution")), 1)
                  ], true)
                ]),
                createVNode(_component_QSpace),
                createVNode(_component_RvButton, {
                  class: "no-padding",
                  "data-automation": _ctx.buildId("full-exit"),
                  icon: "mdi-fullscreen-exit",
                  tertiary: "",
                  onClick: _ctx.toggleOpen
                }, null, 8, ["data-automation", "onClick"])
              ]),
              _: 3
            }),
            createVNode(_component_QCardSection, { class: "q-pt-md row" }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_7$8, [
                  _ctx.showMode ? (openBlock(), createElementBlock("div", _hoisted_8$5, [
                    createElementVNode("div", _hoisted_9$4, toDisplayString(_ctx.t("rvai-base.components.histogram.mode")), 1),
                    createVNode(_component_RvSelect, {
                      modelValue: _ctx.mode,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.mode = $event),
                      "data-automation": _ctx.buildId("mode"),
                      dense: "",
                      "emit-value": "",
                      "map-options": "",
                      options: _ctx.modeOptions,
                      "show-checkmark": ""
                    }, null, 8, ["modelValue", "data-automation", "options"])
                  ])) : createCommentVNode("", true),
                  createElementVNode("div", _hoisted_10$2, [
                    createElementVNode("div", _hoisted_11$2, toDisplayString(_ctx.t("rvai-base.components.histogram.split")), 1),
                    createVNode(_component_RvSelect, {
                      modelValue: _ctx.split,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.split = $event),
                      "data-automation": _ctx.buildId("split"),
                      dense: "",
                      "emit-value": "",
                      "map-options": "",
                      options: _ctx.splitOptions,
                      "show-checkmark": ""
                    }, null, 8, ["modelValue", "data-automation", "options"])
                  ]),
                  createElementVNode("div", _hoisted_12$1, [
                    createElementVNode("div", _hoisted_13$1, toDisplayString(_ctx.t("rvai-base.general.table.sortBy")), 1),
                    createVNode(_component_RvSelect, {
                      modelValue: _ctx.sort,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event) => _ctx.sort = $event),
                        _ctx.resetSortAsc
                      ],
                      "data-automation": _ctx.buildId("sort"),
                      dense: "",
                      "emit-value": "",
                      "map-options": "",
                      options: _ctx.sortOptions,
                      "show-checkmark": ""
                    }, {
                      prepend: withCtx(() => [
                        createVNode(_component_RvButton, {
                          color: "grey-1",
                          "data-automation": _ctx.buildId("sort"),
                          icon: _ctx.sortAsc ? "rvai-base:sort-asc" : "rvai-base:sort-desc",
                          size: "md",
                          tertiary: "",
                          onClick: withModifiers(_ctx.toggleSortAsc, ["stop"])
                        }, null, 8, ["data-automation", "icon", "onClick"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "data-automation", "options", "onUpdate:modelValue"])
                  ])
                ]),
                createElementVNode("div", _hoisted_14$1, [
                  _ctx.source ? (openBlock(), createElementBlock("div", _hoisted_15$1, [
                    createVNode(_component_Avatar, {
                      "background-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "white" : _ctx.source.color,
                      "border-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "grey-1" : "white",
                      label: _ctx.source.name,
                      "text-color": _ctx.overrideCurrentUserAvatar && _ctx.source.isCurrent ? "grey-1" : "",
                      uuid: _ctx.source.id
                    }, null, 8, ["background-color", "border-color", "label", "text-color", "uuid"]),
                    createElementVNode("div", {
                      class: normalizeClass(["q-ml-sm text-subtitle3", _ctx.source.color ? `text-${_ctx.source.color}` : ""])
                    }, toDisplayString(_ctx.source.name), 3)
                  ])) : createCommentVNode("", true),
                  createVNode(_component_Histogram, {
                    class: "full-width",
                    "class-distribution": _ctx.classDistribution,
                    classes: _ctx.classes,
                    "data-automation": _ctx.buildId("2"),
                    full: "",
                    "show-class-name": _ctx.showClassName,
                    sort: _ctx.sort,
                    "sort-asc": _ctx.sortAsc,
                    source: _ctx.source
                  }, null, 8, ["class-distribution", "classes", "data-automation", "show-class-name", "sort", "sort-asc", "source"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["modelValue", "data-automation"])
  ], 64);
}
const HistogramWrapper = /* @__PURE__ */ _export_sfc(_sfc_main$U, [["render", _sfc_render$L], ["__scopeId", "data-v-825c1bf0"]]);
const _hoisted_1$J = { key: 0 };
const _hoisted_2$z = ["data-automation"];
const _hoisted_3$s = ["data-automation"];
const _hoisted_4$h = ["data-automation"];
const _sfc_main$T = /* @__PURE__ */ defineComponent({
  __name: "InfoPanel",
  props: {
    class: { default: void 0 },
    color: { default: "blue" },
    compact: { type: Boolean },
    dataAutomation: { default: "info-panel" },
    icon: { default: "rvai-base:info" },
    iconSize: { default: "20px" },
    label: { default: void 0 },
    localStorageKey: { default: void 0 },
    showCloseButton: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const emit = __emit;
    const isClosed = ref$1(LocalStorage_default.getItem(getLocalStorageKey()) ?? false);
    const { buildId } = useAutomation(computed(() => props4.dataAutomation));
    function getLocalStorageKey() {
      if (!props4.localStorageKey) return void 0;
      return `infoPanelClosed.${props4.localStorageKey}`;
    }
    function onClose() {
      isClosed.value = true;
      if (props4.localStorageKey) {
        LocalStorage_default.set(getLocalStorageKey(), true);
      }
      emit("close");
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(QSlideTransition_default), null, {
        default: withCtx(() => [
          !isClosed.value ? (openBlock(), createElementBlock("div", _hoisted_1$J, [
            createElementVNode("div", {
              class: normalizeClass(["rv-info-panel text-small rounded-borders flex no-wrap", [
                _ctx.$props.class,
                `border-${__props.color} text-${__props.color}`,
                {
                  "q-px-md q-py-sm items-center": !__props.compact,
                  "q-pa-sm": __props.compact
                }
              ]]),
              "data-automation": unref(buildId)()
            }, [
              createVNode(unref(QIcon_default), {
                class: "q-mr-sm",
                color: __props.color,
                "data-automation": unref(buildId)("icon"),
                name: __props.icon,
                size: __props.iconSize
              }, null, 8, ["color", "data-automation", "name", "size"]),
              createElementVNode("div", {
                class: "info-panel__label",
                "data-automation": unref(buildId)("label")
              }, [
                renderSlot(_ctx.$slots, "label", {}, () => [
                  createTextVNode(toDisplayString(__props.label), 1)
                ], true)
              ], 8, _hoisted_3$s),
              __props.showCloseButton ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(["info-panel__close", {
                  "q-pl-md": !__props.compact,
                  "q-pl-sm": __props.compact
                }]),
                "data-automation": unref(buildId)("close")
              }, [
                createVNode(Button, {
                  "aria-label": "Close",
                  class: "no-padding",
                  color: __props.color,
                  icon: "mdi-close",
                  tertiary: "",
                  onClick: onClose
                }, null, 8, ["color"])
              ], 10, _hoisted_4$h)) : createCommentVNode("", true)
            ], 10, _hoisted_2$z)
          ])) : createCommentVNode("", true)
        ]),
        _: 3
      });
    };
  }
});
const InfoPanel = /* @__PURE__ */ _export_sfc(_sfc_main$T, [["__scopeId", "data-v-2a532737"]]);
const _sfc_main$S = defineComponent({
  name: "LabelerSlider",
  components: {
    QSlider: QSlider_default
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Flag to hide label
     */
    label: {
      type: Boolean,
      default: true
    },
    /**
     * Maximum value of the model; Set track's maximum value
     */
    max: {
      type: Number,
      default: 100
    },
    /**
     * Minimum value of the model; Set track's minimum value
     */
    min: {
      type: Number,
      default: 0
    },
    /**
     * Model of the component (must be between min/max); Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: Number,
      required: true
    },
    /**
     * Work in reverse (changes direction)
     */
    reverse: {
      type: Boolean,
      default: false
    },
    /**
     * Snap on valid values, rather than sliding freely; Suggestion: use with 'step' prop
     */
    snap: {
      type: Boolean,
      default: false
    },
    /**
     * Specify step amount between valid values (> 0.0); When step equals to 0 it defines infinite granularity
     */
    step: {
      type: Number,
      default: 1
    },
    /**
     * Change the arrow direction
     */
    thumbDown: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
function _sfc_render$K(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QSlider = resolveComponent("QSlider");
  return openBlock(), createBlock(_component_QSlider, mergeProps(_ctx.dataAttrs, {
    class: ["rv-labeler-slider", [{ "rv-labeler-slider--down": _ctx.thumbDown }, _ctx.$props.class]],
    "data-automation": _ctx.buildId(),
    label: _ctx.label,
    max: _ctx.max,
    min: _ctx.min,
    "model-value": _ctx.modelValue,
    reverse: _ctx.reverse,
    snap: _ctx.snap,
    step: _ctx.step,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
  }), null, 16, ["class", "data-automation", "label", "max", "min", "model-value", "reverse", "snap", "step"]);
}
const LabelerSlider = /* @__PURE__ */ _export_sfc(_sfc_main$S, [["render", _sfc_render$K], ["__scopeId", "data-v-c8027423"]]);
const LAYOUT_LOGO = {
  [Layout.Default]: "rvai-base:layout-default",
  [Layout.RightOnly]: "rvai-base:layout-right",
  [Layout.LeftOnly]: "rvai-base:layout-left",
  [Layout.Full]: "rvai-base:layout-full",
  [Layout.Split]: "rvai-base:layout-split"
};
const _sfc_main$R = defineComponent({
  name: "LayoutButton",
  components: {
    QIcon: QIcon_default,
    QItem: QItem_default,
    QItemLabel: QItemLabel_default,
    QItemSection: QItemSection_default,
    QList: QList_default,
    QMenu: QMenu_default,
    RvButton: Button
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    const {
      availableLayouts,
      hasRightContent,
      layout,
      setLayout
    } = useLayout();
    const logo = computed(() => {
      return LAYOUT_LOGO[layout.value];
    });
    const options = computed(() => {
      return availableLayouts.value.map((l) => ({
        icon: LAYOUT_LOGO[l],
        label: t2(`rvai-base.general.layout.${String(l)}`),
        layout: l
      }));
    });
    const showMenu = computed(() => {
      return availableLayouts.value.length > 2;
    });
    const canChangeLayout = computed(() => {
      return availableLayouts.value.length > 1 && !!hasRightContent.value;
    });
    function onChangeLayout() {
      if (showMenu.value) return;
      const value2 = availableLayouts.value.find((l) => l !== layout.value) ?? availableLayouts.value[0];
      setLayout(value2);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      canChangeLayout,
      layout,
      logo,
      onChangeLayout,
      options,
      setLayout,
      showMenu
    };
  }
});
function _sfc_render$J(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItemSection = resolveComponent("QItemSection");
  const _component_QItem = resolveComponent("QItem");
  const _component_QList = resolveComponent("QList");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_RvButton = resolveComponent("RvButton");
  return openBlock(), createBlock(_component_RvButton, {
    class: "bg-white",
    color: "black-1",
    "data-automation": _ctx.buildId(),
    disable: !_ctx.canChangeLayout,
    icon: _ctx.logo,
    tertiary: "",
    onClick: _ctx.onChangeLayout
  }, {
    default: withCtx(() => [
      _ctx.showMenu ? (openBlock(), createBlock(_component_QMenu, {
        key: 0,
        anchor: "bottom right",
        "auto-close": "",
        self: "top right"
      }, {
        default: withCtx(() => [
          createVNode(_component_QList, { separator: "" }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (item) => {
                return openBlock(), createBlock(_component_QItem, {
                  key: item.layout,
                  class: normalizeClass({ "bg-grey-6": item.layout === _ctx.layout }),
                  clickable: "",
                  "data-automation": _ctx.buildId(`option-${item.layout}`),
                  onClick: ($event) => _ctx.setLayout(item.layout)
                }, {
                  default: withCtx(() => [
                    createVNode(_component_QItemSection, null, {
                      default: withCtx(() => [
                        createVNode(_component_QItemLabel, { class: "text-body-3" }, {
                          default: withCtx(() => [
                            createVNode(_component_QIcon, {
                              class: "q-mr-sm",
                              name: item.icon,
                              size: "24px"
                            }, null, 8, ["name"]),
                            createTextVNode(" " + toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["class", "data-automation", "onClick"]);
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })) : createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data-automation", "disable", "icon", "onClick"]);
}
const LayoutButton = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["render", _sfc_render$J]]);
const __default__$1 = defineComponent({
  name: "LinearProgress",
  components: {
    QLinearProgress: QLinearProgress_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Color name for component from the Quasar Color Palette
     */
    color: {
      type: String,
      default: "primary"
    },
    /**
     * Put component into indeterminate mode
     */
    indeterminate: {
      type: Boolean,
      default: false
    },
    /**
     * Applies a small standard border-radius for a squared shape of the component
     */
    rounded: {
      type: Boolean,
      default: true
    },
    /**
     * Size in CSS units, including unit name or standard size name (xs|sm|md|lg|xl)
     */
    size: {
      type: String,
      default: "8px"
    },
    /**
     * Makes a skew line
     */
    skew: {
      type: Boolean,
      default: false
    },
    /**
     * Color name for component's track from the Quasar Color Palette
     */
    trackColor: {
      type: String,
      default: "primary-lighter"
    },
    /**
     * Progress value (0.0 < x < 1.0)
     */
    value: {
      type: Number,
      default: void 0
    },
    /**
     * Render background track
     */
    withTrack: {
      type: Boolean,
      default: true
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const __injectCSSVars__$1 = () => {
  useCssVars((_ctx) => ({
    "v6479ffb4": _ctx.$props.size
  }));
};
const __setup__$1 = __default__$1.setup;
__default__$1.setup = __setup__$1 ? (props4, ctx) => {
  __injectCSSVars__$1();
  return __setup__$1(props4, ctx);
} : __injectCSSVars__$1;
function _sfc_render$I(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QLinearProgress = resolveComponent("QLinearProgress");
  return openBlock(), createBlock(_component_QLinearProgress, {
    class: normalizeClass(["rv-linear-progress", {
      "rv-linear-progress--indeterminate": _ctx.indeterminate,
      "rv-linear-progress--no-track": !_ctx.withTrack,
      "rv-linear-progress--skew": _ctx.skew
    }]),
    color: _ctx.color,
    "data-automation": _ctx.buildId(),
    indeterminate: _ctx.indeterminate,
    rounded: _ctx.rounded,
    size: _ctx.size,
    style: normalizeStyle({
      "--value": `${_ctx.value * 100}%`
    }),
    "track-color": _ctx.trackColor
  }, null, 8, ["class", "color", "data-automation", "indeterminate", "rounded", "size", "style", "track-color"]);
}
const LinearProgress = /* @__PURE__ */ _export_sfc(__default__$1, [["render", _sfc_render$I], ["__scopeId", "data-v-3225131f"]]);
const _sfc_main$Q = /* @__PURE__ */ defineComponent({
  __name: "LocalUrl",
  props: {
    data: {
      default: void 0,
      type: Object
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: void 0,
      type: String
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(computed(() => props4.dataAutomation));
    const url = ref$1(null);
    onUnmounted(() => {
      if (url.value) URL.revokeObjectURL(url.value);
    });
    watch(
      () => props4.data,
      async (data, prevData) => {
        const blob = data && await Promise.resolve(data);
        const prevBlob = prevData && await Promise.resolve(prevData);
        if (blob === prevBlob) return;
        if (url.value) URL.revokeObjectURL(url.value);
        url.value = blob ? URL.createObjectURL(blob) : null;
      },
      { immediate: true }
    );
    return (_ctx, _cache) => {
      return url.value ? renderSlot(_ctx.$slots, "default", {
        key: 0,
        dataAutomation: unref(buildId)(),
        url: url.value
      }) : renderSlot(_ctx.$slots, "empty", {
        key: 1,
        dataAutomation: unref(buildId)("empty")
      });
    };
  }
});
const _hoisted_1$I = ["data-automation", "view-box"];
const _hoisted_2$y = ["xlink:href"];
const DEFAULT_REGULAR_HEIGHT = "40";
const DEFAULT_REGULAR_WIDTH = "136";
const DEFAULT_MAIN_HEIGHT = "120";
const DEFAULT_MAIN_WIDTH = "153";
const _sfc_main$P = /* @__PURE__ */ defineComponent({
  __name: "Logo",
  props: {
    /**
     * Color name for component from the Quasar Color Palette
     */
    color: {
      // in the dark mode black-1 converts to white by default
      default: "black-1",
      type: String
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: "logo",
      type: String
    },
    /**
     * Logo (regular | main)
     */
    name: {
      default: "regular",
      type: String
    },
    /**
     * Logo size [width, height] -> [100, 50]
     */
    size: {
      default: void 0,
      type: Array
    },
    /**
     * Source of the user provided logo.
     */
    src: {
      default: void 0,
      type: String
    },
    /**
     * Styles applied to component
     * @type {[Array, Object, String]}
     */
    style: {
      default: void 0,
      type: [Array, Object, String]
    }
  },
  setup(__props) {
    const props4 = __props;
    const {
      customLogoSrc,
      logoMain,
      logoRegular
    } = useLogo();
    const { buildId } = useAutomation(computed(() => props4.dataAutomation));
    const customSize = computed(() => {
      if (!props4.size) return void 0;
      const [width, height2] = props4.size;
      return {
        "--height": `${height2}px`,
        "--width": `${width}px`
      };
    });
    const logo = computed(() => {
      switch (props4.name) {
        case "regular":
          return {
            name: toValue(
              customLogoSrc.value ? customLogoSrc.value : logoRegular.value
            ),
            size: customSize.value ?? {
              "--height": `${DEFAULT_REGULAR_HEIGHT}px`,
              "--width": `${DEFAULT_REGULAR_WIDTH}px`
            },
            style: {
              height: `${DEFAULT_REGULAR_HEIGHT}px`,
              width: `${DEFAULT_REGULAR_WIDTH}px`
            },
            viewBox: `0 0 ${props4.size ? props4.size.join(" ") : `${DEFAULT_REGULAR_WIDTH} ${DEFAULT_REGULAR_HEIGHT}`}`
          };
        default:
          return {
            name: toValue(
              customLogoSrc.value ? customLogoSrc.value : logoMain.value
            ),
            size: customSize.value ?? {
              "--height": `${DEFAULT_MAIN_HEIGHT}px`,
              "--width": `${DEFAULT_MAIN_WIDTH}px`
            },
            style: {
              height: `${DEFAULT_MAIN_HEIGHT}px`,
              width: `${DEFAULT_MAIN_WIDTH}px`
            },
            viewBox: `0 0 ${props4.size ? props4.size.join(" ") : `${DEFAULT_MAIN_WIDTH} ${DEFAULT_MAIN_HEIGHT}`}`
          };
      }
    });
    return (_ctx, _cache) => {
      return !!unref(customLogoSrc) ? (openBlock(), createBlock(unref(QImg_default), {
        key: 0,
        "data-automation": unref(buildId)(),
        fit: "contain",
        src: logo.value.name,
        style: normalizeStyle(logo.value.style)
      }, null, 8, ["data-automation", "src", "style"])) : (openBlock(), createElementBlock("svg", {
        key: 1,
        class: normalizeClass(["rv-logo", `text-${__props.color}`]),
        "data-automation": unref(buildId)(),
        style: normalizeStyle(logo.value.size),
        "view-box": logo.value.viewBox
      }, [
        createElementVNode("use", {
          "xlink:href": logo.value.name
        }, null, 8, _hoisted_2$y)
      ], 14, _hoisted_1$I));
    };
  }
});
const _sfc_main$O = defineComponent({
  name: "NavigationTitle",
  components: {
    Logo: _sfc_main$P,
    RouterLink,
    RvButton: Button
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    collapseOverlayWithLeftSidebar: {
      type: Boolean,
      default: false
    },
    homeRoute: {
      type: [Object, String],
      default: void 0
    },
    overlay: {
      type: Boolean,
      default: false
    }
  },
  setup(props4) {
    const { logoAlignClasses } = useLogo();
    const {
      isFullLayout,
      isSidebarAnimationInprogress,
      showLeftSidebar,
      toggleNavigationBar,
      toggleShowOverlay
    } = useLayout();
    const collapse = computed(() => {
      return props4.collapseOverlayWithLeftSidebar && !showLeftSidebar.value;
    });
    function onToggle() {
      if (isSidebarAnimationInprogress.value) return;
      if (props4.overlay) {
        toggleShowOverlay();
      } else {
        toggleNavigationBar();
      }
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      collapse,
      isFullLayout,
      logoAlignClasses,
      onToggle
    };
  }
});
const _hoisted_1$H = ["data-automation"];
const _hoisted_2$x = { class: "navigation-bar__icon" };
const _hoisted_3$r = {
  key: 1,
  class: "navigation-bar__icon"
};
function _sfc_render$H(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvButton = resolveComponent("RvButton");
  const _component_Logo = resolveComponent("Logo");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["navigation-bar__header row items-center", {
      "navigation-bar__header--overlay": _ctx.overlay,
      "navigation-bar__header--overlay-collapse": _ctx.collapse
    }]),
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", {
      class: normalizeClass(["navigation-bar__header-item row no-wrap items-center", { "justify-center": _ctx.collapse }])
    }, [
      createElementVNode("div", _hoisted_2$x, [
        createVNode(_component_RvButton, {
          class: "no-padding",
          color: "black-1",
          "data-automation": _ctx.buildId("menu"),
          icon: "mdi-menu",
          tertiary: "",
          onClick: _ctx.onToggle
        }, null, 8, ["data-automation", "onClick"])
      ]),
      !_ctx.isFullLayout ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        !_ctx.collapse ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.homeRoute ? "RouterLink" : "div"), {
          key: 0,
          class: normalizeClass(["navigation-bar__label", _ctx.logoAlignClasses]),
          "data-automation": _ctx.buildId("link"),
          to: _ctx.homeRoute
        }, {
          default: withCtx(() => [
            createVNode(_component_Logo, {
              class: "navigation-bar__logo",
              "data-automation": _ctx.buildId("logo")
            }, null, 8, ["data-automation"])
          ]),
          _: 1
        }, 8, ["class", "data-automation", "to"])) : createCommentVNode("", true),
        !_ctx.collapse ? (openBlock(), createElementBlock("div", _hoisted_3$r)) : createCommentVNode("", true)
      ], 64)) : createCommentVNode("", true)
    ], 2)
  ], 10, _hoisted_1$H);
}
const NavigationTitle = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["render", _sfc_render$H], ["__scopeId", "data-v-4943c1a7"]]);
const _sfc_main$N = defineComponent({
  name: "NavigationHeader",
  components: {
    Avatar,
    EllipsisText,
    HeaderNavigationItems,
    LayoutButton,
    NavigationTitle,
    QItem: QItem_default,
    QItemLabel: QItemLabel_default,
    QList: QList_default,
    QMenu: QMenu_default,
    QSpace: QSpace_default,
    RvButton: Button
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    back: {
      type: Object,
      default: void 0
    },
    backDirectRoute: {
      type: Object,
      default: void 0
    },
    collapseOverlayWithLeftSidebar: {
      type: Boolean,
      default: false
    },
    iconsWidth: {
      type: String,
      default: "auto"
    },
    ignoreShowRightSidebar: {
      type: Boolean,
      default: false
    },
    navigationItems: {
      type: Array,
      default: () => []
    },
    groupedNavigationItems: {
      type: Array,
      default: () => []
    },
    groupedNavigationLabel: {
      type: String,
      default: ""
    },
    overlay: {
      type: Boolean,
      default: false
    },
    sidebarWidth: {
      type: String,
      default: "300px"
    },
    title: {
      type: String,
      required: true
    }
  },
  setup(props4) {
    const options = useOptionsReadOnly();
    const { t: t2 } = useI18n();
    const {
      isFullLayout,
      showLeftSidebar,
      showRightSidebar
    } = useLayout();
    const { goToPreviousPage } = useNavigationHistory(
      props4.back,
      props4.backDirectRoute
    );
    const menuOpen = ref$1(false);
    const actionsWidth = computed(() => {
      return showRightSidebar.value && !props4.ignoreShowRightSidebar ? props4.sidebarWidth : props4.iconsWidth;
    });
    const areNotificationsAvailable = computed(
      () => options.notification.areNotificationsAvailable ?? true
    );
    const collapse = computed(() => {
      return props4.collapseOverlayWithLeftSidebar && !showLeftSidebar.value || isFullLayout.value;
    });
    const homeRoute = computed(
      () => options.navigation.homeRoute
    );
    const notificationButton = computed(() => options.notification.component);
    const user = computed(() => toValue(options.session.currentUser));
    function onLogout() {
      if (options.session.onLogout) {
        void options.session.onLogout();
      }
    }
    function onViewProfile() {
      if (options.session.onViewProfile) {
        void options.session.onViewProfile();
      }
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      actionsWidth,
      areNotificationsAvailable,
      collapse,
      goToPreviousPage,
      homeRoute,
      menuOpen,
      notificationButton,
      onLogout,
      onViewProfile,
      options,
      t: t2,
      user
    };
  }
});
const _hoisted_1$G = ["data-automation"];
const _hoisted_2$w = ["data-automation"];
const _hoisted_3$q = {
  key: 1,
  class: "col-fixed"
};
const _hoisted_4$g = ["data-automation"];
const _hoisted_5$d = ["data-automation"];
const _hoisted_6$9 = { class: "row no-wrap q-gutter-x-sm" };
const _hoisted_7$7 = ["data-automation"];
const _hoisted_8$4 = { class: "navigation-header__icons row no-wrap justify-end items-center q-gutter-md" };
const _hoisted_9$3 = ["data-automation"];
function _sfc_render$G(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavigationTitle = resolveComponent("NavigationTitle");
  const _component_RvButton = resolveComponent("RvButton");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_HeaderNavigationItems = resolveComponent("HeaderNavigationItems");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItem = resolveComponent("QItem");
  const _component_QList = resolveComponent("QList");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_Avatar = resolveComponent("Avatar");
  const _component_LayoutButton = resolveComponent("LayoutButton");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", {
      class: "navigation-header bg-grey-5 row no-wrap items-center q-px-lg",
      "data-automation": _ctx.buildId()
    }, [
      _ctx.overlay || _ctx.$slots["navigation-title"] ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["navigation-header__left", { "navigation-header__left-collapse": _ctx.collapse }]),
        "data-automation": _ctx.buildId("navigation-title-wrapper")
      }, [
        renderSlot(_ctx.$slots, "navigation-title", {}, () => [
          _ctx.overlay ? (openBlock(), createBlock(_component_NavigationTitle, {
            key: 0,
            "collapse-overlay-with-left-sidebar": _ctx.collapseOverlayWithLeftSidebar,
            "data-automation": _ctx.buildId("title"),
            "home-route": _ctx.homeRoute,
            overlay: _ctx.overlay
          }, null, 8, ["collapse-overlay-with-left-sidebar", "data-automation", "home-route", "overlay"])) : createCommentVNode("", true)
        ], true)
      ], 10, _hoisted_2$w)) : createCommentVNode("", true),
      _ctx.back || _ctx.backDirectRoute ? (openBlock(), createElementBlock("div", _hoisted_3$q, [
        createVNode(_component_RvButton, {
          "data-automation": _ctx.buildId("back"),
          icon: "mdi-chevron-left",
          tertiary: "",
          "text-color": "black-1",
          onClick: withModifiers(_ctx.goToPreviousPage, ["prevent"])
        }, null, 8, ["data-automation", "onClick"])
      ])) : createCommentVNode("", true),
      _ctx.$slots["title"] || _ctx.title ? renderSlot(_ctx.$slots, "title", { key: 2 }, () => [
        createVNode(_component_EllipsisText, {
          class: "text-black-1 text-subtitle1",
          "data-automation": _ctx.buildId("title"),
          text: _ctx.title
        }, null, 8, ["data-automation", "text"])
      ], true) : createCommentVNode("", true),
      _ctx.$slots["append-title"] ? (openBlock(), createElementBlock("div", {
        key: 3,
        "data-automation": _ctx.buildId("append-title")
      }, [
        renderSlot(_ctx.$slots, "append-title", {}, void 0, true)
      ], 8, _hoisted_4$g)) : createCommentVNode("", true),
      createVNode(_component_QSpace),
      _ctx.$slots["actions"] ? (openBlock(), createElementBlock("div", {
        key: 4,
        class: "navigation-header__actions q-ml-md",
        "data-automation": _ctx.buildId("actions")
      }, [
        createElementVNode("div", _hoisted_6$9, [
          renderSlot(_ctx.$slots, "actions", {}, void 0, true)
        ])
      ], 8, _hoisted_5$d)) : createCommentVNode("", true),
      _ctx.navigationItems.length ? (openBlock(), createBlock(_component_HeaderNavigationItems, {
        key: 5,
        "data-automation": _ctx.buildId("headerNavigationItems"),
        "grouped-items": _ctx.groupedNavigationItems,
        "grouped-items-label": _ctx.groupedNavigationLabel,
        "navigation-items": _ctx.navigationItems
      }, null, 8, ["data-automation", "grouped-items", "grouped-items-label", "navigation-items"])) : createCommentVNode("", true),
      createElementVNode("div", {
        class: "navigation-header__right col-fixed q-ml-lg",
        "data-automation": _ctx.buildId("right"),
        style: normalizeStyle({ width: _ctx.navigationItems.length ? "auto" : _ctx.actionsWidth })
      }, [
        createElementVNode("div", _hoisted_8$4, [
          _ctx.areNotificationsAvailable ? renderSlot(_ctx.$slots, "extra", { key: 0 }, () => [
            _ctx.notificationButton ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.notificationButton), { key: 0 })) : createCommentVNode("", true)
          ], true) : createCommentVNode("", true),
          _ctx.user ? (openBlock(), createBlock(_component_Avatar, {
            key: 1,
            "background-color": _ctx.user.isCurrent ? "white" : _ctx.user.userColor,
            "border-color": _ctx.user.isCurrent ? "grey-1" : "white",
            class: "cursor-pointer",
            "data-automation": _ctx.buildId("user"),
            image: _ctx.user.userAvatar,
            initials: _ctx.user.userInitials,
            label: _ctx.user.userName,
            "show-tooltip": !_ctx.menuOpen,
            "text-color": _ctx.user.isCurrent ? "grey-1" : "",
            uuid: _ctx.user.userId
          }, {
            extra: withCtx(() => [
              createVNode(_component_QMenu, {
                modelValue: _ctx.menuOpen,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.menuOpen = $event),
                anchor: "bottom right",
                "auto-close": "",
                "content-style": { width: "220px" },
                self: "top right"
              }, {
                default: withCtx(() => [
                  createVNode(_component_QList, { separator: "" }, {
                    default: withCtx(() => [
                      _ctx.options.session.onViewProfile ? (openBlock(), createBlock(_component_QItem, {
                        key: 0,
                        clickable: "",
                        "data-automation": _ctx.buildId("btn-view-profile"),
                        onClick: _ctx.onViewProfile
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_QItemLabel, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.t("rvai-base.general.actions.viewProfile")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data-automation", "onClick"])) : createCommentVNode("", true),
                      createVNode(_component_QItem, {
                        clickable: "",
                        "data-automation": _ctx.buildId("btn-logout"),
                        onClick: _ctx.onLogout
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_QItemLabel, null, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(_ctx.t("rvai-base.general.actions.logout")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data-automation", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["background-color", "border-color", "data-automation", "image", "initials", "label", "show-tooltip", "text-color", "uuid"])) : createCommentVNode("", true),
          createVNode(_component_LayoutButton, {
            "data-automation": _ctx.buildId("layout")
          }, null, 8, ["data-automation"])
        ])
      ], 12, _hoisted_7$7)
    ], 8, _hoisted_1$G),
    _ctx.$slots["sub-header"] ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "bg-grey-5 q-px-lg q-pb-md text-black-1",
      "data-automation": _ctx.buildId("sub-header")
    }, [
      renderSlot(_ctx.$slots, "sub-header", {}, void 0, true)
    ], 8, _hoisted_9$3)) : createCommentVNode("", true)
  ], 64);
}
const NavigationHeader = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["render", _sfc_render$G], ["__scopeId", "data-v-b39148e0"]]);
const _sfc_main$M = defineComponent({
  name: "SpinnerFixed",
  components: {
    QSpinner: QSpinner_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "spinnerFixed"
    },
    /**
     * Spinner size
     */
    size: {
      type: String,
      default: "48px"
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$F = ["data-automation"];
const _hoisted_2$v = { class: "spinner-block__background" };
const _hoisted_3$p = { class: "absolute-center" };
function _sfc_render$F(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QSpinner = resolveComponent("QSpinner");
  return openBlock(), createElementBlock("div", {
    class: "spinner-block flex justify-center",
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", _hoisted_2$v, [
      createElementVNode("div", _hoisted_3$p, [
        createVNode(_component_QSpinner, {
          class: "spinner-block__spinner",
          color: "primary",
          size: _ctx.size
        }, null, 8, ["size"])
      ])
    ])
  ], 8, _hoisted_1$F);
}
const SpinnerFixed = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["render", _sfc_render$F], ["__scopeId", "data-v-7a7a872e"]]);
const _sfc_main$L = defineComponent({
  name: "MainContent",
  components: {
    NavigationHeader,
    QDrawer: QDrawer_default,
    QHeader: QHeader_default,
    QPage: QPage_default,
    QResizeObserver: QResizeObserver_default,
    SpinnerFixed
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    back: {
      type: Object,
      default: void 0
    },
    backDirectRoute: {
      type: Object,
      default: void 0
    },
    collapseOverlayWithLeftSidebar: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: [Array, Object, String],
      default: ""
    },
    ignoreShowRightSidebar: {
      type: Boolean,
      default: false
    },
    headerNavigationItems: {
      type: Array,
      default: () => []
    },
    groupedHeaderNavigationItems: {
      type: Array,
      default: () => []
    },
    groupedHeaderNavigationLabel: {
      type: String,
      default: ""
    },
    overlay: {
      type: Boolean,
      default: false
    },
    pageClass: {
      type: [Array, Object, String],
      default: "q-pb-lg"
    },
    sidebarWidth: {
      type: String,
      default: "300px"
    },
    showSpinner: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  setup(props4) {
    const {
      showLeftSidebar,
      showRightSidebar
    } = useLayout();
    const {
      rightPanelWidth,
      setRightPanelWidth
    } = useRightPanelSize();
    const collapse = computed(() => {
      return props4.collapseOverlayWithLeftSidebar && !showLeftSidebar.value;
    });
    const onResize = ({ width }) => {
      setRightPanelWidth(width);
    };
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      collapse,
      onResize,
      rightPanelWidth,
      showRightSidebar
    };
  }
});
const _hoisted_1$E = ["data-automation"];
const _hoisted_2$u = { class: "q-pr-lg" };
function _sfc_render$E(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavigationHeader = resolveComponent("NavigationHeader");
  const _component_QHeader = resolveComponent("QHeader");
  const _component_SpinnerFixed = resolveComponent("SpinnerFixed");
  const _component_QPage = resolveComponent("QPage");
  const _component_QDrawer = resolveComponent("QDrawer");
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", {
      class: "main-content q-px-lg bg-grey-5",
      "data-automation": _ctx.buildId()
    }, [
      createVNode(_component_QHeader, {
        class: "bg-grey-5",
        "height-hint": "72px"
      }, {
        default: withCtx(() => [
          createVNode(_component_NavigationHeader, {
            back: _ctx.back,
            "back-direct-route": _ctx.backDirectRoute,
            "collapse-overlay-with-left-sidebar": _ctx.collapseOverlayWithLeftSidebar,
            "data-automation": _ctx.buildId("header"),
            "grouped-navigation-items": _ctx.groupedHeaderNavigationItems,
            "grouped-navigation-label": _ctx.groupedHeaderNavigationLabel,
            "ignore-show-right-sidebar": _ctx.ignoreShowRightSidebar,
            "navigation-items": _ctx.headerNavigationItems,
            overlay: _ctx.overlay,
            "sidebar-width": _ctx.sidebarWidth,
            title: _ctx.title
          }, createSlots({ _: 2 }, [
            _ctx.$slots["actions"] ? {
              name: "actions",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "actions", {}, void 0, true)
              ]),
              key: "0"
            } : void 0,
            _ctx.$slots["title"] ? {
              name: "title",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "title", {}, void 0, true)
              ]),
              key: "1"
            } : void 0,
            _ctx.$slots["append-title"] ? {
              name: "append-title",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "append-title", {}, void 0, true)
              ]),
              key: "2"
            } : void 0,
            _ctx.$slots["append-breadcrumbs"] ? {
              name: "append-breadcrumbs",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "append-breadcrumbs", {}, void 0, true)
              ]),
              key: "3"
            } : void 0,
            _ctx.$slots["extra"] ? {
              name: "extra",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "extra", {}, void 0, true)
              ]),
              key: "4"
            } : void 0,
            _ctx.$slots["sub-header"] ? {
              name: "sub-header",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "sub-header", {}, void 0, true)
              ]),
              key: "5"
            } : void 0
          ]), 1032, ["back", "back-direct-route", "collapse-overlay-with-left-sidebar", "data-automation", "grouped-navigation-items", "grouped-navigation-label", "ignore-show-right-sidebar", "navigation-items", "overlay", "sidebar-width", "title"])
        ]),
        _: 3
      }),
      _ctx.showSpinner ? (openBlock(), createBlock(_component_SpinnerFixed, {
        key: 0,
        "data-automation": _ctx.buildId("spinner")
      }, null, 8, ["data-automation"])) : createCommentVNode("", true),
      createVNode(_component_QPage, {
        class: normalizeClass(["main-content__main-block", _ctx.pageClass]),
        "data-automation": _ctx.buildId("page")
      }, {
        default: withCtx(() => [
          _ctx.$slots["left-content"] ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["row no-wrap", { "min-height-inherit": !_ctx.$slots["content-bottom"] }])
          }, [
            createElementVNode("div", {
              class: normalizeClass(["main-content__left-content q-mr-lg", { "main-content__left-content--collapse": _ctx.collapse }])
            }, [
              renderSlot(_ctx.$slots, "left-content", {}, void 0, true)
            ], 2),
            createElementVNode("div", {
              class: normalizeClass(["main-content__content zero-min-width", _ctx.contentClass])
            }, [
              renderSlot(_ctx.$slots, "default", {}, void 0, true)
            ], 2)
          ], 2)) : (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(["main-content__content", _ctx.contentClass])
          }, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 2)),
          renderSlot(_ctx.$slots, "content-bottom", {}, void 0, true)
        ]),
        _: 3
      }, 8, ["class", "data-automation"]),
      _ctx.$slots.sidebar ? (openBlock(), createBlock(_component_QDrawer, {
        key: 1,
        breakpoint: 0,
        class: "bg-grey-5",
        "data-automation": _ctx.buildId("drawer"),
        "model-value": _ctx.showRightSidebar,
        side: "right",
        width: _ctx.rightPanelWidth
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_2$u, [
            renderSlot(_ctx.$slots, "sidebar", {}, void 0, true)
          ])
        ]),
        _: 3
      }, 8, ["data-automation", "model-value", "width"])) : createCommentVNode("", true),
      renderSlot(_ctx.$slots, "footer", {}, void 0, true)
    ], 8, _hoisted_1$E),
    createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"])
  ], 64);
}
const MainContent = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["render", _sfc_render$E], ["__scopeId", "data-v-7dc33dc5"]]);
function isArrayOfObjects(items) {
  return items.length ? items.every((i2) => Object.prototype.toString.call(i2).includes("Object")) : false;
}
const _sfc_main$K = defineComponent({
  name: "MultipleSelect",
  components: {
    Checkbox,
    EllipsisText,
    QChip: QChip_default,
    QIcon: QIcon_default,
    QItem: QItem_default,
    QItemLabel: QItemLabel_default,
    QItemSection: QItemSection_default,
    RvInput,
    RvSelect,
    Separator
  },
  inheritAttrs: false,
  props: {
    allSelectedText: {
      default: "",
      type: String
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Update model with the value of the selected option instead of the whole option
     */
    emitValue: {
      type: Boolean,
      default: false
    },
    /**
     * Adds info icon and shows the text on hover
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * A text label that will “float” up above the input field, once the field gets focus
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Model of the component; Must be Array; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: [Number, Object, String, Boolean],
      required: true
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    /**
     * Property of option which holds the 'label'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionLabel: {
      type: String,
      default: "label"
    },
    /**
     * Property of option which holds the 'value'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionValue: {
      type: String,
      default: "value"
    },
    /**
     * Available options that the user can select from.
     */
    options: {
      type: [Number, Object, String, Boolean],
      default: () => []
    },
    /**
     * Put component in readonly mode
     */
    readonly: {
      type: Boolean,
      default: false
    },
    /**
     * Shows optional label after base label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Validation for the component
     */
    validation: {
      type: Object,
      default: void 0
    },
    /**
     * Shows QChips for selected options
     */
    withChips: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t2 } = useI18n();
    const chips = ref$1([]);
    const chipsWrapper = ref$1(null);
    const filter = ref$1("");
    const selectRef = ref$1(null);
    const wrapperWidth = ref$1(0);
    const allSelected = computed(() => {
      const isEveryItemNotSelected = filteredOptions.value.every((o) => !selectedValues.value.find((v) => v[props4.optionValue] === o[props4.optionValue]));
      if (isEveryItemNotSelected) return false;
      const isEveryItemSelected = filteredOptions.value.every((o) => !!selectedValues.value.find((v) => v[props4.optionValue] === o[props4.optionValue]));
      if (isEveryItemSelected) return true;
      return void 0;
    });
    const componentWidth = computed(() => {
      var _a;
      return ((_a = selectRef.value) == null ? void 0 : _a.$el.offsetWidth) ?? 0;
    });
    const convertedOptions = computed(() => {
      return isArrayOfObjects(props4.options) ? props4.options : props4.options.map((o) => ({
        [props4.optionLabel]: String(o),
        [props4.optionValue]: o
      }));
    });
    const filteredOptions = computed(() => {
      const needle = filter.value.toLowerCase();
      const distinctOptions = props4.withChips ? distinctByKey(
        [
          ...sortByKey(selectedValues.value, props4.optionLabel),
          ...sortByKey(convertedOptions.value, props4.optionLabel)
        ],
        props4.optionLabel
      ) : convertedOptions.value;
      return distinctOptions.filter((o) => String(o[props4.optionLabel]).toLowerCase().includes(needle));
    });
    const labelWidth = computed(() => {
      return componentWidth.value - 32 - 32;
    });
    const selectedValues = computed({
      get() {
        if (isArrayOfObjects(props4.modelValue)) return props4.modelValue;
        return props4.modelValue.map((v) => {
          const option = convertedOptions.value.find((o) => o[props4.optionValue] === v);
          return {
            [props4.optionLabel]: option ? option[props4.optionLabel] : String(v),
            [props4.optionValue]: option ? option[props4.optionValue] : String(v)
          };
        });
      },
      set(value2) {
        const checkList = props4.modelValue.length ? props4.modelValue : props4.options;
        chips.value = [];
        if (isArrayOfObjects(checkList) && !props4.emitValue) {
          emit("update:modelValue", value2);
        } else {
          emit("update:modelValue", value2.map((v) => v[props4.optionValue]));
        }
      }
    });
    const shownChipsCount = computed(() => {
      if (allSelected.value) return 0;
      const CONTAINER_SPACING = 4;
      const CHIP_GAP = 4;
      const DOTS_WIDTH = 13;
      let chipsWidth = DOTS_WIDTH + CONTAINER_SPACING;
      for (let i2 = 0; i2 < chips.value.length; i2++) {
        chipsWidth += chips.value[i2].clientWidth;
        if (i2 > 0) {
          chipsWidth += CHIP_GAP;
        }
        if (wrapperWidth.value && chipsWidth > wrapperWidth.value) return i2 === 0 ? 1 : i2;
      }
      return Number.MAX_SAFE_INTEGER;
    });
    function filterSelected(item) {
      selectedValues.value = selectedValues.value.filter((v) => v !== item);
    }
    function getRefElement(element, index) {
      if (element) {
        chips.value[index] = element;
      }
    }
    function onPopupHide() {
      filter.value = "";
    }
    function onToggleAll() {
      const uniqueValues = distinctByKey(
        [...selectedValues.value, ...filteredOptions.value],
        props4.optionValue
      );
      const hiddenSelectedValues = selectedValues.value.filter((v) => !filteredOptions.value.some((x2) => x2[props4.optionValue] === v[props4.optionValue]));
      selectedValues.value = allSelected.value ? hiddenSelectedValues : uniqueValues;
    }
    function resizeSelect() {
      var _a;
      wrapperWidth.value = (_a = chipsWrapper.value) == null ? void 0 : _a.offsetWidth;
    }
    const resizeObserver = new ResizeObserver(resizeSelect);
    onMounted(() => {
      resizeSelect();
      if (chipsWrapper.value) resizeObserver.observe(chipsWrapper.value);
    });
    onUnmounted(() => {
      resizeObserver.disconnect();
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      allSelected,
      chips,
      chipsWrapper,
      componentWidth,
      filter,
      filteredOptions,
      filterSelected,
      getRefElement,
      labelWidth,
      onPopupHide,
      onToggleAll,
      selectedValues,
      selectRef,
      shownChipsCount,
      t: t2
    };
  }
});
const _hoisted_1$D = { class: "multiple-select__no-items q-ml-md" };
const _hoisted_2$t = ["data-automation"];
const _hoisted_3$o = ["data-automation"];
function _sfc_render$D(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_QItemSection = resolveComponent("QItemSection");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItem = resolveComponent("QItem");
  const _component_Separator = resolveComponent("Separator");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_RvInput = resolveComponent("RvInput");
  const _component_QChip = resolveComponent("QChip");
  const _component_RvSelect = resolveComponent("RvSelect");
  return openBlock(), createBlock(_component_RvSelect, mergeProps(_ctx.dataAttrs, {
    ref: "selectRef",
    modelValue: _ctx.selectedValues,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.selectedValues = $event),
    class: ["multiple-select", _ctx.$props.class],
    "data-automation": _ctx.buildId(),
    disable: _ctx.disable,
    "info-text": _ctx.infoText,
    label: _ctx.label,
    multiple: "",
    "option-label": _ctx.optionLabel,
    "option-value": _ctx.optionValue,
    "optional-label": _ctx.optionalLabel,
    options: _ctx.filteredOptions,
    readonly: _ctx.readonly,
    "show-optional-label": _ctx.showOptionalLabel,
    validation: _ctx.validation,
    onOnPopupHide: _ctx.onPopupHide
  }), createSlots({ _: 2 }, [
    _ctx.withChips ? {
      name: "option",
      fn: withCtx(({ index, itemProps, opt, selected, toggleOption }) => [
        createVNode(_component_QItem, mergeProps({
          "data-automation": _ctx.buildId(`item-chips-${opt[_ctx.optionLabel]}`)
        }, itemProps), {
          default: withCtx(() => [
            createVNode(_component_QItemSection, {
              class: "q-pr-sm",
              side: ""
            }, {
              default: withCtx(() => [
                createVNode(_component_Checkbox, {
                  "data-automation": _ctx.buildId(`item-chips-${opt[_ctx.optionLabel]}__checkbox`),
                  dense: "",
                  "model-value": selected,
                  "onUpdate:modelValue": ($event) => toggleOption(opt)
                }, null, 8, ["data-automation", "model-value", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            createVNode(_component_QItemSection, { class: "q-item__section column q-item__section--main justify-center" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, { class: "q-item__label" }, {
                  default: withCtx(() => [
                    createVNode(_component_EllipsisText, {
                      "data-automation": _ctx.buildId(`item-chips-${opt[_ctx.optionLabel]}__label`),
                      style: normalizeStyle({ "width": `${_ctx.labelWidth}px` }),
                      text: opt[_ctx.optionLabel]
                    }, null, 8, ["data-automation", "style", "text"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040, ["data-automation"]),
        selected && index === _ctx.modelValue.length - 1 ? (openBlock(), createBlock(_component_Separator, { key: 0 })) : createCommentVNode("", true)
      ]),
      key: "0"
    } : {
      name: "option",
      fn: withCtx(({ itemProps, opt, selected, toggleOption }) => [
        createVNode(_component_QItem, mergeProps({
          "data-automation": _ctx.buildId(`item-${opt[_ctx.optionLabel]}`)
        }, itemProps), {
          default: withCtx(() => [
            createVNode(_component_QItemSection, {
              class: "q-pr-sm",
              side: ""
            }, {
              default: withCtx(() => [
                createVNode(_component_Checkbox, {
                  "data-automation": _ctx.buildId(`item-${opt[_ctx.optionLabel]}__checkbox`),
                  dense: "",
                  "model-value": selected,
                  "onUpdate:modelValue": ($event) => toggleOption(opt)
                }, null, 8, ["data-automation", "model-value", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            createVNode(_component_QItemSection, { class: "q-item__section column q-item__section--main justify-center" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, { class: "q-item__label" }, {
                  default: withCtx(() => [
                    createVNode(_component_EllipsisText, {
                      "data-automation": _ctx.buildId(`item-${opt[_ctx.optionLabel]}__label`),
                      style: normalizeStyle({ "width": `${_ctx.labelWidth}px` }),
                      text: opt[_ctx.optionLabel] || opt
                    }, null, 8, ["data-automation", "style", "text"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040, ["data-automation"])
      ]),
      key: "1"
    },
    _ctx.withChips ? {
      name: "no-option",
      fn: withCtx(() => [
        createVNode(_component_RvInput, {
          modelValue: _ctx.filter,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.filter = $event),
          autofocus: "",
          class: "multiple-select__search-input",
          "data-automation": _ctx.buildId("chips"),
          icon: "search",
          placeholder: _ctx.t("rvai-base.components.multipleSelect.search"),
          square: "",
          style: normalizeStyle({ "max-width": `${_ctx.componentWidth}px` })
        }, {
          prepend: withCtx(() => [
            createVNode(_component_QIcon, {
              class: "q-ml-xs q-pr-sm",
              color: "black-1",
              name: "search",
              size: "18px"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "data-automation", "placeholder", "style"]),
        createElementVNode("div", _hoisted_1$D, toDisplayString(_ctx.t("rvai-base.components.multipleSelect.noItems")), 1)
      ]),
      key: "2"
    } : {
      name: "no-option",
      fn: withCtx(() => [
        createVNode(_component_QItem, {
          "data-automation": _ctx.buildId("no-items")
        }, {
          default: withCtx(() => [
            createVNode(_component_QItemSection, { class: "text-grey" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.t("rvai-base.components.multipleSelect.noItems")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-automation"])
      ]),
      key: "3"
    },
    _ctx.withChips ? {
      name: "selected",
      fn: withCtx(() => [
        _ctx.allSelected ? (openBlock(), createBlock(_component_EllipsisText, {
          key: 0,
          class: "text-grey-1",
          "data-automation": _ctx.buildId("selectAll__label"),
          text: _ctx.allSelectedText || _ctx.$t("rvai-base.components.multipleSelect.allItemsSelected")
        }, null, 8, ["data-automation", "text"])) : createCommentVNode("", true),
        createElementVNode("div", {
          ref: "chipsWrapper",
          class: normalizeClass(["row no-wrap full-width overflow-hidden multiple-select__chips-container", { "multiple-select__chips-container--multiple": _ctx.selectedValues.length > 1 }])
        }, [
          !_ctx.allSelected ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.selectedValues, (item, i2) => {
            return openBlock(), createElementBlock("div", {
              key: item[_ctx.optionValue],
              ref_for: true,
              ref: (el) => _ctx.getRefElement(el, i2),
              class: normalizeClass(["multiple-select__chip-container", {
                "multiple-select__chip-container--dots": i2 + 1 === _ctx.shownChipsCount && _ctx.selectedValues.length > 1,
                "hide": i2 + 1 > _ctx.shownChipsCount
              }]),
              "data-automation": _ctx.buildId(`item-selected-${i2}`)
            }, [
              createVNode(_component_QChip, { outline: "" }, {
                default: withCtx(() => [
                  createVNode(_component_EllipsisText, null, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item[_ctx.optionLabel]), 1)
                    ]),
                    _: 2
                  }, 1024),
                  createVNode(_component_QIcon, {
                    class: "q-ml-xs",
                    name: "mdi-close",
                    onClick: withModifiers(($event) => _ctx.filterSelected(item), ["prevent", "stop"])
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ], 10, _hoisted_2$t);
          }), 128)) : createCommentVNode("", true)
        ], 2),
        !_ctx.selectedValues.length ? (openBlock(), createBlock(_component_EllipsisText, {
          key: 1,
          class: "text-grey-1",
          "data-automation": _ctx.buildId("selectOption"),
          text: _ctx.t("rvai-base.components.multipleSelect.selectOption")
        }, null, 8, ["data-automation", "text"])) : createCommentVNode("", true)
      ]),
      key: "4"
    } : void 0,
    _ctx.withChips ? {
      name: "append",
      fn: withCtx(() => [
        _ctx.selectedValues.length ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "multiple-select__chip-container",
          "data-automation": _ctx.buildId("selected")
        }, [
          createVNode(_component_QChip, { outline: "" }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.selectedValues.length) + " ", 1),
              createVNode(_component_QIcon, {
                class: "q-ml-xs",
                name: "mdi-close",
                onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.selectedValues = [], ["prevent", "stop"]))
              })
            ]),
            _: 1
          })
        ], 8, _hoisted_3$o)) : createCommentVNode("", true)
      ]),
      key: "5"
    } : void 0,
    _ctx.withChips ? {
      name: "before-options",
      fn: withCtx(() => [
        createVNode(_component_RvInput, {
          modelValue: _ctx.filter,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.filter = $event),
          autofocus: "",
          class: "multiple-select__search-input",
          "data-automation": _ctx.buildId("input-search"),
          icon: "search",
          placeholder: _ctx.t("rvai-base.components.multipleSelect.search"),
          square: "",
          style: normalizeStyle({ "max-width": `${_ctx.componentWidth}px` })
        }, {
          prepend: withCtx(() => [
            createVNode(_component_QIcon, {
              class: "q-ml-xs q-pr-sm",
              color: "black-1",
              name: "search",
              size: "18px"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "data-automation", "placeholder", "style"]),
        createVNode(_component_QItem, {
          clickable: "",
          "data-automation": _ctx.buildId("selectAll"),
          onClick: _ctx.onToggleAll
        }, {
          default: withCtx(() => [
            createVNode(_component_QItemSection, {
              class: "q-pr-sm",
              side: ""
            }, {
              default: withCtx(() => [
                createVNode(_component_Checkbox, {
                  "data-automation": _ctx.buildId("selectAll__checkbox"),
                  dense: "",
                  "model-value": _ctx.allSelected,
                  style: { "pointer-events": "none" }
                }, null, 8, ["data-automation", "model-value"])
              ]),
              _: 1
            }),
            createVNode(_component_QItemSection, { class: "q-item__section column q-item__section--main justify-center" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, { class: "q-item__label" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.t("rvai-base.components.multipleSelect.selectAll")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-automation", "onClick"]),
        createVNode(_component_Separator, { color: "grey-3" })
      ]),
      key: "6"
    } : void 0
  ]), 1040, ["modelValue", "class", "data-automation", "disable", "info-text", "label", "option-label", "option-value", "optional-label", "options", "readonly", "show-optional-label", "validation", "onOnPopupHide"]);
}
const MultipleSelect = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["render", _sfc_render$D], ["__scopeId", "data-v-891c741f"]]);
const _sfc_main$J = defineComponent({
  name: "NavigationBarLink",
  components: {
    EllipsisText,
    QIcon: QIcon_default,
    QItem: QItem_default,
    RouterLink,
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    alwaysVisible: {
      type: Boolean,
      default: false
    },
    collapsedNavigationbar: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    menu: {
      type: Boolean,
      default: false
    },
    transitionDuration: {
      type: Number,
      default: 0
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$C = ["data-automation", "href", "onClick"];
const _hoisted_2$s = { key: 0 };
function _sfc_render$C(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_QItem = resolveComponent("QItem");
  const _component_RouterLink = resolveComponent("RouterLink");
  return openBlock(), createBlock(_component_RouterLink, {
    custom: "",
    to: _ctx.item.to
  }, {
    default: withCtx(({ href: href2, navigate, isExactActive }) => [
      createVNode(_component_QItem, {
        class: normalizeClass(["navigation-item q-pa-none", { "navigation-item--active": isExactActive }]),
        clickable: "",
        "data-automation": _ctx.buildId()
      }, {
        default: withCtx(() => [
          createElementVNode("a", {
            class: normalizeClass(["navigation q-py-sm q-px-lg row no-wrap items-center full-width", {
              "navigation--menu": _ctx.menu
            }]),
            "data-automation": _ctx.buildId("link"),
            href: href2,
            onClick: withModifiers(navigate, ["stop"])
          }, [
            !_ctx.menu ? (openBlock(), createElementBlock("div", _hoisted_2$s, [
              _ctx.item.icon ? (openBlock(), createBlock(_component_QIcon, {
                key: 0,
                name: _ctx.item.icon,
                size: "1.5rem"
              }, null, 8, ["name"])) : createCommentVNode("", true),
              _ctx.item.tooltip && _ctx.collapsedNavigationbar ? (openBlock(), createBlock(_component_Tooltip, {
                key: 1,
                anchor: "center left",
                arrow: "left",
                "data-automation": _ctx.buildId("tooltip"),
                offset: [-40, 0],
                self: "center left"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.item.tooltip), 1)
                ]),
                _: 1
              }, 8, ["data-automation"])) : createCommentVNode("", true)
            ])) : createCommentVNode("", true),
            createVNode(_component_EllipsisText, {
              class: normalizeClass(["navigation__label q-ml-lg text-subtitle3", { "q-mr-lg navigation__label--hidden": !_ctx.alwaysVisible && _ctx.collapsedNavigationbar }]),
              "data-automation": _ctx.buildId("label"),
              style: normalizeStyle({
                "--transition": `opacity ${_ctx.transitionDuration}ms ease-out`,
                "--transition-delay": `${_ctx.transitionDuration ? Math.max(_ctx.transitionDuration, 300) : 150}ms`
              }),
              text: _ctx.item.label
            }, null, 8, ["class", "data-automation", "style", "text"])
          ], 10, _hoisted_1$C)
        ]),
        _: 2
      }, 1032, ["class", "data-automation"])
    ]),
    _: 1
  }, 8, ["to"]);
}
const NavigationBarLink = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["render", _sfc_render$C], ["__scopeId", "data-v-f4ebd805"]]);
const itemHeight = 40;
function scrollAreaHeight(items) {
  return items * itemHeight;
}
const _sfc_main$I = defineComponent({
  name: "NavigationBarTree",
  components: {
    ExpansionList,
    NavigationBarLink,
    QExpansionItem: QExpansionItem_default,
    QItem: QItem_default,
    QList: QList_default,
    QMenu: QMenu_default,
    QSkeleton: QSkeleton_default,
    ScrollArea,
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    collapsedNavigationbar: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    transitionDuration: {
      type: Number,
      default: 0
    }
  },
  setup(props4) {
    const {
      collapsed,
      toggleCollapsed
    } = useCollapsed(props4.item.label, !props4.item.defaultOpen);
    const { currentRoute } = useRouter();
    const showMenu = ref$1(false);
    const labelClass = computed(() => `ei-${kebabCase(props4.item.label)}`);
    const items = computed(() => toValue(props4.item.items) ?? []);
    const isActivePath = computed(() => items.value.some((v) => {
      var _a;
      return ((_a = v.to) == null ? void 0 : _a.name) === currentRoute.value.name;
    }));
    function toggleExpand() {
      if (props4.collapsedNavigationbar) {
        showMenu.value = true;
      } else {
        showMenu.value = false;
        toggleCollapsed();
      }
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      collapsed,
      isActivePath,
      items,
      labelClass,
      scrollAreaHeight,
      showMenu,
      toggleExpand
    };
  }
});
const _hoisted_1$B = { class: "row items-center q-ml-lg text-subtitle3 text-primary" };
function _sfc_render$B(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QSkeleton = resolveComponent("QSkeleton");
  const _component_QItem = resolveComponent("QItem");
  const _component_NavigationBarLink = resolveComponent("NavigationBarLink");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  const _component_QList = resolveComponent("QList");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_ExpansionList = resolveComponent("ExpansionList");
  const _component_QExpansionItem = resolveComponent("QExpansionItem");
  return openBlock(), createBlock(_component_QExpansionItem, {
    class: normalizeClass([
      "expand-block",
      "text-subtitle3",
      _ctx.labelClass,
      _ctx.showMenu && "active",
      _ctx.collapsedNavigationbar && "expand-block--hidden"
    ]),
    "data-automation": _ctx.buildId(),
    "exact-active-class": "expand-block--active",
    "expand-icon": _ctx.items.length || _ctx.item.loading ? "mdi-chevron-down" : "none",
    icon: _ctx.item.icon,
    label: _ctx.item.label,
    "model-value": !_ctx.collapsed,
    style: normalizeStyle({
      "--transition": `opacity ${_ctx.transitionDuration}ms ease-out`,
      "--transition-delay": `${Math.max(_ctx.transitionDuration, 300)}ms`
    }),
    to: _ctx.item.to,
    "onUpdate:modelValue": _ctx.toggleExpand
  }, {
    default: withCtx(() => [
      _ctx.item.tooltip && _ctx.collapsedNavigationbar && !_ctx.showMenu ? (openBlock(), createBlock(_component_Tooltip, {
        key: 0,
        anchor: "center left",
        arrow: "left",
        "data-automation": _ctx.buildId("tooltip"),
        offset: [-40, 0],
        self: "center left",
        target: `.${_ctx.labelClass} .q-icon`
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.item.tooltip), 1)
        ]),
        _: 1
      }, 8, ["data-automation", "target"])) : createCommentVNode("", true),
      _ctx.item.loading ? (openBlock(), createBlock(_component_QSkeleton, {
        key: 1,
        class: "q-ml-lg q-mr-md",
        "data-automation": _ctx.buildId("skeleton"),
        square: ""
      }, null, 8, ["data-automation"])) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
        createVNode(_component_QMenu, {
          modelValue: _ctx.showMenu,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.showMenu = $event),
          anchor: "center right",
          class: normalizeClass(["no-scroll", _ctx.labelClass]),
          self: "top left",
          style: { "width": "220px" },
          target: `.${_ctx.labelClass} .q-icon`
        }, {
          default: withCtx(() => [
            createVNode(_component_QList, null, {
              default: withCtx(() => [
                createVNode(_component_QItem, { class: "menu-title q-pa-none bg-white" }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_1$B, toDisplayString(_ctx.item.label), 1)
                  ]),
                  _: 1
                }),
                createVNode(_component_ScrollArea, {
                  "no-horizontal": "",
                  style: normalizeStyle({
                    height: `${_ctx.scrollAreaHeight(_ctx.items.length)}px`,
                    maxHeight: "65vh"
                  })
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (linkItem) => {
                      return openBlock(), createBlock(_component_NavigationBarLink, {
                        key: linkItem.label,
                        "always-visible": "",
                        "collapsed-navigationbar": _ctx.collapsedNavigationbar,
                        "data-automation": _ctx.buildId(`item-${linkItem.label}`),
                        item: linkItem,
                        menu: ""
                      }, null, 8, ["collapsed-navigationbar", "data-automation", "item"]);
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "class", "target"]),
        createVNode(_component_ExpansionList, {
          class: "expand-block__list",
          "data-automation": _ctx.buildId("subitems"),
          "expansion-action-class": "expand-block__actions",
          items: _ctx.items,
          limit: _ctx.item.maxItems ?? Number.MAX_SAFE_INTEGER
        }, {
          default: withCtx(({ item: linkItem }) => [
            createVNode(_component_NavigationBarLink, {
              "always-visible": "",
              "collapsed-navigationbar": _ctx.collapsedNavigationbar,
              "data-automation": _ctx.buildId("subitem-link"),
              item: linkItem
            }, null, 8, ["collapsed-navigationbar", "data-automation", "item"])
          ]),
          _: 1
        }, 8, ["data-automation", "items", "limit"])
      ], 64))
    ]),
    _: 1
  }, 8, ["class", "data-automation", "expand-icon", "icon", "label", "model-value", "style", "to", "onUpdate:modelValue"]);
}
const NavigationBarTree = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["render", _sfc_render$B], ["__scopeId", "data-v-c496fc76"]]);
const _sfc_main$H = defineComponent({
  name: "NavigationBar",
  components: {
    Logo: _sfc_main$P,
    NavigationBarLink,
    NavigationBarTree,
    QIcon: QIcon_default,
    QList: QList_default,
    QSpace: QSpace_default,
    RouterLink,
    RvButton: Button,
    ScrollArea,
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    helpUrl: {
      type: String,
      default: void 0
    },
    homeRoute: {
      type: [Object, String],
      default: void 0
    },
    items: {
      type: Array,
      required: true
    },
    overlay: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: false
    },
    showToggle: {
      type: Boolean,
      default: false
    }
  },
  emits: ["close-overlay"],
  setup(props4) {
    const { t: t2 } = useI18n();
    const { logoAlignClasses } = useLogo();
    const {
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      isSidebarAnimationInprogress,
      toggleNavigationBar
    } = useLayout();
    const { currentRoute } = useRouter();
    const { navigation } = useOptionsReadOnly();
    const isCollapsed = computed(() => {
      return !props4.overlay && !!collapsedNavigationbar.value;
    });
    const navigationComponent = computed(() => navigation.component);
    const navigationBarItems = computed(() => {
      const items = toValue(props4.items);
      return items.filter((item) => (item == null ? void 0 : item.available) !== false).map((v) => {
        var _a;
        const item = v;
        if ("items" in item) {
          const items2 = (_a = toValue(item.items)) == null ? void 0 : _a.filter(
            (sub) => sub.available !== false
          );
          return {
            ...item,
            items: (items2 == null ? void 0 : items2.length) ? items2 : void 0
          };
        } else {
          return item;
        }
      }).filter((item) => item.to || "items" in item && item.items);
    });
    function onToggle() {
      if (isSidebarAnimationInprogress.value) return;
      toggleNavigationBar();
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      collapsedNavigationbarAfterAnimation,
      currentRoute,
      isCollapsed,
      logoAlignClasses,
      navigationBarItems,
      navigationComponent,
      onToggle,
      t: t2,
      toggleNavigationBar,
      transitionDuration: navigation.delayOnSidebarToggle
    };
  }
});
const _hoisted_1$A = ["data-automation"];
const _hoisted_2$r = { class: "navigation-bar__header row items-center" };
const _hoisted_3$n = { class: "navigation-bar__header-item row no-wrap items-center" };
const _hoisted_4$f = { class: "navigation-bar__icon" };
const _hoisted_5$c = { class: "navigation-bar__icon" };
const _hoisted_6$8 = ["data-automation"];
const _hoisted_7$6 = ["data-automation"];
const _hoisted_8$3 = ["href"];
const _hoisted_9$2 = { class: "navigation-bar__label text-subtitle3" };
function _sfc_render$A(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvButton = resolveComponent("RvButton");
  const _component_Logo = resolveComponent("Logo");
  const _component_NavigationBarTree = resolveComponent("NavigationBarTree");
  const _component_NavigationBarLink = resolveComponent("NavigationBarLink");
  const _component_QList = resolveComponent("QList");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createElementBlock("div", {
    class: "navigation-bar column no-wrap bg-white full-height",
    "data-automation": _ctx.buildId(),
    style: normalizeStyle({
      "--logo-transition": `opacity ${_ctx.transitionDuration ?? 200}ms ease-out`,
      "--transition-delay": `${_ctx.transitionDuration && _ctx.transitionDuration > 150 ? 0 : 150}ms`
    })
  }, [
    createElementVNode("div", _hoisted_2$r, [
      createElementVNode("div", _hoisted_3$n, [
        createElementVNode("div", _hoisted_4$f, [
          !_ctx.overlay || _ctx.showToggle ? (openBlock(), createBlock(_component_RvButton, {
            key: 0,
            class: "no-padding",
            color: "black-1",
            "data-automation": _ctx.buildId("menu"),
            icon: "mdi-menu",
            tertiary: "",
            onClick: _ctx.onToggle
          }, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)
        ]),
        (openBlock(), createBlock(resolveDynamicComponent(_ctx.homeRoute ? "RouterLink" : "div"), {
          class: normalizeClass(["navigation-bar__logo-wrapper q-py-none q-px-lg", [
            _ctx.logoAlignClasses,
            { "navigation-bar__logo-wrapper--hidden": _ctx.isCollapsed }
          ]]),
          "data-automation": _ctx.buildId("link"),
          to: _ctx.homeRoute
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "logo", {}, () => [
              createVNode(_component_Logo, {
                class: "navigation-bar__logo",
                "data-automation": _ctx.buildId("logo"),
                name: "regular"
              }, null, 8, ["data-automation"])
            ], true)
          ]),
          _: 3
        }, 8, ["class", "data-automation", "to"])),
        createElementVNode("div", _hoisted_5$c, [
          _ctx.showClose && _ctx.overlay ? (openBlock(), createBlock(_component_RvButton, {
            key: 0,
            class: "no-padding",
            color: "black-1",
            "data-automation": _ctx.buildId("close"),
            icon: "mdi-close",
            tertiary: "",
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close-overlay"))
          }, null, 8, ["data-automation"])) : createCommentVNode("", true)
        ])
      ])
    ]),
    _ctx.navigationComponent ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.navigationComponent), {
      key: 0,
      collapsed: _ctx.isCollapsed,
      "collapsed-after-animation": _ctx.collapsedNavigationbarAfterAnimation,
      "help-url": _ctx.helpUrl,
      items: _ctx.items
    }, null, 8, ["collapsed", "collapsed-after-animation", "help-url", "items"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
      createVNode(_component_ScrollArea, {
        class: "navigation-bar__content fit",
        "data-automation": _ctx.buildId("content"),
        "no-horizontal": ""
      }, {
        default: withCtx(() => [
          createVNode(_component_QList, {
            class: normalizeClass({ "navigation-bar__list--active": _ctx.isCollapsed })
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.navigationBarItems, (item) => {
                return openBlock(), createElementBlock(Fragment, {
                  key: item.label
                }, [
                  "items" in item ? (openBlock(), createBlock(_component_NavigationBarTree, {
                    key: 0,
                    "collapsed-navigationbar": _ctx.isCollapsed,
                    "data-automation": _ctx.buildId(`item-tree-${item.label}`),
                    item,
                    "transition-duration": _ctx.transitionDuration
                  }, null, 8, ["collapsed-navigationbar", "data-automation", "item", "transition-duration"])) : (openBlock(), createBlock(_component_NavigationBarLink, {
                    key: 1,
                    "collapsed-navigationbar": _ctx.isCollapsed,
                    "data-automation": _ctx.buildId(`item-link-${item.label}`),
                    item,
                    "transition-duration": _ctx.transitionDuration
                  }, null, 8, ["collapsed-navigationbar", "data-automation", "item", "transition-duration"]))
                ], 64);
              }), 128))
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }, 8, ["data-automation"]),
      _ctx.helpUrl ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "navigation-bar__footer row items-center",
        "data-automation": _ctx.buildId("footer")
      }, [
        createElementVNode("div", {
          "data-automation": _ctx.buildId("help")
        }, [
          createElementVNode("a", {
            class: "navigation-bar__item row no-wrap items-center",
            href: _ctx.helpUrl,
            target: "_blank"
          }, [
            createVNode(_component_QIcon, {
              class: "navigation-bar__icon",
              name: "mdi-help-circle",
              size: "1.5rem"
            }),
            createElementVNode("div", _hoisted_9$2, toDisplayString(_ctx.t("rvai-base.general.help.title")), 1)
          ], 8, _hoisted_8$3),
          createVNode(_component_Tooltip, {
            anchor: "center right",
            arrow: "left",
            "data-automation": _ctx.buildId("help__tooltip"),
            self: "center left"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.t("rvai-base.general.help.hint")), 1)
            ]),
            _: 1
          }, 8, ["data-automation"])
        ], 8, _hoisted_7$6)
      ], 8, _hoisted_6$8)) : createCommentVNode("", true)
    ], 64))
  ], 12, _hoisted_1$A);
}
const NavigationBar = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["render", _sfc_render$A], ["__scopeId", "data-v-710084e1"]]);
const _sfc_main$G = defineComponent({
  name: "NavigationBarOverlay",
  components: {
    NavigationBar
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    items: {
      type: Array,
      required: true
    }
  },
  setup(props4) {
    const {
      showOverlay,
      toggleShowOverlay
    } = useLayout();
    const overlayRef = ref$1(null);
    function closeOverlay() {
      toggleShowOverlay(false);
    }
    onMounted(() => {
      toggleShowOverlay(false);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      closeOverlay,
      overlayRef,
      showOverlay
    };
  }
});
const _hoisted_1$z = ["data-automation"];
function _sfc_render$z(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavigationBar = resolveComponent("NavigationBar");
  return withDirectives((openBlock(), createElementBlock("div", {
    ref: "overlayRef",
    class: "navigation-bar-overlay",
    "data-automation": _ctx.buildId()
  }, [
    createVNode(_component_NavigationBar, mergeProps(_ctx.$attrs, {
      "data-automation": _ctx.buildId("navigationBar"),
      items: _ctx.items,
      overlay: "",
      "show-close": "",
      onCloseOverlay: _ctx.closeOverlay
    }), null, 16, ["data-automation", "items", "onCloseOverlay"])
  ], 8, _hoisted_1$z)), [
    [vShow, _ctx.showOverlay]
  ]);
}
const NavigationBarOverlay = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["render", _sfc_render$z], ["__scopeId", "data-v-5a0051d1"]]);
const _sfc_main$F = defineComponent({
  name: "OptionGroup",
  components: {
    Checkbox,
    EllipsisText,
    QIntersection: QIntersection_default,
    QSpace: QSpace_default,
    Radio,
    Toggle
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Option item class
     */
    itemClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * A text label above the Option Group
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Property of option which holds the 'label'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionLabel: {
      type: String,
      default: "label"
    },
    /**
     * Available options that the user can select from.
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Property of option which holds the 'value'; If using a function then for best performance, reference it from your scope and do not define it inline
     */
    optionValue: {
      type: String,
      default: "value"
    },
    /**
     * Put component in readonly mode
     */
    readonly: {
      type: Boolean,
      default: false
    },
    /**
     * Adds separator between options
     */
    separator: {
      type: Boolean,
      default: false
    },
    /**
     * Shows select all checkbox
     */
    showSelectAll: {
      type: Boolean,
      default: false
    },
    /**
     * Shows selector on hover
     */
    showSelectorOnHover: {
      type: Boolean,
      default: false
    },
    /**
     * Checkboxes or radio buttons
     */
    type: {
      type: String,
      default: "checkbox"
    },
    /**
     * Wraps each option with QIntersection
     */
    withIntersection: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  setup(props4, { emit }) {
    const { t: t2 } = useI18n();
    const allSelected = computed(() => {
      if (!Array.isArray(props4.modelValue)) return false;
      const total = props4.options.length;
      const selected2 = props4.modelValue.length;
      if (total === 0) return false;
      if (total === selected2) return true;
      if (selected2) return void 0;
      return false;
    });
    function isOptionSelected(option) {
      return selected.value === option[props4.optionValue] || Array.isArray(selected.value) && selected.value.includes(option[props4.optionValue]);
    }
    function isSeparatorVisible(index) {
      return props4.separator && index !== props4.options.length - 1;
    }
    const selected = computed({
      get() {
        return props4.modelValue;
      },
      set(value2) {
        emit("update:modelValue", value2);
      }
    });
    function toggleAllSelected(value2) {
      const selected2 = value2 ? props4.options.map((x2) => x2[props4.optionValue]) : [];
      emit("update:modelValue", selected2);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      allSelected,
      isOptionSelected,
      isSeparatorVisible,
      selected,
      t: t2,
      toggleAllSelected
    };
  }
});
const _hoisted_1$y = ["data-automation"];
const _hoisted_2$q = ["data-automation"];
const _hoisted_3$m = ["data-automation"];
const _hoisted_4$e = { class: "rv-option-group__item-selector row justify-center q-mr-sm" };
const _hoisted_5$b = ["data-automation"];
function _sfc_render$y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_Radio = resolveComponent("Radio");
  const _component_Toggle = resolveComponent("Toggle");
  return openBlock(), createElementBlock("div", {
    class: "rv-option-group column q-gutter-y-sm",
    "data-automation": _ctx.buildId()
  }, [
    _ctx.label ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["rv-option-group__label row no-wrap items-center full-width", { "rv-option-group__label--disable": _ctx.disable }]),
      "data-automation": _ctx.buildId("label")
    }, [
      createVNode(_component_EllipsisText, {
        class: "text-subtitle3",
        "data-automation": _ctx.buildId("label__text")
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.label), 1)
        ]),
        _: 1
      }, 8, ["data-automation"])
    ], 10, _hoisted_2$q)) : createCommentVNode("", true),
    _ctx.showSelectAll && _ctx.type === "checkbox" ? (openBlock(), createElementBlock("label", {
      key: 1,
      class: normalizeClass(["rv-option-group__item row no-wrap", { "cursor-pointer": !_ctx.disable }]),
      "data-automation": _ctx.buildId("option-select-all")
    }, [
      createElementVNode("div", _hoisted_4$e, [
        createVNode(_component_Checkbox, {
          "data-automation": _ctx.buildId("selectAll"),
          dense: "",
          disable: _ctx.disable,
          "model-value": _ctx.allSelected,
          "onUpdate:modelValue": _ctx.toggleAllSelected
        }, null, 8, ["data-automation", "disable", "model-value", "onUpdate:modelValue"])
      ]),
      createElementVNode("div", {
        class: normalizeClass(["rv-option-group__item-label row no-wrap full-width", {
          "border-bottom q-pb-sm": _ctx.separator,
          "rv-option-group__item-label--disable": _ctx.disable
        }])
      }, [
        createVNode(_component_EllipsisText, {
          class: normalizeClass(["rv-option-group__text zero-min-width", [
            _ctx.itemClass,
            {
              "rv-option-group__item-label--disable": _ctx.disable
            }
          ]]),
          "data-automation": _ctx.buildId("selectAll__label"),
          text: _ctx.t("rvai-base.general.actions.selectAll")
        }, null, 8, ["class", "data-automation", "text"]),
        createVNode(_component_QSpace),
        _ctx.$slots["select-all-actions"] ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "q-ml-sm",
          "data-automation": _ctx.buildId("select-all-actions")
        }, [
          renderSlot(_ctx.$slots, "select-all-actions", {}, void 0, true)
        ], 8, _hoisted_5$b)) : createCommentVNode("", true)
      ], 2)
    ], 10, _hoisted_3$m)) : createCommentVNode("", true),
    renderSlot(_ctx.$slots, "before-options", {}, void 0, true),
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (opt, index) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.withIntersection ? "QIntersection" : "label"), {
        key: opt[_ctx.optionValue],
        class: normalizeClass(["rv-option-group__item row no-wrap full-width", {
          "cursor-pointer": !_ctx.disable && !opt.disable && !_ctx.readonly,
          "rv-option-group__item-intersection": _ctx.withIntersection
        }]),
        "data-automation": _ctx.buildId(`option-${opt[_ctx.optionValue]}`),
        "transition-duration": 0
      }, {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(["rv-option-group__item-selector row justify-center q-mr-sm", {
              "rv-option-group__item-selector--toggle": _ctx.type === "toggle",
              "rv-option-group__item-selector--show-on-hover": _ctx.showSelectorOnHover && !_ctx.isOptionSelected(opt)
            }])
          }, [
            !_ctx.readonly ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              _ctx.type === "checkbox" ? (openBlock(), createBlock(_component_Checkbox, {
                key: 0,
                modelValue: _ctx.selected,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.selected = $event),
                "data-automation": _ctx.buildId(`option-${opt[_ctx.optionValue]}__checkbox`),
                dense: "",
                disable: !!(_ctx.disable || opt.disable),
                val: opt[_ctx.optionValue]
              }, null, 8, ["modelValue", "data-automation", "disable", "val"])) : _ctx.type === "radio" ? (openBlock(), createBlock(_component_Radio, {
                key: 1,
                modelValue: _ctx.selected,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.selected = $event),
                "data-automation": _ctx.buildId(`option-${opt[_ctx.optionValue]}__radio`),
                dense: "",
                disable: !!(_ctx.disable || opt.disable),
                val: opt[_ctx.optionValue]
              }, null, 8, ["modelValue", "data-automation", "disable", "val"])) : _ctx.type === "toggle" ? (openBlock(), createBlock(_component_Toggle, {
                key: 2,
                modelValue: _ctx.selected,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.selected = $event),
                "data-automation": _ctx.buildId(`option-${opt[_ctx.optionValue]}__toggle`),
                disable: !!(_ctx.disable || opt.disable),
                val: opt[_ctx.optionValue]
              }, null, 8, ["modelValue", "data-automation", "disable", "val"])) : createCommentVNode("", true)
            ], 64)) : createCommentVNode("", true)
          ], 2),
          createElementVNode("div", {
            class: normalizeClass(["rv-option-group__item-label row no-wrap items-center", [
              _ctx.itemClass,
              {
                "border-bottom": _ctx.isSeparatorVisible(index),
                "q-pb-sm": _ctx.separator || _ctx.type === "toggle",
                "rv-option-group__item-label--disable": _ctx.disable || opt.disable,
                "rv-option-group__item-label--toggle": _ctx.type === "toggle"
              }
            ]])
          }, [
            renderSlot(_ctx.$slots, "label", { option: opt }, () => [
              createVNode(_component_EllipsisText, {
                class: "rv-option-group__text",
                "data-automation": _ctx.buildId("option"),
                "data-automation-value": opt[_ctx.optionValue],
                text: opt[_ctx.optionLabel]
              }, null, 8, ["data-automation", "data-automation-value", "text"]),
              createVNode(_component_QSpace),
              renderSlot(_ctx.$slots, "after-label", { option: opt }, void 0, true)
            ], true)
          ], 2)
        ]),
        _: 2
      }, 1032, ["class", "data-automation"]);
    }), 128)),
    renderSlot(_ctx.$slots, "after-options", {}, void 0, true)
  ], 8, _hoisted_1$y);
}
const OptionGroup = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["render", _sfc_render$y], ["__scopeId", "data-v-0531210f"]]);
const _sfc_main$E = defineComponent({
  name: "Bullet",
  components: {
    ActionButton,
    RvInput,
    RvSelect
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: "pagination",
      type: String
    },
    /**
     * Put navigation buttons into disabled state
     */
    loading: {
      default: false,
      type: Boolean
    },
    /**
     * Set page size options to make it managable
     */
    pageSizeOptions: {
      default: () => [],
      type: Array
    }
  },
  setup(props4) {
    const {
      canNavigate,
      goToFirstPage,
      goToLastPage,
      goToNextPage,
      goToPreviousPage,
      hasNextPage,
      hasPreviousPage,
      newPage,
      onBlur: onBlur2,
      pageCount,
      pageSize,
      pageValue,
      setPageSize
    } = usePagination();
    const input = ref$1(null);
    const disableInput = computed(() => props4.loading || !canNavigate.value);
    const disableNext = computed(() => props4.loading || !hasNextPage.value);
    const disablePrevious = computed(() => props4.loading || !hasPreviousPage.value);
    const inputWidth = computed(() => {
      const paddingX = 16;
      const pixelsPerNumber = 8;
      const minWidth = 38;
      return Math.max(String(pageCount.value).length * pixelsPerNumber + paddingX, minWidth);
    });
    function onEnter() {
      var _a;
      (_a = input.value) == null ? void 0 : _a.blur();
    }
    function onKeyPress(e2) {
      const onlyDigits = /\d/g;
      if (!onlyDigits.test(e2.key)) e2.preventDefault();
    }
    function onGlobalKeyUp(e2) {
      if (isInputElement(document.activeElement)) return;
      switch (e2.key) {
        case KEY_ARROW_LEFT:
          if (hasPreviousPage.value) {
            goToPreviousPage();
          }
          return;
        case KEY_ARROW_RIGHT:
          if (hasNextPage.value) {
            goToNextPage();
          }
      }
    }
    onMounted(() => {
      document.addEventListener("keyup", onGlobalKeyUp, false);
      if (props4.pageSizeOptions.length && !props4.pageSizeOptions.includes(pageSize.value)) {
        setPageSize(props4.pageSizeOptions[0]);
      }
    });
    onUnmounted(() => {
      document.removeEventListener("keyup", onGlobalKeyUp, false);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      disableInput,
      disableNext,
      disablePrevious,
      goToFirstPage,
      goToLastPage,
      goToNextPage,
      goToPreviousPage,
      input,
      inputWidth,
      newPage,
      onBlur: onBlur2,
      onEnter,
      onKeyPress,
      pageCount,
      pageSize,
      pageValue,
      setPageSize
    };
  }
});
const _hoisted_1$x = ["data-automation"];
const _hoisted_2$p = ["data-automation"];
const _hoisted_3$l = ["data-automation"];
function _sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ActionButton = resolveComponent("ActionButton");
  const _component_RvInput = resolveComponent("RvInput");
  const _component_RvSelect = resolveComponent("RvSelect");
  return openBlock(), createElementBlock("div", {
    class: "pagination row no-wrap items-center q-gutter-xs text-grey-1",
    "data-automation": _ctx.buildId(),
    style: normalizeStyle({ "--input-width": `${_ctx.inputWidth}px` })
  }, [
    createVNode(_component_ActionButton, {
      class: "pagination__first-page text-grey-1",
      "data-automation": _ctx.buildId("first-page"),
      disable: _ctx.disablePrevious,
      icon: "mdi-chevron-double-left",
      onClick: _ctx.goToFirstPage
    }, null, 8, ["data-automation", "disable", "onClick"]),
    createVNode(_component_ActionButton, {
      class: "pagination__previous-page text-grey-1",
      "data-automation": _ctx.buildId("previous-page"),
      disable: _ctx.disablePrevious,
      icon: "mdi-chevron-left",
      onClick: _ctx.goToPreviousPage
    }, null, 8, ["data-automation", "disable", "onClick"]),
    createElementVNode("div", {
      class: "pagination__current-page row no-wrap items-center",
      "data-automation": _ctx.buildId("current-page")
    }, [
      createVNode(_component_RvInput, {
        ref: "input",
        modelValue: _ctx.newPage,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.newPage = $event),
        class: "pagination__new-page",
        "data-automation": _ctx.buildId("page-input"),
        dense: "",
        disable: _ctx.disableInput,
        "input-class": "pagination__input text-center",
        placeholder: _ctx.pageValue,
        type: "number",
        onBlur: _ctx.onBlur,
        onKeypress: _ctx.onKeyPress,
        onKeyup: withKeys(_ctx.onEnter, ["enter"])
      }, null, 8, ["modelValue", "data-automation", "disable", "placeholder", "onBlur", "onKeypress", "onKeyup"]),
      createElementVNode("div", {
        class: normalizeClass(["pagination__page-count text-subtitle3 text-no-wrap q-ml-sm", { "pagination__page-count--disable": _ctx.disableInput }]),
        "data-automation": _ctx.buildId("page-count")
      }, toDisplayString(_ctx.$t("rvai-base.general.symbols.slash")) + " " + toDisplayString(_ctx.pageCount), 11, _hoisted_3$l)
    ], 8, _hoisted_2$p),
    createVNode(_component_ActionButton, {
      class: "pagination__next-page text-grey-1",
      "data-automation": _ctx.buildId("next-page"),
      disable: _ctx.disableNext,
      icon: "mdi-chevron-right",
      onClick: _ctx.goToNextPage
    }, null, 8, ["data-automation", "disable", "onClick"]),
    createVNode(_component_ActionButton, {
      class: "pagination__last-page text-grey-1",
      "data-automation": _ctx.buildId("last-page"),
      disable: _ctx.disableNext,
      icon: "mdi-chevron-double-right",
      onClick: _ctx.goToLastPage
    }, null, 8, ["data-automation", "disable", "onClick"]),
    _ctx.pageSizeOptions.length ? (openBlock(), createBlock(_component_RvSelect, {
      key: 0,
      "data-automation": _ctx.buildId("page-size"),
      "model-value": _ctx.pageSize,
      options: _ctx.pageSizeOptions,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.setPageSize($event))
    }, null, 8, ["data-automation", "model-value", "options"])) : createCommentVNode("", true)
  ], 12, _hoisted_1$x);
}
const Pagination = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["render", _sfc_render$x], ["__scopeId", "data-v-db9929f3"]]);
const _sfc_main$D = defineComponent({
  name: "PrivacyPolicyDialog",
  components: {
    QCard: QCard_default,
    QCardSection: QCardSection_default,
    QDialog: QDialog_default,
    RvButton: Button
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "privacyPolicyDialog"
    },
    /**
     * Provide privacy policy URL to open in the iframe
     */
    privacyPolicyUrl: {
      type: String,
      required: true
    }
  },
  emits: [
    ...useDialogPluginComponent.emits
  ],
  setup(props4) {
    const {
      dialogRef,
      onDialogCancel,
      onDialogHide
    } = useDialogPluginComponent();
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      dialogRef,
      onCancel: onDialogCancel,
      onHide: onDialogHide
    };
  }
});
const _hoisted_1$w = ["src"];
function _sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvButton = resolveComponent("RvButton");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  const _directive_quasar_variables = resolveDirective("quasar-variables");
  return openBlock(), createBlock(_component_QDialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId(),
    maximized: ""
  }, toHandlers(_ctx.$attrs), { onHide: _ctx.onHide }), {
    default: withCtx(() => [
      createVNode(_component_QCard, { class: "rv-privacy-policy-dialog column no-wrap" }, {
        default: withCtx(() => [
          createVNode(_component_QCardSection, { class: "q-pb-none flex justify-end" }, {
            default: withCtx(() => [
              createVNode(_component_RvButton, {
                icon: "mdi-close",
                tertiary: "",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          createVNode(_component_QCardSection, { class: "full-width full-height" }, {
            default: withCtx(() => [
              withDirectives(createElementVNode("iframe", {
                frameborder: "0",
                height: "100%",
                src: _ctx.privacyPolicyUrl,
                width: "100%"
              }, null, 8, _hoisted_1$w), [
                [_directive_quasar_variables]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["data-automation", "onHide"]);
}
const PrivacyPolicyDialog = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["render", _sfc_render$w]]);
const _sfc_main$C = defineComponent({
  name: "TermsAndConditionsDialog",
  components: {
    QCard: QCard_default,
    QCardSection: QCardSection_default,
    QDialog: QDialog_default,
    RvButton: Button
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "termsAndConditionsDialog"
    },
    /**
     * Provide rems and conditions URL to open in the iframe
     */
    termsAndConditionsUrl: {
      type: String,
      required: true
    }
  },
  emits: [
    ...useDialogPluginComponent.emits
  ],
  setup(props4) {
    const {
      dialogRef,
      onDialogCancel,
      onDialogHide
    } = useDialogPluginComponent();
    const { t: t2 } = useI18n();
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      dialogRef,
      onCancel: onDialogCancel,
      onHide: onDialogHide,
      t: t2
    };
  }
});
const _hoisted_1$v = { class: "rv-terms-and-conditions-dialog__subtitle text-subtitle1 full-width" };
const _hoisted_2$o = ["src"];
function _sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvButton = resolveComponent("RvButton");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  const _directive_quasar_variables = resolveDirective("quasar-variables");
  return openBlock(), createBlock(_component_QDialog, mergeProps({
    ref: "dialogRef",
    "data-automation": _ctx.buildId(),
    maximized: ""
  }, toHandlers(_ctx.$attrs), { onHide: _ctx.onHide }), {
    default: withCtx(() => [
      createVNode(_component_QCard, { class: "rv-terms-and-conditions-dialog column no-wrap overflow-hidden" }, {
        default: withCtx(() => [
          createVNode(_component_QCardSection, { class: "q-pb-none flex justify-end" }, {
            default: withCtx(() => [
              createVNode(_component_RvButton, {
                icon: "mdi-close",
                tertiary: "",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          createVNode(_component_QCardSection, { class: "row flex-center q-mx-lg" }, {
            default: withCtx(() => [
              createElementVNode("span", _hoisted_1$v, toDisplayString(_ctx.t("rvai-base.policiesAndLicenses.titles.termsAndConditions")), 1)
            ]),
            _: 1
          }),
          createVNode(_component_QCardSection, { class: "full-width full-height q-mx-lg q-pb-none" }, {
            default: withCtx(() => [
              withDirectives(createElementVNode("iframe", {
                frameborder: "0",
                height: "100%",
                src: _ctx.termsAndConditionsUrl,
                width: "100%"
              }, null, 8, _hoisted_2$o), [
                [_directive_quasar_variables]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["data-automation", "onHide"]);
}
const TermsAndConditionsDialog = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["render", _sfc_render$v], ["__scopeId", "data-v-6ff9fdbb"]]);
const _sfc_main$B = defineComponent({
  name: "PoliciesAndLicenses",
  components: {
    RvButton: Button
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "policiesAndLicenses"
    },
    /**
     * Provide cookies label for accept button
     */
    cookiesAcceptBtn: {
      type: String,
      default: void 0
    },
    /**
     * Provide cookies label for reject button
     */
    cookiesRejectBtn: {
      type: String,
      default: void 0
    },
    /**
     * Provide cookies title
     */
    cookiesTitle: {
      type: String,
      default: void 0
    },
    /**
     * Provide cookies URL to open in the iframe
     */
    cookiesUrl: {
      type: String,
      required: true
    },
    /**
     * Provide cookies dialog width
     */
    cookiesWidth: {
      type: String,
      default: "420px"
    },
    /**
     * Provide privacy policy URL to open in the iframe
     */
    privacyPolicyUrl: {
      type: String,
      required: true
    },
    /**
     * Provide rems and conditions URL to open in the iframe
     */
    termsAndConditionsUrl: {
      type: String,
      required: true
    },
    /**
     * Provide title
     */
    title: {
      default: void 0,
      type: String
    }
  },
  emits: ["on-title-click"],
  setup(props4) {
    const { hasCookiesPolicy } = useCookiesPolicy();
    const $q = useQuasar();
    const { t: t2 } = useI18n();
    const options = [
      {
        action: onOpenCookiesDialog,
        title: t2("rvai-base.policiesAndLicenses.actions.cookies.open")
      },
      {
        action: onOpenPrivacyPolicyDialog,
        title: t2("rvai-base.policiesAndLicenses.actions.privacyPolicy.open")
      },
      {
        action: onOpenTermsAndConditionsDialog,
        title: t2("rvai-base.policiesAndLicenses.actions.termsAndConditions.open")
      }
    ];
    function onOpenCookiesDialog() {
      $q.dialog({
        component: CookiesDialog,
        componentProps: {
          cookiesAcceptBtn: props4.cookiesAcceptBtn,
          cookiesRejectBtn: props4.cookiesRejectBtn,
          cookiesTitle: props4.cookiesTitle,
          cookiesUrl: props4.cookiesUrl,
          cookiesWidth: props4.cookiesWidth
        }
      });
    }
    function onOpenPrivacyPolicyDialog() {
      $q.dialog({
        component: PrivacyPolicyDialog,
        componentProps: {
          privacyPolicyUrl: props4.privacyPolicyUrl
        }
      });
    }
    function onOpenTermsAndConditionsDialog() {
      $q.dialog({
        component: TermsAndConditionsDialog,
        componentProps: {
          termsAndConditionsUrl: props4.termsAndConditionsUrl
        }
      });
    }
    onMounted(() => {
      if (!hasCookiesPolicy.value) {
        void nextTick(onOpenCookiesDialog);
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      options,
      t: t2
    };
  }
});
const _hoisted_1$u = ["data-automation"];
const _hoisted_2$n = { class: "text-subtitle3" };
const _hoisted_3$k = { class: "flex flex-center full-width" };
const _hoisted_4$d = ["onClick"];
function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvButton = resolveComponent("RvButton");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["rv-policies-and-licenses flex column items-center full-width", {
      "rv-policies-and-licenses--with-title": _ctx.title,
      "justify-center": !_ctx.title
    }]),
    "data-automation": _ctx.buildId()
  }, [
    _ctx.title ? (openBlock(), createBlock(_component_RvButton, {
      key: 0,
      class: "q-mt-lg",
      "data-automation": _ctx.buildId("title"),
      size: "md",
      tertiary: "",
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("on-title-click"))
    }, {
      default: withCtx(() => [
        createElementVNode("span", _hoisted_2$n, toDisplayString(_ctx.title), 1)
      ]),
      _: 1
    }, 8, ["data-automation"])) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_3$k, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option, index) => {
        return openBlock(), createElementBlock(Fragment, {
          key: option.title
        }, [
          createElementVNode("span", {
            class: "rv-policies-and-licenses__action text-body2",
            onClick: option.action
          }, toDisplayString(option.title), 9, _hoisted_4$d),
          index !== _ctx.options.length - 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(_ctx.t("rvai-base.general.symbols.pipe")), 1)
          ], 64)) : createCommentVNode("", true)
        ], 64);
      }), 128))
    ])
  ], 10, _hoisted_1$u);
}
const PoliciesAndLicenses = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["render", _sfc_render$u], ["__scopeId", "data-v-b411e3c9"]]);
const _sfc_main$A = defineComponent({
  name: "Range",
  components: {
    EllipsisText,
    QIcon: QIcon_default,
    QRange: QRange_default,
    RvInput,
    Tooltip
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Render info icon with tooltip. Can be used as an "info-text" property or as a slot
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: ""
    },
    /**
     * How many numbers show after comma for float numbers
     * @type {number}
     */
    inputDecimals: {
      type: Number,
      default: void 0
    },
    /**
     * The text that will be shown above the input
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    labelClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Maximum value of the model; Set track's maximum value
     */
    max: {
      type: Number,
      default: 100
    },
    /**
     * Minimum value of the model; Set track's minimum value
     */
    min: {
      type: Number,
      default: 0
    },
    /**
     * Label to show instead of minimum value
     */
    minLabel: {
      type: String,
      default: ""
    },
    /**
     * Model of the component of type { min, max } (both values must be between global min/max); Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: Object,
      required: true
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    /**
     * Shows min and max values around slider
     */
    showMinMax: {
      type: Boolean,
      default: true
    },
    /**
     * Show optional label next to label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Popup a label when user clicks/taps on the slider thumb and moves it
     */
    showPinLabel: {
      type: Boolean,
      default: true
    },
    /**
       * Specify step amount between valid values (> 0.0); When step equals to 0 it defines infinite granularity
       */
    step: {
      type: Number,
      default: 1
    },
    /**
     * Allow setting the values via input fields
     */
    withInput: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when the component needs to change the model; Is also used by v-model
     *
     * @type {RangeModel}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const maxValueString = ref$1(String(props4.modelValue.max));
    const minValueString = ref$1(String(props4.modelValue.min));
    function getParsedValue(value2) {
      const parsed = props4.inputDecimals && value2 ? truncateNumber(parseFloat(value2), props4.inputDecimals) : roundToStep(Number(value2), props4.step);
      if (isNaN(parsed)) {
        return NaN;
      }
      if (parsed < props4.min) {
        return props4.min;
      }
      if (parsed > props4.max) {
        return props4.max;
      }
      return parsed;
    }
    function onMinInputBlur() {
      const parsed = getParsedValue(minValueString.value);
      if (isNaN(parsed)) {
        minValueString.value = String(props4.modelValue.min);
        return;
      }
      const newModelValue = { ...props4.modelValue };
      if (parsed > props4.modelValue.max) {
        newModelValue.max = parsed;
        newModelValue.min = props4.modelValue.max;
      } else {
        newModelValue.min = parsed;
      }
      emit("update:modelValue", newModelValue);
    }
    function onMaxInputBlur() {
      const parsed = getParsedValue(maxValueString.value);
      if (isNaN(parsed)) {
        maxValueString.value = String(props4.modelValue.max);
        return;
      }
      const newModelValue = { ...props4.modelValue };
      if (parsed < props4.modelValue.min) {
        newModelValue.max = props4.modelValue.min;
        newModelValue.min = parsed;
      } else {
        newModelValue.max = parsed;
      }
      emit("update:modelValue", newModelValue);
    }
    watch(() => props4.modelValue, (value2) => {
      minValueString.value = String(value2.min);
      maxValueString.value = String(value2.max);
    }, { immediate: true });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      maxValueString,
      minValueString,
      onMaxInputBlur,
      onMinInputBlur
    };
  }
});
const _hoisted_1$t = ["data-automation"];
const _hoisted_2$m = ["data-automation"];
const _hoisted_3$j = { class: "row no-wrap items-center full-width" };
const _hoisted_4$c = {
  key: 0,
  class: "q-ml-xs"
};
const _hoisted_5$a = { class: "row items-center no-wrap" };
const _hoisted_6$7 = { class: "q-mr-md col-fixed" };
const _hoisted_7$5 = { class: "q-ml-md col-fixed" };
function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_RvInput = resolveComponent("RvInput");
  const _component_QRange = resolveComponent("QRange");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: ["rv-range", { "rv-range--with-input": _ctx.withInput }],
    "data-automation": _ctx.buildId()
  }), [
    _ctx.label ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["rv-slider__label flex justify-between items-center", _ctx.labelClass]),
      "data-automation": _ctx.buildId("label-container")
    }, [
      createElementVNode("span", _hoisted_3$j, [
        createVNode(_component_EllipsisText, {
          class: "text-subtitle3",
          "data-automation": _ctx.buildId("label"),
          text: _ctx.label
        }, null, 8, ["data-automation", "text"]),
        _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_4$c, toDisplayString(_ctx.optionalLabel || _ctx.$t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
        _ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
          key: 1,
          class: "q-ml-xs info-icon",
          color: "black-1",
          "data-automation": _ctx.buildId("icon-info"),
          name: "info",
          size: "16px"
        }, {
          default: withCtx(() => [
            createVNode(_component_Tooltip, {
              anchor: "top middle",
              class: normalizeClass(_ctx.infoTextClass),
              "data-automation": _ctx.buildId("icon-info__tooltip"),
              self: "bottom middle"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "infoText", {}, () => [
                  createTextVNode(toDisplayString(_ctx.infoText), 1)
                ], true)
              ]),
              _: 3
            }, 8, ["class", "data-automation"])
          ]),
          _: 3
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ])
    ], 10, _hoisted_2$m)) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_5$a, [
      createElementVNode("div", _hoisted_6$7, [
        _ctx.withInput ? (openBlock(), createBlock(_component_RvInput, {
          key: 0,
          modelValue: _ctx.minValueString,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.minValueString = $event),
          class: "rv-slider__input",
          "data-automation": _ctx.buildId("min-input"),
          disable: _ctx.disable,
          "item-aligned": "center",
          "show-error": false,
          "show-error-message": false,
          "show-valid": false,
          onBlur: _ctx.onMinInputBlur,
          onKeyup: _cache[1] || (_cache[1] = withKeys(($event) => $event.target.blur(), ["enter"]))
        }, null, 8, ["modelValue", "data-automation", "disable", "onBlur"])) : _ctx.showMinMax ? (openBlock(), createBlock(_component_EllipsisText, {
          key: 1,
          class: "rv-range__limit text-grey-1",
          "data-automation": _ctx.buildId("min")
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.minLabel || _ctx.min), 1)
          ]),
          _: 1
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      createVNode(_component_QRange, {
        class: normalizeClass(_ctx.$props.class),
        "data-automation": _ctx.buildId("slider"),
        disable: _ctx.disable,
        label: _ctx.showPinLabel,
        max: _ctx.max,
        min: _ctx.min,
        "model-value": _ctx.modelValue,
        step: _ctx.step,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.$emit("update:modelValue", $event))
      }, null, 8, ["class", "data-automation", "disable", "label", "max", "min", "model-value", "step"]),
      createElementVNode("div", _hoisted_7$5, [
        _ctx.withInput ? (openBlock(), createBlock(_component_RvInput, {
          key: 0,
          modelValue: _ctx.maxValueString,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.maxValueString = $event),
          class: "rv-slider__input",
          "data-automation": _ctx.buildId("max-input"),
          disable: _ctx.disable,
          "item-aligned": "center",
          "show-error": false,
          "show-error-message": false,
          "show-valid": false,
          onBlur: _ctx.onMaxInputBlur,
          onKeyup: _cache[4] || (_cache[4] = withKeys(($event) => $event.target.blur(), ["enter"]))
        }, null, 8, ["modelValue", "data-automation", "disable", "onBlur"])) : _ctx.showMinMax ? (openBlock(), createBlock(_component_EllipsisText, {
          key: 1,
          class: "rv-range__limit text-grey-1",
          "data-automation": _ctx.buildId("max")
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.max), 1)
          ]),
          _: 1
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ])
    ])
  ], 16, _hoisted_1$t);
}
const Range = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["render", _sfc_render$t], ["__scopeId", "data-v-3a80790d"]]);
const _sfc_main$z = defineComponent({
  name: "ScrollNavigation",
  components: {
    CardItem,
    QIcon: QIcon_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Elements to be shown as buttons
     */
    entries: {
      required: true,
      type: Array
    },
    /**
     * Section title
     */
    title: {
      required: true,
      type: String
    }
  },
  emits: ["on-click"],
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$s = ["data-automation"];
const _hoisted_2$l = { class: "q-pl-lg q-pt-lg q-pb-md text-subtitle1" };
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_CardItem = resolveComponent("CardItem");
  const _component_rv_scroll_area = resolveComponent("rv-scroll-area");
  return openBlock(), createElementBlock("div", {
    class: "scroll-buttons items-start",
    "data-automation": _ctx.buildId(),
    style: normalizeStyle({
      "--items": _ctx.entries.length
    })
  }, [
    createElementVNode("div", _hoisted_2$l, toDisplayString(_ctx.title), 1),
    createVNode(_component_rv_scroll_area, {
      class: "scroll-buttons__list",
      "data-automation": _ctx.buildId("scrollArea")
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.entries, (entry, index) => {
          return openBlock(), createBlock(_component_CardItem, {
            key: index,
            class: normalizeClass(["scroll-buttons__item", { "scroll-buttons__item--active": entry.active }]),
            "data-automation": _ctx.buildId(`item__${index}`),
            "hide-icon": "",
            title: entry.label,
            onClick: ($event) => _ctx.$emit("on-click", entry.to)
          }, createSlots({ _: 2 }, [
            entry.icon ? {
              name: "prepend",
              fn: withCtx(() => [
                createVNode(_component_QIcon, {
                  class: "q-mr-md",
                  name: entry.icon,
                  size: "24px"
                }, null, 8, ["name"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["class", "data-automation", "title", "onClick"]);
        }), 128))
      ]),
      _: 1
    }, 8, ["data-automation"])
  ], 12, _hoisted_1$s);
}
const ScrollNavigation = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["render", _sfc_render$s], ["__scopeId", "data-v-b1bd8d7b"]]);
const __default__ = defineComponent({
  name: "SearchInput",
  components: {
    RvButton: Button,
    RvInput,
    ScrollArea
  },
  inheritAttrs: false,
  props: {
    /**
     * Enables bottom slots ('error', 'hint', 'counter')
     */
    bottomSlots: {
      type: Boolean,
      default: false
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Clear the input when user select a value
     * @type {boolean}
     */
    clearOnSelect: {
      default: true,
      type: Boolean
    },
    /**
     * Items to be searched
     * @type {[string | number]}
     */
    data: {
      required: true,
      type: Array
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      default: "searchInput",
      type: String
    },
    /**
     * Dense mode; occupies less space
     */
    dense: {
      default: false,
      type: Boolean
    },
    /**
     * Disable input element
     */
    disable: {
      default: false,
      type: Boolean
    },
    /**
     * Helper (hint) text which gets placed below your wrapped form component
     */
    hint: {
      default: void 0,
      type: String
    },
    /**
     * Max height of scrollable content
     * @type {boolean}
     */
    maxContentHeight: {
      default: 200,
      type: Number
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      required: true,
      type: String
    },
    /**
     * Text that appears in the input element when it has no value set
     */
    placeholder: {
      default: () => useI18n().t("rvai-base.general.text.search"),
      type: String
    }
  },
  emits: [
    /**
     * Emitted when the component needs to change the model; Is also used by v-model
     *
     * @type {string}
     */
    "update:modelValue",
    /**
     * Emitted when selected value from search list
     *
     * @type {string}
     */
    "select"
  ],
  setup(props4, { emit }) {
    const slots = useSlots();
    const { t: t2 } = useI18n();
    const inputRef = ref$1(null);
    const contentHeight = ref$1(0);
    const scrollAreaRef = ref$1(null);
    const selectedIndex = ref$1(void 0);
    const bottomSlotNames = computed(() => {
      return ["error", "hint", "counter"].filter((name2) => props4.bottomSlots && slots[name2]);
    });
    const search = computed({
      get() {
        return props4.modelValue;
      },
      set(value2) {
        emit("update:modelValue", value2);
      }
    });
    const contentHeightPx = computed(() => {
      return filteredData.value.length ? `${Math.min(props4.maxContentHeight, contentHeight.value)}px` : "auto";
    });
    const sortedData = computed(() => {
      return [...props4.data].sort((a3, b2) => naturalSort(a3.value, b2.value));
    });
    const filteredData = computed(() => {
      const needle = String(search.value).toLowerCase();
      return needle ? sortedData.value.filter((v) => v.label.toLowerCase().includes(needle) || v.value.toLowerCase().includes(needle)) : [];
    });
    function clear() {
      search.value = "";
      selectedIndex.value = void 0;
    }
    function focus() {
      var _a;
      void ((_a = inputRef.value) == null ? void 0 : _a.input.focus());
    }
    function handleArrowKey(e2) {
      var _a, _b, _c;
      e2.preventDefault();
      const isKeyUp = e2.key === KEY_ARROW_UP;
      selectedIndex.value = isKeyUp ? Math.max(0, (selectedIndex.value ?? 0) - 1) : Math.min(filteredData.value.length - 1, (selectedIndex.value ?? 0) + 1);
      const el = document.querySelector(`[search-input-item-index="${selectedIndex.value}"]`);
      if (!el) return;
      const offsetTop = el.offsetTop;
      const offsetBottom = offsetTop != null ? offsetTop + el.offsetHeight : 0;
      const rect = el.getBoundingClientRect();
      const visibleAreaHeight = (_a = scrollAreaRef.value) == null ? void 0 : _a.$el.clientHeight;
      const scrollPosition = ((_b = scrollAreaRef.value) == null ? void 0 : _b.scrollAreaRef.getScrollPosition().top) ?? 0;
      const isOutsideView = rect && offsetTop != null && offsetBottom != null && !!(isKeyUp ? offsetTop < scrollPosition : offsetBottom - scrollPosition > visibleAreaHeight);
      if (isOutsideView) {
        (_c = scrollAreaRef.value) == null ? void 0 : _c.setScrollPosition(
          "vertical",
          isKeyUp ? scrollPosition - rect.height : scrollPosition + rect.height
        );
      }
    }
    function handleEnter(e2) {
      if (selectedIndex.value === void 0) return;
      e2.preventDefault();
      emit("select", filteredData.value[selectedIndex.value]);
      if (props4.clearOnSelect) {
        clear();
      }
    }
    const onBlur2 = debounce_default(clear, 200);
    function onKeyUp(e2) {
      var _a;
      switch (e2.key) {
        case KEY_ESC:
        case KEY_ESCAPE:
          (_a = inputRef.value) == null ? void 0 : _a.input.blur();
          return;
      }
      if (filteredData.value.length) {
        switch (e2.key) {
          case KEY_ARROW_UP:
          case KEY_ARROW_DOWN:
            return handleArrowKey(e2);
          case KEY_ENTER:
            return handleEnter(e2);
        }
      }
    }
    function onMouseSelect(v) {
      emit("select", v);
      clear();
    }
    watch(() => {
      var _a;
      return (_a = inputRef.value) == null ? void 0 : _a.focused;
    }, (focused, prev) => {
      if (focused && focused !== prev) {
        document.addEventListener("keyup", onKeyUp);
      } else {
        document.removeEventListener("keyup", onKeyUp);
      }
    }, { immediate: true });
    watch(filteredData, async (v) => {
      var _a, _b;
      selectedIndex.value = v.length ? 0 : void 0;
      await nextTick();
      const scrollContentHeight = (_b = (_a = scrollAreaRef.value) == null ? void 0 : _a.$el.querySelector(".search-input__list")) == null ? void 0 : _b.clientHeight;
      if (scrollContentHeight != null) {
        contentHeight.value = scrollContentHeight;
      }
    }, { immediate: true });
    onUnmounted(() => {
      document.removeEventListener("keyup", onKeyUp);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      bottomSlotNames,
      clear,
      contentHeightPx,
      filteredData,
      focus,
      inputRef,
      onBlur: onBlur2,
      onKeyUp,
      onMouseSelect,
      scrollAreaRef,
      search,
      selectedIndex,
      t: t2
    };
  }
});
const __injectCSSVars__ = () => {
  useCssVars((_ctx) => ({
    "v69587158": _ctx.contentHeightPx
  }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props4, ctx) => {
  __injectCSSVars__();
  return __setup__(props4, ctx);
} : __injectCSSVars__;
const _hoisted_1$r = ["data-automation"];
const _hoisted_2$k = ["data-automation"];
const _hoisted_3$i = ["data-automation"];
const _hoisted_4$b = ["data-automation"];
const _hoisted_5$9 = ["data-automation", "search-input-item-index", "onClick"];
const _hoisted_6$6 = { class: "q-pa-xs q-pl-md" };
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvButton = resolveComponent("RvButton");
  const _component_RvInput = resolveComponent("RvInput");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: ["search-input relative-position", _ctx.$props.class],
    "data-automation": _ctx.buildId(),
    onKeyUp: _cache[1] || (_cache[1] = (...args) => _ctx.onKeyUp && _ctx.onKeyUp(...args))
  }), [
    createVNode(_component_RvInput, {
      ref: "inputRef",
      modelValue: _ctx.search,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.search = $event),
      "bottom-slots": _ctx.bottomSlots,
      class: "search-input__input",
      "data-automation": _ctx.buildId("input"),
      dense: _ctx.dense,
      disable: _ctx.disable,
      hint: _ctx.hint,
      icon: "search",
      placeholder: _ctx.placeholder,
      onBlur: _ctx.onBlur,
      onKeyUp: withModifiers(_ctx.onKeyUp, ["stop", "prevent"])
    }, createSlots({
      append: withCtx(() => [
        _ctx.search ? (openBlock(), createBlock(_component_RvButton, {
          key: 0,
          color: "black-1",
          "data-automation": _ctx.buildId("input__close-btn"),
          icon: "close",
          size: "md",
          tertiary: "",
          onClick: _ctx.clear
        }, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)
      ]),
      _: 2
    }, [
      renderList(_ctx.bottomSlotNames, (name2) => {
        return {
          name: name2,
          fn: withCtx((slotData) => [
            renderSlot(_ctx.$slots, name2, normalizeProps(guardReactiveProps(slotData || {})), void 0, true)
          ])
        };
      })
    ]), 1032, ["modelValue", "bottom-slots", "data-automation", "dense", "disable", "hint", "placeholder", "onBlur", "onKeyUp"]),
    _ctx.filteredData.length || _ctx.search ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "search-input__list-wrapper bg-white rounded-borders shadow-6 absolute full-width",
      "data-automation": _ctx.buildId("list")
    }, [
      _ctx.search && !_ctx.filteredData.length ? renderSlot(_ctx.$slots, "noSearchResult", { key: 0 }, () => [
        createElementVNode("div", {
          class: "q-pa-xs q-pl-md",
          "data-automation": _ctx.buildId("list__no-match")
        }, toDisplayString(_ctx.t("rvai-base.components.searchInput.noMatches")), 9, _hoisted_3$i)
      ], true) : createCommentVNode("", true),
      createVNode(_component_ScrollArea, {
        ref: "scrollAreaRef",
        class: "full-height",
        "data-automation": _ctx.buildId("scroll"),
        "no-horizontal": ""
      }, {
        default: withCtx(() => [
          _ctx.filteredData.length || _ctx.search ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["search-input__list rounded-borders full-height full-width", { "search-input__list--offset": _ctx.hint }]),
            "data-automation": _ctx.buildId("list")
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.filteredData, (item, index) => {
              return openBlock(), createElementBlock("div", {
                key: `${item}-${index}`,
                class: normalizeClass(["search-input__list__item", { "search-input__list__item--selected": index === _ctx.selectedIndex }]),
                "data-automation": _ctx.buildId("list__item"),
                "search-input-item-index": index,
                onClick: ($event) => _ctx.onMouseSelect(item)
              }, [
                renderSlot(_ctx.$slots, "menuItem", { item }, () => [
                  createElementVNode("div", _hoisted_6$6, toDisplayString(item.label), 1)
                ], true)
              ], 10, _hoisted_5$9);
            }), 128))
          ], 10, _hoisted_4$b)) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["data-automation"])
    ], 8, _hoisted_2$k)) : createCommentVNode("", true)
  ], 16, _hoisted_1$r);
}
const SearchInput = /* @__PURE__ */ _export_sfc(__default__, [["render", _sfc_render$r], ["__scopeId", "data-v-680dd51d"]]);
const _sfc_main$y = defineComponent({
  name: "SectionMessage",
  components: {
    QIcon: QIcon_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "section-message"
    },
    class: {
      default: void 0,
      type: [Array, Object, String]
    },
    color: {
      default: "negative",
      type: String,
      validator: (v) => [
        "blue",
        "negative",
        "positive"
      ].includes(v)
    },
    iconName: {
      default: void 0,
      type: String
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$q = ["data-automation"];
const _hoisted_2$j = ["data-automation"];
const _hoisted_3$h = ["data-automation"];
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_q_icon = resolveComponent("q-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.$props.class),
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", {
      class: normalizeClass(`rounded-borders q-px-md q-py-sm flex no-wrap items-center text-white bg-${_ctx.color}`),
      "data-automation": _ctx.buildId("main")
    }, [
      _ctx.iconName ? (openBlock(), createBlock(_component_q_icon, {
        key: 0,
        class: "q-mr-md",
        color: "white",
        "data-automation": _ctx.buildId("icon"),
        name: _ctx.iconName,
        size: "24px"
      }, null, 8, ["data-automation", "name"])) : createCommentVNode("", true),
      _ctx.$slots["default"] ? (openBlock(), createElementBlock("div", {
        key: 1,
        "data-automation": _ctx.buildId("message-slot")
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_3$h)) : createCommentVNode("", true)
    ], 10, _hoisted_2$j)
  ], 10, _hoisted_1$q);
}
const SectionMessage = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["render", _sfc_render$q]]);
const _sfc_main$x = defineComponent({
  name: "SelectBoolean",
  components: {
    RvSelect
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    const options = computed(() => {
      return [
        {
          label: t2("rvai-base.general.text.no"),
          value: false
        },
        {
          label: t2("rvai-base.general.text.yes"),
          value: true
        }
      ];
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      options
    };
  }
});
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvSelect = resolveComponent("RvSelect");
  return openBlock(), createBlock(_component_RvSelect, mergeProps(_ctx.$attrs, {
    "data-automation": _ctx.buildId(),
    "emit-value": "",
    "map-options": "",
    options: _ctx.options
  }), null, 16, ["data-automation", "options"]);
}
const SelectBoolean = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["render", _sfc_render$p]]);
const _sfc_main$w = defineComponent({
  name: "SpinnerAbsolute",
  components: {
    QSpinner: QSpinner_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "spinnerAbsolute"
    },
    /**
     * Spinner size
     */
    size: {
      type: String,
      default: "48px"
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$p = ["data-automation"];
const _hoisted_2$i = { class: "spinner-block__background absolute-full" };
const _hoisted_3$g = { class: "absolute-center" };
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QSpinner = resolveComponent("QSpinner");
  return openBlock(), createElementBlock("div", {
    class: "spinner-block flex justify-center",
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", _hoisted_2$i, [
      createElementVNode("div", _hoisted_3$g, [
        createVNode(_component_QSpinner, {
          class: "spinner-block__spinner",
          color: "primary",
          size: _ctx.size
        }, null, 8, ["size"])
      ])
    ])
  ], 8, _hoisted_1$p);
}
const SpinnerAbsolute = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["render", _sfc_render$o], ["__scopeId", "data-v-3f9f141d"]]);
const _sfc_main$v = defineComponent({
  name: "Sidebar",
  components: {
    Logo: _sfc_main$P,
    QCard: QCard_default,
    QCardActions: QCardActions_default,
    QCardSection: QCardSection_default,
    QDialog: QDialog_default,
    QSpace: QSpace_default,
    RvButton: Button,
    ScrollArea,
    SpinnerAbsolute
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Disable back button
     */
    disableBackBtn: {
      type: Boolean,
      default: false
    },
    /**
     * Disable close button
     */
    disableCloseBtn: {
      type: Boolean,
      default: false
    },
    /**
     * Focus field on initial component render
     */
    focusFirstInput: {
      type: Boolean,
      default: true
    },
    /**
     * Hide back button
     */
    hideBackBtn: {
      type: Boolean,
      default: true
    },
    /**
     * Hide close button
     */
    hideCloseBtn: {
      type: Boolean,
      default: false
    },
    /**
     * Display loading state
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Stick dialog to one of the sides (top, right, bottom or left)
     */
    position: {
      type: String,
      default: "left"
    },
    /**
     * Display saving state
     */
    saving: {
      type: Boolean,
      default: false
    },
    /**
     * Text displayed in title
     */
    title: {
      type: String,
      default: ""
    }
  },
  emits: [
    ...useDialogPluginComponent.emits,
    "on-back",
    "on-cancel",
    "on-submit"
  ],
  setup(props4, { emit }) {
    const { logoAlignClasses } = useLogo();
    const {
      dialogRef,
      onDialogCancel,
      onDialogHide,
      onDialogOK
    } = useDialogPluginComponent();
    function cancel() {
      emit("on-cancel");
      onDialogCancel();
    }
    function hide() {
      var _a;
      (_a = dialogRef.value) == null ? void 0 : _a.hide();
    }
    function show() {
      var _a;
      (_a = dialogRef.value) == null ? void 0 : _a.show();
    }
    function onBack() {
      emit("on-back");
    }
    function onSubmit() {
      emit("on-submit");
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      cancel,
      dialogRef,
      hide,
      logoAlignClasses,
      onBack,
      onDialogHide,
      onDialogOK,
      onSubmit,
      show
    };
  }
});
const _hoisted_1$o = { class: "sidebar__back" };
const _hoisted_2$h = { class: "sidebar__cancel" };
const _hoisted_3$f = ["data-automation"];
const _hoisted_4$a = ["data-automation"];
const _hoisted_5$8 = ["data-automation"];
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvButton = resolveComponent("RvButton");
  const _component_Logo = resolveComponent("Logo");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_SpinnerAbsolute = resolveComponent("SpinnerAbsolute");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_QCardActions = resolveComponent("QCardActions");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  const _directive_focus = resolveDirective("focus");
  const _directive_hotkey = resolveDirective("hotkey");
  return openBlock(), createBlock(_component_QDialog, mergeProps({ ref: "dialogRef" }, _ctx.$attrs, {
    "data-automation": _ctx.buildId(),
    maximized: "",
    "no-backdrop-dismiss": "",
    position: _ctx.position,
    onHide: _ctx.onDialogHide
  }), {
    default: withCtx(() => [
      withDirectives((openBlock(), createBlock(_component_QCard, { class: "sidebar column no-wrap" }, {
        default: withCtx(() => [
          createVNode(_component_QCardSection, {
            class: "sidebar__header row no-wrap items-center q-px-lg q-pt-md q-pb-lg",
            "data-automation": _ctx.buildId("header")
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1$o, [
                !_ctx.hideBackBtn ? (openBlock(), createBlock(_component_RvButton, {
                  key: 0,
                  class: "no-padding",
                  color: "black-1",
                  "data-automation": _ctx.buildId("back"),
                  disable: _ctx.disableBackBtn,
                  icon: "mdi-chevron-left",
                  tertiary: "",
                  onClick: _ctx.onBack
                }, null, 8, ["data-automation", "disable", "onClick"])) : createCommentVNode("", true)
              ]),
              createElementVNode("div", {
                class: normalizeClass(["sidebar__logo-wrapper", _ctx.logoAlignClasses])
              }, [
                createVNode(_component_Logo, {
                  class: "sidebar__logo",
                  "data-automation": _ctx.buildId("logo"),
                  name: "regular"
                }, null, 8, ["data-automation"])
              ], 2),
              createElementVNode("div", _hoisted_2$h, [
                !_ctx.hideCloseBtn ? (openBlock(), createBlock(_component_RvButton, {
                  key: 0,
                  class: "no-padding",
                  color: "black-1",
                  "data-automation": _ctx.buildId("cancel"),
                  disable: _ctx.disableCloseBtn,
                  icon: "mdi-close",
                  tertiary: "",
                  onClick: _ctx.cancel
                }, null, 8, ["data-automation", "disable", "onClick"])) : createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["data-automation"]),
          _ctx.title ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "sidebar__title text-subtitle1 q-px-lg q-pb-md",
            "data-automation": _ctx.buildId("title")
          }, [
            createTextVNode(toDisplayString(_ctx.title) + " ", 1),
            renderSlot(_ctx.$slots, "title-append", {}, void 0, true)
          ], 8, _hoisted_3$f)) : createCommentVNode("", true),
          createVNode(_component_QCardSection, {
            class: "fit q-pa-none relative-position",
            "data-automation": _ctx.buildId("content-wrapper")
          }, {
            default: withCtx(() => [
              _ctx.loading || _ctx.saving ? (openBlock(), createBlock(_component_SpinnerAbsolute, {
                key: 0,
                "data-automation": _ctx.buildId("spinner")
              }, null, 8, ["data-automation"])) : createCommentVNode("", true),
              createVNode(_component_ScrollArea, {
                class: "full-height",
                "data-automation": _ctx.buildId("scrollArea")
              }, {
                default: withCtx(() => [
                  createElementVNode("div", {
                    class: normalizeClass(["sidebar__content q-pb-md", { "disabled no-pointer-events": _ctx.saving || _ctx.loading }]),
                    "data-automation": _ctx.buildId("content")
                  }, [
                    !_ctx.loading ? renderSlot(_ctx.$slots, "default", { key: 0 }, void 0, true) : createCommentVNode("", true)
                  ], 10, _hoisted_4$a)
                ]),
                _: 3
              }, 8, ["data-automation"])
            ]),
            _: 3
          }, 8, ["data-automation"]),
          createVNode(_component_QSpace),
          withDirectives(createVNode(_component_QCardActions, { class: "row q-pa-none z-top" }, {
            default: withCtx(() => [
              createElementVNode("div", {
                class: normalizeClass(["sidebar__actions col-grow shadow-6 q-px-lg q-py-md", { "disabled no-pointer-events": _ctx.saving || _ctx.loading }]),
                "data-automation": _ctx.buildId("actions")
              }, [
                renderSlot(_ctx.$slots, "actions", {}, void 0, true)
              ], 10, _hoisted_5$8)
            ]),
            _: 3
          }, 512), [
            [vShow, _ctx.$slots.actions]
          ])
        ]),
        _: 3
      })), [
        [_directive_focus, _ctx.focusFirstInput],
        [_directive_hotkey, { "Enter": _ctx.onSubmit }]
      ])
    ]),
    _: 3
  }, 16, ["data-automation", "position", "onHide"]);
}
const Sidebar = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$n], ["__scopeId", "data-v-0fa2e0e9"]]);
const _sfc_main$u = defineComponent({
  name: "SidebarListClassSlugs",
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    /**
     * Shows class name or class id
     */
    showClassName: {
      type: Boolean,
      default: true
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      t: t2
    };
  }
});
const _hoisted_1$n = ["data-automation"];
const _hoisted_2$g = {
  key: 0,
  class: "sidebar-list-class-slugs__content"
};
const _hoisted_3$e = ["data-automation"];
const _hoisted_4$9 = { key: 0 };
const _hoisted_5$7 = {
  key: 1,
  class: "sidebar-list-class-slugs__content--separator q-mr-sm"
};
const _hoisted_6$5 = {
  key: 0,
  class: "sidebar-list-class-slugs__content--separator q-mr-sm"
};
const _hoisted_7$4 = {
  key: 1,
  class: "q-pb-md"
};
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "sidebar-list-class-slugs",
    "data-automation": _ctx.buildId()
  }, [
    _ctx.modelValue.length ? (openBlock(), createElementBlock("div", _hoisted_2$g, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.modelValue, (item, index) => {
        return openBlock(), createElementBlock("div", {
          key: item.id,
          class: "inline-block",
          "data-automation": _ctx.buildId(`item-${item.id}`)
        }, [
          _ctx.showClassName ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(item.name) + " ", 1),
            item.hasDifferentNames ? (openBlock(), createElementBlock("span", _hoisted_4$9, toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [item.id])), 1)) : createCommentVNode("", true),
            index < _ctx.modelValue.length - 1 ? (openBlock(), createElementBlock("span", _hoisted_5$7, toDisplayString(_ctx.t("rvai-base.general.symbols.comma")), 1)) : createCommentVNode("", true)
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode(toDisplayString(item.id) + " ", 1),
            index < _ctx.modelValue.length - 1 ? (openBlock(), createElementBlock("span", _hoisted_6$5, toDisplayString(_ctx.t("rvai-base.general.symbols.comma")), 1)) : createCommentVNode("", true)
          ], 64))
        ], 8, _hoisted_3$e);
      }), 128))
    ])) : (openBlock(), createElementBlock("div", _hoisted_7$4, toDisplayString(_ctx.t("rvai-base.general.common.none")), 1))
  ], 8, _hoisted_1$n);
}
const SidebarListClassSlugs = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["render", _sfc_render$m], ["__scopeId", "data-v-0bd0435b"]]);
const _sfc_main$t = defineComponent({
  name: "SidebarLoading",
  components: {
    QIcon: QIcon_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      t: t2
    };
  }
});
const _hoisted_1$m = ["data-automation"];
const _hoisted_2$f = { class: "bg-white absolute-full z-fab" };
const _hoisted_3$d = { class: "sidebar-loading__content relative-position flex items-center column text-grey-1" };
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  return openBlock(), createElementBlock("div", {
    class: "sidebar-loading",
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", _hoisted_2$f, [
      createElementVNode("div", _hoisted_3$d, [
        createVNode(_component_QIcon, {
          color: "grey-2",
          name: "mdi-alert-circle",
          size: "33px"
        }),
        createElementVNode("span", null, toDisplayString(_ctx.t("rvai-base.general.text.loading")), 1),
        createElementVNode("span", null, toDisplayString(_ctx.t("rvai-base.general.text.loadingExtra")), 1)
      ])
    ])
  ], 8, _hoisted_1$m);
}
const SidebarLoading = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["render", _sfc_render$l], ["__scopeId", "data-v-abc83384"]]);
const _sfc_main$s = defineComponent({
  name: "Slider",
  components: {
    EllipsisText,
    QIcon: QIcon_default,
    QSlider: QSlider_default,
    RvInput,
    Tooltip
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Focus field on initial component render
     */
    autofocus: {
      type: Boolean,
      default: false
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Debounce amount (in milliseconds) when updating model
     */
    debounce: {
      type: [String, Number],
      default: 200
    },
    /**
     * Put component in disabled mode
     */
    disable: {
      type: Boolean,
      default: false
    },
    /**
     * Accept float values when using with-input
     */
    float: {
      type: Boolean,
      default: false
    },
    /**
     * Render info icon with tooltip. Can be used as an "info-text" property or as a slot
     */
    infoText: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the info text
     */
    infoTextClass: {
      type: String,
      default: "rv-slider__info-text"
    },
    /**
     * Classes applied to the input
     * @type {[Array, Object, String]}
     */
    inputClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * How many numbers show after comma for float numbers
     * @type {number}
     */
    inputDecimals: {
      type: Number,
      default: void 0
    },
    /**
     * The text that will be shown above the input
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Classes applied to the label
     * @type {[Array, Object, String]}
     */
    labelClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Override default pin value
     * @type {[Array, Object, String]}
     */
    pinValue: {
      type: [String, Number],
      default: void 0
    },
    /**
     * Display markers on the track, one for each possible value for the model
     */
    markers: {
      type: Boolean,
      default: false
    },
    /**
     * Maximum value of the model; Set track's maximum value
     */
    max: {
      type: Number,
      default: 100
    },
    /**
     * Minimum value of the model; Set track's minimum value
     */
    min: {
      type: Number,
      default: 0
    },
    /**
     * Label to show instead of minimum value
     */
    minLabel: {
      type: String,
      default: ""
    },
    /**
     * Model of the component (must be between min/max); Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: Number,
      required: true
    },
    /**
     * The text that will be shown next to label
     */
    optionalLabel: {
      type: String,
      default: ""
    },
    /**
     * Text that appears in the form control when it has no value set
     */
    placeholder: {
      type: String,
      default: void 0
    },
    /**
     * Put component in readonly mode
     */
    readonly: {
      type: Boolean,
      default: false
    },
    /**
     * Shows min and max values around slider
     */
    showMinMax: {
      type: Boolean,
      default: true
    },
    /**
     * Show optional label next to label
     */
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    /**
     * Flag to show/hide pin on hover
     */
    showPin: {
      type: Boolean,
      default: true
    },
    /**
     * Classes applied to the slider
     * @type {[Array, Object, String]}
     */
    sliderClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Specify step amount between valid values (> 0.0); When step equals to 0 it defines infinite granularity
     */
    step: {
      type: Number,
      default: 1
    },
    /**
     * The text to be displayed at the end of max
     */
    suffix: {
      type: String,
      default: void 0
    },
    /**
     * Renders input next to slider
     */
    withInput: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when the component needs to change the model; Is also used by v-model
     *
     * @type {[string, number]}
     */
    "update:modelValue"
  ],
  setup(props4, { emit }) {
    const { t: t2 } = useI18n();
    const stringValue = ref$1("");
    function onBlur2() {
      let parsed = props4.inputDecimals && stringValue.value ? truncateNumber(parseFloat(stringValue.value), props4.inputDecimals) : roundToStep(Number(stringValue.value), props4.step);
      if (isNaN(parsed)) {
        stringValue.value = props4.modelValue.toString();
        return;
      }
      if (parsed < props4.min) parsed = props4.min;
      if (parsed > props4.max) parsed = props4.max;
      parsed = props4.float ? parsed : ~~parsed;
      if (stringValue.value !== parsed.toString()) {
        stringValue.value = parsed.toString();
      }
      emit("update:modelValue", parsed);
    }
    function onSliderValueChange(event) {
      emit("update:modelValue", event);
    }
    watch(() => props4.modelValue, (value2) => {
      stringValue.value = String(value2);
    }, { immediate: true });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      onBlur: onBlur2,
      onSliderValueChange: props4.debounce ? debounce_default(onSliderValueChange, Number(props4.debounce)) : onSliderValueChange,
      stringValue,
      t: t2
    };
  }
});
const _hoisted_1$l = ["data-automation"];
const _hoisted_2$e = ["data-automation"];
const _hoisted_3$c = { class: "row no-wrap items-center full-width" };
const _hoisted_4$8 = {
  key: 0,
  class: "q-ml-xs"
};
const _hoisted_5$6 = { class: "flex justify-between full-width" };
const _hoisted_6$4 = {
  key: 0,
  class: "rv-slider__input-wrapper flex items-center justify-between"
};
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QSlider = resolveComponent("QSlider");
  const _component_RvInput = resolveComponent("RvInput");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: ["rv-slider", [
      _ctx.$props.class,
      {
        "rv-slider--disabled": _ctx.disable || _ctx.readonly,
        "rv-slider--with-input": _ctx.withInput
      }
    ]],
    "data-automation": _ctx.buildId()
  }), [
    _ctx.label ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["rv-slider__label flex justify-between items-center", _ctx.labelClass]),
      "data-automation": _ctx.buildId("label-container")
    }, [
      createElementVNode("span", _hoisted_3$c, [
        createVNode(_component_EllipsisText, {
          class: "text-subtitle3",
          "data-automation": _ctx.buildId("label"),
          text: _ctx.label
        }, null, 8, ["data-automation", "text"]),
        _ctx.showOptionalLabel ? (openBlock(), createElementBlock("div", _hoisted_4$8, toDisplayString(_ctx.optionalLabel || _ctx.t("rvai-base.general.inputs.optional")), 1)) : createCommentVNode("", true),
        _ctx.infoText || _ctx.$slots["infoText"] ? (openBlock(), createBlock(_component_QIcon, {
          key: 1,
          class: "q-ml-xs info-icon",
          color: "black-1",
          "data-automation": _ctx.buildId("icon-info"),
          name: "info",
          size: "16px"
        }, {
          default: withCtx(() => [
            createVNode(_component_Tooltip, {
              anchor: "top middle",
              class: normalizeClass(_ctx.infoTextClass),
              self: "bottom middle"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "infoText", {}, () => [
                  createTextVNode(toDisplayString(_ctx.infoText), 1)
                ], true)
              ]),
              _: 3
            }, 8, ["class"])
          ]),
          _: 3
        }, 8, ["data-automation"])) : createCommentVNode("", true)
      ]),
      renderSlot(_ctx.$slots, "label-append", {}, void 0, true)
    ], 10, _hoisted_2$e)) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_5$6, [
      createElementVNode("div", {
        class: normalizeClass(["rv-slider__slider-wrapper row items-center no-wrap", { "q-pr-md": _ctx.withInput }])
      }, [
        _ctx.showMinMax ? (openBlock(), createBlock(_component_EllipsisText, {
          key: 0,
          class: "rv-slider__limit q-mr-md col-fixed text-grey-1",
          "data-automation": _ctx.buildId("limit-min")
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.minLabel || _ctx.min), 1)
          ]),
          _: 1
        }, 8, ["data-automation"])) : createCommentVNode("", true),
        createVNode(_component_QSlider, {
          class: normalizeClass(["rv-slider__slider", _ctx.sliderClass]),
          "data-automation": _ctx.buildId("slider"),
          disable: _ctx.disable,
          label: _ctx.showPin,
          "label-value": _ctx.pinValue,
          markers: _ctx.markers,
          max: _ctx.max,
          min: _ctx.min,
          "model-value": _ctx.modelValue,
          readonly: _ctx.readonly,
          step: _ctx.step,
          "onUpdate:modelValue": _ctx.onSliderValueChange
        }, null, 8, ["class", "data-automation", "disable", "label", "label-value", "markers", "max", "min", "model-value", "readonly", "step", "onUpdate:modelValue"]),
        _ctx.showMinMax ? (openBlock(), createBlock(_component_EllipsisText, {
          key: 1,
          class: normalizeClass(["rv-slider__limit q-ml-md col-fixed text-grey-1", { "rv-slider__limit--suffix": _ctx.suffix }]),
          "data-automation": _ctx.buildId("limit-max")
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(_ctx.max) + " " + toDisplayString(_ctx.suffix), 1)
          ]),
          _: 1
        }, 8, ["class", "data-automation"])) : createCommentVNode("", true)
      ], 2),
      _ctx.withInput ? (openBlock(), createElementBlock("div", _hoisted_6$4, [
        createVNode(_component_RvInput, {
          modelValue: _ctx.stringValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.stringValue = $event),
          autofocus: _ctx.autofocus,
          class: "rv-slider__input",
          "data-automation": _ctx.buildId("input"),
          debounce: _ctx.debounce,
          disable: _ctx.disable,
          "input-class": _ctx.inputClass,
          "item-aligned": "center",
          placeholder: _ctx.placeholder,
          readonly: _ctx.readonly,
          "show-error": false,
          "show-error-message": false,
          "show-valid": false,
          suffix: _ctx.suffix,
          onBlur: _ctx.onBlur,
          onKeyup: _cache[1] || (_cache[1] = withKeys(($event) => $event.target.blur(), ["enter"]))
        }, null, 8, ["modelValue", "autofocus", "data-automation", "debounce", "disable", "input-class", "placeholder", "readonly", "suffix", "onBlur"])
      ])) : createCommentVNode("", true)
    ])
  ], 16, _hoisted_1$l);
}
const Slider = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$k], ["__scopeId", "data-v-30eb7b5a"]]);
const _sfc_main$r = defineComponent({
  name: "SortSelect",
  components: {
    QIcon: QIcon_default,
    QItem: QItem_default,
    QItemLabel: QItemLabel_default,
    QItemSection: QItemSection_default,
    RvSelect
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "sortSelect"
    },
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: Object,
      default: null
    },
    /**
     * Available sort options that the user can select from. For best performance freeze the list of options.
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Shows label before select
     */
    showLabelBefore: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue"],
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$k = ["data-automation"];
const _hoisted_2$d = ["data-automation"];
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QItemSection = resolveComponent("QItemSection");
  const _component_QItem = resolveComponent("QItem");
  const _component_RvSelect = resolveComponent("RvSelect");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["rv-sort-select", _ctx.$props.class]),
    "data-automation": _ctx.buildId()
  }, [
    _ctx.showLabelBefore ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "text-subtitle3 flex flex-center q-mr-sm",
      "data-automation": _ctx.buildId("label")
    }, toDisplayString(_ctx.$t("rvai-base.general.table.sortBy")), 9, _hoisted_2$d)) : createCommentVNode("", true),
    createVNode(_component_RvSelect, {
      class: "rv-sort-select__select",
      "data-automation": _ctx.buildId("select"),
      dense: "",
      "model-value": _ctx.modelValue,
      options: _ctx.options,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
    }, {
      prepend: withCtx(() => [
        createVNode(_component_QIcon, {
          color: "grey-1",
          name: "rvai-base:sort-asc",
          size: "sm"
        })
      ]),
      option: withCtx((scope) => [
        createVNode(_component_QItem, mergeProps(scope.itemProps, {
          "data-automation": _ctx.buildId(`option-${scope.label}`)
        }), {
          default: withCtx(() => [
            createVNode(_component_QItemSection, { class: "rv-sort-select__item-section" }, {
              default: withCtx(() => [
                createVNode(_component_QItemLabel, null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(scope.label), 1)
                  ]),
                  _: 2
                }, 1024),
                _ctx.modelValue && _ctx.modelValue.label === scope.label ? (openBlock(), createBlock(_component_QIcon, {
                  key: 0,
                  color: "grey-1",
                  name: "mdi-check",
                  size: "18px"
                })) : createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040, ["data-automation"])
      ]),
      _: 1
    }, 8, ["data-automation", "model-value", "options"])
  ], 10, _hoisted_1$k);
}
const SortSelect = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$j], ["__scopeId", "data-v-8c252cdf"]]);
const _sfc_main$q = defineComponent({
  name: "Spinner",
  components: {
    QCircularProgress: QCircularProgress_default
  },
  props: {
    /**
     * Classes applied to component
     * @type {[Array, Object, String]}
     */
    class: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: "spinner"
    },
    /**
     * Spinner size
     */
    size: {
      type: String,
      default: "20px"
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QCircularProgress = resolveComponent("QCircularProgress");
  return openBlock(), createBlock(_component_QCircularProgress, {
    class: normalizeClass(_ctx.$props.class),
    color: "primary",
    "data-automation": _ctx.dataAutomation,
    indeterminate: "",
    rounded: "",
    size: _ctx.size,
    thickness: 0.3,
    "track-color": "grey-3"
  }, null, 8, ["class", "data-automation", "size"]);
}
const Spinner = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$i]]);
const _sfc_main$p = defineComponent({
  name: "StatusPanel",
  components: {
    CircularProgress,
    QIcon: QIcon_default
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Text displayed in title
     */
    color: {
      type: String,
      default: "primary"
    },
    /**
     * Set 'full-width' class to the component
     */
    fullWidth: {
      type: Boolean,
      default: false
    },
    /**
     * Text displayed in title
     */
    icon: {
      type: String,
      default: ""
    },
    /**
     * Text displayed in title
     */
    iconColor: {
      type: String,
      default: "positive"
    },
    /**
     * Minimum value defining 'no progress' (must be lower than 'max')
     */
    max: {
      type: [Number, String],
      default: 100
    },
    /**
     * Minimum value defining 'no progress' (must be lower than 'max')
     */
    min: {
      type: [Number, String],
      default: 0
    },
    /**
     * Text displayed in title
     */
    title: {
      type: String,
      default: () => useI18n().t("rvai-base.general.text.status")
    },
    /**
     * Text displayed in title
     */
    text: {
      type: String,
      default: ""
    },
    /**
     * Current progress (must be between min/max)
     */
    value: {
      type: [Number, String],
      required: true
    }
  },
  setup(props4) {
    return {
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$j = ["data-automation"];
const _hoisted_2$c = { class: "row no-wrap items-center full-width" };
const _hoisted_3$b = ["data-automation"];
const _hoisted_4$7 = ["data-automation"];
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QIcon = resolveComponent("QIcon");
  const _component_CircularProgress = resolveComponent("CircularProgress");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["status-panel column no-wrap items-center rounded-borders bg-grey-5 q-py-sm q-px-md", { "full-width": _ctx.fullWidth }]),
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", _hoisted_2$c, [
      createElementVNode("span", {
        class: "text-subtitle3",
        "data-automation": _ctx.buildId("title-text")
      }, toDisplayString(_ctx.title), 9, _hoisted_3$b),
      _ctx.icon ? (openBlock(), createBlock(_component_QIcon, {
        key: 0,
        class: "q-ml-xs",
        color: _ctx.iconColor,
        "data-automation": _ctx.buildId("title-icon"),
        name: _ctx.icon,
        size: "xs"
      }, null, 8, ["color", "data-automation", "name"])) : createCommentVNode("", true)
    ]),
    createVNode(_component_CircularProgress, {
      class: "q-mt-sm q-mb-xs",
      color: _ctx.color,
      "data-automation": _ctx.buildId("progress"),
      max: Number(_ctx.max),
      min: Number(_ctx.min),
      "show-value": "",
      size: "80px",
      "track-color": "grey-3",
      value: Number(_ctx.value)
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]),
      _: 3
    }, 8, ["color", "data-automation", "max", "min", "value"]),
    _ctx.text ? (openBlock(), createElementBlock("span", {
      key: 0,
      class: "text-small",
      "data-automation": _ctx.buildId("text")
    }, toDisplayString(_ctx.text), 9, _hoisted_4$7)) : createCommentVNode("", true)
  ], 10, _hoisted_1$j);
}
const StatusPanel = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$h], ["__scopeId", "data-v-742b1eda"]]);
const _sfc_main$o = defineComponent({
  name: "SuspenseWithError",
  components: {
    QImg: QImg_default,
    QInnerLoading: QInnerLoading_default
  },
  setup() {
    const error = ref$1(false);
    onErrorCaptured((e2) => {
      error.value = true;
      console.error(e2);
    });
    return {
      error
    };
  }
});
const _hoisted_1$i = {
  key: 1,
  class: "q-pa-md fit column flex-center"
};
const _hoisted_2$b = { class: "text-subtitle3" };
const _hoisted_3$a = { class: "q-mt-sm text-body3" };
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QInnerLoading = resolveComponent("QInnerLoading");
  const _component_QImg = resolveComponent("QImg");
  return !_ctx.error ? (openBlock(), createBlock(Suspense, { key: 0 }, {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    fallback: withCtx(() => [
      createVNode(_component_QInnerLoading, {
        color: "primary",
        showing: true
      })
    ]),
    _: 3
  })) : (openBlock(), createElementBlock("div", _hoisted_1$i, [
    createVNode(_component_QImg, {
      class: "icon",
      src: "rvai-base/not-found.svg",
      width: "75%"
    }),
    createElementVNode("div", _hoisted_2$b, toDisplayString(_ctx.$t("rvai-base.general.errors.title")), 1),
    createElementVNode("div", _hoisted_3$a, toDisplayString(_ctx.$t("rvai-base.general.errors.description")), 1)
  ]));
}
const SuspenseWithError = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$g]]);
const _sfc_main$n = defineComponent({
  name: "StepSidebar",
  components: {
    Logo: _sfc_main$P,
    QCard: QCard_default,
    QCardSection: QCardSection_default,
    QDialog: QDialog_default,
    QIcon: QIcon_default,
    RvButton: Button,
    SuspenseWithError
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    customBackEvent: {
      type: Boolean,
      default: false
    },
    disableCloseBtn: {
      type: Boolean,
      default: false
    },
    hideBackBtn: {
      type: Boolean,
      default: false
    },
    hideCloseBtn: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: "left"
    }
  },
  emits: ["on-back"],
  setup(props4, { emit }) {
    const { logoAlignClasses } = useLogo();
    const {
      dialogRef,
      onDialogCancel,
      onDialogHide,
      onDialogOK
    } = useDialogPluginComponent();
    const {
      isCurrentStep,
      isDefaultStep,
      onBack,
      showBackButton,
      stack: stack2
    } = useStepSidebar();
    function onBackClick() {
      if (props4.customBackEvent) {
        emit("on-back");
      } else {
        onBack();
      }
    }
    function hide() {
      var _a;
      (_a = dialogRef.value) == null ? void 0 : _a.hide();
    }
    function show() {
      var _a;
      (_a = dialogRef.value) == null ? void 0 : _a.show();
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      dialogRef,
      hide,
      isCurrentStep,
      isDefaultStep,
      logoAlignClasses,
      onBackClick,
      onDialogCancel,
      onDialogHide,
      onDialogOK,
      show,
      showBackButton,
      stack: stack2
    };
  }
});
const _hoisted_1$h = { class: "sidebar__back" };
const _hoisted_2$a = { class: "sidebar__cancel" };
const _hoisted_3$9 = ["data-automation"];
const _hoisted_4$6 = ["data-automation"];
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvButton = resolveComponent("RvButton");
  const _component_Logo = resolveComponent("Logo");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_SuspenseWithError = resolveComponent("SuspenseWithError");
  const _component_QCard = resolveComponent("QCard");
  const _component_QDialog = resolveComponent("QDialog");
  return openBlock(), createBlock(_component_QDialog, mergeProps({ ref: "dialogRef" }, _ctx.$attrs, {
    "data-automation": _ctx.buildId(),
    maximized: "",
    "no-backdrop-dismiss": "",
    position: _ctx.position
  }), {
    default: withCtx(() => [
      createVNode(_component_QCard, { class: "sidebar column no-wrap" }, {
        default: withCtx(() => [
          createVNode(_component_QCardSection, {
            class: "sidebar__header row no-wrap items-center q-pa-md q-pt-md q-pb-lg",
            "data-automation": _ctx.buildId("header")
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1$h, [
                !_ctx.hideBackBtn && _ctx.showBackButton ? (openBlock(), createBlock(_component_RvButton, {
                  key: 0,
                  class: "no-padding",
                  color: "black-1",
                  "data-automation": _ctx.buildId("back"),
                  icon: "mdi-chevron-left",
                  tertiary: "",
                  onClick: _ctx.onBackClick
                }, null, 8, ["data-automation", "onClick"])) : createCommentVNode("", true)
              ]),
              createElementVNode("div", {
                class: normalizeClass(["sidebar__logo-wrapper", _ctx.logoAlignClasses])
              }, [
                createVNode(_component_Logo, {
                  class: "sidebar__logo",
                  "data-automation": _ctx.buildId("logo")
                }, null, 8, ["data-automation"])
              ], 2),
              createElementVNode("div", _hoisted_2$a, [
                !_ctx.hideCloseBtn ? (openBlock(), createBlock(_component_RvButton, {
                  key: 0,
                  class: "no-padding",
                  color: "black-1",
                  "data-automation": _ctx.buildId("cancel"),
                  disable: _ctx.disableCloseBtn,
                  icon: "mdi-close",
                  tertiary: "",
                  onClick: _ctx.onDialogCancel
                }, null, 8, ["data-automation", "disable", "onClick"])) : createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["data-automation"]),
          withDirectives(createElementVNode("div", {
            class: "column no-wrap full-height",
            "data-automation": _ctx.buildId("content")
          }, [
            createVNode(_component_SuspenseWithError, null, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default", {}, void 0, true)
              ]),
              _: 3
            })
          ], 8, _hoisted_3$9), [
            [vShow, _ctx.isDefaultStep]
          ]),
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.stack, (step, index) => {
            return withDirectives((openBlock(), createElementBlock("div", {
              key: index,
              class: "column no-wrap full-height",
              "data-automation": _ctx.buildId(`stack-${step.stepName ?? index}`)
            }, [
              createVNode(_component_SuspenseWithError, null, {
                default: withCtx(() => [
                  (openBlock(), createBlock(resolveDynamicComponent(step.component), mergeProps({ ref_for: true }, step.componentProps), null, 16))
                ]),
                _: 2
              }, 1024)
            ], 8, _hoisted_4$6)), [
              [vShow, _ctx.isCurrentStep(step)]
            ]);
          }), 128))
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 16, ["data-automation", "position"]);
}
const StepSidebar = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$f], ["__scopeId", "data-v-52f17e3a"]]);
const _sfc_main$m = defineComponent({
  name: "StepSidebarContent",
  components: {
    QCardActions: QCardActions_default,
    QCardSection: QCardSection_default,
    QSpace: QSpace_default,
    ScrollArea,
    SidebarLoading,
    SpinnerAbsolute
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    contentClass: {
      type: [Array, Object, String],
      default: void 0
    },
    /**
     * Focus field on initial component render
     */
    focusFirstInput: {
      type: Boolean,
      default: true
    },
    headerClass: {
      type: [Array, Object, String],
      default: void 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingExtended: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    step: {
      type: Object,
      default: void 0
    },
    title: {
      type: String,
      default: ""
    }
  },
  emits: ["on-submit"],
  setup(props4, { emit }) {
    function onSubmit() {
      emit("on-submit");
    }
    return {
      onSubmit,
      ...useAutomation(computed(() => props4.dataAutomation))
    };
  }
});
const _hoisted_1$g = ["data-automation"];
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SpinnerAbsolute = resolveComponent("SpinnerAbsolute");
  const _component_SidebarLoading = resolveComponent("SidebarLoading");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_QCardActions = resolveComponent("QCardActions");
  const _directive_focus = resolveDirective("focus");
  const _directive_hotkey = resolveDirective("hotkey");
  return openBlock(), createElementBlock(Fragment, null, [
    renderSlot(_ctx.$slots, "title", {}, () => [
      _ctx.title || _ctx.$slots["append-title"] ? (openBlock(), createElementBlock("div", mergeProps({ key: 0 }, _ctx.dataAttrs, {
        class: ["sidebar__title row items-center justify-between text-subtitle1 q-px-lg q-pb-md", _ctx.headerClass],
        "data-automation": _ctx.buildId()
      }), [
        createTextVNode(toDisplayString(_ctx.title) + " ", 1),
        renderSlot(_ctx.$slots, "append-title", {}, void 0, true)
      ], 16, _hoisted_1$g)) : createCommentVNode("", true)
    ], true),
    withDirectives((openBlock(), createBlock(_component_QCardSection, {
      class: "fit q-pa-none relative-position",
      "data-automation": _ctx.buildId("content")
    }, {
      default: withCtx(() => [
        _ctx.saving || _ctx.loading ? (openBlock(), createBlock(_component_SpinnerAbsolute, {
          key: 0,
          "data-automation": _ctx.buildId("loading")
        }, null, 8, ["data-automation"])) : createCommentVNode("", true),
        _ctx.loadingExtended ? (openBlock(), createBlock(_component_SidebarLoading, {
          key: 1,
          "data-automation": _ctx.buildId("loading-extended")
        }, null, 8, ["data-automation"])) : createCommentVNode("", true),
        createVNode(_component_ScrollArea, {
          class: "full-height",
          "data-automation": _ctx.buildId("scrollArea")
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(["sidebar__content q-pb-md", [
                _ctx.contentClass,
                { "disabled no-pointer-events": _ctx.saving || _ctx.loading || _ctx.loadingExtended }
              ]])
            }, [
              !_ctx.loading ? renderSlot(_ctx.$slots, "default", { key: 0 }, void 0, true) : createCommentVNode("", true)
            ], 2)
          ]),
          _: 3
        }, 8, ["data-automation"])
      ]),
      _: 3
    }, 8, ["data-automation"])), [
      [_directive_focus, _ctx.focusFirstInput],
      [_directive_hotkey, { "Enter": _ctx.onSubmit }]
    ]),
    createVNode(_component_QSpace),
    _ctx.$slots["actions"] ? (openBlock(), createBlock(_component_QCardActions, {
      key: 0,
      class: "row q-pa-none z-top",
      "data-automation": _ctx.buildId("actions")
    }, {
      default: withCtx(() => [
        createElementVNode("div", {
          class: normalizeClass(["sidebar__actions col-grow shadow-6 q-px-lg q-py-md", { "disabled no-pointer-events": _ctx.saving || _ctx.loading }])
        }, [
          renderSlot(_ctx.$slots, "actions", {}, void 0, true)
        ], 2)
      ]),
      _: 3
    }, 8, ["data-automation"])) : createCommentVNode("", true)
  ], 64);
}
const StepSidebarContent = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$e], ["__scopeId", "data-v-74414917"]]);
const _sfc_main$l = defineComponent({
  name: "TableCard",
  components: {
    QCard: QCard_default,
    QCardSection: QCardSection_default,
    QMenu: QMenu_default,
    RvButton: Button
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    clickableCard: {
      type: Boolean,
      default: false
    },
    cols: {
      type: Array,
      required: true
    },
    customActions: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      required: true
    },
    selecting: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "menuChange"
  ],
  setup(props4, { emit }) {
    const menuOpen = ref$1(false);
    function onMenuChange(open2) {
      emit("menuChange", open2, props4.row);
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      menuOpen,
      onMenuChange
    };
  }
});
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QCardSection = resolveComponent("QCardSection");
  const _component_RvButton = resolveComponent("RvButton");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_QCard = resolveComponent("QCard");
  return openBlock(), createBlock(_component_QCard, mergeProps(_ctx.$attrs, {
    class: ["rv-table-card", {
      "rv-table-card--clickable": _ctx.clickableCard
    }],
    "data-automation": _ctx.buildId()
  }), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "cardHeader", {}, void 0, true),
      _ctx.selecting || _ctx.$slots.cardTitle ? (openBlock(), createBlock(_component_QCardSection, {
        key: 0,
        class: "rv-table-card__title row no-wrap items-start q-pb-none"
      }, {
        default: withCtx(() => [
          _ctx.selecting ? renderSlot(_ctx.$slots, "select", { key: 0 }, void 0, true) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "cardTitle", {}, void 0, true)
        ]),
        _: 3
      })) : createCommentVNode("", true),
      _ctx.$slots["actions"] ? (openBlock(), createElementBlock("div", {
        key: 1,
        class: "rv-table-card__actions cursor-pointer",
        onClick: _cache[1] || (_cache[1] = withModifiers(() => {
        }, ["stop"]))
      }, [
        _ctx.customActions ? renderSlot(_ctx.$slots, "actions", normalizeProps(mergeProps({ key: 0 }, _ctx.row || {})), void 0, true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createVNode(_component_RvButton, {
            class: "no-padding",
            color: "grey-1",
            "data-automation": _ctx.buildId("dots"),
            icon: "mdi-dots-horizontal",
            tertiary: ""
          }, null, 8, ["data-automation"]),
          createVNode(_component_QMenu, {
            modelValue: _ctx.menuOpen,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event) => _ctx.menuOpen = $event),
              _ctx.onMenuChange
            ],
            "auto-close": ""
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "actions", {}, void 0, true)
            ]),
            _: 3
          }, 8, ["modelValue", "onUpdate:modelValue"])
        ], 64))
      ])) : createCommentVNode("", true),
      createVNode(_component_QCardSection, null, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "cardContent", {}, void 0, true)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 16, ["class", "data-automation"]);
}
const TableCard = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$d], ["__scopeId", "data-v-ad942b1e"]]);
const _sfc_main$k = defineComponent({
  name: "TablePagination",
  components: {
    ActionButton,
    RvInput,
    RvSelect
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Show elements on the center
     */
    centered: {
      default: false,
      type: Boolean
    },
    /**
     * Hide dropdown to set items per page
     */
    hidePageSizeSelection: {
      default: false,
      type: Boolean
    },
    rowsPerPageOptions: {
      type: Array,
      default: () => [10, 20, 50, 100, 0]
    },
    /**
     * Show with space between table and pagination block§
     */
    separated: {
      default: false,
      type: Boolean
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    const {
      pagination,
      tableRef
    } = useTable();
    const newPage = ref$1("");
    const inputRef = ref$1();
    const computedRowsPerPageOptions = computed(() => {
      return props4.rowsPerPageOptions.map((count) => ({
        label: count === 0 ? "All" : String(count),
        // TODO i18n
        value: count
      }));
    });
    const disableRowsPerPage = computed(() => {
      const min2 = Math.min(...props4.rowsPerPageOptions.filter((c2) => !!c2));
      return (pagination.value.rowsNumber ?? 0) < min2;
    });
    const page = computed(() => pagination.value.page ?? 1);
    const rowsPerPage = computed({
      get() {
        return pagination.value.rowsPerPage ?? 0;
      },
      set(rowsPerPage2) {
        setPagination({ rowsPerPage: rowsPerPage2 });
      }
    });
    const totalPages = computed(() => {
      const rowsNumber = pagination.value.rowsNumber ?? 0;
      const rowsPerPage2 = pagination.value.rowsPerPage ?? 0;
      const pages = rowsPerPage2 ? Math.ceil(rowsNumber / rowsPerPage2) : 1;
      return Math.max(pages, 1);
    });
    function firstPage() {
      setPagination({ page: 1 });
    }
    function lastPage() {
      setPagination({ page: totalPages.value });
    }
    function nextPage() {
      if (page.value >= totalPages.value) return;
      setPagination({ page: page.value + 1 });
    }
    function previousPage() {
      if (page.value <= 1) return;
      setPagination({ page: page.value - 1 });
    }
    function setPagination(update6) {
      var _a;
      const paginationObject = {
        ...pagination.value,
        ...update6
      };
      (_a = tableRef.value) == null ? void 0 : _a.requestServerInteraction({
        pagination: {
          ...paginationObject,
          sortBy: paginationObject.sortBy ?? void 0
        }
      });
    }
    async function onBlur2() {
      let value2 = parseInt(newPage.value, 10);
      newPage.value = "";
      if (isNaN(value2) || value2 === page.value) return;
      value2 = Math.max(1, Math.min(totalPages.value, value2));
      setPagination({ page: value2 });
    }
    function onEnter() {
      var _a;
      (_a = inputRef.value) == null ? void 0 : _a.blur();
    }
    function onKeyPress(e2) {
      if (!/\d/g.test(e2.key)) e2.preventDefault();
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      computedRowsPerPageOptions,
      disableRowsPerPage,
      firstPage,
      inputRef,
      lastPage,
      newPage,
      nextPage,
      onBlur: onBlur2,
      onEnter,
      onKeyPress,
      page,
      previousPage,
      rowsPerPage,
      t: t2,
      totalPages
    };
  }
});
const _hoisted_1$f = ["data-automation"];
const _hoisted_2$9 = ["data-automation"];
const _hoisted_3$8 = ["data-automation"];
const _hoisted_4$5 = { class: "row items-center" };
const _hoisted_5$5 = { class: "text-body3 text-grey-1 block q-mr-md" };
const _hoisted_6$3 = {
  key: 1,
  class: "row items-center no-wrap q-ml-sm"
};
const _hoisted_7$3 = { class: "text-subtitle3 text-grey-1" };
const _hoisted_8$2 = ["data-automation"];
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvSelect = resolveComponent("RvSelect");
  const _component_ActionButton = resolveComponent("ActionButton");
  const _component_RvInput = resolveComponent("RvInput");
  return openBlock(), createElementBlock("div", {
    class: "column full-width",
    "data-automation": _ctx.buildId("wrapper")
  }, [
    _ctx.separated ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "full-width q-py-sm bg-grey-5",
      "data-automation": _ctx.buildId("separation")
    }, null, 8, _hoisted_2$9)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: normalizeClass(["table-pagination row full-width bg-white", {
        "justify-center": _ctx.centered,
        "q-py-sm": _ctx.separated
      }]),
      "data-automation": _ctx.buildId()
    }, [
      createElementVNode("div", _hoisted_4$5, [
        !_ctx.hidePageSizeSelection ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createElementVNode("span", _hoisted_5$5, toDisplayString(_ctx.t("rvai-base.general.table.recordPerPage")), 1),
          createVNode(_component_RvSelect, {
            modelValue: _ctx.rowsPerPage,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.rowsPerPage = $event),
            "data-automation": _ctx.buildId("rowsPerPage"),
            dense: "",
            disable: _ctx.disableRowsPerPage,
            "emit-value": "",
            "map-options": "",
            options: _ctx.computedRowsPerPageOptions,
            "options-dense": ""
          }, null, 8, ["modelValue", "data-automation", "disable", "options"])
        ], 64)) : createCommentVNode("", true),
        _ctx.rowsPerPage !== 0 ? (openBlock(), createElementBlock("div", _hoisted_6$3, [
          createVNode(_component_ActionButton, {
            class: "text-grey-1",
            "data-automation": _ctx.buildId("firstPage"),
            disable: _ctx.page === 1,
            icon: "mdi-chevron-double-left",
            size: "md",
            tertiary: "",
            onClick: _ctx.firstPage
          }, null, 8, ["data-automation", "disable", "onClick"]),
          createVNode(_component_ActionButton, {
            class: "text-grey-1",
            "data-automation": _ctx.buildId("previousPage"),
            disable: _ctx.page === 1,
            icon: "mdi-chevron-left",
            size: "md",
            tertiary: "",
            onClick: _ctx.previousPage
          }, null, 8, ["data-automation", "disable", "onClick"]),
          createVNode(_component_RvInput, {
            ref: "inputRef",
            modelValue: _ctx.newPage,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.newPage = $event),
            class: "table-pagination__input q-mx-sm",
            "data-automation": _ctx.buildId("currentPage"),
            disable: _ctx.totalPages <= 1,
            "input-class": "text-center",
            placeholder: String(_ctx.page),
            type: "number",
            onBlur: _ctx.onBlur,
            onKeypress: _ctx.onKeyPress,
            onKeyup: withKeys(_ctx.onEnter, ["enter"])
          }, null, 8, ["modelValue", "data-automation", "disable", "placeholder", "onBlur", "onKeypress", "onKeyup"]),
          createElementVNode("span", _hoisted_7$3, [
            createTextVNode(toDisplayString(_ctx.t("rvai-base.general.symbols.slash")) + " ", 1),
            createElementVNode("span", {
              "data-automation": _ctx.buildId("totalPage")
            }, toDisplayString(_ctx.totalPages), 9, _hoisted_8$2)
          ]),
          createVNode(_component_ActionButton, {
            class: "text-grey-1 q-ml-sm",
            "data-automation": _ctx.buildId("nextPage"),
            disable: _ctx.page === _ctx.totalPages,
            icon: "mdi-chevron-right",
            size: "md",
            tertiary: "",
            onClick: _ctx.nextPage
          }, null, 8, ["data-automation", "disable", "onClick"]),
          createVNode(_component_ActionButton, {
            class: "text-grey-1",
            "data-automation": _ctx.buildId("lastPage"),
            disable: _ctx.page === _ctx.totalPages,
            icon: "mdi-chevron-double-right",
            size: "md",
            tertiary: "",
            onClick: _ctx.lastPage
          }, null, 8, ["data-automation", "disable", "onClick"])
        ])) : createCommentVNode("", true)
      ])
    ], 10, _hoisted_3$8)
  ], 8, _hoisted_1$f);
}
const TablePagination = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$c], ["__scopeId", "data-v-c06b1b4e"]]);
const _sfc_main$j = defineComponent({
  name: "TableSortBy",
  components: {
    SortSelect
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    const {
      pagination,
      selectedItem,
      sortableItems,
      tableRef
    } = useTable();
    if (pagination.value.sortBy) {
      selectedItem.value = sortableItems.value.find((i2) => i2.name === pagination.value.sortBy && pagination.value.descending === i2.descending);
    } else {
      selectedItem.value = null;
    }
    watch(selectedItem, (item) => {
      var _a;
      if (!item) return;
      (_a = tableRef.value) == null ? void 0 : _a.requestServerInteraction({
        pagination: {
          ...pagination.value,
          descending: item.descending,
          sortBy: item.name
        }
      });
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      selectedItem,
      sortableItems,
      t: t2
    };
  }
});
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SortSelect = resolveComponent("SortSelect");
  return openBlock(), createBlock(_component_SortSelect, {
    modelValue: _ctx.selectedItem,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.selectedItem = $event),
    class: "rv-table-sort-by row",
    "data-automation": _ctx.buildId(),
    options: _ctx.sortableItems
  }, null, 8, ["modelValue", "data-automation", "options"]);
}
const TableSortBy = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$b], ["__scopeId", "data-v-d84e3eb6"]]);
const SLOTS_COLUMNS = {
  "row-actions": {
    label: "",
    name: "actions"
  }
};
const _sfc_main$i = defineComponent({
  name: "RvTable",
  components: {
    ActionButton,
    Checkbox,
    NoData,
    QIcon: QIcon_default,
    QMenu: QMenu_default,
    QResizeObserver: QResizeObserver_default,
    QSpace: QSpace_default,
    QTable: QTable_default,
    QTd: QTd_default,
    QTh: QTh_default,
    QTr: QTr_default,
    RvButton: Button,
    RvInput,
    TableCard,
    TablePagination,
    TableSortBy,
    Tooltip
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    bottomPaginationCentered: {
      type: Boolean,
      default: false
    },
    bottomPaginationSeparated: {
      type: Boolean,
      default: false
    },
    clickableCard: {
      type: Boolean,
      default: false
    },
    defaultGrid: {
      type: Boolean,
      default: false
    },
    fakeSelection: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    gridClass: {
      type: Function,
      default: () => String
    },
    gridResponsive: {
      type: Boolean,
      default: true
    },
    hideGridButton: {
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    getRowActionsVisibility: {
      type: Function,
      default: () => RowActionsVisibility.HiddenUntilHover
    },
    hideListButton: {
      type: Boolean,
      default: false
    },
    hidePagination: {
      type: Boolean,
      default: true
    },
    hideRightSidebar: {
      type: Boolean,
      default: true
    },
    hidePageSizeSelection: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      required: true
    },
    noPersistConfig: {
      type: Boolean,
      default: false
    },
    rowsPerPageOptions: {
      type: Array,
      default: void 0
    },
    selected: {
      type: Array,
      default: () => void 0
    },
    selectable: {
      type: Boolean,
      default: true
    },
    selectedTitle: {
      type: String,
      default: ""
    },
    selection: {
      type: String,
      default: "multiple"
    },
    showSelectCount: {
      type: Boolean,
      default: false
    },
    showSortBy: {
      type: Boolean,
      default: false
    },
    showTopPagination: {
      type: Boolean,
      default: false
    },
    virtualScroll: {
      type: Boolean,
      default: true
    },
    withFilters: {
      type: Boolean,
      default: true
    },
    customActions: {
      type: Boolean,
      default: false
    },
    wrapperClass: {
      type: [Array, String, Object],
      default: void 0
    }
  },
  emits: [
    "card-click",
    "menuChange",
    "on-toggle-all",
    "set-columns",
    "set-grid",
    "update:selected"
  ],
  setup(props4, {
    emit,
    slots
  }) {
    const { t: t2 } = useI18n();
    const {
      allSelected,
      allSelectedValue,
      clearSelection: clearSelection2,
      columns,
      colWidth,
      disableNextButton,
      disablePreviousButton,
      enableSelection,
      filteredSelected,
      filters,
      getConfig,
      hasFilterableValues,
      hasFilters,
      hasNoData,
      hasRowActions,
      hasSearchQueryFilter,
      immutableKey,
      initializeFilters,
      isCarouselEnabled,
      nextColumn,
      onRequest,
      onResize,
      pagination,
      prevColumn,
      resetFilters,
      resetSearchQuery,
      rowKey,
      rows,
      search,
      searchable,
      selectableRows,
      selecting,
      serverLoading,
      setCarouselCalculationsEnabled,
      setConfig,
      tableRef,
      toggleAll,
      toggleSelected,
      toggleSelecting,
      totalRows,
      transformOffsetLeft,
      updateSelection
    } = useTable();
    const {
      isDefaultLayout,
      showRightSidebar,
      toggleRightSidebar
    } = useLayout();
    let scrollTicking = false;
    const config = !props4.noPersistConfig && getConfig() || void 0;
    const thRefs = ref$1([]);
    const wrapperRef = ref$1(null);
    const grid = ref$1((config == null ? void 0 : config.grid) ?? props4.defaultGrid);
    const menuOpen = ref$1(null);
    const isScrolled = ref$1(false);
    const isScrolledGrid = ref$1(false);
    const hasVerticalScroll = ref$1(false);
    const hasScrollbar2 = ref$1(false);
    const allColumns = computed(() => {
      return [
        ...columns.value,
        ...slotsColumns.value,
        isCarouselEnabled.value && {
          label: "",
          name: "carousel-next"
        }
      ].filter(Boolean);
    });
    const otherColumns = computed(() => {
      const cellSlots = Object.keys(slots).filter((x2) => x2.startsWith("body-cell-")).map((x2) => x2.replace(/^body-cell-/, ""));
      return columns.value.filter((c2) => !cellSlots.includes(c2.name));
    });
    const cssVars = computed(() => {
      return {
        "--table-col-width": colWidth.value,
        "--table-transform": `translate(-${transformOffsetLeft.value}px, 0)`
      };
    });
    const filteredRowsCount = computed(() => pagination.value.rowsNumber);
    const hasFilteredRows = computed(
      () => filteredRowsCount.value !== totalRows.value
    );
    const hasSelectedRows = computed(() => !!allSelected.value.length);
    const isFiltersPanelOpened = computed(() => isDefaultLayout.value);
    const isLoading = computed(() => props4.loading || serverLoading.value);
    const isTableEmpty = computed(() => {
      return hasNoData.value && !isLoading.value || hasNoFiltersResult.value || hasNoSearchQueryResult.value;
    });
    const hasDivider = computed(() => {
      return !disablePreviousButton.value;
    });
    const hasNoFiltersResult = computed(() => {
      return !rows.value.length && !isLoading.value && hasFilters.value;
    });
    const hasNoSearchQueryResult = computed(() => {
      return !rows.value.length && !isLoading.value && hasSearchQueryFilter.value;
    });
    const slotsColumns = computed(() => {
      return Object.keys(SLOTS_COLUMNS).filter((k2) => {
        if (k2 === "row-actions" && !hasRowActions) return false;
        return !!slots[k2];
      }).map((k2) => SLOTS_COLUMNS[k2]);
    });
    const visibleColumns = computed(() => {
      return allColumns.value.map((c2) => c2.name);
    });
    const checkForScrollbar = () => {
      if (wrapperRef.value) {
        hasScrollbar2.value = wrapperRef.value.scrollHeight > wrapperRef.value.clientHeight;
      }
    };
    function hasActionsColumn(columns2) {
      return columns2.some((v) => v.name === "actions");
    }
    function checkVirtualScrollPresented() {
      var _a;
      const children = (_a = tableRef.value) == null ? void 0 : _a.$el.children;
      if (!children) return false;
      const virtualScrollElement = [...children].find((el) => el.classList.contains("q-virtual-scroll"));
      return (virtualScrollElement == null ? void 0 : virtualScrollElement.scrollHeight) > (virtualScrollElement == null ? void 0 : virtualScrollElement.clientHeight);
    }
    function onCardClick(row) {
      if (!props4.clickableCard) return;
      emit("card-click", row);
    }
    function onCheckboxClick(row, event) {
      if (props4.fakeSelection) return;
      toggleSelected(row, event.shiftKey);
    }
    function onClearSelection() {
      clearSelection2();
      emit("on-toggle-all", false);
    }
    function onMenuChange(open2, row) {
      menuOpen.value = open2 ? row : null;
      emit("menuChange", open2, row);
    }
    function onScrollVirtual(v) {
      isScrolled.value = v.index !== 0;
    }
    function onScrollWrapper() {
      if (!scrollTicking) {
        window.requestAnimationFrame(() => {
          var _a, _b;
          isScrolledGrid.value = !!(((_a = wrapperRef.value) == null ? void 0 : _a.scrollTop) && ((_b = wrapperRef.value) == null ? void 0 : _b.scrollTop) > 0);
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    }
    function onToggleAll(value2) {
      toggleAll(value2);
      emit("on-toggle-all", value2);
    }
    function setThRef(el) {
      if (el) {
        thRefs.value.push(el);
      }
    }
    function showThTooltip(index) {
      var _a;
      const el = (_a = thRefs.value[index]) == null ? void 0 : _a.$el;
      return !!el && el.scrollWidth > el.clientWidth;
    }
    const onVirtualScroll = throttle(
      (event) => {
        const isTableScrolled = event.composedPath().some(
          (el) => {
            var _a;
            return (_a = el.classList) == null ? void 0 : _a.contains("q-virtual-scroll");
          }
        );
        if (!isTableScrolled) return;
        if (event.deltaX > 0 && !disableNextButton.value) nextColumn();
        if (event.deltaX < 0 && !disablePreviousButton.value) prevColumn();
      },
      300,
      { trailing: false }
    );
    function setGrid(value2) {
      grid.value = value2;
      setCarouselCalculationsEnabled(!value2);
      if (!props4.noPersistConfig) setConfig({ grid: grid.value });
      emit("set-grid", value2);
    }
    watch(filteredSelected, (value2) => {
      emit("update:selected", value2);
      void nextTick(() => {
        hasVerticalScroll.value = checkVirtualScrollPresented();
      });
    });
    watch(
      () => props4.selected,
      (value2) => {
        if (value2) updateSelection(value2);
      }
    );
    watch(columns, () => {
      void initializeFilters();
    });
    onMounted(() => {
      var _a, _b;
      if (((_a = props4.selected) == null ? void 0 : _a.length) && !allSelected.value.length) {
        allSelected.value = props4.selected;
      }
      (_b = tableRef.value) == null ? void 0 : _b.requestServerInteraction();
      void initializeFilters();
      if (!hasNoData.value && showRightSidebar.value && props4.hideRightSidebar) {
        toggleRightSidebar();
      }
      if (isCarouselEnabled.value) document.addEventListener("wheel", onVirtualScroll);
      if (grid.value) {
        checkForScrollbar();
      }
    });
    onUpdated(() => {
      if (grid.value) {
        checkForScrollbar();
      }
    });
    onUnmounted(() => {
      if (isCarouselEnabled.value) {
        document.removeEventListener("wheel", onVirtualScroll);
      }
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      allColumns,
      allSelected,
      allSelectedValue,
      colWidth,
      cssVars,
      disableNextButton,
      disablePreviousButton,
      enableSelection,
      filteredRowsCount,
      filters,
      grid,
      hasActionsColumn,
      hasDivider,
      hasFilterableValues,
      hasFilteredRows,
      hasFilters,
      hasNoData,
      hasNoFiltersResult,
      hasNoSearchQueryResult,
      hasScrollbar: hasScrollbar2,
      hasSearchQueryFilter,
      hasSelectedRows,
      hasVerticalScroll,
      immutableKey,
      isCarouselEnabled,
      isFiltersPanelOpened,
      isLoading,
      isScrolled,
      isScrolledGrid,
      isTableEmpty,
      menuOpen,
      nextColumn,
      onCardClick,
      onCheckboxClick,
      onClearSelection,
      onMenuChange,
      onRequest,
      onResize,
      onScrollVirtual,
      onScrollWrapper,
      onToggleAll,
      otherColumns,
      pagination,
      prevColumn,
      resetFilters,
      resetSearchQuery,
      RowActionsVisibility,
      rowKey,
      rows,
      search,
      searchable,
      selectableRows,
      selecting,
      setGrid,
      setThRef,
      showThTooltip,
      slots,
      t: t2,
      tableRef,
      toggleRightSidebar,
      toggleSelecting,
      totalRows,
      visibleColumns,
      wrapperRef
    };
  }
});
const _hoisted_1$e = ["data-automation"];
const _hoisted_2$8 = { class: "rv-table__top row no-wrap full-width" };
const _hoisted_3$7 = { class: "row no-wrap items-center" };
const _hoisted_4$4 = { class: "rv-table__modes row no-wrap q-gutter-x-sm" };
const _hoisted_5$4 = { class: "row q-gutter-x-sm q-ml-md" };
const _hoisted_6$2 = { class: "row no-wrap q-gutter-x-sm items-center" };
const _hoisted_7$2 = {
  key: 0,
  class: "rv-table__top-inside row no-wrap full-width"
};
const _hoisted_8$1 = {
  key: 1,
  class: "flex full-width justify-between q-px-md q-pb-sm"
};
const _hoisted_9$1 = { class: "flex flex-center" };
const _hoisted_10$1 = {
  key: 0,
  class: "text-body3 text-grey-1"
};
const _hoisted_11$1 = {
  key: 1,
  class: "text-body3 text-grey-1 q-mx-xs"
};
const _hoisted_12 = {
  key: 2,
  class: "text-body3 text-grey-1"
};
const _hoisted_13 = {
  key: 2,
  class: "flex full-width justify-between q-pt-md bg-grey-5"
};
const _hoisted_14 = { class: "flex flex-center" };
const _hoisted_15 = {
  key: 3,
  class: "flex full-width justify-end q-pt-md bg-grey-5"
};
const _hoisted_16 = { class: "rv-table__header__backplate" };
const _hoisted_17 = {
  key: 1,
  class: "rv-table__row-progress absolute",
  style: { "right": "64px", "top": "19px" }
};
const _hoisted_18 = {
  class: "absolute text-bold",
  style: { "right": "0", "z-index": "2" }
};
const _hoisted_19 = {
  class: "row no-wrap flex items-center",
  style: { "height": "32px" }
};
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  const _component_ActionButton = resolveComponent("ActionButton");
  const _component_TablePagination = resolveComponent("TablePagination");
  const _component_RvButton = resolveComponent("RvButton");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_QIcon = resolveComponent("QIcon");
  const _component_RvInput = resolveComponent("RvInput");
  const _component_Checkbox = resolveComponent("Checkbox");
  const _component_TableSortBy = resolveComponent("TableSortBy");
  const _component_TableCard = resolveComponent("TableCard");
  const _component_QTh = resolveComponent("QTh");
  const _component_Tooltip = resolveComponent("Tooltip");
  const _component_QTr = resolveComponent("QTr");
  const _component_QMenu = resolveComponent("QMenu");
  const _component_QTd = resolveComponent("QTd");
  const _component_QTable = resolveComponent("QTable");
  const _component_NoData = resolveComponent("NoData");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["rv-table__wrapper", [_ctx.wrapperClass, { "rv-table__wrapper--full-height": _ctx.fullHeight }]]),
    "data-automation": _ctx.buildId()
  }, [
    createElementVNode("div", {
      ref: "wrapperRef",
      class: normalizeClass(["rv-table", {
        "rv-table--carousel": _ctx.isCarouselEnabled,
        "rv-table--grid": _ctx.grid,
        "rv-table--list": !_ctx.grid,
        "rv-table--select": _ctx.selection !== "none",
        "rv-table--shadow": _ctx.grid && _ctx.isScrolledGrid,
        "rv-table--empty": _ctx.isTableEmpty,
        "rv-table--without-selection": !_ctx.enableSelection,
        "rv-table--pagination-separated": _ctx.bottomPaginationSeparated,
        "rv-table--with-scrollbar": _ctx.hasScrollbar,
        "rv-table--full-height": _ctx.fullHeight
      }]),
      style: normalizeStyle(_ctx.cssVars),
      onScroll: _cache[7] || (_cache[7] = (...args) => _ctx.onScrollWrapper && _ctx.onScrollWrapper(...args))
    }, [
      createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"]),
      createVNode(_component_QTable, mergeProps(_ctx.$attrs, {
        ref: "tableRef",
        pagination: _ctx.pagination,
        "onUpdate:pagination": _cache[5] || (_cache[5] = ($event) => _ctx.pagination = $event),
        selected: _ctx.allSelected,
        "onUpdate:selected": _cache[6] || (_cache[6] = ($event) => _ctx.allSelected = $event),
        "card-container-class": [
          "rv-table__grid",
          {
            "rv-table__grid--responsive": _ctx.gridResponsive,
            hidden: !_ctx.totalRows
          }
        ],
        class: ["rv-table__element", { "rv-table--no-margin": !_ctx.totalRows }],
        color: "primary",
        columns: _ctx.allColumns,
        filter: _ctx.filters,
        flat: "",
        grid: _ctx.grid,
        "hide-no-data": "",
        "hide-pagination": _ctx.hidePagination,
        "hide-selected-banner": "",
        loading: _ctx.isLoading,
        "row-key": _ctx.rowKey,
        rows: _ctx.rows,
        "rows-per-page-options": _ctx.rowsPerPageOptions,
        selection: _ctx.selection,
        separator: "none",
        "table-class": [
          _ctx.totalRows ? "rv-table__content" : "rv-table__content--hide",
          _ctx.hasVerticalScroll && "rv-table__content--with-scroll",
          _ctx.hasDivider && "rv-table__content--with-divider"
        ],
        "table-header-class": "rv-table__header",
        "virtual-scroll": _ctx.virtualScroll,
        "virtual-scroll-sticky-size-start": "56",
        "visible-columns": _ctx.visibleColumns,
        onRequest: _ctx.onRequest,
        onVirtualScroll: _ctx.onScrollVirtual
      }), createSlots({
        item: withCtx((props4) => [
          createVNode(_component_TableCard, mergeProps(props4, {
            class: _ctx.gridClass(props4.row),
            "clickable-card": !props4.row[_ctx.immutableKey] && _ctx.clickableCard,
            "custom-actions": _ctx.customActions,
            "data-automation": _ctx.buildId(`card-${props4.row[_ctx.rowKey]}`),
            selecting: _ctx.selecting,
            onClick: ($event) => !props4.row[_ctx.immutableKey] && _ctx.onCardClick(props4.row),
            onMenuChange: _ctx.onMenuChange
          }), createSlots({
            select: withCtx(() => [
              !props4.row[_ctx.immutableKey] ? (openBlock(), createBlock(_component_Checkbox, {
                key: 0,
                class: "q-mr-sm",
                "data-automation": _ctx.buildId(`card-${props4.row[_ctx.rowKey]}__checkbox`),
                dense: "",
                disable: _ctx.fakeSelection,
                "model-value": _ctx.fakeSelection ? true : props4.selected,
                onClick: ($event) => _ctx.onCheckboxClick(props4.row, $event)
              }, null, 8, ["data-automation", "disable", "model-value", "onClick"])) : createCommentVNode("", true)
            ]),
            cardHeader: withCtx(() => [
              renderSlot(_ctx.$slots, "cardHeader", normalizeProps(guardReactiveProps(props4 || {})))
            ]),
            cardTitle: withCtx(() => [
              renderSlot(_ctx.$slots, "cardTitle", normalizeProps(guardReactiveProps(props4 || {})))
            ]),
            cardContent: withCtx(() => [
              renderSlot(_ctx.$slots, "cardContent", normalizeProps(guardReactiveProps(props4 || {})))
            ]),
            _: 2
          }, [
            _ctx.$slots["row-actions"] && _ctx.getRowActionsVisibility(props4.row) !== _ctx.RowActionsVisibility.NoActions ? {
              name: "actions",
              fn: withCtx(() => [
                renderSlot(_ctx.$slots, "row-actions", normalizeProps(guardReactiveProps(props4 || {})))
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["class", "clickable-card", "custom-actions", "data-automation", "selecting", "onClick", "onMenuChange"])
        ]),
        header: withCtx((props4) => [
          createVNode(_component_QTr, {
            class: "rv-table__header",
            props: props4
          }, {
            default: withCtx(() => [
              createVNode(_component_QTh, { class: "flex items-center bg-grey-5--light bg-grey-1--dark" }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "select-all", {}, () => [
                    _ctx.enableSelection ? (openBlock(), createBlock(_component_Checkbox, {
                      key: 0,
                      "data-automation": _ctx.buildId("selectAll"),
                      disable: _ctx.fakeSelection || !_ctx.selectableRows.length,
                      "model-value": _ctx.fakeSelection ? true : _ctx.allSelectedValue,
                      "onUpdate:modelValue": _ctx.onToggleAll
                    }, null, 8, ["data-automation", "disable", "model-value", "onUpdate:modelValue"])) : createCommentVNode("", true)
                  ])
                ]),
                _: 3
              }),
              (openBlock(true), createElementBlock(Fragment, null, renderList(props4.cols.filter(
                (v) => v.name !== "actions" && v.name !== "carousel-next"
              ), (col, i2) => {
                return openBlock(), createBlock(_component_QTh, {
                  key: col.name,
                  ref_for: true,
                  ref: _ctx.setThRef,
                  class: "rv-table__header__column ellipsis",
                  props: props4,
                  style: normalizeStyle({
                    ..._ctx.isCarouselEnabled && {
                      width: _ctx.colWidth,
                      "max-width": _ctx.colWidth,
                      "min-width": _ctx.colWidth
                    }
                  })
                }, {
                  default: withCtx(() => [
                    _ctx.$slots[`header-cell-${col.name}`] ? renderSlot(_ctx.$slots, `header-cell-${col.name}`, mergeProps({
                      key: 0,
                      ref_for: true
                    }, col || {})) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                      createTextVNode(toDisplayString(col.label), 1)
                    ], 64)),
                    _ctx.showThTooltip(i2) ? (openBlock(), createBlock(_component_Tooltip, {
                      key: 2,
                      "data-automation": _ctx.buildId("thTooltip")
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(col.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["data-automation"])) : createCommentVNode("", true),
                    _ctx.isCarouselEnabled && i2 === 0 ? (openBlock(), createBlock(_component_RvButton, {
                      key: 3,
                      class: "rv-table__header__move-prev rv-table--transition-opacity full-height",
                      color: "grey-1",
                      "data-automation": _ctx.buildId("prevColumn"),
                      disable: _ctx.disablePreviousButton,
                      icon: "mdi-chevron-left",
                      style: normalizeStyle({
                        opacity: `${_ctx.disablePreviousButton ? 0 : 1} !important`
                      }),
                      tertiary: "",
                      onClick: withModifiers(_ctx.prevColumn, ["stop"])
                    }, null, 8, ["data-automation", "disable", "style", "onClick"])) : createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["props", "style"]);
              }), 128)),
              _ctx.hasActionsColumn(props4.cols) ? (openBlock(), createBlock(_component_QTh, {
                key: 0,
                class: "rv-table__header__column rv-table__header__column--fixed rv-table__header__action-column"
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "header-cell-actions")
                ]),
                _: 3
              })) : createCommentVNode("", true),
              _ctx.isCarouselEnabled ? (openBlock(), createBlock(_component_QTh, {
                key: 1,
                class: "rv-table__header__column rv-table__header__column--fixed rv-table__header__move-next"
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_16, [
                    createVNode(_component_RvButton, {
                      class: "rv-table__header__move-next__button rv-table--transition-opacity",
                      color: "grey-1",
                      "data-automation": _ctx.buildId("nextColumn"),
                      disable: _ctx.disableNextButton,
                      icon: "mdi-chevron-right",
                      style: normalizeStyle({
                        opacity: `${_ctx.disableNextButton ? 0 : 1} !important`
                      }),
                      tertiary: "",
                      onClick: withModifiers(_ctx.nextColumn, ["stop"])
                    }, null, 8, ["data-automation", "disable", "style", "onClick"])
                  ])
                ]),
                _: 1
              })) : createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["props"]),
          createVNode(_component_QTr, {
            class: normalizeClass(["rv-table__header__shadow-column", { "rv-table__header__shadow-column--active": _ctx.isScrolled }])
          }, {
            default: withCtx(() => [
              createVNode(_component_QTh),
              (openBlock(true), createElementBlock(Fragment, null, renderList(props4.cols.filter(
                (v) => v.name !== "actions"
              ), (col) => {
                return openBlock(), createBlock(_component_QTh, {
                  key: col.name
                });
              }), 128)),
              _ctx.hasActionsColumn(props4.cols) ? (openBlock(), createBlock(_component_QTh, { key: 0 })) : createCommentVNode("", true),
              _ctx.isCarouselEnabled ? (openBlock(), createBlock(_component_QTh, { key: 1 })) : createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["class"])
        ]),
        "body-cell-actions": withCtx((props4) => [
          createVNode(_component_QTd, { class: "rv-table__cell rv-table__cell--fixed rv-table__row-actions-wrapper" }, {
            default: withCtx(() => [
              _ctx.getRowActionsVisibility(props4.row) !== _ctx.RowActionsVisibility.NoActions ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(["rv-table__row-actions cursor-pointer", {
                  "rv-table__row-actions--open": _ctx.menuOpen === props4.row,
                  "rv-table__row-actions-hidden-until-hover": _ctx.getRowActionsVisibility(props4.row) == _ctx.RowActionsVisibility.HiddenUntilHover
                }])
              }, [
                _ctx.customActions ? renderSlot(_ctx.$slots, "row-actions", mergeProps({ key: 0 }, props4, {
                  menuOpen: _ctx.menuOpen === props4.row,
                  onMenuChange: (open2) => _ctx.onMenuChange(open2, props4.row)
                })) : (openBlock(), createBlock(_component_RvButton, {
                  key: 1,
                  class: "no-padding",
                  color: "grey-1",
                  "data-automation": _ctx.buildId("dots"),
                  icon: "mdi-dots-horizontal",
                  tertiary: ""
                }, {
                  default: withCtx(() => [
                    createVNode(_component_QMenu, {
                      anchor: "bottom middle",
                      "auto-close": "",
                      self: "top middle",
                      "onUpdate:modelValue": ($event) => _ctx.onMenuChange($event, props4.row)
                    }, {
                      default: withCtx(() => [
                        renderSlot(_ctx.$slots, "row-actions", normalizeProps(guardReactiveProps(props4 || {})))
                      ]),
                      _: 2
                    }, 1032, ["onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1032, ["data-automation"]))
              ], 2)) : createCommentVNode("", true),
              _ctx.$slots["row-progress"] ? (openBlock(), createElementBlock("div", _hoisted_17, [
                createElementVNode("div", _hoisted_18, [
                  createElementVNode("div", _hoisted_19, [
                    renderSlot(_ctx.$slots, "row-progress", normalizeProps(guardReactiveProps(props4 || {})))
                  ])
                ])
              ])) : createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]),
        "body-cell-carousel-next": withCtx(() => [
          createVNode(_component_QTd, { class: "rv-table__cell rv-table__cell--fixed" })
        ]),
        "body-selection": withCtx((props4) => [
          _ctx.enableSelection && !props4.row[_ctx.immutableKey] ? (openBlock(), createBlock(_component_Checkbox, {
            key: 0,
            class: "rv-table__body-selection",
            "data-automation": _ctx.buildId(`row-${props4.row[_ctx.rowKey]}__checkbox`),
            disable: _ctx.fakeSelection,
            "model-value": _ctx.fakeSelection ? true : props4.selected,
            onClick: ($event) => _ctx.onCheckboxClick(props4.row, $event)
          }, null, 8, ["data-automation", "disable", "model-value", "onClick"])) : createCommentVNode("", true)
        ]),
        loading: withCtx(() => [
          createElementVNode("div", {
            class: "rv-table__loading q-linear-progress__model absolute-full q-linear-progress__model--with-transition q-linear-progress__model--indeterminate",
            style: normalizeStyle({ ...!_ctx.hideHeader && { top: "56px" } })
          }, null, 4)
        ]),
        _: 2
      }, [
        !_ctx.hideHeader ? {
          name: "top",
          fn: withCtx(() => {
            var _a;
            return [
              createElementVNode("div", _hoisted_2$8, [
                createElementVNode("div", _hoisted_3$7, [
                  createElementVNode("div", _hoisted_4$4, [
                    !_ctx.hideGridButton ? (openBlock(), createBlock(_component_ActionButton, {
                      key: 0,
                      "data-automation": _ctx.buildId("module"),
                      icon: "mdi-view-module",
                      selected: _ctx.grid,
                      tooltip: _ctx.t("rvai-base.general.table.thumbnailsView"),
                      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.setGrid(true))
                    }, null, 8, ["data-automation", "selected", "tooltip"])) : createCommentVNode("", true),
                    !_ctx.hideListButton ? (openBlock(), createBlock(_component_ActionButton, {
                      key: 1,
                      "data-automation": _ctx.buildId("list"),
                      icon: "mdi-view-list",
                      selected: !_ctx.grid,
                      tooltip: _ctx.t("rvai-base.general.table.listView"),
                      onClick: _cache[1] || (_cache[1] = ($event) => _ctx.setGrid(false))
                    }, null, 8, ["data-automation", "selected", "tooltip"])) : createCommentVNode("", true),
                    renderSlot(_ctx.$slots, "table-modes"),
                    !_ctx.hidePagination && _ctx.showTopPagination && _ctx.totalRows ? (openBlock(), createBlock(_component_TablePagination, {
                      key: 2,
                      "data-automation": _ctx.buildId("paginationTop"),
                      "rows-per-page-options": _ctx.rowsPerPageOptions
                    }, null, 8, ["data-automation", "rows-per-page-options"])) : createCommentVNode("", true)
                  ]),
                  createElementVNode("div", _hoisted_5$4, [
                    _ctx.enableSelection && _ctx.selectable && _ctx.grid ? (openBlock(), createBlock(_component_RvButton, {
                      key: 0,
                      color: "primary",
                      "data-automation": _ctx.buildId("select"),
                      disable: !_ctx.totalRows,
                      icon: _ctx.selecting && _ctx.totalRows ? "mdi-close" : "mdi-content-copy",
                      label: _ctx.selecting && _ctx.totalRows ? _ctx.t("rvai-base.general.table.cancel") : _ctx.t("rvai-base.general.table.select"),
                      size: "sm",
                      tertiary: "",
                      onClick: _ctx.toggleSelecting
                    }, null, 8, ["data-automation", "disable", "icon", "label", "onClick"])) : createCommentVNode("", true),
                    ((_a = _ctx.selected) == null ? void 0 : _a.length) ? renderSlot(_ctx.$slots, "actions", { key: 1 }) : createCommentVNode("", true)
                  ])
                ]),
                createVNode(_component_QSpace),
                createElementVNode("div", _hoisted_6$2, [
                  _ctx.searchable ? (openBlock(), createBlock(_component_RvInput, {
                    key: 0,
                    modelValue: _ctx.search,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.search = $event),
                    class: "rv-table__search",
                    "clear-icon": "mdi-close",
                    clearable: "",
                    "data-automation": _ctx.buildId("search"),
                    dense: "",
                    disable: _ctx.hasNoData,
                    placeholder: _ctx.t("rvai-base.general.table.search")
                  }, {
                    prepend: withCtx(() => [
                      createVNode(_component_QIcon, {
                        color: "grey-1",
                        name: "search"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "data-automation", "disable", "placeholder"])) : createCommentVNode("", true),
                  _ctx.withFilters ? (openBlock(), createBlock(_component_ActionButton, {
                    key: 1,
                    "data-automation": _ctx.buildId("sidebar"),
                    disable: _ctx.hasNoData || !_ctx.hasFilterableValues,
                    icon: "mdi-filter",
                    selected: _ctx.isFiltersPanelOpened || _ctx.hasFilters,
                    tooltip: _ctx.t("rvai-base.general.table.filter"),
                    onClick: _ctx.toggleRightSidebar
                  }, null, 8, ["data-automation", "disable", "selected", "tooltip", "onClick"])) : createCommentVNode("", true)
                ]),
                renderSlot(_ctx.$slots, "top-right")
              ]),
              _ctx.$slots["top-inside"] && !_ctx.grid ? (openBlock(), createElementBlock("div", _hoisted_7$2, [
                renderSlot(_ctx.$slots, "top-inside")
              ])) : createCommentVNode("", true),
              !_ctx.grid && _ctx.showSelectCount && _ctx.totalRows && (_ctx.hasSelectedRows || _ctx.hasFilteredRows) ? (openBlock(), createElementBlock("div", _hoisted_8$1, [
                createElementVNode("div", _hoisted_9$1, [
                  _ctx.hasSelectedRows ? (openBlock(), createElementBlock("div", _hoisted_10$1, toDisplayString(_ctx.allSelected.length ? _ctx.t("rvai-base.general.table.selected", [
                    _ctx.allSelected.length,
                    _ctx.totalRows
                  ]) : _ctx.t("rvai-base.general.table.total", [_ctx.totalRows])), 1)) : createCommentVNode("", true),
                  _ctx.hasSelectedRows && _ctx.hasFilteredRows ? (openBlock(), createElementBlock("div", _hoisted_11$1, toDisplayString(_ctx.t("rvai-base.general.symbols.dash")), 1)) : createCommentVNode("", true),
                  _ctx.hasFilteredRows ? (openBlock(), createElementBlock("div", _hoisted_12, toDisplayString(_ctx.t("rvai-base.general.table.filteredResults", [
                    _ctx.filteredRowsCount,
                    _ctx.totalRows
                  ])), 1)) : createCommentVNode("", true),
                  _ctx.allSelected.length ? (openBlock(), createBlock(_component_RvButton, {
                    key: 3,
                    class: "q-ml-xs",
                    "data-automation": _ctx.buildId("clear"),
                    label: _ctx.t("rvai-base.general.table.clear"),
                    size: "sm",
                    style: { "padding-top": "0", "padding-bottom": "0" },
                    tertiary: "",
                    onClick: _cache[3] || (_cache[3] = ($event) => _ctx.onClearSelection())
                  }, null, 8, ["data-automation", "label"])) : createCommentVNode("", true)
                ])
              ])) : _ctx.grid && _ctx.selecting && _ctx.totalRows ? (openBlock(), createElementBlock("div", _hoisted_13, [
                createElementVNode("div", _hoisted_14, [
                  createVNode(_component_Checkbox, {
                    class: "q-ml-md",
                    "data-automation": _ctx.buildId("selectAll"),
                    dense: "",
                    disable: _ctx.fakeSelection,
                    label: _ctx.t("rvai-base.general.table.selected", [
                      _ctx.allSelected.length,
                      _ctx.totalRows
                    ]),
                    "model-value": _ctx.fakeSelection ? true : _ctx.allSelectedValue,
                    "onUpdate:modelValue": _ctx.onToggleAll
                  }, null, 8, ["data-automation", "disable", "label", "model-value", "onUpdate:modelValue"]),
                  _ctx.allSelected.length ? (openBlock(), createBlock(_component_RvButton, {
                    key: 0,
                    class: "q-ml-xs",
                    "data-automation": _ctx.buildId("clear"),
                    label: _ctx.t("rvai-base.general.table.clear"),
                    size: "sm",
                    style: { "padding-top": "0", "padding-bottom": "0" },
                    tertiary: "",
                    onClick: _cache[4] || (_cache[4] = ($event) => _ctx.onClearSelection())
                  }, null, 8, ["data-automation", "label"])) : createCommentVNode("", true)
                ]),
                createVNode(_component_TableSortBy, {
                  "data-automation": _ctx.buildId("sortBy")
                }, null, 8, ["data-automation"])
              ])) : _ctx.showSortBy && _ctx.grid && _ctx.totalRows && !_ctx.selecting ? (openBlock(), createElementBlock("div", _hoisted_15, [
                createVNode(_component_TableSortBy, {
                  "data-automation": _ctx.buildId("sortBy")
                }, null, 8, ["data-automation"])
              ])) : createCommentVNode("", true)
            ];
          }),
          key: "0"
        } : void 0,
        renderList(_ctx.otherColumns, (col) => {
          return {
            name: `body-cell-${col.name}`,
            fn: withCtx((slotData) => [
              createVNode(_component_QTd, {
                classes: slotData.col.classes,
                "data-automation": _ctx.buildId(`td-body-cell-${col.name}`),
                style: normalizeStyle(slotData.col.style)
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, `body-cell-${col.name}`, normalizeProps(guardReactiveProps(slotData || {})), () => {
                    var _a;
                    return [
                      createTextVNode(toDisplayString(((_a = _ctx.tableRef) == null ? void 0 : _a.getCellValue(slotData.col, slotData.row)) ?? ""), 1)
                    ];
                  })
                ]),
                _: 2
              }, 1032, ["classes", "data-automation", "style"])
            ])
          };
        }),
        !_ctx.hidePagination ? {
          name: "bottom",
          fn: withCtx(() => [
            createVNode(_component_TablePagination, {
              centered: _ctx.bottomPaginationCentered,
              "data-automation": _ctx.buildId("pagination"),
              "hide-page-size-selection": _ctx.hidePageSizeSelection,
              "rows-per-page-options": _ctx.rowsPerPageOptions,
              separated: _ctx.bottomPaginationSeparated
            }, null, 8, ["centered", "data-automation", "hide-page-size-selection", "rows-per-page-options", "separated"])
          ]),
          key: "1"
        } : void 0,
        renderList(_ctx.slots, (_, name2) => {
          return {
            name: name2,
            fn: withCtx((slotData) => [
              String(name2).startsWith("body-cell-") ? (openBlock(), createBlock(_component_QTd, {
                key: name2,
                classes: slotData.col.classes,
                "data-automation": _ctx.buildId(`td-${name2}`),
                style: normalizeStyle(slotData.col.style)
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, name2, normalizeProps(guardReactiveProps(slotData || {})))
                ]),
                _: 2
              }, 1032, ["classes", "data-automation", "style"])) : renderSlot(_ctx.$slots, name2, normalizeProps(mergeProps({ key: 1 }, slotData || {})))
            ])
          };
        })
      ]), 1040, ["pagination", "selected", "card-container-class", "class", "columns", "filter", "grid", "hide-pagination", "loading", "row-key", "rows", "rows-per-page-options", "selection", "table-class", "virtual-scroll", "visible-columns", "onRequest", "onVirtualScroll"])
    ], 38),
    _ctx.hasNoData && !_ctx.isLoading ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(_ctx.$slots["no-data"] ? "rv-table__no-data" : "hidden")
    }, [
      renderSlot(_ctx.$slots, "no-data")
    ], 2)) : _ctx.hasNoSearchQueryResult ? (openBlock(), createBlock(_component_NoData, {
      key: 1,
      class: "rv-table__no-data",
      "data-automation": _ctx.buildId("noData"),
      "icon-name": "img:/rvai-base/robot-search.svg",
      title: _ctx.t("rvai-base.tableFields.noQueryResults")
    }, {
      default: withCtx(() => [
        createVNode(_component_RvButton, {
          color: "primary",
          "data-automation": _ctx.buildId("reset-search"),
          label: _ctx.t("rvai-base.tableFields.clearSearchResults"),
          size: "sm",
          onClick: _ctx.resetSearchQuery
        }, null, 8, ["data-automation", "label", "onClick"])
      ]),
      _: 1
    }, 8, ["data-automation", "title"])) : _ctx.hasNoFiltersResult ? (openBlock(), createBlock(_component_NoData, {
      key: 2,
      class: "rv-table__no-data",
      "data-automation": _ctx.buildId("noData"),
      "icon-name": "img:/rvai-base/robot-filters.svg",
      title: _ctx.t("rvai-base.tableFields.noFilteredResults")
    }, {
      default: withCtx(() => [
        createVNode(_component_RvButton, {
          color: "primary",
          "data-automation": _ctx.buildId("clear-filter"),
          label: _ctx.t("rvai-base.tableFields.clearFilter"),
          size: "sm",
          onClick: _ctx.resetFilters
        }, null, 8, ["data-automation", "label", "onClick"])
      ]),
      _: 1
    }, 8, ["data-automation", "title"])) : createCommentVNode("", true)
  ], 10, _hoisted_1$e);
}
const Table = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$a]]);
function useDateFilter(filter, filterValueRef) {
  var _a;
  const { updateFilters } = useTable();
  const { t: t2 } = useI18n();
  const isDate2 = ((_a = filter.value) == null ? void 0 : _a.type) === TableFilterType.Date;
  const originalValueStart = ref$1("");
  const originalValueEnd = ref$1("");
  const dateFilter = filter.value;
  const dateFilterOption = ref$1(void 0);
  const filterValue = filterValueRef.value;
  const dateValue = reactive({
    end: (filterValue == null ? void 0 : filterValue.type) === TableFilterType.Date ? filterValue.value.end : "",
    start: (filterValue == null ? void 0 : filterValue.type) === TableFilterType.Date ? filterValue.value.start : ""
  });
  const dateStart = computed({
    get() {
      return dateValue.start;
    },
    set(value2) {
      dateValue.start = value2;
      setFilters();
    }
  });
  const dateEnd = computed({
    get() {
      return dateValue.end;
    },
    set(value2) {
      dateValue.end = value2;
      setFilters();
    }
  });
  const showDefaultDateFilter = computed(() => {
    var _a2;
    return !((_a2 = dateFilter.beforeOptions) == null ? void 0 : _a2.length) || !!dateFilterOption.value && !dateFilterOption.value.hideDefaultFilter;
  });
  function endRestrictions(date) {
    return !dateStart.value || formatToSlash(date) >= formatToSlash(dateStart.value);
  }
  function onUpdateDateFilterOption(value2) {
    dateFilterOption.value = value2;
    if (value2 && value2.hideDefaultFilter) {
      dateValue.start = formatDate$1(new Date(Date.now() - Number(value2.value)));
      dateValue.end = formatDate$1(/* @__PURE__ */ new Date());
    } else {
      dateValue.start = "";
      dateValue.end = "";
    }
    setFilters();
  }
  function setDateFilterOption(start, end) {
    var _a2;
    if (!((_a2 = dateFilter.beforeOptions) == null ? void 0 : _a2.length)) return;
    if (start && end) {
      const differenceInMs = differenceInMilliseconds(new Date(end), new Date(start));
      const availableOption = dateFilter.beforeOptions.find((o) => o.value === differenceInMs);
      if (start.length > 10 && end.length > 10) {
        onUpdateDateFilterOption(availableOption);
        return;
      }
    }
    dateFilterOption.value = dateFilter.beforeOptions.find((o) => !o.hideDefaultFilter);
  }
  function setFilterByDefaultDateOption() {
    const defaultFilterOption = dateFilter.beforeOptions ? dateFilter.beforeOptions.find((o) => o.selectedByDefault) || dateFilter.beforeOptions[0] : void 0;
    onUpdateDateFilterOption(defaultFilterOption);
  }
  function setFilters() {
    if (!dateValue.start && !dateValue.end) {
      updateFilters(filter.value, void 0);
    } else {
      updateFilters(filter.value, {
        key: filter.value.key,
        type: TableFilterType.Date,
        value: {
          end: dateValue.end,
          start: dateValue.start
        }
      });
    }
  }
  function setOriginalValueEnd(value2) {
    originalValueEnd.value = value2;
  }
  function setOriginalValueStart(value2) {
    originalValueStart.value = value2;
  }
  function startRestrictions(date) {
    return !dateEnd.value || formatToSlash(date) <= formatToSlash(dateEnd.value);
  }
  function formatToSlash(date) {
    return date.replace(/-/g, "/");
  }
  const validationRules = computed(() => {
    return {
      originalValueEnd: ValidationBuilder.$t("rvai-base.filters.date.endDate").custom(
        (value2) => originalValueStart.value && value2 ? formatToSlash(value2) >= formatToSlash(originalValueStart.value) : true,
        t2("rvai-base.filters.errors.endIsEarlier")
      ).rules,
      originalValueStart: ValidationBuilder.$t("rvai-base.filters.date.startDate").custom(
        (value2) => value2 && originalValueEnd.value ? formatToSlash(value2) <= formatToSlash(originalValueEnd.value) : true,
        t2("rvai-base.filters.errors.startIsLater")
      ).rules
    };
  });
  const v$ = useVuelidate(
    validationRules,
    {
      originalValueEnd,
      originalValueStart
    },
    { $autoDirty: true }
  );
  watch(filterValueRef, () => {
    var _a2;
    const filterValue2 = filterValueRef.value;
    dateValue.start = (filterValue2 == null ? void 0 : filterValue2.type) === TableFilterType.Date ? filterValue2.value.start : "";
    dateValue.end = (filterValue2 == null ? void 0 : filterValue2.type) === TableFilterType.Date ? filterValue2.value.end : "";
    if (!filterValue2 && ((_a2 = dateFilter.beforeOptions) == null ? void 0 : _a2.length)) {
      dateFilterOption.value = dateFilter.beforeOptions.find((o) => !o.hideDefaultFilter);
    }
  });
  onMounted(() => {
    var _a2, _b;
    if (!isDate2) return;
    if (!((_a2 = dateFilter.beforeOptions) == null ? void 0 : _a2.length)) return;
    if (!filterValueRef.value) {
      setFilterByDefaultDateOption();
    } else if (filterValueRef.value.type === TableFilterType.Date && ((_b = dateFilter.beforeOptions) == null ? void 0 : _b.length)) {
      setDateFilterOption(filterValueRef.value.value.start, filterValueRef.value.value.end);
    }
  });
  return {
    dateEnd,
    dateFilterOption,
    dateStart,
    endRestrictions,
    isDate: isDate2,
    onUpdateDateFilterOption,
    originalValueEnd,
    originalValueStart,
    setOriginalValueEnd,
    setOriginalValueStart,
    showDefaultDateFilter,
    startRestrictions,
    v$
  };
}
function useListFilter(filter, filterValueRef) {
  var _a;
  const { updateFilters } = useTable();
  const isList = ((_a = filter.value) == null ? void 0 : _a.type) === TableFilterType.List;
  const listValue = computed({
    get() {
      const filterValue = filterValueRef.value;
      return (filterValue == null ? void 0 : filterValue.type) === TableFilterType.List ? filterValue.value : [];
    },
    set(value2) {
      if (!value2.length) {
        updateFilters(filter.value, void 0);
      } else {
        updateFilters(filter.value, {
          key: filter.value.key,
          type: TableFilterType.List,
          value: value2
        });
      }
    }
  });
  return {
    isList,
    listValue
  };
}
function useNumberFilter(filter, filterValueRef) {
  var _a;
  const { updateFilters } = useTable();
  const isNumber2 = ((_a = filter.value) == null ? void 0 : _a.type) === TableFilterType.Number;
  const numberValue = computed(() => {
    const filterValue = filterValueRef.value;
    return (filterValue == null ? void 0 : filterValue.type) === TableFilterType.Number ? {
      max: filterValue.max,
      min: filterValue.min
    } : {
      max: null,
      min: null
    };
  });
  const numberRange = computed(() => {
    const {
      max: maxValue2,
      min: minValue2,
      step
    } = filter.value;
    if (maxValue2 == null || minValue2 == null) {
      return {
        max: null,
        min: null
      };
    }
    const min2 = step ? Math.floor(minValue2 / step) * step : Math.floor(minValue2);
    const max2 = step ? Math.ceil(maxValue2 / step) * step : Math.ceil(maxValue2);
    return {
      max: max2,
      min: min2
    };
  });
  function onUpdateNumber(value2) {
    const {
      max: maxValue2,
      min: minValue2
    } = value2;
    const {
      max: filterMax,
      min: filterMin
    } = numberRange.value;
    let max2 = maxValue2;
    let min2 = minValue2;
    if (filterMax != null && filterMin != null && maxValue2 != null && minValue2 != null) {
      min2 = minValue2 < filterMax ? minValue2 > filterMin ? minValue2 : filterMin : filterMax;
      max2 = maxValue2 > filterMin ? maxValue2 < filterMax ? maxValue2 : filterMax : filterMin;
      if (min2 > max2) {
        min2 = max2;
      }
    }
    updateFilters(filter.value, {
      key: filter.value.key,
      max: max2,
      min: min2,
      type: TableFilterType.Number
    });
  }
  return {
    isNumber: isNumber2,
    numberRange,
    numberValue,
    onUpdateNumber
  };
}
function useSingleFilter(filter, filterValueRef) {
  var _a;
  const { updateFilters } = useTable();
  const isSingle = ((_a = filter.value) == null ? void 0 : _a.type) === TableFilterType.Single;
  const singleValue = computed({
    get() {
      const filterValue = filterValueRef.value;
      return (filterValue == null ? void 0 : filterValue.type) === TableFilterType.Single ? filterValue.value : void 0;
    },
    set(value2) {
      updateFilters(filter.value, {
        key: filter.value.key,
        type: TableFilterType.Single,
        value: value2
      });
    }
  });
  return {
    isSingle,
    singleValue
  };
}
const _sfc_main$h = defineComponent({
  name: "TableFilterItem",
  components: {
    DatePicker,
    EllipsisText,
    ExpansionItem,
    OptionGroup,
    QItemLabel: QItemLabel_default,
    QRange: QRange_default,
    QSpace: QSpace_default,
    RvInput,
    RvSelect,
    ScrollArea
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * Puts expansion item into open state on initial render; Overridden by v-model if used
     */
    defaultOpened: {
      default: false,
      type: Boolean
    },
    filterKey: {
      type: String,
      required: true
    },
    scrollMaxItems: {
      type: Number,
      default: 0
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    const {
      filterOptions,
      filters
    } = useTable();
    const filter = computed(() => filterOptions.value[props4.filterKey]);
    const filterValue = computed(() => filters.values[props4.filterKey]);
    const showScroll = computed(() => {
      if (filter.value.type !== TableFilterType.List && filter.value.type !== TableFilterType.Single) {
        return false;
      }
      return props4.scrollMaxItems !== 0 && filter.value.options.length > props4.scrollMaxItems;
    });
    const scrollHeight = computed(() => {
      const value2 = props4.scrollMaxItems * 32 - 8;
      return `${value2}px`;
    });
    return {
      filter,
      kebabCase,
      scrollHeight,
      showScroll,
      t: t2,
      ...useAutomation(computed(() => props4.dataAutomation)),
      ...useDateFilter(filter, filterValue),
      ...useListFilter(filter, filterValue),
      ...useNumberFilter(filter, filterValue),
      ...useSingleFilter(filter, filterValue)
    };
  }
});
const _hoisted_1$d = { class: "q-px-sm flex items-center no-wrap" };
const _hoisted_2$7 = { class: "q-mr-md" };
const _hoisted_3$6 = { class: "q-ml-md" };
const _hoisted_4$3 = { class: "row justify-between items-center q-mb-sm" };
const _hoisted_5$3 = { class: "q-mt-md" };
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvSelect = resolveComponent("RvSelect");
  const _component_DatePicker = resolveComponent("DatePicker");
  const _component_OptionGroup = resolveComponent("OptionGroup");
  const _component_ScrollArea = resolveComponent("ScrollArea");
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_QSpace = resolveComponent("QSpace");
  const _component_QItemLabel = resolveComponent("QItemLabel");
  const _component_QRange = resolveComponent("QRange");
  const _component_RvInput = resolveComponent("RvInput");
  const _component_ExpansionItem = resolveComponent("ExpansionItem");
  return openBlock(), createBlock(_component_ExpansionItem, mergeProps({
    "data-automation": _ctx.buildId()
  }, _ctx.$attrs, {
    "default-opened": _ctx.defaultOpened,
    label: _ctx.filter.label
  }), {
    default: withCtx(() => {
      var _a;
      return [
        createElementVNode("div", null, [
          _ctx.isDate ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            "beforeOptions" in _ctx.filter && ((_a = _ctx.filter.beforeOptions) == null ? void 0 : _a.length) ? (openBlock(), createBlock(_component_RvSelect, {
              key: 0,
              class: normalizeClass(!_ctx.dateFilterOption || _ctx.dateFilterOption.hideDefaultFilter ? "q-mb-sm" : "q-mb-lg"),
              "data-automation": _ctx.buildId("date-before-options"),
              "model-value": _ctx.dateFilterOption,
              options: _ctx.filter.beforeOptions,
              "onUpdate:modelValue": _ctx.onUpdateDateFilterOption
            }, null, 8, ["class", "data-automation", "model-value", "options", "onUpdate:modelValue"])) : createCommentVNode("", true),
            withDirectives(createVNode(_component_DatePicker, {
              modelValue: _ctx.dateStart,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.dateStart = $event),
              "data-automation": _ctx.buildId("start-date"),
              options: _ctx.startRestrictions,
              placeholder: _ctx.t("rvai-base.filters.date.startDate"),
              "validation-error": _ctx.v$.originalValueStart.$error ? _ctx.v$.originalValueStart.$errors[0].$message : "",
              "with-validation": "",
              "wrapper-class": "q-mb-md",
              "onUpdate:originalValue": _ctx.setOriginalValueStart
            }, null, 8, ["modelValue", "data-automation", "options", "placeholder", "validation-error", "onUpdate:originalValue"]), [
              [vShow, _ctx.showDefaultDateFilter]
            ]),
            withDirectives(createVNode(_component_DatePicker, {
              modelValue: _ctx.dateEnd,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.dateEnd = $event),
              "data-automation": _ctx.buildId("end-date"),
              options: _ctx.endRestrictions,
              placeholder: _ctx.t("rvai-base.filters.date.endDate"),
              "validation-error": _ctx.v$.originalValueEnd.$error ? _ctx.v$.originalValueEnd.$errors[0].$message : "",
              "with-validation": "",
              "onUpdate:originalValue": _ctx.setOriginalValueEnd
            }, null, 8, ["modelValue", "data-automation", "options", "placeholder", "validation-error", "onUpdate:originalValue"]), [
              [vShow, _ctx.showDefaultDateFilter]
            ])
          ], 64)) : _ctx.isList ? (openBlock(), createBlock(_component_ScrollArea, {
            key: 1,
            "no-horizontal": "",
            "no-scroll": !_ctx.showScroll,
            style: normalizeStyle(_ctx.showScroll && {
              height: _ctx.scrollHeight
            })
          }, {
            default: withCtx(() => [
              createVNode(_component_OptionGroup, {
                modelValue: _ctx.listValue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.listValue = $event),
                "data-automation": _ctx.buildId("options"),
                options: "options" in _ctx.filter ? _ctx.filter.options : [],
                type: "checkbox"
              }, {
                "after-label": withCtx(({ option }) => [
                  createElementVNode("div", null, toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [option.count])), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "data-automation", "options"])
            ]),
            _: 1
          }, 8, ["no-scroll", "style"])) : _ctx.isSingle ? (openBlock(), createBlock(_component_ScrollArea, {
            key: 2,
            "no-horizontal": "",
            "no-scroll": !_ctx.showScroll,
            style: normalizeStyle(_ctx.showScroll && {
              height: _ctx.scrollHeight
            })
          }, {
            default: withCtx(() => [
              createVNode(_component_OptionGroup, {
                modelValue: _ctx.singleValue,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.singleValue = $event),
                "data-automation": _ctx.buildId("options"),
                options: "options" in _ctx.filter ? _ctx.filter.options : [],
                type: "radio"
              }, {
                label: withCtx(({ option }) => [
                  createVNode(_component_QItemLabel, {
                    class: "row no-wrap full-width text-grey-1",
                    "data-automation": _ctx.buildId(`option-single-${_ctx.kebabCase(option.label)}`)
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_EllipsisText, {
                        text: option.label
                      }, null, 8, ["text"]),
                      createVNode(_component_QSpace),
                      createElementVNode("div", null, toDisplayString(_ctx.t("rvai-base.general.common.wordInBrackets", [option.count])), 1)
                    ]),
                    _: 2
                  }, 1032, ["data-automation"])
                ]),
                _: 1
              }, 8, ["modelValue", "data-automation", "options"])
            ]),
            _: 1
          }, 8, ["no-scroll", "style"])) : _ctx.isNumber ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
            createElementVNode("div", _hoisted_1$d, [
              createElementVNode("span", _hoisted_2$7, toDisplayString(_ctx.numberRange.min), 1),
              createVNode(_component_QRange, {
                "data-automation": _ctx.buildId("range"),
                label: "",
                max: _ctx.numberRange.max,
                min: _ctx.numberRange.min,
                "model-value": _ctx.numberValue,
                step: _ctx.filter.step,
                onChange: _ctx.onUpdateNumber
              }, null, 8, ["data-automation", "max", "min", "model-value", "step", "onChange"]),
              createElementVNode("span", _hoisted_3$6, toDisplayString(_ctx.numberRange.max), 1)
            ]),
            createElementVNode("div", _hoisted_4$3, [
              createVNode(_component_RvInput, {
                modelValue: _ctx.numberValue.min,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => _ctx.numberValue.min = $event),
                class: "col-5",
                "data-automation": _ctx.buildId("min"),
                label: _ctx.t("rvai-base.general.inputs.from"),
                onChange: _cache[5] || (_cache[5] = ($event) => _ctx.onUpdateNumber({ min: Number($event), max: _ctx.numberValue.max }))
              }, null, 8, ["modelValue", "data-automation", "label"]),
              createElementVNode("span", _hoisted_5$3, toDisplayString(_ctx.t("rvai-base.general.symbols.dash")), 1),
              createVNode(_component_RvInput, {
                modelValue: _ctx.numberValue.max,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => _ctx.numberValue.max = $event),
                class: "col-5",
                "data-automation": _ctx.buildId("max"),
                label: _ctx.t("rvai-base.general.inputs.until"),
                onChange: _cache[7] || (_cache[7] = ($event) => _ctx.onUpdateNumber({ min: _ctx.numberValue.min, max: Number($event) }))
              }, null, 8, ["modelValue", "data-automation", "label"])
            ])
          ], 64)) : createCommentVNode("", true)
        ])
      ];
    }),
    _: 1
  }, 16, ["data-automation", "default-opened", "label"]);
}
const TableFilterItem = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$9]]);
const _sfc_main$g = defineComponent({
  name: "TableFilter",
  components: {
    QList: QList_default,
    RvButton: Button,
    TableFilterItem
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    /**
     * The maximum number of items to display in a filter item. If set to 0, all items are shown. Default: 0
     */
    scrollMaxItems: {
      type: Number,
      default: 0
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    const { setHasRightContent } = useLayout();
    const {
      filterOptionsOpenedByDefault,
      hasFilters,
      resetFilters,
      visibleFilterOptions
    } = useTable();
    function hasValue(option) {
      return option.type === TableFilterType.Number ? option.max !== 0 : option.options.length !== 0;
    }
    function isDateFilter(option) {
      return option.type === TableFilterType.Date;
    }
    watch(
      visibleFilterOptions,
      () => {
        setHasRightContent(!!Object.keys(visibleFilterOptions.value).length);
      },
      { immediate: true }
    );
    onUnmounted(() => {
      setHasRightContent(true);
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      filterOptionsOpenedByDefault,
      hasFilters,
      hasValue,
      isDateFilter,
      kebabCase,
      resetFilters,
      t: t2,
      visibleFilterOptions
    };
  }
});
const _hoisted_1$c = ["data-automation"];
const _hoisted_2$6 = { class: "flex justify-between q-mb-sm" };
const _hoisted_3$5 = { class: "text-subtitle1" };
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RvButton = resolveComponent("RvButton");
  const _component_TableFilterItem = resolveComponent("TableFilterItem");
  const _component_QList = resolveComponent("QList");
  return openBlock(), createElementBlock("div", mergeProps(_ctx.dataAttrs, {
    class: "rv-table-filter q-px-lg q-py-md bg-white rounded-borders",
    "data-automation": _ctx.buildId()
  }), [
    createElementVNode("div", _hoisted_2$6, [
      createElementVNode("div", _hoisted_3$5, toDisplayString(_ctx.t("rvai-base.general.text.filter")), 1),
      _ctx.hasFilters ? (openBlock(), createBlock(_component_RvButton, {
        key: 0,
        class: "text-capitalize",
        "data-automation": _ctx.buildId("clear"),
        label: _ctx.t("rvai-base.general.text.clear"),
        size: "sm",
        tertiary: "",
        onClick: _ctx.resetFilters
      }, null, 8, ["data-automation", "label", "onClick"])) : createCommentVNode("", true)
    ]),
    createVNode(_component_QList, null, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.visibleFilterOptions, (option, key) => {
          return openBlock(), createElementBlock(Fragment, { key }, [
            _ctx.hasValue(option) || _ctx.isDateFilter(option) ? (openBlock(), createBlock(_component_TableFilterItem, {
              key: 0,
              class: "q-py-sm",
              "data-automation": _ctx.buildId(`item-${_ctx.kebabCase(key)}`),
              "default-opened": _ctx.filterOptionsOpenedByDefault.includes(key),
              "filter-key": key,
              "scroll-max-items": _ctx.scrollMaxItems
            }, null, 8, ["data-automation", "default-opened", "filter-key", "scroll-max-items"])) : createCommentVNode("", true)
          ], 64);
        }), 128))
      ]),
      _: 1
    })
  ], 16, _hoisted_1$c);
}
const TableFilter = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$8], ["__scopeId", "data-v-969d2a9b"]]);
const _sfc_main$f = defineComponent({
  name: "TableList",
  components: {
    EllipsisText,
    Tooltip
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    disable: {
      type: Boolean,
      default: false
    },
    emptyValue: {
      type: String,
      default: void 0
    },
    multipleRows: {
      type: Boolean,
      default: false
    },
    values: {
      type: Array,
      required: true
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    const tooltip = computed(() => props4.values.slice(1).join(", "));
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      t: t2,
      tooltip
    };
  }
});
const _hoisted_1$b = ["data-automation"];
const _hoisted_2$5 = {
  key: 0,
  class: "rv-table-list cursor-pointer"
};
const _hoisted_3$4 = { class: "show-more" };
const _hoisted_4$2 = { class: "show-more" };
const _hoisted_5$2 = { key: 3 };
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EllipsisText = resolveComponent("EllipsisText");
  const _component_Tooltip = resolveComponent("Tooltip");
  return _ctx.values.length > 1 && !_ctx.multipleRows ? (openBlock(), createElementBlock("span", {
    key: 0,
    class: normalizeClass(["row no-wrap", { "text-grey-2": _ctx.disable }]),
    "data-automation": _ctx.buildId()
  }, [
    createVNode(_component_EllipsisText, {
      text: _ctx.values[0]
    }, null, 8, ["text"]),
    _ctx.values.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_2$5, [
      createElementVNode("span", null, toDisplayString(_ctx.t("rvai-base.general.symbols.comma") + " "), 1),
      createElementVNode("span", _hoisted_3$4, toDisplayString(_ctx.t("rvai-base.general.text.more", [_ctx.values.length - 1])), 1),
      createVNode(_component_Tooltip, {
        arrow: "top",
        offset: [0, 10]
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.tooltip), 1)
        ]),
        _: 1
      })
    ])) : createCommentVNode("", true)
  ], 10, _hoisted_1$b)) : _ctx.values.length > 1 && _ctx.multipleRows ? (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(["rv-table-list cursor-pointer", { "text-grey-2": _ctx.disable }])
  }, [
    createVNode(_component_EllipsisText, {
      text: _ctx.values[0]
    }, null, 8, ["text"]),
    createElementVNode("span", _hoisted_4$2, toDisplayString(_ctx.t("rvai-base.general.text.more", [_ctx.values.length - 1])), 1),
    createVNode(_component_Tooltip, {
      anchor: "bottom left",
      arrow: "top",
      self: "center left"
    }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString(_ctx.tooltip), 1)
      ]),
      _: 1
    })
  ], 2)) : _ctx.values.length === 1 ? (openBlock(), createElementBlock("span", {
    key: 2,
    class: normalizeClass(["rv-table-list", { "text-grey-2": _ctx.disable }])
  }, [
    createVNode(_component_EllipsisText, {
      text: _ctx.values[0]
    }, null, 8, ["text"])
  ], 2)) : (openBlock(), createElementBlock("span", _hoisted_5$2, toDisplayString(_ctx.emptyValue), 1));
}
const TableList = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$7], ["__scopeId", "data-v-f9dfed45"]]);
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "Tabs",
  props: {
    dataAutomation: {
      default: void 0,
      type: String
    },
    modelValue: {
      default: void 0,
      type: [String, Number, void 0]
    },
    optionLabel: {
      default: "label",
      type: String
    },
    options: {
      required: true,
      type: Array
    },
    optionValue: {
      default: "name",
      type: String
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props4 = __props;
    const emit = __emit;
    const { buildId } = useAutomation(props4.dataAutomation);
    const selectedTab = computed({
      get() {
        return props4.modelValue;
      },
      set(value2) {
        emit("update:modelValue", value2);
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(QTabs_default), {
        modelValue: selectedTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selectedTab.value = $event),
        class: "tab-container bg-white rounded-borders",
        "data-automation": unref(buildId)(),
        dense: "",
        "indicator-color": "primary",
        "inline-label": "",
        "narrow-indicator": "",
        shrink: "",
        stretch: ""
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (option) => {
            return openBlock(), createBlock(resolveDynamicComponent(option.to ? unref(QRouteTab_default) : unref(QTab_default)), {
              key: option[__props.optionValue],
              class: "q-px-sm",
              "content-class": "q-px-sm text-body3",
              "data-automation": unref(buildId)(`tab-${option[__props.optionValue]}`),
              exact: option.exact,
              label: option[__props.optionLabel],
              name: option[__props.optionValue],
              "no-caps": "",
              ripple: false,
              to: option.to
            }, null, 8, ["data-automation", "exact", "label", "name", "to"]);
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "data-automation"]);
    };
  }
});
const Tabs = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["__scopeId", "data-v-94338ea0"]]);
const _sfc_main$d = defineComponent({
  name: "UsersGroup",
  components: {
    Avatar
  },
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    idKey: {
      type: String,
      required: true
    },
    labelKey: {
      type: String,
      required: true
    },
    maxLength: {
      type: Number,
      default: 10
    },
    overrideCurrentUserAvatar: {
      type: Boolean,
      default: false
    },
    users: {
      type: Array,
      required: true
    }
  },
  setup(props4) {
    const { t: t2 } = useI18n();
    const filteredUsers = computed(() => {
      return props4.users.length > props4.maxLength ? props4.users.slice(0, props4.maxLength - 1) : props4.users;
    });
    const hidden = computed(() => {
      return props4.users.length - filteredUsers.value.length;
    });
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      filteredUsers,
      hidden,
      t: t2
    };
  }
});
const _hoisted_1$a = ["data-automation"];
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = resolveComponent("Avatar");
  return openBlock(), createElementBlock("div", {
    "data-automation": _ctx.buildId()
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.filteredUsers, (user, index) => {
      return openBlock(), createBlock(_component_Avatar, mergeProps({
        key: user[_ctx.idKey]
      }, { ref_for: true }, _ctx.$attrs, {
        "background-color": _ctx.overrideCurrentUserAvatar && user.isCurrent ? "white" : user.color,
        "border-color": _ctx.overrideCurrentUserAvatar && user.isCurrent ? "grey-1" : "white",
        class: "users-group__avatar",
        "data-automation": _ctx.buildId(`${user[_ctx.idKey]}`),
        label: user[_ctx.labelKey],
        style: { zIndex: _ctx.filteredUsers.length - index },
        "text-color": _ctx.overrideCurrentUserAvatar && user.isCurrent ? "grey-1" : "",
        uuid: user[_ctx.idKey]
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", mergeProps({ ref_for: true }, user || {}), void 0, true)
        ]),
        _: 2
      }, 1040, ["background-color", "border-color", "data-automation", "label", "style", "text-color", "uuid"]);
    }), 128)),
    _ctx.hidden ? (openBlock(), createBlock(_component_Avatar, mergeProps({ key: 0 }, _ctx.$attrs, {
      class: "users-group__avatar",
      "data-automation": _ctx.buildId("hidden"),
      label: _ctx.t("rvai-base.general.text.more", [_ctx.hidden]),
      "no-initial": "",
      style: { zIndex: 0 }
    }), null, 16, ["data-automation", "label"])) : createCommentVNode("", true)
  ], 8, _hoisted_1$a);
}
const UsersGroup = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$6], ["__scopeId", "data-v-81c65878"]]);
const _sfc_main$c = defineComponent({
  name: "ValidationTooltip",
  components: {
    Bullet,
    Tooltip
  },
  inheritAttrs: false,
  props: {
    /**
     * Automation ID to easily find element in the DOM by its value
     */
    dataAutomation: {
      type: String,
      default: void 0
    },
    exclude: {
      type: Array,
      default: () => []
    },
    /**
     * The text that will be shown above the input
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Model of the component; Either use this property (along with a listener for 'update:modelValue' event) OR use v-model directive
     */
    modelValue: {
      type: Boolean,
      default: false
    },
    /**
     * Validation for the component
     */
    validation: {
      type: Object,
      required: true
    }
  },
  emits: [
    /**
     * Emitted when the component needs to change the model; Is also used by v-model
     *
     * @type {[string, number]}
     */
    "update:modelValue"
  ],
  setup(props4) {
    const { t: t2 } = useI18n();
    const results = computed(() => {
      return Object.entries(props4.validation).filter(([key]) => !key.startsWith("$") && !props4.exclude.includes(key)).map(([key, rule]) => {
        return {
          key,
          message: rule.$message,
          valid: props4.validation.$dirty ? !rule.$invalid : void 0
        };
      });
    });
    function iconColor(valid) {
      if (valid) {
        return "positive";
      } else if (valid === false) {
        return "negative";
      } else {
        return "grey-1-fixed";
      }
    }
    return {
      ...useAutomation(computed(() => props4.dataAutomation)),
      iconColor,
      results,
      t: t2
    };
  }
});
const _hoisted_1$9 = {
  key: 0,
  class: "q-ml-xs"
};
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Bullet = resolveComponent("Bullet");
  const _component_Tooltip = resolveComponent("Tooltip");
  return openBlock(), createBlock(_component_Tooltip, mergeProps(_ctx.dataAttrs, {
    anchor: "bottom left",
    arrow: "top",
    class: "text-grey-1-fixed text-small",
    "data-automation": _ctx.buildId(),
    "model-value": _ctx.modelValue,
    offset: [0, 4],
    self: "top left",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.$emit("update:modelValue", $event))
  }), {
    default: withCtx(() => [
      _ctx.label ? (openBlock(), createElementBlock("div", _hoisted_1$9, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true),
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.results, (entry) => {
        return openBlock(), createElementBlock("div", {
          key: entry.key,
          class: normalizeClass(["row no-wrap", { "text-negative": entry.valid === false }])
        }, [
          createVNode(_component_Bullet, {
            class: "q-mx-sm",
            color: _ctx.iconColor(entry.valid),
            "no-contrast-border": "",
            rounded: "",
            size: "4"
          }, null, 8, ["color"]),
          createTextVNode(" " + toDisplayString(entry.message), 1)
        ], 2);
      }), 128))
    ]),
    _: 1
  }, 16, ["data-automation", "model-value"]);
}
const ValidationTooltip = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$5]]);
const _hoisted_1$8 = ["data-automation"];
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "WaferMapWarning",
  props: {
    dataAutomation: {
      default: "wafer-map-warning",
      type: String
    },
    fullscreen: {
      default: false,
      type: Boolean
    },
    samplesCount: {
      required: true,
      type: Number
    },
    totalCount: {
      required: true,
      type: Number
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      const _component_q_icon = resolveComponent("q-icon");
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["border-blue text-small rounded-borders q-pa-sm q-mb-md flex no-wrap text-blue", { "items-center": __props.fullscreen }]),
        "data-automation": unref(buildId)()
      }, [
        createVNode(_component_q_icon, {
          class: "q-mr-sm",
          color: "blue",
          "data-automation": unref(buildId)("icon"),
          name: "mdi-information",
          size: "24px"
        }, null, 8, ["data-automation"]),
        createElementVNode("div", null, toDisplayString(_ctx.$t("rvai-base.components.waferMap.locationMissing", [__props.totalCount - __props.samplesCount, __props.totalCount])), 1)
      ], 10, _hoisted_1$8);
    };
  }
});
const emptyWaferBackground = "data:image/svg+xml,%3csvg%20width='1800'%20height='1800'%20viewBox='0%200%201800%201800'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='900'%20cy='900'%20r='900'%20fill='%23F5F6F9'%20/%3e%3c/svg%3e";
const _hoisted_1$7 = { class: "row full-width row no-wrap justify-end q-mb-md" };
const _hoisted_2$4 = { class: "row no-wrap offset-4 col-4 justify-center items-center" };
const _hoisted_3$3 = { class: "row no-wrap col-4 justify-end" };
const _hoisted_4$1 = {
  key: 0,
  class: "row justify-center"
};
const _hoisted_5$1 = {
  key: 1,
  class: "q-gutter-sm z-top"
};
const _hoisted_6$1 = { class: "absolute-top-right wafer-map__controls__splitview--top z-top q-mr-md" };
const _hoisted_7$1 = {
  key: 0,
  class: "row no-wrap items-center q-mt-sm"
};
const _hoisted_8 = { class: "flex row no-wrap q-mt-sm" };
const _hoisted_9 = { style: { "min-width": "49px" } };
const _hoisted_10 = { style: { "min-width": "49px" } };
const _hoisted_11 = { style: { "min-width": "58px" } };
const canvasSpacing = 32;
const zoomRatio = 0.4;
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "WaferMapChart",
  props: {
    annotationSources: {
      default: void 0,
      type: Array
    },
    backgroundImage: {
      default: emptyWaferBackground,
      type: String
    },
    dataset: {
      required: true,
      type: Object
    },
    fullscreen: {
      default: false,
      type: Boolean
    },
    isSplitView: {
      default: false,
      type: Boolean
    },
    modelValue: {
      required: true,
      type: Array
    }
  },
  emits: ["resetBackground", "toggleFullscreen", "update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    var _a;
    const props4 = __props;
    const emit = __emit;
    const { t: t2 } = useI18n();
    const { getPaletteColorCache } = usePaletteColorsCache();
    const greyPaletteColor = getPaletteColorCache("grey-3");
    const primaryPaletteColor = getPaletteColorCache("primary");
    const canvas = ref$1();
    const disableZoomOut = ref$1(true);
    const disableResetView = ref$1(true);
    const scatterplotRef = ref$1();
    const showTooltip = ref$1(false);
    const tooltip = ref$1();
    const mouseMode = ref$1("panZoom");
    const isSkipSelectionSync = ref$1(false);
    const canvasClientHeight = ref$1((_a = canvas.value) == null ? void 0 : _a.clientHeight);
    __expose({
      canvasClientHeight
    });
    const selection = computed(() => props4.modelValue);
    const classesColors = computed(() => props4.dataset.classes.map((c2) => c2.id === "unannotated" ? greyPaletteColor : c2.color));
    const classesNames = computed(() => props4.dataset.classes.map((c2) => c2.id === "unannotated" ? t2("rvai-base.components.waferMap.notAnnotated") : c2.name));
    const points = computed(() => props4.dataset.dataPoints);
    const sampleInfo = computed(() => props4.dataset.samples);
    const samplesCount = computed(() => props4.dataset.samplesCount);
    const totalSampleCount = computed(() => props4.dataset.totalCount);
    const showMissingPointsInfo = computed(() => totalSampleCount.value !== samplesCount.value);
    const lassoActive = computed(() => mouseMode.value === "lasso");
    const menuItems = computed(() => [
      {
        disabled: !selection.value.length,
        label: t2("rvai-base.components.waferMap.deselect"),
        onClick: deselectHandler
      },
      {
        disabled: disableResetView.value,
        label: t2("rvai-base.components.waferMap.resetZoomLevel"),
        onClick: resetView
      }
    ]);
    async function createScatterplotView() {
      const scatterplot = createScatterplot({
        backgroundImage: props4.backgroundImage,
        canvas: canvas.value,
        pointSize: 5
      });
      const isMac = window.navigator.userAgent.toLocaleUpperCase().indexOf("MAC") !== -1;
      scatterplot.set({
        colorBy: "w",
        // @ts-expect-error fix for regl-scatterplot
        keyMap: {
          alt: "rotate",
          // I opened a bug on the regl-scatterplot github because we can't set both.
          ...isMac ? { cmd: "merge" } : { ctrl: "merge" },
          shift: "lasso"
        },
        lassoColor: primaryPaletteColor,
        pointColor: classesColors.value,
        // Sometimes when we only have unannotated data, the color on hover changes to white, this fixes it
        // @ts-expect-error regl-scatterplot accepts hex colors but types expect RGB arrays
        pointColorActive: classesColors.value,
        // @ts-expect-error regl-scatterplot accepts hex colors but types expect RGB arrays
        pointColorHover: classesColors.value
      });
      scatterplot.subscribe("pointOver", pointOverHandler);
      scatterplot.subscribe("pointOut", pointOutHandler);
      scatterplot.subscribe("view", viewHandler);
      scatterplot.subscribe("select", selectHandler);
      scatterplot.subscribe("deselect", deselectHandler);
      scatterplot.subscribe("lassoEnd", () => {
        mouseMode.value = "panZoom";
      });
      scatterplot.get("camera").setScaleBounds([1, Infinity]);
      await scatterplot.draw(points.value);
      scatterplotRef.value = scatterplot;
      updateSelection(props4.modelValue);
    }
    function createTooltip(pointIndex) {
      var _a2, _b, _c, _d;
      const { height: height2 } = scatterplotRef.value.get("canvas").getBoundingClientRect();
      const [x2, y3] = scatterplotRef.value.getScreenPosition(pointIndex);
      const classIndex = getClassIndex(pointIndex);
      const sampleData = (_a2 = sampleInfo.value) == null ? void 0 : _a2[pointIndex];
      const tooltipHeight = 94;
      const averagePointSizeInPixels = 10;
      let verticalOffset = -y3 - tooltipHeight / 4;
      if (Math.abs(verticalOffset) + tooltipHeight > height2) {
        verticalOffset = -y3 + tooltipHeight + averagePointSizeInPixels;
      }
      const offset2 = [-x2, verticalOffset];
      tooltip.value = {
        classColor: (_b = classesColors.value) == null ? void 0 : _b[classIndex],
        classLabel: (_c = classesNames.value) == null ? void 0 : _c[classIndex],
        offset: offset2,
        sampleName: sampleData == null ? void 0 : sampleData.name,
        sourceData: getSourceData((_d = sampleData == null ? void 0 : sampleData.metadata) == null ? void 0 : _d.source_id)
      };
      showTooltip.value = true;
    }
    function getClassIndex(pointIndex) {
      var _a2;
      return (_a2 = points.value[pointIndex]) == null ? void 0 : _a2[3];
    }
    function getSourceData(id3) {
      var _a2, _b;
      if (!id3) return;
      return (_b = (_a2 = props4 == null ? void 0 : props4.annotationSources) == null ? void 0 : _a2.filter((s3) => s3.id === id3)) == null ? void 0 : _b[0];
    }
    function onResize({
      height: height2,
      width
    }) {
      var _a2;
      (_a2 = scatterplotRef.value) == null ? void 0 : _a2.set({
        height: height2 - canvasSpacing,
        width: width - canvasSpacing
      });
      emit("resetBackground");
    }
    const selectHandler = ({ points: points2 }) => {
      const sampleIds = points2.map((p) => {
        var _a2, _b;
        return (_b = (_a2 = sampleInfo == null ? void 0 : sampleInfo.value) == null ? void 0 : _a2[p]) == null ? void 0 : _b.id;
      }).filter(Boolean);
      isSkipSelectionSync.value = true;
      emit("update:modelValue", sampleIds);
    };
    const deselectHandler = () => {
      emit("update:modelValue", []);
    };
    function pointOutHandler() {
      tooltip.value = null;
      showTooltip.value = false;
    }
    function pointOverHandler(pointIndex) {
      createTooltip(pointIndex);
    }
    function resetView() {
      emit("resetBackground");
      scatterplotRef.value.reset();
    }
    function viewHandler(event) {
      disableZoomOut.value = event.camera.distance[0] === 1 && event.camera.distance[1] === 1;
      disableResetView.value = disableZoomOut.value && event.camera.target[0] === 0 && event.camera.target[1] === 0;
    }
    function zoomIn() {
      const camera = scatterplotRef.value.get("camera");
      const distance = camera.distance[0] - camera.distance[0] * zoomRatio;
      scatterplotRef.value.zoomToLocation(
        camera.target,
        distance,
        { transition: true }
      );
    }
    function zoomOut() {
      const camera = scatterplotRef.value.get("camera");
      const distance = camera.distance[0] / (1 - zoomRatio);
      scatterplotRef.value.zoomToLocation(
        camera.target,
        distance < 1 ? distance : 1,
        { transition: true }
      );
    }
    function updateSelection(value2) {
      if (!(sampleInfo.value && scatterplotRef.value)) return;
      const sampleIndices = [];
      for (let i2 = 0; i2 < (sampleInfo == null ? void 0 : sampleInfo.value.length); i2++) {
        const sample = sampleInfo == null ? void 0 : sampleInfo.value[i2];
        if ((sample == null ? void 0 : sample.id) && value2.includes(sample.id)) {
          sampleIndices.push(i2);
        }
        if (value2.length === sampleIndices.length) {
          break;
        }
      }
      scatterplotRef.value.select(sampleIndices, { preventEvent: true });
    }
    function toggleLasso() {
      mouseMode.value = mouseMode.value === "lasso" ? "panZoom" : "lasso";
    }
    watch(mouseMode, (value2) => {
      if (canvas.value) {
        if (value2 === "lasso") {
          scatterplotRef.value.set({ mouseMode: "lasso" });
          canvas.value.style.cursor = "crosshair";
        } else {
          scatterplotRef.value.set({ mouseMode: "panZoom" });
          canvas.value.style.cursor = "default";
        }
      }
    });
    watch(selection, (value2) => {
      if (value2.length === 0 || !isSkipSelectionSync.value) {
        updateSelection(value2);
      }
      isSkipSelectionSync.value = false;
    });
    watch(() => props4.backgroundImage, (backgroundImage) => {
      var _a2;
      (_a2 = scatterplotRef.value) == null ? void 0 : _a2.set({
        backgroundImage
      });
    });
    watch(points, (current, prev) => {
      if (!arrayShallowEqual(prev, current)) {
        scatterplotRef == null ? void 0 : scatterplotRef.value.draw(points.value);
      }
    }, { deep: true });
    watch(() => {
      var _a2;
      return (_a2 = canvas.value) == null ? void 0 : _a2.clientHeight;
    }, (height2) => {
      canvasClientHeight.value = height2;
    }, { immediate: true });
    onUnmounted(() => {
      var _a2;
      (_a2 = scatterplotRef.value) == null ? void 0 : _a2.destroy();
    });
    onMounted(async () => {
      await createScatterplotView();
    });
    return (_ctx, _cache) => {
      const _component_i18n_t = resolveComponent("i18n-t");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          class: normalizeClass(["canvas-wrapper", { "canvas-wrapper--border q-pa-md rounded-borders": __props.isSplitView }]),
          "data-automation": "wafer-map-chart"
        }, [
          createElementVNode("div", {
            class: normalizeClass(["wafer-map__controls__container__top", __props.fullscreen ? "wafer-map__controls__container__top--fullscreen" : "absolute-top-right"])
          }, [
            __props.fullscreen ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createElementVNode("div", _hoisted_1$7, [
                createElementVNode("div", _hoisted_2$4, [
                  createVNode(_component_i18n_t, {
                    keypath: "rvai-base.components.waferMap.selectedCount",
                    tag: "div"
                  }, {
                    selectedSamples: withCtx(() => [
                      createElementVNode("strong", null, toDisplayString(selection.value.length), 1)
                    ]),
                    totalSamples: withCtx(() => [
                      createElementVNode("strong", null, toDisplayString(samplesCount.value), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(Button, {
                    class: "q-ml-sm",
                    "data-automation": "wafer-map__controls__deselect",
                    disable: !selection.value.length,
                    label: _ctx.$t("rvai-base.components.waferMap.deselect"),
                    size: "sm",
                    tertiary: "",
                    onClick: deselectHandler
                  }, null, 8, ["disable", "label"])
                ]),
                createElementVNode("div", _hoisted_3$3, [
                  createVNode(Button, {
                    class: "wafer-map__controls__lasso z-top bg-white shadow",
                    color: lassoActive.value ? "primary" : "black-1",
                    "data-automation": "wafer-map__lasso-select",
                    icon: "rvai-base:lasso",
                    label: _ctx.$t("rvai-base.components.waferMap.makeFreehandSelection"),
                    size: "sm",
                    tertiary: "",
                    onClick: withModifiers(toggleLasso, ["stop"])
                  }, null, 8, ["color", "label"])
                ])
              ]),
              showMissingPointsInfo.value ? (openBlock(), createElementBlock("div", _hoisted_4$1, [
                createVNode(_sfc_main$b, {
                  fullscreen: "",
                  "samples-count": samplesCount.value,
                  "total-count": totalSampleCount.value
                }, null, 8, ["samples-count", "total-count"])
              ])) : createCommentVNode("", true)
            ], 64)) : !__props.isSplitView ? (openBlock(), createElementBlock("div", _hoisted_5$1, [
              createVNode(Button, {
                class: normalizeClass(["bg-white shadow", { "bg-grey-6": lassoActive.value }]),
                color: lassoActive.value ? "primary" : "black-1",
                "data-automation": "wafer-map__lasso-select",
                icon: "rvai-base:lasso",
                secondary: "",
                size: "xs",
                onClick: withModifiers(toggleLasso, ["stop"])
              }, {
                default: withCtx(() => [
                  createVNode(Tooltip, {
                    anchor: "top middle",
                    "data-automation": "wafer-map__reset-view--tooltip",
                    self: "center end"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.$t("rvai-base.components.waferMap.makeFreehandSelection")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class", "color"]),
              createVNode(Button, {
                class: "bg-white shadow",
                "data-automation": "wafer-map__controls__full-screen",
                icon: "fullscreen",
                secondary: "",
                size: "xs",
                onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("toggleFullscreen"), ["stop"]))
              })
            ])) : createCommentVNode("", true)
          ], 2),
          __props.isSplitView ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createVNode(Button, {
              class: "absolute-top-left wafer-map__controls__splitview--top wafer-map__controls__lasso bg-white q-ml-md shadow",
              color: lassoActive.value ? "primary" : "black-1",
              "data-automation": "wafer-map__lasso-select",
              icon: "rvai-base:lasso",
              label: _ctx.$t("rvai-base.components.waferMap.makeFreehandSelection"),
              size: "sm",
              tertiary: "",
              onClick: withModifiers(toggleLasso, ["stop"])
            }, null, 8, ["color", "label"]),
            createElementVNode("div", _hoisted_6$1, [
              createVNode(Button, {
                class: "wafer-map__controls__deselect bg-white q-mx-sm",
                "data-automation": "wafer-map__controls__deselect",
                disable: !selection.value.length,
                label: _ctx.$t("rvai-base.components.waferMap.deselect"),
                size: "sm",
                tertiary: "",
                onClick: deselectHandler
              }, null, 8, ["disable", "label"]),
              createVNode(Button, {
                class: "bg-white shadow",
                "data-automation": "wafer-map__controls__full-screen",
                icon: "fullscreen",
                secondary: "",
                size: "xs",
                onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.$emit("toggleFullscreen"), ["stop"]))
              })
            ])
          ], 64)) : createCommentVNode("", true),
          createElementVNode("canvas", {
            ref_key: "canvas",
            ref: canvas,
            class: "canvas bg-white",
            "data-automation": "wafer-map__canvas"
          }, null, 512),
          createVNode(unref(QResizeObserver_default), { onResize }),
          !!tooltip.value ? (openBlock(), createBlock(Tooltip, {
            key: 1,
            modelValue: showTooltip.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => showTooltip.value = $event),
            anchor: "top left",
            "data-automation": "wafer-map__data-tooltip",
            "max-width": "170px",
            offset: tooltip.value.offset,
            self: "top middle",
            target: ".canvas"
          }, {
            default: withCtx(() => {
              var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
              return [
                createElementVNode("strong", null, [
                  createVNode(EllipsisText, {
                    "data-automation": "sampleName",
                    text: tooltip.value.sampleName
                  }, null, 8, ["text"])
                ]),
                ((_a2 = tooltip.value.sourceData) == null ? void 0 : _a2.id) ? (openBlock(), createElementBlock("div", _hoisted_7$1, [
                  createVNode(Avatar, {
                    "background-color": ((_b = tooltip.value.sourceData) == null ? void 0 : _b.isCurrent) ? "white" : (_c = tooltip.value.sourceData) == null ? void 0 : _c.color,
                    "border-color": ((_d = tooltip.value.sourceData) == null ? void 0 : _d.isCurrent) ? "grey-1" : void 0,
                    "data-automation": "source-avatar",
                    label: (_e = tooltip.value.sourceData) == null ? void 0 : _e.name,
                    "show-logo": !((_f = tooltip.value.sourceData) == null ? void 0 : _f.isUser),
                    size: "sm",
                    "text-color": ((_g = tooltip.value.sourceData) == null ? void 0 : _g.isCurrent) ? "grey-1" : "",
                    uuid: (_h = tooltip.value.sourceData) == null ? void 0 : _h.id
                  }, null, 8, ["background-color", "border-color", "label", "show-logo", "text-color", "uuid"]),
                  createVNode(EllipsisText, {
                    class: "q-ml-xs",
                    "data-automation": "source-name",
                    text: (_i = tooltip.value.sourceData) == null ? void 0 : _i.name
                  }, null, 8, ["text"])
                ])) : createCommentVNode("", true),
                createElementVNode("div", _hoisted_8, [
                  ((_j = tooltip.value.sourceData) == null ? void 0 : _j.id) ? (openBlock(), createBlock(Bullet, {
                    key: 0,
                    class: "q-ml-xs",
                    color: tooltip.value.classColor,
                    "data-automation": "class-color",
                    size: "12"
                  }, null, 8, ["color"])) : createCommentVNode("", true),
                  createVNode(EllipsisText, {
                    class: normalizeClass({ "q-ml-sm": (_k = tooltip.value.sourceData) == null ? void 0 : _k.id }),
                    "data-automation": "class-name",
                    text: tooltip.value.classLabel
                  }, null, 8, ["class", "text"])
                ])
              ];
            }),
            _: 1
          }, 8, ["modelValue", "offset"])) : createCommentVNode("", true)
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(["wafer-map__controls__container__bottom absolute-bottom-right column z-top", { "wafer-map__controls__container__bottom--fullscreen": __props.fullscreen || __props.isSplitView }])
        }, [
          __props.fullscreen || __props.isSplitView ? (openBlock(), createBlock(Button, {
            key: 0,
            class: normalizeClass(["bg-white q-mt-sm shadow", { "q-mr-md": __props.isSplitView }]),
            "data-automation": "wafer-map__reset-view",
            icon: "mdi-refresh",
            secondary: "",
            size: "xs",
            onClick: withModifiers(resetView, ["stop"])
          }, {
            default: withCtx(() => [
              createVNode(Tooltip, {
                anchor: "center left",
                "data-automation": "wafer-map__reset-view--tooltip",
                self: "center right"
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_9, toDisplayString(_ctx.$t("rvai-base.components.waferMap.resetZoomLevel")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"])) : (openBlock(), createBlock(Button, {
            key: 1,
            class: "bg-white shadow",
            "data-automation": "wafer-map__reset-view",
            icon: "rvai-base:meat-ball",
            secondary: "",
            size: "xs"
          }, {
            default: withCtx(() => [
              createVNode(unref(QMenu_default), {
                anchor: "bottom left",
                "auto-close": "",
                offset: [4, 0],
                self: "bottom right"
              }, {
                default: withCtx(() => [
                  createVNode(unref(QList_default), { separator: "" }, {
                    default: withCtx(() => [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(menuItems.value, (menuItem) => {
                        return openBlock(), createBlock(unref(QItem_default), {
                          key: menuItem.label,
                          clickable: "",
                          disable: menuItem.disabled,
                          onClick: menuItem.onClick
                        }, {
                          default: withCtx(() => [
                            createVNode(unref(QItemLabel_default), null, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(menuItem.label), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["disable", "onClick"]);
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
          __props.fullscreen || __props.isSplitView ? (openBlock(), createBlock(Button, {
            key: 2,
            class: normalizeClass(["bg-white q-mt-sm shadow", { "q-mr-md": __props.isSplitView }]),
            "data-automation": "wafer-map__zoom-in",
            icon: "mdi-plus",
            secondary: "",
            size: "xs",
            onClick: withModifiers(zoomIn, ["stop"])
          }, {
            default: withCtx(() => [
              createVNode(Tooltip, {
                anchor: "center left",
                "data-automation": "wafer-map__zoom-in--tooltip",
                self: "center right"
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_10, toDisplayString(_ctx.$t("rvai-base.components.waferMap.zoomIn")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"])) : createCommentVNode("", true),
          __props.fullscreen || __props.isSplitView ? (openBlock(), createBlock(Button, {
            key: 3,
            class: normalizeClass(["bg-white q-mt-sm shadow", { "q-mr-md q-mb-md": __props.isSplitView }]),
            "data-automation": "wafer-map__zoom-out",
            disable: disableZoomOut.value,
            icon: "mdi-minus",
            secondary: "",
            size: "xs",
            onClick: withModifiers(zoomOut, ["stop"])
          }, {
            default: withCtx(() => [
              createVNode(Tooltip, {
                anchor: "center left",
                "data-automation": "wafer-map__zoom-out--tooltip",
                self: "center right"
              }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_11, toDisplayString(_ctx.$t("rvai-base.components.waferMap.zoomOut")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class", "disable"])) : createCommentVNode("", true)
        ], 2)
      ], 64);
    };
  }
});
const WaferMapChart = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["__scopeId", "data-v-4b5ec1e6"]]);
const _hoisted_1$6 = ["data-automation"];
const _hoisted_2$3 = ["data-automation"];
const _hoisted_3$2 = ["data-automation"];
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "WaferMapChartFilters",
  props: {
    dataAutomation: {
      default: "wafer-map-chart-filters",
      type: String
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "border-card rounded-borders q-mb-md",
        "data-automation": unref(buildId)()
      }, [
        createVNode(ExpansionItem, {
          class: "q-px-lg q-py-md",
          "data-automation": unref(buildId)("expansion-item"),
          "default-opened": "",
          label: _ctx.$t("rvai-base.components.waferMap.chartSpecificFilters"),
          "no-hover-animation": ""
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: "text-body3",
              "data-automation": unref(buildId)("annotation-source")
            }, toDisplayString(_ctx.$t("rvai-base.components.waferMap.annotationSource")), 9, _hoisted_2$3),
            createElementVNode("div", {
              class: "text-subtitle3",
              "data-automation": unref(buildId)("last-updated-annotations")
            }, toDisplayString(_ctx.$t("rvai-base.components.waferMap.lastUpdatedAnnotations")), 9, _hoisted_3$2)
          ]),
          _: 1
        }, 8, ["data-automation", "label"])
      ], 8, _hoisted_1$6);
    };
  }
});
const _hoisted_1$5 = ["data-automation"];
const _hoisted_2$2 = ["data-automation"];
const _hoisted_3$1 = ["data-automation"];
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "WaferMapChartLegend",
  props: {
    classes: {
      required: true,
      type: Array
    },
    dataAutomation: {
      default: "wafer-map-chart-legend",
      type: String
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "border-card rounded-borders",
        "data-automation": unref(buildId)()
      }, [
        createVNode(ExpansionItem, {
          class: "q-px-lg q-py-md full-height",
          "content-class": "full-height q-mt-sm",
          "data-automation": unref(buildId)("expansion-item"),
          "default-opened": "",
          label: _ctx.$t("rvai-base.components.waferMap.annotations"),
          "no-hover-animation": ""
        }, {
          default: withCtx(() => [
            __props.classes.length ? (openBlock(), createBlock(ScrollArea, {
              key: 0,
              class: "annotation-class-item__list full-height col-grow",
              "data-automation": unref(buildId)("annotation-class-item__list"),
              "no-horizontal": ""
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(__props.classes, (annotationClass) => {
                  return openBlock(), createElementBlock("div", {
                    key: annotationClass.id,
                    class: "row no-wrap items-center q-pb-sm",
                    "data-automation": unref(buildId)("annotation-class-item")
                  }, [
                    createVNode(Bullet, {
                      class: "q-pr-sm",
                      color: annotationClass.color,
                      "data-automation": unref(buildId)("annotation-class-item__bullet"),
                      "is-tooltip-shown": false,
                      size: 8,
                      style: normalizeStyle({ visibility: annotationClass.id === "unannotated" ? "hidden" : "visible" })
                    }, null, 8, ["color", "data-automation", "style"]),
                    createVNode(EllipsisText, {
                      "data-automation": unref(buildId)("annotation-class-item__name"),
                      text: annotationClass.name
                    }, null, 8, ["data-automation", "text"])
                  ], 8, _hoisted_2$2);
                }), 128))
              ]),
              _: 1
            }, 8, ["data-automation"])) : (openBlock(), createElementBlock("div", {
              key: 1,
              "data-automation": unref(buildId)("no-items")
            }, toDisplayString(_ctx.$t("rvai-base.components.waferMap.noItems")), 9, _hoisted_3$1))
          ]),
          _: 1
        }, 8, ["data-automation", "label"])
      ], 8, _hoisted_1$5);
    };
  }
});
const WaferMapChartLegend = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["__scopeId", "data-v-6993da7d"]]);
const _hoisted_1$4 = ["data-automation"];
const _hoisted_2$1 = { key: 0 };
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "WaferMapError",
  props: {
    dataAutomation: {
      default: "wafer-map-error",
      type: String
    },
    loadingFailed: {
      default: false,
      type: Boolean
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "wafer-map-error relative-position flex items-center justify-center column text-grey-1 full-height full-width bg-grey-5 text-center",
        "data-automation": unref(buildId)()
      }, [
        createElementVNode("div", null, toDisplayString(__props.loadingFailed ? _ctx.$t("rvai-base.general.text.loadingFailed") : _ctx.$t("rvai-base.components.waferMap.noPositions")), 1),
        __props.loadingFailed ? (openBlock(), createElementBlock("div", _hoisted_2$1, toDisplayString(_ctx.$t("rvai-base.components.waferMap.loadingFailedExtra")), 1)) : createCommentVNode("", true)
      ], 8, _hoisted_1$4);
    };
  }
});
const WaferMapError = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["__scopeId", "data-v-d7cba4ff"]]);
const _hoisted_1$3 = ["data-automation"];
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "WaferMapLoader",
  props: {
    dataAutomation: {
      default: "wafer-map-loader",
      type: String
    }
  },
  setup(__props) {
    const props4 = __props;
    const { buildId } = useAutomation(props4.dataAutomation);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "relative-position flex items-center justify-center column text-grey-1 full-height full-width bg-grey-5",
        "data-automation": unref(buildId)()
      }, [
        createVNode(unref(QSpinner_default), {
          color: "primary",
          "data-automation": unref(buildId)("spinner"),
          size: "40px"
        }, null, 8, ["data-automation"]),
        createElementVNode("span", null, toDisplayString(_ctx.$t("rvai-base.general.text.loading")), 1),
        createElementVNode("span", null, toDisplayString(_ctx.$t("rvai-base.general.text.loadingExtra")), 1)
      ], 8, _hoisted_1$3);
    };
  }
});
const _hoisted_1$2 = ["data-automation"];
const _hoisted_2 = ["data-automation"];
const _hoisted_3 = ["data-automation"];
const _hoisted_4 = ["data-automation"];
const _hoisted_5 = ["data-automation"];
const _hoisted_6 = ["data-automation"];
const _hoisted_7 = ["data-automation"];
const annotationSourceHeight = 64;
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "WaferMap",
  props: {
    annotationSources: {
      default: void 0,
      type: Array
    },
    backgroundImage: {
      default: void 0,
      type: String
    },
    dataset: {
      default: () => ({}),
      type: Object
    },
    fullscreen: {
      default: false,
      type: Boolean
    },
    isPartiallyLoaded: {
      default: false,
      type: Boolean
    },
    isSplitView: {
      default: false,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    loadingFailed: {
      default: false,
      type: Boolean
    },
    modelValue: {
      required: true,
      type: Array
    }
  },
  emits: ["resetBackground", "resize", "toggleFullscreen", "update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const emit = __emit;
    const props4 = __props;
    const wrapperRef = ref$1();
    const canvasRef = ref$1();
    const canvasFullscreenRef = ref$1();
    __expose({
      canvasFullscreenRef,
      canvasRef,
      wrapperRef
    });
    const { buildId } = useAutomation("wafer-map");
    const selection = computed(() => props4.modelValue);
    const classes = computed(() => {
      var _a;
      return ((_a = props4.dataset) == null ? void 0 : _a.classes) ?? [];
    });
    const warningHeight = computed(() => {
      const blockHeight = props4.fullscreen ? 58 : 70;
      return props4.isPartiallyLoaded ? blockHeight : 0;
    });
    async function onResize({
      width
    }) {
      emit("resize", {
        annotationSourceHeight,
        warningHeight: warningHeight.value,
        width
      });
    }
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", {
        ref_key: "wrapperRef",
        ref: wrapperRef,
        class: normalizeClass(["full-height bg-white", {
          "flex no-wrap q-pt-md": __props.fullscreen
        }]),
        "data-automation": unref(buildId)(),
        style: normalizeStyle({
          "--annotation-source-height": `${annotationSourceHeight}px`,
          "--warning-height": `${warningHeight.value}px`
        })
      }, [
        createVNode(unref(QResizeObserver_default), { onResize }),
        __props.loading ? (openBlock(), createBlock(_sfc_main$6, { key: 0 })) : __props.loadingFailed || !((_b = (_a = __props.dataset) == null ? void 0 : _a.dataPoints) == null ? void 0 : _b.length) ? (openBlock(), createBlock(WaferMapError, {
          key: 1,
          "loading-failed": __props.loadingFailed
        }, null, 8, ["loading-failed"])) : __props.fullscreen ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
          createElementVNode("div", {
            class: "wafer-map__sidepanel column no-wrap",
            "data-automation": unref(buildId)("sidepanel")
          }, [
            createVNode(_sfc_main$9),
            createVNode(WaferMapChartLegend, { classes: classes.value }, null, 8, ["classes"])
          ], 8, _hoisted_2),
          createElementVNode("div", {
            class: normalizeClass(["wafer-map__fullscreen", {
              "border-card rounded-borders full-width q-pa-md": __props.fullscreen
            }]),
            "data-automation": unref(buildId)("fullscreen-container")
          }, [
            createElementVNode("div", {
              class: normalizeClass(["relative-position", __props.isPartiallyLoaded ? "wafer-map__fullscreen--partial" : "wafer-map__fullscreen--full"]),
              "data-automation": unref(buildId)("fullscreen-wrapper")
            }, [
              createVNode(WaferMapChart, {
                ref_key: "canvasFullscreenRef",
                ref: canvasFullscreenRef,
                modelValue: selection.value,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event) => selection.value = $event),
                  _cache[2] || (_cache[2] = ($event) => emit("update:modelValue", $event))
                ],
                "annotation-sources": __props.annotationSources,
                "background-image": __props.backgroundImage,
                dataset: __props.dataset,
                fullscreen: __props.fullscreen,
                onResetBackground: _cache[1] || (_cache[1] = ($event) => emit("resetBackground"))
              }, null, 8, ["modelValue", "annotation-sources", "background-image", "dataset", "fullscreen"])
            ], 10, _hoisted_4)
          ], 10, _hoisted_3)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 3 }, [
          createElementVNode("div", {
            class: "wafer-map__annotation-source",
            "data-automation": unref(buildId)("annotation-source")
          }, [
            createElementVNode("div", {
              class: "text-body3",
              "data-automation": unref(buildId)("annotation-source__label")
            }, toDisplayString(_ctx.$t("rvai-base.components.waferMap.annotationSource")), 9, _hoisted_6),
            createElementVNode("div", {
              class: "text-subtitle3",
              "data-automation": unref(buildId)("annotation-source__last-updated")
            }, toDisplayString(_ctx.$t("rvai-base.components.waferMap.lastUpdatedAnnotations")), 9, _hoisted_7)
          ], 8, _hoisted_5),
          __props.isPartiallyLoaded ? (openBlock(), createBlock(_sfc_main$b, {
            key: 0,
            fullscreen: __props.fullscreen,
            "samples-count": __props.dataset.samplesCount,
            "total-count": __props.dataset.totalCount
          }, null, 8, ["fullscreen", "samples-count", "total-count"])) : createCommentVNode("", true),
          createVNode(WaferMapChart, {
            ref_key: "canvasRef",
            ref: canvasRef,
            modelValue: selection.value,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = ($event) => selection.value = $event),
              _cache[6] || (_cache[6] = ($event) => emit("update:modelValue", $event))
            ],
            "annotation-sources": __props.annotationSources,
            "background-image": __props.backgroundImage,
            dataset: __props.dataset,
            "is-split-view": __props.isSplitView,
            onResetBackground: _cache[4] || (_cache[4] = ($event) => emit("resetBackground")),
            onToggleFullscreen: _cache[5] || (_cache[5] = ($event) => emit("toggleFullscreen", true))
          }, null, 8, ["modelValue", "annotation-sources", "background-image", "dataset", "is-split-view"])
        ], 64))
      ], 14, _hoisted_1$2);
    };
  }
});
const components = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActionButton,
  AutoHeight,
  Avatar,
  BackButton,
  BarChart,
  Bullet,
  Button,
  ButtonDropdown,
  Card,
  CardImage,
  CardItem,
  Carousel,
  Chart,
  ChartLineIndicator: _sfc_main$1s,
  Checkbox,
  Chip,
  CircularProgress,
  ClickableArea,
  ColorPicker,
  ColorPickerInput,
  ColorPickerV2,
  CombinedInputs,
  ConfirmDialog,
  ConfusionMatrix,
  CookiesDialog,
  CopyContentBtn,
  DatePicker,
  Dialog: RvDialog,
  DoubleCircularProgress,
  Dropzone,
  Duration,
  EditableText,
  EllipsisText,
  ExpansionItem,
  ExpansionList,
  FieldEdit,
  FieldsVisibilityDialog,
  FilePicker,
  FilterableList,
  HeaderNavigationItems,
  HealthIcon,
  Histogram,
  HistogramWrapper,
  InfoDialog,
  InfoPanel,
  Input: RvInput,
  LabelerSlider,
  LayoutButton,
  LinearProgress,
  LocalUrl: _sfc_main$Q,
  Logo: _sfc_main$P,
  MainContent,
  MultipleSelect,
  NavigationBar,
  NavigationBarLink,
  NavigationBarOverlay,
  NavigationBarTree,
  NavigationHeader,
  NavigationTitle,
  NoData,
  OptionGroup,
  Pagination,
  PoliciesAndLicenses,
  PrivacyPolicyDialog,
  Radio,
  Range,
  ScrollArea,
  ScrollNavigation,
  SearchInput,
  SectionMessage,
  Select: RvSelect,
  SelectBoolean,
  Separator,
  Sidebar,
  SidebarListClassSlugs,
  SidebarLoading,
  Slider,
  SortButton,
  SortSelect,
  Spinner,
  SpinnerAbsolute,
  SpinnerFixed,
  StatusPanel,
  StepSidebar,
  StepSidebarContent,
  SuspenseWithError,
  Table,
  TableCard,
  TableFilter,
  TableFilterItem,
  TableList,
  TableSortBy,
  Tabs,
  TermsAndConditionsDialog,
  Toggle,
  Tooltip,
  UsersGroup,
  Validation,
  ValidationTooltip,
  WaferMap: _sfc_main$5
}, Symbol.toStringTag, { value: "Module" }));
const HeightAuto = {
  mounted(el, binding) {
    const parent = el.parentElement;
    if (!parent) return;
    const target2 = (binding.value && el.querySelector(binding.value)) ?? el;
    target2.style.height = `${parent.offsetHeight}px`;
  }
};
function focusFirstInput(el, binding) {
  if (!binding.value) return;
  const target2 = el.querySelector(`
    input[type='text']:not([disabled]):not([tabindex='-1']),
    select:not([disabled]):not([tabindex='-1']),
    textarea:not([disabled]):not([tabindex='-1'])
  `);
  if (!target2) return;
  target2.focus();
}
const Focus = {
  mounted: focusFirstInput,
  updated: focusFirstInput
};
let keyHandler;
const instances = /* @__PURE__ */ new Map();
function defineKeyMap(binding) {
  const bindingValue = binding.value;
  return Object.keys(bindingValue).reduce((acc, curr) => acc.set(curr, bindingValue[curr]), /* @__PURE__ */ new Map());
}
function bindEvent(el, binding) {
  const keyMap = defineKeyMap(binding);
  instances.set(binding.instance, keyMap);
  keyHandler = (e2) => {
    if ([...instances.values()].some((keyMap2) => keyMap2.get(e2.key) === false)) {
      return;
    }
    const callback = keyMap.get(e2.key);
    const isElementHidden = el.offsetParent === null;
    if (typeof callback !== "function" || isElementHidden) return;
    callback();
  };
  document.addEventListener("keyup", keyHandler);
}
function unbindEvent(_, binding) {
  instances.delete(binding.instance);
  document.removeEventListener("keyup", keyHandler);
}
const Hotkey = {
  mounted: bindEvent,
  unmounted: unbindEvent
};
const variables = [
  "accent",
  "black-1",
  "blue",
  "dark-page",
  "dark",
  "grey-1",
  "grey-2",
  "grey-3",
  "grey-5",
  "grey-6",
  "info",
  "negative",
  "pink-1",
  "pink-2",
  "pink-3",
  "pink",
  "positive",
  "primary",
  "secondary",
  "warning",
  "white"
];
const QuasarVariables = {
  mounted(el) {
    el.onload = function() {
      var _a;
      for (const color of variables) {
        (_a = el.contentDocument) == null ? void 0 : _a.body.style.setProperty(`--q-${color}`, getCssVar(color));
      }
    };
  }
};
const directives = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus,
  HeightAuto,
  Hotkey,
  QuasarVariables
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$4 = defineComponent({
  name: "FullLayout",
  components: {
    NavigationBarOverlay,
    QLayout: QLayout_default,
    QPageContainer: QPageContainer_default,
    RouterView
  },
  setup() {
    const {
      showOverlay,
      toggleShowOverlay,
      watchRoute
    } = useLayout();
    const { navigation } = useOptionsReadOnly();
    const overlayRef = ref$1(null);
    const helpUrl = computed(() => navigation.helpUrl);
    const homeRoute = computed(() => navigation.homeRoute);
    const items = computed(() => navigation.items ?? []);
    function closeOverlay() {
      toggleShowOverlay(false);
    }
    onMounted(() => {
      toggleShowOverlay(false);
    });
    watchRoute([
      Layout.Default,
      Layout.LeftOnly
    ]);
    return {
      closeOverlay,
      helpUrl,
      homeRoute,
      items,
      overlayRef,
      showOverlay
    };
  }
});
const _hoisted_1$1 = {
  ref: "overlayRef",
  class: "navigation-bar-overlay"
};
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavigationBarOverlay = resolveComponent("NavigationBarOverlay");
  const _component_RouterView = resolveComponent("RouterView");
  const _component_QPageContainer = resolveComponent("QPageContainer");
  const _component_QLayout = resolveComponent("QLayout");
  return openBlock(), createBlock(_component_QLayout, {
    class: "full-layout",
    view: "hHh LpR lfr"
  }, {
    default: withCtx(() => [
      withDirectives(createElementVNode("div", {
        class: "full-layout__backdrop fixed-full",
        onClick: _cache[0] || (_cache[0] = (...args) => _ctx.closeOverlay && _ctx.closeOverlay(...args))
      }, null, 512), [
        [vShow, _ctx.showOverlay]
      ]),
      withDirectives(createElementVNode("div", _hoisted_1$1, [
        renderSlot(_ctx.$slots, "navigation", {
          onCloseOverlay: _cache[1] || (_cache[1] = (...args) => _ctx.closeOverlay && _ctx.closeOverlay(...args))
        }, () => [
          createVNode(_component_NavigationBarOverlay, {
            "data-automation": "navigationBarOverlay",
            "help-url": _ctx.helpUrl,
            "home-route": _ctx.homeRoute,
            items: _ctx.items
          }, null, 8, ["help-url", "home-route", "items"])
        ], true)
      ], 512), [
        [vShow, _ctx.showOverlay]
      ]),
      createVNode(_component_QPageContainer, null, {
        default: withCtx(() => [
          createVNode(_component_RouterView)
        ]),
        _: 1
      })
    ]),
    _: 3
  });
}
const FullLayout = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4], ["__scopeId", "data-v-35577d11"]]);
const _sfc_main$3 = defineComponent({
  name: "MainLayout",
  components: {
    NavigationBar,
    QDrawer: QDrawer_default,
    QLayout: QLayout_default,
    QPageContainer: QPageContainer_default,
    RouterView
  },
  setup() {
    const {
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      watchRoute
    } = useLayout();
    const { navigation } = useOptionsReadOnly();
    const helpUrl = computed(() => toValue(navigation.helpUrl));
    const homeRoute = computed(() => navigation.homeRoute);
    const items = computed(
      () => navigation.items ?? []
    );
    watchRoute([Layout.Default, Layout.LeftOnly]);
    return {
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      helpUrl,
      homeRoute,
      items
    };
  }
});
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavigationBar = resolveComponent("NavigationBar");
  const _component_QDrawer = resolveComponent("QDrawer");
  const _component_RouterView = resolveComponent("RouterView");
  const _component_QPageContainer = resolveComponent("QPageContainer");
  const _component_QLayout = resolveComponent("QLayout");
  return openBlock(), createBlock(_component_QLayout, {
    class: "main-layout",
    view: "lHh LpR lff"
  }, {
    default: withCtx(() => [
      createVNode(_component_QDrawer, {
        breakpoint: 0,
        mini: _ctx.collapsedNavigationbarAfterAnimation,
        "mini-width": 72,
        "model-value": true,
        persistent: "",
        "show-if-above": "",
        side: "left",
        width: 312
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "navigation", {}, () => [
            createVNode(_component_NavigationBar, {
              "data-automation": "navigationBar",
              "help-url": _ctx.helpUrl,
              "home-route": _ctx.homeRoute,
              items: _ctx.items
            }, null, 8, ["help-url", "home-route", "items"])
          ])
        ]),
        _: 3
      }, 8, ["mini"]),
      createVNode(_component_QPageContainer, null, {
        default: withCtx(() => [
          createVNode(_component_RouterView)
        ]),
        _: 1
      })
    ]),
    _: 3
  });
}
const MainLayout = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3]]);
const _sfc_main$2 = {};
function _sfc_render$2(_ctx, _cache) {
  const _component_RouterView = resolveComponent("RouterView");
  return openBlock(), createBlock(_component_RouterView);
}
const Passthrough = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
const BREAK_POINT$1 = 1536;
const SPLIT_VIEW_BREAK_POINT = 1920;
const SPLIT_ALLOWED_BREAK_POINT = 1440;
const _sfc_main$1 = defineComponent({
  name: "LabelerLayout",
  components: {
    NavigationBar,
    NavigationBarOverlay,
    QDrawer: QDrawer_default,
    QLayout: QLayout_default,
    QPageContainer: QPageContainer_default,
    QResizeObserver: QResizeObserver_default,
    RouterView
  },
  setup() {
    const {
      availableLayouts,
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      isFullLayout,
      isSplitLayout,
      layout,
      setAvailableLayouts,
      setSmallScreen,
      showOverlay,
      smallScreen,
      toggleNavigationBar,
      toggleShowOverlay,
      watchRoute
    } = useLayout();
    const { navigation } = useOptionsReadOnly();
    const screenWidth = ref$1(window.innerWidth);
    const helpUrl = computed(() => toValue(navigation.helpUrl));
    const homeRoute = computed(() => navigation.homeRoute);
    const items = computed(
      () => navigation.items ?? []
    );
    const isSplitLayoutSmallScreen = computed(() => {
      return isSplitLayout.value && screenWidth.value < SPLIT_VIEW_BREAK_POINT;
    });
    const minDrawerWidth = computed(() => {
      return isFullLayout.value || isSplitLayoutSmallScreen.value ? 0 : 72;
    });
    watchRoute([
      Layout.Default,
      Layout.Full,
      Layout.LeftOnly,
      Layout.RightOnly,
      Layout.Split
    ]);
    const onResize = ({ width }) => {
      screenWidth.value = width;
      if (width < SPLIT_ALLOWED_BREAK_POINT) {
        setAvailableLayouts(
          availableLayouts.value.filter((v) => v !== Layout.Split)
        );
      } else {
        setAvailableLayouts(distinct([...availableLayouts.value, Layout.Split]));
      }
      if (width <= BREAK_POINT$1 || isSplitLayout.value && width < SPLIT_VIEW_BREAK_POINT) {
        setSmallScreen(true);
        toggleNavigationBar(true);
      } else {
        setSmallScreen(false);
      }
    };
    function closeOverlay() {
      toggleNavigationBar(true);
      toggleShowOverlay(false);
    }
    function closeOverlayOnSmallScreen() {
      if (smallScreen.value) {
        closeOverlay();
      }
    }
    onBeforeRouteLeave(closeOverlayOnSmallScreen);
    onBeforeRouteUpdate(closeOverlayOnSmallScreen);
    watch(isFullLayout, (value2) => {
      if (value2) closeOverlay();
    });
    return {
      closeOverlay,
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      helpUrl,
      homeRoute,
      items,
      layout,
      minDrawerWidth,
      onResize,
      showOverlay,
      smallScreen
    };
  }
});
const _hoisted_1 = {
  ref: "overlayRef",
  class: "navigation-bar-overlay"
};
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavigationBarOverlay = resolveComponent("NavigationBarOverlay");
  const _component_NavigationBar = resolveComponent("NavigationBar");
  const _component_QDrawer = resolveComponent("QDrawer");
  const _component_RouterView = resolveComponent("RouterView");
  const _component_QPageContainer = resolveComponent("QPageContainer");
  const _component_QLayout = resolveComponent("QLayout");
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  return openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_QLayout, {
      class: "labeler-layout",
      "data-automation-view": _ctx.layout,
      view: "lHh LpR lff"
    }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", {
          class: "labeler-layout__backdrop fixed-full",
          onClick: _cache[0] || (_cache[0] = (...args) => _ctx.closeOverlay && _ctx.closeOverlay(...args))
        }, null, 512), [
          [vShow, _ctx.showOverlay]
        ]),
        withDirectives(createElementVNode("div", _hoisted_1, [
          renderSlot(_ctx.$slots, "navigation", {
            onCloseOverlay: _cache[1] || (_cache[1] = (...args) => _ctx.closeOverlay && _ctx.closeOverlay(...args))
          }, () => [
            createVNode(_component_NavigationBarOverlay, {
              "data-automation": "navigationBarOverlay",
              "help-url": _ctx.helpUrl,
              "home-route": _ctx.homeRoute,
              items: _ctx.items
            }, null, 8, ["help-url", "home-route", "items"])
          ], true)
        ], 512), [
          [vShow, _ctx.showOverlay]
        ]),
        withDirectives(createElementVNode("div", {
          class: "labeler-layout__backdrop fixed-full",
          onClick: _cache[2] || (_cache[2] = (...args) => _ctx.closeOverlay && _ctx.closeOverlay(...args))
        }, null, 512), [
          [vShow, _ctx.smallScreen && !_ctx.collapsedNavigationbarAfterAnimation]
        ]),
        createVNode(_component_QDrawer, {
          breakpoint: 0,
          mini: _ctx.collapsedNavigationbarAfterAnimation,
          "mini-to-overlay": _ctx.smallScreen,
          "mini-width": _ctx.minDrawerWidth,
          "model-value": true,
          persistent: "",
          "show-if-above": "",
          side: "left",
          width: 312
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "navigation", {}, () => [
              createVNode(_component_NavigationBar, {
                "data-automation": "navigationBar",
                "help-url": _ctx.helpUrl,
                "home-route": _ctx.homeRoute,
                items: _ctx.items,
                overlay: _ctx.smallScreen && !_ctx.collapsedNavigationbarAfterAnimation,
                "show-toggle": "",
                onCloseOverlay: _ctx.closeOverlay
              }, null, 8, ["help-url", "home-route", "items", "overlay", "onCloseOverlay"])
            ], true)
          ]),
          _: 3
        }, 8, ["mini", "mini-to-overlay", "mini-width"]),
        createVNode(_component_QPageContainer, null, {
          default: withCtx(() => [
            createVNode(_component_RouterView)
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["data-automation-view"]),
    createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"])
  ], 64);
}
const LabelerLayout = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__scopeId", "data-v-ebd7b723"]]);
const BREAK_POINT = 1536;
const _sfc_main = defineComponent({
  name: "ResponsiveLayout",
  components: {
    NavigationBar,
    QDrawer: QDrawer_default,
    QLayout: QLayout_default,
    QPageContainer: QPageContainer_default,
    QResizeObserver: QResizeObserver_default,
    RouterView
  },
  setup() {
    const {
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      setSmallScreen,
      smallScreen,
      toggleNavigationBar,
      watchRoute
    } = useLayout();
    const { navigation } = useOptions();
    const helpUrl = computed(() => toValue(navigation.helpUrl));
    const homeRoute = computed(() => navigation.homeRoute);
    const items = computed(
      () => navigation.items ?? []
    );
    watchRoute([Layout.Default, Layout.LeftOnly]);
    const onResize = ({ width }) => {
      if (width <= BREAK_POINT) {
        setSmallScreen(true);
        toggleNavigationBar(true);
      } else {
        setSmallScreen(false);
      }
    };
    function closeOverlay() {
      toggleNavigationBar(true);
    }
    function closeOverlayOnSmallScreen() {
      if (smallScreen.value) {
        closeOverlay();
      }
    }
    onBeforeRouteLeave(closeOverlayOnSmallScreen);
    onBeforeRouteUpdate(closeOverlayOnSmallScreen);
    return {
      closeOverlay,
      collapsedNavigationbar,
      collapsedNavigationbarAfterAnimation,
      helpUrl,
      homeRoute,
      items,
      onResize,
      smallScreen
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavigationBar = resolveComponent("NavigationBar");
  const _component_QDrawer = resolveComponent("QDrawer");
  const _component_RouterView = resolveComponent("RouterView");
  const _component_QPageContainer = resolveComponent("QPageContainer");
  const _component_QLayout = resolveComponent("QLayout");
  const _component_QResizeObserver = resolveComponent("QResizeObserver");
  return openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_QLayout, {
      class: "responsive-layout",
      view: "lHh LpR lff"
    }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", {
          class: "responsive-layout__backdrop fixed-full",
          onClick: _cache[0] || (_cache[0] = (...args) => _ctx.closeOverlay && _ctx.closeOverlay(...args))
        }, null, 512), [
          [vShow, _ctx.smallScreen && !_ctx.collapsedNavigationbarAfterAnimation]
        ]),
        createVNode(_component_QDrawer, {
          breakpoint: 0,
          mini: _ctx.collapsedNavigationbarAfterAnimation,
          "mini-to-overlay": _ctx.smallScreen,
          "mini-width": 72,
          "model-value": true,
          persistent: "",
          "show-if-above": "",
          side: "left",
          width: 312
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "navigation", {}, () => [
              createVNode(_component_NavigationBar, {
                "data-automation": "navigationBar",
                "help-url": _ctx.helpUrl,
                "home-route": _ctx.homeRoute,
                items: _ctx.items,
                overlay: _ctx.smallScreen && !_ctx.collapsedNavigationbarAfterAnimation,
                "show-toggle": "",
                onCloseOverlay: _ctx.closeOverlay
              }, null, 8, ["help-url", "home-route", "items", "overlay", "onCloseOverlay"])
            ], true)
          ]),
          _: 3
        }, 8, ["mini", "mini-to-overlay"]),
        createVNode(_component_QPageContainer, null, {
          default: withCtx(() => [
            createVNode(_component_RouterView)
          ]),
          _: 1
        })
      ]),
      _: 3
    }),
    createVNode(_component_QResizeObserver, { onResize: _ctx.onResize }, null, 8, ["onResize"])
  ], 64);
}
const ResponsiveLayout = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-7f5670b5"]]);
const layouts = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FullLayout,
  LabelerLayout,
  MainLayout,
  Passthrough,
  ResponsiveLayout
}, Symbol.toStringTag, { value: "Module" }));
const defaultMessages = {
  "rvai-base": {
    charts: {
      relative: "Relative: {0}",
      step: "Step: {0}"
    },
    components: {
      classesTooltipInfo: {
        displayName: "Display name:",
        originalName: "Original name:"
      },
      colorPicker: {
        hex: "Hex",
        rgb: {
          b: "B",
          g: "G",
          r: "R"
        }
      },
      confusionMatrix: {
        matchPercentage: "Match (%)",
        noAnnotation: "No label"
      },
      copyContentButton: {
        copied: "Copied",
        copy: "Copy to clipboard"
      },
      datePicker: {
        days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday",
        daysShort: "S_M_T_W_T_F_S",
        hh: "hh",
        mm: "mm",
        months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec",
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec",
        selectTime: "Select time",
        ss: "ss",
        wrongFormat: "Date format is wrong"
      },
      dropzone: {
        addMore: "Add more",
        clearAll: "clear all files",
        clearFile: "Clear file",
        dataDescription: "{0} or {1}",
        dataTitle: "File selected and ready for upload | Files selected and ready for upload",
        denseTitle: "Upload from computer",
        dragDescription: "Release your files here to upload",
        dragTitle: "Release files",
        emptyDescription: "or {0}",
        emptyTitle: "Drag & drop new file | Drag & drop new files",
        errorTitle: "Oops...",
        maxFiles: "max {n} file | max {n} files",
        retry: "Try again",
        uploadFromComputer: "upload from computer",
        validation: {
          fileExtensions: "The file format is not supported.",
          maxFiles: "Too many files selected. A maximum of {0} files can be selected.",
          maxSize: "Your data is too big. You selected {0} but the maximum size is {1}."
        }
      },
      duration: {
        infinite: "Infinite"
      },
      health: {
        autoscalingStatus: {
          critical: "Not all running instances are able to respond or are being started up through autoscaling"
        },
        replicaStatus: {
          error: "Group has an error",
          queued: "Group is queued and will start soon",
          running: "Group is running healthy",
          starting: "Group is warming up for training"
        },
        status: {
          critical: "Not all running instances are able to respond",
          failing: "Some instances are experiencing inference failures",
          healthy: "Group is running healthy",
          overpowered: "Reducing instances will free up resources for other groups",
          stopped: "Group was stopped",
          underpowered: "Increase instances if possible",
          unknown: "No health information received yet"
        }
      },
      histogram: {
        annotations: "Annotations",
        chartTitle: "Chart: ",
        classDistribution: "Class distribution",
        classId: "Class ID",
        className: "Class name",
        count: "Count",
        countPct: "<strong>{count}</strong> ({pct})",
        emptyAnnotation: "Empty annotation",
        mode: "Count:",
        modes: {
          annotations: "Annotations",
          samples: "Samples"
        },
        name: "Name",
        noLabel: "No label",
        notAnnotated: "Not annotated",
        percentage: "Percentage",
        samples: "Samples",
        split: "Split:",
        trainingSetup: {
          all: "All",
          test: "Test set",
          train: "Train set",
          validate: "Validation set"
        },
        unknownClass: "Unknown class"
      },
      multipleSelect: {
        allItemsSelected: "All items selected",
        noItems: "No items",
        search: "Search",
        selectAll: "Select all",
        selectOption: "Select option"
      },
      pagination: {
        noPage: "There is no page '{page}'. Select a page between {min} and {max}."
      },
      searchInput: {
        noMatches: "No matches"
      },
      sliderWithInput: {
        value: "The value"
      },
      waferMap: {
        annotations: "Annotations",
        annotationSource: "Annotation source:",
        chartSpecificFilters: "Chart-specific filters",
        classes: "Classes",
        deselect: "Deselect",
        lastUpdatedAnnotations: "Last updated annotations",
        loadingFailedExtra: "Please clear the chart setup and try again.",
        locationMissing: "{0} of {1} sample positions are missing.",
        makeFreehandSelection: "Make freehand selection",
        noItems: "No items",
        noPositions: "These samples don’t have positions; therefore, the wafer map cannot be generated.",
        notAnnotated: "Not annotated",
        resetZoomLevel: "Reset zoom",
        selectedCount: "{selectedSamples} of {totalSamples} selected -",
        zoomIn: "Zoom in",
        zoomOut: "Zoom out"
      }
    },
    dialogs: {
      confirmation: {
        dontShowAgain: "Don't show again"
      }
    },
    filters: {
      date: {
        endDate: "End date",
        startDate: "Start date"
      },
      errors: {
        endIsEarlier: "End date is earlier than start date",
        startIsLater: "Start date is later than end date",
        typeMismatch: "Some types are missing",
        typedConfig: "Cannot build filter config for type {0}",
        typesMismatch: "Filter types do not match. Expected {0}, got {1}",
        unknownConfig: "Cannot build filter config for unknown type"
      }
    },
    general: {
      actions: {
        add: "Add",
        back: "Back",
        browse: "Browse",
        cancel: "Cancel",
        clear: "clear",
        clone: "Clone",
        confirm: "Confirm",
        copyLink: "Copy link",
        create: "Create",
        customize: "Customize",
        decline: "Decline",
        "delete": "Delete",
        deleteMultiple: "Delete|Delete ({n})",
        deploy: "Deploy",
        discard: "Discard",
        disconnect: "Disconnect",
        disconnectMultiple: "Disconnect|Disconnect ({n})",
        download: "Download",
        duplicate: "Duplicate",
        duplicateMultiple: "Duplicate|Duplicate ({n})",
        edit: "Edit",
        evaluate: "Evaluate",
        "export": "Export",
        "import": "Import",
        info: "Info",
        load: "Load",
        logout: "Log out",
        next: "Next",
        noItems: "No items",
        ok: "Ok",
        previous: "Previous",
        restore: "Restore",
        review: "Review",
        save: "Save",
        search: "Search",
        selectAll: "Select all",
        selectOption: "Select option",
        showAll: "Show all",
        showDetail: "Show detail",
        showDetails: "Show details",
        showLess: "Show less",
        showMore: "Show more",
        skip: "Skip",
        sort: "Sort",
        stop: "Stop",
        submit: "Submit",
        unlink: "Unlink",
        update: "Update",
        viewProfile: "View profile"
      },
      backBtn: {
        "default": "back"
      },
      common: {
        none: "none",
        wordInBrackets: " ({0})"
      },
      errors: {
        description: "Please try again.",
        title: "Sorry, something went wrong."
      },
      help: {
        hint: "Help (F1)",
        title: "Help"
      },
      inputs: {
        field: "Field",
        from: "From",
        maxCharacters: "max. {n} characters",
        name: "Name",
        optional: "(optional)",
        until: "Until"
      },
      layout: {
        "default": "Left and right panels",
        full: "Fullscreen",
        leftOnly: "Only left panel",
        rightOnly: "Only right panel",
        split: "Split view"
      },
      process: {
        percentage: "{0}%"
      },
      symbols: {
        comma: ",",
        dash: "-",
        dots: "...",
        hashtag: "#",
        percentage: "%",
        pipe: "{'|'}",
        plus: "+",
        semicolon: ":",
        separator: " • ",
        separatorX: " x ",
        slash: "/",
        zero: "0"
      },
      table: {
        cancel: "Cancel",
        clear: "(Clear)",
        clearFilter: "Clear filter",
        filter: "Filters",
        filtered: "Filtered {0}/{1}",
        filteredResults: "{0}/{1} filtered results",
        listView: "List view",
        noFilteredResults: "Your filters produced no results",
        noQueryResults: "Sorry, we couldn't find any results",
        noSearchResult: "we couldn't find any results",
        recordPerPage: "Items per page:",
        search: "Search",
        searchAgain: "Search again",
        select: "Select",
        selected: "{0}/{1} selected",
        sorry: "Sorry",
        sortBy: "Sort by:",
        thumbnailsView: "Thumbnails view",
        total: "{0} items"
      },
      text: {
        advanced: "Advanced",
        allRows: "All rows",
        clear: "Clear",
        compressed: "Compressed",
        createdDate: "Created date",
        dateAsc: "Oldest",
        dateDesc: "Newest",
        failed: "Failed",
        filter: "Filter",
        first: "First",
        gpu: "GPU",
        inUse: "in use",
        items: "Items",
        itemsNumber: "Items ({0})",
        label: "{0}: ",
        labelValue: "{0}: {1}",
        last: "Last",
        loading: "Loading...",
        loadingExtra: "Could take some time.",
        loadingFailed: "Looks like something went wrong.",
        more: "+{0}",
        multiselect: "Multiselect",
        name: "Name",
        no: "No",
        noItems: "No items",
        notInUse: "not in use",
        otherCenters: "Other centers",
        role: "Role",
        search: "Search",
        showRows: "Show rows",
        sortAsc: "A to Z",
        sortDesc: "Z to A",
        status: "Status",
        theValue: "The value",
        valueTotal: "{0}/{1}",
        yes: "Yes"
      },
      titles: {
        sure: "Are you sure?"
      }
    },
    policiesAndLicenses: {
      actions: {
        cookies: {
          accept: "Accept all",
          here: "here",
          open: "Cookies",
          reject: "Reject other than necessary"
        },
        privacyPolicy: {
          open: "Privacy policy"
        },
        termsAndConditions: {
          agree: "Agree & sign up",
          disagree: "Disagree",
          open: "Terms and conditions"
        }
      },
      text: {
        cookies: "We use cookies to improve your visit to this application. Click 'Accept all' to accept all cookies. Want to know more about these cookies? Click {here} for more information."
      },
      titles: {
        cookies: "cookies",
        termsAndConditions: "Terms and conditions"
      }
    },
    tableFields: {
      actions: {
        save: "Set for all members"
      },
      clearFilter: "Clear filter",
      clearSearchResults: "Clear search results",
      inputs: {
        all: "All columns",
        columnName: "Column name",
        edit: "edit",
        editable: "Editable",
        showColumns: "Show columns",
        view: "view"
      },
      noFilteredResults: "Your filters produced no results",
      noQueryResults: "Sorry, we couldn't find any results",
      searchAgain: "Search again",
      title: "Table settings"
    },
    validation: {
      decimal: "{0} must be decimal",
      "default": "Invalid value",
      dnsLabel: "{0} must be a valid DNS label (at most 63 characters, contain only alphanumeric characters and dashes, start with an alphabetic character and end with an alphanumeric character)",
      email: "Must be a valid email address",
      equalTo: "{0} must be {1}",
      fileTooLarge: "The file is too large (MAX. {0})",
      integer: "{0} must be an integer",
      isRequired: "{0} is required",
      isUnique: "{0} must be unique",
      maxLength: "{0} must be at most {1} characters",
      maxValue: "{0} must be less than or equal to {1}",
      maxValueExclusive: "{0} must be less than {1}",
      minLength: "{0} must be at least {1} characters",
      minLowerCaseCount: "{0} must contain at least {1} lower case letter|{0} must contain at least {1} lower case letters",
      minNumberCount: "{0} must contain at least {1} number|{0} must contain at least {1} numbers",
      minSpecialCount: "{0} must contain at least {1} special character|{0} must contain at least {1} special characters",
      minUpperAndLowerCaseCount: "{0} must contain at least {1} upper case letter and {1} lower case letter|{0} must contain at least {1} upper case letters and {1} lower case letters",
      minUpperCaseCount: "{0} must contain at least {1} upper case letter|{0} must contain at least {1} upper case letters",
      minValue: "{0} must be greater than or equal to {1}",
      minValueExclusive: "{0} must be greater than {1}",
      mustBeValid: "{0} must be valid",
      notAllowedSymbols: "{0} cannot contain {1}",
      numbers: "{0} must contain only numbers",
      numeric: "{0} must be numeric",
      sameAs: "{0} value should be the same as {1}",
      slug: "{0} must contain only lowercase letters and numbers separated by hyphen, underscore or dot",
      url: "{0} in not valid URL",
      withoutSpaces: "{0} cannot contain spaces",
      wordsAndNumbers: "{0} must contain only letters and numbers. No spaces.",
      wordsAndUnderscores: "{0} must contain only letters, numbers, underscores, dashes and spaces",
      wordsWithoutSpaces: "{0} must contain only letters, numbers, underscores and dashes",
      wordsWithSpaces: "{0} must contain only letters, numbers, underscores, dashes and spaces",
      wrongFormat: "The file you selected has the wrong format"
    }
  }
};
function iconMapFn(iconName) {
  const iconPrefix = "rvai-base:";
  if (iconName.startsWith(iconPrefix)) {
    const name2 = iconName.substring(iconPrefix.length);
    return { icon: `svguse:rvai-base/icons.svg#${name2}` };
  }
}
function initializeRouter() {
  const router = useRouter();
  router.beforeEach(navigationHistoryGuard);
}
function initializeI18n(i18n = useI18n()) {
  const messages = i18n.getLocaleMessage("en");
  const merged = merge$1({}, defaultMessages, messages);
  i18n.setLocaleMessage("en", merged);
  ValidationBuilder.i18n = i18n;
}
function initialize(options) {
  const $q = useQuasar();
  $q.iconMapFn = iconMapFn;
  initializeRouter();
  initializeI18n();
  initializeOptions(options);
  provideLayoutStore(options == null ? void 0 : options.layout);
  useDarkMode().initialize(options == null ? void 0 : options.darkMode);
}
const PREFIX = "Rv";
const install = function(app2) {
  app2.config.globalProperties.$sanitize = DOMPurify.sanitize;
  Object.entries(components).forEach(([componentName, component]) => {
    app2.component(`${PREFIX}${componentName}`, component);
  });
  Object.entries(layouts).forEach(([layoutName, layout]) => {
    app2.component(`${PREFIX}${layoutName}`, layout);
  });
  Object.entries(directives).forEach(([directiveName, directive]) => {
    app2.directive(directiveName, directive);
  });
};
Object.entries(components).forEach(([componentName, component]) => {
  if (componentName !== "default") {
    const key = componentName;
    const val = component;
    install[key] = val;
  }
});
export {
  ActionButton,
  AutoHeight,
  Avatar,
  BackButton,
  BarChart,
  Bullet,
  Button,
  ButtonDropdown,
  Card,
  CardImage,
  CardItem,
  Carousel,
  Chart,
  ChartDefinition,
  ChartEntry,
  _sfc_main$1s as ChartLineIndicator,
  Checkbox,
  Chip,
  CircularProgress,
  ClickableArea,
  ColorPicker,
  ColorPickerInput,
  ColorPickerV2,
  CombinedInputs,
  ConfirmDialog,
  ConfusionMatrix,
  ConfusionMatrixData,
  CookiesDialog,
  CookiesPolicy,
  CopyContentBtn,
  DARK_MODE_LOCAL_STORAGE_KEY,
  DatePicker,
  DetailsDataType,
  RvDialog as Dialog,
  DoubleCircularProgress,
  Dropzone,
  Duration,
  EditableText,
  EllipsisText,
  ExpansionItem,
  ExpansionList,
  FieldEdit,
  FieldVisibility,
  FieldsVisibilityDialog,
  FilePicker,
  FilterableList,
  Focus,
  FullLayout,
  HeaderNavigationItems,
  HealthIcon,
  HeightAuto,
  Histogram,
  HistogramWrapper,
  Hotkey,
  InfoDialog,
  InfoPanel,
  RvInput as Input,
  KEY_0,
  KEY_1,
  KEY_2,
  KEY_3,
  KEY_4,
  KEY_5,
  KEY_6,
  KEY_7,
  KEY_8,
  KEY_9,
  KEY_ALT,
  KEY_ARROW_DOWN,
  KEY_ARROW_LEFT,
  KEY_ARROW_RIGHT,
  KEY_ARROW_UP,
  KEY_A_LOWER,
  KEY_A_UPPER,
  KEY_BACKSPACE,
  KEY_B_LOWER,
  KEY_B_UPPER,
  KEY_CONTROL,
  KEY_C_UPPER,
  KEY_DEL,
  KEY_DELETE,
  KEY_D_LOWER,
  KEY_D_UPPER,
  KEY_ENTER,
  KEY_EQUAL,
  KEY_ESC,
  KEY_ESCAPE,
  KEY_E_UPPER,
  KEY_F1,
  KEY_F_LOWER,
  KEY_F_UPPER,
  KEY_G_LOWER,
  KEY_G_UPPER,
  KEY_I_UPPER,
  KEY_L_LOWER,
  KEY_L_UPPER,
  KEY_META,
  KEY_MINUS,
  KEY_M_UPPER,
  KEY_O_UPPER,
  KEY_PLUS,
  KEY_P_LOWER,
  KEY_P_UPPER,
  KEY_R_LOWER,
  KEY_R_UPPER,
  KEY_SHIFT,
  KEY_SPACE,
  KEY_S_LOWER,
  KEY_S_UPPER,
  KEY_TAB,
  KEY_T_LOWER,
  KEY_T_UPPER,
  KEY_V_UPPER,
  KEY_W_UPPER,
  KEY_X_LOWER,
  KEY_X_UPPER,
  KEY_Y_UPPER,
  KEY_Z_CODE,
  KEY_Z_LOWER,
  KEY_Z_UPPER,
  LabelerLayout,
  LabelerSlider,
  Layout,
  LayoutButton,
  LinearProgress,
  _sfc_main$Q as LocalUrl,
  _sfc_main$P as Logo,
  MainContent,
  MainLayout,
  MultipleSelect,
  NULL_CLASS_ID,
  NavigationBar,
  NavigationBarLink,
  NavigationBarOverlay,
  NavigationBarTree,
  NavigationHeader,
  NavigationTitle,
  NoData,
  OptionGroup,
  PAPER_KEY_SHIFT,
  PAPER_KEY_SPACE,
  Pagination,
  Passthrough,
  PipelineHealthStatus,
  PoliciesAndLicenses,
  PrivacyPolicyDialog,
  QuasarVariables,
  Radio,
  Range,
  ReplicaStatus,
  ResponsiveLayout,
  RowActionsVisibility,
  RvaiExceptions,
  ScrollArea,
  ScrollNavigation,
  SearchInput,
  SectionMessage,
  RvSelect as Select,
  SelectBoolean,
  Separator,
  ShapesNoData,
  Sidebar,
  SidebarListClassSlugs,
  SidebarLoading,
  Slider,
  SortButton,
  SortOrders,
  SortSelect,
  SortType,
  Spinner,
  SpinnerAbsolute,
  SpinnerFixed,
  StatusPanel,
  StepSidebar,
  StepSidebarContent,
  SuspenseWithError,
  Table,
  TableCard,
  TableFilter,
  TableFilterItem,
  TableFilterType,
  TableList,
  TableSortBy,
  Tabs,
  TermsAndConditionsDialog,
  Toggle,
  Tooltip,
  UNKNOWN_CLASS_ID,
  USER_COLORS,
  UsersGroup,
  Validation,
  ValidationBuilder,
  ValidationTooltip,
  _sfc_main$5 as WaferMap,
  buildFieldsVisibility,
  buildGradient,
  buildPaginationComposable,
  install as default,
  getColor,
  getUserColor,
  iconMapFn,
  initialize,
  initializeI18n,
  isHistoryRouteMeta,
  isLayoutRouteMeta,
  navigationHistoryGuard,
  provideFieldsVisibility,
  provideLayoutStore,
  providePagination,
  provideStepSidebar,
  provideTable,
  rgbaColor,
  roundToStep,
  setPrimaryColor,
  truncateNumber,
  useAutomation,
  useChartDatasets,
  useChartOptions,
  useChartTooltip,
  useCollapsed,
  useConfirmDialog,
  useCookiesPolicy,
  useDarkMode,
  useFieldsVisibility,
  useInfoDialog,
  useLayout,
  useLogo,
  useNavigationHistory,
  usePagination,
  usePaletteColorsCache,
  useQueryParams,
  useRightPanelSize,
  useScrollNavigation,
  useSidebar,
  useSidebarHelpers,
  useStepSidebar,
  useTable,
  useValidation
};
//# sourceMappingURL=index.es.js.map
